
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6luGJ", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $5ZrzL = parcelRequire("5ZrzL");
var $49ec8247e82be1c5$require$Buffer = $5ZrzL.Buffer;

var $bzgIH = parcelRequire("bzgIH");
var $49ec8247e82be1c5$var$iconv = module.exports;
// All codecs and aliases are kept here, keyed by encoding name/alias.
// They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
$49ec8247e82be1c5$var$iconv.encodings = null;
// Characters emitted in case of error.
$49ec8247e82be1c5$var$iconv.defaultCharUnicode = "\uFFFD";
$49ec8247e82be1c5$var$iconv.defaultCharSingleByte = '?';
// Public API.
$49ec8247e82be1c5$var$iconv.encode = function encode(str, encoding, options) {
    str = "" + (str || ""); // Ensure string.
    var encoder = $49ec8247e82be1c5$var$iconv.getEncoder(encoding, options);
    var res = encoder.write(str);
    var trail = encoder.end();
    return trail && trail.length > 0 ? $49ec8247e82be1c5$require$Buffer.concat([
        res,
        trail
    ]) : res;
};
$49ec8247e82be1c5$var$iconv.decode = function decode(buf, encoding, options) {
    if (typeof buf === 'string') {
        if (!$49ec8247e82be1c5$var$iconv.skipDecodeWarning) {
            console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
            $49ec8247e82be1c5$var$iconv.skipDecodeWarning = true;
        }
        buf = $49ec8247e82be1c5$require$Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
    }
    var decoder = $49ec8247e82be1c5$var$iconv.getDecoder(encoding, options);
    var res = decoder.write(buf);
    var trail = decoder.end();
    return trail ? res + trail : res;
};
$49ec8247e82be1c5$var$iconv.encodingExists = function encodingExists(enc) {
    try {
        $49ec8247e82be1c5$var$iconv.getCodec(enc);
        return true;
    } catch (e) {
        return false;
    }
};
// Legacy aliases to convert functions
$49ec8247e82be1c5$var$iconv.toEncoding = $49ec8247e82be1c5$var$iconv.encode;
$49ec8247e82be1c5$var$iconv.fromEncoding = $49ec8247e82be1c5$var$iconv.decode;
// Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
$49ec8247e82be1c5$var$iconv._codecDataCache = {};

$49ec8247e82be1c5$var$iconv.getCodec = function getCodec(encoding) {
    if (!$49ec8247e82be1c5$var$iconv.encodings) $49ec8247e82be1c5$var$iconv.encodings = (parcelRequire("eI9YC")); // Lazy load all encoding definitions.
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    var enc = $49ec8247e82be1c5$var$iconv._canonicalizeEncoding(encoding);
    // Traverse iconv.encodings to find actual codec.
    var codecOptions = {};
    while(true){
        var codec = $49ec8247e82be1c5$var$iconv._codecDataCache[enc];
        if (codec) return codec;
        var codecDef = $49ec8247e82be1c5$var$iconv.encodings[enc];
        switch(typeof codecDef){
            case "string":
                enc = codecDef;
                break;
            case "object":
                for(var key in codecDef)codecOptions[key] = codecDef[key];
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                enc = codecDef.type;
                break;
            case "function":
                if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                // The codec function must load all tables and return object with .encoder and .decoder methods.
                // It'll be called only once (for each different options object).
                codec = new codecDef(codecOptions, $49ec8247e82be1c5$var$iconv);
                $49ec8247e82be1c5$var$iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                return codec;
            default:
                throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
        }
    }
};
$49ec8247e82be1c5$var$iconv._canonicalizeEncoding = function(encoding) {
    // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
    return ('' + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
};
$49ec8247e82be1c5$var$iconv.getEncoder = function getEncoder(encoding, options) {
    var codec = $49ec8247e82be1c5$var$iconv.getCodec(encoding), encoder = new codec.encoder(options, codec);
    if (codec.bomAware && options && options.addBOM) encoder = new $bzgIH.PrependBOM(encoder, options);
    return encoder;
};
$49ec8247e82be1c5$var$iconv.getDecoder = function getDecoder(encoding, options) {
    var codec = $49ec8247e82be1c5$var$iconv.getCodec(encoding), decoder = new codec.decoder(options, codec);
    if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new $bzgIH.StripBOM(decoder, options);
    return decoder;
};
// Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
var $49ec8247e82be1c5$var$nodeVer = typeof $hPtJY !== 'undefined' && $hPtJY.versions && $hPtJY.versions.node;


if ($49ec8247e82be1c5$var$nodeVer) {
    // Load streaming support in Node v0.10+
    var $49ec8247e82be1c5$var$nodeVerArr = $49ec8247e82be1c5$var$nodeVer.split(".").map(Number);
    if ($49ec8247e82be1c5$var$nodeVerArr[0] > 0 || $49ec8247e82be1c5$var$nodeVerArr[1] >= 10) (parcelRequire("kjyEk"))($49ec8247e82be1c5$var$iconv);
    // Load Node primitive extensions.
    (parcelRequire("kjyEk"))($49ec8247e82be1c5$var$iconv);
}

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("5ZrzL", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $hPtJY = parcelRequire("hPtJY");
'use strict';

var $6ZWSX = parcelRequire("6ZWSX");
var $45c80a3e8b7e5b65$var$Buffer = $6ZWSX.Buffer;
var $45c80a3e8b7e5b65$var$safer = {};
var $45c80a3e8b7e5b65$var$key;
for($45c80a3e8b7e5b65$var$key in $6ZWSX){
    if (!$6ZWSX.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === 'SlowBuffer' || $45c80a3e8b7e5b65$var$key === 'Buffer') continue;
    $45c80a3e8b7e5b65$var$safer[$45c80a3e8b7e5b65$var$key] = $6ZWSX[$45c80a3e8b7e5b65$var$key];
}
var $45c80a3e8b7e5b65$var$Safer = $45c80a3e8b7e5b65$var$safer.Buffer = {};
for($45c80a3e8b7e5b65$var$key in $45c80a3e8b7e5b65$var$Buffer){
    if (!$45c80a3e8b7e5b65$var$Buffer.hasOwnProperty($45c80a3e8b7e5b65$var$key)) continue;
    if ($45c80a3e8b7e5b65$var$key === 'allocUnsafe' || $45c80a3e8b7e5b65$var$key === 'allocUnsafeSlow') continue;
    $45c80a3e8b7e5b65$var$Safer[$45c80a3e8b7e5b65$var$key] = $45c80a3e8b7e5b65$var$Buffer[$45c80a3e8b7e5b65$var$key];
}
$45c80a3e8b7e5b65$var$safer.Buffer.prototype = $45c80a3e8b7e5b65$var$Buffer.prototype;
if (!$45c80a3e8b7e5b65$var$Safer.from || $45c80a3e8b7e5b65$var$Safer.from === Uint8Array.from) $45c80a3e8b7e5b65$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === 'undefined') throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value);
    return $45c80a3e8b7e5b65$var$Buffer(value, encodingOrOffset, length);
};
if (!$45c80a3e8b7e5b65$var$Safer.alloc) $45c80a3e8b7e5b65$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $45c80a3e8b7e5b65$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === 'string') buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$45c80a3e8b7e5b65$var$safer.kStringMaxLength) try {
    $45c80a3e8b7e5b65$var$safer.kStringMaxLength = $hPtJY.binding('buffer').kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$45c80a3e8b7e5b65$var$safer.constants) {
    $45c80a3e8b7e5b65$var$safer.constants = {
        MAX_LENGTH: $45c80a3e8b7e5b65$var$safer.kMaxLength
    };
    if ($45c80a3e8b7e5b65$var$safer.kStringMaxLength) $45c80a3e8b7e5b65$var$safer.constants.MAX_STRING_LENGTH = $45c80a3e8b7e5b65$var$safer.kStringMaxLength;
}
module.exports = $45c80a3e8b7e5b65$var$safer;

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
'use strict';

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case 'ascii':
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case 'base64':
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$51861dfc7ca9d588$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
'use strict';
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup['-'.charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup['_'.charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("bzgIH", function(module, exports) {

$parcel$export(module.exports, "PrependBOM", () => $86bfeed14a6b65a8$export$e46ffb123c920c9f, (v) => $86bfeed14a6b65a8$export$e46ffb123c920c9f = v);
$parcel$export(module.exports, "StripBOM", () => $86bfeed14a6b65a8$export$99ac9f64d7386375, (v) => $86bfeed14a6b65a8$export$99ac9f64d7386375 = v);
var $86bfeed14a6b65a8$export$e46ffb123c920c9f;
//------------------------------------------------------------------------------
var $86bfeed14a6b65a8$export$99ac9f64d7386375;
"use strict";
var $86bfeed14a6b65a8$var$BOMChar = '\uFEFF';
$86bfeed14a6b65a8$export$e46ffb123c920c9f = $86bfeed14a6b65a8$var$PrependBOMWrapper;
function $86bfeed14a6b65a8$var$PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}
$86bfeed14a6b65a8$var$PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = $86bfeed14a6b65a8$var$BOMChar + str;
        this.addBOM = false;
    }
    return this.encoder.write(str);
};
$86bfeed14a6b65a8$var$PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
};
$86bfeed14a6b65a8$export$99ac9f64d7386375 = $86bfeed14a6b65a8$var$StripBOMWrapper;
function $86bfeed14a6b65a8$var$StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}
$86bfeed14a6b65a8$var$StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res) return res;
    if (res[0] === $86bfeed14a6b65a8$var$BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === 'function') this.options.stripBOM();
    }
    this.pass = true;
    return res;
};
$86bfeed14a6b65a8$var$StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
};

});

parcelRegister("eI9YC", function(module, exports) {
"use strict";








// Update this array if you add/rename/remove files in this directory.
// We support Browserify by skipping automatic module discovery and requiring modules directly.
var $ab5ce9e62122eb81$var$modules = [
    (parcelRequire("5Hwrz")),
    (parcelRequire("428wG")),
    (parcelRequire("9ar1n")),
    (parcelRequire("l2RZw")),
    (parcelRequire("cJ0pA")),
    (parcelRequire("2BLNr")),
    (parcelRequire("84zY3")),
    (parcelRequire("lEdD9"))
];
// Put all encoding/alias/codec definitions to single object and export it. 
for(var $ab5ce9e62122eb81$var$i = 0; $ab5ce9e62122eb81$var$i < $ab5ce9e62122eb81$var$modules.length; $ab5ce9e62122eb81$var$i++){
    var $ab5ce9e62122eb81$var$module = $ab5ce9e62122eb81$var$modules[$ab5ce9e62122eb81$var$i];
    for(var $ab5ce9e62122eb81$var$enc in $ab5ce9e62122eb81$var$module)if (Object.prototype.hasOwnProperty.call($ab5ce9e62122eb81$var$module, $ab5ce9e62122eb81$var$enc)) module.exports[$ab5ce9e62122eb81$var$enc] = $ab5ce9e62122eb81$var$module[$ab5ce9e62122eb81$var$enc];
}

});
parcelRegister("5Hwrz", function(module, exports) {
"use strict";

var $5ZrzL = parcelRequire("5ZrzL");
var $426a228a266c36e2$require$Buffer = $5ZrzL.Buffer;
// Export Node.js internal encodings.
module.exports = {
    // Encodings
    utf8: {
        type: "_internal",
        bomAware: true
    },
    cesu8: {
        type: "_internal",
        bomAware: true
    },
    unicode11utf8: "utf8",
    ucs2: {
        type: "_internal",
        bomAware: true
    },
    utf16le: "ucs2",
    binary: {
        type: "_internal"
    },
    base64: {
        type: "_internal"
    },
    hex: {
        type: "_internal"
    },
    // Codec.
    _internal: $426a228a266c36e2$var$InternalCodec
};
//------------------------------------------------------------------------------
function $426a228a266c36e2$var$InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;
    if (this.enc === "base64") this.encoder = $426a228a266c36e2$var$InternalEncoderBase64;
    else if (this.enc === "cesu8") {
        this.enc = "utf8"; // Use utf8 for decoding.
        this.encoder = $426a228a266c36e2$var$InternalEncoderCesu8;
        // Add decoder for versions of Node not supporting CESU-8
        if ($426a228a266c36e2$require$Buffer.from('eda0bdedb2a9', 'hex').toString() !== "\uD83D\uDCA9") {
            this.decoder = $426a228a266c36e2$var$InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}
$426a228a266c36e2$var$InternalCodec.prototype.encoder = $426a228a266c36e2$var$InternalEncoder;
$426a228a266c36e2$var$InternalCodec.prototype.decoder = $426a228a266c36e2$var$InternalDecoder;

var $eNRCS = parcelRequire("eNRCS");
var $426a228a266c36e2$require$StringDecoder = $eNRCS.StringDecoder;
if (!$426a228a266c36e2$require$StringDecoder.prototype.end) $426a228a266c36e2$require$StringDecoder.prototype.end = function() {};
function $426a228a266c36e2$var$InternalDecoder(options, codec) {
    $426a228a266c36e2$require$StringDecoder.call(this, codec.enc);
}
$426a228a266c36e2$var$InternalDecoder.prototype = $426a228a266c36e2$require$StringDecoder.prototype;
//------------------------------------------------------------------------------
// Encoder is mostly trivial
function $426a228a266c36e2$var$InternalEncoder(options, codec) {
    this.enc = codec.enc;
}
$426a228a266c36e2$var$InternalEncoder.prototype.write = function(str) {
    return $426a228a266c36e2$require$Buffer.from(str, this.enc);
};
$426a228a266c36e2$var$InternalEncoder.prototype.end = function() {};
//------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.
function $426a228a266c36e2$var$InternalEncoderBase64(options, codec) {
    this.prevStr = '';
}
$426a228a266c36e2$var$InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - str.length % 4;
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);
    return $426a228a266c36e2$require$Buffer.from(str, "base64");
};
$426a228a266c36e2$var$InternalEncoderBase64.prototype.end = function() {
    return $426a228a266c36e2$require$Buffer.from(this.prevStr, "base64");
};
//------------------------------------------------------------------------------
// CESU-8 encoder is also special.
function $426a228a266c36e2$var$InternalEncoderCesu8(options, codec) {}
$426a228a266c36e2$var$InternalEncoderCesu8.prototype.write = function(str) {
    var buf = $426a228a266c36e2$require$Buffer.alloc(str.length * 3), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var charCode = str.charCodeAt(i);
        // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80) buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        } else {
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
};
$426a228a266c36e2$var$InternalEncoderCesu8.prototype.end = function() {};
//------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+
function $426a228a266c36e2$var$InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}
$426a228a266c36e2$var$InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, res = '';
    for(var i = 0; i < buf.length; i++){
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) {
            if (contBytes > 0) {
                res += this.defaultCharUnicode;
                contBytes = 0;
            }
            if (curByte < 0x80) res += String.fromCharCode(curByte);
            else if (curByte < 0xE0) {
                acc = curByte & 0x1F;
                contBytes = 1;
                accBytes = 1;
            } else if (curByte < 0xF0) {
                acc = curByte & 0x0F;
                contBytes = 2;
                accBytes = 1;
            } else res += this.defaultCharUnicode;
        } else if (contBytes > 0) {
            acc = acc << 6 | curByte & 0x3f;
            contBytes--;
            accBytes++;
            if (contBytes === 0) {
                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                else // Actually add character.
                res += String.fromCharCode(acc);
            }
        } else res += this.defaultCharUnicode;
    }
    this.acc = acc;
    this.contBytes = contBytes;
    this.accBytes = accBytes;
    return res;
};
$426a228a266c36e2$var$InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0) res += this.defaultCharUnicode;
    return res;
};

});
parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
'use strict';

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $6ZWSX.SlowBuffer(size);
};

});



parcelRegister("428wG", function(module, exports) {

$parcel$export(module.exports, "utf16be", () => $2efdf672016778c3$export$8b9ec48b10867f55, (v) => $2efdf672016778c3$export$8b9ec48b10867f55 = v);
$parcel$export(module.exports, "utf16", () => $2efdf672016778c3$export$5e3087022f4331a5, (v) => $2efdf672016778c3$export$5e3087022f4331a5 = v);
// Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
// == UTF16-BE codec. ==========================================================
var $2efdf672016778c3$export$8b9ec48b10867f55;
// == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
var $2efdf672016778c3$export$5e3087022f4331a5;
"use strict";

var $5ZrzL = parcelRequire("5ZrzL");
var $2efdf672016778c3$require$Buffer = $5ZrzL.Buffer;
$2efdf672016778c3$export$8b9ec48b10867f55 = $2efdf672016778c3$var$Utf16BECodec;
function $2efdf672016778c3$var$Utf16BECodec() {}
$2efdf672016778c3$var$Utf16BECodec.prototype.encoder = $2efdf672016778c3$var$Utf16BEEncoder;
$2efdf672016778c3$var$Utf16BECodec.prototype.decoder = $2efdf672016778c3$var$Utf16BEDecoder;
$2efdf672016778c3$var$Utf16BECodec.prototype.bomAware = true;
// -- Encoding
function $2efdf672016778c3$var$Utf16BEEncoder() {}
$2efdf672016778c3$var$Utf16BEEncoder.prototype.write = function(str) {
    var buf = $2efdf672016778c3$require$Buffer.from(str, 'ucs2');
    for(var i = 0; i < buf.length; i += 2){
        var tmp = buf[i];
        buf[i] = buf[i + 1];
        buf[i + 1] = tmp;
    }
    return buf;
};
$2efdf672016778c3$var$Utf16BEEncoder.prototype.end = function() {};
// -- Decoding
function $2efdf672016778c3$var$Utf16BEDecoder() {
    this.overflowByte = -1;
}
$2efdf672016778c3$var$Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0) return '';
    var buf2 = $2efdf672016778c3$require$Buffer.alloc(buf.length + 1), i = 0, j = 0;
    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1;
        j = 2;
    }
    for(; i < buf.length - 1; i += 2, j += 2){
        buf2[j] = buf[i + 1];
        buf2[j + 1] = buf[i];
    }
    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
    return buf2.slice(0, j).toString('ucs2');
};
$2efdf672016778c3$var$Utf16BEDecoder.prototype.end = function() {};
$2efdf672016778c3$export$5e3087022f4331a5 = $2efdf672016778c3$var$Utf16Codec;
function $2efdf672016778c3$var$Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$2efdf672016778c3$var$Utf16Codec.prototype.encoder = $2efdf672016778c3$var$Utf16Encoder;
$2efdf672016778c3$var$Utf16Codec.prototype.decoder = $2efdf672016778c3$var$Utf16Decoder;
// -- Encoding (pass-through)
function $2efdf672016778c3$var$Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder('utf-16le', options);
}
$2efdf672016778c3$var$Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
$2efdf672016778c3$var$Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
};
// -- Decoding
function $2efdf672016778c3$var$Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBytes = [];
    this.initialBytesLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
$2efdf672016778c3$var$Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBytes.push(buf);
        this.initialBytesLen += buf.length;
        if (this.initialBytesLen < 16) return '';
        // We have enough bytes -> detect endianness.
        var buf = $2efdf672016778c3$require$Buffer.concat(this.initialBytes), encoding = $2efdf672016778c3$var$detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        this.initialBytes.length = this.initialBytesLen = 0;
    }
    return this.decoder.write(buf);
};
$2efdf672016778c3$var$Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var buf = $2efdf672016778c3$require$Buffer.concat(this.initialBytes), encoding = $2efdf672016778c3$var$detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var res = this.decoder.write(buf), trail = this.decoder.end();
        return trail ? res + trail : res;
    }
    return this.decoder.end();
};
function $2efdf672016778c3$var$detectEncoding(buf, defaultEncoding) {
    var enc = defaultEncoding || 'utf-16le';
    if (buf.length >= 2) {
        // Check BOM.
        if (buf[0] == 0xFE && buf[1] == 0xFF) enc = 'utf-16be';
        else if (buf[0] == 0xFF && buf[1] == 0xFE) enc = 'utf-16le';
        else {
            // No BOM found. Try to deduce encoding from initial content.
            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
            // So, we count ASCII as if it was LE or BE, and decide from that.
            var asciiCharsLE = 0, asciiCharsBE = 0, _len = Math.min(buf.length - buf.length % 2, 64); // Len is always even.
            for(var i = 0; i < _len; i += 2){
                if (buf[i] === 0 && buf[i + 1] !== 0) asciiCharsBE++;
                if (buf[i] !== 0 && buf[i + 1] === 0) asciiCharsLE++;
            }
            if (asciiCharsBE > asciiCharsLE) enc = 'utf-16be';
            else if (asciiCharsBE < asciiCharsLE) enc = 'utf-16le';
        }
    }
    return enc;
}

});

parcelRegister("9ar1n", function(module, exports) {

$parcel$export(module.exports, "utf7", () => $6aca02159dd489fb$export$b2f9c8661b81cf99, (v) => $6aca02159dd489fb$export$b2f9c8661b81cf99 = v);
$parcel$export(module.exports, "unicode11utf7", () => $6aca02159dd489fb$export$cc49de5f94fc4004, (v) => $6aca02159dd489fb$export$cc49de5f94fc4004 = v);
$parcel$export(module.exports, "utf7imap", () => $6aca02159dd489fb$export$2488b28744623c18, (v) => $6aca02159dd489fb$export$2488b28744623c18 = v);
// UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
var $6aca02159dd489fb$export$b2f9c8661b81cf99;
var $6aca02159dd489fb$export$cc49de5f94fc4004;
// UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.
var $6aca02159dd489fb$export$2488b28744623c18;
"use strict";

var $5ZrzL = parcelRequire("5ZrzL");
var $6aca02159dd489fb$require$Buffer = $5ZrzL.Buffer;
$6aca02159dd489fb$export$b2f9c8661b81cf99 = $6aca02159dd489fb$var$Utf7Codec;
$6aca02159dd489fb$export$cc49de5f94fc4004 = 'utf7'; // Alias UNICODE-1-1-UTF-7
function $6aca02159dd489fb$var$Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$6aca02159dd489fb$var$Utf7Codec.prototype.encoder = $6aca02159dd489fb$var$Utf7Encoder;
$6aca02159dd489fb$var$Utf7Codec.prototype.decoder = $6aca02159dd489fb$var$Utf7Decoder;
$6aca02159dd489fb$var$Utf7Codec.prototype.bomAware = true;
// -- Encoding
var $6aca02159dd489fb$var$nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
function $6aca02159dd489fb$var$Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}
$6aca02159dd489fb$var$Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return $6aca02159dd489fb$require$Buffer.from(str.replace($6aca02159dd489fb$var$nonDirectChars, (function(chunk) {
        return "+" + (chunk === '+' ? '' : this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) + "-";
    }).bind(this)));
};
$6aca02159dd489fb$var$Utf7Encoder.prototype.end = function() {};
// -- Decoding
function $6aca02159dd489fb$var$Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var $6aca02159dd489fb$var$base64Regex = /[A-Za-z0-9\/+]/;
var $6aca02159dd489fb$var$base64Chars = [];
for(var $6aca02159dd489fb$var$i = 0; $6aca02159dd489fb$var$i < 256; $6aca02159dd489fb$var$i++)$6aca02159dd489fb$var$base64Chars[$6aca02159dd489fb$var$i] = $6aca02159dd489fb$var$base64Regex.test(String.fromCharCode($6aca02159dd489fb$var$i));
var $6aca02159dd489fb$var$plusChar = '+'.charCodeAt(0), $6aca02159dd489fb$var$minusChar = '-'.charCodeAt(0), $6aca02159dd489fb$var$andChar = '&'.charCodeAt(0);
$6aca02159dd489fb$var$Utf7Decoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '+'
        {
            if (buf[i] == $6aca02159dd489fb$var$plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!$6aca02159dd489fb$var$base64Chars[buf[i]]) {
            if (i == lastI && buf[i] == $6aca02159dd489fb$var$minusChar) res += "+";
            else {
                var b64str = base64Accum + buf.slice(lastI, i).toString();
                res += this.iconv.decode($6aca02159dd489fb$require$Buffer.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != $6aca02159dd489fb$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + buf.slice(lastI).toString();
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($6aca02159dd489fb$require$Buffer.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$6aca02159dd489fb$var$Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($6aca02159dd489fb$require$Buffer.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
};
$6aca02159dd489fb$export$2488b28744623c18 = $6aca02159dd489fb$var$Utf7IMAPCodec;
function $6aca02159dd489fb$var$Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
}
$6aca02159dd489fb$var$Utf7IMAPCodec.prototype.encoder = $6aca02159dd489fb$var$Utf7IMAPEncoder;
$6aca02159dd489fb$var$Utf7IMAPCodec.prototype.decoder = $6aca02159dd489fb$var$Utf7IMAPDecoder;
$6aca02159dd489fb$var$Utf7IMAPCodec.prototype.bomAware = true;
// -- Encoding
function $6aca02159dd489fb$var$Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = $6aca02159dd489fb$require$Buffer.alloc(6);
    this.base64AccumIdx = 0;
}
$6aca02159dd489fb$var$Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64, base64Accum = this.base64Accum, base64AccumIdx = this.base64AccumIdx, buf = $6aca02159dd489fb$require$Buffer.alloc(str.length * 5 + 10), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var uChar = str.charCodeAt(i);
        if (0x20 <= uChar && uChar <= 0x7E) {
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                    base64AccumIdx = 0;
                }
                buf[bufIdx++] = $6aca02159dd489fb$var$minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
            }
            if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character
                if (uChar === $6aca02159dd489fb$var$andChar) buf[bufIdx++] = $6aca02159dd489fb$var$minusChar;
            }
        } else {
            if (!inBase64) {
                buf[bufIdx++] = $6aca02159dd489fb$var$andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }
    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;
    return buf.slice(0, bufIdx);
};
$6aca02159dd489fb$var$Utf7IMAPEncoder.prototype.end = function() {
    var buf = $6aca02159dd489fb$require$Buffer.alloc(10), bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
            this.base64AccumIdx = 0;
        }
        buf[bufIdx++] = $6aca02159dd489fb$var$minusChar; // Write '-', then go to direct mode.
        this.inBase64 = false;
    }
    return buf.slice(0, bufIdx);
};
// -- Decoding
function $6aca02159dd489fb$var$Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var $6aca02159dd489fb$var$base64IMAPChars = $6aca02159dd489fb$var$base64Chars.slice();
$6aca02159dd489fb$var$base64IMAPChars[','.charCodeAt(0)] = true;
$6aca02159dd489fb$var$Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum;
    // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // Write direct chars until '&'
        {
            if (buf[i] == $6aca02159dd489fb$var$andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else if (!$6aca02159dd489fb$var$base64IMAPChars[buf[i]]) {
            if (i == lastI && buf[i] == $6aca02159dd489fb$var$minusChar) res += "&";
            else {
                var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
                res += this.iconv.decode($6aca02159dd489fb$require$Buffer.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != $6aca02159dd489fb$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($6aca02159dd489fb$require$Buffer.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$6aca02159dd489fb$var$Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($6aca02159dd489fb$require$Buffer.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
};

});

parcelRegister("l2RZw", function(module, exports) {

$parcel$export(module.exports, "_sbcs", () => $f523aa6956895cf8$export$90ce6c201c0ff1a9, (v) => $f523aa6956895cf8$export$90ce6c201c0ff1a9 = v);
// Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII). 
var $f523aa6956895cf8$export$90ce6c201c0ff1a9;
"use strict";

var $5ZrzL = parcelRequire("5ZrzL");
var $f523aa6956895cf8$require$Buffer = $5ZrzL.Buffer;
$f523aa6956895cf8$export$90ce6c201c0ff1a9 = $f523aa6956895cf8$var$SBCSCodec;
function $f523aa6956895cf8$var$SBCSCodec(codecOptions, iconv) {
    if (!codecOptions) throw new Error("SBCS codec is called without the data.");
    // Prepare char buffer for decoding.
    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }
    this.decodeBuf = $f523aa6956895cf8$require$Buffer.from(codecOptions.chars, 'ucs2');
    // Encoding buffer.
    var encodeBuf = $f523aa6956895cf8$require$Buffer.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
    this.encodeBuf = encodeBuf;
}
$f523aa6956895cf8$var$SBCSCodec.prototype.encoder = $f523aa6956895cf8$var$SBCSEncoder;
$f523aa6956895cf8$var$SBCSCodec.prototype.decoder = $f523aa6956895cf8$var$SBCSDecoder;
function $f523aa6956895cf8$var$SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}
$f523aa6956895cf8$var$SBCSEncoder.prototype.write = function(str) {
    var buf = $f523aa6956895cf8$require$Buffer.alloc(str.length);
    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
    return buf;
};
$f523aa6956895cf8$var$SBCSEncoder.prototype.end = function() {};
function $f523aa6956895cf8$var$SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}
$f523aa6956895cf8$var$SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = $f523aa6956895cf8$require$Buffer.alloc(buf.length * 2);
    var idx1 = 0, idx2 = 0;
    for(var i = 0; i < buf.length; i++){
        idx1 = buf[i] * 2;
        idx2 = i * 2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
    }
    return newBuf.toString('ucs2');
};
$f523aa6956895cf8$var$SBCSDecoder.prototype.end = function() {};

});

parcelRegister("cJ0pA", function(module, exports) {
"use strict";
// Manually added data to be used by sbcs codec in addition to generated one.
module.exports = {
    // Not supported by iconv, not sure why.
    "10029": "maccenteuro",
    "maccenteuro": {
        "type": "_sbcs",
        "chars": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7"
    },
    "808": "cp808",
    "ibm808": "cp808",
    "cp808": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\u20AC\u25A0\xa0"
    },
    "mik": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2514\u2534\u252C\u251C\u2500\u253C\u2563\u2551\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2510\u2591\u2592\u2593\u2502\u2524\u2116\xa7\u2557\u255D\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    // Aliases of generated encodings.
    "ascii8bit": "ascii",
    "usascii": "ascii",
    "ansix34": "ascii",
    "ansix341968": "ascii",
    "ansix341986": "ascii",
    "csascii": "ascii",
    "cp367": "ascii",
    "ibm367": "ascii",
    "isoir6": "ascii",
    "iso646us": "ascii",
    "iso646irv": "ascii",
    "us": "ascii",
    "latin1": "iso88591",
    "latin2": "iso88592",
    "latin3": "iso88593",
    "latin4": "iso88594",
    "latin5": "iso88599",
    "latin6": "iso885910",
    "latin7": "iso885913",
    "latin8": "iso885914",
    "latin9": "iso885915",
    "latin10": "iso885916",
    "csisolatin1": "iso88591",
    "csisolatin2": "iso88592",
    "csisolatin3": "iso88593",
    "csisolatin4": "iso88594",
    "csisolatincyrillic": "iso88595",
    "csisolatinarabic": "iso88596",
    "csisolatingreek": "iso88597",
    "csisolatinhebrew": "iso88598",
    "csisolatin5": "iso88599",
    "csisolatin6": "iso885910",
    "l1": "iso88591",
    "l2": "iso88592",
    "l3": "iso88593",
    "l4": "iso88594",
    "l5": "iso88599",
    "l6": "iso885910",
    "l7": "iso885913",
    "l8": "iso885914",
    "l9": "iso885915",
    "l10": "iso885916",
    "isoir14": "iso646jp",
    "isoir57": "iso646cn",
    "isoir100": "iso88591",
    "isoir101": "iso88592",
    "isoir109": "iso88593",
    "isoir110": "iso88594",
    "isoir144": "iso88595",
    "isoir127": "iso88596",
    "isoir126": "iso88597",
    "isoir138": "iso88598",
    "isoir148": "iso88599",
    "isoir157": "iso885910",
    "isoir166": "tis620",
    "isoir179": "iso885913",
    "isoir199": "iso885914",
    "isoir203": "iso885915",
    "isoir226": "iso885916",
    "cp819": "iso88591",
    "ibm819": "iso88591",
    "cyrillic": "iso88595",
    "arabic": "iso88596",
    "arabic8": "iso88596",
    "ecma114": "iso88596",
    "asmo708": "iso88596",
    "greek": "iso88597",
    "greek8": "iso88597",
    "ecma118": "iso88597",
    "elot928": "iso88597",
    "hebrew": "iso88598",
    "hebrew8": "iso88598",
    "turkish": "iso88599",
    "turkish8": "iso88599",
    "thai": "iso885911",
    "thai8": "iso885911",
    "celtic": "iso885914",
    "celtic8": "iso885914",
    "isoceltic": "iso885914",
    "tis6200": "tis620",
    "tis62025291": "tis620",
    "tis62025330": "tis620",
    "10000": "macroman",
    "10006": "macgreek",
    "10007": "maccyrillic",
    "10079": "maciceland",
    "10081": "macturkish",
    "cspc8codepage437": "cp437",
    "cspc775baltic": "cp775",
    "cspc850multilingual": "cp850",
    "cspcp852": "cp852",
    "cspc862latinhebrew": "cp862",
    "cpgr": "cp869",
    "msee": "cp1250",
    "mscyrl": "cp1251",
    "msansi": "cp1252",
    "msgreek": "cp1253",
    "msturk": "cp1254",
    "mshebr": "cp1255",
    "msarab": "cp1256",
    "winbaltrim": "cp1257",
    "cp20866": "koi8r",
    "20866": "koi8r",
    "ibm878": "koi8r",
    "cskoi8r": "koi8r",
    "cp21866": "koi8u",
    "21866": "koi8u",
    "ibm1168": "koi8u",
    "strk10482002": "rk1048",
    "tcvn5712": "tcvn",
    "tcvn57121": "tcvn",
    "gb198880": "iso646cn",
    "cn": "iso646cn",
    "csiso14jisc6220ro": "iso646jp",
    "jisc62201969ro": "iso646jp",
    "jp": "iso646jp",
    "cshproman8": "hproman8",
    "r8": "hproman8",
    "roman8": "hproman8",
    "xroman8": "hproman8",
    "ibm1051": "hproman8",
    "mac": "macintosh",
    "csmacintosh": "macintosh"
};

});

parcelRegister("2BLNr", function(module, exports) {
"use strict";
// Generated data for sbcs codec. Don't edit manually. Regenerate using generation/gen-sbcs.js script.
module.exports = {
    "437": "cp437",
    "737": "cp737",
    "775": "cp775",
    "850": "cp850",
    "852": "cp852",
    "855": "cp855",
    "856": "cp856",
    "857": "cp857",
    "858": "cp858",
    "860": "cp860",
    "861": "cp861",
    "862": "cp862",
    "863": "cp863",
    "864": "cp864",
    "865": "cp865",
    "866": "cp866",
    "869": "cp869",
    "874": "windows874",
    "922": "cp922",
    "1046": "cp1046",
    "1124": "cp1124",
    "1125": "cp1125",
    "1129": "cp1129",
    "1133": "cp1133",
    "1161": "cp1161",
    "1162": "cp1162",
    "1163": "cp1163",
    "1250": "windows1250",
    "1251": "windows1251",
    "1252": "windows1252",
    "1253": "windows1253",
    "1254": "windows1254",
    "1255": "windows1255",
    "1256": "windows1256",
    "1257": "windows1257",
    "1258": "windows1258",
    "28591": "iso88591",
    "28592": "iso88592",
    "28593": "iso88593",
    "28594": "iso88594",
    "28595": "iso88595",
    "28596": "iso88596",
    "28597": "iso88597",
    "28598": "iso88598",
    "28599": "iso88599",
    "28600": "iso885910",
    "28601": "iso885911",
    "28603": "iso885913",
    "28604": "iso885914",
    "28605": "iso885915",
    "28606": "iso885916",
    "windows874": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "win874": "windows874",
    "cp874": "windows874",
    "windows1250": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "win1250": "windows1250",
    "cp1250": "windows1250",
    "windows1251": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "win1251": "windows1251",
    "cp1251": "windows1251",
    "windows1252": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "win1252": "windows1252",
    "cp1252": "windows1252",
    "windows1253": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "win1253": "windows1253",
    "cp1253": "windows1253",
    "windows1254": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "win1254": "windows1254",
    "cp1254": "windows1254",
    "windows1255": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\u05BA\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "win1255": "windows1255",
    "cp1255": "windows1255",
    "windows1256": {
        "type": "_sbcs",
        "chars": "\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2"
    },
    "win1256": "windows1256",
    "cp1256": "windows1256",
    "windows1257": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9"
    },
    "win1257": "windows1257",
    "cp1257": "windows1257",
    "windows1258": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "win1258": "windows1258",
    "cp1258": "windows1258",
    "iso88591": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28591": "iso88591",
    "iso88592": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u02D8\u0141\xa4\u013D\u015A\xa7\xa8\u0160\u015E\u0164\u0179\xad\u017D\u017B\xb0\u0105\u02DB\u0142\xb4\u013E\u015B\u02C7\xb8\u0161\u015F\u0165\u017A\u02DD\u017E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "cp28592": "iso88592",
    "iso88593": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0126\u02D8\xa3\xa4\uFFFD\u0124\xa7\xa8\u0130\u015E\u011E\u0134\xad\uFFFD\u017B\xb0\u0127\xb2\xb3\xb4\xb5\u0125\xb7\xb8\u0131\u015F\u011F\u0135\xbd\uFFFD\u017C\xc0\xc1\xc2\uFFFD\xc4\u010A\u0108\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\uFFFD\xd1\xd2\xd3\xd4\u0120\xd6\xd7\u011C\xd9\xda\xdb\xdc\u016C\u015C\xdf\xe0\xe1\xe2\uFFFD\xe4\u010B\u0109\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\uFFFD\xf1\xf2\xf3\xf4\u0121\xf6\xf7\u011D\xf9\xfa\xfb\xfc\u016D\u015D\u02D9"
    },
    "cp28593": "iso88593",
    "iso88594": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0138\u0156\xa4\u0128\u013B\xa7\xa8\u0160\u0112\u0122\u0166\xad\u017D\xaf\xb0\u0105\u02DB\u0157\xb4\u0129\u013C\u02C7\xb8\u0161\u0113\u0123\u0167\u014A\u017E\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\u012A\u0110\u0145\u014C\u0136\xd4\xd5\xd6\xd7\xd8\u0172\xda\xdb\xdc\u0168\u016A\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\u012B\u0111\u0146\u014D\u0137\xf4\xf5\xf6\xf7\xf8\u0173\xfa\xfb\xfc\u0169\u016B\u02D9"
    },
    "cp28594": "iso88594",
    "iso88595": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0403\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "cp28595": "iso88595",
    "iso88596": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\uFFFD\uFFFD\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u060C\xad\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061B\uFFFD\uFFFD\uFFFD\u061F\uFFFD\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28596": "iso88596",
    "iso88597": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u2018\u2019\xa3\u20AC\u20AF\xa6\xa7\xa8\xa9\u037A\xab\xac\xad\uFFFD\u2015\xb0\xb1\xb2\xb3\u0384\u0385\u0386\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "cp28597": "iso88597",
    "iso88598": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2017\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "cp28598": "iso88598",
    "iso88599": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "cp28599": "iso88599",
    "iso885910": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0112\u0122\u012A\u0128\u0136\xa7\u013B\u0110\u0160\u0166\u017D\xad\u016A\u014A\xb0\u0105\u0113\u0123\u012B\u0129\u0137\xb7\u013C\u0111\u0161\u0167\u017E\u2015\u016B\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\xcf\xd0\u0145\u014C\xd3\xd4\xd5\xd6\u0168\xd8\u0172\xda\xdb\xdc\xdd\xde\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\xef\xf0\u0146\u014D\xf3\xf4\xf5\xf6\u0169\xf8\u0173\xfa\xfb\xfc\xfd\xfe\u0138"
    },
    "cp28600": "iso885910",
    "iso885911": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28601": "iso885911",
    "iso885913": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u201D\xa2\xa3\xa4\u201E\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\u201C\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u2019"
    },
    "cp28603": "iso885913",
    "iso885914": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u1E02\u1E03\xa3\u010A\u010B\u1E0A\xa7\u1E80\xa9\u1E82\u1E0B\u1EF2\xad\xae\u0178\u1E1E\u1E1F\u0120\u0121\u1E40\u1E41\xb6\u1E56\u1E81\u1E57\u1E83\u1E60\u1EF3\u1E84\u1E85\u1E61\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0174\xd1\xd2\xd3\xd4\xd5\xd6\u1E6A\xd8\xd9\xda\xdb\xdc\xdd\u0176\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0175\xf1\xf2\xf3\xf4\xf5\xf6\u1E6B\xf8\xf9\xfa\xfb\xfc\xfd\u0177\xff"
    },
    "cp28604": "iso885914",
    "iso885915": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\u0160\xa7\u0161\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u017D\xb5\xb6\xb7\u017E\xb9\xba\xbb\u0152\u0153\u0178\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28605": "iso885915",
    "iso885916": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0105\u0141\u20AC\u201E\u0160\xa7\u0161\xa9\u0218\xab\u0179\xad\u017A\u017B\xb0\xb1\u010C\u0142\u017D\u201D\xb6\xb7\u017E\u010D\u0219\xbb\u0152\u0153\u0178\u017C\xc0\xc1\xc2\u0102\xc4\u0106\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0110\u0143\xd2\xd3\xd4\u0150\xd6\u015A\u0170\xd9\xda\xdb\xdc\u0118\u021A\xdf\xe0\xe1\xe2\u0103\xe4\u0107\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0111\u0144\xf2\xf3\xf4\u0151\xf6\u015B\u0171\xf9\xfa\xfb\xfc\u0119\u021B\xff"
    },
    "cp28606": "iso885916",
    "cp437": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm437": "cp437",
    "csibm437": "cp437",
    "cp737": {
        "type": "_sbcs",
        "chars": "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm737": "cp737",
    "csibm737": "cp737",
    "cp775": {
        "type": "_sbcs",
        "chars": "\u0106\xfc\xe9\u0101\xe4\u0123\xe5\u0107\u0142\u0113\u0156\u0157\u012B\u0179\xc4\xc5\xc9\xe6\xc6\u014D\xf6\u0122\xa2\u015A\u015B\xd6\xdc\xf8\xa3\xd8\xd7\xa4\u0100\u012A\xf3\u017B\u017C\u017A\u201D\xa6\xa9\xae\xac\xbd\xbc\u0141\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0104\u010C\u0118\u0116\u2563\u2551\u2557\u255D\u012E\u0160\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0172\u016A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u017D\u0105\u010D\u0119\u0117\u012F\u0161\u0173\u016B\u017E\u2518\u250C\u2588\u2584\u258C\u2590\u2580\xd3\xdf\u014C\u0143\xf5\xd5\xb5\u0144\u0136\u0137\u013B\u013C\u0146\u0112\u0145\u2019\xad\xb1\u201C\xbe\xb6\xa7\xf7\u201E\xb0\u2219\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm775": "cp775",
    "csibm775": "cp775",
    "cp850": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm850": "cp850",
    "csibm850": "cp850",
    "cp852": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0"
    },
    "ibm852": "cp852",
    "csibm852": "cp852",
    "cp855": {
        "type": "_sbcs",
        "chars": "\u0452\u0402\u0453\u0403\u0451\u0401\u0454\u0404\u0455\u0405\u0456\u0406\u0457\u0407\u0458\u0408\u0459\u0409\u045A\u040A\u045B\u040B\u045C\u040C\u045E\u040E\u045F\u040F\u044E\u042E\u044A\u042A\u0430\u0410\u0431\u0411\u0446\u0426\u0434\u0414\u0435\u0415\u0444\u0424\u0433\u0413\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0445\u0425\u0438\u0418\u2563\u2551\u2557\u255D\u0439\u0419\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u043A\u041A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u043B\u041B\u043C\u041C\u043D\u041D\u043E\u041E\u043F\u2518\u250C\u2588\u2584\u041F\u044F\u2580\u042F\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0436\u0416\u0432\u0412\u044C\u042C\u2116\xad\u044B\u042B\u0437\u0417\u0448\u0428\u044D\u042D\u0449\u0429\u0447\u0427\xa7\u25A0\xa0"
    },
    "ibm855": "cp855",
    "csibm855": "cp855",
    "cp856": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\xa3\uFFFD\xd7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xae\xac\xbd\xbc\uFFFD\xab\xbb\u2591\u2592\u2593\u2502\u2524\uFFFD\uFFFD\uFFFD\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\uFFFD\uFFFD\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2518\u250C\u2588\u2584\xa6\uFFFD\u2580\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xb5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm856": "cp856",
    "csibm856": "cp856",
    "cp857": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm857": "cp857",
    "csibm857": "cp857",
    "cp858": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u20AC\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm858": "cp858",
    "csibm858": "cp858",
    "cp860": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9\u20A7\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm860": "cp860",
    "csibm860": "cp860",
    "cp861": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm861": "cp861",
    "csibm861": "cp861",
    "cp862": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm862": "cp862",
    "csibm862": "cp862",
    "cp863": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee\u2017\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdb\u0192\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce\u2310\xac\xbd\xbc\xbe\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm863": "cp863",
    "csibm863": "cp863",
    "cp864": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$\u066A&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xb0\xb7\u2219\u221A\u2592\u2500\u2502\u253C\u2524\u252C\u251C\u2534\u2510\u250C\u2514\u2518\u03B2\u221E\u03C6\xb1\xbd\xbc\u2248\xab\xbb\uFEF7\uFEF8\uFFFD\uFFFD\uFEFB\uFEFC\uFFFD\xa0\xad\uFE82\xa3\xa4\uFE84\uFFFD\uFFFD\uFE8E\uFE8F\uFE95\uFE99\u060C\uFE9D\uFEA1\uFEA5\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFED1\u061B\uFEB1\uFEB5\uFEB9\u061F\xa2\uFE80\uFE81\uFE83\uFE85\uFECA\uFE8B\uFE8D\uFE91\uFE93\uFE97\uFE9B\uFE9F\uFEA3\uFEA7\uFEA9\uFEAB\uFEAD\uFEAF\uFEB3\uFEB7\uFEBB\uFEBF\uFEC1\uFEC5\uFECB\uFECF\xa6\xac\xf7\xd7\uFEC9\u0640\uFED3\uFED7\uFEDB\uFEDF\uFEE3\uFEE7\uFEEB\uFEED\uFEEF\uFEF3\uFEBD\uFECC\uFECE\uFECD\uFEE1\uFE7D\u0651\uFEE5\uFEE9\uFEEC\uFEF0\uFEF2\uFED0\uFED5\uFEF5\uFEF6\uFEDD\uFED9\uFEF1\u25A0\uFFFD"
    },
    "ibm864": "cp864",
    "csibm864": "cp864",
    "cp865": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm865": "cp865",
    "csibm865": "cp865",
    "cp866": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm866": "cp866",
    "csibm866": "cp866",
    "cp869": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0386\uFFFD\xb7\xac\xa6\u2018\u2019\u0388\u2015\u0389\u038A\u03AA\u038C\uFFFD\uFFFD\u038E\u03AB\xa9\u038F\xb2\xb3\u03AC\xa3\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03CD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\xbd\u0398\u0399\xab\xbb\u2591\u2592\u2593\u2502\u2524\u039A\u039B\u039C\u039D\u2563\u2551\u2557\u255D\u039E\u039F\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u03A0\u03A1\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u2518\u250C\u2588\u2584\u03B4\u03B5\u2580\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u0384\xad\xb1\u03C5\u03C6\u03C7\xa7\u03C8\u0385\xb0\xa8\u03C9\u03CB\u03B0\u03CE\u25A0\xa0"
    },
    "ibm869": "cp869",
    "csibm869": "cp869",
    "cp922": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\u203E\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0160\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\u017D\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0161\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\u017E\xff"
    },
    "ibm922": "cp922",
    "csibm922": "cp922",
    "cp1046": {
        "type": "_sbcs",
        "chars": "\uFE88\xd7\xf7\uF8F6\uF8F5\uF8F4\uF8F7\uFE71\x88\u25A0\u2502\u2500\u2510\u250C\u2514\u2518\uFE79\uFE7B\uFE7D\uFE7F\uFE77\uFE8A\uFEF0\uFEF3\uFEF2\uFECE\uFECF\uFED0\uFEF6\uFEF8\uFEFA\uFEFC\xa0\uF8FA\uF8F9\uF8F8\xa4\uF8FB\uFE8B\uFE91\uFE97\uFE9B\uFE9F\uFEA3\u060C\xad\uFEA7\uFEB3\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFEB7\u061B\uFEBB\uFEBF\uFECA\u061F\uFECB\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\uFEC7\u0639\u063A\uFECC\uFE82\uFE84\uFE8E\uFED3\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFED7\uFEDB\uFEDF\uF8FC\uFEF5\uFEF7\uFEF9\uFEFB\uFEE3\uFEE7\uFEEC\uFEE9\uFFFD"
    },
    "ibm1046": "cp1046",
    "csibm1046": "cp1046",
    "cp1124": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0490\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0491\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "ibm1124": "cp1124",
    "csibm1124": "cp1124",
    "cp1125": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0490\u0491\u0404\u0454\u0406\u0456\u0407\u0457\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm1125": "cp1125",
    "csibm1125": "cp1125",
    "cp1129": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1129": "cp1129",
    "csibm1129": "cp1129",
    "cp1133": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E81\u0E82\u0E84\u0E87\u0E88\u0EAA\u0E8A\u0E8D\u0E94\u0E95\u0E96\u0E97\u0E99\u0E9A\u0E9B\u0E9C\u0E9D\u0E9E\u0E9F\u0EA1\u0EA2\u0EA3\u0EA5\u0EA7\u0EAB\u0EAD\u0EAE\uFFFD\uFFFD\uFFFD\u0EAF\u0EB0\u0EB2\u0EB3\u0EB4\u0EB5\u0EB6\u0EB7\u0EB8\u0EB9\u0EBC\u0EB1\u0EBB\u0EBD\uFFFD\uFFFD\uFFFD\u0EC0\u0EC1\u0EC2\u0EC3\u0EC4\u0EC8\u0EC9\u0ECA\u0ECB\u0ECC\u0ECD\u0EC6\uFFFD\u0EDC\u0EDD\u20AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0ED0\u0ED1\u0ED2\u0ED3\u0ED4\u0ED5\u0ED6\u0ED7\u0ED8\u0ED9\uFFFD\uFFFD\xa2\xac\xa6\uFFFD"
    },
    "ibm1133": "cp1133",
    "csibm1133": "cp1133",
    "cp1161": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E48\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\u0E49\u0E4A\u0E4B\u20AC\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\xa2\xac\xa6\xa0"
    },
    "ibm1161": "cp1161",
    "csibm1161": "cp1161",
    "cp1162": {
        "type": "_sbcs",
        "chars": "\u20AC\x81\x82\x83\x84\u2026\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "ibm1162": "cp1162",
    "csibm1162": "cp1162",
    "cp1163": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1163": "cp1163",
    "csibm1163": "cp1163",
    "maccroatian": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u2126\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uFFFD\xa9\u2044\xa4\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7"
    },
    "maccyrillic": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "macgreek": {
        "type": "_sbcs",
        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD"
    },
    "maciceland": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macroman": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macromania": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u015E\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\u0103\u015F\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\u0162\u0163\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macthai": {
        "type": "_sbcs",
        "chars": "\xab\xbb\u2026\uF88C\uF88F\uF892\uF895\uF898\uF88B\uF88E\uF891\uF894\uF897\u201C\u201D\uF899\uFFFD\u2022\uF884\uF889\uF885\uF886\uF887\uF888\uF88A\uF88D\uF890\uF893\uF896\u2018\u2019\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFEFF\u200B\u2013\u2014\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u2122\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\xae\xa9\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "macturkish": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macukraine": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "koi8r": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u0401\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8u": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u255D\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8ru": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u045E\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u040E\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8t": {
        "type": "_sbcs",
        "chars": "\u049B\u0493\u201A\u0492\u201E\u2026\u2020\u2021\uFFFD\u2030\u04B3\u2039\u04B2\u04B7\u04B6\uFFFD\u049A\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04EF\u04EE\u0451\xa4\u04E3\xa6\xa7\uFFFD\uFFFD\uFFFD\xab\xac\xad\xae\uFFFD\xb0\xb1\xb2\u0401\uFFFD\u04E2\xb6\xb7\uFFFD\u2116\uFFFD\xbb\uFFFD\uFFFD\uFFFD\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "armscii8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\u0587\u0589)(\xbb\xab\u2014.\u055D,-\u058A\u2026\u055C\u055B\u055E\u0531\u0561\u0532\u0562\u0533\u0563\u0534\u0564\u0535\u0565\u0536\u0566\u0537\u0567\u0538\u0568\u0539\u0569\u053A\u056A\u053B\u056B\u053C\u056C\u053D\u056D\u053E\u056E\u053F\u056F\u0540\u0570\u0541\u0571\u0542\u0572\u0543\u0573\u0544\u0574\u0545\u0575\u0546\u0576\u0547\u0577\u0548\u0578\u0549\u0579\u054A\u057A\u054B\u057B\u054C\u057C\u054D\u057D\u054E\u057E\u054F\u057F\u0550\u0580\u0551\u0581\u0552\u0582\u0553\u0583\u0554\u0584\u0555\u0585\u0556\u0586\u055A\uFFFD"
    },
    "rk1048": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u049A\u04BA\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u049B\u04BB\u045F\xa0\u04B0\u04B1\u04D8\xa4\u04E8\xa6\xa7\u0401\xa9\u0492\xab\xac\xad\xae\u04AE\xb0\xb1\u0406\u0456\u04E9\xb5\xb6\xb7\u0451\u2116\u0493\xbb\u04D9\u04A2\u04A3\u04AF\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "tcvn": {
        "type": "_sbcs",
        "chars": "\0\xda\u1EE4\x03\u1EEA\u1EEC\u1EEE\x07\b	\n\v\f\r\x0e\x0f\x10\u1EE8\u1EF0\u1EF2\u1EF6\u1EF8\xdd\u1EF4\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\xc0\u1EA2\xc3\xc1\u1EA0\u1EB6\u1EAC\xc8\u1EBA\u1EBC\xc9\u1EB8\u1EC6\xcc\u1EC8\u0128\xcd\u1ECA\xd2\u1ECE\xd5\xd3\u1ECC\u1ED8\u1EDC\u1EDE\u1EE0\u1EDA\u1EE2\xd9\u1EE6\u0168\xa0\u0102\xc2\xca\xd4\u01A0\u01AF\u0110\u0103\xe2\xea\xf4\u01A1\u01B0\u0111\u1EB0\u0300\u0309\u0303\u0301\u0323\xe0\u1EA3\xe3\xe1\u1EA1\u1EB2\u1EB1\u1EB3\u1EB5\u1EAF\u1EB4\u1EAE\u1EA6\u1EA8\u1EAA\u1EA4\u1EC0\u1EB7\u1EA7\u1EA9\u1EAB\u1EA5\u1EAD\xe8\u1EC2\u1EBB\u1EBD\xe9\u1EB9\u1EC1\u1EC3\u1EC5\u1EBF\u1EC7\xec\u1EC9\u1EC4\u1EBE\u1ED2\u0129\xed\u1ECB\xf2\u1ED4\u1ECF\xf5\xf3\u1ECD\u1ED3\u1ED5\u1ED7\u1ED1\u1ED9\u1EDD\u1EDF\u1EE1\u1EDB\u1EE3\xf9\u1ED6\u1EE7\u0169\xfa\u1EE5\u1EEB\u1EED\u1EEF\u1EE9\u1EF1\u1EF3\u1EF7\u1EF9\xfd\u1EF5\u1ED0"
    },
    "georgianacademy": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10EF\u10F0\u10F1\u10F2\u10F3\u10F4\u10F5\u10F6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "georgianps": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10F1\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10F2\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10F3\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10F4\u10EF\u10F0\u10F5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "pt154": {
        "type": "_sbcs",
        "chars": "\u0496\u0492\u04EE\u0493\u201E\u2026\u04B6\u04AE\u04B2\u04AF\u04A0\u04E2\u04A2\u049A\u04BA\u04B8\u0497\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u04B3\u04B7\u04A1\u04E3\u04A3\u049B\u04BB\u04B9\xa0\u040E\u045E\u0408\u04E8\u0498\u04B0\xa7\u0401\xa9\u04D8\xab\xac\u04EF\xae\u049C\xb0\u04B1\u0406\u0456\u0499\u04E9\xb6\xb7\u0451\u2116\u04D9\xbb\u0458\u04AA\u04AB\u049D\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "viscii": {
        "type": "_sbcs",
        "chars": "\0\x01\u1EB2\x03\x04\u1EB4\u1EAA\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\u1EF6\x15\x16\x17\x18\u1EF8\x1a\x1b\x1c\x1d\u1EF4\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7f\u1EA0\u1EAE\u1EB0\u1EB6\u1EA4\u1EA6\u1EA8\u1EAC\u1EBC\u1EB8\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EE2\u1EDA\u1EDC\u1EDE\u1ECA\u1ECE\u1ECC\u1EC8\u1EE6\u0168\u1EE4\u1EF2\xd5\u1EAF\u1EB1\u1EB7\u1EA5\u1EA7\u1EA9\u1EAD\u1EBD\u1EB9\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1ED1\u1ED3\u1ED5\u1ED7\u1EE0\u01A0\u1ED9\u1EDD\u1EDF\u1ECB\u1EF0\u1EE8\u1EEA\u1EEC\u01A1\u1EDB\u01AF\xc0\xc1\xc2\xc3\u1EA2\u0102\u1EB3\u1EB5\xc8\xc9\xca\u1EBA\xcc\xcd\u0128\u1EF3\u0110\u1EE9\xd2\xd3\xd4\u1EA1\u1EF7\u1EEB\u1EED\xd9\xda\u1EF9\u1EF5\xdd\u1EE1\u01B0\xe0\xe1\xe2\xe3\u1EA3\u0103\u1EEF\u1EAB\xe8\xe9\xea\u1EBB\xec\xed\u0129\u1EC9\u0111\u1EF1\xf2\xf3\xf4\xf5\u1ECF\u1ECD\u1EE5\xf9\xfa\u0169\u1EE7\xfd\u1EE3\u1EEE"
    },
    "iso646cn": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#\xa5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "iso646jp": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b	\n\v\f\r\x0e\x0f\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1a\x1b\x1c\x1d\x1e\x1f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xa5]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7f\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "hproman8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4\u02CB\u02C6\xa8\u02DC\xd9\xdb\u20A4\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7\u0192\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5\u0160\u0161\xda\u0178\xff\xde\xfe\xb7\xb5\xb6\xbe\u2014\xbc\xbd\xaa\xba\xab\u25A0\xbb\xb1\uFFFD"
    },
    "macintosh": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "ascii": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "tis620": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    }
};

});

parcelRegister("84zY3", function(module, exports) {

$parcel$export(module.exports, "_dbcs", () => $5e0a98dbbf444b79$export$d4d33b1e1c7abf2e, (v) => $5e0a98dbbf444b79$export$d4d33b1e1c7abf2e = v);
// Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.
var $5e0a98dbbf444b79$export$d4d33b1e1c7abf2e;
"use strict";

var $5ZrzL = parcelRequire("5ZrzL");
var $5e0a98dbbf444b79$require$Buffer = $5ZrzL.Buffer;
$5e0a98dbbf444b79$export$d4d33b1e1c7abf2e = $5e0a98dbbf444b79$var$DBCSCodec;
var $5e0a98dbbf444b79$var$UNASSIGNED = -1, $5e0a98dbbf444b79$var$GB18030_CODE = -2, $5e0a98dbbf444b79$var$SEQ_START = -10, $5e0a98dbbf444b79$var$NODE_START = -1000, $5e0a98dbbf444b79$var$UNASSIGNED_NODE = new Array(0x100), $5e0a98dbbf444b79$var$DEF_CHAR = -1;
for(var $5e0a98dbbf444b79$var$i = 0; $5e0a98dbbf444b79$var$i < 0x100; $5e0a98dbbf444b79$var$i++)$5e0a98dbbf444b79$var$UNASSIGNED_NODE[$5e0a98dbbf444b79$var$i] = $5e0a98dbbf444b79$var$UNASSIGNED;
// Class DBCSCodec reads and initializes mapping tables.
function $5e0a98dbbf444b79$var$DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data.");
    // Load tables.
    var mappingTable = codecOptions.table();
    // Decode tables: MBCS -> Unicode.
    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = $5e0a98dbbf444b79$var$UNASSIGNED_NODE.slice(0); // Create root node.
    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
    this.decodeTableSeq = [];
    // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
    this.defaultCharUnicode = iconv.defaultCharUnicode;
    // Encode tables: Unicode -> DBCS.
    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = [];
    // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = [];
    // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
        var val = codecOptions.encodeSkipVals[i];
        if (typeof val === 'number') skipEncodeChars[val] = true;
        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
    }
    // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars);
    // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }
    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === $5e0a98dbbf444b79$var$UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
    if (this.defCharSB === $5e0a98dbbf444b79$var$UNASSIGNED) this.defCharSB = "?".charCodeAt(0);
    // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === 'function') {
        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
        // Add GB18030 decode tables.
        var thirdByteNodeIdx = this.decodeTables.length;
        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = $5e0a98dbbf444b79$var$UNASSIGNED_NODE.slice(0);
        var fourthByteNodeIdx = this.decodeTables.length;
        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = $5e0a98dbbf444b79$var$UNASSIGNED_NODE.slice(0);
        for(var i = 0x81; i <= 0xFE; i++){
            var secondByteNodeIdx = $5e0a98dbbf444b79$var$NODE_START - this.decodeTables[0][i];
            var secondByteNode = this.decodeTables[secondByteNodeIdx];
            for(var j = 0x30; j <= 0x39; j++)secondByteNode[j] = $5e0a98dbbf444b79$var$NODE_START - thirdByteNodeIdx;
        }
        for(var i = 0x81; i <= 0xFE; i++)thirdByteNode[i] = $5e0a98dbbf444b79$var$NODE_START - fourthByteNodeIdx;
        for(var i = 0x30; i <= 0x39; i++)fourthByteNode[i] = $5e0a98dbbf444b79$var$GB18030_CODE;
    }
}
$5e0a98dbbf444b79$var$DBCSCodec.prototype.encoder = $5e0a98dbbf444b79$var$DBCSEncoder;
$5e0a98dbbf444b79$var$DBCSCodec.prototype.decoder = $5e0a98dbbf444b79$var$DBCSDecoder;
// Decoder helpers
$5e0a98dbbf444b79$var$DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for(; addr > 0; addr >>= 8)bytes.push(addr & 0xFF);
    if (bytes.length == 0) bytes.push(0);
    var node = this.decodeTables[0];
    for(var i = bytes.length - 1; i > 0; i--){
        var val = node[bytes[i]];
        if (val == $5e0a98dbbf444b79$var$UNASSIGNED) {
            node[bytes[i]] = $5e0a98dbbf444b79$var$NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = $5e0a98dbbf444b79$var$UNASSIGNED_NODE.slice(0));
        } else if (val <= $5e0a98dbbf444b79$var$NODE_START) node = this.decodeTables[$5e0a98dbbf444b79$var$NODE_START - val];
        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
};
$5e0a98dbbf444b79$var$DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16);
    // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF;
    // Write all other elements of the chunk to the table.
    for(var k = 1; k < chunk.length; k++){
        var part = chunk[k];
        if (typeof part === "string") for(var l = 0; l < part.length;){
            var code = part.charCodeAt(l++);
            if (0xD800 <= code && code < 0xDC00) {
                var codeTrail = part.charCodeAt(l++);
                if (0xDC00 <= codeTrail && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
            } else if (0x0FF0 < code && code <= 0x0FFF) {
                var len = 0xFFF - code + 2;
                var seq = [];
                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++)); // Simple variation: don't support surrogates or subsequences in seq.
                writeTable[curAddr++] = $5e0a98dbbf444b79$var$SEQ_START - this.decodeTableSeq.length;
                this.decodeTableSeq.push(seq);
            } else writeTable[curAddr++] = code; // Basic char
        }
        else if (typeof part === "number") {
            var charCode = writeTable[curAddr - 1] + 1;
            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
};
// Encoder helpers
$5e0a98dbbf444b79$var$DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
    if (this.encodeTable[high] === undefined) this.encodeTable[high] = $5e0a98dbbf444b79$var$UNASSIGNED_NODE.slice(0); // Create bucket on demand.
    return this.encodeTable[high];
};
$5e0a98dbbf444b79$var$DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= $5e0a98dbbf444b79$var$SEQ_START) this.encodeTableSeq[$5e0a98dbbf444b79$var$SEQ_START - bucket[low]][$5e0a98dbbf444b79$var$DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
    else if (bucket[low] == $5e0a98dbbf444b79$var$UNASSIGNED) bucket[low] = dbcsCode;
};
$5e0a98dbbf444b79$var$DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    var node;
    if (bucket[low] <= $5e0a98dbbf444b79$var$SEQ_START) // There's already a sequence with  - use it.
    node = this.encodeTableSeq[$5e0a98dbbf444b79$var$SEQ_START - bucket[low]];
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== $5e0a98dbbf444b79$var$UNASSIGNED) node[$5e0a98dbbf444b79$var$DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
        bucket[low] = $5e0a98dbbf444b79$var$SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    }
    // Traverse the character tree, allocating new nodes as needed.
    for(var j = 1; j < seq.length - 1; j++){
        var oldVal = node[uCode];
        if (typeof oldVal === 'object') node = oldVal;
        else {
            node = node[uCode] = {};
            if (oldVal !== undefined) node[$5e0a98dbbf444b79$var$DEF_CHAR] = oldVal;
        }
    }
    // Set the leaf to given dbcsCode.
    uCode = seq[seq.length - 1];
    node[uCode] = dbcsCode;
};
$5e0a98dbbf444b79$var$DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    for(var i = 0; i < 0x100; i++){
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode]) continue;
        if (uCode >= 0) this._setEncodeChar(uCode, mbCode);
        else if (uCode <= $5e0a98dbbf444b79$var$NODE_START) this._fillEncodeTable($5e0a98dbbf444b79$var$NODE_START - uCode, mbCode << 8, skipEncodeChars);
        else if (uCode <= $5e0a98dbbf444b79$var$SEQ_START) this._setEncodeSequence(this.decodeTableSeq[$5e0a98dbbf444b79$var$SEQ_START - uCode], mbCode);
    }
};
// == Encoder ==================================================================
function $5e0a98dbbf444b79$var$DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined;
    // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}
$5e0a98dbbf444b79$var$DBCSEncoder.prototype.write = function(str) {
    var newBuf = $5e0a98dbbf444b79$require$Buffer.alloc(str.length * (this.gb18030 ? 4 : 3)), leadSurrogate = this.leadSurrogate, seqObj = this.seqObj, nextChar = -1, i = 0, j = 0;
    while(true){
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        } else {
            var uCode = nextChar;
            nextChar = -1;
        }
        // 1. Handle surrogates.
        if (0xD800 <= uCode && uCode < 0xE000) {
            if (uCode < 0xDC00) {
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode;
                    // Double lead surrogate found.
                    uCode = $5e0a98dbbf444b79$var$UNASSIGNED;
                }
            } else if (leadSurrogate !== -1) {
                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                leadSurrogate = -1;
            } else // Incomplete surrogate pair - only trail surrogate found.
            uCode = $5e0a98dbbf444b79$var$UNASSIGNED;
        } else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode;
            uCode = $5e0a98dbbf444b79$var$UNASSIGNED; // Write an error, then current char.
            leadSurrogate = -1;
        }
        // 2. Convert uCode character.
        var dbcsCode = $5e0a98dbbf444b79$var$UNASSIGNED;
        if (seqObj !== undefined && uCode != $5e0a98dbbf444b79$var$UNASSIGNED) {
            var resCode = seqObj[uCode];
            if (typeof resCode === 'object') {
                seqObj = resCode;
                continue;
            } else if (typeof resCode == 'number') dbcsCode = resCode;
            else if (resCode == undefined) {
                // Try default character for this sequence
                resCode = seqObj[$5e0a98dbbf444b79$var$DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode; // Found. Write it.
                    nextChar = uCode; // Current character will be written too in the next iteration.
                }
            }
            seqObj = undefined;
        } else if (uCode >= 0) {
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
            if (dbcsCode <= $5e0a98dbbf444b79$var$SEQ_START) {
                seqObj = this.encodeTableSeq[$5e0a98dbbf444b79$var$SEQ_START - dbcsCode];
                continue;
            }
            if (dbcsCode == $5e0a98dbbf444b79$var$UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = $5e0a98dbbf444b79$var$findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                    dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                    dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                    dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        }
        // 3. Write dbcsCode character.
        if (dbcsCode === $5e0a98dbbf444b79$var$UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8; // high byte
            newBuf[j++] = dbcsCode & 0xFF; // low byte
        } else {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = dbcsCode >> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }
    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
};
$5e0a98dbbf444b79$var$DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.
    var newBuf = $5e0a98dbbf444b79$require$Buffer.alloc(10), j = 0;
    if (this.seqObj) {
        var dbcsCode = this.seqObj[$5e0a98dbbf444b79$var$DEF_CHAR];
        if (dbcsCode !== undefined) {
            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
            else {
                newBuf[j++] = dbcsCode >> 8; // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
            }
        } else ;
        this.seqObj = undefined;
    }
    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    return newBuf.slice(0, j);
};
// Export for testing
$5e0a98dbbf444b79$var$DBCSEncoder.prototype.findIdx = $5e0a98dbbf444b79$var$findIdx;
// == Decoder ==================================================================
function $5e0a98dbbf444b79$var$DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBuf = $5e0a98dbbf444b79$require$Buffer.alloc(0);
    // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}
$5e0a98dbbf444b79$var$DBCSDecoder.prototype.write = function(buf) {
    var newBuf = $5e0a98dbbf444b79$require$Buffer.alloc(buf.length * 2), nodeIdx = this.nodeIdx, prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length, seqStart = -this.prevBuf.length, uCode;
    if (prevBufOffset > 0) prevBuf = $5e0a98dbbf444b79$require$Buffer.concat([
        prevBuf,
        buf.slice(0, 10)
    ]);
    for(var i = 0, j = 0; i < buf.length; i++){
        var curByte = i >= 0 ? buf[i] : prevBuf[i + prevBufOffset];
        // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];
        if (uCode >= 0) ;
        else if (uCode === $5e0a98dbbf444b79$var$UNASSIGNED) {
            // TODO: Callback with seq.
            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
            uCode = this.defaultCharUnicode.charCodeAt(0);
        } else if (uCode === $5e0a98dbbf444b79$var$GB18030_CODE) {
            var curSeq = seqStart >= 0 ? buf.slice(seqStart, i + 1) : prevBuf.slice(seqStart + prevBufOffset, i + 1 + prevBufOffset);
            var ptr = (curSeq[0] - 0x81) * 12600 + (curSeq[1] - 0x30) * 1260 + (curSeq[2] - 0x81) * 10 + (curSeq[3] - 0x30);
            var idx = $5e0a98dbbf444b79$var$findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        } else if (uCode <= $5e0a98dbbf444b79$var$NODE_START) {
            nodeIdx = $5e0a98dbbf444b79$var$NODE_START - uCode;
            continue;
        } else if (uCode <= $5e0a98dbbf444b79$var$SEQ_START) {
            var seq = this.decodeTableSeq[$5e0a98dbbf444b79$var$SEQ_START - uCode];
            for(var k = 0; k < seq.length - 1; k++){
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length - 1];
        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte);
        // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode > 0xFFFF) {
            uCode -= 0x10000;
            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;
            uCode = 0xDC00 + uCode % 0x400;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8;
        // Reset trie node.
        nodeIdx = 0;
        seqStart = i + 1;
    }
    this.nodeIdx = nodeIdx;
    this.prevBuf = seqStart >= 0 ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
    return newBuf.slice(0, j).toString('ucs2');
};
$5e0a98dbbf444b79$var$DBCSDecoder.prototype.end = function() {
    var ret = '';
    // Try to parse all remaining chars.
    while(this.prevBuf.length > 0){
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var buf = this.prevBuf.slice(1);
        // Parse remaining as usual.
        this.prevBuf = $5e0a98dbbf444b79$require$Buffer.alloc(0);
        this.nodeIdx = 0;
        if (buf.length > 0) ret += this.write(buf);
    }
    this.nodeIdx = 0;
    return ret;
};
// Binary search for GB18030. Returns largest i such that table[i] <= val.
function $5e0a98dbbf444b79$var$findIdx(table, val) {
    if (table[0] > val) return -1;
    var l = 0, r = table.length;
    while(l < r - 1){
        var mid = l + Math.floor((r - l + 1) / 2);
        if (table[mid] <= val) l = mid;
        else r = mid;
    }
    return l;
}

});

parcelRegister("lEdD9", function(module, exports) {
"use strict";












// Description of supported double byte encodings and aliases.
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.
module.exports = {
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
    'shiftjis': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("8HZWs"));
        },
        encodeAdd: {
            '\u00a5': 0x5C,
            '\u203E': 0x7E
        },
        encodeSkipVals: [
            {
                from: 0xED40,
                to: 0xF940
            }
        ]
    },
    'csshiftjis': 'shiftjis',
    'mskanji': 'shiftjis',
    'sjis': 'shiftjis',
    'windows31j': 'shiftjis',
    'ms31j': 'shiftjis',
    'xsjis': 'shiftjis',
    'windows932': 'shiftjis',
    'ms932': 'shiftjis',
    '932': 'shiftjis',
    'cp932': 'shiftjis',
    'eucjp': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("4600b"));
        },
        encodeAdd: {
            '\u00a5': 0x5C,
            '\u203E': 0x7E
        }
    },
    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    'gb2312': 'cp936',
    'gb231280': 'cp936',
    'gb23121980': 'cp936',
    'csgb2312': 'cp936',
    'csiso58gb231280': 'cp936',
    'euccn': 'cp936',
    // Microsoft's CP936 is a subset and approximation of GBK.
    'windows936': 'cp936',
    'ms936': 'cp936',
    '936': 'cp936',
    'cp936': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("MHD54"));
        }
    },
    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    'gbk': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("MHD54")).concat((parcelRequire("1yO5j")));
        }
    },
    'xgbk': 'gbk',
    'isoir58': 'gbk',
    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    'gb18030': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("MHD54")).concat((parcelRequire("1yO5j")));
        },
        gb18030: function() {
            return (parcelRequire("kvi1G"));
        },
        encodeSkipVals: [
            0x80
        ],
        encodeAdd: {
            "\u20AC": 0xA2E3
        }
    },
    'chinese': 'gb18030',
    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    'windows949': 'cp949',
    'ms949': 'cp949',
    '949': 'cp949',
    'cp949': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("8NjHr"));
        }
    },
    'cseuckr': 'cp949',
    'csksc56011987': 'cp949',
    'euckr': 'cp949',
    'isoir149': 'cp949',
    'korean': 'cp949',
    'ksc56011987': 'cp949',
    'ksc56011989': 'cp949',
    'ksc5601': 'cp949',
    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    // 
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
    'windows950': 'cp950',
    'ms950': 'cp950',
    '950': 'cp950',
    'cp950': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("6EjUj"));
        }
    },
    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    'big5': 'big5hkscs',
    'big5hkscs': {
        type: '_dbcs',
        table: function() {
            return (parcelRequire("6EjUj")).concat((parcelRequire("7EqcH")));
        },
        encodeSkipVals: [
            0xa2cc
        ]
    },
    'cnbig5': 'big5hkscs',
    'csbig5': 'big5hkscs',
    'xxbig5': 'big5hkscs'
};

});
parcelRegister("8HZWs", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",128],["a1","\uFF61",62],["8140","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7"],["8180","\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["81b8","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["81c8","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["81da","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["81f0","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["81fc","\u25EF"],["824f","\uFF10",9],["8260","\uFF21",25],["8281","\uFF41",25],["829f","\u3041",82],["8340","\u30A1",62],["8380","\u30E0",22],["839f","\u0391",16,"\u03A3",6],["83bf","\u03B1",16,"\u03C3",6],["8440","\u0410",5,"\u0401\u0416",25],["8470","\u0430",5,"\u0451\u0436",7],["8480","\u043E",17],["849f","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["8740","\u2460",19,"\u2160",9],["875f","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["877e","\u337B"],["8780","\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["889f","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["8940","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"],["8980","\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["8a40","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"],["8a80","\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["8b40","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"],["8b80","\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["8c40","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"],["8c80","\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["8d40","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"],["8d80","\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["8e40","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"],["8e80","\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["8f40","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"],["8f80","\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["9040","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"],["9080","\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["9140","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"],["9180","\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["9240","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"],["9280","\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["9340","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"],["9380","\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["9440","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"],["9480","\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["9540","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"],["9580","\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["9640","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"],["9680","\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["9740","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"],["9780","\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["9840","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["989f","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["9940","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"],["9980","\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["9a40","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"],["9a80","\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["9b40","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"],["9b80","\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["9c40","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"],["9c80","\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["9d40","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"],["9d80","\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["9e40","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"],["9e80","\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["9f40","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"],["9f80","\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["e040","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"],["e080","\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e140","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"],["e180","\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e240","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"],["e280","\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e340","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"],["e380","\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e440","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"],["e480","\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e540","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"],["e580","\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["e640","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"],["e680","\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["e740","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"],["e780","\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["e840","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"],["e880","\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["e940","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"],["e980","\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["ea40","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"],["ea80","\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"],["ed40","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F"],["ed80","\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["ee40","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559"],["ee80","\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["eeef","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["f040","\uE000",62],["f080","\uE03F",124],["f140","\uE0BC",62],["f180","\uE0FB",124],["f240","\uE178",62],["f280","\uE1B7",124],["f340","\uE234",62],["f380","\uE273",124],["f440","\uE2F0",62],["f480","\uE32F",124],["f540","\uE3AC",62],["f580","\uE3EB",124],["f640","\uE468",62],["f680","\uE4A7",124],["f740","\uE524",62],["f780","\uE563",124],["f840","\uE5E0",62],["f880","\uE61F",124],["f940","\uE69C"],["fa40","\u2170",9,"\u2160",9,"\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A"],["fa80","\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F"],["fb40","\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19"],["fb80","\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9"],["fc40","\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"]]');

});

parcelRegister("4600b", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["8ea1","\uFF61",62],["a1a1","\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",9,"\uFF0B\uFF0D\xb1\xd7\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7"],["a2a1","\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"],["a2ba","\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"],["a2ca","\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"],["a2dc","\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"],["a2f2","\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"],["a2fe","\u25EF"],["a3b0","\uFF10",9],["a3c1","\uFF21",25],["a3e1","\uFF41",25],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a8a1","\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"],["ada1","\u2460",19,"\u2160",9],["adc0","\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"],["addf","\u337B\u301D\u301F\u2116\u33CD\u2121\u32A4",4,"\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"],["b0a1","\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"],["b1a1","\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC"],["b2a1","\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"],["b3a1","\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431"],["b4a1","\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"],["b5a1","\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC"],["b6a1","\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"],["b7a1","\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372"],["b8a1","\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"],["b9a1","\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC"],["baa1","\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"],["bba1","\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642"],["bca1","\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"],["bda1","\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F"],["bea1","\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"],["bfa1","\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE"],["c0a1","\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"],["c1a1","\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E"],["c2a1","\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"],["c3a1","\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5"],["c4a1","\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"],["c5a1","\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230"],["c6a1","\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"],["c7a1","\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6"],["c8a1","\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"],["c9a1","\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D"],["caa1","\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"],["cba1","\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80"],["cca1","\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"],["cda1","\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483"],["cea1","\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"],["cfa1","\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"],["d0a1","\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"],["d1a1","\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8"],["d2a1","\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"],["d3a1","\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709"],["d4a1","\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"],["d5a1","\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53"],["d6a1","\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"],["d7a1","\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A"],["d8a1","\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"],["d9a1","\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC"],["daa1","\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"],["dba1","\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD"],["dca1","\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"],["dda1","\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE"],["dea1","\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"],["dfa1","\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC"],["e0a1","\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"],["e1a1","\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670"],["e2a1","\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"],["e3a1","\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50"],["e4a1","\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"],["e5a1","\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A"],["e6a1","\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"],["e7a1","\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9"],["e8a1","\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"],["e9a1","\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759"],["eaa1","\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"],["eba1","\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B"],["eca1","\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"],["eda1","\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8"],["eea1","\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"],["efa1","\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E"],["f0a1","\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"],["f1a1","\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7"],["f2a1","\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"],["f3a1","\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0"],["f4a1","\u582F\u69C7\u9059\u7464\u51DC\u7199"],["f9a1","\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7"],["faa1","\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"],["fba1","\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA"],["fca1","\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"],["fcf1","\u2170",9,"\uFFE2\uFFE4\uFF07\uFF02"],["8fa2af","\u02D8\u02C7\xb8\u02D9\u02DD\xaf\u02DB\u02DA\uFF5E\u0384\u0385"],["8fa2c2","\xa1\xa6\xbf"],["8fa2eb","\xba\xaa\xa9\xae\u2122\xa4\u2116"],["8fa6e1","\u0386\u0388\u0389\u038A\u03AA"],["8fa6e7","\u038C"],["8fa6e9","\u038E\u03AB"],["8fa6ec","\u038F"],["8fa6f1","\u03AC\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03C2\u03CD\u03CB\u03B0\u03CE"],["8fa7c2","\u0402",10,"\u040E\u040F"],["8fa7f2","\u0452",10,"\u045E\u045F"],["8fa9a1","\xc6\u0110"],["8fa9a4","\u0126"],["8fa9a6","\u0132"],["8fa9a8","\u0141\u013F"],["8fa9ab","\u014A\xd8\u0152"],["8fa9af","\u0166\xde"],["8fa9c1","\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0142\u0140\u0149\u014B\xf8\u0153\xdf\u0167\xfe"],["8faaa1","\xc1\xc0\xc4\xc2\u0102\u01CD\u0100\u0104\xc5\xc3\u0106\u0108\u010C\xc7\u010A\u010E\xc9\xc8\xcb\xca\u011A\u0116\u0112\u0118"],["8faaba","\u011C\u011E\u0122\u0120\u0124\xcd\xcc\xcf\xce\u01CF\u0130\u012A\u012E\u0128\u0134\u0136\u0139\u013D\u013B\u0143\u0147\u0145\xd1\xd3\xd2\xd6\xd4\u01D1\u0150\u014C\xd5\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0164\u0162\xda\xd9\xdc\xdb\u016C\u01D3\u0170\u016A\u0172\u016E\u0168\u01D7\u01DB\u01D9\u01D5\u0174\xdd\u0178\u0176\u0179\u017D\u017B"],["8faba1","\xe1\xe0\xe4\xe2\u0103\u01CE\u0101\u0105\xe5\xe3\u0107\u0109\u010D\xe7\u010B\u010F\xe9\xe8\xeb\xea\u011B\u0117\u0113\u0119\u01F5\u011D\u011F"],["8fabbd","\u0121\u0125\xed\xec\xef\xee\u01D0"],["8fabc5","\u012B\u012F\u0129\u0135\u0137\u013A\u013E\u013C\u0144\u0148\u0146\xf1\xf3\xf2\xf6\xf4\u01D2\u0151\u014D\xf5\u0155\u0159\u0157\u015B\u015D\u0161\u015F\u0165\u0163\xfa\xf9\xfc\xfb\u016D\u01D4\u0171\u016B\u0173\u016F\u0169\u01D8\u01DC\u01DA\u01D6\u0175\xfd\xff\u0177\u017A\u017E\u017C"],["8fb0a1","\u4E02\u4E04\u4E05\u4E0C\u4E12\u4E1F\u4E23\u4E24\u4E28\u4E2B\u4E2E\u4E2F\u4E30\u4E35\u4E40\u4E41\u4E44\u4E47\u4E51\u4E5A\u4E5C\u4E63\u4E68\u4E69\u4E74\u4E75\u4E79\u4E7F\u4E8D\u4E96\u4E97\u4E9D\u4EAF\u4EB9\u4EC3\u4ED0\u4EDA\u4EDB\u4EE0\u4EE1\u4EE2\u4EE8\u4EEF\u4EF1\u4EF3\u4EF5\u4EFD\u4EFE\u4EFF\u4F00\u4F02\u4F03\u4F08\u4F0B\u4F0C\u4F12\u4F15\u4F16\u4F17\u4F19\u4F2E\u4F31\u4F60\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F40\u4F42\u4F48\u4F49\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F58\u4F5F\u4F63\u4F6A\u4F6C\u4F6E\u4F71\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F7E\u4F81\u4F82\u4F84"],["8fb1a1","\u4F85\u4F89\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F94\u4F97\u4F99\u4F9A\u4F9E\u4F9F\u4FB2\u4FB7\u4FB9\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC5\u4FC6\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FCF\u4FD2\u4FDC\u4FE0\u4FE2\u4FF0\u4FF2\u4FFC\u4FFD\u4FFF\u5000\u5001\u5004\u5007\u500A\u500C\u500E\u5010\u5013\u5017\u5018\u501B\u501C\u501D\u501E\u5022\u5027\u502E\u5030\u5032\u5033\u5035\u5040\u5041\u5042\u5045\u5046\u504A\u504C\u504E\u5051\u5052\u5053\u5057\u5059\u505F\u5060\u5062\u5063\u5066\u5067\u506A\u506D\u5070\u5071\u503B\u5081\u5083\u5084\u5086\u508A\u508E\u508F\u5090"],["8fb2a1","\u5092\u5093\u5094\u5096\u509B\u509C\u509E",4,"\u50AA\u50AF\u50B0\u50B9\u50BA\u50BD\u50C0\u50C3\u50C4\u50C7\u50CC\u50CE\u50D0\u50D3\u50D4\u50D8\u50DC\u50DD\u50DF\u50E2\u50E4\u50E6\u50E8\u50E9\u50EF\u50F1\u50F6\u50FA\u50FE\u5103\u5106\u5107\u5108\u510B\u510C\u510D\u510E\u50F2\u5110\u5117\u5119\u511B\u511C\u511D\u511E\u5123\u5127\u5128\u512C\u512D\u512F\u5131\u5133\u5134\u5135\u5138\u5139\u5142\u514A\u514F\u5153\u5155\u5157\u5158\u515F\u5164\u5166\u517E\u5183\u5184\u518B\u518E\u5198\u519D\u51A1\u51A3\u51AD\u51B8\u51BA\u51BC\u51BE\u51BF\u51C2"],["8fb3a1","\u51C8\u51CF\u51D1\u51D2\u51D3\u51D5\u51D8\u51DE\u51E2\u51E5\u51EE\u51F2\u51F3\u51F4\u51F7\u5201\u5202\u5205\u5212\u5213\u5215\u5216\u5218\u5222\u5228\u5231\u5232\u5235\u523C\u5245\u5249\u5255\u5257\u5258\u525A\u525C\u525F\u5260\u5261\u5266\u526E\u5277\u5278\u5279\u5280\u5282\u5285\u528A\u528C\u5293\u5295\u5296\u5297\u5298\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AF\u52B0\u52B6\u52B7\u52B8\u52BA\u52BB\u52BD\u52C0\u52C4\u52C6\u52C8\u52CC\u52CF\u52D1\u52D4\u52D6\u52DB\u52DC\u52E1\u52E5\u52E8\u52E9\u52EA\u52EC\u52F0\u52F1\u52F4\u52F6\u52F7\u5300\u5303\u530A\u530B"],["8fb4a1","\u530C\u5311\u5313\u5318\u531B\u531C\u531E\u531F\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u5330\u5332\u5335\u533C\u533D\u533E\u5342\u534C\u534B\u5359\u535B\u5361\u5363\u5365\u536C\u536D\u5372\u5379\u537E\u5383\u5387\u5388\u538E\u5393\u5394\u5399\u539D\u53A1\u53A4\u53AA\u53AB\u53AF\u53B2\u53B4\u53B5\u53B7\u53B8\u53BA\u53BD\u53C0\u53C5\u53CF\u53D2\u53D3\u53D5\u53DA\u53DD\u53DE\u53E0\u53E6\u53E7\u53F5\u5402\u5413\u541A\u5421\u5427\u5428\u542A\u542F\u5431\u5434\u5435\u5443\u5444\u5447\u544D\u544F\u545E\u5462\u5464\u5466\u5467\u5469\u546B\u546D\u546E\u5474\u547F"],["8fb5a1","\u5481\u5483\u5485\u5488\u5489\u548D\u5491\u5495\u5496\u549C\u549F\u54A1\u54A6\u54A7\u54A9\u54AA\u54AD\u54AE\u54B1\u54B7\u54B9\u54BA\u54BB\u54BF\u54C6\u54CA\u54CD\u54CE\u54E0\u54EA\u54EC\u54EF\u54F6\u54FC\u54FE\u54FF\u5500\u5501\u5505\u5508\u5509\u550C\u550D\u550E\u5515\u552A\u552B\u5532\u5535\u5536\u553B\u553C\u553D\u5541\u5547\u5549\u554A\u554D\u5550\u5551\u5558\u555A\u555B\u555E\u5560\u5561\u5564\u5566\u557F\u5581\u5582\u5586\u5588\u558E\u558F\u5591\u5592\u5593\u5594\u5597\u55A3\u55A4\u55AD\u55B2\u55BF\u55C1\u55C3\u55C6\u55C9\u55CB\u55CC\u55CE\u55D1\u55D2"],["8fb6a1","\u55D3\u55D7\u55D8\u55DB\u55DE\u55E2\u55E9\u55F6\u55FF\u5605\u5608\u560A\u560D",5,"\u5619\u562C\u5630\u5633\u5635\u5637\u5639\u563B\u563C\u563D\u563F\u5640\u5641\u5643\u5644\u5646\u5649\u564B\u564D\u564F\u5654\u565E\u5660\u5661\u5662\u5663\u5666\u5669\u566D\u566F\u5671\u5672\u5675\u5684\u5685\u5688\u568B\u568C\u5695\u5699\u569A\u569D\u569E\u569F\u56A6\u56A7\u56A8\u56A9\u56AB\u56AC\u56AD\u56B1\u56B3\u56B7\u56BE\u56C5\u56C9\u56CA\u56CB\u56CF\u56D0\u56CC\u56CD\u56D9\u56DC\u56DD\u56DF\u56E1\u56E4",4,"\u56F1\u56EB\u56ED"],["8fb7a1","\u56F6\u56F7\u5701\u5702\u5707\u570A\u570C\u5711\u5715\u571A\u571B\u571D\u5720\u5722\u5723\u5724\u5725\u5729\u572A\u572C\u572E\u572F\u5733\u5734\u573D\u573E\u573F\u5745\u5746\u574C\u574D\u5752\u5762\u5765\u5767\u5768\u576B\u576D",4,"\u5773\u5774\u5775\u5777\u5779\u577A\u577B\u577C\u577E\u5781\u5783\u578C\u5794\u5797\u5799\u579A\u579C\u579D\u579E\u579F\u57A1\u5795\u57A7\u57A8\u57A9\u57AC\u57B8\u57BD\u57C7\u57C8\u57CC\u57CF\u57D5\u57DD\u57DE\u57E4\u57E6\u57E7\u57E9\u57ED\u57F0\u57F5\u57F6\u57F8\u57FD\u57FE\u57FF\u5803\u5804\u5808\u5809\u57E1"],["8fb8a1","\u580C\u580D\u581B\u581E\u581F\u5820\u5826\u5827\u582D\u5832\u5839\u583F\u5849\u584C\u584D\u584F\u5850\u5855\u585F\u5861\u5864\u5867\u5868\u5878\u587C\u587F\u5880\u5881\u5887\u5888\u5889\u588A\u588C\u588D\u588F\u5890\u5894\u5896\u589D\u58A0\u58A1\u58A2\u58A6\u58A9\u58B1\u58B2\u58C4\u58BC\u58C2\u58C8\u58CD\u58CE\u58D0\u58D2\u58D4\u58D6\u58DA\u58DD\u58E1\u58E2\u58E9\u58F3\u5905\u5906\u590B\u590C\u5912\u5913\u5914\u8641\u591D\u5921\u5923\u5924\u5928\u592F\u5930\u5933\u5935\u5936\u593F\u5943\u5946\u5952\u5953\u5959\u595B\u595D\u595E\u595F\u5961\u5963\u596B\u596D"],["8fb9a1","\u596F\u5972\u5975\u5976\u5979\u597B\u597C\u598B\u598C\u598E\u5992\u5995\u5997\u599F\u59A4\u59A7\u59AD\u59AE\u59AF\u59B0\u59B3\u59B7\u59BA\u59BC\u59C1\u59C3\u59C4\u59C8\u59CA\u59CD\u59D2\u59DD\u59DE\u59DF\u59E3\u59E4\u59E7\u59EE\u59EF\u59F1\u59F2\u59F4\u59F7\u5A00\u5A04\u5A0C\u5A0D\u5A0E\u5A12\u5A13\u5A1E\u5A23\u5A24\u5A27\u5A28\u5A2A\u5A2D\u5A30\u5A44\u5A45\u5A47\u5A48\u5A4C\u5A50\u5A55\u5A5E\u5A63\u5A65\u5A67\u5A6D\u5A77\u5A7A\u5A7B\u5A7E\u5A8B\u5A90\u5A93\u5A96\u5A99\u5A9C\u5A9E\u5A9F\u5AA0\u5AA2\u5AA7\u5AAC\u5AB1\u5AB2\u5AB3\u5AB5\u5AB8\u5ABA\u5ABB\u5ABF"],["8fbaa1","\u5AC4\u5AC6\u5AC8\u5ACF\u5ADA\u5ADC\u5AE0\u5AE5\u5AEA\u5AEE\u5AF5\u5AF6\u5AFD\u5B00\u5B01\u5B08\u5B17\u5B34\u5B19\u5B1B\u5B1D\u5B21\u5B25\u5B2D\u5B38\u5B41\u5B4B\u5B4C\u5B52\u5B56\u5B5E\u5B68\u5B6E\u5B6F\u5B7C\u5B7D\u5B7E\u5B7F\u5B81\u5B84\u5B86\u5B8A\u5B8E\u5B90\u5B91\u5B93\u5B94\u5B96\u5BA8\u5BA9\u5BAC\u5BAD\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBC\u5BC0\u5BC1\u5BCD\u5BCF\u5BD6",4,"\u5BE0\u5BEF\u5BF1\u5BF4\u5BFD\u5C0C\u5C17\u5C1E\u5C1F\u5C23\u5C26\u5C29\u5C2B\u5C2C\u5C2E\u5C30\u5C32\u5C35\u5C36\u5C59\u5C5A\u5C5C\u5C62\u5C63\u5C67\u5C68\u5C69"],["8fbba1","\u5C6D\u5C70\u5C74\u5C75\u5C7A\u5C7B\u5C7C\u5C7D\u5C87\u5C88\u5C8A\u5C8F\u5C92\u5C9D\u5C9F\u5CA0\u5CA2\u5CA3\u5CA6\u5CAA\u5CB2\u5CB4\u5CB5\u5CBA\u5CC9\u5CCB\u5CD2\u5CDD\u5CD7\u5CEE\u5CF1\u5CF2\u5CF4\u5D01\u5D06\u5D0D\u5D12\u5D2B\u5D23\u5D24\u5D26\u5D27\u5D31\u5D34\u5D39\u5D3D\u5D3F\u5D42\u5D43\u5D46\u5D48\u5D55\u5D51\u5D59\u5D4A\u5D5F\u5D60\u5D61\u5D62\u5D64\u5D6A\u5D6D\u5D70\u5D79\u5D7A\u5D7E\u5D7F\u5D81\u5D83\u5D88\u5D8A\u5D92\u5D93\u5D94\u5D95\u5D99\u5D9B\u5D9F\u5DA0\u5DA7\u5DAB\u5DB0\u5DB4\u5DB8\u5DB9\u5DC3\u5DC7\u5DCB\u5DD0\u5DCE\u5DD8\u5DD9\u5DE0\u5DE4"],["8fbca1","\u5DE9\u5DF8\u5DF9\u5E00\u5E07\u5E0D\u5E12\u5E14\u5E15\u5E18\u5E1F\u5E20\u5E2E\u5E28\u5E32\u5E35\u5E3E\u5E4B\u5E50\u5E49\u5E51\u5E56\u5E58\u5E5B\u5E5C\u5E5E\u5E68\u5E6A",4,"\u5E70\u5E80\u5E8B\u5E8E\u5EA2\u5EA4\u5EA5\u5EA8\u5EAA\u5EAC\u5EB1\u5EB3\u5EBD\u5EBE\u5EBF\u5EC6\u5ECC\u5ECB\u5ECE\u5ED1\u5ED2\u5ED4\u5ED5\u5EDC\u5EDE\u5EE5\u5EEB\u5F02\u5F06\u5F07\u5F08\u5F0E\u5F19\u5F1C\u5F1D\u5F21\u5F22\u5F23\u5F24\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F34\u5F36\u5F3B\u5F3D\u5F3F\u5F40\u5F44\u5F45\u5F47\u5F4D\u5F50\u5F54\u5F58\u5F5B\u5F60\u5F63\u5F64\u5F67"],["8fbda1","\u5F6F\u5F72\u5F74\u5F75\u5F78\u5F7A\u5F7D\u5F7E\u5F89\u5F8D\u5F8F\u5F96\u5F9C\u5F9D\u5FA2\u5FA7\u5FAB\u5FA4\u5FAC\u5FAF\u5FB0\u5FB1\u5FB8\u5FC4\u5FC7\u5FC8\u5FC9\u5FCB\u5FD0",4,"\u5FDE\u5FE1\u5FE2\u5FE8\u5FE9\u5FEA\u5FEC\u5FED\u5FEE\u5FEF\u5FF2\u5FF3\u5FF6\u5FFA\u5FFC\u6007\u600A\u600D\u6013\u6014\u6017\u6018\u601A\u601F\u6024\u602D\u6033\u6035\u6040\u6047\u6048\u6049\u604C\u6051\u6054\u6056\u6057\u605D\u6061\u6067\u6071\u607E\u607F\u6082\u6086\u6088\u608A\u608E\u6091\u6093\u6095\u6098\u609D\u609E\u60A2\u60A4\u60A5\u60A8\u60B0\u60B1\u60B7"],["8fbea1","\u60BB\u60BE\u60C2\u60C4\u60C8\u60C9\u60CA\u60CB\u60CE\u60CF\u60D4\u60D5\u60D9\u60DB\u60DD\u60DE\u60E2\u60E5\u60F2\u60F5\u60F8\u60FC\u60FD\u6102\u6107\u610A\u610C\u6110",4,"\u6116\u6117\u6119\u611C\u611E\u6122\u612A\u612B\u6130\u6131\u6135\u6136\u6137\u6139\u6141\u6145\u6146\u6149\u615E\u6160\u616C\u6172\u6178\u617B\u617C\u617F\u6180\u6181\u6183\u6184\u618B\u618D\u6192\u6193\u6197\u6198\u619C\u619D\u619F\u61A0\u61A5\u61A8\u61AA\u61AD\u61B8\u61B9\u61BC\u61C0\u61C1\u61C2\u61CE\u61CF\u61D5\u61DC\u61DD\u61DE\u61DF\u61E1\u61E2\u61E7\u61E9\u61E5"],["8fbfa1","\u61EC\u61ED\u61EF\u6201\u6203\u6204\u6207\u6213\u6215\u621C\u6220\u6222\u6223\u6227\u6229\u622B\u6239\u623D\u6242\u6243\u6244\u6246\u624C\u6250\u6251\u6252\u6254\u6256\u625A\u625C\u6264\u626D\u626F\u6273\u627A\u627D\u628D\u628E\u628F\u6290\u62A6\u62A8\u62B3\u62B6\u62B7\u62BA\u62BE\u62BF\u62C4\u62CE\u62D5\u62D6\u62DA\u62EA\u62F2\u62F4\u62FC\u62FD\u6303\u6304\u630A\u630B\u630D\u6310\u6313\u6316\u6318\u6329\u632A\u632D\u6335\u6336\u6339\u633C\u6341\u6342\u6343\u6344\u6346\u634A\u634B\u634E\u6352\u6353\u6354\u6358\u635B\u6365\u6366\u636C\u636D\u6371\u6374\u6375"],["8fc0a1","\u6378\u637C\u637D\u637F\u6382\u6384\u6387\u638A\u6390\u6394\u6395\u6399\u639A\u639E\u63A4\u63A6\u63AD\u63AE\u63AF\u63BD\u63C1\u63C5\u63C8\u63CE\u63D1\u63D3\u63D4\u63D5\u63DC\u63E0\u63E5\u63EA\u63EC\u63F2\u63F3\u63F5\u63F8\u63F9\u6409\u640A\u6410\u6412\u6414\u6418\u641E\u6420\u6422\u6424\u6425\u6429\u642A\u642F\u6430\u6435\u643D\u643F\u644B\u644F\u6451\u6452\u6453\u6454\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6463\u646D\u6473\u6474\u647B\u647D\u6485\u6487\u648F\u6490\u6491\u6498\u6499\u649B\u649D\u649F\u64A1\u64A3\u64A6\u64A8\u64AC\u64B3\u64BD\u64BE\u64BF"],["8fc1a1","\u64C4\u64C9\u64CA\u64CB\u64CC\u64CE\u64D0\u64D1\u64D5\u64D7\u64E4\u64E5\u64E9\u64EA\u64ED\u64F0\u64F5\u64F7\u64FB\u64FF\u6501\u6504\u6508\u6509\u650A\u650F\u6513\u6514\u6516\u6519\u651B\u651E\u651F\u6522\u6526\u6529\u652E\u6531\u653A\u653C\u653D\u6543\u6547\u6549\u6550\u6552\u6554\u655F\u6560\u6567\u656B\u657A\u657D\u6581\u6585\u658A\u6592\u6595\u6598\u659D\u65A0\u65A3\u65A6\u65AE\u65B2\u65B3\u65B4\u65BF\u65C2\u65C8\u65C9\u65CE\u65D0\u65D4\u65D6\u65D8\u65DF\u65F0\u65F2\u65F4\u65F5\u65F9\u65FE\u65FF\u6600\u6604\u6608\u6609\u660D\u6611\u6612\u6615\u6616\u661D"],["8fc2a1","\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6631\u6633\u6639\u6637\u6640\u6645\u6646\u664A\u664C\u6651\u664E\u6657\u6658\u6659\u665B\u665C\u6660\u6661\u66FB\u666A\u666B\u666C\u667E\u6673\u6675\u667F\u6677\u6678\u6679\u667B\u6680\u667C\u668B\u668C\u668D\u6690\u6692\u6699\u669A\u669B\u669C\u669F\u66A0\u66A4\u66AD\u66B1\u66B2\u66B5\u66BB\u66BF\u66C0\u66C2\u66C3\u66C8\u66CC\u66CE\u66CF\u66D4\u66DB\u66DF\u66E8\u66EB\u66EC\u66EE\u66FA\u6705\u6707\u670E\u6713\u6719\u671C\u6720\u6722\u6733\u673E\u6745\u6747\u6748\u674C\u6754\u6755\u675D"],["8fc3a1","\u6766\u676C\u676E\u6774\u6776\u677B\u6781\u6784\u678E\u678F\u6791\u6793\u6796\u6798\u6799\u679B\u67B0\u67B1\u67B2\u67B5\u67BB\u67BC\u67BD\u67F9\u67C0\u67C2\u67C3\u67C5\u67C8\u67C9\u67D2\u67D7\u67D9\u67DC\u67E1\u67E6\u67F0\u67F2\u67F6\u67F7\u6852\u6814\u6819\u681D\u681F\u6828\u6827\u682C\u682D\u682F\u6830\u6831\u6833\u683B\u683F\u6844\u6845\u684A\u684C\u6855\u6857\u6858\u685B\u686B\u686E",4,"\u6875\u6879\u687A\u687B\u687C\u6882\u6884\u6886\u6888\u6896\u6898\u689A\u689C\u68A1\u68A3\u68A5\u68A9\u68AA\u68AE\u68B2\u68BB\u68C5\u68C8\u68CC\u68CF"],["8fc4a1","\u68D0\u68D1\u68D3\u68D6\u68D9\u68DC\u68DD\u68E5\u68E8\u68EA\u68EB\u68EC\u68ED\u68F0\u68F1\u68F5\u68F6\u68FB\u68FC\u68FD\u6906\u6909\u690A\u6910\u6911\u6913\u6916\u6917\u6931\u6933\u6935\u6938\u693B\u6942\u6945\u6949\u694E\u6957\u695B\u6963\u6964\u6965\u6966\u6968\u6969\u696C\u6970\u6971\u6972\u697A\u697B\u697F\u6980\u698D\u6992\u6996\u6998\u69A1\u69A5\u69A6\u69A8\u69AB\u69AD\u69AF\u69B7\u69B8\u69BA\u69BC\u69C5\u69C8\u69D1\u69D6\u69D7\u69E2\u69E5\u69EE\u69EF\u69F1\u69F3\u69F5\u69FE\u6A00\u6A01\u6A03\u6A0F\u6A11\u6A15\u6A1A\u6A1D\u6A20\u6A24\u6A28\u6A30\u6A32"],["8fc5a1","\u6A34\u6A37\u6A3B\u6A3E\u6A3F\u6A45\u6A46\u6A49\u6A4A\u6A4E\u6A50\u6A51\u6A52\u6A55\u6A56\u6A5B\u6A64\u6A67\u6A6A\u6A71\u6A73\u6A7E\u6A81\u6A83\u6A86\u6A87\u6A89\u6A8B\u6A91\u6A9B\u6A9D\u6A9E\u6A9F\u6AA5\u6AAB\u6AAF\u6AB0\u6AB1\u6AB4\u6ABD\u6ABE\u6ABF\u6AC6\u6AC9\u6AC8\u6ACC\u6AD0\u6AD4\u6AD5\u6AD6\u6ADC\u6ADD\u6AE4\u6AE7\u6AEC\u6AF0\u6AF1\u6AF2\u6AFC\u6AFD\u6B02\u6B03\u6B06\u6B07\u6B09\u6B0F\u6B10\u6B11\u6B17\u6B1B\u6B1E\u6B24\u6B28\u6B2B\u6B2C\u6B2F\u6B35\u6B36\u6B3B\u6B3F\u6B46\u6B4A\u6B4D\u6B52\u6B56\u6B58\u6B5D\u6B60\u6B67\u6B6B\u6B6E\u6B70\u6B75\u6B7D"],["8fc6a1","\u6B7E\u6B82\u6B85\u6B97\u6B9B\u6B9F\u6BA0\u6BA2\u6BA3\u6BA8\u6BA9\u6BAC\u6BAD\u6BAE\u6BB0\u6BB8\u6BB9\u6BBD\u6BBE\u6BC3\u6BC4\u6BC9\u6BCC\u6BD6\u6BDA\u6BE1\u6BE3\u6BE6\u6BE7\u6BEE\u6BF1\u6BF7\u6BF9\u6BFF\u6C02\u6C04\u6C05\u6C09\u6C0D\u6C0E\u6C10\u6C12\u6C19\u6C1F\u6C26\u6C27\u6C28\u6C2C\u6C2E\u6C33\u6C35\u6C36\u6C3A\u6C3B\u6C3F\u6C4A\u6C4B\u6C4D\u6C4F\u6C52\u6C54\u6C59\u6C5B\u6C5C\u6C6B\u6C6D\u6C6F\u6C74\u6C76\u6C78\u6C79\u6C7B\u6C85\u6C86\u6C87\u6C89\u6C94\u6C95\u6C97\u6C98\u6C9C\u6C9F\u6CB0\u6CB2\u6CB4\u6CC2\u6CC6\u6CCD\u6CCF\u6CD0\u6CD1\u6CD2\u6CD4\u6CD6"],["8fc7a1","\u6CDA\u6CDC\u6CE0\u6CE7\u6CE9\u6CEB\u6CEC\u6CEE\u6CF2\u6CF4\u6D04\u6D07\u6D0A\u6D0E\u6D0F\u6D11\u6D13\u6D1A\u6D26\u6D27\u6D28\u6C67\u6D2E\u6D2F\u6D31\u6D39\u6D3C\u6D3F\u6D57\u6D5E\u6D5F\u6D61\u6D65\u6D67\u6D6F\u6D70\u6D7C\u6D82\u6D87\u6D91\u6D92\u6D94\u6D96\u6D97\u6D98\u6DAA\u6DAC\u6DB4\u6DB7\u6DB9\u6DBD\u6DBF\u6DC4\u6DC8\u6DCA\u6DCE\u6DCF\u6DD6\u6DDB\u6DDD\u6DDF\u6DE0\u6DE2\u6DE5\u6DE9\u6DEF\u6DF0\u6DF4\u6DF6\u6DFC\u6E00\u6E04\u6E1E\u6E22\u6E27\u6E32\u6E36\u6E39\u6E3B\u6E3C\u6E44\u6E45\u6E48\u6E49\u6E4B\u6E4F\u6E51\u6E52\u6E53\u6E54\u6E57\u6E5C\u6E5D\u6E5E"],["8fc8a1","\u6E62\u6E63\u6E68\u6E73\u6E7B\u6E7D\u6E8D\u6E93\u6E99\u6EA0\u6EA7\u6EAD\u6EAE\u6EB1\u6EB3\u6EBB\u6EBF\u6EC0\u6EC1\u6EC3\u6EC7\u6EC8\u6ECA\u6ECD\u6ECE\u6ECF\u6EEB\u6EED\u6EEE\u6EF9\u6EFB\u6EFD\u6F04\u6F08\u6F0A\u6F0C\u6F0D\u6F16\u6F18\u6F1A\u6F1B\u6F26\u6F29\u6F2A\u6F2F\u6F30\u6F33\u6F36\u6F3B\u6F3C\u6F2D\u6F4F\u6F51\u6F52\u6F53\u6F57\u6F59\u6F5A\u6F5D\u6F5E\u6F61\u6F62\u6F68\u6F6C\u6F7D\u6F7E\u6F83\u6F87\u6F88\u6F8B\u6F8C\u6F8D\u6F90\u6F92\u6F93\u6F94\u6F96\u6F9A\u6F9F\u6FA0\u6FA5\u6FA6\u6FA7\u6FA8\u6FAE\u6FAF\u6FB0\u6FB5\u6FB6\u6FBC\u6FC5\u6FC7\u6FC8\u6FCA"],["8fc9a1","\u6FDA\u6FDE\u6FE8\u6FE9\u6FF0\u6FF5\u6FF9\u6FFC\u6FFD\u7000\u7005\u7006\u7007\u700D\u7017\u7020\u7023\u702F\u7034\u7037\u7039\u703C\u7043\u7044\u7048\u7049\u704A\u704B\u7054\u7055\u705D\u705E\u704E\u7064\u7065\u706C\u706E\u7075\u7076\u707E\u7081\u7085\u7086\u7094",4,"\u709B\u70A4\u70AB\u70B0\u70B1\u70B4\u70B7\u70CA\u70D1\u70D3\u70D4\u70D5\u70D6\u70D8\u70DC\u70E4\u70FA\u7103",4,"\u710B\u710C\u710F\u711E\u7120\u712B\u712D\u712F\u7130\u7131\u7138\u7141\u7145\u7146\u7147\u714A\u714B\u7150\u7152\u7157\u715A\u715C\u715E\u7160"],["8fcaa1","\u7168\u7179\u7180\u7185\u7187\u718C\u7192\u719A\u719B\u71A0\u71A2\u71AF\u71B0\u71B2\u71B3\u71BA\u71BF\u71C0\u71C1\u71C4\u71CB\u71CC\u71D3\u71D6\u71D9\u71DA\u71DC\u71F8\u71FE\u7200\u7207\u7208\u7209\u7213\u7217\u721A\u721D\u721F\u7224\u722B\u722F\u7234\u7238\u7239\u7241\u7242\u7243\u7245\u724E\u724F\u7250\u7253\u7255\u7256\u725A\u725C\u725E\u7260\u7263\u7268\u726B\u726E\u726F\u7271\u7277\u7278\u727B\u727C\u727F\u7284\u7289\u728D\u728E\u7293\u729B\u72A8\u72AD\u72AE\u72B1\u72B4\u72BE\u72C1\u72C7\u72C9\u72CC\u72D5\u72D6\u72D8\u72DF\u72E5\u72F3\u72F4\u72FA\u72FB"],["8fcba1","\u72FE\u7302\u7304\u7305\u7307\u730B\u730D\u7312\u7313\u7318\u7319\u731E\u7322\u7324\u7327\u7328\u732C\u7331\u7332\u7335\u733A\u733B\u733D\u7343\u734D\u7350\u7352\u7356\u7358\u735D\u735E\u735F\u7360\u7366\u7367\u7369\u736B\u736C\u736E\u736F\u7371\u7377\u7379\u737C\u7380\u7381\u7383\u7385\u7386\u738E\u7390\u7393\u7395\u7397\u7398\u739C\u739E\u739F\u73A0\u73A2\u73A5\u73A6\u73AA\u73AB\u73AD\u73B5\u73B7\u73B9\u73BC\u73BD\u73BF\u73C5\u73C6\u73C9\u73CB\u73CC\u73CF\u73D2\u73D3\u73D6\u73D9\u73DD\u73E1\u73E3\u73E6\u73E7\u73E9\u73F4\u73F5\u73F7\u73F9\u73FA\u73FB\u73FD"],["8fcca1","\u73FF\u7400\u7401\u7404\u7407\u740A\u7411\u741A\u741B\u7424\u7426\u7428",9,"\u7439\u7440\u7443\u7444\u7446\u7447\u744B\u744D\u7451\u7452\u7457\u745D\u7462\u7466\u7467\u7468\u746B\u746D\u746E\u7471\u7472\u7480\u7481\u7485\u7486\u7487\u7489\u748F\u7490\u7491\u7492\u7498\u7499\u749A\u749C\u749F\u74A0\u74A1\u74A3\u74A6\u74A8\u74A9\u74AA\u74AB\u74AE\u74AF\u74B1\u74B2\u74B5\u74B9\u74BB\u74BF\u74C8\u74C9\u74CC\u74D0\u74D3\u74D8\u74DA\u74DB\u74DE\u74DF\u74E4\u74E8\u74EA\u74EB\u74EF\u74F4\u74FA\u74FB\u74FC\u74FF\u7506"],["8fcda1","\u7512\u7516\u7517\u7520\u7521\u7524\u7527\u7529\u752A\u752F\u7536\u7539\u753D\u753E\u753F\u7540\u7543\u7547\u7548\u754E\u7550\u7552\u7557\u755E\u755F\u7561\u756F\u7571\u7579",5,"\u7581\u7585\u7590\u7592\u7593\u7595\u7599\u759C\u75A2\u75A4\u75B4\u75BA\u75BF\u75C0\u75C1\u75C4\u75C6\u75CC\u75CE\u75CF\u75D7\u75DC\u75DF\u75E0\u75E1\u75E4\u75E7\u75EC\u75EE\u75EF\u75F1\u75F9\u7600\u7602\u7603\u7604\u7607\u7608\u760A\u760C\u760F\u7612\u7613\u7615\u7616\u7619\u761B\u761C\u761D\u761E\u7623\u7625\u7626\u7629\u762D\u7632\u7633\u7635\u7638\u7639"],["8fcea1","\u763A\u763C\u764A\u7640\u7641\u7643\u7644\u7645\u7649\u764B\u7655\u7659\u765F\u7664\u7665\u766D\u766E\u766F\u7671\u7674\u7681\u7685\u768C\u768D\u7695\u769B\u769C\u769D\u769F\u76A0\u76A2",6,"\u76AA\u76AD\u76BD\u76C1\u76C5\u76C9\u76CB\u76CC\u76CE\u76D4\u76D9\u76E0\u76E6\u76E8\u76EC\u76F0\u76F1\u76F6\u76F9\u76FC\u7700\u7706\u770A\u770E\u7712\u7714\u7715\u7717\u7719\u771A\u771C\u7722\u7728\u772D\u772E\u772F\u7734\u7735\u7736\u7739\u773D\u773E\u7742\u7745\u7746\u774A\u774D\u774E\u774F\u7752\u7756\u7757\u775C\u775E\u775F\u7760\u7762"],["8fcfa1","\u7764\u7767\u776A\u776C\u7770\u7772\u7773\u7774\u777A\u777D\u7780\u7784\u778C\u778D\u7794\u7795\u7796\u779A\u779F\u77A2\u77A7\u77AA\u77AE\u77AF\u77B1\u77B5\u77BE\u77C3\u77C9\u77D1\u77D2\u77D5\u77D9\u77DE\u77DF\u77E0\u77E4\u77E6\u77EA\u77EC\u77F0\u77F1\u77F4\u77F8\u77FB\u7805\u7806\u7809\u780D\u780E\u7811\u781D\u7821\u7822\u7823\u782D\u782E\u7830\u7835\u7837\u7843\u7844\u7847\u7848\u784C\u784E\u7852\u785C\u785E\u7860\u7861\u7863\u7864\u7868\u786A\u786E\u787A\u787E\u788A\u788F\u7894\u7898\u78A1\u789D\u789E\u789F\u78A4\u78A8\u78AC\u78AD\u78B0\u78B1\u78B2\u78B3"],["8fd0a1","\u78BB\u78BD\u78BF\u78C7\u78C8\u78C9\u78CC\u78CE\u78D2\u78D3\u78D5\u78D6\u78E4\u78DB\u78DF\u78E0\u78E1\u78E6\u78EA\u78F2\u78F3\u7900\u78F6\u78F7\u78FA\u78FB\u78FF\u7906\u790C\u7910\u791A\u791C\u791E\u791F\u7920\u7925\u7927\u7929\u792D\u7931\u7934\u7935\u793B\u793D\u793F\u7944\u7945\u7946\u794A\u794B\u794F\u7951\u7954\u7958\u795B\u795C\u7967\u7969\u796B\u7972\u7979\u797B\u797C\u797E\u798B\u798C\u7991\u7993\u7994\u7995\u7996\u7998\u799B\u799C\u79A1\u79A8\u79A9\u79AB\u79AF\u79B1\u79B4\u79B8\u79BB\u79C2\u79C4\u79C7\u79C8\u79CA\u79CF\u79D4\u79D6\u79DA\u79DD\u79DE"],["8fd1a1","\u79E0\u79E2\u79E5\u79EA\u79EB\u79ED\u79F1\u79F8\u79FC\u7A02\u7A03\u7A07\u7A09\u7A0A\u7A0C\u7A11\u7A15\u7A1B\u7A1E\u7A21\u7A27\u7A2B\u7A2D\u7A2F\u7A30\u7A34\u7A35\u7A38\u7A39\u7A3A\u7A44\u7A45\u7A47\u7A48\u7A4C\u7A55\u7A56\u7A59\u7A5C\u7A5D\u7A5F\u7A60\u7A65\u7A67\u7A6A\u7A6D\u7A75\u7A78\u7A7E\u7A80\u7A82\u7A85\u7A86\u7A8A\u7A8B\u7A90\u7A91\u7A94\u7A9E\u7AA0\u7AA3\u7AAC\u7AB3\u7AB5\u7AB9\u7ABB\u7ABC\u7AC6\u7AC9\u7ACC\u7ACE\u7AD1\u7ADB\u7AE8\u7AE9\u7AEB\u7AEC\u7AF1\u7AF4\u7AFB\u7AFD\u7AFE\u7B07\u7B14\u7B1F\u7B23\u7B27\u7B29\u7B2A\u7B2B\u7B2D\u7B2E\u7B2F\u7B30"],["8fd2a1","\u7B31\u7B34\u7B3D\u7B3F\u7B40\u7B41\u7B47\u7B4E\u7B55\u7B60\u7B64\u7B66\u7B69\u7B6A\u7B6D\u7B6F\u7B72\u7B73\u7B77\u7B84\u7B89\u7B8E\u7B90\u7B91\u7B96\u7B9B\u7B9E\u7BA0\u7BA5\u7BAC\u7BAF\u7BB0\u7BB2\u7BB5\u7BB6\u7BBA\u7BBB\u7BBC\u7BBD\u7BC2\u7BC5\u7BC8\u7BCA\u7BD4\u7BD6\u7BD7\u7BD9\u7BDA\u7BDB\u7BE8\u7BEA\u7BF2\u7BF4\u7BF5\u7BF8\u7BF9\u7BFA\u7BFC\u7BFE\u7C01\u7C02\u7C03\u7C04\u7C06\u7C09\u7C0B\u7C0C\u7C0E\u7C0F\u7C19\u7C1B\u7C20\u7C25\u7C26\u7C28\u7C2C\u7C31\u7C33\u7C34\u7C36\u7C39\u7C3A\u7C46\u7C4A\u7C55\u7C51\u7C52\u7C53\u7C59",5],["8fd3a1","\u7C61\u7C63\u7C67\u7C69\u7C6D\u7C6E\u7C70\u7C72\u7C79\u7C7C\u7C7D\u7C86\u7C87\u7C8F\u7C94\u7C9E\u7CA0\u7CA6\u7CB0\u7CB6\u7CB7\u7CBA\u7CBB\u7CBC\u7CBF\u7CC4\u7CC7\u7CC8\u7CC9\u7CCD\u7CCF\u7CD3\u7CD4\u7CD5\u7CD7\u7CD9\u7CDA\u7CDD\u7CE6\u7CE9\u7CEB\u7CF5\u7D03\u7D07\u7D08\u7D09\u7D0F\u7D11\u7D12\u7D13\u7D16\u7D1D\u7D1E\u7D23\u7D26\u7D2A\u7D2D\u7D31\u7D3C\u7D3D\u7D3E\u7D40\u7D41\u7D47\u7D48\u7D4D\u7D51\u7D53\u7D57\u7D59\u7D5A\u7D5C\u7D5D\u7D65\u7D67\u7D6A\u7D70\u7D78\u7D7A\u7D7B\u7D7F\u7D81\u7D82\u7D83\u7D85\u7D86\u7D88\u7D8B\u7D8C\u7D8D\u7D91\u7D96\u7D97\u7D9D"],["8fd4a1","\u7D9E\u7DA6\u7DA7\u7DAA\u7DB3\u7DB6\u7DB7\u7DB9\u7DC2",4,"\u7DCC\u7DCD\u7DCE\u7DD7\u7DD9\u7E00\u7DE2\u7DE5\u7DE6\u7DEA\u7DEB\u7DED\u7DF1\u7DF5\u7DF6\u7DF9\u7DFA\u7E08\u7E10\u7E11\u7E15\u7E17\u7E1C\u7E1D\u7E20\u7E27\u7E28\u7E2C\u7E2D\u7E2F\u7E33\u7E36\u7E3F\u7E44\u7E45\u7E47\u7E4E\u7E50\u7E52\u7E58\u7E5F\u7E61\u7E62\u7E65\u7E6B\u7E6E\u7E6F\u7E73\u7E78\u7E7E\u7E81\u7E86\u7E87\u7E8A\u7E8D\u7E91\u7E95\u7E98\u7E9A\u7E9D\u7E9E\u7F3C\u7F3B\u7F3D\u7F3E\u7F3F\u7F43\u7F44\u7F47\u7F4F\u7F52\u7F53\u7F5B\u7F5C\u7F5D\u7F61\u7F63\u7F64\u7F65\u7F66\u7F6D"],["8fd5a1","\u7F71\u7F7D\u7F7E\u7F7F\u7F80\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F96\u7F97\u7F9C\u7FA1\u7FA2\u7FA6\u7FAA\u7FAD\u7FB4\u7FBC\u7FBF\u7FC0\u7FC3\u7FC8\u7FCE\u7FCF\u7FDB\u7FDF\u7FE3\u7FE5\u7FE8\u7FEC\u7FEE\u7FEF\u7FF2\u7FFA\u7FFD\u7FFE\u7FFF\u8007\u8008\u800A\u800D\u800E\u800F\u8011\u8013\u8014\u8016\u801D\u801E\u801F\u8020\u8024\u8026\u802C\u802E\u8030\u8034\u8035\u8037\u8039\u803A\u803C\u803E\u8040\u8044\u8060\u8064\u8066\u806D\u8071\u8075\u8081\u8088\u808E\u809C\u809E\u80A6\u80A7\u80AB\u80B8\u80B9\u80C8\u80CD\u80CF\u80D2\u80D4\u80D5\u80D7\u80D8\u80E0\u80ED\u80EE"],["8fd6a1","\u80F0\u80F2\u80F3\u80F6\u80F9\u80FA\u80FE\u8103\u810B\u8116\u8117\u8118\u811C\u811E\u8120\u8124\u8127\u812C\u8130\u8135\u813A\u813C\u8145\u8147\u814A\u814C\u8152\u8157\u8160\u8161\u8167\u8168\u8169\u816D\u816F\u8177\u8181\u8190\u8184\u8185\u8186\u818B\u818E\u8196\u8198\u819B\u819E\u81A2\u81AE\u81B2\u81B4\u81BB\u81CB\u81C3\u81C5\u81CA\u81CE\u81CF\u81D5\u81D7\u81DB\u81DD\u81DE\u81E1\u81E4\u81EB\u81EC\u81F0\u81F1\u81F2\u81F5\u81F6\u81F8\u81F9\u81FD\u81FF\u8200\u8203\u820F\u8213\u8214\u8219\u821A\u821D\u8221\u8222\u8228\u8232\u8234\u823A\u8243\u8244\u8245\u8246"],["8fd7a1","\u824B\u824E\u824F\u8251\u8256\u825C\u8260\u8263\u8267\u826D\u8274\u827B\u827D\u827F\u8280\u8281\u8283\u8284\u8287\u8289\u828A\u828E\u8291\u8294\u8296\u8298\u829A\u829B\u82A0\u82A1\u82A3\u82A4\u82A7\u82A8\u82A9\u82AA\u82AE\u82B0\u82B2\u82B4\u82B7\u82BA\u82BC\u82BE\u82BF\u82C6\u82D0\u82D5\u82DA\u82E0\u82E2\u82E4\u82E8\u82EA\u82ED\u82EF\u82F6\u82F7\u82FD\u82FE\u8300\u8301\u8307\u8308\u830A\u830B\u8354\u831B\u831D\u831E\u831F\u8321\u8322\u832C\u832D\u832E\u8330\u8333\u8337\u833A\u833C\u833D\u8342\u8343\u8344\u8347\u834D\u834E\u8351\u8355\u8356\u8357\u8370\u8378"],["8fd8a1","\u837D\u837F\u8380\u8382\u8384\u8386\u838D\u8392\u8394\u8395\u8398\u8399\u839B\u839C\u839D\u83A6\u83A7\u83A9\u83AC\u83BE\u83BF\u83C0\u83C7\u83C9\u83CF\u83D0\u83D1\u83D4\u83DD\u8353\u83E8\u83EA\u83F6\u83F8\u83F9\u83FC\u8401\u8406\u840A\u840F\u8411\u8415\u8419\u83AD\u842F\u8439\u8445\u8447\u8448\u844A\u844D\u844F\u8451\u8452\u8456\u8458\u8459\u845A\u845C\u8460\u8464\u8465\u8467\u846A\u8470\u8473\u8474\u8476\u8478\u847C\u847D\u8481\u8485\u8492\u8493\u8495\u849E\u84A6\u84A8\u84A9\u84AA\u84AF\u84B1\u84B4\u84BA\u84BD\u84BE\u84C0\u84C2\u84C7\u84C8\u84CC\u84CF\u84D3"],["8fd9a1","\u84DC\u84E7\u84EA\u84EF\u84F0\u84F1\u84F2\u84F7\u8532\u84FA\u84FB\u84FD\u8502\u8503\u8507\u850C\u850E\u8510\u851C\u851E\u8522\u8523\u8524\u8525\u8527\u852A\u852B\u852F\u8533\u8534\u8536\u853F\u8546\u854F",4,"\u8556\u8559\u855C",6,"\u8564\u856B\u856F\u8579\u857A\u857B\u857D\u857F\u8581\u8585\u8586\u8589\u858B\u858C\u858F\u8593\u8598\u859D\u859F\u85A0\u85A2\u85A5\u85A7\u85B4\u85B6\u85B7\u85B8\u85BC\u85BD\u85BE\u85BF\u85C2\u85C7\u85CA\u85CB\u85CE\u85AD\u85D8\u85DA\u85DF\u85E0\u85E6\u85E8\u85ED\u85F3\u85F6\u85FC"],["8fdaa1","\u85FF\u8600\u8604\u8605\u860D\u860E\u8610\u8611\u8612\u8618\u8619\u861B\u861E\u8621\u8627\u8629\u8636\u8638\u863A\u863C\u863D\u8640\u8642\u8646\u8652\u8653\u8656\u8657\u8658\u8659\u865D\u8660",4,"\u8669\u866C\u866F\u8675\u8676\u8677\u867A\u868D\u8691\u8696\u8698\u869A\u869C\u86A1\u86A6\u86A7\u86A8\u86AD\u86B1\u86B3\u86B4\u86B5\u86B7\u86B8\u86B9\u86BF\u86C0\u86C1\u86C3\u86C5\u86D1\u86D2\u86D5\u86D7\u86DA\u86DC\u86E0\u86E3\u86E5\u86E7\u8688\u86FA\u86FC\u86FD\u8704\u8705\u8707\u870B\u870E\u870F\u8710\u8713\u8714\u8719\u871E\u871F\u8721\u8723"],["8fdba1","\u8728\u872E\u872F\u8731\u8732\u8739\u873A\u873C\u873D\u873E\u8740\u8743\u8745\u874D\u8758\u875D\u8761\u8764\u8765\u876F\u8771\u8772\u877B\u8783",6,"\u878B\u878C\u8790\u8793\u8795\u8797\u8798\u8799\u879E\u87A0\u87A3\u87A7\u87AC\u87AD\u87AE\u87B1\u87B5\u87BE\u87BF\u87C1\u87C8\u87C9\u87CA\u87CE\u87D5\u87D6\u87D9\u87DA\u87DC\u87DF\u87E2\u87E3\u87E4\u87EA\u87EB\u87ED\u87F1\u87F3\u87F8\u87FA\u87FF\u8801\u8803\u8806\u8809\u880A\u880B\u8810\u8819\u8812\u8813\u8814\u8818\u881A\u881B\u881C\u881E\u881F\u8828\u882D\u882E\u8830\u8832\u8835"],["8fdca1","\u883A\u883C\u8841\u8843\u8845\u8848\u8849\u884A\u884B\u884E\u8851\u8855\u8856\u8858\u885A\u885C\u885F\u8860\u8864\u8869\u8871\u8879\u887B\u8880\u8898\u889A\u889B\u889C\u889F\u88A0\u88A8\u88AA\u88BA\u88BD\u88BE\u88C0\u88CA",4,"\u88D1\u88D2\u88D3\u88DB\u88DE\u88E7\u88EF\u88F0\u88F1\u88F5\u88F7\u8901\u8906\u890D\u890E\u890F\u8915\u8916\u8918\u8919\u891A\u891C\u8920\u8926\u8927\u8928\u8930\u8931\u8932\u8935\u8939\u893A\u893E\u8940\u8942\u8945\u8946\u8949\u894F\u8952\u8957\u895A\u895B\u895C\u8961\u8962\u8963\u896B\u896E\u8970\u8973\u8975\u897A"],["8fdda1","\u897B\u897C\u897D\u8989\u898D\u8990\u8994\u8995\u899B\u899C\u899F\u89A0\u89A5\u89B0\u89B4\u89B5\u89B6\u89B7\u89BC\u89D4",4,"\u89E5\u89E9\u89EB\u89ED\u89F1\u89F3\u89F6\u89F9\u89FD\u89FF\u8A04\u8A05\u8A07\u8A0F\u8A11\u8A12\u8A14\u8A15\u8A1E\u8A20\u8A22\u8A24\u8A26\u8A2B\u8A2C\u8A2F\u8A35\u8A37\u8A3D\u8A3E\u8A40\u8A43\u8A45\u8A47\u8A49\u8A4D\u8A4E\u8A53\u8A56\u8A57\u8A58\u8A5C\u8A5D\u8A61\u8A65\u8A67\u8A75\u8A76\u8A77\u8A79\u8A7A\u8A7B\u8A7E\u8A7F\u8A80\u8A83\u8A86\u8A8B\u8A8F\u8A90\u8A92\u8A96\u8A97\u8A99\u8A9F\u8AA7\u8AA9\u8AAE\u8AAF\u8AB3"],["8fdea1","\u8AB6\u8AB7\u8ABB\u8ABE\u8AC3\u8AC6\u8AC8\u8AC9\u8ACA\u8AD1\u8AD3\u8AD4\u8AD5\u8AD7\u8ADD\u8ADF\u8AEC\u8AF0\u8AF4\u8AF5\u8AF6\u8AFC\u8AFF\u8B05\u8B06\u8B0B\u8B11\u8B1C\u8B1E\u8B1F\u8B0A\u8B2D\u8B30\u8B37\u8B3C\u8B42",4,"\u8B48\u8B52\u8B53\u8B54\u8B59\u8B4D\u8B5E\u8B63\u8B6D\u8B76\u8B78\u8B79\u8B7C\u8B7E\u8B81\u8B84\u8B85\u8B8B\u8B8D\u8B8F\u8B94\u8B95\u8B9C\u8B9E\u8B9F\u8C38\u8C39\u8C3D\u8C3E\u8C45\u8C47\u8C49\u8C4B\u8C4F\u8C51\u8C53\u8C54\u8C57\u8C58\u8C5B\u8C5D\u8C59\u8C63\u8C64\u8C66\u8C68\u8C69\u8C6D\u8C73\u8C75\u8C76\u8C7B\u8C7E\u8C86"],["8fdfa1","\u8C87\u8C8B\u8C90\u8C92\u8C93\u8C99\u8C9B\u8C9C\u8CA4\u8CB9\u8CBA\u8CC5\u8CC6\u8CC9\u8CCB\u8CCF\u8CD6\u8CD5\u8CD9\u8CDD\u8CE1\u8CE8\u8CEC\u8CEF\u8CF0\u8CF2\u8CF5\u8CF7\u8CF8\u8CFE\u8CFF\u8D01\u8D03\u8D09\u8D12\u8D17\u8D1B\u8D65\u8D69\u8D6C\u8D6E\u8D7F\u8D82\u8D84\u8D88\u8D8D\u8D90\u8D91\u8D95\u8D9E\u8D9F\u8DA0\u8DA6\u8DAB\u8DAC\u8DAF\u8DB2\u8DB5\u8DB7\u8DB9\u8DBB\u8DC0\u8DC5\u8DC6\u8DC7\u8DC8\u8DCA\u8DCE\u8DD1\u8DD4\u8DD5\u8DD7\u8DD9\u8DE4\u8DE5\u8DE7\u8DEC\u8DF0\u8DBC\u8DF1\u8DF2\u8DF4\u8DFD\u8E01\u8E04\u8E05\u8E06\u8E0B\u8E11\u8E14\u8E16\u8E20\u8E21\u8E22"],["8fe0a1","\u8E23\u8E26\u8E27\u8E31\u8E33\u8E36\u8E37\u8E38\u8E39\u8E3D\u8E40\u8E41\u8E4B\u8E4D\u8E4E\u8E4F\u8E54\u8E5B\u8E5C\u8E5D\u8E5E\u8E61\u8E62\u8E69\u8E6C\u8E6D\u8E6F\u8E70\u8E71\u8E79\u8E7A\u8E7B\u8E82\u8E83\u8E89\u8E90\u8E92\u8E95\u8E9A\u8E9B\u8E9D\u8E9E\u8EA2\u8EA7\u8EA9\u8EAD\u8EAE\u8EB3\u8EB5\u8EBA\u8EBB\u8EC0\u8EC1\u8EC3\u8EC4\u8EC7\u8ECF\u8ED1\u8ED4\u8EDC\u8EE8\u8EEE\u8EF0\u8EF1\u8EF7\u8EF9\u8EFA\u8EED\u8F00\u8F02\u8F07\u8F08\u8F0F\u8F10\u8F16\u8F17\u8F18\u8F1E\u8F20\u8F21\u8F23\u8F25\u8F27\u8F28\u8F2C\u8F2D\u8F2E\u8F34\u8F35\u8F36\u8F37\u8F3A\u8F40\u8F41"],["8fe1a1","\u8F43\u8F47\u8F4F\u8F51",4,"\u8F58\u8F5D\u8F5E\u8F65\u8F9D\u8FA0\u8FA1\u8FA4\u8FA5\u8FA6\u8FB5\u8FB6\u8FB8\u8FBE\u8FC0\u8FC1\u8FC6\u8FCA\u8FCB\u8FCD\u8FD0\u8FD2\u8FD3\u8FD5\u8FE0\u8FE3\u8FE4\u8FE8\u8FEE\u8FF1\u8FF5\u8FF6\u8FFB\u8FFE\u9002\u9004\u9008\u900C\u9018\u901B\u9028\u9029\u902F\u902A\u902C\u902D\u9033\u9034\u9037\u903F\u9043\u9044\u904C\u905B\u905D\u9062\u9066\u9067\u906C\u9070\u9074\u9079\u9085\u9088\u908B\u908C\u908E\u9090\u9095\u9097\u9098\u9099\u909B\u90A0\u90A1\u90A2\u90A5\u90B0\u90B2\u90B3\u90B4\u90B6\u90BD\u90CC\u90BE\u90C3"],["8fe2a1","\u90C4\u90C5\u90C7\u90C8\u90D5\u90D7\u90D8\u90D9\u90DC\u90DD\u90DF\u90E5\u90D2\u90F6\u90EB\u90EF\u90F0\u90F4\u90FE\u90FF\u9100\u9104\u9105\u9106\u9108\u910D\u9110\u9114\u9116\u9117\u9118\u911A\u911C\u911E\u9120\u9125\u9122\u9123\u9127\u9129\u912E\u912F\u9131\u9134\u9136\u9137\u9139\u913A\u913C\u913D\u9143\u9147\u9148\u914F\u9153\u9157\u9159\u915A\u915B\u9161\u9164\u9167\u916D\u9174\u9179\u917A\u917B\u9181\u9183\u9185\u9186\u918A\u918E\u9191\u9193\u9194\u9195\u9198\u919E\u91A1\u91A6\u91A8\u91AC\u91AD\u91AE\u91B0\u91B1\u91B2\u91B3\u91B6\u91BB\u91BC\u91BD\u91BF"],["8fe3a1","\u91C2\u91C3\u91C5\u91D3\u91D4\u91D7\u91D9\u91DA\u91DE\u91E4\u91E5\u91E9\u91EA\u91EC",5,"\u91F7\u91F9\u91FB\u91FD\u9200\u9201\u9204\u9205\u9206\u9207\u9209\u920A\u920C\u9210\u9212\u9213\u9216\u9218\u921C\u921D\u9223\u9224\u9225\u9226\u9228\u922E\u922F\u9230\u9233\u9235\u9236\u9238\u9239\u923A\u923C\u923E\u9240\u9242\u9243\u9246\u9247\u924A\u924D\u924E\u924F\u9251\u9258\u9259\u925C\u925D\u9260\u9261\u9265\u9267\u9268\u9269\u926E\u926F\u9270\u9275",4,"\u927B\u927C\u927D\u927F\u9288\u9289\u928A\u928D\u928E\u9292\u9297"],["8fe4a1","\u9299\u929F\u92A0\u92A4\u92A5\u92A7\u92A8\u92AB\u92AF\u92B2\u92B6\u92B8\u92BA\u92BB\u92BC\u92BD\u92BF",4,"\u92C5\u92C6\u92C7\u92C8\u92CB\u92CC\u92CD\u92CE\u92D0\u92D3\u92D5\u92D7\u92D8\u92D9\u92DC\u92DD\u92DF\u92E0\u92E1\u92E3\u92E5\u92E7\u92E8\u92EC\u92EE\u92F0\u92F9\u92FB\u92FF\u9300\u9302\u9308\u930D\u9311\u9314\u9315\u931C\u931D\u931E\u931F\u9321\u9324\u9325\u9327\u9329\u932A\u9333\u9334\u9336\u9337\u9347\u9348\u9349\u9350\u9351\u9352\u9355\u9357\u9358\u935A\u935E\u9364\u9365\u9367\u9369\u936A\u936D\u936F\u9370\u9371\u9373\u9374\u9376"],["8fe5a1","\u937A\u937D\u937F\u9380\u9381\u9382\u9388\u938A\u938B\u938D\u938F\u9392\u9395\u9398\u939B\u939E\u93A1\u93A3\u93A4\u93A6\u93A8\u93AB\u93B4\u93B5\u93B6\u93BA\u93A9\u93C1\u93C4\u93C5\u93C6\u93C7\u93C9",4,"\u93D3\u93D9\u93DC\u93DE\u93DF\u93E2\u93E6\u93E7\u93F9\u93F7\u93F8\u93FA\u93FB\u93FD\u9401\u9402\u9404\u9408\u9409\u940D\u940E\u940F\u9415\u9416\u9417\u941F\u942E\u942F\u9431\u9432\u9433\u9434\u943B\u943F\u943D\u9443\u9445\u9448\u944A\u944C\u9455\u9459\u945C\u945F\u9461\u9463\u9468\u946B\u946D\u946E\u946F\u9471\u9472\u9484\u9483\u9578\u9579"],["8fe6a1","\u957E\u9584\u9588\u958C\u958D\u958E\u959D\u959E\u959F\u95A1\u95A6\u95A9\u95AB\u95AC\u95B4\u95B6\u95BA\u95BD\u95BF\u95C6\u95C8\u95C9\u95CB\u95D0\u95D1\u95D2\u95D3\u95D9\u95DA\u95DD\u95DE\u95DF\u95E0\u95E4\u95E6\u961D\u961E\u9622\u9624\u9625\u9626\u962C\u9631\u9633\u9637\u9638\u9639\u963A\u963C\u963D\u9641\u9652\u9654\u9656\u9657\u9658\u9661\u966E\u9674\u967B\u967C\u967E\u967F\u9681\u9682\u9683\u9684\u9689\u9691\u9696\u969A\u969D\u969F\u96A4\u96A5\u96A6\u96A9\u96AE\u96AF\u96B3\u96BA\u96CA\u96D2\u5DB2\u96D8\u96DA\u96DD\u96DE\u96DF\u96E9\u96EF\u96F1\u96FA\u9702"],["8fe7a1","\u9703\u9705\u9709\u971A\u971B\u971D\u9721\u9722\u9723\u9728\u9731\u9733\u9741\u9743\u974A\u974E\u974F\u9755\u9757\u9758\u975A\u975B\u9763\u9767\u976A\u976E\u9773\u9776\u9777\u9778\u977B\u977D\u977F\u9780\u9789\u9795\u9796\u9797\u9799\u979A\u979E\u979F\u97A2\u97AC\u97AE\u97B1\u97B2\u97B5\u97B6\u97B8\u97B9\u97BA\u97BC\u97BE\u97BF\u97C1\u97C4\u97C5\u97C7\u97C9\u97CA\u97CC\u97CD\u97CE\u97D0\u97D1\u97D4\u97D7\u97D8\u97D9\u97DD\u97DE\u97E0\u97DB\u97E1\u97E4\u97EF\u97F1\u97F4\u97F7\u97F8\u97FA\u9807\u980A\u9819\u980D\u980E\u9814\u9816\u981C\u981E\u9820\u9823\u9826"],["8fe8a1","\u982B\u982E\u982F\u9830\u9832\u9833\u9835\u9825\u983E\u9844\u9847\u984A\u9851\u9852\u9853\u9856\u9857\u9859\u985A\u9862\u9863\u9865\u9866\u986A\u986C\u98AB\u98AD\u98AE\u98B0\u98B4\u98B7\u98B8\u98BA\u98BB\u98BF\u98C2\u98C5\u98C8\u98CC\u98E1\u98E3\u98E5\u98E6\u98E7\u98EA\u98F3\u98F6\u9902\u9907\u9908\u9911\u9915\u9916\u9917\u991A\u991B\u991C\u991F\u9922\u9926\u9927\u992B\u9931",4,"\u9939\u993A\u993B\u993C\u9940\u9941\u9946\u9947\u9948\u994D\u994E\u9954\u9958\u9959\u995B\u995C\u995E\u995F\u9960\u999B\u999D\u999F\u99A6\u99B0\u99B1\u99B2\u99B5"],["8fe9a1","\u99B9\u99BA\u99BD\u99BF\u99C3\u99C9\u99D3\u99D4\u99D9\u99DA\u99DC\u99DE\u99E7\u99EA\u99EB\u99EC\u99F0\u99F4\u99F5\u99F9\u99FD\u99FE\u9A02\u9A03\u9A04\u9A0B\u9A0C\u9A10\u9A11\u9A16\u9A1E\u9A20\u9A22\u9A23\u9A24\u9A27\u9A2D\u9A2E\u9A33\u9A35\u9A36\u9A38\u9A47\u9A41\u9A44\u9A4A\u9A4B\u9A4C\u9A4E\u9A51\u9A54\u9A56\u9A5D\u9AAA\u9AAC\u9AAE\u9AAF\u9AB2\u9AB4\u9AB5\u9AB6\u9AB9\u9ABB\u9ABE\u9ABF\u9AC1\u9AC3\u9AC6\u9AC8\u9ACE\u9AD0\u9AD2\u9AD5\u9AD6\u9AD7\u9ADB\u9ADC\u9AE0\u9AE4\u9AE5\u9AE7\u9AE9\u9AEC\u9AF2\u9AF3\u9AF5\u9AF9\u9AFA\u9AFD\u9AFF",4],["8feaa1","\u9B04\u9B05\u9B08\u9B09\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B12\u9B16\u9B19\u9B1B\u9B1C\u9B20\u9B26\u9B2B\u9B2D\u9B33\u9B34\u9B35\u9B37\u9B39\u9B3A\u9B3D\u9B48\u9B4B\u9B4C\u9B55\u9B56\u9B57\u9B5B\u9B5E\u9B61\u9B63\u9B65\u9B66\u9B68\u9B6A",4,"\u9B73\u9B75\u9B77\u9B78\u9B79\u9B7F\u9B80\u9B84\u9B85\u9B86\u9B87\u9B89\u9B8A\u9B8B\u9B8D\u9B8F\u9B90\u9B94\u9B9A\u9B9D\u9B9E\u9BA6\u9BA7\u9BA9\u9BAC\u9BB0\u9BB1\u9BB2\u9BB7\u9BB8\u9BBB\u9BBC\u9BBE\u9BBF\u9BC1\u9BC7\u9BC8\u9BCE\u9BD0\u9BD7\u9BD8\u9BDD\u9BDF\u9BE5\u9BE7\u9BEA\u9BEB\u9BEF\u9BF3\u9BF7\u9BF8"],["8feba1","\u9BF9\u9BFA\u9BFD\u9BFF\u9C00\u9C02\u9C0B\u9C0F\u9C11\u9C16\u9C18\u9C19\u9C1A\u9C1C\u9C1E\u9C22\u9C23\u9C26",4,"\u9C31\u9C35\u9C36\u9C37\u9C3D\u9C41\u9C43\u9C44\u9C45\u9C49\u9C4A\u9C4E\u9C4F\u9C50\u9C53\u9C54\u9C56\u9C58\u9C5B\u9C5D\u9C5E\u9C5F\u9C63\u9C69\u9C6A\u9C5C\u9C6B\u9C68\u9C6E\u9C70\u9C72\u9C75\u9C77\u9C7B\u9CE6\u9CF2\u9CF7\u9CF9\u9D0B\u9D02\u9D11\u9D17\u9D18\u9D1C\u9D1D\u9D1E\u9D2F\u9D30\u9D32\u9D33\u9D34\u9D3A\u9D3C\u9D45\u9D3D\u9D42\u9D43\u9D47\u9D4A\u9D53\u9D54\u9D5F\u9D63\u9D62\u9D65\u9D69\u9D6A\u9D6B\u9D70\u9D76\u9D77\u9D7B"],["8feca1","\u9D7C\u9D7E\u9D83\u9D84\u9D86\u9D8A\u9D8D\u9D8E\u9D92\u9D93\u9D95\u9D96\u9D97\u9D98\u9DA1\u9DAA\u9DAC\u9DAE\u9DB1\u9DB5\u9DB9\u9DBC\u9DBF\u9DC3\u9DC7\u9DC9\u9DCA\u9DD4\u9DD5\u9DD6\u9DD7\u9DDA\u9DDE\u9DDF\u9DE0\u9DE5\u9DE7\u9DE9\u9DEB\u9DEE\u9DF0\u9DF3\u9DF4\u9DFE\u9E0A\u9E02\u9E07\u9E0E\u9E10\u9E11\u9E12\u9E15\u9E16\u9E19\u9E1C\u9E1D\u9E7A\u9E7B\u9E7C\u9E80\u9E82\u9E83\u9E84\u9E85\u9E87\u9E8E\u9E8F\u9E96\u9E98\u9E9B\u9E9E\u9EA4\u9EA8\u9EAC\u9EAE\u9EAF\u9EB0\u9EB3\u9EB4\u9EB5\u9EC6\u9EC8\u9ECB\u9ED5\u9EDF\u9EE4\u9EE7\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF5"],["8feda1","\u9EF8\u9EFF\u9F02\u9F03\u9F09\u9F0F\u9F10\u9F11\u9F12\u9F14\u9F16\u9F17\u9F19\u9F1A\u9F1B\u9F1F\u9F22\u9F26\u9F2A\u9F2B\u9F2F\u9F31\u9F32\u9F34\u9F37\u9F39\u9F3A\u9F3C\u9F3D\u9F3F\u9F41\u9F43",4,"\u9F53\u9F55\u9F56\u9F57\u9F58\u9F5A\u9F5D\u9F5E\u9F68\u9F69\u9F6D",4,"\u9F73\u9F75\u9F7A\u9F7D\u9F8F\u9F90\u9F91\u9F92\u9F94\u9F96\u9F97\u9F9E\u9FA1\u9FA2\u9FA3\u9FA5"]]');

});

parcelRegister("MHD54", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127,"\u20AC"],["8140","\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A",5,"\u4E72\u4E74",9,"\u4E7F",6,"\u4E87\u4E8A"],["8180","\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02",6,"\u4F0B\u4F0C\u4F12",4,"\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E",4,"\u4F44\u4F45\u4F47",5,"\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2"],["8240","\u4FA4\u4FAB\u4FAD\u4FB0",4,"\u4FB6",8,"\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2",4,"\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF",11],["8280","\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F",10,"\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050",4,"\u5056\u5057\u5058\u5059\u505B\u505D",7,"\u5066",5,"\u506D",8,"\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E",20,"\u50A4\u50A6\u50AA\u50AB\u50AD",4,"\u50B3",6,"\u50BC"],["8340","\u50BD",17,"\u50D0",5,"\u50D7\u50D8\u50D9\u50DB",10,"\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6",4,"\u50FC",9,"\u5108"],["8380","\u5109\u510A\u510C",5,"\u5113",13,"\u5122",28,"\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D",4,"\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6",4,"\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2",5],["8440","\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5",5,"\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244",5,"\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258"],["8480","\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273",9,"\u527E\u5280\u5283",4,"\u5289",6,"\u5291\u5292\u5294",6,"\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4",9,"\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9",5,"\u52E0\u52E1\u52E2\u52E3\u52E5",10,"\u52F1",7,"\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E"],["8540","\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F",9,"\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F"],["8580","\u5390",4,"\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF",6,"\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3",4,"\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D",4,"\u5463\u5465\u5467\u5469",7,"\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1"],["8640","\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0",4,"\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4",5,"\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A",4,"\u5512\u5513\u5515",5,"\u551C\u551D\u551E\u551F\u5521\u5525\u5526"],["8680","\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B",4,"\u5551\u5552\u5553\u5554\u5557",4,"\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F",5,"\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0",6,"\u55A8",8,"\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF",4,"\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7",4,"\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8",4,"\u55FF\u5602\u5603\u5604\u5605"],["8740","\u5606\u5607\u560A\u560B\u560D\u5610",7,"\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640",11,"\u564F",4,"\u5655\u5656\u565A\u565B\u565D",4],["8780","\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D",7,"\u5687",6,"\u5690\u5691\u5692\u5694",14,"\u56A4",10,"\u56B0",6,"\u56B8\u56B9\u56BA\u56BB\u56BD",12,"\u56CB",8,"\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5",5,"\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B",6],["8840","\u5712",9,"\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734",4,"\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752",4,"\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780"],["8880","\u5781\u5787\u5788\u5789\u578A\u578D",4,"\u5794",6,"\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9",8,"\u57C4",6,"\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5",7,"\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825",4,"\u582B",4,"\u5831\u5832\u5833\u5834\u5836",7],["8940","\u583E",5,"\u5845",6,"\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859",4,"\u585F",5,"\u5866",4,"\u586D",16,"\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C"],["8980","\u588D",4,"\u5894",4,"\u589B\u589C\u589D\u58A0",7,"\u58AA",17,"\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6",10,"\u58D2\u58D3\u58D4\u58D6",13,"\u58E5",5,"\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA",7,"\u5903\u5905\u5906\u5908",4,"\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B"],["8a40","\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B",4,"\u5961\u5963\u5964\u5966",12,"\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6"],["8a80","\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3",5,"\u59BA\u59BC\u59BD\u59BF",6,"\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE",4,"\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED",11,"\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A",6,"\u5A33\u5A35\u5A37",4,"\u5A3D\u5A3E\u5A3F\u5A41",4,"\u5A47\u5A48\u5A4B",9,"\u5A56\u5A57\u5A58\u5A59\u5A5B",5],["8b40","\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B",8,"\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80",17,"\u5A93",6,"\u5A9C",13,"\u5AAB\u5AAC"],["8b80","\u5AAD",4,"\u5AB4\u5AB6\u5AB7\u5AB9",4,"\u5ABF\u5AC0\u5AC3",5,"\u5ACA\u5ACB\u5ACD",4,"\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC",4,"\u5AF2",22,"\u5B0A",11,"\u5B18",25,"\u5B33\u5B35\u5B36\u5B38",7,"\u5B41",6],["8c40","\u5B48",7,"\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF"],["8c80","\u5BD1\u5BD4",8,"\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9",4,"\u5BEF\u5BF1",6,"\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67",6,"\u5C70\u5C72",6,"\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83",4,"\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D",4,"\u5CA4",4],["8d40","\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5",5,"\u5CCC",5,"\u5CD3",5,"\u5CDA",6,"\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1",9,"\u5CFC",4],["8d80","\u5D01\u5D04\u5D05\u5D08",5,"\u5D0F",4,"\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F",4,"\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F",4,"\u5D35",7,"\u5D3F",7,"\u5D48\u5D49\u5D4D",10,"\u5D59\u5D5A\u5D5C\u5D5E",10,"\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75",12,"\u5D83",21,"\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0"],["8e40","\u5DA1",21,"\u5DB8",12,"\u5DC6",6,"\u5DCE",12,"\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED"],["8e80","\u5DF0\u5DF5\u5DF6\u5DF8",4,"\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E",7,"\u5E28",4,"\u5E2F\u5E30\u5E32",4,"\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46",5,"\u5E4D",6,"\u5E56",4,"\u5E5C\u5E5D\u5E5F\u5E60\u5E63",14,"\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8",4,"\u5EAE",4,"\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF",6],["8f40","\u5EC6\u5EC7\u5EC8\u5ECB",5,"\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC",11,"\u5EE9\u5EEB",8,"\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24"],["8f80","\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32",6,"\u5F3B\u5F3D\u5F3E\u5F3F\u5F41",14,"\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2",5,"\u5FA9\u5FAB\u5FAC\u5FAF",5,"\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE",4,"\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007"],["9040","\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030",4,"\u6036",4,"\u603D\u603E\u6040\u6044",6,"\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080"],["9080","\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD",7,"\u60C7\u60C8\u60C9\u60CC",4,"\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1",4,"\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB",4,"\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110",4,"\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C",18,"\u6140",6],["9140","\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156",6,"\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169",6,"\u6171\u6172\u6173\u6174\u6176\u6178",18,"\u618C\u618D\u618F",4,"\u6195"],["9180","\u6196",6,"\u619E",8,"\u61AA\u61AB\u61AD",9,"\u61B8",5,"\u61BF\u61C0\u61C1\u61C3",4,"\u61C9\u61CC",4,"\u61D3\u61D5",16,"\u61E7",13,"\u61F6",8,"\u6200",5,"\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238",4,"\u6242\u6244\u6245\u6246\u624A"],["9240","\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C",6,"\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B",5,"\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1"],["9280","\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333",5,"\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356",7,"\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399",6,"\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0"],["9340","\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7",6,"\u63DF\u63E2\u63E4",4,"\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406",4,"\u640D\u640E\u6411\u6412\u6415",5,"\u641D\u641F\u6422\u6423\u6424"],["9380","\u6425\u6427\u6428\u6429\u642B\u642E",5,"\u6435",4,"\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B",6,"\u6453\u6455\u6456\u6457\u6459",4,"\u645F",7,"\u6468\u646A\u646B\u646C\u646E",9,"\u647B",6,"\u6483\u6486\u6488",8,"\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F",4,"\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6",6,"\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA"],["9440","\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7",24,"\u6501",7,"\u650A",7,"\u6513",4,"\u6519",8],["9480","\u6522\u6523\u6524\u6526",4,"\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540",4,"\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578",14,"\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1",7,"\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8",7,"\u65E1\u65E3\u65E4\u65EA\u65EB"],["9540","\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB",4,"\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637",4,"\u663D\u663F\u6640\u6642\u6644",6,"\u664D\u664E\u6650\u6651\u6658"],["9580","\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669",4,"\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698",4,"\u669E",8,"\u66A9",4,"\u66AF",4,"\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF",25,"\u66DA\u66DE",7,"\u66E7\u66E8\u66EA",5,"\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703"],["9640","\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720",5,"\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757",4,"\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776"],["9680","\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9",7,"\u67C2\u67C5",9,"\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5",7,"\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818",4,"\u681E\u681F\u6820\u6822",6,"\u682B",6,"\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856",5],["9740","\u685C\u685D\u685E\u685F\u686A\u686C",7,"\u6875\u6878",8,"\u6882\u6884\u6887",7,"\u6890\u6891\u6892\u6894\u6895\u6896\u6898",9,"\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8"],["9780","\u68B9",6,"\u68C1\u68C3",5,"\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB",4,"\u68E1\u68E2\u68E4",9,"\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906",4,"\u690C\u690F\u6911\u6913",11,"\u6921\u6922\u6923\u6925",7,"\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943",16,"\u6955\u6956\u6958\u6959\u695B\u695C\u695F"],["9840","\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972",4,"\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E",5,"\u6996\u6997\u6999\u699A\u699D",9,"\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD"],["9880","\u69BE\u69BF\u69C0\u69C2",7,"\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5",5,"\u69DC\u69DD\u69DE\u69E1",11,"\u69EE\u69EF\u69F0\u69F1\u69F3",9,"\u69FE\u6A00",9,"\u6A0B",11,"\u6A19",5,"\u6A20\u6A22",5,"\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36",6,"\u6A3F",4,"\u6A45\u6A46\u6A48",7,"\u6A51",6,"\u6A5A"],["9940","\u6A5C",4,"\u6A62\u6A63\u6A64\u6A66",10,"\u6A72",6,"\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85",8,"\u6A8F\u6A92",4,"\u6A98",7,"\u6AA1",5],["9980","\u6AA7\u6AA8\u6AAA\u6AAD",114,"\u6B25\u6B26\u6B28",6],["9a40","\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D",11,"\u6B5A",7,"\u6B68\u6B69\u6B6B",13,"\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88"],["9a80","\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C",4,"\u6BA2",7,"\u6BAB",7,"\u6BB6\u6BB8",6,"\u6BC0\u6BC3\u6BC4\u6BC6",4,"\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC",4,"\u6BE2",7,"\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE",6,"\u6C08",4,"\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B",4,"\u6C51\u6C52\u6C53\u6C56\u6C58"],["9b40","\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B",4,"\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8"],["9b80","\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F",5,"\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D",4,"\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96",4,"\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9",5,"\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA"],["9c40","\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD",7,"\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35"],["9c80","\u6E36\u6E37\u6E39\u6E3B",7,"\u6E45",7,"\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60",10,"\u6E6C\u6E6D\u6E6F",14,"\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A",4,"\u6E91",6,"\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA",5],["9d40","\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA",7,"\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A",4,"\u6F10\u6F11\u6F12\u6F16",9,"\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37",6,"\u6F3F\u6F40\u6F41\u6F42"],["9d80","\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E",9,"\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67",5,"\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D",6,"\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F",12,"\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2",4,"\u6FA8",10,"\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA",5,"\u6FC1\u6FC3",5,"\u6FCA",6,"\u6FD3",10,"\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5"],["9e40","\u6FE6",7,"\u6FF0",32,"\u7012",7,"\u701C",6,"\u7024",6],["9e80","\u702B",9,"\u7036\u7037\u7038\u703A",17,"\u704D\u704E\u7050",13,"\u705F",11,"\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E",12,"\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB",12,"\u70DA"],["9f40","\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0",6,"\u70F8\u70FA\u70FB\u70FC\u70FE",10,"\u710B",4,"\u7111\u7112\u7114\u7117\u711B",10,"\u7127",7,"\u7132\u7133\u7134"],["9f80","\u7135\u7137",13,"\u7146\u7147\u7148\u7149\u714B\u714D\u714F",12,"\u715D\u715F",4,"\u7165\u7169",4,"\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E",5,"\u7185",4,"\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A",4,"\u71A1",6,"\u71A9\u71AA\u71AB\u71AD",5,"\u71B4\u71B6\u71B7\u71B8\u71BA",8,"\u71C4",9,"\u71CF",4],["a040","\u71D6",9,"\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8",5,"\u71EF",9,"\u71FA",11,"\u7207",19],["a080","\u721B\u721C\u721E",9,"\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240",6,"\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285",4,"\u728C\u728E\u7290\u7291\u7293",11,"\u72A0",11,"\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA",6,"\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB"],["a1a1","\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008",7,"\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013"],["a2a1","\u2170",9],["a2b1","\u2488",19,"\u2474",19,"\u2460",9],["a2e5","\u3220",9],["a2f1","\u2160",11],["a3a1","\uFF01\uFF02\uFF03\uFFE5\uFF05",88,"\uFFE3"],["a4a1","\u3041",82],["a5a1","\u30A1",85],["a6a1","\u0391",16,"\u03A3",6],["a6c1","\u03B1",16,"\u03C3",6],["a6e0","\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44"],["a6ee","\uFE3B\uFE3C\uFE37\uFE38\uFE31"],["a6f4","\uFE33\uFE34"],["a7a1","\u0410",5,"\u0401\u0416",25],["a7d1","\u0430",5,"\u0451\u0436",25],["a840","\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550",35,"\u2581",6],["a880","\u2588",7,"\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E"],["a8a1","\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251"],["a8bd","\u0144\u0148"],["a8c0","\u0261"],["a8c5","\u3105",36],["a940","\u3021",8,"\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4"],["a959","\u2121\u3231"],["a95c","\u2010"],["a960","\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49",9,"\uFE54\uFE55\uFE56\uFE57\uFE59",8],["a980","\uFE62",4,"\uFE68\uFE69\uFE6A\uFE6B"],["a996","\u3007"],["a9a4","\u2500",75],["aa40","\u72DC\u72DD\u72DF\u72E2",5,"\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304",5,"\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340",8],["aa80","\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358",7,"\u7361",10,"\u736E\u7370\u7371"],["ab40","\u7372",11,"\u737F",4,"\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3",5,"\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3",4],["ab80","\u73CB\u73CC\u73CE\u73D2",6,"\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3",4],["ac40","\u73F8",10,"\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411",8,"\u741C",5,"\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437",4,"\u743D\u743E\u743F\u7440\u7442",11],["ac80","\u744E",6,"\u7456\u7458\u745D\u7460",12,"\u746E\u746F\u7471",4,"\u7478\u7479\u747A"],["ad40","\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491",10,"\u749D\u749F",7,"\u74AA",15,"\u74BB",12],["ad80","\u74C8",9,"\u74D3",8,"\u74DD\u74DF\u74E1\u74E5\u74E7",6,"\u74F0\u74F1\u74F2"],["ae40","\u74F3\u74F5\u74F8",6,"\u7500\u7501\u7502\u7503\u7505",7,"\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520",4,"\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558"],["ae80","\u755D",7,"\u7567\u7568\u7569\u756B",6,"\u7573\u7575\u7576\u7577\u757A",4,"\u7580\u7581\u7582\u7584\u7585\u7587"],["af40","\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6",4,"\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607"],["af80","\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644"],["b040","\u7645",6,"\u764E",5,"\u7655\u7657",4,"\u765D\u765F\u7660\u7661\u7662\u7664",6,"\u766C\u766D\u766E\u7670",7,"\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B"],["b080","\u769C",7,"\u76A5",8,"\u76AF\u76B0\u76B3\u76B5",9,"\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265"],["b140","\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0",4,"\u76E6",7,"\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E",10,"\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B"],["b180","\u772C\u772E\u7730",4,"\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748",7,"\u7752",7,"\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3"],["b240","\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D",11,"\u777A\u777B\u777C\u7781\u7782\u7783\u7786",5,"\u778F\u7790\u7793",11,"\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6",4],["b280","\u77BC\u77BE\u77C0",12,"\u77CE",8,"\u77D8\u77D9\u77DA\u77DD",4,"\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316"],["b340","\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803",5,"\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A"],["b380","\u785B\u785C\u785E",11,"\u786F",7,"\u7878\u7879\u787A\u787B\u787D",6,"\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A"],["b440","\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8",7,"\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA",9],["b480","\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED",4,"\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB",5,"\u7902\u7903\u7904\u7906",6,"\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E"],["b540","\u790D",5,"\u7914",9,"\u791F",4,"\u7925",14,"\u7935",4,"\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A",8,"\u7954\u7955\u7958\u7959\u7961\u7963"],["b580","\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970",6,"\u7979\u797B",4,"\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0"],["b640","\u7993",6,"\u799B",11,"\u79A8",10,"\u79B4",4,"\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9",5,"\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA"],["b680","\u79EC\u79EE\u79F1",6,"\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F",4,"\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C"],["b740","\u7A1D\u7A1F\u7A21\u7A22\u7A24",14,"\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40",5,"\u7A47",9,"\u7A52",4,"\u7A58",16],["b780","\u7A69",6,"\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D"],["b840","\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE",4,"\u7AB4",10,"\u7AC0",10,"\u7ACC",9,"\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7",5,"\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3"],["b880","\u7AF4",4,"\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9"],["b940","\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F",5,"\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63",10,"\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86",6,"\u7B8E\u7B8F"],["b980","\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9",7,"\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8"],["ba40","\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4",4,"\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2",4,"\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF",7,"\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10",5,"\u7C17\u7C18\u7C19"],["ba80","\u7C1A",4,"\u7C20",5,"\u7C28\u7C29\u7C2B",12,"\u7C39",5,"\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56"],["bb40","\u7C43",9,"\u7C4E",36,"\u7C75",5,"\u7C7E",9],["bb80","\u7C88\u7C8A",6,"\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4",4,"\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95"],["bc40","\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE",6,"\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1",6,"\u7CE9",5,"\u7CF0",7,"\u7CF9\u7CFA\u7CFC",13,"\u7D0B",5],["bc80","\u7D11",14,"\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30",6,"\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6"],["bd40","\u7D37",54,"\u7D6F",7],["bd80","\u7D78",32,"\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78"],["be40","\u7D99",12,"\u7DA7",6,"\u7DAF",42],["be80","\u7DDA",32,"\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB"],["bf40","\u7DFB",62],["bf80","\u7E3A\u7E3C",4,"\u7E42",4,"\u7E48",21,"\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080"],["c040","\u7E5E",35,"\u7E83",23,"\u7E9C\u7E9D\u7E9E"],["c080","\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B",6,"\u7F43\u7F46",9,"\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0"],["c140","\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63",4,"\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82",7,"\u7F8B\u7F8D\u7F8F",4,"\u7F95",4,"\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8",6,"\u7FB1"],["c180","\u7FB3",4,"\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF",4,"\u7FD6\u7FD7\u7FD9",5,"\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF"],["c240","\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4",6,"\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B",5,"\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057"],["c280","\u8059\u805B",13,"\u806B",5,"\u8072",11,"\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B"],["c340","\u807E\u8081\u8082\u8085\u8088\u808A\u808D",5,"\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7",4,"\u80CF",6,"\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B"],["c380","\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F",12,"\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139",4,"\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478"],["c440","\u8140",5,"\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B",4,"\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183",4,"\u8189\u818B\u818C\u818D\u818E\u8190\u8192",5,"\u8199\u819A\u819E",4,"\u81A4\u81A5"],["c480","\u81A7\u81A9\u81AB",7,"\u81B4",5,"\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD",6,"\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81"],["c540","\u81D4",14,"\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE",4,"\u81F5",5,"\u81FD\u81FF\u8203\u8207",4,"\u820E\u820F\u8211\u8213\u8215",5,"\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F"],["c580","\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250",7,"\u8259\u825B\u825C\u825D\u825E\u8260",7,"\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7"],["c640","\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8"],["c680","\u82FA\u82FC",4,"\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D",9,"\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390"],["c740","\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A",4,"\u8353\u8355",4,"\u835D\u8362\u8370",6,"\u8379\u837A\u837E",6,"\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1",6,"\u83AC\u83AD\u83AE"],["c780","\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20"],["c840","\u83EE\u83EF\u83F3",4,"\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412",5,"\u8419\u841A\u841B\u841E",5,"\u8429",7,"\u8432",5,"\u8439\u843A\u843B\u843E",7,"\u8447\u8448\u8449"],["c880","\u844A",6,"\u8452",4,"\u8458\u845D\u845E\u845F\u8460\u8462\u8464",4,"\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1"],["c940","\u847D",4,"\u8483\u8484\u8485\u8486\u848A\u848D\u848F",7,"\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2",12,"\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7"],["c980","\u84D8",4,"\u84DE\u84E1\u84E2\u84E4\u84E7",4,"\u84ED\u84EE\u84EF\u84F1",10,"\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3"],["ca40","\u8503",8,"\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522",8,"\u852D",9,"\u853E",4,"\u8544\u8545\u8546\u8547\u854B",10],["ca80","\u8557\u8558\u855A\u855B\u855C\u855D\u855F",4,"\u8565\u8566\u8567\u8569",8,"\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31"],["cb40","\u8582\u8583\u8586\u8588",6,"\u8590",10,"\u859D",6,"\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1",5,"\u85B8\u85BA",6,"\u85C2",6,"\u85CA",4,"\u85D1\u85D2"],["cb80","\u85D4\u85D6",5,"\u85DD",6,"\u85E5\u85E6\u85E7\u85E8\u85EA",14,"\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854"],["cc40","\u85F9\u85FA\u85FC\u85FD\u85FE\u8600",4,"\u8606",10,"\u8612\u8613\u8614\u8615\u8617",15,"\u8628\u862A",13,"\u8639\u863A\u863B\u863D\u863E\u863F\u8640"],["cc80","\u8641",11,"\u8652\u8653\u8655",4,"\u865B\u865C\u865D\u865F\u8660\u8661\u8663",7,"\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3"],["cd40","\u866D\u866F\u8670\u8672",6,"\u8683",6,"\u868E",4,"\u8694\u8696",5,"\u869E",4,"\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB",4,"\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC"],["cd80","\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01"],["ce40","\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740",6,"\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A",5,"\u8761\u8762\u8766",7,"\u876F\u8771\u8772\u8773\u8775"],["ce80","\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E",4,"\u8794\u8795\u8796\u8798",6,"\u87A0",4,"\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A"],["cf40","\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1",4,"\u87C7\u87C8\u87C9\u87CC",4,"\u87D4",6,"\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF",9],["cf80","\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804",5,"\u880B",7,"\u8814\u8817\u8818\u8819\u881A\u881C",4,"\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653"],["d040","\u8824",13,"\u8833",5,"\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846",5,"\u884E",5,"\u8855\u8856\u8858\u885A",6,"\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A"],["d080","\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897",4,"\u889D",4,"\u88A3\u88A5",5,"\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384"],["d140","\u88AC\u88AE\u88AF\u88B0\u88B2",4,"\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA",4,"\u88E0\u88E1\u88E6\u88E7\u88E9",6,"\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903",5],["d180","\u8909\u890B",4,"\u8911\u8914",4,"\u891C",4,"\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476"],["d240","\u8938",8,"\u8942\u8943\u8945",24,"\u8960",5,"\u8967",19,"\u897C"],["d280","\u897D\u897E\u8980\u8982\u8984\u8985\u8987",26,"\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690"],["d340","\u89A2",30,"\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4",6],["d380","\u89FB",4,"\u8A01",5,"\u8A08",21,"\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89"],["d440","\u8A1E",31,"\u8A3F",8,"\u8A49",21],["d480","\u8A5F",25,"\u8A7A",6,"\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67"],["d540","\u8A81",7,"\u8A8B",7,"\u8A94",46],["d580","\u8AC3",32,"\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F"],["d640","\u8AE4",34,"\u8B08",27],["d680","\u8B24\u8B25\u8B27",30,"\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51"],["d740","\u8B46",31,"\u8B67",4,"\u8B6D",25],["d780","\u8B87",24,"\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7"],["d840","\u8C38",8,"\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D",7,"\u8C56\u8C57\u8C58\u8C59\u8C5B",5,"\u8C63",6,"\u8C6C",6,"\u8C74\u8C75\u8C76\u8C77\u8C7B",6,"\u8C83\u8C84\u8C86\u8C87"],["d880","\u8C88\u8C8B\u8C8D",6,"\u8C95\u8C96\u8C97\u8C99",20,"\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D"],["d940","\u8CAE",62],["d980","\u8CED",32,"\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC"],["da40","\u8D0E",14,"\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78",8,"\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C",4,"\u8D92\u8D93\u8D95",9,"\u8DA0\u8DA1"],["da80","\u8DA2\u8DA4",12,"\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA"],["db40","\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE",6,"\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15",7,"\u8E20\u8E21\u8E24",4,"\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E"],["db80","\u8E3F\u8E43\u8E45\u8E46\u8E4C",4,"\u8E53",5,"\u8E5A",11,"\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD"],["dc40","\u8E73\u8E75\u8E77",4,"\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88",6,"\u8E91\u8E92\u8E93\u8E95",6,"\u8E9D\u8E9F",11,"\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3",6,"\u8EBB",7],["dc80","\u8EC3",10,"\u8ECF",21,"\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365"],["dd40","\u8EE5",62],["dd80","\u8F24",32,"\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A"],["de40","\u8F45",32,"\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6"],["de80","\u8FC9",4,"\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496"],["df40","\u9019\u901C\u9023\u9024\u9025\u9027",5,"\u9030",4,"\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048",4,"\u904E\u9054\u9055\u9056\u9059\u905A\u905C",5,"\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F",4,"\u9076",6,"\u907E\u9081"],["df80","\u9084\u9085\u9086\u9087\u9089\u908A\u908C",4,"\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C"],["e040","\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105",19,"\u911A\u911B\u911C"],["e080","\u911D\u911F\u9120\u9121\u9124",10,"\u9130\u9132",6,"\u913A",8,"\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C"],["e140","\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180",4,"\u9186\u9188\u918A\u918E\u918F\u9193",6,"\u919C",5,"\u91A4",5,"\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB"],["e180","\u91BC",10,"\u91C8\u91CB\u91D0\u91D2",9,"\u91DD",8,"\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA"],["e240","\u91E6",62],["e280","\u9225",32,"\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967",5,"\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042"],["e340","\u9246",45,"\u9275",16],["e380","\u9286",7,"\u928F",24,"\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE"],["e440","\u92A8",5,"\u92AF",24,"\u92C9",31],["e480","\u92E9",32,"\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1"],["e540","\u930A",51,"\u933F",10],["e580","\u934A",31,"\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3"],["e640","\u936C",34,"\u9390",27],["e680","\u93AC",29,"\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9"],["e740","\u93CE",7,"\u93D7",54],["e780","\u940E",32,"\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21",6,"\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F",4,"\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C"],["e840","\u942F",14,"\u943F",43,"\u946C\u946D\u946E\u946F"],["e880","\u9470",20,"\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9"],["e940","\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577",7,"\u9580",42],["e980","\u95AB",32,"\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B"],["ea40","\u95CC",27,"\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623",6,"\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657"],["ea80","\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D",4,"\u9673\u9678",12,"\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0"],["eb40","\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D",9,"\u96A8",7,"\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6",9,"\u96E1",6,"\u96EB"],["eb80","\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717",4,"\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB"],["ec40","\u9721",8,"\u972B\u972C\u972E\u972F\u9731\u9733",4,"\u973A\u973B\u973C\u973D\u973F",18,"\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A",7],["ec80","\u9772\u9775\u9777",4,"\u977D",7,"\u9786",4,"\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799",4,"\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0"],["ed40","\u979E\u979F\u97A1\u97A2\u97A4",6,"\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5",46],["ed80","\u97E4\u97E5\u97E8\u97EE",4,"\u97F4\u97F7",23,"\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768"],["ee40","\u980F",62],["ee80","\u984E",32,"\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6",4,"\u94BC\u94BD\u94BF\u94C4\u94C8",6,"\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA"],["ef40","\u986F",5,"\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8",37,"\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0",4],["ef80","\u98E5\u98E6\u98E9",30,"\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512",4,"\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564",8,"\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14"],["f040","\u9908",4,"\u990E\u990F\u9911",28,"\u992F",26],["f080","\u994A",9,"\u9956",12,"\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28",4,"\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66",6,"\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619"],["f140","\u998C\u998E\u999A",10,"\u99A6\u99A7\u99A9",47],["f180","\u99D9",32,"\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883"],["f240","\u99FA",62],["f280","\u9A39",32,"\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2"],["f340","\u9A5A",17,"\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9",6,"\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6",4,"\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC"],["f380","\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0",8,"\u9AFA\u9AFC",6,"\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B"],["f440","\u9B07\u9B09",5,"\u9B10\u9B11\u9B12\u9B14",10,"\u9B20\u9B21\u9B22\u9B24",10,"\u9B30\u9B31\u9B33",7,"\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55",5],["f480","\u9B5B",32,"\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164"],["f540","\u9B7C",62],["f580","\u9BBB",32,"\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC"],["f640","\u9BDC",62],["f680","\u9C1B",32,"\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85",5,"\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E",5,"\u9CA5",4,"\u9CAB\u9CAD\u9CAE\u9CB0",7,"\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB"],["f740","\u9C3C",62],["f780","\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE",4,"\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC",4,"\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44"],["f840","\u9CE3",62],["f880","\u9D22",32],["f940","\u9D43",62],["f980","\u9D82",32],["fa40","\u9DA3",62],["fa80","\u9DE2",32],["fb40","\u9E03",27,"\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74",9,"\u9E80"],["fb80","\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C",5,"\u9E94",8,"\u9E9E\u9EA0",5,"\u9EA7\u9EA8\u9EA9\u9EAA"],["fc40","\u9EAB",8,"\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF",4,"\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0",8,"\u9EFA\u9EFD\u9EFF",6],["fc80","\u9F06",4,"\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A",5,"\u9F21\u9F23",8,"\u9F2D\u9F2E\u9F30\u9F31"],["fd40","\u9F32",4,"\u9F38\u9F3A\u9F3C\u9F3F",4,"\u9F45",10,"\u9F52",38],["fd80","\u9F79",5,"\u9F81\u9F82\u9F8D",11,"\u9F9C\u9F9D\u9F9E\u9FA1",4,"\uF92C\uF979\uF995\uF9E7\uF9F1"],["fe40","\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29"]]');

});

parcelRegister("1yO5j", function(module, exports) {
module.exports = JSON.parse('[["a140","\uE4C6",62],["a180","\uE505",32],["a240","\uE526",62],["a280","\uE565",32],["a2ab","\uE766",5],["a2e3","\u20AC\uE76D"],["a2ef","\uE76E\uE76F"],["a2fd","\uE770\uE771"],["a340","\uE586",62],["a380","\uE5C5",31,"\u3000"],["a440","\uE5E6",62],["a480","\uE625",32],["a4f4","\uE772",10],["a540","\uE646",62],["a580","\uE685",32],["a5f7","\uE77D",7],["a640","\uE6A6",62],["a680","\uE6E5",32],["a6b9","\uE785",7],["a6d9","\uE78D",6],["a6ec","\uE794\uE795"],["a6f3","\uE796"],["a6f6","\uE797",8],["a740","\uE706",62],["a780","\uE745",32],["a7c2","\uE7A0",14],["a7f2","\uE7AF",12],["a896","\uE7BC",10],["a8bc","\uE7C7"],["a8bf","\u01F9"],["a8c1","\uE7C9\uE7CA\uE7CB\uE7CC"],["a8ea","\uE7CD",20],["a958","\uE7E2"],["a95b","\uE7E3"],["a95d","\uE7E4\uE7E5\uE7E6"],["a989","\u303E\u2FF0",11],["a997","\uE7F4",12],["a9f0","\uE801",14],["aaa1","\uE000",93],["aba1","\uE05E",93],["aca1","\uE0BC",93],["ada1","\uE11A",93],["aea1","\uE178",93],["afa1","\uE1D6",93],["d7fa","\uE810",4],["f8a1","\uE234",93],["f9a1","\uE292",93],["faa1","\uE2F0",93],["fba1","\uE34E",93],["fca1","\uE3AC",93],["fda1","\uE40A",93],["fe50","\u2E81\uE816\uE817\uE818\u2E84\u3473\u3447\u2E88\u2E8B\uE81E\u359E\u361A\u360E\u2E8C\u2E97\u396E\u3918\uE826\u39CF\u39DF\u3A73\u39D0\uE82B\uE82C\u3B4E\u3C6E\u3CE0\u2EA7\uE831\uE832\u2EAA\u4056\u415F\u2EAE\u4337\u2EB3\u2EB6\u2EB7\uE83B\u43B1\u43AC\u2EBB\u43DD\u44D6\u4661\u464C\uE843"],["fe80","\u4723\u4729\u477C\u478D\u2ECA\u4947\u497A\u497D\u4982\u4983\u4985\u4986\u499F\u499B\u49B7\u49B6\uE854\uE855\u4CA3\u4C9F\u4CA0\u4CA1\u4C77\u4CA2\u4D13",6,"\u4DAE\uE864\uE468",93]]');

});

parcelRegister("kvi1G", function(module, exports) {
module.exports = JSON.parse("{\"uChars\":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],\"gbChars\":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}");

});

parcelRegister("8NjHr", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["8141","\uAC02\uAC03\uAC05\uAC06\uAC0B",4,"\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25",6,"\uAC2E\uAC32\uAC33\uAC34"],["8161","\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41",9,"\uAC4C\uAC4E",5,"\uAC55"],["8181","\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D",18,"\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B",4,"\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95",6,"\uAC9E\uACA2",5,"\uACAB\uACAD\uACAE\uACB1",6,"\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD",7,"\uACD6\uACD8",7,"\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7",4,"\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07",4,"\uAD0E\uAD10\uAD12\uAD13"],["8241","\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21",7,"\uAD2A\uAD2B\uAD2E",5],["8261","\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D",6,"\uAD46\uAD48\uAD4A",5,"\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57"],["8281","\uAD59",7,"\uAD62\uAD64",7,"\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83",4,"\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91",10,"\uAD9E",5,"\uADA5",17,"\uADB8",7,"\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9",6,"\uADD2\uADD4",7,"\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5",18],["8341","\uADFA\uADFB\uADFD\uADFE\uAE02",5,"\uAE0A\uAE0C\uAE0E",5,"\uAE15",7],["8361","\uAE1D",18,"\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C"],["8381","\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57",4,"\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71",6,"\uAE7A\uAE7E",5,"\uAE86",5,"\uAE8D",46,"\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5",6,"\uAECE\uAED2",5,"\uAEDA\uAEDB\uAEDD",8],["8441","\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE",5,"\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD",8],["8461","\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11",18],["8481","\uAF24",7,"\uAF2E\uAF2F\uAF31\uAF33\uAF35",6,"\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A",5,"\uAF51",10,"\uAF5E",5,"\uAF66",18,"\uAF7A",5,"\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89",6,"\uAF92\uAF93\uAF94\uAF96",5,"\uAF9D",26,"\uAFBA\uAFBB\uAFBD\uAFBE"],["8541","\uAFBF\uAFC1",5,"\uAFCA\uAFCC\uAFCF",4,"\uAFD5",6,"\uAFDD",4],["8561","\uAFE2",5,"\uAFEA",5,"\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9",6,"\uB002\uB003"],["8581","\uB005",6,"\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015",6,"\uB01E",9,"\uB029",26,"\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E",29,"\uB07E\uB07F\uB081\uB082\uB083\uB085",6,"\uB08E\uB090\uB092",5,"\uB09B\uB09D\uB09E\uB0A3\uB0A4"],["8641","\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD",6,"\uB0C6\uB0CA",5,"\uB0D2"],["8661","\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9",6,"\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6",10],["8681","\uB0F1",22,"\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E",4,"\uB126\uB127\uB129\uB12A\uB12B\uB12D",6,"\uB136\uB13A",5,"\uB142\uB143\uB145\uB146\uB147\uB149",6,"\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161",22,"\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183",4,"\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D"],["8741","\uB19E",9,"\uB1A9",15],["8761","\uB1B9",18,"\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5"],["8781","\uB1D6",5,"\uB1DE\uB1E0",7,"\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1",7,"\uB1FA\uB1FC\uB1FE",5,"\uB206\uB207\uB209\uB20A\uB20D",6,"\uB216\uB218\uB21A",5,"\uB221",18,"\uB235",6,"\uB23D",26,"\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261",6,"\uB26A",4],["8841","\uB26F",4,"\uB276",5,"\uB27D",6,"\uB286\uB287\uB288\uB28A",4],["8861","\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B",4,"\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7"],["8881","\uB2B8",15,"\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3",4,"\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309",6,"\uB312\uB316",5,"\uB31D",54,"\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363"],["8941","\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379",6,"\uB382\uB386",5,"\uB38D"],["8961","\uB38E\uB38F\uB391\uB392\uB393\uB395",10,"\uB3A2",5,"\uB3A9\uB3AA\uB3AB\uB3AD"],["8981","\uB3AE",21,"\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9",18,"\uB3FD",18,"\uB411",6,"\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421",6,"\uB42A\uB42C",7,"\uB435",15],["8a41","\uB445",10,"\uB452\uB453\uB455\uB456\uB457\uB459",6,"\uB462\uB464\uB466"],["8a61","\uB467",4,"\uB46D",18,"\uB481\uB482"],["8a81","\uB483",4,"\uB489",19,"\uB49E",5,"\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD",7,"\uB4B6\uB4B8\uB4BA",5,"\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9",6,"\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6",5,"\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7",4,"\uB4EE\uB4F0\uB4F2",5,"\uB4F9",26,"\uB516\uB517\uB519\uB51A\uB51D"],["8b41","\uB51E",5,"\uB526\uB52B",4,"\uB532\uB533\uB535\uB536\uB537\uB539",6,"\uB542\uB546"],["8b61","\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555",6,"\uB55E\uB562",8],["8b81","\uB56B",52,"\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6",4,"\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5",6,"\uB5CE\uB5D2",5,"\uB5D9",18,"\uB5ED",18],["8c41","\uB600",15,"\uB612\uB613\uB615\uB616\uB617\uB619",4],["8c61","\uB61E",6,"\uB626",5,"\uB62D",6,"\uB635",5],["8c81","\uB63B",12,"\uB649",26,"\uB665\uB666\uB667\uB669",50,"\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5",5,"\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2",16],["8d41","\uB6C3",16,"\uB6D5",8],["8d61","\uB6DE",17,"\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA"],["8d81","\uB6FB",4,"\uB702\uB703\uB704\uB706",33,"\uB72A\uB72B\uB72D\uB72E\uB731",6,"\uB73A\uB73C",7,"\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D",6,"\uB756",9,"\uB761\uB762\uB763\uB765\uB766\uB767\uB769",6,"\uB772\uB774\uB776",5,"\uB77E\uB77F\uB781\uB782\uB783\uB785",6,"\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E"],["8e41","\uB79F\uB7A1",6,"\uB7AA\uB7AE",5,"\uB7B6\uB7B7\uB7B9",8],["8e61","\uB7C2",4,"\uB7C8\uB7CA",19],["8e81","\uB7DE",13,"\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5",6,"\uB7FE\uB802",4,"\uB80A\uB80B\uB80D\uB80E\uB80F\uB811",6,"\uB81A\uB81C\uB81E",5,"\uB826\uB827\uB829\uB82A\uB82B\uB82D",6,"\uB836\uB83A",5,"\uB841\uB842\uB843\uB845",11,"\uB852\uB854",7,"\uB85E\uB85F\uB861\uB862\uB863\uB865",6,"\uB86E\uB870\uB872",5,"\uB879\uB87A\uB87B\uB87D",7],["8f41","\uB885",7,"\uB88E",17],["8f61","\uB8A0",7,"\uB8A9",6,"\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9",4],["8f81","\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6",5,"\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5",7,"\uB8DE\uB8E0\uB8E2",5,"\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1",6,"\uB8FA\uB8FC\uB8FE",5,"\uB905",18,"\uB919",6,"\uB921",26,"\uB93E\uB93F\uB941\uB942\uB943\uB945",6,"\uB94D\uB94E\uB950\uB952",5],["9041","\uB95A\uB95B\uB95D\uB95E\uB95F\uB961",6,"\uB96A\uB96C\uB96E",5,"\uB976\uB977\uB979\uB97A\uB97B\uB97D"],["9061","\uB97E",5,"\uB986\uB988\uB98B\uB98C\uB98F",15],["9081","\uB99F",12,"\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5",6,"\uB9BE\uB9C0\uB9C2",5,"\uB9CA\uB9CB\uB9CD\uB9D3",4,"\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED",6,"\uB9F6\uB9FB",4,"\uBA02",5,"\uBA09",11,"\uBA16",33,"\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46"],["9141","\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D",6,"\uBA66\uBA6A",5],["9161","\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79",9,"\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D",5],["9181","\uBA93",20,"\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3",4,"\uBABA\uBABC\uBABE",5,"\uBAC5\uBAC6\uBAC7\uBAC9",14,"\uBADA",33,"\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05",7,"\uBB0E\uBB10\uBB12",5,"\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21",6],["9241","\uBB28\uBB2A\uBB2C",7,"\uBB37\uBB39\uBB3A\uBB3F",4,"\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52"],["9261","\uBB53\uBB55\uBB56\uBB57\uBB59",7,"\uBB62\uBB64",7,"\uBB6D",4],["9281","\uBB72",21,"\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91",18,"\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD",6,"\uBBB5\uBBB6\uBBB8",7,"\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9",6,"\uBBD1\uBBD2\uBBD4",35,"\uBBFA\uBBFB\uBBFD\uBBFE\uBC01"],["9341","\uBC03",4,"\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35"],["9361","\uBC36\uBC37\uBC39",6,"\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51",8],["9381","\uBC5A\uBC5B\uBC5C\uBC5E",37,"\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F",4,"\uBC96\uBC98\uBC9B",4,"\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9",6,"\uBCB2\uBCB6",5,"\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5",7,"\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD",22,"\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD"],["9441","\uBCFE",5,"\uBD06\uBD08\uBD0A",5,"\uBD11\uBD12\uBD13\uBD15",8],["9461","\uBD1E",5,"\uBD25",6,"\uBD2D",12],["9481","\uBD3A",5,"\uBD41",6,"\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51",6,"\uBD5A",9,"\uBD65\uBD66\uBD67\uBD69",22,"\uBD82\uBD83\uBD85\uBD86\uBD8B",4,"\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D",6,"\uBDA5",10,"\uBDB1",6,"\uBDB9",24],["9541","\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD",11,"\uBDEA",5,"\uBDF1"],["9561","\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9",6,"\uBE01\uBE02\uBE04\uBE06",5,"\uBE0E\uBE0F\uBE11\uBE12\uBE13"],["9581","\uBE15",6,"\uBE1E\uBE20",35,"\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F",4,"\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B",4,"\uBE72\uBE76",4,"\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85",6,"\uBE8E\uBE92",5,"\uBE9A",13,"\uBEA9",14],["9641","\uBEB8",23,"\uBED2\uBED3"],["9661","\uBED5\uBED6\uBED9",6,"\uBEE1\uBEE2\uBEE6",5,"\uBEED",8],["9681","\uBEF6",10,"\uBF02",5,"\uBF0A",13,"\uBF1A\uBF1E",33,"\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49",6,"\uBF52\uBF53\uBF54\uBF56",44],["9741","\uBF83",16,"\uBF95",8],["9761","\uBF9E",17,"\uBFB1",7],["9781","\uBFB9",11,"\uBFC6",5,"\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5",6,"\uBFDD\uBFDE\uBFE0\uBFE2",89,"\uC03D\uC03E\uC03F"],["9841","\uC040",16,"\uC052",5,"\uC059\uC05A\uC05B"],["9861","\uC05D\uC05E\uC05F\uC061",6,"\uC06A",15],["9881","\uC07A",21,"\uC092\uC093\uC095\uC096\uC097\uC099",6,"\uC0A2\uC0A4\uC0A6",5,"\uC0AE\uC0B1\uC0B2\uC0B7",4,"\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1",6,"\uC0DA\uC0DE",5,"\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED",6,"\uC0F6\uC0F8\uC0FA",5,"\uC101\uC102\uC103\uC105\uC106\uC107\uC109",6,"\uC111\uC112\uC113\uC114\uC116",5,"\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E"],["9941","\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141",6,"\uC14A\uC14E",5,"\uC156\uC157"],["9961","\uC159\uC15A\uC15B\uC15D",6,"\uC166\uC16A",5,"\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B"],["9981","\uC17C",8,"\uC186",5,"\uC18F\uC191\uC192\uC193\uC195\uC197",4,"\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1",11,"\uC1BE",5,"\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD",6,"\uC1D5\uC1D6\uC1D9",6,"\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9",6,"\uC1F2\uC1F4",7,"\uC1FE\uC1FF\uC201\uC202\uC203\uC205",6,"\uC20E\uC210\uC212",5,"\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223"],["9a41","\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235",16],["9a61","\uC246\uC247\uC249",6,"\uC252\uC253\uC255\uC256\uC257\uC259",6,"\uC261\uC262\uC263\uC264\uC266"],["9a81","\uC267",4,"\uC26E\uC26F\uC271\uC272\uC273\uC275",6,"\uC27E\uC280\uC282",5,"\uC28A",5,"\uC291",6,"\uC299\uC29A\uC29C\uC29E",5,"\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE",5,"\uC2B6\uC2B8\uC2BA",33,"\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5",5,"\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301",6,"\uC30A\uC30B\uC30E\uC30F"],["9b41","\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D",6,"\uC326\uC327\uC32A",8],["9b61","\uC333",17,"\uC346",7],["9b81","\uC34E",25,"\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373",4,"\uC37A\uC37B\uC37E",5,"\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D",50,"\uC3C1",22,"\uC3DA"],["9c41","\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3",4,"\uC3EA\uC3EB\uC3EC\uC3EE",5,"\uC3F6\uC3F7\uC3F9",5],["9c61","\uC3FF",8,"\uC409",6,"\uC411",9],["9c81","\uC41B",8,"\uC425",6,"\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435",6,"\uC43E",9,"\uC449",26,"\uC466\uC467\uC469\uC46A\uC46B\uC46D",6,"\uC476\uC477\uC478\uC47A",5,"\uC481",18,"\uC495",6,"\uC49D",12],["9d41","\uC4AA",13,"\uC4B9\uC4BA\uC4BB\uC4BD",8],["9d61","\uC4C6",25],["9d81","\uC4E0",8,"\uC4EA",5,"\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502",9,"\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515",6,"\uC51D",10,"\uC52A\uC52B\uC52D\uC52E\uC52F\uC531",6,"\uC53A\uC53C\uC53E",5,"\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569",6,"\uC572\uC576",5,"\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594"],["9e41","\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1",7,"\uC5AA",9,"\uC5B6"],["9e61","\uC5B7\uC5BA\uC5BF",4,"\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9",6,"\uC5E2\uC5E4\uC5E6\uC5E7"],["9e81","\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611",6,"\uC61A\uC61D",6,"\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649",6,"\uC652\uC656",5,"\uC65E\uC65F\uC661",10,"\uC66D\uC66E\uC670\uC672",5,"\uC67A\uC67B\uC67D\uC67E\uC67F\uC681",6,"\uC68A\uC68C\uC68E",5,"\uC696\uC697\uC699\uC69A\uC69B\uC69D",6,"\uC6A6"],["9f41","\uC6A8\uC6AA",5,"\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB",4,"\uC6C2\uC6C4\uC6C6",5,"\uC6CE"],["9f61","\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5",6,"\uC6DE\uC6DF\uC6E2",5,"\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2"],["9f81","\uC6F3",4,"\uC6FA\uC6FB\uC6FC\uC6FE",5,"\uC706\uC707\uC709\uC70A\uC70B\uC70D",6,"\uC716\uC718\uC71A",5,"\uC722\uC723\uC725\uC726\uC727\uC729",6,"\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745",4,"\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761",6,"\uC769\uC76A\uC76C",7,"\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B",4,"\uC7A2\uC7A7",4,"\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7"],["a041","\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2",5,"\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1",6,"\uC7D9\uC7DA\uC7DB\uC7DC"],["a061","\uC7DE",5,"\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED",13],["a081","\uC7FB",4,"\uC802\uC803\uC805\uC806\uC807\uC809\uC80B",4,"\uC812\uC814\uC817",4,"\uC81E\uC81F\uC821\uC822\uC823\uC825",6,"\uC82E\uC830\uC832",5,"\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841",6,"\uC84A\uC84B\uC84E",5,"\uC855",26,"\uC872\uC873\uC875\uC876\uC877\uC879\uC87B",4,"\uC882\uC884\uC888\uC889\uC88A\uC88E",5,"\uC895",7,"\uC89E\uC8A0\uC8A2\uC8A3\uC8A4"],["a141","\uC8A5\uC8A6\uC8A7\uC8A9",18,"\uC8BE\uC8BF\uC8C0\uC8C1"],["a161","\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD",6,"\uC8D6\uC8D8\uC8DA",5,"\uC8E2\uC8E3\uC8E5"],["a181","\uC8E6",14,"\uC8F6",5,"\uC8FE\uC8FF\uC901\uC902\uC903\uC907",4,"\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008",9,"\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2"],["a241","\uC910\uC912",5,"\uC919",18],["a261","\uC92D",6,"\uC935",18],["a281","\uC948",7,"\uC952\uC953\uC955\uC956\uC957\uC959",6,"\uC962\uC964",7,"\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae"],["a341","\uC971\uC972\uC973\uC975",6,"\uC97D",10,"\uC98A\uC98B\uC98D\uC98E\uC98F"],["a361","\uC991",6,"\uC99A\uC99C\uC99E",16],["a381","\uC9AF",16,"\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB",4,"\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01",58,"\uFFE6\uFF3D",32,"\uFFE3"],["a441","\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2",5,"\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04"],["a461","\uCA05\uCA06\uCA07\uCA0A\uCA0E",5,"\uCA15\uCA16\uCA17\uCA19",12],["a481","\uCA26\uCA27\uCA28\uCA2A",28,"\u3131",93],["a541","\uCA47",4,"\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55",6,"\uCA5E\uCA62",5,"\uCA69\uCA6A"],["a561","\uCA6B",17,"\uCA7E",5,"\uCA85\uCA86"],["a581","\uCA87",16,"\uCA99",14,"\u2170",9],["a5b0","\u2160",9],["a5c1","\u0391",16,"\u03A3",6],["a5e1","\u03B1",16,"\u03C3",6],["a641","\uCAA8",19,"\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5"],["a661","\uCAC6",5,"\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA",5,"\uCAE1",6],["a681","\uCAE8\uCAE9\uCAEA\uCAEB\uCAED",6,"\uCAF5",18,"\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543",7],["a741","\uCB0B",4,"\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19",6,"\uCB22",7],["a761","\uCB2A",22,"\uCB42\uCB43\uCB44"],["a781","\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51",6,"\uCB5A\uCB5B\uCB5C\uCB5E",5,"\uCB65",7,"\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399",9,"\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0",9,"\u3380",4,"\u33BA",5,"\u3390",4,"\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6"],["a841","\uCB6D",10,"\uCB7A",14],["a861","\uCB89",18,"\uCB9D",6],["a881","\uCBA4",19,"\uCBB9",11,"\xc6\xd0\xaa\u0126"],["a8a6","\u0132"],["a8a8","\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A"],["a8b1","\u3260",27,"\u24D0",25,"\u2460",14,"\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E"],["a941","\uCBC5",14,"\uCBD5",10],["a961","\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA",18],["a981","\uCBFD",14,"\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15",6,"\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200",27,"\u249C",25,"\u2474",14,"\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084"],["aa41","\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31",6,"\uCC3A\uCC3F",4,"\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E"],["aa61","\uCC4F",4,"\uCC56\uCC5A",5,"\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69",6,"\uCC71\uCC72"],["aa81","\uCC73\uCC74\uCC76",29,"\u3041",82],["ab41","\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1",6,"\uCCAA\uCCAE",5,"\uCCB6\uCCB7\uCCB9"],["ab61","\uCCBA\uCCBB\uCCBD",6,"\uCCC6\uCCC8\uCCCA",5,"\uCCD1\uCCD2\uCCD3\uCCD5",5],["ab81","\uCCDB",8,"\uCCE5",6,"\uCCED\uCCEE\uCCEF\uCCF1",12,"\u30A1",85],["ac41","\uCCFE\uCCFF\uCD00\uCD02",5,"\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11",6,"\uCD1A\uCD1C\uCD1E\uCD1F\uCD20"],["ac61","\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D",11,"\uCD3A",4],["ac81","\uCD3F",28,"\uCD5D\uCD5E\uCD5F\u0410",5,"\u0401\u0416",25],["acd1","\u0430",5,"\u0451\u0436",25],["ad41","\uCD61\uCD62\uCD63\uCD65",6,"\uCD6E\uCD70\uCD72",5,"\uCD79",7],["ad61","\uCD81",6,"\uCD89",10,"\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F"],["ad81","\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA",5,"\uCDB1",18,"\uCDC5"],["ae41","\uCDC6",5,"\uCDCD\uCDCE\uCDCF\uCDD1",16],["ae61","\uCDE2",5,"\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1",6,"\uCDFA\uCDFC\uCDFE",4],["ae81","\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D",6,"\uCE15\uCE16\uCE17\uCE18\uCE1A",5,"\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B"],["af41","\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36",19],["af61","\uCE4A",13,"\uCE5A\uCE5B\uCE5D\uCE5E\uCE62",5,"\uCE6A\uCE6C"],["af81","\uCE6E",5,"\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D",6,"\uCE86\uCE88\uCE8A",5,"\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99"],["b041","\uCE9A",5,"\uCEA2\uCEA6",5,"\uCEAE",12],["b061","\uCEBB",5,"\uCEC2",19],["b081","\uCED6",13,"\uCEE6\uCEE7\uCEE9\uCEEA\uCEED",6,"\uCEF6\uCEFA",5,"\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10",7,"\uAC19",4,"\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06"],["b141","\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09",6,"\uCF12\uCF14\uCF16",5,"\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23"],["b161","\uCF25",6,"\uCF2E\uCF32",5,"\uCF39",11],["b181","\uCF45",14,"\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D",6,"\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78"],["b241","\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79",6,"\uCF81\uCF82\uCF83\uCF84\uCF86",5,"\uCF8D"],["b261","\uCF8E",18,"\uCFA2",5,"\uCFA9"],["b281","\uCFAA",5,"\uCFB1",18,"\uCFC5",6,"\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059"],["b341","\uCFCC",19,"\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9"],["b361","\uCFEA",5,"\uCFF2\uCFF4\uCFF6",5,"\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005",5],["b381","\uD00B",5,"\uD012",5,"\uD019",19,"\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB",4,"\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD"],["b441","\uD02E",5,"\uD036\uD037\uD039\uD03A\uD03B\uD03D",6,"\uD046\uD048\uD04A",5],["b461","\uD051\uD052\uD053\uD055\uD056\uD057\uD059",6,"\uD061",10,"\uD06E\uD06F"],["b481","\uD071\uD072\uD073\uD075",6,"\uD07E\uD07F\uD080\uD082",18,"\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB",4,"\uB2F3\uB2F4\uB2F5\uB2F7",4,"\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365"],["b541","\uD095",14,"\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD",5],["b561","\uD0B3\uD0B6\uD0B8\uD0BA",5,"\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA",5,"\uD0D2\uD0D6",4],["b581","\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5",6,"\uD0EE\uD0F2",5,"\uD0F9",11,"\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538"],["b641","\uD105",7,"\uD10E",17],["b661","\uD120",15,"\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E"],["b681","\uD13F\uD142\uD146",5,"\uD14E\uD14F\uD151\uD152\uD153\uD155",6,"\uD15E\uD160\uD162",5,"\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797"],["b741","\uD16E",13,"\uD17D",6,"\uD185\uD186\uD187\uD189\uD18A"],["b761","\uD18B",20,"\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7"],["b781","\uD1A9",6,"\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1",14,"\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969"],["b841","\uD1D0",7,"\uD1D9",17],["b861","\uD1EB",8,"\uD1F5\uD1F6\uD1F7\uD1F9",13],["b881","\uD208\uD20A",5,"\uD211",24,"\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE",4,"\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC"],["b941","\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235",6,"\uD23E\uD240\uD242",5,"\uD249\uD24A\uD24B\uD24C"],["b961","\uD24D",14,"\uD25D",6,"\uD265\uD266\uD267\uD268"],["b981","\uD269",22,"\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14",4,"\uBC1B",4,"\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97"],["ba41","\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296",5,"\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5",6,"\uD2AD"],["ba61","\uD2AE\uD2AF\uD2B0\uD2B2",5,"\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3",4,"\uD2CA\uD2CC",5],["ba81","\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD",6,"\uD2E6",9,"\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64"],["bb41","\uD2FB",4,"\uD302\uD304\uD306",5,"\uD30F\uD311\uD312\uD313\uD315\uD317",4,"\uD31E\uD322\uD323"],["bb61","\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331",6,"\uD33A\uD33E",5,"\uD346\uD347\uD348\uD349"],["bb81","\uD34A",31,"\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4"],["bc41","\uD36A",17,"\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387"],["bc61","\uD388\uD389\uD38A\uD38B\uD38E\uD392",5,"\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1",6,"\uD3AA\uD3AC\uD3AE"],["bc81","\uD3AF",4,"\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD",6,"\uD3C6\uD3C7\uD3CA",5,"\uD3D1",5,"\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C",4,"\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D"],["bd41","\uD3D7\uD3D9",7,"\uD3E2\uD3E4",7,"\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7"],["bd61","\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402",5,"\uD409",13],["bd81","\uD417",5,"\uD41E",25,"\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430"],["be41","\uD438",7,"\uD441\uD442\uD443\uD445",14],["be61","\uD454",7,"\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465",7,"\uD46E\uD470\uD471\uD472"],["be81","\uD473",4,"\uD47A\uD47B\uD47D\uD47E\uD481\uD483",4,"\uD48A\uD48C\uD48E",5,"\uD495",8,"\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4",6,"\uC5CC\uC5CE"],["bf41","\uD49E",10,"\uD4AA",14],["bf61","\uD4B9",18,"\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5"],["bf81","\uD4D6",5,"\uD4DD\uD4DE\uD4E0",7,"\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1",6,"\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC",5,"\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8"],["c041","\uD4FE",5,"\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D",6,"\uD516\uD518",5],["c061","\uD51E",25],["c081","\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545",6,"\uD54E\uD550\uD552",5,"\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751",7,"\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A"],["c141","\uD564\uD566\uD567\uD56A\uD56C\uD56E",5,"\uD576\uD577\uD579\uD57A\uD57B\uD57D",6,"\uD586\uD58A\uD58B"],["c161","\uD58C\uD58D\uD58E\uD58F\uD591",19,"\uD5A6\uD5A7"],["c181","\uD5A8",31,"\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3"],["c241","\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3",4,"\uD5DA\uD5DC\uD5DE",5,"\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE"],["c261","\uD5EF",4,"\uD5F6\uD5F8\uD5FA",5,"\uD602\uD603\uD605\uD606\uD607\uD609",6,"\uD612"],["c281","\uD616",5,"\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625",7,"\uD62E",9,"\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B"],["c341","\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D",4],["c361","\uD662",4,"\uD668\uD66A",5,"\uD672\uD673\uD675",11],["c381","\uD681\uD682\uD684\uD686",5,"\uD68E\uD68F\uD691\uD692\uD693\uD695",7,"\uD69E\uD6A0\uD6A2",5,"\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35"],["c441","\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1",7,"\uD6BA\uD6BC",7,"\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB"],["c461","\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA",5,"\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9",4],["c481","\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6",5,"\uD6FE\uD6FF\uD701\uD702\uD703\uD705",11,"\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C"],["c541","\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721",6,"\uD72A\uD72C\uD72E",5,"\uD736\uD737\uD739"],["c561","\uD73A\uD73B\uD73D",6,"\uD745\uD746\uD748\uD74A",5,"\uD752\uD753\uD755\uD75A",4],["c581","\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775",6,"\uD77E\uD77F\uD780\uD782",5,"\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C"],["c641","\uD78D\uD78E\uD78F\uD791",6,"\uD79A\uD79C\uD79E",5],["c6a1","\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401"],["c7a1","\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620"],["c8a1","\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D"],["caa1","\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95"],["cba1","\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2"],["cca1","\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0"],["cda1","\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC"],["cea1","\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE"],["cfa1","\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4"],["d0a1","\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3"],["d1a1","\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E",5,"\u90A3\uF914",4,"\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925"],["d2a1","\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928",4,"\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933",5,"\u99D1\uF939",10,"\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A",7,"\u5AE9\u8A25\u677B\u7D10\uF952",5,"\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336"],["d3a1","\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843"],["d4a1","\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85"],["d5a1","\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23"],["d6a1","\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC"],["d7a1","\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C"],["d8a1","\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5"],["d9a1","\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587"],["daa1","\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51"],["dba1","\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656"],["dca1","\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66"],["dda1","\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5"],["dea1","\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A"],["dfa1","\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72"],["e0a1","\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C"],["e1a1","\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101"],["e2a1","\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27"],["e3a1","\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81"],["e4a1","\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D"],["e5a1","\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982"],["e6a1","\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2"],["e7a1","\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3"],["e8a1","\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1"],["e9a1","\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553"],["eaa1","\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB"],["eba1","\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC"],["eca1","\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344"],["eda1","\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577"],["eea1","\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1"],["efa1","\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756"],["f0a1","\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B"],["f1a1","\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA"],["f2a1","\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F"],["f3a1","\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56"],["f4a1","\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2"],["f5a1","\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403"],["f6a1","\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17"],["f7a1","\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211"],["f8a1","\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43"],["f9a1","\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A"],["faa1","\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B"],["fba1","\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575"],["fca1","\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6"],["fda1","\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70"]]');

});

parcelRegister("6EjUj", function(module, exports) {
module.exports = JSON.parse('[["0","\\u0000",127],["a140","\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A"],["a1a1","\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62",4,"\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F"],["a240","\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581",7,"\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D"],["a2a1","\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10",9,"\u2160",9,"\u3021",8,"\u5341\u5344\u5345\uFF21",25,"\uFF41",21],["a340","\uFF57\uFF58\uFF59\uFF5A\u0391",16,"\u03A3",6,"\u03B1",16,"\u03C3",6,"\u3105",10],["a3a1","\u3110",25,"\u02D9\u02C9\u02CA\u02C7\u02CB"],["a3e1","\u20AC"],["a440","\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D"],["a4a1","\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19"],["a540","\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916"],["a5a1","\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168"],["a640","\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74"],["a6a1","\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63"],["a740","\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D"],["a7a1","\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760"],["a840","\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292"],["a8a1","\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475"],["a940","\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45"],["a9a1","\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A"],["aa40","\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0"],["aaa1","\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644"],["ab40","\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1"],["aba1","\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7"],["ac40","\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17"],["aca1","\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004"],["ad40","\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5"],["ada1","\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA"],["ae40","\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059"],["aea1","\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93"],["af40","\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837"],["afa1","\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343"],["b040","\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661"],["b0a1","\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40"],["b140","\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD"],["b1a1","\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA"],["b240","\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6"],["b2a1","\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C"],["b340","\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014"],["b3a1","\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960"],["b440","\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD"],["b4a1","\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB"],["b540","\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98"],["b5a1","\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41"],["b640","\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591"],["b6a1","\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC"],["b740","\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D"],["b7a1","\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763"],["b840","\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B"],["b8a1","\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A"],["b940","\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4"],["b9a1","\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147"],["ba40","\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22"],["baa1","\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC"],["bb40","\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4"],["bba1","\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC"],["bc40","\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182"],["bca1","\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483"],["bd40","\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF"],["bda1","\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E"],["be40","\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09"],["bea1","\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1"],["bf40","\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A"],["bfa1","\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A"],["c040","\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687"],["c0a1","\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC"],["c140","\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA"],["c1a1","\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01"],["c240","\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658"],["c2a1","\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6"],["c340","\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378"],["c3a1","\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E"],["c440","\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C"],["c4a1","\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74"],["c540","\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C"],["c5a1","\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92"],["c640","\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72"],["c940","\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15"],["c9a1","\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B"],["ca40","\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418"],["caa1","\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747"],["cb40","\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293"],["cba1","\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762"],["cc40","\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B"],["cca1","\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2"],["cd40","\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA"],["cda1","\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF"],["ce40","\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB"],["cea1","\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA"],["cf40","\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42"],["cfa1","\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80"],["d040","\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA"],["d0a1","\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1"],["d140","\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067"],["d1a1","\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4"],["d240","\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278"],["d2a1","\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10"],["d340","\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322"],["d3a1","\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150"],["d440","\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545"],["d4a1","\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F"],["d540","\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F"],["d5a1","\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9"],["d640","\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF"],["d6a1","\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F"],["d740","\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7"],["d7a1","\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA"],["d840","\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837"],["d8a1","\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114"],["d940","\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2"],["d9a1","\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E"],["da40","\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416"],["daa1","\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65"],["db40","\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3"],["dba1","\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA"],["dc40","\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688"],["dca1","\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6"],["dd40","\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424"],["dda1","\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC"],["de40","\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153"],["dea1","\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13"],["df40","\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F"],["dfa1","\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4"],["e040","\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F"],["e0a1","\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0"],["e140","\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0"],["e1a1","\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9"],["e240","\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A"],["e2a1","\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993"],["e340","\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE"],["e3a1","\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB"],["e440","\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D"],["e4a1","\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658"],["e540","\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189"],["e5a1","\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92"],["e640","\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359"],["e6a1","\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F"],["e740","\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662"],["e7a1","\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27"],["e840","\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3"],["e8a1","\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E"],["e940","\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA"],["e9a1","\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8"],["ea40","\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799"],["eaa1","\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558"],["eb40","\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0"],["eba1","\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C"],["ec40","\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95"],["eca1","\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E"],["ed40","\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6"],["eda1","\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E"],["ee40","\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E"],["eea1","\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C"],["ef40","\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30"],["efa1","\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376"],["f040","\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2"],["f0a1","\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67"],["f140","\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA"],["f1a1","\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70"],["f240","\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B"],["f2a1","\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55"],["f340","\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726"],["f3a1","\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2"],["f440","\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929"],["f4a1","\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF"],["f540","\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B"],["f5a1","\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625"],["f640","\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A"],["f6a1","\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A"],["f740","\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A"],["f7a1","\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE"],["f840","\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F"],["f8a1","\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A"],["f940","\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A"],["f9a1","\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593"]]');

});

parcelRegister("7EqcH", function(module, exports) {
module.exports = JSON.parse('[["8740","\u43F0\u4C32\u4603\u45A6\u4578\uD85C\uDE67\u4D77\u45B3\uD85F\uDCB1\u4CE2\uD85F\uDCC5\u3B95\u4736\u4744\u4C47\u4C40\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2\u4C57\uD868\uDF51\u474F\u45DA\u4C85\uD85F\uDC6C\u4D07\u4AA4\u46A1\uD85A\uDF23\u7225\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61\u664D\u56FB"],["8767","\u7D95\u591D\uD862\uDFB9\u3DF4\u9734\uD85E\uDFEF\u5BDB\uD847\uDD5E\u5AA4\u3625\uD867\uDEB0\u5AD1\u5BB7\u5CFC\u676E\u8593\uD866\uDD45\u7461\u749D\u3875\uD847\uDD53\uD84D\uDE9E\uD858\uDC21\u3EEC"],["87a1","\uD856\uDCDE\u3AF5\u7AFC\u9F97\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E\u430A\u8484\u9F96\u942F\u4930\u8613\u5896\u974A\u9218\u79D0\u7A32\u6660\u6A29\u889D\u744C\u7BC5\u6782\u7A2C\u524F\u9046\u34E6\u73C4\uD857\uDDB9\u74C6\u9FC7\u57B3\u492F\u544C\u4131\uD84D\uDE8E\u5818\u7A72\uD85E\uDF65\u8B8F\u46AE\uD85B\uDE88\u4181\uD857\uDD99\u7BAE\uD849\uDCBC\u9FC8\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC\u9FC9\u8504\uD84D\uDDBB\u40B4\u9FCA\u44E1\uD86B\uDDFF\u62C1\u706E\u9FCB"],["8840","\u31C0",4,"\uD840\uDD0C\u31C5\uD840\uDCD1\uD840\uDCCD\u31C6\u31C7\uD840\uDCCB\uD847\uDFE8\u31C8\uD840\uDCCA\u31C9\u31CA\u31CB\u31CC\uD840\uDD0E\u31CD\u31CE\u0100\xc1\u01CD\xc0\u0112\xc9\u011A\xc8\u014C\xd3\u01D1\xd2\u0FFF\xca\u0304\u1EBE\u0FFF\xca\u030C\u1EC0\xca\u0101\xe1\u01CE\xe0\u0251\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA"],["88a1","\u01DC\xfc\u0FFF\xea\u0304\u1EBF\u0FFF\xea\u030C\u1EC1\xea\u0261\u23DA\u23DB"],["8940","\uD868\uDFA9\uD844\uDD45"],["8943","\u650A"],["8946","\u4E3D\u6EDD\u9D4E\u91DF"],["894c","\uD85D\uDF35\u6491\u4F1A\u4F28\u4FA8\u5156\u5174\u519C\u51E4\u52A1\u52A8\u533B\u534E\u53D1\u53D8\u56E2\u58F0\u5904\u5907\u5932\u5934\u5B66\u5B9E\u5B9F\u5C9A\u5E86\u603B\u6589\u67FE\u6804\u6865\u6D4E\u70BC\u7535\u7EA4\u7EAC\u7EBA\u7EC7\u7ECF\u7EDF\u7F06\u7F37\u827A\u82CF\u836F\u89C6\u8BBE\u8BE2\u8F66\u8F67\u8F6E"],["89a1","\u7411\u7CFC\u7DCD\u6946\u7AC9\u5227"],["89ab","\u918C\u78B8\u915E\u80BC"],["89b0","\u8D0B\u80F6\uD842\uDDE7"],["89b5","\u809F\u9EC7\u4CCD\u9DC9\u9E0C\u4C3E\uD867\uDDF6\uD85C\uDC0E\u9E0A\uD868\uDD33\u35C1"],["89c1","\u6E9A\u823E\u7519"],["89c5","\u4911\u9A6C\u9A8F\u9F99\u7987\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6\u4E24\u4E81\u4E80\u4E87\u4EBF\u4EEB\u4F37\u344C\u4FBD\u3E48\u5003\u5088\u347D\u3493\u34A5\u5186\u5905\u51DB\u51FC\u5205\u4E89\u5279\u5290\u5327\u35C7\u53A9\u3551\u53B0\u3553\u53C2\u5423\u356D\u3572\u3681\u5493\u54A3\u54B4\u54B9\u54D0\u54EF\u5518\u5523\u5528\u3598\u553F\u35A5\u35BF\u55D7\u35C5"],["8a40","\uD85F\uDD84\u5525"],["8a43","\uD843\uDC42\uD843\uDD15\uD854\uDD2B\u5590\uD84B\uDCC6\u39EC\uD840\uDF41\u8E46\uD853\uDDB8\uD865\uDCE5\u4053\uD860\uDCBE\u777A\uD84B\uDC38\u3A34\u47D5\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA\u64DD\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4\u648D\u8E7E\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"],["8a64","\uD843\uDD46\uD866\uDE4D\uD860\uDCE9\u47F4\uD853\uDEA7\uD84B\uDCC2\u9AB2\u3A67\uD865\uDDF4\u3FED\u3506\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44\u9D6E\u9815"],["8a76","\u43D9\uD858\uDCA5\u64B4\u54E3\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77\u39FB\uD844\uDC6F"],["8aa1","\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0\u64EA\uD854\uDC52\uD843\uDC43\u8E68\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"],["8aac","\u480B\uD840\uDDA9\u3FFA\u5873\uD84B\uDD8D"],["8ab2","\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96\u5579\u40BB\u43BA"],["8abb","\u4AB4\uD84A\uDE66\uD844\uDC9D\u81AA\u98F5\uD843\uDD9C\u6379\u39FE\uD849\uDF75\u8DC0\u56A1\u647C\u3E43"],["8ac9","\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"],["8ace","\uD844\uDCC8\uD84E\uDDC2\u3992\u3A06\uD860\uDE9B\u3578\uD857\uDE49\uD848\uDCC7\u5652\uD843\uDF31\uD84B\uDCB2\uD865\uDF20\u34BC\u6C3D\uD853\uDE3B"],["8adf","\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C\u7F93\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39\u35FB\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA\u3F93\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"],["8af6","\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D\u3FF9\uD849\uDE96\u6432\uD843\uDFAD"],["8b40","\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55\u3A18\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA\u95AA\u54CC\u82C4\u55B9"],["8b55","\uD867\uDEC3\u9C26\u9AB6\uD85D\uDF5E\uD84B\uDDEE\u7140\u816D\u80EC\u5C1C\uD859\uDD72\u8134\u3797\u535F\uD860\uDCBD\u91B6\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB\u35DD\uD853\uDDEB\u3609\uD843\uDCD6\u56AF\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4\u5A54\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6\u579C\uD843\uDE11"],["8ba1","\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E\u3703\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C\u5899\u5268\u361A\uD855\uDF3D\u7BB2\u5B68\u4800\u4B2C\u9F27\u49E7\u9C1F\u9B8D\uD856\uDF74\uD84C\uDD3D\u55FB\u35F2\u5689\u4E28\u5902\uD846\uDFC1\uD87E\uDC78\u9751\uD840\uDC86\u4E5B\u4EBB\u353E\u5C23\u5F51\u5FC4\u38FA\u624C\u6535\u6B7A\u6C35\u6C3A\u706C\u722B\u4E2C\u72AD\uD852\uDCE9\u7F52\u793B\u7CF9\u7F53\uD858\uDE6A\u34C1"],["8bde","\uD858\uDF4B\u8002\u8080\uD859\uDE12\uD85A\uDD51\u535D\u8864\u89C1\uD85E\uDCB2\u8BA0\u8D1D\u9485\u9578\u957F\u95E8\uD863\uDE0F\u97E6\u9875\u98CE\u98DE\u9963\uD866\uDC10\u9C7C\u9E1F\u9EC4\u6B6F\uF907\u4E37\uD840\uDC87\u961D\u6237\u94A2"],["8c40","\u503B\u6DFE\uD867\uDC73\u9FA6\u3DC9\u888F\uD850\uDD4E\u7077\u5CF5\u4B20\uD854\uDDCD\u3559\uD857\uDD30\u6122\uD862\uDE32\u8FA7\u91F6\u7191\u6719\u73BA\uD84C\uDE81\uD868\uDD07\u3C8B\uD846\uDD80\u4B10\u78E4\u7402\u51AE\uD861\uDF0F\u4009\u6A63\uD868\uDEBA\u4223\u860F\uD842\uDE6F\u7A2A\uD866\uDD47\uD862\uDEEA\u9755\u704D\u5324\uD848\uDC7E\u93F4\u76D9\uD862\uDDE3\u9FA7\u77DD\u4EA3\u4FF0\u50BC\u4E2F\u4F17\u9FA8\u5434\u7D8B\u5892\u58D0\uD847\uDDB6\u5E92\u5E99\u5FC2\uD849\uDF12\u658B"],["8ca1","\uD84C\uDFF9\u6919\u6A43\uD84F\uDC63\u6CFF"],["8ca7","\u7200\uD851\uDD05\u738C\u3EDB\uD852\uDE13\u5B15\u74B9\u8B83\uD857\uDCA4\uD855\uDE95\u7A93\u7BEC\u7CC3\u7E6C\u82F8\u8597\u9FA9\u8890\u9FAA\u8EB9\u9FAB\u8FCF\u855F\u99E0\u9221\u9FAC\uD863\uDDB9\uD845\uDC3F\u4071\u42A2\u5A1A"],["8cc9","\u9868\u676B\u4276\u573D"],["8cce","\u85D6\uD852\uDD7B\u82BF\uD85C\uDD0D\u4C81\uD85B\uDD74\u5D7B\uD85A\uDF15\uD85B\uDFBE\u9FAD\u9FAE\u5B96\u9FAF\u66E7\u7E5B\u6E57\u79CA\u3D88\u44C3\uD84C\uDE56\uD849\uDF96\u439A\u4536"],["8ce6","\u5CD5\uD84E\uDF1A\u8AF9\u5C78\u3D12\uD84D\uDD51\u5D78\u9FB2\u7157\u4558\uD850\uDCEC\uD847\uDE23\u4C77\u3978\u344A\uD840\uDDA4\uD85B\uDC41\u8ACC\u4FB4\uD840\uDE39\u59BF\u816C\u9856\uD866\uDCFA\u5F3B"],["8d40","\uD842\uDF9F"],["8d42","\uD848\uDDC1\uD862\uDD6D\u4102\u46BB\uD864\uDC79\u3F07\u9FB3\uD868\uDDB5\u40F8\u37D6\u46F7\uD85B\uDC46\u417C\uD861\uDEB2\uD85C\uDFFF\u456D\u38D4\uD855\uDC9A\u4561\u451B\u4D89\u4C7B\u4D76\u45EA\u3FC8\uD852\uDF0F\u3661\u44DE\u44BD\u41ED\u5D3E\u5D48\u5D56\u3DFC\u380F\u5DA4\u5DB9\u3820\u3838\u5E42\u5EBD\u5F25\u5F83\u3908\u3914\u393F\u394D\u60D7\u613D\u5CE5\u3989\u61B7\u61B9\u61CF\u39B8\u622C\u6290\u62E5\u6318\u39F8\u56B1"],["8da1","\u3A03\u63E2\u63FB\u6407\u645A\u3A4B\u64C0\u5D15\u5621\u9F9F\u3A97\u6586\u3ABD\u65FF\u6653\u3AF2\u6692\u3B22\u6716\u3B42\u67A4\u6800\u3B58\u684A\u6884\u3B72\u3B71\u3B7B\u6909\u6943\u725C\u6964\u699F\u6985\u3BBC\u69D6\u3BDD\u6A65\u6A74\u6A71\u6A82\u3BEC\u6A99\u3BF2\u6AAB\u6AB5\u6AD4\u6AF6\u6B81\u6BC1\u6BEA\u6C75\u6CAA\u3CCB\u6D02\u6D06\u6D26\u6D81\u3CEF\u6DA4\u6DB1\u6E15\u6E18\u6E29\u6E86\uD862\uDDC0\u6EBB\u6EE2\u6EDA\u9F7F\u6EE8\u6EE9\u6F24\u6F34\u3D46\uD84F\uDF41\u6F81\u6FBE\u3D6A\u3D75\u71B7\u5C99\u3D8A\u702C\u3D91\u7050\u7054\u706F\u707F\u7089\uD840\uDF25\u43C1\u35F1\uD843\uDED8"],["8e40","\uD84F\uDED7\u57BE\uD85B\uDED3\u713E\uD855\uDFE0\u364E\u69A2\uD862\uDFE9\u5B74\u7A49\uD856\uDCE1\uD865\uDCD9\u7A65\u7A7D\uD856\uDDAC\u7ABB\u7AB0\u7AC2\u7AC3\u71D1\uD859\uDC8D\u41CA\u7ADA\u7ADD\u7AEA\u41EF\u54B2\uD857\uDC01\u7B0B\u7B55\u7B29\uD854\uDF0E\uD857\uDCFE\u7BA2\u7B6F\u839C\uD856\uDFB4\uD85B\uDC7F\u7BD0\u8421\u7B92\u7BB8\uD857\uDD20\u3DAD\uD857\uDC65\u8492\u7BFA\u7C06\u7C35\uD857\uDCC1\u7C44\u7C83\uD852\uDC82\u7CA6\u667D\uD851\uDD78\u7CC9\u7CC7\u7CE6\u7C74\u7CF3\u7CF5\u7CCE"],["8ea1","\u7E67\u451D\uD85B\uDE44\u7D5D\uD85B\uDED6\u748D\u7D89\u7DAB\u7135\u7DB3\u7DD2\uD850\uDC57\uD858\uDC29\u7DE4\u3D13\u7DF5\uD845\uDFF9\u7DE5\uD860\uDF6D\u7E1D\uD858\uDD21\uD858\uDD5A\u7E6E\u7E92\u432B\u946C\u7E27\u7F40\u7F41\u7F47\u7936\uD858\uDED0\u99E1\u7F97\uD858\uDF51\u7FA3\uD845\uDE61\uD840\uDC68\u455C\uD84D\uDF66\u4503\uD860\uDF3A\u7FFA\uD859\uDC89\u8005\u8008\u801D\u8028\u802F\uD868\uDC87\uD85B\uDCC3\u803B\u803C\u8061\uD849\uDF14\u4989\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8\u6725\u80A7\uD862\uDE48\u8107\u811A\u58B0\uD849\uDEF6\u6C7F\uD859\uDC98\uD853\uDFB8\u64E7\uD845\uDC8A\u8218\uD846\uDC5E\u6A53\uD852\uDE65\uD852\uDE95\u447A\u8229\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E\u4FF9\uD845\uDCFD\u84E2\u8362\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8\u82AA\u691B\uD87E\uDD94\u41DB"],["8f40","\u854B\u82D0\u831A\uD843\uDE16\uD845\uDFB4\u36C1\uD84C\uDD7D\uD84D\uDD5A\u827B\u82E2\u8318\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE\u3DBF\u831D\u55EC\u8385\u450B\uD85B\uDDA5\u83AC\u83C1\u83D3\u347E\uD85B\uDED4\u6A57\u855A\u3496\uD85B\uDE42\uD84B\uDEEF\u8458\uD856\uDFE4\u8471\u3DD3\u44E4\u6AA7\u844A\uD84F\uDCB5\u7958\u84A8\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43\u84DE\u840F\u8391\u44A0\u8493\u84E4\uD857\uDC91\u4240\uD857\uDCC0\u4543\u8534\u5AF2\uD85B\uDE99\u4527\u8573\u4516\u67BF\u8616"],["8fa1","\uD861\uDE25\uD861\uDE3B\u85C1\uD85C\uDC88\u8602\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2\u456A\u8628\u3648\uD846\uDCA2\u53F7\uD85C\uDF9A\u867E\u8771\uD868\uDCF8\u87EE\uD84B\uDC27\u87B1\u87DA\u880F\u5661\u866C\u6856\u460F\u8845\u8846\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4\u885E\u889C\u465B\u88B4\u88B5\u63C1\u88C5\u7777\uD85D\uDF0F\u8987\u898A\u89A6\u89A9\u89A7\u89BC\uD862\uDE25\u89E7\uD85E\uDD24\uD85E\uDEBD\u8A9C\u7793\u91FE\u8A90\uD85E\uDE59\u7AE9\uD85E\uDF3A\uD84F\uDF8F\u4713\uD85E\uDF38\u717C\u8B0C\u8B1F\uD855\uDC30\uD855\uDD65\u8B3F\u8B4C\u8B4D\u8AA9\uD852\uDE7A\u8B90\u8B9B\u8AAF\uD845\uDEDF\u4615\u884F\u8C9B\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4\u3725\uD85F\uDD53\u8CD6\uD85F\uDD98\uD85F\uDDBD\u8D12\u8D03\uD846\uDD10\u8CDB\u705C\u8D11\uD853\uDCC9\u3ED0\u8D77"],["9040","\u8DA9\uD860\uDC02\uD844\uDC14\uD852\uDD8A\u3B7C\uD860\uDDBC\uD85C\uDD0C\u7AE7\u8EAD\u8EB6\u8EC3\u92D4\u8F19\u8F2D\uD860\uDF65\uD861\uDC12\u8FA5\u9303\uD868\uDE9F\uD842\uDE50\u8FB3\u492A\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB\u5EF8\uD84C\uDE62\u8FF9\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25\u3980\uD85B\uDED7\u9037\uD861\uDD3C\uD85E\uDEBE\u9061\uD861\uDD6C\uD861\uDE0B\u90A8\uD861\uDF13\u90C4\uD861\uDEE6\u90AE\u90FD\u9167\u3AF0\u91A9\u91C4\u7CAC\uD862\uDD33\uD847\uDE89\u920E\u6C9F\u9241\u9262\uD855\uDDB9\u92B9\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"],["90a1","\uD843\uDD31\u932C\u936B\uD862\uDEE1\uD862\uDFEB\u708F\u5AC3\uD862\uDEE2\uD862\uDEE5\u4965\u9244\uD862\uDFEC\uD863\uDC39\uD862\uDFFF\u9373\u945B\u8EBC\u9585\u95A6\u9426\u95A0\u6FF6\u42B9\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E\u49DF\u6C1C\u967B\u9696\u416C\u96A3\uD85B\uDED5\u61DA\u96B6\u78F5\uD862\uDEE0\u96BD\u53CC\u49A1\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A\u9731\u8642\u9736\u4A0F\u453D\u4585\uD852\uDEE9\u7075\u5B41\u971B\u975C\uD864\uDDD5\u9757\u5B4A\uD864\uDDEB\u975F\u9425\u50D0\uD84C\uDCB7\uD84C\uDCBC\u9789\u979F\u97B1\u97BE\u97C0\u97D2\u97E0\uD855\uDC6C\u97EE\u741C\uD865\uDC33\u97FF\u97F5\uD865\uDC1D\uD85E\uDD7A\u4AD1\u9834\u9833\u984B\u9866\u3B0E\uD85C\uDD75\u3D51\uD841\uDE30\uD850\uDD5C"],["9140","\uD855\uDF06\u98CA\u98B7\u98C8\u98C7\u4AFF\uD85B\uDD27\uD845\uDED3\u55B0\u98E1\u98E6\u98EC\u9378\u9939\uD852\uDE29\u4B72\uD866\uDC57\uD866\uDD05\u99F5\u9A0C\u9A3B\u9A10\u9A58\uD855\uDF25\u36C4\uD864\uDCB1\uD866\uDFD5\u9AE0\u9AE2\uD866\uDF05\u9AF4\u4C0E\u9B14\u9B2D\uD861\uDE00\u5034\u9B34\uD85A\uDDA8\u38C3\uD84C\uDC7D\u9B50\u9B40\uD867\uDD3E\u5A45\uD846\uDC63\u9B8E\uD850\uDE4B\u9C02\u9BFF\u9C0C\uD867\uDE68\u9DD4\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF\u9D7E\u9D83\uD868\uDD34\u9E0E\u6888"],["91a1","\u9DC4\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33\u9D39\uD868\uDCB9\uD868\uDEB4\u9E90\u9E95\u9E9E\u9EA2\u4D34\u9EAA\u9EAF\uD850\uDF64\u9EC1\u3B60\u39E5\u3D1D\u4F32\u37BE\uD863\uDC2B\u9F02\u9F08\u4B96\u9424\uD85B\uDDA2\u9F17\u9F16\u9F39\u569F\u568A\u9F45\u99B8\uD864\uDC8B\u97F2\u847F\u9F62\u9F69\u7ADC\u9F8E\u7216\u4BBE\uD852\uDD75\uD852\uDDBB\u7177\uD852\uDDF8\uD850\uDF48\uD852\uDE51\u739E\uD862\uDFDA\uD846\uDCFA\u799F\uD862\uDD7E\uD863\uDE36\u9369\u93F3\uD862\uDE44\u92EC\u9381\u93CB\uD862\uDD6C\uD851\uDCB9\u7217\u3EEB\u7772\u7A43\u70D0\uD851\uDC73\uD850\uDFF8\u717E\uD845\uDFEF\u70A3\uD846\uDCBE\uD84D\uDD99\u3EC7\uD846\uDC85\uD855\uDC2F\uD845\uDFF8\u3722\uD845\uDEFB\uD846\uDC39\u36E1\uD845\uDF74\uD846\uDCD1\uD857\uDF4B\u3723\uD845\uDEC0\u575B\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"],["9240","\uD844\uDFC6\uD845\uDCB6\u8503\uD84D\uDEA6\u8503\u8455\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52\u44F4\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26\u67F9\u3733\u3C15\u3DE7\u586C\uD846\uDD22\u6810\u4057\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21\u54CB\u569E\uD859\uDEB1\u5692\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D\u93C6\uD862\uDF13\u939C\u4EF8\u512B\u3819\uD851\uDC36\u4EBC\uD841\uDC65\uD840\uDF7F\u4F4B\u4F8A\uD855\uDE51\u5A68\uD840\uDDAB\uD840\uDFCB\u3999\uD840\uDF0A\uD841\uDC14\u3435\u4F29\uD840\uDEC0\uD863\uDEB3\uD840\uDE75\u8ADA\uD840\uDE0C\u4E98"],["92a1","\u50CD\u510D\u4FA2\u4F03\uD852\uDE0E\uD84F\uDE8A\u4F42\u502E\u506C\u5081\u4FCC\u4FE5\u5058\u50FC\u5159\u515B\u515D\u515E\u6E76\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF\u6D72\uD846\uDC84\uD84F\uDE89\u51A8\u51C3\uD841\uDDE0\u44DD\uD841\uDCA3\uD841\uDC92\uD841\uDC91\u8D7A\uD862\uDE9C\uD841\uDF0E\u5259\u52A4\uD842\uDC73\u52E1\u936E\u467A\u718C\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4\u69D1\uD843\uDE1D\u7479\u3EDE\u7499\u7414\u7456\u7398\u4B8E\uD852\uDEBC\uD850\uDC8D\u53D0\u3584\u720F\uD850\uDCC9\u55B4\uD840\uDF45\u54CD\uD842\uDFC6\u571D\u925D\u96F4\u9366\u57DD\u578D\u577F\u363E\u58CB\u5A99\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10\u5A2C\u59B8\u928F\u5A7E\u5ACF\u5A12\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95\u36F5\u6D05\u7443\u5A21\uD857\uDE83"],["9340","\u5A81\uD862\uDFD7\uD841\uDC13\u93E0\u748C\uD844\uDF03\u7105\u4972\u9408\uD862\uDDFB\u93BD\u37A0\u5C1E\u5C9E\u5E5E\u5E48\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE\u5ECD\u5B4F\uD846\uDD03\uD846\uDD04\u3701\uD846\uDCA0\u36DD\uD845\uDEFE\u36D3\u812A\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8\u5F0C\u5F0E\uD846\uDD27\uD845\uDFAB\u5A6B\uD845\uDF3B\u5B44\u8614\uD85D\uDDFD\u8860\u607E\uD84A\uDC60\uD849\uDE2B\u5FDB\u3EB8\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73\u61C0\uD840\uDC3E\uD840\uDC46\uD849\uDE1B\u6199\u6198\u6075\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"],["93a1","\u6471\uD851\uDE65\uD84A\uDF6A\u3A29\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78\u6337\uD869\uDC5B\u64B6\u6331\u63D1\uD852\uDDE3\uD84B\uDD67\u62A4\uD84B\uDCA1\u643B\u656B\u6972\u3BF4\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB\u550D\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F\u66CE\uD84C\uDE89\uD84C\uDDB3\u3AE0\u4190\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25\u78EE\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34\u3464\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9\u668E\uD85B\uDD24\u666B\u4B93\u6630\uD85E\uDC70\uD847\uDDEB\u6663\uD84C\uDED2\uD84C\uDEE1\u661E\uD856\uDC72\u38D1\uD84E\uDC3A\uD84D\uDFBC\u3B99\uD84D\uDFA2\uD84C\uDFFE\u74D0\u3B96\u678F\uD851\uDE2A\u68B6\u681E\u3BC4\u6ABE\u3863\uD84D\uDFD5\uD851\uDC87\u6A33\u6A52\u6AC9\u6B05\uD846\uDD12\u6511\u6898\u6A4C\u3BD7\u6A7A\u6B57\uD84F\uDFC0\uD84F\uDC9A\u93A0\u92F2\uD862\uDFEA\uD862\uDECB"],["9440","\u9289\uD860\uDC1E\uD862\uDDDC\u9467\u6DA5\u6F0B\uD852\uDDEC\u6D67\uD84F\uDF7F\u3D8F\u6E04\uD850\uDC3C\u5A3D\u6E0A\u5847\u6D24\u7842\u713B\uD850\uDF1A\uD850\uDE76\u70F1\u7250\u7287\u7294\uD851\uDF8F\uD851\uDF25\u5179\uD852\uDEA4\uD841\uDDEB\u747A\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1\u3F06\u3EB1\uD852\uDEDF\uD863\uDC23\uD84F\uDF35\u60A7\u3EF3\u74CC\u743C\u9387\u7437\u449F\uD85B\uDDEA\u4551\u7583\u3F63\uD853\uDCD9\uD853\uDD06\u3F58\u7555\u7673\uD869\uDDC6\u3B19\u7468\uD862\uDECC\uD852\uDDAB\uD852\uDD8E\u3AFB"],["94a1","\u3DCD\uD852\uDE4E\u3EFF\uD852\uDDC5\uD852\uDCF3\u91FA\u5732\u9342\uD862\uDEE3\uD846\uDC64\u50DF\uD854\uDE21\uD854\uDDE7\u7778\uD84C\uDE32\u770E\u770F\u777B\uD851\uDE97\uD84D\uDF81\u3A5E\uD852\uDCF0\u7438\u749B\u3EBF\uD852\uDEBA\uD852\uDEC7\u40C8\uD852\uDE96\uD858\uDDAE\u9307\uD855\uDD81\u781E\u788D\u7888\u78D2\u73D0\u7959\uD85D\uDF41\uD855\uDEE3\u410E\u799B\u8496\u79A5\u6A2D\uD84F\uDEFA\u7A3A\u79F4\u416E\uD845\uDEE6\u4132\u9235\u79F1\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E\u3597\u556B\u3570\u36AA\uD840\uDDD4\uD843\uDC0D\u7AE2\u5A59\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C\u5A0D\uD840\uDE5B\u78F0\u5A2A\uD856\uDFC6\u7AFE\u41F9\u7C5D\u7C6D\u4211\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6\u7CCD\uD852\uDDF9\uD845\uDFB0\u7C8E\u7C7C\u7CAE\u6AB2\u7DDC\u7E07\u7DD3\u7F4E\uD858\uDE61"],["9540","\uD858\uDD5C\uD85E\uDF48\u7D97\uD857\uDE82\u426A\uD85A\uDF75\uD842\uDD16\u67D6\uD840\uDC4E\uD84D\uDDCF\u57C4\uD859\uDC12\uD858\uDFF8\uD852\uDD62\u7FDD\u7B27\uD842\uDC2C\uD856\uDEE9\uD857\uDD43\u7B0C\uD857\uDE0E\u99E6\u8645\u9A63\u6A1C\uD84D\uDC3F\u39E2\uD852\uDDF7\uD859\uDDAD\u9A1F\uD859\uDDA0\u8480\uD85C\uDD27\uD85B\uDCD1\u44EA\u8137\u4402\u80C6\u8109\u8142\uD859\uDFB4\u98C3\uD85A\uDE42\u8262\u8265\uD85A\uDE51\u8453\uD85B\uDDA7\u8610\uD85C\uDE1B\u5A86\u417F\uD846\uDC40\u5B2B\uD846\uDCA1\u5AE4\uD846\uDCD8\u86A0\uD87E\uDDBC\uD84F\uDD8F\u882D\uD85D\uDC22\u5A02"],["95a1","\u886E\u4F45\u8887\u88BF\u88E6\u8965\u894D\uD855\uDE83\u8954\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9\u3EAD\u84A3\u46F5\u46CF\u37F2\u8A3D\u8A1C\uD865\uDC48\u5F4D\u922B\uD850\uDE84\u65D4\u7129\u70C4\uD846\uDC45\u9D6D\u8C9F\u8CE9\uD85F\uDDDC\u599A\u77C3\u59F0\u436E\u36D4\u8E2A\u8EA7\uD853\uDC09\u8F30\u8F4A\u42F4\u6C58\u6FBB\uD848\uDF21\u489B\u6F79\u6E8B\uD845\uDFDA\u9BE9\u36B5\uD852\uDD2F\u90BB\u9097\u5571\u4906\u91BB\u9404\uD862\uDE4B\u4062\uD862\uDEFC\u9427\uD863\uDC1D\uD863\uDC3B\u84E5\u8A2B\u9599\u95A7\u9597\u9596\uD863\uDD34\u7445\u3EC2\uD852\uDCFF\uD852\uDE42\uD850\uDFEA\u3EE7\uD84C\uDE25\u968F\uD863\uDEE7\uD863\uDE66\uD863\uDE65\u3ECC\uD852\uDDED\uD852\uDE78\uD84F\uDFEE\u7412\u746B\u3EFC\u9741\uD864\uDCB0"],["9640","\u6847\u4A1D\uD864\uDC93\uD855\uDFDF\u975D\u9368\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE\u92BA\u5B11\u8B69\u493C\u73F9\uD850\uDE1B\u979B\u9771\u9938\uD843\uDF26\u5DC1\uD862\uDFC5\uD852\uDEB2\u981F\uD865\uDCDA\u92F6\uD865\uDDD7\u91E5\u44C0\uD862\uDF50\uD852\uDE67\uD862\uDF64\u98DC\uD862\uDE45\u3F00\u922A\u4925\u8414\u993B\u994D\uD85E\uDF06\u3DFD\u999B\u4B6F\u99AA\u9A5C\uD862\uDF65\uD856\uDCC8\u6A8F\u9A21\u5AFE\u9A2F\uD866\uDCF1\u4B90\uD866\uDD48\u99BC\u4BBD\u4B97\u937D\u5872\uD844\uDF02\u5822\uD852\uDDB8"],["96a1","\uD845\uDCE8\u7844\uD849\uDF1F\uD84F\uDDB8\u68C5\u3D7D\u9458\u3927\u6150\uD849\uDF81\uD84A\uDD6B\u6107\u9C4F\u9C53\u9C7B\u9C35\u9C10\u9B7F\u9BCF\uD867\uDE2D\u9B9F\uD868\uDDF5\uD868\uDCFE\u9D21\u4CAE\uD850\uDD04\u9E18\u4CB0\u9D0C\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F\u9DA5\u84BD\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82\u85FC\u4533\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0\u8420\u85EE\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64\u79E2\uD84D\uDD9C\uD84D\uDE40\u492D\uD852\uDDDE\u3D62\u93DB\u92BE\u9348\uD840\uDEBF\u78B9\u9277\u944D\u4FE4\u3440\u9064\uD855\uDD5D\u783D\u7854\u78B6\u784B\uD845\uDF57\uD84C\uDDC9\uD852\uDD41\u369A\u4F72\u6FDA\u6FD9\u701E\u701E\u5414\uD850\uDDB5\u57BB\u58F3\u578A\u9D16\u57D7\u7134\u34AF\uD850\uDDAC\u71EB\uD85B\uDC40\uD853\uDF97\u5B28\uD845\uDFB5\uD862\uDE49"],["9740","\u610C\u5ACE\u5A0B\u42BC\uD851\uDC88\u372C\u4B7B\uD862\uDDFC\u93BB\u93B8\uD846\uDCD6\uD843\uDF1D\u8472\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1\u5994\uD84F\uDDB7\uD859\uDF41\u7DA8\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA\u92E5\u73E2\u3EE9\u74B4\uD862\uDF63\uD846\uDC9F\u3EE1\uD852\uDEB3\u6AD8\u73F3\u73FB\u3ED6\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5\u7448\uD852\uDD16\u70A5\uD852\uDD76\u9284\u73E6\u935F\uD841\uDCFE\u9331\uD862\uDECE\uD862\uDE16\u9386\uD862\uDFE7\uD855\uDDD5\u4935\uD862\uDE82\u716B"],["97a1","\uD852\uDD43\uD843\uDCFF\u56A4\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8\u5502\u79C4\uD845\uDFFA\u7DFE\uD845\uDEC2\uD852\uDE50\uD846\uDC52\u452E\u9401\u370A\uD862\uDEC0\uD852\uDDAD\u59B0\uD846\uDCBF\uD846\uDC83\uD85D\uDC84\u5AA1\u36E2\uD84F\uDD5B\u36B0\u925F\u5A79\uD862\uDE81\uD846\uDC62\u9374\u3CCD\uD842\uDEB4\u4A96\u398A\u50F4\u3D69\u3D4C\uD844\uDF9C\u7175\u42FB\uD860\uDE18\u6E0F\uD864\uDCE4\u44EB\u6D57\uD85F\uDE4F\u7067\u6CAF\u3CD6\uD84F\uDFED\uD84F\uDE2D\u6E02\u6F0C\u3D6F\uD840\uDFF5\u7551\u36BC\u34C8\u4680\u3EDA\u4871\u59C4\u926E\u493E\u8F41\uD863\uDC1C\uD85A\uDFC0\u5812\u57C8\u36D6\uD845\uDC52\u70FE\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD\u68B9\u6967\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F\u6A1A\uD84D\uDEAD\uD85B\uDCB7\u843E\u44DF\u44CE"],["9840","\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE\u6F17\uD85C\uDD09\u833D\uD845\uDF3A\u83ED\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB\u5989\u5A82\uD845\uDFB3\u5A61\u5A71\uD846\uDD05\uD850\uDDFC\u372D\u59EF\uD845\uDF3C\u36C7\u718E\u9390\u669A\uD850\uDEA5\u5A6E\u5A2B\uD850\uDE93\u6A2B\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA\u711D\uD850\uDE59\uD862\uDDE1\u4FB0\uD85B\uDD28\u5CC2\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD\u6A0C\uD850\uDE56\uD844\uDF04\u70A6\u7133\uD850\uDFE9\u3DA5\u6CDF\uD87E\uDC25\uD852\uDE4F\u7E65\u59EB\u5D2F\u3DF3\u5F5C\uD852\uDE5D\uD845\uDFDF\u7DA4\u8426"],["98a1","\u5485\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14\u577E\uD842\uDCD5\uD841\uDE19\u3FE5\uD847\uDF9E\uD868\uDEB6\u7003\uD864\uDD5B\u5D70\u738F\u7CD3\uD862\uDE59\uD865\uDC20\u4FC8\u7FE7\u72CD\u7310\uD85E\uDEF4\u7338\u7339\uD855\uDEF6\u7341\u7348\u3EA9\uD85E\uDF18\u906C\u71F5\uD852\uDCF2\u73E1\u81F6\u3ECA\u770C\u3ED1\u6CA2\u56FD\u7419\u741E\u741F\u3EE2\u3EF0\u3EF4\u3EFA\u74D3\u3F0E\u3F53\u7542\u756D\u7572\u758D\u3F7C\u75C8\u75DC\u3FC0\u764D\u3FD7\u7674\u3FDC\u767A\uD853\uDF5C\u7188\u5623\u8980\u5869\u401D\u7743\u4039\u6761\u4045\u35DB\u7798\u406A\u406F\u5C5E\u77BE\u77CB\u58F2\u7818\u70B9\u781C\u40A8\u7839\u7847\u7851\u7866\u8448\uD855\uDD35\u7933\u6803\u7932\u4103"],["9940","\u4109\u7991\u7999\u8FBB\u7A06\u8FBC\u4167\u7A91\u41B2\u7ABC\u8279\u41C4\u7ACF\u7ADB\u41CF\u4E21\u7B62\u7B6C\u7B7B\u7C12\u7C1B\u4260\u427A\u7C7B\u7C9C\u428C\u7CB8\u4294\u7CED\u8F93\u70C0\uD843\uDCCF\u7DCF\u7DD4\u7DD0\u7DFD\u7FAE\u7FB4\u729F\u4397\u8020\u8025\u7B39\u802E\u8031\u8054\u3DCC\u57B4\u70A0\u80B7\u80E9\u43ED\u810C\u732A\u810E\u8112\u7560\u8114\u4401\u3B39\u8156\u8159\u815A"],["99a1","\u4413\u583A\u817C\u8184\u4425\u8193\u442D\u81A5\u57EF\u81C1\u81E4\u8254\u448F\u82A6\u8276\u82CA\u82D8\u82FF\u44B0\u8357\u9669\u698A\u8405\u70F5\u8464\u60E3\u8488\u4504\u84BE\u84E1\u84F8\u8510\u8538\u8552\u453B\u856F\u8570\u85E0\u4577\u8672\u8692\u86B2\u86EF\u9645\u878B\u4606\u4617\u88AE\u88FF\u8924\u8947\u8991\uD85E\uDD67\u8A29\u8A38\u8A94\u8AB4\u8C51\u8CD4\u8CF2\u8D1C\u4798\u585F\u8DC3\u47ED\u4EEE\u8E3A\u55D8\u5754\u8E71\u55F5\u8EB0\u4837\u8ECE\u8EE2\u8EE4\u8EED\u8EF2\u8FB7\u8FC1\u8FCA\u8FCC\u9033\u99C4\u48AD\u98E0\u9213\u491E\u9228\u9258\u926B\u92B1\u92AE\u92BF"],["9a40","\u92E3\u92EB\u92F3\u92F4\u92FD\u9343\u9384\u93AD\u4945\u4951\u9EBF\u9417\u5301\u941D\u942D\u943E\u496A\u9454\u9479\u952D\u95A2\u49A7\u95F4\u9633\u49E5\u67A0\u4A24\u9740\u4A35\u97B2\u97C2\u5654\u4AE4\u60E8\u98B9\u4B19\u98F1\u5844\u990E\u9919\u51B4\u991C\u9937\u9942\u995D\u9962\u4B70\u99C5\u4B9D\u9A3C\u9B0F\u7A83\u9B69\u9B81\u9BDD\u9BF1\u9BF4\u4C6D\u9C20\u376F\uD846\uDFC2\u9D49\u9C3A"],["9aa1","\u9EFE\u5650\u9D93\u9DBD\u9DC0\u9DFC\u94F6\u8FB6\u9E7B\u9EAC\u9EB1\u9EBD\u9EC6\u94DC\u9EE2\u9EF1\u9EF8\u7AC8\u9F44\uD840\uDC94\uD840\uDEB7\uD840\uDFA0\u691A\u94C3\u59AC\uD841\uDCD7\u5840\u94C1\u37B9\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA\u5757\u7173\uD842\uDEC2\uD842\uDECD\uD842\uDFBF\u546A\uD87E\uDC3B\uD842\uDFCB\u549E\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C\u60E7\uD843\uDC8D\u567A\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8\u6955\u9C2F\u87A5\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73\u5C20\uD843\uDFBC\u5E0B\uD844\uDC5C\uD844\uDC4F\uD844\uDC76\u671E\uD844\uDC7B\uD844\uDC88\uD844\uDC96\u3647\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B\u5364\u84AD\uD844\uDEE3\uD844\uDF75\uD844\uDF36\u8B81\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7\u4E78\u70BB\uD846\uDC2D\uD846\uDD6A"],["9b40","\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8\u62C3\uD847\uDED5\uD847\uDF15\u7198\u6855\uD848\uDC45\u69E9\u36C8\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F\u82FD\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5\u89A5\uD84A\uDEE8\u8FA0\uD84A\uDF0E\u97B8\uD84A\uDF3F\u9847\u9ABD\uD84B\uDC4C"],["9b62","\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE\u5FB1\u6648\u66BF\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3\u7201\uD852\uDDBA\u77D7\uD84D\uDE1A\uD84D\uDF16\u7E87\uD840\uDF46\u58B5\u670E"],["9ba1","\u6918\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A\u48D0\u4AB8\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA\u51D2\uD841\uDE11\u599F\uD847\uDEA8\u3BBE\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6\u5788\uD851\uDE74\u399B\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9\u3762\uD848\uDDC3\u8B5E\uD862\uDF4E\u99D6\uD852\uDC12\uD852\uDCFB\uD852\uDE15\u7209\uD852\uDEC0\uD843\uDC78\u5965\uD853\uDEA5\uD853\uDF86\uD841\uDF79\u8EDA\uD854\uDC2C\u528F\u573F\u7171\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7\u55BC\uD855\uDC46\uD855\uDC6E\uD85A\uDF52\u91D4\u3473\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E\u4718\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D\u5066\u34FB\uD84C\uDFCC\u60DE\uD856\uDD03\u477C\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90\u57A1\u7151\u6FB6\uD858\uDD02\uD85F\uDC12\u9056\uD858\uDDB2\uD853\uDF9A\u8B62\uD859\uDC02\uD859\uDC4A"],["9c40","\u5D5B\uD85A\uDFF7\u8F36\uD859\uDC84\uD846\uDD1C\u8AEA\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12\u4BC0\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B\u9465\uD855\uDFE1\u6195\u5A27\uD87E\uDCCD\u4FBB\u56B9\uD851\uDD21\uD859\uDEFC\u4E6A\uD852\uDD34\u9656\u6D8F\uD85B\uDCBD\u3618\u8977\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E\u71DF\uD85A\uDCC7\u7B42\uD864\uDCC0\uD842\uDE11\uD85A\uDD26\u9104\uD85A\uDD39\u7A45\u9DF0\uD85A\uDDFA\u9A26\uD85A\uDE2D\u365F\uD859\uDC69\uD840\uDC21\u7983\uD85A\uDE34\uD85A\uDF5B\u5D2C\uD84D\uDD19\u83CF\uD85A\uDF9D\u46D0\uD85B\uDCA4\u753B\u8865\uD85B\uDDAE\u58B6"],["9ca1","\u371C\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD\u3C54\uD85C\uDE80\uD85C\uDE85\u9281\uD848\uDD7A\uD85C\uDE8B\u9330\uD85C\uDEE6\uD852\uDDD0\u6C39\u949F\uD85D\uDC50\uD843\uDEF8\u8827\u88F5\uD84A\uDD26\uD861\uDC73\uD845\uDFB1\u6EB8\uD852\uDE2A\uD846\uDC20\u39A4\u36B9\u5C10\u79E3\u453F\u66B6\uD867\uDCAD\uD866\uDCA4\u8943\uD85D\uDFCC\uD85E\uDC58\u56D6\u40DF\uD845\uDE0A\u39A1\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5\u71AD\u8366\uD85E\uDDDD\uD864\uDDA8\u5A67\u4CB7\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A\u7B43\u797E\uD860\uDC09\u6FB5\uD868\uDEDF\u6A03\uD860\uDF18\u53A2\uD85B\uDE07\u93BF\u6836\u975D\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48\u5D85\uD863\uDC30\uD860\uDC83\u5715\u9823\uD862\uDD49\u5DAB\uD852\uDD88\u65BE\u69D5\u53D2\uD852\uDEA5\uD84F\uDF81\u3C11\u6736\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"],["9d40","\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A\u35CA\uD861\uDC68\uD861\uDEAA\u48FA\u63E6\uD862\uDD56\u7808\u9255\uD862\uDDB8\u43F2\uD862\uDDE7\u43DF\uD862\uDDE8\uD862\uDF46\uD862\uDFD4\u59F8\uD863\uDC09\u8F0B\uD863\uDFC5\uD864\uDCEC\u7B51\uD864\uDD10\uD864\uDD3C\u3DF7\uD864\uDD5E\uD852\uDECA\u8FD0\u728F\u568B\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B\u7E9F\uD867\uDEF8\uD867\uDF23\u4CA4\u9547\uD868\uDE93\u71A2\uD868\uDEFF\u4D91\u9012\uD869\uDDCB\u4D9C\uD843\uDC9C\u8FBE\u55C1"],["9da1","\u8FBA\uD849\uDCB0\u8FB9\uD852\uDE93\u4509\u7E7F\u6F56\u6AB1\u4EEA\u34E4\uD862\uDF2C\uD85E\uDC9D\u373A\u8E80\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF\u3DEB\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56\u4E9A\uD857\uDE81\uD858\uDE58\u56BF\uD843\uDE6D\u8E0E\u5B6D\uD84F\uDE88\uD853\uDC9E\u63DE\u62D0\uD845\uDFF6\uD846\uDC7B\u6530\u562D\uD857\uDC4A\u541A\uD854\uDF11\u3DC6\uD867\uDD98\u4C7D\u5622\u561E\u7F49\uD857\uDED8\u5975\uD84F\uDD40\u8770\u4E1C\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA\u8117\u9D5E\u8D18\u763B\u9C45\u764E\u77B9\u9345\u5432\u8148\u82F7\u5625\u8132\u8418\u80BD\u55EA\u7962\u5643\u5416\uD843\uDE9D\u35CE\u5605\u55F1\u66F1\uD860\uDEE2\u362D\u7534\u55F0\u55BA\u5497\u5572\uD843\uDC41\uD843\uDC96\u5ED0\uD854\uDD48\uD843\uDE76\uD84B\uDC62"],["9e40","\uD843\uDEA2\u9EAB\u7D5A\u55DE\uD844\uDC75\u629D\u976D\u5494\u8CCD\u71F6\u9176\u63FC\u63B9\u63FE\u5569\uD84A\uDF43\u9C72\uD84B\uDEB3\u519A\u34DF\uD843\uDDA7\u51A7\u544D\u551E\u5513\u7666\u8E2D\uD85A\uDC8A\u75B1\u80B6\u8804\u8786\u88C7\u81B6\u841C\uD844\uDCC1\u44EC\u7304\uD851\uDF06\u5B90\u830B\uD85A\uDC93\u567B\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6\u9170\uD844\uDDD9\u9208\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9\u7266\uD847\uDCA2\u474E\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB\u40FA"],["9ea1","\u9C5D\u651F\uD84B\uDDA0\u48F3\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A\u6062\uD85D\uDDA3\uD843\uDFED"],["9ead","\uD858\uDC48\uD844\uDD87\u71A3\u7E8E\u9D50\u4E1A\u4E04\u3577\u5B0D\u6CB2\u5367\u36AC\u39DC\u537D\u36A5\uD851\uDE18\u589A\uD852\uDF6E\u822D\u544B\u57AA\uD856\uDE95\uD842\uDD79"],["9ec5","\u3A52\uD849\uDC65\u7374\uD867\uDEAC\u4D09\u9BED\uD84F\uDCFE\uD867\uDF30\u4C5B\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE\u845C\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20\u632E\u7D25\uD84F\uDEF7\uD84F\uDE2C\u3A2A\u9008\u52CC\u3E74\u367A\u45E9\uD841\uDC8E\u7640\u5AF0\uD843\uDEB6\u787A\uD85F\uDF2E\u58A7\u40BF\u567C\u9B8B\u5D74\u7654\uD869\uDC34\u9E85\u4CE1\u75F9\u37FB\u6119\uD84C\uDCDA\uD850\uDFF2"],["9ef5","\u565D\uD844\uDEA9\u57A7\uD852\uDD63\uD867\uDE06\u5234\uD85C\uDCAE\u35AD\u6C4A\u9D7C"],["9f40","\u7C56\u9B39\u57DE\uD845\uDF6C\u5C53\u64D3\uD865\uDCD0\uD858\uDF35\uD85C\uDD64\u86AD\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"],["9f4f","\u51FE\uD847\uDF0F\u5D8E\u9703\uD847\uDDD1\u9E81\u904C\u7B1F\u9B02\u5CD1\u7BA3\u6268\u6335\u9AFF\u7BCF\u9B2A\u7C7E\u9B2E\u7C42\u7C86\u9C15\u7BFC\u9B09\u9F17\u9C1B\uD852\uDD3E\u9F5A\u5573\u5BC3\u4FFD\u9E98\u4FF2\u5260\u3E06\u52D1\u5767\u5056\u59B7\u5E12\u97C8\u9DAB\u8F5C\u5469\u97B4\u9940\u97BA\u532C\u6130"],["9fa1","\u692C\u53DA\u9C0A\u9D02\u4C3B\u9641\u6980\u50A6\u7546\uD845\uDF6D\u99DA\u5273"],["9fae","\u9159\u9681\u915C"],["9fb2","\u9151\uD863\uDE97\u637F\uD85B\uDD23\u6ACA\u5611\u918E\u757A\u6285\uD840\uDFFC\u734F\u7C70\uD857\uDC21\uD84F\uDCFD"],["9fc1","\uD852\uDD19\u76D6\u9B9D\u4E2A\uD843\uDCD4\u83BE\u8842"],["9fc9","\u5C4A\u69C0\u50ED\u577A\u521F\u5DF5\u4ECE\u6C31\uD840\uDDF2\u4F39\u549C\u54DA\u529A\u8D82\u35FE\u5F0C\u35F3"],["9fdb","\u6B52\u917C\u9FA5\u9B97\u982E\u98B4\u9ABA\u9EA8\u9E84\u717A\u7B14"],["9fe7","\u6BFA\u8818\u7F78"],["9feb","\u5620\uD869\uDE4A\u8E77\u9F53"],["9ff0","\u8DD4\u8E4F\u9E1C\u8E01\u6282\uD860\uDF7D\u8E28\u8E75\u7AD3\uD852\uDE77\u7A3E\u78D8\u6CEA\u8A67\u7607"],["a040","\uD862\uDE5A\u9F26\u6CCE\u87D6\u75C3\uD868\uDEB2\u7853\uD87E\uDC40\u8D0C\u72E2\u7371\u8B2D\u7302\u74F1\u8CEB\uD852\uDEBB\u862F\u5FBA\u88A0\u44B7"],["a055","\uD846\uDC3B\uD85B\uDE05"],["a058","\u8A7E\uD849\uDD1B"],["a05b","\u60FD\u7667\u9AD7\u9D44\u936E\u9B8F\u87F5"],["a063","\u880F\u8CF7\u732C\u9721\u9BB0\u35D6\u72B2\u4C07\u7C51\u994A\uD858\uDD59\u6159\u4C04\u9E96\u617D"],["a073","\u575F\u616F\u62A6\u6239\u62CE\u3A5C\u61E2\u53AA\uD84C\uDFF5\u6364\u6802\u35D2"],["a0a1","\u5D57\uD862\uDFC2\u8FDA\uD863\uDE39"],["a0a6","\u50D9\uD847\uDD46\u7906\u5332\u9638\uD843\uDF3B\u4065"],["a0ae","\u77FE"],["a0b0","\u7CC2\uD857\uDF1A\u7CDA\u7A2D\u8066\u8063\u7D4D\u7505\u74F2\u8994\u821A\u670C\u8062\uD85D\uDC86\u805B\u74F0\u8103\u7724\u8989\uD859\uDFCC\u7553\uD85B\uDED1\u87A9\u87CE\u81C8\u878C\u8A49\u8CAD\u8B43\u772B\u74F8\u84DA\u3635\u69B2\u8DA6"],["a0d4","\u89A9\u7468\u6DB9\u87C1\uD850\uDC11\u74E7\u3DDB\u7176\u60A4\u619C\u3CD1\u7162\u6077"],["a0e2","\u7F71\uD862\uDF2D\u7250\u60E9\u4B7E\u5220\u3C18\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD\u5CC1\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E\u4562\u5B1F\uD858\uDF4C\u9F50\u9EA6\uD858\uDE6B"],["a3c0","\u2400",31,"\u2421"],["c6a1","\u2460",9,"\u2474",9,"\u2170",9,"\u4E36\u4E3F\u4E85\u4EA0\u5182\u5196\u51AB\u52F9\u5338\u5369\u53B6\u590A\u5B80\u5DDB\u2F33\u5E7F\u5EF4\u5F50\u5F61\u6534\u65E0\u7592\u7676\u8FB5\u96B6\xa8\u02C6\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\uFF3B\uFF3D\u273D\u3041",23],["c740","\u3059",58,"\u30A1\u30A2\u30A3\u30A4"],["c7a1","\u30A5",81,"\u0410",5,"\u0401\u0416",4],["c840","\u041B",26,"\u0451\u0436",25,"\u21E7\u21B8\u21B9\u31CF\uD840\uDCCC\u4E5A\uD840\uDC8A\u5202\u4491"],["c8a1","\u9FB0\u5188\u9FB1\uD85D\uDE07"],["c8cd","\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u309B\u309C\u2E80\u2E84\u2E86\u2E87\u2E88\u2E8A\u2E8C\u2E8D\u2E95\u2E9C\u2E9D\u2EA5\u2EA7\u2EAA\u2EAC\u2EAE\u2EB6\u2EBC\u2EBE\u2EC6\u2ECA\u2ECC\u2ECD\u2ECF\u2ED6\u2ED7\u2EDE\u2EE3"],["c8f5","\u0283\u0250\u025B\u0254\u0275\u0153\xf8\u014B\u028A\u026A"],["f9fe","\uFFED"],["fa40","\uD841\uDD47\u92DB\uD841\uDDDF\uD84F\uDFC5\u854C\u42B5\u73EF\u51B5\u3649\uD852\uDD42\uD862\uDDE4\u9344\uD846\uDDDB\u82EE\uD84F\uDCC8\u783C\u6744\u62DF\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05\u4FAB\uD849\uDCED\u5008\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13\u5029\uD840\uDF7E\u5FA4\uD840\uDF80\uD840\uDF47\u6EDB\uD841\uDC1F\u507D\u5101\u347A\u510E\u986C\u3743\u8416\uD852\uDDA4\uD841\uDC87\u5160\uD84C\uDFB4\u516A\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83\u5B82\u877D\uD841\uDDB3\uD84F\uDC99\u51B2\u51B8"],["faa1","\u9D34\u51C9\u51CF\u51D1\u3CDC\u51D3\uD852\uDEA6\u51B3\u51E2\u5342\u51ED\u83CD\u693E\uD84D\uDF2D\u5F7B\u520B\u5226\u523C\u52B5\u5257\u5294\u52B9\u52C5\u7C15\u8542\u52E0\u860D\uD85A\uDF13\u5305\uD862\uDEDE\u5549\u6ED9\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC\u5333\u5344\uD842\uDFE2\u6CCB\uD845\uDF26\u681B\u73D5\u604A\u3EAA\u38CC\uD845\uDEE8\u71DD\u44A2\u536D\u5374\uD861\uDEAB\u537E\u537F\uD845\uDD96\uD845\uDE13\u77E6\u5393\uD862\uDE9B\u53A0\u53AB\u53AE\u73A7\uD855\uDF72\u3F59\u739C\u53C1\u53C5\u6C49\u4E49\u57FE\u53D9\u3AAB\uD842\uDF8F\u53E0\uD84F\uDFEB\uD84B\uDDA3\u53F6\uD843\uDC77\u5413\u7079\u552B\u6657\u6D5B\u546D\uD85A\uDF53\uD843\uDD74\u555D\u548F\u54A4\u47A6\uD845\uDF0D\uD843\uDEDD\u3DB4\uD843\uDD4D"],["fb40","\uD862\uDDBC\uD849\uDE98\u5547\u4CED\u542F\u7417\u5586\u55A9\u5605\uD846\uDCD7\uD850\uDC3A\u4552\uD851\uDC35\u66B3\uD844\uDCB4\u5637\u66CD\uD84C\uDE8A\u66A4\u66AD\u564D\u564F\u78F1\u56F1\u9787\u53FE\u5700\u56EF\u56ED\uD862\uDF66\u3623\uD844\uDE4F\u5746\uD850\uDDA5\u6C6E\u708B\u5742\u36B1\uD85B\uDC7E\u57E6\uD845\uDC16\u5803\uD845\uDC54\uD850\uDF63\u5826\uD852\uDFF5\u585C\u58AA\u3561\u58E0\u58DC\uD844\uDE3C\u58FB\u5BFF\u5743\uD868\uDD50\uD850\uDE78\u93D3\u35A1\u591F\u68A6\u36C3\u6E59"],["fba1","\uD845\uDE3E\u5A24\u5553\uD845\uDE92\u8505\u59C9\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC\u59D9\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6\u6D71\uD846\uDC28\uD845\uDED5\u59F9\uD85B\uDE45\u5AAB\u5A63\u36E6\uD852\uDDA9\u5A77\u3708\u5A96\u7465\u5AD3\uD85B\uDFA1\uD849\uDD54\u3D85\uD846\uDD11\u3732\uD845\uDEB8\u5E83\u52D0\u5B76\u6588\u5B7C\uD85E\uDE0E\u4004\u485D\uD840\uDE04\u5BD5\u6160\uD846\uDE34\uD856\uDDCC\uD841\uDDA5\u5BF3\u5B9D\u4D10\u5C05\uD846\uDF44\u5C13\u73CE\u5C14\uD847\uDCA5\uD85A\uDF28\u5C49\u48DD\u5C85\u5CE9\u5CEF\u5D8B\uD847\uDDF9\uD847\uDE37\u5D10\u5D18\u5D46\uD847\uDEA4\u5CBA\u5DD7\u82FC\u382D\uD852\uDD01\uD848\uDC49\uD848\uDD73\u8287\u3836\u3BC2\u5E2E\u6A8A\u5E75\u5E7A\uD851\uDCBC\uD843\uDCD3\u53A6\u4EB7\u5ED0\u53A8\uD845\uDF71\u5E09\u5EF4\uD861\uDC82"],["fc40","\u5EF9\u5EFB\u38A0\u5EFC\u683E\u941B\u5F0D\uD840\uDDC1\uD87E\uDC94\u3ADE\u48AE\uD844\uDF3A\u5F3A\uD85A\uDC88\uD848\uDFD0\u5F58\uD849\uDC71\u5F63\u97BD\uD85B\uDE6E\u5F72\u9340\uD862\uDE36\u5FA7\u5DB6\u3D5F\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68\u91D6\uD840\uDE9E\uD862\uDE29\u6031\u6685\uD846\uDC77\u3963\u3DC7\u3639\u5790\uD849\uDFB4\u7971\u3E40\u609E\u60A4\u60B3\uD852\uDD82\uD852\uDD8F\uD85E\uDE53\u74A4\u50E1\u5AA0\u6164\u8424\u6142\uD87E\uDCA6\uD85B\uDED2\u6181\u51F4\uD841\uDE56\u6187\u5BAA\uD84F\uDFB7"],["fca1","\uD84A\uDC5F\u61D3\uD862\uDF9D\uD866\uDD5D\u61D0\u3932\uD84A\uDD80\uD84A\uDCC1\u6023\u615C\u651E\u638B\uD840\uDD18\u62C5\uD845\uDF70\u62D5\uD84B\uDE0D\u636C\uD852\uDDDF\u3A17\u6438\u63F8\uD844\uDF8E\uD845\uDFFC\u6490\u6F8A\uD84B\uDE36\u9814\uD850\uDC8C\uD855\uDF1D\u64E1\u64E5\u947B\u3A66\u643A\u3A57\u654D\u6F16\uD852\uDE28\uD852\uDE23\u6585\u656D\u655F\uD84C\uDC7E\u65B5\uD852\uDD40\u4B37\u65D1\u40D8\uD846\uDC29\u65E0\u65E3\u5FDF\uD84D\uDC00\u6618\uD84C\uDDF7\uD84C\uDDF8\u6644\uD84C\uDDA4\uD84C\uDDA5\u664B\uD843\uDE75\u6667\uD854\uDDE6\u6673\u6674\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13\u77C5\uD84A\uDCF7\u99A4\u6702\uD850\uDF9C\uD852\uDE21\u3B2B\u69FA\uD84D\uDFC2\u675E\u6767\u6762\uD850\uDDCD\uD864\uDCED\u67D7\u44E9\u6822\u6E50\u923C\u6801\uD84C\uDFE6\uD85B\uDDA0\u685D"],["fd40","\uD84D\uDC6F\u69E1\u6A0B\uD862\uDEDF\u6973\u68C3\uD84D\uDDCD\u6901\u6900\u3D32\u3A01\uD84D\uDE3C\u3B80\u67AC\u6961\uD862\uDE4A\u42FC\u6936\u6998\u3BA1\uD840\uDFC9\u8363\u5090\u69F9\uD84D\uDE59\uD848\uDD2A\u6A45\uD84D\uDF03\u6A9D\u3BF3\u67B1\u6AC8\uD864\uDD9C\u3C0D\u6B1D\uD842\uDD23\u60DE\u6B35\u6B74\uD849\uDFCD\u6EB5\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58\u3740\u5421\uD84E\uDF5A\u6BE1\uD84F\uDEFC\u6BDC\u6C37\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51\u6C5A\u8226\u6C79\uD84F\uDDBC\u44C5\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"],["fda1","\uD84F\uDCC9\u36E5\u3CEB\uD843\uDD32\u9B83\uD84C\uDDF9\uD849\uDC91\u7F8F\u6837\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB\u6D96\u6D5C\u6E7C\u6F04\uD852\uDD7F\uD850\uDC85\uD85B\uDE72\u8533\uD85B\uDF74\u51C7\u6C9C\u6E1D\u842E\uD862\uDF21\u6E2F\uD84F\uDE2F\u7453\uD84F\uDF82\u79CC\u6E4F\u5A91\uD84C\uDC4B\u6FF8\u370D\u6F9D\uD84F\uDE30\u6EFA\uD845\uDC97\uD850\uDC3D\u4555\u93F0\u6F44\u6F5C\u3D4E\u6F74\uD864\uDD70\u3D3B\u6F9F\uD850\uDD44\u6FD3\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F\u51DF\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD\u704B\u707E\u70A7\u7081\u70CC\u70D5\u70D6\u70DF\u4104\u3DE8\u71B4\u7196\uD850\uDE77\u712B\u7145\u5A88\u714A\u716E\u5C9C\uD850\uDF65\u714F\u9362\uD850\uDEC1\u712C\uD851\uDC5A\uD852\uDE27\uD852\uDE22\u71BA\uD862\uDFE8\u70BD\u720E"],["fe40","\u9442\u7215\u5911\u9443\u7224\u9341\uD855\uDE05\u722E\u7240\uD852\uDD74\u68BD\u7255\u7257\u3E55\uD84C\uDC44\u680D\u6F3D\u7282\u732A\u732B\uD852\uDC23\uD862\uDC2B\u48ED\uD862\uDC04\u7328\u732E\u73CF\u73AA\uD843\uDC3A\uD85A\uDE2E\u73C9\u7449\uD850\uDDE2\uD845\uDEE7\uD852\uDE24\u6623\u36C5\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB\u73F7\u7415\u6903\uD852\uDE26\u7439\uD841\uDDC3\u3ED7\u745C\uD84A\uDCAD\u7460\uD863\uDEB2\u7447\u73E4\u7476\u83B9\u746C\u3730\u7474\u93F1\u6A2C\u7482\u4953\uD852\uDE8C"],["fea1","\uD850\uDD5F\uD852\uDE79\uD862\uDF8F\u5B46\uD863\uDC03\uD846\uDC9E\u74C8\uD846\uDD88\u750E\u74E9\u751E\uD863\uDED9\uD846\uDE4B\u5BD7\uD863\uDEAC\u9385\u754D\u754A\u7567\u756E\uD853\uDF82\u3F04\uD853\uDD13\u758E\u745D\u759E\u75B4\u7602\u762C\u7651\u764F\u766F\u7676\uD858\uDFF5\u7690\u81EF\u37F8\uD85A\uDD11\uD85A\uDD0E\u76A1\u76A5\u76B7\u76CC\uD85B\uDF9F\u8462\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C\u771E\u7726\u7740\u64AF\uD854\uDE20\u7758\uD84C\uDEAC\u77AF\uD862\uDD64\uD862\uDD68\uD845\uDEC1\u77F4\u7809\uD844\uDF76\uD852\uDE12\u68CA\u78AF\u78C7\u78D3\u96A5\u792E\uD855\uDDE0\u78D7\u7934\u78B1\uD85D\uDE0C\u8FB8\u8884\uD862\uDF2B\uD858\uDC83\uD849\uDE1C\u7986\u8900\u6902\u7980\uD856\uDC57\u799D\uD85E\uDF39\u793C\u79A9\u6E2A\uD85C\uDD26\u3EA8\u79C6\uD864\uDD0D\u79D4"]]');

});



parcelRegister("kjyEk", function(module, exports) {
"use strict";

});


parcelRegister("796Jz", function(module, exports) {

module.exports = (parcelRequire("cIbJ2"));

});
parcelRegister("cIbJ2", function(module, exports) {

$parcel$export(module.exports, "detect", () => $9412b08a7b5df1c7$export$17b446b869dad473, (v) => $9412b08a7b5df1c7$export$17b446b869dad473 = v);
$parcel$export(module.exports, "detectAll", () => $9412b08a7b5df1c7$export$40146553141f337d, (v) => $9412b08a7b5df1c7$export$40146553141f337d = v);
$parcel$export(module.exports, "UniversalDetector", () => $9412b08a7b5df1c7$export$fbe6cb867ab86f3e, (v) => $9412b08a7b5df1c7$export$fbe6cb867ab86f3e = v);
$parcel$export(module.exports, "enableDebug", () => $9412b08a7b5df1c7$export$917ee82f43ea172b, (v) => $9412b08a7b5df1c7$export$917ee82f43ea172b = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ var $9412b08a7b5df1c7$export$17b446b869dad473;
var $9412b08a7b5df1c7$export$40146553141f337d;
var $9412b08a7b5df1c7$export$fbe6cb867ab86f3e;
var $9412b08a7b5df1c7$export$917ee82f43ea172b;

var $6ZWSX = parcelRequire("6ZWSX");
var $9412b08a7b5df1c7$require$Buffer = $6ZWSX.Buffer;

var $wswMl = parcelRequire("wswMl");

var $87x91 = parcelRequire("87x91");
var $9412b08a7b5df1c7$require$setLogger = $87x91.setLogger;
$9412b08a7b5df1c7$export$17b446b869dad473 = function(buffer, options) {
    var u = $9412b08a7b5df1c7$var$runUniversalDetector(buffer, options);
    return u.result;
};
$9412b08a7b5df1c7$export$40146553141f337d = function(buffer, options) {
    var u = $9412b08a7b5df1c7$var$runUniversalDetector(buffer, options);
    return u.results;
};
$9412b08a7b5df1c7$export$fbe6cb867ab86f3e = $wswMl;
$9412b08a7b5df1c7$export$917ee82f43ea172b = function() {
    $9412b08a7b5df1c7$require$setLogger(console.log.bind(console));
};
function $9412b08a7b5df1c7$var$runUniversalDetector(buffer, options) {
    var u = new $wswMl(options);
    u.reset();
    if (typeof $9412b08a7b5df1c7$require$Buffer == 'function' && buffer instanceof $9412b08a7b5df1c7$require$Buffer) u.feed(buffer.toString('binary'));
    else u.feed(buffer);
    u.close();
    return u;
}

});
parcelRegister("wswMl", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ /**
 * This is a port from the python port, version "2.0.1"
 */ 
var $8hFBI = parcelRequire("8hFBI");

var $7PDlh = parcelRequire("7PDlh");

var $6rWe8 = parcelRequire("6rWe8");

var $3K5jA = parcelRequire("3K5jA");

var $hMYxR = parcelRequire("hMYxR");

var $87x91 = parcelRequire("87x91");
function $06191e473ad6f4c8$var$UniversalDetector(options) {
    if (!options) options = {};
    if (!options.minimumThreshold) options.minimumThreshold = 0.20;
    var _state = {
        pureAscii: 0,
        escAscii: 1,
        highbyte: 2
    };
    var self = this;
    function init() {
        self._highBitDetector = /[\x80-\xFF]/;
        self._escDetector = /(\x1B|~\{)/;
        self._mEscCharsetProber = null;
        self._mCharsetProbers = [];
        self.reset();
    }
    this.reset = function() {
        this.result = {
            "encoding": null,
            "confidence": 0.0
        };
        this.results = [];
        this.done = false;
        this._mStart = true;
        this._mGotData = false;
        this._mInputState = _state.pureAscii;
        this._mLastChar = "";
        this._mBOM = "";
        if (this._mEscCharsetProber) this._mEscCharsetProber.reset();
        for(var i = 0, prober; prober = this._mCharsetProbers[i]; i++)prober.reset();
    };
    this.feed = function(aBuf) {
        if (this.done) return;
        var aLen = aBuf.length;
        if (!aLen) return;
        if (!this._mGotData) {
            this._mBOM += aBuf;
            // If the data starts with BOM, we know it is UTF
            if (this._mBOM.slice(0, 3) == "\xEF\xBB\xBF") // EF BB BF  UTF-8 with BOM
            this.result = {
                "encoding": "UTF-8",
                "confidence": 1.0
            };
            else if (this._mBOM.slice(0, 4) == "\xFF\xFE\x00\x00") // FF FE 00 00  UTF-32, little-endian BOM
            this.result = {
                "encoding": "UTF-32LE",
                "confidence": 1.0
            };
            else if (this._mBOM.slice(0, 4) == "\x00\x00\xFE\xFF") // 00 00 FE FF  UTF-32, big-endian BOM
            this.result = {
                "encoding": "UTF-32BE",
                "confidence": 1.0
            };
            else if (this._mBOM.slice(0, 4) == "\xFE\xFF\x00\x00") // FE FF 00 00  UCS-4, unusual octet order BOM (3412)
            this.result = {
                "encoding": "X-ISO-10646-UCS-4-3412",
                "confidence": 1.0
            };
            else if (this._mBOM.slice(0, 4) == "\x00\x00\xFF\xFE") // 00 00 FF FE  UCS-4, unusual octet order BOM (2143)
            this.result = {
                "encoding": "X-ISO-10646-UCS-4-2143",
                "confidence": 1.0
            };
            else if (this._mBOM.slice(0, 2) == "\xFF\xFE") // FF FE  UTF-16, little endian BOM
            this.result = {
                "encoding": "UTF-16LE",
                "confidence": 1.0
            };
            else if (this._mBOM.slice(0, 2) == "\xFE\xFF") // FE FF  UTF-16, big endian BOM
            this.result = {
                "encoding": "UTF-16BE",
                "confidence": 1.0
            };
            if (this.result.confidence > 0) this.results = [
                this.result
            ];
            // If we got to 4 chars without being able to detect a BOM we
            // stop trying.
            if (this._mBOM.length > 3) this._mGotData = true;
        }
        if (this.result.encoding && this.result.confidence > 0.0) {
            this.done = true;
            return;
        }
        if (this._mInputState == _state.pureAscii) {
            if (this._highBitDetector.test(aBuf)) this._mInputState = _state.highbyte;
            else if (this._escDetector.test(this._mLastChar + aBuf)) this._mInputState = _state.escAscii;
        }
        this._mLastChar = aBuf.slice(-1);
        if (this._mInputState == _state.escAscii) {
            if (!this._mEscCharsetProber) this._mEscCharsetProber = new $hMYxR();
            if (this._mEscCharsetProber.feed(aBuf) == $8hFBI.foundIt) {
                this.result = {
                    "encoding": this._mEscCharsetProber.getCharsetName(),
                    "confidence": this._mEscCharsetProber.getConfidence()
                };
                this.results = [
                    this.result
                ];
                this.done = true;
            }
        } else if (this._mInputState == _state.highbyte) {
            if (this._mCharsetProbers.length == 0) this._mCharsetProbers = [
                new $7PDlh(),
                new $6rWe8(),
                new $3K5jA()
            ];
            for(var i = 0, prober; prober = this._mCharsetProbers[i]; i++)if (prober.feed(aBuf) == $8hFBI.foundIt) {
                this.result = {
                    "encoding": prober.getCharsetName(),
                    "confidence": prober.getConfidence()
                };
                this.results = [
                    this.result
                ];
                this.done = true;
                break;
            }
        }
    };
    this.close = function() {
        if (this.done) return;
        if (this._mBOM.length === 0) {
            $87x91.log("no data received!\n");
            return;
        }
        this.done = true;
        if (this._mInputState == _state.pureAscii) {
            $87x91.log("pure ascii");
            this.result = {
                "encoding": "ascii",
                "confidence": 1.0
            };
            this.results.push(this.result);
            return this.result;
        }
        if (this._mInputState == _state.highbyte) {
            for(var i = 0, prober; prober = this._mCharsetProbers[i]; i++){
                if (!prober || !prober.getCharsetName()) continue;
                this.results.push({
                    "encoding": prober.getCharsetName(),
                    "confidence": prober.getConfidence()
                });
                $87x91.log(prober.getCharsetName() + " confidence " + prober.getConfidence());
            }
            this.results.sort(function(a, b) {
                return b.confidence - a.confidence;
            });
            if (this.results.length > 0) {
                var topResult = this.results[0];
                if (topResult.confidence >= options.minimumThreshold) {
                    this.result = topResult;
                    return topResult;
                }
            }
        }
        if ($87x91.enabled) {
            $87x91.log("no probers hit minimum threshhold\n");
            for(var i = 0, prober; prober = this._mCharsetProbers[i]; i++){
                if (!prober) continue;
                $87x91.log(prober.getCharsetName() + " confidence = " + prober.getConfidence() + "\n");
            }
        }
    };
    init();
}
module.exports = $06191e473ad6f4c8$var$UniversalDetector;

});
parcelRegister("8hFBI", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ module.exports = {
    detecting: 0,
    foundIt: 1,
    notMe: 2,
    start: 0,
    error: 1,
    itsMe: 2,
    SHORTCUT_THRESHOLD: 0.95
};

});

parcelRegister("7PDlh", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $jGBbN = parcelRequire("jGBbN");

var $vv2dX = parcelRequire("vv2dX");

var $iMAyi = parcelRequire("iMAyi");

var $3XgFd = parcelRequire("3XgFd");

var $gvf1X = parcelRequire("gvf1X");

var $gmbm9 = parcelRequire("gmbm9");

var $17rCU = parcelRequire("17rCU");

var $csMjn = parcelRequire("csMjn");
function $5b3bd05a7a70d8aa$var$MBCSGroupProber() {
    $jGBbN.apply(this);
    this._mProbers = [
        new $iMAyi(),
        new $3XgFd(),
        new $gvf1X(),
        new $gmbm9(),
        new $17rCU(),
        new $vv2dX(),
        new $csMjn()
    ];
    this.reset();
}
$5b3bd05a7a70d8aa$var$MBCSGroupProber.prototype = new $jGBbN();
module.exports = $5b3bd05a7a70d8aa$var$MBCSGroupProber;

});
parcelRegister("jGBbN", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $8hFBI = parcelRequire("8hFBI");

var $2SPVp = parcelRequire("2SPVp");

var $87x91 = parcelRequire("87x91");
function $e54ec9929ff18d6d$var$CharSetGroupProber() {
    $2SPVp.apply(this);
    var self = this;
    function init() {
        self._mActiveNum = 0;
        self._mProbers = [];
        self._mBestGuessProber = null;
    }
    this.reset = function() {
        $e54ec9929ff18d6d$var$CharSetGroupProber.prototype.reset.apply(this);
        this._mActiveNum = 0;
        for(var i = 0, prober; prober = this._mProbers[i]; i++)if (prober) {
            prober.reset();
            prober.active = true;
            this._mActiveNum++;
        }
        this._mBestGuessProber = null;
    };
    this.getCharsetName = function() {
        if (!this._mBestGuessProber) {
            this.getConfidence();
            if (!this._mBestGuessProber) return null;
        }
        return this._mBestGuessProber.getCharsetName();
    };
    this.feed = function(aBuf) {
        for(var i = 0, prober; prober = this._mProbers[i]; i++){
            if (!prober || !prober.active) continue;
            var st = prober.feed(aBuf);
            if (!st) continue;
            if (st == $8hFBI.foundIt) {
                this._mBestGuessProber = prober;
                return this.getState();
            } else if (st == $8hFBI.notMe) {
                prober.active = false;
                this._mActiveNum--;
                if (this._mActiveNum <= 0) {
                    this._mState = $8hFBI.notMe;
                    return this.getState();
                }
            }
        }
        return this.getState();
    };
    this.getConfidence = function() {
        var st = this.getState();
        if (st == $8hFBI.foundIt) return 0.99;
        else if (st == $8hFBI.notMe) return 0.01;
        var bestConf = 0.0;
        this._mBestGuessProber = null;
        for(var i = 0, prober; prober = this._mProbers[i]; i++){
            if (!prober) continue;
            if (!prober.active) {
                $87x91.log(prober.getCharsetName() + " not active\n");
                continue;
            }
            var cf = prober.getConfidence();
            $87x91.log(prober.getCharsetName() + " confidence = " + cf + "\n");
            if (bestConf < cf) {
                bestConf = cf;
                this._mBestGuessProber = prober;
            }
        }
        if (!this._mBestGuessProber) return 0.0;
        return bestConf;
    };
    init();
}
$e54ec9929ff18d6d$var$CharSetGroupProber.prototype = new $2SPVp();
module.exports = $e54ec9929ff18d6d$var$CharSetGroupProber;

});
parcelRegister("2SPVp", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $8hFBI = parcelRequire("8hFBI");
function $2198e726a80a2cc8$var$CharSetProber() {
    this.reset = function() {
        this._mState = $8hFBI.detecting;
    };
    this.getCharsetName = function() {
        return null;
    };
    this.feed = function(aBuf) {};
    this.getState = function() {
        return this._mState;
    };
    this.getConfidence = function() {
        return 0.0;
    };
    this.filterHighBitOnly = function(aBuf) {
        aBuf = aBuf.replace(/[\x00-\x7F]+/g, " ");
        return aBuf;
    };
    this.filterWithoutEnglishLetters = function(aBuf) {
        aBuf = aBuf.replace(/[A-Za-z]+/g, " ");
        return aBuf;
    };
    // Input: aBuf is a string containing all different types of characters
    // Output: a string that contains all alphabetic letters, high-byte characters, and word immediately preceding `>`, but nothing else within `<>`
    // Ex: input - '¡£º <div blah blah> abcdef</div> apples! * and oranges 9jd93jd>'
    //     output - '¡£º blah div apples and oranges jd jd '
    this.filterWithEnglishLetters = function(aBuf) {
        var result = '';
        var inTag = false;
        var prev = 0;
        for(var curr = 0; curr < aBuf.length; curr++){
            var c = aBuf[curr];
            if (c == '>') inTag = false;
            else if (c == '<') inTag = true;
            var isAlpha = /[a-zA-Z]/.test(c);
            var isASCII = /^[\x00-\x7F]*$/.test(c);
            if (isASCII && !isAlpha) {
                if (curr > prev && !inTag) result = result + aBuf.substring(prev, curr) + ' ';
                prev = curr + 1;
            }
        }
        if (!inTag) result = result + aBuf.substring(prev);
        return result;
    };
}
module.exports = $2198e726a80a2cc8$var$CharSetProber;

});

parcelRegister("87x91", function(module, exports) {

$parcel$export(module.exports, "log", () => $5e98aff8add860b5$export$bef1f36f5486a6a3, (v) => $5e98aff8add860b5$export$bef1f36f5486a6a3 = v);
$parcel$export(module.exports, "setLogger", () => $5e98aff8add860b5$export$3abbd92f765bee58, (v) => $5e98aff8add860b5$export$3abbd92f765bee58 = v);
$parcel$export(module.exports, "enabled", () => $5e98aff8add860b5$export$25eaa035e2e3a214, (v) => $5e98aff8add860b5$export$25eaa035e2e3a214 = v);
// By default, do nothing
var $5e98aff8add860b5$export$bef1f36f5486a6a3;
var $5e98aff8add860b5$export$3abbd92f765bee58;
var $5e98aff8add860b5$export$25eaa035e2e3a214;
$5e98aff8add860b5$export$bef1f36f5486a6a3 = function() {};
$5e98aff8add860b5$export$3abbd92f765bee58 = function setLogger(loggerFunction) {
    $5e98aff8add860b5$export$25eaa035e2e3a214 = true;
    $5e98aff8add860b5$export$bef1f36f5486a6a3 = loggerFunction;
};

});


parcelRegister("vv2dX", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $3xI8B = parcelRequire("3xI8B");

var $14x9i = parcelRequire("14x9i");

var $7xkUW = parcelRequire("7xkUW");

var $a1Zfb = parcelRequire("a1Zfb");
var $05eaf83e7cf78d16$require$Big5DistributionAnalysis = $a1Zfb.Big5DistributionAnalysis;
function $05eaf83e7cf78d16$var$Big5Prober() {
    $14x9i.apply(this);
    var self = this;
    function init() {
        self._mCodingSM = new $3xI8B($7xkUW);
        self._mDistributionAnalyzer = new $05eaf83e7cf78d16$require$Big5DistributionAnalysis();
        self.reset();
    }
    this.getCharsetName = function() {
        return "Big5";
    };
    init();
}
$05eaf83e7cf78d16$var$Big5Prober.prototype = new $14x9i();
module.exports = $05eaf83e7cf78d16$var$Big5Prober;

});
parcelRegister("3xI8B", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $8hFBI = parcelRequire("8hFBI");
function $2946b0fd5835c473$var$CodingStateMachine(sm) {
    var self = this;
    function init(sm) {
        self._mModel = sm;
        self._mCurrentBytePos = 0;
        self._mCurrentCharLen = 0;
        self.reset();
    }
    this.reset = function() {
        this._mCurrentState = $8hFBI.start;
    };
    this.nextState = function(c) {
        // for each byte we get its class
        // if it is first byte, we also get byte length
        var byteCls = this._mModel.classTable[c.charCodeAt(0)];
        if (this._mCurrentState == $8hFBI.start) {
            this._mCurrentBytePos = 0;
            this._mCurrentCharLen = this._mModel.charLenTable[byteCls];
        }
        // from byte's class and stateTable, we get its next state
        this._mCurrentState = this._mModel.stateTable[this._mCurrentState * this._mModel.classFactor + byteCls];
        this._mCurrentBytePos++;
        return this._mCurrentState;
    };
    this.getCurrentCharLen = function() {
        return this._mCurrentCharLen;
    };
    this.getCodingStateMachine = function() {
        return this._mModel.name;
    };
    init(sm);
}
module.exports = $2946b0fd5835c473$var$CodingStateMachine;

});

parcelRegister("14x9i", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $2SPVp = parcelRequire("2SPVp");

var $8hFBI = parcelRequire("8hFBI");

var $87x91 = parcelRequire("87x91");
function $0c7fe0db0bb70c44$var$MultiByteCharSetProber() {
    $2SPVp.apply(this);
    var self = this;
    function init() {
        self._mDistributionAnalyzer = null;
        self._mCodingSM = null;
        //self._mLastChar = ["\x00", "\x00"];
        self._mLastChar = "\x00\x00";
    }
    this.reset = function() {
        $0c7fe0db0bb70c44$var$MultiByteCharSetProber.prototype.reset.apply(this);
        if (this._mCodingSM) this._mCodingSM.reset();
        if (this._mDistributionAnalyzer) this._mDistributionAnalyzer.reset();
        //this._mLastChar = ["\x00", "\x00"];
        this._mLastChar = "\x00\x00";
    };
    this.getCharsetName = function() {};
    this.feed = function(aBuf) {
        var aLen = aBuf.length;
        for(var i = 0; i < aLen; i++){
            var codingState = this._mCodingSM.nextState(aBuf[i]);
            if (codingState == $8hFBI.error) {
                $87x91.log(this.getCharsetName() + " prober hit error at byte " + i + "\n");
                this._mState = $8hFBI.notMe;
                break;
            } else if (codingState == $8hFBI.itsMe) {
                this._mState = $8hFBI.foundIt;
                break;
            } else if (codingState == $8hFBI.start) {
                var charLen = this._mCodingSM.getCurrentCharLen();
                if (i == 0) {
                    this._mLastChar[1] = aBuf[0];
                    this._mDistributionAnalyzer.feed(this._mLastChar, charLen);
                } else this._mDistributionAnalyzer.feed(aBuf.slice(i - 1, i + 1), charLen);
            }
        }
        this._mLastChar[0] = aBuf[aLen - 1];
        if (this.getState() == $8hFBI.detecting) {
            if (this._mDistributionAnalyzer.gotEnoughData() && this.getConfidence() > $8hFBI.SHORTCUT_THRESHOLD) this._mState = $8hFBI.foundIt;
        }
        return this.getState();
    };
    this.getConfidence = function() {
        return this._mDistributionAnalyzer.getConfidence();
    };
}
$0c7fe0db0bb70c44$var$MultiByteCharSetProber.prototype = new $2SPVp();
module.exports = $0c7fe0db0bb70c44$var$MultiByteCharSetProber;

});

parcelRegister("7xkUW", function(module, exports) {

var $8hFBI = parcelRequire("8hFBI");
var $57cbd7387607713b$var$BIG5_cls = [
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0 // f8 - ff
];
var $57cbd7387607713b$var$BIG5_st = [
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    3,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start //10-17
];
var $57cbd7387607713b$var$Big5CharLenTable = [
    0,
    1,
    1,
    2,
    0
];
module.exports = {
    "classTable": $57cbd7387607713b$var$BIG5_cls,
    "classFactor": 5,
    "stateTable": $57cbd7387607713b$var$BIG5_st,
    "charLenTable": $57cbd7387607713b$var$Big5CharLenTable,
    "name": "Big5"
};

});

parcelRegister("a1Zfb", function(module, exports) {

$parcel$export(module.exports, "EUCTWDistributionAnalysis", () => $74d9812244804ab2$export$6a0530bde43421ed, (v) => $74d9812244804ab2$export$6a0530bde43421ed = v);
$parcel$export(module.exports, "EUCKRDistributionAnalysis", () => $74d9812244804ab2$export$4ed7baa8693b012f, (v) => $74d9812244804ab2$export$4ed7baa8693b012f = v);
$parcel$export(module.exports, "GB2312DistributionAnalysis", () => $74d9812244804ab2$export$e27aa2f87087c245, (v) => $74d9812244804ab2$export$e27aa2f87087c245 = v);
$parcel$export(module.exports, "Big5DistributionAnalysis", () => $74d9812244804ab2$export$6c17dd4b2cddd39e, (v) => $74d9812244804ab2$export$6c17dd4b2cddd39e = v);
$parcel$export(module.exports, "SJISDistributionAnalysis", () => $74d9812244804ab2$export$d7b3478af73cf9f2, (v) => $74d9812244804ab2$export$d7b3478af73cf9f2 = v);
$parcel$export(module.exports, "EUCJPDistributionAnalysis", () => $74d9812244804ab2$export$f3eb7c74ebce6ac7, (v) => $74d9812244804ab2$export$f3eb7c74ebce6ac7 = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ var $74d9812244804ab2$export$4d3e0a828c4e9692;
var $74d9812244804ab2$export$6a0530bde43421ed;
var $74d9812244804ab2$export$4ed7baa8693b012f;
var $74d9812244804ab2$export$e27aa2f87087c245;
var $74d9812244804ab2$export$6c17dd4b2cddd39e;
var $74d9812244804ab2$export$d7b3478af73cf9f2;
var $74d9812244804ab2$export$f3eb7c74ebce6ac7;

var $5SMLi = parcelRequire("5SMLi");

var $6CKw7 = parcelRequire("6CKw7");

var $bytDp = parcelRequire("bytDp");

var $cVcw3 = parcelRequire("cVcw3");

var $61Jcp = parcelRequire("61Jcp");
function $74d9812244804ab2$var$CharDistributionAnalysis() {
    var ENOUGH_DATA_THRESHOLD = 1024;
    var SURE_YES = 0.99;
    var SURE_NO = 0.01;
    var MINIMUM_DATA_THRESHOLD = 3;
    var self = this;
    function init() {
        self._mCharToFreqOrder = null; // Mapping table to get frequency order from char order (get from GetOrder())
        self._mTableSize = null; // Size of above table
        self._mTypicalDistributionRatio = null; // This is a constant value which varies from language to language, used in calculating confidence.  See http://www.mozilla.org/projects/intl/UniversalCharsetDetection.html for further detail.
        self.reset();
    }
    /**
     * reset analyser, clear any state
     */ this.reset = function() {
        this._mDone = false; // If this flag is set to constants.True, detection is done and conclusion has been made
        this._mTotalChars = 0; // Total characters encountered
        this._mFreqChars = 0; // The number of characters whose frequency order is less than 512
    };
    /**
     * feed a character with known length
     */ this.feed = function(aStr, aCharLen) {
        if (aCharLen == 2) // we only care about 2-bytes character in our distribution analysis
        var order = this.getOrder(aStr);
        else order = -1;
        if (order >= 0) {
            this._mTotalChars++;
            // order is valid
            if (order < this._mTableSize) {
                if (512 > this._mCharToFreqOrder[order]) this._mFreqChars++;
            }
        }
    };
    /**
     * return confidence based on existing data
     */ this.getConfidence = function() {
        // if we didn't receive any character in our consideration range, return negative answer
        if (this._mTotalChars <= 0 || this._mFreqChars <= MINIMUM_DATA_THRESHOLD) return SURE_NO;
        if (this._mTotalChars != this._mFreqChars) {
            var r = this._mFreqChars / ((this._mTotalChars - this._mFreqChars) * this._mTypicalDistributionRatio);
            if (r < SURE_YES) return r;
        }
        // normalize confidence (we don't want to be 100% sure)
        return SURE_YES;
    };
    this.gotEnoughData = function() {
        // It is not necessary to receive all data to draw conclusion. For charset detection,
        // certain amount of data is enough
        return this._mTotalChars > ENOUGH_DATA_THRESHOLD;
    };
    this.getOrder = function(aStr) {
        // We do not handle characters based on the original encoding string, but
        // convert this encoding string to a number, here called order.
        // This allows multiple encodings of a language to share one frequency table.
        return -1;
    };
    init();
}
$74d9812244804ab2$export$4d3e0a828c4e9692 = $74d9812244804ab2$var$CharDistributionAnalysis;
function $74d9812244804ab2$var$EUCTWDistributionAnalysis() {
    $74d9812244804ab2$var$CharDistributionAnalysis.apply(this);
    var self = this;
    function init() {
        self._mCharToFreqOrder = $6CKw7.EUCTWCharToFreqOrder;
        self._mTableSize = $6CKw7.EUCTW_TABLE_SIZE;
        self._mTypicalDistributionRatio = $6CKw7.EUCTW_TYPICAL_DISTRIBUTION_RATIO;
    }
    this.getOrder = function(aStr) {
        // for euc-TW encoding, we are interested
        //   first  byte range: 0xc4 -- 0xfe
        //   second byte range: 0xa1 -- 0xfe
        // no validation needed here. State machine has done that
        if (aStr.charCodeAt(0) >= 0xC4) return 94 * (aStr.charCodeAt(0) - 0xC4) + aStr.charCodeAt(1) - 0xA1;
        else return -1;
    };
    init();
}
$74d9812244804ab2$var$EUCTWDistributionAnalysis.prototype = new $74d9812244804ab2$var$CharDistributionAnalysis();
$74d9812244804ab2$export$6a0530bde43421ed = $74d9812244804ab2$var$EUCTWDistributionAnalysis;
function $74d9812244804ab2$var$EUCKRDistributionAnalysis() {
    $74d9812244804ab2$var$CharDistributionAnalysis.apply(this);
    var self = this;
    function init() {
        self._mCharToFreqOrder = $bytDp.EUCKRCharToFreqOrder;
        self._mTableSize = $bytDp.EUCKR_TABLE_SIZE;
        self._mTypicalDistributionRatio = $bytDp.EUCKR_TYPICAL_DISTRIBUTION_RATIO;
    }
    this.getOrder = function(aStr) {
        // for euc-KR encoding, we are interested
        //   first  byte range: 0xb0 -- 0xfe
        //   second byte range: 0xa1 -- 0xfe
        // no validation needed here. State machine has done that
        if (aStr.charCodeAt(0) >= 0xB0) return 94 * (aStr.charCodeAt(0) - 0xB0) + aStr.charCodeAt(1) - 0xA1;
        else return -1;
    };
    init();
}
$74d9812244804ab2$var$EUCKRDistributionAnalysis.prototype = new $74d9812244804ab2$var$CharDistributionAnalysis();
$74d9812244804ab2$export$4ed7baa8693b012f = $74d9812244804ab2$var$EUCKRDistributionAnalysis;
function $74d9812244804ab2$var$GB2312DistributionAnalysis() {
    $74d9812244804ab2$var$CharDistributionAnalysis.apply(this);
    var self = this;
    function init() {
        self._mCharToFreqOrder = $cVcw3.GB2312CharToFreqOrder;
        self._mTableSize = $cVcw3.GB2312_TABLE_SIZE;
        self._mTypicalDistributionRatio = $cVcw3.GB2312_TYPICAL_DISTRIBUTION_RATIO;
    }
    this.getOrder = function(aStr) {
        // for GB2312 encoding, we are interested
        //  first  byte range: 0xb0 -- 0xfe
        //  second byte range: 0xa1 -- 0xfe
        // no validation needed here. State machine has done that
        if (aStr.charCodeAt(0) >= 0xB0 && aStr.charCodeAt(1) >= 0xA1) return 94 * (aStr.charCodeAt(0) - 0xB0) + aStr.charCodeAt(1) - 0xA1;
        else return -1;
    };
    init();
}
$74d9812244804ab2$var$GB2312DistributionAnalysis.prototype = new $74d9812244804ab2$var$CharDistributionAnalysis();
$74d9812244804ab2$export$e27aa2f87087c245 = $74d9812244804ab2$var$GB2312DistributionAnalysis;
function $74d9812244804ab2$var$Big5DistributionAnalysis() {
    $74d9812244804ab2$var$CharDistributionAnalysis.apply(this);
    var self = this;
    function init() {
        self._mCharToFreqOrder = $61Jcp.Big5CharToFreqOrder;
        self._mTableSize = $61Jcp.BIG5_TABLE_SIZE;
        self._mTypicalDistributionRatio = $61Jcp.BIG5_TYPICAL_DISTRIBUTION_RATIO;
    }
    this.getOrder = function(aStr) {
        // for big5 encoding, we are interested
        //   first  byte range: 0xa4 -- 0xfe
        //   second byte range: 0x40 -- 0x7e , 0xa1 -- 0xfe
        // no validation needed here. State machine has done that
        if (aStr.charCodeAt(0) >= 0xA4) {
            if (aStr.charCodeAt(1) >= 0xA1) return 157 * (aStr.charCodeAt(0) - 0xA4) + aStr.charCodeAt(1) - 0xA1 + 63;
            else return 157 * (aStr.charCodeAt(0) - 0xA4) + aStr.charCodeAt(1) - 0x40;
        } else return -1;
    };
    init();
}
$74d9812244804ab2$var$Big5DistributionAnalysis.prototype = new $74d9812244804ab2$var$CharDistributionAnalysis();
$74d9812244804ab2$export$6c17dd4b2cddd39e = $74d9812244804ab2$var$Big5DistributionAnalysis;
function $74d9812244804ab2$var$SJISDistributionAnalysis() {
    $74d9812244804ab2$var$CharDistributionAnalysis.apply(this);
    var self = this;
    function init() {
        self._mCharToFreqOrder = $5SMLi.JISCharToFreqOrder;
        self._mTableSize = $5SMLi.JIS_TABLE_SIZE;
        self._mTypicalDistributionRatio = $5SMLi.JIS_TYPICAL_DISTRIBUTION_RATIO;
    }
    this.getOrder = function(aStr) {
        // for sjis encoding, we are interested
        //   first  byte range: 0x81 -- 0x9f , 0xe0 -- 0xef
        //   second byte range: 0x40 -- 0x7e,  0x80 -- 0xfc
        // no validation needed here. State machine has done that
        if (aStr.charCodeAt(0) >= 0x81 && aStr.charCodeAt(0) <= 0x9F) var order = 188 * (aStr.charCodeAt(0) - 0x81);
        else if (aStr.charCodeAt(0) >= 0xE0 && aStr.charCodeAt(0) <= 0xEF) order = 188 * (aStr.charCodeAt(0) - 0xE0 + 31);
        else return -1;
        order += aStr.charCodeAt(1) - 0x40;
        if (aStr.charCodeAt(1) < 0x40 || aStr.charCodeAt(1) === 0x7F || aStr.charCodeAt(1) > 0xFC) order = -1;
        return order;
    };
    init();
}
$74d9812244804ab2$var$SJISDistributionAnalysis.prototype = new $74d9812244804ab2$var$CharDistributionAnalysis();
$74d9812244804ab2$export$d7b3478af73cf9f2 = $74d9812244804ab2$var$SJISDistributionAnalysis;
function $74d9812244804ab2$var$EUCJPDistributionAnalysis() {
    $74d9812244804ab2$var$CharDistributionAnalysis.apply(this);
    var self = this;
    function init() {
        self._mCharToFreqOrder = $5SMLi.JISCharToFreqOrder;
        self._mTableSize = $5SMLi.JIS_TABLE_SIZE;
        self._mTypicalDistributionRatio = $5SMLi.JIS_TYPICAL_DISTRIBUTION_RATIO;
    }
    this.getOrder = function(aStr) {
        // for euc-JP encoding, we are interested
        //   first  byte range: 0xa0 -- 0xfe
        //   second byte range: 0xa1 -- 0xfe
        // no validation needed here. State machine has done that
        if (aStr[0] >= "\xA0") return 94 * (aStr.charCodeAt(0) - 0xA1) + aStr.charCodeAt(1) - 0xA1;
        else return -1;
    };
    init();
}
$74d9812244804ab2$var$EUCJPDistributionAnalysis.prototype = new $74d9812244804ab2$var$CharDistributionAnalysis();
$74d9812244804ab2$export$f3eb7c74ebce6ac7 = $74d9812244804ab2$var$EUCJPDistributionAnalysis;

});
parcelRegister("5SMLi", function(module, exports) {

$parcel$export(module.exports, "JIS_TYPICAL_DISTRIBUTION_RATIO", () => $4487d1f9232de220$export$9e3ddffac507185b, (v) => $4487d1f9232de220$export$9e3ddffac507185b = v);
$parcel$export(module.exports, "JIS_TABLE_SIZE", () => $4487d1f9232de220$export$91b77e0002661201, (v) => $4487d1f9232de220$export$91b77e0002661201 = v);
$parcel$export(module.exports, "JISCharToFreqOrder", () => $4487d1f9232de220$export$670cd97055f5bdf9, (v) => $4487d1f9232de220$export$670cd97055f5bdf9 = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // Sampling from about 20M text materials include literature and computer technology
//
// Japanese frequency table, applied to both S-JIS and EUC-JP
// They are sorted in order.
//
// 128  --> 0.77094
// 256  --> 0.85710
// 512  --> 0.92635
// 1024 --> 0.97130
// 2048 --> 0.99431
//
// Ideal Distribution Ratio = 0.92635 / (1-0.92635) = 12.58
// Random Distribution Ration = 512 / (2965+62+83+86-512) = 0.191
//
// Typical Distribution Ratio, 25% of IDR
var $4487d1f9232de220$export$9e3ddffac507185b;
var $4487d1f9232de220$export$91b77e0002661201;
var $4487d1f9232de220$export$670cd97055f5bdf9;
$4487d1f9232de220$export$9e3ddffac507185b = 3.0;
$4487d1f9232de220$export$91b77e0002661201 = 4368;
$4487d1f9232de220$export$670cd97055f5bdf9 = [
    40,
    1,
    6,
    182,
    152,
    180,
    295,
    2127,
    285,
    381,
    3295,
    4304,
    3068,
    4606,
    3165,
    3510,
    3511,
    1822,
    2785,
    4607,
    1193,
    2226,
    5070,
    4608,
    171,
    2996,
    1247,
    18,
    179,
    5071,
    856,
    1661,
    1262,
    5072,
    619,
    127,
    3431,
    3512,
    3230,
    1899,
    1700,
    232,
    228,
    1294,
    1298,
    284,
    283,
    2041,
    2042,
    1061,
    1062,
    48,
    49,
    44,
    45,
    433,
    434,
    1040,
    1041,
    996,
    787,
    2997,
    1255,
    4305,
    2108,
    4609,
    1684,
    1648,
    5073,
    5074,
    5075,
    5076,
    5077,
    5078,
    3687,
    5079,
    4610,
    5080,
    3927,
    3928,
    5081,
    3296,
    3432,
    290,
    2285,
    1471,
    2187,
    5082,
    2580,
    2825,
    1303,
    2140,
    1739,
    1445,
    2691,
    3375,
    1691,
    3297,
    4306,
    4307,
    4611,
    452,
    3376,
    1182,
    2713,
    3688,
    3069,
    4308,
    5083,
    5084,
    5085,
    5086,
    5087,
    5088,
    5089,
    5090,
    5091,
    5092,
    5093,
    5094,
    5095,
    5096,
    5097,
    5098,
    5099,
    5100,
    5101,
    5102,
    5103,
    5104,
    5105,
    5106,
    5107,
    5108,
    5109,
    5110,
    5111,
    5112,
    4097,
    5113,
    5114,
    5115,
    5116,
    5117,
    5118,
    5119,
    5120,
    5121,
    5122,
    5123,
    5124,
    5125,
    5126,
    5127,
    5128,
    5129,
    5130,
    5131,
    5132,
    5133,
    5134,
    5135,
    5136,
    5137,
    5138,
    5139,
    5140,
    5141,
    5142,
    5143,
    5144,
    5145,
    5146,
    5147,
    5148,
    5149,
    5150,
    5151,
    5152,
    4612,
    5153,
    5154,
    5155,
    5156,
    5157,
    5158,
    5159,
    5160,
    5161,
    5162,
    5163,
    5164,
    5165,
    5166,
    5167,
    5168,
    5169,
    5170,
    5171,
    5172,
    5173,
    5174,
    5175,
    1472,
    598,
    618,
    820,
    1205,
    1309,
    1412,
    1858,
    1307,
    1692,
    5176,
    5177,
    5178,
    5179,
    5180,
    5181,
    5182,
    1142,
    1452,
    1234,
    1172,
    1875,
    2043,
    2149,
    1793,
    1382,
    2973,
    925,
    2404,
    1067,
    1241,
    960,
    1377,
    2935,
    1491,
    919,
    1217,
    1865,
    2030,
    1406,
    1499,
    2749,
    4098,
    5183,
    5184,
    5185,
    5186,
    5187,
    5188,
    2561,
    4099,
    3117,
    1804,
    2049,
    3689,
    4309,
    3513,
    1663,
    5189,
    3166,
    3118,
    3298,
    1587,
    1561,
    3433,
    5190,
    3119,
    1625,
    2998,
    3299,
    4613,
    1766,
    3690,
    2786,
    4614,
    5191,
    5192,
    5193,
    5194,
    2161,
    26,
    3377,
    2,
    3929,
    20,
    3691,
    47,
    4100,
    50,
    17,
    16,
    35,
    268,
    27,
    243,
    42,
    155,
    24,
    154,
    29,
    184,
    4,
    91,
    14,
    92,
    53,
    396,
    33,
    289,
    9,
    37,
    64,
    620,
    21,
    39,
    321,
    5,
    12,
    11,
    52,
    13,
    3,
    208,
    138,
    0,
    7,
    60,
    526,
    141,
    151,
    1069,
    181,
    275,
    1591,
    83,
    132,
    1475,
    126,
    331,
    829,
    15,
    69,
    160,
    59,
    22,
    157,
    55,
    1079,
    312,
    109,
    38,
    23,
    25,
    10,
    19,
    79,
    5195,
    61,
    382,
    1124,
    8,
    30,
    5196,
    5197,
    5198,
    5199,
    5200,
    5201,
    5202,
    5203,
    5204,
    5205,
    5206,
    89,
    62,
    74,
    34,
    2416,
    112,
    139,
    196,
    271,
    149,
    84,
    607,
    131,
    765,
    46,
    88,
    153,
    683,
    76,
    874,
    101,
    258,
    57,
    80,
    32,
    364,
    121,
    1508,
    169,
    1547,
    68,
    235,
    145,
    2999,
    41,
    360,
    3027,
    70,
    63,
    31,
    43,
    259,
    262,
    1383,
    99,
    533,
    194,
    66,
    93,
    846,
    217,
    192,
    56,
    106,
    58,
    565,
    280,
    272,
    311,
    256,
    146,
    82,
    308,
    71,
    100,
    128,
    214,
    655,
    110,
    261,
    104,
    1140,
    54,
    51,
    36,
    87,
    67,
    3070,
    185,
    2618,
    2936,
    2020,
    28,
    1066,
    2390,
    2059,
    5207,
    5208,
    5209,
    5210,
    5211,
    5212,
    5213,
    5214,
    5215,
    5216,
    4615,
    5217,
    5218,
    5219,
    5220,
    5221,
    5222,
    5223,
    5224,
    5225,
    5226,
    5227,
    5228,
    5229,
    5230,
    5231,
    5232,
    5233,
    5234,
    5235,
    5236,
    3514,
    5237,
    5238,
    5239,
    5240,
    5241,
    5242,
    5243,
    5244,
    2297,
    2031,
    4616,
    4310,
    3692,
    5245,
    3071,
    5246,
    3598,
    5247,
    4617,
    3231,
    3515,
    5248,
    4101,
    4311,
    4618,
    3808,
    4312,
    4102,
    5249,
    4103,
    4104,
    3599,
    5250,
    5251,
    5252,
    5253,
    5254,
    5255,
    5256,
    5257,
    5258,
    5259,
    5260,
    5261,
    5262,
    5263,
    5264,
    5265,
    5266,
    5267,
    5268,
    5269,
    5270,
    5271,
    5272,
    5273,
    5274,
    5275,
    5276,
    5277,
    5278,
    5279,
    5280,
    5281,
    5282,
    5283,
    5284,
    5285,
    5286,
    5287,
    5288,
    5289,
    5290,
    5291,
    5292,
    5293,
    5294,
    5295,
    5296,
    5297,
    5298,
    5299,
    5300,
    5301,
    5302,
    5303,
    5304,
    5305,
    5306,
    5307,
    5308,
    5309,
    5310,
    5311,
    5312,
    5313,
    5314,
    5315,
    5316,
    5317,
    5318,
    5319,
    5320,
    5321,
    5322,
    5323,
    5324,
    5325,
    5326,
    5327,
    5328,
    5329,
    5330,
    5331,
    5332,
    5333,
    5334,
    5335,
    5336,
    5337,
    5338,
    5339,
    5340,
    5341,
    5342,
    5343,
    5344,
    5345,
    5346,
    5347,
    5348,
    5349,
    5350,
    5351,
    5352,
    5353,
    5354,
    5355,
    5356,
    5357,
    5358,
    5359,
    5360,
    5361,
    5362,
    5363,
    5364,
    5365,
    5366,
    5367,
    5368,
    5369,
    5370,
    5371,
    5372,
    5373,
    5374,
    5375,
    5376,
    5377,
    5378,
    5379,
    5380,
    5381,
    363,
    642,
    2787,
    2878,
    2788,
    2789,
    2316,
    3232,
    2317,
    3434,
    2011,
    165,
    1942,
    3930,
    3931,
    3932,
    3933,
    5382,
    4619,
    5383,
    4620,
    5384,
    5385,
    5386,
    5387,
    5388,
    5389,
    5390,
    5391,
    5392,
    5393,
    5394,
    5395,
    5396,
    5397,
    5398,
    5399,
    5400,
    5401,
    5402,
    5403,
    5404,
    5405,
    5406,
    5407,
    5408,
    5409,
    5410,
    5411,
    5412,
    5413,
    5414,
    5415,
    5416,
    5417,
    5418,
    5419,
    5420,
    5421,
    5422,
    5423,
    5424,
    5425,
    5426,
    5427,
    5428,
    5429,
    5430,
    5431,
    5432,
    5433,
    5434,
    5435,
    5436,
    5437,
    5438,
    5439,
    5440,
    5441,
    5442,
    5443,
    5444,
    5445,
    5446,
    5447,
    5448,
    5449,
    5450,
    5451,
    5452,
    5453,
    5454,
    5455,
    5456,
    5457,
    5458,
    5459,
    5460,
    5461,
    5462,
    5463,
    5464,
    5465,
    5466,
    5467,
    5468,
    5469,
    5470,
    5471,
    5472,
    5473,
    5474,
    5475,
    5476,
    5477,
    5478,
    5479,
    5480,
    5481,
    5482,
    5483,
    5484,
    5485,
    5486,
    5487,
    5488,
    5489,
    5490,
    5491,
    5492,
    5493,
    5494,
    5495,
    5496,
    5497,
    5498,
    5499,
    5500,
    5501,
    5502,
    5503,
    5504,
    5505,
    5506,
    5507,
    5508,
    5509,
    5510,
    5511,
    5512,
    5513,
    5514,
    5515,
    5516,
    5517,
    5518,
    5519,
    5520,
    5521,
    5522,
    5523,
    5524,
    5525,
    5526,
    5527,
    5528,
    5529,
    5530,
    5531,
    5532,
    5533,
    5534,
    5535,
    5536,
    5537,
    5538,
    5539,
    5540,
    5541,
    5542,
    5543,
    5544,
    5545,
    5546,
    5547,
    5548,
    5549,
    5550,
    5551,
    5552,
    5553,
    5554,
    5555,
    5556,
    5557,
    5558,
    5559,
    5560,
    5561,
    5562,
    5563,
    5564,
    5565,
    5566,
    5567,
    5568,
    5569,
    5570,
    5571,
    5572,
    5573,
    5574,
    5575,
    5576,
    5577,
    5578,
    5579,
    5580,
    5581,
    5582,
    5583,
    5584,
    5585,
    5586,
    5587,
    5588,
    5589,
    5590,
    5591,
    5592,
    5593,
    5594,
    5595,
    5596,
    5597,
    5598,
    5599,
    5600,
    5601,
    5602,
    5603,
    5604,
    5605,
    5606,
    5607,
    5608,
    5609,
    5610,
    5611,
    5612,
    5613,
    5614,
    5615,
    5616,
    5617,
    5618,
    5619,
    5620,
    5621,
    5622,
    5623,
    5624,
    5625,
    5626,
    5627,
    5628,
    5629,
    5630,
    5631,
    5632,
    5633,
    5634,
    5635,
    5636,
    5637,
    5638,
    5639,
    5640,
    5641,
    5642,
    5643,
    5644,
    5645,
    5646,
    5647,
    5648,
    5649,
    5650,
    5651,
    5652,
    5653,
    5654,
    5655,
    5656,
    5657,
    5658,
    5659,
    5660,
    5661,
    5662,
    5663,
    5664,
    5665,
    5666,
    5667,
    5668,
    5669,
    5670,
    5671,
    5672,
    5673,
    5674,
    5675,
    5676,
    5677,
    5678,
    5679,
    5680,
    5681,
    5682,
    5683,
    5684,
    5685,
    5686,
    5687,
    5688,
    5689,
    5690,
    5691,
    5692,
    5693,
    5694,
    5695,
    5696,
    5697,
    5698,
    5699,
    5700,
    5701,
    5702,
    5703,
    5704,
    5705,
    5706,
    5707,
    5708,
    5709,
    5710,
    5711,
    5712,
    5713,
    5714,
    5715,
    5716,
    5717,
    5718,
    5719,
    5720,
    5721,
    5722,
    5723,
    5724,
    5725,
    5726,
    5727,
    5728,
    5729,
    5730,
    5731,
    5732,
    5733,
    5734,
    5735,
    5736,
    5737,
    5738,
    5739,
    5740,
    5741,
    5742,
    5743,
    5744,
    5745,
    5746,
    5747,
    5748,
    5749,
    5750,
    5751,
    5752,
    5753,
    5754,
    5755,
    5756,
    5757,
    5758,
    5759,
    5760,
    5761,
    5762,
    5763,
    5764,
    5765,
    5766,
    5767,
    5768,
    5769,
    5770,
    5771,
    5772,
    5773,
    5774,
    5775,
    5776,
    5777,
    5778,
    5779,
    5780,
    5781,
    5782,
    5783,
    5784,
    5785,
    5786,
    5787,
    5788,
    5789,
    5790,
    5791,
    5792,
    5793,
    5794,
    5795,
    5796,
    5797,
    5798,
    5799,
    5800,
    5801,
    5802,
    5803,
    5804,
    5805,
    5806,
    5807,
    5808,
    5809,
    5810,
    5811,
    5812,
    5813,
    5814,
    5815,
    5816,
    5817,
    5818,
    5819,
    5820,
    5821,
    5822,
    5823,
    5824,
    5825,
    5826,
    5827,
    5828,
    5829,
    5830,
    5831,
    5832,
    5833,
    5834,
    5835,
    5836,
    5837,
    5838,
    5839,
    5840,
    5841,
    5842,
    5843,
    5844,
    5845,
    5846,
    5847,
    5848,
    5849,
    5850,
    5851,
    5852,
    5853,
    5854,
    5855,
    5856,
    5857,
    5858,
    5859,
    5860,
    5861,
    5862,
    5863,
    5864,
    5865,
    5866,
    5867,
    5868,
    5869,
    5870,
    5871,
    5872,
    5873,
    5874,
    5875,
    5876,
    5877,
    5878,
    5879,
    5880,
    5881,
    5882,
    5883,
    5884,
    5885,
    5886,
    5887,
    5888,
    5889,
    5890,
    5891,
    5892,
    5893,
    5894,
    5895,
    5896,
    5897,
    5898,
    5899,
    5900,
    5901,
    5902,
    5903,
    5904,
    5905,
    5906,
    5907,
    5908,
    5909,
    5910,
    5911,
    5912,
    5913,
    5914,
    5915,
    5916,
    5917,
    5918,
    5919,
    5920,
    5921,
    5922,
    5923,
    5924,
    5925,
    5926,
    5927,
    5928,
    5929,
    5930,
    5931,
    5932,
    5933,
    5934,
    5935,
    5936,
    5937,
    5938,
    5939,
    5940,
    5941,
    5942,
    5943,
    5944,
    5945,
    5946,
    5947,
    5948,
    5949,
    5950,
    5951,
    5952,
    5953,
    5954,
    5955,
    5956,
    5957,
    5958,
    5959,
    5960,
    5961,
    5962,
    5963,
    5964,
    5965,
    5966,
    5967,
    5968,
    5969,
    5970,
    5971,
    5972,
    5973,
    5974,
    5975,
    5976,
    5977,
    5978,
    5979,
    5980,
    5981,
    5982,
    5983,
    5984,
    5985,
    5986,
    5987,
    5988,
    5989,
    5990,
    5991,
    5992,
    5993,
    5994,
    5995,
    5996,
    5997,
    5998,
    5999,
    6000,
    6001,
    6002,
    6003,
    6004,
    6005,
    6006,
    6007,
    6008,
    6009,
    6010,
    6011,
    6012,
    6013,
    6014,
    6015,
    6016,
    6017,
    6018,
    6019,
    6020,
    6021,
    6022,
    6023,
    6024,
    6025,
    6026,
    6027,
    6028,
    6029,
    6030,
    6031,
    6032,
    6033,
    6034,
    6035,
    6036,
    6037,
    6038,
    6039,
    6040,
    6041,
    6042,
    6043,
    6044,
    6045,
    6046,
    6047,
    6048,
    6049,
    6050,
    6051,
    6052,
    6053,
    6054,
    6055,
    6056,
    6057,
    6058,
    6059,
    6060,
    6061,
    6062,
    6063,
    6064,
    6065,
    6066,
    6067,
    6068,
    6069,
    6070,
    6071,
    6072,
    6073,
    6074,
    6075,
    6076,
    6077,
    6078,
    6079,
    6080,
    6081,
    6082,
    6083,
    6084,
    6085,
    6086,
    6087,
    6088,
    6089,
    6090,
    6091,
    6092,
    6093,
    6094,
    6095,
    6096,
    6097,
    6098,
    6099,
    6100,
    6101,
    6102,
    6103,
    6104,
    6105,
    6106,
    6107,
    6108,
    6109,
    6110,
    6111,
    6112,
    6113,
    6114,
    2044,
    2060,
    4621,
    997,
    1235,
    473,
    1186,
    4622,
    920,
    3378,
    6115,
    6116,
    379,
    1108,
    4313,
    2657,
    2735,
    3934,
    6117,
    3809,
    636,
    3233,
    573,
    1026,
    3693,
    3435,
    2974,
    3300,
    2298,
    4105,
    854,
    2937,
    2463,
    393,
    2581,
    2417,
    539,
    752,
    1280,
    2750,
    2480,
    140,
    1161,
    440,
    708,
    1569,
    665,
    2497,
    1746,
    1291,
    1523,
    3000,
    164,
    1603,
    847,
    1331,
    537,
    1997,
    486,
    508,
    1693,
    2418,
    1970,
    2227,
    878,
    1220,
    299,
    1030,
    969,
    652,
    2751,
    624,
    1137,
    3301,
    2619,
    65,
    3302,
    2045,
    1761,
    1859,
    3120,
    1930,
    3694,
    3516,
    663,
    1767,
    852,
    835,
    3695,
    269,
    767,
    2826,
    2339,
    1305,
    896,
    1150,
    770,
    1616,
    6118,
    506,
    1502,
    2075,
    1012,
    2519,
    775,
    2520,
    2975,
    2340,
    2938,
    4314,
    3028,
    2086,
    1224,
    1943,
    2286,
    6119,
    3072,
    4315,
    2240,
    1273,
    1987,
    3935,
    1557,
    175,
    597,
    985,
    3517,
    2419,
    2521,
    1416,
    3029,
    585,
    938,
    1931,
    1007,
    1052,
    1932,
    1685,
    6120,
    3379,
    4316,
    4623,
    804,
    599,
    3121,
    1333,
    2128,
    2539,
    1159,
    1554,
    2032,
    3810,
    687,
    2033,
    2904,
    952,
    675,
    1467,
    3436,
    6121,
    2241,
    1096,
    1786,
    2440,
    1543,
    1924,
    980,
    1813,
    2228,
    781,
    2692,
    1879,
    728,
    1918,
    3696,
    4624,
    548,
    1950,
    4625,
    1809,
    1088,
    1356,
    3303,
    2522,
    1944,
    502,
    972,
    373,
    513,
    2827,
    586,
    2377,
    2391,
    1003,
    1976,
    1631,
    6122,
    2464,
    1084,
    648,
    1776,
    4626,
    2141,
    324,
    962,
    2012,
    2177,
    2076,
    1384,
    742,
    2178,
    1448,
    1173,
    1810,
    222,
    102,
    301,
    445,
    125,
    2420,
    662,
    2498,
    277,
    200,
    1476,
    1165,
    1068,
    224,
    2562,
    1378,
    1446,
    450,
    1880,
    659,
    791,
    582,
    4627,
    2939,
    3936,
    1516,
    1274,
    555,
    2099,
    3697,
    1020,
    1389,
    1526,
    3380,
    1762,
    1723,
    1787,
    2229,
    412,
    2114,
    1900,
    2392,
    3518,
    512,
    2597,
    427,
    1925,
    2341,
    3122,
    1653,
    1686,
    2465,
    2499,
    697,
    330,
    273,
    380,
    2162,
    951,
    832,
    780,
    991,
    1301,
    3073,
    965,
    2270,
    3519,
    668,
    2523,
    2636,
    1286,
    535,
    1407,
    518,
    671,
    957,
    2658,
    2378,
    267,
    611,
    2197,
    3030,
    6123,
    248,
    2299,
    967,
    1799,
    2356,
    850,
    1418,
    3437,
    1876,
    1256,
    1480,
    2828,
    1718,
    6124,
    6125,
    1755,
    1664,
    2405,
    6126,
    4628,
    2879,
    2829,
    499,
    2179,
    676,
    4629,
    557,
    2329,
    2214,
    2090,
    325,
    3234,
    464,
    811,
    3001,
    992,
    2342,
    2481,
    1232,
    1469,
    303,
    2242,
    466,
    1070,
    2163,
    603,
    1777,
    2091,
    4630,
    2752,
    4631,
    2714,
    322,
    2659,
    1964,
    1768,
    481,
    2188,
    1463,
    2330,
    2857,
    3600,
    2092,
    3031,
    2421,
    4632,
    2318,
    2070,
    1849,
    2598,
    4633,
    1302,
    2254,
    1668,
    1701,
    2422,
    3811,
    2905,
    3032,
    3123,
    2046,
    4106,
    1763,
    1694,
    4634,
    1604,
    943,
    1724,
    1454,
    917,
    868,
    2215,
    1169,
    2940,
    552,
    1145,
    1800,
    1228,
    1823,
    1955,
    316,
    1080,
    2510,
    361,
    1807,
    2830,
    4107,
    2660,
    3381,
    1346,
    1423,
    1134,
    4108,
    6127,
    541,
    1263,
    1229,
    1148,
    2540,
    545,
    465,
    1833,
    2880,
    3438,
    1901,
    3074,
    2482,
    816,
    3937,
    713,
    1788,
    2500,
    122,
    1575,
    195,
    1451,
    2501,
    1111,
    6128,
    859,
    374,
    1225,
    2243,
    2483,
    4317,
    390,
    1033,
    3439,
    3075,
    2524,
    1687,
    266,
    793,
    1440,
    2599,
    946,
    779,
    802,
    507,
    897,
    1081,
    528,
    2189,
    1292,
    711,
    1866,
    1725,
    1167,
    1640,
    753,
    398,
    2661,
    1053,
    246,
    348,
    4318,
    137,
    1024,
    3440,
    1600,
    2077,
    2129,
    825,
    4319,
    698,
    238,
    521,
    187,
    2300,
    1157,
    2423,
    1641,
    1605,
    1464,
    1610,
    1097,
    2541,
    1260,
    1436,
    759,
    2255,
    1814,
    2150,
    705,
    3235,
    409,
    2563,
    3304,
    561,
    3033,
    2005,
    2564,
    726,
    1956,
    2343,
    3698,
    4109,
    949,
    3812,
    3813,
    3520,
    1669,
    653,
    1379,
    2525,
    881,
    2198,
    632,
    2256,
    1027,
    778,
    1074,
    733,
    1957,
    514,
    1481,
    2466,
    554,
    2180,
    702,
    3938,
    1606,
    1017,
    1398,
    6129,
    1380,
    3521,
    921,
    993,
    1313,
    594,
    449,
    1489,
    1617,
    1166,
    768,
    1426,
    1360,
    495,
    1794,
    3601,
    1177,
    3602,
    1170,
    4320,
    2344,
    476,
    425,
    3167,
    4635,
    3168,
    1424,
    401,
    2662,
    1171,
    3382,
    1998,
    1089,
    4110,
    477,
    3169,
    474,
    6130,
    1909,
    596,
    2831,
    1842,
    494,
    693,
    1051,
    1028,
    1207,
    3076,
    606,
    2115,
    727,
    2790,
    1473,
    1115,
    743,
    3522,
    630,
    805,
    1532,
    4321,
    2021,
    366,
    1057,
    838,
    684,
    1114,
    2142,
    4322,
    2050,
    1492,
    1892,
    1808,
    2271,
    3814,
    2424,
    1971,
    1447,
    1373,
    3305,
    1090,
    1536,
    3939,
    3523,
    3306,
    1455,
    2199,
    336,
    369,
    2331,
    1035,
    584,
    2393,
    902,
    718,
    2600,
    6131,
    2753,
    463,
    2151,
    1149,
    1611,
    2467,
    715,
    1308,
    3124,
    1268,
    343,
    1413,
    3236,
    1517,
    1347,
    2663,
    2093,
    3940,
    2022,
    1131,
    1553,
    2100,
    2941,
    1427,
    3441,
    2942,
    1323,
    2484,
    6132,
    1980,
    872,
    2368,
    2441,
    2943,
    320,
    2369,
    2116,
    1082,
    679,
    1933,
    3941,
    2791,
    3815,
    625,
    1143,
    2023,
    422,
    2200,
    3816,
    6133,
    730,
    1695,
    356,
    2257,
    1626,
    2301,
    2858,
    2637,
    1627,
    1778,
    937,
    883,
    2906,
    2693,
    3002,
    1769,
    1086,
    400,
    1063,
    1325,
    3307,
    2792,
    4111,
    3077,
    456,
    2345,
    1046,
    747,
    6134,
    1524,
    884,
    1094,
    3383,
    1474,
    2164,
    1059,
    974,
    1688,
    2181,
    2258,
    1047,
    345,
    1665,
    1187,
    358,
    875,
    3170,
    305,
    660,
    3524,
    2190,
    1334,
    1135,
    3171,
    1540,
    1649,
    2542,
    1527,
    927,
    968,
    2793,
    885,
    1972,
    1850,
    482,
    500,
    2638,
    1218,
    1109,
    1085,
    2543,
    1654,
    2034,
    876,
    78,
    2287,
    1482,
    1277,
    861,
    1675,
    1083,
    1779,
    724,
    2754,
    454,
    397,
    1132,
    1612,
    2332,
    893,
    672,
    1237,
    257,
    2259,
    2370,
    135,
    3384,
    337,
    2244,
    547,
    352,
    340,
    709,
    2485,
    1400,
    788,
    1138,
    2511,
    540,
    772,
    1682,
    2260,
    2272,
    2544,
    2013,
    1843,
    1902,
    4636,
    1999,
    1562,
    2288,
    4637,
    2201,
    1403,
    1533,
    407,
    576,
    3308,
    1254,
    2071,
    978,
    3385,
    170,
    136,
    1201,
    3125,
    2664,
    3172,
    2394,
    213,
    912,
    873,
    3603,
    1713,
    2202,
    699,
    3604,
    3699,
    813,
    3442,
    493,
    531,
    1054,
    468,
    2907,
    1483,
    304,
    281,
    4112,
    1726,
    1252,
    2094,
    339,
    2319,
    2130,
    2639,
    756,
    1563,
    2944,
    748,
    571,
    2976,
    1588,
    2425,
    2715,
    1851,
    1460,
    2426,
    1528,
    1392,
    1973,
    3237,
    288,
    3309,
    685,
    3386,
    296,
    892,
    2716,
    2216,
    1570,
    2245,
    722,
    1747,
    2217,
    905,
    3238,
    1103,
    6135,
    1893,
    1441,
    1965,
    251,
    1805,
    2371,
    3700,
    2601,
    1919,
    1078,
    75,
    2182,
    1509,
    1592,
    1270,
    2640,
    4638,
    2152,
    6136,
    3310,
    3817,
    524,
    706,
    1075,
    292,
    3818,
    1756,
    2602,
    317,
    98,
    3173,
    3605,
    3525,
    1844,
    2218,
    3819,
    2502,
    814,
    567,
    385,
    2908,
    1534,
    6137,
    534,
    1642,
    3239,
    797,
    6138,
    1670,
    1529,
    953,
    4323,
    188,
    1071,
    538,
    178,
    729,
    3240,
    2109,
    1226,
    1374,
    2000,
    2357,
    2977,
    731,
    2468,
    1116,
    2014,
    2051,
    6139,
    1261,
    1593,
    803,
    2859,
    2736,
    3443,
    556,
    682,
    823,
    1541,
    6140,
    1369,
    2289,
    1706,
    2794,
    845,
    462,
    2603,
    2665,
    1361,
    387,
    162,
    2358,
    1740,
    739,
    1770,
    1720,
    1304,
    1401,
    3241,
    1049,
    627,
    1571,
    2427,
    3526,
    1877,
    3942,
    1852,
    1500,
    431,
    1910,
    1503,
    677,
    297,
    2795,
    286,
    1433,
    1038,
    1198,
    2290,
    1133,
    1596,
    4113,
    4639,
    2469,
    1510,
    1484,
    3943,
    6141,
    2442,
    108,
    712,
    4640,
    2372,
    866,
    3701,
    2755,
    3242,
    1348,
    834,
    1945,
    1408,
    3527,
    2395,
    3243,
    1811,
    824,
    994,
    1179,
    2110,
    1548,
    1453,
    790,
    3003,
    690,
    4324,
    4325,
    2832,
    2909,
    3820,
    1860,
    3821,
    225,
    1748,
    310,
    346,
    1780,
    2470,
    821,
    1993,
    2717,
    2796,
    828,
    877,
    3528,
    2860,
    2471,
    1702,
    2165,
    2910,
    2486,
    1789,
    453,
    359,
    2291,
    1676,
    73,
    1164,
    1461,
    1127,
    3311,
    421,
    604,
    314,
    1037,
    589,
    116,
    2487,
    737,
    837,
    1180,
    111,
    244,
    735,
    6142,
    2261,
    1861,
    1362,
    986,
    523,
    418,
    581,
    2666,
    3822,
    103,
    855,
    503,
    1414,
    1867,
    2488,
    1091,
    657,
    1597,
    979,
    605,
    1316,
    4641,
    1021,
    2443,
    2078,
    2001,
    1209,
    96,
    587,
    2166,
    1032,
    260,
    1072,
    2153,
    173,
    94,
    226,
    3244,
    819,
    2006,
    4642,
    4114,
    2203,
    231,
    1744,
    782,
    97,
    2667,
    786,
    3387,
    887,
    391,
    442,
    2219,
    4326,
    1425,
    6143,
    2694,
    633,
    1544,
    1202,
    483,
    2015,
    592,
    2052,
    1958,
    2472,
    1655,
    419,
    129,
    4327,
    3444,
    3312,
    1714,
    1257,
    3078,
    4328,
    1518,
    1098,
    865,
    1310,
    1019,
    1885,
    1512,
    1734,
    469,
    2444,
    148,
    773,
    436,
    1815,
    1868,
    1128,
    1055,
    4329,
    1245,
    2756,
    3445,
    2154,
    1934,
    1039,
    4643,
    579,
    1238,
    932,
    2320,
    353,
    205,
    801,
    115,
    2428,
    944,
    2321,
    1881,
    399,
    2565,
    1211,
    678,
    766,
    3944,
    335,
    2101,
    1459,
    1781,
    1402,
    3945,
    2737,
    2131,
    1010,
    844,
    981,
    1326,
    1013,
    550,
    1816,
    1545,
    2620,
    1335,
    1008,
    371,
    2881,
    936,
    1419,
    1613,
    3529,
    1456,
    1395,
    2273,
    1834,
    2604,
    1317,
    2738,
    2503,
    416,
    1643,
    4330,
    806,
    1126,
    229,
    591,
    3946,
    1314,
    1981,
    1576,
    1837,
    1666,
    347,
    1790,
    977,
    3313,
    764,
    2861,
    1853,
    688,
    2429,
    1920,
    1462,
    77,
    595,
    415,
    2002,
    3034,
    798,
    1192,
    4115,
    6144,
    2978,
    4331,
    3035,
    2695,
    2582,
    2072,
    2566,
    430,
    2430,
    1727,
    842,
    1396,
    3947,
    3702,
    613,
    377,
    278,
    236,
    1417,
    3388,
    3314,
    3174,
    757,
    1869,
    107,
    3530,
    6145,
    1194,
    623,
    2262,
    207,
    1253,
    2167,
    3446,
    3948,
    492,
    1117,
    1935,
    536,
    1838,
    2757,
    1246,
    4332,
    696,
    2095,
    2406,
    1393,
    1572,
    3175,
    1782,
    583,
    190,
    253,
    1390,
    2230,
    830,
    3126,
    3389,
    934,
    3245,
    1703,
    1749,
    2979,
    1870,
    2545,
    1656,
    2204,
    869,
    2346,
    4116,
    3176,
    1817,
    496,
    1764,
    4644,
    942,
    1504,
    404,
    1903,
    1122,
    1580,
    3606,
    2945,
    1022,
    515,
    372,
    1735,
    955,
    2431,
    3036,
    6146,
    2797,
    1110,
    2302,
    2798,
    617,
    6147,
    441,
    762,
    1771,
    3447,
    3607,
    3608,
    1904,
    840,
    3037,
    86,
    939,
    1385,
    572,
    1370,
    2445,
    1336,
    114,
    3703,
    898,
    294,
    203,
    3315,
    703,
    1583,
    2274,
    429,
    961,
    4333,
    1854,
    1951,
    3390,
    2373,
    3704,
    4334,
    1318,
    1381,
    966,
    1911,
    2322,
    1006,
    1155,
    309,
    989,
    458,
    2718,
    1795,
    1372,
    1203,
    252,
    1689,
    1363,
    3177,
    517,
    1936,
    168,
    1490,
    562,
    193,
    3823,
    1042,
    4117,
    1835,
    551,
    470,
    4645,
    395,
    489,
    3448,
    1871,
    1465,
    2583,
    2641,
    417,
    1493,
    279,
    1295,
    511,
    1236,
    1119,
    72,
    1231,
    1982,
    1812,
    3004,
    871,
    1564,
    984,
    3449,
    1667,
    2696,
    2096,
    4646,
    2347,
    2833,
    1673,
    3609,
    695,
    3246,
    2668,
    807,
    1183,
    4647,
    890,
    388,
    2333,
    1801,
    1457,
    2911,
    1765,
    1477,
    1031,
    3316,
    3317,
    1278,
    3391,
    2799,
    2292,
    2526,
    163,
    3450,
    4335,
    2669,
    1404,
    1802,
    6148,
    2323,
    2407,
    1584,
    1728,
    1494,
    1824,
    1269,
    298,
    909,
    3318,
    1034,
    1632,
    375,
    776,
    1683,
    2061,
    291,
    210,
    1123,
    809,
    1249,
    1002,
    2642,
    3038,
    206,
    1011,
    2132,
    144,
    975,
    882,
    1565,
    342,
    667,
    754,
    1442,
    2143,
    1299,
    2303,
    2062,
    447,
    626,
    2205,
    1221,
    2739,
    2912,
    1144,
    1214,
    2206,
    2584,
    760,
    1715,
    614,
    950,
    1281,
    2670,
    2621,
    810,
    577,
    1287,
    2546,
    4648,
    242,
    2168,
    250,
    2643,
    691,
    123,
    2644,
    647,
    313,
    1029,
    689,
    1357,
    2946,
    1650,
    216,
    771,
    1339,
    1306,
    808,
    2063,
    549,
    913,
    1371,
    2913,
    2914,
    6149,
    1466,
    1092,
    1174,
    1196,
    1311,
    2605,
    2396,
    1783,
    1796,
    3079,
    406,
    2671,
    2117,
    3949,
    4649,
    487,
    1825,
    2220,
    6150,
    2915,
    448,
    2348,
    1073,
    6151,
    2397,
    1707,
    130,
    900,
    1598,
    329,
    176,
    1959,
    2527,
    1620,
    6152,
    2275,
    4336,
    3319,
    1983,
    2191,
    3705,
    3610,
    2155,
    3706,
    1912,
    1513,
    1614,
    6153,
    1988,
    646,
    392,
    2304,
    1589,
    3320,
    3039,
    1826,
    1239,
    1352,
    1340,
    2916,
    505,
    2567,
    1709,
    1437,
    2408,
    2547,
    906,
    6154,
    2672,
    384,
    1458,
    1594,
    1100,
    1329,
    710,
    423,
    3531,
    2064,
    2231,
    2622,
    1989,
    2673,
    1087,
    1882,
    333,
    841,
    3005,
    1296,
    2882,
    2379,
    580,
    1937,
    1827,
    1293,
    2585,
    601,
    574,
    249,
    1772,
    4118,
    2079,
    1120,
    645,
    901,
    1176,
    1690,
    795,
    2207,
    478,
    1434,
    516,
    1190,
    1530,
    761,
    2080,
    930,
    1264,
    355,
    435,
    1552,
    644,
    1791,
    987,
    220,
    1364,
    1163,
    1121,
    1538,
    306,
    2169,
    1327,
    1222,
    546,
    2645,
    218,
    241,
    610,
    1704,
    3321,
    1984,
    1839,
    1966,
    2528,
    451,
    6155,
    2586,
    3707,
    2568,
    907,
    3178,
    254,
    2947,
    186,
    1845,
    4650,
    745,
    432,
    1757,
    428,
    1633,
    888,
    2246,
    2221,
    2489,
    3611,
    2118,
    1258,
    1265,
    956,
    3127,
    1784,
    4337,
    2490,
    319,
    510,
    119,
    457,
    3612,
    274,
    2035,
    2007,
    4651,
    1409,
    3128,
    970,
    2758,
    590,
    2800,
    661,
    2247,
    4652,
    2008,
    3950,
    1420,
    1549,
    3080,
    3322,
    3951,
    1651,
    1375,
    2111,
    485,
    2491,
    1429,
    1156,
    6156,
    2548,
    2183,
    1495,
    831,
    1840,
    2529,
    2446,
    501,
    1657,
    307,
    1894,
    3247,
    1341,
    666,
    899,
    2156,
    1539,
    2549,
    1559,
    886,
    349,
    2208,
    3081,
    2305,
    1736,
    3824,
    2170,
    2759,
    1014,
    1913,
    1386,
    542,
    1397,
    2948,
    490,
    368,
    716,
    362,
    159,
    282,
    2569,
    1129,
    1658,
    1288,
    1750,
    2674,
    276,
    649,
    2016,
    751,
    1496,
    658,
    1818,
    1284,
    1862,
    2209,
    2087,
    2512,
    3451,
    622,
    2834,
    376,
    117,
    1060,
    2053,
    1208,
    1721,
    1101,
    1443,
    247,
    1250,
    3179,
    1792,
    3952,
    2760,
    2398,
    3953,
    6157,
    2144,
    3708,
    446,
    2432,
    1151,
    2570,
    3452,
    2447,
    2761,
    2835,
    1210,
    2448,
    3082,
    424,
    2222,
    1251,
    2449,
    2119,
    2836,
    504,
    1581,
    4338,
    602,
    817,
    857,
    3825,
    2349,
    2306,
    357,
    3826,
    1470,
    1883,
    2883,
    255,
    958,
    929,
    2917,
    3248,
    302,
    4653,
    1050,
    1271,
    1751,
    2307,
    1952,
    1430,
    2697,
    2719,
    2359,
    354,
    3180,
    777,
    158,
    2036,
    4339,
    1659,
    4340,
    4654,
    2308,
    2949,
    2248,
    1146,
    2232,
    3532,
    2720,
    1696,
    2623,
    3827,
    6158,
    3129,
    1550,
    2698,
    1485,
    1297,
    1428,
    637,
    931,
    2721,
    2145,
    914,
    2550,
    2587,
    81,
    2450,
    612,
    827,
    2646,
    1242,
    4655,
    1118,
    2884,
    472,
    1855,
    3181,
    3533,
    3534,
    569,
    1353,
    2699,
    1244,
    1758,
    2588,
    4119,
    2009,
    2762,
    2171,
    3709,
    1312,
    1531,
    6159,
    1152,
    1938,
    134,
    1830,
    471,
    3710,
    2276,
    1112,
    1535,
    3323,
    3453,
    3535,
    982,
    1337,
    2950,
    488,
    826,
    674,
    1058,
    1628,
    4120,
    2017,
    522,
    2399,
    211,
    568,
    1367,
    3454,
    350,
    293,
    1872,
    1139,
    3249,
    1399,
    1946,
    3006,
    1300,
    2360,
    3324,
    588,
    736,
    6160,
    2606,
    744,
    669,
    3536,
    3828,
    6161,
    1358,
    199,
    723,
    848,
    933,
    851,
    1939,
    1505,
    1514,
    1338,
    1618,
    1831,
    4656,
    1634,
    3613,
    443,
    2740,
    3829,
    717,
    1947,
    491,
    1914,
    6162,
    2551,
    1542,
    4121,
    1025,
    6163,
    1099,
    1223,
    198,
    3040,
    2722,
    370,
    410,
    1905,
    2589,
    998,
    1248,
    3182,
    2380,
    519,
    1449,
    4122,
    1710,
    947,
    928,
    1153,
    4341,
    2277,
    344,
    2624,
    1511,
    615,
    105,
    161,
    1212,
    1076,
    1960,
    3130,
    2054,
    1926,
    1175,
    1906,
    2473,
    414,
    1873,
    2801,
    6164,
    2309,
    315,
    1319,
    3325,
    318,
    2018,
    2146,
    2157,
    963,
    631,
    223,
    4342,
    4343,
    2675,
    479,
    3711,
    1197,
    2625,
    3712,
    2676,
    2361,
    6165,
    4344,
    4123,
    6166,
    2451,
    3183,
    1886,
    2184,
    1674,
    1330,
    1711,
    1635,
    1506,
    799,
    219,
    3250,
    3083,
    3954,
    1677,
    3713,
    3326,
    2081,
    3614,
    1652,
    2073,
    4657,
    1147,
    3041,
    1752,
    643,
    1961,
    147,
    1974,
    3955,
    6167,
    1716,
    2037,
    918,
    3007,
    1994,
    120,
    1537,
    118,
    609,
    3184,
    4345,
    740,
    3455,
    1219,
    332,
    1615,
    3830,
    6168,
    1621,
    2980,
    1582,
    783,
    212,
    553,
    2350,
    3714,
    1349,
    2433,
    2082,
    4124,
    889,
    6169,
    2310,
    1275,
    1410,
    973,
    166,
    1320,
    3456,
    1797,
    1215,
    3185,
    2885,
    1846,
    2590,
    2763,
    4658,
    629,
    822,
    3008,
    763,
    940,
    1990,
    2862,
    439,
    2409,
    1566,
    1240,
    1622,
    926,
    1282,
    1907,
    2764,
    654,
    2210,
    1607,
    327,
    1130,
    3956,
    1678,
    1623,
    6170,
    2434,
    2192,
    686,
    608,
    3831,
    3715,
    903,
    3957,
    3042,
    6171,
    2741,
    1522,
    1915,
    1105,
    1555,
    2552,
    1359,
    323,
    3251,
    4346,
    3457,
    738,
    1354,
    2553,
    2311,
    2334,
    1828,
    2003,
    3832,
    1753,
    2351,
    1227,
    6172,
    1887,
    4125,
    1478,
    6173,
    2410,
    1874,
    1712,
    1847,
    520,
    1204,
    2607,
    264,
    4659,
    836,
    2677,
    2102,
    600,
    4660,
    3833,
    2278,
    3084,
    6174,
    4347,
    3615,
    1342,
    640,
    532,
    543,
    2608,
    1888,
    2400,
    2591,
    1009,
    4348,
    1497,
    341,
    1737,
    3616,
    2723,
    1394,
    529,
    3252,
    1321,
    983,
    4661,
    1515,
    2120,
    971,
    2592,
    924,
    287,
    1662,
    3186,
    4349,
    2700,
    4350,
    1519,
    908,
    1948,
    2452,
    156,
    796,
    1629,
    1486,
    2223,
    2055,
    694,
    4126,
    1259,
    1036,
    3392,
    1213,
    2249,
    2742,
    1889,
    1230,
    3958,
    1015,
    910,
    408,
    559,
    3617,
    4662,
    746,
    725,
    935,
    4663,
    3959,
    3009,
    1289,
    563,
    867,
    4664,
    3960,
    1567,
    2981,
    2038,
    2626,
    988,
    2263,
    2381,
    4351,
    143,
    2374,
    704,
    1895,
    6175,
    1188,
    3716,
    2088,
    673,
    3085,
    2362,
    4352,
    484,
    1608,
    1921,
    2765,
    2918,
    215,
    904,
    3618,
    3537,
    894,
    509,
    976,
    3043,
    2701,
    3961,
    4353,
    2837,
    2982,
    498,
    6176,
    6177,
    1102,
    3538,
    1332,
    3393,
    1487,
    1636,
    1637,
    233,
    245,
    3962,
    383,
    650,
    995,
    3044,
    460,
    1520,
    1206,
    2352,
    749,
    3327,
    530,
    700,
    389,
    1438,
    1560,
    1773,
    3963,
    2264,
    719,
    2951,
    2724,
    3834,
    870,
    1832,
    1644,
    1000,
    839,
    2474,
    3717,
    197,
    1630,
    3394,
    365,
    2886,
    3964,
    1285,
    2133,
    734,
    922,
    818,
    1106,
    732,
    480,
    2083,
    1774,
    3458,
    923,
    2279,
    1350,
    221,
    3086,
    85,
    2233,
    2234,
    3835,
    1585,
    3010,
    2147,
    1387,
    1705,
    2382,
    1619,
    2475,
    133,
    239,
    2802,
    1991,
    1016,
    2084,
    2383,
    411,
    2838,
    1113,
    651,
    1985,
    1160,
    3328,
    990,
    1863,
    3087,
    1048,
    1276,
    2647,
    265,
    2627,
    1599,
    3253,
    2056,
    150,
    638,
    2019,
    656,
    853,
    326,
    1479,
    680,
    1439,
    4354,
    1001,
    1759,
    413,
    3459,
    3395,
    2492,
    1431,
    459,
    4355,
    1125,
    3329,
    2265,
    1953,
    1450,
    2065,
    2863,
    849,
    351,
    2678,
    3131,
    3254,
    3255,
    1104,
    1577,
    227,
    1351,
    1645,
    2453,
    2193,
    1421,
    2887,
    812,
    2121,
    634,
    95,
    2435,
    201,
    2312,
    4665,
    1646,
    1671,
    2743,
    1601,
    2554,
    2702,
    2648,
    2280,
    1315,
    1366,
    2089,
    3132,
    1573,
    3718,
    3965,
    1729,
    1189,
    328,
    2679,
    1077,
    1940,
    1136,
    558,
    1283,
    964,
    1195,
    621,
    2074,
    1199,
    1743,
    3460,
    3619,
    1896,
    1916,
    1890,
    3836,
    2952,
    1154,
    2112,
    1064,
    862,
    378,
    3011,
    2066,
    2113,
    2803,
    1568,
    2839,
    6178,
    3088,
    2919,
    1941,
    1660,
    2004,
    1992,
    2194,
    142,
    707,
    1590,
    1708,
    1624,
    1922,
    1023,
    1836,
    1233,
    1004,
    2313,
    789,
    741,
    3620,
    6179,
    1609,
    2411,
    1200,
    4127,
    3719,
    3720,
    4666,
    2057,
    3721,
    593,
    2840,
    367,
    2920,
    1878,
    6180,
    3461,
    1521,
    628,
    1168,
    692,
    2211,
    2649,
    300,
    720,
    2067,
    2571,
    2953,
    3396,
    959,
    2504,
    3966,
    3539,
    3462,
    1977,
    701,
    6181,
    954,
    1043,
    800,
    681,
    183,
    3722,
    1803,
    1730,
    3540,
    4128,
    2103,
    815,
    2314,
    174,
    467,
    230,
    2454,
    1093,
    2134,
    755,
    3541,
    3397,
    1141,
    1162,
    6182,
    1738,
    2039,
    270,
    3256,
    2513,
    1005,
    1647,
    2185,
    3837,
    858,
    1679,
    1897,
    1719,
    2954,
    2324,
    1806,
    402,
    670,
    167,
    4129,
    1498,
    2158,
    2104,
    750,
    6183,
    915,
    189,
    1680,
    1551,
    455,
    4356,
    1501,
    2455,
    405,
    1095,
    2955,
    338,
    1586,
    1266,
    1819,
    570,
    641,
    1324,
    237,
    1556,
    2650,
    1388,
    3723,
    6184,
    1368,
    2384,
    1343,
    1978,
    3089,
    2436,
    879,
    3724,
    792,
    1191,
    758,
    3012,
    1411,
    2135,
    1322,
    4357,
    240,
    4667,
    1848,
    3725,
    1574,
    6185,
    420,
    3045,
    1546,
    1391,
    714,
    4358,
    1967,
    941,
    1864,
    863,
    664,
    426,
    560,
    1731,
    2680,
    1785,
    2864,
    1949,
    2363,
    403,
    3330,
    1415,
    1279,
    2136,
    1697,
    2335,
    204,
    721,
    2097,
    3838,
    90,
    6186,
    2085,
    2505,
    191,
    3967,
    124,
    2148,
    1376,
    1798,
    1178,
    1107,
    1898,
    1405,
    860,
    4359,
    1243,
    1272,
    2375,
    2983,
    1558,
    2456,
    1638,
    113,
    3621,
    578,
    1923,
    2609,
    880,
    386,
    4130,
    784,
    2186,
    2266,
    1422,
    2956,
    2172,
    1722,
    497,
    263,
    2514,
    1267,
    2412,
    2610,
    177,
    2703,
    3542,
    774,
    1927,
    1344,
    616,
    1432,
    1595,
    1018,
    172,
    4360,
    2325,
    911,
    4361,
    438,
    1468,
    3622,
    794,
    3968,
    2024,
    2173,
    1681,
    1829,
    2957,
    945,
    895,
    3090,
    575,
    2212,
    2476,
    475,
    2401,
    2681,
    785,
    2744,
    1745,
    2293,
    2555,
    1975,
    3133,
    2865,
    394,
    4668,
    3839,
    635,
    4131,
    639,
    202,
    1507,
    2195,
    2766,
    1345,
    1435,
    2572,
    3726,
    1908,
    1184,
    1181,
    2457,
    3727,
    3134,
    4362,
    843,
    2611,
    437,
    916,
    4669,
    234,
    769,
    1884,
    3046,
    3047,
    3623,
    833,
    6187,
    1639,
    2250,
    2402,
    1355,
    1185,
    2010,
    2047,
    999,
    525,
    1732,
    1290,
    1488,
    2612,
    948,
    1578,
    3728,
    2413,
    2477,
    1216,
    2725,
    2159,
    334,
    3840,
    1328,
    3624,
    2921,
    1525,
    4132,
    564,
    1056,
    891,
    4363,
    1444,
    1698,
    2385,
    2251,
    3729,
    1365,
    2281,
    2235,
    1717,
    6188,
    864,
    3841,
    2515,
    444,
    527,
    2767,
    2922,
    3625,
    544,
    461,
    6189,
    566,
    209,
    2437,
    3398,
    2098,
    1065,
    2068,
    3331,
    3626,
    3257,
    2137,
    //Everything below is of no interest for detection purpose
    2138,
    2122,
    3730,
    2888,
    1995,
    1820,
    1044,
    6190,
    6191,
    6192,
    6193,
    6194,
    6195,
    6196,
    6197,
    6198,
    6199,
    6200,
    6201,
    6202,
    6203,
    6204,
    6205,
    4670,
    6206,
    6207,
    6208,
    6209,
    6210,
    6211,
    6212,
    6213,
    6214,
    6215,
    6216,
    6217,
    6218,
    6219,
    6220,
    6221,
    6222,
    6223,
    6224,
    6225,
    6226,
    6227,
    6228,
    6229,
    6230,
    6231,
    6232,
    6233,
    6234,
    6235,
    6236,
    6237,
    3187,
    6238,
    6239,
    3969,
    6240,
    6241,
    6242,
    6243,
    6244,
    4671,
    6245,
    6246,
    4672,
    6247,
    6248,
    4133,
    6249,
    6250,
    4364,
    6251,
    2923,
    2556,
    2613,
    4673,
    4365,
    3970,
    6252,
    6253,
    6254,
    6255,
    4674,
    6256,
    6257,
    6258,
    2768,
    2353,
    4366,
    4675,
    4676,
    3188,
    4367,
    3463,
    6259,
    4134,
    4677,
    4678,
    6260,
    2267,
    6261,
    3842,
    3332,
    4368,
    3543,
    6262,
    6263,
    6264,
    3013,
    1954,
    1928,
    4135,
    4679,
    6265,
    6266,
    2478,
    3091,
    6267,
    4680,
    4369,
    6268,
    6269,
    1699,
    6270,
    3544,
    4136,
    4681,
    6271,
    4137,
    6272,
    4370,
    2804,
    6273,
    6274,
    2593,
    3971,
    3972,
    4682,
    6275,
    2236,
    4683,
    6276,
    6277,
    4684,
    6278,
    6279,
    4138,
    3973,
    4685,
    6280,
    6281,
    3258,
    6282,
    6283,
    6284,
    6285,
    3974,
    4686,
    2841,
    3975,
    6286,
    6287,
    3545,
    6288,
    6289,
    4139,
    4687,
    4140,
    6290,
    4141,
    6291,
    4142,
    6292,
    6293,
    3333,
    6294,
    6295,
    6296,
    4371,
    6297,
    3399,
    6298,
    6299,
    4372,
    3976,
    6300,
    6301,
    6302,
    4373,
    6303,
    6304,
    3843,
    3731,
    6305,
    4688,
    4374,
    6306,
    6307,
    3259,
    2294,
    6308,
    3732,
    2530,
    4143,
    6309,
    4689,
    6310,
    6311,
    6312,
    3048,
    6313,
    6314,
    4690,
    3733,
    2237,
    6315,
    6316,
    2282,
    3334,
    6317,
    6318,
    3844,
    6319,
    6320,
    4691,
    6321,
    3400,
    4692,
    6322,
    4693,
    6323,
    3049,
    6324,
    4375,
    6325,
    3977,
    6326,
    6327,
    6328,
    3546,
    6329,
    4694,
    3335,
    6330,
    4695,
    4696,
    6331,
    6332,
    6333,
    6334,
    4376,
    3978,
    6335,
    4697,
    3979,
    4144,
    6336,
    3980,
    4698,
    6337,
    6338,
    6339,
    6340,
    6341,
    4699,
    4700,
    4701,
    6342,
    6343,
    4702,
    6344,
    6345,
    4703,
    6346,
    6347,
    4704,
    6348,
    4705,
    4706,
    3135,
    6349,
    4707,
    6350,
    4708,
    6351,
    4377,
    6352,
    4709,
    3734,
    4145,
    6353,
    2506,
    4710,
    3189,
    6354,
    3050,
    4711,
    3981,
    6355,
    3547,
    3014,
    4146,
    4378,
    3735,
    2651,
    3845,
    3260,
    3136,
    2224,
    1986,
    6356,
    3401,
    6357,
    4712,
    2594,
    3627,
    3137,
    2573,
    3736,
    3982,
    4713,
    3628,
    4714,
    4715,
    2682,
    3629,
    4716,
    6358,
    3630,
    4379,
    3631,
    6359,
    6360,
    6361,
    3983,
    6362,
    6363,
    6364,
    6365,
    4147,
    3846,
    4717,
    6366,
    6367,
    3737,
    2842,
    6368,
    4718,
    2628,
    6369,
    3261,
    6370,
    2386,
    6371,
    6372,
    3738,
    3984,
    4719,
    3464,
    4720,
    3402,
    6373,
    2924,
    3336,
    4148,
    2866,
    6374,
    2805,
    3262,
    4380,
    2704,
    2069,
    2531,
    3138,
    2806,
    2984,
    6375,
    2769,
    6376,
    4721,
    4722,
    3403,
    6377,
    6378,
    3548,
    6379,
    6380,
    2705,
    3092,
    1979,
    4149,
    2629,
    3337,
    2889,
    6381,
    3338,
    4150,
    2557,
    3339,
    4381,
    6382,
    3190,
    3263,
    3739,
    6383,
    4151,
    4723,
    4152,
    2558,
    2574,
    3404,
    3191,
    6384,
    6385,
    4153,
    6386,
    4724,
    4382,
    6387,
    6388,
    4383,
    6389,
    6390,
    4154,
    6391,
    4725,
    3985,
    6392,
    3847,
    4155,
    6393,
    6394,
    6395,
    6396,
    6397,
    3465,
    6398,
    4384,
    6399,
    6400,
    6401,
    6402,
    6403,
    6404,
    4156,
    6405,
    6406,
    6407,
    6408,
    2123,
    6409,
    6410,
    2326,
    3192,
    4726,
    6411,
    6412,
    6413,
    6414,
    4385,
    4157,
    6415,
    6416,
    4158,
    6417,
    3093,
    3848,
    6418,
    3986,
    6419,
    6420,
    3849,
    6421,
    6422,
    6423,
    4159,
    6424,
    6425,
    4160,
    6426,
    3740,
    6427,
    6428,
    6429,
    6430,
    3987,
    6431,
    4727,
    6432,
    2238,
    6433,
    6434,
    4386,
    3988,
    6435,
    6436,
    3632,
    6437,
    6438,
    2843,
    6439,
    6440,
    6441,
    6442,
    3633,
    6443,
    2958,
    6444,
    6445,
    3466,
    6446,
    2364,
    4387,
    3850,
    6447,
    4388,
    2959,
    3340,
    6448,
    3851,
    6449,
    4728,
    6450,
    6451,
    3264,
    4729,
    6452,
    3193,
    6453,
    4389,
    4390,
    2706,
    3341,
    4730,
    6454,
    3139,
    6455,
    3194,
    6456,
    3051,
    2124,
    3852,
    1602,
    4391,
    4161,
    3853,
    1158,
    3854,
    4162,
    3989,
    4392,
    3990,
    4731,
    4732,
    4393,
    2040,
    4163,
    4394,
    3265,
    6457,
    2807,
    3467,
    3855,
    6458,
    6459,
    6460,
    3991,
    3468,
    4733,
    4734,
    6461,
    3140,
    2960,
    6462,
    4735,
    6463,
    6464,
    6465,
    6466,
    4736,
    4737,
    4738,
    4739,
    6467,
    6468,
    4164,
    2403,
    3856,
    6469,
    6470,
    2770,
    2844,
    6471,
    4740,
    6472,
    6473,
    6474,
    6475,
    6476,
    6477,
    6478,
    3195,
    6479,
    4741,
    4395,
    6480,
    2867,
    6481,
    4742,
    2808,
    6482,
    2493,
    4165,
    6483,
    6484,
    6485,
    6486,
    2295,
    4743,
    6487,
    6488,
    6489,
    3634,
    6490,
    6491,
    6492,
    6493,
    6494,
    6495,
    6496,
    2985,
    4744,
    6497,
    6498,
    4745,
    6499,
    6500,
    2925,
    3141,
    4166,
    6501,
    6502,
    4746,
    6503,
    6504,
    4747,
    6505,
    6506,
    6507,
    2890,
    6508,
    6509,
    6510,
    6511,
    6512,
    6513,
    6514,
    6515,
    6516,
    6517,
    6518,
    6519,
    3469,
    4167,
    6520,
    6521,
    6522,
    4748,
    4396,
    3741,
    4397,
    4749,
    4398,
    3342,
    2125,
    4750,
    6523,
    4751,
    4752,
    4753,
    3052,
    6524,
    2961,
    4168,
    6525,
    4754,
    6526,
    4755,
    4399,
    2926,
    4169,
    6527,
    3857,
    6528,
    4400,
    4170,
    6529,
    4171,
    6530,
    6531,
    2595,
    6532,
    6533,
    6534,
    6535,
    3635,
    6536,
    6537,
    6538,
    6539,
    6540,
    6541,
    6542,
    4756,
    6543,
    6544,
    6545,
    6546,
    6547,
    6548,
    4401,
    6549,
    6550,
    6551,
    6552,
    4402,
    3405,
    4757,
    4403,
    6553,
    6554,
    6555,
    4172,
    3742,
    6556,
    6557,
    6558,
    3992,
    3636,
    6559,
    6560,
    3053,
    2726,
    6561,
    3549,
    4173,
    3054,
    4404,
    6562,
    6563,
    3993,
    4405,
    3266,
    3550,
    2809,
    4406,
    6564,
    6565,
    6566,
    4758,
    4759,
    6567,
    3743,
    6568,
    4760,
    3744,
    4761,
    3470,
    6569,
    6570,
    6571,
    4407,
    6572,
    3745,
    4174,
    6573,
    4175,
    2810,
    4176,
    3196,
    4762,
    6574,
    4177,
    6575,
    6576,
    2494,
    2891,
    3551,
    6577,
    6578,
    3471,
    6579,
    4408,
    6580,
    3015,
    3197,
    6581,
    3343,
    2532,
    3994,
    3858,
    6582,
    3094,
    3406,
    4409,
    6583,
    2892,
    4178,
    4763,
    4410,
    3016,
    4411,
    6584,
    3995,
    3142,
    3017,
    2683,
    6585,
    4179,
    6586,
    6587,
    4764,
    4412,
    6588,
    6589,
    4413,
    6590,
    2986,
    6591,
    2962,
    3552,
    6592,
    2963,
    3472,
    6593,
    6594,
    4180,
    4765,
    6595,
    6596,
    2225,
    3267,
    4414,
    6597,
    3407,
    3637,
    4766,
    6598,
    6599,
    3198,
    6600,
    4415,
    6601,
    3859,
    3199,
    6602,
    3473,
    4767,
    2811,
    4416,
    1856,
    3268,
    3200,
    2575,
    3996,
    3997,
    3201,
    4417,
    6603,
    3095,
    2927,
    6604,
    3143,
    6605,
    2268,
    6606,
    3998,
    3860,
    3096,
    2771,
    6607,
    6608,
    3638,
    2495,
    4768,
    6609,
    3861,
    6610,
    3269,
    2745,
    4769,
    4181,
    3553,
    6611,
    2845,
    3270,
    6612,
    6613,
    6614,
    3862,
    6615,
    6616,
    4770,
    4771,
    6617,
    3474,
    3999,
    4418,
    4419,
    6618,
    3639,
    3344,
    6619,
    4772,
    4182,
    6620,
    2126,
    6621,
    6622,
    6623,
    4420,
    4773,
    6624,
    3018,
    6625,
    4774,
    3554,
    6626,
    4183,
    2025,
    3746,
    6627,
    4184,
    2707,
    6628,
    4421,
    4422,
    3097,
    1775,
    4185,
    3555,
    6629,
    6630,
    2868,
    6631,
    6632,
    4423,
    6633,
    6634,
    4424,
    2414,
    2533,
    2928,
    6635,
    4186,
    2387,
    6636,
    4775,
    6637,
    4187,
    6638,
    1891,
    4425,
    3202,
    3203,
    6639,
    6640,
    4776,
    6641,
    3345,
    6642,
    6643,
    3640,
    6644,
    3475,
    3346,
    3641,
    4000,
    6645,
    3144,
    6646,
    3098,
    2812,
    4188,
    3642,
    3204,
    6647,
    3863,
    3476,
    6648,
    3864,
    6649,
    4426,
    4001,
    6650,
    6651,
    6652,
    2576,
    6653,
    4189,
    4777,
    6654,
    6655,
    6656,
    2846,
    6657,
    3477,
    3205,
    4002,
    6658,
    4003,
    6659,
    3347,
    2252,
    6660,
    6661,
    6662,
    4778,
    6663,
    6664,
    6665,
    6666,
    6667,
    6668,
    6669,
    4779,
    4780,
    2048,
    6670,
    3478,
    3099,
    6671,
    3556,
    3747,
    4004,
    6672,
    6673,
    6674,
    3145,
    4005,
    3748,
    6675,
    6676,
    6677,
    6678,
    6679,
    3408,
    6680,
    6681,
    6682,
    6683,
    3206,
    3207,
    6684,
    6685,
    4781,
    4427,
    6686,
    4782,
    4783,
    4784,
    6687,
    6688,
    6689,
    4190,
    6690,
    6691,
    3479,
    6692,
    2746,
    6693,
    4428,
    6694,
    6695,
    6696,
    6697,
    6698,
    6699,
    4785,
    6700,
    6701,
    3208,
    2727,
    6702,
    3146,
    6703,
    6704,
    3409,
    2196,
    6705,
    4429,
    6706,
    6707,
    6708,
    2534,
    1996,
    6709,
    6710,
    6711,
    2747,
    6712,
    6713,
    6714,
    4786,
    3643,
    6715,
    4430,
    4431,
    6716,
    3557,
    6717,
    4432,
    4433,
    6718,
    6719,
    6720,
    6721,
    3749,
    6722,
    4006,
    4787,
    6723,
    6724,
    3644,
    4788,
    4434,
    6725,
    6726,
    4789,
    2772,
    6727,
    6728,
    6729,
    6730,
    6731,
    2708,
    3865,
    2813,
    4435,
    6732,
    6733,
    4790,
    4791,
    3480,
    6734,
    6735,
    6736,
    6737,
    4436,
    3348,
    6738,
    3410,
    4007,
    6739,
    6740,
    4008,
    6741,
    6742,
    4792,
    3411,
    4191,
    6743,
    6744,
    6745,
    6746,
    6747,
    3866,
    6748,
    3750,
    6749,
    6750,
    6751,
    6752,
    6753,
    6754,
    6755,
    3867,
    6756,
    4009,
    6757,
    4793,
    4794,
    6758,
    2814,
    2987,
    6759,
    6760,
    6761,
    4437,
    6762,
    6763,
    6764,
    6765,
    3645,
    6766,
    6767,
    3481,
    4192,
    6768,
    3751,
    6769,
    6770,
    2174,
    6771,
    3868,
    3752,
    6772,
    6773,
    6774,
    4193,
    4795,
    4438,
    3558,
    4796,
    4439,
    6775,
    4797,
    6776,
    6777,
    4798,
    6778,
    4799,
    3559,
    4800,
    6779,
    6780,
    6781,
    3482,
    6782,
    2893,
    6783,
    6784,
    4194,
    4801,
    4010,
    6785,
    6786,
    4440,
    6787,
    4011,
    6788,
    6789,
    6790,
    6791,
    6792,
    6793,
    4802,
    6794,
    6795,
    6796,
    4012,
    6797,
    6798,
    6799,
    6800,
    3349,
    4803,
    3483,
    6801,
    4804,
    4195,
    6802,
    4013,
    6803,
    6804,
    4196,
    6805,
    4014,
    4015,
    6806,
    2847,
    3271,
    2848,
    6807,
    3484,
    6808,
    6809,
    6810,
    4441,
    6811,
    4442,
    4197,
    4443,
    3272,
    4805,
    6812,
    3412,
    4016,
    1579,
    6813,
    6814,
    4017,
    6815,
    3869,
    6816,
    2964,
    6817,
    4806,
    6818,
    6819,
    4018,
    3646,
    6820,
    6821,
    4807,
    4019,
    4020,
    6822,
    6823,
    3560,
    6824,
    6825,
    4021,
    4444,
    6826,
    4198,
    6827,
    6828,
    4445,
    6829,
    6830,
    4199,
    4808,
    6831,
    6832,
    6833,
    3870,
    3019,
    2458,
    6834,
    3753,
    3413,
    3350,
    6835,
    4809,
    3871,
    4810,
    3561,
    4446,
    6836,
    6837,
    4447,
    4811,
    4812,
    6838,
    2459,
    4448,
    6839,
    4449,
    6840,
    6841,
    4022,
    3872,
    6842,
    4813,
    4814,
    6843,
    6844,
    4815,
    4200,
    4201,
    4202,
    6845,
    4023,
    6846,
    6847,
    4450,
    3562,
    3873,
    6848,
    6849,
    4816,
    4817,
    6850,
    4451,
    4818,
    2139,
    6851,
    3563,
    6852,
    6853,
    3351,
    6854,
    6855,
    3352,
    4024,
    2709,
    3414,
    4203,
    4452,
    6856,
    4204,
    6857,
    6858,
    3874,
    3875,
    6859,
    6860,
    4819,
    6861,
    6862,
    6863,
    6864,
    4453,
    3647,
    6865,
    6866,
    4820,
    6867,
    6868,
    6869,
    6870,
    4454,
    6871,
    2869,
    6872,
    6873,
    4821,
    6874,
    3754,
    6875,
    4822,
    4205,
    6876,
    6877,
    6878,
    3648,
    4206,
    4455,
    6879,
    4823,
    6880,
    4824,
    3876,
    6881,
    3055,
    4207,
    6882,
    3415,
    6883,
    6884,
    6885,
    4208,
    4209,
    6886,
    4210,
    3353,
    6887,
    3354,
    3564,
    3209,
    3485,
    2652,
    6888,
    2728,
    6889,
    3210,
    3755,
    6890,
    4025,
    4456,
    6891,
    4825,
    6892,
    6893,
    6894,
    6895,
    4211,
    6896,
    6897,
    6898,
    4826,
    6899,
    6900,
    4212,
    6901,
    4827,
    6902,
    2773,
    3565,
    6903,
    4828,
    6904,
    6905,
    6906,
    6907,
    3649,
    3650,
    6908,
    2849,
    3566,
    6909,
    3567,
    3100,
    6910,
    6911,
    6912,
    6913,
    6914,
    6915,
    4026,
    6916,
    3355,
    4829,
    3056,
    4457,
    3756,
    6917,
    3651,
    6918,
    4213,
    3652,
    2870,
    6919,
    4458,
    6920,
    2438,
    6921,
    6922,
    3757,
    2774,
    4830,
    6923,
    3356,
    4831,
    4832,
    6924,
    4833,
    4459,
    3653,
    2507,
    6925,
    4834,
    2535,
    6926,
    6927,
    3273,
    4027,
    3147,
    6928,
    3568,
    6929,
    6930,
    6931,
    4460,
    6932,
    3877,
    4461,
    2729,
    3654,
    6933,
    6934,
    6935,
    6936,
    2175,
    4835,
    2630,
    4214,
    4028,
    4462,
    4836,
    4215,
    6937,
    3148,
    4216,
    4463,
    4837,
    4838,
    4217,
    6938,
    6939,
    2850,
    4839,
    6940,
    4464,
    6941,
    6942,
    6943,
    4840,
    6944,
    4218,
    3274,
    4465,
    6945,
    6946,
    2710,
    6947,
    4841,
    4466,
    6948,
    6949,
    2894,
    6950,
    6951,
    4842,
    6952,
    4219,
    3057,
    2871,
    6953,
    6954,
    6955,
    6956,
    4467,
    6957,
    2711,
    6958,
    6959,
    6960,
    3275,
    3101,
    4843,
    6961,
    3357,
    3569,
    6962,
    4844,
    6963,
    6964,
    4468,
    4845,
    3570,
    6965,
    3102,
    4846,
    3758,
    6966,
    4847,
    3878,
    4848,
    4849,
    4029,
    6967,
    2929,
    3879,
    4850,
    4851,
    6968,
    6969,
    1733,
    6970,
    4220,
    6971,
    6972,
    6973,
    6974,
    6975,
    6976,
    4852,
    6977,
    6978,
    6979,
    6980,
    6981,
    6982,
    3759,
    6983,
    6984,
    6985,
    3486,
    3487,
    6986,
    3488,
    3416,
    6987,
    6988,
    6989,
    6990,
    6991,
    6992,
    6993,
    6994,
    6995,
    6996,
    6997,
    4853,
    6998,
    6999,
    4030,
    7000,
    7001,
    3211,
    7002,
    7003,
    4221,
    7004,
    7005,
    3571,
    4031,
    7006,
    3572,
    7007,
    2614,
    4854,
    2577,
    7008,
    7009,
    2965,
    3655,
    3656,
    4855,
    2775,
    3489,
    3880,
    4222,
    4856,
    3881,
    4032,
    3882,
    3657,
    2730,
    3490,
    4857,
    7010,
    3149,
    7011,
    4469,
    4858,
    2496,
    3491,
    4859,
    2283,
    7012,
    7013,
    7014,
    2365,
    4860,
    4470,
    7015,
    7016,
    3760,
    7017,
    7018,
    4223,
    1917,
    7019,
    7020,
    7021,
    4471,
    7022,
    2776,
    4472,
    7023,
    7024,
    7025,
    7026,
    4033,
    7027,
    3573,
    4224,
    4861,
    4034,
    4862,
    7028,
    7029,
    1929,
    3883,
    4035,
    7030,
    4473,
    3058,
    7031,
    2536,
    3761,
    3884,
    7032,
    4036,
    7033,
    2966,
    2895,
    1968,
    4474,
    3276,
    4225,
    3417,
    3492,
    4226,
    2105,
    7034,
    7035,
    1754,
    2596,
    3762,
    4227,
    4863,
    4475,
    3763,
    4864,
    3764,
    2615,
    2777,
    3103,
    3765,
    3658,
    3418,
    4865,
    2296,
    3766,
    2815,
    7036,
    7037,
    7038,
    3574,
    2872,
    3277,
    4476,
    7039,
    4037,
    4477,
    7040,
    7041,
    4038,
    7042,
    7043,
    7044,
    7045,
    7046,
    7047,
    2537,
    7048,
    7049,
    7050,
    7051,
    7052,
    7053,
    7054,
    4478,
    7055,
    7056,
    3767,
    3659,
    4228,
    3575,
    7057,
    7058,
    4229,
    7059,
    7060,
    7061,
    3660,
    7062,
    3212,
    7063,
    3885,
    4039,
    2460,
    7064,
    7065,
    7066,
    7067,
    7068,
    7069,
    7070,
    7071,
    7072,
    7073,
    7074,
    4866,
    3768,
    4867,
    7075,
    7076,
    7077,
    7078,
    4868,
    3358,
    3278,
    2653,
    7079,
    7080,
    4479,
    3886,
    7081,
    7082,
    4869,
    7083,
    7084,
    7085,
    7086,
    7087,
    7088,
    2538,
    7089,
    7090,
    7091,
    4040,
    3150,
    3769,
    4870,
    4041,
    2896,
    3359,
    4230,
    2930,
    7092,
    3279,
    7093,
    2967,
    4480,
    3213,
    4481,
    3661,
    7094,
    7095,
    7096,
    7097,
    7098,
    7099,
    7100,
    7101,
    7102,
    2461,
    3770,
    7103,
    7104,
    4231,
    3151,
    7105,
    7106,
    7107,
    4042,
    3662,
    7108,
    7109,
    4871,
    3663,
    4872,
    4043,
    3059,
    7110,
    7111,
    7112,
    3493,
    2988,
    7113,
    4873,
    7114,
    7115,
    7116,
    3771,
    4874,
    7117,
    7118,
    4232,
    4875,
    7119,
    3576,
    2336,
    4876,
    7120,
    4233,
    3419,
    4044,
    4877,
    4878,
    4482,
    4483,
    4879,
    4484,
    4234,
    7121,
    3772,
    4880,
    1045,
    3280,
    3664,
    4881,
    4882,
    7122,
    7123,
    7124,
    7125,
    4883,
    7126,
    2778,
    7127,
    4485,
    4486,
    7128,
    4884,
    3214,
    3887,
    7129,
    7130,
    3215,
    7131,
    4885,
    4045,
    7132,
    7133,
    4046,
    7134,
    7135,
    7136,
    7137,
    7138,
    7139,
    7140,
    7141,
    7142,
    7143,
    4235,
    7144,
    4886,
    7145,
    7146,
    7147,
    4887,
    7148,
    7149,
    7150,
    4487,
    4047,
    4488,
    7151,
    7152,
    4888,
    4048,
    2989,
    3888,
    7153,
    3665,
    7154,
    4049,
    7155,
    7156,
    7157,
    7158,
    7159,
    7160,
    2931,
    4889,
    4890,
    4489,
    7161,
    2631,
    3889,
    4236,
    2779,
    7162,
    7163,
    4891,
    7164,
    3060,
    7165,
    1672,
    4892,
    7166,
    4893,
    4237,
    3281,
    4894,
    7167,
    7168,
    3666,
    7169,
    3494,
    7170,
    7171,
    4050,
    7172,
    7173,
    3104,
    3360,
    3420,
    4490,
    4051,
    2684,
    4052,
    7174,
    4053,
    7175,
    7176,
    7177,
    2253,
    4054,
    7178,
    7179,
    4895,
    7180,
    3152,
    3890,
    3153,
    4491,
    3216,
    7181,
    7182,
    7183,
    2968,
    4238,
    4492,
    4055,
    7184,
    2990,
    7185,
    2479,
    7186,
    7187,
    4493,
    7188,
    7189,
    7190,
    7191,
    7192,
    4896,
    7193,
    4897,
    2969,
    4494,
    4898,
    7194,
    3495,
    7195,
    7196,
    4899,
    4495,
    7197,
    3105,
    2731,
    7198,
    4900,
    7199,
    7200,
    7201,
    4056,
    7202,
    3361,
    7203,
    7204,
    4496,
    4901,
    4902,
    7205,
    4497,
    7206,
    7207,
    2315,
    4903,
    7208,
    4904,
    7209,
    4905,
    2851,
    7210,
    7211,
    3577,
    7212,
    3578,
    4906,
    7213,
    4057,
    3667,
    4907,
    7214,
    4058,
    2354,
    3891,
    2376,
    3217,
    3773,
    7215,
    7216,
    7217,
    7218,
    7219,
    4498,
    7220,
    4908,
    3282,
    2685,
    7221,
    3496,
    4909,
    2632,
    3154,
    4910,
    7222,
    2337,
    7223,
    4911,
    7224,
    7225,
    7226,
    4912,
    4913,
    3283,
    4239,
    4499,
    7227,
    2816,
    7228,
    7229,
    7230,
    7231,
    7232,
    7233,
    7234,
    4914,
    4500,
    4501,
    7235,
    7236,
    7237,
    2686,
    7238,
    4915,
    7239,
    2897,
    4502,
    7240,
    4503,
    7241,
    2516,
    7242,
    4504,
    3362,
    3218,
    7243,
    7244,
    7245,
    4916,
    7246,
    7247,
    4505,
    3363,
    7248,
    7249,
    7250,
    7251,
    3774,
    4506,
    7252,
    7253,
    4917,
    7254,
    7255,
    3284,
    2991,
    4918,
    4919,
    3219,
    3892,
    4920,
    3106,
    3497,
    4921,
    7256,
    7257,
    7258,
    4922,
    7259,
    4923,
    3364,
    4507,
    4508,
    4059,
    7260,
    4240,
    3498,
    7261,
    7262,
    4924,
    7263,
    2992,
    3893,
    4060,
    3220,
    7264,
    7265,
    7266,
    7267,
    7268,
    7269,
    4509,
    3775,
    7270,
    2817,
    7271,
    4061,
    4925,
    4510,
    3776,
    7272,
    4241,
    4511,
    3285,
    7273,
    7274,
    3499,
    7275,
    7276,
    7277,
    4062,
    4512,
    4926,
    7278,
    3107,
    3894,
    7279,
    7280,
    4927,
    7281,
    4513,
    7282,
    7283,
    3668,
    7284,
    7285,
    4242,
    4514,
    4243,
    7286,
    2058,
    4515,
    4928,
    4929,
    4516,
    7287,
    3286,
    4244,
    7288,
    4517,
    7289,
    7290,
    7291,
    3669,
    7292,
    7293,
    4930,
    4931,
    4932,
    2355,
    4933,
    7294,
    2633,
    4518,
    7295,
    4245,
    7296,
    7297,
    4519,
    7298,
    7299,
    4520,
    4521,
    4934,
    7300,
    4246,
    4522,
    7301,
    7302,
    7303,
    3579,
    7304,
    4247,
    4935,
    7305,
    4936,
    7306,
    7307,
    7308,
    7309,
    3777,
    7310,
    4523,
    7311,
    7312,
    7313,
    4248,
    3580,
    7314,
    4524,
    3778,
    4249,
    7315,
    3581,
    7316,
    3287,
    7317,
    3221,
    7318,
    4937,
    7319,
    7320,
    7321,
    7322,
    7323,
    7324,
    4938,
    4939,
    7325,
    4525,
    7326,
    7327,
    7328,
    4063,
    7329,
    7330,
    4940,
    7331,
    7332,
    4941,
    7333,
    4526,
    7334,
    3500,
    2780,
    1741,
    4942,
    2026,
    1742,
    7335,
    7336,
    3582,
    4527,
    2388,
    7337,
    7338,
    7339,
    4528,
    7340,
    4250,
    4943,
    7341,
    7342,
    7343,
    4944,
    7344,
    7345,
    7346,
    3020,
    7347,
    4945,
    7348,
    7349,
    7350,
    7351,
    3895,
    7352,
    3896,
    4064,
    3897,
    7353,
    7354,
    7355,
    4251,
    7356,
    7357,
    3898,
    7358,
    3779,
    7359,
    3780,
    3288,
    7360,
    7361,
    4529,
    7362,
    4946,
    4530,
    2027,
    7363,
    3899,
    4531,
    4947,
    3222,
    3583,
    7364,
    4948,
    7365,
    7366,
    7367,
    7368,
    4949,
    3501,
    4950,
    3781,
    4951,
    4532,
    7369,
    2517,
    4952,
    4252,
    4953,
    3155,
    7370,
    4954,
    4955,
    4253,
    2518,
    4533,
    7371,
    7372,
    2712,
    4254,
    7373,
    7374,
    7375,
    3670,
    4956,
    3671,
    7376,
    2389,
    3502,
    4065,
    7377,
    2338,
    7378,
    7379,
    7380,
    7381,
    3061,
    7382,
    4957,
    7383,
    7384,
    7385,
    7386,
    4958,
    4534,
    7387,
    7388,
    2993,
    7389,
    3062,
    7390,
    4959,
    7391,
    7392,
    7393,
    4960,
    3108,
    4961,
    7394,
    4535,
    7395,
    4962,
    3421,
    4536,
    7396,
    4963,
    7397,
    4964,
    1857,
    7398,
    4965,
    7399,
    7400,
    2176,
    3584,
    4966,
    7401,
    7402,
    3422,
    4537,
    3900,
    3585,
    7403,
    3782,
    7404,
    2852,
    7405,
    7406,
    7407,
    4538,
    3783,
    2654,
    3423,
    4967,
    4539,
    7408,
    3784,
    3586,
    2853,
    4540,
    4541,
    7409,
    3901,
    7410,
    3902,
    7411,
    7412,
    3785,
    3109,
    2327,
    3903,
    7413,
    7414,
    2970,
    4066,
    2932,
    7415,
    7416,
    7417,
    3904,
    3672,
    3424,
    7418,
    4542,
    4543,
    4544,
    7419,
    4968,
    7420,
    7421,
    4255,
    7422,
    7423,
    7424,
    7425,
    7426,
    4067,
    7427,
    3673,
    3365,
    4545,
    7428,
    3110,
    2559,
    3674,
    7429,
    7430,
    3156,
    7431,
    7432,
    3503,
    7433,
    3425,
    4546,
    7434,
    3063,
    2873,
    7435,
    3223,
    4969,
    4547,
    4548,
    2898,
    4256,
    4068,
    7436,
    4069,
    3587,
    3786,
    2933,
    3787,
    4257,
    4970,
    4971,
    3788,
    7437,
    4972,
    3064,
    7438,
    4549,
    7439,
    7440,
    7441,
    7442,
    7443,
    4973,
    3905,
    7444,
    2874,
    7445,
    7446,
    7447,
    7448,
    3021,
    7449,
    4550,
    3906,
    3588,
    4974,
    7450,
    7451,
    3789,
    3675,
    7452,
    2578,
    7453,
    4070,
    7454,
    7455,
    7456,
    4258,
    3676,
    7457,
    4975,
    7458,
    4976,
    4259,
    3790,
    3504,
    2634,
    4977,
    3677,
    4551,
    4260,
    7459,
    7460,
    7461,
    7462,
    3907,
    4261,
    4978,
    7463,
    7464,
    7465,
    7466,
    4979,
    4980,
    7467,
    7468,
    2213,
    4262,
    7469,
    7470,
    7471,
    3678,
    4981,
    7472,
    2439,
    7473,
    4263,
    3224,
    3289,
    7474,
    3908,
    2415,
    4982,
    7475,
    4264,
    7476,
    4983,
    2655,
    7477,
    7478,
    2732,
    4552,
    2854,
    2875,
    7479,
    7480,
    4265,
    7481,
    4553,
    4984,
    7482,
    7483,
    4266,
    7484,
    3679,
    3366,
    3680,
    2818,
    2781,
    2782,
    3367,
    3589,
    4554,
    3065,
    7485,
    4071,
    2899,
    7486,
    7487,
    3157,
    2462,
    4072,
    4555,
    4073,
    4985,
    4986,
    3111,
    4267,
    2687,
    3368,
    4556,
    4074,
    3791,
    4268,
    7488,
    3909,
    2783,
    7489,
    2656,
    1962,
    3158,
    4557,
    4987,
    1963,
    3159,
    3160,
    7490,
    3112,
    4988,
    4989,
    3022,
    4990,
    4991,
    3792,
    2855,
    7491,
    7492,
    2971,
    4558,
    7493,
    7494,
    4992,
    7495,
    7496,
    7497,
    7498,
    4993,
    7499,
    3426,
    4559,
    4994,
    7500,
    3681,
    4560,
    4269,
    4270,
    3910,
    7501,
    4075,
    4995,
    4271,
    7502,
    7503,
    4076,
    7504,
    4996,
    7505,
    3225,
    4997,
    4272,
    4077,
    2819,
    3023,
    7506,
    7507,
    2733,
    4561,
    7508,
    4562,
    7509,
    3369,
    3793,
    7510,
    3590,
    2508,
    7511,
    7512,
    4273,
    3113,
    2994,
    2616,
    7513,
    7514,
    7515,
    7516,
    7517,
    7518,
    2820,
    3911,
    4078,
    2748,
    7519,
    7520,
    4563,
    4998,
    7521,
    7522,
    7523,
    7524,
    4999,
    4274,
    7525,
    4564,
    3682,
    2239,
    4079,
    4565,
    7526,
    7527,
    7528,
    7529,
    5000,
    7530,
    7531,
    5001,
    4275,
    3794,
    7532,
    7533,
    7534,
    3066,
    5002,
    4566,
    3161,
    7535,
    7536,
    4080,
    7537,
    3162,
    7538,
    7539,
    4567,
    7540,
    7541,
    7542,
    7543,
    7544,
    7545,
    5003,
    7546,
    4568,
    7547,
    7548,
    7549,
    7550,
    7551,
    7552,
    7553,
    7554,
    7555,
    7556,
    5004,
    7557,
    7558,
    7559,
    5005,
    7560,
    3795,
    7561,
    4569,
    7562,
    7563,
    7564,
    2821,
    3796,
    4276,
    4277,
    4081,
    7565,
    2876,
    7566,
    5006,
    7567,
    7568,
    2900,
    7569,
    3797,
    3912,
    7570,
    7571,
    7572,
    4278,
    7573,
    7574,
    7575,
    5007,
    7576,
    7577,
    5008,
    7578,
    7579,
    4279,
    2934,
    7580,
    7581,
    5009,
    7582,
    4570,
    7583,
    4280,
    7584,
    7585,
    7586,
    4571,
    4572,
    3913,
    7587,
    4573,
    3505,
    7588,
    5010,
    7589,
    7590,
    7591,
    7592,
    3798,
    4574,
    7593,
    7594,
    5011,
    7595,
    4281,
    7596,
    7597,
    7598,
    4282,
    5012,
    7599,
    7600,
    5013,
    3163,
    7601,
    5014,
    7602,
    3914,
    7603,
    7604,
    2734,
    4575,
    4576,
    4577,
    7605,
    7606,
    7607,
    7608,
    7609,
    3506,
    5015,
    4578,
    7610,
    4082,
    7611,
    2822,
    2901,
    2579,
    3683,
    3024,
    4579,
    3507,
    7612,
    4580,
    7613,
    3226,
    3799,
    5016,
    7614,
    7615,
    7616,
    7617,
    7618,
    7619,
    7620,
    2995,
    3290,
    7621,
    4083,
    7622,
    5017,
    7623,
    7624,
    7625,
    7626,
    7627,
    4581,
    3915,
    7628,
    3291,
    7629,
    5018,
    7630,
    7631,
    7632,
    7633,
    4084,
    7634,
    7635,
    3427,
    3800,
    7636,
    7637,
    4582,
    7638,
    5019,
    4583,
    5020,
    7639,
    3916,
    7640,
    3801,
    5021,
    4584,
    4283,
    7641,
    7642,
    3428,
    3591,
    2269,
    7643,
    2617,
    7644,
    4585,
    3592,
    7645,
    4586,
    2902,
    7646,
    7647,
    3227,
    5022,
    7648,
    4587,
    7649,
    4284,
    7650,
    7651,
    7652,
    4588,
    2284,
    7653,
    5023,
    7654,
    7655,
    7656,
    4589,
    5024,
    3802,
    7657,
    7658,
    5025,
    3508,
    4590,
    7659,
    7660,
    7661,
    1969,
    5026,
    7662,
    7663,
    3684,
    1821,
    2688,
    7664,
    2028,
    2509,
    4285,
    7665,
    2823,
    1841,
    7666,
    2689,
    3114,
    7667,
    3917,
    4085,
    2160,
    5027,
    5028,
    2972,
    7668,
    5029,
    7669,
    7670,
    7671,
    3593,
    4086,
    7672,
    4591,
    4087,
    5030,
    3803,
    7673,
    7674,
    7675,
    7676,
    7677,
    7678,
    7679,
    4286,
    2366,
    4592,
    4593,
    3067,
    2328,
    7680,
    7681,
    4594,
    3594,
    3918,
    2029,
    4287,
    7682,
    5031,
    3919,
    3370,
    4288,
    4595,
    2856,
    7683,
    3509,
    7684,
    7685,
    5032,
    5033,
    7686,
    7687,
    3804,
    2784,
    7688,
    7689,
    7690,
    7691,
    3371,
    7692,
    7693,
    2877,
    5034,
    7694,
    7695,
    3920,
    4289,
    4088,
    7696,
    7697,
    7698,
    5035,
    7699,
    5036,
    4290,
    5037,
    5038,
    5039,
    7700,
    7701,
    7702,
    5040,
    5041,
    3228,
    7703,
    1760,
    7704,
    5042,
    3229,
    4596,
    2106,
    4089,
    7705,
    4597,
    2824,
    5043,
    2107,
    3372,
    7706,
    4291,
    4090,
    5044,
    7707,
    4091,
    7708,
    5045,
    3025,
    3805,
    4598,
    4292,
    4293,
    4294,
    3373,
    7709,
    4599,
    7710,
    5046,
    7711,
    7712,
    5047,
    5048,
    3806,
    7713,
    7714,
    7715,
    5049,
    7716,
    7717,
    7718,
    7719,
    4600,
    5050,
    7720,
    7721,
    7722,
    5051,
    7723,
    4295,
    3429,
    7724,
    7725,
    7726,
    7727,
    3921,
    7728,
    3292,
    5052,
    4092,
    7729,
    7730,
    7731,
    7732,
    7733,
    7734,
    7735,
    5053,
    5054,
    7736,
    7737,
    7738,
    7739,
    3922,
    3685,
    7740,
    7741,
    7742,
    7743,
    2635,
    5055,
    7744,
    5056,
    4601,
    7745,
    7746,
    2560,
    7747,
    7748,
    7749,
    7750,
    3923,
    7751,
    7752,
    7753,
    7754,
    7755,
    4296,
    2903,
    7756,
    7757,
    7758,
    7759,
    7760,
    3924,
    7761,
    5057,
    4297,
    7762,
    7763,
    5058,
    4298,
    7764,
    4093,
    7765,
    7766,
    5059,
    3925,
    7767,
    7768,
    7769,
    7770,
    7771,
    7772,
    7773,
    7774,
    7775,
    7776,
    3595,
    7777,
    4299,
    5060,
    4094,
    7778,
    3293,
    5061,
    7779,
    7780,
    4300,
    7781,
    7782,
    4602,
    7783,
    3596,
    7784,
    7785,
    3430,
    2367,
    7786,
    3164,
    5062,
    5063,
    4301,
    7787,
    7788,
    4095,
    5064,
    5065,
    7789,
    3374,
    3115,
    7790,
    7791,
    7792,
    7793,
    7794,
    7795,
    7796,
    3597,
    4603,
    7797,
    7798,
    3686,
    3116,
    3807,
    5066,
    7799,
    7800,
    5067,
    7801,
    7802,
    4604,
    4302,
    5068,
    4303,
    4096,
    7803,
    7804,
    3294,
    7805,
    7806,
    5069,
    4605,
    2690,
    7807,
    3026,
    7808,
    7809,
    7810,
    7811,
    7812,
    7813,
    7814,
    7815,
    7816,
    7817,
    7818,
    7819,
    7820,
    7821,
    7822,
    7823,
    7824,
    7825,
    7826,
    7827,
    7828,
    7829,
    7830,
    7831,
    7832,
    7833,
    7834,
    7835,
    7836,
    7837,
    7838,
    7839,
    7840,
    7841,
    7842,
    7843,
    7844,
    7845,
    7846,
    7847,
    7848,
    7849,
    7850,
    7851,
    7852,
    7853,
    7854,
    7855,
    7856,
    7857,
    7858,
    7859,
    7860,
    7861,
    7862,
    7863,
    7864,
    7865,
    7866,
    7867,
    7868,
    7869,
    7870,
    7871,
    7872,
    7873,
    7874,
    7875,
    7876,
    7877,
    7878,
    7879,
    7880,
    7881,
    7882,
    7883,
    7884,
    7885,
    7886,
    7887,
    7888,
    7889,
    7890,
    7891,
    7892,
    7893,
    7894,
    7895,
    7896,
    7897,
    7898,
    7899,
    7900,
    7901,
    7902,
    7903,
    7904,
    7905,
    7906,
    7907,
    7908,
    7909,
    7910,
    7911,
    7912,
    7913,
    7914,
    7915,
    7916,
    7917,
    7918,
    7919,
    7920,
    7921,
    7922,
    7923,
    7924,
    3926,
    7925,
    7926,
    7927,
    7928,
    7929,
    7930,
    7931,
    7932,
    7933,
    7934,
    7935,
    7936,
    7937,
    7938,
    7939,
    7940,
    7941,
    7942,
    7943,
    7944,
    7945,
    7946,
    7947,
    7948,
    7949,
    7950,
    7951,
    7952,
    7953,
    7954,
    7955,
    7956,
    7957,
    7958,
    7959,
    7960,
    7961,
    7962,
    7963,
    7964,
    7965,
    7966,
    7967,
    7968,
    7969,
    7970,
    7971,
    7972,
    7973,
    7974,
    7975,
    7976,
    7977,
    7978,
    7979,
    7980,
    7981,
    7982,
    7983,
    7984,
    7985,
    7986,
    7987,
    7988,
    7989,
    7990,
    7991,
    7992,
    7993,
    7994,
    7995,
    7996,
    7997,
    7998,
    7999,
    8000,
    8001,
    8002,
    8003,
    8004,
    8005,
    8006,
    8007,
    8008,
    8009,
    8010,
    8011,
    8012,
    8013,
    8014,
    8015,
    8016,
    8017,
    8018,
    8019,
    8020,
    8021,
    8022,
    8023,
    8024,
    8025,
    8026,
    8027,
    8028,
    8029,
    8030,
    8031,
    8032,
    8033,
    8034,
    8035,
    8036,
    8037,
    8038,
    8039,
    8040,
    8041,
    8042,
    8043,
    8044,
    8045,
    8046,
    8047,
    8048,
    8049,
    8050,
    8051,
    8052,
    8053,
    8054,
    8055,
    8056,
    8057,
    8058,
    8059,
    8060,
    8061,
    8062,
    8063,
    8064,
    8065,
    8066,
    8067,
    8068,
    8069,
    8070,
    8071,
    8072,
    8073,
    8074,
    8075,
    8076,
    8077,
    8078,
    8079,
    8080,
    8081,
    8082,
    8083,
    8084,
    8085,
    8086,
    8087,
    8088,
    8089,
    8090,
    8091,
    8092,
    8093,
    8094,
    8095,
    8096,
    8097,
    8098,
    8099,
    8100,
    8101,
    8102,
    8103,
    8104,
    8105,
    8106,
    8107,
    8108,
    8109,
    8110,
    8111,
    8112,
    8113,
    8114,
    8115,
    8116,
    8117,
    8118,
    8119,
    8120,
    8121,
    8122,
    8123,
    8124,
    8125,
    8126,
    8127,
    8128,
    8129,
    8130,
    8131,
    8132,
    8133,
    8134,
    8135,
    8136,
    8137,
    8138,
    8139,
    8140,
    8141,
    8142,
    8143,
    8144,
    8145,
    8146,
    8147,
    8148,
    8149,
    8150,
    8151,
    8152,
    8153,
    8154,
    8155,
    8156,
    8157,
    8158,
    8159,
    8160,
    8161,
    8162,
    8163,
    8164,
    8165,
    8166,
    8167,
    8168,
    8169,
    8170,
    8171,
    8172,
    8173,
    8174,
    8175,
    8176,
    8177,
    8178,
    8179,
    8180,
    8181,
    8182,
    8183,
    8184,
    8185,
    8186,
    8187,
    8188,
    8189,
    8190,
    8191,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8203,
    8204,
    8205,
    8206,
    8207,
    8208,
    8209,
    8210,
    8211,
    8212,
    8213,
    8214,
    8215,
    8216,
    8217,
    8218,
    8219,
    8220,
    8221,
    8222,
    8223,
    8224,
    8225,
    8226,
    8227,
    8228,
    8229,
    8230,
    8231,
    8232,
    8233,
    8234,
    8235,
    8236,
    8237,
    8238,
    8239,
    8240,
    8241,
    8242,
    8243,
    8244,
    8245,
    8246,
    8247,
    8248,
    8249,
    8250,
    8251,
    8252,
    8253,
    8254,
    8255,
    8256,
    8257,
    8258,
    8259,
    8260,
    8261,
    8262,
    8263,
    8264,
    8265,
    8266,
    8267,
    8268,
    8269,
    8270,
    8271 // 8272
];

});

parcelRegister("6CKw7", function(module, exports) {

$parcel$export(module.exports, "EUCTW_TYPICAL_DISTRIBUTION_RATIO", () => $4d2a5ffb84db4e19$export$d7e0b05b947d9e8e, (v) => $4d2a5ffb84db4e19$export$d7e0b05b947d9e8e = v);
$parcel$export(module.exports, "EUCTW_TABLE_SIZE", () => $4d2a5ffb84db4e19$export$8297c448974e85c4, (v) => $4d2a5ffb84db4e19$export$8297c448974e85c4 = v);
$parcel$export(module.exports, "EUCTWCharToFreqOrder", () => $4d2a5ffb84db4e19$export$8c46355d780ba222, (v) => $4d2a5ffb84db4e19$export$8c46355d780ba222 = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // EUCTW frequency table
// Converted from big5 work
// by Taiwan's Mandarin Promotion Council
// <http://www.edu.tw:81/mandr/>
// 128  --> 0.42261
// 256  --> 0.57851
// 512  --> 0.74851
// 1024 --> 0.89384
// 2048 --> 0.97583
//
// Idea Distribution Ratio = 0.74851/(1-0.74851) =2.98
// Random Distribution Ration = 512/(5401-512)=0.105
//
// Typical Distribution Ratio about 25% of Ideal one, still much higher than RDR
var $4d2a5ffb84db4e19$export$d7e0b05b947d9e8e;
// Char to FreqOrder table ,
var $4d2a5ffb84db4e19$export$8297c448974e85c4;
var $4d2a5ffb84db4e19$export$8c46355d780ba222;
$4d2a5ffb84db4e19$export$d7e0b05b947d9e8e = 0.75;
$4d2a5ffb84db4e19$export$8297c448974e85c4 = 8102;
$4d2a5ffb84db4e19$export$8c46355d780ba222 = [
    1,
    1800,
    1506,
    255,
    1431,
    198,
    9,
    82,
    6,
    7310,
    177,
    202,
    3615,
    1256,
    2808,
    110,
    3735,
    33,
    3241,
    261,
    76,
    44,
    2113,
    16,
    2931,
    2184,
    1176,
    659,
    3868,
    26,
    3404,
    2643,
    1198,
    3869,
    3313,
    4060,
    410,
    2211,
    302,
    590,
    361,
    1963,
    8,
    204,
    58,
    4296,
    7311,
    1931,
    63,
    7312,
    7313,
    317,
    1614,
    75,
    222,
    159,
    4061,
    2412,
    1480,
    7314,
    3500,
    3068,
    224,
    2809,
    3616,
    3,
    10,
    3870,
    1471,
    29,
    2774,
    1135,
    2852,
    1939,
    873,
    130,
    3242,
    1123,
    312,
    7315,
    4297,
    2051,
    507,
    252,
    682,
    7316,
    142,
    1914,
    124,
    206,
    2932,
    34,
    3501,
    3173,
    64,
    604,
    7317,
    2494,
    1976,
    1977,
    155,
    1990,
    645,
    641,
    1606,
    7318,
    3405,
    337,
    72,
    406,
    7319,
    80,
    630,
    238,
    3174,
    1509,
    263,
    939,
    1092,
    2644,
    756,
    1440,
    1094,
    3406,
    449,
    69,
    2969,
    591,
    179,
    2095,
    471,
    115,
    2034,
    1843,
    60,
    50,
    2970,
    134,
    806,
    1868,
    734,
    2035,
    3407,
    180,
    995,
    1607,
    156,
    537,
    2893,
    688,
    7320,
    319,
    1305,
    779,
    2144,
    514,
    2374,
    298,
    4298,
    359,
    2495,
    90,
    2707,
    1338,
    663,
    11,
    906,
    1099,
    2545,
    20,
    2436,
    182,
    532,
    1716,
    7321,
    732,
    1376,
    4062,
    1311,
    1420,
    3175,
    25,
    2312,
    1056,
    113,
    399,
    382,
    1949,
    242,
    3408,
    2467,
    529,
    3243,
    475,
    1447,
    3617,
    7322,
    117,
    21,
    656,
    810,
    1297,
    2295,
    2329,
    3502,
    7323,
    126,
    4063,
    706,
    456,
    150,
    613,
    4299,
    71,
    1118,
    2036,
    4064,
    145,
    3069,
    85,
    835,
    486,
    2114,
    1246,
    1426,
    428,
    727,
    1285,
    1015,
    800,
    106,
    623,
    303,
    1281,
    7324,
    2127,
    2354,
    347,
    3736,
    221,
    3503,
    3110,
    7325,
    1955,
    1153,
    4065,
    83,
    296,
    1199,
    3070,
    192,
    624,
    93,
    7326,
    822,
    1897,
    2810,
    3111,
    795,
    2064,
    991,
    1554,
    1542,
    1592,
    27,
    43,
    2853,
    859,
    139,
    1456,
    860,
    4300,
    437,
    712,
    3871,
    164,
    2392,
    3112,
    695,
    211,
    3017,
    2096,
    195,
    3872,
    1608,
    3504,
    3505,
    3618,
    3873,
    234,
    811,
    2971,
    2097,
    3874,
    2229,
    1441,
    3506,
    1615,
    2375,
    668,
    2076,
    1638,
    305,
    228,
    1664,
    4301,
    467,
    415,
    7327,
    262,
    2098,
    1593,
    239,
    108,
    300,
    200,
    1033,
    512,
    1247,
    2077,
    7328,
    7329,
    2173,
    3176,
    3619,
    2673,
    593,
    845,
    1062,
    3244,
    88,
    1723,
    2037,
    3875,
    1950,
    212,
    266,
    152,
    149,
    468,
    1898,
    4066,
    4302,
    77,
    187,
    7330,
    3018,
    37,
    5,
    2972,
    7331,
    3876,
    7332,
    7333,
    39,
    2517,
    4303,
    2894,
    3177,
    2078,
    55,
    148,
    74,
    4304,
    545,
    483,
    1474,
    1029,
    1665,
    217,
    1869,
    1531,
    3113,
    1104,
    2645,
    4067,
    24,
    172,
    3507,
    900,
    3877,
    3508,
    3509,
    4305,
    32,
    1408,
    2811,
    1312,
    329,
    487,
    2355,
    2247,
    2708,
    784,
    2674,
    4,
    3019,
    3314,
    1427,
    1788,
    188,
    109,
    499,
    7334,
    3620,
    1717,
    1789,
    888,
    1217,
    3020,
    4306,
    7335,
    3510,
    7336,
    3315,
    1520,
    3621,
    3878,
    196,
    1034,
    775,
    7337,
    7338,
    929,
    1815,
    249,
    439,
    38,
    7339,
    1063,
    7340,
    794,
    3879,
    1435,
    2296,
    46,
    178,
    3245,
    2065,
    7341,
    2376,
    7342,
    214,
    1709,
    4307,
    804,
    35,
    707,
    324,
    3622,
    1601,
    2546,
    140,
    459,
    4068,
    7343,
    7344,
    1365,
    839,
    272,
    978,
    2257,
    2572,
    3409,
    2128,
    1363,
    3623,
    1423,
    697,
    100,
    3071,
    48,
    70,
    1231,
    495,
    3114,
    2193,
    7345,
    1294,
    7346,
    2079,
    462,
    586,
    1042,
    3246,
    853,
    256,
    988,
    185,
    2377,
    3410,
    1698,
    434,
    1084,
    7347,
    3411,
    314,
    2615,
    2775,
    4308,
    2330,
    2331,
    569,
    2280,
    637,
    1816,
    2518,
    757,
    1162,
    1878,
    1616,
    3412,
    287,
    1577,
    2115,
    768,
    4309,
    1671,
    2854,
    3511,
    2519,
    1321,
    3737,
    909,
    2413,
    7348,
    4069,
    933,
    3738,
    7349,
    2052,
    2356,
    1222,
    4310,
    765,
    2414,
    1322,
    786,
    4311,
    7350,
    1919,
    1462,
    1677,
    2895,
    1699,
    7351,
    4312,
    1424,
    2437,
    3115,
    3624,
    2590,
    3316,
    1774,
    1940,
    3413,
    3880,
    4070,
    309,
    1369,
    1130,
    2812,
    364,
    2230,
    1653,
    1299,
    3881,
    3512,
    3882,
    3883,
    2646,
    525,
    1085,
    3021,
    902,
    2000,
    1475,
    964,
    4313,
    421,
    1844,
    1415,
    1057,
    2281,
    940,
    1364,
    3116,
    376,
    4314,
    4315,
    1381,
    7,
    2520,
    983,
    2378,
    336,
    1710,
    2675,
    1845,
    321,
    3414,
    559,
    1131,
    3022,
    2742,
    1808,
    1132,
    1313,
    265,
    1481,
    1857,
    7352,
    352,
    1203,
    2813,
    3247,
    167,
    1089,
    420,
    2814,
    776,
    792,
    1724,
    3513,
    4071,
    2438,
    3248,
    7353,
    4072,
    7354,
    446,
    229,
    333,
    2743,
    901,
    3739,
    1200,
    1557,
    4316,
    2647,
    1920,
    395,
    2744,
    2676,
    3740,
    4073,
    1835,
    125,
    916,
    3178,
    2616,
    4317,
    7355,
    7356,
    3741,
    7357,
    7358,
    7359,
    4318,
    3117,
    3625,
    1133,
    2547,
    1757,
    3415,
    1510,
    2313,
    1409,
    3514,
    7360,
    2145,
    438,
    2591,
    2896,
    2379,
    3317,
    1068,
    958,
    3023,
    461,
    311,
    2855,
    2677,
    4074,
    1915,
    3179,
    4075,
    1978,
    383,
    750,
    2745,
    2617,
    4076,
    274,
    539,
    385,
    1278,
    1442,
    7361,
    1154,
    1964,
    384,
    561,
    210,
    98,
    1295,
    2548,
    3515,
    7362,
    1711,
    2415,
    1482,
    3416,
    3884,
    2897,
    1257,
    129,
    7363,
    3742,
    642,
    523,
    2776,
    2777,
    2648,
    7364,
    141,
    2231,
    1333,
    68,
    176,
    441,
    876,
    907,
    4077,
    603,
    2592,
    710,
    171,
    3417,
    404,
    549,
    18,
    3118,
    2393,
    1410,
    3626,
    1666,
    7365,
    3516,
    4319,
    2898,
    4320,
    7366,
    2973,
    368,
    7367,
    146,
    366,
    99,
    871,
    3627,
    1543,
    748,
    807,
    1586,
    1185,
    22,
    2258,
    379,
    3743,
    3180,
    7368,
    3181,
    505,
    1941,
    2618,
    1991,
    1382,
    2314,
    7369,
    380,
    2357,
    218,
    702,
    1817,
    1248,
    3418,
    3024,
    3517,
    3318,
    3249,
    7370,
    2974,
    3628,
    930,
    3250,
    3744,
    7371,
    59,
    7372,
    585,
    601,
    4078,
    497,
    3419,
    1112,
    1314,
    4321,
    1801,
    7373,
    1223,
    1472,
    2174,
    7374,
    749,
    1836,
    690,
    1899,
    3745,
    1772,
    3885,
    1476,
    429,
    1043,
    1790,
    2232,
    2116,
    917,
    4079,
    447,
    1086,
    1629,
    7375,
    556,
    7376,
    7377,
    2020,
    1654,
    844,
    1090,
    105,
    550,
    966,
    1758,
    2815,
    1008,
    1782,
    686,
    1095,
    7378,
    2282,
    793,
    1602,
    7379,
    3518,
    2593,
    4322,
    4080,
    2933,
    2297,
    4323,
    3746,
    980,
    2496,
    544,
    353,
    527,
    4324,
    908,
    2678,
    2899,
    7380,
    381,
    2619,
    1942,
    1348,
    7381,
    1341,
    1252,
    560,
    3072,
    7382,
    3420,
    2856,
    7383,
    2053,
    973,
    886,
    2080,
    143,
    4325,
    7384,
    7385,
    157,
    3886,
    496,
    4081,
    57,
    840,
    540,
    2038,
    4326,
    4327,
    3421,
    2117,
    1445,
    970,
    2259,
    1748,
    1965,
    2081,
    4082,
    3119,
    1234,
    1775,
    3251,
    2816,
    3629,
    773,
    1206,
    2129,
    1066,
    2039,
    1326,
    3887,
    1738,
    1725,
    4083,
    279,
    3120,
    51,
    1544,
    2594,
    423,
    1578,
    2130,
    2066,
    173,
    4328,
    1879,
    7386,
    7387,
    1583,
    264,
    610,
    3630,
    4329,
    2439,
    280,
    154,
    7388,
    7389,
    7390,
    1739,
    338,
    1282,
    3073,
    693,
    2857,
    1411,
    1074,
    3747,
    2440,
    7391,
    4330,
    7392,
    7393,
    1240,
    952,
    2394,
    7394,
    2900,
    1538,
    2679,
    685,
    1483,
    4084,
    2468,
    1436,
    953,
    4085,
    2054,
    4331,
    671,
    2395,
    79,
    4086,
    2441,
    3252,
    608,
    567,
    2680,
    3422,
    4087,
    4088,
    1691,
    393,
    1261,
    1791,
    2396,
    7395,
    4332,
    7396,
    7397,
    7398,
    7399,
    1383,
    1672,
    3748,
    3182,
    1464,
    522,
    1119,
    661,
    1150,
    216,
    675,
    4333,
    3888,
    1432,
    3519,
    609,
    4334,
    2681,
    2397,
    7400,
    7401,
    7402,
    4089,
    3025,
    0,
    7403,
    2469,
    315,
    231,
    2442,
    301,
    3319,
    4335,
    2380,
    7404,
    233,
    4090,
    3631,
    1818,
    4336,
    4337,
    7405,
    96,
    1776,
    1315,
    2082,
    7406,
    257,
    7407,
    1809,
    3632,
    2709,
    1139,
    1819,
    4091,
    2021,
    1124,
    2163,
    2778,
    1777,
    2649,
    7408,
    3074,
    363,
    1655,
    3183,
    7409,
    2975,
    7410,
    7411,
    7412,
    3889,
    1567,
    3890,
    718,
    103,
    3184,
    849,
    1443,
    341,
    3320,
    2934,
    1484,
    7413,
    1712,
    127,
    67,
    339,
    4092,
    2398,
    679,
    1412,
    821,
    7414,
    7415,
    834,
    738,
    351,
    2976,
    2146,
    846,
    235,
    1497,
    1880,
    418,
    1992,
    3749,
    2710,
    186,
    1100,
    2147,
    2746,
    3520,
    1545,
    1355,
    2935,
    2858,
    1377,
    583,
    3891,
    4093,
    2573,
    2977,
    7416,
    1298,
    3633,
    1078,
    2549,
    3634,
    2358,
    78,
    3750,
    3751,
    267,
    1289,
    2099,
    2001,
    1594,
    4094,
    348,
    369,
    1274,
    2194,
    2175,
    1837,
    4338,
    1820,
    2817,
    3635,
    2747,
    2283,
    2002,
    4339,
    2936,
    2748,
    144,
    3321,
    882,
    4340,
    3892,
    2749,
    3423,
    4341,
    2901,
    7417,
    4095,
    1726,
    320,
    7418,
    3893,
    3026,
    788,
    2978,
    7419,
    2818,
    1773,
    1327,
    2859,
    3894,
    2819,
    7420,
    1306,
    4342,
    2003,
    1700,
    3752,
    3521,
    2359,
    2650,
    787,
    2022,
    506,
    824,
    3636,
    534,
    323,
    4343,
    1044,
    3322,
    2023,
    1900,
    946,
    3424,
    7421,
    1778,
    1500,
    1678,
    7422,
    1881,
    4344,
    165,
    243,
    4345,
    3637,
    2521,
    123,
    683,
    4096,
    764,
    4346,
    36,
    3895,
    1792,
    589,
    2902,
    816,
    626,
    1667,
    3027,
    2233,
    1639,
    1555,
    1622,
    3753,
    3896,
    7423,
    3897,
    2860,
    1370,
    1228,
    1932,
    891,
    2083,
    2903,
    304,
    4097,
    7424,
    292,
    2979,
    2711,
    3522,
    691,
    2100,
    4098,
    1115,
    4347,
    118,
    662,
    7425,
    611,
    1156,
    854,
    2381,
    1316,
    2861,
    2,
    386,
    515,
    2904,
    7426,
    7427,
    3253,
    868,
    2234,
    1486,
    855,
    2651,
    785,
    2212,
    3028,
    7428,
    1040,
    3185,
    3523,
    7429,
    3121,
    448,
    7430,
    1525,
    7431,
    2164,
    4348,
    7432,
    3754,
    7433,
    4099,
    2820,
    3524,
    3122,
    503,
    818,
    3898,
    3123,
    1568,
    814,
    676,
    1444,
    306,
    1749,
    7434,
    3755,
    1416,
    1030,
    197,
    1428,
    805,
    2821,
    1501,
    4349,
    7435,
    7436,
    7437,
    1993,
    7438,
    4350,
    7439,
    7440,
    2195,
    13,
    2779,
    3638,
    2980,
    3124,
    1229,
    1916,
    7441,
    3756,
    2131,
    7442,
    4100,
    4351,
    2399,
    3525,
    7443,
    2213,
    1511,
    1727,
    1120,
    7444,
    7445,
    646,
    3757,
    2443,
    307,
    7446,
    7447,
    1595,
    3186,
    7448,
    7449,
    7450,
    3639,
    1113,
    1356,
    3899,
    1465,
    2522,
    2523,
    7451,
    519,
    7452,
    128,
    2132,
    92,
    2284,
    1979,
    7453,
    3900,
    1512,
    342,
    3125,
    2196,
    7454,
    2780,
    2214,
    1980,
    3323,
    7455,
    290,
    1656,
    1317,
    789,
    827,
    2360,
    7456,
    3758,
    4352,
    562,
    581,
    3901,
    7457,
    401,
    4353,
    2248,
    94,
    4354,
    1399,
    2781,
    7458,
    1463,
    2024,
    4355,
    3187,
    1943,
    7459,
    828,
    1105,
    4101,
    1262,
    1394,
    7460,
    4102,
    605,
    4356,
    7461,
    1783,
    2862,
    7462,
    2822,
    819,
    2101,
    578,
    2197,
    2937,
    7463,
    1502,
    436,
    3254,
    4103,
    3255,
    2823,
    3902,
    2905,
    3425,
    3426,
    7464,
    2712,
    2315,
    7465,
    7466,
    2332,
    2067,
    23,
    4357,
    193,
    826,
    3759,
    2102,
    699,
    1630,
    4104,
    3075,
    390,
    1793,
    1064,
    3526,
    7467,
    1579,
    3076,
    3077,
    1400,
    7468,
    4105,
    1838,
    1640,
    2863,
    7469,
    4358,
    4359,
    137,
    4106,
    598,
    3078,
    1966,
    780,
    104,
    974,
    2938,
    7470,
    278,
    899,
    253,
    402,
    572,
    504,
    493,
    1339,
    7471,
    3903,
    1275,
    4360,
    2574,
    2550,
    7472,
    3640,
    3029,
    3079,
    2249,
    565,
    1334,
    2713,
    863,
    41,
    7473,
    7474,
    4361,
    7475,
    1657,
    2333,
    19,
    463,
    2750,
    4107,
    606,
    7476,
    2981,
    3256,
    1087,
    2084,
    1323,
    2652,
    2982,
    7477,
    1631,
    1623,
    1750,
    4108,
    2682,
    7478,
    2864,
    791,
    2714,
    2653,
    2334,
    232,
    2416,
    7479,
    2983,
    1498,
    7480,
    2654,
    2620,
    755,
    1366,
    3641,
    3257,
    3126,
    2025,
    1609,
    119,
    1917,
    3427,
    862,
    1026,
    4109,
    7481,
    3904,
    3760,
    4362,
    3905,
    4363,
    2260,
    1951,
    2470,
    7482,
    1125,
    817,
    4110,
    4111,
    3906,
    1513,
    1766,
    2040,
    1487,
    4112,
    3030,
    3258,
    2824,
    3761,
    3127,
    7483,
    7484,
    1507,
    7485,
    2683,
    733,
    40,
    1632,
    1106,
    2865,
    345,
    4113,
    841,
    2524,
    230,
    4364,
    2984,
    1846,
    3259,
    3428,
    7486,
    1263,
    986,
    3429,
    7487,
    735,
    879,
    254,
    1137,
    857,
    622,
    1300,
    1180,
    1388,
    1562,
    3907,
    3908,
    2939,
    967,
    2751,
    2655,
    1349,
    592,
    2133,
    1692,
    3324,
    2985,
    1994,
    4114,
    1679,
    3909,
    1901,
    2185,
    7488,
    739,
    3642,
    2715,
    1296,
    1290,
    7489,
    4115,
    2198,
    2199,
    1921,
    1563,
    2595,
    2551,
    1870,
    2752,
    2986,
    7490,
    435,
    7491,
    343,
    1108,
    596,
    17,
    1751,
    4365,
    2235,
    3430,
    3643,
    7492,
    4366,
    294,
    3527,
    2940,
    1693,
    477,
    979,
    281,
    2041,
    3528,
    643,
    2042,
    3644,
    2621,
    2782,
    2261,
    1031,
    2335,
    2134,
    2298,
    3529,
    4367,
    367,
    1249,
    2552,
    7493,
    3530,
    7494,
    4368,
    1283,
    3325,
    2004,
    240,
    1762,
    3326,
    4369,
    4370,
    836,
    1069,
    3128,
    474,
    7495,
    2148,
    2525,
    268,
    3531,
    7496,
    3188,
    1521,
    1284,
    7497,
    1658,
    1546,
    4116,
    7498,
    3532,
    3533,
    7499,
    4117,
    3327,
    2684,
    1685,
    4118,
    961,
    1673,
    2622,
    190,
    2005,
    2200,
    3762,
    4371,
    4372,
    7500,
    570,
    2497,
    3645,
    1490,
    7501,
    4373,
    2623,
    3260,
    1956,
    4374,
    584,
    1514,
    396,
    1045,
    1944,
    7502,
    4375,
    1967,
    2444,
    7503,
    7504,
    4376,
    3910,
    619,
    7505,
    3129,
    3261,
    215,
    2006,
    2783,
    2553,
    3189,
    4377,
    3190,
    4378,
    763,
    4119,
    3763,
    4379,
    7506,
    7507,
    1957,
    1767,
    2941,
    3328,
    3646,
    1174,
    452,
    1477,
    4380,
    3329,
    3130,
    7508,
    2825,
    1253,
    2382,
    2186,
    1091,
    2285,
    4120,
    492,
    7509,
    638,
    1169,
    1824,
    2135,
    1752,
    3911,
    648,
    926,
    1021,
    1324,
    4381,
    520,
    4382,
    997,
    847,
    1007,
    892,
    4383,
    3764,
    2262,
    1871,
    3647,
    7510,
    2400,
    1784,
    4384,
    1952,
    2942,
    3080,
    3191,
    1728,
    4121,
    2043,
    3648,
    4385,
    2007,
    1701,
    3131,
    1551,
    30,
    2263,
    4122,
    7511,
    2026,
    4386,
    3534,
    7512,
    501,
    7513,
    4123,
    594,
    3431,
    2165,
    1821,
    3535,
    3432,
    3536,
    3192,
    829,
    2826,
    4124,
    7514,
    1680,
    3132,
    1225,
    4125,
    7515,
    3262,
    4387,
    4126,
    3133,
    2336,
    7516,
    4388,
    4127,
    7517,
    3912,
    3913,
    7518,
    1847,
    2383,
    2596,
    3330,
    7519,
    4389,
    374,
    3914,
    652,
    4128,
    4129,
    375,
    1140,
    798,
    7520,
    7521,
    7522,
    2361,
    4390,
    2264,
    546,
    1659,
    138,
    3031,
    2445,
    4391,
    7523,
    2250,
    612,
    1848,
    910,
    796,
    3765,
    1740,
    1371,
    825,
    3766,
    3767,
    7524,
    2906,
    2554,
    7525,
    692,
    444,
    3032,
    2624,
    801,
    4392,
    4130,
    7526,
    1491,
    244,
    1053,
    3033,
    4131,
    4132,
    340,
    7527,
    3915,
    1041,
    2987,
    293,
    1168,
    87,
    1357,
    7528,
    1539,
    959,
    7529,
    2236,
    721,
    694,
    4133,
    3768,
    219,
    1478,
    644,
    1417,
    3331,
    2656,
    1413,
    1401,
    1335,
    1389,
    3916,
    7530,
    7531,
    2988,
    2362,
    3134,
    1825,
    730,
    1515,
    184,
    2827,
    66,
    4393,
    7532,
    1660,
    2943,
    246,
    3332,
    378,
    1457,
    226,
    3433,
    975,
    3917,
    2944,
    1264,
    3537,
    674,
    696,
    7533,
    163,
    7534,
    1141,
    2417,
    2166,
    713,
    3538,
    3333,
    4394,
    3918,
    7535,
    7536,
    1186,
    15,
    7537,
    1079,
    1070,
    7538,
    1522,
    3193,
    3539,
    276,
    1050,
    2716,
    758,
    1126,
    653,
    2945,
    3263,
    7539,
    2337,
    889,
    3540,
    3919,
    3081,
    2989,
    903,
    1250,
    4395,
    3920,
    3434,
    3541,
    1342,
    1681,
    1718,
    766,
    3264,
    286,
    89,
    2946,
    3649,
    7540,
    1713,
    7541,
    2597,
    3334,
    2990,
    7542,
    2947,
    2215,
    3194,
    2866,
    7543,
    4396,
    2498,
    2526,
    181,
    387,
    1075,
    3921,
    731,
    2187,
    3335,
    7544,
    3265,
    310,
    313,
    3435,
    2299,
    770,
    4134,
    54,
    3034,
    189,
    4397,
    3082,
    3769,
    3922,
    7545,
    1230,
    1617,
    1849,
    355,
    3542,
    4135,
    4398,
    3336,
    111,
    4136,
    3650,
    1350,
    3135,
    3436,
    3035,
    4137,
    2149,
    3266,
    3543,
    7546,
    2784,
    3923,
    3924,
    2991,
    722,
    2008,
    7547,
    1071,
    247,
    1207,
    2338,
    2471,
    1378,
    4399,
    2009,
    864,
    1437,
    1214,
    4400,
    373,
    3770,
    1142,
    2216,
    667,
    4401,
    442,
    2753,
    2555,
    3771,
    3925,
    1968,
    4138,
    3267,
    1839,
    837,
    170,
    1107,
    934,
    1336,
    1882,
    7548,
    7549,
    2118,
    4139,
    2828,
    743,
    1569,
    7550,
    4402,
    4140,
    582,
    2384,
    1418,
    3437,
    7551,
    1802,
    7552,
    357,
    1395,
    1729,
    3651,
    3268,
    2418,
    1564,
    2237,
    7553,
    3083,
    3772,
    1633,
    4403,
    1114,
    2085,
    4141,
    1532,
    7554,
    482,
    2446,
    4404,
    7555,
    7556,
    1492,
    833,
    1466,
    7557,
    2717,
    3544,
    1641,
    2829,
    7558,
    1526,
    1272,
    3652,
    4142,
    1686,
    1794,
    416,
    2556,
    1902,
    1953,
    1803,
    7559,
    3773,
    2785,
    3774,
    1159,
    2316,
    7560,
    2867,
    4405,
    1610,
    1584,
    3036,
    2419,
    2754,
    443,
    3269,
    1163,
    3136,
    7561,
    7562,
    3926,
    7563,
    4143,
    2499,
    3037,
    4406,
    3927,
    3137,
    2103,
    1647,
    3545,
    2010,
    1872,
    4144,
    7564,
    4145,
    431,
    3438,
    7565,
    250,
    97,
    81,
    4146,
    7566,
    1648,
    1850,
    1558,
    160,
    848,
    7567,
    866,
    740,
    1694,
    7568,
    2201,
    2830,
    3195,
    4147,
    4407,
    3653,
    1687,
    950,
    2472,
    426,
    469,
    3196,
    3654,
    3655,
    3928,
    7569,
    7570,
    1188,
    424,
    1995,
    861,
    3546,
    4148,
    3775,
    2202,
    2685,
    168,
    1235,
    3547,
    4149,
    7571,
    2086,
    1674,
    4408,
    3337,
    3270,
    220,
    2557,
    1009,
    7572,
    3776,
    670,
    2992,
    332,
    1208,
    717,
    7573,
    7574,
    3548,
    2447,
    3929,
    3338,
    7575,
    513,
    7576,
    1209,
    2868,
    3339,
    3138,
    4409,
    1080,
    7577,
    7578,
    7579,
    7580,
    2527,
    3656,
    3549,
    815,
    1587,
    3930,
    3931,
    7581,
    3550,
    3439,
    3777,
    1254,
    4410,
    1328,
    3038,
    1390,
    3932,
    1741,
    3933,
    3778,
    3934,
    7582,
    236,
    3779,
    2448,
    3271,
    7583,
    7584,
    3657,
    3780,
    1273,
    3781,
    4411,
    7585,
    308,
    7586,
    4412,
    245,
    4413,
    1851,
    2473,
    1307,
    2575,
    430,
    715,
    2136,
    2449,
    7587,
    270,
    199,
    2869,
    3935,
    7588,
    3551,
    2718,
    1753,
    761,
    1754,
    725,
    1661,
    1840,
    4414,
    3440,
    3658,
    7589,
    7590,
    587,
    14,
    3272,
    227,
    2598,
    326,
    480,
    2265,
    943,
    2755,
    3552,
    291,
    650,
    1883,
    7591,
    1702,
    1226,
    102,
    1547,
    62,
    3441,
    904,
    4415,
    3442,
    1164,
    4150,
    7592,
    7593,
    1224,
    1548,
    2756,
    391,
    498,
    1493,
    7594,
    1386,
    1419,
    7595,
    2055,
    1177,
    4416,
    813,
    880,
    1081,
    2363,
    566,
    1145,
    4417,
    2286,
    1001,
    1035,
    2558,
    2599,
    2238,
    394,
    1286,
    7596,
    7597,
    2068,
    7598,
    86,
    1494,
    1730,
    3936,
    491,
    1588,
    745,
    897,
    2948,
    843,
    3340,
    3937,
    2757,
    2870,
    3273,
    1768,
    998,
    2217,
    2069,
    397,
    1826,
    1195,
    1969,
    3659,
    2993,
    3341,
    284,
    7599,
    3782,
    2500,
    2137,
    2119,
    1903,
    7600,
    3938,
    2150,
    3939,
    4151,
    1036,
    3443,
    1904,
    114,
    2559,
    4152,
    209,
    1527,
    7601,
    7602,
    2949,
    2831,
    2625,
    2385,
    2719,
    3139,
    812,
    2560,
    7603,
    3274,
    7604,
    1559,
    737,
    1884,
    3660,
    1210,
    885,
    28,
    2686,
    3553,
    3783,
    7605,
    4153,
    1004,
    1779,
    4418,
    7606,
    346,
    1981,
    2218,
    2687,
    4419,
    3784,
    1742,
    797,
    1642,
    3940,
    1933,
    1072,
    1384,
    2151,
    896,
    3941,
    3275,
    3661,
    3197,
    2871,
    3554,
    7607,
    2561,
    1958,
    4420,
    2450,
    1785,
    7608,
    7609,
    7610,
    3942,
    4154,
    1005,
    1308,
    3662,
    4155,
    2720,
    4421,
    4422,
    1528,
    2600,
    161,
    1178,
    4156,
    1982,
    987,
    4423,
    1101,
    4157,
    631,
    3943,
    1157,
    3198,
    2420,
    1343,
    1241,
    1016,
    2239,
    2562,
    372,
    877,
    2339,
    2501,
    1160,
    555,
    1934,
    911,
    3944,
    7611,
    466,
    1170,
    169,
    1051,
    2907,
    2688,
    3663,
    2474,
    2994,
    1182,
    2011,
    2563,
    1251,
    2626,
    7612,
    992,
    2340,
    3444,
    1540,
    2721,
    1201,
    2070,
    2401,
    1996,
    2475,
    7613,
    4424,
    528,
    1922,
    2188,
    1503,
    1873,
    1570,
    2364,
    3342,
    3276,
    7614,
    557,
    1073,
    7615,
    1827,
    3445,
    2087,
    2266,
    3140,
    3039,
    3084,
    767,
    3085,
    2786,
    4425,
    1006,
    4158,
    4426,
    2341,
    1267,
    2176,
    3664,
    3199,
    778,
    3945,
    3200,
    2722,
    1597,
    2657,
    7616,
    4427,
    7617,
    3446,
    7618,
    7619,
    7620,
    3277,
    2689,
    1433,
    3278,
    131,
    95,
    1504,
    3946,
    723,
    4159,
    3141,
    1841,
    3555,
    2758,
    2189,
    3947,
    2027,
    2104,
    3665,
    7621,
    2995,
    3948,
    1218,
    7622,
    3343,
    3201,
    3949,
    4160,
    2576,
    248,
    1634,
    3785,
    912,
    7623,
    2832,
    3666,
    3040,
    3786,
    654,
    53,
    7624,
    2996,
    7625,
    1688,
    4428,
    777,
    3447,
    1032,
    3950,
    1425,
    7626,
    191,
    820,
    2120,
    2833,
    971,
    4429,
    931,
    3202,
    135,
    664,
    783,
    3787,
    1997,
    772,
    2908,
    1935,
    3951,
    3788,
    4430,
    2909,
    3203,
    282,
    2723,
    640,
    1372,
    3448,
    1127,
    922,
    325,
    3344,
    7627,
    7628,
    711,
    2044,
    7629,
    7630,
    3952,
    2219,
    2787,
    1936,
    3953,
    3345,
    2220,
    2251,
    3789,
    2300,
    7631,
    4431,
    3790,
    1258,
    3279,
    3954,
    3204,
    2138,
    2950,
    3955,
    3956,
    7632,
    2221,
    258,
    3205,
    4432,
    101,
    1227,
    7633,
    3280,
    1755,
    7634,
    1391,
    3281,
    7635,
    2910,
    2056,
    893,
    7636,
    7637,
    7638,
    1402,
    4161,
    2342,
    7639,
    7640,
    3206,
    3556,
    7641,
    7642,
    878,
    1325,
    1780,
    2788,
    4433,
    259,
    1385,
    2577,
    744,
    1183,
    2267,
    4434,
    7643,
    3957,
    2502,
    7644,
    684,
    1024,
    4162,
    7645,
    472,
    3557,
    3449,
    1165,
    3282,
    3958,
    3959,
    322,
    2152,
    881,
    455,
    1695,
    1152,
    1340,
    660,
    554,
    2153,
    4435,
    1058,
    4436,
    4163,
    830,
    1065,
    3346,
    3960,
    4437,
    1923,
    7646,
    1703,
    1918,
    7647,
    932,
    2268,
    122,
    7648,
    4438,
    947,
    677,
    7649,
    3791,
    2627,
    297,
    1905,
    1924,
    2269,
    4439,
    2317,
    3283,
    7650,
    7651,
    4164,
    7652,
    4165,
    84,
    4166,
    112,
    989,
    7653,
    547,
    1059,
    3961,
    701,
    3558,
    1019,
    7654,
    4167,
    7655,
    3450,
    942,
    639,
    457,
    2301,
    2451,
    993,
    2951,
    407,
    851,
    494,
    4440,
    3347,
    927,
    7656,
    1237,
    7657,
    2421,
    3348,
    573,
    4168,
    680,
    921,
    2911,
    1279,
    1874,
    285,
    790,
    1448,
    1983,
    719,
    2167,
    7658,
    7659,
    4441,
    3962,
    3963,
    1649,
    7660,
    1541,
    563,
    7661,
    1077,
    7662,
    3349,
    3041,
    3451,
    511,
    2997,
    3964,
    3965,
    3667,
    3966,
    1268,
    2564,
    3350,
    3207,
    4442,
    4443,
    7663,
    535,
    1048,
    1276,
    1189,
    2912,
    2028,
    3142,
    1438,
    1373,
    2834,
    2952,
    1134,
    2012,
    7664,
    4169,
    1238,
    2578,
    3086,
    1259,
    7665,
    700,
    7666,
    2953,
    3143,
    3668,
    4170,
    7667,
    4171,
    1146,
    1875,
    1906,
    4444,
    2601,
    3967,
    781,
    2422,
    132,
    1589,
    203,
    147,
    273,
    2789,
    2402,
    898,
    1786,
    2154,
    3968,
    3969,
    7668,
    3792,
    2790,
    7669,
    7670,
    4445,
    4446,
    7671,
    3208,
    7672,
    1635,
    3793,
    965,
    7673,
    1804,
    2690,
    1516,
    3559,
    1121,
    1082,
    1329,
    3284,
    3970,
    1449,
    3794,
    65,
    1128,
    2835,
    2913,
    2759,
    1590,
    3795,
    7674,
    7675,
    12,
    2658,
    45,
    976,
    2579,
    3144,
    4447,
    517,
    2528,
    1013,
    1037,
    3209,
    7676,
    3796,
    2836,
    7677,
    3797,
    7678,
    3452,
    7679,
    2602,
    614,
    1998,
    2318,
    3798,
    3087,
    2724,
    2628,
    7680,
    2580,
    4172,
    599,
    1269,
    7681,
    1810,
    3669,
    7682,
    2691,
    3088,
    759,
    1060,
    489,
    1805,
    3351,
    3285,
    1358,
    7683,
    7684,
    2386,
    1387,
    1215,
    2629,
    2252,
    490,
    7685,
    7686,
    4173,
    1759,
    2387,
    2343,
    7687,
    4448,
    3799,
    1907,
    3971,
    2630,
    1806,
    3210,
    4449,
    3453,
    3286,
    2760,
    2344,
    874,
    7688,
    7689,
    3454,
    3670,
    1858,
    91,
    2914,
    3671,
    3042,
    3800,
    4450,
    7690,
    3145,
    3972,
    2659,
    7691,
    3455,
    1202,
    1403,
    3801,
    2954,
    2529,
    1517,
    2503,
    4451,
    3456,
    2504,
    7692,
    4452,
    7693,
    2692,
    1885,
    1495,
    1731,
    3973,
    2365,
    4453,
    7694,
    2029,
    7695,
    7696,
    3974,
    2693,
    1216,
    237,
    2581,
    4174,
    2319,
    3975,
    3802,
    4454,
    4455,
    2694,
    3560,
    3457,
    445,
    4456,
    7697,
    7698,
    7699,
    7700,
    2761,
    61,
    3976,
    3672,
    1822,
    3977,
    7701,
    687,
    2045,
    935,
    925,
    405,
    2660,
    703,
    1096,
    1859,
    2725,
    4457,
    3978,
    1876,
    1367,
    2695,
    3352,
    918,
    2105,
    1781,
    2476,
    334,
    3287,
    1611,
    1093,
    4458,
    564,
    3146,
    3458,
    3673,
    3353,
    945,
    2631,
    2057,
    4459,
    7702,
    1925,
    872,
    4175,
    7703,
    3459,
    2696,
    3089,
    349,
    4176,
    3674,
    3979,
    4460,
    3803,
    4177,
    3675,
    2155,
    3980,
    4461,
    4462,
    4178,
    4463,
    2403,
    2046,
    782,
    3981,
    400,
    251,
    4179,
    1624,
    7704,
    7705,
    277,
    3676,
    299,
    1265,
    476,
    1191,
    3804,
    2121,
    4180,
    4181,
    1109,
    205,
    7706,
    2582,
    1000,
    2156,
    3561,
    1860,
    7707,
    7708,
    7709,
    4464,
    7710,
    4465,
    2565,
    107,
    2477,
    2157,
    3982,
    3460,
    3147,
    7711,
    1533,
    541,
    1301,
    158,
    753,
    4182,
    2872,
    3562,
    7712,
    1696,
    370,
    1088,
    4183,
    4466,
    3563,
    579,
    327,
    440,
    162,
    2240,
    269,
    1937,
    1374,
    3461,
    968,
    3043,
    56,
    1396,
    3090,
    2106,
    3288,
    3354,
    7713,
    1926,
    2158,
    4467,
    2998,
    7714,
    3564,
    7715,
    7716,
    3677,
    4468,
    2478,
    7717,
    2791,
    7718,
    1650,
    4469,
    7719,
    2603,
    7720,
    7721,
    3983,
    2661,
    3355,
    1149,
    3356,
    3984,
    3805,
    3985,
    7722,
    1076,
    49,
    7723,
    951,
    3211,
    3289,
    3290,
    450,
    2837,
    920,
    7724,
    1811,
    2792,
    2366,
    4184,
    1908,
    1138,
    2367,
    3806,
    3462,
    7725,
    3212,
    4470,
    1909,
    1147,
    1518,
    2423,
    4471,
    3807,
    7726,
    4472,
    2388,
    2604,
    260,
    1795,
    3213,
    7727,
    7728,
    3808,
    3291,
    708,
    7729,
    3565,
    1704,
    7730,
    3566,
    1351,
    1618,
    3357,
    2999,
    1886,
    944,
    4185,
    3358,
    4186,
    3044,
    3359,
    4187,
    7731,
    3678,
    422,
    413,
    1714,
    3292,
    500,
    2058,
    2345,
    4188,
    2479,
    7732,
    1344,
    1910,
    954,
    7733,
    1668,
    7734,
    7735,
    3986,
    2404,
    4189,
    3567,
    3809,
    4190,
    7736,
    2302,
    1318,
    2505,
    3091,
    133,
    3092,
    2873,
    4473,
    629,
    31,
    2838,
    2697,
    3810,
    4474,
    850,
    949,
    4475,
    3987,
    2955,
    1732,
    2088,
    4191,
    1496,
    1852,
    7737,
    3988,
    620,
    3214,
    981,
    1242,
    3679,
    3360,
    1619,
    3680,
    1643,
    3293,
    2139,
    2452,
    1970,
    1719,
    3463,
    2168,
    7738,
    3215,
    7739,
    7740,
    3361,
    1828,
    7741,
    1277,
    4476,
    1565,
    2047,
    7742,
    1636,
    3568,
    3093,
    7743,
    869,
    2839,
    655,
    3811,
    3812,
    3094,
    3989,
    3000,
    3813,
    1310,
    3569,
    4477,
    7744,
    7745,
    7746,
    1733,
    558,
    4478,
    3681,
    335,
    1549,
    3045,
    1756,
    4192,
    3682,
    1945,
    3464,
    1829,
    1291,
    1192,
    470,
    2726,
    2107,
    2793,
    913,
    1054,
    3990,
    7747,
    1027,
    7748,
    3046,
    3991,
    4479,
    982,
    2662,
    3362,
    3148,
    3465,
    3216,
    3217,
    1946,
    2794,
    7749,
    571,
    4480,
    7750,
    1830,
    7751,
    3570,
    2583,
    1523,
    2424,
    7752,
    2089,
    984,
    4481,
    3683,
    1959,
    7753,
    3684,
    852,
    923,
    2795,
    3466,
    3685,
    969,
    1519,
    999,
    2048,
    2320,
    1705,
    7754,
    3095,
    615,
    1662,
    151,
    597,
    3992,
    2405,
    2321,
    1049,
    275,
    4482,
    3686,
    4193,
    568,
    3687,
    3571,
    2480,
    4194,
    3688,
    7755,
    2425,
    2270,
    409,
    3218,
    7756,
    1566,
    2874,
    3467,
    1002,
    769,
    2840,
    194,
    2090,
    3149,
    3689,
    2222,
    3294,
    4195,
    628,
    1505,
    7757,
    7758,
    1763,
    2177,
    3001,
    3993,
    521,
    1161,
    2584,
    1787,
    2203,
    2406,
    4483,
    3994,
    1625,
    4196,
    4197,
    412,
    42,
    3096,
    464,
    7759,
    2632,
    4484,
    3363,
    1760,
    1571,
    2875,
    3468,
    2530,
    1219,
    2204,
    3814,
    2633,
    2140,
    2368,
    4485,
    4486,
    3295,
    1651,
    3364,
    3572,
    7760,
    7761,
    3573,
    2481,
    3469,
    7762,
    3690,
    7763,
    7764,
    2271,
    2091,
    460,
    7765,
    4487,
    7766,
    3002,
    962,
    588,
    3574,
    289,
    3219,
    2634,
    1116,
    52,
    7767,
    3047,
    1796,
    7768,
    7769,
    7770,
    1467,
    7771,
    1598,
    1143,
    3691,
    4198,
    1984,
    1734,
    1067,
    4488,
    1280,
    3365,
    465,
    4489,
    1572,
    510,
    7772,
    1927,
    2241,
    1812,
    1644,
    3575,
    7773,
    4490,
    3692,
    7774,
    7775,
    2663,
    1573,
    1534,
    7776,
    7777,
    4199,
    536,
    1807,
    1761,
    3470,
    3815,
    3150,
    2635,
    7778,
    7779,
    7780,
    4491,
    3471,
    2915,
    1911,
    2796,
    7781,
    3296,
    1122,
    377,
    3220,
    7782,
    360,
    7783,
    7784,
    4200,
    1529,
    551,
    7785,
    2059,
    3693,
    1769,
    2426,
    7786,
    2916,
    4201,
    3297,
    3097,
    2322,
    2108,
    2030,
    4492,
    1404,
    136,
    1468,
    1479,
    672,
    1171,
    3221,
    2303,
    271,
    3151,
    7787,
    2762,
    7788,
    2049,
    678,
    2727,
    865,
    1947,
    4493,
    7789,
    2013,
    3995,
    2956,
    7790,
    2728,
    2223,
    1397,
    3048,
    3694,
    4494,
    4495,
    1735,
    2917,
    3366,
    3576,
    7791,
    3816,
    509,
    2841,
    2453,
    2876,
    3817,
    7792,
    7793,
    3152,
    3153,
    4496,
    4202,
    2531,
    4497,
    2304,
    1166,
    1010,
    552,
    681,
    1887,
    7794,
    7795,
    2957,
    2958,
    3996,
    1287,
    1596,
    1861,
    3154,
    358,
    453,
    736,
    175,
    478,
    1117,
    905,
    1167,
    1097,
    7796,
    1853,
    1530,
    7797,
    1706,
    7798,
    2178,
    3472,
    2287,
    3695,
    3473,
    3577,
    4203,
    2092,
    4204,
    7799,
    3367,
    1193,
    2482,
    4205,
    1458,
    2190,
    2205,
    1862,
    1888,
    1421,
    3298,
    2918,
    3049,
    2179,
    3474,
    595,
    2122,
    7800,
    3997,
    7801,
    7802,
    4206,
    1707,
    2636,
    223,
    3696,
    1359,
    751,
    3098,
    183,
    3475,
    7803,
    2797,
    3003,
    419,
    2369,
    633,
    704,
    3818,
    2389,
    241,
    7804,
    7805,
    7806,
    838,
    3004,
    3697,
    2272,
    2763,
    2454,
    3819,
    1938,
    2050,
    3998,
    1309,
    3099,
    2242,
    1181,
    7807,
    1136,
    2206,
    3820,
    2370,
    1446,
    4207,
    2305,
    4498,
    7808,
    7809,
    4208,
    1055,
    2605,
    484,
    3698,
    7810,
    3999,
    625,
    4209,
    2273,
    3368,
    1499,
    4210,
    4000,
    7811,
    4001,
    4211,
    3222,
    2274,
    2275,
    3476,
    7812,
    7813,
    2764,
    808,
    2606,
    3699,
    3369,
    4002,
    4212,
    3100,
    2532,
    526,
    3370,
    3821,
    4213,
    955,
    7814,
    1620,
    4214,
    2637,
    2427,
    7815,
    1429,
    3700,
    1669,
    1831,
    994,
    928,
    7816,
    3578,
    1260,
    7817,
    7818,
    7819,
    1948,
    2288,
    741,
    2919,
    1626,
    4215,
    2729,
    2455,
    867,
    1184,
    362,
    3371,
    1392,
    7820,
    7821,
    4003,
    4216,
    1770,
    1736,
    3223,
    2920,
    4499,
    4500,
    1928,
    2698,
    1459,
    1158,
    7822,
    3050,
    3372,
    2877,
    1292,
    1929,
    2506,
    2842,
    3701,
    1985,
    1187,
    2071,
    2014,
    2607,
    4217,
    7823,
    2566,
    2507,
    2169,
    3702,
    2483,
    3299,
    7824,
    3703,
    4501,
    7825,
    7826,
    666,
    1003,
    3005,
    1022,
    3579,
    4218,
    7827,
    4502,
    1813,
    2253,
    574,
    3822,
    1603,
    295,
    1535,
    705,
    3823,
    4219,
    283,
    858,
    417,
    7828,
    7829,
    3224,
    4503,
    4504,
    3051,
    1220,
    1889,
    1046,
    2276,
    2456,
    4004,
    1393,
    1599,
    689,
    2567,
    388,
    4220,
    7830,
    2484,
    802,
    7831,
    2798,
    3824,
    2060,
    1405,
    2254,
    7832,
    4505,
    3825,
    2109,
    1052,
    1345,
    3225,
    1585,
    7833,
    809,
    7834,
    7835,
    7836,
    575,
    2730,
    3477,
    956,
    1552,
    1469,
    1144,
    2323,
    7837,
    2324,
    1560,
    2457,
    3580,
    3226,
    4005,
    616,
    2207,
    3155,
    2180,
    2289,
    7838,
    1832,
    7839,
    3478,
    4506,
    7840,
    1319,
    3704,
    3705,
    1211,
    3581,
    1023,
    3227,
    1293,
    2799,
    7841,
    7842,
    7843,
    3826,
    607,
    2306,
    3827,
    762,
    2878,
    1439,
    4221,
    1360,
    7844,
    1485,
    3052,
    7845,
    4507,
    1038,
    4222,
    1450,
    2061,
    2638,
    4223,
    1379,
    4508,
    2585,
    7846,
    7847,
    4224,
    1352,
    1414,
    2325,
    2921,
    1172,
    7848,
    7849,
    3828,
    3829,
    7850,
    1797,
    1451,
    7851,
    7852,
    7853,
    7854,
    2922,
    4006,
    4007,
    2485,
    2346,
    411,
    4008,
    4009,
    3582,
    3300,
    3101,
    4509,
    1561,
    2664,
    1452,
    4010,
    1375,
    7855,
    7856,
    47,
    2959,
    316,
    7857,
    1406,
    1591,
    2923,
    3156,
    7858,
    1025,
    2141,
    3102,
    3157,
    354,
    2731,
    884,
    2224,
    4225,
    2407,
    508,
    3706,
    726,
    3583,
    996,
    2428,
    3584,
    729,
    7859,
    392,
    2191,
    1453,
    4011,
    4510,
    3707,
    7860,
    7861,
    2458,
    3585,
    2608,
    1675,
    2800,
    919,
    2347,
    2960,
    2348,
    1270,
    4511,
    4012,
    73,
    7862,
    7863,
    647,
    7864,
    3228,
    2843,
    2255,
    1550,
    1346,
    3006,
    7865,
    1332,
    883,
    3479,
    7866,
    7867,
    7868,
    7869,
    3301,
    2765,
    7870,
    1212,
    831,
    1347,
    4226,
    4512,
    2326,
    3830,
    1863,
    3053,
    720,
    3831,
    4513,
    4514,
    3832,
    7871,
    4227,
    7872,
    7873,
    4515,
    7874,
    7875,
    1798,
    4516,
    3708,
    2609,
    4517,
    3586,
    1645,
    2371,
    7876,
    7877,
    2924,
    669,
    2208,
    2665,
    2429,
    7878,
    2879,
    7879,
    7880,
    1028,
    3229,
    7881,
    4228,
    2408,
    7882,
    2256,
    1353,
    7883,
    7884,
    4518,
    3158,
    518,
    7885,
    4013,
    7886,
    4229,
    1960,
    7887,
    2142,
    4230,
    7888,
    7889,
    3007,
    2349,
    2350,
    3833,
    516,
    1833,
    1454,
    4014,
    2699,
    4231,
    4519,
    2225,
    2610,
    1971,
    1129,
    3587,
    7890,
    2766,
    7891,
    2961,
    1422,
    577,
    1470,
    3008,
    1524,
    3373,
    7892,
    7893,
    432,
    4232,
    3054,
    3480,
    7894,
    2586,
    1455,
    2508,
    2226,
    1972,
    1175,
    7895,
    1020,
    2732,
    4015,
    3481,
    4520,
    7896,
    2733,
    7897,
    1743,
    1361,
    3055,
    3482,
    2639,
    4016,
    4233,
    4521,
    2290,
    895,
    924,
    4234,
    2170,
    331,
    2243,
    3056,
    166,
    1627,
    3057,
    1098,
    7898,
    1232,
    2880,
    2227,
    3374,
    4522,
    657,
    403,
    1196,
    2372,
    542,
    3709,
    3375,
    1600,
    4235,
    3483,
    7899,
    4523,
    2767,
    3230,
    576,
    530,
    1362,
    7900,
    4524,
    2533,
    2666,
    3710,
    4017,
    7901,
    842,
    3834,
    7902,
    2801,
    2031,
    1014,
    4018,
    213,
    2700,
    3376,
    665,
    621,
    4236,
    7903,
    3711,
    2925,
    2430,
    7904,
    2431,
    3302,
    3588,
    3377,
    7905,
    4237,
    2534,
    4238,
    4525,
    3589,
    1682,
    4239,
    3484,
    1380,
    7906,
    724,
    2277,
    600,
    1670,
    7907,
    1337,
    1233,
    4526,
    3103,
    2244,
    7908,
    1621,
    4527,
    7909,
    651,
    4240,
    7910,
    1612,
    4241,
    2611,
    7911,
    2844,
    7912,
    2734,
    2307,
    3058,
    7913,
    716,
    2459,
    3059,
    174,
    1255,
    2701,
    4019,
    3590,
    548,
    1320,
    1398,
    728,
    4020,
    1574,
    7914,
    1890,
    1197,
    3060,
    4021,
    7915,
    3061,
    3062,
    3712,
    3591,
    3713,
    747,
    7916,
    635,
    4242,
    4528,
    7917,
    7918,
    7919,
    4243,
    7920,
    7921,
    4529,
    7922,
    3378,
    4530,
    2432,
    451,
    7923,
    3714,
    2535,
    2072,
    4244,
    2735,
    4245,
    4022,
    7924,
    1764,
    4531,
    7925,
    4246,
    350,
    7926,
    2278,
    2390,
    2486,
    7927,
    4247,
    4023,
    2245,
    1434,
    4024,
    488,
    4532,
    458,
    4248,
    4025,
    3715,
    771,
    1330,
    2391,
    3835,
    2568,
    3159,
    2159,
    2409,
    1553,
    2667,
    3160,
    4249,
    7928,
    2487,
    2881,
    2612,
    1720,
    2702,
    4250,
    3379,
    4533,
    7929,
    2536,
    4251,
    7930,
    3231,
    4252,
    2768,
    7931,
    2015,
    2736,
    7932,
    1155,
    1017,
    3716,
    3836,
    7933,
    3303,
    2308,
    201,
    1864,
    4253,
    1430,
    7934,
    4026,
    7935,
    7936,
    7937,
    7938,
    7939,
    4254,
    1604,
    7940,
    414,
    1865,
    371,
    2587,
    4534,
    4535,
    3485,
    2016,
    3104,
    4536,
    1708,
    960,
    4255,
    887,
    389,
    2171,
    1536,
    1663,
    1721,
    7941,
    2228,
    4027,
    2351,
    2926,
    1580,
    7942,
    7943,
    7944,
    1744,
    7945,
    2537,
    4537,
    4538,
    7946,
    4539,
    7947,
    2073,
    7948,
    7949,
    3592,
    3380,
    2882,
    4256,
    7950,
    4257,
    2640,
    3381,
    2802,
    673,
    2703,
    2460,
    709,
    3486,
    4028,
    3593,
    4258,
    7951,
    1148,
    502,
    634,
    7952,
    7953,
    1204,
    4540,
    3594,
    1575,
    4541,
    2613,
    3717,
    7954,
    3718,
    3105,
    948,
    3232,
    121,
    1745,
    3837,
    1110,
    7955,
    4259,
    3063,
    2509,
    3009,
    4029,
    3719,
    1151,
    1771,
    3838,
    1488,
    4030,
    1986,
    7956,
    2433,
    3487,
    7957,
    7958,
    2093,
    7959,
    4260,
    3839,
    1213,
    1407,
    2803,
    531,
    2737,
    2538,
    3233,
    1011,
    1537,
    7960,
    2769,
    4261,
    3106,
    1061,
    7961,
    3720,
    3721,
    1866,
    2883,
    7962,
    2017,
    120,
    4262,
    4263,
    2062,
    3595,
    3234,
    2309,
    3840,
    2668,
    3382,
    1954,
    4542,
    7963,
    7964,
    3488,
    1047,
    2704,
    1266,
    7965,
    1368,
    4543,
    2845,
    649,
    3383,
    3841,
    2539,
    2738,
    1102,
    2846,
    2669,
    7966,
    7967,
    1999,
    7968,
    1111,
    3596,
    2962,
    7969,
    2488,
    3842,
    3597,
    2804,
    1854,
    3384,
    3722,
    7970,
    7971,
    3385,
    2410,
    2884,
    3304,
    3235,
    3598,
    7972,
    2569,
    7973,
    3599,
    2805,
    4031,
    1460,
    856,
    7974,
    3600,
    7975,
    2885,
    2963,
    7976,
    2886,
    3843,
    7977,
    4264,
    632,
    2510,
    875,
    3844,
    1697,
    3845,
    2291,
    7978,
    7979,
    4544,
    3010,
    1239,
    580,
    4545,
    4265,
    7980,
    914,
    936,
    2074,
    1190,
    4032,
    1039,
    2123,
    7981,
    7982,
    7983,
    3386,
    1473,
    7984,
    1354,
    4266,
    3846,
    7985,
    2172,
    3064,
    4033,
    915,
    3305,
    4267,
    4268,
    3306,
    1605,
    1834,
    7986,
    2739,
    398,
    3601,
    4269,
    3847,
    4034,
    328,
    1912,
    2847,
    4035,
    3848,
    1331,
    4270,
    3011,
    937,
    4271,
    7987,
    3602,
    4036,
    4037,
    3387,
    2160,
    4546,
    3388,
    524,
    742,
    538,
    3065,
    1012,
    7988,
    7989,
    3849,
    2461,
    7990,
    658,
    1103,
    225,
    3850,
    7991,
    7992,
    4547,
    7993,
    4548,
    7994,
    3236,
    1243,
    7995,
    4038,
    963,
    2246,
    4549,
    7996,
    2705,
    3603,
    3161,
    7997,
    7998,
    2588,
    2327,
    7999,
    4550,
    8000,
    8001,
    8002,
    3489,
    3307,
    957,
    3389,
    2540,
    2032,
    1930,
    2927,
    2462,
    870,
    2018,
    3604,
    1746,
    2770,
    2771,
    2434,
    2463,
    8003,
    3851,
    8004,
    3723,
    3107,
    3724,
    3490,
    3390,
    3725,
    8005,
    1179,
    3066,
    8006,
    3162,
    2373,
    4272,
    3726,
    2541,
    3163,
    3108,
    2740,
    4039,
    8007,
    3391,
    1556,
    2542,
    2292,
    977,
    2887,
    2033,
    4040,
    1205,
    3392,
    8008,
    1765,
    3393,
    3164,
    2124,
    1271,
    1689,
    714,
    4551,
    3491,
    8009,
    2328,
    3852,
    533,
    4273,
    3605,
    2181,
    617,
    8010,
    2464,
    3308,
    3492,
    2310,
    8011,
    8012,
    3165,
    8013,
    8014,
    3853,
    1987,
    618,
    427,
    2641,
    3493,
    3394,
    8015,
    8016,
    1244,
    1690,
    8017,
    2806,
    4274,
    4552,
    8018,
    3494,
    8019,
    8020,
    2279,
    1576,
    473,
    3606,
    4275,
    3395,
    972,
    8021,
    3607,
    8022,
    3067,
    8023,
    8024,
    4553,
    4554,
    8025,
    3727,
    4041,
    4042,
    8026,
    153,
    4555,
    356,
    8027,
    1891,
    2888,
    4276,
    2143,
    408,
    803,
    2352,
    8028,
    3854,
    8029,
    4277,
    1646,
    2570,
    2511,
    4556,
    4557,
    3855,
    8030,
    3856,
    4278,
    8031,
    2411,
    3396,
    752,
    8032,
    8033,
    1961,
    2964,
    8034,
    746,
    3012,
    2465,
    8035,
    4279,
    3728,
    698,
    4558,
    1892,
    4280,
    3608,
    2543,
    4559,
    3609,
    3857,
    8036,
    3166,
    3397,
    8037,
    1823,
    1302,
    4043,
    2706,
    3858,
    1973,
    4281,
    8038,
    4282,
    3167,
    823,
    1303,
    1288,
    1236,
    2848,
    3495,
    4044,
    3398,
    774,
    3859,
    8039,
    1581,
    4560,
    1304,
    2849,
    3860,
    4561,
    8040,
    2435,
    2161,
    1083,
    3237,
    4283,
    4045,
    4284,
    344,
    1173,
    288,
    2311,
    454,
    1683,
    8041,
    8042,
    1461,
    4562,
    4046,
    2589,
    8043,
    8044,
    4563,
    985,
    894,
    8045,
    3399,
    3168,
    8046,
    1913,
    2928,
    3729,
    1988,
    8047,
    2110,
    1974,
    8048,
    4047,
    8049,
    2571,
    1194,
    425,
    8050,
    4564,
    3169,
    1245,
    3730,
    4285,
    8051,
    8052,
    2850,
    8053,
    636,
    4565,
    1855,
    3861,
    760,
    1799,
    8054,
    4286,
    2209,
    1508,
    4566,
    4048,
    1893,
    1684,
    2293,
    8055,
    8056,
    8057,
    4287,
    4288,
    2210,
    479,
    8058,
    8059,
    832,
    8060,
    4049,
    2489,
    8061,
    2965,
    2490,
    3731,
    990,
    3109,
    627,
    1814,
    2642,
    4289,
    1582,
    4290,
    2125,
    2111,
    3496,
    4567,
    8062,
    799,
    4291,
    3170,
    8063,
    4568,
    2112,
    1737,
    3013,
    1018,
    543,
    754,
    4292,
    3309,
    1676,
    4569,
    4570,
    4050,
    8064,
    1489,
    8065,
    3497,
    8066,
    2614,
    2889,
    4051,
    8067,
    8068,
    2966,
    8069,
    8070,
    8071,
    8072,
    3171,
    4571,
    4572,
    2182,
    1722,
    8073,
    3238,
    3239,
    1842,
    3610,
    1715,
    481,
    365,
    1975,
    1856,
    8074,
    8075,
    1962,
    2491,
    4573,
    8076,
    2126,
    3611,
    3240,
    433,
    1894,
    2063,
    2075,
    8077,
    602,
    2741,
    8078,
    8079,
    8080,
    8081,
    8082,
    3014,
    1628,
    3400,
    8083,
    3172,
    4574,
    4052,
    2890,
    4575,
    2512,
    8084,
    2544,
    2772,
    8085,
    8086,
    8087,
    3310,
    4576,
    2891,
    8088,
    4577,
    8089,
    2851,
    4578,
    4579,
    1221,
    2967,
    4053,
    2513,
    8090,
    8091,
    8092,
    1867,
    1989,
    8093,
    8094,
    8095,
    1895,
    8096,
    8097,
    4580,
    1896,
    4054,
    318,
    8098,
    2094,
    4055,
    4293,
    8099,
    8100,
    485,
    8101,
    938,
    3862,
    553,
    2670,
    116,
    8102,
    3863,
    3612,
    8103,
    3498,
    2671,
    2773,
    3401,
    3311,
    2807,
    8104,
    3613,
    2929,
    4056,
    1747,
    2930,
    2968,
    8105,
    8106,
    207,
    8107,
    8108,
    2672,
    4581,
    2514,
    8109,
    3015,
    890,
    3614,
    3864,
    8110,
    1877,
    3732,
    3402,
    8111,
    2183,
    2353,
    3403,
    1652,
    8112,
    8113,
    8114,
    941,
    2294,
    208,
    3499,
    4057,
    2019,
    330,
    4294,
    3865,
    2892,
    2492,
    3733,
    4295,
    8115,
    8116,
    8117,
    8118,
    //Everything below is of no interest for detection purpose
    2515,
    1613,
    4582,
    8119,
    3312,
    3866,
    2516,
    8120,
    4058,
    8121,
    1637,
    4059,
    2466,
    4583,
    3867,
    8122,
    2493,
    3016,
    3734,
    8123,
    8124,
    2192,
    8125,
    8126,
    2162,
    8127,
    8128,
    8129,
    8130,
    8131,
    8132,
    8133,
    8134,
    8135,
    8136,
    8137,
    8138,
    8139,
    8140,
    8141,
    8142,
    8143,
    8144,
    8145,
    8146,
    8147,
    8148,
    8149,
    8150,
    8151,
    8152,
    8153,
    8154,
    8155,
    8156,
    8157,
    8158,
    8159,
    8160,
    8161,
    8162,
    8163,
    8164,
    8165,
    8166,
    8167,
    8168,
    8169,
    8170,
    8171,
    8172,
    8173,
    8174,
    8175,
    8176,
    8177,
    8178,
    8179,
    8180,
    8181,
    8182,
    8183,
    8184,
    8185,
    8186,
    8187,
    8188,
    8189,
    8190,
    8191,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8203,
    8204,
    8205,
    8206,
    8207,
    8208,
    8209,
    8210,
    8211,
    8212,
    8213,
    8214,
    8215,
    8216,
    8217,
    8218,
    8219,
    8220,
    8221,
    8222,
    8223,
    8224,
    8225,
    8226,
    8227,
    8228,
    8229,
    8230,
    8231,
    8232,
    8233,
    8234,
    8235,
    8236,
    8237,
    8238,
    8239,
    8240,
    8241,
    8242,
    8243,
    8244,
    8245,
    8246,
    8247,
    8248,
    8249,
    8250,
    8251,
    8252,
    8253,
    8254,
    8255,
    8256,
    8257,
    8258,
    8259,
    8260,
    8261,
    8262,
    8263,
    8264,
    8265,
    8266,
    8267,
    8268,
    8269,
    8270,
    8271,
    8272,
    8273,
    8274,
    8275,
    8276,
    8277,
    8278,
    8279,
    8280,
    8281,
    8282,
    8283,
    8284,
    8285,
    8286,
    8287,
    8288,
    8289,
    8290,
    8291,
    8292,
    8293,
    8294,
    8295,
    8296,
    8297,
    8298,
    8299,
    8300,
    8301,
    8302,
    8303,
    8304,
    8305,
    8306,
    8307,
    8308,
    8309,
    8310,
    8311,
    8312,
    8313,
    8314,
    8315,
    8316,
    8317,
    8318,
    8319,
    8320,
    8321,
    8322,
    8323,
    8324,
    8325,
    8326,
    8327,
    8328,
    8329,
    8330,
    8331,
    8332,
    8333,
    8334,
    8335,
    8336,
    8337,
    8338,
    8339,
    8340,
    8341,
    8342,
    8343,
    8344,
    8345,
    8346,
    8347,
    8348,
    8349,
    8350,
    8351,
    8352,
    8353,
    8354,
    8355,
    8356,
    8357,
    8358,
    8359,
    8360,
    8361,
    8362,
    8363,
    8364,
    8365,
    8366,
    8367,
    8368,
    8369,
    8370,
    8371,
    8372,
    8373,
    8374,
    8375,
    8376,
    8377,
    8378,
    8379,
    8380,
    8381,
    8382,
    8383,
    8384,
    8385,
    8386,
    8387,
    8388,
    8389,
    8390,
    8391,
    8392,
    8393,
    8394,
    8395,
    8396,
    8397,
    8398,
    8399,
    8400,
    8401,
    8402,
    8403,
    8404,
    8405,
    8406,
    8407,
    8408,
    8409,
    8410,
    8411,
    8412,
    8413,
    8414,
    8415,
    8416,
    8417,
    8418,
    8419,
    8420,
    8421,
    8422,
    8423,
    8424,
    8425,
    8426,
    8427,
    8428,
    8429,
    8430,
    8431,
    8432,
    8433,
    8434,
    8435,
    8436,
    8437,
    8438,
    8439,
    8440,
    8441,
    8442,
    8443,
    8444,
    8445,
    8446,
    8447,
    8448,
    8449,
    8450,
    8451,
    8452,
    8453,
    8454,
    8455,
    8456,
    8457,
    8458,
    8459,
    8460,
    8461,
    8462,
    8463,
    8464,
    8465,
    8466,
    8467,
    8468,
    8469,
    8470,
    8471,
    8472,
    8473,
    8474,
    8475,
    8476,
    8477,
    8478,
    8479,
    8480,
    8481,
    8482,
    8483,
    8484,
    8485,
    8486,
    8487,
    8488,
    8489,
    8490,
    8491,
    8492,
    8493,
    8494,
    8495,
    8496,
    8497,
    8498,
    8499,
    8500,
    8501,
    8502,
    8503,
    8504,
    8505,
    8506,
    8507,
    8508,
    8509,
    8510,
    8511,
    8512,
    8513,
    8514,
    8515,
    8516,
    8517,
    8518,
    8519,
    8520,
    8521,
    8522,
    8523,
    8524,
    8525,
    8526,
    8527,
    8528,
    8529,
    8530,
    8531,
    8532,
    8533,
    8534,
    8535,
    8536,
    8537,
    8538,
    8539,
    8540,
    8541,
    8542,
    8543,
    8544,
    8545,
    8546,
    8547,
    8548,
    8549,
    8550,
    8551,
    8552,
    8553,
    8554,
    8555,
    8556,
    8557,
    8558,
    8559,
    8560,
    8561,
    8562,
    8563,
    8564,
    8565,
    8566,
    8567,
    8568,
    8569,
    8570,
    8571,
    8572,
    8573,
    8574,
    8575,
    8576,
    8577,
    8578,
    8579,
    8580,
    8581,
    8582,
    8583,
    8584,
    8585,
    8586,
    8587,
    8588,
    8589,
    8590,
    8591,
    8592,
    8593,
    8594,
    8595,
    8596,
    8597,
    8598,
    8599,
    8600,
    8601,
    8602,
    8603,
    8604,
    8605,
    8606,
    8607,
    8608,
    8609,
    8610,
    8611,
    8612,
    8613,
    8614,
    8615,
    8616,
    8617,
    8618,
    8619,
    8620,
    8621,
    8622,
    8623,
    8624,
    8625,
    8626,
    8627,
    8628,
    8629,
    8630,
    8631,
    8632,
    8633,
    8634,
    8635,
    8636,
    8637,
    8638,
    8639,
    8640,
    8641,
    8642,
    8643,
    8644,
    8645,
    8646,
    8647,
    8648,
    8649,
    8650,
    8651,
    8652,
    8653,
    8654,
    8655,
    8656,
    8657,
    8658,
    8659,
    8660,
    8661,
    8662,
    8663,
    8664,
    8665,
    8666,
    8667,
    8668,
    8669,
    8670,
    8671,
    8672,
    8673,
    8674,
    8675,
    8676,
    8677,
    8678,
    8679,
    8680,
    8681,
    8682,
    8683,
    8684,
    8685,
    8686,
    8687,
    8688,
    8689,
    8690,
    8691,
    8692,
    8693,
    8694,
    8695,
    8696,
    8697,
    8698,
    8699,
    8700,
    8701,
    8702,
    8703,
    8704,
    8705,
    8706,
    8707,
    8708,
    8709,
    8710,
    8711,
    8712,
    8713,
    8714,
    8715,
    8716,
    8717,
    8718,
    8719,
    8720,
    8721,
    8722,
    8723,
    8724,
    8725,
    8726,
    8727,
    8728,
    8729,
    8730,
    8731,
    8732,
    8733,
    8734,
    8735,
    8736,
    8737,
    8738,
    8739,
    8740,
    8741
]; // 8742

});

parcelRegister("bytDp", function(module, exports) {

$parcel$export(module.exports, "EUCKR_TYPICAL_DISTRIBUTION_RATIO", () => $8699db813f494e33$export$c181397cd9321bb2, (v) => $8699db813f494e33$export$c181397cd9321bb2 = v);
$parcel$export(module.exports, "EUCKR_TABLE_SIZE", () => $8699db813f494e33$export$80b234935e4f707e, (v) => $8699db813f494e33$export$80b234935e4f707e = v);
$parcel$export(module.exports, "EUCKRCharToFreqOrder", () => $8699db813f494e33$export$b31eca8503ee16ac, (v) => $8699db813f494e33$export$b31eca8503ee16ac = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // Sampling from about 20M text materials include literature and computer technology
// 128  --> 0.79
// 256  --> 0.92
// 512  --> 0.986
// 1024 --> 0.99944
// 2048 --> 0.99999
//
// Idea Distribution Ratio = 0.98653 / (1-0.98653) = 73.24
// Random Distribution Ration = 512 / (2350-512) = 0.279.
//
// Typical Distribution Ratio
var $8699db813f494e33$export$c181397cd9321bb2;
var $8699db813f494e33$export$80b234935e4f707e;
// Char to FreqOrder table ,
var $8699db813f494e33$export$b31eca8503ee16ac;
$8699db813f494e33$export$c181397cd9321bb2 = 6.0;
$8699db813f494e33$export$80b234935e4f707e = 2352;
$8699db813f494e33$export$b31eca8503ee16ac = [
    13,
    130,
    120,
    1396,
    481,
    1719,
    1720,
    328,
    609,
    212,
    1721,
    707,
    400,
    299,
    1722,
    87,
    1397,
    1723,
    104,
    536,
    1117,
    1203,
    1724,
    1267,
    685,
    1268,
    508,
    1725,
    1726,
    1727,
    1728,
    1398,
    1399,
    1729,
    1730,
    1731,
    141,
    621,
    326,
    1057,
    368,
    1732,
    267,
    488,
    20,
    1733,
    1269,
    1734,
    945,
    1400,
    1735,
    47,
    904,
    1270,
    1736,
    1737,
    773,
    248,
    1738,
    409,
    313,
    786,
    429,
    1739,
    116,
    987,
    813,
    1401,
    683,
    75,
    1204,
    145,
    1740,
    1741,
    1742,
    1743,
    16,
    847,
    667,
    622,
    708,
    1744,
    1745,
    1746,
    966,
    787,
    304,
    129,
    1747,
    60,
    820,
    123,
    676,
    1748,
    1749,
    1750,
    1751,
    617,
    1752,
    626,
    1753,
    1754,
    1755,
    1756,
    653,
    1757,
    1758,
    1759,
    1760,
    1761,
    1762,
    856,
    344,
    1763,
    1764,
    1765,
    1766,
    89,
    401,
    418,
    806,
    905,
    848,
    1767,
    1768,
    1769,
    946,
    1205,
    709,
    1770,
    1118,
    1771,
    241,
    1772,
    1773,
    1774,
    1271,
    1775,
    569,
    1776,
    999,
    1777,
    1778,
    1779,
    1780,
    337,
    751,
    1058,
    28,
    628,
    254,
    1781,
    177,
    906,
    270,
    349,
    891,
    1079,
    1782,
    19,
    1783,
    379,
    1784,
    315,
    1785,
    629,
    754,
    1402,
    559,
    1786,
    636,
    203,
    1206,
    1787,
    710,
    567,
    1788,
    935,
    814,
    1789,
    1790,
    1207,
    766,
    528,
    1791,
    1792,
    1208,
    1793,
    1794,
    1795,
    1796,
    1797,
    1403,
    1798,
    1799,
    533,
    1059,
    1404,
    1405,
    1156,
    1406,
    936,
    884,
    1080,
    1800,
    351,
    1801,
    1802,
    1803,
    1804,
    1805,
    801,
    1806,
    1807,
    1808,
    1119,
    1809,
    1157,
    714,
    474,
    1407,
    1810,
    298,
    899,
    885,
    1811,
    1120,
    802,
    1158,
    1812,
    892,
    1813,
    1814,
    1408,
    659,
    1815,
    1816,
    1121,
    1817,
    1818,
    1819,
    1820,
    1821,
    1822,
    319,
    1823,
    594,
    545,
    1824,
    815,
    937,
    1209,
    1825,
    1826,
    573,
    1409,
    1022,
    1827,
    1210,
    1828,
    1829,
    1830,
    1831,
    1832,
    1833,
    556,
    722,
    807,
    1122,
    1060,
    1834,
    697,
    1835,
    900,
    557,
    715,
    1836,
    1410,
    540,
    1411,
    752,
    1159,
    294,
    597,
    1211,
    976,
    803,
    770,
    1412,
    1837,
    1838,
    39,
    794,
    1413,
    358,
    1839,
    371,
    925,
    1840,
    453,
    661,
    788,
    531,
    723,
    544,
    1023,
    1081,
    869,
    91,
    1841,
    392,
    430,
    790,
    602,
    1414,
    677,
    1082,
    457,
    1415,
    1416,
    1842,
    1843,
    475,
    327,
    1024,
    1417,
    795,
    121,
    1844,
    733,
    403,
    1418,
    1845,
    1846,
    1847,
    300,
    119,
    711,
    1212,
    627,
    1848,
    1272,
    207,
    1849,
    1850,
    796,
    1213,
    382,
    1851,
    519,
    1852,
    1083,
    893,
    1853,
    1854,
    1855,
    367,
    809,
    487,
    671,
    1856,
    663,
    1857,
    1858,
    956,
    471,
    306,
    857,
    1859,
    1860,
    1160,
    1084,
    1861,
    1862,
    1863,
    1864,
    1865,
    1061,
    1866,
    1867,
    1868,
    1869,
    1870,
    1871,
    282,
    96,
    574,
    1872,
    502,
    1085,
    1873,
    1214,
    1874,
    907,
    1875,
    1876,
    827,
    977,
    1419,
    1420,
    1421,
    268,
    1877,
    1422,
    1878,
    1879,
    1880,
    308,
    1881,
    2,
    537,
    1882,
    1883,
    1215,
    1884,
    1885,
    127,
    791,
    1886,
    1273,
    1423,
    1887,
    34,
    336,
    404,
    643,
    1888,
    571,
    654,
    894,
    840,
    1889,
    0,
    886,
    1274,
    122,
    575,
    260,
    908,
    938,
    1890,
    1275,
    410,
    316,
    1891,
    1892,
    100,
    1893,
    1894,
    1123,
    48,
    1161,
    1124,
    1025,
    1895,
    633,
    901,
    1276,
    1896,
    1897,
    115,
    816,
    1898,
    317,
    1899,
    694,
    1900,
    909,
    734,
    1424,
    572,
    866,
    1425,
    691,
    85,
    524,
    1010,
    543,
    394,
    841,
    1901,
    1902,
    1903,
    1026,
    1904,
    1905,
    1906,
    1907,
    1908,
    1909,
    30,
    451,
    651,
    988,
    310,
    1910,
    1911,
    1426,
    810,
    1216,
    93,
    1912,
    1913,
    1277,
    1217,
    1914,
    858,
    759,
    45,
    58,
    181,
    610,
    269,
    1915,
    1916,
    131,
    1062,
    551,
    443,
    1000,
    821,
    1427,
    957,
    895,
    1086,
    1917,
    1918,
    375,
    1919,
    359,
    1920,
    687,
    1921,
    822,
    1922,
    293,
    1923,
    1924,
    40,
    662,
    118,
    692,
    29,
    939,
    887,
    640,
    482,
    174,
    1925,
    69,
    1162,
    728,
    1428,
    910,
    1926,
    1278,
    1218,
    1279,
    386,
    870,
    217,
    854,
    1163,
    823,
    1927,
    1928,
    1929,
    1930,
    834,
    1931,
    78,
    1932,
    859,
    1933,
    1063,
    1934,
    1935,
    1936,
    1937,
    438,
    1164,
    208,
    595,
    1938,
    1939,
    1940,
    1941,
    1219,
    1125,
    1942,
    280,
    888,
    1429,
    1430,
    1220,
    1431,
    1943,
    1944,
    1945,
    1946,
    1947,
    1280,
    150,
    510,
    1432,
    1948,
    1949,
    1950,
    1951,
    1952,
    1953,
    1954,
    1011,
    1087,
    1955,
    1433,
    1043,
    1956,
    881,
    1957,
    614,
    958,
    1064,
    1065,
    1221,
    1958,
    638,
    1001,
    860,
    967,
    896,
    1434,
    989,
    492,
    553,
    1281,
    1165,
    1959,
    1282,
    1002,
    1283,
    1222,
    1960,
    1961,
    1962,
    1963,
    36,
    383,
    228,
    753,
    247,
    454,
    1964,
    876,
    678,
    1965,
    1966,
    1284,
    126,
    464,
    490,
    835,
    136,
    672,
    529,
    940,
    1088,
    1435,
    473,
    1967,
    1968,
    467,
    50,
    390,
    227,
    587,
    279,
    378,
    598,
    792,
    968,
    240,
    151,
    160,
    849,
    882,
    1126,
    1285,
    639,
    1044,
    133,
    140,
    288,
    360,
    811,
    563,
    1027,
    561,
    142,
    523,
    1969,
    1970,
    1971,
    7,
    103,
    296,
    439,
    407,
    506,
    634,
    990,
    1972,
    1973,
    1974,
    1975,
    645,
    1976,
    1977,
    1978,
    1979,
    1980,
    1981,
    236,
    1982,
    1436,
    1983,
    1984,
    1089,
    192,
    828,
    618,
    518,
    1166,
    333,
    1127,
    1985,
    818,
    1223,
    1986,
    1987,
    1988,
    1989,
    1990,
    1991,
    1992,
    1993,
    342,
    1128,
    1286,
    746,
    842,
    1994,
    1995,
    560,
    223,
    1287,
    98,
    8,
    189,
    650,
    978,
    1288,
    1996,
    1437,
    1997,
    17,
    345,
    250,
    423,
    277,
    234,
    512,
    226,
    97,
    289,
    42,
    167,
    1998,
    201,
    1999,
    2000,
    843,
    836,
    824,
    532,
    338,
    783,
    1090,
    182,
    576,
    436,
    1438,
    1439,
    527,
    500,
    2001,
    947,
    889,
    2002,
    2003,
    2004,
    2005,
    262,
    600,
    314,
    447,
    2006,
    547,
    2007,
    693,
    738,
    1129,
    2008,
    71,
    1440,
    745,
    619,
    688,
    2009,
    829,
    2010,
    2011,
    147,
    2012,
    33,
    948,
    2013,
    2014,
    74,
    224,
    2015,
    61,
    191,
    918,
    399,
    637,
    2016,
    1028,
    1130,
    257,
    902,
    2017,
    2018,
    2019,
    2020,
    2021,
    2022,
    2023,
    2024,
    2025,
    2026,
    837,
    2027,
    2028,
    2029,
    2030,
    179,
    874,
    591,
    52,
    724,
    246,
    2031,
    2032,
    2033,
    2034,
    1167,
    969,
    2035,
    1289,
    630,
    605,
    911,
    1091,
    1168,
    2036,
    2037,
    2038,
    1441,
    912,
    2039,
    623,
    2040,
    2041,
    253,
    1169,
    1290,
    2042,
    1442,
    146,
    620,
    611,
    577,
    433,
    2043,
    1224,
    719,
    1170,
    959,
    440,
    437,
    534,
    84,
    388,
    480,
    1131,
    159,
    220,
    198,
    679,
    2044,
    1012,
    819,
    1066,
    1443,
    113,
    1225,
    194,
    318,
    1003,
    1029,
    2045,
    2046,
    2047,
    2048,
    1067,
    2049,
    2050,
    2051,
    2052,
    2053,
    59,
    913,
    112,
    2054,
    632,
    2055,
    455,
    144,
    739,
    1291,
    2056,
    273,
    681,
    499,
    2057,
    448,
    2058,
    2059,
    760,
    2060,
    2061,
    970,
    384,
    169,
    245,
    1132,
    2062,
    2063,
    414,
    1444,
    2064,
    2065,
    41,
    235,
    2066,
    157,
    252,
    877,
    568,
    919,
    789,
    580,
    2067,
    725,
    2068,
    2069,
    1292,
    2070,
    2071,
    1445,
    2072,
    1446,
    2073,
    2074,
    55,
    588,
    66,
    1447,
    271,
    1092,
    2075,
    1226,
    2076,
    960,
    1013,
    372,
    2077,
    2078,
    2079,
    2080,
    2081,
    1293,
    2082,
    2083,
    2084,
    2085,
    850,
    2086,
    2087,
    2088,
    2089,
    2090,
    186,
    2091,
    1068,
    180,
    2092,
    2093,
    2094,
    109,
    1227,
    522,
    606,
    2095,
    867,
    1448,
    1093,
    991,
    1171,
    926,
    353,
    1133,
    2096,
    581,
    2097,
    2098,
    2099,
    1294,
    1449,
    1450,
    2100,
    596,
    1172,
    1014,
    1228,
    2101,
    1451,
    1295,
    1173,
    1229,
    2102,
    2103,
    1296,
    1134,
    1452,
    949,
    1135,
    2104,
    2105,
    1094,
    1453,
    1454,
    1455,
    2106,
    1095,
    2107,
    2108,
    2109,
    2110,
    2111,
    2112,
    2113,
    2114,
    2115,
    2116,
    2117,
    804,
    2118,
    2119,
    1230,
    1231,
    805,
    1456,
    405,
    1136,
    2120,
    2121,
    2122,
    2123,
    2124,
    720,
    701,
    1297,
    992,
    1457,
    927,
    1004,
    2125,
    2126,
    2127,
    2128,
    2129,
    2130,
    22,
    417,
    2131,
    303,
    2132,
    385,
    2133,
    971,
    520,
    513,
    2134,
    1174,
    73,
    1096,
    231,
    274,
    962,
    1458,
    673,
    2135,
    1459,
    2136,
    152,
    1137,
    2137,
    2138,
    2139,
    2140,
    1005,
    1138,
    1460,
    1139,
    2141,
    2142,
    2143,
    2144,
    11,
    374,
    844,
    2145,
    154,
    1232,
    46,
    1461,
    2146,
    838,
    830,
    721,
    1233,
    106,
    2147,
    90,
    428,
    462,
    578,
    566,
    1175,
    352,
    2148,
    2149,
    538,
    1234,
    124,
    1298,
    2150,
    1462,
    761,
    565,
    2151,
    686,
    2152,
    649,
    2153,
    72,
    173,
    2154,
    460,
    415,
    2155,
    1463,
    2156,
    1235,
    305,
    2157,
    2158,
    2159,
    2160,
    2161,
    2162,
    579,
    2163,
    2164,
    2165,
    2166,
    2167,
    747,
    2168,
    2169,
    2170,
    2171,
    1464,
    669,
    2172,
    2173,
    2174,
    2175,
    2176,
    1465,
    2177,
    23,
    530,
    285,
    2178,
    335,
    729,
    2179,
    397,
    2180,
    2181,
    2182,
    1030,
    2183,
    2184,
    698,
    2185,
    2186,
    325,
    2187,
    2188,
    369,
    2189,
    799,
    1097,
    1015,
    348,
    2190,
    1069,
    680,
    2191,
    851,
    1466,
    2192,
    2193,
    10,
    2194,
    613,
    424,
    2195,
    979,
    108,
    449,
    589,
    27,
    172,
    81,
    1031,
    80,
    774,
    281,
    350,
    1032,
    525,
    301,
    582,
    1176,
    2196,
    674,
    1045,
    2197,
    2198,
    1467,
    730,
    762,
    2199,
    2200,
    2201,
    2202,
    1468,
    2203,
    993,
    2204,
    2205,
    266,
    1070,
    963,
    1140,
    2206,
    2207,
    2208,
    664,
    1098,
    972,
    2209,
    2210,
    2211,
    1177,
    1469,
    1470,
    871,
    2212,
    2213,
    2214,
    2215,
    2216,
    1471,
    2217,
    2218,
    2219,
    2220,
    2221,
    2222,
    2223,
    2224,
    2225,
    2226,
    2227,
    1472,
    1236,
    2228,
    2229,
    2230,
    2231,
    2232,
    2233,
    2234,
    2235,
    1299,
    2236,
    2237,
    200,
    2238,
    477,
    373,
    2239,
    2240,
    731,
    825,
    777,
    2241,
    2242,
    2243,
    521,
    486,
    548,
    2244,
    2245,
    2246,
    1473,
    1300,
    53,
    549,
    137,
    875,
    76,
    158,
    2247,
    1301,
    1474,
    469,
    396,
    1016,
    278,
    712,
    2248,
    321,
    442,
    503,
    767,
    744,
    941,
    1237,
    1178,
    1475,
    2249,
    82,
    178,
    1141,
    1179,
    973,
    2250,
    1302,
    2251,
    297,
    2252,
    2253,
    570,
    2254,
    2255,
    2256,
    18,
    450,
    206,
    2257,
    290,
    292,
    1142,
    2258,
    511,
    162,
    99,
    346,
    164,
    735,
    2259,
    1476,
    1477,
    4,
    554,
    343,
    798,
    1099,
    2260,
    1100,
    2261,
    43,
    171,
    1303,
    139,
    215,
    2262,
    2263,
    717,
    775,
    2264,
    1033,
    322,
    216,
    2265,
    831,
    2266,
    149,
    2267,
    1304,
    2268,
    2269,
    702,
    1238,
    135,
    845,
    347,
    309,
    2270,
    484,
    2271,
    878,
    655,
    238,
    1006,
    1478,
    2272,
    67,
    2273,
    295,
    2274,
    2275,
    461,
    2276,
    478,
    942,
    412,
    2277,
    1034,
    2278,
    2279,
    2280,
    265,
    2281,
    541,
    2282,
    2283,
    2284,
    2285,
    2286,
    70,
    852,
    1071,
    2287,
    2288,
    2289,
    2290,
    21,
    56,
    509,
    117,
    432,
    2291,
    2292,
    331,
    980,
    552,
    1101,
    148,
    284,
    105,
    393,
    1180,
    1239,
    755,
    2293,
    187,
    2294,
    1046,
    1479,
    2295,
    340,
    2296,
    63,
    1047,
    230,
    2297,
    2298,
    1305,
    763,
    1306,
    101,
    800,
    808,
    494,
    2299,
    2300,
    2301,
    903,
    2302,
    37,
    1072,
    14,
    5,
    2303,
    79,
    675,
    2304,
    312,
    2305,
    2306,
    2307,
    2308,
    2309,
    1480,
    6,
    1307,
    2310,
    2311,
    2312,
    1,
    470,
    35,
    24,
    229,
    2313,
    695,
    210,
    86,
    778,
    15,
    784,
    592,
    779,
    32,
    77,
    855,
    964,
    2314,
    259,
    2315,
    501,
    380,
    2316,
    2317,
    83,
    981,
    153,
    689,
    1308,
    1481,
    1482,
    1483,
    2318,
    2319,
    716,
    1484,
    2320,
    2321,
    2322,
    2323,
    2324,
    2325,
    1485,
    2326,
    2327,
    128,
    57,
    68,
    261,
    1048,
    211,
    170,
    1240,
    31,
    2328,
    51,
    435,
    742,
    2329,
    2330,
    2331,
    635,
    2332,
    264,
    456,
    2333,
    2334,
    2335,
    425,
    2336,
    1486,
    143,
    507,
    263,
    943,
    2337,
    363,
    920,
    1487,
    256,
    1488,
    1102,
    243,
    601,
    1489,
    2338,
    2339,
    2340,
    2341,
    2342,
    2343,
    2344,
    861,
    2345,
    2346,
    2347,
    2348,
    2349,
    2350,
    395,
    2351,
    1490,
    1491,
    62,
    535,
    166,
    225,
    2352,
    2353,
    668,
    419,
    1241,
    138,
    604,
    928,
    2354,
    1181,
    2355,
    1492,
    1493,
    2356,
    2357,
    2358,
    1143,
    2359,
    696,
    2360,
    387,
    307,
    1309,
    682,
    476,
    2361,
    2362,
    332,
    12,
    222,
    156,
    2363,
    232,
    2364,
    641,
    276,
    656,
    517,
    1494,
    1495,
    1035,
    416,
    736,
    1496,
    2365,
    1017,
    586,
    2366,
    2367,
    2368,
    1497,
    2369,
    242,
    2370,
    2371,
    2372,
    1498,
    2373,
    965,
    713,
    2374,
    2375,
    2376,
    2377,
    740,
    982,
    1499,
    944,
    1500,
    1007,
    2378,
    2379,
    1310,
    1501,
    2380,
    2381,
    2382,
    785,
    329,
    2383,
    2384,
    1502,
    2385,
    2386,
    2387,
    932,
    2388,
    1503,
    2389,
    2390,
    2391,
    2392,
    1242,
    2393,
    2394,
    2395,
    2396,
    2397,
    994,
    950,
    2398,
    2399,
    2400,
    2401,
    1504,
    1311,
    2402,
    2403,
    2404,
    2405,
    1049,
    749,
    2406,
    2407,
    853,
    718,
    1144,
    1312,
    2408,
    1182,
    1505,
    2409,
    2410,
    255,
    516,
    479,
    564,
    550,
    214,
    1506,
    1507,
    1313,
    413,
    239,
    444,
    339,
    1145,
    1036,
    1508,
    1509,
    1314,
    1037,
    1510,
    1315,
    2411,
    1511,
    2412,
    2413,
    2414,
    176,
    703,
    497,
    624,
    593,
    921,
    302,
    2415,
    341,
    165,
    1103,
    1512,
    2416,
    1513,
    2417,
    2418,
    2419,
    376,
    2420,
    700,
    2421,
    2422,
    2423,
    258,
    768,
    1316,
    2424,
    1183,
    2425,
    995,
    608,
    2426,
    2427,
    2428,
    2429,
    221,
    2430,
    2431,
    2432,
    2433,
    2434,
    2435,
    2436,
    2437,
    195,
    323,
    726,
    188,
    897,
    983,
    1317,
    377,
    644,
    1050,
    879,
    2438,
    452,
    2439,
    2440,
    2441,
    2442,
    2443,
    2444,
    914,
    2445,
    2446,
    2447,
    2448,
    915,
    489,
    2449,
    1514,
    1184,
    2450,
    2451,
    515,
    64,
    427,
    495,
    2452,
    583,
    2453,
    483,
    485,
    1038,
    562,
    213,
    1515,
    748,
    666,
    2454,
    2455,
    2456,
    2457,
    334,
    2458,
    780,
    996,
    1008,
    705,
    1243,
    2459,
    2460,
    2461,
    2462,
    2463,
    114,
    2464,
    493,
    1146,
    366,
    163,
    1516,
    961,
    1104,
    2465,
    291,
    2466,
    1318,
    1105,
    2467,
    1517,
    365,
    2468,
    355,
    951,
    1244,
    2469,
    1319,
    2470,
    631,
    2471,
    2472,
    218,
    1320,
    364,
    320,
    756,
    1518,
    1519,
    1321,
    1520,
    1322,
    2473,
    2474,
    2475,
    2476,
    997,
    2477,
    2478,
    2479,
    2480,
    665,
    1185,
    2481,
    916,
    1521,
    2482,
    2483,
    2484,
    584,
    684,
    2485,
    2486,
    797,
    2487,
    1051,
    1186,
    2488,
    2489,
    2490,
    1522,
    2491,
    2492,
    370,
    2493,
    1039,
    1187,
    65,
    2494,
    434,
    205,
    463,
    1188,
    2495,
    125,
    812,
    391,
    402,
    826,
    699,
    286,
    398,
    155,
    781,
    771,
    585,
    2496,
    590,
    505,
    1073,
    2497,
    599,
    244,
    219,
    917,
    1018,
    952,
    646,
    1523,
    2498,
    1323,
    2499,
    2500,
    49,
    984,
    354,
    741,
    2501,
    625,
    2502,
    1324,
    2503,
    1019,
    190,
    357,
    757,
    491,
    95,
    782,
    868,
    2504,
    2505,
    2506,
    2507,
    2508,
    2509,
    134,
    1524,
    1074,
    422,
    1525,
    898,
    2510,
    161,
    2511,
    2512,
    2513,
    2514,
    769,
    2515,
    1526,
    2516,
    2517,
    411,
    1325,
    2518,
    472,
    1527,
    2519,
    2520,
    2521,
    2522,
    2523,
    2524,
    985,
    2525,
    2526,
    2527,
    2528,
    2529,
    2530,
    764,
    2531,
    1245,
    2532,
    2533,
    25,
    204,
    311,
    2534,
    496,
    2535,
    1052,
    2536,
    2537,
    2538,
    2539,
    2540,
    2541,
    2542,
    199,
    704,
    504,
    468,
    758,
    657,
    1528,
    196,
    44,
    839,
    1246,
    272,
    750,
    2543,
    765,
    862,
    2544,
    2545,
    1326,
    2546,
    132,
    615,
    933,
    2547,
    732,
    2548,
    2549,
    2550,
    1189,
    1529,
    2551,
    283,
    1247,
    1053,
    607,
    929,
    2552,
    2553,
    2554,
    930,
    183,
    872,
    616,
    1040,
    1147,
    2555,
    1148,
    1020,
    441,
    249,
    1075,
    2556,
    2557,
    2558,
    466,
    743,
    2559,
    2560,
    2561,
    92,
    514,
    426,
    420,
    526,
    2562,
    2563,
    2564,
    2565,
    2566,
    2567,
    2568,
    185,
    2569,
    2570,
    2571,
    2572,
    776,
    1530,
    658,
    2573,
    362,
    2574,
    361,
    922,
    1076,
    793,
    2575,
    2576,
    2577,
    2578,
    2579,
    2580,
    1531,
    251,
    2581,
    2582,
    2583,
    2584,
    1532,
    54,
    612,
    237,
    1327,
    2585,
    2586,
    275,
    408,
    647,
    111,
    2587,
    1533,
    1106,
    465,
    3,
    458,
    9,
    38,
    2588,
    107,
    110,
    890,
    209,
    26,
    737,
    498,
    2589,
    1534,
    2590,
    431,
    202,
    88,
    1535,
    356,
    287,
    1107,
    660,
    1149,
    2591,
    381,
    1536,
    986,
    1150,
    445,
    1248,
    1151,
    974,
    2592,
    2593,
    846,
    2594,
    446,
    953,
    184,
    1249,
    1250,
    727,
    2595,
    923,
    193,
    883,
    2596,
    2597,
    2598,
    102,
    324,
    539,
    817,
    2599,
    421,
    1041,
    2600,
    832,
    2601,
    94,
    175,
    197,
    406,
    2602,
    459,
    2603,
    2604,
    2605,
    2606,
    2607,
    330,
    555,
    2608,
    2609,
    2610,
    706,
    1108,
    389,
    2611,
    2612,
    2613,
    2614,
    233,
    2615,
    833,
    558,
    931,
    954,
    1251,
    2616,
    2617,
    1537,
    546,
    2618,
    2619,
    1009,
    2620,
    2621,
    2622,
    1538,
    690,
    1328,
    2623,
    955,
    2624,
    1539,
    2625,
    2626,
    772,
    2627,
    2628,
    2629,
    2630,
    2631,
    924,
    648,
    863,
    603,
    2632,
    2633,
    934,
    1540,
    864,
    865,
    2634,
    642,
    1042,
    670,
    1190,
    2635,
    2636,
    2637,
    2638,
    168,
    2639,
    652,
    873,
    542,
    1054,
    1541,
    2640,
    2641,
    2642,
    //Everything below is of no interest for detection purpose
    2643,
    2644,
    2645,
    2646,
    2647,
    2648,
    2649,
    2650,
    2651,
    2652,
    2653,
    2654,
    2655,
    2656,
    2657,
    2658,
    2659,
    2660,
    2661,
    2662,
    2663,
    2664,
    2665,
    2666,
    2667,
    2668,
    2669,
    2670,
    2671,
    2672,
    2673,
    2674,
    2675,
    2676,
    2677,
    2678,
    2679,
    2680,
    2681,
    2682,
    2683,
    2684,
    2685,
    2686,
    2687,
    2688,
    2689,
    2690,
    2691,
    2692,
    2693,
    2694,
    2695,
    2696,
    2697,
    2698,
    2699,
    1542,
    880,
    2700,
    2701,
    2702,
    2703,
    2704,
    2705,
    2706,
    2707,
    2708,
    2709,
    2710,
    2711,
    2712,
    2713,
    2714,
    2715,
    2716,
    2717,
    2718,
    2719,
    2720,
    2721,
    2722,
    2723,
    2724,
    2725,
    1543,
    2726,
    2727,
    2728,
    2729,
    2730,
    2731,
    2732,
    1544,
    2733,
    2734,
    2735,
    2736,
    2737,
    2738,
    2739,
    2740,
    2741,
    2742,
    2743,
    2744,
    2745,
    2746,
    2747,
    2748,
    2749,
    2750,
    2751,
    2752,
    2753,
    2754,
    1545,
    2755,
    2756,
    2757,
    2758,
    2759,
    2760,
    2761,
    2762,
    2763,
    2764,
    2765,
    2766,
    1546,
    2767,
    1547,
    2768,
    2769,
    2770,
    2771,
    2772,
    2773,
    2774,
    2775,
    2776,
    2777,
    2778,
    2779,
    2780,
    2781,
    2782,
    2783,
    2784,
    2785,
    2786,
    1548,
    2787,
    2788,
    2789,
    1109,
    2790,
    2791,
    2792,
    2793,
    2794,
    2795,
    2796,
    2797,
    2798,
    2799,
    2800,
    2801,
    2802,
    2803,
    2804,
    2805,
    2806,
    2807,
    2808,
    2809,
    2810,
    2811,
    2812,
    1329,
    2813,
    2814,
    2815,
    2816,
    2817,
    2818,
    2819,
    2820,
    2821,
    2822,
    2823,
    2824,
    2825,
    2826,
    2827,
    2828,
    2829,
    2830,
    2831,
    2832,
    2833,
    2834,
    2835,
    2836,
    2837,
    2838,
    2839,
    2840,
    2841,
    2842,
    2843,
    2844,
    2845,
    2846,
    2847,
    2848,
    2849,
    2850,
    2851,
    2852,
    2853,
    2854,
    2855,
    2856,
    1549,
    2857,
    2858,
    2859,
    2860,
    1550,
    2861,
    2862,
    1551,
    2863,
    2864,
    2865,
    2866,
    2867,
    2868,
    2869,
    2870,
    2871,
    2872,
    2873,
    2874,
    1110,
    1330,
    2875,
    2876,
    2877,
    2878,
    2879,
    2880,
    2881,
    2882,
    2883,
    2884,
    2885,
    2886,
    2887,
    2888,
    2889,
    2890,
    2891,
    2892,
    2893,
    2894,
    2895,
    2896,
    2897,
    2898,
    2899,
    2900,
    2901,
    2902,
    2903,
    2904,
    2905,
    2906,
    2907,
    2908,
    2909,
    2910,
    2911,
    2912,
    2913,
    2914,
    2915,
    2916,
    2917,
    2918,
    2919,
    2920,
    2921,
    2922,
    2923,
    2924,
    2925,
    2926,
    2927,
    2928,
    2929,
    2930,
    1331,
    2931,
    2932,
    2933,
    2934,
    2935,
    2936,
    2937,
    2938,
    2939,
    2940,
    2941,
    2942,
    2943,
    1552,
    2944,
    2945,
    2946,
    2947,
    2948,
    2949,
    2950,
    2951,
    2952,
    2953,
    2954,
    2955,
    2956,
    2957,
    2958,
    2959,
    2960,
    2961,
    2962,
    2963,
    2964,
    1252,
    2965,
    2966,
    2967,
    2968,
    2969,
    2970,
    2971,
    2972,
    2973,
    2974,
    2975,
    2976,
    2977,
    2978,
    2979,
    2980,
    2981,
    2982,
    2983,
    2984,
    2985,
    2986,
    2987,
    2988,
    2989,
    2990,
    2991,
    2992,
    2993,
    2994,
    2995,
    2996,
    2997,
    2998,
    2999,
    3000,
    3001,
    3002,
    3003,
    3004,
    3005,
    3006,
    3007,
    3008,
    3009,
    3010,
    3011,
    3012,
    1553,
    3013,
    3014,
    3015,
    3016,
    3017,
    1554,
    3018,
    1332,
    3019,
    3020,
    3021,
    3022,
    3023,
    3024,
    3025,
    3026,
    3027,
    3028,
    3029,
    3030,
    3031,
    3032,
    3033,
    3034,
    3035,
    3036,
    3037,
    3038,
    3039,
    3040,
    3041,
    3042,
    3043,
    3044,
    3045,
    3046,
    3047,
    3048,
    3049,
    3050,
    1555,
    3051,
    3052,
    3053,
    1556,
    1557,
    3054,
    3055,
    3056,
    3057,
    3058,
    3059,
    3060,
    3061,
    3062,
    3063,
    3064,
    3065,
    3066,
    3067,
    1558,
    3068,
    3069,
    3070,
    3071,
    3072,
    3073,
    3074,
    3075,
    3076,
    1559,
    3077,
    3078,
    3079,
    3080,
    3081,
    3082,
    3083,
    1253,
    3084,
    3085,
    3086,
    3087,
    3088,
    3089,
    3090,
    3091,
    3092,
    3093,
    3094,
    3095,
    3096,
    3097,
    3098,
    3099,
    3100,
    3101,
    3102,
    3103,
    3104,
    3105,
    3106,
    3107,
    3108,
    1152,
    3109,
    3110,
    3111,
    3112,
    3113,
    1560,
    3114,
    3115,
    3116,
    3117,
    1111,
    3118,
    3119,
    3120,
    3121,
    3122,
    3123,
    3124,
    3125,
    3126,
    3127,
    3128,
    3129,
    3130,
    3131,
    3132,
    3133,
    3134,
    3135,
    3136,
    3137,
    3138,
    3139,
    3140,
    3141,
    3142,
    3143,
    3144,
    3145,
    3146,
    3147,
    3148,
    3149,
    3150,
    3151,
    3152,
    3153,
    3154,
    3155,
    3156,
    3157,
    3158,
    3159,
    3160,
    3161,
    3162,
    3163,
    3164,
    3165,
    3166,
    3167,
    3168,
    3169,
    3170,
    3171,
    3172,
    3173,
    3174,
    3175,
    3176,
    1333,
    3177,
    3178,
    3179,
    3180,
    3181,
    3182,
    3183,
    3184,
    3185,
    3186,
    3187,
    3188,
    3189,
    1561,
    3190,
    3191,
    1334,
    3192,
    3193,
    3194,
    3195,
    3196,
    3197,
    3198,
    3199,
    3200,
    3201,
    3202,
    3203,
    3204,
    3205,
    3206,
    3207,
    3208,
    3209,
    3210,
    3211,
    3212,
    3213,
    3214,
    3215,
    3216,
    3217,
    3218,
    3219,
    3220,
    3221,
    3222,
    3223,
    3224,
    3225,
    3226,
    3227,
    3228,
    3229,
    3230,
    3231,
    3232,
    3233,
    3234,
    1562,
    3235,
    3236,
    3237,
    3238,
    3239,
    3240,
    3241,
    3242,
    3243,
    3244,
    3245,
    3246,
    3247,
    3248,
    3249,
    3250,
    3251,
    3252,
    3253,
    3254,
    3255,
    3256,
    3257,
    3258,
    3259,
    3260,
    3261,
    3262,
    3263,
    3264,
    3265,
    3266,
    3267,
    3268,
    3269,
    3270,
    3271,
    3272,
    3273,
    3274,
    3275,
    3276,
    3277,
    1563,
    3278,
    3279,
    3280,
    3281,
    3282,
    3283,
    3284,
    3285,
    3286,
    3287,
    3288,
    3289,
    3290,
    3291,
    3292,
    3293,
    3294,
    3295,
    3296,
    3297,
    3298,
    3299,
    3300,
    3301,
    3302,
    3303,
    3304,
    3305,
    3306,
    3307,
    3308,
    3309,
    3310,
    3311,
    3312,
    3313,
    3314,
    3315,
    3316,
    3317,
    3318,
    3319,
    3320,
    3321,
    3322,
    3323,
    3324,
    3325,
    3326,
    3327,
    3328,
    3329,
    3330,
    3331,
    3332,
    3333,
    3334,
    3335,
    3336,
    3337,
    3338,
    3339,
    3340,
    3341,
    3342,
    3343,
    3344,
    3345,
    3346,
    3347,
    3348,
    3349,
    3350,
    3351,
    3352,
    3353,
    3354,
    3355,
    3356,
    3357,
    3358,
    3359,
    3360,
    3361,
    3362,
    3363,
    3364,
    1335,
    3365,
    3366,
    3367,
    3368,
    3369,
    3370,
    3371,
    3372,
    3373,
    3374,
    3375,
    3376,
    3377,
    3378,
    3379,
    3380,
    3381,
    3382,
    3383,
    3384,
    3385,
    3386,
    3387,
    1336,
    3388,
    3389,
    3390,
    3391,
    3392,
    3393,
    3394,
    3395,
    3396,
    3397,
    3398,
    3399,
    3400,
    3401,
    3402,
    3403,
    3404,
    3405,
    3406,
    3407,
    3408,
    3409,
    3410,
    3411,
    3412,
    3413,
    3414,
    1337,
    3415,
    3416,
    3417,
    3418,
    3419,
    1338,
    3420,
    3421,
    3422,
    1564,
    1565,
    3423,
    3424,
    3425,
    3426,
    3427,
    3428,
    3429,
    3430,
    3431,
    1254,
    3432,
    3433,
    3434,
    1339,
    3435,
    3436,
    3437,
    3438,
    3439,
    1566,
    3440,
    3441,
    3442,
    3443,
    3444,
    3445,
    3446,
    3447,
    3448,
    3449,
    3450,
    3451,
    3452,
    3453,
    3454,
    1255,
    3455,
    3456,
    3457,
    3458,
    3459,
    1567,
    1191,
    3460,
    1568,
    1569,
    3461,
    3462,
    3463,
    1570,
    3464,
    3465,
    3466,
    3467,
    3468,
    1571,
    3469,
    3470,
    3471,
    3472,
    3473,
    1572,
    3474,
    3475,
    3476,
    3477,
    3478,
    3479,
    3480,
    3481,
    3482,
    3483,
    3484,
    3485,
    3486,
    1340,
    3487,
    3488,
    3489,
    3490,
    3491,
    3492,
    1021,
    3493,
    3494,
    3495,
    3496,
    3497,
    3498,
    1573,
    3499,
    1341,
    3500,
    3501,
    3502,
    3503,
    3504,
    3505,
    3506,
    3507,
    3508,
    3509,
    3510,
    3511,
    1342,
    3512,
    3513,
    3514,
    3515,
    3516,
    1574,
    1343,
    3517,
    3518,
    3519,
    1575,
    3520,
    1576,
    3521,
    3522,
    3523,
    3524,
    3525,
    3526,
    3527,
    3528,
    3529,
    3530,
    3531,
    3532,
    3533,
    3534,
    3535,
    3536,
    3537,
    3538,
    3539,
    3540,
    3541,
    3542,
    3543,
    3544,
    3545,
    3546,
    3547,
    3548,
    3549,
    3550,
    3551,
    3552,
    3553,
    3554,
    3555,
    3556,
    3557,
    3558,
    3559,
    3560,
    3561,
    3562,
    3563,
    3564,
    3565,
    3566,
    3567,
    3568,
    3569,
    3570,
    3571,
    3572,
    3573,
    3574,
    3575,
    3576,
    3577,
    3578,
    3579,
    3580,
    1577,
    3581,
    3582,
    1578,
    3583,
    3584,
    3585,
    3586,
    3587,
    3588,
    3589,
    3590,
    3591,
    3592,
    3593,
    3594,
    3595,
    3596,
    3597,
    3598,
    3599,
    3600,
    3601,
    3602,
    3603,
    3604,
    1579,
    3605,
    3606,
    3607,
    3608,
    3609,
    3610,
    3611,
    3612,
    3613,
    3614,
    3615,
    3616,
    3617,
    3618,
    3619,
    3620,
    3621,
    3622,
    3623,
    3624,
    3625,
    3626,
    3627,
    3628,
    3629,
    1580,
    3630,
    3631,
    1581,
    3632,
    3633,
    3634,
    3635,
    3636,
    3637,
    3638,
    3639,
    3640,
    3641,
    3642,
    3643,
    3644,
    3645,
    3646,
    3647,
    3648,
    3649,
    3650,
    3651,
    3652,
    3653,
    3654,
    3655,
    3656,
    1582,
    3657,
    3658,
    3659,
    3660,
    3661,
    3662,
    3663,
    3664,
    3665,
    3666,
    3667,
    3668,
    3669,
    3670,
    3671,
    3672,
    3673,
    3674,
    3675,
    3676,
    3677,
    3678,
    3679,
    3680,
    3681,
    3682,
    3683,
    3684,
    3685,
    3686,
    3687,
    3688,
    3689,
    3690,
    3691,
    3692,
    3693,
    3694,
    3695,
    3696,
    3697,
    3698,
    3699,
    3700,
    1192,
    3701,
    3702,
    3703,
    3704,
    1256,
    3705,
    3706,
    3707,
    3708,
    1583,
    1257,
    3709,
    3710,
    3711,
    3712,
    3713,
    3714,
    3715,
    3716,
    1584,
    3717,
    3718,
    3719,
    3720,
    3721,
    3722,
    3723,
    3724,
    3725,
    3726,
    3727,
    3728,
    3729,
    3730,
    3731,
    3732,
    3733,
    3734,
    3735,
    3736,
    3737,
    3738,
    3739,
    3740,
    3741,
    3742,
    3743,
    3744,
    3745,
    1344,
    3746,
    3747,
    3748,
    3749,
    3750,
    3751,
    3752,
    3753,
    3754,
    3755,
    3756,
    1585,
    3757,
    3758,
    3759,
    3760,
    3761,
    3762,
    3763,
    3764,
    3765,
    3766,
    1586,
    3767,
    3768,
    3769,
    3770,
    3771,
    3772,
    3773,
    3774,
    3775,
    3776,
    3777,
    3778,
    1345,
    3779,
    3780,
    3781,
    3782,
    3783,
    3784,
    3785,
    3786,
    3787,
    3788,
    3789,
    3790,
    3791,
    3792,
    3793,
    3794,
    3795,
    1346,
    1587,
    3796,
    3797,
    1588,
    3798,
    3799,
    3800,
    3801,
    3802,
    3803,
    3804,
    3805,
    3806,
    1347,
    3807,
    3808,
    3809,
    3810,
    3811,
    1589,
    3812,
    3813,
    3814,
    3815,
    3816,
    3817,
    3818,
    3819,
    3820,
    3821,
    1590,
    3822,
    3823,
    1591,
    1348,
    3824,
    3825,
    3826,
    3827,
    3828,
    3829,
    3830,
    1592,
    3831,
    3832,
    1593,
    3833,
    3834,
    3835,
    3836,
    3837,
    3838,
    3839,
    3840,
    3841,
    3842,
    3843,
    3844,
    1349,
    3845,
    3846,
    3847,
    3848,
    3849,
    3850,
    3851,
    3852,
    3853,
    3854,
    3855,
    3856,
    3857,
    3858,
    1594,
    3859,
    3860,
    3861,
    3862,
    3863,
    3864,
    3865,
    3866,
    3867,
    3868,
    3869,
    1595,
    3870,
    3871,
    3872,
    3873,
    1596,
    3874,
    3875,
    3876,
    3877,
    3878,
    3879,
    3880,
    3881,
    3882,
    3883,
    3884,
    3885,
    3886,
    1597,
    3887,
    3888,
    3889,
    3890,
    3891,
    3892,
    3893,
    3894,
    3895,
    1598,
    3896,
    3897,
    3898,
    1599,
    1600,
    3899,
    1350,
    3900,
    1351,
    3901,
    3902,
    1352,
    3903,
    3904,
    3905,
    3906,
    3907,
    3908,
    3909,
    3910,
    3911,
    3912,
    3913,
    3914,
    3915,
    3916,
    3917,
    3918,
    3919,
    3920,
    3921,
    3922,
    3923,
    3924,
    1258,
    3925,
    3926,
    3927,
    3928,
    3929,
    3930,
    3931,
    1193,
    3932,
    1601,
    3933,
    3934,
    3935,
    3936,
    3937,
    3938,
    3939,
    3940,
    3941,
    3942,
    3943,
    1602,
    3944,
    3945,
    3946,
    3947,
    3948,
    1603,
    3949,
    3950,
    3951,
    3952,
    3953,
    3954,
    3955,
    3956,
    3957,
    3958,
    3959,
    3960,
    3961,
    3962,
    3963,
    3964,
    3965,
    1604,
    3966,
    3967,
    3968,
    3969,
    3970,
    3971,
    3972,
    3973,
    3974,
    3975,
    3976,
    3977,
    1353,
    3978,
    3979,
    3980,
    3981,
    3982,
    3983,
    3984,
    3985,
    3986,
    3987,
    3988,
    3989,
    3990,
    3991,
    1354,
    3992,
    3993,
    3994,
    3995,
    3996,
    3997,
    3998,
    3999,
    4000,
    4001,
    4002,
    4003,
    4004,
    4005,
    4006,
    4007,
    4008,
    4009,
    4010,
    4011,
    4012,
    4013,
    4014,
    4015,
    4016,
    4017,
    4018,
    4019,
    4020,
    4021,
    4022,
    4023,
    1355,
    4024,
    4025,
    4026,
    4027,
    4028,
    4029,
    4030,
    4031,
    4032,
    4033,
    4034,
    4035,
    4036,
    4037,
    4038,
    4039,
    4040,
    1605,
    4041,
    4042,
    4043,
    4044,
    4045,
    4046,
    4047,
    4048,
    4049,
    4050,
    4051,
    4052,
    4053,
    4054,
    4055,
    4056,
    4057,
    4058,
    4059,
    4060,
    1606,
    4061,
    4062,
    4063,
    4064,
    1607,
    4065,
    4066,
    4067,
    4068,
    4069,
    4070,
    4071,
    4072,
    4073,
    4074,
    4075,
    4076,
    1194,
    4077,
    4078,
    1608,
    4079,
    4080,
    4081,
    4082,
    4083,
    4084,
    4085,
    4086,
    4087,
    1609,
    4088,
    4089,
    4090,
    4091,
    4092,
    4093,
    4094,
    4095,
    4096,
    4097,
    4098,
    4099,
    4100,
    4101,
    4102,
    4103,
    4104,
    4105,
    4106,
    4107,
    4108,
    1259,
    4109,
    4110,
    4111,
    4112,
    4113,
    4114,
    4115,
    4116,
    4117,
    4118,
    4119,
    4120,
    4121,
    4122,
    4123,
    4124,
    1195,
    4125,
    4126,
    4127,
    1610,
    4128,
    4129,
    4130,
    4131,
    4132,
    4133,
    4134,
    4135,
    4136,
    4137,
    1356,
    4138,
    4139,
    4140,
    4141,
    4142,
    4143,
    4144,
    1611,
    4145,
    4146,
    4147,
    4148,
    4149,
    4150,
    4151,
    4152,
    4153,
    4154,
    4155,
    4156,
    4157,
    4158,
    4159,
    4160,
    4161,
    4162,
    4163,
    4164,
    4165,
    4166,
    4167,
    4168,
    4169,
    4170,
    4171,
    4172,
    4173,
    4174,
    4175,
    4176,
    4177,
    4178,
    4179,
    4180,
    4181,
    4182,
    4183,
    4184,
    4185,
    4186,
    4187,
    4188,
    4189,
    4190,
    4191,
    4192,
    4193,
    4194,
    4195,
    4196,
    4197,
    4198,
    4199,
    4200,
    4201,
    4202,
    4203,
    4204,
    4205,
    4206,
    4207,
    4208,
    4209,
    4210,
    4211,
    4212,
    4213,
    4214,
    4215,
    4216,
    4217,
    4218,
    4219,
    1612,
    4220,
    4221,
    4222,
    4223,
    4224,
    4225,
    4226,
    4227,
    1357,
    4228,
    1613,
    4229,
    4230,
    4231,
    4232,
    4233,
    4234,
    4235,
    4236,
    4237,
    4238,
    4239,
    4240,
    4241,
    4242,
    4243,
    1614,
    4244,
    4245,
    4246,
    4247,
    4248,
    4249,
    4250,
    4251,
    4252,
    4253,
    4254,
    4255,
    4256,
    4257,
    4258,
    4259,
    4260,
    4261,
    4262,
    4263,
    4264,
    4265,
    4266,
    4267,
    4268,
    4269,
    4270,
    1196,
    1358,
    4271,
    4272,
    4273,
    4274,
    4275,
    4276,
    4277,
    4278,
    4279,
    4280,
    4281,
    4282,
    4283,
    4284,
    4285,
    4286,
    4287,
    1615,
    4288,
    4289,
    4290,
    4291,
    4292,
    4293,
    4294,
    4295,
    4296,
    4297,
    4298,
    4299,
    4300,
    4301,
    4302,
    4303,
    4304,
    4305,
    4306,
    4307,
    4308,
    4309,
    4310,
    4311,
    4312,
    4313,
    4314,
    4315,
    4316,
    4317,
    4318,
    4319,
    4320,
    4321,
    4322,
    4323,
    4324,
    4325,
    4326,
    4327,
    4328,
    4329,
    4330,
    4331,
    4332,
    4333,
    4334,
    1616,
    4335,
    4336,
    4337,
    4338,
    4339,
    4340,
    4341,
    4342,
    4343,
    4344,
    4345,
    4346,
    4347,
    4348,
    4349,
    4350,
    4351,
    4352,
    4353,
    4354,
    4355,
    4356,
    4357,
    4358,
    4359,
    4360,
    1617,
    4361,
    4362,
    4363,
    4364,
    4365,
    1618,
    4366,
    4367,
    4368,
    4369,
    4370,
    4371,
    4372,
    4373,
    4374,
    4375,
    4376,
    4377,
    4378,
    4379,
    4380,
    4381,
    4382,
    4383,
    4384,
    4385,
    4386,
    4387,
    4388,
    4389,
    4390,
    4391,
    4392,
    4393,
    4394,
    4395,
    4396,
    4397,
    4398,
    4399,
    4400,
    4401,
    4402,
    4403,
    4404,
    4405,
    4406,
    4407,
    4408,
    4409,
    4410,
    4411,
    4412,
    4413,
    4414,
    4415,
    4416,
    1619,
    4417,
    4418,
    4419,
    4420,
    4421,
    4422,
    4423,
    4424,
    4425,
    1112,
    4426,
    4427,
    4428,
    4429,
    4430,
    1620,
    4431,
    4432,
    4433,
    4434,
    4435,
    4436,
    4437,
    4438,
    4439,
    4440,
    4441,
    4442,
    1260,
    1261,
    4443,
    4444,
    4445,
    4446,
    4447,
    4448,
    4449,
    4450,
    4451,
    4452,
    4453,
    4454,
    4455,
    1359,
    4456,
    4457,
    4458,
    4459,
    4460,
    4461,
    4462,
    4463,
    4464,
    4465,
    1621,
    4466,
    4467,
    4468,
    4469,
    4470,
    4471,
    4472,
    4473,
    4474,
    4475,
    4476,
    4477,
    4478,
    4479,
    4480,
    4481,
    4482,
    4483,
    4484,
    4485,
    4486,
    4487,
    4488,
    4489,
    1055,
    4490,
    4491,
    4492,
    4493,
    4494,
    4495,
    4496,
    4497,
    4498,
    4499,
    4500,
    4501,
    4502,
    4503,
    4504,
    4505,
    4506,
    4507,
    4508,
    4509,
    4510,
    4511,
    4512,
    4513,
    4514,
    4515,
    4516,
    4517,
    4518,
    1622,
    4519,
    4520,
    4521,
    1623,
    4522,
    4523,
    4524,
    4525,
    4526,
    4527,
    4528,
    4529,
    4530,
    4531,
    4532,
    4533,
    4534,
    4535,
    1360,
    4536,
    4537,
    4538,
    4539,
    4540,
    4541,
    4542,
    4543,
    975,
    4544,
    4545,
    4546,
    4547,
    4548,
    4549,
    4550,
    4551,
    4552,
    4553,
    4554,
    4555,
    4556,
    4557,
    4558,
    4559,
    4560,
    4561,
    4562,
    4563,
    4564,
    4565,
    4566,
    4567,
    4568,
    4569,
    4570,
    4571,
    1624,
    4572,
    4573,
    4574,
    4575,
    4576,
    1625,
    4577,
    4578,
    4579,
    4580,
    4581,
    4582,
    4583,
    4584,
    1626,
    4585,
    4586,
    4587,
    4588,
    4589,
    4590,
    4591,
    4592,
    4593,
    4594,
    4595,
    1627,
    4596,
    4597,
    4598,
    4599,
    4600,
    4601,
    4602,
    4603,
    4604,
    4605,
    4606,
    4607,
    4608,
    4609,
    4610,
    4611,
    4612,
    4613,
    4614,
    4615,
    1628,
    4616,
    4617,
    4618,
    4619,
    4620,
    4621,
    4622,
    4623,
    4624,
    4625,
    4626,
    4627,
    4628,
    4629,
    4630,
    4631,
    4632,
    4633,
    4634,
    4635,
    4636,
    4637,
    4638,
    4639,
    4640,
    4641,
    4642,
    4643,
    4644,
    4645,
    4646,
    4647,
    4648,
    4649,
    1361,
    4650,
    4651,
    4652,
    4653,
    4654,
    4655,
    4656,
    4657,
    4658,
    4659,
    4660,
    4661,
    1362,
    4662,
    4663,
    4664,
    4665,
    4666,
    4667,
    4668,
    4669,
    4670,
    4671,
    4672,
    4673,
    4674,
    4675,
    4676,
    4677,
    4678,
    4679,
    4680,
    4681,
    4682,
    1629,
    4683,
    4684,
    4685,
    4686,
    4687,
    1630,
    4688,
    4689,
    4690,
    4691,
    1153,
    4692,
    4693,
    4694,
    1113,
    4695,
    4696,
    4697,
    4698,
    4699,
    4700,
    4701,
    4702,
    4703,
    4704,
    4705,
    4706,
    4707,
    4708,
    4709,
    4710,
    4711,
    1197,
    4712,
    4713,
    4714,
    4715,
    4716,
    4717,
    4718,
    4719,
    4720,
    4721,
    4722,
    4723,
    4724,
    4725,
    4726,
    4727,
    4728,
    4729,
    4730,
    4731,
    4732,
    4733,
    4734,
    4735,
    1631,
    4736,
    1632,
    4737,
    4738,
    4739,
    4740,
    4741,
    4742,
    4743,
    4744,
    1633,
    4745,
    4746,
    4747,
    4748,
    4749,
    1262,
    4750,
    4751,
    4752,
    4753,
    4754,
    1363,
    4755,
    4756,
    4757,
    4758,
    4759,
    4760,
    4761,
    4762,
    4763,
    4764,
    4765,
    4766,
    4767,
    4768,
    1634,
    4769,
    4770,
    4771,
    4772,
    4773,
    4774,
    4775,
    4776,
    4777,
    4778,
    1635,
    4779,
    4780,
    4781,
    4782,
    4783,
    4784,
    4785,
    4786,
    4787,
    4788,
    4789,
    1636,
    4790,
    4791,
    4792,
    4793,
    4794,
    4795,
    4796,
    4797,
    4798,
    4799,
    4800,
    4801,
    4802,
    4803,
    4804,
    4805,
    4806,
    1637,
    4807,
    4808,
    4809,
    1638,
    4810,
    4811,
    4812,
    4813,
    4814,
    4815,
    4816,
    4817,
    4818,
    1639,
    4819,
    4820,
    4821,
    4822,
    4823,
    4824,
    4825,
    4826,
    4827,
    4828,
    4829,
    4830,
    4831,
    4832,
    4833,
    1077,
    4834,
    4835,
    4836,
    4837,
    4838,
    4839,
    4840,
    4841,
    4842,
    4843,
    4844,
    4845,
    4846,
    4847,
    4848,
    4849,
    4850,
    4851,
    4852,
    4853,
    4854,
    4855,
    4856,
    4857,
    4858,
    4859,
    4860,
    4861,
    4862,
    4863,
    4864,
    4865,
    4866,
    4867,
    4868,
    4869,
    4870,
    4871,
    4872,
    4873,
    4874,
    4875,
    4876,
    4877,
    4878,
    4879,
    4880,
    4881,
    4882,
    4883,
    1640,
    4884,
    4885,
    1641,
    4886,
    4887,
    4888,
    4889,
    4890,
    4891,
    4892,
    4893,
    4894,
    4895,
    4896,
    4897,
    4898,
    4899,
    4900,
    4901,
    4902,
    4903,
    4904,
    4905,
    4906,
    4907,
    4908,
    4909,
    4910,
    4911,
    1642,
    4912,
    4913,
    4914,
    1364,
    4915,
    4916,
    4917,
    4918,
    4919,
    4920,
    4921,
    4922,
    4923,
    4924,
    4925,
    4926,
    4927,
    4928,
    4929,
    4930,
    4931,
    1643,
    4932,
    4933,
    4934,
    4935,
    4936,
    4937,
    4938,
    4939,
    4940,
    4941,
    4942,
    4943,
    4944,
    4945,
    4946,
    4947,
    4948,
    4949,
    4950,
    4951,
    4952,
    4953,
    4954,
    4955,
    4956,
    4957,
    4958,
    4959,
    4960,
    4961,
    4962,
    4963,
    4964,
    4965,
    4966,
    4967,
    4968,
    4969,
    4970,
    4971,
    4972,
    4973,
    4974,
    4975,
    4976,
    4977,
    4978,
    4979,
    4980,
    1644,
    4981,
    4982,
    4983,
    4984,
    1645,
    4985,
    4986,
    1646,
    4987,
    4988,
    4989,
    4990,
    4991,
    4992,
    4993,
    4994,
    4995,
    4996,
    4997,
    4998,
    4999,
    5000,
    5001,
    5002,
    5003,
    5004,
    5005,
    1647,
    5006,
    1648,
    5007,
    5008,
    5009,
    5010,
    5011,
    5012,
    1078,
    5013,
    5014,
    5015,
    5016,
    5017,
    5018,
    5019,
    5020,
    5021,
    5022,
    5023,
    5024,
    5025,
    5026,
    5027,
    5028,
    1365,
    5029,
    5030,
    5031,
    5032,
    5033,
    5034,
    5035,
    5036,
    5037,
    5038,
    5039,
    1649,
    5040,
    5041,
    5042,
    5043,
    5044,
    5045,
    1366,
    5046,
    5047,
    5048,
    5049,
    5050,
    5051,
    5052,
    5053,
    5054,
    5055,
    1650,
    5056,
    5057,
    5058,
    5059,
    5060,
    5061,
    5062,
    5063,
    5064,
    5065,
    5066,
    5067,
    5068,
    5069,
    5070,
    5071,
    5072,
    5073,
    5074,
    5075,
    5076,
    5077,
    1651,
    5078,
    5079,
    5080,
    5081,
    5082,
    5083,
    5084,
    5085,
    5086,
    5087,
    5088,
    5089,
    5090,
    5091,
    5092,
    5093,
    5094,
    5095,
    5096,
    5097,
    5098,
    5099,
    5100,
    5101,
    5102,
    5103,
    5104,
    5105,
    5106,
    5107,
    5108,
    5109,
    5110,
    1652,
    5111,
    5112,
    5113,
    5114,
    5115,
    5116,
    5117,
    5118,
    1367,
    5119,
    5120,
    5121,
    5122,
    5123,
    5124,
    5125,
    5126,
    5127,
    5128,
    5129,
    1653,
    5130,
    5131,
    5132,
    5133,
    5134,
    5135,
    5136,
    5137,
    5138,
    5139,
    5140,
    5141,
    5142,
    5143,
    5144,
    5145,
    5146,
    5147,
    5148,
    5149,
    1368,
    5150,
    1654,
    5151,
    1369,
    5152,
    5153,
    5154,
    5155,
    5156,
    5157,
    5158,
    5159,
    5160,
    5161,
    5162,
    5163,
    5164,
    5165,
    5166,
    5167,
    5168,
    5169,
    5170,
    5171,
    5172,
    5173,
    5174,
    5175,
    5176,
    5177,
    5178,
    1370,
    5179,
    5180,
    5181,
    5182,
    5183,
    5184,
    5185,
    5186,
    5187,
    5188,
    5189,
    5190,
    5191,
    5192,
    5193,
    5194,
    5195,
    5196,
    5197,
    5198,
    1655,
    5199,
    5200,
    5201,
    5202,
    1656,
    5203,
    5204,
    5205,
    5206,
    1371,
    5207,
    1372,
    5208,
    5209,
    5210,
    5211,
    1373,
    5212,
    5213,
    1374,
    5214,
    5215,
    5216,
    5217,
    5218,
    5219,
    5220,
    5221,
    5222,
    5223,
    5224,
    5225,
    5226,
    5227,
    5228,
    5229,
    5230,
    5231,
    5232,
    5233,
    5234,
    5235,
    5236,
    5237,
    5238,
    5239,
    5240,
    5241,
    5242,
    5243,
    5244,
    5245,
    5246,
    5247,
    1657,
    5248,
    5249,
    5250,
    5251,
    1658,
    1263,
    5252,
    5253,
    5254,
    5255,
    5256,
    1375,
    5257,
    5258,
    5259,
    5260,
    5261,
    5262,
    5263,
    5264,
    5265,
    5266,
    5267,
    5268,
    5269,
    5270,
    5271,
    5272,
    5273,
    5274,
    5275,
    5276,
    5277,
    5278,
    5279,
    5280,
    5281,
    5282,
    5283,
    1659,
    5284,
    5285,
    5286,
    5287,
    5288,
    5289,
    5290,
    5291,
    5292,
    5293,
    5294,
    5295,
    5296,
    5297,
    5298,
    5299,
    5300,
    1660,
    5301,
    5302,
    5303,
    5304,
    5305,
    5306,
    5307,
    5308,
    5309,
    5310,
    5311,
    5312,
    5313,
    5314,
    5315,
    5316,
    5317,
    5318,
    5319,
    5320,
    5321,
    1376,
    5322,
    5323,
    5324,
    5325,
    5326,
    5327,
    5328,
    5329,
    5330,
    5331,
    5332,
    5333,
    1198,
    5334,
    5335,
    5336,
    5337,
    5338,
    5339,
    5340,
    5341,
    5342,
    5343,
    1661,
    5344,
    5345,
    5346,
    5347,
    5348,
    5349,
    5350,
    5351,
    5352,
    5353,
    5354,
    5355,
    5356,
    5357,
    5358,
    5359,
    5360,
    5361,
    5362,
    5363,
    5364,
    5365,
    5366,
    5367,
    5368,
    5369,
    5370,
    5371,
    5372,
    5373,
    5374,
    5375,
    5376,
    5377,
    5378,
    5379,
    5380,
    5381,
    5382,
    5383,
    5384,
    5385,
    5386,
    5387,
    5388,
    5389,
    5390,
    5391,
    5392,
    5393,
    5394,
    5395,
    5396,
    5397,
    5398,
    1264,
    5399,
    5400,
    5401,
    5402,
    5403,
    5404,
    5405,
    5406,
    5407,
    5408,
    5409,
    5410,
    5411,
    5412,
    1662,
    5413,
    5414,
    5415,
    5416,
    1663,
    5417,
    5418,
    5419,
    5420,
    5421,
    5422,
    5423,
    5424,
    5425,
    5426,
    5427,
    5428,
    5429,
    5430,
    5431,
    5432,
    5433,
    5434,
    5435,
    5436,
    5437,
    5438,
    1664,
    5439,
    5440,
    5441,
    5442,
    5443,
    5444,
    5445,
    5446,
    5447,
    5448,
    5449,
    5450,
    5451,
    5452,
    5453,
    5454,
    5455,
    5456,
    5457,
    5458,
    5459,
    5460,
    5461,
    5462,
    5463,
    5464,
    5465,
    5466,
    5467,
    5468,
    5469,
    5470,
    5471,
    5472,
    5473,
    5474,
    5475,
    5476,
    5477,
    5478,
    1154,
    5479,
    5480,
    5481,
    5482,
    5483,
    5484,
    5485,
    1665,
    5486,
    5487,
    5488,
    5489,
    5490,
    5491,
    5492,
    5493,
    5494,
    5495,
    5496,
    5497,
    5498,
    5499,
    5500,
    5501,
    5502,
    5503,
    5504,
    5505,
    5506,
    5507,
    5508,
    5509,
    5510,
    5511,
    5512,
    5513,
    5514,
    5515,
    5516,
    5517,
    5518,
    5519,
    5520,
    5521,
    5522,
    5523,
    5524,
    5525,
    5526,
    5527,
    5528,
    5529,
    5530,
    5531,
    5532,
    5533,
    5534,
    5535,
    5536,
    5537,
    5538,
    5539,
    5540,
    5541,
    5542,
    5543,
    5544,
    5545,
    5546,
    5547,
    5548,
    1377,
    5549,
    5550,
    5551,
    5552,
    5553,
    5554,
    5555,
    5556,
    5557,
    5558,
    5559,
    5560,
    5561,
    5562,
    5563,
    5564,
    5565,
    5566,
    5567,
    5568,
    5569,
    5570,
    1114,
    5571,
    5572,
    5573,
    5574,
    5575,
    5576,
    5577,
    5578,
    5579,
    5580,
    5581,
    5582,
    5583,
    5584,
    5585,
    5586,
    5587,
    5588,
    5589,
    5590,
    5591,
    5592,
    1378,
    5593,
    5594,
    5595,
    5596,
    5597,
    5598,
    5599,
    5600,
    5601,
    5602,
    5603,
    5604,
    5605,
    5606,
    5607,
    5608,
    5609,
    5610,
    5611,
    5612,
    5613,
    5614,
    1379,
    5615,
    5616,
    5617,
    5618,
    5619,
    5620,
    5621,
    5622,
    5623,
    5624,
    5625,
    5626,
    5627,
    5628,
    5629,
    5630,
    5631,
    5632,
    5633,
    5634,
    1380,
    5635,
    5636,
    5637,
    5638,
    5639,
    5640,
    5641,
    5642,
    5643,
    5644,
    5645,
    5646,
    5647,
    5648,
    5649,
    1381,
    1056,
    5650,
    5651,
    5652,
    5653,
    5654,
    5655,
    5656,
    5657,
    5658,
    5659,
    5660,
    1666,
    5661,
    5662,
    5663,
    5664,
    5665,
    5666,
    5667,
    5668,
    1667,
    5669,
    1668,
    5670,
    5671,
    5672,
    5673,
    5674,
    5675,
    5676,
    5677,
    5678,
    1155,
    5679,
    5680,
    5681,
    5682,
    5683,
    5684,
    5685,
    5686,
    5687,
    5688,
    5689,
    5690,
    5691,
    5692,
    5693,
    5694,
    5695,
    5696,
    5697,
    5698,
    1669,
    5699,
    5700,
    5701,
    5702,
    5703,
    5704,
    5705,
    1670,
    5706,
    5707,
    5708,
    5709,
    5710,
    1671,
    5711,
    5712,
    5713,
    5714,
    1382,
    5715,
    5716,
    5717,
    5718,
    5719,
    5720,
    5721,
    5722,
    5723,
    5724,
    5725,
    1672,
    5726,
    5727,
    1673,
    1674,
    5728,
    5729,
    5730,
    5731,
    5732,
    5733,
    5734,
    5735,
    5736,
    1675,
    5737,
    5738,
    5739,
    5740,
    5741,
    5742,
    5743,
    5744,
    1676,
    5745,
    5746,
    5747,
    5748,
    5749,
    5750,
    5751,
    1383,
    5752,
    5753,
    5754,
    5755,
    5756,
    5757,
    5758,
    5759,
    5760,
    5761,
    5762,
    5763,
    5764,
    5765,
    5766,
    5767,
    5768,
    1677,
    5769,
    5770,
    5771,
    5772,
    5773,
    1678,
    5774,
    5775,
    5776,
    998,
    5777,
    5778,
    5779,
    5780,
    5781,
    5782,
    5783,
    5784,
    5785,
    1384,
    5786,
    5787,
    5788,
    5789,
    5790,
    5791,
    5792,
    5793,
    5794,
    5795,
    5796,
    5797,
    5798,
    5799,
    5800,
    1679,
    5801,
    5802,
    5803,
    1115,
    1116,
    5804,
    5805,
    5806,
    5807,
    5808,
    5809,
    5810,
    5811,
    5812,
    5813,
    5814,
    5815,
    5816,
    5817,
    5818,
    5819,
    5820,
    5821,
    5822,
    5823,
    5824,
    5825,
    5826,
    5827,
    5828,
    5829,
    5830,
    5831,
    5832,
    5833,
    5834,
    5835,
    5836,
    5837,
    5838,
    5839,
    5840,
    5841,
    5842,
    5843,
    5844,
    5845,
    5846,
    5847,
    5848,
    5849,
    5850,
    5851,
    5852,
    5853,
    5854,
    5855,
    1680,
    5856,
    5857,
    5858,
    5859,
    5860,
    5861,
    5862,
    5863,
    5864,
    1681,
    5865,
    5866,
    5867,
    1682,
    5868,
    5869,
    5870,
    5871,
    5872,
    5873,
    5874,
    5875,
    5876,
    5877,
    5878,
    5879,
    1683,
    5880,
    1684,
    5881,
    5882,
    5883,
    5884,
    1685,
    5885,
    5886,
    5887,
    5888,
    5889,
    5890,
    5891,
    5892,
    5893,
    5894,
    5895,
    5896,
    5897,
    5898,
    5899,
    5900,
    5901,
    5902,
    5903,
    5904,
    5905,
    5906,
    5907,
    1686,
    5908,
    5909,
    5910,
    5911,
    5912,
    5913,
    5914,
    5915,
    5916,
    5917,
    5918,
    5919,
    5920,
    5921,
    5922,
    5923,
    5924,
    5925,
    5926,
    5927,
    5928,
    5929,
    5930,
    5931,
    5932,
    5933,
    5934,
    5935,
    1687,
    5936,
    5937,
    5938,
    5939,
    5940,
    5941,
    5942,
    5943,
    5944,
    5945,
    5946,
    5947,
    5948,
    5949,
    5950,
    5951,
    5952,
    1688,
    1689,
    5953,
    1199,
    5954,
    5955,
    5956,
    5957,
    5958,
    5959,
    5960,
    5961,
    1690,
    5962,
    5963,
    5964,
    5965,
    5966,
    5967,
    5968,
    5969,
    5970,
    5971,
    5972,
    5973,
    5974,
    5975,
    5976,
    5977,
    5978,
    5979,
    5980,
    5981,
    1385,
    5982,
    1386,
    5983,
    5984,
    5985,
    5986,
    5987,
    5988,
    5989,
    5990,
    5991,
    5992,
    5993,
    5994,
    5995,
    5996,
    5997,
    5998,
    5999,
    6000,
    6001,
    6002,
    6003,
    6004,
    6005,
    6006,
    6007,
    6008,
    6009,
    6010,
    6011,
    6012,
    6013,
    6014,
    6015,
    6016,
    6017,
    6018,
    6019,
    6020,
    6021,
    6022,
    6023,
    6024,
    6025,
    6026,
    6027,
    1265,
    6028,
    6029,
    1691,
    6030,
    6031,
    6032,
    6033,
    6034,
    6035,
    6036,
    6037,
    6038,
    6039,
    6040,
    6041,
    6042,
    6043,
    6044,
    6045,
    6046,
    6047,
    6048,
    6049,
    6050,
    6051,
    6052,
    6053,
    6054,
    6055,
    6056,
    6057,
    6058,
    6059,
    6060,
    6061,
    6062,
    6063,
    6064,
    6065,
    6066,
    6067,
    6068,
    6069,
    6070,
    6071,
    6072,
    6073,
    6074,
    6075,
    6076,
    6077,
    6078,
    6079,
    6080,
    6081,
    6082,
    6083,
    6084,
    1692,
    6085,
    6086,
    6087,
    6088,
    6089,
    6090,
    6091,
    6092,
    6093,
    6094,
    6095,
    6096,
    6097,
    6098,
    6099,
    6100,
    6101,
    6102,
    6103,
    6104,
    6105,
    6106,
    6107,
    6108,
    6109,
    6110,
    6111,
    6112,
    6113,
    6114,
    6115,
    6116,
    6117,
    6118,
    6119,
    6120,
    6121,
    6122,
    6123,
    6124,
    6125,
    6126,
    6127,
    6128,
    6129,
    6130,
    6131,
    1693,
    6132,
    6133,
    6134,
    6135,
    6136,
    1694,
    6137,
    6138,
    6139,
    6140,
    6141,
    1695,
    6142,
    6143,
    6144,
    6145,
    6146,
    6147,
    6148,
    6149,
    6150,
    6151,
    6152,
    6153,
    6154,
    6155,
    6156,
    6157,
    6158,
    6159,
    6160,
    6161,
    6162,
    6163,
    6164,
    6165,
    6166,
    6167,
    6168,
    6169,
    6170,
    6171,
    6172,
    6173,
    6174,
    6175,
    6176,
    6177,
    6178,
    6179,
    6180,
    6181,
    6182,
    6183,
    6184,
    6185,
    1696,
    6186,
    6187,
    6188,
    6189,
    6190,
    6191,
    6192,
    6193,
    6194,
    6195,
    6196,
    6197,
    6198,
    6199,
    6200,
    6201,
    6202,
    6203,
    6204,
    6205,
    6206,
    6207,
    6208,
    6209,
    6210,
    6211,
    6212,
    6213,
    6214,
    6215,
    6216,
    6217,
    6218,
    6219,
    1697,
    6220,
    6221,
    6222,
    6223,
    6224,
    6225,
    6226,
    6227,
    6228,
    6229,
    6230,
    6231,
    6232,
    6233,
    6234,
    6235,
    6236,
    6237,
    6238,
    6239,
    6240,
    6241,
    6242,
    6243,
    6244,
    6245,
    6246,
    6247,
    6248,
    6249,
    6250,
    6251,
    6252,
    6253,
    1698,
    6254,
    6255,
    6256,
    6257,
    6258,
    6259,
    6260,
    6261,
    6262,
    6263,
    1200,
    6264,
    6265,
    6266,
    6267,
    6268,
    6269,
    6270,
    6271,
    6272,
    6273,
    6274,
    6275,
    6276,
    6277,
    6278,
    6279,
    6280,
    6281,
    6282,
    6283,
    6284,
    6285,
    6286,
    6287,
    6288,
    6289,
    6290,
    6291,
    6292,
    6293,
    6294,
    6295,
    6296,
    6297,
    6298,
    6299,
    6300,
    6301,
    6302,
    1699,
    6303,
    6304,
    1700,
    6305,
    6306,
    6307,
    6308,
    6309,
    6310,
    6311,
    6312,
    6313,
    6314,
    6315,
    6316,
    6317,
    6318,
    6319,
    6320,
    6321,
    6322,
    6323,
    6324,
    6325,
    6326,
    6327,
    6328,
    6329,
    6330,
    6331,
    6332,
    6333,
    6334,
    6335,
    6336,
    6337,
    6338,
    6339,
    1701,
    6340,
    6341,
    6342,
    6343,
    6344,
    1387,
    6345,
    6346,
    6347,
    6348,
    6349,
    6350,
    6351,
    6352,
    6353,
    6354,
    6355,
    6356,
    6357,
    6358,
    6359,
    6360,
    6361,
    6362,
    6363,
    6364,
    6365,
    6366,
    6367,
    6368,
    6369,
    6370,
    6371,
    6372,
    6373,
    6374,
    6375,
    6376,
    6377,
    6378,
    6379,
    6380,
    6381,
    6382,
    6383,
    6384,
    6385,
    6386,
    6387,
    6388,
    6389,
    6390,
    6391,
    6392,
    6393,
    6394,
    6395,
    6396,
    6397,
    6398,
    6399,
    6400,
    6401,
    6402,
    6403,
    6404,
    6405,
    6406,
    6407,
    6408,
    6409,
    6410,
    6411,
    6412,
    6413,
    1702,
    6414,
    6415,
    6416,
    6417,
    6418,
    6419,
    6420,
    6421,
    6422,
    1703,
    6423,
    6424,
    6425,
    6426,
    6427,
    6428,
    6429,
    6430,
    6431,
    6432,
    6433,
    6434,
    6435,
    6436,
    6437,
    6438,
    1704,
    6439,
    6440,
    6441,
    6442,
    6443,
    6444,
    6445,
    6446,
    6447,
    6448,
    6449,
    6450,
    6451,
    6452,
    6453,
    6454,
    6455,
    6456,
    6457,
    6458,
    6459,
    6460,
    6461,
    6462,
    6463,
    6464,
    6465,
    6466,
    6467,
    6468,
    6469,
    6470,
    6471,
    6472,
    6473,
    6474,
    6475,
    6476,
    6477,
    6478,
    6479,
    6480,
    6481,
    6482,
    6483,
    6484,
    6485,
    6486,
    6487,
    6488,
    6489,
    6490,
    6491,
    6492,
    6493,
    6494,
    6495,
    6496,
    6497,
    6498,
    6499,
    6500,
    6501,
    6502,
    6503,
    1266,
    6504,
    6505,
    6506,
    6507,
    6508,
    6509,
    6510,
    6511,
    6512,
    6513,
    6514,
    6515,
    6516,
    6517,
    6518,
    6519,
    6520,
    6521,
    6522,
    6523,
    6524,
    6525,
    6526,
    6527,
    6528,
    6529,
    6530,
    6531,
    6532,
    6533,
    6534,
    6535,
    6536,
    6537,
    6538,
    6539,
    6540,
    6541,
    6542,
    6543,
    6544,
    6545,
    6546,
    6547,
    6548,
    6549,
    6550,
    6551,
    1705,
    1706,
    6552,
    6553,
    6554,
    6555,
    6556,
    6557,
    6558,
    6559,
    6560,
    6561,
    6562,
    6563,
    6564,
    6565,
    6566,
    6567,
    6568,
    6569,
    6570,
    6571,
    6572,
    6573,
    6574,
    6575,
    6576,
    6577,
    6578,
    6579,
    6580,
    6581,
    6582,
    6583,
    6584,
    6585,
    6586,
    6587,
    6588,
    6589,
    6590,
    6591,
    6592,
    6593,
    6594,
    6595,
    6596,
    6597,
    6598,
    6599,
    6600,
    6601,
    6602,
    6603,
    6604,
    6605,
    6606,
    6607,
    6608,
    6609,
    6610,
    6611,
    6612,
    6613,
    6614,
    6615,
    6616,
    6617,
    6618,
    6619,
    6620,
    6621,
    6622,
    6623,
    6624,
    6625,
    6626,
    6627,
    6628,
    6629,
    6630,
    6631,
    6632,
    6633,
    6634,
    6635,
    6636,
    6637,
    1388,
    6638,
    6639,
    6640,
    6641,
    6642,
    6643,
    6644,
    1707,
    6645,
    6646,
    6647,
    6648,
    6649,
    6650,
    6651,
    6652,
    6653,
    6654,
    6655,
    6656,
    6657,
    6658,
    6659,
    6660,
    6661,
    6662,
    6663,
    1708,
    6664,
    6665,
    6666,
    6667,
    6668,
    6669,
    6670,
    6671,
    6672,
    6673,
    6674,
    1201,
    6675,
    6676,
    6677,
    6678,
    6679,
    6680,
    6681,
    6682,
    6683,
    6684,
    6685,
    6686,
    6687,
    6688,
    6689,
    6690,
    6691,
    6692,
    6693,
    6694,
    6695,
    6696,
    6697,
    6698,
    6699,
    6700,
    6701,
    6702,
    6703,
    6704,
    6705,
    6706,
    6707,
    6708,
    6709,
    6710,
    6711,
    6712,
    6713,
    6714,
    6715,
    6716,
    6717,
    6718,
    6719,
    6720,
    6721,
    6722,
    6723,
    6724,
    6725,
    1389,
    6726,
    6727,
    6728,
    6729,
    6730,
    6731,
    6732,
    6733,
    6734,
    6735,
    6736,
    1390,
    1709,
    6737,
    6738,
    6739,
    6740,
    6741,
    6742,
    1710,
    6743,
    6744,
    6745,
    6746,
    1391,
    6747,
    6748,
    6749,
    6750,
    6751,
    6752,
    6753,
    6754,
    6755,
    6756,
    6757,
    1392,
    6758,
    6759,
    6760,
    6761,
    6762,
    6763,
    6764,
    6765,
    6766,
    6767,
    6768,
    6769,
    6770,
    6771,
    6772,
    6773,
    6774,
    6775,
    6776,
    6777,
    6778,
    6779,
    6780,
    1202,
    6781,
    6782,
    6783,
    6784,
    6785,
    6786,
    6787,
    6788,
    6789,
    6790,
    6791,
    6792,
    6793,
    6794,
    6795,
    6796,
    6797,
    6798,
    6799,
    6800,
    6801,
    6802,
    6803,
    6804,
    6805,
    6806,
    6807,
    6808,
    6809,
    1711,
    6810,
    6811,
    6812,
    6813,
    6814,
    6815,
    6816,
    6817,
    6818,
    6819,
    6820,
    6821,
    6822,
    6823,
    6824,
    6825,
    6826,
    6827,
    6828,
    6829,
    6830,
    6831,
    6832,
    6833,
    6834,
    6835,
    6836,
    1393,
    6837,
    6838,
    6839,
    6840,
    6841,
    6842,
    6843,
    6844,
    6845,
    6846,
    6847,
    6848,
    6849,
    6850,
    6851,
    6852,
    6853,
    6854,
    6855,
    6856,
    6857,
    6858,
    6859,
    6860,
    6861,
    6862,
    6863,
    6864,
    6865,
    6866,
    6867,
    6868,
    6869,
    6870,
    6871,
    6872,
    6873,
    6874,
    6875,
    6876,
    6877,
    6878,
    6879,
    6880,
    6881,
    6882,
    6883,
    6884,
    6885,
    6886,
    6887,
    6888,
    6889,
    6890,
    6891,
    6892,
    6893,
    6894,
    6895,
    6896,
    6897,
    6898,
    6899,
    6900,
    6901,
    6902,
    1712,
    6903,
    6904,
    6905,
    6906,
    6907,
    6908,
    6909,
    6910,
    1713,
    6911,
    6912,
    6913,
    6914,
    6915,
    6916,
    6917,
    6918,
    6919,
    6920,
    6921,
    6922,
    6923,
    6924,
    6925,
    6926,
    6927,
    6928,
    6929,
    6930,
    6931,
    6932,
    6933,
    6934,
    6935,
    6936,
    6937,
    6938,
    6939,
    6940,
    6941,
    6942,
    6943,
    6944,
    6945,
    6946,
    6947,
    6948,
    6949,
    6950,
    6951,
    6952,
    6953,
    6954,
    6955,
    6956,
    6957,
    6958,
    6959,
    6960,
    6961,
    6962,
    6963,
    6964,
    6965,
    6966,
    6967,
    6968,
    6969,
    6970,
    6971,
    6972,
    6973,
    6974,
    1714,
    6975,
    6976,
    6977,
    6978,
    6979,
    6980,
    6981,
    6982,
    6983,
    6984,
    6985,
    6986,
    6987,
    6988,
    1394,
    6989,
    6990,
    6991,
    6992,
    6993,
    6994,
    6995,
    6996,
    6997,
    6998,
    6999,
    7000,
    1715,
    7001,
    7002,
    7003,
    7004,
    7005,
    7006,
    7007,
    7008,
    7009,
    7010,
    7011,
    7012,
    7013,
    7014,
    7015,
    7016,
    7017,
    7018,
    7019,
    7020,
    7021,
    7022,
    7023,
    7024,
    7025,
    7026,
    7027,
    7028,
    1716,
    7029,
    7030,
    7031,
    7032,
    7033,
    7034,
    7035,
    7036,
    7037,
    7038,
    7039,
    7040,
    7041,
    7042,
    7043,
    7044,
    7045,
    7046,
    7047,
    7048,
    7049,
    7050,
    7051,
    7052,
    7053,
    7054,
    7055,
    7056,
    7057,
    7058,
    7059,
    7060,
    7061,
    7062,
    7063,
    7064,
    7065,
    7066,
    7067,
    7068,
    7069,
    7070,
    7071,
    7072,
    7073,
    7074,
    7075,
    7076,
    7077,
    7078,
    7079,
    7080,
    7081,
    7082,
    7083,
    7084,
    7085,
    7086,
    7087,
    7088,
    7089,
    7090,
    7091,
    7092,
    7093,
    7094,
    7095,
    7096,
    7097,
    7098,
    7099,
    7100,
    7101,
    7102,
    7103,
    7104,
    7105,
    7106,
    7107,
    7108,
    7109,
    7110,
    7111,
    7112,
    7113,
    7114,
    7115,
    7116,
    7117,
    7118,
    7119,
    7120,
    7121,
    7122,
    7123,
    7124,
    7125,
    7126,
    7127,
    7128,
    7129,
    7130,
    7131,
    7132,
    7133,
    7134,
    7135,
    7136,
    7137,
    7138,
    7139,
    7140,
    7141,
    7142,
    7143,
    7144,
    7145,
    7146,
    7147,
    7148,
    7149,
    7150,
    7151,
    7152,
    7153,
    7154,
    7155,
    7156,
    7157,
    7158,
    7159,
    7160,
    7161,
    7162,
    7163,
    7164,
    7165,
    7166,
    7167,
    7168,
    7169,
    7170,
    7171,
    7172,
    7173,
    7174,
    7175,
    7176,
    7177,
    7178,
    7179,
    7180,
    7181,
    7182,
    7183,
    7184,
    7185,
    7186,
    7187,
    7188,
    7189,
    7190,
    7191,
    7192,
    7193,
    7194,
    7195,
    7196,
    7197,
    7198,
    7199,
    7200,
    7201,
    7202,
    7203,
    7204,
    7205,
    7206,
    7207,
    1395,
    7208,
    7209,
    7210,
    7211,
    7212,
    7213,
    1717,
    7214,
    7215,
    7216,
    7217,
    7218,
    7219,
    7220,
    7221,
    7222,
    7223,
    7224,
    7225,
    7226,
    7227,
    7228,
    7229,
    7230,
    7231,
    7232,
    7233,
    7234,
    7235,
    7236,
    7237,
    7238,
    7239,
    7240,
    7241,
    7242,
    7243,
    7244,
    7245,
    7246,
    7247,
    7248,
    7249,
    7250,
    7251,
    7252,
    7253,
    7254,
    7255,
    7256,
    7257,
    7258,
    7259,
    7260,
    7261,
    7262,
    7263,
    7264,
    7265,
    7266,
    7267,
    7268,
    7269,
    7270,
    7271,
    7272,
    7273,
    7274,
    7275,
    7276,
    7277,
    7278,
    7279,
    7280,
    7281,
    7282,
    7283,
    7284,
    7285,
    7286,
    7287,
    7288,
    7289,
    7290,
    7291,
    7292,
    7293,
    7294,
    7295,
    7296,
    7297,
    7298,
    7299,
    7300,
    7301,
    7302,
    7303,
    7304,
    7305,
    7306,
    7307,
    7308,
    7309,
    7310,
    7311,
    7312,
    7313,
    1718,
    7314,
    7315,
    7316,
    7317,
    7318,
    7319,
    7320,
    7321,
    7322,
    7323,
    7324,
    7325,
    7326,
    7327,
    7328,
    7329,
    7330,
    7331,
    7332,
    7333,
    7334,
    7335,
    7336,
    7337,
    7338,
    7339,
    7340,
    7341,
    7342,
    7343,
    7344,
    7345,
    7346,
    7347,
    7348,
    7349,
    7350,
    7351,
    7352,
    7353,
    7354,
    7355,
    7356,
    7357,
    7358,
    7359,
    7360,
    7361,
    7362,
    7363,
    7364,
    7365,
    7366,
    7367,
    7368,
    7369,
    7370,
    7371,
    7372,
    7373,
    7374,
    7375,
    7376,
    7377,
    7378,
    7379,
    7380,
    7381,
    7382,
    7383,
    7384,
    7385,
    7386,
    7387,
    7388,
    7389,
    7390,
    7391,
    7392,
    7393,
    7394,
    7395,
    7396,
    7397,
    7398,
    7399,
    7400,
    7401,
    7402,
    7403,
    7404,
    7405,
    7406,
    7407,
    7408,
    7409,
    7410,
    7411,
    7412,
    7413,
    7414,
    7415,
    7416,
    7417,
    7418,
    7419,
    7420,
    7421,
    7422,
    7423,
    7424,
    7425,
    7426,
    7427,
    7428,
    7429,
    7430,
    7431,
    7432,
    7433,
    7434,
    7435,
    7436,
    7437,
    7438,
    7439,
    7440,
    7441,
    7442,
    7443,
    7444,
    7445,
    7446,
    7447,
    7448,
    7449,
    7450,
    7451,
    7452,
    7453,
    7454,
    7455,
    7456,
    7457,
    7458,
    7459,
    7460,
    7461,
    7462,
    7463,
    7464,
    7465,
    7466,
    7467,
    7468,
    7469,
    7470,
    7471,
    7472,
    7473,
    7474,
    7475,
    7476,
    7477,
    7478,
    7479,
    7480,
    7481,
    7482,
    7483,
    7484,
    7485,
    7486,
    7487,
    7488,
    7489,
    7490,
    7491,
    7492,
    7493,
    7494,
    7495,
    7496,
    7497,
    7498,
    7499,
    7500,
    7501,
    7502,
    7503,
    7504,
    7505,
    7506,
    7507,
    7508,
    7509,
    7510,
    7511,
    7512,
    7513,
    7514,
    7515,
    7516,
    7517,
    7518,
    7519,
    7520,
    7521,
    7522,
    7523,
    7524,
    7525,
    7526,
    7527,
    7528,
    7529,
    7530,
    7531,
    7532,
    7533,
    7534,
    7535,
    7536,
    7537,
    7538,
    7539,
    7540,
    7541,
    7542,
    7543,
    7544,
    7545,
    7546,
    7547,
    7548,
    7549,
    7550,
    7551,
    7552,
    7553,
    7554,
    7555,
    7556,
    7557,
    7558,
    7559,
    7560,
    7561,
    7562,
    7563,
    7564,
    7565,
    7566,
    7567,
    7568,
    7569,
    7570,
    7571,
    7572,
    7573,
    7574,
    7575,
    7576,
    7577,
    7578,
    7579,
    7580,
    7581,
    7582,
    7583,
    7584,
    7585,
    7586,
    7587,
    7588,
    7589,
    7590,
    7591,
    7592,
    7593,
    7594,
    7595,
    7596,
    7597,
    7598,
    7599,
    7600,
    7601,
    7602,
    7603,
    7604,
    7605,
    7606,
    7607,
    7608,
    7609,
    7610,
    7611,
    7612,
    7613,
    7614,
    7615,
    7616,
    7617,
    7618,
    7619,
    7620,
    7621,
    7622,
    7623,
    7624,
    7625,
    7626,
    7627,
    7628,
    7629,
    7630,
    7631,
    7632,
    7633,
    7634,
    7635,
    7636,
    7637,
    7638,
    7639,
    7640,
    7641,
    7642,
    7643,
    7644,
    7645,
    7646,
    7647,
    7648,
    7649,
    7650,
    7651,
    7652,
    7653,
    7654,
    7655,
    7656,
    7657,
    7658,
    7659,
    7660,
    7661,
    7662,
    7663,
    7664,
    7665,
    7666,
    7667,
    7668,
    7669,
    7670,
    7671,
    7672,
    7673,
    7674,
    7675,
    7676,
    7677,
    7678,
    7679,
    7680,
    7681,
    7682,
    7683,
    7684,
    7685,
    7686,
    7687,
    7688,
    7689,
    7690,
    7691,
    7692,
    7693,
    7694,
    7695,
    7696,
    7697,
    7698,
    7699,
    7700,
    7701,
    7702,
    7703,
    7704,
    7705,
    7706,
    7707,
    7708,
    7709,
    7710,
    7711,
    7712,
    7713,
    7714,
    7715,
    7716,
    7717,
    7718,
    7719,
    7720,
    7721,
    7722,
    7723,
    7724,
    7725,
    7726,
    7727,
    7728,
    7729,
    7730,
    7731,
    7732,
    7733,
    7734,
    7735,
    7736,
    7737,
    7738,
    7739,
    7740,
    7741,
    7742,
    7743,
    7744,
    7745,
    7746,
    7747,
    7748,
    7749,
    7750,
    7751,
    7752,
    7753,
    7754,
    7755,
    7756,
    7757,
    7758,
    7759,
    7760,
    7761,
    7762,
    7763,
    7764,
    7765,
    7766,
    7767,
    7768,
    7769,
    7770,
    7771,
    7772,
    7773,
    7774,
    7775,
    7776,
    7777,
    7778,
    7779,
    7780,
    7781,
    7782,
    7783,
    7784,
    7785,
    7786,
    7787,
    7788,
    7789,
    7790,
    7791,
    7792,
    7793,
    7794,
    7795,
    7796,
    7797,
    7798,
    7799,
    7800,
    7801,
    7802,
    7803,
    7804,
    7805,
    7806,
    7807,
    7808,
    7809,
    7810,
    7811,
    7812,
    7813,
    7814,
    7815,
    7816,
    7817,
    7818,
    7819,
    7820,
    7821,
    7822,
    7823,
    7824,
    7825,
    7826,
    7827,
    7828,
    7829,
    7830,
    7831,
    7832,
    7833,
    7834,
    7835,
    7836,
    7837,
    7838,
    7839,
    7840,
    7841,
    7842,
    7843,
    7844,
    7845,
    7846,
    7847,
    7848,
    7849,
    7850,
    7851,
    7852,
    7853,
    7854,
    7855,
    7856,
    7857,
    7858,
    7859,
    7860,
    7861,
    7862,
    7863,
    7864,
    7865,
    7866,
    7867,
    7868,
    7869,
    7870,
    7871,
    7872,
    7873,
    7874,
    7875,
    7876,
    7877,
    7878,
    7879,
    7880,
    7881,
    7882,
    7883,
    7884,
    7885,
    7886,
    7887,
    7888,
    7889,
    7890,
    7891,
    7892,
    7893,
    7894,
    7895,
    7896,
    7897,
    7898,
    7899,
    7900,
    7901,
    7902,
    7903,
    7904,
    7905,
    7906,
    7907,
    7908,
    7909,
    7910,
    7911,
    7912,
    7913,
    7914,
    7915,
    7916,
    7917,
    7918,
    7919,
    7920,
    7921,
    7922,
    7923,
    7924,
    7925,
    7926,
    7927,
    7928,
    7929,
    7930,
    7931,
    7932,
    7933,
    7934,
    7935,
    7936,
    7937,
    7938,
    7939,
    7940,
    7941,
    7942,
    7943,
    7944,
    7945,
    7946,
    7947,
    7948,
    7949,
    7950,
    7951,
    7952,
    7953,
    7954,
    7955,
    7956,
    7957,
    7958,
    7959,
    7960,
    7961,
    7962,
    7963,
    7964,
    7965,
    7966,
    7967,
    7968,
    7969,
    7970,
    7971,
    7972,
    7973,
    7974,
    7975,
    7976,
    7977,
    7978,
    7979,
    7980,
    7981,
    7982,
    7983,
    7984,
    7985,
    7986,
    7987,
    7988,
    7989,
    7990,
    7991,
    7992,
    7993,
    7994,
    7995,
    7996,
    7997,
    7998,
    7999,
    8000,
    8001,
    8002,
    8003,
    8004,
    8005,
    8006,
    8007,
    8008,
    8009,
    8010,
    8011,
    8012,
    8013,
    8014,
    8015,
    8016,
    8017,
    8018,
    8019,
    8020,
    8021,
    8022,
    8023,
    8024,
    8025,
    8026,
    8027,
    8028,
    8029,
    8030,
    8031,
    8032,
    8033,
    8034,
    8035,
    8036,
    8037,
    8038,
    8039,
    8040,
    8041,
    8042,
    8043,
    8044,
    8045,
    8046,
    8047,
    8048,
    8049,
    8050,
    8051,
    8052,
    8053,
    8054,
    8055,
    8056,
    8057,
    8058,
    8059,
    8060,
    8061,
    8062,
    8063,
    8064,
    8065,
    8066,
    8067,
    8068,
    8069,
    8070,
    8071,
    8072,
    8073,
    8074,
    8075,
    8076,
    8077,
    8078,
    8079,
    8080,
    8081,
    8082,
    8083,
    8084,
    8085,
    8086,
    8087,
    8088,
    8089,
    8090,
    8091,
    8092,
    8093,
    8094,
    8095,
    8096,
    8097,
    8098,
    8099,
    8100,
    8101,
    8102,
    8103,
    8104,
    8105,
    8106,
    8107,
    8108,
    8109,
    8110,
    8111,
    8112,
    8113,
    8114,
    8115,
    8116,
    8117,
    8118,
    8119,
    8120,
    8121,
    8122,
    8123,
    8124,
    8125,
    8126,
    8127,
    8128,
    8129,
    8130,
    8131,
    8132,
    8133,
    8134,
    8135,
    8136,
    8137,
    8138,
    8139,
    8140,
    8141,
    8142,
    8143,
    8144,
    8145,
    8146,
    8147,
    8148,
    8149,
    8150,
    8151,
    8152,
    8153,
    8154,
    8155,
    8156,
    8157,
    8158,
    8159,
    8160,
    8161,
    8162,
    8163,
    8164,
    8165,
    8166,
    8167,
    8168,
    8169,
    8170,
    8171,
    8172,
    8173,
    8174,
    8175,
    8176,
    8177,
    8178,
    8179,
    8180,
    8181,
    8182,
    8183,
    8184,
    8185,
    8186,
    8187,
    8188,
    8189,
    8190,
    8191,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8203,
    8204,
    8205,
    8206,
    8207,
    8208,
    8209,
    8210,
    8211,
    8212,
    8213,
    8214,
    8215,
    8216,
    8217,
    8218,
    8219,
    8220,
    8221,
    8222,
    8223,
    8224,
    8225,
    8226,
    8227,
    8228,
    8229,
    8230,
    8231,
    8232,
    8233,
    8234,
    8235,
    8236,
    8237,
    8238,
    8239,
    8240,
    8241,
    8242,
    8243,
    8244,
    8245,
    8246,
    8247,
    8248,
    8249,
    8250,
    8251,
    8252,
    8253,
    8254,
    8255,
    8256,
    8257,
    8258,
    8259,
    8260,
    8261,
    8262,
    8263,
    8264,
    8265,
    8266,
    8267,
    8268,
    8269,
    8270,
    8271,
    8272,
    8273,
    8274,
    8275,
    8276,
    8277,
    8278,
    8279,
    8280,
    8281,
    8282,
    8283,
    8284,
    8285,
    8286,
    8287,
    8288,
    8289,
    8290,
    8291,
    8292,
    8293,
    8294,
    8295,
    8296,
    8297,
    8298,
    8299,
    8300,
    8301,
    8302,
    8303,
    8304,
    8305,
    8306,
    8307,
    8308,
    8309,
    8310,
    8311,
    8312,
    8313,
    8314,
    8315,
    8316,
    8317,
    8318,
    8319,
    8320,
    8321,
    8322,
    8323,
    8324,
    8325,
    8326,
    8327,
    8328,
    8329,
    8330,
    8331,
    8332,
    8333,
    8334,
    8335,
    8336,
    8337,
    8338,
    8339,
    8340,
    8341,
    8342,
    8343,
    8344,
    8345,
    8346,
    8347,
    8348,
    8349,
    8350,
    8351,
    8352,
    8353,
    8354,
    8355,
    8356,
    8357,
    8358,
    8359,
    8360,
    8361,
    8362,
    8363,
    8364,
    8365,
    8366,
    8367,
    8368,
    8369,
    8370,
    8371,
    8372,
    8373,
    8374,
    8375,
    8376,
    8377,
    8378,
    8379,
    8380,
    8381,
    8382,
    8383,
    8384,
    8385,
    8386,
    8387,
    8388,
    8389,
    8390,
    8391,
    8392,
    8393,
    8394,
    8395,
    8396,
    8397,
    8398,
    8399,
    8400,
    8401,
    8402,
    8403,
    8404,
    8405,
    8406,
    8407,
    8408,
    8409,
    8410,
    8411,
    8412,
    8413,
    8414,
    8415,
    8416,
    8417,
    8418,
    8419,
    8420,
    8421,
    8422,
    8423,
    8424,
    8425,
    8426,
    8427,
    8428,
    8429,
    8430,
    8431,
    8432,
    8433,
    8434,
    8435,
    8436,
    8437,
    8438,
    8439,
    8440,
    8441,
    8442,
    8443,
    8444,
    8445,
    8446,
    8447,
    8448,
    8449,
    8450,
    8451,
    8452,
    8453,
    8454,
    8455,
    8456,
    8457,
    8458,
    8459,
    8460,
    8461,
    8462,
    8463,
    8464,
    8465,
    8466,
    8467,
    8468,
    8469,
    8470,
    8471,
    8472,
    8473,
    8474,
    8475,
    8476,
    8477,
    8478,
    8479,
    8480,
    8481,
    8482,
    8483,
    8484,
    8485,
    8486,
    8487,
    8488,
    8489,
    8490,
    8491,
    8492,
    8493,
    8494,
    8495,
    8496,
    8497,
    8498,
    8499,
    8500,
    8501,
    8502,
    8503,
    8504,
    8505,
    8506,
    8507,
    8508,
    8509,
    8510,
    8511,
    8512,
    8513,
    8514,
    8515,
    8516,
    8517,
    8518,
    8519,
    8520,
    8521,
    8522,
    8523,
    8524,
    8525,
    8526,
    8527,
    8528,
    8529,
    8530,
    8531,
    8532,
    8533,
    8534,
    8535,
    8536,
    8537,
    8538,
    8539,
    8540,
    8541,
    8542,
    8543,
    8544,
    8545,
    8546,
    8547,
    8548,
    8549,
    8550,
    8551,
    8552,
    8553,
    8554,
    8555,
    8556,
    8557,
    8558,
    8559,
    8560,
    8561,
    8562,
    8563,
    8564,
    8565,
    8566,
    8567,
    8568,
    8569,
    8570,
    8571,
    8572,
    8573,
    8574,
    8575,
    8576,
    8577,
    8578,
    8579,
    8580,
    8581,
    8582,
    8583,
    8584,
    8585,
    8586,
    8587,
    8588,
    8589,
    8590,
    8591,
    8592,
    8593,
    8594,
    8595,
    8596,
    8597,
    8598,
    8599,
    8600,
    8601,
    8602,
    8603,
    8604,
    8605,
    8606,
    8607,
    8608,
    8609,
    8610,
    8611,
    8612,
    8613,
    8614,
    8615,
    8616,
    8617,
    8618,
    8619,
    8620,
    8621,
    8622,
    8623,
    8624,
    8625,
    8626,
    8627,
    8628,
    8629,
    8630,
    8631,
    8632,
    8633,
    8634,
    8635,
    8636,
    8637,
    8638,
    8639,
    8640,
    8641,
    8642,
    8643,
    8644,
    8645,
    8646,
    8647,
    8648,
    8649,
    8650,
    8651,
    8652,
    8653,
    8654,
    8655,
    8656,
    8657,
    8658,
    8659,
    8660,
    8661,
    8662,
    8663,
    8664,
    8665,
    8666,
    8667,
    8668,
    8669,
    8670,
    8671,
    8672,
    8673,
    8674,
    8675,
    8676,
    8677,
    8678,
    8679,
    8680,
    8681,
    8682,
    8683,
    8684,
    8685,
    8686,
    8687,
    8688,
    8689,
    8690,
    8691,
    8692,
    8693,
    8694,
    8695,
    8696,
    8697,
    8698,
    8699,
    8700,
    8701,
    8702,
    8703,
    8704,
    8705,
    8706,
    8707,
    8708,
    8709,
    8710,
    8711,
    8712,
    8713,
    8714,
    8715,
    8716,
    8717,
    8718,
    8719,
    8720,
    8721,
    8722,
    8723,
    8724,
    8725,
    8726,
    8727,
    8728,
    8729,
    8730,
    8731,
    8732,
    8733,
    8734,
    8735,
    8736,
    8737,
    8738,
    8739,
    8740,
    8741
];

});

parcelRegister("cVcw3", function(module, exports) {

$parcel$export(module.exports, "GB2312_TYPICAL_DISTRIBUTION_RATIO", () => $968484537a960bad$export$dd61760bd0581971, (v) => $968484537a960bad$export$dd61760bd0581971 = v);
$parcel$export(module.exports, "GB2312_TABLE_SIZE", () => $968484537a960bad$export$6c60dba4a5a2728e, (v) => $968484537a960bad$export$6c60dba4a5a2728e = v);
$parcel$export(module.exports, "GB2312CharToFreqOrder", () => $968484537a960bad$export$25b46c3dc43b6e8c, (v) => $968484537a960bad$export$25b46c3dc43b6e8c = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // GB2312 most frequently used character table
//
// Char to FreqOrder table , from hz6763
// 512  --> 0.79  -- 0.79
// 1024 --> 0.92  -- 0.13
// 2048 --> 0.98  -- 0.06
// 6768 --> 1.00  -- 0.02
//
// Ideal Distribution Ratio = 0.79135/(1-0.79135) = 3.79
// Random Distribution Ration = 512 / (3755 - 512) = 0.157
//
// Typical Distribution Ratio about 25% of Ideal one, still much higher that RDR
var $968484537a960bad$export$dd61760bd0581971;
var $968484537a960bad$export$6c60dba4a5a2728e;
var $968484537a960bad$export$25b46c3dc43b6e8c;
$968484537a960bad$export$dd61760bd0581971 = 0.9;
$968484537a960bad$export$6c60dba4a5a2728e = 3760;
$968484537a960bad$export$25b46c3dc43b6e8c = [
    1671,
    749,
    1443,
    2364,
    3924,
    3807,
    2330,
    3921,
    1704,
    3463,
    2691,
    1511,
    1515,
    572,
    3191,
    2205,
    2361,
    224,
    2558,
    479,
    1711,
    963,
    3162,
    440,
    4060,
    1905,
    2966,
    2947,
    3580,
    2647,
    3961,
    3842,
    2204,
    869,
    4207,
    970,
    2678,
    5626,
    2944,
    2956,
    1479,
    4048,
    514,
    3595,
    588,
    1346,
    2820,
    3409,
    249,
    4088,
    1746,
    1873,
    2047,
    1774,
    581,
    1813,
    358,
    1174,
    3590,
    1014,
    1561,
    4844,
    2245,
    670,
    1636,
    3112,
    889,
    1286,
    953,
    556,
    2327,
    3060,
    1290,
    3141,
    613,
    185,
    3477,
    1367,
    850,
    3820,
    1715,
    2428,
    2642,
    2303,
    2732,
    3041,
    2562,
    2648,
    3566,
    3946,
    1349,
    388,
    3098,
    2091,
    1360,
    3585,
    152,
    1687,
    1539,
    738,
    1559,
    59,
    1232,
    2925,
    2267,
    1388,
    1249,
    1741,
    1679,
    2960,
    151,
    1566,
    1125,
    1352,
    4271,
    924,
    4296,
    385,
    3166,
    4459,
    310,
    1245,
    2850,
    70,
    3285,
    2729,
    3534,
    3575,
    2398,
    3298,
    3466,
    1960,
    2265,
    217,
    3647,
    864,
    1909,
    2084,
    4401,
    2773,
    1010,
    3269,
    5152,
    853,
    3051,
    3121,
    1244,
    4251,
    1895,
    364,
    1499,
    1540,
    2313,
    1180,
    3655,
    2268,
    562,
    715,
    2417,
    3061,
    544,
    336,
    3768,
    2380,
    1752,
    4075,
    950,
    280,
    2425,
    4382,
    183,
    2759,
    3272,
    333,
    4297,
    2155,
    1688,
    2356,
    1444,
    1039,
    4540,
    736,
    1177,
    3349,
    2443,
    2368,
    2144,
    2225,
    565,
    196,
    1482,
    3406,
    927,
    1335,
    4147,
    692,
    878,
    1311,
    1653,
    3911,
    3622,
    1378,
    4200,
    1840,
    2969,
    3149,
    2126,
    1816,
    2534,
    1546,
    2393,
    2760,
    737,
    2494,
    13,
    447,
    245,
    2747,
    38,
    2765,
    2129,
    2589,
    1079,
    606,
    360,
    471,
    3755,
    2890,
    404,
    848,
    699,
    1785,
    1236,
    370,
    2221,
    1023,
    3746,
    2074,
    2026,
    2023,
    2388,
    1581,
    2119,
    812,
    1141,
    3091,
    2536,
    1519,
    804,
    2053,
    406,
    1596,
    1090,
    784,
    548,
    4414,
    1806,
    2264,
    2936,
    1100,
    343,
    4114,
    5096,
    622,
    3358,
    743,
    3668,
    1510,
    1626,
    5020,
    3567,
    2513,
    3195,
    4115,
    5627,
    2489,
    2991,
    24,
    2065,
    2697,
    1087,
    2719,
    48,
    1634,
    315,
    68,
    985,
    2052,
    198,
    2239,
    1347,
    1107,
    1439,
    597,
    2366,
    2172,
    871,
    3307,
    919,
    2487,
    2790,
    1867,
    236,
    2570,
    1413,
    3794,
    906,
    3365,
    3381,
    1701,
    1982,
    1818,
    1524,
    2924,
    1205,
    616,
    2586,
    2072,
    2004,
    575,
    253,
    3099,
    32,
    1365,
    1182,
    197,
    1714,
    2454,
    1201,
    554,
    3388,
    3224,
    2748,
    756,
    2587,
    250,
    2567,
    1507,
    1517,
    3529,
    1922,
    2761,
    2337,
    3416,
    1961,
    1677,
    2452,
    2238,
    3153,
    615,
    911,
    1506,
    1474,
    2495,
    1265,
    1906,
    2749,
    3756,
    3280,
    2161,
    898,
    2714,
    1759,
    3450,
    2243,
    2444,
    563,
    26,
    3286,
    2266,
    3769,
    3344,
    2707,
    3677,
    611,
    1402,
    531,
    1028,
    2871,
    4548,
    1375,
    261,
    2948,
    835,
    1190,
    4134,
    353,
    840,
    2684,
    1900,
    3082,
    1435,
    2109,
    1207,
    1674,
    329,
    1872,
    2781,
    4055,
    2686,
    2104,
    608,
    3318,
    2423,
    2957,
    2768,
    1108,
    3739,
    3512,
    3271,
    3985,
    2203,
    1771,
    3520,
    1418,
    2054,
    1681,
    1153,
    225,
    1627,
    2929,
    162,
    2050,
    2511,
    3687,
    1954,
    124,
    1859,
    2431,
    1684,
    3032,
    2894,
    585,
    4805,
    3969,
    2869,
    2704,
    2088,
    2032,
    2095,
    3656,
    2635,
    4362,
    2209,
    256,
    518,
    2042,
    2105,
    3777,
    3657,
    643,
    2298,
    1148,
    1779,
    190,
    989,
    3544,
    414,
    11,
    2135,
    2063,
    2979,
    1471,
    403,
    3678,
    126,
    770,
    1563,
    671,
    2499,
    3216,
    2877,
    600,
    1179,
    307,
    2805,
    4937,
    1268,
    1297,
    2694,
    252,
    4032,
    1448,
    1494,
    1331,
    1394,
    127,
    2256,
    222,
    1647,
    1035,
    1481,
    3056,
    1915,
    1048,
    873,
    3651,
    210,
    33,
    1608,
    2516,
    200,
    1520,
    415,
    102,
    0,
    3389,
    1287,
    817,
    91,
    3299,
    2940,
    836,
    1814,
    549,
    2197,
    1396,
    1669,
    2987,
    3582,
    2297,
    2848,
    4528,
    1070,
    687,
    20,
    1819,
    121,
    1552,
    1364,
    1461,
    1968,
    2617,
    3540,
    2824,
    2083,
    177,
    948,
    4938,
    2291,
    110,
    4549,
    2066,
    648,
    3359,
    1755,
    2110,
    2114,
    4642,
    4845,
    1693,
    3937,
    3308,
    1257,
    1869,
    2123,
    208,
    1804,
    3159,
    2992,
    2531,
    2549,
    3361,
    2418,
    1350,
    2347,
    2800,
    2568,
    1291,
    2036,
    2680,
    72,
    842,
    1990,
    212,
    1233,
    1154,
    1586,
    75,
    2027,
    3410,
    4900,
    1823,
    1337,
    2710,
    2676,
    728,
    2810,
    1522,
    3026,
    4995,
    157,
    755,
    1050,
    4022,
    710,
    785,
    1936,
    2194,
    2085,
    1406,
    2777,
    2400,
    150,
    1250,
    4049,
    1206,
    807,
    1910,
    534,
    529,
    3309,
    1721,
    1660,
    274,
    39,
    2827,
    661,
    2670,
    1578,
    925,
    3248,
    3815,
    1094,
    4278,
    4901,
    4252,
    41,
    1150,
    3747,
    2572,
    2227,
    4501,
    3658,
    4902,
    3813,
    3357,
    3617,
    2884,
    2258,
    887,
    538,
    4187,
    3199,
    1294,
    2439,
    3042,
    2329,
    2343,
    2497,
    1255,
    107,
    543,
    1527,
    521,
    3478,
    3568,
    194,
    5062,
    15,
    961,
    3870,
    1241,
    1192,
    2664,
    66,
    5215,
    3260,
    2111,
    1295,
    1127,
    2152,
    3805,
    4135,
    901,
    1164,
    1976,
    398,
    1278,
    530,
    1460,
    748,
    904,
    1054,
    1966,
    1426,
    53,
    2909,
    509,
    523,
    2279,
    1534,
    536,
    1019,
    239,
    1685,
    460,
    2353,
    673,
    1065,
    2401,
    3600,
    4298,
    2272,
    1272,
    2363,
    284,
    1753,
    3679,
    4064,
    1695,
    81,
    815,
    2677,
    2757,
    2731,
    1386,
    859,
    500,
    4221,
    2190,
    2566,
    757,
    1006,
    2519,
    2068,
    1166,
    1455,
    337,
    2654,
    3203,
    1863,
    1682,
    1914,
    3025,
    1252,
    1409,
    1366,
    847,
    714,
    2834,
    2038,
    3209,
    964,
    2970,
    1901,
    885,
    2553,
    1078,
    1756,
    3049,
    301,
    1572,
    3326,
    688,
    2130,
    1996,
    2429,
    1805,
    1648,
    2930,
    3421,
    2750,
    3652,
    3088,
    262,
    1158,
    1254,
    389,
    1641,
    1812,
    526,
    1719,
    923,
    2073,
    1073,
    1902,
    468,
    489,
    4625,
    1140,
    857,
    2375,
    3070,
    3319,
    2863,
    380,
    116,
    1328,
    2693,
    1161,
    2244,
    273,
    1212,
    1884,
    2769,
    3011,
    1775,
    1142,
    461,
    3066,
    1200,
    2147,
    2212,
    790,
    702,
    2695,
    4222,
    1601,
    1058,
    434,
    2338,
    5153,
    3640,
    67,
    2360,
    4099,
    2502,
    618,
    3472,
    1329,
    416,
    1132,
    830,
    2782,
    1807,
    2653,
    3211,
    3510,
    1662,
    192,
    2124,
    296,
    3979,
    1739,
    1611,
    3684,
    23,
    118,
    324,
    446,
    1239,
    1225,
    293,
    2520,
    3814,
    3795,
    2535,
    3116,
    17,
    1074,
    467,
    2692,
    2201,
    387,
    2922,
    45,
    1326,
    3055,
    1645,
    3659,
    2817,
    958,
    243,
    1903,
    2320,
    1339,
    2825,
    1784,
    3289,
    356,
    576,
    865,
    2315,
    2381,
    3377,
    3916,
    1088,
    3122,
    1713,
    1655,
    935,
    628,
    4689,
    1034,
    1327,
    441,
    800,
    720,
    894,
    1979,
    2183,
    1528,
    5289,
    2702,
    1071,
    4046,
    3572,
    2399,
    1571,
    3281,
    79,
    761,
    1103,
    327,
    134,
    758,
    1899,
    1371,
    1615,
    879,
    442,
    215,
    2605,
    2579,
    173,
    2048,
    2485,
    1057,
    2975,
    3317,
    1097,
    2253,
    3801,
    4263,
    1403,
    1650,
    2946,
    814,
    4968,
    3487,
    1548,
    2644,
    1567,
    1285,
    2,
    295,
    2636,
    97,
    946,
    3576,
    832,
    141,
    4257,
    3273,
    760,
    3821,
    3521,
    3156,
    2607,
    949,
    1024,
    1733,
    1516,
    1803,
    1920,
    2125,
    2283,
    2665,
    3180,
    1501,
    2064,
    3560,
    2171,
    1592,
    803,
    3518,
    1416,
    732,
    3897,
    4258,
    1363,
    1362,
    2458,
    119,
    1427,
    602,
    1525,
    2608,
    1605,
    1639,
    3175,
    694,
    3064,
    10,
    465,
    76,
    2000,
    4846,
    4208,
    444,
    3781,
    1619,
    3353,
    2206,
    1273,
    3796,
    740,
    2483,
    320,
    1723,
    2377,
    3660,
    2619,
    1359,
    1137,
    1762,
    1724,
    2345,
    2842,
    1850,
    1862,
    912,
    821,
    1866,
    612,
    2625,
    1735,
    2573,
    3369,
    1093,
    844,
    89,
    937,
    930,
    1424,
    3564,
    2413,
    2972,
    1004,
    3046,
    3019,
    2011,
    711,
    3171,
    1452,
    4178,
    428,
    801,
    1943,
    432,
    445,
    2811,
    206,
    4136,
    1472,
    730,
    349,
    73,
    397,
    2802,
    2547,
    998,
    1637,
    1167,
    789,
    396,
    3217,
    154,
    1218,
    716,
    1120,
    1780,
    2819,
    4826,
    1931,
    3334,
    3762,
    2139,
    1215,
    2627,
    552,
    3664,
    3628,
    3232,
    1405,
    2383,
    3111,
    1356,
    2652,
    3577,
    3320,
    3101,
    1703,
    640,
    1045,
    1370,
    1246,
    4996,
    371,
    1575,
    2436,
    1621,
    2210,
    984,
    4033,
    1734,
    2638,
    16,
    4529,
    663,
    2755,
    3255,
    1451,
    3917,
    2257,
    1253,
    1955,
    2234,
    1263,
    2951,
    214,
    1229,
    617,
    485,
    359,
    1831,
    1969,
    473,
    2310,
    750,
    2058,
    165,
    80,
    2864,
    2419,
    361,
    4344,
    2416,
    2479,
    1134,
    796,
    3726,
    1266,
    2943,
    860,
    2715,
    938,
    390,
    2734,
    1313,
    1384,
    248,
    202,
    877,
    1064,
    2854,
    522,
    3907,
    279,
    1602,
    297,
    2357,
    395,
    3740,
    137,
    2075,
    944,
    4089,
    2584,
    1267,
    3802,
    62,
    1533,
    2285,
    178,
    176,
    780,
    2440,
    201,
    3707,
    590,
    478,
    1560,
    4354,
    2117,
    1075,
    30,
    74,
    4643,
    4004,
    1635,
    1441,
    2745,
    776,
    2596,
    238,
    1077,
    1692,
    1912,
    2844,
    605,
    499,
    1742,
    3947,
    241,
    3053,
    980,
    1749,
    936,
    2640,
    4511,
    2582,
    515,
    1543,
    2162,
    5322,
    2892,
    2993,
    890,
    2148,
    1924,
    665,
    1827,
    3581,
    1032,
    968,
    3163,
    339,
    1044,
    1896,
    270,
    583,
    1791,
    1720,
    4367,
    1194,
    3488,
    3669,
    43,
    2523,
    1657,
    163,
    2167,
    290,
    1209,
    1622,
    3378,
    550,
    634,
    2508,
    2510,
    695,
    2634,
    2384,
    2512,
    1476,
    1414,
    220,
    1469,
    2341,
    2138,
    2852,
    3183,
    2900,
    4939,
    2865,
    3502,
    1211,
    3680,
    854,
    3227,
    1299,
    2976,
    3172,
    186,
    2998,
    1459,
    443,
    1067,
    3251,
    1495,
    321,
    1932,
    3054,
    909,
    753,
    1410,
    1828,
    436,
    2441,
    1119,
    1587,
    3164,
    2186,
    1258,
    227,
    231,
    1425,
    1890,
    3200,
    3942,
    247,
    959,
    725,
    5254,
    2741,
    577,
    2158,
    2079,
    929,
    120,
    174,
    838,
    2813,
    591,
    1115,
    417,
    2024,
    40,
    3240,
    1536,
    1037,
    291,
    4151,
    2354,
    632,
    1298,
    2406,
    2500,
    3535,
    1825,
    1846,
    3451,
    205,
    1171,
    345,
    4238,
    18,
    1163,
    811,
    685,
    2208,
    1217,
    425,
    1312,
    1508,
    1175,
    4308,
    2552,
    1033,
    587,
    1381,
    3059,
    2984,
    3482,
    340,
    1316,
    4023,
    3972,
    792,
    3176,
    519,
    777,
    4690,
    918,
    933,
    4130,
    2981,
    3741,
    90,
    3360,
    2911,
    2200,
    5184,
    4550,
    609,
    3079,
    2030,
    272,
    3379,
    2736,
    363,
    3881,
    1130,
    1447,
    286,
    779,
    357,
    1169,
    3350,
    3137,
    1630,
    1220,
    2687,
    2391,
    747,
    1277,
    3688,
    2618,
    2682,
    2601,
    1156,
    3196,
    5290,
    4034,
    3102,
    1689,
    3596,
    3128,
    874,
    219,
    2783,
    798,
    508,
    1843,
    2461,
    269,
    1658,
    1776,
    1392,
    1913,
    2983,
    3287,
    2866,
    2159,
    2372,
    829,
    4076,
    46,
    4253,
    2873,
    1889,
    1894,
    915,
    1834,
    1631,
    2181,
    2318,
    298,
    664,
    2818,
    3555,
    2735,
    954,
    3228,
    3117,
    527,
    3511,
    2173,
    681,
    2712,
    3033,
    2247,
    2346,
    3467,
    1652,
    155,
    2164,
    3382,
    113,
    1994,
    450,
    899,
    494,
    994,
    1237,
    2958,
    1875,
    2336,
    1926,
    3727,
    545,
    1577,
    1550,
    633,
    3473,
    204,
    1305,
    3072,
    2410,
    1956,
    2471,
    707,
    2134,
    841,
    2195,
    2196,
    2663,
    3843,
    1026,
    4940,
    990,
    3252,
    4997,
    368,
    1092,
    437,
    3212,
    3258,
    1933,
    1829,
    675,
    2977,
    2893,
    412,
    943,
    3723,
    4644,
    3294,
    3283,
    2230,
    2373,
    5154,
    2389,
    2241,
    2661,
    2323,
    1404,
    2524,
    593,
    787,
    677,
    3008,
    1275,
    2059,
    438,
    2709,
    2609,
    2240,
    2269,
    2246,
    1446,
    36,
    1568,
    1373,
    3892,
    1574,
    2301,
    1456,
    3962,
    693,
    2276,
    5216,
    2035,
    1143,
    2720,
    1919,
    1797,
    1811,
    2763,
    4137,
    2597,
    1830,
    1699,
    1488,
    1198,
    2090,
    424,
    1694,
    312,
    3634,
    3390,
    4179,
    3335,
    2252,
    1214,
    561,
    1059,
    3243,
    2295,
    2561,
    975,
    5155,
    2321,
    2751,
    3772,
    472,
    1537,
    3282,
    3398,
    1047,
    2077,
    2348,
    2878,
    1323,
    3340,
    3076,
    690,
    2906,
    51,
    369,
    170,
    3541,
    1060,
    2187,
    2688,
    3670,
    2541,
    1083,
    1683,
    928,
    3918,
    459,
    109,
    4427,
    599,
    3744,
    4286,
    143,
    2101,
    2730,
    2490,
    82,
    1588,
    3036,
    2121,
    281,
    1860,
    477,
    4035,
    1238,
    2812,
    3020,
    2716,
    3312,
    1530,
    2188,
    2055,
    1317,
    843,
    636,
    1808,
    1173,
    3495,
    649,
    181,
    1002,
    147,
    3641,
    1159,
    2414,
    3750,
    2289,
    2795,
    813,
    3123,
    2610,
    1136,
    4368,
    5,
    3391,
    4541,
    2174,
    420,
    429,
    1728,
    754,
    1228,
    2115,
    2219,
    347,
    2223,
    2733,
    735,
    1518,
    3003,
    2355,
    3134,
    1764,
    3948,
    3329,
    1888,
    2424,
    1001,
    1234,
    1972,
    3321,
    3363,
    1672,
    1021,
    1450,
    1584,
    226,
    765,
    655,
    2526,
    3404,
    3244,
    2302,
    3665,
    731,
    594,
    2184,
    319,
    1576,
    621,
    658,
    2656,
    4299,
    2099,
    3864,
    1279,
    2071,
    2598,
    2739,
    795,
    3086,
    3699,
    3908,
    1707,
    2352,
    2402,
    1382,
    3136,
    2475,
    1465,
    4847,
    3496,
    3865,
    1085,
    3004,
    2591,
    1084,
    213,
    2287,
    1963,
    3565,
    2250,
    822,
    793,
    4574,
    3187,
    1772,
    1789,
    3050,
    595,
    1484,
    1959,
    2770,
    1080,
    2650,
    456,
    422,
    2996,
    940,
    3322,
    4328,
    4345,
    3092,
    2742,
    965,
    2784,
    739,
    4124,
    952,
    1358,
    2498,
    2949,
    2565,
    332,
    2698,
    2378,
    660,
    2260,
    2473,
    4194,
    3856,
    2919,
    535,
    1260,
    2651,
    1208,
    1428,
    1300,
    1949,
    1303,
    2942,
    433,
    2455,
    2450,
    1251,
    1946,
    614,
    1269,
    641,
    1306,
    1810,
    2737,
    3078,
    2912,
    564,
    2365,
    1419,
    1415,
    1497,
    4460,
    2367,
    2185,
    1379,
    3005,
    1307,
    3218,
    2175,
    1897,
    3063,
    682,
    1157,
    4040,
    4005,
    1712,
    1160,
    1941,
    1399,
    394,
    402,
    2952,
    1573,
    1151,
    2986,
    2404,
    862,
    299,
    2033,
    1489,
    3006,
    346,
    171,
    2886,
    3401,
    1726,
    2932,
    168,
    2533,
    47,
    2507,
    1030,
    3735,
    1145,
    3370,
    1395,
    1318,
    1579,
    3609,
    4560,
    2857,
    4116,
    1457,
    2529,
    1965,
    504,
    1036,
    2690,
    2988,
    2405,
    745,
    5871,
    849,
    2397,
    2056,
    3081,
    863,
    2359,
    3857,
    2096,
    99,
    1397,
    1769,
    2300,
    4428,
    1643,
    3455,
    1978,
    1757,
    3718,
    1440,
    35,
    4879,
    3742,
    1296,
    4228,
    2280,
    160,
    5063,
    1599,
    2013,
    166,
    520,
    3479,
    1646,
    3345,
    3012,
    490,
    1937,
    1545,
    1264,
    2182,
    2505,
    1096,
    1188,
    1369,
    1436,
    2421,
    1667,
    2792,
    2460,
    1270,
    2122,
    727,
    3167,
    2143,
    806,
    1706,
    1012,
    1800,
    3037,
    960,
    2218,
    1882,
    805,
    139,
    2456,
    1139,
    1521,
    851,
    1052,
    3093,
    3089,
    342,
    2039,
    744,
    5097,
    1468,
    1502,
    1585,
    2087,
    223,
    939,
    326,
    2140,
    2577,
    892,
    2481,
    1623,
    4077,
    982,
    3708,
    135,
    2131,
    87,
    2503,
    3114,
    2326,
    1106,
    876,
    1616,
    547,
    2997,
    2831,
    2093,
    3441,
    4530,
    4314,
    9,
    3256,
    4229,
    4148,
    659,
    1462,
    1986,
    1710,
    2046,
    2913,
    2231,
    4090,
    4880,
    5255,
    3392,
    3274,
    1368,
    3689,
    4645,
    1477,
    705,
    3384,
    3635,
    1068,
    1529,
    2941,
    1458,
    3782,
    1509,
    100,
    1656,
    2548,
    718,
    2339,
    408,
    1590,
    2780,
    3548,
    1838,
    4117,
    3719,
    1345,
    3530,
    717,
    3442,
    2778,
    3220,
    2898,
    1892,
    4590,
    3614,
    3371,
    2043,
    1998,
    1224,
    3483,
    891,
    635,
    584,
    2559,
    3355,
    733,
    1766,
    1729,
    1172,
    3789,
    1891,
    2307,
    781,
    2982,
    2271,
    1957,
    1580,
    5773,
    2633,
    2005,
    4195,
    3097,
    1535,
    3213,
    1189,
    1934,
    5693,
    3262,
    586,
    3118,
    1324,
    1598,
    517,
    1564,
    2217,
    1868,
    1893,
    4445,
    3728,
    2703,
    3139,
    1526,
    1787,
    1992,
    3882,
    2875,
    1549,
    1199,
    1056,
    2224,
    1904,
    2711,
    5098,
    4287,
    338,
    1993,
    3129,
    3489,
    2689,
    1809,
    2815,
    1997,
    957,
    1855,
    3898,
    2550,
    3275,
    3057,
    1105,
    1319,
    627,
    1505,
    1911,
    1883,
    3526,
    698,
    3629,
    3456,
    1833,
    1431,
    746,
    77,
    1261,
    2017,
    2296,
    1977,
    1885,
    125,
    1334,
    1600,
    525,
    1798,
    1109,
    2222,
    1470,
    1945,
    559,
    2236,
    1186,
    3443,
    2476,
    1929,
    1411,
    2411,
    3135,
    1777,
    3372,
    2621,
    1841,
    1613,
    3229,
    668,
    1430,
    1839,
    2643,
    2916,
    195,
    1989,
    2671,
    2358,
    1387,
    629,
    3205,
    2293,
    5256,
    4439,
    123,
    1310,
    888,
    1879,
    4300,
    3021,
    3605,
    1003,
    1162,
    3192,
    2910,
    2010,
    140,
    2395,
    2859,
    55,
    1082,
    2012,
    2901,
    662,
    419,
    2081,
    1438,
    680,
    2774,
    4654,
    3912,
    1620,
    1731,
    1625,
    5035,
    4065,
    2328,
    512,
    1344,
    802,
    5443,
    2163,
    2311,
    2537,
    524,
    3399,
    98,
    1155,
    2103,
    1918,
    2606,
    3925,
    2816,
    1393,
    2465,
    1504,
    3773,
    2177,
    3963,
    1478,
    4346,
    180,
    1113,
    4655,
    3461,
    2028,
    1698,
    833,
    2696,
    1235,
    1322,
    1594,
    4408,
    3623,
    3013,
    3225,
    2040,
    3022,
    541,
    2881,
    607,
    3632,
    2029,
    1665,
    1219,
    639,
    1385,
    1686,
    1099,
    2803,
    3231,
    1938,
    3188,
    2858,
    427,
    676,
    2772,
    1168,
    2025,
    454,
    3253,
    2486,
    3556,
    230,
    1950,
    580,
    791,
    1991,
    1280,
    1086,
    1974,
    2034,
    630,
    257,
    3338,
    2788,
    4903,
    1017,
    86,
    4790,
    966,
    2789,
    1995,
    1696,
    1131,
    259,
    3095,
    4188,
    1308,
    179,
    1463,
    5257,
    289,
    4107,
    1248,
    42,
    3413,
    1725,
    2288,
    896,
    1947,
    774,
    4474,
    4254,
    604,
    3430,
    4264,
    392,
    2514,
    2588,
    452,
    237,
    1408,
    3018,
    988,
    4531,
    1970,
    3034,
    3310,
    540,
    2370,
    1562,
    1288,
    2990,
    502,
    4765,
    1147,
    4,
    1853,
    2708,
    207,
    294,
    2814,
    4078,
    2902,
    2509,
    684,
    34,
    3105,
    3532,
    2551,
    644,
    709,
    2801,
    2344,
    573,
    1727,
    3573,
    3557,
    2021,
    1081,
    3100,
    4315,
    2100,
    3681,
    199,
    2263,
    1837,
    2385,
    146,
    3484,
    1195,
    2776,
    3949,
    997,
    1939,
    3973,
    1008,
    1091,
    1202,
    1962,
    1847,
    1149,
    4209,
    5444,
    1076,
    493,
    117,
    5400,
    2521,
    972,
    1490,
    2934,
    1796,
    4542,
    2374,
    1512,
    2933,
    2657,
    413,
    2888,
    1135,
    2762,
    2314,
    2156,
    1355,
    2369,
    766,
    2007,
    2527,
    2170,
    3124,
    2491,
    2593,
    2632,
    4757,
    2437,
    234,
    3125,
    3591,
    1898,
    1750,
    1376,
    1942,
    3468,
    3138,
    570,
    2127,
    2145,
    3276,
    4131,
    962,
    132,
    1445,
    4196,
    19,
    941,
    3624,
    3480,
    3366,
    1973,
    1374,
    4461,
    3431,
    2629,
    283,
    2415,
    2275,
    808,
    2887,
    3620,
    2112,
    2563,
    1353,
    3610,
    955,
    1089,
    3103,
    1053,
    96,
    88,
    4097,
    823,
    3808,
    1583,
    399,
    292,
    4091,
    3313,
    421,
    1128,
    642,
    4006,
    903,
    2539,
    1877,
    2082,
    596,
    29,
    4066,
    1790,
    722,
    2157,
    130,
    995,
    1569,
    769,
    1485,
    464,
    513,
    2213,
    288,
    1923,
    1101,
    2453,
    4316,
    133,
    486,
    2445,
    50,
    625,
    487,
    2207,
    57,
    423,
    481,
    2962,
    159,
    3729,
    1558,
    491,
    303,
    482,
    501,
    240,
    2837,
    112,
    3648,
    2392,
    1783,
    362,
    8,
    3433,
    3422,
    610,
    2793,
    3277,
    1390,
    1284,
    1654,
    21,
    3823,
    734,
    367,
    623,
    193,
    287,
    374,
    1009,
    1483,
    816,
    476,
    313,
    2255,
    2340,
    1262,
    2150,
    2899,
    1146,
    2581,
    782,
    2116,
    1659,
    2018,
    1880,
    255,
    3586,
    3314,
    1110,
    2867,
    2137,
    2564,
    986,
    2767,
    5185,
    2006,
    650,
    158,
    926,
    762,
    881,
    3157,
    2717,
    2362,
    3587,
    306,
    3690,
    3245,
    1542,
    3077,
    2427,
    1691,
    2478,
    2118,
    2985,
    3490,
    2438,
    539,
    2305,
    983,
    129,
    1754,
    355,
    4201,
    2386,
    827,
    2923,
    104,
    1773,
    2838,
    2771,
    411,
    2905,
    3919,
    376,
    767,
    122,
    1114,
    828,
    2422,
    1817,
    3506,
    266,
    3460,
    1007,
    1609,
    4998,
    945,
    2612,
    4429,
    2274,
    726,
    1247,
    1964,
    2914,
    2199,
    2070,
    4002,
    4108,
    657,
    3323,
    1422,
    579,
    455,
    2764,
    4737,
    1222,
    2895,
    1670,
    824,
    1223,
    1487,
    2525,
    558,
    861,
    3080,
    598,
    2659,
    2515,
    1967,
    752,
    2583,
    2376,
    2214,
    4180,
    977,
    704,
    2464,
    4999,
    2622,
    4109,
    1210,
    2961,
    819,
    1541,
    142,
    2284,
    44,
    418,
    457,
    1126,
    3730,
    4347,
    4626,
    1644,
    1876,
    3671,
    1864,
    302,
    1063,
    5694,
    624,
    723,
    1984,
    3745,
    1314,
    1676,
    2488,
    1610,
    1449,
    3558,
    3569,
    2166,
    2098,
    409,
    1011,
    2325,
    3704,
    2306,
    818,
    1732,
    1383,
    1824,
    1844,
    3757,
    999,
    2705,
    3497,
    1216,
    1423,
    2683,
    2426,
    2954,
    2501,
    2726,
    2229,
    1475,
    2554,
    5064,
    1971,
    1794,
    1666,
    2014,
    1343,
    783,
    724,
    191,
    2434,
    1354,
    2220,
    5065,
    1763,
    2752,
    2472,
    4152,
    131,
    175,
    2885,
    3434,
    92,
    1466,
    4920,
    2616,
    3871,
    3872,
    3866,
    128,
    1551,
    1632,
    669,
    1854,
    3682,
    4691,
    4125,
    1230,
    188,
    2973,
    3290,
    1302,
    1213,
    560,
    3266,
    917,
    763,
    3909,
    3249,
    1760,
    868,
    1958,
    764,
    1782,
    2097,
    145,
    2277,
    3774,
    4462,
    64,
    1491,
    3062,
    971,
    2132,
    3606,
    2442,
    221,
    1226,
    1617,
    218,
    323,
    1185,
    3207,
    3147,
    571,
    619,
    1473,
    1005,
    1744,
    2281,
    449,
    1887,
    2396,
    3685,
    275,
    375,
    3816,
    1743,
    3844,
    3731,
    845,
    1983,
    2350,
    4210,
    1377,
    773,
    967,
    3499,
    3052,
    3743,
    2725,
    4007,
    1697,
    1022,
    3943,
    1464,
    3264,
    2855,
    2722,
    1952,
    1029,
    2839,
    2467,
    84,
    4383,
    2215,
    820,
    1391,
    2015,
    2448,
    3672,
    377,
    1948,
    2168,
    797,
    2545,
    3536,
    2578,
    2645,
    94,
    2874,
    1678,
    405,
    1259,
    3071,
    771,
    546,
    1315,
    470,
    1243,
    3083,
    895,
    2468,
    981,
    969,
    2037,
    846,
    4181,
    653,
    1276,
    2928,
    14,
    2594,
    557,
    3007,
    2474,
    156,
    902,
    1338,
    1740,
    2574,
    537,
    2518,
    973,
    2282,
    2216,
    2433,
    1928,
    138,
    2903,
    1293,
    2631,
    1612,
    646,
    3457,
    839,
    2935,
    111,
    496,
    2191,
    2847,
    589,
    3186,
    149,
    3994,
    2060,
    4031,
    2641,
    4067,
    3145,
    1870,
    37,
    3597,
    2136,
    1025,
    2051,
    3009,
    3383,
    3549,
    1121,
    1016,
    3261,
    1301,
    251,
    2446,
    2599,
    2153,
    872,
    3246,
    637,
    334,
    3705,
    831,
    884,
    921,
    3065,
    3140,
    4092,
    2198,
    1944,
    246,
    2964,
    108,
    2045,
    1152,
    1921,
    2308,
    1031,
    203,
    3173,
    4170,
    1907,
    3890,
    810,
    1401,
    2003,
    1690,
    506,
    647,
    1242,
    2828,
    1761,
    1649,
    3208,
    2249,
    1589,
    3709,
    2931,
    5156,
    1708,
    498,
    666,
    2613,
    834,
    3817,
    1231,
    184,
    2851,
    1124,
    883,
    3197,
    2261,
    3710,
    1765,
    1553,
    2658,
    1178,
    2639,
    2351,
    93,
    1193,
    942,
    2538,
    2141,
    4402,
    235,
    1821,
    870,
    1591,
    2192,
    1709,
    1871,
    3341,
    1618,
    4126,
    2595,
    2334,
    603,
    651,
    69,
    701,
    268,
    2662,
    3411,
    2555,
    1380,
    1606,
    503,
    448,
    254,
    2371,
    2646,
    574,
    1187,
    2309,
    1770,
    322,
    2235,
    1292,
    1801,
    305,
    566,
    1133,
    229,
    2067,
    2057,
    706,
    167,
    483,
    2002,
    2672,
    3295,
    1820,
    3561,
    3067,
    316,
    378,
    2746,
    3452,
    1112,
    136,
    1981,
    507,
    1651,
    2917,
    1117,
    285,
    4591,
    182,
    2580,
    3522,
    1304,
    335,
    3303,
    1835,
    2504,
    1795,
    1792,
    2248,
    674,
    1018,
    2106,
    2449,
    1857,
    2292,
    2845,
    976,
    3047,
    1781,
    2600,
    2727,
    1389,
    1281,
    52,
    3152,
    153,
    265,
    3950,
    672,
    3485,
    3951,
    4463,
    430,
    1183,
    365,
    278,
    2169,
    27,
    1407,
    1336,
    2304,
    209,
    1340,
    1730,
    2202,
    1852,
    2403,
    2883,
    979,
    1737,
    1062,
    631,
    2829,
    2542,
    3876,
    2592,
    825,
    2086,
    2226,
    3048,
    3625,
    352,
    1417,
    3724,
    542,
    991,
    431,
    1351,
    3938,
    1861,
    2294,
    826,
    1361,
    2927,
    3142,
    3503,
    1738,
    463,
    2462,
    2723,
    582,
    1916,
    1595,
    2808,
    400,
    3845,
    3891,
    2868,
    3621,
    2254,
    58,
    2492,
    1123,
    910,
    2160,
    2614,
    1372,
    1603,
    1196,
    1072,
    3385,
    1700,
    3267,
    1980,
    696,
    480,
    2430,
    920,
    799,
    1570,
    2920,
    1951,
    2041,
    4047,
    2540,
    1321,
    4223,
    2469,
    3562,
    2228,
    1271,
    2602,
    401,
    2833,
    3351,
    2575,
    5157,
    907,
    2312,
    1256,
    410,
    263,
    3507,
    1582,
    996,
    678,
    1849,
    2316,
    1480,
    908,
    3545,
    2237,
    703,
    2322,
    667,
    1826,
    2849,
    1531,
    2604,
    2999,
    2407,
    3146,
    2151,
    2630,
    1786,
    3711,
    469,
    3542,
    497,
    3899,
    2409,
    858,
    837,
    4446,
    3393,
    1274,
    786,
    620,
    1845,
    2001,
    3311,
    484,
    308,
    3367,
    1204,
    1815,
    3691,
    2332,
    1532,
    2557,
    1842,
    2020,
    2724,
    1927,
    2333,
    4440,
    567,
    22,
    1673,
    2728,
    4475,
    1987,
    1858,
    1144,
    1597,
    101,
    1832,
    3601,
    12,
    974,
    3783,
    4391,
    951,
    1412,
    1,
    3720,
    453,
    4608,
    4041,
    528,
    1041,
    1027,
    3230,
    2628,
    1129,
    875,
    1051,
    3291,
    1203,
    2262,
    1069,
    2860,
    2799,
    2149,
    2615,
    3278,
    144,
    1758,
    3040,
    31,
    475,
    1680,
    366,
    2685,
    3184,
    311,
    1642,
    4008,
    2466,
    5036,
    1593,
    1493,
    2809,
    216,
    1420,
    1668,
    233,
    304,
    2128,
    3284,
    232,
    1429,
    1768,
    1040,
    2008,
    3407,
    2740,
    2967,
    2543,
    242,
    2133,
    778,
    1565,
    2022,
    2620,
    505,
    2189,
    2756,
    1098,
    2273,
    372,
    1614,
    708,
    553,
    2846,
    2094,
    2278,
    169,
    3626,
    2835,
    4161,
    228,
    2674,
    3165,
    809,
    1454,
    1309,
    466,
    1705,
    1095,
    900,
    3423,
    880,
    2667,
    3751,
    5258,
    2317,
    3109,
    2571,
    4317,
    2766,
    1503,
    1342,
    866,
    4447,
    1118,
    63,
    2076,
    314,
    1881,
    1348,
    1061,
    172,
    978,
    3515,
    1747,
    532,
    511,
    3970,
    6,
    601,
    905,
    2699,
    3300,
    1751,
    276,
    1467,
    3725,
    2668,
    65,
    4239,
    2544,
    2779,
    2556,
    1604,
    578,
    2451,
    1802,
    992,
    2331,
    2624,
    1320,
    3446,
    713,
    1513,
    1013,
    103,
    2786,
    2447,
    1661,
    886,
    1702,
    916,
    654,
    3574,
    2031,
    1556,
    751,
    2178,
    2821,
    2179,
    1498,
    1538,
    2176,
    271,
    914,
    2251,
    2080,
    1325,
    638,
    1953,
    2937,
    3877,
    2432,
    2754,
    95,
    3265,
    1716,
    260,
    1227,
    4083,
    775,
    106,
    1357,
    3254,
    426,
    1607,
    555,
    2480,
    772,
    1985,
    244,
    2546,
    474,
    495,
    1046,
    2611,
    1851,
    2061,
    71,
    2089,
    1675,
    2590,
    742,
    3758,
    2843,
    3222,
    1433,
    267,
    2180,
    2576,
    2826,
    2233,
    2092,
    3913,
    2435,
    956,
    1745,
    3075,
    856,
    2113,
    1116,
    451,
    3,
    1988,
    2896,
    1398,
    993,
    2463,
    1878,
    2049,
    1341,
    2718,
    2721,
    2870,
    2108,
    712,
    2904,
    4363,
    2753,
    2324,
    277,
    2872,
    2349,
    2649,
    384,
    987,
    435,
    691,
    3000,
    922,
    164,
    3939,
    652,
    1500,
    1184,
    4153,
    2482,
    3373,
    2165,
    4848,
    2335,
    3775,
    3508,
    3154,
    2806,
    2830,
    1554,
    2102,
    1664,
    2530,
    1434,
    2408,
    893,
    1547,
    2623,
    3447,
    2832,
    2242,
    2532,
    3169,
    2856,
    3223,
    2078,
    49,
    3770,
    3469,
    462,
    318,
    656,
    2259,
    3250,
    3069,
    679,
    1629,
    2758,
    344,
    1138,
    1104,
    3120,
    1836,
    1283,
    3115,
    2154,
    1437,
    4448,
    934,
    759,
    1999,
    794,
    2862,
    1038,
    533,
    2560,
    1722,
    2342,
    855,
    2626,
    1197,
    1663,
    4476,
    3127,
    85,
    4240,
    2528,
    25,
    1111,
    1181,
    3673,
    407,
    3470,
    4561,
    2679,
    2713,
    768,
    1925,
    2841,
    3986,
    1544,
    1165,
    932,
    373,
    1240,
    2146,
    1930,
    2673,
    721,
    4766,
    354,
    4333,
    391,
    2963,
    187,
    61,
    3364,
    1442,
    1102,
    330,
    1940,
    1767,
    341,
    3809,
    4118,
    393,
    2496,
    2062,
    2211,
    105,
    331,
    300,
    439,
    913,
    1332,
    626,
    379,
    3304,
    1557,
    328,
    689,
    3952,
    309,
    1555,
    931,
    317,
    2517,
    3027,
    325,
    569,
    686,
    2107,
    3084,
    60,
    1042,
    1333,
    2794,
    264,
    3177,
    4014,
    1628,
    258,
    3712,
    7,
    4464,
    1176,
    1043,
    1778,
    683,
    114,
    1975,
    78,
    1492,
    383,
    1886,
    510,
    386,
    645,
    5291,
    2891,
    2069,
    3305,
    4138,
    3867,
    2939,
    2603,
    2493,
    1935,
    1066,
    1848,
    3588,
    1015,
    1282,
    1289,
    4609,
    697,
    1453,
    3044,
    2666,
    3611,
    1856,
    2412,
    54,
    719,
    1330,
    568,
    3778,
    2459,
    1748,
    788,
    492,
    551,
    1191,
    1000,
    488,
    3394,
    3763,
    282,
    1799,
    348,
    2016,
    1523,
    3155,
    2390,
    1049,
    382,
    2019,
    1788,
    1170,
    729,
    2968,
    3523,
    897,
    3926,
    2785,
    2938,
    3292,
    350,
    2319,
    3238,
    1718,
    1717,
    2655,
    3453,
    3143,
    4465,
    161,
    2889,
    2980,
    2009,
    1421,
    56,
    1908,
    1640,
    2387,
    2232,
    1917,
    1874,
    2477,
    4921,
    148,
    83,
    3438,
    592,
    4245,
    2882,
    1822,
    1055,
    741,
    115,
    1496,
    1624,
    381,
    1638,
    4592,
    1020,
    516,
    3214,
    458,
    947,
    4575,
    1432,
    211,
    1514,
    2926,
    1865,
    2142,
    189,
    852,
    1221,
    1400,
    1486,
    882,
    2299,
    4036,
    351,
    28,
    1122,
    700,
    6479,
    6480,
    6481,
    6482,
    6483,
    //Everything below is of no interest for detection purpose
    5508,
    6484,
    3900,
    3414,
    3974,
    4441,
    4024,
    3537,
    4037,
    5628,
    5099,
    3633,
    6485,
    3148,
    6486,
    3636,
    5509,
    3257,
    5510,
    5973,
    5445,
    5872,
    4941,
    4403,
    3174,
    4627,
    5873,
    6276,
    2286,
    4230,
    5446,
    5874,
    5122,
    6102,
    6103,
    4162,
    5447,
    5123,
    5323,
    4849,
    6277,
    3980,
    3851,
    5066,
    4246,
    5774,
    5067,
    6278,
    3001,
    2807,
    5695,
    3346,
    5775,
    5974,
    5158,
    5448,
    6487,
    5975,
    5976,
    5776,
    3598,
    6279,
    5696,
    4806,
    4211,
    4154,
    6280,
    6488,
    6489,
    6490,
    6281,
    4212,
    5037,
    3374,
    4171,
    6491,
    4562,
    4807,
    4722,
    4827,
    5977,
    6104,
    4532,
    4079,
    5159,
    5324,
    5160,
    4404,
    3858,
    5359,
    5875,
    3975,
    4288,
    4610,
    3486,
    4512,
    5325,
    3893,
    5360,
    6282,
    6283,
    5560,
    2522,
    4231,
    5978,
    5186,
    5449,
    2569,
    3878,
    6284,
    5401,
    3578,
    4415,
    6285,
    4656,
    5124,
    5979,
    2506,
    4247,
    4449,
    3219,
    3417,
    4334,
    4969,
    4329,
    6492,
    4576,
    4828,
    4172,
    4416,
    4829,
    5402,
    6286,
    3927,
    3852,
    5361,
    4369,
    4830,
    4477,
    4867,
    5876,
    4173,
    6493,
    6105,
    4657,
    6287,
    6106,
    5877,
    5450,
    6494,
    4155,
    4868,
    5451,
    3700,
    5629,
    4384,
    6288,
    6289,
    5878,
    3189,
    4881,
    6107,
    6290,
    6495,
    4513,
    6496,
    4692,
    4515,
    4723,
    5100,
    3356,
    6497,
    6291,
    3810,
    4080,
    5561,
    3570,
    4430,
    5980,
    6498,
    4355,
    5697,
    6499,
    4724,
    6108,
    6109,
    3764,
    4050,
    5038,
    5879,
    4093,
    3226,
    6292,
    5068,
    5217,
    4693,
    3342,
    5630,
    3504,
    4831,
    4377,
    4466,
    4309,
    5698,
    4431,
    5777,
    6293,
    5778,
    4272,
    3706,
    6110,
    5326,
    3752,
    4676,
    5327,
    4273,
    5403,
    4767,
    5631,
    6500,
    5699,
    5880,
    3475,
    5039,
    6294,
    5562,
    5125,
    4348,
    4301,
    4482,
    4068,
    5126,
    4593,
    5700,
    3380,
    3462,
    5981,
    5563,
    3824,
    5404,
    4970,
    5511,
    3825,
    4738,
    6295,
    6501,
    5452,
    4516,
    6111,
    5881,
    5564,
    6502,
    6296,
    5982,
    6503,
    4213,
    4163,
    3454,
    6504,
    6112,
    4009,
    4450,
    6113,
    4658,
    6297,
    6114,
    3035,
    6505,
    6115,
    3995,
    4904,
    4739,
    4563,
    4942,
    4110,
    5040,
    3661,
    3928,
    5362,
    3674,
    6506,
    5292,
    3612,
    4791,
    5565,
    4149,
    5983,
    5328,
    5259,
    5021,
    4725,
    4577,
    4564,
    4517,
    4364,
    6298,
    5405,
    4578,
    5260,
    4594,
    4156,
    4157,
    5453,
    3592,
    3491,
    6507,
    5127,
    5512,
    4709,
    4922,
    5984,
    5701,
    4726,
    4289,
    6508,
    4015,
    6116,
    5128,
    4628,
    3424,
    4241,
    5779,
    6299,
    4905,
    6509,
    6510,
    5454,
    5702,
    5780,
    6300,
    4365,
    4923,
    3971,
    6511,
    5161,
    3270,
    3158,
    5985,
    4100,
    867,
    5129,
    5703,
    6117,
    5363,
    3695,
    3301,
    5513,
    4467,
    6118,
    6512,
    5455,
    4232,
    4242,
    4629,
    6513,
    3959,
    4478,
    6514,
    5514,
    5329,
    5986,
    4850,
    5162,
    5566,
    3846,
    4694,
    6119,
    5456,
    4869,
    5781,
    3779,
    6301,
    5704,
    5987,
    5515,
    4710,
    6302,
    5882,
    6120,
    4392,
    5364,
    5705,
    6515,
    6121,
    6516,
    6517,
    3736,
    5988,
    5457,
    5989,
    4695,
    2457,
    5883,
    4551,
    5782,
    6303,
    6304,
    6305,
    5130,
    4971,
    6122,
    5163,
    6123,
    4870,
    3263,
    5365,
    3150,
    4871,
    6518,
    6306,
    5783,
    5069,
    5706,
    3513,
    3498,
    4409,
    5330,
    5632,
    5366,
    5458,
    5459,
    3991,
    5990,
    4502,
    3324,
    5991,
    5784,
    3696,
    4518,
    5633,
    4119,
    6519,
    4630,
    5634,
    4417,
    5707,
    4832,
    5992,
    3418,
    6124,
    5993,
    5567,
    4768,
    5218,
    6520,
    4595,
    3458,
    5367,
    6125,
    5635,
    6126,
    4202,
    6521,
    4740,
    4924,
    6307,
    3981,
    4069,
    4385,
    6308,
    3883,
    2675,
    4051,
    3834,
    4302,
    4483,
    5568,
    5994,
    4972,
    4101,
    5368,
    6309,
    5164,
    5884,
    3922,
    6127,
    6522,
    6523,
    5261,
    5460,
    5187,
    4164,
    5219,
    3538,
    5516,
    4111,
    3524,
    5995,
    6310,
    6311,
    5369,
    3181,
    3386,
    2484,
    5188,
    3464,
    5569,
    3627,
    5708,
    6524,
    5406,
    5165,
    4677,
    4492,
    6312,
    4872,
    4851,
    5885,
    4468,
    5996,
    6313,
    5709,
    5710,
    6128,
    2470,
    5886,
    6314,
    5293,
    4882,
    5785,
    3325,
    5461,
    5101,
    6129,
    5711,
    5786,
    6525,
    4906,
    6526,
    6527,
    4418,
    5887,
    5712,
    4808,
    2907,
    3701,
    5713,
    5888,
    6528,
    3765,
    5636,
    5331,
    6529,
    6530,
    3593,
    5889,
    3637,
    4943,
    3692,
    5714,
    5787,
    4925,
    6315,
    6130,
    5462,
    4405,
    6131,
    6132,
    6316,
    5262,
    6531,
    6532,
    5715,
    3859,
    5716,
    5070,
    4696,
    5102,
    3929,
    5788,
    3987,
    4792,
    5997,
    6533,
    6534,
    3920,
    4809,
    5000,
    5998,
    6535,
    2974,
    5370,
    6317,
    5189,
    5263,
    5717,
    3826,
    6536,
    3953,
    5001,
    4883,
    3190,
    5463,
    5890,
    4973,
    5999,
    4741,
    6133,
    6134,
    3607,
    5570,
    6000,
    4711,
    3362,
    3630,
    4552,
    5041,
    6318,
    6001,
    2950,
    2953,
    5637,
    4646,
    5371,
    4944,
    6002,
    2044,
    4120,
    3429,
    6319,
    6537,
    5103,
    4833,
    6538,
    6539,
    4884,
    4647,
    3884,
    6003,
    6004,
    4758,
    3835,
    5220,
    5789,
    4565,
    5407,
    6540,
    6135,
    5294,
    4697,
    4852,
    6320,
    6321,
    3206,
    4907,
    6541,
    6322,
    4945,
    6542,
    6136,
    6543,
    6323,
    6005,
    4631,
    3519,
    6544,
    5891,
    6545,
    5464,
    3784,
    5221,
    6546,
    5571,
    4659,
    6547,
    6324,
    6137,
    5190,
    6548,
    3853,
    6549,
    4016,
    4834,
    3954,
    6138,
    5332,
    3827,
    4017,
    3210,
    3546,
    4469,
    5408,
    5718,
    3505,
    4648,
    5790,
    5131,
    5638,
    5791,
    5465,
    4727,
    4318,
    6325,
    6326,
    5792,
    4553,
    4010,
    4698,
    3439,
    4974,
    3638,
    4335,
    3085,
    6006,
    5104,
    5042,
    5166,
    5892,
    5572,
    6327,
    4356,
    4519,
    5222,
    5573,
    5333,
    5793,
    5043,
    6550,
    5639,
    5071,
    4503,
    6328,
    6139,
    6551,
    6140,
    3914,
    3901,
    5372,
    6007,
    5640,
    4728,
    4793,
    3976,
    3836,
    4885,
    6552,
    4127,
    6553,
    4451,
    4102,
    5002,
    6554,
    3686,
    5105,
    6555,
    5191,
    5072,
    5295,
    4611,
    5794,
    5296,
    6556,
    5893,
    5264,
    5894,
    4975,
    5466,
    5265,
    4699,
    4976,
    4370,
    4056,
    3492,
    5044,
    4886,
    6557,
    5795,
    4432,
    4769,
    4357,
    5467,
    3940,
    4660,
    4290,
    6141,
    4484,
    4770,
    4661,
    3992,
    6329,
    4025,
    4662,
    5022,
    4632,
    4835,
    4070,
    5297,
    4663,
    4596,
    5574,
    5132,
    5409,
    5895,
    6142,
    4504,
    5192,
    4664,
    5796,
    5896,
    3885,
    5575,
    5797,
    5023,
    4810,
    5798,
    3732,
    5223,
    4712,
    5298,
    4084,
    5334,
    5468,
    6143,
    4052,
    4053,
    4336,
    4977,
    4794,
    6558,
    5335,
    4908,
    5576,
    5224,
    4233,
    5024,
    4128,
    5469,
    5225,
    4873,
    6008,
    5045,
    4729,
    4742,
    4633,
    3675,
    4597,
    6559,
    5897,
    5133,
    5577,
    5003,
    5641,
    5719,
    6330,
    6560,
    3017,
    2382,
    3854,
    4406,
    4811,
    6331,
    4393,
    3964,
    4946,
    6561,
    2420,
    3722,
    6562,
    4926,
    4378,
    3247,
    1736,
    4442,
    6332,
    5134,
    6333,
    5226,
    3996,
    2918,
    5470,
    4319,
    4003,
    4598,
    4743,
    4744,
    4485,
    3785,
    3902,
    5167,
    5004,
    5373,
    4394,
    5898,
    6144,
    4874,
    1793,
    3997,
    6334,
    4085,
    4214,
    5106,
    5642,
    4909,
    5799,
    6009,
    4419,
    4189,
    3330,
    5899,
    4165,
    4420,
    5299,
    5720,
    5227,
    3347,
    6145,
    4081,
    6335,
    2876,
    3930,
    6146,
    3293,
    3786,
    3910,
    3998,
    5900,
    5300,
    5578,
    2840,
    6563,
    5901,
    5579,
    6147,
    3531,
    5374,
    6564,
    6565,
    5580,
    4759,
    5375,
    6566,
    6148,
    3559,
    5643,
    6336,
    6010,
    5517,
    6337,
    6338,
    5721,
    5902,
    3873,
    6011,
    6339,
    6567,
    5518,
    3868,
    3649,
    5722,
    6568,
    4771,
    4947,
    6569,
    6149,
    4812,
    6570,
    2853,
    5471,
    6340,
    6341,
    5644,
    4795,
    6342,
    6012,
    5723,
    6343,
    5724,
    6013,
    4349,
    6344,
    3160,
    6150,
    5193,
    4599,
    4514,
    4493,
    5168,
    4320,
    6345,
    4927,
    3666,
    4745,
    5169,
    5903,
    5005,
    4928,
    6346,
    5725,
    6014,
    4730,
    4203,
    5046,
    4948,
    3395,
    5170,
    6015,
    4150,
    6016,
    5726,
    5519,
    6347,
    5047,
    3550,
    6151,
    6348,
    4197,
    4310,
    5904,
    6571,
    5581,
    2965,
    6152,
    4978,
    3960,
    4291,
    5135,
    6572,
    5301,
    5727,
    4129,
    4026,
    5905,
    4853,
    5728,
    5472,
    6153,
    6349,
    4533,
    2700,
    4505,
    5336,
    4678,
    3583,
    5073,
    2994,
    4486,
    3043,
    4554,
    5520,
    6350,
    6017,
    5800,
    4487,
    6351,
    3931,
    4103,
    5376,
    6352,
    4011,
    4321,
    4311,
    4190,
    5136,
    6018,
    3988,
    3233,
    4350,
    5906,
    5645,
    4198,
    6573,
    5107,
    3432,
    4191,
    3435,
    5582,
    6574,
    4139,
    5410,
    6353,
    5411,
    3944,
    5583,
    5074,
    3198,
    6575,
    6354,
    4358,
    6576,
    5302,
    4600,
    5584,
    5194,
    5412,
    6577,
    6578,
    5585,
    5413,
    5303,
    4248,
    5414,
    3879,
    4433,
    6579,
    4479,
    5025,
    4854,
    5415,
    6355,
    4760,
    4772,
    3683,
    2978,
    4700,
    3797,
    4452,
    3965,
    3932,
    3721,
    4910,
    5801,
    6580,
    5195,
    3551,
    5907,
    3221,
    3471,
    3029,
    6019,
    3999,
    5908,
    5909,
    5266,
    5267,
    3444,
    3023,
    3828,
    3170,
    4796,
    5646,
    4979,
    4259,
    6356,
    5647,
    5337,
    3694,
    6357,
    5648,
    5338,
    4520,
    4322,
    5802,
    3031,
    3759,
    4071,
    6020,
    5586,
    4836,
    4386,
    5048,
    6581,
    3571,
    4679,
    4174,
    4949,
    6154,
    4813,
    3787,
    3402,
    3822,
    3958,
    3215,
    3552,
    5268,
    4387,
    3933,
    4950,
    4359,
    6021,
    5910,
    5075,
    3579,
    6358,
    4234,
    4566,
    5521,
    6359,
    3613,
    5049,
    6022,
    5911,
    3375,
    3702,
    3178,
    4911,
    5339,
    4521,
    6582,
    6583,
    4395,
    3087,
    3811,
    5377,
    6023,
    6360,
    6155,
    4027,
    5171,
    5649,
    4421,
    4249,
    2804,
    6584,
    2270,
    6585,
    4000,
    4235,
    3045,
    6156,
    5137,
    5729,
    4140,
    4312,
    3886,
    6361,
    4330,
    6157,
    4215,
    6158,
    3500,
    3676,
    4929,
    4331,
    3713,
    4930,
    5912,
    4265,
    3776,
    3368,
    5587,
    4470,
    4855,
    3038,
    4980,
    3631,
    6159,
    6160,
    4132,
    4680,
    6161,
    6362,
    3923,
    4379,
    5588,
    4255,
    6586,
    4121,
    6587,
    6363,
    4649,
    6364,
    3288,
    4773,
    4774,
    6162,
    6024,
    6365,
    3543,
    6588,
    4274,
    3107,
    3737,
    5050,
    5803,
    4797,
    4522,
    5589,
    5051,
    5730,
    3714,
    4887,
    5378,
    4001,
    4523,
    6163,
    5026,
    5522,
    4701,
    4175,
    2791,
    3760,
    6589,
    5473,
    4224,
    4133,
    3847,
    4814,
    4815,
    4775,
    3259,
    5416,
    6590,
    2738,
    6164,
    6025,
    5304,
    3733,
    5076,
    5650,
    4816,
    5590,
    6591,
    6165,
    6592,
    3934,
    5269,
    6593,
    3396,
    5340,
    6594,
    5804,
    3445,
    3602,
    4042,
    4488,
    5731,
    5732,
    3525,
    5591,
    4601,
    5196,
    6166,
    6026,
    5172,
    3642,
    4612,
    3202,
    4506,
    4798,
    6366,
    3818,
    5108,
    4303,
    5138,
    5139,
    4776,
    3332,
    4304,
    2915,
    3415,
    4434,
    5077,
    5109,
    4856,
    2879,
    5305,
    4817,
    6595,
    5913,
    3104,
    3144,
    3903,
    4634,
    5341,
    3133,
    5110,
    5651,
    5805,
    6167,
    4057,
    5592,
    2945,
    4371,
    5593,
    6596,
    3474,
    4182,
    6367,
    6597,
    6168,
    4507,
    4279,
    6598,
    2822,
    6599,
    4777,
    4713,
    5594,
    3829,
    6169,
    3887,
    5417,
    6170,
    3653,
    5474,
    6368,
    4216,
    2971,
    5228,
    3790,
    4579,
    6369,
    5733,
    6600,
    6601,
    4951,
    4746,
    4555,
    6602,
    5418,
    5475,
    6027,
    3400,
    4665,
    5806,
    6171,
    4799,
    6028,
    5052,
    6172,
    3343,
    4800,
    4747,
    5006,
    6370,
    4556,
    4217,
    5476,
    4396,
    5229,
    5379,
    5477,
    3839,
    5914,
    5652,
    5807,
    4714,
    3068,
    4635,
    5808,
    6173,
    5342,
    4192,
    5078,
    5419,
    5523,
    5734,
    6174,
    4557,
    6175,
    4602,
    6371,
    6176,
    6603,
    5809,
    6372,
    5735,
    4260,
    3869,
    5111,
    5230,
    6029,
    5112,
    6177,
    3126,
    4681,
    5524,
    5915,
    2706,
    3563,
    4748,
    3130,
    6178,
    4018,
    5525,
    6604,
    6605,
    5478,
    4012,
    4837,
    6606,
    4534,
    4193,
    5810,
    4857,
    3615,
    5479,
    6030,
    4082,
    3697,
    3539,
    4086,
    5270,
    3662,
    4508,
    4931,
    5916,
    4912,
    5811,
    5027,
    3888,
    6607,
    4397,
    3527,
    3302,
    3798,
    2775,
    2921,
    2637,
    3966,
    4122,
    4388,
    4028,
    4054,
    1633,
    4858,
    5079,
    3024,
    5007,
    3982,
    3412,
    5736,
    6608,
    3426,
    3236,
    5595,
    3030,
    6179,
    3427,
    3336,
    3279,
    3110,
    6373,
    3874,
    3039,
    5080,
    5917,
    5140,
    4489,
    3119,
    6374,
    5812,
    3405,
    4494,
    6031,
    4666,
    4141,
    6180,
    4166,
    6032,
    5813,
    4981,
    6609,
    5081,
    4422,
    4982,
    4112,
    3915,
    5653,
    3296,
    3983,
    6375,
    4266,
    4410,
    5654,
    6610,
    6181,
    3436,
    5082,
    6611,
    5380,
    6033,
    3819,
    5596,
    4535,
    5231,
    5306,
    5113,
    6612,
    4952,
    5918,
    4275,
    3113,
    6613,
    6376,
    6182,
    6183,
    5814,
    3073,
    4731,
    4838,
    5008,
    3831,
    6614,
    4888,
    3090,
    3848,
    4280,
    5526,
    5232,
    3014,
    5655,
    5009,
    5737,
    5420,
    5527,
    6615,
    5815,
    5343,
    5173,
    5381,
    4818,
    6616,
    3151,
    4953,
    6617,
    5738,
    2796,
    3204,
    4360,
    2989,
    4281,
    5739,
    5174,
    5421,
    5197,
    3132,
    5141,
    3849,
    5142,
    5528,
    5083,
    3799,
    3904,
    4839,
    5480,
    2880,
    4495,
    3448,
    6377,
    6184,
    5271,
    5919,
    3771,
    3193,
    6034,
    6035,
    5920,
    5010,
    6036,
    5597,
    6037,
    6378,
    6038,
    3106,
    5422,
    6618,
    5423,
    5424,
    4142,
    6619,
    4889,
    5084,
    4890,
    4313,
    5740,
    6620,
    3437,
    5175,
    5307,
    5816,
    4199,
    5198,
    5529,
    5817,
    5199,
    5656,
    4913,
    5028,
    5344,
    3850,
    6185,
    2955,
    5272,
    5011,
    5818,
    4567,
    4580,
    5029,
    5921,
    3616,
    5233,
    6621,
    6622,
    6186,
    4176,
    6039,
    6379,
    6380,
    3352,
    5200,
    5273,
    2908,
    5598,
    5234,
    3837,
    5308,
    6623,
    6624,
    5819,
    4496,
    4323,
    5309,
    5201,
    6625,
    6626,
    4983,
    3194,
    3838,
    4167,
    5530,
    5922,
    5274,
    6381,
    6382,
    3860,
    3861,
    5599,
    3333,
    4292,
    4509,
    6383,
    3553,
    5481,
    5820,
    5531,
    4778,
    6187,
    3955,
    3956,
    4324,
    4389,
    4218,
    3945,
    4325,
    3397,
    2681,
    5923,
    4779,
    5085,
    4019,
    5482,
    4891,
    5382,
    5383,
    6040,
    4682,
    3425,
    5275,
    4094,
    6627,
    5310,
    3015,
    5483,
    5657,
    4398,
    5924,
    3168,
    4819,
    6628,
    5925,
    6629,
    5532,
    4932,
    4613,
    6041,
    6630,
    4636,
    6384,
    4780,
    4204,
    5658,
    4423,
    5821,
    3989,
    4683,
    5822,
    6385,
    4954,
    6631,
    5345,
    6188,
    5425,
    5012,
    5384,
    3894,
    6386,
    4490,
    4104,
    6632,
    5741,
    5053,
    6633,
    5823,
    5926,
    5659,
    5660,
    5927,
    6634,
    5235,
    5742,
    5824,
    4840,
    4933,
    4820,
    6387,
    4859,
    5928,
    4955,
    6388,
    4143,
    3584,
    5825,
    5346,
    5013,
    6635,
    5661,
    6389,
    5014,
    5484,
    5743,
    4337,
    5176,
    5662,
    6390,
    2836,
    6391,
    3268,
    6392,
    6636,
    6042,
    5236,
    6637,
    4158,
    6638,
    5744,
    5663,
    4471,
    5347,
    3663,
    4123,
    5143,
    4293,
    3895,
    6639,
    6640,
    5311,
    5929,
    5826,
    3800,
    6189,
    6393,
    6190,
    5664,
    5348,
    3554,
    3594,
    4749,
    4603,
    6641,
    5385,
    4801,
    6043,
    5827,
    4183,
    6642,
    5312,
    5426,
    4761,
    6394,
    5665,
    6191,
    4715,
    2669,
    6643,
    6644,
    5533,
    3185,
    5427,
    5086,
    5930,
    5931,
    5386,
    6192,
    6044,
    6645,
    4781,
    4013,
    5745,
    4282,
    4435,
    5534,
    4390,
    4267,
    6045,
    5746,
    4984,
    6046,
    2743,
    6193,
    3501,
    4087,
    5485,
    5932,
    5428,
    4184,
    4095,
    5747,
    4061,
    5054,
    3058,
    3862,
    5933,
    5600,
    6646,
    5144,
    3618,
    6395,
    3131,
    5055,
    5313,
    6396,
    4650,
    4956,
    3855,
    6194,
    3896,
    5202,
    4985,
    4029,
    4225,
    6195,
    6647,
    5828,
    5486,
    5829,
    3589,
    3002,
    6648,
    6397,
    4782,
    5276,
    6649,
    6196,
    6650,
    4105,
    3803,
    4043,
    5237,
    5830,
    6398,
    4096,
    3643,
    6399,
    3528,
    6651,
    4453,
    3315,
    4637,
    6652,
    3984,
    6197,
    5535,
    3182,
    3339,
    6653,
    3096,
    2660,
    6400,
    6654,
    3449,
    5934,
    4250,
    4236,
    6047,
    6401,
    5831,
    6655,
    5487,
    3753,
    4062,
    5832,
    6198,
    6199,
    6656,
    3766,
    6657,
    3403,
    4667,
    6048,
    6658,
    4338,
    2897,
    5833,
    3880,
    2797,
    3780,
    4326,
    6659,
    5748,
    5015,
    6660,
    5387,
    4351,
    5601,
    4411,
    6661,
    3654,
    4424,
    5935,
    4339,
    4072,
    5277,
    4568,
    5536,
    6402,
    6662,
    5238,
    6663,
    5349,
    5203,
    6200,
    5204,
    6201,
    5145,
    4536,
    5016,
    5056,
    4762,
    5834,
    4399,
    4957,
    6202,
    6403,
    5666,
    5749,
    6664,
    4340,
    6665,
    5936,
    5177,
    5667,
    6666,
    6667,
    3459,
    4668,
    6404,
    6668,
    6669,
    4543,
    6203,
    6670,
    4276,
    6405,
    4480,
    5537,
    6671,
    4614,
    5205,
    5668,
    6672,
    3348,
    2193,
    4763,
    6406,
    6204,
    5937,
    5602,
    4177,
    5669,
    3419,
    6673,
    4020,
    6205,
    4443,
    4569,
    5388,
    3715,
    3639,
    6407,
    6049,
    4058,
    6206,
    6674,
    5938,
    4544,
    6050,
    4185,
    4294,
    4841,
    4651,
    4615,
    5488,
    6207,
    6408,
    6051,
    5178,
    3241,
    3509,
    5835,
    6208,
    4958,
    5836,
    4341,
    5489,
    5278,
    6209,
    2823,
    5538,
    5350,
    5206,
    5429,
    6675,
    4638,
    4875,
    4073,
    3516,
    4684,
    4914,
    4860,
    5939,
    5603,
    5389,
    6052,
    5057,
    3237,
    5490,
    3791,
    6676,
    6409,
    6677,
    4821,
    4915,
    4106,
    5351,
    5058,
    4243,
    5539,
    4244,
    5604,
    4842,
    4916,
    5239,
    3028,
    3716,
    5837,
    5114,
    5605,
    5390,
    5940,
    5430,
    6210,
    4332,
    6678,
    5540,
    4732,
    3667,
    3840,
    6053,
    4305,
    3408,
    5670,
    5541,
    6410,
    2744,
    5240,
    5750,
    6679,
    3234,
    5606,
    6680,
    5607,
    5671,
    3608,
    4283,
    4159,
    4400,
    5352,
    4783,
    6681,
    6411,
    6682,
    4491,
    4802,
    6211,
    6412,
    5941,
    6413,
    6414,
    5542,
    5751,
    6683,
    4669,
    3734,
    5942,
    6684,
    6415,
    5943,
    5059,
    3328,
    4670,
    4144,
    4268,
    6685,
    6686,
    6687,
    6688,
    4372,
    3603,
    6689,
    5944,
    5491,
    4373,
    3440,
    6416,
    5543,
    4784,
    4822,
    5608,
    3792,
    4616,
    5838,
    5672,
    3514,
    5391,
    6417,
    4892,
    6690,
    4639,
    6691,
    6054,
    5673,
    5839,
    6055,
    6692,
    6056,
    5392,
    6212,
    4038,
    5544,
    5674,
    4497,
    6057,
    6693,
    5840,
    4284,
    5675,
    4021,
    4545,
    5609,
    6418,
    4454,
    6419,
    6213,
    4113,
    4472,
    5314,
    3738,
    5087,
    5279,
    4074,
    5610,
    4959,
    4063,
    3179,
    4750,
    6058,
    6420,
    6214,
    3476,
    4498,
    4716,
    5431,
    4960,
    4685,
    6215,
    5241,
    6694,
    6421,
    6216,
    6695,
    5841,
    5945,
    6422,
    3748,
    5946,
    5179,
    3905,
    5752,
    5545,
    5947,
    4374,
    6217,
    4455,
    6423,
    4412,
    6218,
    4803,
    5353,
    6696,
    3832,
    5280,
    6219,
    4327,
    4702,
    6220,
    6221,
    6059,
    4652,
    5432,
    6424,
    3749,
    4751,
    6425,
    5753,
    4986,
    5393,
    4917,
    5948,
    5030,
    5754,
    4861,
    4733,
    6426,
    4703,
    6697,
    6222,
    4671,
    5949,
    4546,
    4961,
    5180,
    6223,
    5031,
    3316,
    5281,
    6698,
    4862,
    4295,
    4934,
    5207,
    3644,
    6427,
    5842,
    5950,
    6428,
    6429,
    4570,
    5843,
    5282,
    6430,
    6224,
    5088,
    3239,
    6060,
    6699,
    5844,
    5755,
    6061,
    6431,
    2701,
    5546,
    6432,
    5115,
    5676,
    4039,
    3993,
    3327,
    4752,
    4425,
    5315,
    6433,
    3941,
    6434,
    5677,
    4617,
    4604,
    3074,
    4581,
    6225,
    5433,
    6435,
    6226,
    6062,
    4823,
    5756,
    5116,
    6227,
    3717,
    5678,
    4717,
    5845,
    6436,
    5679,
    5846,
    6063,
    5847,
    6064,
    3977,
    3354,
    6437,
    3863,
    5117,
    6228,
    5547,
    5394,
    4499,
    4524,
    6229,
    4605,
    6230,
    4306,
    4500,
    6700,
    5951,
    6065,
    3693,
    5952,
    5089,
    4366,
    4918,
    6701,
    6231,
    5548,
    6232,
    6702,
    6438,
    4704,
    5434,
    6703,
    6704,
    5953,
    4168,
    6705,
    5680,
    3420,
    6706,
    5242,
    4407,
    6066,
    3812,
    5757,
    5090,
    5954,
    4672,
    4525,
    3481,
    5681,
    4618,
    5395,
    5354,
    5316,
    5955,
    6439,
    4962,
    6707,
    4526,
    6440,
    3465,
    4673,
    6067,
    6441,
    5682,
    6708,
    5435,
    5492,
    5758,
    5683,
    4619,
    4571,
    4674,
    4804,
    4893,
    4686,
    5493,
    4753,
    6233,
    6068,
    4269,
    6442,
    6234,
    5032,
    4705,
    5146,
    5243,
    5208,
    5848,
    6235,
    6443,
    4963,
    5033,
    4640,
    4226,
    6236,
    5849,
    3387,
    6444,
    6445,
    4436,
    4437,
    5850,
    4843,
    5494,
    4785,
    4894,
    6709,
    4361,
    6710,
    5091,
    5956,
    3331,
    6237,
    4987,
    5549,
    6069,
    6711,
    4342,
    3517,
    4473,
    5317,
    6070,
    6712,
    6071,
    4706,
    6446,
    5017,
    5355,
    6713,
    6714,
    4988,
    5436,
    6447,
    4734,
    5759,
    6715,
    4735,
    4547,
    4456,
    4754,
    6448,
    5851,
    6449,
    6450,
    3547,
    5852,
    5318,
    6451,
    6452,
    5092,
    4205,
    6716,
    6238,
    4620,
    4219,
    5611,
    6239,
    6072,
    4481,
    5760,
    5957,
    5958,
    4059,
    6240,
    6453,
    4227,
    4537,
    6241,
    5761,
    4030,
    4186,
    5244,
    5209,
    3761,
    4457,
    4876,
    3337,
    5495,
    5181,
    6242,
    5959,
    5319,
    5612,
    5684,
    5853,
    3493,
    5854,
    6073,
    4169,
    5613,
    5147,
    4895,
    6074,
    5210,
    6717,
    5182,
    6718,
    3830,
    6243,
    2798,
    3841,
    6075,
    6244,
    5855,
    5614,
    3604,
    4606,
    5496,
    5685,
    5118,
    5356,
    6719,
    6454,
    5960,
    5357,
    5961,
    6720,
    4145,
    3935,
    4621,
    5119,
    5962,
    4261,
    6721,
    6455,
    4786,
    5963,
    4375,
    4582,
    6245,
    6246,
    6247,
    6076,
    5437,
    4877,
    5856,
    3376,
    4380,
    6248,
    4160,
    6722,
    5148,
    6456,
    5211,
    6457,
    6723,
    4718,
    6458,
    6724,
    6249,
    5358,
    4044,
    3297,
    6459,
    6250,
    5857,
    5615,
    5497,
    5245,
    6460,
    5498,
    6725,
    6251,
    6252,
    5550,
    3793,
    5499,
    2959,
    5396,
    6461,
    6462,
    4572,
    5093,
    5500,
    5964,
    3806,
    4146,
    6463,
    4426,
    5762,
    5858,
    6077,
    6253,
    4755,
    3967,
    4220,
    5965,
    6254,
    4989,
    5501,
    6464,
    4352,
    6726,
    6078,
    4764,
    2290,
    5246,
    3906,
    5438,
    5283,
    3767,
    4964,
    2861,
    5763,
    5094,
    6255,
    6256,
    4622,
    5616,
    5859,
    5860,
    4707,
    6727,
    4285,
    4708,
    4824,
    5617,
    6257,
    5551,
    4787,
    5212,
    4965,
    4935,
    4687,
    6465,
    6728,
    6466,
    5686,
    6079,
    3494,
    4413,
    2995,
    5247,
    5966,
    5618,
    6729,
    5967,
    5764,
    5765,
    5687,
    5502,
    6730,
    6731,
    6080,
    5397,
    6467,
    4990,
    6258,
    6732,
    4538,
    5060,
    5619,
    6733,
    4719,
    5688,
    5439,
    5018,
    5149,
    5284,
    5503,
    6734,
    6081,
    4607,
    6259,
    5120,
    3645,
    5861,
    4583,
    6260,
    4584,
    4675,
    5620,
    4098,
    5440,
    6261,
    4863,
    2379,
    3306,
    4585,
    5552,
    5689,
    4586,
    5285,
    6735,
    4864,
    6736,
    5286,
    6082,
    6737,
    4623,
    3010,
    4788,
    4381,
    4558,
    5621,
    4587,
    4896,
    3698,
    3161,
    5248,
    4353,
    4045,
    6262,
    3754,
    5183,
    4588,
    6738,
    6263,
    6739,
    6740,
    5622,
    3936,
    6741,
    6468,
    6742,
    6264,
    5095,
    6469,
    4991,
    5968,
    6743,
    4992,
    6744,
    6083,
    4897,
    6745,
    4256,
    5766,
    4307,
    3108,
    3968,
    4444,
    5287,
    3889,
    4343,
    6084,
    4510,
    6085,
    4559,
    6086,
    4898,
    5969,
    6746,
    5623,
    5061,
    4919,
    5249,
    5250,
    5504,
    5441,
    6265,
    5320,
    4878,
    3242,
    5862,
    5251,
    3428,
    6087,
    6747,
    4237,
    5624,
    5442,
    6266,
    5553,
    4539,
    6748,
    2585,
    3533,
    5398,
    4262,
    6088,
    5150,
    4736,
    4438,
    6089,
    6267,
    5505,
    4966,
    6749,
    6268,
    6750,
    6269,
    5288,
    5554,
    3650,
    6090,
    6091,
    4624,
    6092,
    5690,
    6751,
    5863,
    4270,
    5691,
    4277,
    5555,
    5864,
    6752,
    5692,
    4720,
    4865,
    6470,
    5151,
    4688,
    4825,
    6753,
    3094,
    6754,
    6471,
    3235,
    4653,
    6755,
    5213,
    5399,
    6756,
    3201,
    4589,
    5865,
    4967,
    6472,
    5866,
    6473,
    5019,
    3016,
    6757,
    5321,
    4756,
    3957,
    4573,
    6093,
    4993,
    5767,
    4721,
    6474,
    6758,
    5625,
    6759,
    4458,
    6475,
    6270,
    6760,
    5556,
    4994,
    5214,
    5252,
    6271,
    3875,
    5768,
    6094,
    5034,
    5506,
    4376,
    5769,
    6761,
    2120,
    6476,
    5253,
    5770,
    6762,
    5771,
    5970,
    3990,
    5971,
    5557,
    5558,
    5772,
    6477,
    6095,
    2787,
    4641,
    5972,
    5121,
    6096,
    6097,
    6272,
    6763,
    3703,
    5867,
    5507,
    6273,
    4206,
    6274,
    4789,
    6098,
    6764,
    3619,
    3646,
    3833,
    3804,
    2394,
    3788,
    4936,
    3978,
    4866,
    4899,
    6099,
    6100,
    5559,
    6478,
    6765,
    3599,
    5868,
    6101,
    5869,
    5870,
    6275,
    6766,
    4527,
    6767
];

});

parcelRegister("61Jcp", function(module, exports) {

$parcel$export(module.exports, "BIG5_TYPICAL_DISTRIBUTION_RATIO", () => $4635e5ae863c7421$export$11012e972caf547d, (v) => $4635e5ae863c7421$export$11012e972caf547d = v);
$parcel$export(module.exports, "BIG5_TABLE_SIZE", () => $4635e5ae863c7421$export$c1edd5729119cd05, (v) => $4635e5ae863c7421$export$c1edd5729119cd05 = v);
$parcel$export(module.exports, "Big5CharToFreqOrder", () => $4635e5ae863c7421$export$4ba21bf6bf2a0df9, (v) => $4635e5ae863c7421$export$4ba21bf6bf2a0df9 = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // Big5 frequency table
// by Taiwan's Mandarin Promotion Council
// <http://www.edu.tw:81/mandr/>
//
// 128  --> 0.42261
// 256  --> 0.57851
// 512  --> 0.74851
// 1024 --> 0.89384
// 2048 --> 0.97583
//
// Ideal Distribution Ratio = 0.74851/(1-0.74851) =2.98
// Random Distribution Ration = 512/(5401-512)=0.105
//
// Typical Distribution Ratio about 25% of Ideal one, still much higher than RDR
var $4635e5ae863c7421$export$11012e972caf547d;
//Char to FreqOrder table
var $4635e5ae863c7421$export$c1edd5729119cd05;
var $4635e5ae863c7421$export$4ba21bf6bf2a0df9;
$4635e5ae863c7421$export$11012e972caf547d = 0.75;
$4635e5ae863c7421$export$c1edd5729119cd05 = 5376;
$4635e5ae863c7421$export$4ba21bf6bf2a0df9 = [
    1,
    1801,
    1506,
    255,
    1431,
    198,
    9,
    82,
    6,
    5008,
    177,
    202,
    3681,
    1256,
    2821,
    110,
    3814,
    33,
    3274,
    261,
    76,
    44,
    2114,
    16,
    2946,
    2187,
    1176,
    659,
    3971,
    26,
    3451,
    2653,
    1198,
    3972,
    3350,
    4202,
    410,
    2215,
    302,
    590,
    361,
    1964,
    8,
    204,
    58,
    4510,
    5009,
    1932,
    63,
    5010,
    5011,
    317,
    1614,
    75,
    222,
    159,
    4203,
    2417,
    1480,
    5012,
    3555,
    3091,
    224,
    2822,
    3682,
    3,
    10,
    3973,
    1471,
    29,
    2787,
    1135,
    2866,
    1940,
    873,
    130,
    3275,
    1123,
    312,
    5013,
    4511,
    2052,
    507,
    252,
    682,
    5014,
    142,
    1915,
    124,
    206,
    2947,
    34,
    3556,
    3204,
    64,
    604,
    5015,
    2501,
    1977,
    1978,
    155,
    1991,
    645,
    641,
    1606,
    5016,
    3452,
    337,
    72,
    406,
    5017,
    80,
    630,
    238,
    3205,
    1509,
    263,
    939,
    1092,
    2654,
    756,
    1440,
    1094,
    3453,
    449,
    69,
    2987,
    591,
    179,
    2096,
    471,
    115,
    2035,
    1844,
    60,
    50,
    2988,
    134,
    806,
    1869,
    734,
    2036,
    3454,
    180,
    995,
    1607,
    156,
    537,
    2907,
    688,
    5018,
    319,
    1305,
    779,
    2145,
    514,
    2379,
    298,
    4512,
    359,
    2502,
    90,
    2716,
    1338,
    663,
    11,
    906,
    1099,
    2553,
    20,
    2441,
    182,
    532,
    1716,
    5019,
    732,
    1376,
    4204,
    1311,
    1420,
    3206,
    25,
    2317,
    1056,
    113,
    399,
    382,
    1950,
    242,
    3455,
    2474,
    529,
    3276,
    475,
    1447,
    3683,
    5020,
    117,
    21,
    656,
    810,
    1297,
    2300,
    2334,
    3557,
    5021,
    126,
    4205,
    706,
    456,
    150,
    613,
    4513,
    71,
    1118,
    2037,
    4206,
    145,
    3092,
    85,
    835,
    486,
    2115,
    1246,
    1426,
    428,
    727,
    1285,
    1015,
    800,
    106,
    623,
    303,
    1281,
    5022,
    2128,
    2359,
    347,
    3815,
    221,
    3558,
    3135,
    5023,
    1956,
    1153,
    4207,
    83,
    296,
    1199,
    3093,
    192,
    624,
    93,
    5024,
    822,
    1898,
    2823,
    3136,
    795,
    2065,
    991,
    1554,
    1542,
    1592,
    27,
    43,
    2867,
    859,
    139,
    1456,
    860,
    4514,
    437,
    712,
    3974,
    164,
    2397,
    3137,
    695,
    211,
    3037,
    2097,
    195,
    3975,
    1608,
    3559,
    3560,
    3684,
    3976,
    234,
    811,
    2989,
    2098,
    3977,
    2233,
    1441,
    3561,
    1615,
    2380,
    668,
    2077,
    1638,
    305,
    228,
    1664,
    4515,
    467,
    415,
    5025,
    262,
    2099,
    1593,
    239,
    108,
    300,
    200,
    1033,
    512,
    1247,
    2078,
    5026,
    5027,
    2176,
    3207,
    3685,
    2682,
    593,
    845,
    1062,
    3277,
    88,
    1723,
    2038,
    3978,
    1951,
    212,
    266,
    152,
    149,
    468,
    1899,
    4208,
    4516,
    77,
    187,
    5028,
    3038,
    37,
    5,
    2990,
    5029,
    3979,
    5030,
    5031,
    39,
    2524,
    4517,
    2908,
    3208,
    2079,
    55,
    148,
    74,
    4518,
    545,
    483,
    1474,
    1029,
    1665,
    217,
    1870,
    1531,
    3138,
    1104,
    2655,
    4209,
    24,
    172,
    3562,
    900,
    3980,
    3563,
    3564,
    4519,
    32,
    1408,
    2824,
    1312,
    329,
    487,
    2360,
    2251,
    2717,
    784,
    2683,
    4,
    3039,
    3351,
    1427,
    1789,
    188,
    109,
    499,
    5032,
    3686,
    1717,
    1790,
    888,
    1217,
    3040,
    4520,
    5033,
    3565,
    5034,
    3352,
    1520,
    3687,
    3981,
    196,
    1034,
    775,
    5035,
    5036,
    929,
    1816,
    249,
    439,
    38,
    5037,
    1063,
    5038,
    794,
    3982,
    1435,
    2301,
    46,
    178,
    3278,
    2066,
    5039,
    2381,
    5040,
    214,
    1709,
    4521,
    804,
    35,
    707,
    324,
    3688,
    1601,
    2554,
    140,
    459,
    4210,
    5041,
    5042,
    1365,
    839,
    272,
    978,
    2262,
    2580,
    3456,
    2129,
    1363,
    3689,
    1423,
    697,
    100,
    3094,
    48,
    70,
    1231,
    495,
    3139,
    2196,
    5043,
    1294,
    5044,
    2080,
    462,
    586,
    1042,
    3279,
    853,
    256,
    988,
    185,
    2382,
    3457,
    1698,
    434,
    1084,
    5045,
    3458,
    314,
    2625,
    2788,
    4522,
    2335,
    2336,
    569,
    2285,
    637,
    1817,
    2525,
    757,
    1162,
    1879,
    1616,
    3459,
    287,
    1577,
    2116,
    768,
    4523,
    1671,
    2868,
    3566,
    2526,
    1321,
    3816,
    909,
    2418,
    5046,
    4211,
    933,
    3817,
    4212,
    2053,
    2361,
    1222,
    4524,
    765,
    2419,
    1322,
    786,
    4525,
    5047,
    1920,
    1462,
    1677,
    2909,
    1699,
    5048,
    4526,
    1424,
    2442,
    3140,
    3690,
    2600,
    3353,
    1775,
    1941,
    3460,
    3983,
    4213,
    309,
    1369,
    1130,
    2825,
    364,
    2234,
    1653,
    1299,
    3984,
    3567,
    3985,
    3986,
    2656,
    525,
    1085,
    3041,
    902,
    2001,
    1475,
    964,
    4527,
    421,
    1845,
    1415,
    1057,
    2286,
    940,
    1364,
    3141,
    376,
    4528,
    4529,
    1381,
    7,
    2527,
    983,
    2383,
    336,
    1710,
    2684,
    1846,
    321,
    3461,
    559,
    1131,
    3042,
    2752,
    1809,
    1132,
    1313,
    265,
    1481,
    1858,
    5049,
    352,
    1203,
    2826,
    3280,
    167,
    1089,
    420,
    2827,
    776,
    792,
    1724,
    3568,
    4214,
    2443,
    3281,
    5050,
    4215,
    5051,
    446,
    229,
    333,
    2753,
    901,
    3818,
    1200,
    1557,
    4530,
    2657,
    1921,
    395,
    2754,
    2685,
    3819,
    4216,
    1836,
    125,
    916,
    3209,
    2626,
    4531,
    5052,
    5053,
    3820,
    5054,
    5055,
    5056,
    4532,
    3142,
    3691,
    1133,
    2555,
    1757,
    3462,
    1510,
    2318,
    1409,
    3569,
    5057,
    2146,
    438,
    2601,
    2910,
    2384,
    3354,
    1068,
    958,
    3043,
    461,
    311,
    2869,
    2686,
    4217,
    1916,
    3210,
    4218,
    1979,
    383,
    750,
    2755,
    2627,
    4219,
    274,
    539,
    385,
    1278,
    1442,
    5058,
    1154,
    1965,
    384,
    561,
    210,
    98,
    1295,
    2556,
    3570,
    5059,
    1711,
    2420,
    1482,
    3463,
    3987,
    2911,
    1257,
    129,
    5060,
    3821,
    642,
    523,
    2789,
    2790,
    2658,
    5061,
    141,
    2235,
    1333,
    68,
    176,
    441,
    876,
    907,
    4220,
    603,
    2602,
    710,
    171,
    3464,
    404,
    549,
    18,
    3143,
    2398,
    1410,
    3692,
    1666,
    5062,
    3571,
    4533,
    2912,
    4534,
    5063,
    2991,
    368,
    5064,
    146,
    366,
    99,
    871,
    3693,
    1543,
    748,
    807,
    1586,
    1185,
    22,
    2263,
    379,
    3822,
    3211,
    5065,
    3212,
    505,
    1942,
    2628,
    1992,
    1382,
    2319,
    5066,
    380,
    2362,
    218,
    702,
    1818,
    1248,
    3465,
    3044,
    3572,
    3355,
    3282,
    5067,
    2992,
    3694,
    930,
    3283,
    3823,
    5068,
    59,
    5069,
    585,
    601,
    4221,
    497,
    3466,
    1112,
    1314,
    4535,
    1802,
    5070,
    1223,
    1472,
    2177,
    5071,
    749,
    1837,
    690,
    1900,
    3824,
    1773,
    3988,
    1476,
    429,
    1043,
    1791,
    2236,
    2117,
    917,
    4222,
    447,
    1086,
    1629,
    5072,
    556,
    5073,
    5074,
    2021,
    1654,
    844,
    1090,
    105,
    550,
    966,
    1758,
    2828,
    1008,
    1783,
    686,
    1095,
    5075,
    2287,
    793,
    1602,
    5076,
    3573,
    2603,
    4536,
    4223,
    2948,
    2302,
    4537,
    3825,
    980,
    2503,
    544,
    353,
    527,
    4538,
    908,
    2687,
    2913,
    5077,
    381,
    2629,
    1943,
    1348,
    5078,
    1341,
    1252,
    560,
    3095,
    5079,
    3467,
    2870,
    5080,
    2054,
    973,
    886,
    2081,
    143,
    4539,
    5081,
    5082,
    157,
    3989,
    496,
    4224,
    57,
    840,
    540,
    2039,
    4540,
    4541,
    3468,
    2118,
    1445,
    970,
    2264,
    1748,
    1966,
    2082,
    4225,
    3144,
    1234,
    1776,
    3284,
    2829,
    3695,
    773,
    1206,
    2130,
    1066,
    2040,
    1326,
    3990,
    1738,
    1725,
    4226,
    279,
    3145,
    51,
    1544,
    2604,
    423,
    1578,
    2131,
    2067,
    173,
    4542,
    1880,
    5083,
    5084,
    1583,
    264,
    610,
    3696,
    4543,
    2444,
    280,
    154,
    5085,
    5086,
    5087,
    1739,
    338,
    1282,
    3096,
    693,
    2871,
    1411,
    1074,
    3826,
    2445,
    5088,
    4544,
    5089,
    5090,
    1240,
    952,
    2399,
    5091,
    2914,
    1538,
    2688,
    685,
    1483,
    4227,
    2475,
    1436,
    953,
    4228,
    2055,
    4545,
    671,
    2400,
    79,
    4229,
    2446,
    3285,
    608,
    567,
    2689,
    3469,
    4230,
    4231,
    1691,
    393,
    1261,
    1792,
    2401,
    5092,
    4546,
    5093,
    5094,
    5095,
    5096,
    1383,
    1672,
    3827,
    3213,
    1464,
    522,
    1119,
    661,
    1150,
    216,
    675,
    4547,
    3991,
    1432,
    3574,
    609,
    4548,
    2690,
    2402,
    5097,
    5098,
    5099,
    4232,
    3045,
    0,
    5100,
    2476,
    315,
    231,
    2447,
    301,
    3356,
    4549,
    2385,
    5101,
    233,
    4233,
    3697,
    1819,
    4550,
    4551,
    5102,
    96,
    1777,
    1315,
    2083,
    5103,
    257,
    5104,
    1810,
    3698,
    2718,
    1139,
    1820,
    4234,
    2022,
    1124,
    2164,
    2791,
    1778,
    2659,
    5105,
    3097,
    363,
    1655,
    3214,
    5106,
    2993,
    5107,
    5108,
    5109,
    3992,
    1567,
    3993,
    718,
    103,
    3215,
    849,
    1443,
    341,
    3357,
    2949,
    1484,
    5110,
    1712,
    127,
    67,
    339,
    4235,
    2403,
    679,
    1412,
    821,
    5111,
    5112,
    834,
    738,
    351,
    2994,
    2147,
    846,
    235,
    1497,
    1881,
    418,
    1993,
    3828,
    2719,
    186,
    1100,
    2148,
    2756,
    3575,
    1545,
    1355,
    2950,
    2872,
    1377,
    583,
    3994,
    4236,
    2581,
    2995,
    5113,
    1298,
    3699,
    1078,
    2557,
    3700,
    2363,
    78,
    3829,
    3830,
    267,
    1289,
    2100,
    2002,
    1594,
    4237,
    348,
    369,
    1274,
    2197,
    2178,
    1838,
    4552,
    1821,
    2830,
    3701,
    2757,
    2288,
    2003,
    4553,
    2951,
    2758,
    144,
    3358,
    882,
    4554,
    3995,
    2759,
    3470,
    4555,
    2915,
    5114,
    4238,
    1726,
    320,
    5115,
    3996,
    3046,
    788,
    2996,
    5116,
    2831,
    1774,
    1327,
    2873,
    3997,
    2832,
    5117,
    1306,
    4556,
    2004,
    1700,
    3831,
    3576,
    2364,
    2660,
    787,
    2023,
    506,
    824,
    3702,
    534,
    323,
    4557,
    1044,
    3359,
    2024,
    1901,
    946,
    3471,
    5118,
    1779,
    1500,
    1678,
    5119,
    1882,
    4558,
    165,
    243,
    4559,
    3703,
    2528,
    123,
    683,
    4239,
    764,
    4560,
    36,
    3998,
    1793,
    589,
    2916,
    816,
    626,
    1667,
    3047,
    2237,
    1639,
    1555,
    1622,
    3832,
    3999,
    5120,
    4000,
    2874,
    1370,
    1228,
    1933,
    891,
    2084,
    2917,
    304,
    4240,
    5121,
    292,
    2997,
    2720,
    3577,
    691,
    2101,
    4241,
    1115,
    4561,
    118,
    662,
    5122,
    611,
    1156,
    854,
    2386,
    1316,
    2875,
    2,
    386,
    515,
    2918,
    5123,
    5124,
    3286,
    868,
    2238,
    1486,
    855,
    2661,
    785,
    2216,
    3048,
    5125,
    1040,
    3216,
    3578,
    5126,
    3146,
    448,
    5127,
    1525,
    5128,
    2165,
    4562,
    5129,
    3833,
    5130,
    4242,
    2833,
    3579,
    3147,
    503,
    818,
    4001,
    3148,
    1568,
    814,
    676,
    1444,
    306,
    1749,
    5131,
    3834,
    1416,
    1030,
    197,
    1428,
    805,
    2834,
    1501,
    4563,
    5132,
    5133,
    5134,
    1994,
    5135,
    4564,
    5136,
    5137,
    2198,
    13,
    2792,
    3704,
    2998,
    3149,
    1229,
    1917,
    5138,
    3835,
    2132,
    5139,
    4243,
    4565,
    2404,
    3580,
    5140,
    2217,
    1511,
    1727,
    1120,
    5141,
    5142,
    646,
    3836,
    2448,
    307,
    5143,
    5144,
    1595,
    3217,
    5145,
    5146,
    5147,
    3705,
    1113,
    1356,
    4002,
    1465,
    2529,
    2530,
    5148,
    519,
    5149,
    128,
    2133,
    92,
    2289,
    1980,
    5150,
    4003,
    1512,
    342,
    3150,
    2199,
    5151,
    2793,
    2218,
    1981,
    3360,
    4244,
    290,
    1656,
    1317,
    789,
    827,
    2365,
    5152,
    3837,
    4566,
    562,
    581,
    4004,
    5153,
    401,
    4567,
    2252,
    94,
    4568,
    5154,
    1399,
    2794,
    5155,
    1463,
    2025,
    4569,
    3218,
    1944,
    5156,
    828,
    1105,
    4245,
    1262,
    1394,
    5157,
    4246,
    605,
    4570,
    5158,
    1784,
    2876,
    5159,
    2835,
    819,
    2102,
    578,
    2200,
    2952,
    5160,
    1502,
    436,
    3287,
    4247,
    3288,
    2836,
    4005,
    2919,
    3472,
    3473,
    5161,
    2721,
    2320,
    5162,
    5163,
    2337,
    2068,
    23,
    4571,
    193,
    826,
    3838,
    2103,
    699,
    1630,
    4248,
    3098,
    390,
    1794,
    1064,
    3581,
    5164,
    1579,
    3099,
    3100,
    1400,
    5165,
    4249,
    1839,
    1640,
    2877,
    5166,
    4572,
    4573,
    137,
    4250,
    598,
    3101,
    1967,
    780,
    104,
    974,
    2953,
    5167,
    278,
    899,
    253,
    402,
    572,
    504,
    493,
    1339,
    5168,
    4006,
    1275,
    4574,
    2582,
    2558,
    5169,
    3706,
    3049,
    3102,
    2253,
    565,
    1334,
    2722,
    863,
    41,
    5170,
    5171,
    4575,
    5172,
    1657,
    2338,
    19,
    463,
    2760,
    4251,
    606,
    5173,
    2999,
    3289,
    1087,
    2085,
    1323,
    2662,
    3000,
    5174,
    1631,
    1623,
    1750,
    4252,
    2691,
    5175,
    2878,
    791,
    2723,
    2663,
    2339,
    232,
    2421,
    5176,
    3001,
    1498,
    5177,
    2664,
    2630,
    755,
    1366,
    3707,
    3290,
    3151,
    2026,
    1609,
    119,
    1918,
    3474,
    862,
    1026,
    4253,
    5178,
    4007,
    3839,
    4576,
    4008,
    4577,
    2265,
    1952,
    2477,
    5179,
    1125,
    817,
    4254,
    4255,
    4009,
    1513,
    1766,
    2041,
    1487,
    4256,
    3050,
    3291,
    2837,
    3840,
    3152,
    5180,
    5181,
    1507,
    5182,
    2692,
    733,
    40,
    1632,
    1106,
    2879,
    345,
    4257,
    841,
    2531,
    230,
    4578,
    3002,
    1847,
    3292,
    3475,
    5183,
    1263,
    986,
    3476,
    5184,
    735,
    879,
    254,
    1137,
    857,
    622,
    1300,
    1180,
    1388,
    1562,
    4010,
    4011,
    2954,
    967,
    2761,
    2665,
    1349,
    592,
    2134,
    1692,
    3361,
    3003,
    1995,
    4258,
    1679,
    4012,
    1902,
    2188,
    5185,
    739,
    3708,
    2724,
    1296,
    1290,
    5186,
    4259,
    2201,
    2202,
    1922,
    1563,
    2605,
    2559,
    1871,
    2762,
    3004,
    5187,
    435,
    5188,
    343,
    1108,
    596,
    17,
    1751,
    4579,
    2239,
    3477,
    3709,
    5189,
    4580,
    294,
    3582,
    2955,
    1693,
    477,
    979,
    281,
    2042,
    3583,
    643,
    2043,
    3710,
    2631,
    2795,
    2266,
    1031,
    2340,
    2135,
    2303,
    3584,
    4581,
    367,
    1249,
    2560,
    5190,
    3585,
    5191,
    4582,
    1283,
    3362,
    2005,
    240,
    1762,
    3363,
    4583,
    4584,
    836,
    1069,
    3153,
    474,
    5192,
    2149,
    2532,
    268,
    3586,
    5193,
    3219,
    1521,
    1284,
    5194,
    1658,
    1546,
    4260,
    5195,
    3587,
    3588,
    5196,
    4261,
    3364,
    2693,
    1685,
    4262,
    961,
    1673,
    2632,
    190,
    2006,
    2203,
    3841,
    4585,
    4586,
    5197,
    570,
    2504,
    3711,
    1490,
    5198,
    4587,
    2633,
    3293,
    1957,
    4588,
    584,
    1514,
    396,
    1045,
    1945,
    5199,
    4589,
    1968,
    2449,
    5200,
    5201,
    4590,
    4013,
    619,
    5202,
    3154,
    3294,
    215,
    2007,
    2796,
    2561,
    3220,
    4591,
    3221,
    4592,
    763,
    4263,
    3842,
    4593,
    5203,
    5204,
    1958,
    1767,
    2956,
    3365,
    3712,
    1174,
    452,
    1477,
    4594,
    3366,
    3155,
    5205,
    2838,
    1253,
    2387,
    2189,
    1091,
    2290,
    4264,
    492,
    5206,
    638,
    1169,
    1825,
    2136,
    1752,
    4014,
    648,
    926,
    1021,
    1324,
    4595,
    520,
    4596,
    997,
    847,
    1007,
    892,
    4597,
    3843,
    2267,
    1872,
    3713,
    2405,
    1785,
    4598,
    1953,
    2957,
    3103,
    3222,
    1728,
    4265,
    2044,
    3714,
    4599,
    2008,
    1701,
    3156,
    1551,
    30,
    2268,
    4266,
    5207,
    2027,
    4600,
    3589,
    5208,
    501,
    5209,
    4267,
    594,
    3478,
    2166,
    1822,
    3590,
    3479,
    3591,
    3223,
    829,
    2839,
    4268,
    5210,
    1680,
    3157,
    1225,
    4269,
    5211,
    3295,
    4601,
    4270,
    3158,
    2341,
    5212,
    4602,
    4271,
    5213,
    4015,
    4016,
    5214,
    1848,
    2388,
    2606,
    3367,
    5215,
    4603,
    374,
    4017,
    652,
    4272,
    4273,
    375,
    1140,
    798,
    5216,
    5217,
    5218,
    2366,
    4604,
    2269,
    546,
    1659,
    138,
    3051,
    2450,
    4605,
    5219,
    2254,
    612,
    1849,
    910,
    796,
    3844,
    1740,
    1371,
    825,
    3845,
    3846,
    5220,
    2920,
    2562,
    5221,
    692,
    444,
    3052,
    2634,
    801,
    4606,
    4274,
    5222,
    1491,
    244,
    1053,
    3053,
    4275,
    4276,
    340,
    5223,
    4018,
    1041,
    3005,
    293,
    1168,
    87,
    1357,
    5224,
    1539,
    959,
    5225,
    2240,
    721,
    694,
    4277,
    3847,
    219,
    1478,
    644,
    1417,
    3368,
    2666,
    1413,
    1401,
    1335,
    1389,
    4019,
    5226,
    5227,
    3006,
    2367,
    3159,
    1826,
    730,
    1515,
    184,
    2840,
    66,
    4607,
    5228,
    1660,
    2958,
    246,
    3369,
    378,
    1457,
    226,
    3480,
    975,
    4020,
    2959,
    1264,
    3592,
    674,
    696,
    5229,
    163,
    5230,
    1141,
    2422,
    2167,
    713,
    3593,
    3370,
    4608,
    4021,
    5231,
    5232,
    1186,
    15,
    5233,
    1079,
    1070,
    5234,
    1522,
    3224,
    3594,
    276,
    1050,
    2725,
    758,
    1126,
    653,
    2960,
    3296,
    5235,
    2342,
    889,
    3595,
    4022,
    3104,
    3007,
    903,
    1250,
    4609,
    4023,
    3481,
    3596,
    1342,
    1681,
    1718,
    766,
    3297,
    286,
    89,
    2961,
    3715,
    5236,
    1713,
    5237,
    2607,
    3371,
    3008,
    5238,
    2962,
    2219,
    3225,
    2880,
    5239,
    4610,
    2505,
    2533,
    181,
    387,
    1075,
    4024,
    731,
    2190,
    3372,
    5240,
    3298,
    310,
    313,
    3482,
    2304,
    770,
    4278,
    54,
    3054,
    189,
    4611,
    3105,
    3848,
    4025,
    5241,
    1230,
    1617,
    1850,
    355,
    3597,
    4279,
    4612,
    3373,
    111,
    4280,
    3716,
    1350,
    3160,
    3483,
    3055,
    4281,
    2150,
    3299,
    3598,
    5242,
    2797,
    4026,
    4027,
    3009,
    722,
    2009,
    5243,
    1071,
    247,
    1207,
    2343,
    2478,
    1378,
    4613,
    2010,
    864,
    1437,
    1214,
    4614,
    373,
    3849,
    1142,
    2220,
    667,
    4615,
    442,
    2763,
    2563,
    3850,
    4028,
    1969,
    4282,
    3300,
    1840,
    837,
    170,
    1107,
    934,
    1336,
    1883,
    5244,
    5245,
    2119,
    4283,
    2841,
    743,
    1569,
    5246,
    4616,
    4284,
    582,
    2389,
    1418,
    3484,
    5247,
    1803,
    5248,
    357,
    1395,
    1729,
    3717,
    3301,
    2423,
    1564,
    2241,
    5249,
    3106,
    3851,
    1633,
    4617,
    1114,
    2086,
    4285,
    1532,
    5250,
    482,
    2451,
    4618,
    5251,
    5252,
    1492,
    833,
    1466,
    5253,
    2726,
    3599,
    1641,
    2842,
    5254,
    1526,
    1272,
    3718,
    4286,
    1686,
    1795,
    416,
    2564,
    1903,
    1954,
    1804,
    5255,
    3852,
    2798,
    3853,
    1159,
    2321,
    5256,
    2881,
    4619,
    1610,
    1584,
    3056,
    2424,
    2764,
    443,
    3302,
    1163,
    3161,
    5257,
    5258,
    4029,
    5259,
    4287,
    2506,
    3057,
    4620,
    4030,
    3162,
    2104,
    1647,
    3600,
    2011,
    1873,
    4288,
    5260,
    4289,
    431,
    3485,
    5261,
    250,
    97,
    81,
    4290,
    5262,
    1648,
    1851,
    1558,
    160,
    848,
    5263,
    866,
    740,
    1694,
    5264,
    2204,
    2843,
    3226,
    4291,
    4621,
    3719,
    1687,
    950,
    2479,
    426,
    469,
    3227,
    3720,
    3721,
    4031,
    5265,
    5266,
    1188,
    424,
    1996,
    861,
    3601,
    4292,
    3854,
    2205,
    2694,
    168,
    1235,
    3602,
    4293,
    5267,
    2087,
    1674,
    4622,
    3374,
    3303,
    220,
    2565,
    1009,
    5268,
    3855,
    670,
    3010,
    332,
    1208,
    717,
    5269,
    5270,
    3603,
    2452,
    4032,
    3375,
    5271,
    513,
    5272,
    1209,
    2882,
    3376,
    3163,
    4623,
    1080,
    5273,
    5274,
    5275,
    5276,
    2534,
    3722,
    3604,
    815,
    1587,
    4033,
    4034,
    5277,
    3605,
    3486,
    3856,
    1254,
    4624,
    1328,
    3058,
    1390,
    4035,
    1741,
    4036,
    3857,
    4037,
    5278,
    236,
    3858,
    2453,
    3304,
    5279,
    5280,
    3723,
    3859,
    1273,
    3860,
    4625,
    5281,
    308,
    5282,
    4626,
    245,
    4627,
    1852,
    2480,
    1307,
    2583,
    430,
    715,
    2137,
    2454,
    5283,
    270,
    199,
    2883,
    4038,
    5284,
    3606,
    2727,
    1753,
    761,
    1754,
    725,
    1661,
    1841,
    4628,
    3487,
    3724,
    5285,
    5286,
    587,
    14,
    3305,
    227,
    2608,
    326,
    480,
    2270,
    943,
    2765,
    3607,
    291,
    650,
    1884,
    5287,
    1702,
    1226,
    102,
    1547,
    62,
    3488,
    904,
    4629,
    3489,
    1164,
    4294,
    5288,
    5289,
    1224,
    1548,
    2766,
    391,
    498,
    1493,
    5290,
    1386,
    1419,
    5291,
    2056,
    1177,
    4630,
    813,
    880,
    1081,
    2368,
    566,
    1145,
    4631,
    2291,
    1001,
    1035,
    2566,
    2609,
    2242,
    394,
    1286,
    5292,
    5293,
    2069,
    5294,
    86,
    1494,
    1730,
    4039,
    491,
    1588,
    745,
    897,
    2963,
    843,
    3377,
    4040,
    2767,
    2884,
    3306,
    1768,
    998,
    2221,
    2070,
    397,
    1827,
    1195,
    1970,
    3725,
    3011,
    3378,
    284,
    5295,
    3861,
    2507,
    2138,
    2120,
    1904,
    5296,
    4041,
    2151,
    4042,
    4295,
    1036,
    3490,
    1905,
    114,
    2567,
    4296,
    209,
    1527,
    5297,
    5298,
    2964,
    2844,
    2635,
    2390,
    2728,
    3164,
    812,
    2568,
    5299,
    3307,
    5300,
    1559,
    737,
    1885,
    3726,
    1210,
    885,
    28,
    2695,
    3608,
    3862,
    5301,
    4297,
    1004,
    1780,
    4632,
    5302,
    346,
    1982,
    2222,
    2696,
    4633,
    3863,
    1742,
    797,
    1642,
    4043,
    1934,
    1072,
    1384,
    2152,
    896,
    4044,
    3308,
    3727,
    3228,
    2885,
    3609,
    5303,
    2569,
    1959,
    4634,
    2455,
    1786,
    5304,
    5305,
    5306,
    4045,
    4298,
    1005,
    1308,
    3728,
    4299,
    2729,
    4635,
    4636,
    1528,
    2610,
    161,
    1178,
    4300,
    1983,
    987,
    4637,
    1101,
    4301,
    631,
    4046,
    1157,
    3229,
    2425,
    1343,
    1241,
    1016,
    2243,
    2570,
    372,
    877,
    2344,
    2508,
    1160,
    555,
    1935,
    911,
    4047,
    5307,
    466,
    1170,
    169,
    1051,
    2921,
    2697,
    3729,
    2481,
    3012,
    1182,
    2012,
    2571,
    1251,
    2636,
    5308,
    992,
    2345,
    3491,
    1540,
    2730,
    1201,
    2071,
    2406,
    1997,
    2482,
    5309,
    4638,
    528,
    1923,
    2191,
    1503,
    1874,
    1570,
    2369,
    3379,
    3309,
    5310,
    557,
    1073,
    5311,
    1828,
    3492,
    2088,
    2271,
    3165,
    3059,
    3107,
    767,
    3108,
    2799,
    4639,
    1006,
    4302,
    4640,
    2346,
    1267,
    2179,
    3730,
    3230,
    778,
    4048,
    3231,
    2731,
    1597,
    2667,
    5312,
    4641,
    5313,
    3493,
    5314,
    5315,
    5316,
    3310,
    2698,
    1433,
    3311,
    131,
    95,
    1504,
    4049,
    723,
    4303,
    3166,
    1842,
    3610,
    2768,
    2192,
    4050,
    2028,
    2105,
    3731,
    5317,
    3013,
    4051,
    1218,
    5318,
    3380,
    3232,
    4052,
    4304,
    2584,
    248,
    1634,
    3864,
    912,
    5319,
    2845,
    3732,
    3060,
    3865,
    654,
    53,
    5320,
    3014,
    5321,
    1688,
    4642,
    777,
    3494,
    1032,
    4053,
    1425,
    5322,
    191,
    820,
    2121,
    2846,
    971,
    4643,
    931,
    3233,
    135,
    664,
    783,
    3866,
    1998,
    772,
    2922,
    1936,
    4054,
    3867,
    4644,
    2923,
    3234,
    282,
    2732,
    640,
    1372,
    3495,
    1127,
    922,
    325,
    3381,
    5323,
    5324,
    711,
    2045,
    5325,
    5326,
    4055,
    2223,
    2800,
    1937,
    4056,
    3382,
    2224,
    2255,
    3868,
    2305,
    5327,
    4645,
    3869,
    1258,
    3312,
    4057,
    3235,
    2139,
    2965,
    4058,
    4059,
    5328,
    2225,
    258,
    3236,
    4646,
    101,
    1227,
    5329,
    3313,
    1755,
    5330,
    1391,
    3314,
    5331,
    2924,
    2057,
    893,
    5332,
    5333,
    5334,
    1402,
    4305,
    2347,
    5335,
    5336,
    3237,
    3611,
    5337,
    5338,
    878,
    1325,
    1781,
    2801,
    4647,
    259,
    1385,
    2585,
    744,
    1183,
    2272,
    4648,
    5339,
    4060,
    2509,
    5340,
    684,
    1024,
    4306,
    5341,
    472,
    3612,
    3496,
    1165,
    3315,
    4061,
    4062,
    322,
    2153,
    881,
    455,
    1695,
    1152,
    1340,
    660,
    554,
    2154,
    4649,
    1058,
    4650,
    4307,
    830,
    1065,
    3383,
    4063,
    4651,
    1924,
    5342,
    1703,
    1919,
    5343,
    932,
    2273,
    122,
    5344,
    4652,
    947,
    677,
    5345,
    3870,
    2637,
    297,
    1906,
    1925,
    2274,
    4653,
    2322,
    3316,
    5346,
    5347,
    4308,
    5348,
    4309,
    84,
    4310,
    112,
    989,
    5349,
    547,
    1059,
    4064,
    701,
    3613,
    1019,
    5350,
    4311,
    5351,
    3497,
    942,
    639,
    457,
    2306,
    2456,
    993,
    2966,
    407,
    851,
    494,
    4654,
    3384,
    927,
    5352,
    1237,
    5353,
    2426,
    3385,
    573,
    4312,
    680,
    921,
    2925,
    1279,
    1875,
    285,
    790,
    1448,
    1984,
    719,
    2168,
    5354,
    5355,
    4655,
    4065,
    4066,
    1649,
    5356,
    1541,
    563,
    5357,
    1077,
    5358,
    3386,
    3061,
    3498,
    511,
    3015,
    4067,
    4068,
    3733,
    4069,
    1268,
    2572,
    3387,
    3238,
    4656,
    4657,
    5359,
    535,
    1048,
    1276,
    1189,
    2926,
    2029,
    3167,
    1438,
    1373,
    2847,
    2967,
    1134,
    2013,
    5360,
    4313,
    1238,
    2586,
    3109,
    1259,
    5361,
    700,
    5362,
    2968,
    3168,
    3734,
    4314,
    5363,
    4315,
    1146,
    1876,
    1907,
    4658,
    2611,
    4070,
    781,
    2427,
    132,
    1589,
    203,
    147,
    273,
    2802,
    2407,
    898,
    1787,
    2155,
    4071,
    4072,
    5364,
    3871,
    2803,
    5365,
    5366,
    4659,
    4660,
    5367,
    3239,
    5368,
    1635,
    3872,
    965,
    5369,
    1805,
    2699,
    1516,
    3614,
    1121,
    1082,
    1329,
    3317,
    4073,
    1449,
    3873,
    65,
    1128,
    2848,
    2927,
    2769,
    1590,
    3874,
    5370,
    5371,
    12,
    2668,
    45,
    976,
    2587,
    3169,
    4661,
    517,
    2535,
    1013,
    1037,
    3240,
    5372,
    3875,
    2849,
    5373,
    3876,
    5374,
    3499,
    5375,
    2612,
    614,
    1999,
    2323,
    3877,
    3110,
    2733,
    2638,
    5376,
    2588,
    4316,
    599,
    1269,
    5377,
    1811,
    3735,
    5378,
    2700,
    3111,
    759,
    1060,
    489,
    1806,
    3388,
    3318,
    1358,
    5379,
    5380,
    2391,
    1387,
    1215,
    2639,
    2256,
    490,
    5381,
    5382,
    4317,
    1759,
    2392,
    2348,
    5383,
    4662,
    3878,
    1908,
    4074,
    2640,
    1807,
    3241,
    4663,
    3500,
    3319,
    2770,
    2349,
    874,
    5384,
    5385,
    3501,
    3736,
    1859,
    91,
    2928,
    3737,
    3062,
    3879,
    4664,
    5386,
    3170,
    4075,
    2669,
    5387,
    3502,
    1202,
    1403,
    3880,
    2969,
    2536,
    1517,
    2510,
    4665,
    3503,
    2511,
    5388,
    4666,
    5389,
    2701,
    1886,
    1495,
    1731,
    4076,
    2370,
    4667,
    5390,
    2030,
    5391,
    5392,
    4077,
    2702,
    1216,
    237,
    2589,
    4318,
    2324,
    4078,
    3881,
    4668,
    4669,
    2703,
    3615,
    3504,
    445,
    4670,
    5393,
    5394,
    5395,
    5396,
    2771,
    61,
    4079,
    3738,
    1823,
    4080,
    5397,
    687,
    2046,
    935,
    925,
    405,
    2670,
    703,
    1096,
    1860,
    2734,
    4671,
    4081,
    1877,
    1367,
    2704,
    3389,
    918,
    2106,
    1782,
    2483,
    334,
    3320,
    1611,
    1093,
    4672,
    564,
    3171,
    3505,
    3739,
    3390,
    945,
    2641,
    2058,
    4673,
    5398,
    1926,
    872,
    4319,
    5399,
    3506,
    2705,
    3112,
    349,
    4320,
    3740,
    4082,
    4674,
    3882,
    4321,
    3741,
    2156,
    4083,
    4675,
    4676,
    4322,
    4677,
    2408,
    2047,
    782,
    4084,
    400,
    251,
    4323,
    1624,
    5400,
    5401,
    277,
    3742,
    299,
    1265,
    476,
    1191,
    3883,
    2122,
    4324,
    4325,
    1109,
    205,
    5402,
    2590,
    1000,
    2157,
    3616,
    1861,
    5403,
    5404,
    5405,
    4678,
    5406,
    4679,
    2573,
    107,
    2484,
    2158,
    4085,
    3507,
    3172,
    5407,
    1533,
    541,
    1301,
    158,
    753,
    4326,
    2886,
    3617,
    5408,
    1696,
    370,
    1088,
    4327,
    4680,
    3618,
    579,
    327,
    440,
    162,
    2244,
    269,
    1938,
    1374,
    3508,
    968,
    3063,
    56,
    1396,
    3113,
    2107,
    3321,
    3391,
    5409,
    1927,
    2159,
    4681,
    3016,
    5410,
    3619,
    5411,
    5412,
    3743,
    4682,
    2485,
    5413,
    2804,
    5414,
    1650,
    4683,
    5415,
    2613,
    5416,
    5417,
    4086,
    2671,
    3392,
    1149,
    3393,
    4087,
    3884,
    4088,
    5418,
    1076,
    49,
    5419,
    951,
    3242,
    3322,
    3323,
    450,
    2850,
    920,
    5420,
    1812,
    2805,
    2371,
    4328,
    1909,
    1138,
    2372,
    3885,
    3509,
    5421,
    3243,
    4684,
    1910,
    1147,
    1518,
    2428,
    4685,
    3886,
    5422,
    4686,
    2393,
    2614,
    260,
    1796,
    3244,
    5423,
    5424,
    3887,
    3324,
    708,
    5425,
    3620,
    1704,
    5426,
    3621,
    1351,
    1618,
    3394,
    3017,
    1887,
    944,
    4329,
    3395,
    4330,
    3064,
    3396,
    4331,
    5427,
    3744,
    422,
    413,
    1714,
    3325,
    500,
    2059,
    2350,
    4332,
    2486,
    5428,
    1344,
    1911,
    954,
    5429,
    1668,
    5430,
    5431,
    4089,
    2409,
    4333,
    3622,
    3888,
    4334,
    5432,
    2307,
    1318,
    2512,
    3114,
    133,
    3115,
    2887,
    4687,
    629,
    31,
    2851,
    2706,
    3889,
    4688,
    850,
    949,
    4689,
    4090,
    2970,
    1732,
    2089,
    4335,
    1496,
    1853,
    5433,
    4091,
    620,
    3245,
    981,
    1242,
    3745,
    3397,
    1619,
    3746,
    1643,
    3326,
    2140,
    2457,
    1971,
    1719,
    3510,
    2169,
    5434,
    3246,
    5435,
    5436,
    3398,
    1829,
    5437,
    1277,
    4690,
    1565,
    2048,
    5438,
    1636,
    3623,
    3116,
    5439,
    869,
    2852,
    655,
    3890,
    3891,
    3117,
    4092,
    3018,
    3892,
    1310,
    3624,
    4691,
    5440,
    5441,
    5442,
    1733,
    558,
    4692,
    3747,
    335,
    1549,
    3065,
    1756,
    4336,
    3748,
    1946,
    3511,
    1830,
    1291,
    1192,
    470,
    2735,
    2108,
    2806,
    913,
    1054,
    4093,
    5443,
    1027,
    5444,
    3066,
    4094,
    4693,
    982,
    2672,
    3399,
    3173,
    3512,
    3247,
    3248,
    1947,
    2807,
    5445,
    571,
    4694,
    5446,
    1831,
    5447,
    3625,
    2591,
    1523,
    2429,
    5448,
    2090,
    984,
    4695,
    3749,
    1960,
    5449,
    3750,
    852,
    923,
    2808,
    3513,
    3751,
    969,
    1519,
    999,
    2049,
    2325,
    1705,
    5450,
    3118,
    615,
    1662,
    151,
    597,
    4095,
    2410,
    2326,
    1049,
    275,
    4696,
    3752,
    4337,
    568,
    3753,
    3626,
    2487,
    4338,
    3754,
    5451,
    2430,
    2275,
    409,
    3249,
    5452,
    1566,
    2888,
    3514,
    1002,
    769,
    2853,
    194,
    2091,
    3174,
    3755,
    2226,
    3327,
    4339,
    628,
    1505,
    5453,
    5454,
    1763,
    2180,
    3019,
    4096,
    521,
    1161,
    2592,
    1788,
    2206,
    2411,
    4697,
    4097,
    1625,
    4340,
    4341,
    412,
    42,
    3119,
    464,
    5455,
    2642,
    4698,
    3400,
    1760,
    1571,
    2889,
    3515,
    2537,
    1219,
    2207,
    3893,
    2643,
    2141,
    2373,
    4699,
    4700,
    3328,
    1651,
    3401,
    3627,
    5456,
    5457,
    3628,
    2488,
    3516,
    5458,
    3756,
    5459,
    5460,
    2276,
    2092,
    460,
    5461,
    4701,
    5462,
    3020,
    962,
    588,
    3629,
    289,
    3250,
    2644,
    1116,
    52,
    5463,
    3067,
    1797,
    5464,
    5465,
    5466,
    1467,
    5467,
    1598,
    1143,
    3757,
    4342,
    1985,
    1734,
    1067,
    4702,
    1280,
    3402,
    465,
    4703,
    1572,
    510,
    5468,
    1928,
    2245,
    1813,
    1644,
    3630,
    5469,
    4704,
    3758,
    5470,
    5471,
    2673,
    1573,
    1534,
    5472,
    5473,
    536,
    1808,
    1761,
    3517,
    3894,
    3175,
    2645,
    5474,
    5475,
    5476,
    4705,
    3518,
    2929,
    1912,
    2809,
    5477,
    3329,
    1122,
    377,
    3251,
    5478,
    360,
    5479,
    5480,
    4343,
    1529,
    551,
    5481,
    2060,
    3759,
    1769,
    2431,
    5482,
    2930,
    4344,
    3330,
    3120,
    2327,
    2109,
    2031,
    4706,
    1404,
    136,
    1468,
    1479,
    672,
    1171,
    3252,
    2308,
    271,
    3176,
    5483,
    2772,
    5484,
    2050,
    678,
    2736,
    865,
    1948,
    4707,
    5485,
    2014,
    4098,
    2971,
    5486,
    2737,
    2227,
    1397,
    3068,
    3760,
    4708,
    4709,
    1735,
    2931,
    3403,
    3631,
    5487,
    3895,
    509,
    2854,
    2458,
    2890,
    3896,
    5488,
    5489,
    3177,
    3178,
    4710,
    4345,
    2538,
    4711,
    2309,
    1166,
    1010,
    552,
    681,
    1888,
    5490,
    5491,
    2972,
    2973,
    4099,
    1287,
    1596,
    1862,
    3179,
    358,
    453,
    736,
    175,
    478,
    1117,
    905,
    1167,
    1097,
    5492,
    1854,
    1530,
    5493,
    1706,
    5494,
    2181,
    3519,
    2292,
    3761,
    3520,
    3632,
    4346,
    2093,
    4347,
    5495,
    3404,
    1193,
    2489,
    4348,
    1458,
    2193,
    2208,
    1863,
    1889,
    1421,
    3331,
    2932,
    3069,
    2182,
    3521,
    595,
    2123,
    5496,
    4100,
    5497,
    5498,
    4349,
    1707,
    2646,
    223,
    3762,
    1359,
    751,
    3121,
    183,
    3522,
    5499,
    2810,
    3021,
    419,
    2374,
    633,
    704,
    3897,
    2394,
    241,
    5500,
    5501,
    5502,
    838,
    3022,
    3763,
    2277,
    2773,
    2459,
    3898,
    1939,
    2051,
    4101,
    1309,
    3122,
    2246,
    1181,
    5503,
    1136,
    2209,
    3899,
    2375,
    1446,
    4350,
    2310,
    4712,
    5504,
    5505,
    4351,
    1055,
    2615,
    484,
    3764,
    5506,
    4102,
    625,
    4352,
    2278,
    3405,
    1499,
    4353,
    4103,
    5507,
    4104,
    4354,
    3253,
    2279,
    2280,
    3523,
    5508,
    5509,
    2774,
    808,
    2616,
    3765,
    3406,
    4105,
    4355,
    3123,
    2539,
    526,
    3407,
    3900,
    4356,
    955,
    5510,
    1620,
    4357,
    2647,
    2432,
    5511,
    1429,
    3766,
    1669,
    1832,
    994,
    928,
    5512,
    3633,
    1260,
    5513,
    5514,
    5515,
    1949,
    2293,
    741,
    2933,
    1626,
    4358,
    2738,
    2460,
    867,
    1184,
    362,
    3408,
    1392,
    5516,
    5517,
    4106,
    4359,
    1770,
    1736,
    3254,
    2934,
    4713,
    4714,
    1929,
    2707,
    1459,
    1158,
    5518,
    3070,
    3409,
    2891,
    1292,
    1930,
    2513,
    2855,
    3767,
    1986,
    1187,
    2072,
    2015,
    2617,
    4360,
    5519,
    2574,
    2514,
    2170,
    3768,
    2490,
    3332,
    5520,
    3769,
    4715,
    5521,
    5522,
    666,
    1003,
    3023,
    1022,
    3634,
    4361,
    5523,
    4716,
    1814,
    2257,
    574,
    3901,
    1603,
    295,
    1535,
    705,
    3902,
    4362,
    283,
    858,
    417,
    5524,
    5525,
    3255,
    4717,
    4718,
    3071,
    1220,
    1890,
    1046,
    2281,
    2461,
    4107,
    1393,
    1599,
    689,
    2575,
    388,
    4363,
    5526,
    2491,
    802,
    5527,
    2811,
    3903,
    2061,
    1405,
    2258,
    5528,
    4719,
    3904,
    2110,
    1052,
    1345,
    3256,
    1585,
    5529,
    809,
    5530,
    5531,
    5532,
    575,
    2739,
    3524,
    956,
    1552,
    1469,
    1144,
    2328,
    5533,
    2329,
    1560,
    2462,
    3635,
    3257,
    4108,
    616,
    2210,
    4364,
    3180,
    2183,
    2294,
    5534,
    1833,
    5535,
    3525,
    4720,
    5536,
    1319,
    3770,
    3771,
    1211,
    3636,
    1023,
    3258,
    1293,
    2812,
    5537,
    5538,
    5539,
    3905,
    607,
    2311,
    3906,
    762,
    2892,
    1439,
    4365,
    1360,
    4721,
    1485,
    3072,
    5540,
    4722,
    1038,
    4366,
    1450,
    2062,
    2648,
    4367,
    1379,
    4723,
    2593,
    5541,
    5542,
    4368,
    1352,
    1414,
    2330,
    2935,
    1172,
    5543,
    5544,
    3907,
    3908,
    4724,
    1798,
    1451,
    5545,
    5546,
    5547,
    5548,
    2936,
    4109,
    4110,
    2492,
    2351,
    411,
    4111,
    4112,
    3637,
    3333,
    3124,
    4725,
    1561,
    2674,
    1452,
    4113,
    1375,
    5549,
    5550,
    47,
    2974,
    316,
    5551,
    1406,
    1591,
    2937,
    3181,
    5552,
    1025,
    2142,
    3125,
    3182,
    354,
    2740,
    884,
    2228,
    4369,
    2412,
    508,
    3772,
    726,
    3638,
    996,
    2433,
    3639,
    729,
    5553,
    392,
    2194,
    1453,
    4114,
    4726,
    3773,
    5554,
    5555,
    2463,
    3640,
    2618,
    1675,
    2813,
    919,
    2352,
    2975,
    2353,
    1270,
    4727,
    4115,
    73,
    5556,
    5557,
    647,
    5558,
    3259,
    2856,
    2259,
    1550,
    1346,
    3024,
    5559,
    1332,
    883,
    3526,
    5560,
    5561,
    5562,
    5563,
    3334,
    2775,
    5564,
    1212,
    831,
    1347,
    4370,
    4728,
    2331,
    3909,
    1864,
    3073,
    720,
    3910,
    4729,
    4730,
    3911,
    5565,
    4371,
    5566,
    5567,
    4731,
    5568,
    5569,
    1799,
    4732,
    3774,
    2619,
    4733,
    3641,
    1645,
    2376,
    4734,
    5570,
    2938,
    669,
    2211,
    2675,
    2434,
    5571,
    2893,
    5572,
    5573,
    1028,
    3260,
    5574,
    4372,
    2413,
    5575,
    2260,
    1353,
    5576,
    5577,
    4735,
    3183,
    518,
    5578,
    4116,
    5579,
    4373,
    1961,
    5580,
    2143,
    4374,
    5581,
    5582,
    3025,
    2354,
    2355,
    3912,
    516,
    1834,
    1454,
    4117,
    2708,
    4375,
    4736,
    2229,
    2620,
    1972,
    1129,
    3642,
    5583,
    2776,
    5584,
    2976,
    1422,
    577,
    1470,
    3026,
    1524,
    3410,
    5585,
    5586,
    432,
    4376,
    3074,
    3527,
    5587,
    2594,
    1455,
    2515,
    2230,
    1973,
    1175,
    5588,
    1020,
    2741,
    4118,
    3528,
    4737,
    5589,
    2742,
    5590,
    1743,
    1361,
    3075,
    3529,
    2649,
    4119,
    4377,
    4738,
    2295,
    895,
    924,
    4378,
    2171,
    331,
    2247,
    3076,
    166,
    1627,
    3077,
    1098,
    5591,
    1232,
    2894,
    2231,
    3411,
    4739,
    657,
    403,
    1196,
    2377,
    542,
    3775,
    3412,
    1600,
    4379,
    3530,
    5592,
    4740,
    2777,
    3261,
    576,
    530,
    1362,
    4741,
    4742,
    2540,
    2676,
    3776,
    4120,
    5593,
    842,
    3913,
    5594,
    2814,
    2032,
    1014,
    4121,
    213,
    2709,
    3413,
    665,
    621,
    4380,
    5595,
    3777,
    2939,
    2435,
    5596,
    2436,
    3335,
    3643,
    3414,
    4743,
    4381,
    2541,
    4382,
    4744,
    3644,
    1682,
    4383,
    3531,
    1380,
    5597,
    724,
    2282,
    600,
    1670,
    5598,
    1337,
    1233,
    4745,
    3126,
    2248,
    5599,
    1621,
    4746,
    5600,
    651,
    4384,
    5601,
    1612,
    4385,
    2621,
    5602,
    2857,
    5603,
    2743,
    2312,
    3078,
    5604,
    716,
    2464,
    3079,
    174,
    1255,
    2710,
    4122,
    3645,
    548,
    1320,
    1398,
    728,
    4123,
    1574,
    5605,
    1891,
    1197,
    3080,
    4124,
    5606,
    3081,
    3082,
    3778,
    3646,
    3779,
    747,
    5607,
    635,
    4386,
    4747,
    5608,
    5609,
    5610,
    4387,
    5611,
    5612,
    4748,
    5613,
    3415,
    4749,
    2437,
    451,
    5614,
    3780,
    2542,
    2073,
    4388,
    2744,
    4389,
    4125,
    5615,
    1764,
    4750,
    5616,
    4390,
    350,
    4751,
    2283,
    2395,
    2493,
    5617,
    4391,
    4126,
    2249,
    1434,
    4127,
    488,
    4752,
    458,
    4392,
    4128,
    3781,
    771,
    1330,
    2396,
    3914,
    2576,
    3184,
    2160,
    2414,
    1553,
    2677,
    3185,
    4393,
    5618,
    2494,
    2895,
    2622,
    1720,
    2711,
    4394,
    3416,
    4753,
    5619,
    2543,
    4395,
    5620,
    3262,
    4396,
    2778,
    5621,
    2016,
    2745,
    5622,
    1155,
    1017,
    3782,
    3915,
    5623,
    3336,
    2313,
    201,
    1865,
    4397,
    1430,
    5624,
    4129,
    5625,
    5626,
    5627,
    5628,
    5629,
    4398,
    1604,
    5630,
    414,
    1866,
    371,
    2595,
    4754,
    4755,
    3532,
    2017,
    3127,
    4756,
    1708,
    960,
    4399,
    887,
    389,
    2172,
    1536,
    1663,
    1721,
    5631,
    2232,
    4130,
    2356,
    2940,
    1580,
    5632,
    5633,
    1744,
    4757,
    2544,
    4758,
    4759,
    5634,
    4760,
    5635,
    2074,
    5636,
    4761,
    3647,
    3417,
    2896,
    4400,
    5637,
    4401,
    2650,
    3418,
    2815,
    673,
    2712,
    2465,
    709,
    3533,
    4131,
    3648,
    4402,
    5638,
    1148,
    502,
    634,
    5639,
    5640,
    1204,
    4762,
    3649,
    1575,
    4763,
    2623,
    3783,
    5641,
    3784,
    3128,
    948,
    3263,
    121,
    1745,
    3916,
    1110,
    5642,
    4403,
    3083,
    2516,
    3027,
    4132,
    3785,
    1151,
    1771,
    3917,
    1488,
    4133,
    1987,
    5643,
    2438,
    3534,
    5644,
    5645,
    2094,
    5646,
    4404,
    3918,
    1213,
    1407,
    2816,
    531,
    2746,
    2545,
    3264,
    1011,
    1537,
    4764,
    2779,
    4405,
    3129,
    1061,
    5647,
    3786,
    3787,
    1867,
    2897,
    5648,
    2018,
    120,
    4406,
    4407,
    2063,
    3650,
    3265,
    2314,
    3919,
    2678,
    3419,
    1955,
    4765,
    4134,
    5649,
    3535,
    1047,
    2713,
    1266,
    5650,
    1368,
    4766,
    2858,
    649,
    3420,
    3920,
    2546,
    2747,
    1102,
    2859,
    2679,
    5651,
    5652,
    2000,
    5653,
    1111,
    3651,
    2977,
    5654,
    2495,
    3921,
    3652,
    2817,
    1855,
    3421,
    3788,
    5655,
    5656,
    3422,
    2415,
    2898,
    3337,
    3266,
    3653,
    5657,
    2577,
    5658,
    3654,
    2818,
    4135,
    1460,
    856,
    5659,
    3655,
    5660,
    2899,
    2978,
    5661,
    2900,
    3922,
    5662,
    4408,
    632,
    2517,
    875,
    3923,
    1697,
    3924,
    2296,
    5663,
    5664,
    4767,
    3028,
    1239,
    580,
    4768,
    4409,
    5665,
    914,
    936,
    2075,
    1190,
    4136,
    1039,
    2124,
    5666,
    5667,
    5668,
    5669,
    3423,
    1473,
    5670,
    1354,
    4410,
    3925,
    4769,
    2173,
    3084,
    4137,
    915,
    3338,
    4411,
    4412,
    3339,
    1605,
    1835,
    5671,
    2748,
    398,
    3656,
    4413,
    3926,
    4138,
    328,
    1913,
    2860,
    4139,
    3927,
    1331,
    4414,
    3029,
    937,
    4415,
    5672,
    3657,
    4140,
    4141,
    3424,
    2161,
    4770,
    3425,
    524,
    742,
    538,
    3085,
    1012,
    5673,
    5674,
    3928,
    2466,
    5675,
    658,
    1103,
    225,
    3929,
    5676,
    5677,
    4771,
    5678,
    4772,
    5679,
    3267,
    1243,
    5680,
    4142,
    963,
    2250,
    4773,
    5681,
    2714,
    3658,
    3186,
    5682,
    5683,
    2596,
    2332,
    5684,
    4774,
    5685,
    5686,
    5687,
    3536,
    957,
    3426,
    2547,
    2033,
    1931,
    2941,
    2467,
    870,
    2019,
    3659,
    1746,
    2780,
    2781,
    2439,
    2468,
    5688,
    3930,
    5689,
    3789,
    3130,
    3790,
    3537,
    3427,
    3791,
    5690,
    1179,
    3086,
    5691,
    3187,
    2378,
    4416,
    3792,
    2548,
    3188,
    3131,
    2749,
    4143,
    5692,
    3428,
    1556,
    2549,
    2297,
    977,
    2901,
    2034,
    4144,
    1205,
    3429,
    5693,
    1765,
    3430,
    3189,
    2125,
    1271,
    714,
    1689,
    4775,
    3538,
    5694,
    2333,
    3931,
    533,
    4417,
    3660,
    2184,
    617,
    5695,
    2469,
    3340,
    3539,
    2315,
    5696,
    5697,
    3190,
    5698,
    5699,
    3932,
    1988,
    618,
    427,
    2651,
    3540,
    3431,
    5700,
    5701,
    1244,
    1690,
    5702,
    2819,
    4418,
    4776,
    5703,
    3541,
    4777,
    5704,
    2284,
    1576,
    473,
    3661,
    4419,
    3432,
    972,
    5705,
    3662,
    5706,
    3087,
    5707,
    5708,
    4778,
    4779,
    5709,
    3793,
    4145,
    4146,
    5710,
    153,
    4780,
    356,
    5711,
    1892,
    2902,
    4420,
    2144,
    408,
    803,
    2357,
    5712,
    3933,
    5713,
    4421,
    1646,
    2578,
    2518,
    4781,
    4782,
    3934,
    5714,
    3935,
    4422,
    5715,
    2416,
    3433,
    752,
    5716,
    5717,
    1962,
    3341,
    2979,
    5718,
    746,
    3030,
    2470,
    4783,
    4423,
    3794,
    698,
    4784,
    1893,
    4424,
    3663,
    2550,
    4785,
    3664,
    3936,
    5719,
    3191,
    3434,
    5720,
    1824,
    1302,
    4147,
    2715,
    3937,
    1974,
    4425,
    5721,
    4426,
    3192,
    823,
    1303,
    1288,
    1236,
    2861,
    3542,
    4148,
    3435,
    774,
    3938,
    5722,
    1581,
    4786,
    1304,
    2862,
    3939,
    4787,
    5723,
    2440,
    2162,
    1083,
    3268,
    4427,
    4149,
    4428,
    344,
    1173,
    288,
    2316,
    454,
    1683,
    5724,
    5725,
    1461,
    4788,
    4150,
    2597,
    5726,
    5727,
    4789,
    985,
    894,
    5728,
    3436,
    3193,
    5729,
    1914,
    2942,
    3795,
    1989,
    5730,
    2111,
    1975,
    5731,
    4151,
    5732,
    2579,
    1194,
    425,
    5733,
    4790,
    3194,
    1245,
    3796,
    4429,
    5734,
    5735,
    2863,
    5736,
    636,
    4791,
    1856,
    3940,
    760,
    1800,
    5737,
    4430,
    2212,
    1508,
    4792,
    4152,
    1894,
    1684,
    2298,
    5738,
    5739,
    4793,
    4431,
    4432,
    2213,
    479,
    5740,
    5741,
    832,
    5742,
    4153,
    2496,
    5743,
    2980,
    2497,
    3797,
    990,
    3132,
    627,
    1815,
    2652,
    4433,
    1582,
    4434,
    2126,
    2112,
    3543,
    4794,
    5744,
    799,
    4435,
    3195,
    5745,
    4795,
    2113,
    1737,
    3031,
    1018,
    543,
    754,
    4436,
    3342,
    1676,
    4796,
    4797,
    4154,
    4798,
    1489,
    5746,
    3544,
    5747,
    2624,
    2903,
    4155,
    5748,
    5749,
    2981,
    5750,
    5751,
    5752,
    5753,
    3196,
    4799,
    4800,
    2185,
    1722,
    5754,
    3269,
    3270,
    1843,
    3665,
    1715,
    481,
    365,
    1976,
    1857,
    5755,
    5756,
    1963,
    2498,
    4801,
    5757,
    2127,
    3666,
    3271,
    433,
    1895,
    2064,
    2076,
    5758,
    602,
    2750,
    5759,
    5760,
    5761,
    5762,
    5763,
    3032,
    1628,
    3437,
    5764,
    3197,
    4802,
    4156,
    2904,
    4803,
    2519,
    5765,
    2551,
    2782,
    5766,
    5767,
    5768,
    3343,
    4804,
    2905,
    5769,
    4805,
    5770,
    2864,
    4806,
    4807,
    1221,
    2982,
    4157,
    2520,
    5771,
    5772,
    5773,
    1868,
    1990,
    5774,
    5775,
    5776,
    1896,
    5777,
    5778,
    4808,
    1897,
    4158,
    318,
    5779,
    2095,
    4159,
    4437,
    5780,
    5781,
    485,
    5782,
    938,
    3941,
    553,
    2680,
    116,
    5783,
    3942,
    3667,
    5784,
    3545,
    2681,
    2783,
    3438,
    3344,
    2820,
    5785,
    3668,
    2943,
    4160,
    1747,
    2944,
    2983,
    5786,
    5787,
    207,
    5788,
    4809,
    5789,
    4810,
    2521,
    5790,
    3033,
    890,
    3669,
    3943,
    5791,
    1878,
    3798,
    3439,
    5792,
    2186,
    2358,
    3440,
    1652,
    5793,
    5794,
    5795,
    941,
    2299,
    208,
    3546,
    4161,
    2020,
    330,
    4438,
    3944,
    2906,
    2499,
    3799,
    4439,
    4811,
    5796,
    5797,
    5798,
    //Everything below is of no interest for detection purpose
    2522,
    1613,
    4812,
    5799,
    3345,
    3945,
    2523,
    5800,
    4162,
    5801,
    1637,
    4163,
    2471,
    4813,
    3946,
    5802,
    2500,
    3034,
    3800,
    5803,
    5804,
    2195,
    4814,
    5805,
    2163,
    5806,
    5807,
    5808,
    5809,
    5810,
    5811,
    5812,
    5813,
    5814,
    5815,
    5816,
    5817,
    5818,
    5819,
    5820,
    5821,
    5822,
    5823,
    5824,
    5825,
    5826,
    5827,
    5828,
    5829,
    5830,
    5831,
    5832,
    5833,
    5834,
    5835,
    5836,
    5837,
    5838,
    5839,
    5840,
    5841,
    5842,
    5843,
    5844,
    5845,
    5846,
    5847,
    5848,
    5849,
    5850,
    5851,
    5852,
    5853,
    5854,
    5855,
    5856,
    5857,
    5858,
    5859,
    5860,
    5861,
    5862,
    5863,
    5864,
    5865,
    5866,
    5867,
    5868,
    5869,
    5870,
    5871,
    5872,
    5873,
    5874,
    5875,
    5876,
    5877,
    5878,
    5879,
    5880,
    5881,
    5882,
    5883,
    5884,
    5885,
    5886,
    5887,
    5888,
    5889,
    5890,
    5891,
    5892,
    5893,
    5894,
    5895,
    5896,
    5897,
    5898,
    5899,
    5900,
    5901,
    5902,
    5903,
    5904,
    5905,
    5906,
    5907,
    5908,
    5909,
    5910,
    5911,
    5912,
    5913,
    5914,
    5915,
    5916,
    5917,
    5918,
    5919,
    5920,
    5921,
    5922,
    5923,
    5924,
    5925,
    5926,
    5927,
    5928,
    5929,
    5930,
    5931,
    5932,
    5933,
    5934,
    5935,
    5936,
    5937,
    5938,
    5939,
    5940,
    5941,
    5942,
    5943,
    5944,
    5945,
    5946,
    5947,
    5948,
    5949,
    5950,
    5951,
    5952,
    5953,
    5954,
    5955,
    5956,
    5957,
    5958,
    5959,
    5960,
    5961,
    5962,
    5963,
    5964,
    5965,
    5966,
    5967,
    5968,
    5969,
    5970,
    5971,
    5972,
    5973,
    5974,
    5975,
    5976,
    5977,
    5978,
    5979,
    5980,
    5981,
    5982,
    5983,
    5984,
    5985,
    5986,
    5987,
    5988,
    5989,
    5990,
    5991,
    5992,
    5993,
    5994,
    5995,
    5996,
    5997,
    5998,
    5999,
    6000,
    6001,
    6002,
    6003,
    6004,
    6005,
    6006,
    6007,
    6008,
    6009,
    6010,
    6011,
    6012,
    6013,
    6014,
    6015,
    6016,
    6017,
    6018,
    6019,
    6020,
    6021,
    6022,
    6023,
    6024,
    6025,
    6026,
    6027,
    6028,
    6029,
    6030,
    6031,
    6032,
    6033,
    6034,
    6035,
    6036,
    6037,
    6038,
    6039,
    6040,
    6041,
    6042,
    6043,
    6044,
    6045,
    6046,
    6047,
    6048,
    6049,
    6050,
    6051,
    6052,
    6053,
    6054,
    6055,
    6056,
    6057,
    6058,
    6059,
    6060,
    6061,
    6062,
    6063,
    6064,
    6065,
    6066,
    6067,
    6068,
    6069,
    6070,
    6071,
    6072,
    6073,
    6074,
    6075,
    6076,
    6077,
    6078,
    6079,
    6080,
    6081,
    6082,
    6083,
    6084,
    6085,
    6086,
    6087,
    6088,
    6089,
    6090,
    6091,
    6092,
    6093,
    6094,
    6095,
    6096,
    6097,
    6098,
    6099,
    6100,
    6101,
    6102,
    6103,
    6104,
    6105,
    6106,
    6107,
    6108,
    6109,
    6110,
    6111,
    6112,
    6113,
    6114,
    6115,
    6116,
    6117,
    6118,
    6119,
    6120,
    6121,
    6122,
    6123,
    6124,
    6125,
    6126,
    6127,
    6128,
    6129,
    6130,
    6131,
    6132,
    6133,
    6134,
    6135,
    6136,
    6137,
    6138,
    6139,
    6140,
    6141,
    6142,
    6143,
    6144,
    6145,
    6146,
    6147,
    6148,
    6149,
    6150,
    6151,
    6152,
    6153,
    6154,
    6155,
    6156,
    6157,
    6158,
    6159,
    6160,
    6161,
    6162,
    6163,
    6164,
    6165,
    6166,
    6167,
    6168,
    6169,
    6170,
    6171,
    6172,
    6173,
    6174,
    6175,
    6176,
    6177,
    6178,
    6179,
    6180,
    6181,
    6182,
    6183,
    6184,
    6185,
    6186,
    6187,
    6188,
    6189,
    6190,
    6191,
    6192,
    6193,
    6194,
    6195,
    6196,
    6197,
    6198,
    6199,
    6200,
    6201,
    6202,
    6203,
    6204,
    6205,
    6206,
    6207,
    6208,
    6209,
    6210,
    6211,
    6212,
    6213,
    6214,
    6215,
    6216,
    6217,
    6218,
    6219,
    6220,
    6221,
    6222,
    6223,
    3670,
    6224,
    6225,
    6226,
    6227,
    6228,
    6229,
    6230,
    6231,
    6232,
    6233,
    6234,
    6235,
    6236,
    6237,
    6238,
    6239,
    6240,
    6241,
    6242,
    6243,
    6244,
    6245,
    6246,
    6247,
    6248,
    6249,
    6250,
    6251,
    6252,
    6253,
    6254,
    6255,
    6256,
    6257,
    6258,
    6259,
    6260,
    6261,
    6262,
    6263,
    6264,
    6265,
    6266,
    6267,
    6268,
    6269,
    6270,
    6271,
    6272,
    6273,
    6274,
    6275,
    6276,
    6277,
    6278,
    6279,
    6280,
    6281,
    6282,
    6283,
    6284,
    6285,
    4815,
    6286,
    6287,
    6288,
    6289,
    6290,
    6291,
    6292,
    4816,
    6293,
    6294,
    6295,
    6296,
    6297,
    6298,
    6299,
    6300,
    6301,
    6302,
    6303,
    6304,
    6305,
    6306,
    6307,
    6308,
    6309,
    6310,
    6311,
    4817,
    4818,
    6312,
    6313,
    6314,
    6315,
    6316,
    6317,
    6318,
    4819,
    6319,
    6320,
    6321,
    6322,
    6323,
    6324,
    6325,
    6326,
    6327,
    6328,
    6329,
    6330,
    6331,
    6332,
    6333,
    6334,
    6335,
    6336,
    6337,
    4820,
    6338,
    6339,
    6340,
    6341,
    6342,
    6343,
    6344,
    6345,
    6346,
    6347,
    6348,
    6349,
    6350,
    6351,
    6352,
    6353,
    6354,
    6355,
    6356,
    6357,
    6358,
    6359,
    6360,
    6361,
    6362,
    6363,
    6364,
    6365,
    6366,
    6367,
    6368,
    6369,
    6370,
    6371,
    6372,
    6373,
    6374,
    6375,
    6376,
    6377,
    6378,
    6379,
    6380,
    6381,
    6382,
    6383,
    6384,
    6385,
    6386,
    6387,
    6388,
    6389,
    6390,
    6391,
    6392,
    6393,
    6394,
    6395,
    6396,
    6397,
    6398,
    6399,
    6400,
    6401,
    6402,
    6403,
    6404,
    6405,
    6406,
    6407,
    6408,
    6409,
    6410,
    3441,
    6411,
    6412,
    6413,
    6414,
    6415,
    6416,
    6417,
    6418,
    6419,
    6420,
    6421,
    6422,
    6423,
    6424,
    6425,
    4440,
    6426,
    6427,
    6428,
    6429,
    6430,
    6431,
    6432,
    6433,
    6434,
    6435,
    6436,
    6437,
    6438,
    6439,
    6440,
    6441,
    6442,
    6443,
    6444,
    6445,
    6446,
    6447,
    6448,
    6449,
    6450,
    6451,
    6452,
    6453,
    6454,
    4821,
    6455,
    6456,
    6457,
    6458,
    6459,
    6460,
    6461,
    6462,
    6463,
    6464,
    6465,
    6466,
    6467,
    6468,
    6469,
    6470,
    6471,
    6472,
    6473,
    6474,
    6475,
    6476,
    6477,
    3947,
    3948,
    6478,
    6479,
    6480,
    6481,
    3272,
    4441,
    6482,
    6483,
    6484,
    6485,
    4442,
    6486,
    6487,
    6488,
    6489,
    6490,
    6491,
    6492,
    6493,
    6494,
    6495,
    6496,
    4822,
    6497,
    6498,
    6499,
    6500,
    6501,
    6502,
    6503,
    6504,
    6505,
    6506,
    6507,
    6508,
    6509,
    6510,
    6511,
    6512,
    6513,
    6514,
    6515,
    6516,
    6517,
    6518,
    6519,
    6520,
    6521,
    6522,
    6523,
    6524,
    6525,
    6526,
    6527,
    6528,
    6529,
    6530,
    6531,
    6532,
    6533,
    6534,
    6535,
    6536,
    6537,
    6538,
    6539,
    6540,
    6541,
    6542,
    6543,
    6544,
    6545,
    6546,
    6547,
    6548,
    6549,
    6550,
    6551,
    6552,
    6553,
    6554,
    6555,
    6556,
    2784,
    6557,
    4823,
    6558,
    6559,
    6560,
    6561,
    6562,
    6563,
    6564,
    6565,
    6566,
    6567,
    6568,
    6569,
    3949,
    6570,
    6571,
    6572,
    4824,
    6573,
    6574,
    6575,
    6576,
    6577,
    6578,
    6579,
    6580,
    6581,
    6582,
    6583,
    4825,
    6584,
    6585,
    6586,
    3950,
    2785,
    6587,
    6588,
    6589,
    6590,
    6591,
    6592,
    6593,
    6594,
    6595,
    6596,
    6597,
    6598,
    6599,
    6600,
    6601,
    6602,
    6603,
    6604,
    6605,
    6606,
    6607,
    6608,
    6609,
    6610,
    6611,
    6612,
    4826,
    6613,
    6614,
    6615,
    4827,
    6616,
    6617,
    6618,
    6619,
    6620,
    6621,
    6622,
    6623,
    6624,
    6625,
    4164,
    6626,
    6627,
    6628,
    6629,
    6630,
    6631,
    6632,
    6633,
    6634,
    3547,
    6635,
    4828,
    6636,
    6637,
    6638,
    6639,
    6640,
    6641,
    6642,
    3951,
    2984,
    6643,
    6644,
    6645,
    6646,
    6647,
    6648,
    6649,
    4165,
    6650,
    4829,
    6651,
    6652,
    4830,
    6653,
    6654,
    6655,
    6656,
    6657,
    6658,
    6659,
    6660,
    6661,
    6662,
    4831,
    6663,
    6664,
    6665,
    6666,
    6667,
    6668,
    6669,
    6670,
    6671,
    4166,
    6672,
    4832,
    3952,
    6673,
    6674,
    6675,
    6676,
    4833,
    6677,
    6678,
    6679,
    4167,
    6680,
    6681,
    6682,
    3198,
    6683,
    6684,
    6685,
    6686,
    6687,
    6688,
    6689,
    6690,
    6691,
    6692,
    6693,
    6694,
    6695,
    6696,
    6697,
    4834,
    6698,
    6699,
    6700,
    6701,
    6702,
    6703,
    6704,
    6705,
    6706,
    6707,
    6708,
    6709,
    6710,
    6711,
    6712,
    6713,
    6714,
    6715,
    6716,
    6717,
    6718,
    6719,
    6720,
    6721,
    6722,
    6723,
    6724,
    6725,
    6726,
    6727,
    6728,
    6729,
    6730,
    6731,
    6732,
    6733,
    6734,
    4443,
    6735,
    6736,
    6737,
    6738,
    6739,
    6740,
    6741,
    6742,
    6743,
    6744,
    6745,
    4444,
    6746,
    6747,
    6748,
    6749,
    6750,
    6751,
    6752,
    6753,
    6754,
    6755,
    6756,
    6757,
    6758,
    6759,
    6760,
    6761,
    6762,
    6763,
    6764,
    6765,
    6766,
    6767,
    6768,
    6769,
    6770,
    6771,
    6772,
    6773,
    6774,
    6775,
    6776,
    6777,
    6778,
    6779,
    6780,
    6781,
    4168,
    6782,
    6783,
    3442,
    6784,
    6785,
    6786,
    6787,
    6788,
    6789,
    6790,
    6791,
    4169,
    6792,
    6793,
    6794,
    6795,
    6796,
    6797,
    6798,
    6799,
    6800,
    6801,
    6802,
    6803,
    6804,
    6805,
    6806,
    6807,
    6808,
    6809,
    6810,
    6811,
    4835,
    6812,
    6813,
    6814,
    4445,
    6815,
    6816,
    4446,
    6817,
    6818,
    6819,
    6820,
    6821,
    6822,
    6823,
    6824,
    6825,
    6826,
    6827,
    6828,
    6829,
    6830,
    6831,
    6832,
    6833,
    6834,
    6835,
    3548,
    6836,
    6837,
    6838,
    6839,
    6840,
    6841,
    6842,
    6843,
    6844,
    6845,
    6846,
    4836,
    6847,
    6848,
    6849,
    6850,
    6851,
    6852,
    6853,
    6854,
    3953,
    6855,
    6856,
    6857,
    6858,
    6859,
    6860,
    6861,
    6862,
    6863,
    6864,
    6865,
    6866,
    6867,
    6868,
    6869,
    6870,
    6871,
    6872,
    6873,
    6874,
    6875,
    6876,
    6877,
    3199,
    6878,
    6879,
    6880,
    6881,
    6882,
    4447,
    6883,
    6884,
    6885,
    6886,
    6887,
    6888,
    6889,
    6890,
    6891,
    6892,
    6893,
    6894,
    6895,
    6896,
    6897,
    6898,
    6899,
    6900,
    6901,
    6902,
    6903,
    6904,
    4170,
    6905,
    6906,
    6907,
    6908,
    6909,
    6910,
    6911,
    6912,
    6913,
    6914,
    6915,
    6916,
    6917,
    6918,
    6919,
    6920,
    6921,
    6922,
    6923,
    6924,
    6925,
    6926,
    6927,
    4837,
    6928,
    6929,
    6930,
    6931,
    6932,
    6933,
    6934,
    6935,
    6936,
    3346,
    6937,
    6938,
    4838,
    6939,
    6940,
    6941,
    4448,
    6942,
    6943,
    6944,
    6945,
    6946,
    4449,
    6947,
    6948,
    6949,
    6950,
    6951,
    6952,
    6953,
    6954,
    6955,
    6956,
    6957,
    6958,
    6959,
    6960,
    6961,
    6962,
    6963,
    6964,
    6965,
    6966,
    6967,
    6968,
    6969,
    6970,
    6971,
    6972,
    6973,
    6974,
    6975,
    6976,
    6977,
    6978,
    6979,
    6980,
    6981,
    6982,
    6983,
    6984,
    6985,
    6986,
    6987,
    6988,
    6989,
    6990,
    6991,
    6992,
    6993,
    6994,
    3671,
    6995,
    6996,
    6997,
    6998,
    4839,
    6999,
    7000,
    7001,
    7002,
    3549,
    7003,
    7004,
    7005,
    7006,
    7007,
    7008,
    7009,
    7010,
    7011,
    7012,
    7013,
    7014,
    7015,
    7016,
    7017,
    7018,
    7019,
    7020,
    7021,
    7022,
    7023,
    7024,
    7025,
    7026,
    7027,
    7028,
    7029,
    7030,
    4840,
    7031,
    7032,
    7033,
    7034,
    7035,
    7036,
    7037,
    7038,
    4841,
    7039,
    7040,
    7041,
    7042,
    7043,
    7044,
    7045,
    7046,
    7047,
    7048,
    7049,
    7050,
    7051,
    7052,
    7053,
    7054,
    7055,
    7056,
    7057,
    7058,
    7059,
    7060,
    7061,
    7062,
    7063,
    7064,
    7065,
    7066,
    7067,
    7068,
    7069,
    7070,
    2985,
    7071,
    7072,
    7073,
    7074,
    7075,
    7076,
    7077,
    7078,
    7079,
    7080,
    4842,
    7081,
    7082,
    7083,
    7084,
    7085,
    7086,
    7087,
    7088,
    7089,
    7090,
    7091,
    7092,
    7093,
    7094,
    7095,
    7096,
    7097,
    7098,
    7099,
    7100,
    7101,
    7102,
    7103,
    7104,
    7105,
    7106,
    7107,
    7108,
    7109,
    7110,
    7111,
    7112,
    7113,
    7114,
    7115,
    7116,
    7117,
    7118,
    4450,
    7119,
    7120,
    7121,
    7122,
    7123,
    7124,
    7125,
    7126,
    7127,
    7128,
    7129,
    7130,
    7131,
    7132,
    7133,
    7134,
    7135,
    7136,
    7137,
    7138,
    7139,
    7140,
    7141,
    7142,
    7143,
    4843,
    7144,
    7145,
    7146,
    7147,
    7148,
    7149,
    7150,
    7151,
    7152,
    7153,
    7154,
    7155,
    7156,
    7157,
    7158,
    7159,
    7160,
    7161,
    7162,
    7163,
    7164,
    7165,
    7166,
    7167,
    7168,
    7169,
    7170,
    7171,
    7172,
    7173,
    7174,
    7175,
    7176,
    7177,
    7178,
    7179,
    7180,
    7181,
    7182,
    7183,
    7184,
    7185,
    7186,
    7187,
    7188,
    4171,
    4172,
    7189,
    7190,
    7191,
    7192,
    7193,
    7194,
    7195,
    7196,
    7197,
    7198,
    7199,
    7200,
    7201,
    7202,
    7203,
    7204,
    7205,
    7206,
    7207,
    7208,
    7209,
    7210,
    7211,
    7212,
    7213,
    7214,
    7215,
    7216,
    7217,
    7218,
    7219,
    7220,
    7221,
    7222,
    7223,
    7224,
    7225,
    7226,
    7227,
    7228,
    7229,
    7230,
    7231,
    7232,
    7233,
    7234,
    7235,
    7236,
    7237,
    7238,
    7239,
    7240,
    7241,
    7242,
    7243,
    7244,
    7245,
    7246,
    7247,
    7248,
    7249,
    7250,
    7251,
    7252,
    7253,
    7254,
    7255,
    7256,
    7257,
    7258,
    7259,
    7260,
    7261,
    7262,
    7263,
    7264,
    7265,
    7266,
    7267,
    7268,
    7269,
    7270,
    7271,
    7272,
    7273,
    7274,
    7275,
    7276,
    7277,
    7278,
    7279,
    7280,
    7281,
    7282,
    7283,
    7284,
    7285,
    7286,
    7287,
    7288,
    7289,
    7290,
    7291,
    7292,
    7293,
    7294,
    7295,
    7296,
    4844,
    7297,
    7298,
    7299,
    7300,
    7301,
    7302,
    7303,
    7304,
    7305,
    7306,
    7307,
    7308,
    7309,
    7310,
    7311,
    7312,
    7313,
    7314,
    7315,
    7316,
    4451,
    7317,
    7318,
    7319,
    7320,
    7321,
    7322,
    7323,
    7324,
    7325,
    7326,
    7327,
    7328,
    7329,
    7330,
    7331,
    7332,
    7333,
    7334,
    7335,
    7336,
    7337,
    7338,
    7339,
    7340,
    7341,
    7342,
    7343,
    7344,
    7345,
    7346,
    7347,
    7348,
    7349,
    7350,
    7351,
    7352,
    7353,
    4173,
    7354,
    7355,
    4845,
    7356,
    7357,
    7358,
    7359,
    7360,
    7361,
    7362,
    7363,
    7364,
    7365,
    7366,
    7367,
    7368,
    7369,
    7370,
    7371,
    7372,
    7373,
    7374,
    7375,
    7376,
    7377,
    7378,
    7379,
    7380,
    7381,
    7382,
    7383,
    7384,
    7385,
    7386,
    7387,
    7388,
    4846,
    7389,
    7390,
    7391,
    7392,
    7393,
    7394,
    7395,
    7396,
    7397,
    7398,
    7399,
    7400,
    7401,
    7402,
    7403,
    7404,
    7405,
    3672,
    7406,
    7407,
    7408,
    7409,
    7410,
    7411,
    7412,
    7413,
    7414,
    7415,
    7416,
    7417,
    7418,
    7419,
    7420,
    7421,
    7422,
    7423,
    7424,
    7425,
    7426,
    7427,
    7428,
    7429,
    7430,
    7431,
    7432,
    7433,
    7434,
    7435,
    7436,
    7437,
    7438,
    7439,
    7440,
    7441,
    7442,
    7443,
    7444,
    7445,
    7446,
    7447,
    7448,
    7449,
    7450,
    7451,
    7452,
    7453,
    4452,
    7454,
    3200,
    7455,
    7456,
    7457,
    7458,
    7459,
    7460,
    7461,
    7462,
    7463,
    7464,
    7465,
    7466,
    7467,
    7468,
    7469,
    7470,
    7471,
    7472,
    7473,
    7474,
    4847,
    7475,
    7476,
    7477,
    3133,
    7478,
    7479,
    7480,
    7481,
    7482,
    7483,
    7484,
    7485,
    7486,
    7487,
    7488,
    7489,
    7490,
    7491,
    7492,
    7493,
    7494,
    7495,
    7496,
    7497,
    7498,
    7499,
    7500,
    7501,
    7502,
    3347,
    7503,
    7504,
    7505,
    7506,
    7507,
    7508,
    7509,
    7510,
    7511,
    7512,
    7513,
    7514,
    7515,
    7516,
    7517,
    7518,
    7519,
    7520,
    7521,
    4848,
    7522,
    7523,
    7524,
    7525,
    7526,
    7527,
    7528,
    7529,
    7530,
    7531,
    7532,
    7533,
    7534,
    7535,
    7536,
    7537,
    7538,
    7539,
    7540,
    7541,
    7542,
    7543,
    7544,
    7545,
    7546,
    7547,
    7548,
    7549,
    3801,
    4849,
    7550,
    7551,
    7552,
    7553,
    7554,
    7555,
    7556,
    7557,
    7558,
    7559,
    7560,
    7561,
    7562,
    7563,
    7564,
    7565,
    7566,
    7567,
    7568,
    7569,
    3035,
    7570,
    7571,
    7572,
    7573,
    7574,
    7575,
    7576,
    7577,
    7578,
    7579,
    7580,
    7581,
    7582,
    7583,
    7584,
    7585,
    7586,
    7587,
    7588,
    7589,
    7590,
    7591,
    7592,
    7593,
    7594,
    7595,
    7596,
    7597,
    7598,
    7599,
    7600,
    7601,
    7602,
    7603,
    7604,
    7605,
    7606,
    7607,
    7608,
    7609,
    7610,
    7611,
    7612,
    7613,
    7614,
    7615,
    7616,
    4850,
    7617,
    7618,
    3802,
    7619,
    7620,
    7621,
    7622,
    7623,
    7624,
    7625,
    7626,
    7627,
    7628,
    7629,
    7630,
    7631,
    7632,
    4851,
    7633,
    7634,
    7635,
    7636,
    7637,
    7638,
    7639,
    7640,
    7641,
    7642,
    7643,
    7644,
    7645,
    7646,
    7647,
    7648,
    7649,
    7650,
    7651,
    7652,
    7653,
    7654,
    7655,
    7656,
    7657,
    7658,
    7659,
    7660,
    7661,
    7662,
    7663,
    7664,
    7665,
    7666,
    7667,
    7668,
    7669,
    7670,
    4453,
    7671,
    7672,
    7673,
    7674,
    7675,
    7676,
    7677,
    7678,
    7679,
    7680,
    7681,
    7682,
    7683,
    7684,
    7685,
    7686,
    7687,
    7688,
    7689,
    7690,
    7691,
    7692,
    7693,
    7694,
    7695,
    7696,
    7697,
    3443,
    7698,
    7699,
    7700,
    7701,
    7702,
    4454,
    7703,
    7704,
    7705,
    7706,
    7707,
    7708,
    7709,
    7710,
    7711,
    7712,
    7713,
    2472,
    7714,
    7715,
    7716,
    7717,
    7718,
    7719,
    7720,
    7721,
    7722,
    7723,
    7724,
    7725,
    7726,
    7727,
    7728,
    7729,
    7730,
    7731,
    3954,
    7732,
    7733,
    7734,
    7735,
    7736,
    7737,
    7738,
    7739,
    7740,
    7741,
    7742,
    7743,
    7744,
    7745,
    7746,
    7747,
    7748,
    7749,
    7750,
    3134,
    7751,
    7752,
    4852,
    7753,
    7754,
    7755,
    4853,
    7756,
    7757,
    7758,
    7759,
    7760,
    4174,
    7761,
    7762,
    7763,
    7764,
    7765,
    7766,
    7767,
    7768,
    7769,
    7770,
    7771,
    7772,
    7773,
    7774,
    7775,
    7776,
    7777,
    7778,
    7779,
    7780,
    7781,
    7782,
    7783,
    7784,
    7785,
    7786,
    7787,
    7788,
    7789,
    7790,
    7791,
    7792,
    7793,
    7794,
    7795,
    7796,
    7797,
    7798,
    7799,
    7800,
    7801,
    7802,
    7803,
    7804,
    7805,
    4854,
    7806,
    7807,
    7808,
    7809,
    7810,
    7811,
    7812,
    7813,
    7814,
    7815,
    7816,
    7817,
    7818,
    7819,
    7820,
    7821,
    7822,
    7823,
    7824,
    7825,
    4855,
    7826,
    7827,
    7828,
    7829,
    7830,
    7831,
    7832,
    7833,
    7834,
    7835,
    7836,
    7837,
    7838,
    7839,
    7840,
    7841,
    7842,
    7843,
    7844,
    7845,
    7846,
    7847,
    3955,
    7848,
    7849,
    7850,
    7851,
    7852,
    7853,
    7854,
    7855,
    7856,
    7857,
    7858,
    7859,
    7860,
    3444,
    7861,
    7862,
    7863,
    7864,
    7865,
    7866,
    7867,
    7868,
    7869,
    7870,
    7871,
    7872,
    7873,
    7874,
    7875,
    7876,
    7877,
    7878,
    7879,
    7880,
    7881,
    7882,
    7883,
    7884,
    7885,
    7886,
    7887,
    7888,
    7889,
    7890,
    7891,
    4175,
    7892,
    7893,
    7894,
    7895,
    7896,
    4856,
    4857,
    7897,
    7898,
    7899,
    7900,
    2598,
    7901,
    7902,
    7903,
    7904,
    7905,
    7906,
    7907,
    7908,
    4455,
    7909,
    7910,
    7911,
    7912,
    7913,
    7914,
    3201,
    7915,
    7916,
    7917,
    7918,
    7919,
    7920,
    7921,
    4858,
    7922,
    7923,
    7924,
    7925,
    7926,
    7927,
    7928,
    7929,
    7930,
    7931,
    7932,
    7933,
    7934,
    7935,
    7936,
    7937,
    7938,
    7939,
    7940,
    7941,
    7942,
    7943,
    7944,
    7945,
    7946,
    7947,
    7948,
    7949,
    7950,
    7951,
    7952,
    7953,
    7954,
    7955,
    7956,
    7957,
    7958,
    7959,
    7960,
    7961,
    7962,
    7963,
    7964,
    7965,
    7966,
    7967,
    7968,
    7969,
    7970,
    7971,
    7972,
    7973,
    7974,
    7975,
    7976,
    7977,
    7978,
    7979,
    7980,
    7981,
    4859,
    7982,
    7983,
    7984,
    7985,
    7986,
    7987,
    7988,
    7989,
    7990,
    7991,
    7992,
    7993,
    7994,
    7995,
    7996,
    4860,
    7997,
    7998,
    7999,
    8000,
    8001,
    8002,
    8003,
    8004,
    8005,
    8006,
    8007,
    8008,
    8009,
    8010,
    8011,
    8012,
    8013,
    8014,
    8015,
    8016,
    4176,
    8017,
    8018,
    8019,
    8020,
    8021,
    8022,
    8023,
    4861,
    8024,
    8025,
    8026,
    8027,
    8028,
    8029,
    8030,
    8031,
    8032,
    8033,
    8034,
    8035,
    8036,
    4862,
    4456,
    8037,
    8038,
    8039,
    8040,
    4863,
    8041,
    8042,
    8043,
    8044,
    8045,
    8046,
    8047,
    8048,
    8049,
    8050,
    8051,
    8052,
    8053,
    8054,
    8055,
    8056,
    8057,
    8058,
    8059,
    8060,
    8061,
    8062,
    8063,
    8064,
    8065,
    8066,
    8067,
    8068,
    8069,
    8070,
    8071,
    8072,
    8073,
    8074,
    8075,
    8076,
    8077,
    8078,
    8079,
    8080,
    8081,
    8082,
    8083,
    8084,
    8085,
    8086,
    8087,
    8088,
    8089,
    8090,
    8091,
    8092,
    8093,
    8094,
    8095,
    8096,
    8097,
    8098,
    8099,
    4864,
    4177,
    8100,
    8101,
    8102,
    8103,
    8104,
    8105,
    8106,
    8107,
    8108,
    8109,
    8110,
    8111,
    8112,
    8113,
    8114,
    8115,
    8116,
    8117,
    8118,
    8119,
    8120,
    4178,
    8121,
    8122,
    8123,
    8124,
    8125,
    8126,
    8127,
    8128,
    8129,
    8130,
    8131,
    8132,
    8133,
    8134,
    8135,
    8136,
    8137,
    8138,
    8139,
    8140,
    8141,
    8142,
    8143,
    8144,
    8145,
    4865,
    4866,
    8146,
    8147,
    8148,
    8149,
    8150,
    8151,
    8152,
    8153,
    8154,
    8155,
    8156,
    8157,
    8158,
    8159,
    8160,
    8161,
    8162,
    8163,
    8164,
    8165,
    4179,
    8166,
    8167,
    8168,
    8169,
    8170,
    8171,
    8172,
    8173,
    8174,
    8175,
    8176,
    8177,
    8178,
    8179,
    8180,
    8181,
    4457,
    8182,
    8183,
    8184,
    8185,
    8186,
    8187,
    8188,
    8189,
    8190,
    8191,
    8192,
    8193,
    8194,
    8195,
    8196,
    8197,
    8198,
    8199,
    8200,
    8201,
    8202,
    8203,
    8204,
    8205,
    8206,
    8207,
    8208,
    8209,
    8210,
    8211,
    8212,
    8213,
    8214,
    8215,
    8216,
    8217,
    8218,
    8219,
    8220,
    8221,
    8222,
    8223,
    8224,
    8225,
    8226,
    8227,
    8228,
    8229,
    8230,
    8231,
    8232,
    8233,
    8234,
    8235,
    8236,
    8237,
    8238,
    8239,
    8240,
    8241,
    8242,
    8243,
    8244,
    8245,
    8246,
    8247,
    8248,
    8249,
    8250,
    8251,
    8252,
    8253,
    8254,
    8255,
    8256,
    3445,
    8257,
    8258,
    8259,
    8260,
    8261,
    8262,
    4458,
    8263,
    8264,
    8265,
    8266,
    8267,
    8268,
    8269,
    8270,
    8271,
    8272,
    4459,
    8273,
    8274,
    8275,
    8276,
    3550,
    8277,
    8278,
    8279,
    8280,
    8281,
    8282,
    8283,
    8284,
    8285,
    8286,
    8287,
    8288,
    8289,
    4460,
    8290,
    8291,
    8292,
    8293,
    8294,
    8295,
    8296,
    8297,
    8298,
    8299,
    8300,
    8301,
    8302,
    8303,
    8304,
    8305,
    8306,
    8307,
    4867,
    8308,
    8309,
    8310,
    8311,
    8312,
    3551,
    8313,
    8314,
    8315,
    8316,
    8317,
    8318,
    8319,
    8320,
    8321,
    8322,
    8323,
    8324,
    8325,
    8326,
    4868,
    8327,
    8328,
    8329,
    8330,
    8331,
    8332,
    8333,
    8334,
    8335,
    8336,
    8337,
    8338,
    8339,
    8340,
    8341,
    8342,
    8343,
    8344,
    8345,
    8346,
    8347,
    8348,
    8349,
    8350,
    8351,
    8352,
    8353,
    8354,
    8355,
    8356,
    8357,
    8358,
    8359,
    8360,
    8361,
    8362,
    8363,
    4869,
    4461,
    8364,
    8365,
    8366,
    8367,
    8368,
    8369,
    8370,
    4870,
    8371,
    8372,
    8373,
    8374,
    8375,
    8376,
    8377,
    8378,
    8379,
    8380,
    8381,
    8382,
    8383,
    8384,
    8385,
    8386,
    8387,
    8388,
    8389,
    8390,
    8391,
    8392,
    8393,
    8394,
    8395,
    8396,
    8397,
    8398,
    8399,
    8400,
    8401,
    8402,
    8403,
    8404,
    8405,
    8406,
    8407,
    8408,
    8409,
    8410,
    4871,
    8411,
    8412,
    8413,
    8414,
    8415,
    8416,
    8417,
    8418,
    8419,
    8420,
    8421,
    8422,
    4462,
    8423,
    8424,
    8425,
    8426,
    8427,
    8428,
    8429,
    8430,
    8431,
    8432,
    8433,
    2986,
    8434,
    8435,
    8436,
    8437,
    8438,
    8439,
    8440,
    8441,
    8442,
    8443,
    8444,
    8445,
    8446,
    8447,
    8448,
    8449,
    8450,
    8451,
    8452,
    8453,
    8454,
    8455,
    8456,
    8457,
    8458,
    8459,
    8460,
    8461,
    8462,
    8463,
    8464,
    8465,
    8466,
    8467,
    8468,
    8469,
    8470,
    8471,
    8472,
    8473,
    8474,
    8475,
    8476,
    8477,
    8478,
    4180,
    8479,
    8480,
    8481,
    8482,
    8483,
    8484,
    8485,
    8486,
    8487,
    8488,
    8489,
    8490,
    8491,
    8492,
    8493,
    8494,
    8495,
    8496,
    8497,
    8498,
    8499,
    8500,
    8501,
    8502,
    8503,
    8504,
    8505,
    8506,
    8507,
    8508,
    8509,
    8510,
    8511,
    8512,
    8513,
    8514,
    8515,
    8516,
    8517,
    8518,
    8519,
    8520,
    8521,
    8522,
    8523,
    8524,
    8525,
    8526,
    8527,
    8528,
    8529,
    8530,
    8531,
    8532,
    8533,
    8534,
    8535,
    8536,
    8537,
    8538,
    8539,
    8540,
    8541,
    8542,
    8543,
    8544,
    8545,
    8546,
    8547,
    8548,
    8549,
    8550,
    8551,
    8552,
    8553,
    8554,
    8555,
    8556,
    8557,
    8558,
    8559,
    8560,
    8561,
    8562,
    8563,
    8564,
    4872,
    8565,
    8566,
    8567,
    8568,
    8569,
    8570,
    8571,
    8572,
    8573,
    4873,
    8574,
    8575,
    8576,
    8577,
    8578,
    8579,
    8580,
    8581,
    8582,
    8583,
    8584,
    8585,
    8586,
    8587,
    8588,
    8589,
    8590,
    8591,
    8592,
    8593,
    8594,
    8595,
    8596,
    8597,
    8598,
    8599,
    8600,
    8601,
    8602,
    8603,
    8604,
    8605,
    3803,
    8606,
    8607,
    8608,
    8609,
    8610,
    8611,
    8612,
    8613,
    4874,
    3804,
    8614,
    8615,
    8616,
    8617,
    8618,
    8619,
    8620,
    8621,
    3956,
    8622,
    8623,
    8624,
    8625,
    8626,
    8627,
    8628,
    8629,
    8630,
    8631,
    8632,
    8633,
    8634,
    8635,
    8636,
    8637,
    8638,
    2865,
    8639,
    8640,
    8641,
    8642,
    8643,
    8644,
    8645,
    8646,
    8647,
    8648,
    8649,
    8650,
    8651,
    8652,
    8653,
    8654,
    8655,
    8656,
    4463,
    8657,
    8658,
    8659,
    4875,
    4876,
    8660,
    8661,
    8662,
    8663,
    8664,
    8665,
    8666,
    8667,
    8668,
    8669,
    8670,
    8671,
    8672,
    8673,
    8674,
    8675,
    8676,
    8677,
    8678,
    8679,
    8680,
    8681,
    4464,
    8682,
    8683,
    8684,
    8685,
    8686,
    8687,
    8688,
    8689,
    8690,
    8691,
    8692,
    8693,
    8694,
    8695,
    8696,
    8697,
    8698,
    8699,
    8700,
    8701,
    8702,
    8703,
    8704,
    8705,
    8706,
    8707,
    8708,
    8709,
    2261,
    8710,
    8711,
    8712,
    8713,
    8714,
    8715,
    8716,
    8717,
    8718,
    8719,
    8720,
    8721,
    8722,
    8723,
    8724,
    8725,
    8726,
    8727,
    8728,
    8729,
    8730,
    8731,
    8732,
    8733,
    4181,
    8734,
    8735,
    8736,
    8737,
    8738,
    8739,
    8740,
    8741,
    8742,
    8743,
    8744,
    8745,
    8746,
    8747,
    8748,
    8749,
    8750,
    8751,
    8752,
    8753,
    8754,
    8755,
    8756,
    8757,
    8758,
    8759,
    8760,
    8761,
    8762,
    8763,
    4877,
    8764,
    8765,
    8766,
    8767,
    8768,
    8769,
    8770,
    8771,
    8772,
    8773,
    8774,
    8775,
    8776,
    8777,
    8778,
    8779,
    8780,
    8781,
    8782,
    8783,
    8784,
    8785,
    8786,
    8787,
    8788,
    4878,
    8789,
    4879,
    8790,
    8791,
    8792,
    4880,
    8793,
    8794,
    8795,
    8796,
    8797,
    8798,
    8799,
    8800,
    8801,
    4881,
    8802,
    8803,
    8804,
    8805,
    8806,
    8807,
    8808,
    8809,
    8810,
    8811,
    8812,
    8813,
    8814,
    8815,
    3957,
    8816,
    8817,
    8818,
    8819,
    8820,
    8821,
    8822,
    8823,
    8824,
    8825,
    8826,
    8827,
    8828,
    8829,
    8830,
    8831,
    8832,
    8833,
    8834,
    8835,
    8836,
    8837,
    8838,
    8839,
    8840,
    8841,
    8842,
    8843,
    8844,
    8845,
    8846,
    8847,
    4882,
    8848,
    8849,
    8850,
    8851,
    8852,
    8853,
    8854,
    8855,
    8856,
    8857,
    8858,
    8859,
    8860,
    8861,
    8862,
    8863,
    8864,
    8865,
    8866,
    8867,
    8868,
    8869,
    8870,
    8871,
    8872,
    8873,
    8874,
    8875,
    8876,
    8877,
    8878,
    8879,
    8880,
    8881,
    8882,
    8883,
    8884,
    3202,
    8885,
    8886,
    8887,
    8888,
    8889,
    8890,
    8891,
    8892,
    8893,
    8894,
    8895,
    8896,
    8897,
    8898,
    8899,
    8900,
    8901,
    8902,
    8903,
    8904,
    8905,
    8906,
    8907,
    8908,
    8909,
    8910,
    8911,
    8912,
    8913,
    8914,
    8915,
    8916,
    8917,
    8918,
    8919,
    8920,
    8921,
    8922,
    8923,
    8924,
    4465,
    8925,
    8926,
    8927,
    8928,
    8929,
    8930,
    8931,
    8932,
    4883,
    8933,
    8934,
    8935,
    8936,
    8937,
    8938,
    8939,
    8940,
    8941,
    8942,
    8943,
    2214,
    8944,
    8945,
    8946,
    8947,
    8948,
    8949,
    8950,
    8951,
    8952,
    8953,
    8954,
    8955,
    8956,
    8957,
    8958,
    8959,
    8960,
    8961,
    8962,
    8963,
    8964,
    8965,
    4884,
    8966,
    8967,
    8968,
    8969,
    8970,
    8971,
    8972,
    8973,
    8974,
    8975,
    8976,
    8977,
    8978,
    8979,
    8980,
    8981,
    8982,
    8983,
    8984,
    8985,
    8986,
    8987,
    8988,
    8989,
    8990,
    8991,
    8992,
    4885,
    8993,
    8994,
    8995,
    8996,
    8997,
    8998,
    8999,
    9000,
    9001,
    9002,
    9003,
    9004,
    9005,
    9006,
    9007,
    9008,
    9009,
    9010,
    9011,
    9012,
    9013,
    9014,
    9015,
    9016,
    9017,
    9018,
    9019,
    9020,
    9021,
    4182,
    9022,
    9023,
    9024,
    9025,
    9026,
    9027,
    9028,
    9029,
    9030,
    9031,
    9032,
    9033,
    9034,
    9035,
    9036,
    9037,
    9038,
    9039,
    9040,
    9041,
    9042,
    9043,
    9044,
    9045,
    9046,
    9047,
    9048,
    9049,
    9050,
    9051,
    9052,
    9053,
    9054,
    9055,
    9056,
    9057,
    9058,
    9059,
    9060,
    9061,
    9062,
    9063,
    4886,
    9064,
    9065,
    9066,
    9067,
    9068,
    9069,
    4887,
    9070,
    9071,
    9072,
    9073,
    9074,
    9075,
    9076,
    9077,
    9078,
    9079,
    9080,
    9081,
    9082,
    9083,
    9084,
    9085,
    9086,
    9087,
    9088,
    9089,
    9090,
    9091,
    9092,
    9093,
    9094,
    9095,
    9096,
    9097,
    9098,
    9099,
    9100,
    9101,
    9102,
    9103,
    9104,
    9105,
    9106,
    9107,
    9108,
    9109,
    9110,
    9111,
    9112,
    9113,
    9114,
    9115,
    9116,
    9117,
    9118,
    9119,
    9120,
    9121,
    9122,
    9123,
    9124,
    9125,
    9126,
    9127,
    9128,
    9129,
    9130,
    9131,
    9132,
    9133,
    9134,
    9135,
    9136,
    9137,
    9138,
    9139,
    9140,
    9141,
    3958,
    9142,
    9143,
    9144,
    9145,
    9146,
    9147,
    9148,
    9149,
    9150,
    9151,
    4888,
    9152,
    9153,
    9154,
    9155,
    9156,
    9157,
    9158,
    9159,
    9160,
    9161,
    9162,
    9163,
    9164,
    9165,
    9166,
    9167,
    9168,
    9169,
    9170,
    9171,
    9172,
    9173,
    9174,
    9175,
    4889,
    9176,
    9177,
    9178,
    9179,
    9180,
    9181,
    9182,
    9183,
    9184,
    9185,
    9186,
    9187,
    9188,
    9189,
    9190,
    9191,
    9192,
    9193,
    9194,
    9195,
    9196,
    9197,
    9198,
    9199,
    9200,
    9201,
    9202,
    9203,
    4890,
    9204,
    9205,
    9206,
    9207,
    9208,
    9209,
    9210,
    9211,
    9212,
    9213,
    9214,
    9215,
    9216,
    9217,
    9218,
    9219,
    9220,
    9221,
    9222,
    4466,
    9223,
    9224,
    9225,
    9226,
    9227,
    9228,
    9229,
    9230,
    9231,
    9232,
    9233,
    9234,
    9235,
    9236,
    9237,
    9238,
    9239,
    9240,
    9241,
    9242,
    9243,
    9244,
    9245,
    4891,
    9246,
    9247,
    9248,
    9249,
    9250,
    9251,
    9252,
    9253,
    9254,
    9255,
    9256,
    9257,
    4892,
    9258,
    9259,
    9260,
    9261,
    4893,
    4894,
    9262,
    9263,
    9264,
    9265,
    9266,
    9267,
    9268,
    9269,
    9270,
    9271,
    9272,
    9273,
    4467,
    9274,
    9275,
    9276,
    9277,
    9278,
    9279,
    9280,
    9281,
    9282,
    9283,
    9284,
    9285,
    3673,
    9286,
    9287,
    9288,
    9289,
    9290,
    9291,
    9292,
    9293,
    9294,
    9295,
    9296,
    9297,
    9298,
    9299,
    9300,
    9301,
    9302,
    9303,
    9304,
    9305,
    9306,
    9307,
    9308,
    9309,
    9310,
    9311,
    9312,
    9313,
    9314,
    9315,
    9316,
    9317,
    9318,
    9319,
    9320,
    9321,
    9322,
    4895,
    9323,
    9324,
    9325,
    9326,
    9327,
    9328,
    9329,
    9330,
    9331,
    9332,
    9333,
    9334,
    9335,
    9336,
    9337,
    9338,
    9339,
    9340,
    9341,
    9342,
    9343,
    9344,
    9345,
    9346,
    9347,
    4468,
    9348,
    9349,
    9350,
    9351,
    9352,
    9353,
    9354,
    9355,
    9356,
    9357,
    9358,
    9359,
    9360,
    9361,
    9362,
    9363,
    9364,
    9365,
    9366,
    9367,
    9368,
    9369,
    9370,
    9371,
    9372,
    9373,
    4896,
    9374,
    4469,
    9375,
    9376,
    9377,
    9378,
    9379,
    4897,
    9380,
    9381,
    9382,
    9383,
    9384,
    9385,
    9386,
    9387,
    9388,
    9389,
    9390,
    9391,
    9392,
    9393,
    9394,
    9395,
    9396,
    9397,
    9398,
    9399,
    9400,
    9401,
    9402,
    9403,
    9404,
    9405,
    9406,
    4470,
    9407,
    2751,
    9408,
    9409,
    3674,
    3552,
    9410,
    9411,
    9412,
    9413,
    9414,
    9415,
    9416,
    9417,
    9418,
    9419,
    9420,
    9421,
    4898,
    9422,
    9423,
    9424,
    9425,
    9426,
    9427,
    9428,
    9429,
    3959,
    9430,
    9431,
    9432,
    9433,
    9434,
    9435,
    9436,
    4471,
    9437,
    9438,
    9439,
    9440,
    9441,
    9442,
    9443,
    9444,
    9445,
    9446,
    9447,
    9448,
    9449,
    9450,
    3348,
    9451,
    9452,
    9453,
    9454,
    9455,
    9456,
    9457,
    9458,
    9459,
    9460,
    9461,
    9462,
    9463,
    9464,
    9465,
    9466,
    9467,
    9468,
    9469,
    9470,
    9471,
    9472,
    4899,
    9473,
    9474,
    9475,
    9476,
    9477,
    4900,
    9478,
    9479,
    9480,
    9481,
    9482,
    9483,
    9484,
    9485,
    9486,
    9487,
    9488,
    3349,
    9489,
    9490,
    9491,
    9492,
    9493,
    9494,
    9495,
    9496,
    9497,
    9498,
    9499,
    9500,
    9501,
    9502,
    9503,
    9504,
    9505,
    9506,
    9507,
    9508,
    9509,
    9510,
    9511,
    9512,
    9513,
    9514,
    9515,
    9516,
    9517,
    9518,
    9519,
    9520,
    4901,
    9521,
    9522,
    9523,
    9524,
    9525,
    9526,
    4902,
    9527,
    9528,
    9529,
    9530,
    9531,
    9532,
    9533,
    9534,
    9535,
    9536,
    9537,
    9538,
    9539,
    9540,
    9541,
    9542,
    9543,
    9544,
    9545,
    9546,
    9547,
    9548,
    9549,
    9550,
    9551,
    9552,
    9553,
    9554,
    9555,
    9556,
    9557,
    9558,
    9559,
    9560,
    9561,
    9562,
    9563,
    9564,
    9565,
    9566,
    9567,
    9568,
    9569,
    9570,
    9571,
    9572,
    9573,
    9574,
    9575,
    9576,
    9577,
    9578,
    9579,
    9580,
    9581,
    9582,
    9583,
    9584,
    3805,
    9585,
    9586,
    9587,
    9588,
    9589,
    9590,
    9591,
    9592,
    9593,
    9594,
    9595,
    9596,
    9597,
    9598,
    9599,
    9600,
    9601,
    9602,
    4903,
    9603,
    9604,
    9605,
    9606,
    9607,
    4904,
    9608,
    9609,
    9610,
    9611,
    9612,
    9613,
    9614,
    4905,
    9615,
    9616,
    9617,
    9618,
    9619,
    9620,
    9621,
    9622,
    9623,
    9624,
    9625,
    9626,
    9627,
    9628,
    9629,
    9630,
    9631,
    9632,
    4906,
    9633,
    9634,
    9635,
    9636,
    9637,
    9638,
    9639,
    9640,
    9641,
    9642,
    9643,
    4907,
    9644,
    9645,
    9646,
    9647,
    9648,
    9649,
    9650,
    9651,
    9652,
    9653,
    9654,
    9655,
    9656,
    9657,
    9658,
    9659,
    9660,
    9661,
    9662,
    9663,
    9664,
    9665,
    9666,
    9667,
    9668,
    9669,
    9670,
    9671,
    9672,
    4183,
    9673,
    9674,
    9675,
    9676,
    9677,
    4908,
    9678,
    9679,
    9680,
    9681,
    4909,
    9682,
    9683,
    9684,
    9685,
    9686,
    9687,
    9688,
    9689,
    9690,
    4910,
    9691,
    9692,
    9693,
    3675,
    9694,
    9695,
    9696,
    2945,
    9697,
    9698,
    9699,
    9700,
    9701,
    9702,
    9703,
    9704,
    9705,
    4911,
    9706,
    9707,
    9708,
    9709,
    9710,
    9711,
    9712,
    9713,
    9714,
    9715,
    9716,
    9717,
    9718,
    9719,
    9720,
    9721,
    9722,
    9723,
    9724,
    9725,
    9726,
    9727,
    9728,
    9729,
    9730,
    9731,
    9732,
    9733,
    9734,
    9735,
    4912,
    9736,
    9737,
    9738,
    9739,
    9740,
    4913,
    9741,
    9742,
    9743,
    9744,
    9745,
    9746,
    9747,
    9748,
    9749,
    9750,
    9751,
    9752,
    9753,
    9754,
    9755,
    9756,
    9757,
    9758,
    4914,
    9759,
    9760,
    9761,
    9762,
    9763,
    9764,
    9765,
    9766,
    9767,
    9768,
    9769,
    9770,
    9771,
    9772,
    9773,
    9774,
    9775,
    9776,
    9777,
    9778,
    9779,
    9780,
    9781,
    9782,
    4915,
    9783,
    9784,
    9785,
    9786,
    9787,
    9788,
    9789,
    9790,
    9791,
    9792,
    9793,
    4916,
    9794,
    9795,
    9796,
    9797,
    9798,
    9799,
    9800,
    9801,
    9802,
    9803,
    9804,
    9805,
    9806,
    9807,
    9808,
    9809,
    9810,
    9811,
    9812,
    9813,
    9814,
    9815,
    9816,
    9817,
    9818,
    9819,
    9820,
    9821,
    9822,
    9823,
    9824,
    9825,
    9826,
    9827,
    9828,
    9829,
    9830,
    9831,
    9832,
    9833,
    9834,
    9835,
    9836,
    9837,
    9838,
    9839,
    9840,
    9841,
    9842,
    9843,
    9844,
    9845,
    9846,
    9847,
    9848,
    9849,
    9850,
    9851,
    9852,
    9853,
    9854,
    9855,
    9856,
    9857,
    9858,
    9859,
    9860,
    9861,
    9862,
    9863,
    9864,
    9865,
    9866,
    9867,
    9868,
    4917,
    9869,
    9870,
    9871,
    9872,
    9873,
    9874,
    9875,
    9876,
    9877,
    9878,
    9879,
    9880,
    9881,
    9882,
    9883,
    9884,
    9885,
    9886,
    9887,
    9888,
    9889,
    9890,
    9891,
    9892,
    4472,
    9893,
    9894,
    9895,
    9896,
    9897,
    3806,
    9898,
    9899,
    9900,
    9901,
    9902,
    9903,
    9904,
    9905,
    9906,
    9907,
    9908,
    9909,
    9910,
    9911,
    9912,
    9913,
    9914,
    4918,
    9915,
    9916,
    9917,
    4919,
    9918,
    9919,
    9920,
    9921,
    4184,
    9922,
    9923,
    9924,
    9925,
    9926,
    9927,
    9928,
    9929,
    9930,
    9931,
    9932,
    9933,
    9934,
    9935,
    9936,
    9937,
    9938,
    9939,
    9940,
    9941,
    9942,
    9943,
    9944,
    9945,
    9946,
    4920,
    9947,
    9948,
    9949,
    9950,
    9951,
    9952,
    9953,
    9954,
    9955,
    4185,
    9956,
    9957,
    9958,
    9959,
    9960,
    9961,
    9962,
    9963,
    9964,
    9965,
    4921,
    9966,
    9967,
    9968,
    4473,
    9969,
    9970,
    9971,
    9972,
    9973,
    9974,
    9975,
    9976,
    9977,
    4474,
    9978,
    9979,
    9980,
    9981,
    9982,
    9983,
    9984,
    9985,
    9986,
    9987,
    9988,
    9989,
    9990,
    9991,
    9992,
    9993,
    9994,
    9995,
    9996,
    9997,
    9998,
    9999,
    10000,
    10001,
    10002,
    10003,
    10004,
    10005,
    10006,
    10007,
    10008,
    10009,
    10010,
    10011,
    10012,
    10013,
    10014,
    10015,
    10016,
    10017,
    10018,
    10019,
    10020,
    10021,
    4922,
    10022,
    4923,
    10023,
    10024,
    10025,
    10026,
    10027,
    10028,
    10029,
    10030,
    10031,
    10032,
    10033,
    10034,
    10035,
    10036,
    10037,
    10038,
    10039,
    10040,
    10041,
    10042,
    10043,
    10044,
    10045,
    10046,
    10047,
    10048,
    4924,
    10049,
    10050,
    10051,
    10052,
    10053,
    10054,
    10055,
    10056,
    10057,
    10058,
    10059,
    10060,
    10061,
    10062,
    10063,
    10064,
    10065,
    10066,
    10067,
    10068,
    10069,
    10070,
    10071,
    10072,
    10073,
    10074,
    10075,
    10076,
    10077,
    10078,
    10079,
    10080,
    10081,
    10082,
    10083,
    10084,
    10085,
    10086,
    10087,
    4475,
    10088,
    10089,
    10090,
    10091,
    10092,
    10093,
    10094,
    10095,
    10096,
    10097,
    4476,
    10098,
    10099,
    10100,
    10101,
    10102,
    10103,
    10104,
    10105,
    10106,
    10107,
    10108,
    10109,
    10110,
    10111,
    2174,
    10112,
    10113,
    10114,
    10115,
    10116,
    10117,
    10118,
    10119,
    10120,
    10121,
    10122,
    10123,
    10124,
    10125,
    10126,
    10127,
    10128,
    10129,
    10130,
    10131,
    10132,
    10133,
    10134,
    10135,
    10136,
    10137,
    10138,
    10139,
    10140,
    3807,
    4186,
    4925,
    10141,
    10142,
    10143,
    10144,
    10145,
    10146,
    10147,
    4477,
    4187,
    10148,
    10149,
    10150,
    10151,
    10152,
    10153,
    4188,
    10154,
    10155,
    10156,
    10157,
    10158,
    10159,
    10160,
    10161,
    4926,
    10162,
    10163,
    10164,
    10165,
    10166,
    10167,
    10168,
    10169,
    10170,
    10171,
    10172,
    10173,
    10174,
    10175,
    10176,
    10177,
    10178,
    10179,
    10180,
    10181,
    10182,
    10183,
    10184,
    10185,
    10186,
    10187,
    10188,
    10189,
    10190,
    10191,
    10192,
    3203,
    10193,
    10194,
    10195,
    10196,
    10197,
    10198,
    10199,
    10200,
    4478,
    10201,
    10202,
    10203,
    10204,
    4479,
    10205,
    10206,
    10207,
    10208,
    10209,
    10210,
    10211,
    10212,
    10213,
    10214,
    10215,
    10216,
    10217,
    10218,
    10219,
    10220,
    10221,
    10222,
    10223,
    10224,
    10225,
    10226,
    10227,
    10228,
    10229,
    10230,
    10231,
    10232,
    10233,
    10234,
    4927,
    10235,
    10236,
    10237,
    10238,
    10239,
    10240,
    10241,
    10242,
    10243,
    10244,
    10245,
    10246,
    10247,
    10248,
    10249,
    10250,
    10251,
    10252,
    10253,
    10254,
    10255,
    10256,
    10257,
    10258,
    10259,
    10260,
    10261,
    10262,
    10263,
    10264,
    10265,
    10266,
    10267,
    10268,
    10269,
    10270,
    10271,
    10272,
    10273,
    4480,
    4928,
    4929,
    10274,
    10275,
    10276,
    10277,
    10278,
    10279,
    10280,
    10281,
    10282,
    10283,
    10284,
    10285,
    10286,
    10287,
    10288,
    10289,
    10290,
    10291,
    10292,
    10293,
    10294,
    10295,
    10296,
    10297,
    10298,
    10299,
    10300,
    10301,
    10302,
    10303,
    10304,
    10305,
    10306,
    10307,
    10308,
    10309,
    10310,
    10311,
    10312,
    10313,
    10314,
    10315,
    10316,
    10317,
    10318,
    10319,
    10320,
    10321,
    10322,
    10323,
    10324,
    10325,
    10326,
    10327,
    10328,
    10329,
    10330,
    10331,
    10332,
    10333,
    10334,
    4930,
    10335,
    10336,
    10337,
    10338,
    10339,
    10340,
    10341,
    10342,
    4931,
    10343,
    10344,
    10345,
    10346,
    10347,
    10348,
    10349,
    10350,
    10351,
    10352,
    10353,
    10354,
    10355,
    3088,
    10356,
    2786,
    10357,
    10358,
    10359,
    10360,
    4189,
    10361,
    10362,
    10363,
    10364,
    10365,
    10366,
    10367,
    10368,
    10369,
    10370,
    10371,
    10372,
    10373,
    10374,
    10375,
    4932,
    10376,
    10377,
    10378,
    10379,
    10380,
    10381,
    10382,
    10383,
    10384,
    10385,
    10386,
    10387,
    10388,
    10389,
    10390,
    10391,
    10392,
    4933,
    10393,
    10394,
    10395,
    4934,
    10396,
    10397,
    10398,
    10399,
    10400,
    10401,
    10402,
    10403,
    10404,
    10405,
    10406,
    10407,
    10408,
    10409,
    10410,
    10411,
    10412,
    3446,
    10413,
    10414,
    10415,
    10416,
    10417,
    10418,
    10419,
    10420,
    10421,
    10422,
    10423,
    4935,
    10424,
    10425,
    10426,
    10427,
    10428,
    10429,
    10430,
    4936,
    10431,
    10432,
    10433,
    10434,
    10435,
    10436,
    10437,
    10438,
    10439,
    10440,
    10441,
    10442,
    10443,
    4937,
    10444,
    10445,
    10446,
    10447,
    4481,
    10448,
    10449,
    10450,
    10451,
    10452,
    10453,
    10454,
    10455,
    10456,
    10457,
    10458,
    10459,
    10460,
    10461,
    10462,
    10463,
    10464,
    10465,
    10466,
    10467,
    10468,
    10469,
    10470,
    10471,
    10472,
    10473,
    10474,
    10475,
    10476,
    10477,
    10478,
    10479,
    10480,
    10481,
    10482,
    10483,
    10484,
    10485,
    10486,
    10487,
    10488,
    10489,
    10490,
    10491,
    10492,
    10493,
    10494,
    10495,
    10496,
    10497,
    10498,
    10499,
    10500,
    10501,
    10502,
    10503,
    10504,
    10505,
    4938,
    10506,
    10507,
    10508,
    10509,
    10510,
    2552,
    10511,
    10512,
    10513,
    10514,
    10515,
    10516,
    3447,
    10517,
    10518,
    10519,
    10520,
    10521,
    10522,
    10523,
    10524,
    10525,
    10526,
    10527,
    10528,
    10529,
    10530,
    10531,
    10532,
    10533,
    10534,
    10535,
    10536,
    10537,
    10538,
    10539,
    10540,
    10541,
    10542,
    10543,
    4482,
    10544,
    4939,
    10545,
    10546,
    10547,
    10548,
    10549,
    10550,
    10551,
    10552,
    10553,
    10554,
    10555,
    10556,
    10557,
    10558,
    10559,
    10560,
    10561,
    10562,
    10563,
    10564,
    10565,
    10566,
    10567,
    3676,
    4483,
    10568,
    10569,
    10570,
    10571,
    10572,
    3448,
    10573,
    10574,
    10575,
    10576,
    10577,
    10578,
    10579,
    10580,
    10581,
    10582,
    10583,
    10584,
    10585,
    10586,
    10587,
    10588,
    10589,
    10590,
    10591,
    10592,
    10593,
    10594,
    10595,
    10596,
    10597,
    10598,
    10599,
    10600,
    10601,
    10602,
    10603,
    10604,
    10605,
    10606,
    10607,
    10608,
    10609,
    10610,
    10611,
    10612,
    10613,
    10614,
    10615,
    10616,
    10617,
    10618,
    10619,
    10620,
    10621,
    10622,
    10623,
    10624,
    10625,
    10626,
    10627,
    4484,
    10628,
    10629,
    10630,
    10631,
    10632,
    4940,
    10633,
    10634,
    10635,
    10636,
    10637,
    10638,
    10639,
    10640,
    10641,
    10642,
    10643,
    10644,
    10645,
    10646,
    10647,
    10648,
    10649,
    10650,
    10651,
    10652,
    10653,
    10654,
    10655,
    10656,
    4941,
    10657,
    10658,
    10659,
    2599,
    10660,
    10661,
    10662,
    10663,
    10664,
    10665,
    10666,
    3089,
    10667,
    10668,
    10669,
    10670,
    10671,
    10672,
    10673,
    10674,
    10675,
    10676,
    10677,
    10678,
    10679,
    10680,
    4942,
    10681,
    10682,
    10683,
    10684,
    10685,
    10686,
    10687,
    10688,
    10689,
    10690,
    10691,
    10692,
    10693,
    10694,
    10695,
    10696,
    10697,
    4485,
    10698,
    10699,
    10700,
    10701,
    10702,
    10703,
    10704,
    4943,
    10705,
    3677,
    10706,
    10707,
    10708,
    10709,
    10710,
    10711,
    10712,
    4944,
    10713,
    10714,
    10715,
    10716,
    10717,
    10718,
    10719,
    10720,
    10721,
    10722,
    10723,
    10724,
    10725,
    10726,
    10727,
    10728,
    4945,
    10729,
    10730,
    10731,
    10732,
    10733,
    10734,
    10735,
    10736,
    10737,
    10738,
    10739,
    10740,
    10741,
    10742,
    10743,
    10744,
    10745,
    10746,
    10747,
    10748,
    10749,
    10750,
    10751,
    10752,
    10753,
    10754,
    10755,
    10756,
    10757,
    10758,
    10759,
    10760,
    10761,
    4946,
    10762,
    10763,
    10764,
    10765,
    10766,
    10767,
    4947,
    4948,
    10768,
    10769,
    10770,
    10771,
    10772,
    10773,
    10774,
    10775,
    10776,
    10777,
    10778,
    10779,
    10780,
    10781,
    10782,
    10783,
    10784,
    10785,
    10786,
    10787,
    10788,
    10789,
    10790,
    10791,
    10792,
    10793,
    10794,
    10795,
    10796,
    10797,
    10798,
    10799,
    10800,
    10801,
    10802,
    10803,
    10804,
    10805,
    10806,
    10807,
    10808,
    10809,
    10810,
    10811,
    10812,
    10813,
    10814,
    10815,
    10816,
    10817,
    10818,
    10819,
    10820,
    10821,
    10822,
    10823,
    10824,
    10825,
    10826,
    10827,
    10828,
    10829,
    10830,
    10831,
    10832,
    10833,
    10834,
    10835,
    10836,
    10837,
    10838,
    10839,
    10840,
    10841,
    10842,
    10843,
    10844,
    10845,
    10846,
    10847,
    10848,
    10849,
    10850,
    10851,
    10852,
    10853,
    10854,
    10855,
    10856,
    10857,
    10858,
    10859,
    10860,
    10861,
    10862,
    10863,
    10864,
    10865,
    10866,
    10867,
    10868,
    10869,
    10870,
    10871,
    10872,
    10873,
    10874,
    10875,
    10876,
    10877,
    10878,
    4486,
    10879,
    10880,
    10881,
    10882,
    10883,
    10884,
    10885,
    4949,
    10886,
    10887,
    10888,
    10889,
    10890,
    10891,
    10892,
    10893,
    10894,
    10895,
    10896,
    10897,
    10898,
    10899,
    10900,
    10901,
    10902,
    10903,
    10904,
    10905,
    10906,
    10907,
    10908,
    10909,
    10910,
    10911,
    10912,
    10913,
    10914,
    10915,
    10916,
    10917,
    10918,
    10919,
    4487,
    10920,
    10921,
    10922,
    10923,
    10924,
    10925,
    10926,
    10927,
    10928,
    10929,
    10930,
    10931,
    10932,
    4950,
    10933,
    10934,
    10935,
    10936,
    10937,
    10938,
    10939,
    10940,
    10941,
    10942,
    10943,
    10944,
    10945,
    10946,
    10947,
    10948,
    10949,
    4488,
    10950,
    10951,
    10952,
    10953,
    10954,
    10955,
    10956,
    10957,
    10958,
    10959,
    4190,
    10960,
    10961,
    10962,
    10963,
    10964,
    10965,
    10966,
    10967,
    10968,
    10969,
    10970,
    10971,
    10972,
    10973,
    10974,
    10975,
    10976,
    10977,
    10978,
    10979,
    10980,
    10981,
    10982,
    10983,
    10984,
    10985,
    10986,
    10987,
    10988,
    10989,
    10990,
    10991,
    10992,
    10993,
    10994,
    10995,
    10996,
    10997,
    10998,
    10999,
    11000,
    11001,
    11002,
    11003,
    11004,
    11005,
    11006,
    3960,
    11007,
    11008,
    11009,
    11010,
    11011,
    11012,
    11013,
    11014,
    11015,
    11016,
    11017,
    11018,
    11019,
    11020,
    11021,
    11022,
    11023,
    11024,
    11025,
    11026,
    11027,
    11028,
    11029,
    11030,
    11031,
    11032,
    4951,
    11033,
    11034,
    11035,
    11036,
    11037,
    11038,
    11039,
    11040,
    11041,
    11042,
    11043,
    11044,
    11045,
    11046,
    11047,
    4489,
    11048,
    11049,
    11050,
    11051,
    4952,
    11052,
    11053,
    11054,
    11055,
    11056,
    11057,
    11058,
    4953,
    11059,
    11060,
    11061,
    11062,
    11063,
    11064,
    11065,
    11066,
    11067,
    11068,
    11069,
    11070,
    11071,
    4954,
    11072,
    11073,
    11074,
    11075,
    11076,
    11077,
    11078,
    11079,
    11080,
    11081,
    11082,
    11083,
    11084,
    11085,
    11086,
    11087,
    11088,
    11089,
    11090,
    11091,
    11092,
    11093,
    11094,
    11095,
    11096,
    11097,
    11098,
    11099,
    11100,
    11101,
    11102,
    11103,
    11104,
    11105,
    11106,
    11107,
    11108,
    11109,
    11110,
    11111,
    11112,
    11113,
    11114,
    11115,
    3808,
    11116,
    11117,
    11118,
    11119,
    11120,
    11121,
    11122,
    11123,
    11124,
    11125,
    11126,
    11127,
    11128,
    11129,
    11130,
    11131,
    11132,
    11133,
    11134,
    4955,
    11135,
    11136,
    11137,
    11138,
    11139,
    11140,
    11141,
    11142,
    11143,
    11144,
    11145,
    11146,
    11147,
    11148,
    11149,
    11150,
    11151,
    11152,
    11153,
    11154,
    11155,
    11156,
    11157,
    11158,
    11159,
    11160,
    11161,
    4956,
    11162,
    11163,
    11164,
    11165,
    11166,
    11167,
    11168,
    11169,
    11170,
    11171,
    11172,
    11173,
    11174,
    11175,
    11176,
    11177,
    11178,
    11179,
    11180,
    4957,
    11181,
    11182,
    11183,
    11184,
    11185,
    11186,
    4958,
    11187,
    11188,
    11189,
    11190,
    11191,
    11192,
    11193,
    11194,
    11195,
    11196,
    11197,
    11198,
    11199,
    11200,
    3678,
    11201,
    11202,
    11203,
    11204,
    11205,
    11206,
    4191,
    11207,
    11208,
    11209,
    11210,
    11211,
    11212,
    11213,
    11214,
    11215,
    11216,
    11217,
    11218,
    11219,
    11220,
    11221,
    11222,
    11223,
    11224,
    11225,
    11226,
    11227,
    11228,
    11229,
    11230,
    11231,
    11232,
    11233,
    11234,
    11235,
    11236,
    11237,
    11238,
    11239,
    11240,
    11241,
    11242,
    11243,
    11244,
    11245,
    11246,
    11247,
    11248,
    11249,
    11250,
    11251,
    4959,
    11252,
    11253,
    11254,
    11255,
    11256,
    11257,
    11258,
    11259,
    11260,
    11261,
    11262,
    11263,
    11264,
    11265,
    11266,
    11267,
    11268,
    11269,
    11270,
    11271,
    11272,
    11273,
    11274,
    11275,
    11276,
    11277,
    11278,
    11279,
    11280,
    11281,
    11282,
    11283,
    11284,
    11285,
    11286,
    11287,
    11288,
    11289,
    11290,
    11291,
    11292,
    11293,
    11294,
    11295,
    11296,
    11297,
    11298,
    11299,
    11300,
    11301,
    11302,
    11303,
    11304,
    11305,
    11306,
    11307,
    11308,
    11309,
    11310,
    11311,
    11312,
    11313,
    11314,
    3679,
    11315,
    11316,
    11317,
    11318,
    4490,
    11319,
    11320,
    11321,
    11322,
    11323,
    11324,
    11325,
    11326,
    11327,
    11328,
    11329,
    11330,
    11331,
    11332,
    11333,
    11334,
    11335,
    11336,
    11337,
    11338,
    11339,
    11340,
    11341,
    11342,
    11343,
    11344,
    11345,
    11346,
    11347,
    4960,
    11348,
    11349,
    11350,
    11351,
    11352,
    11353,
    11354,
    11355,
    11356,
    11357,
    11358,
    11359,
    11360,
    11361,
    11362,
    11363,
    11364,
    11365,
    11366,
    11367,
    11368,
    11369,
    11370,
    11371,
    11372,
    11373,
    11374,
    11375,
    11376,
    11377,
    3961,
    4961,
    11378,
    11379,
    11380,
    11381,
    11382,
    11383,
    11384,
    11385,
    11386,
    11387,
    11388,
    11389,
    11390,
    11391,
    11392,
    11393,
    11394,
    11395,
    11396,
    11397,
    4192,
    11398,
    11399,
    11400,
    11401,
    11402,
    11403,
    11404,
    11405,
    11406,
    11407,
    11408,
    11409,
    11410,
    11411,
    4962,
    11412,
    11413,
    11414,
    11415,
    11416,
    11417,
    11418,
    11419,
    11420,
    11421,
    11422,
    11423,
    11424,
    11425,
    11426,
    11427,
    11428,
    11429,
    11430,
    11431,
    11432,
    11433,
    11434,
    11435,
    11436,
    11437,
    11438,
    11439,
    11440,
    11441,
    11442,
    11443,
    11444,
    11445,
    11446,
    11447,
    11448,
    11449,
    11450,
    11451,
    11452,
    11453,
    11454,
    11455,
    11456,
    11457,
    11458,
    11459,
    11460,
    11461,
    11462,
    11463,
    11464,
    11465,
    11466,
    11467,
    11468,
    11469,
    4963,
    11470,
    11471,
    4491,
    11472,
    11473,
    11474,
    11475,
    4964,
    11476,
    11477,
    11478,
    11479,
    11480,
    11481,
    11482,
    11483,
    11484,
    11485,
    11486,
    11487,
    11488,
    11489,
    11490,
    11491,
    11492,
    4965,
    11493,
    11494,
    11495,
    11496,
    11497,
    11498,
    11499,
    11500,
    11501,
    11502,
    11503,
    11504,
    11505,
    11506,
    11507,
    11508,
    11509,
    11510,
    11511,
    11512,
    11513,
    11514,
    11515,
    11516,
    11517,
    11518,
    11519,
    11520,
    11521,
    11522,
    11523,
    11524,
    11525,
    11526,
    11527,
    11528,
    11529,
    3962,
    11530,
    11531,
    11532,
    11533,
    11534,
    11535,
    11536,
    11537,
    11538,
    11539,
    11540,
    11541,
    11542,
    11543,
    11544,
    11545,
    11546,
    11547,
    11548,
    11549,
    11550,
    11551,
    11552,
    11553,
    11554,
    11555,
    11556,
    11557,
    11558,
    11559,
    11560,
    11561,
    11562,
    11563,
    11564,
    4193,
    4194,
    11565,
    11566,
    11567,
    11568,
    11569,
    11570,
    11571,
    11572,
    11573,
    11574,
    11575,
    11576,
    11577,
    11578,
    11579,
    11580,
    11581,
    11582,
    11583,
    11584,
    11585,
    11586,
    11587,
    11588,
    11589,
    11590,
    11591,
    4966,
    4195,
    11592,
    11593,
    11594,
    11595,
    11596,
    11597,
    11598,
    11599,
    11600,
    11601,
    11602,
    11603,
    11604,
    3090,
    11605,
    11606,
    11607,
    11608,
    11609,
    11610,
    4967,
    11611,
    11612,
    11613,
    11614,
    11615,
    11616,
    11617,
    11618,
    11619,
    11620,
    11621,
    11622,
    11623,
    11624,
    11625,
    11626,
    11627,
    11628,
    11629,
    11630,
    11631,
    11632,
    11633,
    11634,
    11635,
    11636,
    11637,
    11638,
    11639,
    11640,
    11641,
    11642,
    11643,
    11644,
    11645,
    11646,
    11647,
    11648,
    11649,
    11650,
    11651,
    11652,
    11653,
    11654,
    11655,
    11656,
    11657,
    11658,
    11659,
    11660,
    11661,
    11662,
    11663,
    11664,
    11665,
    11666,
    11667,
    11668,
    11669,
    11670,
    11671,
    11672,
    11673,
    11674,
    4968,
    11675,
    11676,
    11677,
    11678,
    11679,
    11680,
    11681,
    11682,
    11683,
    11684,
    11685,
    11686,
    11687,
    11688,
    11689,
    11690,
    11691,
    11692,
    11693,
    3809,
    11694,
    11695,
    11696,
    11697,
    11698,
    11699,
    11700,
    11701,
    11702,
    11703,
    11704,
    11705,
    11706,
    11707,
    11708,
    11709,
    11710,
    11711,
    11712,
    11713,
    11714,
    11715,
    11716,
    11717,
    11718,
    3553,
    11719,
    11720,
    11721,
    11722,
    11723,
    11724,
    11725,
    11726,
    11727,
    11728,
    11729,
    11730,
    4969,
    11731,
    11732,
    11733,
    11734,
    11735,
    11736,
    11737,
    11738,
    11739,
    11740,
    4492,
    11741,
    11742,
    11743,
    11744,
    11745,
    11746,
    11747,
    11748,
    11749,
    11750,
    11751,
    11752,
    4970,
    11753,
    11754,
    11755,
    11756,
    11757,
    11758,
    11759,
    11760,
    11761,
    11762,
    11763,
    11764,
    11765,
    11766,
    11767,
    11768,
    11769,
    11770,
    11771,
    11772,
    11773,
    11774,
    11775,
    11776,
    11777,
    11778,
    11779,
    11780,
    11781,
    11782,
    11783,
    11784,
    11785,
    11786,
    11787,
    11788,
    11789,
    11790,
    4971,
    11791,
    11792,
    11793,
    11794,
    11795,
    11796,
    11797,
    4972,
    11798,
    11799,
    11800,
    11801,
    11802,
    11803,
    11804,
    11805,
    11806,
    11807,
    11808,
    11809,
    11810,
    4973,
    11811,
    11812,
    11813,
    11814,
    11815,
    11816,
    11817,
    11818,
    11819,
    11820,
    11821,
    11822,
    11823,
    11824,
    11825,
    11826,
    11827,
    11828,
    11829,
    11830,
    11831,
    11832,
    11833,
    11834,
    3680,
    3810,
    11835,
    11836,
    4974,
    11837,
    11838,
    11839,
    11840,
    11841,
    11842,
    11843,
    11844,
    11845,
    11846,
    11847,
    11848,
    11849,
    11850,
    11851,
    11852,
    11853,
    11854,
    11855,
    11856,
    11857,
    11858,
    11859,
    11860,
    11861,
    11862,
    11863,
    11864,
    11865,
    11866,
    11867,
    11868,
    11869,
    11870,
    11871,
    11872,
    11873,
    11874,
    11875,
    11876,
    11877,
    11878,
    11879,
    11880,
    11881,
    11882,
    11883,
    11884,
    4493,
    11885,
    11886,
    11887,
    11888,
    11889,
    11890,
    11891,
    11892,
    11893,
    11894,
    11895,
    11896,
    11897,
    11898,
    11899,
    11900,
    11901,
    11902,
    11903,
    11904,
    11905,
    11906,
    11907,
    11908,
    11909,
    11910,
    11911,
    11912,
    11913,
    11914,
    11915,
    4975,
    11916,
    11917,
    11918,
    11919,
    11920,
    11921,
    11922,
    11923,
    11924,
    11925,
    11926,
    11927,
    11928,
    11929,
    11930,
    11931,
    11932,
    11933,
    11934,
    11935,
    11936,
    11937,
    11938,
    11939,
    11940,
    11941,
    11942,
    11943,
    11944,
    11945,
    11946,
    11947,
    11948,
    11949,
    4976,
    11950,
    11951,
    11952,
    11953,
    11954,
    11955,
    11956,
    11957,
    11958,
    11959,
    11960,
    11961,
    11962,
    11963,
    11964,
    11965,
    11966,
    11967,
    11968,
    11969,
    11970,
    11971,
    11972,
    11973,
    11974,
    11975,
    11976,
    11977,
    11978,
    11979,
    11980,
    11981,
    11982,
    11983,
    11984,
    11985,
    11986,
    11987,
    4196,
    11988,
    11989,
    11990,
    11991,
    11992,
    4977,
    11993,
    11994,
    11995,
    11996,
    11997,
    11998,
    11999,
    12000,
    12001,
    12002,
    12003,
    12004,
    12005,
    12006,
    12007,
    12008,
    12009,
    12010,
    12011,
    12012,
    12013,
    12014,
    12015,
    12016,
    12017,
    12018,
    12019,
    12020,
    12021,
    12022,
    12023,
    12024,
    12025,
    12026,
    12027,
    12028,
    12029,
    12030,
    12031,
    12032,
    12033,
    12034,
    12035,
    12036,
    12037,
    12038,
    12039,
    12040,
    12041,
    12042,
    12043,
    12044,
    12045,
    12046,
    12047,
    12048,
    12049,
    12050,
    12051,
    12052,
    12053,
    12054,
    12055,
    12056,
    12057,
    12058,
    12059,
    12060,
    12061,
    4978,
    12062,
    12063,
    12064,
    12065,
    12066,
    12067,
    12068,
    12069,
    12070,
    12071,
    12072,
    12073,
    12074,
    12075,
    12076,
    12077,
    12078,
    12079,
    12080,
    12081,
    12082,
    12083,
    12084,
    12085,
    12086,
    12087,
    12088,
    12089,
    12090,
    12091,
    12092,
    12093,
    12094,
    12095,
    12096,
    12097,
    12098,
    12099,
    12100,
    12101,
    12102,
    12103,
    12104,
    12105,
    12106,
    12107,
    12108,
    12109,
    12110,
    12111,
    12112,
    12113,
    12114,
    12115,
    12116,
    12117,
    12118,
    12119,
    12120,
    12121,
    12122,
    12123,
    4979,
    12124,
    12125,
    12126,
    12127,
    12128,
    4197,
    12129,
    12130,
    12131,
    12132,
    12133,
    12134,
    12135,
    12136,
    12137,
    12138,
    12139,
    12140,
    12141,
    12142,
    12143,
    12144,
    12145,
    12146,
    12147,
    12148,
    12149,
    12150,
    12151,
    12152,
    12153,
    12154,
    4980,
    12155,
    12156,
    12157,
    12158,
    12159,
    12160,
    4494,
    12161,
    12162,
    12163,
    12164,
    3811,
    12165,
    12166,
    12167,
    12168,
    12169,
    4495,
    12170,
    12171,
    4496,
    12172,
    12173,
    12174,
    12175,
    12176,
    3812,
    12177,
    12178,
    12179,
    12180,
    12181,
    12182,
    12183,
    12184,
    12185,
    12186,
    12187,
    12188,
    12189,
    12190,
    12191,
    12192,
    12193,
    12194,
    12195,
    12196,
    12197,
    12198,
    12199,
    12200,
    12201,
    12202,
    12203,
    12204,
    12205,
    12206,
    12207,
    12208,
    12209,
    12210,
    12211,
    12212,
    12213,
    12214,
    12215,
    12216,
    12217,
    12218,
    12219,
    12220,
    12221,
    4981,
    12222,
    12223,
    12224,
    12225,
    12226,
    12227,
    12228,
    12229,
    12230,
    12231,
    12232,
    12233,
    12234,
    12235,
    4982,
    12236,
    12237,
    12238,
    12239,
    12240,
    12241,
    12242,
    12243,
    12244,
    12245,
    4983,
    12246,
    12247,
    12248,
    12249,
    4984,
    12250,
    12251,
    12252,
    12253,
    12254,
    12255,
    12256,
    12257,
    12258,
    12259,
    12260,
    12261,
    12262,
    12263,
    12264,
    4985,
    12265,
    4497,
    12266,
    12267,
    12268,
    12269,
    12270,
    12271,
    12272,
    12273,
    12274,
    12275,
    12276,
    12277,
    12278,
    12279,
    12280,
    12281,
    12282,
    12283,
    12284,
    12285,
    12286,
    12287,
    4986,
    12288,
    12289,
    12290,
    12291,
    12292,
    12293,
    12294,
    12295,
    12296,
    2473,
    12297,
    12298,
    12299,
    12300,
    12301,
    12302,
    12303,
    12304,
    12305,
    12306,
    12307,
    12308,
    12309,
    12310,
    12311,
    12312,
    12313,
    12314,
    12315,
    12316,
    12317,
    12318,
    12319,
    3963,
    12320,
    12321,
    12322,
    12323,
    12324,
    12325,
    12326,
    12327,
    12328,
    12329,
    12330,
    12331,
    12332,
    4987,
    12333,
    12334,
    12335,
    12336,
    12337,
    12338,
    12339,
    12340,
    12341,
    12342,
    12343,
    12344,
    12345,
    12346,
    12347,
    12348,
    12349,
    12350,
    12351,
    12352,
    12353,
    12354,
    12355,
    12356,
    12357,
    12358,
    12359,
    3964,
    12360,
    12361,
    12362,
    12363,
    12364,
    12365,
    12366,
    12367,
    12368,
    12369,
    12370,
    3965,
    12371,
    12372,
    12373,
    12374,
    12375,
    12376,
    12377,
    12378,
    12379,
    12380,
    12381,
    12382,
    12383,
    12384,
    12385,
    12386,
    12387,
    12388,
    12389,
    12390,
    12391,
    12392,
    12393,
    12394,
    12395,
    12396,
    12397,
    12398,
    12399,
    12400,
    12401,
    12402,
    12403,
    12404,
    12405,
    12406,
    12407,
    12408,
    4988,
    12409,
    12410,
    12411,
    12412,
    12413,
    12414,
    12415,
    12416,
    12417,
    12418,
    12419,
    12420,
    12421,
    12422,
    12423,
    12424,
    12425,
    12426,
    12427,
    12428,
    12429,
    12430,
    12431,
    12432,
    12433,
    12434,
    12435,
    12436,
    12437,
    12438,
    3554,
    12439,
    12440,
    12441,
    12442,
    12443,
    12444,
    12445,
    12446,
    12447,
    12448,
    12449,
    12450,
    12451,
    12452,
    12453,
    12454,
    12455,
    12456,
    12457,
    12458,
    12459,
    12460,
    12461,
    12462,
    12463,
    12464,
    4989,
    12465,
    12466,
    12467,
    12468,
    12469,
    12470,
    12471,
    12472,
    12473,
    12474,
    12475,
    12476,
    12477,
    12478,
    12479,
    12480,
    4990,
    12481,
    12482,
    12483,
    12484,
    12485,
    12486,
    12487,
    12488,
    12489,
    4498,
    12490,
    12491,
    12492,
    12493,
    12494,
    12495,
    12496,
    12497,
    12498,
    12499,
    12500,
    12501,
    12502,
    12503,
    12504,
    12505,
    12506,
    12507,
    12508,
    12509,
    12510,
    12511,
    12512,
    12513,
    12514,
    12515,
    12516,
    12517,
    12518,
    12519,
    12520,
    12521,
    12522,
    12523,
    12524,
    12525,
    12526,
    12527,
    12528,
    12529,
    12530,
    12531,
    12532,
    12533,
    12534,
    12535,
    12536,
    12537,
    12538,
    12539,
    12540,
    12541,
    12542,
    12543,
    12544,
    12545,
    12546,
    12547,
    12548,
    12549,
    12550,
    12551,
    4991,
    12552,
    12553,
    12554,
    12555,
    12556,
    12557,
    12558,
    12559,
    12560,
    12561,
    12562,
    12563,
    12564,
    12565,
    12566,
    12567,
    12568,
    12569,
    12570,
    12571,
    12572,
    12573,
    12574,
    12575,
    12576,
    12577,
    12578,
    3036,
    12579,
    12580,
    12581,
    12582,
    12583,
    3966,
    12584,
    12585,
    12586,
    12587,
    12588,
    12589,
    12590,
    12591,
    12592,
    12593,
    12594,
    12595,
    12596,
    12597,
    12598,
    12599,
    12600,
    12601,
    12602,
    12603,
    12604,
    12605,
    12606,
    12607,
    12608,
    12609,
    12610,
    12611,
    12612,
    12613,
    12614,
    12615,
    12616,
    12617,
    12618,
    12619,
    12620,
    12621,
    12622,
    12623,
    12624,
    12625,
    12626,
    12627,
    12628,
    12629,
    12630,
    12631,
    12632,
    12633,
    12634,
    12635,
    12636,
    12637,
    12638,
    12639,
    12640,
    12641,
    12642,
    12643,
    12644,
    12645,
    12646,
    4499,
    12647,
    12648,
    12649,
    12650,
    12651,
    12652,
    12653,
    12654,
    12655,
    12656,
    12657,
    12658,
    12659,
    12660,
    12661,
    12662,
    12663,
    12664,
    12665,
    12666,
    12667,
    12668,
    12669,
    12670,
    12671,
    12672,
    12673,
    12674,
    12675,
    12676,
    12677,
    12678,
    12679,
    12680,
    12681,
    12682,
    12683,
    12684,
    12685,
    12686,
    12687,
    12688,
    12689,
    12690,
    12691,
    12692,
    12693,
    12694,
    12695,
    12696,
    12697,
    12698,
    4992,
    12699,
    12700,
    12701,
    12702,
    12703,
    12704,
    12705,
    12706,
    12707,
    12708,
    12709,
    12710,
    12711,
    12712,
    12713,
    12714,
    12715,
    12716,
    12717,
    12718,
    12719,
    12720,
    12721,
    12722,
    12723,
    12724,
    12725,
    12726,
    12727,
    12728,
    12729,
    12730,
    12731,
    12732,
    12733,
    12734,
    12735,
    12736,
    12737,
    12738,
    12739,
    12740,
    12741,
    12742,
    12743,
    12744,
    12745,
    12746,
    12747,
    12748,
    12749,
    12750,
    12751,
    12752,
    12753,
    12754,
    12755,
    12756,
    12757,
    12758,
    12759,
    12760,
    12761,
    12762,
    12763,
    12764,
    12765,
    12766,
    12767,
    12768,
    12769,
    12770,
    12771,
    12772,
    12773,
    12774,
    12775,
    12776,
    12777,
    12778,
    4993,
    2175,
    12779,
    12780,
    12781,
    12782,
    12783,
    12784,
    12785,
    12786,
    4500,
    12787,
    12788,
    12789,
    12790,
    12791,
    12792,
    12793,
    12794,
    12795,
    12796,
    12797,
    12798,
    12799,
    12800,
    12801,
    12802,
    12803,
    12804,
    12805,
    12806,
    12807,
    12808,
    12809,
    12810,
    12811,
    12812,
    12813,
    12814,
    12815,
    12816,
    12817,
    12818,
    12819,
    12820,
    12821,
    12822,
    12823,
    12824,
    12825,
    12826,
    4198,
    3967,
    12827,
    12828,
    12829,
    12830,
    12831,
    12832,
    12833,
    12834,
    12835,
    12836,
    12837,
    12838,
    12839,
    12840,
    12841,
    12842,
    12843,
    12844,
    12845,
    12846,
    12847,
    12848,
    12849,
    12850,
    12851,
    12852,
    12853,
    12854,
    12855,
    12856,
    12857,
    12858,
    12859,
    12860,
    12861,
    4199,
    12862,
    12863,
    12864,
    12865,
    12866,
    12867,
    12868,
    12869,
    12870,
    12871,
    12872,
    12873,
    12874,
    12875,
    12876,
    12877,
    12878,
    12879,
    12880,
    12881,
    12882,
    12883,
    12884,
    12885,
    12886,
    12887,
    4501,
    12888,
    12889,
    12890,
    12891,
    12892,
    12893,
    12894,
    12895,
    12896,
    12897,
    12898,
    12899,
    12900,
    12901,
    12902,
    12903,
    12904,
    12905,
    12906,
    12907,
    12908,
    12909,
    12910,
    12911,
    12912,
    4994,
    12913,
    12914,
    12915,
    12916,
    12917,
    12918,
    12919,
    12920,
    12921,
    12922,
    12923,
    12924,
    12925,
    12926,
    12927,
    12928,
    12929,
    12930,
    12931,
    12932,
    12933,
    12934,
    12935,
    12936,
    12937,
    12938,
    12939,
    12940,
    12941,
    12942,
    12943,
    12944,
    12945,
    12946,
    12947,
    12948,
    12949,
    12950,
    12951,
    12952,
    12953,
    12954,
    12955,
    12956,
    1772,
    12957,
    12958,
    12959,
    12960,
    12961,
    12962,
    12963,
    12964,
    12965,
    12966,
    12967,
    12968,
    12969,
    12970,
    12971,
    12972,
    12973,
    12974,
    12975,
    12976,
    12977,
    12978,
    12979,
    12980,
    12981,
    12982,
    12983,
    12984,
    12985,
    12986,
    12987,
    12988,
    12989,
    12990,
    12991,
    12992,
    12993,
    12994,
    12995,
    12996,
    12997,
    4502,
    12998,
    4503,
    12999,
    13000,
    13001,
    13002,
    13003,
    4504,
    13004,
    13005,
    13006,
    13007,
    13008,
    13009,
    13010,
    13011,
    13012,
    13013,
    13014,
    13015,
    13016,
    13017,
    13018,
    13019,
    13020,
    13021,
    13022,
    13023,
    13024,
    13025,
    13026,
    13027,
    13028,
    13029,
    3449,
    13030,
    13031,
    13032,
    13033,
    13034,
    13035,
    13036,
    13037,
    13038,
    13039,
    13040,
    13041,
    13042,
    13043,
    13044,
    13045,
    13046,
    13047,
    13048,
    13049,
    13050,
    13051,
    13052,
    13053,
    13054,
    13055,
    13056,
    13057,
    13058,
    13059,
    13060,
    13061,
    13062,
    13063,
    13064,
    13065,
    13066,
    13067,
    13068,
    13069,
    13070,
    13071,
    13072,
    13073,
    13074,
    13075,
    13076,
    13077,
    13078,
    13079,
    13080,
    13081,
    13082,
    13083,
    13084,
    13085,
    13086,
    13087,
    13088,
    13089,
    13090,
    13091,
    13092,
    13093,
    13094,
    13095,
    13096,
    13097,
    13098,
    13099,
    13100,
    13101,
    13102,
    13103,
    13104,
    13105,
    13106,
    13107,
    13108,
    13109,
    13110,
    13111,
    13112,
    13113,
    13114,
    13115,
    13116,
    13117,
    13118,
    3968,
    13119,
    4995,
    13120,
    13121,
    13122,
    13123,
    13124,
    13125,
    13126,
    13127,
    4505,
    13128,
    13129,
    13130,
    13131,
    13132,
    13133,
    13134,
    4996,
    4506,
    13135,
    13136,
    13137,
    13138,
    13139,
    4997,
    13140,
    13141,
    13142,
    13143,
    13144,
    13145,
    13146,
    13147,
    13148,
    13149,
    13150,
    13151,
    13152,
    13153,
    13154,
    13155,
    13156,
    13157,
    13158,
    13159,
    4998,
    13160,
    13161,
    13162,
    13163,
    13164,
    13165,
    13166,
    13167,
    13168,
    13169,
    13170,
    13171,
    13172,
    13173,
    13174,
    13175,
    13176,
    4999,
    13177,
    13178,
    13179,
    13180,
    13181,
    13182,
    13183,
    13184,
    13185,
    13186,
    13187,
    13188,
    13189,
    13190,
    13191,
    13192,
    13193,
    13194,
    13195,
    13196,
    13197,
    13198,
    13199,
    13200,
    13201,
    13202,
    13203,
    13204,
    13205,
    13206,
    5000,
    13207,
    13208,
    13209,
    13210,
    13211,
    13212,
    13213,
    13214,
    13215,
    13216,
    13217,
    13218,
    13219,
    13220,
    13221,
    13222,
    13223,
    13224,
    13225,
    13226,
    13227,
    4200,
    5001,
    13228,
    13229,
    13230,
    13231,
    13232,
    13233,
    13234,
    13235,
    13236,
    13237,
    13238,
    13239,
    13240,
    3969,
    13241,
    13242,
    13243,
    13244,
    3970,
    13245,
    13246,
    13247,
    13248,
    13249,
    13250,
    13251,
    13252,
    13253,
    13254,
    13255,
    13256,
    13257,
    13258,
    13259,
    13260,
    13261,
    13262,
    13263,
    13264,
    13265,
    13266,
    13267,
    13268,
    3450,
    13269,
    13270,
    13271,
    13272,
    13273,
    13274,
    13275,
    13276,
    5002,
    13277,
    13278,
    13279,
    13280,
    13281,
    13282,
    13283,
    13284,
    13285,
    13286,
    13287,
    13288,
    13289,
    13290,
    13291,
    13292,
    13293,
    13294,
    13295,
    13296,
    13297,
    13298,
    13299,
    13300,
    13301,
    13302,
    3813,
    13303,
    13304,
    13305,
    13306,
    13307,
    13308,
    13309,
    13310,
    13311,
    13312,
    13313,
    13314,
    13315,
    13316,
    13317,
    13318,
    13319,
    13320,
    13321,
    13322,
    13323,
    13324,
    13325,
    13326,
    13327,
    13328,
    4507,
    13329,
    13330,
    13331,
    13332,
    13333,
    13334,
    13335,
    13336,
    13337,
    13338,
    13339,
    13340,
    13341,
    5003,
    13342,
    13343,
    13344,
    13345,
    13346,
    13347,
    13348,
    13349,
    13350,
    13351,
    13352,
    13353,
    13354,
    13355,
    13356,
    13357,
    13358,
    13359,
    13360,
    13361,
    13362,
    13363,
    13364,
    13365,
    13366,
    13367,
    5004,
    13368,
    13369,
    13370,
    13371,
    13372,
    13373,
    13374,
    13375,
    13376,
    13377,
    13378,
    13379,
    13380,
    13381,
    13382,
    13383,
    13384,
    13385,
    13386,
    13387,
    13388,
    13389,
    13390,
    13391,
    13392,
    13393,
    13394,
    13395,
    13396,
    13397,
    13398,
    13399,
    13400,
    13401,
    13402,
    13403,
    13404,
    13405,
    13406,
    13407,
    13408,
    13409,
    13410,
    13411,
    13412,
    13413,
    13414,
    13415,
    13416,
    13417,
    13418,
    13419,
    13420,
    13421,
    13422,
    13423,
    13424,
    13425,
    13426,
    13427,
    13428,
    13429,
    13430,
    13431,
    13432,
    4508,
    13433,
    13434,
    13435,
    4201,
    13436,
    13437,
    13438,
    13439,
    13440,
    13441,
    13442,
    13443,
    13444,
    13445,
    13446,
    13447,
    13448,
    13449,
    13450,
    13451,
    13452,
    13453,
    13454,
    13455,
    13456,
    13457,
    5005,
    13458,
    13459,
    13460,
    13461,
    13462,
    13463,
    13464,
    13465,
    13466,
    13467,
    13468,
    13469,
    13470,
    4509,
    13471,
    13472,
    13473,
    13474,
    13475,
    13476,
    13477,
    13478,
    13479,
    13480,
    13481,
    13482,
    13483,
    13484,
    13485,
    13486,
    13487,
    13488,
    13489,
    13490,
    13491,
    13492,
    13493,
    13494,
    13495,
    13496,
    13497,
    13498,
    13499,
    13500,
    13501,
    13502,
    13503,
    13504,
    13505,
    13506,
    13507,
    13508,
    13509,
    13510,
    13511,
    13512,
    13513,
    13514,
    13515,
    13516,
    13517,
    13518,
    13519,
    13520,
    13521,
    13522,
    13523,
    13524,
    13525,
    13526,
    13527,
    13528,
    13529,
    13530,
    13531,
    13532,
    13533,
    13534,
    13535,
    13536,
    13537,
    13538,
    13539,
    13540,
    13541,
    13542,
    13543,
    13544,
    13545,
    13546,
    13547,
    13548,
    13549,
    13550,
    13551,
    13552,
    13553,
    13554,
    13555,
    13556,
    13557,
    13558,
    13559,
    13560,
    13561,
    13562,
    13563,
    13564,
    13565,
    13566,
    13567,
    13568,
    13569,
    13570,
    13571,
    13572,
    13573,
    13574,
    13575,
    13576,
    13577,
    13578,
    13579,
    13580,
    13581,
    13582,
    13583,
    13584,
    13585,
    13586,
    13587,
    13588,
    13589,
    13590,
    13591,
    13592,
    13593,
    13594,
    13595,
    13596,
    13597,
    13598,
    13599,
    13600,
    13601,
    13602,
    13603,
    13604,
    13605,
    13606,
    13607,
    13608,
    13609,
    13610,
    13611,
    13612,
    13613,
    13614,
    13615,
    13616,
    13617,
    13618,
    13619,
    13620,
    13621,
    13622,
    13623,
    13624,
    13625,
    13626,
    13627,
    13628,
    13629,
    13630,
    13631,
    13632,
    13633,
    13634,
    13635,
    13636,
    13637,
    13638,
    13639,
    13640,
    13641,
    13642,
    5006,
    13643,
    13644,
    13645,
    13646,
    13647,
    13648,
    13649,
    13650,
    13651,
    5007,
    13652,
    13653,
    13654,
    13655,
    13656,
    13657,
    13658,
    13659,
    13660,
    13661,
    13662,
    13663,
    13664,
    13665,
    13666,
    13667,
    13668,
    13669,
    13670,
    13671,
    13672,
    13673,
    13674,
    13675,
    13676,
    13677,
    13678,
    13679,
    13680,
    13681,
    13682,
    13683,
    13684,
    13685,
    13686,
    13687,
    13688,
    13689,
    13690,
    13691,
    13692,
    13693,
    13694,
    13695,
    13696,
    13697,
    13698,
    13699,
    13700,
    13701,
    13702,
    13703,
    13704,
    13705,
    13706,
    13707,
    13708,
    13709,
    13710,
    13711,
    13712,
    13713,
    13714,
    13715,
    13716,
    13717,
    13718,
    13719,
    13720,
    13721,
    13722,
    13723,
    13724,
    13725,
    13726,
    13727,
    13728,
    13729,
    13730,
    13731,
    13732,
    13733,
    13734,
    13735,
    13736,
    13737,
    13738,
    13739,
    13740,
    13741,
    13742,
    13743,
    13744,
    13745,
    13746,
    13747,
    13748,
    13749,
    13750,
    13751,
    13752,
    13753,
    13754,
    13755,
    13756,
    13757,
    13758,
    13759,
    13760,
    13761,
    13762,
    13763,
    13764,
    13765,
    13766,
    13767,
    13768,
    13769,
    13770,
    13771,
    13772,
    13773,
    13774,
    3273,
    13775,
    13776,
    13777,
    13778,
    13779,
    13780,
    13781,
    13782,
    13783,
    13784,
    13785,
    13786,
    13787,
    13788,
    13789,
    13790,
    13791,
    13792,
    13793,
    13794,
    13795,
    13796,
    13797,
    13798,
    13799,
    13800,
    13801,
    13802,
    13803,
    13804,
    13805,
    13806,
    13807,
    13808,
    13809,
    13810,
    13811,
    13812,
    13813,
    13814,
    13815,
    13816,
    13817,
    13818,
    13819,
    13820,
    13821,
    13822,
    13823,
    13824,
    13825,
    13826,
    13827,
    13828,
    13829,
    13830,
    13831,
    13832,
    13833,
    13834,
    13835,
    13836,
    13837,
    13838,
    13839,
    13840,
    13841,
    13842,
    13843,
    13844,
    13845,
    13846,
    13847,
    13848,
    13849,
    13850,
    13851,
    13852,
    13853,
    13854,
    13855,
    13856,
    13857,
    13858,
    13859,
    13860,
    13861,
    13862,
    13863,
    13864,
    13865,
    13866,
    13867,
    13868,
    13869,
    13870,
    13871,
    13872,
    13873,
    13874,
    13875,
    13876,
    13877,
    13878,
    13879,
    13880,
    13881,
    13882,
    13883,
    13884,
    13885,
    13886,
    13887,
    13888,
    13889,
    13890,
    13891,
    13892,
    13893,
    13894,
    13895,
    13896,
    13897,
    13898,
    13899,
    13900,
    13901,
    13902,
    13903,
    13904,
    13905,
    13906,
    13907,
    13908,
    13909,
    13910,
    13911,
    13912,
    13913,
    13914,
    13915,
    13916,
    13917,
    13918,
    13919,
    13920,
    13921,
    13922,
    13923,
    13924,
    13925,
    13926,
    13927,
    13928,
    13929,
    13930,
    13931,
    13932,
    13933,
    13934,
    13935,
    13936,
    13937,
    13938,
    13939,
    13940,
    13941,
    13942,
    13943,
    13944,
    13945,
    13946,
    13947,
    13948,
    13949,
    13950,
    13951,
    13952,
    13953,
    13954,
    13955,
    13956,
    13957,
    13958,
    13959,
    13960,
    13961,
    13962,
    13963,
    13964,
    13965,
    13966,
    13967,
    13968,
    13969,
    13970,
    13971,
    13972
]; //13973

});



parcelRegister("iMAyi", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $3xI8B = parcelRequire("3xI8B");

var $2SPVp = parcelRequire("2SPVp");

var $8hFBI = parcelRequire("8hFBI");

var $2q0cO = parcelRequire("2q0cO");
function $dac91034cc8ac2db$var$UTF8Prober() {
    $2SPVp.apply(this);
    var ONE_CHAR_PROB = 0.5;
    var self = this;
    function init() {
        self._mCodingSM = new $3xI8B($2q0cO);
        self.reset();
    }
    this.reset = function() {
        $dac91034cc8ac2db$var$UTF8Prober.prototype.reset.apply(this);
        this._mCodingSM.reset();
        this._mNumOfMBChar = 0;
        this._mMBCharLen = 0;
        this._mFullLen = 0;
        this._mBasicAsciiLen = 0;
    };
    this.getCharsetName = function() {
        return "UTF-8";
    };
    this.feed = function(aBuf) {
        this._mFullLen += aBuf.length;
        for(var i = 0, c; i < aBuf.length; i++){
            c = aBuf[i];
            var codingState = this._mCodingSM.nextState(c);
            if (codingState == $8hFBI.error) {
                this._mState = $8hFBI.notMe;
                break;
            } else if (codingState == $8hFBI.itsMe) {
                this._mState = $8hFBI.foundIt;
                break;
            } else if (codingState == $8hFBI.start) {
                if (this._mCodingSM.getCurrentCharLen() >= 2) {
                    this._mNumOfMBChar++;
                    this._mMBCharLen += this._mCodingSM.getCurrentCharLen();
                } else if (c.charCodeAt(0) < 128) this._mBasicAsciiLen++;
            }
        }
        if (this.getState() == $8hFBI.detecting) {
            if (this.getConfidence() > $8hFBI.SHORTCUT_THRESHOLD) this._mState = $8hFBI.foundIt;
        }
        return this.getState();
    };
    this.getConfidence = function() {
        var unlike = 0.99;
        var mbCharRatio = 0;
        var nonBasciAsciiLen = this._mFullLen - this._mBasicAsciiLen;
        if (nonBasciAsciiLen > 0) mbCharRatio = this._mMBCharLen / nonBasciAsciiLen;
        if (this._mNumOfMBChar < 6 && mbCharRatio <= 0.6) {
            for(var i = 0; i < this._mNumOfMBChar; i++)unlike *= Math.pow(ONE_CHAR_PROB, this._mNumOfMBChar);
            return 1 - unlike;
        } else return unlike;
    };
    init();
}
$dac91034cc8ac2db$var$UTF8Prober.prototype = new $2SPVp();
module.exports = $dac91034cc8ac2db$var$UTF8Prober;

});
parcelRegister("2q0cO", function(module, exports) {

var $8hFBI = parcelRequire("8hFBI");
var $1c2e2b4adf942b20$var$UTF8_cls = [
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    0,
    0,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    9,
    8,
    8,
    10,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    12,
    13,
    13,
    13,
    14,
    15,
    0,
    0 // f8 - ff
];
var $1c2e2b4adf942b20$var$UTF8_st = [
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    12,
    10,
    9,
    11,
    8,
    7,
    6,
    5,
    4,
    3,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    5,
    5,
    5,
    5,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    5,
    5,
    5,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    7,
    7,
    7,
    7,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    7,
    7,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    9,
    9,
    9,
    9,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    9,
    9,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    12,
    12,
    12,
    12,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    12,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    12,
    12,
    12,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error //c8-cf
];
var $1c2e2b4adf942b20$var$UTF8CharLenTable = [
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6
];
module.exports = {
    "classTable": $1c2e2b4adf942b20$var$UTF8_cls,
    "classFactor": 16,
    "stateTable": $1c2e2b4adf942b20$var$UTF8_st,
    "charLenTable": $1c2e2b4adf942b20$var$UTF8CharLenTable,
    "name": "UTF-8"
};

});


parcelRegister("3XgFd", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $3xI8B = parcelRequire("3xI8B");

var $14x9i = parcelRequire("14x9i");

var $b0yIF = parcelRequire("b0yIF");

var $a1Zfb = parcelRequire("a1Zfb");
var $2e13cedf323c63ad$require$SJISDistributionAnalysis = $a1Zfb.SJISDistributionAnalysis;

var $acaMs = parcelRequire("acaMs");
var $2e13cedf323c63ad$require$SJISContextAnalysis = $acaMs.SJISContextAnalysis;

var $8hFBI = parcelRequire("8hFBI");

var $87x91 = parcelRequire("87x91");
function $2e13cedf323c63ad$var$SJISProber() {
    $14x9i.apply(this);
    var self = this;
    function init() {
        self._mCodingSM = new $3xI8B($b0yIF);
        self._mDistributionAnalyzer = new $2e13cedf323c63ad$require$SJISDistributionAnalysis();
        self._mContextAnalyzer = new $2e13cedf323c63ad$require$SJISContextAnalysis();
        self.reset();
    }
    this.reset = function() {
        $2e13cedf323c63ad$var$SJISProber.prototype.reset.apply(this);
        this._mContextAnalyzer.reset();
    };
    this.getCharsetName = function() {
        return "SHIFT_JIS";
    };
    this.feed = function(aBuf) {
        var aLen = aBuf.length;
        for(var i = 0; i < aLen; i++){
            var codingState = this._mCodingSM.nextState(aBuf[i]);
            if (codingState == $8hFBI.error) {
                $87x91.log(this.getCharsetName() + " prober hit error at byte " + i + "\n");
                this._mState = $8hFBI.notMe;
                break;
            } else if (codingState == $8hFBI.itsMe) {
                this._mState = $8hFBI.foundIt;
                break;
            } else if (codingState == $8hFBI.start) {
                var charLen = this._mCodingSM.getCurrentCharLen();
                if (i == 0) {
                    this._mLastChar[1] = aBuf[0];
                    this._mContextAnalyzer.feed(this._mLastChar.slice(2 - charLen), charLen);
                    this._mDistributionAnalyzer.feed(this._mLastChar, charLen);
                } else {
                    this._mContextAnalyzer.feed(aBuf.slice(i + 1 - charLen, i + 3 - charLen), charLen);
                    this._mDistributionAnalyzer.feed(aBuf.slice(i - 1, i + 1), charLen);
                }
            }
        }
        this._mLastChar[0] = aBuf[aLen - 1];
        if (this.getState() == $8hFBI.detecting) {
            if (this._mContextAnalyzer.gotEnoughData() && this.getConfidence() > $8hFBI.SHORTCUT_THRESHOLD) this._mState = $8hFBI.foundIt;
        }
        return this.getState();
    };
    this.getConfidence = function() {
        var contxtCf = this._mContextAnalyzer.getConfidence();
        var distribCf = this._mDistributionAnalyzer.getConfidence();
        return Math.max(contxtCf, distribCf);
    };
    init();
}
$2e13cedf323c63ad$var$SJISProber.prototype = new $14x9i();
module.exports = $2e13cedf323c63ad$var$SJISProber;

});
parcelRegister("b0yIF", function(module, exports) {

var $8hFBI = parcelRequire("8hFBI");
var $803aa05523dac348$var$SJIS_cls = [
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    // 0xa0 is illegal in sjis encoding, but some pages does
    // contain such byte. We need to be more consts.error forgiven.
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    0 // f8 - ff
];
var $803aa05523dac348$var$SJIS_st = [
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    3,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start //10-17
];
var $803aa05523dac348$var$SJISCharLenTable = [
    0,
    1,
    1,
    2,
    0,
    0
];
module.exports = {
    "classTable": $803aa05523dac348$var$SJIS_cls,
    "classFactor": 6,
    "stateTable": $803aa05523dac348$var$SJIS_st,
    "charLenTable": $803aa05523dac348$var$SJISCharLenTable,
    "name": "Shift_JIS"
};

});

parcelRegister("acaMs", function(module, exports) {

$parcel$export(module.exports, "jp2CharContext", () => $76c3632f58b67b56$export$f5d998e2212d7909, (v) => $76c3632f58b67b56$export$f5d998e2212d7909 = v);
$parcel$export(module.exports, "SJISContextAnalysis", () => $76c3632f58b67b56$export$cd4690d83476f80a, (v) => $76c3632f58b67b56$export$cd4690d83476f80a = v);
$parcel$export(module.exports, "EUCJPContextAnalysis", () => $76c3632f58b67b56$export$cb228283d2c3b721, (v) => $76c3632f58b67b56$export$cb228283d2c3b721 = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // This is hiragana 2-char sequence table, the number in each cell represents its frequency category
var $76c3632f58b67b56$export$f5d998e2212d7909;
var $76c3632f58b67b56$export$cd4690d83476f80a;
var $76c3632f58b67b56$export$cb228283d2c3b721;
$76c3632f58b67b56$export$f5d998e2212d7909 = [
    [
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1
    ],
    [
        2,
        4,
        0,
        4,
        0,
        3,
        0,
        4,
        0,
        3,
        4,
        4,
        4,
        2,
        4,
        3,
        3,
        4,
        3,
        2,
        3,
        3,
        4,
        2,
        3,
        3,
        3,
        2,
        4,
        1,
        4,
        3,
        3,
        1,
        5,
        4,
        3,
        4,
        3,
        4,
        3,
        5,
        3,
        0,
        3,
        5,
        4,
        2,
        0,
        3,
        1,
        0,
        3,
        3,
        0,
        3,
        3,
        0,
        1,
        1,
        0,
        4,
        3,
        0,
        3,
        3,
        0,
        4,
        0,
        2,
        0,
        3,
        5,
        5,
        5,
        5,
        4,
        0,
        4,
        1,
        0,
        3,
        4
    ],
    [
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2
    ],
    [
        0,
        4,
        0,
        5,
        0,
        5,
        0,
        4,
        0,
        4,
        5,
        4,
        4,
        3,
        5,
        3,
        5,
        1,
        5,
        3,
        4,
        3,
        4,
        4,
        3,
        4,
        3,
        3,
        4,
        3,
        5,
        4,
        4,
        3,
        5,
        5,
        3,
        5,
        5,
        5,
        3,
        5,
        5,
        3,
        4,
        5,
        5,
        3,
        1,
        3,
        2,
        0,
        3,
        4,
        0,
        4,
        2,
        0,
        4,
        2,
        1,
        5,
        3,
        2,
        3,
        5,
        0,
        4,
        0,
        2,
        0,
        5,
        4,
        4,
        5,
        4,
        5,
        0,
        4,
        0,
        0,
        4,
        4
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        3,
        0,
        4,
        0,
        3,
        0,
        3,
        0,
        4,
        5,
        4,
        3,
        3,
        3,
        3,
        4,
        3,
        5,
        4,
        4,
        3,
        5,
        4,
        4,
        3,
        4,
        3,
        4,
        4,
        4,
        4,
        5,
        3,
        4,
        4,
        3,
        4,
        5,
        5,
        4,
        5,
        5,
        1,
        4,
        5,
        4,
        3,
        0,
        3,
        3,
        1,
        3,
        3,
        0,
        4,
        4,
        0,
        3,
        3,
        1,
        5,
        3,
        3,
        3,
        5,
        0,
        4,
        0,
        3,
        0,
        4,
        4,
        3,
        4,
        3,
        3,
        0,
        4,
        1,
        1,
        3,
        4
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        4,
        0,
        3,
        0,
        3,
        0,
        4,
        0,
        3,
        4,
        4,
        3,
        2,
        2,
        1,
        2,
        1,
        3,
        1,
        3,
        3,
        3,
        3,
        3,
        4,
        3,
        1,
        3,
        3,
        5,
        3,
        3,
        0,
        4,
        3,
        0,
        5,
        4,
        3,
        3,
        5,
        4,
        4,
        3,
        4,
        4,
        5,
        0,
        1,
        2,
        0,
        1,
        2,
        0,
        2,
        2,
        0,
        1,
        0,
        0,
        5,
        2,
        2,
        1,
        4,
        0,
        3,
        0,
        1,
        0,
        4,
        4,
        3,
        5,
        4,
        3,
        0,
        2,
        1,
        0,
        4,
        3
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        3,
        0,
        5,
        0,
        4,
        0,
        2,
        1,
        4,
        4,
        2,
        4,
        1,
        4,
        2,
        4,
        2,
        4,
        3,
        3,
        3,
        4,
        3,
        3,
        3,
        3,
        1,
        4,
        2,
        3,
        3,
        3,
        1,
        4,
        4,
        1,
        1,
        1,
        4,
        3,
        3,
        2,
        0,
        2,
        4,
        3,
        2,
        0,
        3,
        3,
        0,
        3,
        1,
        1,
        0,
        0,
        0,
        3,
        3,
        0,
        4,
        2,
        2,
        3,
        4,
        0,
        4,
        0,
        3,
        0,
        4,
        4,
        5,
        3,
        4,
        4,
        0,
        3,
        0,
        0,
        1,
        4
    ],
    [
        1,
        4,
        0,
        4,
        0,
        4,
        0,
        4,
        0,
        3,
        5,
        4,
        4,
        3,
        4,
        3,
        5,
        4,
        3,
        3,
        4,
        3,
        5,
        4,
        4,
        4,
        4,
        3,
        4,
        2,
        4,
        3,
        3,
        1,
        5,
        4,
        3,
        2,
        4,
        5,
        4,
        5,
        5,
        4,
        4,
        5,
        4,
        4,
        0,
        3,
        2,
        2,
        3,
        3,
        0,
        4,
        3,
        1,
        3,
        2,
        1,
        4,
        3,
        3,
        4,
        5,
        0,
        3,
        0,
        2,
        0,
        4,
        5,
        5,
        4,
        5,
        4,
        0,
        4,
        0,
        0,
        5,
        4
    ],
    [
        0,
        5,
        0,
        5,
        0,
        4,
        0,
        3,
        0,
        4,
        4,
        3,
        4,
        3,
        3,
        3,
        4,
        0,
        4,
        4,
        4,
        3,
        4,
        3,
        4,
        3,
        3,
        1,
        4,
        2,
        4,
        3,
        4,
        0,
        5,
        4,
        1,
        4,
        5,
        4,
        4,
        5,
        3,
        2,
        4,
        3,
        4,
        3,
        2,
        4,
        1,
        3,
        3,
        3,
        2,
        3,
        2,
        0,
        4,
        3,
        3,
        4,
        3,
        3,
        3,
        4,
        0,
        4,
        0,
        3,
        0,
        4,
        5,
        4,
        4,
        4,
        3,
        0,
        4,
        1,
        0,
        1,
        3
    ],
    [
        0,
        3,
        1,
        4,
        0,
        3,
        0,
        2,
        0,
        3,
        4,
        4,
        3,
        1,
        4,
        2,
        3,
        3,
        4,
        3,
        4,
        3,
        4,
        3,
        4,
        4,
        3,
        2,
        3,
        1,
        5,
        4,
        4,
        1,
        4,
        4,
        3,
        5,
        4,
        4,
        3,
        5,
        5,
        4,
        3,
        4,
        4,
        3,
        1,
        2,
        3,
        1,
        2,
        2,
        0,
        3,
        2,
        0,
        3,
        1,
        0,
        5,
        3,
        3,
        3,
        4,
        3,
        3,
        3,
        3,
        4,
        4,
        4,
        4,
        5,
        4,
        2,
        0,
        3,
        3,
        2,
        4,
        3
    ],
    [
        0,
        2,
        0,
        3,
        0,
        1,
        0,
        1,
        0,
        0,
        3,
        2,
        0,
        0,
        2,
        0,
        1,
        0,
        2,
        1,
        3,
        3,
        3,
        1,
        2,
        3,
        1,
        0,
        1,
        0,
        4,
        2,
        1,
        1,
        3,
        3,
        0,
        4,
        3,
        3,
        1,
        4,
        3,
        3,
        0,
        3,
        3,
        2,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        4,
        1,
        0,
        2,
        3,
        2,
        2,
        2,
        1,
        3,
        3,
        3,
        4,
        4,
        3,
        2,
        0,
        3,
        1,
        0,
        3,
        3
    ],
    [
        0,
        4,
        0,
        4,
        0,
        3,
        0,
        3,
        0,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
        3,
        4,
        2,
        4,
        3,
        4,
        3,
        3,
        2,
        4,
        3,
        4,
        5,
        4,
        1,
        4,
        5,
        3,
        5,
        4,
        5,
        3,
        5,
        4,
        0,
        3,
        5,
        5,
        3,
        1,
        3,
        3,
        2,
        2,
        3,
        0,
        3,
        4,
        1,
        3,
        3,
        2,
        4,
        3,
        3,
        3,
        4,
        0,
        4,
        0,
        3,
        0,
        4,
        5,
        4,
        4,
        5,
        3,
        0,
        4,
        1,
        0,
        3,
        4
    ],
    [
        0,
        2,
        0,
        3,
        0,
        3,
        0,
        0,
        0,
        2,
        2,
        2,
        1,
        0,
        1,
        0,
        0,
        0,
        3,
        0,
        3,
        0,
        3,
        0,
        1,
        3,
        1,
        0,
        3,
        1,
        3,
        3,
        3,
        1,
        3,
        3,
        3,
        0,
        1,
        3,
        1,
        3,
        4,
        0,
        0,
        3,
        1,
        1,
        0,
        3,
        2,
        0,
        0,
        0,
        0,
        1,
        3,
        0,
        1,
        0,
        0,
        3,
        3,
        2,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        3,
        4,
        3,
        4,
        3,
        3,
        0,
        3,
        0,
        0,
        2,
        3
    ],
    [
        2,
        3,
        0,
        3,
        0,
        2,
        0,
        1,
        0,
        3,
        3,
        4,
        3,
        1,
        3,
        1,
        1,
        1,
        3,
        1,
        4,
        3,
        4,
        3,
        3,
        3,
        0,
        0,
        3,
        1,
        5,
        4,
        3,
        1,
        4,
        3,
        2,
        5,
        5,
        4,
        4,
        4,
        4,
        3,
        3,
        4,
        4,
        4,
        0,
        2,
        1,
        1,
        3,
        2,
        0,
        1,
        2,
        0,
        0,
        1,
        0,
        4,
        1,
        3,
        3,
        3,
        0,
        3,
        0,
        1,
        0,
        4,
        4,
        4,
        5,
        5,
        3,
        0,
        2,
        0,
        0,
        4,
        4
    ],
    [
        0,
        2,
        0,
        1,
        0,
        3,
        1,
        3,
        0,
        2,
        3,
        3,
        3,
        0,
        3,
        1,
        0,
        0,
        3,
        0,
        3,
        2,
        3,
        1,
        3,
        2,
        1,
        1,
        0,
        0,
        4,
        2,
        1,
        0,
        2,
        3,
        1,
        4,
        3,
        2,
        0,
        4,
        4,
        3,
        1,
        3,
        1,
        3,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        4,
        1,
        1,
        1,
        2,
        0,
        3,
        0,
        0,
        0,
        3,
        4,
        2,
        4,
        3,
        2,
        0,
        1,
        0,
        0,
        3,
        3
    ],
    [
        0,
        1,
        0,
        4,
        0,
        5,
        0,
        4,
        0,
        2,
        4,
        4,
        2,
        3,
        3,
        2,
        3,
        3,
        5,
        3,
        3,
        3,
        4,
        3,
        4,
        2,
        3,
        0,
        4,
        3,
        3,
        3,
        4,
        1,
        4,
        3,
        2,
        1,
        5,
        5,
        3,
        4,
        5,
        1,
        3,
        5,
        4,
        2,
        0,
        3,
        3,
        0,
        1,
        3,
        0,
        4,
        2,
        0,
        1,
        3,
        1,
        4,
        3,
        3,
        3,
        3,
        0,
        3,
        0,
        1,
        0,
        3,
        4,
        4,
        4,
        5,
        5,
        0,
        3,
        0,
        1,
        4,
        5
    ],
    [
        0,
        2,
        0,
        3,
        0,
        3,
        0,
        0,
        0,
        2,
        3,
        1,
        3,
        0,
        4,
        0,
        1,
        1,
        3,
        0,
        3,
        4,
        3,
        2,
        3,
        1,
        0,
        3,
        3,
        2,
        3,
        1,
        3,
        0,
        2,
        3,
        0,
        2,
        1,
        4,
        1,
        2,
        2,
        0,
        0,
        3,
        3,
        0,
        0,
        2,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        2,
        2,
        0,
        3,
        2,
        1,
        3,
        3,
        0,
        2,
        0,
        2,
        0,
        0,
        3,
        3,
        1,
        2,
        4,
        0,
        3,
        0,
        2,
        2,
        3
    ],
    [
        2,
        4,
        0,
        5,
        0,
        4,
        0,
        4,
        0,
        2,
        4,
        4,
        4,
        3,
        4,
        3,
        3,
        3,
        1,
        2,
        4,
        3,
        4,
        3,
        4,
        4,
        5,
        0,
        3,
        3,
        3,
        3,
        2,
        0,
        4,
        3,
        1,
        4,
        3,
        4,
        1,
        4,
        4,
        3,
        3,
        4,
        4,
        3,
        1,
        2,
        3,
        0,
        4,
        2,
        0,
        4,
        1,
        0,
        3,
        3,
        0,
        4,
        3,
        3,
        3,
        4,
        0,
        4,
        0,
        2,
        0,
        3,
        5,
        3,
        4,
        5,
        2,
        0,
        3,
        0,
        0,
        4,
        5
    ],
    [
        0,
        3,
        0,
        4,
        0,
        1,
        0,
        1,
        0,
        1,
        3,
        2,
        2,
        1,
        3,
        0,
        3,
        0,
        2,
        0,
        2,
        0,
        3,
        0,
        2,
        0,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        0,
        3,
        1,
        0,
        0,
        0,
        4,
        0,
        3,
        1,
        0,
        2,
        1,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        4,
        2,
        2,
        3,
        1,
        0,
        3,
        0,
        0,
        0,
        1,
        4,
        4,
        4,
        3,
        0,
        0,
        4,
        0,
        0,
        1,
        4
    ],
    [
        1,
        4,
        1,
        5,
        0,
        3,
        0,
        3,
        0,
        4,
        5,
        4,
        4,
        3,
        5,
        3,
        3,
        4,
        4,
        3,
        4,
        1,
        3,
        3,
        3,
        3,
        2,
        1,
        4,
        1,
        5,
        4,
        3,
        1,
        4,
        4,
        3,
        5,
        4,
        4,
        3,
        5,
        4,
        3,
        3,
        4,
        4,
        4,
        0,
        3,
        3,
        1,
        2,
        3,
        0,
        3,
        1,
        0,
        3,
        3,
        0,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        3,
        3,
        5,
        4,
        4,
        3,
        3,
        5,
        4,
        0,
        3,
        2,
        0,
        4,
        4
    ],
    [
        0,
        2,
        0,
        3,
        0,
        1,
        0,
        0,
        0,
        1,
        3,
        3,
        3,
        2,
        4,
        1,
        3,
        0,
        3,
        1,
        3,
        0,
        2,
        2,
        1,
        1,
        0,
        0,
        2,
        0,
        4,
        3,
        1,
        0,
        4,
        3,
        0,
        4,
        4,
        4,
        1,
        4,
        3,
        1,
        1,
        3,
        3,
        1,
        0,
        2,
        0,
        0,
        1,
        3,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        4,
        3,
        2,
        4,
        3,
        5,
        4,
        3,
        3,
        3,
        4,
        3,
        3,
        4,
        3,
        3,
        0,
        2,
        1,
        0,
        3,
        3
    ],
    [
        0,
        2,
        0,
        4,
        0,
        3,
        0,
        2,
        0,
        2,
        5,
        5,
        3,
        4,
        4,
        4,
        4,
        1,
        4,
        3,
        3,
        0,
        4,
        3,
        4,
        3,
        1,
        3,
        3,
        2,
        4,
        3,
        0,
        3,
        4,
        3,
        0,
        3,
        4,
        4,
        2,
        4,
        4,
        0,
        4,
        5,
        3,
        3,
        2,
        2,
        1,
        1,
        1,
        2,
        0,
        1,
        5,
        0,
        3,
        3,
        2,
        4,
        3,
        3,
        3,
        4,
        0,
        3,
        0,
        2,
        0,
        4,
        4,
        3,
        5,
        5,
        0,
        0,
        3,
        0,
        2,
        3,
        3
    ],
    [
        0,
        3,
        0,
        4,
        0,
        3,
        0,
        1,
        0,
        3,
        4,
        3,
        3,
        1,
        3,
        3,
        3,
        0,
        3,
        1,
        3,
        0,
        4,
        3,
        3,
        1,
        1,
        0,
        3,
        0,
        3,
        3,
        0,
        0,
        4,
        4,
        0,
        1,
        5,
        4,
        3,
        3,
        5,
        0,
        3,
        3,
        4,
        3,
        0,
        2,
        0,
        1,
        1,
        1,
        0,
        1,
        3,
        0,
        1,
        2,
        1,
        3,
        3,
        2,
        3,
        3,
        0,
        3,
        0,
        1,
        0,
        1,
        3,
        3,
        4,
        4,
        1,
        0,
        1,
        2,
        2,
        1,
        3
    ],
    [
        0,
        1,
        0,
        4,
        0,
        4,
        0,
        3,
        0,
        1,
        3,
        3,
        3,
        2,
        3,
        1,
        1,
        0,
        3,
        0,
        3,
        3,
        4,
        3,
        2,
        4,
        2,
        0,
        1,
        0,
        4,
        3,
        2,
        0,
        4,
        3,
        0,
        5,
        3,
        3,
        2,
        4,
        4,
        4,
        3,
        3,
        3,
        4,
        0,
        1,
        3,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        4,
        2,
        3,
        3,
        3,
        0,
        3,
        0,
        0,
        0,
        4,
        4,
        4,
        5,
        3,
        2,
        0,
        3,
        3,
        0,
        3,
        5
    ],
    [
        0,
        2,
        0,
        3,
        0,
        0,
        0,
        3,
        0,
        1,
        3,
        0,
        2,
        0,
        0,
        0,
        1,
        0,
        3,
        1,
        1,
        3,
        3,
        0,
        0,
        3,
        0,
        0,
        3,
        0,
        2,
        3,
        1,
        0,
        3,
        1,
        0,
        3,
        3,
        2,
        0,
        4,
        2,
        2,
        0,
        2,
        0,
        0,
        0,
        4,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        1,
        2,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        3,
        1,
        2,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        4
    ],
    [
        0,
        3,
        0,
        3,
        0,
        5,
        0,
        1,
        0,
        2,
        4,
        3,
        1,
        3,
        3,
        2,
        1,
        1,
        5,
        2,
        1,
        0,
        5,
        1,
        2,
        0,
        0,
        0,
        3,
        3,
        2,
        2,
        3,
        2,
        4,
        3,
        0,
        0,
        3,
        3,
        1,
        3,
        3,
        0,
        2,
        5,
        3,
        4,
        0,
        3,
        3,
        0,
        1,
        2,
        0,
        2,
        2,
        0,
        3,
        2,
        0,
        2,
        2,
        3,
        3,
        3,
        0,
        2,
        0,
        1,
        0,
        3,
        4,
        4,
        2,
        5,
        4,
        0,
        3,
        0,
        0,
        3,
        5
    ],
    [
        0,
        3,
        0,
        3,
        0,
        3,
        0,
        1,
        0,
        3,
        3,
        3,
        3,
        0,
        3,
        0,
        2,
        0,
        2,
        1,
        1,
        0,
        2,
        0,
        1,
        0,
        0,
        0,
        2,
        1,
        0,
        0,
        1,
        0,
        3,
        2,
        0,
        0,
        3,
        3,
        1,
        2,
        3,
        1,
        0,
        3,
        3,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        2,
        3,
        1,
        2,
        3,
        0,
        3,
        0,
        1,
        0,
        3,
        2,
        1,
        0,
        4,
        3,
        0,
        1,
        1,
        0,
        3,
        3
    ],
    [
        0,
        4,
        0,
        5,
        0,
        3,
        0,
        3,
        0,
        4,
        5,
        5,
        4,
        3,
        5,
        3,
        4,
        3,
        5,
        3,
        3,
        2,
        5,
        3,
        4,
        4,
        4,
        3,
        4,
        3,
        4,
        5,
        5,
        3,
        4,
        4,
        3,
        4,
        4,
        5,
        4,
        4,
        4,
        3,
        4,
        5,
        5,
        4,
        2,
        3,
        4,
        2,
        3,
        4,
        0,
        3,
        3,
        1,
        4,
        3,
        2,
        4,
        3,
        3,
        5,
        5,
        0,
        3,
        0,
        3,
        0,
        5,
        5,
        5,
        5,
        4,
        4,
        0,
        4,
        0,
        1,
        4,
        4
    ],
    [
        0,
        4,
        0,
        4,
        0,
        3,
        0,
        3,
        0,
        3,
        5,
        4,
        4,
        2,
        3,
        2,
        5,
        1,
        3,
        2,
        5,
        1,
        4,
        2,
        3,
        2,
        3,
        3,
        4,
        3,
        3,
        3,
        3,
        2,
        5,
        4,
        1,
        3,
        3,
        5,
        3,
        4,
        4,
        0,
        4,
        4,
        3,
        1,
        1,
        3,
        1,
        0,
        2,
        3,
        0,
        2,
        3,
        0,
        3,
        0,
        0,
        4,
        3,
        1,
        3,
        4,
        0,
        3,
        0,
        2,
        0,
        4,
        4,
        4,
        3,
        4,
        5,
        0,
        4,
        0,
        0,
        3,
        4
    ],
    [
        0,
        3,
        0,
        3,
        0,
        3,
        1,
        2,
        0,
        3,
        4,
        4,
        3,
        3,
        3,
        0,
        2,
        2,
        4,
        3,
        3,
        1,
        3,
        3,
        3,
        1,
        1,
        0,
        3,
        1,
        4,
        3,
        2,
        3,
        4,
        4,
        2,
        4,
        4,
        4,
        3,
        4,
        4,
        3,
        2,
        4,
        4,
        3,
        1,
        3,
        3,
        1,
        3,
        3,
        0,
        4,
        1,
        0,
        2,
        2,
        1,
        4,
        3,
        2,
        3,
        3,
        5,
        4,
        3,
        3,
        5,
        4,
        4,
        3,
        3,
        0,
        4,
        0,
        3,
        2,
        2,
        4,
        4
    ],
    [
        0,
        2,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        2,
        1,
        3,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        1,
        2,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        1,
        0,
        1,
        1,
        3,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        2,
        2,
        0,
        3,
        4,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1
    ],
    [
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        4,
        0,
        4,
        1,
        4,
        0,
        3,
        0,
        4,
        0,
        3,
        0,
        4,
        0,
        3,
        0,
        3,
        0,
        4,
        1,
        5,
        1,
        4,
        0,
        0,
        3,
        0,
        5,
        0,
        5,
        2,
        0,
        1,
        0,
        0,
        0,
        2,
        1,
        4,
        0,
        1,
        3,
        0,
        0,
        3,
        0,
        0,
        3,
        1,
        1,
        4,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        1,
        4,
        0,
        5,
        0,
        3,
        0,
        2,
        0,
        3,
        5,
        4,
        4,
        3,
        4,
        3,
        5,
        3,
        4,
        3,
        3,
        0,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        2,
        4,
        4,
        3,
        1,
        3,
        4,
        4,
        5,
        4,
        4,
        3,
        4,
        4,
        1,
        3,
        5,
        4,
        3,
        3,
        3,
        1,
        2,
        2,
        3,
        3,
        1,
        3,
        1,
        3,
        3,
        3,
        5,
        3,
        3,
        4,
        5,
        0,
        3,
        0,
        3,
        0,
        3,
        4,
        3,
        4,
        4,
        3,
        0,
        3,
        0,
        2,
        4,
        3
    ],
    [
        0,
        1,
        0,
        4,
        0,
        0,
        0,
        0,
        0,
        1,
        4,
        0,
        4,
        1,
        4,
        2,
        4,
        0,
        3,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        3,
        1,
        1,
        1,
        0,
        3,
        0,
        0,
        0,
        1,
        2,
        1,
        0,
        0,
        1,
        1,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        3,
        2,
        0,
        2,
        2,
        0,
        1,
        0,
        0,
        0,
        2,
        3,
        2,
        3,
        3,
        0,
        0,
        0,
        0,
        2,
        1,
        0
    ],
    [
        0,
        5,
        1,
        5,
        0,
        3,
        0,
        3,
        0,
        5,
        4,
        4,
        5,
        1,
        5,
        3,
        3,
        0,
        4,
        3,
        4,
        3,
        5,
        3,
        4,
        3,
        3,
        2,
        4,
        3,
        4,
        3,
        3,
        0,
        3,
        3,
        1,
        4,
        4,
        3,
        4,
        4,
        4,
        3,
        4,
        5,
        5,
        3,
        2,
        3,
        1,
        1,
        3,
        3,
        1,
        3,
        1,
        1,
        3,
        3,
        2,
        4,
        5,
        3,
        3,
        5,
        0,
        4,
        0,
        3,
        0,
        4,
        4,
        3,
        5,
        3,
        3,
        0,
        3,
        4,
        0,
        4,
        3
    ],
    [
        0,
        5,
        0,
        5,
        0,
        3,
        0,
        2,
        0,
        4,
        4,
        3,
        5,
        2,
        4,
        3,
        3,
        3,
        4,
        4,
        4,
        3,
        5,
        3,
        5,
        3,
        3,
        1,
        4,
        0,
        4,
        3,
        3,
        0,
        3,
        3,
        0,
        4,
        4,
        4,
        4,
        5,
        4,
        3,
        3,
        5,
        5,
        3,
        2,
        3,
        1,
        2,
        3,
        2,
        0,
        1,
        0,
        0,
        3,
        2,
        2,
        4,
        4,
        3,
        1,
        5,
        0,
        4,
        0,
        3,
        0,
        4,
        3,
        1,
        3,
        2,
        1,
        0,
        3,
        3,
        0,
        3,
        3
    ],
    [
        0,
        4,
        0,
        5,
        0,
        5,
        0,
        4,
        0,
        4,
        5,
        5,
        5,
        3,
        4,
        3,
        3,
        2,
        5,
        4,
        4,
        3,
        5,
        3,
        5,
        3,
        4,
        0,
        4,
        3,
        4,
        4,
        3,
        2,
        4,
        4,
        3,
        4,
        5,
        4,
        4,
        5,
        5,
        0,
        3,
        5,
        5,
        4,
        1,
        3,
        3,
        2,
        3,
        3,
        1,
        3,
        1,
        0,
        4,
        3,
        1,
        4,
        4,
        3,
        4,
        5,
        0,
        4,
        0,
        2,
        0,
        4,
        3,
        4,
        4,
        3,
        3,
        0,
        4,
        0,
        0,
        5,
        5
    ],
    [
        0,
        4,
        0,
        4,
        0,
        5,
        0,
        1,
        1,
        3,
        3,
        4,
        4,
        3,
        4,
        1,
        3,
        0,
        5,
        1,
        3,
        0,
        3,
        1,
        3,
        1,
        1,
        0,
        3,
        0,
        3,
        3,
        4,
        0,
        4,
        3,
        0,
        4,
        4,
        4,
        3,
        4,
        4,
        0,
        3,
        5,
        4,
        1,
        0,
        3,
        0,
        0,
        2,
        3,
        0,
        3,
        1,
        0,
        3,
        1,
        0,
        3,
        2,
        1,
        3,
        5,
        0,
        3,
        0,
        1,
        0,
        3,
        2,
        3,
        3,
        4,
        4,
        0,
        2,
        2,
        0,
        4,
        4
    ],
    [
        2,
        4,
        0,
        5,
        0,
        4,
        0,
        3,
        0,
        4,
        5,
        5,
        4,
        3,
        5,
        3,
        5,
        3,
        5,
        3,
        5,
        2,
        5,
        3,
        4,
        3,
        3,
        4,
        3,
        4,
        5,
        3,
        2,
        1,
        5,
        4,
        3,
        2,
        3,
        4,
        5,
        3,
        4,
        1,
        2,
        5,
        4,
        3,
        0,
        3,
        3,
        0,
        3,
        2,
        0,
        2,
        3,
        0,
        4,
        1,
        0,
        3,
        4,
        3,
        3,
        5,
        0,
        3,
        0,
        1,
        0,
        4,
        5,
        5,
        5,
        4,
        3,
        0,
        4,
        2,
        0,
        3,
        5
    ],
    [
        0,
        5,
        0,
        4,
        0,
        4,
        0,
        2,
        0,
        5,
        4,
        3,
        4,
        3,
        4,
        3,
        3,
        3,
        4,
        3,
        4,
        2,
        5,
        3,
        5,
        3,
        4,
        1,
        4,
        3,
        4,
        4,
        4,
        0,
        3,
        5,
        0,
        4,
        4,
        4,
        4,
        5,
        3,
        1,
        3,
        4,
        5,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        0,
        2,
        2,
        0,
        3,
        3,
        2,
        4,
        3,
        3,
        3,
        5,
        3,
        4,
        1,
        3,
        3,
        5,
        3,
        2,
        0,
        0,
        0,
        0,
        4,
        3,
        1,
        3,
        3
    ],
    [
        0,
        1,
        0,
        3,
        0,
        3,
        0,
        1,
        0,
        1,
        3,
        3,
        3,
        2,
        3,
        3,
        3,
        0,
        3,
        0,
        0,
        0,
        3,
        1,
        3,
        0,
        0,
        0,
        2,
        2,
        2,
        3,
        0,
        0,
        3,
        2,
        0,
        1,
        2,
        4,
        1,
        3,
        3,
        0,
        0,
        3,
        3,
        3,
        0,
        1,
        0,
        0,
        2,
        1,
        0,
        0,
        3,
        0,
        3,
        1,
        0,
        3,
        0,
        0,
        1,
        3,
        0,
        2,
        0,
        1,
        0,
        3,
        3,
        1,
        3,
        3,
        0,
        0,
        1,
        1,
        0,
        3,
        3
    ],
    [
        0,
        2,
        0,
        3,
        0,
        2,
        1,
        4,
        0,
        2,
        2,
        3,
        1,
        1,
        3,
        1,
        1,
        0,
        2,
        0,
        3,
        1,
        2,
        3,
        1,
        3,
        0,
        0,
        1,
        0,
        4,
        3,
        2,
        3,
        3,
        3,
        1,
        4,
        2,
        3,
        3,
        3,
        3,
        1,
        0,
        3,
        1,
        4,
        0,
        1,
        1,
        0,
        1,
        2,
        0,
        1,
        1,
        0,
        1,
        1,
        0,
        3,
        1,
        3,
        2,
        2,
        0,
        1,
        0,
        0,
        0,
        2,
        3,
        3,
        3,
        1,
        0,
        0,
        0,
        0,
        0,
        2,
        3
    ],
    [
        0,
        5,
        0,
        4,
        0,
        5,
        0,
        2,
        0,
        4,
        5,
        5,
        3,
        3,
        4,
        3,
        3,
        1,
        5,
        4,
        4,
        2,
        4,
        4,
        4,
        3,
        4,
        2,
        4,
        3,
        5,
        5,
        4,
        3,
        3,
        4,
        3,
        3,
        5,
        5,
        4,
        5,
        5,
        1,
        3,
        4,
        5,
        3,
        1,
        4,
        3,
        1,
        3,
        3,
        0,
        3,
        3,
        1,
        4,
        3,
        1,
        4,
        5,
        3,
        3,
        5,
        0,
        4,
        0,
        3,
        0,
        5,
        3,
        3,
        1,
        4,
        3,
        0,
        4,
        0,
        1,
        5,
        3
    ],
    [
        0,
        5,
        0,
        5,
        0,
        4,
        0,
        2,
        0,
        4,
        4,
        3,
        4,
        3,
        3,
        3,
        3,
        3,
        5,
        4,
        4,
        4,
        4,
        4,
        4,
        5,
        3,
        3,
        5,
        2,
        4,
        4,
        4,
        3,
        4,
        4,
        3,
        3,
        4,
        4,
        5,
        5,
        3,
        3,
        4,
        3,
        4,
        3,
        3,
        4,
        3,
        3,
        3,
        3,
        1,
        2,
        2,
        1,
        4,
        3,
        3,
        5,
        4,
        4,
        3,
        4,
        0,
        4,
        0,
        3,
        0,
        4,
        4,
        4,
        4,
        4,
        1,
        0,
        4,
        2,
        0,
        2,
        4
    ],
    [
        0,
        4,
        0,
        4,
        0,
        3,
        0,
        1,
        0,
        3,
        5,
        2,
        3,
        0,
        3,
        0,
        2,
        1,
        4,
        2,
        3,
        3,
        4,
        1,
        4,
        3,
        3,
        2,
        4,
        1,
        3,
        3,
        3,
        0,
        3,
        3,
        0,
        0,
        3,
        3,
        3,
        5,
        3,
        3,
        3,
        3,
        3,
        2,
        0,
        2,
        0,
        0,
        2,
        0,
        0,
        2,
        0,
        0,
        1,
        0,
        0,
        3,
        1,
        2,
        2,
        3,
        0,
        3,
        0,
        2,
        0,
        4,
        4,
        3,
        3,
        4,
        1,
        0,
        3,
        0,
        0,
        2,
        4
    ],
    [
        0,
        0,
        0,
        4,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        3,
        1,
        3,
        0,
        3,
        2,
        0,
        0,
        0,
        1,
        0,
        3,
        2,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        4,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        2
    ],
    [
        0,
        2,
        1,
        3,
        0,
        2,
        0,
        2,
        0,
        3,
        3,
        3,
        3,
        1,
        3,
        1,
        3,
        3,
        3,
        3,
        3,
        3,
        4,
        2,
        2,
        1,
        2,
        1,
        4,
        0,
        4,
        3,
        1,
        3,
        3,
        3,
        2,
        4,
        3,
        5,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        0,
        1,
        3,
        0,
        2,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        4,
        2,
        0,
        2,
        3,
        0,
        3,
        3,
        0,
        3,
        3,
        4,
        2,
        3,
        1,
        4,
        0,
        1,
        2,
        0,
        2,
        3
    ],
    [
        0,
        3,
        0,
        3,
        0,
        1,
        0,
        3,
        0,
        2,
        3,
        3,
        3,
        0,
        3,
        1,
        2,
        0,
        3,
        3,
        2,
        3,
        3,
        2,
        3,
        2,
        3,
        1,
        3,
        0,
        4,
        3,
        2,
        0,
        3,
        3,
        1,
        4,
        3,
        3,
        2,
        3,
        4,
        3,
        1,
        3,
        3,
        1,
        1,
        0,
        1,
        1,
        0,
        1,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        4,
        1,
        1,
        0,
        3,
        0,
        3,
        1,
        0,
        2,
        3,
        3,
        3,
        3,
        3,
        1,
        0,
        0,
        2,
        0,
        3,
        3
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        2,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        3,
        0,
        3,
        1,
        0,
        1,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        2,
        0,
        2,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3
    ],
    [
        0,
        2,
        0,
        3,
        1,
        3,
        0,
        3,
        0,
        2,
        3,
        3,
        3,
        1,
        3,
        1,
        3,
        1,
        3,
        1,
        3,
        3,
        3,
        1,
        3,
        0,
        2,
        3,
        1,
        1,
        4,
        3,
        3,
        2,
        3,
        3,
        1,
        2,
        2,
        4,
        1,
        3,
        3,
        0,
        1,
        4,
        2,
        3,
        0,
        1,
        3,
        0,
        3,
        0,
        0,
        1,
        3,
        0,
        2,
        0,
        0,
        3,
        3,
        2,
        1,
        3,
        0,
        3,
        0,
        2,
        0,
        3,
        4,
        4,
        4,
        3,
        1,
        0,
        3,
        0,
        0,
        3,
        3
    ],
    [
        0,
        2,
        0,
        1,
        0,
        2,
        0,
        0,
        0,
        1,
        3,
        2,
        2,
        1,
        3,
        0,
        1,
        1,
        3,
        0,
        3,
        2,
        3,
        1,
        2,
        0,
        2,
        0,
        1,
        1,
        3,
        3,
        3,
        0,
        3,
        3,
        1,
        1,
        2,
        3,
        2,
        3,
        3,
        1,
        2,
        3,
        2,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        1,
        0,
        0,
        2,
        1,
        2,
        1,
        3,
        0,
        3,
        0,
        0,
        0,
        3,
        4,
        4,
        4,
        3,
        2,
        0,
        2,
        0,
        0,
        2,
        4
    ],
    [
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        2,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        3,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3
    ],
    [
        0,
        3,
        0,
        3,
        0,
        2,
        0,
        3,
        0,
        3,
        3,
        3,
        2,
        3,
        2,
        2,
        2,
        0,
        3,
        1,
        3,
        3,
        3,
        2,
        3,
        3,
        0,
        0,
        3,
        0,
        3,
        2,
        2,
        0,
        2,
        3,
        1,
        4,
        3,
        4,
        3,
        3,
        2,
        3,
        1,
        5,
        4,
        4,
        0,
        3,
        1,
        2,
        1,
        3,
        0,
        3,
        1,
        1,
        2,
        0,
        2,
        3,
        1,
        3,
        1,
        3,
        0,
        3,
        0,
        1,
        0,
        3,
        3,
        4,
        4,
        2,
        1,
        0,
        2,
        1,
        0,
        2,
        4
    ],
    [
        0,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        4,
        2,
        5,
        1,
        4,
        0,
        2,
        0,
        2,
        1,
        3,
        1,
        4,
        0,
        2,
        1,
        0,
        0,
        2,
        1,
        4,
        1,
        1,
        0,
        3,
        3,
        0,
        5,
        1,
        3,
        2,
        3,
        3,
        1,
        0,
        3,
        2,
        3,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        4,
        0,
        1,
        0,
        3,
        0,
        2,
        0,
        1,
        0,
        3,
        3,
        3,
        4,
        3,
        3,
        0,
        0,
        0,
        0,
        2,
        3
    ],
    [
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        3
    ],
    [
        0,
        1,
        0,
        3,
        0,
        4,
        0,
        3,
        0,
        2,
        4,
        3,
        1,
        0,
        3,
        2,
        2,
        1,
        3,
        1,
        2,
        2,
        3,
        1,
        1,
        1,
        2,
        1,
        3,
        0,
        1,
        2,
        0,
        1,
        3,
        2,
        1,
        3,
        0,
        5,
        5,
        1,
        0,
        0,
        1,
        3,
        2,
        1,
        0,
        3,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        3,
        4,
        0,
        1,
        1,
        1,
        3,
        2,
        0,
        2,
        0,
        1,
        0,
        2,
        3,
        3,
        1,
        2,
        3,
        0,
        1,
        0,
        1,
        0,
        4
    ],
    [
        0,
        0,
        0,
        1,
        0,
        3,
        0,
        3,
        0,
        2,
        2,
        1,
        0,
        0,
        4,
        0,
        3,
        0,
        3,
        1,
        3,
        0,
        3,
        0,
        3,
        0,
        1,
        0,
        3,
        0,
        3,
        1,
        3,
        0,
        3,
        3,
        0,
        0,
        1,
        2,
        1,
        1,
        1,
        0,
        1,
        2,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        2,
        1,
        2,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        2,
        3,
        3,
        3,
        3,
        0,
        0,
        0,
        0,
        1,
        4
    ],
    [
        0,
        0,
        0,
        3,
        0,
        3,
        0,
        0,
        0,
        0,
        3,
        1,
        1,
        0,
        3,
        0,
        1,
        0,
        2,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        3,
        0,
        2,
        0,
        2,
        3,
        0,
        0,
        2,
        2,
        3,
        1,
        2,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        2,
        3
    ],
    [
        2,
        4,
        0,
        5,
        0,
        5,
        0,
        4,
        0,
        3,
        4,
        3,
        3,
        3,
        4,
        3,
        3,
        3,
        4,
        3,
        4,
        4,
        5,
        4,
        5,
        5,
        5,
        2,
        3,
        0,
        5,
        5,
        4,
        1,
        5,
        4,
        3,
        1,
        5,
        4,
        3,
        4,
        4,
        3,
        3,
        4,
        3,
        3,
        0,
        3,
        2,
        0,
        2,
        3,
        0,
        3,
        0,
        0,
        3,
        3,
        0,
        5,
        3,
        2,
        3,
        3,
        0,
        3,
        0,
        3,
        0,
        3,
        4,
        5,
        4,
        5,
        3,
        0,
        4,
        3,
        0,
        3,
        4
    ],
    [
        0,
        3,
        0,
        3,
        0,
        3,
        0,
        3,
        0,
        3,
        3,
        4,
        3,
        2,
        3,
        2,
        3,
        0,
        4,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        3,
        0,
        3,
        2,
        4,
        3,
        3,
        1,
        3,
        4,
        3,
        4,
        4,
        4,
        3,
        4,
        4,
        3,
        2,
        4,
        4,
        1,
        0,
        2,
        0,
        0,
        1,
        1,
        0,
        2,
        0,
        0,
        3,
        1,
        0,
        5,
        3,
        2,
        1,
        3,
        0,
        3,
        0,
        1,
        2,
        4,
        3,
        2,
        4,
        3,
        3,
        0,
        3,
        2,
        0,
        4,
        4
    ],
    [
        0,
        3,
        0,
        3,
        0,
        1,
        0,
        0,
        0,
        1,
        4,
        3,
        3,
        2,
        3,
        1,
        3,
        1,
        4,
        2,
        3,
        2,
        4,
        2,
        3,
        4,
        3,
        0,
        2,
        2,
        3,
        3,
        3,
        0,
        3,
        3,
        3,
        0,
        3,
        4,
        1,
        3,
        3,
        0,
        3,
        4,
        3,
        3,
        0,
        1,
        1,
        0,
        1,
        0,
        0,
        0,
        4,
        0,
        3,
        0,
        0,
        3,
        1,
        2,
        1,
        3,
        0,
        4,
        0,
        1,
        0,
        4,
        3,
        3,
        4,
        3,
        3,
        0,
        2,
        0,
        0,
        3,
        3
    ],
    [
        0,
        3,
        0,
        4,
        0,
        1,
        0,
        3,
        0,
        3,
        4,
        3,
        3,
        0,
        3,
        3,
        3,
        1,
        3,
        1,
        3,
        3,
        4,
        3,
        3,
        3,
        0,
        0,
        3,
        1,
        5,
        3,
        3,
        1,
        3,
        3,
        2,
        5,
        4,
        3,
        3,
        4,
        5,
        3,
        2,
        5,
        3,
        4,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        1,
        1,
        0,
        4,
        2,
        2,
        1,
        3,
        0,
        3,
        0,
        2,
        0,
        4,
        4,
        3,
        5,
        3,
        2,
        0,
        1,
        1,
        0,
        3,
        4
    ],
    [
        0,
        5,
        0,
        4,
        0,
        5,
        0,
        2,
        0,
        4,
        4,
        3,
        3,
        2,
        3,
        3,
        3,
        1,
        4,
        3,
        4,
        1,
        5,
        3,
        4,
        3,
        4,
        0,
        4,
        2,
        4,
        3,
        4,
        1,
        5,
        4,
        0,
        4,
        4,
        4,
        4,
        5,
        4,
        1,
        3,
        5,
        4,
        2,
        1,
        4,
        1,
        1,
        3,
        2,
        0,
        3,
        1,
        0,
        3,
        2,
        1,
        4,
        3,
        3,
        3,
        4,
        0,
        4,
        0,
        3,
        0,
        4,
        4,
        4,
        3,
        3,
        3,
        0,
        4,
        2,
        0,
        3,
        4
    ],
    [
        1,
        4,
        0,
        4,
        0,
        3,
        0,
        1,
        0,
        3,
        3,
        3,
        1,
        1,
        3,
        3,
        2,
        2,
        3,
        3,
        1,
        0,
        3,
        2,
        2,
        1,
        2,
        0,
        3,
        1,
        2,
        1,
        2,
        0,
        3,
        2,
        0,
        2,
        2,
        3,
        3,
        4,
        3,
        0,
        3,
        3,
        1,
        2,
        0,
        1,
        1,
        3,
        1,
        2,
        0,
        0,
        3,
        0,
        1,
        1,
        0,
        3,
        2,
        2,
        3,
        3,
        0,
        3,
        0,
        0,
        0,
        2,
        3,
        3,
        4,
        3,
        3,
        0,
        1,
        0,
        0,
        1,
        4
    ],
    [
        0,
        4,
        0,
        4,
        0,
        4,
        0,
        0,
        0,
        3,
        4,
        4,
        3,
        1,
        4,
        2,
        3,
        2,
        3,
        3,
        3,
        1,
        4,
        3,
        4,
        0,
        3,
        0,
        4,
        2,
        3,
        3,
        2,
        2,
        5,
        4,
        2,
        1,
        3,
        4,
        3,
        4,
        3,
        1,
        3,
        3,
        4,
        2,
        0,
        2,
        1,
        0,
        3,
        3,
        0,
        0,
        2,
        0,
        3,
        1,
        0,
        4,
        4,
        3,
        4,
        3,
        0,
        4,
        0,
        1,
        0,
        2,
        4,
        4,
        4,
        4,
        4,
        0,
        3,
        2,
        0,
        3,
        3
    ],
    [
        0,
        0,
        0,
        1,
        0,
        4,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        3,
        2,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        2
    ],
    [
        0,
        2,
        0,
        3,
        0,
        4,
        0,
        4,
        0,
        1,
        3,
        3,
        3,
        0,
        4,
        0,
        2,
        1,
        2,
        1,
        1,
        1,
        2,
        0,
        3,
        1,
        1,
        0,
        1,
        0,
        3,
        1,
        0,
        0,
        3,
        3,
        2,
        0,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        2,
        0,
        2,
        2,
        0,
        3,
        1,
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1,
        2,
        0,
        3,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        3,
        3,
        4,
        3,
        1,
        0,
        1,
        0,
        3,
        0,
        2
    ],
    [
        0,
        0,
        0,
        3,
        0,
        5,
        0,
        0,
        0,
        0,
        1,
        0,
        2,
        0,
        3,
        1,
        0,
        1,
        3,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        4,
        0,
        0,
        0,
        2,
        3,
        0,
        1,
        4,
        1,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        3
    ],
    [
        0,
        2,
        0,
        5,
        0,
        5,
        0,
        1,
        0,
        2,
        4,
        3,
        3,
        2,
        5,
        1,
        3,
        2,
        3,
        3,
        3,
        0,
        4,
        1,
        2,
        0,
        3,
        0,
        4,
        0,
        2,
        2,
        1,
        1,
        5,
        3,
        0,
        0,
        1,
        4,
        2,
        3,
        2,
        0,
        3,
        3,
        3,
        2,
        0,
        2,
        4,
        1,
        1,
        2,
        0,
        1,
        1,
        0,
        3,
        1,
        0,
        1,
        3,
        1,
        2,
        3,
        0,
        2,
        0,
        0,
        0,
        1,
        3,
        5,
        4,
        4,
        4,
        0,
        3,
        0,
        0,
        1,
        3
    ],
    [
        0,
        4,
        0,
        5,
        0,
        4,
        0,
        4,
        0,
        4,
        5,
        4,
        3,
        3,
        4,
        3,
        3,
        3,
        4,
        3,
        4,
        4,
        5,
        3,
        4,
        5,
        4,
        2,
        4,
        2,
        3,
        4,
        3,
        1,
        4,
        4,
        1,
        3,
        5,
        4,
        4,
        5,
        5,
        4,
        4,
        5,
        5,
        5,
        2,
        3,
        3,
        1,
        4,
        3,
        1,
        3,
        3,
        0,
        3,
        3,
        1,
        4,
        3,
        4,
        4,
        4,
        0,
        3,
        0,
        4,
        0,
        3,
        3,
        4,
        4,
        5,
        0,
        0,
        4,
        3,
        0,
        4,
        5
    ],
    [
        0,
        4,
        0,
        4,
        0,
        3,
        0,
        3,
        0,
        3,
        4,
        4,
        4,
        3,
        3,
        2,
        4,
        3,
        4,
        3,
        4,
        3,
        5,
        3,
        4,
        3,
        2,
        1,
        4,
        2,
        4,
        4,
        3,
        1,
        3,
        4,
        2,
        4,
        5,
        5,
        3,
        4,
        5,
        4,
        1,
        5,
        4,
        3,
        0,
        3,
        2,
        2,
        3,
        2,
        1,
        3,
        1,
        0,
        3,
        3,
        3,
        5,
        3,
        3,
        3,
        5,
        4,
        4,
        2,
        3,
        3,
        4,
        3,
        3,
        3,
        2,
        1,
        0,
        3,
        2,
        1,
        4,
        3
    ],
    [
        0,
        4,
        0,
        5,
        0,
        4,
        0,
        3,
        0,
        3,
        5,
        5,
        3,
        2,
        4,
        3,
        4,
        0,
        5,
        4,
        4,
        1,
        4,
        4,
        4,
        3,
        3,
        3,
        4,
        3,
        5,
        5,
        2,
        3,
        3,
        4,
        1,
        2,
        5,
        5,
        3,
        5,
        5,
        2,
        3,
        5,
        5,
        4,
        0,
        3,
        2,
        0,
        3,
        3,
        1,
        1,
        5,
        1,
        4,
        1,
        0,
        4,
        3,
        2,
        3,
        5,
        0,
        4,
        0,
        3,
        0,
        5,
        4,
        3,
        4,
        3,
        0,
        0,
        4,
        1,
        0,
        4,
        4
    ],
    [
        1,
        3,
        0,
        4,
        0,
        2,
        0,
        2,
        0,
        2,
        5,
        5,
        3,
        3,
        3,
        3,
        3,
        0,
        4,
        2,
        3,
        4,
        4,
        4,
        3,
        4,
        0,
        0,
        3,
        4,
        5,
        4,
        3,
        3,
        3,
        3,
        2,
        5,
        5,
        4,
        5,
        5,
        5,
        4,
        3,
        5,
        5,
        5,
        1,
        3,
        1,
        0,
        1,
        0,
        0,
        3,
        2,
        0,
        4,
        2,
        0,
        5,
        2,
        3,
        2,
        4,
        1,
        3,
        0,
        3,
        0,
        4,
        5,
        4,
        5,
        4,
        3,
        0,
        4,
        2,
        0,
        5,
        4
    ],
    [
        0,
        3,
        0,
        4,
        0,
        5,
        0,
        3,
        0,
        3,
        4,
        4,
        3,
        2,
        3,
        2,
        3,
        3,
        3,
        3,
        3,
        2,
        4,
        3,
        3,
        2,
        2,
        0,
        3,
        3,
        3,
        3,
        3,
        1,
        3,
        3,
        3,
        0,
        4,
        4,
        3,
        4,
        4,
        1,
        1,
        4,
        4,
        2,
        0,
        3,
        1,
        0,
        1,
        1,
        0,
        4,
        1,
        0,
        2,
        3,
        1,
        3,
        3,
        1,
        3,
        4,
        0,
        3,
        0,
        1,
        0,
        3,
        1,
        3,
        0,
        0,
        1,
        0,
        2,
        0,
        0,
        4,
        4
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ],
    [
        0,
        3,
        0,
        3,
        0,
        2,
        0,
        3,
        0,
        1,
        5,
        4,
        3,
        3,
        3,
        1,
        4,
        2,
        1,
        2,
        3,
        4,
        4,
        2,
        4,
        4,
        5,
        0,
        3,
        1,
        4,
        3,
        4,
        0,
        4,
        3,
        3,
        3,
        2,
        3,
        2,
        5,
        3,
        4,
        3,
        2,
        2,
        3,
        0,
        0,
        3,
        0,
        2,
        1,
        0,
        1,
        2,
        0,
        0,
        0,
        0,
        2,
        1,
        1,
        3,
        1,
        0,
        2,
        0,
        4,
        0,
        3,
        4,
        4,
        4,
        5,
        2,
        0,
        2,
        0,
        0,
        1,
        3
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        1,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        4,
        2,
        1,
        1,
        0,
        1,
        0,
        3,
        2,
        0,
        0,
        3,
        1,
        1,
        1,
        2,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        1,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        1,
        4,
        0,
        4,
        2,
        1,
        0,
        0,
        0,
        0,
        0,
        1
    ],
    [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        1,
        0,
        0,
        0,
        0,
        3,
        1,
        0,
        0,
        0,
        2,
        0,
        2,
        1,
        0,
        0,
        1,
        2,
        1,
        0,
        1,
        1,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        3,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        2,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2
    ],
    [
        0,
        4,
        0,
        4,
        0,
        4,
        0,
        3,
        0,
        4,
        4,
        3,
        4,
        2,
        4,
        3,
        2,
        0,
        4,
        4,
        4,
        3,
        5,
        3,
        5,
        3,
        3,
        2,
        4,
        2,
        4,
        3,
        4,
        3,
        1,
        4,
        0,
        2,
        3,
        4,
        4,
        4,
        3,
        3,
        3,
        4,
        4,
        4,
        3,
        4,
        1,
        3,
        4,
        3,
        2,
        1,
        2,
        1,
        3,
        3,
        3,
        4,
        4,
        3,
        3,
        5,
        0,
        4,
        0,
        3,
        0,
        4,
        3,
        3,
        3,
        2,
        1,
        0,
        3,
        0,
        0,
        3,
        3
    ],
    [
        0,
        4,
        0,
        3,
        0,
        3,
        0,
        3,
        0,
        3,
        5,
        5,
        3,
        3,
        3,
        3,
        4,
        3,
        4,
        3,
        3,
        3,
        4,
        4,
        4,
        3,
        3,
        3,
        3,
        4,
        3,
        5,
        3,
        3,
        1,
        3,
        2,
        4,
        5,
        5,
        5,
        5,
        4,
        3,
        4,
        5,
        5,
        3,
        2,
        2,
        3,
        3,
        3,
        3,
        2,
        3,
        3,
        1,
        2,
        3,
        2,
        4,
        3,
        3,
        3,
        4,
        0,
        4,
        0,
        2,
        0,
        4,
        3,
        2,
        2,
        1,
        2,
        0,
        3,
        0,
        0,
        4,
        1
    ]
];
function $76c3632f58b67b56$var$JapaneseContextAnalysis() {
    var NUM_OF_CATEGORY = 6;
    var DONT_KNOW = -1;
    var ENOUGH_REL_THRESHOLD = 100;
    var MAX_REL_THRESHOLD = 1000;
    var MINIMUM_DATA_THRESHOLD = 4;
    var self = this;
    function init() {
        self.reset();
    }
    this.reset = function() {
        this._mTotalRel = 0; // total sequence received
        this._mRelSample = []; // category counters, each interger counts sequence in its category
        for(var i = 0; i < NUM_OF_CATEGORY; this._mRelSample[i++] = 0);
        this._mNeedToSkipCharNum = 0; // if last byte in current buffer is not the last byte of a character, we need to know how many bytes to skip in next buffer
        this._mLastCharOrder = -1; // The order of previous char
        this._mDone = false; // If this flag is set to true, detection is done and conclusion has been made
    };
    this.feed = function(aBuf, aLen) {
        if (this._mDone) return;
        // The buffer we got is byte oriented, and a character may span in more than one
        // buffers. In case the last one or two byte in last buffer is not complete, we
        // record how many byte needed to complete that character and skip these bytes here.
        // We can choose to record those bytes as well and analyse the character once it
        // is complete, but since a character will not make much difference, by simply skipping
        // this character will simply our logic and improve performance.
        var i = this._mNeedToSkipCharNum;
        while(i < aLen){
            var rets = this.getOrder(aBuf.slice(i, i + 2));
            var order = rets[0];
            var charLen = rets[1];
            i += charLen;
            if (i > aLen) {
                this._mNeedToSkipCharNum = i - aLen;
                this._mLastCharOrder = -1;
            } else {
                if (order != -1 && this._mLastCharOrder != -1) {
                    this._mTotalRel += 1;
                    if (this._mTotalRel > MAX_REL_THRESHOLD) {
                        this._mDone = true;
                        break;
                    }
                    this._mRelSample[$76c3632f58b67b56$export$f5d998e2212d7909[this._mLastCharOrder][order]] += 1;
                }
                this._mLastCharOrder = order;
            }
        }
    };
    this.gotEnoughData = function() {
        return this._mTotalRel > ENOUGH_REL_THRESHOLD;
    };
    this.getConfidence = function() {
        // This is just one way to calculate confidence. It works well for me.
        if (this._mTotalRel > MINIMUM_DATA_THRESHOLD) return (this._mTotalRel - this._mRelSample[0]) / this._mTotalRel;
        else return DONT_KNOW;
    };
    this.getOrder = function(aStr) {
        return [
            -1,
            1
        ];
    };
    init();
}
function $76c3632f58b67b56$var$SJISContextAnalysis() {
    this.getOrder = function(aStr) {
        if (!aStr) return [
            -1,
            1
        ];
        // find out current char's byte length
        if (aStr.charCodeAt(0) >= 0x81 && aStr.charCodeAt(0) <= 0x9F || aStr.charCodeAt(0) >= 0xE0 && aStr.charCodeAt(0) <= 0xFC) var charLen = 2;
        else charLen = 1;
        // return its order if it is hiragana
        if (aStr.length > 1) {
            if (aStr.charCodeAt(0) == 0x82 && aStr.charCodeAt(1) >= 0x9F && aStr.charCodeAt(0) <= 0xF1) return [
                aStr.charCodeAt(1) - 0x9F,
                charLen
            ];
        }
        return [
            -1,
            charLen
        ];
    };
}
$76c3632f58b67b56$var$SJISContextAnalysis.prototype = new $76c3632f58b67b56$var$JapaneseContextAnalysis();
$76c3632f58b67b56$export$cd4690d83476f80a = $76c3632f58b67b56$var$SJISContextAnalysis;
function $76c3632f58b67b56$var$EUCJPContextAnalysis() {
    this.getOrder = function(aStr) {
        if (!aStr) return [
            -1,
            1
        ];
        // find out current char's byte length
        if (aStr.charCodeAt(0) >= 0x8E || aStr.charCodeAt(0) >= 0xA1 && aStr.charCodeAt(0) <= 0xFE) var charLen = 2;
        else if (aStr.charCodeAt(0) == 0x8F) charLen = 3;
        else charLen = 1;
        // return its order if it is hiragana
        if (aStr.length > 1) {
            if (aStr.charCodeAt(0) == 0xA4 && aStr.charCodeAt(1) >= 0xA1 && aStr.charCodeAt(1) <= 0xF3) return [
                aStr.charCodeAt(1) - 0xA1,
                charLen
            ];
        }
        return [
            -1,
            charLen
        ];
    };
}
$76c3632f58b67b56$var$EUCJPContextAnalysis.prototype = new $76c3632f58b67b56$var$JapaneseContextAnalysis();
$76c3632f58b67b56$export$cb228283d2c3b721 = $76c3632f58b67b56$var$EUCJPContextAnalysis;

});


parcelRegister("gvf1X", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $3xI8B = parcelRequire("3xI8B");

var $14x9i = parcelRequire("14x9i");

var $a1Zfb = parcelRequire("a1Zfb");
var $c03b335b30b32aee$require$EUCJPDistributionAnalysis = $a1Zfb.EUCJPDistributionAnalysis;

var $acaMs = parcelRequire("acaMs");
var $c03b335b30b32aee$require$EUCJPContextAnalysis = $acaMs.EUCJPContextAnalysis;

var $eHARW = parcelRequire("eHARW");

var $8hFBI = parcelRequire("8hFBI");

var $87x91 = parcelRequire("87x91");
function $c03b335b30b32aee$var$EUCJPProber() {
    $14x9i.apply(this);
    var self = this;
    function init() {
        self._mCodingSM = new $3xI8B($eHARW);
        self._mDistributionAnalyzer = new $c03b335b30b32aee$require$EUCJPDistributionAnalysis();
        self._mContextAnalyzer = new $c03b335b30b32aee$require$EUCJPContextAnalysis();
        self.reset();
    }
    this.reset = function() {
        $c03b335b30b32aee$var$EUCJPProber.prototype.reset.apply(this);
        this._mContextAnalyzer.reset();
    };
    this.getCharsetName = function() {
        return "EUC-JP";
    };
    this.feed = function(aBuf) {
        var aLen = aBuf.length;
        for(var i = 0; i < aLen; i++){
            var codingState = this._mCodingSM.nextState(aBuf[i]);
            if (codingState == $8hFBI.error) {
                $87x91.log(this.getCharsetName() + " prober hit error at byte " + i + "\n");
                this._mState = $8hFBI.notMe;
                break;
            } else if (codingState == $8hFBI.itsMe) {
                this._mState = $8hFBI.foundIt;
                break;
            } else if (codingState == $8hFBI.start) {
                var charLen = this._mCodingSM.getCurrentCharLen();
                if (i == 0) {
                    this._mLastChar[1] = aBuf[0];
                    this._mContextAnalyzer.feed(this._mLastChar, charLen);
                    this._mDistributionAnalyzer.feed(this._mLastChar, charLen);
                } else {
                    this._mContextAnalyzer.feed(aBuf.slice(i - 1, i + 1), charLen);
                    this._mDistributionAnalyzer.feed(aBuf.slice(i - 1, i + 1), charLen);
                }
            }
        }
        this._mLastChar[0] = aBuf[aLen - 1];
        if (this.getState() == $8hFBI.detecting) {
            if (this._mContextAnalyzer.gotEnoughData() && this.getConfidence() > $8hFBI.SHORTCUT_THRESHOLD) this._mState = $8hFBI.foundIt;
        }
        return this.getState();
    };
    this.getConfidence = function() {
        var contxtCf = this._mContextAnalyzer.getConfidence();
        var distribCf = this._mDistributionAnalyzer.getConfidence();
        return Math.max(contxtCf, distribCf);
    };
    init();
}
$c03b335b30b32aee$var$EUCJPProber.prototype = new $14x9i();
module.exports = $c03b335b30b32aee$var$EUCJPProber;

});
parcelRegister("eHARW", function(module, exports) {

var $8hFBI = parcelRequire("8hFBI");
var $ab41ae45f9cb3806$var$EUCJP_cls = [
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    1,
    3,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    5 // f8 - ff
];
var $ab41ae45f9cb3806$var$EUCJP_st = [
    3,
    4,
    3,
    5,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    3,
    $8hFBI.error,
    3,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start //20-27
];
var $ab41ae45f9cb3806$var$EUCJPCharLenTable = [
    2,
    2,
    2,
    3,
    1,
    0
];
module.exports = {
    "classTable": $ab41ae45f9cb3806$var$EUCJP_cls,
    "classFactor": 6,
    "stateTable": $ab41ae45f9cb3806$var$EUCJP_st,
    "charLenTable": $ab41ae45f9cb3806$var$EUCJPCharLenTable,
    "name": "EUC-JP"
};

});


parcelRegister("gmbm9", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $14x9i = parcelRequire("14x9i");

var $3xI8B = parcelRequire("3xI8B");

var $7EhKX = parcelRequire("7EhKX");

var $a1Zfb = parcelRequire("a1Zfb");
var $be87828bb09f3891$require$GB2312DistributionAnalysis = $a1Zfb.GB2312DistributionAnalysis;
function $be87828bb09f3891$var$GB2312Prober() {
    $14x9i.apply(this);
    var self = this;
    function init() {
        self._mCodingSM = new $3xI8B($7EhKX);
        self._mDistributionAnalyzer = new $be87828bb09f3891$require$GB2312DistributionAnalysis();
        self.reset();
    }
    this.getCharsetName = function() {
        return "GB2312";
    };
    init();
}
$be87828bb09f3891$var$GB2312Prober.prototype = new $14x9i();
module.exports = $be87828bb09f3891$var$GB2312Prober;

});
parcelRegister("7EhKX", function(module, exports) {

var $8hFBI = parcelRequire("8hFBI");
var $591a0ae26ba4d65a$var$GB2312_cls = [
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    4,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    0 // f8 - ff
];
var $591a0ae26ba4d65a$var$GB2312_st = [
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    3,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    4,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    5,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start //28-2f
];
// To be accurate, the length of class 6 can be either 2 or 4.
// But it is not necessary to discriminate between the two since
// it is used for frequency analysis only, and we are validing
// each code range there as well. So it is safe to set it to be
// 2 here.
var $591a0ae26ba4d65a$var$GB2312CharLenTable = [
    0,
    1,
    1,
    1,
    1,
    1,
    2
];
module.exports = {
    "classTable": $591a0ae26ba4d65a$var$GB2312_cls,
    "classFactor": 7,
    "stateTable": $591a0ae26ba4d65a$var$GB2312_st,
    "charLenTable": $591a0ae26ba4d65a$var$GB2312CharLenTable,
    "name": "GB2312"
};

});


parcelRegister("17rCU", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $3xI8B = parcelRequire("3xI8B");

var $14x9i = parcelRequire("14x9i");

var $a1Zfb = parcelRequire("a1Zfb");
var $0d0bdff855761c61$require$EUCKRDistributionAnalysis = $a1Zfb.EUCKRDistributionAnalysis;

var $ffIr4 = parcelRequire("ffIr4");
function $0d0bdff855761c61$var$EUCKRProber() {
    $14x9i.apply(this);
    var self = this;
    function init() {
        self._mCodingSM = new $3xI8B($ffIr4);
        self._mDistributionAnalyzer = new $0d0bdff855761c61$require$EUCKRDistributionAnalysis();
        self.reset();
    }
    this.getCharsetName = function() {
        return "EUC-KR";
    };
    init();
}
$0d0bdff855761c61$var$EUCKRProber.prototype = new $14x9i();
module.exports = $0d0bdff855761c61$var$EUCKRProber;

});
parcelRegister("ffIr4", function(module, exports) {

var $8hFBI = parcelRequire("8hFBI");
var $b1aab9be5dc725f6$var$EUCKR_cls = [
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0 // f8 - ff
];
var $b1aab9be5dc725f6$var$EUCKR_st = [
    $8hFBI.error,
    $8hFBI.start,
    3,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start //08-0f
];
var $b1aab9be5dc725f6$var$EUCKRCharLenTable = [
    0,
    1,
    2,
    0
];
module.exports = {
    "classTable": $b1aab9be5dc725f6$var$EUCKR_cls,
    "classFactor": 4,
    "stateTable": $b1aab9be5dc725f6$var$EUCKR_st,
    "charLenTable": $b1aab9be5dc725f6$var$EUCKRCharLenTable,
    "name": "EUC-KR"
};

});


parcelRegister("csMjn", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $3xI8B = parcelRequire("3xI8B");

var $14x9i = parcelRequire("14x9i");

var $a1Zfb = parcelRequire("a1Zfb");
var $912d933e081eab2a$require$EUCTWDistributionAnalysis = $a1Zfb.EUCTWDistributionAnalysis;

var $dPOm1 = parcelRequire("dPOm1");
function $912d933e081eab2a$var$EUCTWProber() {
    $14x9i.apply(this);
    var self = this;
    function init() {
        self._mCodingSM = new $3xI8B($dPOm1);
        self._mDistributionAnalyzer = new $912d933e081eab2a$require$EUCTWDistributionAnalysis();
        self.reset();
    }
    this.getCharsetName = function() {
        return "EUC-TW";
    };
    init();
}
$912d933e081eab2a$var$EUCTWProber.prototype = new $14x9i();
module.exports = $912d933e081eab2a$var$EUCTWProber;

});
parcelRegister("dPOm1", function(module, exports) {

var $8hFBI = parcelRequire("8hFBI");
var $a1271917a7d117f2$var$EUCTW_cls = [
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    6,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0 // f8 - ff
];
var $a1271917a7d117f2$var$EUCTW_st = [
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    3,
    3,
    3,
    4,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    5,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start //28-2f
];
var $a1271917a7d117f2$var$EUCTWCharLenTable = [
    0,
    0,
    1,
    2,
    2,
    2,
    3
];
module.exports = {
    "classTable": $a1271917a7d117f2$var$EUCTW_cls,
    "classFactor": 7,
    "stateTable": $a1271917a7d117f2$var$EUCTW_st,
    "charLenTable": $a1271917a7d117f2$var$EUCTWCharLenTable,
    "name": "x-euc-tw"
};

});



parcelRegister("6rWe8", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $jAGUv = parcelRequire("jAGUv");

var $jGBbN = parcelRequire("jGBbN");

var $eXbYA = parcelRequire("eXbYA");
var $4b226e627ba1cf5d$require$Win1255HebrewModel = $eXbYA.Win1255HebrewModel;

var $9wca0 = parcelRequire("9wca0");

var $cCGdf = parcelRequire("cCGdf");

var $kvpUH = parcelRequire("kvpUH");

var $3Q6nm = parcelRequire("3Q6nm");
var $4b226e627ba1cf5d$require$TIS620ThaiModel = $3Q6nm.TIS620ThaiModel;

var $kJVTE = parcelRequire("kJVTE");

var $bhZUU = parcelRequire("bhZUU");
function $4b226e627ba1cf5d$var$SBCSGroupProber() {
    $jGBbN.apply(this);
    var self = this;
    function init() {
        self._mProbers = [
            new $jAGUv($cCGdf.Win1251CyrillicModel),
            new $jAGUv($cCGdf.Koi8rModel),
            new $jAGUv($cCGdf.Latin5CyrillicModel),
            new $jAGUv($cCGdf.MacCyrillicModel),
            new $jAGUv($cCGdf.Ibm866Model),
            new $jAGUv($cCGdf.Ibm855Model),
            new $jAGUv($kvpUH.Latin7GreekModel),
            new $jAGUv($kvpUH.Win1253GreekModel),
            new $jAGUv($bhZUU.Latin5BulgarianModel),
            new $jAGUv($bhZUU.Win1251BulgarianModel),
            new $jAGUv($kJVTE.Latin2HungarianModel),
            new $jAGUv($kJVTE.Win1250HungarianModel),
            new $jAGUv($4b226e627ba1cf5d$require$TIS620ThaiModel)
        ];
        var hebrewProber = new $9wca0();
        var logicalHebrewProber = new $jAGUv($4b226e627ba1cf5d$require$Win1255HebrewModel, false, hebrewProber);
        var visualHebrewProber = new $jAGUv($4b226e627ba1cf5d$require$Win1255HebrewModel, true, hebrewProber);
        hebrewProber.setModelProbers(logicalHebrewProber, visualHebrewProber);
        self._mProbers.push(hebrewProber, logicalHebrewProber, visualHebrewProber);
        self.reset();
    }
    init();
}
$4b226e627ba1cf5d$var$SBCSGroupProber.prototype = new $jGBbN();
module.exports = $4b226e627ba1cf5d$var$SBCSGroupProber;

});
parcelRegister("jAGUv", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $2SPVp = parcelRequire("2SPVp");

var $8hFBI = parcelRequire("8hFBI");

var $87x91 = parcelRequire("87x91");
function $e432aa37e6035aaf$var$SingleByteCharSetProber(model, reversed, nameProber) {
    $2SPVp.apply(this);
    var SAMPLE_SIZE = 64;
    var SB_ENOUGH_REL_THRESHOLD = 1024;
    var POSITIVE_SHORTCUT_THRESHOLD = 0.95;
    var NEGATIVE_SHORTCUT_THRESHOLD = 0.05;
    var SYMBOL_CAT_ORDER = 250;
    var NUMBER_OF_SEQ_CAT = 4;
    var POSITIVE_CAT = NUMBER_OF_SEQ_CAT - 1;
    //var NEGATIVE_CAT = 0;
    var self = this;
    function init(model, reversed, nameProber) {
        self._mModel = model;
        self._mReversed = reversed; // "true" if we need to reverse every pair in the model lookup
        self._mNameProber = nameProber; // Optional auxiliary prober for name decision
        self.reset();
    }
    this.reset = function() {
        $e432aa37e6035aaf$var$SingleByteCharSetProber.prototype.reset.apply(this);
        this._mLastOrder = 255; // char order of last character
        this._mSeqCounters = [];
        for(var i = 0; i < NUMBER_OF_SEQ_CAT; this._mSeqCounters[i++] = 0);
        this._mTotalSeqs = 0;
        this._mTotalChar = 0;
        this._mFreqChar = 0; // characters that fall in our sampling range
    };
    this.getCharsetName = function() {
        if (this._mNameProber) return this._mNameProber.getCharsetName();
        else return this._mModel.charsetName;
    };
    this.feed = function(aBuf) {
        if (!this._mModel.keepEnglishLetter) aBuf = this.filterWithoutEnglishLetters(aBuf);
        var aLen = aBuf.length;
        if (!aLen) return this.getState();
        for(var i = 0, c; i < aLen; i++){
            c = aBuf.charCodeAt(i);
            var order = this._mModel.charToOrderMap[c];
            if (order < SYMBOL_CAT_ORDER) this._mTotalChar++;
            if (order < SAMPLE_SIZE) {
                this._mFreqChar++;
                if (this._mLastOrder < SAMPLE_SIZE) {
                    this._mTotalSeqs++;
                    if (!this._mReversed) this._mSeqCounters[this._mModel.precedenceMatrix[this._mLastOrder * SAMPLE_SIZE + order]]++;
                    else this._mSeqCounters[this._mModel.precedenceMatrix[order * SAMPLE_SIZE + this._mLastOrder]]++;
                }
            }
            this._mLastOrder = order;
        }
        if (this.getState() == $8hFBI.detecting) {
            if (self._mTotalSeqs > SB_ENOUGH_REL_THRESHOLD) {
                var cf = this.getConfidence();
                if (cf > POSITIVE_SHORTCUT_THRESHOLD) $87x91.log(this._mModel.charsetName + " confidence = " + cf + ", we have a winner\n");
                else if (cf < NEGATIVE_SHORTCUT_THRESHOLD) {
                    $87x91.log(this._mModel.charsetName + " confidence = " + cf + ", below negative shortcut threshhold " + NEGATIVE_SHORTCUT_THRESHOLD + "\n");
                    this._mState = $8hFBI.notMe;
                }
            }
        }
        return this.getState();
    };
    this.getConfidence = function() {
        var r = 0.01;
        if (this._mTotalSeqs > 0) {
            //logger.log(this._mSeqCounters[POSITIVE_CAT] + " " + this._mTotalSeqs + " " + this._mModel.mTypicalPositiveRatio);
            r = 1.0 * this._mSeqCounters[POSITIVE_CAT] / this._mTotalSeqs / this._mModel.mTypicalPositiveRatio;
            //logger.log(r + " " + this._mFreqChar + " " + this._mTotalChar);
            r *= this._mFreqChar / this._mTotalChar;
            if (r >= 1.0) r = 0.99;
        }
        return r;
    };
    reversed = reversed !== undefined ? reversed : false;
    nameProber = nameProber !== undefined ? nameProber : null;
    init(model, reversed, nameProber);
}
$e432aa37e6035aaf$var$SingleByteCharSetProber.prototype = new $2SPVp();
module.exports = $e432aa37e6035aaf$var$SingleByteCharSetProber;

});

parcelRegister("eXbYA", function(module, exports) {

$parcel$export(module.exports, "win1255_CharToOrderMap", () => $ae2fdd9b18cbab2c$export$20b745873a46c733, (v) => $ae2fdd9b18cbab2c$export$20b745873a46c733 = v);
$parcel$export(module.exports, "HebrewLangModel", () => $ae2fdd9b18cbab2c$export$20ba5ddbda68dbb8, (v) => $ae2fdd9b18cbab2c$export$20ba5ddbda68dbb8 = v);
$parcel$export(module.exports, "Win1255HebrewModel", () => $ae2fdd9b18cbab2c$export$8f2c37d9c9653a0f, (v) => $ae2fdd9b18cbab2c$export$8f2c37d9c9653a0f = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // 255: Control characters that usually does not exist in any text
// 254: Carriage/Return
// 253: symbol (punctuation) that does not belong to word
// 252: 0 - 9
// Windows-1255 language model
// Character Mapping Table:
var $ae2fdd9b18cbab2c$export$20b745873a46c733;
// Model Table:
// total sequences: 100%
// first 512 sequences: 98.4004%
// first 1024 sequences: 1.5981%
// rest  sequences:      0.087%
// negative sequences:   0.0015%
var $ae2fdd9b18cbab2c$export$20ba5ddbda68dbb8;
var $ae2fdd9b18cbab2c$export$8f2c37d9c9653a0f;
$ae2fdd9b18cbab2c$export$20b745873a46c733 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    69,
    91,
    79,
    80,
    92,
    89,
    97,
    90,
    68,
    111,
    112,
    82,
    73,
    95,
    85,
    78,
    121,
    86,
    71,
    67,
    102,
    107,
    84,
    114,
    103,
    115,
    253,
    253,
    253,
    253,
    253,
    253,
    50,
    74,
    60,
    61,
    42,
    76,
    70,
    64,
    53,
    105,
    93,
    56,
    65,
    54,
    49,
    66,
    110,
    51,
    43,
    44,
    63,
    81,
    77,
    98,
    75,
    108,
    253,
    253,
    253,
    253,
    253,
    124,
    202,
    203,
    204,
    205,
    40,
    58,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    83,
    52,
    47,
    46,
    72,
    32,
    94,
    216,
    113,
    217,
    109,
    218,
    219,
    220,
    221,
    34,
    116,
    222,
    118,
    100,
    223,
    224,
    117,
    119,
    104,
    125,
    225,
    226,
    87,
    99,
    227,
    106,
    122,
    123,
    228,
    55,
    229,
    230,
    101,
    231,
    232,
    120,
    233,
    48,
    39,
    57,
    234,
    30,
    59,
    41,
    88,
    33,
    37,
    36,
    31,
    29,
    35,
    235,
    62,
    28,
    236,
    126,
    237,
    238,
    38,
    45,
    239,
    240,
    241,
    242,
    243,
    127,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    9,
    8,
    20,
    16,
    3,
    2,
    24,
    14,
    22,
    1,
    25,
    15,
    4,
    11,
    6,
    23,
    12,
    19,
    13,
    26,
    18,
    27,
    21,
    17,
    7,
    10,
    5,
    251,
    252,
    128,
    96,
    253
];
$ae2fdd9b18cbab2c$export$20ba5ddbda68dbb8 = [
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    1,
    2,
    0,
    1,
    0,
    0,
    3,
    0,
    3,
    1,
    0,
    0,
    1,
    3,
    2,
    0,
    1,
    1,
    2,
    0,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    0,
    0,
    2,
    2,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    1,
    2,
    1,
    3,
    1,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    0,
    1,
    2,
    2,
    1,
    3,
    1,
    2,
    1,
    1,
    2,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    2,
    1,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    0,
    2,
    2,
    2,
    0,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    0,
    2,
    0,
    2,
    0,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    3,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    1,
    2,
    0,
    2,
    1,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    1,
    2,
    2,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    1,
    2,
    2,
    0,
    2,
    2,
    2,
    0,
    2,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    2,
    2,
    0,
    2,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    1,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    1,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    1,
    2,
    1,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    0,
    2,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    1,
    2,
    3,
    0,
    2,
    1,
    2,
    2,
    0,
    2,
    1,
    1,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    1,
    2,
    2,
    2,
    1,
    2,
    3,
    3,
    1,
    2,
    1,
    2,
    2,
    2,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    2,
    3,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    1,
    2,
    2,
    2,
    2,
    3,
    2,
    3,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    0,
    2,
    2,
    2,
    2,
    0,
    1,
    0,
    1,
    2,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    3,
    3,
    3,
    0,
    3,
    0,
    2,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    2,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    2,
    1,
    2,
    2,
    2,
    0,
    2,
    0,
    2,
    0,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    2,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    1,
    2,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    0,
    2,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    2,
    2,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    1,
    0,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0
];
$ae2fdd9b18cbab2c$export$8f2c37d9c9653a0f = {
    "charToOrderMap": $ae2fdd9b18cbab2c$export$20b745873a46c733,
    "precedenceMatrix": $ae2fdd9b18cbab2c$export$20ba5ddbda68dbb8,
    "mTypicalPositiveRatio": 0.984004,
    "keepEnglishLetter": false,
    "charsetName": "windows-1255"
};

});

parcelRegister("9wca0", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // This prober doesn't actually recognize a language or a charset.
// It is a helper prober for the use of the Hebrew model probers
////// General ideas of the Hebrew charset recognition //////
//
// Four main charsets exist in Hebrew:
// "ISO-8859-8" - Visual Hebrew
// "windows-1255" - Logical Hebrew
// "ISO-8859-8-I" - Logical Hebrew
// "x-mac-hebrew" - ?? Logical Hebrew ??
//
// Both "ISO" charsets use a completely identical set of code points, whereas
// "windows-1255" and "x-mac-hebrew" are two different proper supersets of
// these code points. windows-1255 defines additional characters in the range
// 0x80-0x9F as some misc punctuation marks as well as some Hebrew-specific
// diacritics and additional 'Yiddish' ligature letters in the range 0xc0-0xd6.
// x-mac-hebrew defines similar additional code points but with a different
// mapping.
//
// As far as an average Hebrew text with no diacritics is concerned, all four
// charsets are identical with respect to code points. Meaning that for the
// main Hebrew alphabet, all four map the same values to all 27 Hebrew letters
// (including final letters).
//
// The dominant difference between these charsets is their directionality.
// "Visual" directionality means that the text is ordered as if the renderer is
// not aware of a BIDI rendering algorithm. The renderer sees the text and
// draws it from left to right. The text itself when ordered naturally is read
// backwards. A buffer of Visual Hebrew generally looks like so:
// "[last word of first line spelled backwards] [whole line ordered backwards
// and spelled backwards] [first word of first line spelled backwards]
// [end of line] [last word of second line] ... etc' "
// adding punctuation marks, numbers and English text to visual text is
// naturally also "visual" and from left to right.
//
// "Logical" directionality means the text is ordered "naturally" according to
// the order it is read. It is the responsibility of the renderer to display
// the text from right to left. A BIDI algorithm is used to place general
// punctuation marks, numbers and English text in the text.
//
// Texts in x-mac-hebrew are almost impossible to find on the Internet. From
// what little evidence I could find, it seems that its general directionality
// is Logical.
//
// To sum up all of the above, the Hebrew probing mechanism knows about two
// charsets:
// Visual Hebrew - "ISO-8859-8" - backwards text - Words and sentences are
//    backwards while line order is natural. For charset recognition purposes
//    the line order is unimportant (In fact, for this implementation, even
//    word order is unimportant).
// Logical Hebrew - "windows-1255" - normal, naturally ordered text.
//
// "ISO-8859-8-I" is a subset of windows-1255 and doesn't need to be
//    specifically identified.
// "x-mac-hebrew" is also identified as windows-1255. A text in x-mac-hebrew
//    that contain special punctuation marks or diacritics is displayed with
//    some unconverted characters showing as question marks. This problem might
//    be corrected using another model prober for x-mac-hebrew. Due to the fact
//    that x-mac-hebrew texts are so rare, writing another model prober isn't
//    worth the effort and performance hit.
//
//////// The Prober ////////
//
// The prober is divided between two SBCharSetProbers and a HebrewProber,
// all of which are managed, created, fed data, inquired and deleted by the
// SBCSGroupProber. The two SBCharSetProbers identify that the text is in
// fact some kind of Hebrew, Logical or Visual. The final decision about which
// one is it is made by the HebrewProber by combining final-letter scores
// with the scores of the two SBCharSetProbers to produce a final answer.
//
// The SBCSGroupProber is responsible for stripping the original text of HTML
// tags, English characters, numbers, low-ASCII punctuation characters, spaces
// and new lines. It reduces any sequence of such characters to a single space.
// The buffer fed to each prober in the SBCS group prober is pure text in
// high-ASCII.
// The two SBCharSetProbers (model probers) share the same language model:
// Win1255Model.
// The first SBCharSetProber uses the model normally as any other
// SBCharSetProber does, to recognize windows-1255, upon which this model was
// built. The second SBCharSetProber is told to make the pair-of-letter
// lookup in the language model backwards. This in practice exactly simulates
// a visual Hebrew model using the windows-1255 logical Hebrew model.
//
// The HebrewProber is not using any language model. All it does is look for
// final-letter evidence suggesting the text is either logical Hebrew or visual
// Hebrew. Disjointed from the model probers, the results of the HebrewProber
// alone are meaningless. HebrewProber always returns 0.00 as confidence
// since it never identifies a charset by itself. Instead, the pointer to the
// HebrewProber is passed to the model probers as a helper "Name Prober".
// When the Group prober receives a positive identification from any prober,
// it asks for the name of the charset identified. If the prober queried is a
// Hebrew model prober, the model prober forwards the call to the
// HebrewProber to make the final decision. In the HebrewProber, the
// decision is made according to the final-letters scores maintained and Both
// model probers scores. The answer is returned in the form of the name of the
// charset identified, either "windows-1255" or "ISO-8859-8".

var $2SPVp = parcelRequire("2SPVp");

var $8hFBI = parcelRequire("8hFBI");
// https://developer.mozilla.org/En/Core_JavaScript_1.5_Reference/Objects/Array/IndexOf
if (!Array.prototype.indexOf) Array.prototype.indexOf = function(elt /*, from*/ ) {
    var len = this.length >>> 0;
    var from = Number(arguments[1]) || 0;
    from = from < 0 ? Math.ceil(from) : Math.floor(from);
    if (from < 0) from += len;
    for(; from < len; from++){
        if (from in this && this[from] === elt) return from;
    }
    return -1;
};
function $6ee088ff78e284cc$var$HebrewProber() {
    $2SPVp.apply(this);
    // windows-1255 / ISO-8859-8 code points of interest
    var FINAL_KAF = '\xea';
    var NORMAL_KAF = '\xeb';
    var FINAL_MEM = '\xed';
    var NORMAL_MEM = '\xee';
    var FINAL_NUN = '\xef';
    var NORMAL_NUN = '\xf0';
    var FINAL_PE = '\xf3';
    var NORMAL_PE = '\xf4';
    var FINAL_TSADI = '\xf5';
    var NORMAL_TSADI = '\xf6';
    // Minimum Visual vs Logical final letter score difference.
    // If the difference is below this, don't rely solely on the final letter score distance.
    var MIN_FINAL_CHAR_DISTANCE = 5;
    // Minimum Visual vs Logical model score difference.
    // If the difference is below this, don't rely at all on the model score distance.
    var MIN_MODEL_DISTANCE = 0.01;
    var VISUAL_HEBREW_NAME = "ISO-8859-8";
    var LOGICAL_HEBREW_NAME = "windows-1255";
    var self = this;
    function init() {
        self._mLogicalProber = null;
        self._mVisualProber = null;
        self.reset();
    }
    this.reset = function() {
        this._mFinalCharLogicalScore = 0;
        this._mFinalCharVisualScore = 0;
        // The two last characters seen in the previous buffer,
        // mPrev and mBeforePrev are initialized to space in order to simulate a word
        // delimiter at the beginning of the data
        this._mPrev = " ";
        this._mBeforePrev = " ";
    // These probers are owned by the group prober.
    };
    this.setModelProbers = function(logicalProber, visualProber) {
        this._mLogicalProber = logicalProber;
        this._mVisualProber = visualProber;
    };
    this.isFinal = function(c) {
        return [
            FINAL_KAF,
            FINAL_MEM,
            FINAL_NUN,
            FINAL_PE,
            FINAL_TSADI
        ].indexOf(c) != -1;
    };
    this.isNonFinal = function(c) {
        // The normal Tsadi is not a good Non-Final letter due to words like
        // 'lechotet' (to chat) containing an apostrophe after the tsadi. This
        // apostrophe is converted to a space in FilterWithoutEnglishLetters causing
        // the Non-Final tsadi to appear at an end of a word even though this is not
        // the case in the original text.
        // The letters Pe and Kaf rarely display a related behavior of not being a
        // good Non-Final letter. Words like 'Pop', 'Winamp' and 'Mubarak' for
        // example legally end with a Non-Final Pe or Kaf. However, the benefit of
        // these letters as Non-Final letters outweighs the damage since these words
        // are quite rare.
        return [
            NORMAL_KAF,
            NORMAL_MEM,
            NORMAL_NUN,
            NORMAL_PE
        ].indexOf(c) != -1;
    };
    this.feed = function(aBuf) {
        // Final letter analysis for logical-visual decision.
        // Look for evidence that the received buffer is either logical Hebrew or
        // visual Hebrew.
        // The following cases are checked:
        // 1) A word longer than 1 letter, ending with a final letter. This is an
        //    indication that the text is laid out "naturally" since the final letter
        //    really appears at the end. +1 for logical score.
        // 2) A word longer than 1 letter, ending with a Non-Final letter. In normal
        //    Hebrew, words ending with Kaf, Mem, Nun, Pe or Tsadi, should not end with
        //    the Non-Final form of that letter. Exceptions to this rule are mentioned
        //    above in isNonFinal(). This is an indication that the text is laid out
        //    backwards. +1 for visual score
        // 3) A word longer than 1 letter, starting with a final letter. Final letters
        //    should not appear at the beginning of a word. This is an indication that
        //    the text is laid out backwards. +1 for visual score.
        //
        // The visual score and logical score are accumulated throughout the text and
        // are finally checked against each other in GetCharSetName().
        // No checking for final letters in the middle of words is done since that case
        // is not an indication for either Logical or Visual text.
        //
        // We automatically filter out all 7-bit characters (replace them with spaces)
        // so the word boundary detection works properly. [MAP]
        if (this.getState() == $8hFBI.notMe) // Both model probers say it's not them. No reason to continue.
        return $8hFBI.notMe;
        aBuf = this.filterHighBitOnly(aBuf);
        for(var i = 0, cur; i < aBuf.length; i++){
            cur = aBuf[i];
            if (cur == " ") // We stand on a space - a word just ended
            {
                if (this._mBeforePrev != " ") {
                    // next-to-last char was not a space so self._mPrev is not a 1 letter word
                    if (this.isFinal(this._mPrev)) // case (1) [-2:not space][-1:final letter][cur:space]
                    this._mFinalCharLogicalScore++;
                    else if (this.isNonFinal(this._mPrev)) // case (2) [-2:not space][-1:Non-Final letter][cur:space]
                    this._mFinalCharVisualScore++;
                }
            } else // Not standing on a space
            if (this._mBeforePrev == " " && this.isFinal(this._mPrev) && cur != " ") // case (3) [-2:space][-1:final letter][cur:not space]
            this._mFinalCharVisualScore++;
            this._mBeforePrev = this._mPrev;
            this._mPrev = cur;
        }
        // Forever detecting, till the end or until both model probers return eNotMe (handled above)
        return $8hFBI.detecting;
    };
    this.getCharsetName = function() {
        // Make the decision: is it Logical or Visual?
        // If the final letter score distance is dominant enough, rely on it.
        var finalsub = this._mFinalCharLogicalScore - this._mFinalCharVisualScore;
        if (finalsub >= MIN_FINAL_CHAR_DISTANCE) return LOGICAL_HEBREW_NAME;
        if (finalsub <= -MIN_FINAL_CHAR_DISTANCE) return VISUAL_HEBREW_NAME;
        // It's not dominant enough, try to rely on the model scores instead.
        var modelsub = this._mLogicalProber.getConfidence() - this._mVisualProber.getConfidence();
        if (modelsub > MIN_MODEL_DISTANCE) return LOGICAL_HEBREW_NAME;
        if (modelsub < -MIN_MODEL_DISTANCE) return VISUAL_HEBREW_NAME;
        // Still no good, back to final letter distance, maybe it'll save the day.
        if (finalsub < 0) return VISUAL_HEBREW_NAME;
        // (finalsub > 0 - Logical) or (don't know what to do) default to Logical.
        return LOGICAL_HEBREW_NAME;
    };
    this.getState = function() {
        // Remain active as long as any of the model probers are active.
        if (this._mLogicalProber.getState() == $8hFBI.notMe && this._mVisualProber.getState() == $8hFBI.notMe) return $8hFBI.notMe;
        return $8hFBI.detecting;
    };
    init();
}
$6ee088ff78e284cc$var$HebrewProber.prototype = new $2SPVp();
module.exports = $6ee088ff78e284cc$var$HebrewProber;

});

parcelRegister("cCGdf", function(module, exports) {

$parcel$export(module.exports, "KOI8R_CharToOrderMap", () => $9309c72df7d77687$export$88dcb70027a86560, (v) => $9309c72df7d77687$export$88dcb70027a86560 = v);
$parcel$export(module.exports, "win1251_CharToOrderMap", () => $9309c72df7d77687$export$d20df975e8856c3d, (v) => $9309c72df7d77687$export$d20df975e8856c3d = v);
$parcel$export(module.exports, "latin5_CharToOrderMap", () => $9309c72df7d77687$export$81b4b5a7cf8d6756, (v) => $9309c72df7d77687$export$81b4b5a7cf8d6756 = v);
$parcel$export(module.exports, "macCyrillic_CharToOrderMap", () => $9309c72df7d77687$export$a820b4325d3e1f2d, (v) => $9309c72df7d77687$export$a820b4325d3e1f2d = v);
$parcel$export(module.exports, "IBM855_CharToOrderMap", () => $9309c72df7d77687$export$8758d219bb239ca0, (v) => $9309c72df7d77687$export$8758d219bb239ca0 = v);
$parcel$export(module.exports, "IBM866_CharToOrderMap", () => $9309c72df7d77687$export$e84ee74ad8016a4a, (v) => $9309c72df7d77687$export$e84ee74ad8016a4a = v);
$parcel$export(module.exports, "RussianLangModel", () => $9309c72df7d77687$export$f49db918b1d5b4f9, (v) => $9309c72df7d77687$export$f49db918b1d5b4f9 = v);
$parcel$export(module.exports, "Koi8rModel", () => $9309c72df7d77687$export$b84bce1ff6268c5c, (v) => $9309c72df7d77687$export$b84bce1ff6268c5c = v);
$parcel$export(module.exports, "Win1251CyrillicModel", () => $9309c72df7d77687$export$c7293a7236b63c82, (v) => $9309c72df7d77687$export$c7293a7236b63c82 = v);
$parcel$export(module.exports, "Latin5CyrillicModel", () => $9309c72df7d77687$export$4b005c533d3dc484, (v) => $9309c72df7d77687$export$4b005c533d3dc484 = v);
$parcel$export(module.exports, "MacCyrillicModel", () => $9309c72df7d77687$export$bfb2e91f7984eb0b, (v) => $9309c72df7d77687$export$bfb2e91f7984eb0b = v);
$parcel$export(module.exports, "Ibm866Model", () => $9309c72df7d77687$export$9b9e945c05f76e27, (v) => $9309c72df7d77687$export$9b9e945c05f76e27 = v);
$parcel$export(module.exports, "Ibm855Model", () => $9309c72df7d77687$export$78f4c283daf72b56, (v) => $9309c72df7d77687$export$78f4c283daf72b56 = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // KOI8-R language model
// Character Mapping Table:
var $9309c72df7d77687$export$88dcb70027a86560;
var $9309c72df7d77687$export$d20df975e8856c3d;
var $9309c72df7d77687$export$81b4b5a7cf8d6756;
var $9309c72df7d77687$export$a820b4325d3e1f2d;
var $9309c72df7d77687$export$8758d219bb239ca0;
var $9309c72df7d77687$export$e84ee74ad8016a4a;
// Model Table:
// total sequences: 100%
// first 512 sequences: 97.6601%
// first 1024 sequences: 2.3389%
// rest  sequences:      0.1237%
// negative sequences:   0.0009%
var $9309c72df7d77687$export$f49db918b1d5b4f9;
var $9309c72df7d77687$export$b84bce1ff6268c5c;
var $9309c72df7d77687$export$c7293a7236b63c82;
var $9309c72df7d77687$export$4b005c533d3dc484;
var $9309c72df7d77687$export$bfb2e91f7984eb0b;
var $9309c72df7d77687$export$9b9e945c05f76e27;
var $9309c72df7d77687$export$78f4c283daf72b56;
$9309c72df7d77687$export$88dcb70027a86560 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    68,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    27,
    3,
    21,
    28,
    13,
    2,
    39,
    19,
    26,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    16,
    9,
    7,
    6,
    14,
    24,
    10,
    17,
    18,
    20,
    25,
    30,
    29,
    22,
    54,
    59,
    37,
    44,
    58,
    41,
    48,
    53,
    46,
    55,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    43,
    45,
    32,
    40,
    52,
    56,
    33,
    61,
    62,
    51,
    57,
    47,
    63,
    50,
    70 // f0
];
$9309c72df7d77687$export$d20df975e8856c3d = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    68,
    247,
    248,
    249,
    250,
    251,
    252,
    253,
    37,
    44,
    33,
    46,
    41,
    48,
    56,
    51,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    45,
    32,
    40,
    52,
    53,
    55,
    58,
    50,
    57,
    63,
    70,
    62,
    61,
    47,
    59,
    43,
    3,
    21,
    10,
    19,
    13,
    2,
    24,
    20,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    9,
    7,
    6,
    14,
    39,
    26,
    28,
    22,
    25,
    29,
    54,
    18,
    17,
    30,
    27,
    16
];
$9309c72df7d77687$export$81b4b5a7cf8d6756 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    37,
    44,
    33,
    46,
    41,
    48,
    56,
    51,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    45,
    32,
    40,
    52,
    53,
    55,
    58,
    50,
    57,
    63,
    70,
    62,
    61,
    47,
    59,
    43,
    3,
    21,
    10,
    19,
    13,
    2,
    24,
    20,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    9,
    7,
    6,
    14,
    39,
    26,
    28,
    22,
    25,
    29,
    54,
    18,
    17,
    30,
    27,
    16,
    239,
    68,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    251,
    252,
    255
];
$9309c72df7d77687$export$a820b4325d3e1f2d = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    37,
    44,
    33,
    46,
    41,
    48,
    56,
    51,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    45,
    32,
    40,
    52,
    53,
    55,
    58,
    50,
    57,
    63,
    70,
    62,
    61,
    47,
    59,
    43,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    251,
    252,
    68,
    16,
    3,
    21,
    10,
    19,
    13,
    2,
    24,
    20,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    9,
    7,
    6,
    14,
    39,
    26,
    28,
    22,
    25,
    29,
    54,
    18,
    17,
    30,
    27,
    255
];
$9309c72df7d77687$export$8758d219bb239ca0 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    191,
    192,
    193,
    194,
    68,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    27,
    59,
    54,
    70,
    3,
    37,
    21,
    44,
    28,
    58,
    13,
    41,
    2,
    48,
    39,
    53,
    19,
    46,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    26,
    55,
    4,
    42,
    225,
    226,
    227,
    228,
    23,
    60,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    11,
    36,
    236,
    237,
    238,
    239,
    240,
    241,
    242,
    243,
    8,
    49,
    12,
    38,
    5,
    31,
    1,
    34,
    15,
    244,
    245,
    246,
    247,
    35,
    16,
    248,
    43,
    9,
    45,
    7,
    32,
    6,
    40,
    14,
    52,
    24,
    56,
    10,
    33,
    17,
    61,
    249,
    250,
    18,
    62,
    20,
    51,
    25,
    57,
    30,
    47,
    29,
    63,
    22,
    50,
    251,
    252,
    255
];
$9309c72df7d77687$export$e84ee74ad8016a4a = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    142,
    143,
    144,
    145,
    146,
    147,
    148,
    149,
    150,
    151,
    152,
    74,
    153,
    75,
    154,
    155,
    156,
    157,
    158,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    253,
    253,
    253,
    253,
    253,
    253,
    71,
    172,
    66,
    173,
    65,
    174,
    76,
    175,
    64,
    176,
    177,
    77,
    72,
    178,
    69,
    67,
    179,
    78,
    73,
    180,
    181,
    79,
    182,
    183,
    184,
    185,
    253,
    253,
    253,
    253,
    253,
    37,
    44,
    33,
    46,
    41,
    48,
    56,
    51,
    42,
    60,
    36,
    49,
    38,
    31,
    34,
    35,
    45,
    32,
    40,
    52,
    53,
    55,
    58,
    50,
    57,
    63,
    70,
    62,
    61,
    47,
    59,
    43,
    3,
    21,
    10,
    19,
    13,
    2,
    24,
    20,
    4,
    23,
    11,
    8,
    12,
    5,
    1,
    15,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    237,
    238,
    9,
    7,
    6,
    14,
    39,
    26,
    28,
    22,
    25,
    29,
    54,
    18,
    17,
    30,
    27,
    16,
    239,
    68,
    240,
    241,
    242,
    243,
    244,
    245,
    246,
    247,
    248,
    249,
    250,
    251,
    252,
    255
];
$9309c72df7d77687$export$f49db918b1d5b4f9 = [
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    1,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    0,
    2,
    2,
    2,
    3,
    3,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    2,
    1,
    2,
    2,
    0,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    0,
    2,
    2,
    3,
    3,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    0,
    3,
    2,
    2,
    3,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    0,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    0,
    1,
    3,
    2,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    1,
    3,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    2,
    1,
    3,
    2,
    3,
    2,
    3,
    2,
    1,
    2,
    2,
    0,
    1,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    3,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    0,
    2,
    1,
    0,
    3,
    2,
    3,
    2,
    3,
    0,
    0,
    1,
    2,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    0,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    0,
    0,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    0,
    2,
    3,
    2,
    3,
    0,
    1,
    2,
    3,
    3,
    2,
    0,
    2,
    3,
    0,
    0,
    2,
    3,
    2,
    2,
    0,
    1,
    3,
    1,
    3,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    3,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    2,
    0,
    0,
    2,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    1,
    3,
    2,
    3,
    1,
    1,
    2,
    1,
    0,
    2,
    2,
    2,
    2,
    1,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    1,
    3,
    1,
    0,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    2,
    1,
    1,
    3,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    3,
    1,
    1,
    2,
    0,
    0,
    2,
    2,
    1,
    3,
    0,
    0,
    2,
    1,
    1,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    3,
    3,
    1,
    1,
    2,
    1,
    2,
    1,
    2,
    2,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    2,
    2,
    3,
    2,
    0,
    3,
    2,
    0,
    3,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    1,
    2,
    1,
    2,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    2,
    1,
    2,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    3,
    0,
    2,
    1,
    0,
    0,
    2,
    2,
    3,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    0,
    1,
    1,
    2,
    2,
    1,
    1,
    3,
    0,
    0,
    1,
    3,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    3,
    3,
    3,
    2,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    2,
    3,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    2,
    2,
    3,
    2,
    2,
    2,
    3,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    2,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    3,
    1,
    2,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    1,
    0,
    3,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    0,
    0,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    2,
    0,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    3,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    3,
    2,
    3,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    0,
    2,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    2,
    0,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    2,
    3,
    2,
    3,
    3,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    1,
    1,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    2,
    2,
    0,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    2,
    0,
    0,
    1,
    1,
    2,
    2,
    1,
    0,
    0,
    2,
    0,
    1,
    1,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    3,
    2,
    3,
    2,
    1,
    0,
    0,
    2,
    2,
    2,
    0,
    1,
    0,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    3,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    3,
    1,
    2,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    3,
    3,
    2,
    2,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    3,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    3,
    2,
    2,
    2,
    1,
    0,
    0,
    2,
    2,
    1,
    0,
    1,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    2,
    3,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    1,
    0,
    3,
    2,
    1,
    2,
    1,
    2,
    2,
    0,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    2,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    0,
    0,
    2,
    0,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    2,
    1,
    2,
    2,
    2,
    0,
    3,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    2,
    2,
    3,
    2,
    2,
    0,
    0,
    1,
    1,
    2,
    0,
    1,
    2,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    2,
    1,
    1,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    2,
    2,
    2,
    2,
    0,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0
];
$9309c72df7d77687$export$b84bce1ff6268c5c = {
    "charToOrderMap": $9309c72df7d77687$export$88dcb70027a86560,
    "precedenceMatrix": $9309c72df7d77687$export$f49db918b1d5b4f9,
    "mTypicalPositiveRatio": 0.976601,
    "keepEnglishLetter": false,
    "charsetName": "KOI8-R"
};
$9309c72df7d77687$export$c7293a7236b63c82 = {
    "charToOrderMap": $9309c72df7d77687$export$d20df975e8856c3d,
    "precedenceMatrix": $9309c72df7d77687$export$f49db918b1d5b4f9,
    "mTypicalPositiveRatio": 0.976601,
    "keepEnglishLetter": false,
    "charsetName": "windows-1251"
};
$9309c72df7d77687$export$4b005c533d3dc484 = {
    "charToOrderMap": $9309c72df7d77687$export$81b4b5a7cf8d6756,
    "precedenceMatrix": $9309c72df7d77687$export$f49db918b1d5b4f9,
    "mTypicalPositiveRatio": 0.976601,
    "keepEnglishLetter": false,
    "charsetName": "ISO-8859-5"
};
$9309c72df7d77687$export$bfb2e91f7984eb0b = {
    "charToOrderMap": $9309c72df7d77687$export$a820b4325d3e1f2d,
    "precedenceMatrix": $9309c72df7d77687$export$f49db918b1d5b4f9,
    "mTypicalPositiveRatio": 0.976601,
    "keepEnglishLetter": false,
    "charsetName": "MacCyrillic"
};
$9309c72df7d77687$export$9b9e945c05f76e27 = {
    "charToOrderMap": $9309c72df7d77687$export$e84ee74ad8016a4a,
    "precedenceMatrix": $9309c72df7d77687$export$f49db918b1d5b4f9,
    "mTypicalPositiveRatio": 0.976601,
    "keepEnglishLetter": false,
    "charsetName": "IBM866"
};
$9309c72df7d77687$export$78f4c283daf72b56 = {
    "charToOrderMap": $9309c72df7d77687$export$8758d219bb239ca0,
    "precedenceMatrix": $9309c72df7d77687$export$f49db918b1d5b4f9,
    "mTypicalPositiveRatio": 0.976601,
    "keepEnglishLetter": false,
    "charsetName": "IBM855"
};

});

parcelRegister("kvpUH", function(module, exports) {

$parcel$export(module.exports, "Latin7_CharToOrderMap", () => $eedacdc444dec377$export$f57628c1c88d3ab3, (v) => $eedacdc444dec377$export$f57628c1c88d3ab3 = v);
$parcel$export(module.exports, "win1253_CharToOrderMap", () => $eedacdc444dec377$export$f8242330aef644d4, (v) => $eedacdc444dec377$export$f8242330aef644d4 = v);
$parcel$export(module.exports, "GreekLangModel", () => $eedacdc444dec377$export$b8cec3d1228b57cb, (v) => $eedacdc444dec377$export$b8cec3d1228b57cb = v);
$parcel$export(module.exports, "Latin7GreekModel", () => $eedacdc444dec377$export$e36e47bfc868771b, (v) => $eedacdc444dec377$export$e36e47bfc868771b = v);
$parcel$export(module.exports, "Win1253GreekModel", () => $eedacdc444dec377$export$7834929f8104291b, (v) => $eedacdc444dec377$export$7834929f8104291b = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // 255: Control characters that usually does not exist in any text
// 254: Carriage/Return
// 253: symbol (punctuation) that does not belong to word
// 252: 0 - 9
// Character Mapping Table:
var $eedacdc444dec377$export$f57628c1c88d3ab3;
var $eedacdc444dec377$export$f8242330aef644d4;
// Model Table:
// total sequences: 100%
// first 512 sequences: 98.2851%
// first 1024 sequences:1.7001%
// rest  sequences:     0.0359%
// negative sequences:  0.0148%
var $eedacdc444dec377$export$b8cec3d1228b57cb;
var $eedacdc444dec377$export$e36e47bfc868771b;
var $eedacdc444dec377$export$7834929f8104291b;
$eedacdc444dec377$export$f57628c1c88d3ab3 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    82,
    100,
    104,
    94,
    98,
    101,
    116,
    102,
    111,
    187,
    117,
    92,
    88,
    113,
    85,
    79,
    118,
    105,
    83,
    67,
    114,
    119,
    95,
    99,
    109,
    188,
    253,
    253,
    253,
    253,
    253,
    253,
    72,
    70,
    80,
    81,
    60,
    96,
    93,
    89,
    68,
    120,
    97,
    77,
    86,
    69,
    55,
    78,
    115,
    65,
    66,
    58,
    76,
    106,
    103,
    87,
    107,
    112,
    253,
    253,
    253,
    253,
    253,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    233,
    90,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    74,
    253,
    253,
    253,
    253,
    253,
    253,
    247,
    248,
    61,
    36,
    46,
    71,
    73,
    253,
    54,
    253,
    108,
    123,
    110,
    31,
    51,
    43,
    41,
    34,
    91,
    40,
    52,
    47,
    44,
    53,
    38,
    49,
    59,
    39,
    35,
    48,
    250,
    37,
    33,
    45,
    56,
    50,
    84,
    57,
    120,
    121,
    17,
    18,
    22,
    15,
    124,
    1,
    29,
    20,
    21,
    3,
    32,
    13,
    25,
    5,
    11,
    16,
    10,
    6,
    30,
    4,
    9,
    8,
    14,
    7,
    2,
    12,
    28,
    23,
    42,
    24,
    64,
    75,
    19,
    26,
    27,
    253 // f0
];
$eedacdc444dec377$export$f8242330aef644d4 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    82,
    100,
    104,
    94,
    98,
    101,
    116,
    102,
    111,
    187,
    117,
    92,
    88,
    113,
    85,
    79,
    118,
    105,
    83,
    67,
    114,
    119,
    95,
    99,
    109,
    188,
    253,
    253,
    253,
    253,
    253,
    253,
    72,
    70,
    80,
    81,
    60,
    96,
    93,
    89,
    68,
    120,
    97,
    77,
    86,
    69,
    55,
    78,
    115,
    65,
    66,
    58,
    76,
    106,
    103,
    87,
    107,
    112,
    253,
    253,
    253,
    253,
    253,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    233,
    61,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    74,
    253,
    253,
    253,
    253,
    253,
    253,
    247,
    253,
    253,
    36,
    46,
    71,
    73,
    253,
    54,
    253,
    108,
    123,
    110,
    31,
    51,
    43,
    41,
    34,
    91,
    40,
    52,
    47,
    44,
    53,
    38,
    49,
    59,
    39,
    35,
    48,
    250,
    37,
    33,
    45,
    56,
    50,
    84,
    57,
    120,
    121,
    17,
    18,
    22,
    15,
    124,
    1,
    29,
    20,
    21,
    3,
    32,
    13,
    25,
    5,
    11,
    16,
    10,
    6,
    30,
    4,
    9,
    8,
    14,
    7,
    2,
    12,
    28,
    23,
    42,
    24,
    64,
    75,
    19,
    26,
    27,
    253 // f0
];
$eedacdc444dec377$export$b8cec3d1228b57cb = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    0,
    2,
    2,
    3,
    3,
    0,
    3,
    0,
    3,
    2,
    0,
    3,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    2,
    3,
    3,
    0,
    3,
    2,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    3,
    3,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    1,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    3,
    3,
    0,
    2,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    0,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    1,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    2,
    2,
    3,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    0,
    3,
    1,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    2,
    3,
    0,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    0,
    2,
    3,
    0,
    3,
    0,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    2,
    2,
    3,
    3,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    0,
    3,
    2,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    3,
    3,
    2,
    3,
    0,
    2,
    2,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    2,
    0,
    3,
    0,
    3,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    0,
    0,
    1,
    2,
    3,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    0,
    0,
    3,
    2,
    2,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    0,
    3,
    2,
    3,
    3,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    2,
    3,
    0,
    0,
    3,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    2,
    0,
    3,
    2,
    3,
    0,
    0,
    3,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    0,
    2,
    0,
    0,
    2,
    3,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    3,
    3,
    2,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    0,
    2,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    0,
    2,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    3,
    3,
    0,
    3,
    0,
    3,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    2,
    0,
    3,
    2,
    0,
    3,
    2,
    3,
    2,
    3,
    0,
    0,
    3,
    2,
    3,
    2,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    0,
    3,
    0,
    2,
    1,
    0,
    0,
    3,
    2,
    2,
    2,
    0,
    3,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    2,
    0,
    3,
    0,
    3,
    0,
    3,
    3,
    0,
    2,
    1,
    2,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    0,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    0,
    3,
    0,
    0,
    0,
    2,
    1,
    0,
    2,
    2,
    3,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    3,
    3,
    3,
    2,
    3,
    0,
    0,
    1,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    1,
    0,
    3,
    0,
    0,
    0,
    3,
    2,
    0,
    3,
    2,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    3,
    2,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    2,
    0,
    2,
    3,
    2,
    0,
    0,
    3,
    0,
    3,
    0,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    3,
    2,
    2,
    3,
    0,
    2,
    0,
    3,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    2,
    0,
    2,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    3,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    3,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    2,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    2,
    3,
    2,
    2,
    3,
    2,
    3,
    2,
    0,
    0,
    3,
    3,
    3,
    0,
    0,
    3,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    3,
    3,
    2,
    2,
    0,
    3,
    0,
    0,
    0,
    2,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    3,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    2,
    3,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    2,
    2,
    2,
    2,
    1,
    0,
    0,
    2,
    2,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    2,
    3,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    2,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    3,
    2,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    0,
    1,
    2,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    0,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    2,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    3,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    3,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    2,
    0,
    2,
    2,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    2,
    0,
    2,
    2,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    3,
    1,
    2,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    2,
    2,
    0,
    1,
    0,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    0,
    1,
    0,
    1,
    0,
    2,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    2,
    2,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
$eedacdc444dec377$export$e36e47bfc868771b = {
    "charToOrderMap": $eedacdc444dec377$export$f57628c1c88d3ab3,
    "precedenceMatrix": $eedacdc444dec377$export$b8cec3d1228b57cb,
    "mTypicalPositiveRatio": 0.982851,
    "keepEnglishLetter": false,
    "charsetName": "ISO-8859-7"
};
$eedacdc444dec377$export$7834929f8104291b = {
    "charToOrderMap": $eedacdc444dec377$export$f8242330aef644d4,
    "precedenceMatrix": $eedacdc444dec377$export$b8cec3d1228b57cb,
    "mTypicalPositiveRatio": 0.982851,
    "keepEnglishLetter": false,
    "charsetName": "windows-1253"
};

});

parcelRegister("3Q6nm", function(module, exports) {

$parcel$export(module.exports, "TIS620CharToOrderMap", () => $2cbb2c8019472d93$export$5889553fc26fff10, (v) => $2cbb2c8019472d93$export$5889553fc26fff10 = v);
$parcel$export(module.exports, "ThaiLangModel", () => $2cbb2c8019472d93$export$442d209575118b7e, (v) => $2cbb2c8019472d93$export$442d209575118b7e = v);
$parcel$export(module.exports, "TIS620ThaiModel", () => $2cbb2c8019472d93$export$e09746373364fe6, (v) => $2cbb2c8019472d93$export$e09746373364fe6 = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // 255: Control characters that usually does not exist in any text
// 254: Carriage/Return
// 253: symbol (punctuation) that does not belong to word
// 252: 0 - 9
// The following result for thai was collected from a limited sample (1M).
// Character Mapping Table:
var $2cbb2c8019472d93$export$5889553fc26fff10;
// Model Table:
// total sequences: 100%
// first 512 sequences: 92.6386%
// first 1024 sequences:7.3177%
// rest  sequences:     1.0230%
// negative sequences:  0.0436%
var $2cbb2c8019472d93$export$442d209575118b7e;
var $2cbb2c8019472d93$export$e09746373364fe6;
$2cbb2c8019472d93$export$5889553fc26fff10 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    182,
    106,
    107,
    100,
    183,
    184,
    185,
    101,
    94,
    186,
    187,
    108,
    109,
    110,
    111,
    188,
    189,
    190,
    89,
    95,
    112,
    113,
    191,
    192,
    193,
    194,
    253,
    253,
    253,
    253,
    253,
    253,
    64,
    72,
    73,
    114,
    74,
    115,
    116,
    102,
    81,
    201,
    117,
    90,
    103,
    78,
    82,
    96,
    202,
    91,
    79,
    84,
    104,
    105,
    97,
    98,
    92,
    203,
    253,
    253,
    253,
    253,
    253,
    209,
    210,
    211,
    212,
    213,
    88,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    118,
    221,
    222,
    223,
    224,
    99,
    85,
    83,
    225,
    226,
    227,
    228,
    229,
    230,
    231,
    232,
    233,
    234,
    235,
    236,
    5,
    30,
    237,
    24,
    238,
    75,
    8,
    26,
    52,
    34,
    51,
    119,
    47,
    58,
    57,
    49,
    53,
    55,
    43,
    20,
    19,
    44,
    14,
    48,
    3,
    17,
    25,
    39,
    62,
    31,
    54,
    45,
    9,
    16,
    2,
    61,
    15,
    239,
    12,
    42,
    46,
    18,
    21,
    76,
    4,
    66,
    63,
    22,
    10,
    1,
    36,
    23,
    13,
    40,
    27,
    32,
    35,
    86,
    240,
    241,
    242,
    243,
    244,
    11,
    28,
    41,
    29,
    33,
    245,
    50,
    37,
    6,
    7,
    67,
    77,
    38,
    93,
    246,
    247,
    68,
    56,
    59,
    65,
    69,
    60,
    70,
    80,
    71,
    87,
    248,
    249,
    250,
    251,
    252,
    253
];
$2cbb2c8019472d93$export$442d209575118b7e = [
    0,
    1,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    0,
    0,
    0,
    1,
    3,
    0,
    3,
    3,
    2,
    3,
    3,
    0,
    1,
    2,
    3,
    3,
    3,
    3,
    0,
    2,
    0,
    2,
    0,
    0,
    3,
    2,
    1,
    2,
    2,
    3,
    0,
    3,
    3,
    2,
    3,
    0,
    0,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    2,
    3,
    0,
    2,
    2,
    2,
    3,
    0,
    2,
    3,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    3,
    1,
    1,
    3,
    2,
    2,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    3,
    1,
    2,
    3,
    0,
    3,
    3,
    2,
    2,
    1,
    2,
    3,
    3,
    1,
    2,
    0,
    1,
    3,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    3,
    2,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    3,
    1,
    2,
    3,
    1,
    2,
    2,
    3,
    3,
    1,
    0,
    2,
    1,
    0,
    0,
    3,
    1,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    1,
    1,
    3,
    1,
    2,
    1,
    1,
    3,
    2,
    1,
    0,
    2,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    2,
    3,
    1,
    1,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    3,
    3,
    2,
    1,
    0,
    1,
    2,
    2,
    0,
    1,
    3,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    0,
    2,
    1,
    1,
    3,
    3,
    2,
    3,
    3,
    2,
    0,
    0,
    3,
    3,
    0,
    3,
    3,
    0,
    2,
    2,
    3,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    1,
    1,
    0,
    2,
    1,
    0,
    2,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    2,
    3,
    3,
    2,
    0,
    0,
    3,
    3,
    0,
    2,
    3,
    0,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    0,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    1,
    1,
    0,
    2,
    1,
    0,
    2,
    0,
    0,
    2,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    0,
    2,
    2,
    1,
    3,
    2,
    1,
    3,
    2,
    1,
    2,
    3,
    2,
    2,
    3,
    0,
    2,
    3,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    3,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    1,
    2,
    3,
    2,
    2,
    3,
    1,
    3,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    3,
    3,
    2,
    1,
    3,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    0,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    0,
    1,
    1,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    3,
    3,
    3,
    0,
    0,
    2,
    3,
    0,
    0,
    3,
    0,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    3,
    0,
    0,
    0,
    3,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    1,
    1,
    3,
    0,
    0,
    1,
    0,
    0,
    2,
    3,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    1,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    2,
    3,
    1,
    1,
    2,
    0,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    1,
    2,
    3,
    3,
    3,
    0,
    2,
    0,
    2,
    2,
    0,
    2,
    1,
    3,
    2,
    2,
    1,
    2,
    1,
    0,
    0,
    2,
    2,
    1,
    0,
    2,
    1,
    2,
    2,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    3,
    1,
    1,
    3,
    0,
    2,
    3,
    1,
    1,
    3,
    2,
    1,
    1,
    2,
    0,
    2,
    2,
    3,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    3,
    0,
    0,
    1,
    3,
    1,
    2,
    1,
    2,
    0,
    3,
    0,
    0,
    0,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    1,
    1,
    3,
    2,
    3,
    3,
    3,
    1,
    3,
    2,
    1,
    3,
    2,
    1,
    3,
    2,
    2,
    2,
    2,
    1,
    3,
    3,
    1,
    2,
    1,
    3,
    1,
    2,
    3,
    0,
    2,
    1,
    1,
    3,
    2,
    2,
    2,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    3,
    2,
    1,
    0,
    3,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    2,
    3,
    0,
    1,
    3,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    2,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    1,
    1,
    3,
    2,
    3,
    2,
    3,
    2,
    0,
    3,
    2,
    2,
    1,
    2,
    0,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    1,
    3,
    2,
    1,
    2,
    2,
    1,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    1,
    2,
    3,
    3,
    2,
    2,
    3,
    0,
    1,
    1,
    2,
    0,
    3,
    3,
    2,
    2,
    3,
    0,
    1,
    1,
    3,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    3,
    3,
    0,
    2,
    0,
    2,
    1,
    0,
    0,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    0,
    1,
    3,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    3,
    1,
    1,
    0,
    2,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    2,
    2,
    1,
    1,
    2,
    1,
    3,
    3,
    2,
    3,
    2,
    2,
    3,
    2,
    2,
    3,
    1,
    2,
    2,
    1,
    2,
    0,
    3,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    3,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    0,
    2,
    1,
    0,
    3,
    2,
    0,
    0,
    3,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    2,
    2,
    3,
    0,
    0,
    1,
    3,
    0,
    3,
    2,
    0,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    0,
    2,
    2,
    2,
    0,
    2,
    2,
    1,
    2,
    0,
    2,
    3,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    0,
    2,
    3,
    1,
    3,
    3,
    2,
    3,
    3,
    0,
    3,
    3,
    0,
    3,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    0,
    0,
    2,
    2,
    3,
    0,
    1,
    1,
    1,
    3,
    0,
    0,
    3,
    0,
    0,
    0,
    2,
    2,
    0,
    1,
    3,
    0,
    1,
    2,
    2,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    2,
    3,
    3,
    2,
    0,
    3,
    3,
    2,
    2,
    3,
    1,
    3,
    2,
    1,
    3,
    2,
    0,
    1,
    2,
    2,
    0,
    2,
    3,
    2,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    2,
    3,
    1,
    3,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    3,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    3,
    1,
    1,
    3,
    1,
    3,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    3,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    1,
    3,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    2,
    1,
    2,
    1,
    3,
    2,
    0,
    0,
    3,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    0,
    2,
    3,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    3,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    1,
    3,
    0,
    0,
    1,
    2,
    0,
    0,
    2,
    0,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    3,
    1,
    3,
    3,
    0,
    0,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    1,
    2,
    3,
    1,
    2,
    3,
    1,
    0,
    3,
    0,
    2,
    2,
    1,
    0,
    2,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    3,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    1,
    0,
    1,
    1,
    1,
    3,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    0,
    3,
    1,
    0,
    1,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    0,
    1,
    3,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    3,
    0,
    2,
    2,
    1,
    3,
    3,
    2,
    3,
    3,
    0,
    1,
    1,
    0,
    2,
    2,
    1,
    2,
    1,
    3,
    3,
    1,
    0,
    0,
    3,
    2,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    1,
    1,
    3,
    1,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    3,
    0,
    0,
    3,
    0,
    3,
    1,
    0,
    1,
    1,
    1,
    3,
    2,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    1,
    3,
    2,
    1,
    3,
    3,
    1,
    2,
    2,
    0,
    1,
    2,
    1,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    2,
    0,
    3,
    3,
    3,
    2,
    2,
    0,
    1,
    1,
    0,
    1,
    3,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    2,
    3,
    1,
    2,
    0,
    0,
    2,
    1,
    0,
    3,
    1,
    0,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    3,
    0,
    0,
    3,
    1,
    1,
    0,
    2,
    2,
    1,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    3,
    1,
    2,
    0,
    0,
    2,
    2,
    0,
    1,
    2,
    0,
    1,
    0,
    1,
    3,
    1,
    2,
    1,
    0,
    0,
    0,
    2,
    0,
    3,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    1,
    1,
    2,
    2,
    0,
    0,
    0,
    2,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    1,
    3,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    3,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    3,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    3,
    2,
    1,
    2,
    2,
    3,
    0,
    0,
    0,
    2,
    3,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    1,
    0,
    3,
    0,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    3,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    1,
    1,
    1,
    1,
    2,
    3,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    2,
    1,
    1,
    0,
    1,
    2,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    3,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    2,
    1,
    3,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    3,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
$2cbb2c8019472d93$export$e09746373364fe6 = {
    "charToOrderMap": $2cbb2c8019472d93$export$5889553fc26fff10,
    "precedenceMatrix": $2cbb2c8019472d93$export$442d209575118b7e,
    "mTypicalPositiveRatio": 0.926386,
    "keepEnglishLetter": false,
    "charsetName": "TIS-620"
};

});

parcelRegister("kJVTE", function(module, exports) {

$parcel$export(module.exports, "Latin2_HungarianCharToOrderMap", () => $f194eba8e8cfbe68$export$4e1416ad2e1a014a, (v) => $f194eba8e8cfbe68$export$4e1416ad2e1a014a = v);
$parcel$export(module.exports, "win1250HungarianCharToOrderMap", () => $f194eba8e8cfbe68$export$c37d41bf66a41ff, (v) => $f194eba8e8cfbe68$export$c37d41bf66a41ff = v);
$parcel$export(module.exports, "HungarianLangModel", () => $f194eba8e8cfbe68$export$d282f556471f5e7, (v) => $f194eba8e8cfbe68$export$d282f556471f5e7 = v);
$parcel$export(module.exports, "Latin2HungarianModel", () => $f194eba8e8cfbe68$export$c7cd9ccb2be5aad2, (v) => $f194eba8e8cfbe68$export$c7cd9ccb2be5aad2 = v);
$parcel$export(module.exports, "Win1250HungarianModel", () => $f194eba8e8cfbe68$export$12bbbb527d3a68cd, (v) => $f194eba8e8cfbe68$export$12bbbb527d3a68cd = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // 255: Control characters that usually does not exist in any text
// 254: Carriage/Return
// 253: symbol (punctuation) that does not belong to word
// 252: 0 - 9
// Character Mapping Table:
var $f194eba8e8cfbe68$export$4e1416ad2e1a014a;
var $f194eba8e8cfbe68$export$c37d41bf66a41ff;
// Model Table:
// total sequences: 100%
// first 512 sequences: 94.7368%
// first 1024 sequences:5.2623%
// rest  sequences:     0.8894%
// negative sequences:  0.0009%
var $f194eba8e8cfbe68$export$d282f556471f5e7;
var $f194eba8e8cfbe68$export$c7cd9ccb2be5aad2;
var $f194eba8e8cfbe68$export$12bbbb527d3a68cd;
$f194eba8e8cfbe68$export$4e1416ad2e1a014a = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    28,
    40,
    54,
    45,
    32,
    50,
    49,
    38,
    39,
    53,
    36,
    41,
    34,
    35,
    47,
    46,
    71,
    43,
    33,
    37,
    57,
    48,
    64,
    68,
    55,
    52,
    253,
    253,
    253,
    253,
    253,
    253,
    2,
    18,
    26,
    17,
    1,
    27,
    12,
    20,
    9,
    22,
    7,
    6,
    13,
    4,
    8,
    23,
    67,
    10,
    5,
    3,
    21,
    19,
    65,
    62,
    16,
    11,
    253,
    253,
    253,
    253,
    253,
    159,
    160,
    161,
    162,
    163,
    164,
    165,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    181,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    75,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    79,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    51,
    81,
    222,
    78,
    223,
    224,
    225,
    226,
    44,
    227,
    228,
    229,
    61,
    230,
    231,
    232,
    233,
    234,
    58,
    235,
    66,
    59,
    236,
    237,
    238,
    60,
    69,
    63,
    239,
    240,
    241,
    82,
    14,
    74,
    242,
    70,
    80,
    243,
    72,
    244,
    15,
    83,
    77,
    84,
    30,
    76,
    85,
    245,
    246,
    247,
    25,
    73,
    42,
    24,
    248,
    249,
    250,
    31,
    56,
    29,
    251,
    252,
    253
];
$f194eba8e8cfbe68$export$c37d41bf66a41ff = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    28,
    40,
    54,
    45,
    32,
    50,
    49,
    38,
    39,
    53,
    36,
    41,
    34,
    35,
    47,
    46,
    72,
    43,
    33,
    37,
    57,
    48,
    64,
    68,
    55,
    52,
    253,
    253,
    253,
    253,
    253,
    253,
    2,
    18,
    26,
    17,
    1,
    27,
    12,
    20,
    9,
    22,
    7,
    6,
    13,
    4,
    8,
    23,
    67,
    10,
    5,
    3,
    21,
    19,
    65,
    62,
    16,
    11,
    253,
    253,
    253,
    253,
    253,
    161,
    162,
    163,
    164,
    165,
    166,
    167,
    168,
    169,
    170,
    171,
    172,
    173,
    174,
    175,
    176,
    177,
    178,
    179,
    180,
    78,
    181,
    69,
    182,
    183,
    184,
    185,
    186,
    187,
    188,
    189,
    190,
    191,
    192,
    193,
    194,
    195,
    196,
    197,
    76,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    81,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    51,
    83,
    222,
    80,
    223,
    224,
    225,
    226,
    44,
    227,
    228,
    229,
    61,
    230,
    231,
    232,
    233,
    234,
    58,
    235,
    66,
    59,
    236,
    237,
    238,
    60,
    70,
    63,
    239,
    240,
    241,
    84,
    14,
    75,
    242,
    71,
    82,
    243,
    73,
    244,
    15,
    85,
    79,
    86,
    30,
    77,
    87,
    245,
    246,
    247,
    25,
    74,
    42,
    24,
    248,
    249,
    250,
    31,
    56,
    29,
    251,
    252,
    253
];
$f194eba8e8cfbe68$export$d282f556471f5e7 = [
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    1,
    3,
    3,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    3,
    2,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    3,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    2,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    2,
    2,
    0,
    3,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    3,
    2,
    0,
    3,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    3,
    1,
    2,
    3,
    3,
    2,
    2,
    0,
    3,
    3,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    3,
    3,
    2,
    1,
    3,
    2,
    2,
    3,
    2,
    1,
    3,
    2,
    2,
    1,
    0,
    3,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    1,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    1,
    1,
    3,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    1,
    3,
    3,
    3,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    0,
    3,
    2,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    1,
    3,
    2,
    2,
    2,
    3,
    1,
    1,
    3,
    3,
    1,
    1,
    0,
    3,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    1,
    3,
    3,
    2,
    2,
    1,
    3,
    3,
    3,
    1,
    1,
    3,
    1,
    2,
    3,
    2,
    3,
    2,
    2,
    2,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    1,
    2,
    1,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    1,
    0,
    3,
    2,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    1,
    1,
    0,
    3,
    3,
    3,
    3,
    0,
    2,
    3,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    3,
    0,
    1,
    2,
    3,
    2,
    3,
    2,
    2,
    3,
    2,
    1,
    2,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    3,
    2,
    1,
    2,
    3,
    3,
    2,
    2,
    2,
    3,
    2,
    3,
    3,
    1,
    3,
    3,
    1,
    1,
    0,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    1,
    1,
    1,
    3,
    3,
    1,
    1,
    3,
    1,
    1,
    3,
    2,
    1,
    2,
    3,
    1,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    1,
    2,
    1,
    1,
    3,
    3,
    1,
    1,
    1,
    1,
    3,
    3,
    1,
    1,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    1,
    1,
    2,
    1,
    1,
    3,
    3,
    1,
    0,
    1,
    1,
    3,
    3,
    2,
    0,
    1,
    1,
    2,
    3,
    1,
    0,
    2,
    2,
    1,
    0,
    0,
    1,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    2,
    3,
    3,
    2,
    1,
    1,
    3,
    2,
    3,
    2,
    1,
    2,
    2,
    0,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    3,
    1,
    2,
    2,
    1,
    1,
    3,
    3,
    0,
    3,
    2,
    1,
    2,
    3,
    2,
    1,
    3,
    3,
    1,
    1,
    0,
    2,
    1,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    2,
    2,
    2,
    3,
    2,
    3,
    3,
    3,
    2,
    1,
    1,
    3,
    3,
    1,
    1,
    1,
    2,
    2,
    3,
    2,
    3,
    2,
    2,
    2,
    1,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    3,
    2,
    3,
    0,
    0,
    0,
    2,
    3,
    3,
    1,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    3,
    3,
    2,
    2,
    1,
    1,
    0,
    3,
    3,
    2,
    2,
    1,
    2,
    2,
    1,
    0,
    2,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    2,
    2,
    1,
    3,
    1,
    2,
    3,
    3,
    2,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    3,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    0,
    1,
    1,
    3,
    3,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    0,
    3,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    0,
    1,
    2,
    3,
    1,
    2,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    0,
    2,
    0,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    2,
    3,
    2,
    3,
    3,
    0,
    1,
    2,
    2,
    3,
    1,
    0,
    1,
    0,
    2,
    1,
    2,
    2,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    2,
    2,
    1,
    0,
    0,
    3,
    2,
    3,
    2,
    0,
    0,
    0,
    1,
    1,
    3,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    2,
    2,
    3,
    3,
    1,
    0,
    1,
    3,
    2,
    3,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    1,
    2,
    2,
    2,
    1,
    0,
    1,
    2,
    3,
    3,
    2,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    3,
    2,
    2,
    1,
    0,
    0,
    1,
    1,
    2,
    2,
    0,
    3,
    0,
    1,
    2,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    3,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    3,
    3,
    0,
    1,
    0,
    0,
    0,
    3,
    3,
    1,
    0,
    0,
    1,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    3,
    3,
    0,
    1,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    0,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    3,
    2,
    2,
    0,
    1,
    0,
    1,
    0,
    2,
    3,
    2,
    0,
    0,
    1,
    2,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    2,
    2,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    1,
    2,
    0,
    0,
    2,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    3,
    0,
    0,
    0,
    1,
    0,
    3,
    2,
    1,
    0,
    0,
    1,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    3,
    0,
    0,
    2,
    1,
    2,
    2,
    1,
    0,
    0,
    2,
    1,
    2,
    2,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    3,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    3,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    3,
    1,
    1,
    2,
    2,
    2,
    3,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    0,
    1,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    2,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    2,
    3,
    2,
    1,
    0,
    0,
    2,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    1,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    2,
    0,
    1,
    1,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    3,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    2,
    1,
    0,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    3,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    2,
    0,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    2,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    1,
    2,
    0,
    0,
    0,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    2,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    2,
    0,
    1,
    1,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    1,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    0,
    0,
    3,
    1,
    0,
    2,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    2,
    1,
    0,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    2,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
$f194eba8e8cfbe68$export$c7cd9ccb2be5aad2 = {
    "charToOrderMap": $f194eba8e8cfbe68$export$4e1416ad2e1a014a,
    "precedenceMatrix": $f194eba8e8cfbe68$export$d282f556471f5e7,
    "mTypicalPositiveRatio": 0.947368,
    "keepEnglishLetter": true,
    "charsetName": "ISO-8859-2"
};
$f194eba8e8cfbe68$export$12bbbb527d3a68cd = {
    "charToOrderMap": $f194eba8e8cfbe68$export$c37d41bf66a41ff,
    "precedenceMatrix": $f194eba8e8cfbe68$export$d282f556471f5e7,
    "mTypicalPositiveRatio": 0.947368,
    "keepEnglishLetter": true,
    "charsetName": "windows-1250"
};

});

parcelRegister("bhZUU", function(module, exports) {

$parcel$export(module.exports, "Latin5_BulgarianCharToOrderMap", () => $83814fa3f4565e1a$export$2a9d60a045c22202, (v) => $83814fa3f4565e1a$export$2a9d60a045c22202 = v);
$parcel$export(module.exports, "win1251BulgarianCharToOrderMap", () => $83814fa3f4565e1a$export$bc68f1f337ce1b29, (v) => $83814fa3f4565e1a$export$bc68f1f337ce1b29 = v);
$parcel$export(module.exports, "BulgarianLangModel", () => $83814fa3f4565e1a$export$87d0a403fe0868d8, (v) => $83814fa3f4565e1a$export$87d0a403fe0868d8 = v);
$parcel$export(module.exports, "Latin5BulgarianModel", () => $83814fa3f4565e1a$export$b80d5fc5528828e6, (v) => $83814fa3f4565e1a$export$b80d5fc5528828e6 = v);
$parcel$export(module.exports, "Win1251BulgarianModel", () => $83814fa3f4565e1a$export$47fcaa04f5e83da0, (v) => $83814fa3f4565e1a$export$47fcaa04f5e83da0 = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ // 255: Control characters that usually does not exist in any text
// 254: Carriage/Return
// 253: symbol (punctuation) that does not belong to word
// 252: 0 - 9
// Character Mapping Table:
// this table is modified base on win1251BulgarianCharToOrderMap, so
// only number <64 is sure valid
var $83814fa3f4565e1a$export$2a9d60a045c22202;
var $83814fa3f4565e1a$export$bc68f1f337ce1b29;
// Model Table:
// total sequences: 100%
// first 512 sequences: 96.9392%
// first 1024 sequences:3.0618%
// rest  sequences:     0.2992%
// negative sequences:  0.0020%
var $83814fa3f4565e1a$export$87d0a403fe0868d8;
var $83814fa3f4565e1a$export$b80d5fc5528828e6;
var $83814fa3f4565e1a$export$47fcaa04f5e83da0;
$83814fa3f4565e1a$export$2a9d60a045c22202 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    77,
    90,
    99,
    100,
    72,
    109,
    107,
    101,
    79,
    185,
    81,
    102,
    76,
    94,
    82,
    110,
    186,
    108,
    91,
    74,
    119,
    84,
    96,
    111,
    187,
    115,
    253,
    253,
    253,
    253,
    253,
    253,
    65,
    69,
    70,
    66,
    63,
    68,
    112,
    103,
    92,
    194,
    104,
    95,
    86,
    87,
    71,
    116,
    195,
    85,
    93,
    97,
    113,
    196,
    197,
    198,
    199,
    200,
    253,
    253,
    253,
    253,
    253,
    194,
    195,
    196,
    197,
    198,
    199,
    200,
    201,
    202,
    203,
    204,
    205,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    222,
    223,
    224,
    225,
    81,
    226,
    227,
    228,
    229,
    230,
    105,
    231,
    232,
    233,
    234,
    235,
    236,
    45,
    237,
    238,
    31,
    32,
    35,
    43,
    37,
    44,
    55,
    47,
    40,
    59,
    33,
    46,
    38,
    36,
    41,
    30,
    39,
    28,
    34,
    51,
    48,
    49,
    53,
    50,
    54,
    57,
    61,
    239,
    67,
    240,
    60,
    56,
    1,
    18,
    9,
    20,
    11,
    3,
    23,
    15,
    2,
    26,
    12,
    10,
    14,
    6,
    4,
    13,
    7,
    8,
    5,
    19,
    29,
    25,
    22,
    21,
    27,
    24,
    17,
    75,
    52,
    241,
    42,
    16,
    62,
    242,
    243,
    244,
    58,
    245,
    98,
    246,
    247,
    248,
    249,
    250,
    251,
    91,
    252,
    253 // f0
];
$83814fa3f4565e1a$export$bc68f1f337ce1b29 = [
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    254,
    255,
    255,
    254,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    255,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    252,
    253,
    253,
    253,
    253,
    253,
    253,
    253,
    77,
    90,
    99,
    100,
    72,
    109,
    107,
    101,
    79,
    185,
    81,
    102,
    76,
    94,
    82,
    110,
    186,
    108,
    91,
    74,
    119,
    84,
    96,
    111,
    187,
    115,
    253,
    253,
    253,
    253,
    253,
    253,
    65,
    69,
    70,
    66,
    63,
    68,
    112,
    103,
    92,
    194,
    104,
    95,
    86,
    87,
    71,
    116,
    195,
    85,
    93,
    97,
    113,
    196,
    197,
    198,
    199,
    200,
    253,
    253,
    253,
    253,
    253,
    206,
    207,
    208,
    209,
    210,
    211,
    212,
    213,
    120,
    214,
    215,
    216,
    217,
    218,
    219,
    220,
    221,
    78,
    64,
    83,
    121,
    98,
    117,
    105,
    222,
    223,
    224,
    225,
    226,
    227,
    228,
    229,
    88,
    230,
    231,
    232,
    233,
    122,
    89,
    106,
    234,
    235,
    236,
    237,
    238,
    45,
    239,
    240,
    73,
    80,
    118,
    114,
    241,
    242,
    243,
    244,
    245,
    62,
    58,
    246,
    247,
    248,
    249,
    250,
    31,
    32,
    35,
    43,
    37,
    44,
    55,
    47,
    40,
    59,
    33,
    46,
    38,
    36,
    41,
    30,
    39,
    28,
    34,
    51,
    48,
    49,
    53,
    50,
    54,
    57,
    61,
    251,
    67,
    252,
    60,
    56,
    1,
    18,
    9,
    20,
    11,
    3,
    23,
    15,
    2,
    26,
    12,
    10,
    14,
    6,
    4,
    13,
    7,
    8,
    5,
    19,
    29,
    25,
    22,
    21,
    27,
    24,
    17,
    75,
    52,
    253,
    42,
    16 // f0
];
$83814fa3f4565e1a$export$87d0a403fe0868d8 = [
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    2,
    1,
    2,
    2,
    3,
    1,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    1,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    1,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    2,
    3,
    3,
    1,
    1,
    2,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    2,
    1,
    2,
    0,
    2,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    3,
    0,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    2,
    3,
    3,
    3,
    1,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    2,
    2,
    3,
    3,
    3,
    1,
    2,
    2,
    3,
    2,
    1,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    1,
    2,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    1,
    2,
    0,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    2,
    2,
    1,
    3,
    1,
    3,
    2,
    2,
    3,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    3,
    2,
    2,
    3,
    1,
    2,
    1,
    1,
    1,
    2,
    3,
    1,
    3,
    1,
    2,
    2,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    1,
    3,
    2,
    2,
    3,
    3,
    1,
    2,
    3,
    1,
    1,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    2,
    3,
    3,
    3,
    2,
    2,
    1,
    1,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    0,
    1,
    2,
    1,
    3,
    3,
    2,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    1,
    0,
    3,
    1,
    2,
    1,
    2,
    1,
    2,
    3,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    0,
    3,
    1,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    1,
    2,
    1,
    3,
    3,
    0,
    3,
    1,
    1,
    1,
    1,
    3,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    3,
    1,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    3,
    2,
    2,
    3,
    2,
    1,
    1,
    1,
    1,
    1,
    3,
    1,
    3,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    2,
    3,
    2,
    0,
    3,
    2,
    0,
    3,
    0,
    2,
    0,
    0,
    2,
    1,
    3,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    1,
    1,
    2,
    1,
    3,
    2,
    1,
    1,
    0,
    1,
    2,
    3,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    2,
    2,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    2,
    1,
    0,
    3,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    2,
    3,
    2,
    3,
    3,
    1,
    3,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    2,
    1,
    3,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    1,
    1,
    2,
    2,
    3,
    3,
    2,
    3,
    2,
    2,
    2,
    3,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    2,
    2,
    0,
    1,
    1,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    1,
    3,
    1,
    0,
    2,
    2,
    1,
    3,
    2,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    2,
    0,
    2,
    3,
    1,
    2,
    3,
    2,
    0,
    1,
    3,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    1,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    3,
    3,
    3,
    3,
    3,
    2,
    1,
    2,
    2,
    1,
    2,
    0,
    2,
    0,
    1,
    0,
    1,
    2,
    1,
    2,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    3,
    3,
    2,
    3,
    3,
    1,
    1,
    3,
    1,
    0,
    3,
    2,
    1,
    0,
    0,
    0,
    1,
    2,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    3,
    1,
    0,
    1,
    0,
    2,
    3,
    2,
    2,
    2,
    3,
    2,
    2,
    2,
    2,
    2,
    1,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    3,
    2,
    3,
    3,
    0,
    0,
    2,
    1,
    0,
    2,
    1,
    0,
    0,
    0,
    0,
    2,
    3,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    1,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    2,
    0,
    0,
    3,
    3,
    2,
    2,
    3,
    0,
    2,
    3,
    1,
    1,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    2,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    3,
    2,
    3,
    3,
    0,
    0,
    3,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    2,
    2,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    1,
    0,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    0,
    2,
    0,
    1,
    0,
    1,
    0,
    0,
    2,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    1,
    0,
    2,
    0,
    1,
    0,
    2,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    0,
    2,
    2,
    0,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    1,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    2,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    2,
    3,
    3,
    3,
    3,
    0,
    2,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    2,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    3,
    3,
    2,
    2,
    3,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    3,
    1,
    0,
    1,
    0,
    2,
    2,
    2,
    2,
    3,
    2,
    1,
    1,
    1,
    2,
    3,
    0,
    0,
    1,
    0,
    2,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    0,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    2,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    0,
    3,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    0,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    2,
    3,
    2,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    3,
    2,
    0,
    1,
    2,
    0,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    2,
    1,
    2,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    2,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    1,
    1,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    2,
    1,
    1,
    1,
    0,
    2,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    3,
    2,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    2,
    3,
    1,
    2,
    1,
    0,
    1,
    1,
    0,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    2,
    1,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    0,
    0,
    2,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    2,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    3,
    2,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    2,
    2,
    2,
    1,
    2,
    1,
    2,
    2,
    1,
    1,
    2,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    3,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    1,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    1,
    2,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    2,
    2,
    2,
    2,
    0,
    1,
    1,
    0,
    2,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    0,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    2,
    1,
    1,
    1,
    1,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    1,
    2,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    0,
    1,
    0,
    2,
    0,
    0,
    2,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    0,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    1,
    0,
    1,
    1,
    0,
    0,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    1,
    1,
    0,
    1,
    1,
    1,
    1,
    1,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1
];
$83814fa3f4565e1a$export$b80d5fc5528828e6 = {
    "charToOrderMap": $83814fa3f4565e1a$export$2a9d60a045c22202,
    "precedenceMatrix": $83814fa3f4565e1a$export$87d0a403fe0868d8,
    "mTypicalPositiveRatio": 0.969392,
    "keepEnglishLetter": false,
    "charsetName": "ISO-8859-5"
};
$83814fa3f4565e1a$export$47fcaa04f5e83da0 = {
    "charToOrderMap": $83814fa3f4565e1a$export$bc68f1f337ce1b29,
    "precedenceMatrix": $83814fa3f4565e1a$export$87d0a403fe0868d8,
    "mTypicalPositiveRatio": 0.969392,
    "keepEnglishLetter": false,
    "charsetName": "windows-1251"
};

});


parcelRegister("3K5jA", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $2SPVp = parcelRequire("2SPVp");

var $8hFBI = parcelRequire("8hFBI");
var $2b99ca67b90450d7$var$UDF = 0; // undefined
var $2b99ca67b90450d7$var$OTH = 1; // other
var $2b99ca67b90450d7$var$ASC = 2; // ascii capital letter
var $2b99ca67b90450d7$var$ASS = 3; // ascii small letter
var $2b99ca67b90450d7$var$ACV = 4; // accent capital vowel
var $2b99ca67b90450d7$var$ACO = 5; // accent capital other
var $2b99ca67b90450d7$var$ASV = 6; // accent small vowel
var $2b99ca67b90450d7$var$ASO = 7; // accent small other
var $2b99ca67b90450d7$var$Latin1_CharToClass = [
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$ASC,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$ASS,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$UDF,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$UDF,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$UDF,
    $2b99ca67b90450d7$var$UDF,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$UDF,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACV,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$ACO,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$OTH,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASV,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$ASO,
    $2b99ca67b90450d7$var$ASO // F8 - FF
];
// 0 : illegal
// 1 : very unlikely
// 2 : normal
// 3 : very likely
var $2b99ca67b90450d7$var$Latin1ClassModel = [
    // UDF OTH ASC ASS ACV ACO ASV ASO
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    3,
    3,
    1,
    1,
    3,
    3,
    0,
    3,
    3,
    3,
    1,
    2,
    1,
    2,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    0,
    3,
    1,
    3,
    1,
    1,
    1,
    3,
    0,
    3,
    1,
    3,
    1,
    1,
    3,
    3 // ASO
];
function $2b99ca67b90450d7$var$Latin1Prober() {
    $2SPVp.apply(this);
    var FREQ_CAT_NUM = 4;
    var CLASS_NUM = 8; // total classes
    var self = this;
    function init() {
        self.reset();
    }
    this.reset = function() {
        this._mLastCharClass = $2b99ca67b90450d7$var$OTH;
        this._mFreqCounter = [];
        for(var i = 0; i < FREQ_CAT_NUM; this._mFreqCounter[i++] = 0);
        $2b99ca67b90450d7$var$Latin1Prober.prototype.reset.apply(this);
    };
    this.getCharsetName = function() {
        return "windows-1252";
    };
    this.feed = function(aBuf) {
        aBuf = this.filterWithEnglishLetters(aBuf);
        for(var i = 0; i < aBuf.length; i++){
            var c = aBuf.charCodeAt(i);
            var charClass = $2b99ca67b90450d7$var$Latin1_CharToClass[c];
            var freq = $2b99ca67b90450d7$var$Latin1ClassModel[this._mLastCharClass * CLASS_NUM + charClass];
            if (freq == 0) {
                this._mState = $8hFBI.notMe;
                break;
            }
            this._mFreqCounter[freq]++;
            this._mLastCharClass = charClass;
        }
        return this.getState();
    };
    this.getConfidence = function() {
        var confidence;
        var constants;
        if (this.getState() == $8hFBI.notMe) return 0.01;
        var total = 0;
        for(var i = 0; i < this._mFreqCounter.length; i++)total += this._mFreqCounter[i];
        if (total < 0.01) constants = 0.0;
        else confidence = this._mFreqCounter[3] / total - this._mFreqCounter[1] * 20 / total;
        if (confidence < 0) confidence = 0.0;
        // lower the confidence of latin1 so that other more accurate detector
        // can take priority.
        //
        // antonio.afonso: need to change this otherwise languages like pt, es, fr using latin1 will never be detected.
        confidence = confidence * 0.95;
        return confidence;
    };
    init();
}
$2b99ca67b90450d7$var$Latin1Prober.prototype = new $2SPVp();
module.exports = $2b99ca67b90450d7$var$Latin1Prober;

});

parcelRegister("hMYxR", function(module, exports) {
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ 
var $2SPVp = parcelRequire("2SPVp");

var $3xI8B = parcelRequire("3xI8B");

var $ksuWo = parcelRequire("ksuWo");

var $8hFBI = parcelRequire("8hFBI");
function $cf35e2590e89a9f4$var$EscCharSetProber() {
    $2SPVp.apply(this);
    var self = this;
    function init() {
        self._mCodingSM = [
            new $3xI8B($ksuWo.HZSMModel),
            new $3xI8B($ksuWo.ISO2022CNSMModel),
            new $3xI8B($ksuWo.ISO2022JPSMModel),
            new $3xI8B($ksuWo.ISO2022KRSMModel)
        ];
        self.reset();
    }
    this.reset = function() {
        $cf35e2590e89a9f4$var$EscCharSetProber.prototype.reset.apply(this);
        for(var i = 0, codingSM; codingSM = this._mCodingSM[i]; i++){
            if (!codingSM) continue;
            codingSM.active = true;
            codingSM.reset();
        }
        this._mActiveSM = self._mCodingSM.length;
        this._mDetectedCharset = null;
    };
    this.getCharsetName = function() {
        return this._mDetectedCharset;
    };
    this.getConfidence = function() {
        if (this._mDetectedCharset) return 0.99;
        else return 0.00;
    };
    this.feed = function(aBuf) {
        for(var i = 0, c; i < aBuf.length; i++){
            c = aBuf[i];
            for(var j = 0, codingSM; codingSM = this._mCodingSM[j]; j++){
                if (!codingSM || !codingSM.active) continue;
                var codingState = codingSM.nextState(c);
                if (codingState == $8hFBI.error) {
                    codingSM.active = false;
                    this._mActiveSM--;
                    if (this._mActiveSM <= 0) {
                        this._mState = $8hFBI.notMe;
                        return this.getState();
                    }
                } else if (codingState == $8hFBI.itsMe) {
                    this._mState = $8hFBI.foundIt;
                    this._mDetectedCharset = codingSM.getCodingStateMachine();
                    return this.getState();
                }
            }
        }
        return this.getState();
    };
    init();
}
$cf35e2590e89a9f4$var$EscCharSetProber.prototype = new $2SPVp();
module.exports = $cf35e2590e89a9f4$var$EscCharSetProber;

});
parcelRegister("ksuWo", function(module, exports) {

$parcel$export(module.exports, "HZSMModel", () => $ee4e6c65b4561a9c$export$e272e0defc4b71d, (v) => $ee4e6c65b4561a9c$export$e272e0defc4b71d = v);
$parcel$export(module.exports, "ISO2022CNSMModel", () => $ee4e6c65b4561a9c$export$7cbfb45c403631c2, (v) => $ee4e6c65b4561a9c$export$7cbfb45c403631c2 = v);
$parcel$export(module.exports, "ISO2022JPSMModel", () => $ee4e6c65b4561a9c$export$15afc959de738330, (v) => $ee4e6c65b4561a9c$export$15afc959de738330 = v);
$parcel$export(module.exports, "ISO2022KRSMModel", () => $ee4e6c65b4561a9c$export$e429e2148fc710ce, (v) => $ee4e6c65b4561a9c$export$e429e2148fc710ce = v);
/*
 * The Original Code is Mozilla Universal charset detector code.
 *
 * The Initial Developer of the Original Code is
 * Netscape Communications Corporation.
 * Portions created by the Initial Developer are Copyright (C) 2001
 * the Initial Developer. All Rights Reserved.
 *
 * Contributor(s):
 *   António Afonso (antonio.afonso gmail.com) - port to JavaScript
 *   Mark Pilgrim - port to Python
 *   Shy Shalom - original C code
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2.1 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin St, Fifth Floor, Boston, MA
 * 02110-1301  USA
 */ var $ee4e6c65b4561a9c$export$e272e0defc4b71d;
var $ee4e6c65b4561a9c$export$7cbfb45c403631c2;
var $ee4e6c65b4561a9c$export$15afc959de738330;
var $ee4e6c65b4561a9c$export$e429e2148fc710ce;

var $8hFBI = parcelRequire("8hFBI");
var $ee4e6c65b4561a9c$var$HZ_cls = [
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    0,
    5,
    2,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1 // f8 - ff
];
var $ee4e6c65b4561a9c$var$HZ_st = [
    $8hFBI.start,
    $8hFBI.error,
    3,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    4,
    $8hFBI.error,
    5,
    $8hFBI.error,
    6,
    $8hFBI.error,
    5,
    5,
    4,
    $8hFBI.error,
    4,
    $8hFBI.error,
    4,
    4,
    4,
    $8hFBI.error,
    4,
    $8hFBI.error,
    4,
    $8hFBI.itsMe,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start // 28-2f
];
var $ee4e6c65b4561a9c$var$HZCharLenTable = [
    0,
    0,
    0,
    0,
    0,
    0
];
$ee4e6c65b4561a9c$export$e272e0defc4b71d = {
    "classTable": $ee4e6c65b4561a9c$var$HZ_cls,
    "classFactor": 6,
    "stateTable": $ee4e6c65b4561a9c$var$HZ_st,
    "charLenTable": $ee4e6c65b4561a9c$var$HZCharLenTable,
    "name": "HZ-GB-2312"
};
var $ee4e6c65b4561a9c$var$ISO2022CN_cls = [
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2 // f8 - ff
];
var $ee4e6c65b4561a9c$var$ISO2022CN_st = [
    $8hFBI.start,
    3,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    4,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    5,
    6,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.start // 38-3f
];
var $ee4e6c65b4561a9c$var$ISO2022CNCharLenTable = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
$ee4e6c65b4561a9c$export$7cbfb45c403631c2 = {
    "classTable": $ee4e6c65b4561a9c$var$ISO2022CN_cls,
    "classFactor": 9,
    "stateTable": $ee4e6c65b4561a9c$var$ISO2022CN_st,
    "charLenTable": $ee4e6c65b4561a9c$var$ISO2022CNCharLenTable,
    "name": "ISO-2022-CN"
};
var $ee4e6c65b4561a9c$var$ISO2022JP_cls = [
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    7,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    6,
    0,
    4,
    0,
    8,
    0,
    0,
    0,
    0,
    9,
    5,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2 // f8 - ff
];
var $ee4e6c65b4561a9c$var$ISO2022JP_st = [
    $8hFBI.start,
    3,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    5,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    4,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    6,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start // 40-47
];
var $ee4e6c65b4561a9c$var$ISO2022JPCharLenTable = [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
];
$ee4e6c65b4561a9c$export$15afc959de738330 = {
    "classTable": $ee4e6c65b4561a9c$var$ISO2022JP_cls,
    "classFactor": 10,
    "stateTable": $ee4e6c65b4561a9c$var$ISO2022JP_st,
    "charLenTable": $ee4e6c65b4561a9c$var$ISO2022JPCharLenTable,
    "name": "ISO-2022-JP"
};
var $ee4e6c65b4561a9c$var$ISO2022KR_cls = [
    2,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    3,
    0,
    0,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    5,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2 // f8 - ff
];
var $ee4e6c65b4561a9c$var$ISO2022KR_st = [
    $8hFBI.start,
    3,
    $8hFBI.error,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.itsMe,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    4,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    5,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.error,
    $8hFBI.itsMe,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start,
    $8hFBI.start // 20-27
];
var $ee4e6c65b4561a9c$var$ISO2022KRCharLenTable = [
    0,
    0,
    0,
    0,
    0,
    0
];
$ee4e6c65b4561a9c$export$e429e2148fc710ce = {
    "classTable": $ee4e6c65b4561a9c$var$ISO2022KR_cls,
    "classFactor": 6,
    "stateTable": $ee4e6c65b4561a9c$var$ISO2022KR_st,
    "charLenTable": $ee4e6c65b4561a9c$var$ISO2022KRCharLenTable,
    "name": "ISO-2022-KR"
};

});





parcelRegister("7p06y", function(module, exports) {

var $9i2AP = parcelRequire("9i2AP");

var $j3YID = parcelRequire("j3YID");
class $563af2fa6c3da438$var$GameTree {
    constructor({ getId: getId = null, merger: merger = null, root: root = null } = {}){
        this.getId = getId || ((id = 0)=>()=>id++)();
        this.merger = merger || (()=>null);
        root = {
            id: this.getId(),
            data: {},
            parentId: null,
            children: [],
            ...root || {}
        };
        this.root = root;
        this._nodeCache = {};
        this._idAliases = {};
        this._heightCache = null;
        this._hashCache = null;
        this._structureHashCache = null;
    }
    get(id) {
        let node = null;
        if (id == null) return node;
        if (id in this._idAliases) return this.get(this._idAliases[id]);
        if (id in this._nodeCache) node = this._nodeCache[id];
        else {
            let inner = (node)=>{
                this._nodeCache[node.id] = node;
                if (node.id === id) return node;
                for (let child of node.children){
                    let result = inner(child);
                    if (result != null) return result;
                }
                return null;
            };
            node = inner(this.root);
        }
        if (node == null) {
            this._nodeCache[id] = null;
            return null;
        }
        for (let child of node.children)this._nodeCache[child.id] = child;
        return node;
    }
    *getSequence(id) {
        let node = this.get(id);
        if (node == null) return;
        yield node;
        while(node.children.length === 1){
            node = node.children[0];
            this._nodeCache[node.id] = node;
            for (let child of node.children)this._nodeCache[child.id] = child;
            yield node;
        }
    }
    mutate(mutator) {
        let draft = new $9i2AP(this);
        mutator(draft);
        if (draft.root === this.root) return this;
        let tree = new $563af2fa6c3da438$var$GameTree({
            getId: this.getId,
            merger: this.merger,
            root: draft.root
        });
        if (draft._passOnNodeCache) tree._nodeCache = draft._nodeCache;
        tree._idAliases = draft._idAliases;
        tree._structureHashCache = draft._structureHashCache;
        tree._heightCache = draft._heightCache;
        return tree;
    }
    navigate(id, step, currents) {
        let node = this.get(id);
        if (node == null) return null;
        if (step === 0) return node;
        if (step < 0) return this.navigate(node.parentId, step + 1);
        let nextId = currents[node.id] != null ? currents[node.id] : node.children.length > 0 ? node.children[0].id : null;
        if (nextId == null) return null;
        return this.navigate(nextId, step - 1, currents);
    }
    *listNodes() {
        function* inner(node) {
            yield node;
            for (let child of node.children)yield* inner(child);
        }
        yield* inner(this.root);
    }
    *listNodesHorizontally(startId, step) {
        if (Math.abs(step) !== 1) throw new Error('Invalid value for step, only -1 or 1 allowed');
        let level = this.getLevel(startId);
        let section = [
            ...this.getSection(level)
        ];
        let index = section.findIndex((node)=>node.id === startId);
        while(section[index] != null){
            while(0 <= index && index < section.length){
                yield section[index];
                index += step;
            }
            level += step;
            section = step > 0 ? [].concat(...section.map((node)=>node.children)) : [
                ...this.getSection(level)
            ];
            index = step > 0 ? 0 : section.length - 1;
        }
    }
    *listNodesVertically(startId, step, currents) {
        if (Math.abs(step) !== 1) throw new Error('Invalid value for step, only -1 or 1 allowed');
        let id = startId;
        let node = this.get(id);
        while(node != null){
            yield node;
            node = this.navigate(node.id, step, currents);
        }
    }
    *listCurrentNodes(currents) {
        yield* this.listNodesVertically(this.root.id, 1, currents);
    }
    *listMainNodes() {
        yield* this.listCurrentNodes({});
    }
    getLevel(id) {
        let result = -1;
        for (let node of this.listNodesVertically(id, -1, {}))result++;
        return result < 0 ? null : result;
    }
    *getSection(level) {
        if (level < 0) return;
        if (level === 0) {
            yield this.root;
            return;
        }
        for (let parent of this.getSection(level - 1))yield* parent.children;
    }
    getCurrentHeight(currents) {
        let result = 0;
        let node = this.root;
        while(node != null){
            result++;
            node = currents[node.id] == null ? node.children[0] : node.children.find((child)=>child.id === currents[node.id]);
        }
        return result;
    }
    getHeight() {
        if (this._heightCache == null) {
            let inner = (node)=>{
                let max = 0;
                for (let child of node.children)max = Math.max(max, inner(child));
                return max + 1;
            };
            this._heightCache = inner(this.root);
        }
        return this._heightCache;
    }
    getStructureHash() {
        if (this._structureHashCache == null) {
            let hash = $j3YID.new();
            let inner = (node)=>{
                hash('[' + JSON.stringify(node.id) + ',');
                node.children.forEach(inner);
                return hash(']');
            };
            this._structureHashCache = inner(this.root);
        }
        return (this._structureHashCache >>> 0) + '';
    }
    getHash() {
        if (this._hashCache == null) {
            let hash = $j3YID.new();
            let inner = (node)=>{
                hash('[' + JSON.stringify(node.data) + ',');
                node.children.forEach(inner);
                return hash(']');
            };
            this._hashCache = inner(this.root);
        }
        return (this._hashCache >>> 0) + '';
    }
    onCurrentLine(id, currents) {
        for (let node of this.listNodesVertically(id, -1, {})){
            let { parentId: parentId } = node;
            if (parentId != null && currents[parentId] !== node.id && (currents[parentId] != null || this.get(parentId).children[0] !== node)) return false;
        }
        return true;
    }
    onMainLine(id) {
        return this.onCurrentLine(id, {});
    }
    toJSON() {
        return this.root;
    }
}
module.exports = $563af2fa6c3da438$var$GameTree;

});
parcelRegister("9i2AP", function(module, exports) {
class $6c37ce6be3c8d11c$var$Draft {
    constructor(base){
        this.base = base;
        this.root = base.root;
        this._passOnNodeCache = true;
        this._nodeCache = {};
        this._idAliases = base._idAliases;
        this._heightCache = base._heightCache;
        this._structureHashCache = base._structureHashCache;
    }
    get(id) {
        if (id == null) return null;
        if (id in this._idAliases) return this.get(this._idAliases[id]);
        if (id in this._nodeCache) return this._nodeCache[id];
        let node = this.base.get(id);
        if (node == null) {
            this._nodeCache[id] = null;
            return null;
        }
        let nodeCopy = {
            ...node,
            data: {
                ...node.data
            },
            children: [
                ...node.children
            ]
        };
        if (node.parentId != null) {
            let parentCopy = this.get(node.parentId);
            let childIndex = parentCopy.children.findIndex((child)=>child.id === id);
            if (childIndex >= 0) parentCopy.children[childIndex] = nodeCopy;
        }
        this._nodeCache[id] = nodeCopy;
        if (this.root.id === id) this.root = nodeCopy;
        return nodeCopy;
    }
    _getLevel(id) {
        let level = -1;
        let node = this.get(id);
        while(node != null){
            level++;
            node = this.get(node.parentId);
        }
        return level;
    }
    appendNode(parentId, data, options = {}) {
        let id = this.base.getId();
        let success = this.UNSAFE_appendNodeWithId(parentId, id, data, options);
        if (!success) return null;
        let merged = id in this._idAliases;
        if (!merged) return id;
        // If a merge occured, clean up id alias since id hasn't been exposed
        let result = this._idAliases[id];
        delete this._idAliases[id];
        return result;
    }
    UNSAFE_appendNodeWithId(parentId, id, data, { disableMerging: disableMerging } = {}) {
        let parent = this.get(parentId);
        if (parent == null) return false;
        let [mergeWithId, mergedData] = (()=>{
            if (!disableMerging) for (let child of parent.children){
                let mergedData = this.base.merger(child, data);
                if (mergedData != null) return [
                    child.id,
                    mergedData
                ];
            }
            return [
                null,
                null
            ];
        })();
        if (mergeWithId != null) {
            let node = this.get(mergeWithId);
            node.data = mergedData;
            if (id !== mergeWithId) this._idAliases[id] = mergeWithId;
        } else {
            let node = {
                id: id,
                data: data,
                parentId: parentId,
                children: []
            };
            parent.children.push(node);
            this._nodeCache[id] = node;
            this._structureHashCache = null;
            if (this._heightCache != null && this._getLevel(parentId) === this._heightCache - 1) this._heightCache++;
        }
        return true;
    }
    removeNode(id) {
        let node = this.get(id);
        if (node == null) return false;
        let parentId = node.parentId;
        if (parentId == null) throw new Error('Cannot remove root node');
        let parent = this.get(parentId);
        if (parent == null) return false;
        let index = parent.children.findIndex((child)=>child.id === id);
        if (index >= 0) parent.children.splice(index, 1);
        else return false;
        this._nodeCache[id] = null;
        this._structureHashCache = null;
        this._heightCache = null;
        return true;
    }
    shiftNode(id, direction) {
        if (![
            'left',
            'right',
            'main'
        ].includes(direction)) throw new Error(`Invalid value for direction, only 'left', 'right', or 'main' allowed`);
        let node = this.get(id);
        if (node == null) return null;
        let { parentId: parentId } = node;
        let parent = this.get(parentId);
        if (parent == null) return null;
        let index = parent.children.findIndex((child)=>child.id === id);
        if (index < 0) return null;
        let newIndex = {
            left: Math.max(index - 1, 0),
            right: Math.min(index + 1, parent.children.length),
            main: 0
        }[direction];
        if (index !== newIndex) {
            let [child] = parent.children.splice(index, 1);
            parent.children.splice(newIndex, 0, child);
        }
        this._structureHashCache = null;
        return newIndex;
    }
    makeRoot(id) {
        if (id === this.root.id) return true;
        let node = this.get(id);
        if (node == null) return false;
        node.parentId = null;
        this.root = node;
        this._passOnNodeCache = false;
        this._heightCache = null;
        this._structureHashCache = null;
        return true;
    }
    addToProperty(id, property, value) {
        let node = this.get(id);
        if (node == null) return false;
        if (node.data[property] == null) node.data[property] = [
            value
        ];
        else if (!node.data[property].includes(value)) node.data[property] = [
            ...node.data[property],
            value
        ];
        return true;
    }
    removeFromProperty(id, property, value) {
        let node = this.get(id);
        if (node == null || node.data[property] == null) return false;
        node.data[property] = node.data[property].filter((x)=>x !== value);
        if (node.data[property].length === 0) delete node.data[property];
        return true;
    }
    updateProperty(id, property, values) {
        let node = this.get(id);
        if (node == null) return false;
        if (values == null || values.length === 0) delete node.data[property];
        else node.data[property] = values;
        return true;
    }
    removeProperty(id, property) {
        return this.updateProperty(id, property, null);
    }
}
module.exports = $6c37ce6be3c8d11c$var$Draft;

});

parcelRegister("j3YID", function(module, exports) {

$parcel$export(module.exports, "new", () => $de0d659ee5308b8b$export$b8cb59497041ffe4, (v) => $de0d659ee5308b8b$export$b8cb59497041ffe4 = v);
var $de0d659ee5308b8b$export$b8cb59497041ffe4;
$de0d659ee5308b8b$export$b8cb59497041ffe4 = function() {
    // Simple hash function adapted from
    // https://github.com/darkskyapp/string-hash
    let result = 5381;
    return (str)=>{
        for(let i = 0; i < str.length; i++)result = result * 33 ^ str.charCodeAt(i);
        return result;
    };
};

});


parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



var $3472ef69887c311d$exports = {};
var $b314d94d0e35b850$export$cf6746a2647f682c;
var $b314d94d0e35b850$export$836c1043eef00e14;
var $b314d94d0e35b850$export$660b2ee2d4fb4eff;
var $b314d94d0e35b850$export$d6edd3c333723876;
var $fdd5d7504eea195b$export$25d50fb3d96367fc;
var $fdd5d7504eea195b$export$107818e33fdfe3b0;
var $fdd5d7504eea195b$export$ae34f10ee4b29837;
$fdd5d7504eea195b$export$25d50fb3d96367fc = function(type, regex, { lineBreaks: lineBreaks = false, stateCondition: stateCondition = (state)=>true, value: value = (match, state)=>match[0], last: last = (match, state)=>false, condition: condition = (match, state)=>true, nextState: nextState = (match, state)=>state } = {}) {
    if (!regex.sticky && !regex.global) throw new TypeError('Either sticky (/y, recommended) or global (/g) has to be enabled for the regular expresion.');
    return {
        type: type,
        lineBreaks: lineBreaks,
        match (input, position, state) {
            if (!stateCondition(state)) return null;
            regex.lastIndex = position;
            let match = regex.exec(input);
            if (match == null || match.index !== position || !condition(match, state)) return null;
            return {
                length: match[0].length,
                value: value(match, state),
                last: last(match, state),
                state: nextState(match, state)
            };
        }
    };
};
$fdd5d7504eea195b$export$107818e33fdfe3b0 = function(type, tokenize, { lineBreaks: lineBreaks = false, stateCondition: stateCondition = (state)=>true, value: value = (tokens, state)=>tokens, last: last = (tokens, state)=>false, condition: condition = (tokens, state)=>true, nextState: nextState = (tokens, state)=>state } = {}) {
    return {
        type: type,
        lineBreaks: lineBreaks,
        match (input, position, state) {
            if (!stateCondition(state)) return null;
            let tokensIter = tokenize(input);
            tokensIter.col = this.col;
            tokensIter.row = this.row;
            tokensIter.pos = position;
            let tokens = [
                ...tokensIter
            ];
            if (!condition(tokens, state)) return null;
            return {
                length: tokensIter.pos - position,
                value: value(tokens, state),
                last: last(tokens, state),
                state: nextState(tokens, state)
            };
        }
    };
};
$fdd5d7504eea195b$export$ae34f10ee4b29837 = function({ rules: rules, strategy: strategy = 'first', state: state = {} }) {
    if (![
        'first',
        'longest'
    ].includes(strategy)) throw new TypeError("Only 'first' and 'longest' are allowed as values for the strategy option.");
    return function tokenize(input) {
        return {
            state: state,
            row: 0,
            col: 0,
            pos: 0,
            done: false,
            [Symbol.iterator] () {
                return this;
            },
            next () {
                while(!this.done && this.pos < input.length){
                    let token, tokenText, match;
                    let lineBreaks = false;
                    for (let rule of rules){
                        match = rule.match.call(this, input, this.pos, this.state);
                        if (match == null) continue;
                        let value = match.value;
                        if (value === undefined) value = tokenText = input.substr(this.pos, match.length);
                        if (token == null || token.length < match.length) {
                            token = {
                                type: rule.type,
                                value: value,
                                row: this.row,
                                col: this.col,
                                pos: this.pos,
                                length: match.length
                            };
                            lineBreaks = !!rule.lineBreaks;
                        }
                        if (strategy === 'first') break;
                    }
                    if (token == null) {
                        token = {
                            type: null,
                            value: input[this.pos],
                            row: this.row,
                            col: this.col,
                            pos: this.pos,
                            length: 1
                        };
                        lineBreaks = true;
                    }
                    // Update source position
                    let newLineCount = 0;
                    let lastNewLineIndex = -1;
                    if (lineBreaks) {
                        if (tokenText == null) tokenText = input.substr(this.pos, token.length);
                        newLineCount = Array.from(tokenText).filter((c, i)=>{
                            if (c === '\n') {
                                lastNewLineIndex = i;
                                return true;
                            }
                            return false;
                        }).length;
                        this.row += newLineCount;
                    }
                    if (newLineCount > 0) this.col = token.length - lastNewLineIndex - 1;
                    else this.col += token.length;
                    this.pos += token.length;
                    // Return token
                    if (match != null && match.state != null) {
                        this.state = match.state;
                        this.done = !!match.last;
                    }
                    if (token.type == null || token.type[0] !== '_') return {
                        value: token,
                        done: false
                    };
                }
                this.done = true;
                return {
                    done: true
                };
            }
        };
    };
};


var $b314d94d0e35b850$require$createTokenizer = $fdd5d7504eea195b$export$ae34f10ee4b29837;
var $b314d94d0e35b850$require$regexRule = $fdd5d7504eea195b$export$25d50fb3d96367fc;
var $887534a3fc9b1c18$exports = {};

$887534a3fc9b1c18$exports = (()=>{
    try {
        let m = (parcelRequire("6luGJ"));
        if (m == null) throw new Error();
        return m;
    } catch (err) {
        return {
            encodingExists: ()=>true,
            decode: (buffer)=>buffer.toString(),
            encode: (str, _)=>str
        };
    }
})();


var $6115b8c07b44a01d$exports = {};

$6115b8c07b44a01d$exports = (()=>{
    try {
        let m = (parcelRequire("796Jz"));
        if (m == null) throw new Error();
        return m;
    } catch (err) {
        return {
            detect: ()=>({
                    encoding: 'UTF-8'
                })
        };
    }
})();


var $675676de27d9cf92$exports = {};

$parcel$export($675676de27d9cf92$exports, "escapeString", () => $675676de27d9cf92$export$4148cf4a40af9f34, (v) => $675676de27d9cf92$export$4148cf4a40af9f34 = v);
$parcel$export($675676de27d9cf92$exports, "unescapeString", () => $675676de27d9cf92$export$8037a56d2f38cf65, (v) => $675676de27d9cf92$export$8037a56d2f38cf65 = v);
$parcel$export($675676de27d9cf92$exports, "parseDates", () => $675676de27d9cf92$export$4344a679afc8cef0, (v) => $675676de27d9cf92$export$4344a679afc8cef0 = v);
$parcel$export($675676de27d9cf92$exports, "stringifyDates", () => $675676de27d9cf92$export$73e26c6e1f07fe0f, (v) => $675676de27d9cf92$export$73e26c6e1f07fe0f = v);
$parcel$export($675676de27d9cf92$exports, "parseVertex", () => $675676de27d9cf92$export$adbcb6a5afc855a2, (v) => $675676de27d9cf92$export$adbcb6a5afc855a2 = v);
$parcel$export($675676de27d9cf92$exports, "stringifyVertex", () => $675676de27d9cf92$export$cfad5752548511c5, (v) => $675676de27d9cf92$export$cfad5752548511c5 = v);
$parcel$export($675676de27d9cf92$exports, "parseCompressedVertices", () => $675676de27d9cf92$export$ba06126de1b238f6, (v) => $675676de27d9cf92$export$ba06126de1b238f6 = v);
var $675676de27d9cf92$export$4148cf4a40af9f34;
var $675676de27d9cf92$export$8037a56d2f38cf65;
var $675676de27d9cf92$export$4344a679afc8cef0;
var $675676de27d9cf92$export$73e26c6e1f07fe0f;
var $675676de27d9cf92$export$adbcb6a5afc855a2;
var $675676de27d9cf92$export$cfad5752548511c5;
var $675676de27d9cf92$export$ba06126de1b238f6;
const $675676de27d9cf92$var$alpha = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
$675676de27d9cf92$export$4148cf4a40af9f34 = function(input) {
    return input.toString().replace(/\\/g, '\\\\').replace(/\]/g, '\\]');
};
$675676de27d9cf92$export$8037a56d2f38cf65 = function(input) {
    let result = [];
    let inBackslash = false;
    input = input.replace(/\r/g, '');
    for(let i = 0; i < input.length; i++)if (!inBackslash) {
        if (input[i] !== '\\') result.push(input[i]);
        else if (input[i] === '\\') inBackslash = true;
    } else {
        if (input[i] !== '\n') result.push(input[i]);
        inBackslash = false;
    }
    return result.join('');
};
$675676de27d9cf92$export$4344a679afc8cef0 = function(input) {
    if (!input.match(/^(\d{4}(-\d{1,2}(-\d{1,2})?)?(\s*,\s*(\d{4}|(\d{4}-)?\d{1,2}(-\d{1,2})?))*)?$/)) return null;
    if (input.trim() === '') return [];
    let dates = input.split(',').map((x)=>x.trim().split('-'));
    for(let i = 1; i < dates.length; i++){
        let date = dates[i];
        let prev = dates[i - 1];
        if (date[0].length !== 4) {
            // No year
            if (date.length === 1 && prev.length === 3) // Add month
            date.unshift(prev[1]);
            // Add year
            date.unshift(prev[0]);
        }
    }
    return dates.map((x)=>x.map((y)=>+y));
};
$675676de27d9cf92$export$73e26c6e1f07fe0f = function(dates) {
    if (dates.length === 0) return '';
    let datesCopy = [
        dates[0].slice()
    ];
    for(let i = 1; i < dates.length; i++){
        let date = dates[i];
        let prev = dates[i - 1];
        let k = 0;
        for(let j = 0; j < date.length; j++){
            if (date[j] === prev[j] && k === j) k++;
            else break;
        }
        datesCopy.push(date.slice(k));
    }
    return datesCopy.map((x)=>x.map((y)=>y > 9 ? '' + y : '0' + y).join('-')).join(',');
};
$675676de27d9cf92$export$adbcb6a5afc855a2 = function(input) {
    if (input.length !== 2) return [
        -1,
        -1
    ];
    return input.split('').map((x)=>$675676de27d9cf92$var$alpha.indexOf(x));
};
$675676de27d9cf92$export$cfad5752548511c5 = function([x, y]) {
    if (Math.min(x, y) < 0 || Math.max(x, y) >= $675676de27d9cf92$var$alpha.length) return '';
    return $675676de27d9cf92$var$alpha[x] + $675676de27d9cf92$var$alpha[y];
};
$675676de27d9cf92$export$ba06126de1b238f6 = function(input) {
    let colon = input.indexOf(':');
    if (colon < 0) return [
        $675676de27d9cf92$export$adbcb6a5afc855a2(input)
    ];
    let [x1, y1] = $675676de27d9cf92$export$adbcb6a5afc855a2(input.slice(0, colon));
    let [x2, y2] = $675676de27d9cf92$export$adbcb6a5afc855a2(input.slice(colon + 1));
    let vertices = [];
    for(let i = Math.min(x1, x2); i <= Math.max(x1, x2); i++)for(let j = Math.min(y1, y2); j <= Math.max(y1, y2); j++)vertices.push([
        i,
        j
    ]);
    return vertices;
};


var $b314d94d0e35b850$require$unescapeString = $675676de27d9cf92$export$8037a56d2f38cf65;
const $b314d94d0e35b850$var$encodingDetectionProps = [
    'EV',
    'GN',
    'GC',
    'AN',
    'BT',
    'WT',
    'PW',
    'PB',
    'C'
];
const $b314d94d0e35b850$var$_tokenize = $b314d94d0e35b850$require$createTokenizer({
    rules: [
        $b314d94d0e35b850$require$regexRule('_whitespace', /\s+/y, {
            lineBreaks: true
        }),
        $b314d94d0e35b850$require$regexRule('parenthesis', /(\(|\))/y),
        $b314d94d0e35b850$require$regexRule('semicolon', /;/y),
        $b314d94d0e35b850$require$regexRule('prop_ident', /[A-Za-z]+/y),
        $b314d94d0e35b850$require$regexRule('c_value_type', /\[([^\\\]]|\\[^])*\]/y, {
            lineBreaks: true
        }),
        {
            type: 'invalid',
            match: (input, position)=>({
                    length: 1
                })
        }
    ]
});
$b314d94d0e35b850$export$cf6746a2647f682c = function*(contents) {
    for (let token of $b314d94d0e35b850$var$_tokenize(contents)){
        token.progress = token.pos / (contents.length - 1);
        delete token.length;
        yield token;
    }
};
$b314d94d0e35b850$export$836c1043eef00e14 = function*(buffer, { encoding: encoding = null } = {}) {
    if (encoding != null) {
        yield* $b314d94d0e35b850$export$cf6746a2647f682c($887534a3fc9b1c18$exports.decode(buffer, encoding));
        return;
    }
    // Guess encoding
    let detectedEncoding = $6115b8c07b44a01d$exports.detect(buffer.slice(0, 300)).encoding;
    let contents = $887534a3fc9b1c18$exports.decode(buffer, detectedEncoding);
    let tokens = $b314d94d0e35b850$export$cf6746a2647f682c(contents);
    // Search for encoding
    let prelude = [];
    while(true){
        let next = tokens.next();
        if (next.done) break;
        let { type: type, value: value } = next.value;
        let lastToken = prelude[prelude.length - 1];
        prelude.push(next.value);
        if (type === 'c_value_type' && lastToken != null && lastToken.type === 'prop_ident' && lastToken.value === 'CA') {
            encoding = $b314d94d0e35b850$require$unescapeString(value.slice(1, -1));
            break;
        }
    }
    if (encoding != null && encoding != detectedEncoding && $887534a3fc9b1c18$exports.encodingExists(encoding)) yield* $b314d94d0e35b850$export$cf6746a2647f682c($887534a3fc9b1c18$exports.decode(buffer, encoding));
    else {
        yield* prelude;
        yield* tokens;
    }
};
$b314d94d0e35b850$export$660b2ee2d4fb4eff = (contents)=>[
        ...$b314d94d0e35b850$export$cf6746a2647f682c(contents)
    ];
$b314d94d0e35b850$export$d6edd3c333723876 = (buffer, opts)=>[
        ...$b314d94d0e35b850$export$836c1043eef00e14(buffer, opts)
    ];


var $3472ef69887c311d$require$tokenizeIter = $b314d94d0e35b850$export$cf6746a2647f682c;
var $3472ef69887c311d$require$tokenizeBufferIter = $b314d94d0e35b850$export$836c1043eef00e14;
var $3472ef69887c311d$require$tokenize = $b314d94d0e35b850$export$660b2ee2d4fb4eff;
var $3472ef69887c311d$require$tokenizeBuffer = $b314d94d0e35b850$export$d6edd3c333723876;
var $44ba9df28abf54cb$export$1519315028697ffe;
var $44ba9df28abf54cb$export$98e6a39c04603d36;
var $44ba9df28abf54cb$export$9df12741220b4999;
var $44ba9df28abf54cb$export$f1c553d4f1a2351;

var $kjyEk = parcelRequire("kjyEk");
var $6d06780b4d638741$exports = {};
class $6d06780b4d638741$var$Peekable {
    constructor(iterator){
        this.iterator = iterator[Symbol.iterator]();
        this.peekedItem = null;
        this.peeked = false;
    }
    next() {
        let next = this.peeked ? this.peekedItem : this.iterator.next();
        this.peekedItem = null;
        this.peeked = false;
        return next;
    }
    peek() {
        if (!this.peeked) {
            this.peekedItem = this.iterator.next();
            this.peeked = true;
        }
        return this.peekedItem;
    }
}
$6d06780b4d638741$exports = $6d06780b4d638741$var$Peekable;



var $44ba9df28abf54cb$require$tokenizeIter = $b314d94d0e35b850$export$cf6746a2647f682c;
var $44ba9df28abf54cb$require$tokenizeBufferIter = $b314d94d0e35b850$export$836c1043eef00e14;

var $44ba9df28abf54cb$require$unescapeString = $675676de27d9cf92$export$8037a56d2f38cf65;
function $44ba9df28abf54cb$var$_parseTokens(peekableTokens, parentId, options) {
    let { getId: getId, dictionary: dictionary, onProgress: onProgress, onNodeCreated: onNodeCreated } = options;
    let anchor = null;
    let node, property;
    while(!peekableTokens.peek().done){
        let { type: type, value: value, row: row, col: col } = peekableTokens.peek().value;
        if (type === 'parenthesis' && value === '(') break;
        if (type === 'parenthesis' && value === ')') {
            if (node != null) onNodeCreated({
                node: node
            });
            return anchor;
        }
        if (type === 'semicolon' || node == null) {
            // Prepare new node
            let lastNode = node;
            node = {
                id: getId(),
                data: {},
                parentId: lastNode == null ? parentId : lastNode.id,
                children: []
            };
            if (dictionary != null) dictionary[node.id] = node;
            if (lastNode != null) {
                onNodeCreated({
                    node: lastNode
                });
                lastNode.children.push(node);
            } else anchor = node;
        }
        if (type === 'semicolon') ;
        else if (type === 'prop_ident') {
            if (node != null) {
                // Prepare new property
                let identifier = value === value.toUpperCase() ? value : value.split('').filter((x)=>x.toUpperCase() === x).join('');
                if (identifier !== '') {
                    if (!(identifier in node.data)) node.data[identifier] = [];
                    property = node.data[identifier];
                } else property = null;
            }
        } else if (type === 'c_value_type') {
            if (property != null) property.push($44ba9df28abf54cb$require$unescapeString(value.slice(1, -1)));
        } else if (type === 'invalid') throw new Error(`Unexpected token at ${row + 1}:${col + 1}`);
        else throw new Error(`Unexpected token type '${type}' at ${row + 1}:${col + 1}`);
        peekableTokens.next();
    }
    if (node == null) anchor = node = {
        id: null,
        data: {},
        parentId: null,
        children: []
    };
    else onNodeCreated({
        node: node
    });
    while(!peekableTokens.peek().done){
        let { type: type, value: value, progress: progress } = peekableTokens.peek().value;
        if (type === 'parenthesis' && value === '(') {
            peekableTokens.next();
            let child = $44ba9df28abf54cb$var$_parseTokens(peekableTokens, node.id, options);
            if (child != null) node.children.push(child);
        } else if (type === 'parenthesis' && value === ')') {
            onProgress({
                progress: progress
            });
            break;
        }
        peekableTokens.next();
    }
    return anchor;
}
$44ba9df28abf54cb$export$1519315028697ffe = function(tokens, { getId: getId = ((id)=>()=>id++)(0), dictionary: dictionary = null, onProgress: onProgress = ()=>{}, onNodeCreated: onNodeCreated = ()=>{} } = {}) {
    let node = $44ba9df28abf54cb$var$_parseTokens(new $6d06780b4d638741$exports(tokens), null, {
        getId: getId,
        dictionary: dictionary,
        onProgress: onProgress,
        onNodeCreated: onNodeCreated
    });
    return node.id == null ? node.children : [
        node
    ];
};
$44ba9df28abf54cb$export$98e6a39c04603d36 = function(contents, options = {}) {
    return $44ba9df28abf54cb$export$1519315028697ffe($44ba9df28abf54cb$require$tokenizeIter(contents), options);
};
$44ba9df28abf54cb$export$9df12741220b4999 = function(buffer, options = {}) {
    return $44ba9df28abf54cb$export$1519315028697ffe($44ba9df28abf54cb$require$tokenizeBufferIter(buffer, {
        encoding: options.encoding
    }), options);
};
$44ba9df28abf54cb$export$f1c553d4f1a2351 = function(filename, options = {}) {
    return $44ba9df28abf54cb$export$9df12741220b4999($kjyEk.readFileSync(filename), options);
};


var $3472ef69887c311d$require$parse = $44ba9df28abf54cb$export$98e6a39c04603d36;
var $3472ef69887c311d$require$parseTokens = $44ba9df28abf54cb$export$1519315028697ffe;
var $3472ef69887c311d$require$parseBuffer = $44ba9df28abf54cb$export$9df12741220b4999;
var $3472ef69887c311d$require$parseFile = $44ba9df28abf54cb$export$f1c553d4f1a2351;
var $63012dc5e45c18ea$export$fac44ee5b035f737;

var $63012dc5e45c18ea$require$escapeString = $675676de27d9cf92$export$4148cf4a40af9f34;
$63012dc5e45c18ea$export$fac44ee5b035f737 = function(node, { linebreak: linebreak = '\n', indent: indent = '  ', level: level = 0 } = {}) {
    if (Array.isArray(node)) return $63012dc5e45c18ea$export$fac44ee5b035f737({
        children: node
    }, {
        linebreak: linebreak,
        level: level
    });
    let output = [];
    let totalIndent = linebreak !== '' ? indent.repeat(level) : '';
    if (node.data != null) {
        output.push(totalIndent, ';');
        for(let id in node.data){
            if (id.toUpperCase() !== id) continue;
            output.push(id, '[', node.data[id].map($63012dc5e45c18ea$require$escapeString).join(']['), ']');
        }
        output.push(linebreak);
    }
    if (node.children.length > 1 || node.children.length > 0 && level === 0) {
        output.push(totalIndent);
        for (let child of node.children)output.push('(', linebreak, $63012dc5e45c18ea$export$fac44ee5b035f737(child, {
            linebreak: linebreak,
            level: level + 1
        }), totalIndent, ')');
        output.push(linebreak);
    } else if (node.children.length === 1) output.push($63012dc5e45c18ea$export$fac44ee5b035f737(node.children[0], {
        linebreak: linebreak,
        level: level
    }));
    return output.join('');
};


var $3472ef69887c311d$require$stringify = $63012dc5e45c18ea$export$fac44ee5b035f737;

Object.assign($3472ef69887c311d$exports, {
    tokenizeIter: $3472ef69887c311d$require$tokenizeIter,
    tokenizeBufferIter: $3472ef69887c311d$require$tokenizeBufferIter,
    tokenize: $3472ef69887c311d$require$tokenize,
    tokenizeBuffer: $3472ef69887c311d$require$tokenizeBuffer,
    parse: $3472ef69887c311d$require$parse,
    parseTokens: $3472ef69887c311d$require$parseTokens,
    parseBuffer: $3472ef69887c311d$require$parseBuffer,
    parseFile: $3472ef69887c311d$require$parseFile,
    stringify: $3472ef69887c311d$require$stringify
}, $675676de27d9cf92$exports);


var $5669c13f2796f695$exports = {};

$5669c13f2796f695$exports = (parcelRequire("7p06y"));


var $225f7c2b7df55bb7$exports = {};
/*!
 * Tenuki v0.3.1 (https://github.com/aprescott/tenuki)
 * Copyright © 2016-2019 Adam Prescott.
 * Licensed under the MIT license.
 */ !function(e) {
    var f;
    $225f7c2b7df55bb7$exports = e();
}(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = undefined;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = undefined;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(require1, module1, exports) {
                "use strict";
                exports.Game = require1("./lib/game").default;
                exports.Client = require1("./lib/client").default;
                exports.utils = require1("./lib/utils").default;
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbImV4cG9ydHMiLCJHYW1lIiwicmVxdWlyZSIsImRlZmF1bHQiLCJDbGllbnQiLCJ1dGlscyJdLCJtYXBwaW5ncyI6Ijs7QUFBQUEsUUFBUUMsSUFBUixHQUFlQyxRQUFRLFlBQVIsRUFBc0JDLE9BQXJDO0FBQ0FILFFBQVFJLE1BQVIsR0FBaUJGLFFBQVEsY0FBUixFQUF3QkMsT0FBekM7QUFDQUgsUUFBUUssS0FBUixHQUFnQkgsUUFBUSxhQUFSLEVBQXVCQyxPQUF2QyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydHMuR2FtZSA9IHJlcXVpcmUoXCIuL2xpYi9nYW1lXCIpLmRlZmF1bHQ7XG5leHBvcnRzLkNsaWVudCA9IHJlcXVpcmUoXCIuL2xpYi9jbGllbnRcIikuZGVmYXVsdDtcbmV4cG9ydHMudXRpbHMgPSByZXF1aXJlKFwiLi9saWIvdXRpbHNcIikuZGVmYXVsdDtcbiJdfQ==
            },
            {
                "./lib/client": 3,
                "./lib/game": 6,
                "./lib/utils": 14
            }
        ],
        2: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _slicedToArray = function() {
                    function sliceIterator(arr, i) {
                        var _arr = [];
                        var _n = true;
                        var _d = false;
                        var _e = undefined;
                        try {
                            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                                _arr.push(_s.value);
                                if (i && _arr.length === i) break;
                            }
                        } catch (err) {
                            _d = true;
                            _e = err;
                        } finally{
                            try {
                                if (!_n && _i["return"]) _i["return"]();
                            } finally{
                                if (_d) throw _e;
                            }
                        }
                        return _arr;
                    }
                    return function(arr, i) {
                        if (Array.isArray(arr)) return arr;
                        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }();
                var _utils = require1("./utils");
                var _utils2 = _interopRequireDefault(_utils);
                var _intersection = require1("./intersection");
                var _intersection2 = _interopRequireDefault(_intersection);
                var _zobrist = require1("./zobrist");
                var _zobrist2 = _interopRequireDefault(_zobrist);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var BoardState = function BoardState(_ref) {
                    var moveNumber = _ref.moveNumber, playedPoint = _ref.playedPoint, color = _ref.color, pass = _ref.pass, blackPassStones = _ref.blackPassStones, whitePassStones = _ref.whitePassStones, intersections = _ref.intersections, blackStonesCaptured = _ref.blackStonesCaptured, whiteStonesCaptured = _ref.whiteStonesCaptured, capturedPositions = _ref.capturedPositions, koPoint = _ref.koPoint, boardSize = _ref.boardSize;
                    this.moveNumber = moveNumber;
                    this.playedPoint = playedPoint;
                    this.color = color;
                    this.pass = pass;
                    this.blackPassStones = blackPassStones;
                    this.whitePassStones = whitePassStones;
                    this.intersections = intersections;
                    this.blackStonesCaptured = blackStonesCaptured;
                    this.whiteStonesCaptured = whiteStonesCaptured;
                    this.capturedPositions = capturedPositions;
                    this.koPoint = koPoint;
                    this.boardSize = boardSize;
                    this._positionHash = _zobrist2.default.hash(boardSize, intersections);
                    Object.freeze(this);
                };
                BoardState.prototype = {
                    copyWithAttributes: function copyWithAttributes(attrs) {
                        var retrieveProperties = function retrieveProperties(_ref2) {
                            var moveNumber = _ref2.moveNumber, playedPoint = _ref2.playedPoint, color = _ref2.color, pass = _ref2.pass, blackPassStones = _ref2.blackPassStones, whitePassStones = _ref2.whitePassStones, intersections = _ref2.intersections, blackStonesCaptured = _ref2.blackStonesCaptured, whiteStonesCaptured = _ref2.whiteStonesCaptured, capturedPositions = _ref2.capturedPositions, koPoint = _ref2.koPoint, boardSize = _ref2.boardSize;
                            return {
                                moveNumber: moveNumber,
                                playedPoint: playedPoint,
                                color: color,
                                pass: pass,
                                blackPassStones: blackPassStones,
                                whitePassStones: whitePassStones,
                                intersections: intersections,
                                blackStonesCaptured: blackStonesCaptured,
                                whiteStonesCaptured: whiteStonesCaptured,
                                capturedPositions: capturedPositions,
                                koPoint: koPoint,
                                boardSize: boardSize
                            };
                        };
                        var existingAttrs = retrieveProperties(this);
                        var newAttrs = retrieveProperties(Object.assign(existingAttrs, attrs));
                        return new BoardState(newAttrs);
                    },
                    _capturesFrom: function _capturesFrom(y, x, color) {
                        var _this = this;
                        var capturedNeighbors = this.neighborsFor(y, x).filter(function(neighbor) {
                            // TODO: this value of 1 is potentially weird.
                            // we're checking against the move before the stone we just played
                            // where this space is not occupied yet. things should possibly be
                            // reworked.
                            return !neighbor.isEmpty() && neighbor.value !== color && _this.libertiesAt(neighbor.y, neighbor.x) === 1;
                        });
                        var capturedStones = _utils2.default.flatMap(capturedNeighbors, function(neighbor) {
                            return _this.groupAt(neighbor.y, neighbor.x);
                        });
                        return _utils2.default.unique(capturedStones);
                    },
                    _updateIntersection: function _updateIntersection(intersection, intersections, color) {
                        return intersections.map(function(i) {
                            if (i.y === intersection.y && i.x === intersection.x) return new _intersection2.default(i.y, i.x, color);
                            else return i;
                        });
                    },
                    _removeIntersection: function _removeIntersection(intersection, intersections) {
                        return this._updateIntersection(intersection, intersections, "empty");
                    },
                    _withoutIntersectionsMatching: function _withoutIntersectionsMatching(condition) {
                        var newPoints = this.intersections.map(function(i) {
                            if (condition(i)) return new _intersection2.default(i.y, i.x, "empty");
                            else return i;
                        });
                        return this._withNewPoints(newPoints);
                    },
                    _withNewPoints: function _withNewPoints(newPoints) {
                        return this.copyWithAttributes({
                            intersections: newPoints
                        });
                    },
                    nextColor: function nextColor() {
                        if (this.color === "black") return "white";
                        else return "black";
                    },
                    yCoordinateFor: function yCoordinateFor(y) {
                        return this.boardSize - y;
                    },
                    xCoordinateFor: function xCoordinateFor(x) {
                        var letters = [
                            "A",
                            "B",
                            "C",
                            "D",
                            "E",
                            "F",
                            "G",
                            "H",
                            "J",
                            "K",
                            "L",
                            "M",
                            "N",
                            "O",
                            "P",
                            "Q",
                            "R",
                            "S",
                            "T"
                        ];
                        return letters[x];
                    },
                    playPass: function playPass(color) {
                        var stateInfo = {
                            moveNumber: this.moveNumber + 1,
                            playedPoint: null,
                            color: color,
                            pass: true,
                            blackPassStones: this.blackPassStones,
                            whitePassStones: this.whitePassStones,
                            intersections: this.intersections,
                            blackStonesCaptured: this.blackStonesCaptured,
                            whiteStonesCaptured: this.whiteStonesCaptured,
                            capturedPositions: [],
                            koPoint: null,
                            boardSize: this.boardSize
                        };
                        stateInfo[color + "PassStones"] += 1;
                        var newState = new BoardState(stateInfo);
                        return newState;
                    },
                    _simpleKoPoint: function _simpleKoPoint() {
                        var simpleKoPoint = null;
                        if (this.playedPoint) {
                            var _playedPoint = this.playedPoint, y = _playedPoint.y, x = _playedPoint.x;
                            if (this.capturedPositions.length === 1 && this.groupAt(y, x).length === 1 && this.inAtari(y, x)) simpleKoPoint = this.capturedPositions[0];
                        }
                        return simpleKoPoint;
                    },
                    playAt: function playAt(y, x, playedColor) {
                        var _this2 = this;
                        var capturedPositions = this._capturesFrom(y, x, playedColor);
                        var playedPoint = this.intersectionAt(y, x);
                        var newPoints = this.intersections;
                        capturedPositions.forEach(function(i) {
                            newPoints = _this2._removeIntersection(i, newPoints);
                        });
                        newPoints = this._updateIntersection(playedPoint, newPoints, playedColor);
                        var newTotalBlackCaptured = this.blackStonesCaptured + (playedColor === "black" ? 0 : capturedPositions.length);
                        var newTotalWhiteCaptured = this.whiteStonesCaptured + (playedColor === "white" ? 0 : capturedPositions.length);
                        var boardSize = this.boardSize;
                        var moveInfo = {
                            moveNumber: this.moveNumber + 1,
                            playedPoint: Object.freeze({
                                y: y,
                                x: x
                            }),
                            color: playedColor,
                            pass: false,
                            blackPassStones: this.blackPassStones,
                            whitePassStones: this.whitePassStones,
                            intersections: newPoints,
                            blackStonesCaptured: newTotalBlackCaptured,
                            whiteStonesCaptured: newTotalWhiteCaptured,
                            capturedPositions: capturedPositions,
                            boardSize: boardSize
                        };
                        var withPlayedPoint = new BoardState(moveInfo);
                        var possibleKoPoint = withPlayedPoint._simpleKoPoint();
                        if (possibleKoPoint) moveInfo["koPoint"] = {
                            y: possibleKoPoint.y,
                            x: possibleKoPoint.x
                        };
                        else moveInfo["koPoint"] = null;
                        return new BoardState(moveInfo);
                    },
                    intersectionAt: function intersectionAt(y, x) {
                        if (y >= this.boardSize || x >= this.boardSize) throw new Error("Intersection at (" + y + ", " + x + ") would be outside the board");
                        if (y < 0 || x < 0) throw new Error("Intersection position cannot be negative, but was given (" + y + ", " + x + ")");
                        return this.intersections[y * this.boardSize + x];
                    },
                    groupAt: function groupAt(y, x) {
                        var startingPoint = this.intersectionAt(y, x);
                        var _partitionTraverse = this.partitionTraverse(startingPoint, function(neighbor) {
                            return neighbor.sameColorAs(startingPoint);
                        }), _partitionTraverse2 = _slicedToArray(_partitionTraverse, 2), group = _partitionTraverse2[0], _ = _partitionTraverse2[1];
                        return group;
                    },
                    libertiesAt: function libertiesAt(y, x) {
                        var _this3 = this;
                        var point = this.intersectionAt(y, x);
                        var emptyPoints = _utils2.default.flatMap(this.groupAt(point.y, point.x), function(groupPoint) {
                            return _this3.neighborsFor(groupPoint.y, groupPoint.x).filter(function(intersection) {
                                return intersection.isEmpty();
                            });
                        });
                        return _utils2.default.unique(emptyPoints).length;
                    },
                    inAtari: function inAtari(y, x) {
                        return this.libertiesAt(y, x) === 1;
                    },
                    neighborsFor: function neighborsFor(y, x) {
                        var neighbors = [];
                        if (x > 0) neighbors.push(this.intersectionAt(y, x - 1));
                        if (x < this.boardSize - 1) neighbors.push(this.intersectionAt(y, x + 1));
                        if (y > 0) neighbors.push(this.intersectionAt(y - 1, x));
                        if (y < this.boardSize - 1) neighbors.push(this.intersectionAt(y + 1, x));
                        return neighbors;
                    },
                    positionSameAs: function positionSameAs(otherState) {
                        return this._positionHash === otherState._positionHash && this.intersections.every(function(point) {
                            return point.sameColorAs(otherState.intersectionAt(point.y, point.x));
                        });
                    },
                    // Iterative depth-first search traversal. Start from
                    // startingPoint, iteratively follow all neighbors.
                    // If inclusionConditionis met for a neighbor, include it
                    // otherwise, exclude it. At the end, return two arrays:
                    // One for the included neighbors, another for the remaining neighbors.
                    partitionTraverse: function partitionTraverse(startingPoint, inclusionCondition) {
                        var checkedPoints = [];
                        var boundaryPoints = [];
                        var pointsToCheck = [];
                        pointsToCheck.push(startingPoint);
                        while(pointsToCheck.length > 0){
                            var point = pointsToCheck.pop();
                            if (checkedPoints.indexOf(point) > -1) ;
                            else {
                                checkedPoints.push(point);
                                this.neighborsFor(point.y, point.x).forEach(function(neighbor) {
                                    if (checkedPoints.indexOf(neighbor) > -1) ;
                                    else if (inclusionCondition(neighbor)) pointsToCheck.push(neighbor);
                                    else boundaryPoints.push(neighbor);
                                });
                            }
                        }
                        return [
                            checkedPoints,
                            _utils2.default.unique(boundaryPoints)
                        ];
                    }
                };
                BoardState._initialFor = function(boardSize, handicapStones) {
                    this._cache = this._cache || {};
                    this._cache[boardSize] = this._cache[boardSize] || {};
                    if (this._cache[boardSize][handicapStones]) return this._cache[boardSize][handicapStones];
                    var emptyPoints = Array.apply(null, Array(boardSize * boardSize));
                    emptyPoints = emptyPoints.map(function(x, i) {
                        return new _intersection2.default(Math.floor(i / boardSize), i % boardSize);
                    });
                    var hoshiOffset = boardSize > 11 ? 3 : 2;
                    var hoshiPoints = {
                        topRight: {
                            y: hoshiOffset,
                            x: boardSize - hoshiOffset - 1
                        },
                        bottomLeft: {
                            y: boardSize - hoshiOffset - 1,
                            x: hoshiOffset
                        },
                        bottomRight: {
                            y: boardSize - hoshiOffset - 1,
                            x: boardSize - hoshiOffset - 1
                        },
                        topLeft: {
                            y: hoshiOffset,
                            x: hoshiOffset
                        },
                        middle: {
                            y: (boardSize + 1) / 2 - 1,
                            x: (boardSize + 1) / 2 - 1
                        },
                        middleLeft: {
                            y: (boardSize + 1) / 2 - 1,
                            x: hoshiOffset
                        },
                        middleRight: {
                            y: (boardSize + 1) / 2 - 1,
                            x: boardSize - hoshiOffset - 1
                        },
                        middleTop: {
                            y: hoshiOffset,
                            x: (boardSize + 1) / 2 - 1
                        },
                        middleBottom: {
                            y: boardSize - hoshiOffset - 1,
                            x: (boardSize + 1) / 2 - 1
                        }
                    };
                    var handicapPlacements = {
                        0: [],
                        1: [],
                        2: [
                            hoshiPoints.topRight,
                            hoshiPoints.bottomLeft
                        ],
                        3: [
                            hoshiPoints.topRight,
                            hoshiPoints.bottomLeft,
                            hoshiPoints.bottomRight
                        ],
                        4: [
                            hoshiPoints.topRight,
                            hoshiPoints.bottomLeft,
                            hoshiPoints.bottomRight,
                            hoshiPoints.topLeft
                        ],
                        5: [
                            hoshiPoints.topRight,
                            hoshiPoints.bottomLeft,
                            hoshiPoints.bottomRight,
                            hoshiPoints.topLeft,
                            hoshiPoints.middle
                        ],
                        6: [
                            hoshiPoints.topRight,
                            hoshiPoints.bottomLeft,
                            hoshiPoints.bottomRight,
                            hoshiPoints.topLeft,
                            hoshiPoints.middleLeft,
                            hoshiPoints.middleRight
                        ],
                        7: [
                            hoshiPoints.topRight,
                            hoshiPoints.bottomLeft,
                            hoshiPoints.bottomRight,
                            hoshiPoints.topLeft,
                            hoshiPoints.middleLeft,
                            hoshiPoints.middleRight,
                            hoshiPoints.middle
                        ],
                        8: [
                            hoshiPoints.topRight,
                            hoshiPoints.bottomLeft,
                            hoshiPoints.bottomRight,
                            hoshiPoints.topLeft,
                            hoshiPoints.middleLeft,
                            hoshiPoints.middleRight,
                            hoshiPoints.middleTop,
                            hoshiPoints.middleBottom
                        ],
                        9: [
                            hoshiPoints.topRight,
                            hoshiPoints.bottomLeft,
                            hoshiPoints.bottomRight,
                            hoshiPoints.topLeft,
                            hoshiPoints.middleLeft,
                            hoshiPoints.middleRight,
                            hoshiPoints.middleTop,
                            hoshiPoints.middleBottom,
                            hoshiPoints.middle
                        ]
                    };
                    handicapPlacements[handicapStones].forEach(function(p) {
                        emptyPoints[p.y * boardSize + p.x] = new _intersection2.default(p.y, p.x, "black");
                    });
                    var initialState = new BoardState({
                        color: handicapStones > 1 ? "black" : "white",
                        moveNumber: 0,
                        intersections: Object.freeze(emptyPoints),
                        blackStonesCaptured: 0,
                        whiteStonesCaptured: 0,
                        whitePassStones: 0,
                        blackPassStones: 0,
                        boardSize: boardSize
                    });
                    this._cache[boardSize][handicapStones] = initialState;
                    return initialState;
                };
                exports.default = BoardState;
            //# sourceMappingURL=board-state.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {
                "./intersection": 7,
                "./utils": 14,
                "./zobrist": 15
            }
        ],
        3: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _game = require1("./game");
                var _game2 = _interopRequireDefault(_game);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                function _toConsumableArray(arr) {
                    if (Array.isArray(arr)) {
                        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
                        return arr2;
                    } else return Array.from(arr);
                }
                var Client = function Client() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    this._boardElement = options["element"];
                    this._setup(options);
                };
                Client.prototype = {
                    _setup: function _setup(_ref) {
                        var _this = this;
                        var player = _ref.player, gameOptions = _ref.gameOptions, hooks = _ref.hooks;
                        this._player = player;
                        this._hooks = hooks;
                        if (this._player !== "black" && this._player !== "white") throw new Error("Player must be either black or white, but was given: " + this._player);
                        gameOptions["_hooks"] = {
                            handleClick: function handleClick(y, x) {
                                if (_this._busy) return;
                                _this._busy = true;
                                if (_this.isOver()) {
                                    var stonesToBeMarkedDead = _this._game.currentState().groupAt(y, x).map(function(i) {
                                        return {
                                            y: i.y,
                                            x: i.x,
                                            color: i.color
                                        };
                                    });
                                    _this._hooks.submitMarkDeadAt(y, x, stonesToBeMarkedDead, function(result) {
                                        if (result) _this._game.toggleDeadAt(y, x);
                                        _this._busy = false;
                                    });
                                } else {
                                    if (_this._player !== _this.currentPlayer() || _this._game.isIllegalAt(y, x)) {
                                        _this._busy = false;
                                        return;
                                    }
                                    _this._hooks.submitPlay(y, x, function(result) {
                                        if (result) _this._game.playAt(y, x);
                                        _this._busy = false;
                                    });
                                }
                            },
                            hoverValue: function hoverValue(y, x) {
                                if (!_this._busy && _this._player === _this.currentPlayer() && !_this.isOver() && !_this._game.isIllegalAt(y, x)) return _this._player;
                            },
                            gameIsOver: function gameIsOver() {
                                return _this.isOver();
                            }
                        };
                        if (this._boardElement) this._game = new _game2.default(Object.assign({
                            element: this._boardElement
                        }, gameOptions));
                        else this._game = new (Function.prototype.bind.apply(_game2.default, [
                            null
                        ].concat(_toConsumableArray(gameOptions))))();
                    },
                    isOver: function isOver() {
                        return this._game.isOver();
                    },
                    currentPlayer: function currentPlayer() {
                        return this._game.currentPlayer();
                    },
                    receivePlay: function receivePlay(y, x) {
                        if (this._player === this.currentPlayer()) return;
                        this._game.playAt(y, x);
                    },
                    moveNumber: function moveNumber() {
                        return this._game.moveNumber();
                    },
                    receivePass: function receivePass() {
                        if (this._player === this.currentPlayer()) return;
                        this._game.pass();
                    },
                    receiveMarkDeadAt: function receiveMarkDeadAt(y, x) {
                        this._game.toggleDeadAt(y, x);
                    },
                    deadStones: function deadStones() {
                        return this._game.deadStones();
                    },
                    setDeadStones: function setDeadStones(points) {
                        this._game._deadPoints = points.map(function(i) {
                            return {
                                y: i.y,
                                x: i.x
                            };
                        });
                        this._game.render();
                    },
                    pass: function pass() {
                        var _this2 = this;
                        if (this._busy || this._player !== this.currentPlayer() || this.isOver()) return;
                        this._busy = true;
                        this._hooks.submitPass(function(result) {
                            if (result) _this2._game.pass();
                            _this2._busy = false;
                        });
                    }
                };
                exports.default = Client;
            //# sourceMappingURL=client.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {
                "./game": 6
            }
        ],
        4: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _utils = require1("./utils");
                var _utils2 = _interopRequireDefault(_utils);
                var _renderer = require1("./renderer");
                var _renderer2 = _interopRequireDefault(_renderer);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var DOMRenderer = function DOMRenderer(boardElement, _ref) {
                    var hooks = _ref.hooks, options = _ref.options;
                    _renderer2.default.call(this, boardElement, {
                        hooks: hooks,
                        options: options
                    });
                    if (this.smallerStones) _utils2.default.addClass(boardElement, "tenuki-smaller-stones");
                    _utils2.default.addClass(boardElement, "tenuki-dom-renderer");
                };
                DOMRenderer.prototype = Object.create(_renderer2.default.prototype);
                DOMRenderer.prototype.constructor = DOMRenderer;
                DOMRenderer.prototype._setup = function(boardState) {
                    _renderer2.default.prototype._setup.call(this, boardState);
                    this.BOARD_LENGTH += 1;
                    this.computeSizing();
                };
                DOMRenderer.prototype.generateBoard = function(boardState) {
                    var _this = this;
                    var contentsContainer = _utils2.default.createElement("div");
                    _utils2.default.appendElement(contentsContainer, _utils2.default.createElement("div", {
                        class: "lines horizontal"
                    }));
                    _utils2.default.appendElement(contentsContainer, _utils2.default.createElement("div", {
                        class: "lines vertical"
                    }));
                    _utils2.default.appendElement(contentsContainer, _utils2.default.createElement("div", {
                        class: "hoshi-points"
                    }));
                    _utils2.default.appendElement(contentsContainer, _utils2.default.createElement("div", {
                        class: "intersections"
                    }));
                    _renderer2.default.hoshiPositionsFor(boardState.boardSize).forEach(function(h) {
                        var hoshi = _utils2.default.createElement("div", {
                            class: "hoshi"
                        });
                        hoshi.style.left = h.left * (_this.INTERSECTION_GAP_SIZE + 1) + "px";
                        hoshi.style.top = h.top * (_this.INTERSECTION_GAP_SIZE + 1) + "px";
                        _utils2.default.appendElement(contentsContainer.querySelector(".hoshi-points"), hoshi);
                    });
                    for(var y = 0; y < boardState.boardSize; y++){
                        var horizontalLine = _utils2.default.createElement("div", {
                            class: "line horizontal"
                        });
                        horizontalLine.setAttribute("data-left-gutter", boardState.yCoordinateFor(y));
                        _utils2.default.appendElement(contentsContainer.querySelector(".lines.horizontal"), horizontalLine);
                        var verticalLine = _utils2.default.createElement("div", {
                            class: "line vertical"
                        });
                        verticalLine.setAttribute("data-top-gutter", boardState.xCoordinateFor(y));
                        _utils2.default.appendElement(contentsContainer.querySelector(".lines.vertical"), verticalLine);
                        for(var x = 0; x < boardState.boardSize; x++){
                            var intersectionElement = _utils2.default.createElement("div", {
                                class: "intersection empty"
                            });
                            var stoneElement = _utils2.default.createElement("div", {
                                class: "stone"
                            });
                            _utils2.default.appendElement(intersectionElement, stoneElement);
                            intersectionElement.setAttribute("data-position-x", x);
                            intersectionElement.setAttribute("data-position-y", y);
                            intersectionElement.style.left = x * (this.INTERSECTION_GAP_SIZE + 1) + "px";
                            intersectionElement.style.top = y * (this.INTERSECTION_GAP_SIZE + 1) + "px";
                            _utils2.default.appendElement(contentsContainer.querySelector(".intersections"), intersectionElement);
                            this.grid[y] = this.grid[y] || [];
                            this.grid[y][x] = intersectionElement;
                            this.addIntersectionEventListeners(intersectionElement, y, x);
                        }
                    }
                    // prevent the text-selection cursor
                    _utils2.default.addEventListener(contentsContainer.querySelector(".lines.horizontal"), "mousedown", function(e) {
                        e.preventDefault();
                    });
                    _utils2.default.addEventListener(contentsContainer.querySelector(".lines.vertical"), "mousedown", function(e) {
                        e.preventDefault();
                    });
                    contentsContainer.querySelector(".lines.horizontal").style.width = this.INTERSECTION_GAP_SIZE * (boardState.boardSize - 1) + boardState.boardSize + "px";
                    contentsContainer.querySelector(".lines.horizontal").style.height = this.INTERSECTION_GAP_SIZE * (boardState.boardSize - 1) + boardState.boardSize + "px";
                    contentsContainer.querySelector(".lines.vertical").style.width = this.INTERSECTION_GAP_SIZE * (boardState.boardSize - 1) + boardState.boardSize + "px";
                    contentsContainer.querySelector(".lines.vertical").style.height = this.INTERSECTION_GAP_SIZE * (boardState.boardSize - 1) + boardState.boardSize + "px";
                    return contentsContainer;
                };
                DOMRenderer.prototype.setIntersectionClasses = function(intersectionEl, intersection, classes) {
                    if (intersectionEl.className !== classes.join(" ")) intersectionEl.className = classes.join(" ");
                };
                exports.default = DOMRenderer;
            //# sourceMappingURL=dom-renderer.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {
                "./renderer": 10,
                "./utils": 14
            }
        ],
        5: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var EyePoint = function EyePoint(boardState, intersection) {
                    this.boardState = boardState;
                    this.intersection = intersection;
                    Object.freeze(this);
                };
                EyePoint.prototype = {
                    diagonals: function diagonals() {
                        var _this = this;
                        var diagonals = [];
                        var possibleX = [];
                        var possibleY = [];
                        if (this.intersection.x > 0) possibleX.push(this.intersection.x - 1);
                        if (this.intersection.x < this.boardState.boardSize - 1) possibleX.push(this.intersection.x + 1);
                        if (this.intersection.y > 0) possibleY.push(this.intersection.y - 1);
                        if (this.intersection.y < this.boardState.boardSize - 1) possibleY.push(this.intersection.y + 1);
                        possibleX.forEach(function(x) {
                            possibleY.forEach(function(y) {
                                diagonals.push(_this.boardState.intersectionAt(y, x));
                            });
                        });
                        return diagonals;
                    },
                    isFalse: function isFalse() {
                        if (!this.intersection.isEmpty()) return false;
                        var diagonals = this.diagonals();
                        var onFirstLine = diagonals.length <= 2;
                        var neighbors = this.neighbors();
                        var occupiedNeighbors = neighbors.filter(function(i) {
                            return !i.isEmpty();
                        });
                        if (onFirstLine && occupiedNeighbors.length < 1) return false;
                        if (!onFirstLine && occupiedNeighbors.length < 2) return false;
                        var opposingOccupiedDiagonals = diagonals.filter(function(d) {
                            return !d.isEmpty() && !d.sameColorAs(occupiedNeighbors[0]);
                        });
                        if (onFirstLine) return opposingOccupiedDiagonals.length >= 1;
                        else return opposingOccupiedDiagonals.length >= 2;
                    },
                    neighbors: function neighbors() {
                        return this.boardState.neighborsFor(this.intersection.y, this.intersection.x);
                    },
                    filledColor: function filledColor() {
                        if (!this.isFalse()) throw new Error("Attempting to find filled color for a non-false eye");
                        return this.neighbors()[0].value;
                    }
                };
                exports.default = EyePoint;
            //# sourceMappingURL=eye-point.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {}
        ],
        6: [
            function(require1, module1, exports) {
                "use strict";
                var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _slicedToArray = function() {
                    function sliceIterator(arr, i) {
                        var _arr = [];
                        var _n = true;
                        var _d = false;
                        var _e = undefined;
                        try {
                            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                                _arr.push(_s.value);
                                if (i && _arr.length === i) break;
                            }
                        } catch (err) {
                            _d = true;
                            _e = err;
                        } finally{
                            try {
                                if (!_n && _i["return"]) _i["return"]();
                            } finally{
                                if (_d) throw _e;
                            }
                        }
                        return _arr;
                    }
                    return function(arr, i) {
                        if (Array.isArray(arr)) return arr;
                        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }();
                var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function(obj) {
                    return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                } : function(obj) {
                    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
                };
                var _domRenderer = require1("./dom-renderer");
                var _domRenderer2 = _interopRequireDefault(_domRenderer);
                var _svgRenderer = require1("./svg-renderer");
                var _svgRenderer2 = _interopRequireDefault(_svgRenderer);
                var _nullRenderer = require1("./null-renderer");
                var _nullRenderer2 = _interopRequireDefault(_nullRenderer);
                var _boardState = require1("./board-state");
                var _boardState2 = _interopRequireDefault(_boardState);
                var _ruleset = require1("./ruleset");
                var _ruleset2 = _interopRequireDefault(_ruleset);
                var _scorer = require1("./scorer");
                var _scorer2 = _interopRequireDefault(_scorer);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var VALID_GAME_OPTIONS = [
                    "element",
                    "boardSize",
                    "scoring",
                    "handicapStones",
                    "koRule",
                    "komi",
                    "_hooks",
                    "fuzzyStonePlacement",
                    "renderer",
                    "freeHandicapPlacement"
                ];
                var Game = function Game() {
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    this._validateOptions(options);
                    this._defaultBoardSize = 19;
                    this.boardSize = null;
                    this._moves = [];
                    this.callbacks = {
                        postRender: function postRender() {}
                    };
                    this._boardElement = options["element"];
                    this._defaultScoring = "territory";
                    this._defaultKoRule = "simple";
                    this._defaultRenderer = "svg";
                    this._deadPoints = [];
                    this._setup(options);
                };
                Game.prototype = {
                    _validateOptions: function _validateOptions(options) {
                        for(var key in options)if (options.hasOwnProperty(key)) {
                            if (VALID_GAME_OPTIONS.indexOf(key) < 0) throw new Error("Unrecognized game option: " + key);
                            if (typeof options[key] === "undefined" || options[key] === null) throw new Error("Game option " + key + " must not be set as null or undefined");
                        }
                    },
                    _configureOptions: function _configureOptions() {
                        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$boardSize = _ref.boardSize, boardSize = _ref$boardSize === undefined ? this._defaultBoardSize : _ref$boardSize, _ref$komi = _ref.komi, komi = _ref$komi === undefined ? 0 : _ref$komi, _ref$handicapStones = _ref.handicapStones, handicapStones = _ref$handicapStones === undefined ? 0 : _ref$handicapStones, _ref$freeHandicapPlac = _ref.freeHandicapPlacement, freeHandicapPlacement = _ref$freeHandicapPlac === undefined ? false : _ref$freeHandicapPlac, _ref$scoring = _ref.scoring, scoring = _ref$scoring === undefined ? this._defaultScoring : _ref$scoring, _ref$koRule = _ref.koRule, koRule = _ref$koRule === undefined ? this._defaultKoRule : _ref$koRule, _ref$renderer = _ref.renderer, renderer = _ref$renderer === undefined ? this._defaultRenderer : _ref$renderer;
                        if (typeof boardSize !== "number") throw new Error("Board size must be a number, but was: " + (typeof boardSize === "undefined" ? "undefined" : _typeof(boardSize)));
                        if (typeof handicapStones !== "number") throw new Error("Handicap stones must be a number, but was: " + (typeof boardSize === "undefined" ? "undefined" : _typeof(boardSize)));
                        if (handicapStones > 0 && boardSize !== 9 && boardSize !== 13 && boardSize !== 19) throw new Error("Handicap stones not supported on sizes other than 9x9, 13x13 and 19x19");
                        if (handicapStones < 0 || handicapStones === 1 || handicapStones > 9) throw new Error("Only 2 to 9 handicap stones are supported");
                        if (boardSize > 19) throw new Error("cannot generate a board size greater than 19");
                        this.boardSize = boardSize;
                        this.handicapStones = handicapStones;
                        this._freeHandicapPlacement = freeHandicapPlacement;
                        this._scorer = new _scorer2.default({
                            scoreBy: scoring,
                            komi: komi
                        });
                        this._rendererChoice = ({
                            "dom": _domRenderer2.default,
                            "svg": _svgRenderer2.default
                        })[renderer];
                        if (!this._rendererChoice) throw new Error("Unknown renderer: " + renderer);
                        this._ruleset = new _ruleset2.default({
                            koRule: koRule
                        });
                        if (this._freeHandicapPlacement) this._initialState = _boardState2.default._initialFor(boardSize, 0);
                        else this._initialState = _boardState2.default._initialFor(boardSize, handicapStones);
                    },
                    _stillPlayingHandicapStones: function _stillPlayingHandicapStones() {
                        return this._freeHandicapPlacement && this.handicapStones > 0 && this._moves.length < this.handicapStones;
                    },
                    _setup: function _setup() {
                        var _this = this;
                        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        this._validateOptions(options);
                        this._configureOptions(options);
                        if (this._boardElement) {
                            var defaultRendererHooks = {
                                handleClick: function handleClick(y, x) {
                                    if (_this.isOver()) _this.toggleDeadAt(y, x);
                                    else _this.playAt(y, x);
                                },
                                hoverValue: function hoverValue(y, x) {
                                    if (!_this.isOver() && !_this.isIllegalAt(y, x)) return _this.currentPlayer();
                                },
                                gameIsOver: function gameIsOver() {
                                    return _this.isOver();
                                }
                            };
                            this.renderer = new this._rendererChoice(this._boardElement, {
                                hooks: options["_hooks"] || defaultRendererHooks,
                                options: {
                                    fuzzyStonePlacement: options["fuzzyStonePlacement"]
                                }
                            });
                        } else this.renderer = new _nullRenderer2.default();
                        this.render();
                    },
                    intersectionAt: function intersectionAt(y, x) {
                        return this.currentState().intersectionAt(y, x);
                    },
                    intersections: function intersections() {
                        return this.currentState().intersections;
                    },
                    deadStones: function deadStones() {
                        return this._deadPoints;
                    },
                    coordinatesFor: function coordinatesFor(y, x) {
                        return this.currentState().xCoordinateFor(x) + this.currentState().yCoordinateFor(y);
                    },
                    currentPlayer: function currentPlayer() {
                        if (this._stillPlayingHandicapStones()) return "black";
                        return this.currentState().nextColor();
                    },
                    isWhitePlaying: function isWhitePlaying() {
                        return this.currentPlayer() === "white";
                    },
                    isBlackPlaying: function isBlackPlaying() {
                        return this.currentPlayer() === "black";
                    },
                    score: function score() {
                        return this._scorer.score(this);
                    },
                    currentState: function currentState() {
                        return this._moves[this._moves.length - 1] || this._initialState;
                    },
                    moveNumber: function moveNumber() {
                        return this.currentState().moveNumber;
                    },
                    playAt: function playAt(y, x) {
                        var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$render = _ref2.render, render = _ref2$render === undefined ? true : _ref2$render;
                        if (this.isIllegalAt(y, x)) return false;
                        var newState = this.currentState().playAt(y, x, this.currentPlayer());
                        var _newState = newState, koPoint = _newState.koPoint;
                        if (koPoint && !this._ruleset._isKoViolation(koPoint.y, koPoint.x, newState, this._moves.concat(newState))) newState = newState.copyWithAttributes({
                            koPoint: null
                        });
                        this._moves.push(newState);
                        if (render) this.render();
                        return true;
                    },
                    pass: function pass() {
                        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$render = _ref3.render, render = _ref3$render === undefined ? true : _ref3$render;
                        if (this.isOver()) return false;
                        var newState = this.currentState().playPass(this.currentPlayer());
                        this._moves.push(newState);
                        if (render) this.render();
                        return true;
                    },
                    isOver: function isOver() {
                        if (this._moves.length < 2) return false;
                        var finalMove = this._moves[this._moves.length - 1];
                        var previousMove = this._moves[this._moves.length - 2];
                        return finalMove.pass && previousMove.pass;
                    },
                    markDeadAt: function markDeadAt(y, x) {
                        var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref4$render = _ref4.render, render = _ref4$render === undefined ? true : _ref4$render;
                        if (this._isDeadAt(y, x)) return true;
                        return this._setDeadStatus(y, x, true, {
                            render: render
                        });
                    },
                    unmarkDeadAt: function unmarkDeadAt(y, x) {
                        var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref5$render = _ref5.render, render = _ref5$render === undefined ? true : _ref5$render;
                        if (!this._isDeadAt(y, x)) return true;
                        return this._setDeadStatus(y, x, false, {
                            render: render
                        });
                    },
                    toggleDeadAt: function toggleDeadAt(y, x) {
                        var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref6$render = _ref6.render, render = _ref6$render === undefined ? true : _ref6$render;
                        return this._setDeadStatus(y, x, !this._isDeadAt(y, x), {
                            render: render
                        });
                    },
                    _setDeadStatus: function _setDeadStatus(y, x, markingDead) {
                        var _this2 = this;
                        var _ref7 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {}, _ref7$render = _ref7.render, render = _ref7$render === undefined ? true : _ref7$render;
                        var selectedIntersection = this.intersectionAt(y, x);
                        if (selectedIntersection.isEmpty()) return;
                        var chosenDead = [];
                        var _currentState$partiti = this.currentState().partitionTraverse(selectedIntersection, function(intersection) {
                            return intersection.isEmpty() || intersection.sameColorAs(selectedIntersection);
                        }), _currentState$partiti2 = _slicedToArray(_currentState$partiti, 1), candidates = _currentState$partiti2[0];
                        candidates.forEach(function(sameColorOrEmpty) {
                            if (!sameColorOrEmpty.isEmpty()) chosenDead.push(sameColorOrEmpty);
                        });
                        chosenDead.forEach(function(intersection) {
                            if (markingDead) _this2._deadPoints.push({
                                y: intersection.y,
                                x: intersection.x
                            });
                            else _this2._deadPoints = _this2._deadPoints.filter(function(dead) {
                                return !(dead.y === intersection.y && dead.x === intersection.x);
                            });
                        });
                        if (render) this.render();
                        return true;
                    },
                    _isDeadAt: function _isDeadAt(y, x) {
                        return this._deadPoints.some(function(dead) {
                            return dead.y === y && dead.x === x;
                        });
                    },
                    isIllegalAt: function isIllegalAt(y, x) {
                        return this._ruleset.isIllegal(y, x, this);
                    },
                    territory: function territory() {
                        if (!this.isOver()) return {
                            black: [],
                            white: []
                        };
                        return this._scorer.territory(this);
                    },
                    undo: function undo() {
                        this._moves.pop();
                        this.render();
                    },
                    render: function render() {
                        if (!this.isOver()) this._deadPoints = [];
                        this.renderer.render(this.currentState(), {
                            territory: this.territory(),
                            deadStones: this.deadStones()
                        });
                        this.callbacks.postRender(this);
                    }
                };
                exports.default = Game;
            //# sourceMappingURL=game.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {
                "./board-state": 2,
                "./dom-renderer": 4,
                "./null-renderer": 8,
                "./ruleset": 11,
                "./scorer": 12,
                "./svg-renderer": 13
            }
        ],
        7: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Intersection = function Intersection(y, x, value) {
                    this.y = y;
                    this.x = x;
                    this.value = value || "empty";
                    Object.freeze(this);
                };
                Intersection.prototype = {
                    isOccupiedWith: function isOccupiedWith(color) {
                        if (this.isEmpty()) return false;
                        return this.value === color;
                    },
                    isBlack: function isBlack() {
                        return this.value === "black";
                    },
                    isWhite: function isWhite() {
                        return this.value === "white";
                    },
                    isEmpty: function isEmpty() {
                        return this.value === "empty";
                    },
                    sameColorAs: function sameColorAs(otherIntersection) {
                        return this.value === otherIntersection.value;
                    }
                };
                exports.default = Intersection;
            //# sourceMappingURL=intersection.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {}
        ],
        8: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = NullRenderer;
                function NullRenderer() {
                    this.setup = function() {};
                    this.render = function() {};
                    this.renderTerritory = function() {};
                }
            //# sourceMappingURL=null-renderer.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm51bGwtcmVuZGVyZXIuanMiXSwibmFtZXMiOlsiT2JqZWN0IiwiZGVmaW5lUHJvcGVydHkiLCJleHBvcnRzIiwidmFsdWUiLCJkZWZhdWx0IiwiTnVsbFJlbmRlcmVyIiwic2V0dXAiLCJyZW5kZXIiLCJyZW5kZXJUZXJyaXRvcnkiXSwibWFwcGluZ3MiOiJBQUFBOztBQUVBQSxPQUFPQyxjQUFQLENBQXNCQyxPQUF0QixFQUErQixZQUEvQixFQUE2QztBQUMzQ0MsU0FBTztBQURvQyxDQUE3QztBQUdBRCxRQUFRRSxPQUFSLEdBQWtCQyxZQUFsQjtBQUNBLFNBQVNBLFlBQVQsR0FBd0I7QUFDdEIsT0FBS0MsS0FBTCxHQUFhLFlBQVksQ0FBRSxDQUEzQjtBQUNBLE9BQUtDLE1BQUwsR0FBYyxZQUFZLENBQUUsQ0FBNUI7QUFDQSxPQUFLQyxlQUFMLEdBQXVCLFlBQVksQ0FBRSxDQUFyQztBQUNEOztBQUVEIiwiZmlsZSI6Im51bGwtcmVuZGVyZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJcInVzZSBzdHJpY3RcIjtcblxuT2JqZWN0LmRlZmluZVByb3BlcnR5KGV4cG9ydHMsIFwiX19lc01vZHVsZVwiLCB7XG4gIHZhbHVlOiB0cnVlXG59KTtcbmV4cG9ydHMuZGVmYXVsdCA9IE51bGxSZW5kZXJlcjtcbmZ1bmN0aW9uIE51bGxSZW5kZXJlcigpIHtcbiAgdGhpcy5zZXR1cCA9IGZ1bmN0aW9uICgpIHt9O1xuICB0aGlzLnJlbmRlciA9IGZ1bmN0aW9uICgpIHt9O1xuICB0aGlzLnJlbmRlclRlcnJpdG9yeSA9IGZ1bmN0aW9uICgpIHt9O1xufVxuXG4vLyMgc291cmNlTWFwcGluZ1VSTD1udWxsLXJlbmRlcmVyLmpzLm1hcCJdfQ==
            },
            {}
        ],
        9: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _slicedToArray = function() {
                    function sliceIterator(arr, i) {
                        var _arr = [];
                        var _n = true;
                        var _d = false;
                        var _e = undefined;
                        try {
                            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                                _arr.push(_s.value);
                                if (i && _arr.length === i) break;
                            }
                        } catch (err) {
                            _d = true;
                            _e = err;
                        } finally{
                            try {
                                if (!_n && _i["return"]) _i["return"]();
                            } finally{
                                if (_d) throw _e;
                            }
                        }
                        return _arr;
                    }
                    return function(arr, i) {
                        if (Array.isArray(arr)) return arr;
                        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }();
                var _utils = require1("./utils");
                var _utils2 = _interopRequireDefault(_utils);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var Region = function Region(boardState, intersections) {
                    this.boardState = boardState;
                    this.intersections = intersections;
                    this._computed = {};
                    Object.freeze(this);
                };
                Region._startingAt = function(boardState, y, x) {
                    var startingPoint = boardState.intersectionAt(y, x);
                    var _boardState$partition = boardState.partitionTraverse(startingPoint, function(neighbor) {
                        return neighbor.sameColorAs(startingPoint);
                    }), _boardState$partition2 = _slicedToArray(_boardState$partition, 2), includedPoints = _boardState$partition2[0], boundaryPoints = _boardState$partition2[1];
                    return [
                        includedPoints,
                        boundaryPoints
                    ];
                };
                Region.allFor = function(boardState) {
                    var checkedPoints = [];
                    var regions = [];
                    boardState.intersections.forEach(function(point) {
                        if (checkedPoints.indexOf(point) > -1) ;
                        else {
                            var _boardState$partition3 = boardState.partitionTraverse(point, function(neighbor) {
                                return neighbor.sameColorAs(point);
                            }), _boardState$partition4 = _slicedToArray(_boardState$partition3, 2), regionPoints = _boardState$partition4[0], _ = _boardState$partition4[1];
                            regions.push(new Region(boardState, regionPoints));
                            checkedPoints = checkedPoints.concat(regionPoints);
                        }
                    });
                    return regions;
                };
                Region.merge = function(regions, region) {
                    var mergedRegions = [
                        region
                    ];
                    var length = -1;
                    while(mergedRegions.length !== length){
                        length = mergedRegions.length;
                        mergedRegions = regions.filter(function(r) {
                            return r.isEmpty() && r.isTerritory() && r.territoryColor() === region.territoryColor() && r.expandedBoundaryStones().some(function(stone) {
                                return mergedRegions.some(function(latestRegion) {
                                    return latestRegion.expandedBoundaryStones().indexOf(stone) > -1;
                                });
                            });
                        });
                    }
                    return mergedRegions;
                };
                Region.prototype = {
                    isEmpty: function isEmpty() {
                        return this.intersections[0].isEmpty();
                    },
                    isTerritory: function isTerritory() {
                        var point = this.intersections[0];
                        if (!point.isEmpty()) return false;
                        var _Region$_startingAt = Region._startingAt(this.boardState, point.y, point.x), _Region$_startingAt2 = _slicedToArray(_Region$_startingAt, 2), _ = _Region$_startingAt2[0], boundaryPoints = _Region$_startingAt2[1];
                        var surroundingColors = _utils2.default.unique(boundaryPoints.map(function(i) {
                            return i.value;
                        }));
                        var isTerritory = surroundingColors.length === 1 && surroundingColors[0] !== "empty";
                        return isTerritory;
                    },
                    territoryColor: function territoryColor() {
                        var point = this.intersections[0];
                        var _Region$_startingAt3 = Region._startingAt(this.boardState, point.y, point.x), _Region$_startingAt4 = _slicedToArray(_Region$_startingAt3, 2), _ = _Region$_startingAt4[0], boundaryPoints = _Region$_startingAt4[1];
                        var surroundingColors = _utils2.default.unique(boundaryPoints.map(function(i) {
                            return i.value;
                        }));
                        var isTerritory = surroundingColors.length === 1 && surroundingColors[0] !== "empty";
                        if (!point.isEmpty() || !isTerritory) throw new Error("Attempted to obtain territory color for something that isn't territory, region containing " + point.y + "," + point.x);
                        else return surroundingColors[0];
                    },
                    isBlack: function isBlack() {
                        return this.territoryColor() === "black";
                    },
                    isWhite: function isWhite() {
                        return this.territoryColor() === "white";
                    },
                    isNeutral: function isNeutral() {
                        return !this.intersections[0].isBlack() && !this.intersections[0].isWhite() && !this.isTerritory();
                    },
                    exterior: function exterior() {
                        var _this = this;
                        return this.boardState.intersections.filter(function(i) {
                            return _this.intersections.indexOf(i) < 0 && _this.boardState.neighborsFor(i.y, i.x).some(function(neighbor) {
                                return _this.intersections.indexOf(neighbor) > -1;
                            });
                        });
                    },
                    boundaryStones: function boundaryStones() {
                        var _this2 = this;
                        if (this._computed.boundaryStones) return this._computed.boundaryStones;
                        if (!this.isEmpty()) throw new Error("Attempted to obtain boundary stones for non-empty region");
                        this._computed.boundaryStones = this.exterior().filter(function(i) {
                            return !i.sameColorAs(_this2.intersections[0]);
                        });
                        return this._computed.boundaryStones;
                    },
                    expandedBoundaryStones: function expandedBoundaryStones() {
                        if (this._computed.expandedBoundaryStones) return this._computed.expandedBoundaryStones;
                        var boundaryStones = this.boundaryStones();
                        var regions = Region.allFor(this.boardState).filter(function(r) {
                            return r.intersections.some(function(i) {
                                return boundaryStones.indexOf(i) > -1;
                            });
                        });
                        this._computed.expandedBoundaryStones = _utils2.default.flatMap(regions, function(r) {
                            return r.intersections;
                        });
                        return this._computed.expandedBoundaryStones;
                    },
                    lengthOfTerritoryBoundary: function lengthOfTerritoryBoundary() {
                        var _this3 = this;
                        // count the empty border points to treat the edge of the board itself as points
                        var borderPoints = this.intersections.filter(function(i) {
                            return i.y === 0 || i.y === _this3.boardState.boardSize - 1 || i.x === 0 || i.x === _this3.boardState.boardSize - 1;
                        });
                        var cornerPoints = this.intersections.filter(function(i) {
                            return i.y % _this3.boardState.boardSize - 1 === 0 && i.x % _this3.boardState.boardSize - 1 === 0;
                        });
                        return this.boundaryStones().length + borderPoints.length + cornerPoints.length;
                    },
                    containsSquareFour: function containsSquareFour() {
                        var _this4 = this;
                        return this.intersections.some(function(i) {
                            return [
                                [
                                    0,
                                    0
                                ],
                                [
                                    0,
                                    1
                                ],
                                [
                                    1,
                                    0
                                ],
                                [
                                    1,
                                    1
                                ]
                            ].every(function(_ref) {
                                var _ref2 = _slicedToArray(_ref, 2), yOffset = _ref2[0], xOffset = _ref2[1];
                                var y = i.y + yOffset;
                                var x = i.x + xOffset;
                                var onTheBoard = y >= 0 && y < _this4.boardState.boardSize && x >= 0 && x < _this4.boardState.boardSize;
                                return onTheBoard && _this4.boardState.intersectionAt(y, x).sameColorAs(i);
                            });
                        });
                    },
                    containsCurvedFour: function containsCurvedFour() {
                        var _this5 = this;
                        return this.intersections.some(function(i) {
                            return [
                                [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        1,
                                        0
                                    ],
                                    [
                                        2,
                                        0
                                    ],
                                    [
                                        2,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        -1,
                                        2
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        1
                                    ],
                                    [
                                        0,
                                        2
                                    ]
                                ],
                                [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        1
                                    ],
                                    [
                                        1,
                                        1
                                    ],
                                    [
                                        2,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        -1,
                                        0
                                    ],
                                    [
                                        -1,
                                        1
                                    ],
                                    [
                                        -1,
                                        2
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ],
                                [
                                    [
                                        -2,
                                        1
                                    ],
                                    [
                                        -1,
                                        1
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        0,
                                        1
                                    ]
                                ],
                                [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        1,
                                        0
                                    ],
                                    [
                                        1,
                                        1
                                    ],
                                    [
                                        1,
                                        2
                                    ]
                                ],
                                [
                                    [
                                        0,
                                        -1
                                    ],
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        1,
                                        -1
                                    ],
                                    [
                                        2,
                                        -1
                                    ]
                                ],
                                [
                                    [
                                        -1,
                                        -2
                                    ],
                                    [
                                        -1,
                                        -1
                                    ],
                                    [
                                        -1,
                                        0
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ]
                            ].some(function(expectedPoints) {
                                return expectedPoints.every(function(_ref3) {
                                    var _ref4 = _slicedToArray(_ref3, 2), yOffset = _ref4[0], xOffset = _ref4[1];
                                    var y = i.y + yOffset;
                                    var x = i.x + xOffset;
                                    var onTheBoard = y >= 0 && y < _this5.boardState.boardSize && x >= 0 && x < _this5.boardState.boardSize;
                                    return onTheBoard && _this5.boardState.intersectionAt(y, x).sameColorAs(i);
                                });
                            });
                        });
                    },
                    numberOfEyes: function numberOfEyes() {
                        if (!this.intersections[0].isEmpty()) throw new Error("Unexpected calculation of number of eyes for a non-empty region containing " + this.intersections[0].y + "," + this.intersections[0].x);
                        var boundaryLength = this.lengthOfTerritoryBoundary();
                        if (boundaryLength < 2) throw new Error("Unexpected boundary length of " + boundaryLength + " for region including " + this.intersections[0].y + "," + this.intersections[0].x);
                        if (boundaryLength >= 10) return 2;
                        var eyes = void 0;
                        switch(boundaryLength){
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                eyes = 1;
                                break;
                            case 7:
                                eyes = 1.5;
                                break;
                            case 8:
                                if (this.containsSquareFour()) eyes = 1;
                                else if (this.containsCurvedFour()) eyes = 2;
                                else eyes = 1.5;
                                break;
                            case 9:
                                if (this.containsSquareFour()) eyes = 1.5;
                                else eyes = 2;
                                break;
                            default:
                                throw new Error("unhandled boundary length " + boundaryLength);
                        }
                        return eyes;
                    }
                };
                exports.default = Region;
            //# sourceMappingURL=region.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {
                "./utils": 14
            }
        ],
        10: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _slicedToArray = function() {
                    function sliceIterator(arr, i) {
                        var _arr = [];
                        var _n = true;
                        var _d = false;
                        var _e = undefined;
                        try {
                            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                                _arr.push(_s.value);
                                if (i && _arr.length === i) break;
                            }
                        } catch (err) {
                            _d = true;
                            _e = err;
                        } finally{
                            try {
                                if (!_n && _i["return"]) _i["return"]();
                            } finally{
                                if (_d) throw _e;
                            }
                        }
                        return _arr;
                    }
                    return function(arr, i) {
                        if (Array.isArray(arr)) return arr;
                        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
                        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
                    };
                }();
                var _utils = require1("./utils");
                var _utils2 = _interopRequireDefault(_utils);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var Renderer = function Renderer(boardElement, _ref) {
                    var hooks = _ref.hooks, options = _ref.options;
                    this.INTERSECTION_GAP_SIZE = 28;
                    this.GUTTER_MARGIN = this.INTERSECTION_GAP_SIZE - 3;
                    this.BASE_MARGIN = this.INTERSECTION_GAP_SIZE - 10;
                    this.hasCoordinates = boardElement.hasAttribute("data-include-coordinates");
                    this.MARGIN = this.hasCoordinates ? this.BASE_MARGIN + this.GUTTER_MARGIN : this.BASE_MARGIN;
                    this.boardElement = boardElement;
                    this.grid = [];
                    this.hooks = hooks || {};
                    this._options = options || {};
                    this._initialized = false;
                    if (this._options["fuzzyStonePlacement"]) {
                        _utils2.default.addClass(boardElement, "tenuki-fuzzy-placement");
                        _utils2.default.removeClass(boardElement, "tenuki-board-flat");
                        _utils2.default.addClass(boardElement, "tenuki-board-nonflat");
                        this.smallerStones = true;
                    }
                    this.flatStones = _utils2.default.hasClass(boardElement, "tenuki-board-flat");
                    if (!this.flatStones) _utils2.default.addClass(boardElement, "tenuki-board-nonflat");
                };
                Renderer.hoshiPositionsFor = function(boardSize) {
                    var hoshiElements = [];
                    if (boardSize < 7) {
                        if (boardSize > 1 && boardSize % 2 === 1) {
                            var hoshi = {};
                            hoshi.top = (boardSize - 1) / 2;
                            hoshi.left = hoshi.top;
                            hoshiElements.push(hoshi);
                        }
                    // no hoshi
                    } else {
                        var hoshiOffset = boardSize > 11 ? 3 : 2;
                        for(var hoshiY = 0; hoshiY < 3; hoshiY++)for(var hoshiX = 0; hoshiX < 3; hoshiX++){
                            if ((boardSize === 7 || boardSize % 2 === 0) && (hoshiY === 1 || hoshiX === 1)) continue;
                            var _hoshi = {};
                            if (hoshiY === 0) _hoshi.top = hoshiOffset;
                            if (hoshiY === 1) _hoshi.top = (boardSize + 1) / 2 - 1;
                            if (hoshiY === 2) _hoshi.top = boardSize - hoshiOffset - 1;
                            if (hoshiX === 0) _hoshi.left = hoshiOffset;
                            if (hoshiX === 1) _hoshi.left = (boardSize + 1) / 2 - 1;
                            if (hoshiX === 2) _hoshi.left = boardSize - hoshiOffset - 1;
                            hoshiElements.push(_hoshi);
                        }
                    }
                    return hoshiElements;
                };
                Renderer.prototype = {
                    _setup: function _setup(boardState) {
                        var renderer = this;
                        var boardElement = this.boardElement;
                        renderer.BOARD_LENGTH = 2 * this.MARGIN + (boardState.boardSize - 1) * (this.INTERSECTION_GAP_SIZE + 1);
                        var innerContainer = _utils2.default.createElement("div", {
                            class: "tenuki-inner-container"
                        });
                        renderer.innerContainer = innerContainer;
                        _utils2.default.appendElement(boardElement, innerContainer);
                        var zoomContainer = _utils2.default.createElement("div", {
                            class: "tenuki-zoom-container"
                        });
                        renderer.zoomContainer = zoomContainer;
                        _utils2.default.appendElement(innerContainer, zoomContainer);
                        renderer.cancelZoomElement = _utils2.default.createElement("div", {
                            class: "cancel-zoom"
                        });
                        var cancelZoomBackdrop = _utils2.default.createElement("div", {
                            class: "cancel-zoom-backdrop"
                        });
                        _utils2.default.addEventListener(renderer.cancelZoomElement, "click", function(event) {
                            event.preventDefault();
                            renderer.zoomOut();
                            return false;
                        });
                        _utils2.default.addEventListener(cancelZoomBackdrop, "click", function(event) {
                            event.preventDefault();
                            renderer.zoomOut();
                            return false;
                        });
                        _utils2.default.appendElement(innerContainer, renderer.cancelZoomElement);
                        _utils2.default.appendElement(innerContainer, cancelZoomBackdrop);
                        // https://developer.mozilla.org/en-US/docs/Web/Events/resize
                        var throttle = function throttle(type, name) {
                            var running = false;
                            var func = function func() {
                                if (running) return;
                                running = true;
                                window.requestAnimationFrame(function() {
                                    window.dispatchEvent(new CustomEvent(name));
                                    running = false;
                                });
                            };
                            window.addEventListener(type, func);
                        };
                        throttle("resize", "optimizedResize");
                        var specificRendererBoard = this.generateBoard(boardState, {
                            hasCoordinates: this.hasCoordinates,
                            smallerStones: this.smallerStones,
                            flatStones: this.flatStones
                        });
                        _utils2.default.appendElement(zoomContainer, specificRendererBoard);
                        window.requestAnimationFrame(function() {
                            // we'll potentially be zooming on touch devices
                            zoomContainer.style.willChange = "transform";
                            renderer.computeSizing();
                        });
                        window.addEventListener("optimizedResize", function() {
                            renderer.computeSizing();
                        });
                        renderer.touchmoveChangedTouch = null;
                        renderer.touchstartEventHandler = renderer.handleTouchStart.bind(renderer);
                        renderer.touchmoveEventHandler = renderer.handleTouchMove.bind(renderer);
                        renderer.touchendEventHandler = renderer.handleTouchEnd.bind(renderer);
                        _utils2.default.addEventListener(renderer.innerContainer, "touchstart", renderer.touchstartEventHandler);
                        _utils2.default.addEventListener(renderer.innerContainer, "touchend", renderer.touchendEventHandler);
                        _utils2.default.addEventListener(renderer.innerContainer, "touchmove", renderer.touchmoveEventHandler);
                    },
                    computeSizing: function computeSizing() {
                        var renderer = this;
                        var innerContainer = this.innerContainer;
                        var zoomContainer = this.zoomContainer;
                        var boardElement = this.boardElement;
                        // reset everything so we can calculate against new values
                        innerContainer.style.height = "";
                        innerContainer.style.width = "";
                        zoomContainer.style.height = "";
                        zoomContainer.style.width = "";
                        innerContainer.style.transform = "";
                        // zoomContainer.style.willChange = "";
                        boardElement.style.width = "";
                        boardElement.style.height = "";
                        // dev-friendly reset of whether this is a touch device
                        renderer._touchEventFired = null;
                        innerContainer.style.width = renderer.BOARD_LENGTH + "px";
                        innerContainer.style.height = renderer.BOARD_LENGTH + "px";
                        zoomContainer.style.width = renderer.BOARD_LENGTH + "px";
                        zoomContainer.style.height = renderer.BOARD_LENGTH + "px";
                        var scaleX = innerContainer.parentNode.clientWidth / innerContainer.clientWidth;
                        var scaleY = innerContainer.parentNode.clientHeight / innerContainer.clientHeight;
                        var scale = Math.min(scaleX, scaleY);
                        if (scale > 0) {
                            if (scale < 1) _utils2.default.addClass(boardElement, "tenuki-scaled");
                            else _utils2.default.removeClass(boardElement, "tenuki-scaled");
                            if (scale < 1 || scale > 1) {
                                innerContainer.style["transform-origin"] = "top left";
                                innerContainer.style.transform = "scale3d(" + scale + ", " + scale + ", 1)";
                            }
                        }
                        // reset the outer element's height to match, ensuring that we free up any lingering whitespace
                        boardElement.style.width = innerContainer.getBoundingClientRect().width + "px";
                        boardElement.style.height = innerContainer.getBoundingClientRect().height + "px";
                        // Work around lack of re-raster in Chrome. See https://github.com/w3c/csswg-drafts/issues/236
                        // and https://bugs.chromium.org/p/chromium/issues/detail?id=600482 for more
                        // information. This is preventing, e.g., horizontal/vertical line width
                        // mismatches after scaling. By adding this, lines are re-rastered and are
                        // all the same width, as if the user had hit refresh at the new viewport
                        // size.
                        zoomContainer.style.willChange = "";
                        window.requestAnimationFrame(function() {
                            zoomContainer.style.willChange = "transform";
                        });
                    },
                    addIntersectionEventListeners: function addIntersectionEventListeners(element, y, x) {
                        var renderer = this;
                        _utils2.default.addEventListener(element, "mouseenter", function() {
                            var hoveredYPosition = y;
                            var hoveredXPosition = x;
                            var hoverValue = renderer.hooks.hoverValue(hoveredYPosition, hoveredXPosition);
                            if (hoverValue) {
                                _utils2.default.addClass(element, "hovered");
                                _utils2.default.addClass(element, hoverValue);
                            }
                        });
                        _utils2.default.addEventListener(element, "mouseleave", function() {
                            if (_utils2.default.hasClass(this, "hovered")) {
                                _utils2.default.removeClass(element, "hovered");
                                _utils2.default.removeClass(element, "black");
                                _utils2.default.removeClass(element, "white");
                            }
                            renderer.resetTouchedPoint();
                        });
                        _utils2.default.addEventListener(element, "click", function() {
                            var playedYPosition = y;
                            var playedXPosition = x;
                            // if this isn't part of a touch,
                            // or it is and the user is zoomed in,
                            // or it's game over and we're marking stones dead,
                            // then don't use the zoom/double-select system.
                            if (!renderer._touchEventFired || document.body.clientWidth / window.innerWidth > 1 || renderer.hooks.gameIsOver()) {
                                renderer.hooks.handleClick(playedYPosition, playedXPosition);
                                return;
                            }
                            if (renderer.touchedPoint) {
                                if (element === renderer.touchedPoint) renderer.hooks.handleClick(playedYPosition, playedXPosition);
                                else renderer.showPossibleMoveAt(element, playedYPosition, playedXPosition);
                            } else renderer.showPossibleMoveAt(element, playedYPosition, playedXPosition);
                        });
                    },
                    handleTouchStart: function handleTouchStart(event) {
                        var renderer = this;
                        renderer._touchEventFired = true;
                        if (event.touches.length > 1) {
                            if (renderer.zoomedIn) event.preventDefault();
                            return;
                        }
                        if (!renderer.zoomedIn) return;
                        var xCursor = event.changedTouches[0].clientX;
                        var yCursor = event.changedTouches[0].clientY;
                        renderer.dragStartX = xCursor;
                        renderer.dragStartY = yCursor;
                        renderer.zoomContainer.style.transition = "none";
                        renderer.animationFrameRequestID = window.requestAnimationFrame(renderer.processDragDelta.bind(renderer));
                    },
                    handleTouchMove: function handleTouchMove(event) {
                        var renderer = this;
                        if (event.touches.length > 1) return;
                        if (!renderer.zoomedIn) return true;
                        // prevent pull-to-refresh
                        event.preventDefault();
                        renderer.touchmoveChangedTouch = event.changedTouches[0];
                        renderer.moveInProgress = true;
                    },
                    handleTouchEnd: function handleTouchEnd(event) {
                        var renderer = this;
                        if (event.touches.length > 1) return;
                        if (!renderer.zoomedIn) return;
                        renderer.zoomContainer.style.transition = "";
                        if (!renderer.moveInProgress) return;
                        renderer.translateY = renderer.lastTranslateY;
                        renderer.translateX = renderer.lastTranslateX;
                        renderer.moveInProgress = false;
                        renderer.touchmoveChangedTouch = null;
                        window.cancelAnimationFrame(renderer.animationFrameRequestID);
                    },
                    processDragDelta: function processDragDelta() {
                        var renderer = this;
                        if (!renderer.touchmoveChangedTouch) {
                            renderer.animationFrameRequestID = window.requestAnimationFrame(renderer.processDragDelta.bind(renderer));
                            return;
                        }
                        var innerContainer = renderer.innerContainer;
                        var xCursor = renderer.touchmoveChangedTouch.clientX;
                        var yCursor = renderer.touchmoveChangedTouch.clientY;
                        var deltaX = xCursor - renderer.dragStartX;
                        var deltaY = yCursor - renderer.dragStartY;
                        var translateY = renderer.translateY + deltaY / 2.5;
                        var translateX = renderer.translateX + deltaX / 2.5;
                        if (translateY > 0.5 * innerContainer.clientHeight - renderer.MARGIN) translateY = 0.5 * innerContainer.clientHeight - renderer.MARGIN;
                        if (translateX > 0.5 * innerContainer.clientWidth - renderer.MARGIN) translateX = 0.5 * innerContainer.clientWidth - renderer.MARGIN;
                        if (translateY < -0.5 * innerContainer.clientHeight + renderer.MARGIN) translateY = -0.5 * innerContainer.clientHeight + renderer.MARGIN;
                        if (translateX < -0.5 * innerContainer.clientWidth + renderer.MARGIN) translateX = -0.5 * innerContainer.clientWidth + renderer.MARGIN;
                        renderer.zoomContainer.style.transform = "translate3d(" + 2.5 * translateX + "px, " + 2.5 * translateY + "px, 0) scale3d(2.5, 2.5, 1)";
                        renderer.lastTranslateX = translateX;
                        renderer.lastTranslateY = translateY;
                        renderer.animationFrameRequestID = window.requestAnimationFrame(renderer.processDragDelta.bind(renderer));
                    },
                    showPossibleMoveAt: function showPossibleMoveAt(intersectionElement, y, x) {
                        var renderer = this;
                        var boardElement = this.boardElement;
                        var zoomContainer = this.zoomContainer;
                        renderer.zoomContainerHeight = renderer.zoomContainerHeight || zoomContainer.clientHeight;
                        renderer.zoomContainerWidth = renderer.zoomContainerWidth || zoomContainer.clientWidth;
                        renderer.touchedPoint = intersectionElement;
                        if (_utils2.default.hasClass(boardElement, "tenuki-scaled")) {
                            var top = y * (this.INTERSECTION_GAP_SIZE + 1);
                            var left = x * (this.INTERSECTION_GAP_SIZE + 1);
                            var translateY = 0.5 * renderer.zoomContainerHeight - top - renderer.MARGIN;
                            var translateX = 0.5 * renderer.zoomContainerWidth - left - renderer.MARGIN;
                            zoomContainer.style.transform = "translate3d(" + 2.5 * translateX + "px, " + 2.5 * translateY + "px, 0) scale3d(2.5, 2.5, 1)";
                            renderer.translateY = translateY;
                            renderer.translateX = translateX;
                            _utils2.default.addClass(renderer.cancelZoomElement, "visible");
                            renderer.zoomedIn = true;
                        }
                    },
                    resetTouchedPoint: function resetTouchedPoint() {
                        var renderer = this;
                        renderer.touchedPoint = null;
                    },
                    zoomOut: function zoomOut() {
                        var renderer = this;
                        this.resetTouchedPoint();
                        renderer.zoomContainer.style.transform = "";
                        renderer.zoomContainer.style.transition = "";
                        renderer.dragStartX = null;
                        renderer.dragStartY = null;
                        renderer.translateY = null;
                        renderer.translateX = null;
                        renderer.lastTranslateX = null;
                        renderer.lastTranslateY = null;
                        _utils2.default.removeClass(renderer.cancelZoomElement, "visible");
                        renderer.zoomedIn = false;
                    },
                    render: function render(boardState) {
                        var _this = this;
                        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, territory = _ref2.territory, deadStones = _ref2.deadStones;
                        if (!this._initialized) {
                            this._setup(boardState);
                            this._initialized = true;
                        }
                        this.resetTouchedPoint();
                        this.renderStonesPlayed(boardState.intersections);
                        var playedPoint = boardState.playedPoint;
                        this.updateMarkerPoints({
                            playedPoint: playedPoint,
                            koPoint: boardState.koPoint
                        });
                        if (this._options["fuzzyStonePlacement"] && playedPoint) {
                            var verticalShiftClasses = [
                                "v-shift-up",
                                "v-shift-upup",
                                "v-shift-down",
                                "v-shift-downdown",
                                "v-shift-none"
                            ];
                            var horizontalShiftClasses = [
                                "h-shift-left",
                                "h-shift-leftleft",
                                "h-shift-right",
                                "h-shift-rightright",
                                "h-shift-none"
                            ];
                            var shiftClasses = verticalShiftClasses.concat(horizontalShiftClasses);
                            var alreadyShifted = shiftClasses.some(function(c) {
                                return _utils2.default.hasClass(_this.grid[playedPoint.y][playedPoint.x], c);
                            });
                            if (!alreadyShifted) {
                                var possibleShifts = _utils2.default.cartesianProduct(verticalShiftClasses, horizontalShiftClasses);
                                var _possibleShifts$Math$ = _slicedToArray(possibleShifts[Math.floor(Math.random() * possibleShifts.length)], 2), playedVerticalShift = _possibleShifts$Math$[0], playedHorizontalShift = _possibleShifts$Math$[1];
                                [
                                    [
                                        -1,
                                        0
                                    ],
                                    [
                                        0,
                                        -1
                                    ],
                                    [
                                        0,
                                        1
                                    ],
                                    [
                                        1,
                                        0
                                    ]
                                ].forEach(function(_ref3) {
                                    var _ref4 = _slicedToArray(_ref3, 2), y = _ref4[0], x = _ref4[1];
                                    if (_this.grid[playedPoint.y + y] && _this.grid[playedPoint.y + y][playedPoint.x + x]) {
                                        var neighboringElement = _this.grid[playedPoint.y + y][playedPoint.x + x];
                                        if (!_utils2.default.hasClass(neighboringElement, "empty")) [
                                            [
                                                -1,
                                                0,
                                                "v-shift-downdown",
                                                "v-shift-up",
                                                "v-shift-down"
                                            ],
                                            [
                                                -1,
                                                0,
                                                "v-shift-downdown",
                                                "v-shift-upup",
                                                "v-shift-none"
                                            ],
                                            [
                                                -1,
                                                0,
                                                "v-shift-down",
                                                "v-shift-upup",
                                                "v-shift-none"
                                            ],
                                            [
                                                1,
                                                0,
                                                "v-shift-upup",
                                                "v-shift-down",
                                                "v-shift-up"
                                            ],
                                            [
                                                1,
                                                0,
                                                "v-shift-upup",
                                                "v-shift-downdown",
                                                "v-shift-none"
                                            ],
                                            [
                                                1,
                                                0,
                                                "v-shift-up",
                                                "v-shift-downdown",
                                                "v-shift-none"
                                            ],
                                            [
                                                0,
                                                -1,
                                                "h-shift-rightright",
                                                "h-shift-left",
                                                "h-shift-right"
                                            ],
                                            [
                                                0,
                                                -1,
                                                "h-shift-rightright",
                                                "h-shift-leftleft",
                                                "h-shift-none"
                                            ],
                                            [
                                                0,
                                                -1,
                                                "h-shift-right",
                                                "h-shift-leftleft",
                                                "h-shift-none"
                                            ],
                                            [
                                                0,
                                                1,
                                                "h-shift-leftleft",
                                                "h-shift-right",
                                                "h-shift-left"
                                            ],
                                            [
                                                0,
                                                1,
                                                "h-shift-leftleft",
                                                "h-shift-rightright",
                                                "h-shift-none"
                                            ],
                                            [
                                                0,
                                                1,
                                                "h-shift-left",
                                                "h-shift-rightright",
                                                "h-shift-none"
                                            ]
                                        ].forEach(function(_ref5) {
                                            var _ref6 = _slicedToArray(_ref5, 5), requiredYOffset = _ref6[0], requiredXOffset = _ref6[1], requiredNeighborShift = _ref6[2], conflictingPlayedShift = _ref6[3], newNeighborShift = _ref6[4];
                                            if (y === requiredYOffset && x === requiredXOffset && _utils2.default.hasClass(neighboringElement, requiredNeighborShift) && (playedVerticalShift === conflictingPlayedShift || playedHorizontalShift === conflictingPlayedShift)) {
                                                _utils2.default.removeClass(neighboringElement, requiredNeighborShift);
                                                _utils2.default.addClass(neighboringElement, newNeighborShift);
                                            }
                                        });
                                    }
                                });
                                _utils2.default.addClass(this.grid[playedPoint.y][playedPoint.x], playedVerticalShift);
                                _utils2.default.addClass(this.grid[playedPoint.y][playedPoint.x], playedHorizontalShift);
                            }
                        }
                        if (deadStones.length > 0 || territory.black.length > 0 || territory.white.length > 0) this.renderTerritory(territory, deadStones);
                    },
                    renderStonesPlayed: function renderStonesPlayed(intersections) {
                        var _this2 = this;
                        intersections.forEach(function(intersection) {
                            _this2.renderIntersection(intersection);
                        });
                    },
                    updateMarkerPoints: function updateMarkerPoints(_ref7) {
                        var playedPoint = _ref7.playedPoint, koPoint = _ref7.koPoint;
                        var renderer = this;
                        if (koPoint) _utils2.default.addClass(renderer.grid[koPoint.y][koPoint.x], "ko");
                        if (playedPoint) _utils2.default.addClass(renderer.grid[playedPoint.y][playedPoint.x], "played");
                    },
                    renderIntersection: function renderIntersection(intersection) {
                        var renderer = this;
                        var intersectionEl = renderer.grid[intersection.y][intersection.x];
                        var classes = [
                            "intersection"
                        ];
                        if (intersection.isEmpty()) classes.push("empty");
                        else {
                            classes.push("occupied");
                            if (intersection.isBlack()) classes.push("black");
                            else classes.push("white");
                            var shiftClasses = [
                                "v-shift-up",
                                "v-shift-upup",
                                "v-shift-down",
                                "v-shift-downdown",
                                "v-shift-none",
                                "h-shift-left",
                                "h-shift-leftleft",
                                "h-shift-right",
                                "h-shift-rightright",
                                "h-shift-none"
                            ];
                            shiftClasses.forEach(function(shiftClass) {
                                if (_utils2.default.hasClass(intersectionEl, shiftClass)) classes.push(shiftClass);
                            });
                        }
                        this.setIntersectionClasses(intersectionEl, intersection, classes);
                    },
                    renderTerritory: function renderTerritory(territory, deadStones) {
                        var _this3 = this;
                        _utils2.default.flatten(this.grid).forEach(function(element) {
                            _utils2.default.removeClass(element, "territory-black");
                            _utils2.default.removeClass(element, "territory-white");
                            _utils2.default.removeClass(element, "dead");
                        });
                        deadStones.forEach(function(point) {
                            _utils2.default.addClass(_this3.grid[point.y][point.x], "dead");
                        });
                        territory.black.forEach(function(territoryPoint) {
                            _utils2.default.addClass(_this3.grid[territoryPoint.y][territoryPoint.x], "territory-black");
                        });
                        territory.white.forEach(function(territoryPoint) {
                            _utils2.default.addClass(_this3.grid[territoryPoint.y][territoryPoint.x], "territory-white");
                        });
                    }
                };
                exports.default = Renderer;
            //# sourceMappingURL=renderer.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {
                "./utils": 14
            }
        ],
        11: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var VALID_KO_OPTIONS = [
                    "simple",
                    "positional-superko",
                    "situational-superko",
                    "natural-situational-superko"
                ];
                var Ruleset = function Ruleset(_ref) {
                    var koRule = _ref.koRule;
                    this.koRule = koRule;
                    if (VALID_KO_OPTIONS.indexOf(this.koRule) < 0) throw new Error("Unknown ko rule: " + koRule);
                    Object.freeze(this);
                };
                Ruleset.prototype = {
                    isIllegal: function isIllegal(y, x, game) {
                        var boardState = game.currentState();
                        var intersection = boardState.intersectionAt(y, x);
                        var result = !intersection.isEmpty() || this._wouldBeSuicide(y, x, boardState) || this._isKoViolation(y, x, boardState, game._moves);
                        return result;
                    },
                    _isKoViolation: function _isKoViolation(y, x, boardState, existingStates) {
                        var isKoViolation = false;
                        if (this.koRule === "simple") {
                            var simpleKoPoint = boardState._simpleKoPoint();
                            isKoViolation = Boolean(simpleKoPoint) && y === simpleKoPoint.y && x === simpleKoPoint.x;
                        } else {
                            var newState = boardState.playAt(y, x, boardState.nextColor());
                            var hasDuplicatePosition = function hasDuplicatePosition(condition) {
                                return existingStates.length > 0 && existingStates.some(function(existingState) {
                                    return condition(existingState) && existingState.positionSameAs(newState);
                                });
                            };
                            if (this.koRule === "positional-superko") isKoViolation = hasDuplicatePosition(function() {
                                return true;
                            });
                            else if (this.koRule === "situational-superko") isKoViolation = hasDuplicatePosition(function(state) {
                                return state.color === newState.color;
                            });
                            else if (this.koRule === "natural-situational-superko") isKoViolation = hasDuplicatePosition(function(state) {
                                return !state.pass && state.color === newState.color;
                            });
                            else throw new Error("Unimplemented ko rule " + this.koRule);
                        }
                        return isKoViolation;
                    },
                    _wouldBeSuicide: function _wouldBeSuicide(y, x, boardState) {
                        var color = boardState.nextColor();
                        var intersection = boardState.intersectionAt(y, x);
                        var surroundedEmptyPoint = intersection.isEmpty() && boardState.neighborsFor(intersection.y, intersection.x).filter(function(neighbor) {
                            return neighbor.isEmpty();
                        }).length === 0;
                        if (!surroundedEmptyPoint) return false;
                        var someFriendlyNotInAtari = boardState.neighborsFor(intersection.y, intersection.x).some(function(neighbor) {
                            var inAtari = boardState.inAtari(neighbor.y, neighbor.x);
                            var friendly = neighbor.isOccupiedWith(color);
                            return friendly && !inAtari;
                        });
                        if (someFriendlyNotInAtari) return false;
                        var someEnemyInAtari = boardState.neighborsFor(intersection.y, intersection.x).some(function(neighbor) {
                            var inAtari = boardState.inAtari(neighbor.y, neighbor.x);
                            var enemy = !neighbor.isOccupiedWith(color);
                            return enemy && inAtari;
                        });
                        if (someEnemyInAtari) return false;
                        return true;
                    }
                };
                exports.default = Ruleset;
            //# sourceMappingURL=ruleset.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {}
        ],
        12: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _utils = require1("./utils");
                var _utils2 = _interopRequireDefault(_utils);
                var _intersection = require1("./intersection");
                var _intersection2 = _interopRequireDefault(_intersection);
                var _region = require1("./region");
                var _region2 = _interopRequireDefault(_region);
                var _eyePoint = require1("./eye-point");
                var _eyePoint2 = _interopRequireDefault(_eyePoint);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var boardStateWithoutDeadPoints = function boardStateWithoutDeadPoints(game) {
                    return game.currentState()._withoutIntersectionsMatching(function(i) {
                        return game._isDeadAt(i.y, i.x);
                    });
                };
                var boardStateWithoutNeutralPoints = function boardStateWithoutNeutralPoints(boardState) {
                    var regions = _region2.default.allFor(boardState);
                    var neutralRegions = regions.filter(function(r) {
                        return r.isNeutral();
                    });
                    if (regions.length === 0 || neutralRegions.length === 0) return boardState;
                    var replacements = {};
                    neutralRegions.forEach(function(r) {
                        var startingX = null;
                        var startingY = null;
                        r.intersections.forEach(function(intersection) {
                            startingX = startingX || intersection.x;
                            startingX = startingX || intersection.y;
                            var manhattanDistance = Math.abs(intersection.y - startingY) + Math.abs(intersection.x - startingX);
                            var replacementColor = [
                                "black",
                                "white"
                            ][manhattanDistance % 2];
                            var replacement = new _intersection2.default(intersection.y, intersection.x, replacementColor);
                            replacements[intersection.y] = replacements[intersection.y] || [];
                            replacements[intersection.y][intersection.x] = replacement;
                        });
                    });
                    var newPoints = boardState.intersections.map(function(i) {
                        if (replacements[i.y] && replacements[i.y][i.x]) return replacements[i.y][i.x];
                        else return i;
                    });
                    return boardState._withNewPoints(newPoints);
                };
                var boardStateWithClearFalseEyesFilled = function boardStateWithClearFalseEyesFilled(boardState) {
                    var territoryRegions = _region2.default.allFor(boardState).filter(function(r) {
                        return r.isTerritory();
                    });
                    var falseEyePoints = _utils2.default.flatMap(territoryRegions, function(r) {
                        return r.intersections;
                    }).filter(function(i) {
                        return new _eyePoint2.default(boardState, i).isFalse();
                    });
                    var pointsNeighboringAtari = falseEyePoints.filter(function(i) {
                        return boardState.neighborsFor(i.y, i.x).some(function(n) {
                            return boardState.inAtari(n.y, n.x);
                        });
                    });
                    var neutralAtariUpdatedState = boardState;
                    var _loop = function _loop() {
                        var newPoints = neutralAtariUpdatedState.intersections.map(function(i) {
                            if (pointsNeighboringAtari.indexOf(i) > -1) return new _intersection2.default(i.y, i.x, new _eyePoint2.default(neutralAtariUpdatedState, i).filledColor());
                            else return i;
                        });
                        neutralAtariUpdatedState = neutralAtariUpdatedState._withNewPoints(newPoints);
                        var boardState = boardStateWithoutNeutralPoints(neutralAtariUpdatedState);
                        var territoryRegions = _region2.default.allFor(boardState).filter(function(r) {
                            return r.isTerritory();
                        });
                        var falseEyePoints = _utils2.default.flatMap(territoryRegions, function(r) {
                            return r.intersections;
                        }).filter(function(i) {
                            return new _eyePoint2.default(boardState, i).isFalse();
                        });
                        pointsNeighboringAtari = falseEyePoints.filter(function(i) {
                            return neutralAtariUpdatedState.neighborsFor(i.y, i.x).some(function(n) {
                                return neutralAtariUpdatedState.inAtari(n.y, n.x);
                            });
                        });
                    };
                    while(pointsNeighboringAtari.length > 0)_loop();
                    return neutralAtariUpdatedState;
                };
                var TerritoryScoring = Object.freeze({
                    score: function score(game) {
                        var blackDeadAsCaptures = game.deadStones().filter(function(deadPoint) {
                            return game.intersectionAt(deadPoint.y, deadPoint.x).isBlack();
                        });
                        var whiteDeadAsCaptures = game.deadStones().filter(function(deadPoint) {
                            return game.intersectionAt(deadPoint.y, deadPoint.x).isWhite();
                        });
                        var territory = game.territory();
                        var boardState = game.currentState();
                        return {
                            black: territory.black.length + boardState.whiteStonesCaptured + whiteDeadAsCaptures.length,
                            white: territory.white.length + boardState.blackStonesCaptured + blackDeadAsCaptures.length
                        };
                    },
                    territory: function territory(game) {
                        var stateWithoutDeadPoints = boardStateWithoutDeadPoints(game);
                        var stateWithoutNeutrals = boardStateWithoutNeutralPoints(stateWithoutDeadPoints);
                        var stateWithClearFalseEyesFilled = boardStateWithClearFalseEyesFilled(stateWithoutNeutrals);
                        var territoryRegions = _region2.default.allFor(stateWithClearFalseEyesFilled).filter(function(r) {
                            return r.isTerritory();
                        });
                        var territoryRegionsWithoutSeki = territoryRegions.filter(function(r) {
                            var merged = _region2.default.merge(territoryRegions, r);
                            var eyeCounts = merged.map(function(m) {
                                return Math.ceil(m.numberOfEyes());
                            });
                            return eyeCounts.length > 0 && eyeCounts.reduce(function(a, b) {
                                return a + b;
                            }) >= 2;
                        });
                        var blackRegions = territoryRegionsWithoutSeki.filter(function(r) {
                            return r.isBlack();
                        });
                        var whiteRegions = territoryRegionsWithoutSeki.filter(function(r) {
                            return r.isWhite();
                        });
                        return {
                            black: _utils2.default.flatMap(blackRegions, function(r) {
                                return r.intersections;
                            }).map(function(i) {
                                return {
                                    y: i.y,
                                    x: i.x
                                };
                            }),
                            white: _utils2.default.flatMap(whiteRegions, function(r) {
                                return r.intersections;
                            }).map(function(i) {
                                return {
                                    y: i.y,
                                    x: i.x
                                };
                            })
                        };
                    }
                });
                var AreaScoring = Object.freeze({
                    score: function score(game) {
                        var blackStonesOnTheBoard = game.intersections().filter(function(intersection) {
                            return intersection.isBlack() && !game._isDeadAt(intersection.y, intersection.x);
                        });
                        var whiteStonesOnTheBoard = game.intersections().filter(function(intersection) {
                            return intersection.isWhite() && !game._isDeadAt(intersection.y, intersection.x);
                        });
                        var territory = game.territory();
                        return {
                            black: territory.black.length + blackStonesOnTheBoard.length,
                            white: territory.white.length + whiteStonesOnTheBoard.length
                        };
                    },
                    territory: function territory(game) {
                        var regions = _region2.default.allFor(boardStateWithoutDeadPoints(game));
                        var territoryRegions = regions.filter(function(r) {
                            return r.isTerritory();
                        });
                        var blackRegions = territoryRegions.filter(function(r) {
                            return r.isBlack();
                        });
                        var whiteRegions = territoryRegions.filter(function(r) {
                            return r.isWhite();
                        });
                        return {
                            black: _utils2.default.flatMap(blackRegions, function(r) {
                                return r.intersections;
                            }).map(function(i) {
                                return {
                                    y: i.y,
                                    x: i.x
                                };
                            }),
                            white: _utils2.default.flatMap(whiteRegions, function(r) {
                                return r.intersections;
                            }).map(function(i) {
                                return {
                                    y: i.y,
                                    x: i.x
                                };
                            })
                        };
                    }
                });
                var Scorer = function Scorer() {
                    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, scoreBy = _ref.scoreBy, komi = _ref.komi;
                    this._strategy = ({
                        "area": AreaScoring,
                        "territory": TerritoryScoring,
                        "equivalence": AreaScoring
                    })[scoreBy];
                    this._komi = komi;
                    if (!this._strategy) throw new Error("Unknown scoring type: " + scoreBy);
                    if (this._komi === null || typeof this._komi === "undefined") throw new Error("Error initializing scorer without a komi value");
                    if (typeof this._komi !== "number") throw new Error("Komi value given is not a number: " + komi);
                    this._usePassStones = scoreBy === "equivalence";
                    Object.freeze(this);
                };
                Scorer.prototype = {
                    score: function score(game) {
                        var result = this._strategy.score(game);
                        result.white += this._komi;
                        if (this._usePassStones) {
                            // Under equivalence scoring, 2 consecutive passes signals(!) the end of the
                            // game, but just prior to the end of the game, white must make one final
                            // pass move if the game didn't end on a white pass.
                            //
                            // However, instead of creating a 3rd consecutive pass in the board state,
                            // white's additional pass stone is handled by the scoring mechanism alone.
                            // The idea is that, under any game resumption, the additional white pass
                            // stone must not exist, so we shouldn't add it.
                            //
                            // NOTE: the final result should rely on this scoring function. Any calculations
                            // using raw board state pass stone numbers may be off by 1 in favor of black.
                            var needsFinalWhitePassStone = game.currentState().color !== "white";
                            return {
                                black: result.black + game.currentState().whitePassStones + (needsFinalWhitePassStone ? 1 : 0),
                                white: result.white + game.currentState().blackPassStones
                            };
                        } else return result;
                    },
                    territory: function territory(game) {
                        return this._strategy.territory(game);
                    },
                    usingPassStones: function usingPassStones() {
                        return this._usePassStones;
                    }
                };
                exports.default = Scorer;
            //# sourceMappingURL=scorer.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNjb3Jlci5qcyJdLCJuYW1lcyI6WyJPYmplY3QiLCJkZWZpbmVQcm9wZXJ0eSIsImV4cG9ydHMiLCJ2YWx1ZSIsIl91dGlscyIsInJlcXVpcmUiLCJfdXRpbHMyIiwiX2ludGVyb3BSZXF1aXJlRGVmYXVsdCIsIl9pbnRlcnNlY3Rpb24iLCJfaW50ZXJzZWN0aW9uMiIsIl9yZWdpb24iLCJfcmVnaW9uMiIsIl9leWVQb2ludCIsIl9leWVQb2ludDIiLCJvYmoiLCJfX2VzTW9kdWxlIiwiZGVmYXVsdCIsImJvYXJkU3RhdGVXaXRob3V0RGVhZFBvaW50cyIsImdhbWUiLCJjdXJyZW50U3RhdGUiLCJfd2l0aG91dEludGVyc2VjdGlvbnNNYXRjaGluZyIsImkiLCJfaXNEZWFkQXQiLCJ5IiwieCIsImJvYXJkU3RhdGVXaXRob3V0TmV1dHJhbFBvaW50cyIsImJvYXJkU3RhdGUiLCJyZWdpb25zIiwiYWxsRm9yIiwibmV1dHJhbFJlZ2lvbnMiLCJmaWx0ZXIiLCJyIiwiaXNOZXV0cmFsIiwibGVuZ3RoIiwicmVwbGFjZW1lbnRzIiwiZm9yRWFjaCIsInN0YXJ0aW5nWCIsInN0YXJ0aW5nWSIsImludGVyc2VjdGlvbnMiLCJpbnRlcnNlY3Rpb24iLCJtYW5oYXR0YW5EaXN0YW5jZSIsIk1hdGgiLCJhYnMiLCJyZXBsYWNlbWVudENvbG9yIiwicmVwbGFjZW1lbnQiLCJuZXdQb2ludHMiLCJtYXAiLCJfd2l0aE5ld1BvaW50cyIsImJvYXJkU3RhdGVXaXRoQ2xlYXJGYWxzZUV5ZXNGaWxsZWQiLCJ0ZXJyaXRvcnlSZWdpb25zIiwiaXNUZXJyaXRvcnkiLCJmYWxzZUV5ZVBvaW50cyIsImZsYXRNYXAiLCJpc0ZhbHNlIiwicG9pbnRzTmVpZ2hib3JpbmdBdGFyaSIsIm5laWdoYm9yc0ZvciIsInNvbWUiLCJuIiwiaW5BdGFyaSIsIm5ldXRyYWxBdGFyaVVwZGF0ZWRTdGF0ZSIsIl9sb29wIiwiaW5kZXhPZiIsImZpbGxlZENvbG9yIiwiVGVycml0b3J5U2NvcmluZyIsImZyZWV6ZSIsInNjb3JlIiwiYmxhY2tEZWFkQXNDYXB0dXJlcyIsImRlYWRTdG9uZXMiLCJkZWFkUG9pbnQiLCJpbnRlcnNlY3Rpb25BdCIsImlzQmxhY2siLCJ3aGl0ZURlYWRBc0NhcHR1cmVzIiwiaXNXaGl0ZSIsInRlcnJpdG9yeSIsImJsYWNrIiwid2hpdGVTdG9uZXNDYXB0dXJlZCIsIndoaXRlIiwiYmxhY2tTdG9uZXNDYXB0dXJlZCIsInN0YXRlV2l0aG91dERlYWRQb2ludHMiLCJzdGF0ZVdpdGhvdXROZXV0cmFscyIsInN0YXRlV2l0aENsZWFyRmFsc2VFeWVzRmlsbGVkIiwidGVycml0b3J5UmVnaW9uc1dpdGhvdXRTZWtpIiwibWVyZ2VkIiwibWVyZ2UiLCJleWVDb3VudHMiLCJtIiwiY2VpbCIsIm51bWJlck9mRXllcyIsInJlZHVjZSIsImEiLCJiIiwiYmxhY2tSZWdpb25zIiwid2hpdGVSZWdpb25zIiwiQXJlYVNjb3JpbmciLCJibGFja1N0b25lc09uVGhlQm9hcmQiLCJ3aGl0ZVN0b25lc09uVGhlQm9hcmQiLCJTY29yZXIiLCJfcmVmIiwiYXJndW1lbnRzIiwidW5kZWZpbmVkIiwic2NvcmVCeSIsImtvbWkiLCJfc3RyYXRlZ3kiLCJfa29taSIsIkVycm9yIiwiX3VzZVBhc3NTdG9uZXMiLCJwcm90b3R5cGUiLCJyZXN1bHQiLCJuZWVkc0ZpbmFsV2hpdGVQYXNzU3RvbmUiLCJjb2xvciIsIndoaXRlUGFzc1N0b25lcyIsImJsYWNrUGFzc1N0b25lcyIsInVzaW5nUGFzc1N0b25lcyJdLCJtYXBwaW5ncyI6IkFBQUE7O0FBRUFBLE9BQU9DLGNBQVAsQ0FBc0JDLE9BQXRCLEVBQStCLFlBQS9CLEVBQTZDO0FBQzNDQyxTQUFPO0FBRG9DLENBQTdDOztBQUlBLElBQUlDLFNBQVNDLFFBQVEsU0FBUixDQUFiOztBQUVBLElBQUlDLFVBQVVDLHVCQUF1QkgsTUFBdkIsQ0FBZDs7QUFFQSxJQUFJSSxnQkFBZ0JILFFBQVEsZ0JBQVIsQ0FBcEI7O0FBRUEsSUFBSUksaUJBQWlCRix1QkFBdUJDLGFBQXZCLENBQXJCOztBQUVBLElBQUlFLFVBQVVMLFFBQVEsVUFBUixDQUFkOztBQUVBLElBQUlNLFdBQVdKLHVCQUF1QkcsT0FBdkIsQ0FBZjs7QUFFQSxJQUFJRSxZQUFZUCxRQUFRLGFBQVIsQ0FBaEI7O0FBRUEsSUFBSVEsYUFBYU4sdUJBQXVCSyxTQUF2QixDQUFqQjs7QUFFQSxTQUFTTCxzQkFBVCxDQUFnQ08sR0FBaEMsRUFBcUM7QUFBRSxTQUFPQSxPQUFPQSxJQUFJQyxVQUFYLEdBQXdCRCxHQUF4QixHQUE4QixFQUFFRSxTQUFTRixHQUFYLEVBQXJDO0FBQXdEOztBQUUvRixJQUFJRyw4QkFBOEIsU0FBU0EsMkJBQVQsQ0FBcUNDLElBQXJDLEVBQTJDO0FBQzNFLFNBQU9BLEtBQUtDLFlBQUwsR0FBb0JDLDZCQUFwQixDQUFrRCxVQUFVQyxDQUFWLEVBQWE7QUFDcEUsV0FBT0gsS0FBS0ksU0FBTCxDQUFlRCxFQUFFRSxDQUFqQixFQUFvQkYsRUFBRUcsQ0FBdEIsQ0FBUDtBQUNELEdBRk0sQ0FBUDtBQUdELENBSkQ7O0FBTUEsSUFBSUMsaUNBQWlDLFNBQVNBLDhCQUFULENBQXdDQyxVQUF4QyxFQUFvRDtBQUN2RixNQUFJQyxVQUFVaEIsU0FBU0ssT0FBVCxDQUFpQlksTUFBakIsQ0FBd0JGLFVBQXhCLENBQWQ7QUFDQSxNQUFJRyxpQkFBaUJGLFFBQVFHLE1BQVIsQ0FBZSxVQUFVQyxDQUFWLEVBQWE7QUFDL0MsV0FBT0EsRUFBRUMsU0FBRixFQUFQO0FBQ0QsR0FGb0IsQ0FBckI7O0FBSUEsTUFBSUwsUUFBUU0sTUFBUixLQUFtQixDQUFuQixJQUF3QkosZUFBZUksTUFBZixLQUEwQixDQUF0RCxFQUF5RDtBQUN2RCxXQUFPUCxVQUFQO0FBQ0Q7O0FBRUQsTUFBSVEsZUFBZSxFQUFuQjs7QUFFQUwsaUJBQWVNLE9BQWYsQ0FBdUIsVUFBVUosQ0FBVixFQUFhO0FBQ2xDLFFBQUlLLFlBQVksSUFBaEI7QUFDQSxRQUFJQyxZQUFZLElBQWhCOztBQUVBTixNQUFFTyxhQUFGLENBQWdCSCxPQUFoQixDQUF3QixVQUFVSSxZQUFWLEVBQXdCO0FBQzlDSCxrQkFBWUEsYUFBYUcsYUFBYWYsQ0FBdEM7QUFDQVksa0JBQVlBLGFBQWFHLGFBQWFoQixDQUF0Qzs7QUFFQSxVQUFJaUIsb0JBQW9CQyxLQUFLQyxHQUFMLENBQVNILGFBQWFoQixDQUFiLEdBQWlCYyxTQUExQixJQUF1Q0ksS0FBS0MsR0FBTCxDQUFTSCxhQUFhZixDQUFiLEdBQWlCWSxTQUExQixDQUEvRDtBQUNBLFVBQUlPLG1CQUFtQixDQUFDLE9BQUQsRUFBVSxPQUFWLEVBQW1CSCxvQkFBb0IsQ0FBdkMsQ0FBdkI7QUFDQSxVQUFJSSxjQUFjLElBQUluQyxlQUFlTyxPQUFuQixDQUEyQnVCLGFBQWFoQixDQUF4QyxFQUEyQ2dCLGFBQWFmLENBQXhELEVBQTJEbUIsZ0JBQTNELENBQWxCOztBQUVBVCxtQkFBYUssYUFBYWhCLENBQTFCLElBQStCVyxhQUFhSyxhQUFhaEIsQ0FBMUIsS0FBZ0MsRUFBL0Q7QUFDQVcsbUJBQWFLLGFBQWFoQixDQUExQixFQUE2QmdCLGFBQWFmLENBQTFDLElBQStDb0IsV0FBL0M7QUFDRCxLQVZEO0FBV0QsR0FmRDs7QUFpQkEsTUFBSUMsWUFBWW5CLFdBQVdZLGFBQVgsQ0FBeUJRLEdBQXpCLENBQTZCLFVBQVV6QixDQUFWLEVBQWE7QUFDeEQsUUFBSWEsYUFBYWIsRUFBRUUsQ0FBZixLQUFxQlcsYUFBYWIsRUFBRUUsQ0FBZixFQUFrQkYsRUFBRUcsQ0FBcEIsQ0FBekIsRUFBaUQ7QUFDL0MsYUFBT1UsYUFBYWIsRUFBRUUsQ0FBZixFQUFrQkYsRUFBRUcsQ0FBcEIsQ0FBUDtBQUNELEtBRkQsTUFFTztBQUNMLGFBQU9ILENBQVA7QUFDRDtBQUNGLEdBTmUsQ0FBaEI7O0FBUUEsU0FBT0ssV0FBV3FCLGNBQVgsQ0FBMEJGLFNBQTFCLENBQVA7QUFDRCxDQXRDRDs7QUF3Q0EsSUFBSUcscUNBQXFDLFNBQVNBLGtDQUFULENBQTRDdEIsVUFBNUMsRUFBd0Q7QUFDL0YsTUFBSXVCLG1CQUFtQnRDLFNBQVNLLE9BQVQsQ0FBaUJZLE1BQWpCLENBQXdCRixVQUF4QixFQUFvQ0ksTUFBcEMsQ0FBMkMsVUFBVUMsQ0FBVixFQUFhO0FBQzdFLFdBQU9BLEVBQUVtQixXQUFGLEVBQVA7QUFDRCxHQUZzQixDQUF2QjtBQUdBLE1BQUlDLGlCQUFpQjdDLFFBQVFVLE9BQVIsQ0FBZ0JvQyxPQUFoQixDQUF3QkgsZ0JBQXhCLEVBQTBDLFVBQVVsQixDQUFWLEVBQWE7QUFDMUUsV0FBT0EsRUFBRU8sYUFBVDtBQUNELEdBRm9CLEVBRWxCUixNQUZrQixDQUVYLFVBQVVULENBQVYsRUFBYTtBQUNyQixXQUFPLElBQUlSLFdBQVdHLE9BQWYsQ0FBdUJVLFVBQXZCLEVBQW1DTCxDQUFuQyxFQUFzQ2dDLE9BQXRDLEVBQVA7QUFDRCxHQUpvQixDQUFyQjs7QUFNQSxNQUFJQyx5QkFBeUJILGVBQWVyQixNQUFmLENBQXNCLFVBQVVULENBQVYsRUFBYTtBQUM5RCxXQUFPSyxXQUFXNkIsWUFBWCxDQUF3QmxDLEVBQUVFLENBQTFCLEVBQTZCRixFQUFFRyxDQUEvQixFQUFrQ2dDLElBQWxDLENBQXVDLFVBQVVDLENBQVYsRUFBYTtBQUN6RCxhQUFPL0IsV0FBV2dDLE9BQVgsQ0FBbUJELEVBQUVsQyxDQUFyQixFQUF3QmtDLEVBQUVqQyxDQUExQixDQUFQO0FBQ0QsS0FGTSxDQUFQO0FBR0QsR0FKNEIsQ0FBN0I7QUFLQSxNQUFJbUMsMkJBQTJCakMsVUFBL0I7O0FBRUEsTUFBSWtDLFFBQVEsU0FBU0EsS0FBVCxHQUFpQjtBQUMzQixRQUFJZixZQUFZYyx5QkFBeUJyQixhQUF6QixDQUF1Q1EsR0FBdkMsQ0FBMkMsVUFBVXpCLENBQVYsRUFBYTtBQUN0RSxVQUFJaUMsdUJBQXVCTyxPQUF2QixDQUErQnhDLENBQS9CLElBQW9DLENBQUMsQ0FBekMsRUFBNEM7QUFDMUMsZUFBTyxJQUFJWixlQUFlTyxPQUFuQixDQUEyQkssRUFBRUUsQ0FBN0IsRUFBZ0NGLEVBQUVHLENBQWxDLEVBQXFDLElBQUlYLFdBQVdHLE9BQWYsQ0FBdUIyQyx3QkFBdkIsRUFBaUR0QyxDQUFqRCxFQUFvRHlDLFdBQXBELEVBQXJDLENBQVA7QUFDRCxPQUZELE1BRU87QUFDTCxlQUFPekMsQ0FBUDtBQUNEO0FBQ0YsS0FOZSxDQUFoQjtBQU9Bc0MsK0JBQTJCQSx5QkFBeUJaLGNBQXpCLENBQXdDRixTQUF4QyxDQUEzQjs7QUFFQSxRQUFJbkIsYUFBYUQsK0JBQStCa0Msd0JBQS9CLENBQWpCO0FBQ0EsUUFBSVYsbUJBQW1CdEMsU0FBU0ssT0FBVCxDQUFpQlksTUFBakIsQ0FBd0JGLFVBQXhCLEVBQW9DSSxNQUFwQyxDQUEyQyxVQUFVQyxDQUFWLEVBQWE7QUFDN0UsYUFBT0EsRUFBRW1CLFdBQUYsRUFBUDtBQUNELEtBRnNCLENBQXZCO0FBR0EsUUFBSUMsaUJBQWlCN0MsUUFBUVUsT0FBUixDQUFnQm9DLE9BQWhCLENBQXdCSCxnQkFBeEIsRUFBMEMsVUFBVWxCLENBQVYsRUFBYTtBQUMxRSxhQUFPQSxFQUFFTyxhQUFUO0FBQ0QsS0FGb0IsRUFFbEJSLE1BRmtCLENBRVgsVUFBVVQsQ0FBVixFQUFhO0FBQ3JCLGFBQU8sSUFBSVIsV0FBV0csT0FBZixDQUF1QlUsVUFBdkIsRUFBbUNMLENBQW5DLEVBQXNDZ0MsT0FBdEMsRUFBUDtBQUNELEtBSm9CLENBQXJCOztBQU1BQyw2QkFBeUJILGVBQWVyQixNQUFmLENBQXNCLFVBQVVULENBQVYsRUFBYTtBQUMxRCxhQUFPc0MseUJBQXlCSixZQUF6QixDQUFzQ2xDLEVBQUVFLENBQXhDLEVBQTJDRixFQUFFRyxDQUE3QyxFQUFnRGdDLElBQWhELENBQXFELFVBQVVDLENBQVYsRUFBYTtBQUN2RSxlQUFPRSx5QkFBeUJELE9BQXpCLENBQWlDRCxFQUFFbEMsQ0FBbkMsRUFBc0NrQyxFQUFFakMsQ0FBeEMsQ0FBUDtBQUNELE9BRk0sQ0FBUDtBQUdELEtBSndCLENBQXpCO0FBS0QsR0F6QkQ7O0FBMkJBLFNBQU84Qix1QkFBdUJyQixNQUF2QixHQUFnQyxDQUF2QyxFQUEwQztBQUN4QzJCO0FBQ0Q7O0FBRUQsU0FBT0Qsd0JBQVA7QUFDRCxDQWpERDs7QUFtREEsSUFBSUksbUJBQW1CL0QsT0FBT2dFLE1BQVAsQ0FBYztBQUNuQ0MsU0FBTyxTQUFTQSxLQUFULENBQWUvQyxJQUFmLEVBQXFCO0FBQzFCLFFBQUlnRCxzQkFBc0JoRCxLQUFLaUQsVUFBTCxHQUFrQnJDLE1BQWxCLENBQXlCLFVBQVVzQyxTQUFWLEVBQXFCO0FBQ3RFLGFBQU9sRCxLQUFLbUQsY0FBTCxDQUFvQkQsVUFBVTdDLENBQTlCLEVBQWlDNkMsVUFBVTVDLENBQTNDLEVBQThDOEMsT0FBOUMsRUFBUDtBQUNELEtBRnlCLENBQTFCO0FBR0EsUUFBSUMsc0JBQXNCckQsS0FBS2lELFVBQUwsR0FBa0JyQyxNQUFsQixDQUF5QixVQUFVc0MsU0FBVixFQUFxQjtBQUN0RSxhQUFPbEQsS0FBS21ELGNBQUwsQ0FBb0JELFVBQVU3QyxDQUE5QixFQUFpQzZDLFVBQVU1QyxDQUEzQyxFQUE4Q2dELE9BQTlDLEVBQVA7QUFDRCxLQUZ5QixDQUExQjs7QUFJQSxRQUFJQyxZQUFZdkQsS0FBS3VELFNBQUwsRUFBaEI7QUFDQSxRQUFJL0MsYUFBYVIsS0FBS0MsWUFBTCxFQUFqQjs7QUFFQSxXQUFPO0FBQ0x1RCxhQUFPRCxVQUFVQyxLQUFWLENBQWdCekMsTUFBaEIsR0FBeUJQLFdBQVdpRCxtQkFBcEMsR0FBMERKLG9CQUFvQnRDLE1BRGhGO0FBRUwyQyxhQUFPSCxVQUFVRyxLQUFWLENBQWdCM0MsTUFBaEIsR0FBeUJQLFdBQVdtRCxtQkFBcEMsR0FBMERYLG9CQUFvQmpDO0FBRmhGLEtBQVA7QUFJRCxHQWhCa0M7O0FBa0JuQ3dDLGFBQVcsU0FBU0EsU0FBVCxDQUFtQnZELElBQW5CLEVBQXlCO0FBQ2xDLFFBQUk0RCx5QkFBeUI3RCw0QkFBNEJDLElBQTVCLENBQTdCO0FBQ0EsUUFBSTZELHVCQUF1QnRELCtCQUErQnFELHNCQUEvQixDQUEzQjtBQUNBLFFBQUlFLGdDQUFnQ2hDLG1DQUFtQytCLG9CQUFuQyxDQUFwQzs7QUFFQSxRQUFJOUIsbUJBQW1CdEMsU0FBU0ssT0FBVCxDQUFpQlksTUFBakIsQ0FBd0JvRCw2QkFBeEIsRUFBdURsRCxNQUF2RCxDQUE4RCxVQUFVQyxDQUFWLEVBQWE7QUFDaEcsYUFBT0EsRUFBRW1CLFdBQUYsRUFBUDtBQUNELEtBRnNCLENBQXZCOztBQUlBLFFBQUkrQiw4QkFBOEJoQyxpQkFBaUJuQixNQUFqQixDQUF3QixVQUFVQyxDQUFWLEVBQWE7QUFDckUsVUFBSW1ELFNBQVN2RSxTQUFTSyxPQUFULENBQWlCbUUsS0FBakIsQ0FBdUJsQyxnQkFBdkIsRUFBeUNsQixDQUF6QyxDQUFiO0FBQ0EsVUFBSXFELFlBQVlGLE9BQU9wQyxHQUFQLENBQVcsVUFBVXVDLENBQVYsRUFBYTtBQUN0QyxlQUFPNUMsS0FBSzZDLElBQUwsQ0FBVUQsRUFBRUUsWUFBRixFQUFWLENBQVA7QUFDRCxPQUZlLENBQWhCOztBQUlBLGFBQU9ILFVBQVVuRCxNQUFWLEdBQW1CLENBQW5CLElBQXdCbUQsVUFBVUksTUFBVixDQUFpQixVQUFVQyxDQUFWLEVBQWFDLENBQWIsRUFBZ0I7QUFDOUQsZUFBT0QsSUFBSUMsQ0FBWDtBQUNELE9BRjhCLEtBRXpCLENBRk47QUFHRCxLQVRpQyxDQUFsQzs7QUFXQSxRQUFJQyxlQUFlViw0QkFBNEJuRCxNQUE1QixDQUFtQyxVQUFVQyxDQUFWLEVBQWE7QUFDakUsYUFBT0EsRUFBRXVDLE9BQUYsRUFBUDtBQUNELEtBRmtCLENBQW5CO0FBR0EsUUFBSXNCLGVBQWVYLDRCQUE0Qm5ELE1BQTVCLENBQW1DLFVBQVVDLENBQVYsRUFBYTtBQUNqRSxhQUFPQSxFQUFFeUMsT0FBRixFQUFQO0FBQ0QsS0FGa0IsQ0FBbkI7O0FBSUEsV0FBTztBQUNMRSxhQUFPcEUsUUFBUVUsT0FBUixDQUFnQm9DLE9BQWhCLENBQXdCdUMsWUFBeEIsRUFBc0MsVUFBVTVELENBQVYsRUFBYTtBQUN4RCxlQUFPQSxFQUFFTyxhQUFUO0FBQ0QsT0FGTSxFQUVKUSxHQUZJLENBRUEsVUFBVXpCLENBQVYsRUFBYTtBQUNsQixlQUFPLEVBQUVFLEdBQUdGLEVBQUVFLENBQVAsRUFBVUMsR0FBR0gsRUFBRUcsQ0FBZixFQUFQO0FBQ0QsT0FKTSxDQURGO0FBTUxvRCxhQUFPdEUsUUFBUVUsT0FBUixDQUFnQm9DLE9BQWhCLENBQXdCd0MsWUFBeEIsRUFBc0MsVUFBVTdELENBQVYsRUFBYTtBQUN4RCxlQUFPQSxFQUFFTyxhQUFUO0FBQ0QsT0FGTSxFQUVKUSxHQUZJLENBRUEsVUFBVXpCLENBQVYsRUFBYTtBQUNsQixlQUFPLEVBQUVFLEdBQUdGLEVBQUVFLENBQVAsRUFBVUMsR0FBR0gsRUFBRUcsQ0FBZixFQUFQO0FBQ0QsT0FKTTtBQU5GLEtBQVA7QUFZRDtBQXpEa0MsQ0FBZCxDQUF2Qjs7QUE0REEsSUFBSXFFLGNBQWM3RixPQUFPZ0UsTUFBUCxDQUFjO0FBQzlCQyxTQUFPLFNBQVNBLEtBQVQsQ0FBZS9DLElBQWYsRUFBcUI7QUFDMUIsUUFBSTRFLHdCQUF3QjVFLEtBQUtvQixhQUFMLEdBQXFCUixNQUFyQixDQUE0QixVQUFVUyxZQUFWLEVBQXdCO0FBQzlFLGFBQU9BLGFBQWErQixPQUFiLE1BQTBCLENBQUNwRCxLQUFLSSxTQUFMLENBQWVpQixhQUFhaEIsQ0FBNUIsRUFBK0JnQixhQUFhZixDQUE1QyxDQUFsQztBQUNELEtBRjJCLENBQTVCO0FBR0EsUUFBSXVFLHdCQUF3QjdFLEtBQUtvQixhQUFMLEdBQXFCUixNQUFyQixDQUE0QixVQUFVUyxZQUFWLEVBQXdCO0FBQzlFLGFBQU9BLGFBQWFpQyxPQUFiLE1BQTBCLENBQUN0RCxLQUFLSSxTQUFMLENBQWVpQixhQUFhaEIsQ0FBNUIsRUFBK0JnQixhQUFhZixDQUE1QyxDQUFsQztBQUNELEtBRjJCLENBQTVCO0FBR0EsUUFBSWlELFlBQVl2RCxLQUFLdUQsU0FBTCxFQUFoQjs7QUFFQSxXQUFPO0FBQ0xDLGFBQU9ELFVBQVVDLEtBQVYsQ0FBZ0J6QyxNQUFoQixHQUF5QjZELHNCQUFzQjdELE1BRGpEO0FBRUwyQyxhQUFPSCxVQUFVRyxLQUFWLENBQWdCM0MsTUFBaEIsR0FBeUI4RCxzQkFBc0I5RDtBQUZqRCxLQUFQO0FBSUQsR0FkNkI7O0FBZ0I5QndDLGFBQVcsU0FBU0EsU0FBVCxDQUFtQnZELElBQW5CLEVBQXlCO0FBQ2xDLFFBQUlTLFVBQVVoQixTQUFTSyxPQUFULENBQWlCWSxNQUFqQixDQUF3QlgsNEJBQTRCQyxJQUE1QixDQUF4QixDQUFkO0FBQ0EsUUFBSStCLG1CQUFtQnRCLFFBQVFHLE1BQVIsQ0FBZSxVQUFVQyxDQUFWLEVBQWE7QUFDakQsYUFBT0EsRUFBRW1CLFdBQUYsRUFBUDtBQUNELEtBRnNCLENBQXZCO0FBR0EsUUFBSXlDLGVBQWUxQyxpQkFBaUJuQixNQUFqQixDQUF3QixVQUFVQyxDQUFWLEVBQWE7QUFDdEQsYUFBT0EsRUFBRXVDLE9BQUYsRUFBUDtBQUNELEtBRmtCLENBQW5CO0FBR0EsUUFBSXNCLGVBQWUzQyxpQkFBaUJuQixNQUFqQixDQUF3QixVQUFVQyxDQUFWLEVBQWE7QUFDdEQsYUFBT0EsRUFBRXlDLE9BQUYsRUFBUDtBQUNELEtBRmtCLENBQW5COztBQUlBLFdBQU87QUFDTEUsYUFBT3BFLFFBQVFVLE9BQVIsQ0FBZ0JvQyxPQUFoQixDQUF3QnVDLFlBQXhCLEVBQXNDLFVBQVU1RCxDQUFWLEVBQWE7QUFDeEQsZUFBT0EsRUFBRU8sYUFBVDtBQUNELE9BRk0sRUFFSlEsR0FGSSxDQUVBLFVBQVV6QixDQUFWLEVBQWE7QUFDbEIsZUFBTyxFQUFFRSxHQUFHRixFQUFFRSxDQUFQLEVBQVVDLEdBQUdILEVBQUVHLENBQWYsRUFBUDtBQUNELE9BSk0sQ0FERjtBQU1Mb0QsYUFBT3RFLFFBQVFVLE9BQVIsQ0FBZ0JvQyxPQUFoQixDQUF3QndDLFlBQXhCLEVBQXNDLFVBQVU3RCxDQUFWLEVBQWE7QUFDeEQsZUFBT0EsRUFBRU8sYUFBVDtBQUNELE9BRk0sRUFFSlEsR0FGSSxDQUVBLFVBQVV6QixDQUFWLEVBQWE7QUFDbEIsZUFBTyxFQUFFRSxHQUFHRixFQUFFRSxDQUFQLEVBQVVDLEdBQUdILEVBQUVHLENBQWYsRUFBUDtBQUNELE9BSk07QUFORixLQUFQO0FBWUQ7QUF4QzZCLENBQWQsQ0FBbEI7O0FBMkNBLElBQUl3RSxTQUFTLFNBQVNBLE1BQVQsR0FBa0I7QUFDN0IsTUFBSUMsT0FBT0MsVUFBVWpFLE1BQVYsR0FBbUIsQ0FBbkIsSUFBd0JpRSxVQUFVLENBQVYsTUFBaUJDLFNBQXpDLEdBQXFERCxVQUFVLENBQVYsQ0FBckQsR0FBb0UsRUFBL0U7QUFBQSxNQUNJRSxVQUFVSCxLQUFLRyxPQURuQjtBQUFBLE1BRUlDLE9BQU9KLEtBQUtJLElBRmhCOztBQUlBLE9BQUtDLFNBQUwsR0FBaUI7QUFDZixZQUFRVCxXQURPO0FBRWYsaUJBQWE5QixnQkFGRTtBQUdmLG1CQUFlOEI7QUFIQSxJQUlmTyxPQUplLENBQWpCOztBQU1BLE9BQUtHLEtBQUwsR0FBYUYsSUFBYjs7QUFFQSxNQUFJLENBQUMsS0FBS0MsU0FBVixFQUFxQjtBQUNuQixVQUFNLElBQUlFLEtBQUosQ0FBVSwyQkFBMkJKLE9BQXJDLENBQU47QUFDRDs7QUFFRCxNQUFJLEtBQUtHLEtBQUwsS0FBZSxJQUFmLElBQXVCLE9BQU8sS0FBS0EsS0FBWixLQUFzQixXQUFqRCxFQUE4RDtBQUM1RCxVQUFNLElBQUlDLEtBQUosQ0FBVSxnREFBVixDQUFOO0FBQ0Q7O0FBRUQsTUFBSSxPQUFPLEtBQUtELEtBQVosS0FBc0IsUUFBMUIsRUFBb0M7QUFDbEMsVUFBTSxJQUFJQyxLQUFKLENBQVUsdUNBQXVDSCxJQUFqRCxDQUFOO0FBQ0Q7O0FBRUQsT0FBS0ksY0FBTCxHQUFzQkwsWUFBWSxhQUFsQzs7QUFFQXBHLFNBQU9nRSxNQUFQLENBQWMsSUFBZDtBQUNELENBNUJEOztBQThCQWdDLE9BQU9VLFNBQVAsR0FBbUI7QUFDakJ6QyxTQUFPLFNBQVNBLEtBQVQsQ0FBZS9DLElBQWYsRUFBcUI7QUFDMUIsUUFBSXlGLFNBQVMsS0FBS0wsU0FBTCxDQUFlckMsS0FBZixDQUFxQi9DLElBQXJCLENBQWI7QUFDQXlGLFdBQU8vQixLQUFQLElBQWdCLEtBQUsyQixLQUFyQjs7QUFFQSxRQUFJLEtBQUtFLGNBQVQsRUFBeUI7QUFDdkI7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBLFVBQUlHLDJCQUEyQjFGLEtBQUtDLFlBQUwsR0FBb0IwRixLQUFwQixLQUE4QixPQUE3RDs7QUFFQSxhQUFPO0FBQ0xuQyxlQUFPaUMsT0FBT2pDLEtBQVAsR0FBZXhELEtBQUtDLFlBQUwsR0FBb0IyRixlQUFuQyxJQUFzREYsMkJBQTJCLENBQTNCLEdBQStCLENBQXJGLENBREY7QUFFTGhDLGVBQU8rQixPQUFPL0IsS0FBUCxHQUFlMUQsS0FBS0MsWUFBTCxHQUFvQjRGO0FBRnJDLE9BQVA7QUFJRCxLQWxCRCxNQWtCTztBQUNMLGFBQU9KLE1BQVA7QUFDRDtBQUNGLEdBMUJnQjs7QUE0QmpCbEMsYUFBVyxTQUFTQSxTQUFULENBQW1CdkQsSUFBbkIsRUFBeUI7QUFDbEMsV0FBTyxLQUFLb0YsU0FBTCxDQUFlN0IsU0FBZixDQUF5QnZELElBQXpCLENBQVA7QUFDRCxHQTlCZ0I7O0FBZ0NqQjhGLG1CQUFpQixTQUFTQSxlQUFULEdBQTJCO0FBQzFDLFdBQU8sS0FBS1AsY0FBWjtBQUNEO0FBbENnQixDQUFuQjs7QUFxQ0F2RyxRQUFRYyxPQUFSLEdBQWtCZ0YsTUFBbEI7O0FBRUEiLCJmaWxlIjoic2NvcmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiXCJ1c2Ugc3RyaWN0XCI7XG5cbk9iamVjdC5kZWZpbmVQcm9wZXJ0eShleHBvcnRzLCBcIl9fZXNNb2R1bGVcIiwge1xuICB2YWx1ZTogdHJ1ZVxufSk7XG5cbnZhciBfdXRpbHMgPSByZXF1aXJlKFwiLi91dGlsc1wiKTtcblxudmFyIF91dGlsczIgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF91dGlscyk7XG5cbnZhciBfaW50ZXJzZWN0aW9uID0gcmVxdWlyZShcIi4vaW50ZXJzZWN0aW9uXCIpO1xuXG52YXIgX2ludGVyc2VjdGlvbjIgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9pbnRlcnNlY3Rpb24pO1xuXG52YXIgX3JlZ2lvbiA9IHJlcXVpcmUoXCIuL3JlZ2lvblwiKTtcblxudmFyIF9yZWdpb24yID0gX2ludGVyb3BSZXF1aXJlRGVmYXVsdChfcmVnaW9uKTtcblxudmFyIF9leWVQb2ludCA9IHJlcXVpcmUoXCIuL2V5ZS1wb2ludFwiKTtcblxudmFyIF9leWVQb2ludDIgPSBfaW50ZXJvcFJlcXVpcmVEZWZhdWx0KF9leWVQb2ludCk7XG5cbmZ1bmN0aW9uIF9pbnRlcm9wUmVxdWlyZURlZmF1bHQob2JqKSB7IHJldHVybiBvYmogJiYgb2JqLl9fZXNNb2R1bGUgPyBvYmogOiB7IGRlZmF1bHQ6IG9iaiB9OyB9XG5cbnZhciBib2FyZFN0YXRlV2l0aG91dERlYWRQb2ludHMgPSBmdW5jdGlvbiBib2FyZFN0YXRlV2l0aG91dERlYWRQb2ludHMoZ2FtZSkge1xuICByZXR1cm4gZ2FtZS5jdXJyZW50U3RhdGUoKS5fd2l0aG91dEludGVyc2VjdGlvbnNNYXRjaGluZyhmdW5jdGlvbiAoaSkge1xuICAgIHJldHVybiBnYW1lLl9pc0RlYWRBdChpLnksIGkueCk7XG4gIH0pO1xufTtcblxudmFyIGJvYXJkU3RhdGVXaXRob3V0TmV1dHJhbFBvaW50cyA9IGZ1bmN0aW9uIGJvYXJkU3RhdGVXaXRob3V0TmV1dHJhbFBvaW50cyhib2FyZFN0YXRlKSB7XG4gIHZhciByZWdpb25zID0gX3JlZ2lvbjIuZGVmYXVsdC5hbGxGb3IoYm9hcmRTdGF0ZSk7XG4gIHZhciBuZXV0cmFsUmVnaW9ucyA9IHJlZ2lvbnMuZmlsdGVyKGZ1bmN0aW9uIChyKSB7XG4gICAgcmV0dXJuIHIuaXNOZXV0cmFsKCk7XG4gIH0pO1xuXG4gIGlmIChyZWdpb25zLmxlbmd0aCA9PT0gMCB8fCBuZXV0cmFsUmVnaW9ucy5sZW5ndGggPT09IDApIHtcbiAgICByZXR1cm4gYm9hcmRTdGF0ZTtcbiAgfVxuXG4gIHZhciByZXBsYWNlbWVudHMgPSB7fTtcblxuICBuZXV0cmFsUmVnaW9ucy5mb3JFYWNoKGZ1bmN0aW9uIChyKSB7XG4gICAgdmFyIHN0YXJ0aW5nWCA9IG51bGw7XG4gICAgdmFyIHN0YXJ0aW5nWSA9IG51bGw7XG5cbiAgICByLmludGVyc2VjdGlvbnMuZm9yRWFjaChmdW5jdGlvbiAoaW50ZXJzZWN0aW9uKSB7XG4gICAgICBzdGFydGluZ1ggPSBzdGFydGluZ1ggfHwgaW50ZXJzZWN0aW9uLng7XG4gICAgICBzdGFydGluZ1ggPSBzdGFydGluZ1ggfHwgaW50ZXJzZWN0aW9uLnk7XG5cbiAgICAgIHZhciBtYW5oYXR0YW5EaXN0YW5jZSA9IE1hdGguYWJzKGludGVyc2VjdGlvbi55IC0gc3RhcnRpbmdZKSArIE1hdGguYWJzKGludGVyc2VjdGlvbi54IC0gc3RhcnRpbmdYKTtcbiAgICAgIHZhciByZXBsYWNlbWVudENvbG9yID0gW1wiYmxhY2tcIiwgXCJ3aGl0ZVwiXVttYW5oYXR0YW5EaXN0YW5jZSAlIDJdO1xuICAgICAgdmFyIHJlcGxhY2VtZW50ID0gbmV3IF9pbnRlcnNlY3Rpb24yLmRlZmF1bHQoaW50ZXJzZWN0aW9uLnksIGludGVyc2VjdGlvbi54LCByZXBsYWNlbWVudENvbG9yKTtcblxuICAgICAgcmVwbGFjZW1lbnRzW2ludGVyc2VjdGlvbi55XSA9IHJlcGxhY2VtZW50c1tpbnRlcnNlY3Rpb24ueV0gfHwgW107XG4gICAgICByZXBsYWNlbWVudHNbaW50ZXJzZWN0aW9uLnldW2ludGVyc2VjdGlvbi54XSA9IHJlcGxhY2VtZW50O1xuICAgIH0pO1xuICB9KTtcblxuICB2YXIgbmV3UG9pbnRzID0gYm9hcmRTdGF0ZS5pbnRlcnNlY3Rpb25zLm1hcChmdW5jdGlvbiAoaSkge1xuICAgIGlmIChyZXBsYWNlbWVudHNbaS55XSAmJiByZXBsYWNlbWVudHNbaS55XVtpLnhdKSB7XG4gICAgICByZXR1cm4gcmVwbGFjZW1lbnRzW2kueV1baS54XTtcbiAgICB9IGVsc2Uge1xuICAgICAgcmV0dXJuIGk7XG4gICAgfVxuICB9KTtcblxuICByZXR1cm4gYm9hcmRTdGF0ZS5fd2l0aE5ld1BvaW50cyhuZXdQb2ludHMpO1xufTtcblxudmFyIGJvYXJkU3RhdGVXaXRoQ2xlYXJGYWxzZUV5ZXNGaWxsZWQgPSBmdW5jdGlvbiBib2FyZFN0YXRlV2l0aENsZWFyRmFsc2VFeWVzRmlsbGVkKGJvYXJkU3RhdGUpIHtcbiAgdmFyIHRlcnJpdG9yeVJlZ2lvbnMgPSBfcmVnaW9uMi5kZWZhdWx0LmFsbEZvcihib2FyZFN0YXRlKS5maWx0ZXIoZnVuY3Rpb24gKHIpIHtcbiAgICByZXR1cm4gci5pc1RlcnJpdG9yeSgpO1xuICB9KTtcbiAgdmFyIGZhbHNlRXllUG9pbnRzID0gX3V0aWxzMi5kZWZhdWx0LmZsYXRNYXAodGVycml0b3J5UmVnaW9ucywgZnVuY3Rpb24gKHIpIHtcbiAgICByZXR1cm4gci5pbnRlcnNlY3Rpb25zO1xuICB9KS5maWx0ZXIoZnVuY3Rpb24gKGkpIHtcbiAgICByZXR1cm4gbmV3IF9leWVQb2ludDIuZGVmYXVsdChib2FyZFN0YXRlLCBpKS5pc0ZhbHNlKCk7XG4gIH0pO1xuXG4gIHZhciBwb2ludHNOZWlnaGJvcmluZ0F0YXJpID0gZmFsc2VFeWVQb2ludHMuZmlsdGVyKGZ1bmN0aW9uIChpKSB7XG4gICAgcmV0dXJuIGJvYXJkU3RhdGUubmVpZ2hib3JzRm9yKGkueSwgaS54KS5zb21lKGZ1bmN0aW9uIChuKSB7XG4gICAgICByZXR1cm4gYm9hcmRTdGF0ZS5pbkF0YXJpKG4ueSwgbi54KTtcbiAgICB9KTtcbiAgfSk7XG4gIHZhciBuZXV0cmFsQXRhcmlVcGRhdGVkU3RhdGUgPSBib2FyZFN0YXRlO1xuXG4gIHZhciBfbG9vcCA9IGZ1bmN0aW9uIF9sb29wKCkge1xuICAgIHZhciBuZXdQb2ludHMgPSBuZXV0cmFsQXRhcmlVcGRhdGVkU3RhdGUuaW50ZXJzZWN0aW9ucy5tYXAoZnVuY3Rpb24gKGkpIHtcbiAgICAgIGlmIChwb2ludHNOZWlnaGJvcmluZ0F0YXJpLmluZGV4T2YoaSkgPiAtMSkge1xuICAgICAgICByZXR1cm4gbmV3IF9pbnRlcnNlY3Rpb24yLmRlZmF1bHQoaS55LCBpLngsIG5ldyBfZXllUG9pbnQyLmRlZmF1bHQobmV1dHJhbEF0YXJpVXBkYXRlZFN0YXRlLCBpKS5maWxsZWRDb2xvcigpKTtcbiAgICAgIH0gZWxzZSB7XG4gICAgICAgIHJldHVybiBpO1xuICAgICAgfVxuICAgIH0pO1xuICAgIG5ldXRyYWxBdGFyaVVwZGF0ZWRTdGF0ZSA9IG5ldXRyYWxBdGFyaVVwZGF0ZWRTdGF0ZS5fd2l0aE5ld1BvaW50cyhuZXdQb2ludHMpO1xuXG4gICAgdmFyIGJvYXJkU3RhdGUgPSBib2FyZFN0YXRlV2l0aG91dE5ldXRyYWxQb2ludHMobmV1dHJhbEF0YXJpVXBkYXRlZFN0YXRlKTtcbiAgICB2YXIgdGVycml0b3J5UmVnaW9ucyA9IF9yZWdpb24yLmRlZmF1bHQuYWxsRm9yKGJvYXJkU3RhdGUpLmZpbHRlcihmdW5jdGlvbiAocikge1xuICAgICAgcmV0dXJuIHIuaXNUZXJyaXRvcnkoKTtcbiAgICB9KTtcbiAgICB2YXIgZmFsc2VFeWVQb2ludHMgPSBfdXRpbHMyLmRlZmF1bHQuZmxhdE1hcCh0ZXJyaXRvcnlSZWdpb25zLCBmdW5jdGlvbiAocikge1xuICAgICAgcmV0dXJuIHIuaW50ZXJzZWN0aW9ucztcbiAgICB9KS5maWx0ZXIoZnVuY3Rpb24gKGkpIHtcbiAgICAgIHJldHVybiBuZXcgX2V5ZVBvaW50Mi5kZWZhdWx0KGJvYXJkU3RhdGUsIGkpLmlzRmFsc2UoKTtcbiAgICB9KTtcblxuICAgIHBvaW50c05laWdoYm9yaW5nQXRhcmkgPSBmYWxzZUV5ZVBvaW50cy5maWx0ZXIoZnVuY3Rpb24gKGkpIHtcbiAgICAgIHJldHVybiBuZXV0cmFsQXRhcmlVcGRhdGVkU3RhdGUubmVpZ2hib3JzRm9yKGkueSwgaS54KS5zb21lKGZ1bmN0aW9uIChuKSB7XG4gICAgICAgIHJldHVybiBuZXV0cmFsQXRhcmlVcGRhdGVkU3RhdGUuaW5BdGFyaShuLnksIG4ueCk7XG4gICAgICB9KTtcbiAgICB9KTtcbiAgfTtcblxuICB3aGlsZSAocG9pbnRzTmVpZ2hib3JpbmdBdGFyaS5sZW5ndGggPiAwKSB7XG4gICAgX2xvb3AoKTtcbiAgfVxuXG4gIHJldHVybiBuZXV0cmFsQXRhcmlVcGRhdGVkU3RhdGU7XG59O1xuXG52YXIgVGVycml0b3J5U2NvcmluZyA9IE9iamVjdC5mcmVlemUoe1xuICBzY29yZTogZnVuY3Rpb24gc2NvcmUoZ2FtZSkge1xuICAgIHZhciBibGFja0RlYWRBc0NhcHR1cmVzID0gZ2FtZS5kZWFkU3RvbmVzKCkuZmlsdGVyKGZ1bmN0aW9uIChkZWFkUG9pbnQpIHtcbiAgICAgIHJldHVybiBnYW1lLmludGVyc2VjdGlvbkF0KGRlYWRQb2ludC55LCBkZWFkUG9pbnQueCkuaXNCbGFjaygpO1xuICAgIH0pO1xuICAgIHZhciB3aGl0ZURlYWRBc0NhcHR1cmVzID0gZ2FtZS5kZWFkU3RvbmVzKCkuZmlsdGVyKGZ1bmN0aW9uIChkZWFkUG9pbnQpIHtcbiAgICAgIHJldHVybiBnYW1lLmludGVyc2VjdGlvbkF0KGRlYWRQb2ludC55LCBkZWFkUG9pbnQueCkuaXNXaGl0ZSgpO1xuICAgIH0pO1xuXG4gICAgdmFyIHRlcnJpdG9yeSA9IGdhbWUudGVycml0b3J5KCk7XG4gICAgdmFyIGJvYXJkU3RhdGUgPSBnYW1lLmN1cnJlbnRTdGF0ZSgpO1xuXG4gICAgcmV0dXJuIHtcbiAgICAgIGJsYWNrOiB0ZXJyaXRvcnkuYmxhY2subGVuZ3RoICsgYm9hcmRTdGF0ZS53aGl0ZVN0b25lc0NhcHR1cmVkICsgd2hpdGVEZWFkQXNDYXB0dXJlcy5sZW5ndGgsXG4gICAgICB3aGl0ZTogdGVycml0b3J5LndoaXRlLmxlbmd0aCArIGJvYXJkU3RhdGUuYmxhY2tTdG9uZXNDYXB0dXJlZCArIGJsYWNrRGVhZEFzQ2FwdHVyZXMubGVuZ3RoXG4gICAgfTtcbiAgfSxcblxuICB0ZXJyaXRvcnk6IGZ1bmN0aW9uIHRlcnJpdG9yeShnYW1lKSB7XG4gICAgdmFyIHN0YXRlV2l0aG91dERlYWRQb2ludHMgPSBib2FyZFN0YXRlV2l0aG91dERlYWRQb2ludHMoZ2FtZSk7XG4gICAgdmFyIHN0YXRlV2l0aG91dE5ldXRyYWxzID0gYm9hcmRTdGF0ZVdpdGhvdXROZXV0cmFsUG9pbnRzKHN0YXRlV2l0aG91dERlYWRQb2ludHMpO1xuICAgIHZhciBzdGF0ZVdpdGhDbGVhckZhbHNlRXllc0ZpbGxlZCA9IGJvYXJkU3RhdGVXaXRoQ2xlYXJGYWxzZUV5ZXNGaWxsZWQoc3RhdGVXaXRob3V0TmV1dHJhbHMpO1xuXG4gICAgdmFyIHRlcnJpdG9yeVJlZ2lvbnMgPSBfcmVnaW9uMi5kZWZhdWx0LmFsbEZvcihzdGF0ZVdpdGhDbGVhckZhbHNlRXllc0ZpbGxlZCkuZmlsdGVyKGZ1bmN0aW9uIChyKSB7XG4gICAgICByZXR1cm4gci5pc1RlcnJpdG9yeSgpO1xuICAgIH0pO1xuXG4gICAgdmFyIHRlcnJpdG9yeVJlZ2lvbnNXaXRob3V0U2VraSA9IHRlcnJpdG9yeVJlZ2lvbnMuZmlsdGVyKGZ1bmN0aW9uIChyKSB7XG4gICAgICB2YXIgbWVyZ2VkID0gX3JlZ2lvbjIuZGVmYXVsdC5tZXJnZSh0ZXJyaXRvcnlSZWdpb25zLCByKTtcbiAgICAgIHZhciBleWVDb3VudHMgPSBtZXJnZWQubWFwKGZ1bmN0aW9uIChtKSB7XG4gICAgICAgIHJldHVybiBNYXRoLmNlaWwobS5udW1iZXJPZkV5ZXMoKSk7XG4gICAgICB9KTtcblxuICAgICAgcmV0dXJuIGV5ZUNvdW50cy5sZW5ndGggPiAwICYmIGV5ZUNvdW50cy5yZWR1Y2UoZnVuY3Rpb24gKGEsIGIpIHtcbiAgICAgICAgcmV0dXJuIGEgKyBiO1xuICAgICAgfSkgPj0gMjtcbiAgICB9KTtcblxuICAgIHZhciBibGFja1JlZ2lvbnMgPSB0ZXJyaXRvcnlSZWdpb25zV2l0aG91dFNla2kuZmlsdGVyKGZ1bmN0aW9uIChyKSB7XG4gICAgICByZXR1cm4gci5pc0JsYWNrKCk7XG4gICAgfSk7XG4gICAgdmFyIHdoaXRlUmVnaW9ucyA9IHRlcnJpdG9yeVJlZ2lvbnNXaXRob3V0U2VraS5maWx0ZXIoZnVuY3Rpb24gKHIpIHtcbiAgICAgIHJldHVybiByLmlzV2hpdGUoKTtcbiAgICB9KTtcblxuICAgIHJldHVybiB7XG4gICAgICBibGFjazogX3V0aWxzMi5kZWZhdWx0LmZsYXRNYXAoYmxhY2tSZWdpb25zLCBmdW5jdGlvbiAocikge1xuICAgICAgICByZXR1cm4gci5pbnRlcnNlY3Rpb25zO1xuICAgICAgfSkubWFwKGZ1bmN0aW9uIChpKSB7XG4gICAgICAgIHJldHVybiB7IHk6IGkueSwgeDogaS54IH07XG4gICAgICB9KSxcbiAgICAgIHdoaXRlOiBfdXRpbHMyLmRlZmF1bHQuZmxhdE1hcCh3aGl0ZVJlZ2lvbnMsIGZ1bmN0aW9uIChyKSB7XG4gICAgICAgIHJldHVybiByLmludGVyc2VjdGlvbnM7XG4gICAgICB9KS5tYXAoZnVuY3Rpb24gKGkpIHtcbiAgICAgICAgcmV0dXJuIHsgeTogaS55LCB4OiBpLnggfTtcbiAgICAgIH0pXG4gICAgfTtcbiAgfVxufSk7XG5cbnZhciBBcmVhU2NvcmluZyA9IE9iamVjdC5mcmVlemUoe1xuICBzY29yZTogZnVuY3Rpb24gc2NvcmUoZ2FtZSkge1xuICAgIHZhciBibGFja1N0b25lc09uVGhlQm9hcmQgPSBnYW1lLmludGVyc2VjdGlvbnMoKS5maWx0ZXIoZnVuY3Rpb24gKGludGVyc2VjdGlvbikge1xuICAgICAgcmV0dXJuIGludGVyc2VjdGlvbi5pc0JsYWNrKCkgJiYgIWdhbWUuX2lzRGVhZEF0KGludGVyc2VjdGlvbi55LCBpbnRlcnNlY3Rpb24ueCk7XG4gICAgfSk7XG4gICAgdmFyIHdoaXRlU3RvbmVzT25UaGVCb2FyZCA9IGdhbWUuaW50ZXJzZWN0aW9ucygpLmZpbHRlcihmdW5jdGlvbiAoaW50ZXJzZWN0aW9uKSB7XG4gICAgICByZXR1cm4gaW50ZXJzZWN0aW9uLmlzV2hpdGUoKSAmJiAhZ2FtZS5faXNEZWFkQXQoaW50ZXJzZWN0aW9uLnksIGludGVyc2VjdGlvbi54KTtcbiAgICB9KTtcbiAgICB2YXIgdGVycml0b3J5ID0gZ2FtZS50ZXJyaXRvcnkoKTtcblxuICAgIHJldHVybiB7XG4gICAgICBibGFjazogdGVycml0b3J5LmJsYWNrLmxlbmd0aCArIGJsYWNrU3RvbmVzT25UaGVCb2FyZC5sZW5ndGgsXG4gICAgICB3aGl0ZTogdGVycml0b3J5LndoaXRlLmxlbmd0aCArIHdoaXRlU3RvbmVzT25UaGVCb2FyZC5sZW5ndGhcbiAgICB9O1xuICB9LFxuXG4gIHRlcnJpdG9yeTogZnVuY3Rpb24gdGVycml0b3J5KGdhbWUpIHtcbiAgICB2YXIgcmVnaW9ucyA9IF9yZWdpb24yLmRlZmF1bHQuYWxsRm9yKGJvYXJkU3RhdGVXaXRob3V0RGVhZFBvaW50cyhnYW1lKSk7XG4gICAgdmFyIHRlcnJpdG9yeVJlZ2lvbnMgPSByZWdpb25zLmZpbHRlcihmdW5jdGlvbiAocikge1xuICAgICAgcmV0dXJuIHIuaXNUZXJyaXRvcnkoKTtcbiAgICB9KTtcbiAgICB2YXIgYmxhY2tSZWdpb25zID0gdGVycml0b3J5UmVnaW9ucy5maWx0ZXIoZnVuY3Rpb24gKHIpIHtcbiAgICAgIHJldHVybiByLmlzQmxhY2soKTtcbiAgICB9KTtcbiAgICB2YXIgd2hpdGVSZWdpb25zID0gdGVycml0b3J5UmVnaW9ucy5maWx0ZXIoZnVuY3Rpb24gKHIpIHtcbiAgICAgIHJldHVybiByLmlzV2hpdGUoKTtcbiAgICB9KTtcblxuICAgIHJldHVybiB7XG4gICAgICBibGFjazogX3V0aWxzMi5kZWZhdWx0LmZsYXRNYXAoYmxhY2tSZWdpb25zLCBmdW5jdGlvbiAocikge1xuICAgICAgICByZXR1cm4gci5pbnRlcnNlY3Rpb25zO1xuICAgICAgfSkubWFwKGZ1bmN0aW9uIChpKSB7XG4gICAgICAgIHJldHVybiB7IHk6IGkueSwgeDogaS54IH07XG4gICAgICB9KSxcbiAgICAgIHdoaXRlOiBfdXRpbHMyLmRlZmF1bHQuZmxhdE1hcCh3aGl0ZVJlZ2lvbnMsIGZ1bmN0aW9uIChyKSB7XG4gICAgICAgIHJldHVybiByLmludGVyc2VjdGlvbnM7XG4gICAgICB9KS5tYXAoZnVuY3Rpb24gKGkpIHtcbiAgICAgICAgcmV0dXJuIHsgeTogaS55LCB4OiBpLnggfTtcbiAgICAgIH0pXG4gICAgfTtcbiAgfVxufSk7XG5cbnZhciBTY29yZXIgPSBmdW5jdGlvbiBTY29yZXIoKSB7XG4gIHZhciBfcmVmID0gYXJndW1lbnRzLmxlbmd0aCA+IDAgJiYgYXJndW1lbnRzWzBdICE9PSB1bmRlZmluZWQgPyBhcmd1bWVudHNbMF0gOiB7fSxcbiAgICAgIHNjb3JlQnkgPSBfcmVmLnNjb3JlQnksXG4gICAgICBrb21pID0gX3JlZi5rb21pO1xuXG4gIHRoaXMuX3N0cmF0ZWd5ID0ge1xuICAgIFwiYXJlYVwiOiBBcmVhU2NvcmluZyxcbiAgICBcInRlcnJpdG9yeVwiOiBUZXJyaXRvcnlTY29yaW5nLFxuICAgIFwiZXF1aXZhbGVuY2VcIjogQXJlYVNjb3JpbmdcbiAgfVtzY29yZUJ5XTtcblxuICB0aGlzLl9rb21pID0ga29taTtcblxuICBpZiAoIXRoaXMuX3N0cmF0ZWd5KSB7XG4gICAgdGhyb3cgbmV3IEVycm9yKFwiVW5rbm93biBzY29yaW5nIHR5cGU6IFwiICsgc2NvcmVCeSk7XG4gIH1cblxuICBpZiAodGhpcy5fa29taSA9PT0gbnVsbCB8fCB0eXBlb2YgdGhpcy5fa29taSA9PT0gXCJ1bmRlZmluZWRcIikge1xuICAgIHRocm93IG5ldyBFcnJvcihcIkVycm9yIGluaXRpYWxpemluZyBzY29yZXIgd2l0aG91dCBhIGtvbWkgdmFsdWVcIik7XG4gIH1cblxuICBpZiAodHlwZW9mIHRoaXMuX2tvbWkgIT09IFwibnVtYmVyXCIpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoXCJLb21pIHZhbHVlIGdpdmVuIGlzIG5vdCBhIG51bWJlcjogXCIgKyBrb21pKTtcbiAgfVxuXG4gIHRoaXMuX3VzZVBhc3NTdG9uZXMgPSBzY29yZUJ5ID09PSBcImVxdWl2YWxlbmNlXCI7XG5cbiAgT2JqZWN0LmZyZWV6ZSh0aGlzKTtcbn07XG5cblNjb3Jlci5wcm90b3R5cGUgPSB7XG4gIHNjb3JlOiBmdW5jdGlvbiBzY29yZShnYW1lKSB7XG4gICAgdmFyIHJlc3VsdCA9IHRoaXMuX3N0cmF0ZWd5LnNjb3JlKGdhbWUpO1xuICAgIHJlc3VsdC53aGl0ZSArPSB0aGlzLl9rb21pO1xuXG4gICAgaWYgKHRoaXMuX3VzZVBhc3NTdG9uZXMpIHtcbiAgICAgIC8vIFVuZGVyIGVxdWl2YWxlbmNlIHNjb3JpbmcsIDIgY29uc2VjdXRpdmUgcGFzc2VzIHNpZ25hbHMoISkgdGhlIGVuZCBvZiB0aGVcbiAgICAgIC8vIGdhbWUsIGJ1dCBqdXN0IHByaW9yIHRvIHRoZSBlbmQgb2YgdGhlIGdhbWUsIHdoaXRlIG11c3QgbWFrZSBvbmUgZmluYWxcbiAgICAgIC8vIHBhc3MgbW92ZSBpZiB0aGUgZ2FtZSBkaWRuJ3QgZW5kIG9uIGEgd2hpdGUgcGFzcy5cbiAgICAgIC8vXG4gICAgICAvLyBIb3dldmVyLCBpbnN0ZWFkIG9mIGNyZWF0aW5nIGEgM3JkIGNvbnNlY3V0aXZlIHBhc3MgaW4gdGhlIGJvYXJkIHN0YXRlLFxuICAgICAgLy8gd2hpdGUncyBhZGRpdGlvbmFsIHBhc3Mgc3RvbmUgaXMgaGFuZGxlZCBieSB0aGUgc2NvcmluZyBtZWNoYW5pc20gYWxvbmUuXG4gICAgICAvLyBUaGUgaWRlYSBpcyB0aGF0LCB1bmRlciBhbnkgZ2FtZSByZXN1bXB0aW9uLCB0aGUgYWRkaXRpb25hbCB3aGl0ZSBwYXNzXG4gICAgICAvLyBzdG9uZSBtdXN0IG5vdCBleGlzdCwgc28gd2Ugc2hvdWxkbid0IGFkZCBpdC5cbiAgICAgIC8vXG4gICAgICAvLyBOT1RFOiB0aGUgZmluYWwgcmVzdWx0IHNob3VsZCByZWx5IG9uIHRoaXMgc2NvcmluZyBmdW5jdGlvbi4gQW55IGNhbGN1bGF0aW9uc1xuICAgICAgLy8gdXNpbmcgcmF3IGJvYXJkIHN0YXRlIHBhc3Mgc3RvbmUgbnVtYmVycyBtYXkgYmUgb2ZmIGJ5IDEgaW4gZmF2b3Igb2YgYmxhY2suXG4gICAgICB2YXIgbmVlZHNGaW5hbFdoaXRlUGFzc1N0b25lID0gZ2FtZS5jdXJyZW50U3RhdGUoKS5jb2xvciAhPT0gXCJ3aGl0ZVwiO1xuXG4gICAgICByZXR1cm4ge1xuICAgICAgICBibGFjazogcmVzdWx0LmJsYWNrICsgZ2FtZS5jdXJyZW50U3RhdGUoKS53aGl0ZVBhc3NTdG9uZXMgKyAobmVlZHNGaW5hbFdoaXRlUGFzc1N0b25lID8gMSA6IDApLFxuICAgICAgICB3aGl0ZTogcmVzdWx0LndoaXRlICsgZ2FtZS5jdXJyZW50U3RhdGUoKS5ibGFja1Bhc3NTdG9uZXNcbiAgICAgIH07XG4gICAgfSBlbHNlIHtcbiAgICAgIHJldHVybiByZXN1bHQ7XG4gICAgfVxuICB9LFxuXG4gIHRlcnJpdG9yeTogZnVuY3Rpb24gdGVycml0b3J5KGdhbWUpIHtcbiAgICByZXR1cm4gdGhpcy5fc3RyYXRlZ3kudGVycml0b3J5KGdhbWUpO1xuICB9LFxuXG4gIHVzaW5nUGFzc1N0b25lczogZnVuY3Rpb24gdXNpbmdQYXNzU3RvbmVzKCkge1xuICAgIHJldHVybiB0aGlzLl91c2VQYXNzU3RvbmVzO1xuICB9XG59O1xuXG5leHBvcnRzLmRlZmF1bHQgPSBTY29yZXI7XG5cbi8vIyBzb3VyY2VNYXBwaW5nVVJMPXNjb3Jlci5qcy5tYXAiXX0=
            },
            {
                "./eye-point": 5,
                "./intersection": 7,
                "./region": 9,
                "./utils": 14
            }
        ],
        13: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var _utils = require1("./utils");
                var _utils2 = _interopRequireDefault(_utils);
                var _renderer = require1("./renderer");
                var _renderer2 = _interopRequireDefault(_renderer);
                function _interopRequireDefault(obj) {
                    return obj && obj.__esModule ? obj : {
                        default: obj
                    };
                }
                var SVGRenderer = function SVGRenderer(boardElement, _ref) {
                    var hooks = _ref.hooks, options = _ref.options;
                    _renderer2.default.call(this, boardElement, {
                        hooks: hooks,
                        options: options
                    });
                    _utils2.default.addClass(boardElement, "tenuki-svg-renderer");
                };
                SVGRenderer.prototype = Object.create(_renderer2.default.prototype);
                SVGRenderer.prototype.constructor = SVGRenderer;
                var CACHED_CONSTRUCTED_LINES = {};
                var constructSVG = function constructSVG(renderer, boardState, _ref2) {
                    var hasCoordinates = _ref2.hasCoordinates, smallerStones = _ref2.smallerStones, flatStones = _ref2.flatStones;
                    var cacheKey = [
                        boardState.boardSize,
                        hasCoordinates,
                        smallerStones,
                        flatStones
                    ].toString();
                    var svg = _utils2.default.createSVGElement("svg");
                    var defs = _utils2.default.createSVGElement("defs");
                    _utils2.default.appendElement(svg, defs);
                    var blackGradient = _utils2.default.createSVGElement("radialGradient", {
                        attributes: {
                            id: renderer.blackGradientID,
                            cy: "15%",
                            r: "50%"
                        }
                    });
                    _utils2.default.appendElement(blackGradient, _utils2.default.createSVGElement("stop", {
                        attributes: {
                            offset: "0%",
                            "stop-color": "hsl(0, 0%, 38%)"
                        }
                    }));
                    _utils2.default.appendElement(blackGradient, _utils2.default.createSVGElement("stop", {
                        attributes: {
                            offset: "100%",
                            "stop-color": "#39363D"
                        }
                    }));
                    _utils2.default.appendElement(defs, blackGradient);
                    var whiteGradient = _utils2.default.createSVGElement("radialGradient", {
                        attributes: {
                            id: renderer.whiteGradientID,
                            cy: "15%",
                            r: "50%"
                        }
                    });
                    _utils2.default.appendElement(whiteGradient, _utils2.default.createSVGElement("stop", {
                        attributes: {
                            offset: "0%",
                            "stop-color": "#FFFFFF"
                        }
                    }));
                    _utils2.default.appendElement(whiteGradient, _utils2.default.createSVGElement("stop", {
                        attributes: {
                            offset: "100%",
                            "stop-color": "#fafdfc"
                        }
                    }));
                    _utils2.default.appendElement(defs, whiteGradient);
                    var contentsContainer = _utils2.default.createSVGElement("g", {
                        attributes: {
                            class: "contents",
                            transform: "translate(" + renderer.MARGIN + ", " + renderer.MARGIN + ")"
                        }
                    });
                    _utils2.default.appendElement(svg, contentsContainer);
                    var lines = void 0;
                    if (CACHED_CONSTRUCTED_LINES[cacheKey]) lines = _utils2.default.clone(CACHED_CONSTRUCTED_LINES[cacheKey]);
                    else {
                        lines = _utils2.default.createSVGElement("g", {
                            attributes: {
                                class: "lines"
                            }
                        });
                        for(var y = 0; y < boardState.boardSize - 1; y++)for(var x = 0; x < boardState.boardSize - 1; x++){
                            var lineBox = _utils2.default.createSVGElement("rect", {
                                attributes: {
                                    y: y * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5,
                                    x: x * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5,
                                    width: renderer.INTERSECTION_GAP_SIZE + 1,
                                    height: renderer.INTERSECTION_GAP_SIZE + 1,
                                    class: "line-box"
                                }
                            });
                            _utils2.default.appendElement(lines, lineBox);
                        }
                        CACHED_CONSTRUCTED_LINES[cacheKey] = lines;
                    }
                    _utils2.default.appendElement(contentsContainer, lines);
                    var hoshiPoints = _utils2.default.createSVGElement("g", {
                        attributes: {
                            class: "hoshi"
                        }
                    });
                    _utils2.default.appendElement(contentsContainer, hoshiPoints);
                    _renderer2.default.hoshiPositionsFor(boardState.boardSize).forEach(function(h) {
                        var hoshi = _utils2.default.createSVGElement("circle", {
                            attributes: {
                                class: "hoshi",
                                cy: h.top * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5,
                                cx: h.left * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5,
                                r: 2
                            }
                        });
                        _utils2.default.appendElement(hoshiPoints, hoshi);
                    });
                    if (hasCoordinates) (function() {
                        var coordinateContainer = _utils2.default.createSVGElement("g", {
                            attributes: {
                                class: "coordinates",
                                transform: "translate(" + renderer.MARGIN + ", " + renderer.MARGIN + ")"
                            }
                        });
                        var _loop = function _loop(_y) {
                            // TODO: 16 is for the rendered height _on my browser_. not reliable...
                            [
                                -21,
                                33 + (boardState.boardSize - 1) * (renderer.INTERSECTION_GAP_SIZE + 1)
                            ].forEach(function(verticalOffset) {
                                _utils2.default.appendElement(coordinateContainer, _utils2.default.createSVGElement("text", {
                                    text: boardState.xCoordinateFor(_y),
                                    attributes: {
                                        "text-anchor": "middle",
                                        y: verticalOffset - 0.5,
                                        x: _y * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5
                                    }
                                }));
                            });
                            [
                                -28,
                                28 + (boardState.boardSize - 1) * (renderer.INTERSECTION_GAP_SIZE + 1)
                            ].forEach(function(horizontalOffset) {
                                _utils2.default.appendElement(coordinateContainer, _utils2.default.createSVGElement("text", {
                                    text: boardState.yCoordinateFor(_y),
                                    attributes: {
                                        "text-anchor": "middle",
                                        y: _y * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5 + 4,
                                        x: horizontalOffset - 0.5
                                    }
                                }));
                            });
                            _utils2.default.appendElement(svg, coordinateContainer);
                        };
                        for(var _y = 0; _y < boardState.boardSize; _y++)_loop(_y);
                    })();
                    var intersections = _utils2.default.createSVGElement("g", {
                        attributes: {
                            class: "intersections"
                        }
                    });
                    for(var _y2 = 0; _y2 < boardState.boardSize; _y2++)for(var _x = 0; _x < boardState.boardSize; _x++){
                        var intersectionGroup = _utils2.default.createSVGElement("g", {
                            attributes: {
                                class: "intersection"
                            }
                        });
                        intersectionGroup.setAttribute("data-intersection-y", _y2);
                        intersectionGroup.setAttribute("data-intersection-x", _x);
                        _utils2.default.appendElement(intersections, intersectionGroup);
                        var intersectionInnerContainer = _utils2.default.createSVGElement("g", {
                            attributes: {
                                class: "intersection-inner-container"
                            }
                        });
                        _utils2.default.appendElement(intersectionGroup, intersectionInnerContainer);
                        var intersectionBox = _utils2.default.createSVGElement("rect", {
                            attributes: {
                                y: _y2 * (renderer.INTERSECTION_GAP_SIZE + 1) - renderer.INTERSECTION_GAP_SIZE / 2 - 0.5,
                                x: _x * (renderer.INTERSECTION_GAP_SIZE + 1) - renderer.INTERSECTION_GAP_SIZE / 2 - 0.5,
                                width: renderer.INTERSECTION_GAP_SIZE,
                                height: renderer.INTERSECTION_GAP_SIZE
                            }
                        });
                        _utils2.default.appendElement(intersectionInnerContainer, intersectionBox);
                        var stoneRadius = renderer.INTERSECTION_GAP_SIZE / 2;
                        if (smallerStones) stoneRadius -= 1;
                        var stoneAttributes = {
                            class: "stone",
                            cy: _y2 * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5,
                            cx: _x * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5,
                            r: stoneRadius
                        };
                        if (!flatStones) _utils2.default.appendElement(intersectionInnerContainer, _utils2.default.createSVGElement("circle", {
                            attributes: {
                                class: "stone-shadow",
                                cy: stoneAttributes["cy"] + 2,
                                cx: stoneAttributes["cx"],
                                r: stoneRadius
                            }
                        }));
                        var intersection = _utils2.default.createSVGElement("circle", {
                            attributes: stoneAttributes
                        });
                        _utils2.default.appendElement(intersectionInnerContainer, intersection);
                        _utils2.default.appendElement(intersectionInnerContainer, _utils2.default.createSVGElement("circle", {
                            attributes: {
                                class: "marker",
                                cy: _y2 * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5,
                                cx: _x * (renderer.INTERSECTION_GAP_SIZE + 1) - 0.5,
                                r: 4.5
                            }
                        }));
                        _utils2.default.appendElement(intersectionInnerContainer, _utils2.default.createSVGElement("rect", {
                            attributes: {
                                class: "ko-marker",
                                y: _y2 * (renderer.INTERSECTION_GAP_SIZE + 1) - 6 - 0.5,
                                x: _x * (renderer.INTERSECTION_GAP_SIZE + 1) - 6 - 0.5,
                                width: 12,
                                height: 12
                            }
                        }));
                        _utils2.default.appendElement(intersectionInnerContainer, _utils2.default.createSVGElement("rect", {
                            attributes: {
                                class: "territory-marker",
                                y: _y2 * (renderer.INTERSECTION_GAP_SIZE + 1) - 6,
                                x: _x * (renderer.INTERSECTION_GAP_SIZE + 1) - 6,
                                width: 11,
                                height: 11
                            }
                        }));
                        renderer.grid[_y2] = renderer.grid[_y2] || [];
                        renderer.grid[_y2][_x] = intersectionGroup;
                        renderer.addIntersectionEventListeners(intersectionGroup, _y2, _x);
                    }
                    _utils2.default.appendElement(contentsContainer, intersections);
                    return svg;
                };
                SVGRenderer.prototype.generateBoard = function(boardState, _ref3) {
                    var hasCoordinates = _ref3.hasCoordinates, smallerStones = _ref3.smallerStones, flatStones = _ref3.flatStones;
                    this.blackGradientID = _utils2.default.randomID("black-gradient");
                    this.whiteGradientID = _utils2.default.randomID("white-gradient");
                    var svg = constructSVG(this, boardState, {
                        hasCoordinates: hasCoordinates,
                        smallerStones: smallerStones,
                        flatStones: flatStones
                    });
                    this.svgElement = svg;
                    this.svgElement.setAttribute("height", this.BOARD_LENGTH);
                    this.svgElement.setAttribute("width", this.BOARD_LENGTH);
                    return svg;
                };
                SVGRenderer.prototype.computeSizing = function() {
                    var _this = this;
                    _renderer2.default.prototype.computeSizing.call(this);
                    // In addition to the will-change re-raster in Renderer,
                    // the SVG element appears to sometimes need this to
                    // prevent blurriness on resize.
                    this.svgElement.style.transform = "none";
                    window.requestAnimationFrame(function() {
                        _this.svgElement.style.transform = "";
                    });
                };
                SVGRenderer.prototype.setIntersectionClasses = function(intersectionEl, intersection, classes) {
                    if (intersectionEl.getAttribute("class") !== classes.join(" ")) intersectionEl.setAttribute("class", classes.join(" "));
                    if (!this.flatStones) {
                        if (intersection.isEmpty()) intersectionEl.querySelector(".stone").setAttribute("style", "");
                        else {
                            var base = window.location.href.split('#')[0];
                            intersectionEl.querySelector(".stone").setAttribute("style", "fill: url(" + base + "#" + this[intersection.value + "GradientID"] + ")");
                        }
                    }
                };
                exports.default = SVGRenderer;
            //# sourceMappingURL=svg-renderer.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {
                "./renderer": 10,
                "./utils": 14
            }
        ],
        14: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.default = {
                    flatten: function flatten(ary) {
                        return ary.reduce(function(a, b) {
                            return a.concat(b);
                        });
                    },
                    flatMap: function flatMap(ary, lambda) {
                        return Array.prototype.concat.apply([], ary.map(lambda));
                    },
                    cartesianProduct: function cartesianProduct(ary1, ary2) {
                        return this.flatten(ary1.map(function(x) {
                            return ary2.map(function(y) {
                                return [
                                    x,
                                    y
                                ];
                            });
                        }));
                    },
                    randomID: function randomID(prefix) {
                        var str = [
                            0,
                            1,
                            2,
                            3
                        ].map(function() {
                            return Math.floor(Math.random() * 0x10000).toString(16).substring(1);
                        }).join("");
                        return prefix + "-" + str;
                    },
                    clone: function clone(element) {
                        return element.cloneNode(true);
                    },
                    createElement: function createElement(elementName, options) {
                        var element = document.createElement(elementName);
                        if (typeof options !== "undefined") {
                            if (options.class) element.className = options.class;
                        }
                        return element;
                    },
                    createSVGElement: function createSVGElement(elementName, options) {
                        var _this = this;
                        var svgNamespace = "http://www.w3.org/2000/svg";
                        var element = document.createElementNS(svgNamespace, elementName);
                        if (typeof options !== "undefined") {
                            if (options.class) options.class.split(" ").forEach(function(name) {
                                _this.addClass(element, name);
                            });
                            if (options.attributes) Object.keys(options.attributes).forEach(function(k) {
                                element.setAttribute(k, options.attributes[k]);
                            });
                            if (options.text) element.textContent = options.text.toString();
                        }
                        return element;
                    },
                    appendElement: function appendElement(parent, el) {
                        parent.insertBefore(el, null);
                    },
                    addEventListener: function addEventListener(el, eventName, fn) {
                        el.addEventListener(eventName, fn, false);
                    },
                    removeClass: function removeClass(el, className) {
                        if (!this.hasClass(el, className)) return;
                        if (el.classList && el.classList.remove) {
                            el.classList.remove(className);
                            return;
                        }
                        var classNameRegex = RegExp('\\b' + className + '\\b', "g");
                        if (el instanceof SVGElement) el.setAttribute("class", el.getAttribute("class").replace(classNameRegex, ""));
                        else el.className = el.getAttribute("class").replace(classNameRegex, "");
                    },
                    addClass: function addClass(el, className) {
                        if (el.classList && el.classList.add) {
                            el.classList.add(className);
                            return;
                        }
                        if (el instanceof SVGElement) el.setAttribute("class", el.getAttribute("class") + " " + className);
                        else el.className = el.getAttribute("class") + " " + className;
                    },
                    hasClass: function hasClass(el, className) {
                        if (el.classList && el.classList.contains) return el.classList.contains(className);
                        var classNameRegex = RegExp('\\b' + className + '\\b', "g");
                        if (el instanceof SVGElement) return classNameRegex.test(el.getAttribute("class"));
                        else return classNameRegex.test(el.className);
                    },
                    toggleClass: function toggleClass(el, className) {
                        if (el.classList && el.classList.toggle) {
                            el.classList.toggle(className);
                            return;
                        }
                        if (this.hasClass(el, className)) this.removeClass(el, className);
                        else this.addClass(el, className);
                    },
                    unique: function unique(ary) {
                        var unique = [];
                        ary.forEach(function(el) {
                            if (unique.indexOf(el) < 0) unique.push(el);
                        });
                        return unique;
                    }
                };
            //# sourceMappingURL=utils.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {}
        ],
        15: [
            function(require1, module1, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var cache = {};
                function initialBitstringFor(size, y, x, value) {
                    cache[size] = cache[size] || {};
                    cache[size][y] = cache[size][y] || {};
                    cache[size][y][x] = cache[size][y][x] || {};
                    if (cache[size][y][x][value]) return cache[size][y][x][value];
                    // The number of legal 19x19 go moves is on the order of 10^170 ≈ 2^565, so
                    // a hash output on the order of 2^31 is woefully insufficient for arbitrary
                    // positions, but it should be good enough for human play, since we're not
                    // searching the entire space. This should be good enough for ~300-move games.
                    var randomValue = Math.floor(Math.random() * (Math.pow(2, 31) - 1));
                    cache[size][y][x][value] = randomValue;
                    return randomValue;
                }
                exports.default = {
                    hash: function hash(boardSize, intersections) {
                        var h = 0;
                        intersections.forEach(function(i) {
                            if (!i.isEmpty()) {
                                var initial = initialBitstringFor(boardSize, i.y, i.x, i.value);
                                h = h ^ initial;
                            }
                        });
                        return h;
                    }
                };
            //# sourceMappingURL=zobrist.js.map
            //# sourceMappingURL=data:application/json;charset=utf-8;base64,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
            },
            {}
        ]
    }, {}, [
        1
    ])(1);
});


const $8087cb83ba2ea5ef$export$83d89fbfd8236492 = "15.0.4";


var $8f6857d83370bfe9$exports = {};



(function(global, factory) {
    factory($8f6857d83370bfe9$exports, (parcelRequire("02Ztr")), (parcelRequire("fu0YK")), (parcelRequire("lR7jo")));
})($8f6857d83370bfe9$exports, function(exports1, _slicedToArray, _classCallCheck, _createClass) {
    'use strict';
    var createExtendedExponentialRampToValueAutomationEvent = function createExtendedExponentialRampToValueAutomationEvent(value, endTime, insertTime) {
        return {
            endTime: endTime,
            insertTime: insertTime,
            type: 'exponentialRampToValue',
            value: value
        };
    };
    var createExtendedLinearRampToValueAutomationEvent = function createExtendedLinearRampToValueAutomationEvent(value, endTime, insertTime) {
        return {
            endTime: endTime,
            insertTime: insertTime,
            type: 'linearRampToValue',
            value: value
        };
    };
    var createSetValueAutomationEvent = function createSetValueAutomationEvent(value, startTime) {
        return {
            startTime: startTime,
            type: 'setValue',
            value: value
        };
    };
    var createSetValueCurveAutomationEvent = function createSetValueCurveAutomationEvent(values, startTime, duration) {
        return {
            duration: duration,
            startTime: startTime,
            type: 'setValueCurve',
            values: values
        };
    };
    var getTargetValueAtTime = function getTargetValueAtTime(time, valueAtStartTime, _ref) {
        var startTime = _ref.startTime, target = _ref.target, timeConstant = _ref.timeConstant;
        return target + (valueAtStartTime - target) * Math.exp((startTime - time) / timeConstant);
    };
    var isExponentialRampToValueAutomationEvent = function isExponentialRampToValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'exponentialRampToValue';
    };
    var isLinearRampToValueAutomationEvent = function isLinearRampToValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'linearRampToValue';
    };
    var isAnyRampToValueAutomationEvent = function isAnyRampToValueAutomationEvent(automationEvent) {
        return isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent);
    };
    var isSetValueAutomationEvent = function isSetValueAutomationEvent(automationEvent) {
        return automationEvent.type === 'setValue';
    };
    var isSetValueCurveAutomationEvent = function isSetValueCurveAutomationEvent(automationEvent) {
        return automationEvent.type === 'setValueCurve';
    };
    var _getValueOfAutomationEventAtIndexAtTime = function getValueOfAutomationEventAtIndexAtTime(automationEvents, index, time, defaultValue) {
        var automationEvent = automationEvents[index];
        return automationEvent === undefined ? defaultValue : isAnyRampToValueAutomationEvent(automationEvent) || isSetValueAutomationEvent(automationEvent) ? automationEvent.value : isSetValueCurveAutomationEvent(automationEvent) ? automationEvent.values[automationEvent.values.length - 1] : getTargetValueAtTime(time, _getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, automationEvent.startTime, defaultValue), automationEvent);
    };
    var getEndTimeAndValueOfPreviousAutomationEvent = function getEndTimeAndValueOfPreviousAutomationEvent(automationEvents, index, currentAutomationEvent, nextAutomationEvent, defaultValue) {
        return currentAutomationEvent === undefined ? [
            nextAutomationEvent.insertTime,
            defaultValue
        ] : isAnyRampToValueAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.endTime,
            currentAutomationEvent.value
        ] : isSetValueAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.startTime,
            currentAutomationEvent.value
        ] : isSetValueCurveAutomationEvent(currentAutomationEvent) ? [
            currentAutomationEvent.startTime + currentAutomationEvent.duration,
            currentAutomationEvent.values[currentAutomationEvent.values.length - 1]
        ] : [
            currentAutomationEvent.startTime,
            _getValueOfAutomationEventAtIndexAtTime(automationEvents, index - 1, currentAutomationEvent.startTime, defaultValue)
        ];
    };
    var isCancelAndHoldAutomationEvent = function isCancelAndHoldAutomationEvent(automationEvent) {
        return automationEvent.type === 'cancelAndHold';
    };
    var isCancelScheduledValuesAutomationEvent = function isCancelScheduledValuesAutomationEvent(automationEvent) {
        return automationEvent.type === 'cancelScheduledValues';
    };
    var getEventTime = function getEventTime(automationEvent) {
        if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) return automationEvent.cancelTime;
        if (isExponentialRampToValueAutomationEvent(automationEvent) || isLinearRampToValueAutomationEvent(automationEvent)) return automationEvent.endTime;
        return automationEvent.startTime;
    };
    var getExponentialRampValueAtTime = function getExponentialRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
        var endTime = _ref.endTime, value = _ref.value;
        if (valueAtStartTime === value) return value;
        if (0 < valueAtStartTime && 0 < value || valueAtStartTime < 0 && value < 0) return valueAtStartTime * Math.pow(value / valueAtStartTime, (time - startTime) / (endTime - startTime));
        return 0;
    };
    var getLinearRampValueAtTime = function getLinearRampValueAtTime(time, startTime, valueAtStartTime, _ref) {
        var endTime = _ref.endTime, value = _ref.value;
        return valueAtStartTime + (time - startTime) / (endTime - startTime) * (value - valueAtStartTime);
    };
    var interpolateValue = function interpolateValue(values, theoreticIndex) {
        var lowerIndex = Math.floor(theoreticIndex);
        var upperIndex = Math.ceil(theoreticIndex);
        if (lowerIndex === upperIndex) return values[lowerIndex];
        return (1 - (theoreticIndex - lowerIndex)) * values[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * values[upperIndex];
    };
    var getValueCurveValueAtTime = function getValueCurveValueAtTime(time, _ref) {
        var duration = _ref.duration, startTime = _ref.startTime, values = _ref.values;
        var theoreticIndex = (time - startTime) / duration * (values.length - 1);
        return interpolateValue(values, theoreticIndex);
    };
    var isSetTargetAutomationEvent = function isSetTargetAutomationEvent(automationEvent) {
        return automationEvent.type === 'setTarget';
    };
    var AutomationEventList = /*#__PURE__*/ function() {
        function AutomationEventList(defaultValue) {
            _classCallCheck(this, AutomationEventList);
            this._automationEvents = [];
            this._currenTime = 0;
            this._defaultValue = defaultValue;
        }
        return _createClass(AutomationEventList, [
            {
                key: Symbol.iterator,
                value: function value() {
                    return this._automationEvents[Symbol.iterator]();
                }
            },
            {
                key: "add",
                value: function add(automationEvent) {
                    var eventTime = getEventTime(automationEvent);
                    if (isCancelAndHoldAutomationEvent(automationEvent) || isCancelScheduledValuesAutomationEvent(automationEvent)) {
                        var index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                            if (isCancelScheduledValuesAutomationEvent(automationEvent) && isSetValueCurveAutomationEvent(currentAutomationEvent)) return currentAutomationEvent.startTime + currentAutomationEvent.duration >= eventTime;
                            return getEventTime(currentAutomationEvent) >= eventTime;
                        });
                        var removedAutomationEvent = this._automationEvents[index];
                        if (index !== -1) this._automationEvents = this._automationEvents.slice(0, index);
                        if (isCancelAndHoldAutomationEvent(automationEvent)) {
                            var lastAutomationEvent = this._automationEvents[this._automationEvents.length - 1];
                            if (removedAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(removedAutomationEvent)) {
                                if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) throw new Error('The internal list is malformed.');
                                var startTime = lastAutomationEvent === undefined ? removedAutomationEvent.insertTime : isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.startTime + lastAutomationEvent.duration : getEventTime(lastAutomationEvent);
                                var startValue = lastAutomationEvent === undefined ? this._defaultValue : isSetValueCurveAutomationEvent(lastAutomationEvent) ? lastAutomationEvent.values[lastAutomationEvent.values.length - 1] : lastAutomationEvent.value;
                                var value = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? getExponentialRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent) : getLinearRampValueAtTime(eventTime, startTime, startValue, removedAutomationEvent);
                                var truncatedAutomationEvent = isExponentialRampToValueAutomationEvent(removedAutomationEvent) ? createExtendedExponentialRampToValueAutomationEvent(value, eventTime, this._currenTime) : createExtendedLinearRampToValueAutomationEvent(value, eventTime, this._currenTime);
                                this._automationEvents.push(truncatedAutomationEvent);
                            }
                            if (lastAutomationEvent !== undefined && isSetTargetAutomationEvent(lastAutomationEvent)) this._automationEvents.push(createSetValueAutomationEvent(this.getValue(eventTime), eventTime));
                            if (lastAutomationEvent !== undefined && isSetValueCurveAutomationEvent(lastAutomationEvent) && lastAutomationEvent.startTime + lastAutomationEvent.duration > eventTime) {
                                var duration = eventTime - lastAutomationEvent.startTime;
                                var ratio = (lastAutomationEvent.values.length - 1) / lastAutomationEvent.duration;
                                var length = Math.max(2, 1 + Math.ceil(duration * ratio));
                                var fraction = duration / (length - 1) * ratio;
                                var values = lastAutomationEvent.values.slice(0, length);
                                if (fraction < 1) for(var i = 1; i < length; i += 1){
                                    var factor = fraction * i % 1;
                                    values[i] = lastAutomationEvent.values[i - 1] * (1 - factor) + lastAutomationEvent.values[i] * factor;
                                }
                                this._automationEvents[this._automationEvents.length - 1] = createSetValueCurveAutomationEvent(values, lastAutomationEvent.startTime, duration);
                            }
                        }
                    } else {
                        var _index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                            return getEventTime(currentAutomationEvent) > eventTime;
                        });
                        var previousAutomationEvent = _index === -1 ? this._automationEvents[this._automationEvents.length - 1] : this._automationEvents[_index - 1];
                        if (previousAutomationEvent !== undefined && isSetValueCurveAutomationEvent(previousAutomationEvent) && getEventTime(previousAutomationEvent) + previousAutomationEvent.duration > eventTime) return false;
                        var persistentAutomationEvent = isExponentialRampToValueAutomationEvent(automationEvent) ? createExtendedExponentialRampToValueAutomationEvent(automationEvent.value, automationEvent.endTime, this._currenTime) : isLinearRampToValueAutomationEvent(automationEvent) ? createExtendedLinearRampToValueAutomationEvent(automationEvent.value, eventTime, this._currenTime) : automationEvent;
                        if (_index === -1) this._automationEvents.push(persistentAutomationEvent);
                        else {
                            if (isSetValueCurveAutomationEvent(automationEvent) && eventTime + automationEvent.duration > getEventTime(this._automationEvents[_index])) return false;
                            this._automationEvents.splice(_index, 0, persistentAutomationEvent);
                        }
                    }
                    return true;
                }
            },
            {
                key: "flush",
                value: function flush(time) {
                    var index = this._automationEvents.findIndex(function(currentAutomationEvent) {
                        return getEventTime(currentAutomationEvent) > time;
                    });
                    if (index > 1) {
                        var remainingAutomationEvents = this._automationEvents.slice(index - 1);
                        var firstRemainingAutomationEvent = remainingAutomationEvents[0];
                        if (isSetTargetAutomationEvent(firstRemainingAutomationEvent)) remainingAutomationEvents.unshift(createSetValueAutomationEvent(_getValueOfAutomationEventAtIndexAtTime(this._automationEvents, index - 2, firstRemainingAutomationEvent.startTime, this._defaultValue), firstRemainingAutomationEvent.startTime));
                        this._automationEvents = remainingAutomationEvents;
                    }
                }
            },
            {
                key: "getValue",
                value: function getValue(time) {
                    if (this._automationEvents.length === 0) return this._defaultValue;
                    var indexOfNextEvent = this._automationEvents.findIndex(function(automationEvent) {
                        return getEventTime(automationEvent) > time;
                    });
                    var nextAutomationEvent = this._automationEvents[indexOfNextEvent];
                    var indexOfCurrentEvent = (indexOfNextEvent === -1 ? this._automationEvents.length : indexOfNextEvent) - 1;
                    var currentAutomationEvent = this._automationEvents[indexOfCurrentEvent];
                    if (currentAutomationEvent !== undefined && isSetTargetAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || nextAutomationEvent.insertTime > time)) return getTargetValueAtTime(time, _getValueOfAutomationEventAtIndexAtTime(this._automationEvents, indexOfCurrentEvent - 1, currentAutomationEvent.startTime, this._defaultValue), currentAutomationEvent);
                    if (currentAutomationEvent !== undefined && isSetValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) return currentAutomationEvent.value;
                    if (currentAutomationEvent !== undefined && isSetValueCurveAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent) || currentAutomationEvent.startTime + currentAutomationEvent.duration > time)) {
                        if (time < currentAutomationEvent.startTime + currentAutomationEvent.duration) return getValueCurveValueAtTime(time, currentAutomationEvent);
                        return currentAutomationEvent.values[currentAutomationEvent.values.length - 1];
                    }
                    if (currentAutomationEvent !== undefined && isAnyRampToValueAutomationEvent(currentAutomationEvent) && (nextAutomationEvent === undefined || !isAnyRampToValueAutomationEvent(nextAutomationEvent))) return currentAutomationEvent.value;
                    if (nextAutomationEvent !== undefined && isExponentialRampToValueAutomationEvent(nextAutomationEvent)) {
                        var _getEndTimeAndValueOf = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue), _getEndTimeAndValueOf2 = _slicedToArray(_getEndTimeAndValueOf, 2), startTime = _getEndTimeAndValueOf2[0], value = _getEndTimeAndValueOf2[1];
                        return getExponentialRampValueAtTime(time, startTime, value, nextAutomationEvent);
                    }
                    if (nextAutomationEvent !== undefined && isLinearRampToValueAutomationEvent(nextAutomationEvent)) {
                        var _getEndTimeAndValueOf3 = getEndTimeAndValueOfPreviousAutomationEvent(this._automationEvents, indexOfCurrentEvent, currentAutomationEvent, nextAutomationEvent, this._defaultValue), _getEndTimeAndValueOf4 = _slicedToArray(_getEndTimeAndValueOf3, 2), _startTime = _getEndTimeAndValueOf4[0], _value = _getEndTimeAndValueOf4[1];
                        return getLinearRampValueAtTime(time, _startTime, _value, nextAutomationEvent);
                    }
                    return this._defaultValue;
                }
            }
        ]);
    }();
    var createCancelAndHoldAutomationEvent = function createCancelAndHoldAutomationEvent(cancelTime) {
        return {
            cancelTime: cancelTime,
            type: 'cancelAndHold'
        };
    };
    var createCancelScheduledValuesAutomationEvent = function createCancelScheduledValuesAutomationEvent(cancelTime) {
        return {
            cancelTime: cancelTime,
            type: 'cancelScheduledValues'
        };
    };
    var createExponentialRampToValueAutomationEvent = function createExponentialRampToValueAutomationEvent(value, endTime) {
        return {
            endTime: endTime,
            type: 'exponentialRampToValue',
            value: value
        };
    };
    var createLinearRampToValueAutomationEvent = function createLinearRampToValueAutomationEvent(value, endTime) {
        return {
            endTime: endTime,
            type: 'linearRampToValue',
            value: value
        };
    };
    var createSetTargetAutomationEvent = function createSetTargetAutomationEvent(target, startTime, timeConstant) {
        return {
            startTime: startTime,
            target: target,
            timeConstant: timeConstant,
            type: 'setTarget'
        };
    };
    exports1.AutomationEventList = AutomationEventList;
    exports1.createCancelAndHoldAutomationEvent = createCancelAndHoldAutomationEvent;
    exports1.createCancelScheduledValuesAutomationEvent = createCancelScheduledValuesAutomationEvent;
    exports1.createExponentialRampToValueAutomationEvent = createExponentialRampToValueAutomationEvent;
    exports1.createLinearRampToValueAutomationEvent = createLinearRampToValueAutomationEvent;
    exports1.createSetTargetAutomationEvent = createSetTargetAutomationEvent;
    exports1.createSetValueAutomationEvent = createSetValueAutomationEvent;
    exports1.createSetValueCurveAutomationEvent = createSetValueCurveAutomationEvent;
});


const $a18cf10db56d480b$export$aff31bd5258e9fd4 = ()=>new DOMException('', 'AbortError');


const $7f23be3a1785a3a3$export$43d20cccdc976834 = (insertElementInSet)=>{
    return (activeInputs, source, [output, input, eventListener], ignoreDuplicates)=>{
        insertElementInSet(activeInputs[input], [
            source,
            output,
            eventListener
        ], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
    };
};


const $38a67e4228ec27a5$export$7ff07578cebde522 = (audioNodeConnectionsStore)=>{
    return (audioNode, audioNodeRenderer, nativeAudioNode)=>{
        const activeInputs = [];
        for(let i = 0; i < nativeAudioNode.numberOfInputs; i += 1)activeInputs.push(new Set());
        audioNodeConnectionsStore.set(audioNode, {
            activeInputs: activeInputs,
            outputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioNodeRenderer
        });
    };
};


const $75c70a9d5b9cda8b$export$25226f7a087f88c3 = (audioParamConnectionsStore)=>{
    return (audioParam, audioParamRenderer)=>{
        audioParamConnectionsStore.set(audioParam, {
            activeInputs: new Set(),
            passiveInputs: new WeakMap(),
            renderer: audioParamRenderer
        });
    };
};


const $7718e734b2fef711$export$2b500979aea0913f = new WeakSet();
const $7718e734b2fef711$export$61ca80a8c8c6d728 = new WeakMap();
const $7718e734b2fef711$export$864a3cfb55580d0c = new WeakMap();
const $7718e734b2fef711$export$c5d3ff1f46a0185a = new WeakMap();
const $7718e734b2fef711$export$55484e3055c7a9e2 = new WeakMap();
const $7718e734b2fef711$export$7d17302229276f06 = new WeakMap();
const $7718e734b2fef711$export$c998cfefa4fd5136 = new WeakMap();
const $7718e734b2fef711$export$cf686a6a3e402092 = new WeakMap();
const $7718e734b2fef711$export$b9bea39f06f96914 = new WeakMap();
const $7718e734b2fef711$export$16d7878f7e059d67 = new WeakMap();


const $8b99c46ccea74444$var$handler = {
    construct () {
        return $8b99c46ccea74444$var$handler;
    }
};
const $8b99c46ccea74444$export$df064419399503e9 = (constructible)=>{
    try {
        const proxy = new Proxy(constructible, $8b99c46ccea74444$var$handler);
        new proxy(); // tslint:disable-line:no-unused-expression
    } catch  {
        return false;
    }
    return true;
};


/*
 * This massive regex tries to cover all the following cases.
 *
 * import './path';
 * import defaultImport from './path';
 * import { namedImport } from './path';
 * import { namedImport as renamendImport } from './path';
 * import * as namespaceImport from './path';
 * import defaultImport, { namedImport } from './path';
 * import defaultImport, { namedImport as renamendImport } from './path';
 * import defaultImport, * as namespaceImport from './path';
 */ const $666948ccc53d62d5$var$IMPORT_STATEMENT_REGEX = /^import(?:(?:[\s]+[\w]+|(?:[\s]+[\w]+[\s]*,)?[\s]*\{[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?(?:[\s]*,[\s]*[\w]+(?:[\s]+as[\s]+[\w]+)?)*[\s]*}|(?:[\s]+[\w]+[\s]*,)?[\s]*\*[\s]+as[\s]+[\w]+)[\s]+from)?(?:[\s]*)("([^"\\]|\\.)+"|'([^'\\]|\\.)+')(?:[\s]*);?/; // tslint:disable-line:max-line-length
const $666948ccc53d62d5$export$949058cf055dbb57 = (source, url)=>{
    const importStatements = [];
    let sourceWithoutImportStatements = source.replace(/^[\s]+/, '');
    let result = sourceWithoutImportStatements.match($666948ccc53d62d5$var$IMPORT_STATEMENT_REGEX);
    while(result !== null){
        const unresolvedUrl = result[1].slice(1, -1);
        const importStatementWithResolvedUrl = result[0].replace(/([\s]+)?;?$/, '').replace(unresolvedUrl, new URL(unresolvedUrl, url).toString());
        importStatements.push(importStatementWithResolvedUrl);
        sourceWithoutImportStatements = sourceWithoutImportStatements.slice(result[0].length).replace(/^[\s]+/, '');
        result = sourceWithoutImportStatements.match($666948ccc53d62d5$var$IMPORT_STATEMENT_REGEX);
    }
    return [
        importStatements.join(';'),
        sourceWithoutImportStatements
    ];
};


const $a5628482838dda15$var$verifyParameterDescriptors = (parameterDescriptors)=>{
    if (parameterDescriptors !== undefined && !Array.isArray(parameterDescriptors)) throw new TypeError('The parameterDescriptors property of given value for processorCtor is not an array.');
};
const $a5628482838dda15$var$verifyProcessorCtor = (processorCtor)=>{
    if (!(0, $8b99c46ccea74444$export$df064419399503e9)(processorCtor)) throw new TypeError('The given value for processorCtor should be a constructor.');
    if (processorCtor.prototype === null || typeof processorCtor.prototype !== 'object') throw new TypeError('The given value for processorCtor should have a prototype.');
};
const $a5628482838dda15$export$16c6049a33c70efa = (cacheTestResult, createNotSupportedError, evaluateSource, exposeCurrentFrameAndCurrentTime, fetchSource, getNativeContext, getOrCreateBackupOfflineAudioContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, ongoingRequests, resolvedRequests, testAudioWorkletProcessorPostMessageSupport, window)=>{
    let index = 0;
    return (context, moduleURL, options = {
        credentials: 'omit'
    })=>{
        const resolvedRequestsOfContext = resolvedRequests.get(context);
        if (resolvedRequestsOfContext !== undefined && resolvedRequestsOfContext.has(moduleURL)) return Promise.resolve();
        const ongoingRequestsOfContext = ongoingRequests.get(context);
        if (ongoingRequestsOfContext !== undefined) {
            const promiseOfOngoingRequest = ongoingRequestsOfContext.get(moduleURL);
            if (promiseOfOngoingRequest !== undefined) return promiseOfOngoingRequest;
        }
        const nativeContext = getNativeContext(context);
        // Bug #59: Safari does not implement the audioWorklet property.
        const promise = nativeContext.audioWorklet === undefined ? fetchSource(moduleURL).then(([source, absoluteUrl])=>{
            const [importStatements, sourceWithoutImportStatements] = (0, $666948ccc53d62d5$export$949058cf055dbb57)(source, absoluteUrl);
            /*
                 * This is the unminified version of the code used below:
                 *
                 * ```js
                 * ${ importStatements };
                 * ((a, b) => {
                 *     (a[b] = a[b] || [ ]).push(
                 *         (AudioWorkletProcessor, global, registerProcessor, sampleRate, self, window) => {
                 *             ${ sourceWithoutImportStatements }
                 *         }
                 *     );
                 * })(window, '_AWGS');
                 * ```
                 */ // tslint:disable-next-line:max-line-length
            const wrappedSource = `${importStatements};((a,b)=>{(a[b]=a[b]||[]).push((AudioWorkletProcessor,global,registerProcessor,sampleRate,self,window)=>{${sourceWithoutImportStatements}
})})(window,'_AWGS')`;
            // @todo Evaluating the given source code is a possible security problem.
            return evaluateSource(wrappedSource);
        }).then(()=>{
            const evaluateAudioWorkletGlobalScope = window._AWGS.pop();
            if (evaluateAudioWorkletGlobalScope === undefined) // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
            throw new SyntaxError();
            exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, ()=>evaluateAudioWorkletGlobalScope(class AudioWorkletProcessor {
                }, undefined, (name, processorCtor)=>{
                    if (name.trim() === '') throw createNotSupportedError();
                    const nodeNameToProcessorConstructorMap = (0, $7718e734b2fef711$export$b9bea39f06f96914).get(nativeContext);
                    if (nodeNameToProcessorConstructorMap !== undefined) {
                        if (nodeNameToProcessorConstructorMap.has(name)) throw createNotSupportedError();
                        $a5628482838dda15$var$verifyProcessorCtor(processorCtor);
                        $a5628482838dda15$var$verifyParameterDescriptors(processorCtor.parameterDescriptors);
                        nodeNameToProcessorConstructorMap.set(name, processorCtor);
                    } else {
                        $a5628482838dda15$var$verifyProcessorCtor(processorCtor);
                        $a5628482838dda15$var$verifyParameterDescriptors(processorCtor.parameterDescriptors);
                        (0, $7718e734b2fef711$export$b9bea39f06f96914).set(nativeContext, new Map([
                            [
                                name,
                                processorCtor
                            ]
                        ]));
                    }
                }, nativeContext.sampleRate, undefined, undefined));
        }) : Promise.all([
            fetchSource(moduleURL),
            Promise.resolve(cacheTestResult(testAudioWorkletProcessorPostMessageSupport, testAudioWorkletProcessorPostMessageSupport))
        ]).then(([[source, absoluteUrl], isSupportingPostMessage])=>{
            const currentIndex = index + 1;
            index = currentIndex;
            const [importStatements, sourceWithoutImportStatements] = (0, $666948ccc53d62d5$export$949058cf055dbb57)(source, absoluteUrl);
            /*
                 * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
                 *
                 * This is the unminified version of the code used below.
                 *
                 * ```js
                 * class extends AudioWorkletProcessor {
                 *
                 *     __buffers = new WeakSet();
                 *
                 *     constructor () {
                 *         super();
                 *
                 *         this.port.postMessage = ((postMessage) => {
                 *             return (message, transferables) => {
                 *                 const filteredTransferables = (transferables)
                 *                     ? transferables.filter((transferable) => !this.__buffers.has(transferable))
                 *                     : transferables;
                 *
                 *                 return postMessage.call(this.port, message, filteredTransferables);
                 *              };
                 *         })(this.port.postMessage);
                 *     }
                 * }
                 * ```
                 */ const patchedAudioWorkletProcessor = isSupportingPostMessage ? 'AudioWorkletProcessor' : 'class extends AudioWorkletProcessor {__b=new WeakSet();constructor(){super();(p=>p.postMessage=(q=>(m,t)=>q.call(p,m,t?t.filter(u=>!this.__b.has(u)):t))(p.postMessage))(this.port)}}';
            /*
                 * Bug #170: Chrome and Edge do call process() with an array with empty channelData for each input if no input is connected.
                 *
                 * Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
                 *
                 * Bug #190: Safari doesn't throw an error when loading an unparsable module.
                 *
                 * This is the unminified version of the code used below:
                 *
                 * ```js
                 * `${ importStatements };
                 * ((AudioWorkletProcessor, registerProcessor) => {${ sourceWithoutImportStatements }
                 * })(
                 *     ${ patchedAudioWorkletProcessor },
                 *     (name, processorCtor) => registerProcessor(name, class extends processorCtor {
                 *
                 *         __collectBuffers = (array) => {
                 *             array.forEach((element) => this.__buffers.add(element.buffer));
                 *         };
                 *
                 *         process (inputs, outputs, parameters) {
                 *             inputs.forEach(this.__collectBuffers);
                 *             outputs.forEach(this.__collectBuffers);
                 *             this.__collectBuffers(Object.values(parameters));
                 *
                 *             return super.process(
                 *                 (inputs.map((input) => input.some((channelData) => channelData.length === 0)) ? [ ] : input),
                 *                 outputs,
                 *                 parameters
                 *             );
                 *         }
                 *
                 *     })
                 * );
                 *
                 * registerProcessor(`__sac${currentIndex}`, class extends AudioWorkletProcessor{
                 *
                 *     process () {
                 *         return false;
                 *     }
                 *
                 * })`
                 * ```
                 */ const memberDefinition = isSupportingPostMessage ? '' : '__c = (a) => a.forEach(e=>this.__b.add(e.buffer));';
            const bufferRegistration = isSupportingPostMessage ? '' : 'i.forEach(this.__c);o.forEach(this.__c);this.__c(Object.values(p));';
            const wrappedSource = `${importStatements};((AudioWorkletProcessor,registerProcessor)=>{${sourceWithoutImportStatements}
})(${patchedAudioWorkletProcessor},(n,p)=>registerProcessor(n,class extends p{${memberDefinition}process(i,o,p){${bufferRegistration}return super.process(i.map(j=>j.some(k=>k.length===0)?[]:j),o,p)}}));registerProcessor('__sac${currentIndex}',class extends AudioWorkletProcessor{process(){return !1}})`;
            const blob = new Blob([
                wrappedSource
            ], {
                type: 'application/javascript; charset=utf-8'
            });
            const url = URL.createObjectURL(blob);
            return nativeContext.audioWorklet.addModule(url, options).then(()=>{
                if (isNativeOfflineAudioContext(nativeContext)) return nativeContext;
                // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.
                const backupOfflineAudioContext = getOrCreateBackupOfflineAudioContext(nativeContext);
                return backupOfflineAudioContext.audioWorklet.addModule(url, options).then(()=>backupOfflineAudioContext);
            }).then((nativeContextOrBackupOfflineAudioContext)=>{
                if (nativeAudioWorkletNodeConstructor === null) throw new SyntaxError();
                try {
                    // Bug #190: Safari doesn't throw an error when loading an unparsable module.
                    new nativeAudioWorkletNodeConstructor(nativeContextOrBackupOfflineAudioContext, `__sac${currentIndex}`); // tslint:disable-line:no-unused-expression
                } catch  {
                    throw new SyntaxError();
                }
            }).finally(()=>URL.revokeObjectURL(url));
        });
        if (ongoingRequestsOfContext === undefined) ongoingRequests.set(context, new Map([
            [
                moduleURL,
                promise
            ]
        ]));
        else ongoingRequestsOfContext.set(moduleURL, promise);
        promise.then(()=>{
            const updatedResolvedRequestsOfContext = resolvedRequests.get(context);
            if (updatedResolvedRequestsOfContext === undefined) resolvedRequests.set(context, new Set([
                moduleURL
            ]));
            else updatedResolvedRequestsOfContext.add(moduleURL);
        }).finally(()=>{
            const updatedOngoingRequestsOfContext = ongoingRequests.get(context);
            if (updatedOngoingRequestsOfContext !== undefined) updatedOngoingRequestsOfContext.delete(moduleURL);
        });
        return promise;
    };
};


const $88ab0c374f97b769$export$520987e3ff3ffad3 = (map, key)=>{
    const value = map.get(key);
    if (value === undefined) throw new Error('A value with the given key could not be found.');
    return value;
};


const $b4907d346209c4aa$export$3f1b331b43a0e659 = (set, predicate)=>{
    const matchingElements = Array.from(set).filter(predicate);
    if (matchingElements.length > 1) throw Error('More than one element was found.');
    if (matchingElements.length === 0) throw Error('No element was found.');
    const [matchingElement] = matchingElements;
    set.delete(matchingElement);
    return matchingElement;
};


const $1347121a05cab167$export$26ec3ebc965d6cfd = (passiveInputs, source, output, input)=>{
    const passiveInputConnections = (0, $88ab0c374f97b769$export$520987e3ff3ffad3)(passiveInputs, source);
    const matchingConnection = (0, $b4907d346209c4aa$export$3f1b331b43a0e659)(passiveInputConnections, (passiveInputConnection)=>passiveInputConnection[0] === output && passiveInputConnection[1] === input);
    if (passiveInputConnections.size === 0) passiveInputs.delete(source);
    return matchingConnection;
};





const $4c5028d8fa80b78b$export$caac7ea54cb93b25 = (audioNode)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$c998cfefa4fd5136), audioNode);
};


const $6f1d61f1020f6c58$export$88a47afdc0e8539c = (audioNode)=>{
    if ((0, $7718e734b2fef711$export$2b500979aea0913f).has(audioNode)) throw new Error('The AudioNode is already stored.');
    (0, $7718e734b2fef711$export$2b500979aea0913f).add(audioNode);
    (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25)(audioNode).forEach((eventListener)=>eventListener(true));
};


const $c6114027b7817185$export$1293b9fc79a24682 = (audioNode)=>{
    return 'port' in audioNode;
};




const $b44e7990017a0eb4$export$7c0830f3a5100dec = (audioNode)=>{
    if (!(0, $7718e734b2fef711$export$2b500979aea0913f).has(audioNode)) throw new Error('The AudioNode is not stored.');
    (0, $7718e734b2fef711$export$2b500979aea0913f).delete(audioNode);
    (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25)(audioNode).forEach((eventListener)=>eventListener(false));
};


const $d86f58cf827039bb$export$c74023ca160dc207 = (audioNode, activeInputs)=>{
    if (!(0, $c6114027b7817185$export$1293b9fc79a24682)(audioNode) && activeInputs.every((connections)=>connections.size === 0)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(audioNode);
};


const $dc45a634363b6091$export$1776cf0d295db1d7 = (addActiveInputConnectionToAudioNode, addPassiveInputConnectionToAudioNode, connectNativeAudioNodeToNativeAudioNode, deleteActiveInputConnectionToAudioNode, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getAudioNodeTailTime, getEventListenersOfAudioNode, getNativeAudioNode, insertElementInSet, isActiveAudioNode, isPartOfACycle, isPassiveAudioNode)=>{
    const tailTimeTimeoutIds = new WeakMap();
    return (source, destination, output, input, isOffline)=>{
        const { activeInputs: activeInputs, passiveInputs: passiveInputs } = getAudioNodeConnections(destination);
        const { outputs: outputs } = getAudioNodeConnections(source);
        const eventListeners = getEventListenersOfAudioNode(source);
        const eventListener = (isActive)=>{
            const nativeDestinationAudioNode = getNativeAudioNode(destination);
            const nativeSourceAudioNode = getNativeAudioNode(source);
            if (isActive) {
                const partialConnection = (0, $1347121a05cab167$export$26ec3ebc965d6cfd)(passiveInputs, source, output, input);
                addActiveInputConnectionToAudioNode(activeInputs, source, partialConnection, false);
                if (!isOffline && !isPartOfACycle(source)) connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
                if (isPassiveAudioNode(destination)) (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(destination);
            } else {
                const partialConnection = deleteActiveInputConnectionToAudioNode(activeInputs, source, output, input);
                addPassiveInputConnectionToAudioNode(passiveInputs, input, partialConnection, false);
                if (!isOffline && !isPartOfACycle(source)) disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output, input);
                const tailTime = getAudioNodeTailTime(destination);
                if (tailTime === 0) {
                    if (isActiveAudioNode(destination)) (0, $d86f58cf827039bb$export$c74023ca160dc207)(destination, activeInputs);
                } else {
                    const tailTimeTimeoutId = tailTimeTimeoutIds.get(destination);
                    if (tailTimeTimeoutId !== undefined) clearTimeout(tailTimeTimeoutId);
                    tailTimeTimeoutIds.set(destination, setTimeout(()=>{
                        if (isActiveAudioNode(destination)) (0, $d86f58cf827039bb$export$c74023ca160dc207)(destination, activeInputs);
                    }, tailTime * 1000));
                }
            }
        };
        if (insertElementInSet(outputs, [
            destination,
            output,
            input
        ], (outputConnection)=>outputConnection[0] === destination && outputConnection[1] === output && outputConnection[2] === input, true)) {
            eventListeners.add(eventListener);
            if (isActiveAudioNode(source)) addActiveInputConnectionToAudioNode(activeInputs, source, [
                output,
                input,
                eventListener
            ], true);
            else addPassiveInputConnectionToAudioNode(passiveInputs, input, [
                source,
                output,
                eventListener
            ], true);
            return true;
        }
        return false;
    };
};


const $3166079db94aa9a9$export$67aa4e90be3a506b = (insertElementInSet)=>{
    return (passiveInputs, input, [source, output, eventListener], ignoreDuplicates)=>{
        const passiveInputConnections = passiveInputs.get(source);
        if (passiveInputConnections === undefined) passiveInputs.set(source, new Set([
            [
                output,
                input,
                eventListener
            ]
        ]));
        else insertElementInSet(passiveInputConnections, [
            output,
            input,
            eventListener
        ], (passiveInputConnection)=>passiveInputConnection[0] === output && passiveInputConnection[1] === input, ignoreDuplicates);
    };
};


const $8d968cebac7e2205$export$c6991e18a29704b9 = (createNativeGainNode)=>{
    return (nativeContext, nativeAudioScheduledSourceNode)=>{
        const nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        nativeAudioScheduledSourceNode.connect(nativeGainNode).connect(nativeContext.destination);
        const disconnect = ()=>{
            nativeAudioScheduledSourceNode.removeEventListener('ended', disconnect);
            nativeAudioScheduledSourceNode.disconnect(nativeGainNode);
            nativeGainNode.disconnect();
        };
        nativeAudioScheduledSourceNode.addEventListener('ended', disconnect);
    };
};


const $c770a27b2f3749ca$export$fd0136b1517d036f = (getUnrenderedAudioWorkletNodes)=>{
    return (nativeContext, audioWorkletNode)=>{
        getUnrenderedAudioWorkletNodes(nativeContext).add(audioWorkletNode);
    };
};


const $108e1fe42ca28dbf$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    fftSize: 2048,
    maxDecibels: -30,
    minDecibels: -100,
    smoothingTimeConstant: 0.8
};
const $108e1fe42ca28dbf$export$569b2da15d7fe153 = (audionNodeConstructor, createAnalyserNodeRenderer, createIndexSizeError, createNativeAnalyserNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class AnalyserNode extends audionNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$108e1fe42ca28dbf$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeAnalyserNode = createNativeAnalyserNode(nativeContext, mergedOptions);
            const analyserNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createAnalyserNodeRenderer() : null;
            super(context, false, nativeAnalyserNode, analyserNodeRenderer);
            this._nativeAnalyserNode = nativeAnalyserNode;
        }
        get fftSize() {
            return this._nativeAnalyserNode.fftSize;
        }
        set fftSize(value) {
            this._nativeAnalyserNode.fftSize = value;
        }
        get frequencyBinCount() {
            return this._nativeAnalyserNode.frequencyBinCount;
        }
        get maxDecibels() {
            return this._nativeAnalyserNode.maxDecibels;
        }
        set maxDecibels(value) {
            // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
            const maxDecibels = this._nativeAnalyserNode.maxDecibels;
            this._nativeAnalyserNode.maxDecibels = value;
            if (!(value > this._nativeAnalyserNode.minDecibels)) {
                this._nativeAnalyserNode.maxDecibels = maxDecibels;
                throw createIndexSizeError();
            }
        }
        get minDecibels() {
            return this._nativeAnalyserNode.minDecibels;
        }
        set minDecibels(value) {
            // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
            const minDecibels = this._nativeAnalyserNode.minDecibels;
            this._nativeAnalyserNode.minDecibels = value;
            if (!(this._nativeAnalyserNode.maxDecibels > value)) {
                this._nativeAnalyserNode.minDecibels = minDecibels;
                throw createIndexSizeError();
            }
        }
        get smoothingTimeConstant() {
            return this._nativeAnalyserNode.smoothingTimeConstant;
        }
        set smoothingTimeConstant(value) {
            this._nativeAnalyserNode.smoothingTimeConstant = value;
        }
        getByteFrequencyData(array) {
            this._nativeAnalyserNode.getByteFrequencyData(array);
        }
        getByteTimeDomainData(array) {
            this._nativeAnalyserNode.getByteTimeDomainData(array);
        }
        getFloatFrequencyData(array) {
            this._nativeAnalyserNode.getFloatFrequencyData(array);
        }
        getFloatTimeDomainData(array) {
            this._nativeAnalyserNode.getFloatTimeDomainData(array);
        }
    };
};


const $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc = (nativeAudioNode, nativeContext)=>{
    return nativeAudioNode.context === nativeContext;
};


const $af022ab249d12b4e$export$5fe3f5c2d995fe20 = (createNativeAnalyserNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAnalyserNodes = new WeakMap();
        const createAnalyserNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAnalyserNode = getNativeAudioNode(proxy);
            // If the initially used nativeAnalyserNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAnalyserNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAnalyserNode, nativeOfflineAudioContext);
            if (!nativeAnalyserNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAnalyserNode.channelCount,
                    channelCountMode: nativeAnalyserNode.channelCountMode,
                    channelInterpretation: nativeAnalyserNode.channelInterpretation,
                    fftSize: nativeAnalyserNode.fftSize,
                    maxDecibels: nativeAnalyserNode.maxDecibels,
                    minDecibels: nativeAnalyserNode.minDecibels,
                    smoothingTimeConstant: nativeAnalyserNode.smoothingTimeConstant
                };
                nativeAnalyserNode = createNativeAnalyserNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAnalyserNodes.set(nativeOfflineAudioContext, nativeAnalyserNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAnalyserNode);
            return nativeAnalyserNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAnalyserNode = renderedNativeAnalyserNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAnalyserNode !== undefined) return Promise.resolve(renderedNativeAnalyserNode);
                return createAnalyserNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $00de7ef4427b01cb$export$54e424f510c54ced = (nativeAudioBuffer)=>{
    try {
        nativeAudioBuffer.copyToChannel(new Float32Array(1), 0, -1);
    } catch  {
        return false;
    }
    return true;
};


const $e1139ef113001733$export$926e4aa3eed6ec13 = ()=>new DOMException('', 'IndexSizeError');


const $e0def92b41d2ffa5$export$df65309cf6249598 = (audioBuffer)=>{
    audioBuffer.getChannelData = ((getChannelData)=>{
        return (channel)=>{
            try {
                return getChannelData.call(audioBuffer, channel);
            } catch (err) {
                if (err.code === 12) throw (0, $e1139ef113001733$export$926e4aa3eed6ec13)();
                throw err;
            }
        };
    })(audioBuffer.getChannelData);
};


const $05b6b25752b14d73$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $05b6b25752b14d73$export$c8b88126795b7df2 = (audioBufferStore, cacheTestResult, createNotSupportedError, nativeAudioBufferConstructor, nativeOfflineAudioContextConstructor, testNativeAudioBufferConstructorSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    let nativeOfflineAudioContext = null;
    return class AudioBuffer {
        constructor(options){
            if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$05b6b25752b14d73$var$DEFAULT_OPTIONS,
                ...options
            };
            if (nativeOfflineAudioContext === null) nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
            /*
             * Bug #99: Firefox does not throw a NotSupportedError when the numberOfChannels is zero. But it only does it when using the
             * factory function. But since Firefox also supports the constructor everything should be fine.
             */ const audioBuffer = nativeAudioBufferConstructor !== null && cacheTestResult(testNativeAudioBufferConstructorSupport, testNativeAudioBufferConstructorSupport) ? new nativeAudioBufferConstructor({
                length: length,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            }) : nativeOfflineAudioContext.createBuffer(numberOfChannels, length, sampleRate);
            // Bug #99: Safari does not throw an error when the numberOfChannels is zero.
            if (audioBuffer.numberOfChannels === 0) throw createNotSupportedError();
            // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
            // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
            if (typeof audioBuffer.copyFromChannel !== 'function') {
                wrapAudioBufferCopyChannelMethods(audioBuffer);
                (0, $e0def92b41d2ffa5$export$df65309cf6249598)(audioBuffer);
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            } else if (!cacheTestResult((0, $00de7ef4427b01cb$export$54e424f510c54ced), ()=>(0, $00de7ef4427b01cb$export$54e424f510c54ced)(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            /*
             * This does violate all good pratices but it is necessary to allow this AudioBuffer to be used with native
             * (Offline)AudioContexts.
             */ return audioBuffer;
        }
        static [Symbol.hasInstance](instance) {
            return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === AudioBuffer.prototype || audioBufferStore.has(instance);
        }
    };
};


const $c205d95559d496ba$export$ced6a5c63b103b52 = -340282346638528860000000000000000000000;
const $c205d95559d496ba$export$ab43bedd17d6a167 = -$c205d95559d496ba$export$ced6a5c63b103b52;



const $74af653805090ad8$export$e44f0fc8e83fb084 = (audioNode)=>(0, $7718e734b2fef711$export$2b500979aea0913f).has(audioNode);




const $55305446a68bbcd4$var$DEFAULT_OPTIONS = {
    buffer: null,
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    // Bug #149: Safari does not yet support the detune AudioParam.
    loop: false,
    loopEnd: 0,
    loopStart: 0,
    playbackRate: 1
};
const $55305446a68bbcd4$export$6857b764b4428518 = (audioNodeConstructor, createAudioBufferSourceNodeRenderer, createAudioParam, createInvalidStateError, createNativeAudioBufferSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class AudioBufferSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$55305446a68bbcd4$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const audioBufferSourceNodeRenderer = isOffline ? createAudioBufferSourceNodeRenderer() : null;
            super(context, false, nativeAudioBufferSourceNode, audioBufferSourceNodeRenderer);
            this._audioBufferSourceNodeRenderer = audioBufferSourceNodeRenderer;
            this._isBufferNullified = false;
            this._isBufferSet = mergedOptions.buffer !== null;
            this._nativeAudioBufferSourceNode = nativeAudioBufferSourceNode;
            this._onended = null;
            // Bug #73: Safari does not export the correct values for maxValue and minValue.
            this._playbackRate = createAudioParam(this, isOffline, nativeAudioBufferSourceNode.playbackRate, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
        }
        get buffer() {
            if (this._isBufferNullified) return null;
            return this._nativeAudioBufferSourceNode.buffer;
        }
        set buffer(value) {
            this._nativeAudioBufferSourceNode.buffer = value;
            // Bug #72: Only Chrome & Edge do not allow to reassign the buffer yet.
            if (value !== null) {
                if (this._isBufferSet) throw createInvalidStateError();
                this._isBufferSet = true;
            }
        }
        get loop() {
            return this._nativeAudioBufferSourceNode.loop;
        }
        set loop(value) {
            this._nativeAudioBufferSourceNode.loop = value;
        }
        get loopEnd() {
            return this._nativeAudioBufferSourceNode.loopEnd;
        }
        set loopEnd(value) {
            this._nativeAudioBufferSourceNode.loopEnd = value;
        }
        get loopStart() {
            return this._nativeAudioBufferSourceNode.loopStart;
        }
        set loopStart(value) {
            this._nativeAudioBufferSourceNode.loopStart = value;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeAudioBufferSourceNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeAudioBufferSourceNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        get playbackRate() {
            return this._playbackRate;
        }
        start(when = 0, offset = 0, duration) {
            this._nativeAudioBufferSourceNode.start(when, offset, duration);
            if (this._audioBufferSourceNodeRenderer !== null) this._audioBufferSourceNodeRenderer.start = duration === undefined ? [
                when,
                offset
            ] : [
                when,
                offset,
                duration
            ];
            if (this.context.state !== 'closed') {
                (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeAudioBufferSourceNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(this)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(this);
                };
                this._nativeAudioBufferSourceNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeAudioBufferSourceNode.stop(when);
            if (this._audioBufferSourceNodeRenderer !== null) this._audioBufferSourceNodeRenderer.stop = when;
        }
    };
};



const $a4008e06a1e577c4$export$82721be5d1bb22c5 = (connectAudioParam, createNativeAudioBufferSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioBufferSourceNodes = new WeakMap();
        let start = null;
        let stop = null;
        const createAudioBufferSourceNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioBufferSourceNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeAudioBufferSourceNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeAudioBufferSourceNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAudioBufferSourceNode, nativeOfflineAudioContext);
            if (!nativeAudioBufferSourceNodeIsOwnedByContext) {
                const options = {
                    buffer: nativeAudioBufferSourceNode.buffer,
                    channelCount: nativeAudioBufferSourceNode.channelCount,
                    channelCountMode: nativeAudioBufferSourceNode.channelCountMode,
                    channelInterpretation: nativeAudioBufferSourceNode.channelInterpretation,
                    // Bug #149: Safari does not yet support the detune AudioParam.
                    loop: nativeAudioBufferSourceNode.loop,
                    loopEnd: nativeAudioBufferSourceNode.loopEnd,
                    loopStart: nativeAudioBufferSourceNode.loopStart,
                    playbackRate: nativeAudioBufferSourceNode.playbackRate.value
                };
                nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeAudioBufferSourceNode.start(...start);
                if (stop !== null) nativeAudioBufferSourceNode.stop(stop);
            }
            renderedNativeAudioBufferSourceNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode);
            if (!nativeAudioBufferSourceNodeIsOwnedByContext) // Bug #149: Safari does not yet support the detune AudioParam.
            await renderAutomation(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
            else // Bug #149: Safari does not yet support the detune AudioParam.
            await connectAudioParam(nativeOfflineAudioContext, proxy.playbackRate, nativeAudioBufferSourceNode.playbackRate);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioBufferSourceNode);
            return nativeAudioBufferSourceNode;
        };
        return {
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioBufferSourceNode = renderedNativeAudioBufferSourceNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioBufferSourceNode !== undefined) return Promise.resolve(renderedNativeAudioBufferSourceNode);
                return createAudioBufferSourceNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $828ce8df8991a5da$export$b030d1cb39b66ce3 = (audioNode)=>{
    return 'playbackRate' in audioNode;
};



const $b1c01e8d3bb75909$export$8bbceb3e2d3b886a = (audioNode)=>{
    return 'frequency' in audioNode && 'gain' in audioNode;
};


const $a5e0cb451ced6be4$export$2b5f11f35c31b1bf = (audioNode)=>{
    return 'offset' in audioNode;
};


const $d21f4a1b4ecd24ee$export$c124c0514d4f41ab = (audioNode)=>{
    return !('frequency' in audioNode) && 'gain' in audioNode;
};


const $3f8d58a407d6c9bc$export$97bb3ed4238ea897 = (audioNode)=>{
    return 'detune' in audioNode && 'frequency' in audioNode && !('gain' in audioNode);
};


const $adf78758fe2f7169$export$79ba82be14a0b006 = (audioNode)=>{
    return 'pan' in audioNode;
};




const $b599ef0c4650ec6d$export$6b29eee2af836dfc = (audioNode)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$61ca80a8c8c6d728), audioNode);
};




const $ca92fb3bedacccdf$export$1b11f454bf19657 = (audioParam)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$c5d3ff1f46a0185a), audioParam);
};




const $91fa2a989bb9a820$export$e16f533d410eeca0 = (audioNode, trace)=>{
    const { activeInputs: activeInputs } = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(audioNode);
    activeInputs.forEach((connections)=>connections.forEach(([source])=>{
            if (!trace.includes(audioNode)) $91fa2a989bb9a820$export$e16f533d410eeca0(source, [
                ...trace,
                audioNode
            ]);
        }));
    const audioParams = (0, $828ce8df8991a5da$export$b030d1cb39b66ce3)(audioNode) ? [
        // Bug #149: Safari does not yet support the detune AudioParam.
        audioNode.playbackRate
    ] : (0, $c6114027b7817185$export$1293b9fc79a24682)(audioNode) ? Array.from(audioNode.parameters.values()) : (0, $b1c01e8d3bb75909$export$8bbceb3e2d3b886a)(audioNode) ? [
        audioNode.Q,
        audioNode.detune,
        audioNode.frequency,
        audioNode.gain
    ] : (0, $a5e0cb451ced6be4$export$2b5f11f35c31b1bf)(audioNode) ? [
        audioNode.offset
    ] : (0, $d21f4a1b4ecd24ee$export$c124c0514d4f41ab)(audioNode) ? [
        audioNode.gain
    ] : (0, $3f8d58a407d6c9bc$export$97bb3ed4238ea897)(audioNode) ? [
        audioNode.detune,
        audioNode.frequency
    ] : (0, $adf78758fe2f7169$export$79ba82be14a0b006)(audioNode) ? [
        audioNode.pan
    ] : [];
    for (const audioParam of audioParams){
        const audioParamConnections = (0, $ca92fb3bedacccdf$export$1b11f454bf19657)(audioParam);
        if (audioParamConnections !== undefined) audioParamConnections.activeInputs.forEach(([source])=>$91fa2a989bb9a820$export$e16f533d410eeca0(source, trace));
    }
    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(audioNode)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(audioNode);
};


const $6d385241f7fab45a$export$cbd606bc629ea938 = (context)=>{
    (0, $91fa2a989bb9a820$export$e16f533d410eeca0)(context.destination, []);
};


const $0cefff6266c0f0f4$export$82d5f0e102842fbe = (latencyHint)=>{
    return latencyHint === undefined || typeof latencyHint === 'number' || typeof latencyHint === 'string' && (latencyHint === 'balanced' || latencyHint === 'interactive' || latencyHint === 'playback');
};


const $57f46748bc9ae741$export$c6fe175def53ff71 = (baseAudioContextConstructor, createInvalidStateError, createNotSupportedError, createUnknownError, mediaElementAudioSourceNodeConstructor, mediaStreamAudioDestinationNodeConstructor, mediaStreamAudioSourceNodeConstructor, mediaStreamTrackAudioSourceNodeConstructor, nativeAudioContextConstructor)=>{
    return class AudioContext extends baseAudioContextConstructor {
        constructor(options = {}){
            if (nativeAudioContextConstructor === null) throw new Error('Missing the native AudioContext constructor.');
            let nativeAudioContext;
            try {
                nativeAudioContext = new nativeAudioContextConstructor(options);
            } catch (err) {
                // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
                if (err.code === 12 && err.message === 'sampleRate is not in range') throw createNotSupportedError();
                throw err;
            }
            // Bug #131 Safari returns null when there are four other AudioContexts running already.
            if (nativeAudioContext === null) throw createUnknownError();
            // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.
            if (!(0, $0cefff6266c0f0f4$export$82d5f0e102842fbe)(options.latencyHint)) throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
            // Bug #150 Safari does not support setting the sampleRate.
            if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) throw createNotSupportedError();
            super(nativeAudioContext, 2);
            const { latencyHint: latencyHint } = options;
            const { sampleRate: sampleRate } = nativeAudioContext;
            // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.
            this._baseLatency = typeof nativeAudioContext.baseLatency === 'number' ? nativeAudioContext.baseLatency : latencyHint === 'balanced' ? 512 / sampleRate : latencyHint === 'interactive' || latencyHint === undefined ? 256 / sampleRate : latencyHint === 'playback' ? 1024 / sampleRate : /*
                                   * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
                                   * ScriptProcessorNode.
                                   */ Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
            this._nativeAudioContext = nativeAudioContext;
            // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.
            if (nativeAudioContextConstructor.name === 'webkitAudioContext') {
                this._nativeGainNode = nativeAudioContext.createGain();
                this._nativeOscillatorNode = nativeAudioContext.createOscillator();
                this._nativeGainNode.gain.value = 1e-37;
                this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);
                this._nativeOscillatorNode.start();
            } else {
                this._nativeGainNode = null;
                this._nativeOscillatorNode = null;
            }
            this._state = null;
            /*
             * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
             * to 'running'.
             */ if (nativeAudioContext.state === 'running') {
                this._state = 'suspended';
                const revokeState = ()=>{
                    if (this._state === 'suspended') this._state = null;
                    nativeAudioContext.removeEventListener('statechange', revokeState);
                };
                nativeAudioContext.addEventListener('statechange', revokeState);
            }
        }
        get baseLatency() {
            return this._baseLatency;
        }
        get state() {
            return this._state !== null ? this._state : this._nativeAudioContext.state;
        }
        close() {
            // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
            if (this.state === 'closed') return this._nativeAudioContext.close().then(()=>{
                throw createInvalidStateError();
            });
            // Bug #34: If the state was set to suspended before it should be revoked now.
            if (this._state === 'suspended') this._state = null;
            return this._nativeAudioContext.close().then(()=>{
                if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
                    this._nativeOscillatorNode.stop();
                    this._nativeGainNode.disconnect();
                    this._nativeOscillatorNode.disconnect();
                }
                (0, $6d385241f7fab45a$export$cbd606bc629ea938)(this);
            });
        }
        createMediaElementSource(mediaElement) {
            return new mediaElementAudioSourceNodeConstructor(this, {
                mediaElement: mediaElement
            });
        }
        createMediaStreamDestination() {
            return new mediaStreamAudioDestinationNodeConstructor(this);
        }
        createMediaStreamSource(mediaStream) {
            return new mediaStreamAudioSourceNodeConstructor(this, {
                mediaStream: mediaStream
            });
        }
        createMediaStreamTrackSource(mediaStreamTrack) {
            return new mediaStreamTrackAudioSourceNodeConstructor(this, {
                mediaStreamTrack: mediaStreamTrack
            });
        }
        resume() {
            if (this._state === 'suspended') return new Promise((resolve, reject)=>{
                const resolvePromise = ()=>{
                    this._nativeAudioContext.removeEventListener('statechange', resolvePromise);
                    if (this._nativeAudioContext.state === 'running') resolve();
                    else this.resume().then(resolve, reject);
                };
                this._nativeAudioContext.addEventListener('statechange', resolvePromise);
            });
            return this._nativeAudioContext.resume().catch((err)=>{
                // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined || err.code === 15) throw createInvalidStateError();
                throw err;
            });
        }
        suspend() {
            return this._nativeAudioContext.suspend().catch((err)=>{
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined) throw createInvalidStateError();
                throw err;
            });
        }
    };
};


const $3c5495fa70efa802$export$cbbb0c3ba3f5dd5b = (audioNodeConstructor, createAudioDestinationNodeRenderer, createIndexSizeError, createInvalidStateError, createNativeAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext, renderInputsOfAudioNode)=>{
    return class AudioDestinationNode extends audioNodeConstructor {
        constructor(context, channelCount){
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const nativeAudioDestinationNode = createNativeAudioDestinationNode(nativeContext, channelCount, isOffline);
            const audioDestinationNodeRenderer = isOffline ? createAudioDestinationNodeRenderer(renderInputsOfAudioNode) : null;
            super(context, false, nativeAudioDestinationNode, audioDestinationNodeRenderer);
            this._isNodeOfNativeOfflineAudioContext = isOffline;
            this._nativeAudioDestinationNode = nativeAudioDestinationNode;
        }
        get channelCount() {
            return this._nativeAudioDestinationNode.channelCount;
        }
        set channelCount(value) {
            // Bug #52: Chrome, Edge & Safari do not throw an exception at all.
            // Bug #54: Firefox does throw an IndexSizeError.
            if (this._isNodeOfNativeOfflineAudioContext) throw createInvalidStateError();
            // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
            if (value > this._nativeAudioDestinationNode.maxChannelCount) throw createIndexSizeError();
            this._nativeAudioDestinationNode.channelCount = value;
        }
        get channelCountMode() {
            return this._nativeAudioDestinationNode.channelCountMode;
        }
        set channelCountMode(value) {
            // Bug #53: No browser does throw an exception yet.
            if (this._isNodeOfNativeOfflineAudioContext) throw createInvalidStateError();
            this._nativeAudioDestinationNode.channelCountMode = value;
        }
        get maxChannelCount() {
            return this._nativeAudioDestinationNode.maxChannelCount;
        }
    };
};


const $722e3b4b287a6f68$export$d44f3f5d4e42ced2 = (renderInputsOfAudioNode)=>{
    const renderedNativeAudioDestinationNodes = new WeakMap();
    const createAudioDestinationNode = async (proxy, nativeOfflineAudioContext)=>{
        const nativeAudioDestinationNode = nativeOfflineAudioContext.destination;
        renderedNativeAudioDestinationNodes.set(nativeOfflineAudioContext, nativeAudioDestinationNode);
        await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioDestinationNode);
        return nativeAudioDestinationNode;
    };
    return {
        render (proxy, nativeOfflineAudioContext) {
            const renderedNativeAudioDestinationNode = renderedNativeAudioDestinationNodes.get(nativeOfflineAudioContext);
            if (renderedNativeAudioDestinationNode !== undefined) return Promise.resolve(renderedNativeAudioDestinationNode);
            return createAudioDestinationNode(proxy, nativeOfflineAudioContext);
        }
    };
};



const $76e2077b6d4a003e$export$3e70692c55bd5b52 = (createAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeScriptProcessorNode, createNotSupportedError, getFirstSample, isNativeOfflineAudioContext, overwriteAccessors)=>{
    return (context, nativeContext)=>{
        const nativeListener = nativeContext.listener;
        // Bug #117: Only Chrome & Edge support the new interface already.
        const createFakeAudioParams = ()=>{
            const buffer = new Float32Array(1);
            const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'speakers',
                numberOfInputs: 9
            });
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            let isScriptProcessorNodeCreated = false;
            let lastOrientation = [
                0,
                0,
                -1,
                0,
                1,
                0
            ];
            let lastPosition = [
                0,
                0,
                0
            ];
            const createScriptProcessorNode = ()=>{
                if (isScriptProcessorNodeCreated) return;
                isScriptProcessorNodeCreated = true;
                const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 9, 0);
                // tslint:disable-next-line:deprecation
                scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer })=>{
                    const orientation = [
                        getFirstSample(inputBuffer, buffer, 0),
                        getFirstSample(inputBuffer, buffer, 1),
                        getFirstSample(inputBuffer, buffer, 2),
                        getFirstSample(inputBuffer, buffer, 3),
                        getFirstSample(inputBuffer, buffer, 4),
                        getFirstSample(inputBuffer, buffer, 5)
                    ];
                    if (orientation.some((value, index)=>value !== lastOrientation[index])) {
                        nativeListener.setOrientation(...orientation); // tslint:disable-line:deprecation
                        lastOrientation = orientation;
                    }
                    const positon = [
                        getFirstSample(inputBuffer, buffer, 6),
                        getFirstSample(inputBuffer, buffer, 7),
                        getFirstSample(inputBuffer, buffer, 8)
                    ];
                    if (positon.some((value, index)=>value !== lastPosition[index])) {
                        nativeListener.setPosition(...positon); // tslint:disable-line:deprecation
                        lastPosition = positon;
                    }
                };
                channelMergerNode.connect(scriptProcessorNode);
            };
            const createSetOrientation = (index)=>(value)=>{
                    if (value !== lastOrientation[index]) {
                        lastOrientation[index] = value;
                        nativeListener.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
                    }
                };
            const createSetPosition = (index)=>(value)=>{
                    if (value !== lastPosition[index]) {
                        lastPosition[index] = value;
                        nativeListener.setPosition(...lastPosition); // tslint:disable-line:deprecation
                    }
                };
            const createFakeAudioParam = (input, initialValue, setValue)=>{
                const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    offset: initialValue
                });
                constantSourceNode.connect(channelMergerNode, 0, input);
                // @todo This should be stopped when the context is closed.
                constantSourceNode.start();
                Object.defineProperty(constantSourceNode.offset, 'defaultValue', {
                    get () {
                        return initialValue;
                    }
                });
                /*
                 * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and
                 * minValue for GainNodes.
                 */ const audioParam = createAudioParam({
                    context: context
                }, isOffline, constantSourceNode.offset, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
                overwriteAccessors(audioParam, 'value', (get)=>()=>get.call(audioParam), (set)=>(value)=>{
                        try {
                            set.call(audioParam, value);
                        } catch (err) {
                            if (err.code !== 9) throw err;
                        }
                        createScriptProcessorNode();
                        if (isOffline) // Bug #117: Using setOrientation() and setPosition() doesn't work with an OfflineAudioContext.
                        setValue(value);
                    });
                audioParam.cancelAndHoldAtTime = ((cancelAndHoldAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = cancelAndHoldAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.cancelAndHoldAtTime);
                audioParam.cancelScheduledValues = ((cancelScheduledValues)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = cancelScheduledValues.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.cancelScheduledValues);
                audioParam.exponentialRampToValueAtTime = ((exponentialRampToValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = exponentialRampToValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.exponentialRampToValueAtTime);
                audioParam.linearRampToValueAtTime = ((linearRampToValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = linearRampToValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.linearRampToValueAtTime);
                audioParam.setTargetAtTime = ((setTargetAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setTargetAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setTargetAtTime);
                audioParam.setValueAtTime = ((setValueAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setValueAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setValueAtTime);
                audioParam.setValueCurveAtTime = ((setValueCurveAtTime)=>{
                    if (isOffline) return ()=>{
                        throw createNotSupportedError();
                    };
                    return (...args)=>{
                        const value = setValueCurveAtTime.apply(audioParam, args);
                        createScriptProcessorNode();
                        return value;
                    };
                })(audioParam.setValueCurveAtTime);
                return audioParam;
            };
            return {
                forwardX: createFakeAudioParam(0, 0, createSetOrientation(0)),
                forwardY: createFakeAudioParam(1, 0, createSetOrientation(1)),
                forwardZ: createFakeAudioParam(2, -1, createSetOrientation(2)),
                positionX: createFakeAudioParam(6, 0, createSetPosition(0)),
                positionY: createFakeAudioParam(7, 0, createSetPosition(1)),
                positionZ: createFakeAudioParam(8, 0, createSetPosition(2)),
                upX: createFakeAudioParam(3, 0, createSetOrientation(3)),
                upY: createFakeAudioParam(4, 1, createSetOrientation(4)),
                upZ: createFakeAudioParam(5, 0, createSetOrientation(5))
            };
        };
        const { forwardX: forwardX, forwardY: forwardY, forwardZ: forwardZ, positionX: positionX, positionY: positionY, positionZ: positionZ, upX: upX, upY: upY, upZ: upZ } = nativeListener.forwardX === undefined ? createFakeAudioParams() : nativeListener;
        return {
            get forwardX () {
                return forwardX;
            },
            get forwardY () {
                return forwardY;
            },
            get forwardZ () {
                return forwardZ;
            },
            get positionX () {
                return positionX;
            },
            get positionY () {
                return positionY;
            },
            get positionZ () {
                return positionZ;
            },
            get upX () {
                return upX;
            },
            get upY () {
                return upY;
            },
            get upZ () {
                return upZ;
            }
        };
    };
};



const $c23aedeecc2b6162$export$85cd8e93eb858e81 = (audioNodeOrAudioParam)=>{
    return 'context' in audioNodeOrAudioParam;
};



const $ea4b38b6f3ac443b$export$419d66ef3a96a878 = (outputConnection)=>{
    return (0, $c23aedeecc2b6162$export$85cd8e93eb858e81)(outputConnection[0]);
};


const $b5b160ddb9cb72cc$export$64505511c8abc942 = (set, element, predicate, ignoreDuplicates)=>{
    for (const lmnt of set)if (predicate(lmnt)) {
        if (ignoreDuplicates) return false;
        throw Error('The set contains at least one similar element.');
    }
    set.add(element);
    return true;
};


const $21a3952b118bdc5d$export$3dfe9f7f712d42df = (activeInputs, source, [output, eventListener], ignoreDuplicates)=>{
    (0, $b5b160ddb9cb72cc$export$64505511c8abc942)(activeInputs, [
        source,
        output,
        eventListener
    ], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output, ignoreDuplicates);
};



const $3bcad23e25c57ecf$export$2a7c0e6916aa50e4 = (passiveInputs, [source, output, eventListener], ignoreDuplicates)=>{
    const passiveInputConnections = passiveInputs.get(source);
    if (passiveInputConnections === undefined) passiveInputs.set(source, new Set([
        [
            output,
            eventListener
        ]
    ]));
    else (0, $b5b160ddb9cb72cc$export$64505511c8abc942)(passiveInputConnections, [
        output,
        eventListener
    ], (passiveInputConnection)=>passiveInputConnection[0] === output, ignoreDuplicates);
};


const $0b958e40cf81116d$export$ac2aef07f705aa48 = (nativeAudioNodeOrNativeAudioNodeFaker)=>{
    return 'inputs' in nativeAudioNodeOrNativeAudioNodeFaker;
};


const $19c742083556a242$export$b92162b3199b4461 = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input)=>{
    if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeDestinationAudioNode)) {
        const fakeNativeDestinationAudioNode = nativeDestinationAudioNode.inputs[input];
        nativeSourceAudioNode.connect(fakeNativeDestinationAudioNode, output, 0);
        return [
            fakeNativeDestinationAudioNode,
            output,
            0
        ];
    }
    nativeSourceAudioNode.connect(nativeDestinationAudioNode, output, input);
    return [
        nativeDestinationAudioNode,
        output,
        input
    ];
};


const $9d73a6929aae649e$export$6cc4c86d6b87a4b8 = (activeInputConnections, source, output)=>{
    for (const activeInputConnection of activeInputConnections)if (activeInputConnection[0] === source && activeInputConnection[1] === output) {
        activeInputConnections.delete(activeInputConnection);
        return activeInputConnection;
    }
    return null;
};



const $0af44684bfcfdb82$export$dc5a8616367736a9 = (activeInputs, source, output)=>{
    return (0, $b4907d346209c4aa$export$3f1b331b43a0e659)(activeInputs, (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output);
};



const $d8593c04fb61e4ca$export$b5a32c2e2eac4137 = (audioNode, eventListener)=>{
    const eventListeners = (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25)(audioNode);
    if (!eventListeners.delete(eventListener)) throw new Error('Missing the expected event listener.');
};





const $7e7e2ad0b0763524$export$368aa16ce008e2f4 = (passiveInputs, source, output)=>{
    const passiveInputConnections = (0, $88ab0c374f97b769$export$520987e3ff3ffad3)(passiveInputs, source);
    const matchingConnection = (0, $b4907d346209c4aa$export$3f1b331b43a0e659)(passiveInputConnections, (passiveInputConnection)=>passiveInputConnection[0] === output);
    if (passiveInputConnections.size === 0) passiveInputs.delete(source);
    return matchingConnection;
};



const $c5150425da7035f6$export$a19b495df4b88921 = (nativeSourceAudioNode, nativeDestinationAudioNode, output, input)=>{
    if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeDestinationAudioNode)) nativeSourceAudioNode.disconnect(nativeDestinationAudioNode.inputs[input], output, 0);
    else nativeSourceAudioNode.disconnect(nativeDestinationAudioNode, output, input);
};







const $f19824d1c532946e$export$e719c0d45ea16d08 = (audioNode)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$864a3cfb55580d0c), audioNode);
};




const $6cb22515327e5f96$export$fad3d843b2a56ffb = (audioParam)=>{
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$55484e3055c7a9e2), audioParam);
};





const $5ab4cc8140911ed0$export$8658a39a04a404d5 = (audioNode)=>{
    return (0, $7718e734b2fef711$export$cf686a6a3e402092).has(audioNode);
};



const $a8abf1563cb0cb90$export$79a7cb9fa56970e = (audioNode)=>{
    return !(0, $7718e734b2fef711$export$2b500979aea0913f).has(audioNode);
};




const $8fbdf1ba7335a1ec$export$f938a299860627 = (nativeAudioContext, nativeAudioWorkletNodeConstructor)=>{
    return new Promise((resolve)=>{
        /*
         * This bug existed in Safari up until v14.0.2. Since AudioWorklets were not supported in Safari until v14.1 the presence of the
         * constructor for an AudioWorkletNode can be used here to skip the test.
         */ if (nativeAudioWorkletNodeConstructor !== null) resolve(true);
        else {
            const analyzer = nativeAudioContext.createScriptProcessor(256, 1, 1); // tslint:disable-line deprecation
            const dummy = nativeAudioContext.createGain();
            // Bug #95: Safari does not play one sample buffers.
            const ones = nativeAudioContext.createBuffer(1, 2, 44100);
            const channelData = ones.getChannelData(0);
            channelData[0] = 1;
            channelData[1] = 1;
            const source = nativeAudioContext.createBufferSource();
            source.buffer = ones;
            source.loop = true;
            source.connect(analyzer).connect(nativeAudioContext.destination);
            source.connect(dummy);
            source.disconnect(dummy);
            // tslint:disable-next-line:deprecation
            analyzer.onaudioprocess = (event)=>{
                const chnnlDt = event.inputBuffer.getChannelData(0); // tslint:disable-line deprecation
                if (Array.prototype.some.call(chnnlDt, (sample)=>sample === 1)) resolve(true);
                else resolve(false);
                source.stop();
                analyzer.onaudioprocess = null; // tslint:disable-line:deprecation
                source.disconnect(analyzer);
                analyzer.disconnect(nativeAudioContext.destination);
            };
            source.start();
        }
    });
};


const $c63caa1a29cc4f1a$export$f8092aa3a6fcf50f = (cycles, visitor)=>{
    const counts = new Map();
    for (const cycle of cycles)for (const audioNode of cycle){
        const count = counts.get(audioNode);
        counts.set(audioNode, count === undefined ? 1 : count + 1);
    }
    counts.forEach((count, audioNode)=>visitor(audioNode, count));
};


const $02572834e9cacc18$export$d647358384f164e0 = (nativeAudioNodeOrAudioParam)=>{
    return 'context' in nativeAudioNodeOrAudioParam;
};


const $5cd1779abf94fd6d$export$d4ca24d0078a887f = (nativeAudioNode)=>{
    const connections = new Map();
    nativeAudioNode.connect = ((connect)=>{
        // tslint:disable-next-line:invalid-void no-inferrable-types
        return (destination, output = 0, input = 0)=>{
            const returnValue = (0, $02572834e9cacc18$export$d647358384f164e0)(destination) ? connect(destination, output, input) : connect(destination, output);
            // Save the new connection only if the calls to connect above didn't throw an error.
            const connectionsToDestination = connections.get(destination);
            if (connectionsToDestination === undefined) connections.set(destination, [
                {
                    input: input,
                    output: output
                }
            ]);
            else if (connectionsToDestination.every((connection)=>connection.input !== input || connection.output !== output)) connectionsToDestination.push({
                input: input,
                output: output
            });
            return returnValue;
        };
    })(nativeAudioNode.connect.bind(nativeAudioNode));
    nativeAudioNode.disconnect = ((disconnect)=>{
        return (destinationOrOutput, output, input)=>{
            disconnect.apply(nativeAudioNode);
            if (destinationOrOutput === undefined) connections.clear();
            else if (typeof destinationOrOutput === 'number') for (const [destination, connectionsToDestination] of connections){
                const filteredConnections = connectionsToDestination.filter((connection)=>connection.output !== destinationOrOutput);
                if (filteredConnections.length === 0) connections.delete(destination);
                else connections.set(destination, filteredConnections);
            }
            else if (connections.has(destinationOrOutput)) {
                if (output === undefined) connections.delete(destinationOrOutput);
                else {
                    const connectionsToDestination = connections.get(destinationOrOutput);
                    if (connectionsToDestination !== undefined) {
                        const filteredConnections = connectionsToDestination.filter((connection)=>connection.output !== output && (connection.input !== input || input === undefined));
                        if (filteredConnections.length === 0) connections.delete(destinationOrOutput);
                        else connections.set(destinationOrOutput, filteredConnections);
                    }
                }
            }
            for (const [destination, connectionsToDestination] of connections)connectionsToDestination.forEach((connection)=>{
                if ((0, $02572834e9cacc18$export$d647358384f164e0)(destination)) nativeAudioNode.connect(destination, connection.output, connection.input);
                else nativeAudioNode.connect(destination, connection.output);
            });
        };
    })(nativeAudioNode.disconnect);
};


const $17fd1e9637f226c8$var$addConnectionToAudioParamOfAudioContext = (source, destination, output, isOffline)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $ca92fb3bedacccdf$export$1b11f454bf19657)(destination);
    const { outputs: outputs } = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(source);
    const eventListeners = (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25)(source);
    const eventListener = (isActive)=>{
        const nativeAudioNode = (0, $f19824d1c532946e$export$e719c0d45ea16d08)(source);
        const nativeAudioParam = (0, $6cb22515327e5f96$export$fad3d843b2a56ffb)(destination);
        if (isActive) {
            const partialConnection = (0, $7e7e2ad0b0763524$export$368aa16ce008e2f4)(passiveInputs, source, output);
            (0, $21a3952b118bdc5d$export$3dfe9f7f712d42df)(activeInputs, source, partialConnection, false);
            if (!isOffline && !(0, $5ab4cc8140911ed0$export$8658a39a04a404d5)(source)) nativeAudioNode.connect(nativeAudioParam, output);
        } else {
            const partialConnection = (0, $0af44684bfcfdb82$export$dc5a8616367736a9)(activeInputs, source, output);
            (0, $3bcad23e25c57ecf$export$2a7c0e6916aa50e4)(passiveInputs, partialConnection, false);
            if (!isOffline && !(0, $5ab4cc8140911ed0$export$8658a39a04a404d5)(source)) nativeAudioNode.disconnect(nativeAudioParam, output);
        }
    };
    if ((0, $b5b160ddb9cb72cc$export$64505511c8abc942)(outputs, [
        destination,
        output
    ], (outputConnection)=>outputConnection[0] === destination && outputConnection[1] === output, true)) {
        eventListeners.add(eventListener);
        if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(source)) (0, $21a3952b118bdc5d$export$3dfe9f7f712d42df)(activeInputs, source, [
            output,
            eventListener
        ], true);
        else (0, $3bcad23e25c57ecf$export$2a7c0e6916aa50e4)(passiveInputs, [
            source,
            output,
            eventListener
        ], true);
        return true;
    }
    return false;
};
const $17fd1e9637f226c8$var$deleteInputConnectionOfAudioNode = (source, destination, output, input)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(destination);
    const activeInputConnection = (0, $9d73a6929aae649e$export$6cc4c86d6b87a4b8)(activeInputs[input], source, output);
    if (activeInputConnection === null) {
        const passiveInputConnection = (0, $1347121a05cab167$export$26ec3ebc965d6cfd)(passiveInputs, source, output, input);
        return [
            passiveInputConnection[2],
            false
        ];
    }
    return [
        activeInputConnection[2],
        true
    ];
};
const $17fd1e9637f226c8$var$deleteInputConnectionOfAudioParam = (source, destination, output)=>{
    const { activeInputs: activeInputs, passiveInputs: passiveInputs } = (0, $ca92fb3bedacccdf$export$1b11f454bf19657)(destination);
    const activeInputConnection = (0, $9d73a6929aae649e$export$6cc4c86d6b87a4b8)(activeInputs, source, output);
    if (activeInputConnection === null) {
        const passiveInputConnection = (0, $7e7e2ad0b0763524$export$368aa16ce008e2f4)(passiveInputs, source, output);
        return [
            passiveInputConnection[1],
            false
        ];
    }
    return [
        activeInputConnection[2],
        true
    ];
};
const $17fd1e9637f226c8$var$deleteInputsOfAudioNode = (source, isOffline, destination, output, input)=>{
    const [listener, isActive] = $17fd1e9637f226c8$var$deleteInputConnectionOfAudioNode(source, destination, output, input);
    if (listener !== null) {
        (0, $d8593c04fb61e4ca$export$b5a32c2e2eac4137)(source, listener);
        if (isActive && !isOffline && !(0, $5ab4cc8140911ed0$export$8658a39a04a404d5)(source)) (0, $c5150425da7035f6$export$a19b495df4b88921)((0, $f19824d1c532946e$export$e719c0d45ea16d08)(source), (0, $f19824d1c532946e$export$e719c0d45ea16d08)(destination), output, input);
    }
    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(destination)) {
        const { activeInputs: activeInputs } = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(destination);
        (0, $d86f58cf827039bb$export$c74023ca160dc207)(destination, activeInputs);
    }
};
const $17fd1e9637f226c8$var$deleteInputsOfAudioParam = (source, isOffline, destination, output)=>{
    const [listener, isActive] = $17fd1e9637f226c8$var$deleteInputConnectionOfAudioParam(source, destination, output);
    if (listener !== null) {
        (0, $d8593c04fb61e4ca$export$b5a32c2e2eac4137)(source, listener);
        if (isActive && !isOffline && !(0, $5ab4cc8140911ed0$export$8658a39a04a404d5)(source)) (0, $f19824d1c532946e$export$e719c0d45ea16d08)(source).disconnect((0, $6cb22515327e5f96$export$fad3d843b2a56ffb)(destination), output);
    }
};
const $17fd1e9637f226c8$var$deleteAnyConnection = (source, isOffline)=>{
    const audioNodeConnectionsOfSource = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(source);
    const destinations = [];
    for (const outputConnection of audioNodeConnectionsOfSource.outputs){
        if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(outputConnection)) $17fd1e9637f226c8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $17fd1e9637f226c8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        destinations.push(outputConnection[0]);
    }
    audioNodeConnectionsOfSource.outputs.clear();
    return destinations;
};
const $17fd1e9637f226c8$var$deleteConnectionAtOutput = (source, isOffline, output)=>{
    const audioNodeConnectionsOfSource = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(source);
    const destinations = [];
    for (const outputConnection of audioNodeConnectionsOfSource.outputs)if (outputConnection[1] === output) {
        if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(outputConnection)) $17fd1e9637f226c8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $17fd1e9637f226c8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        destinations.push(outputConnection[0]);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
    }
    return destinations;
};
const $17fd1e9637f226c8$var$deleteConnectionToDestination = (source, isOffline, destination, output, input)=>{
    const audioNodeConnectionsOfSource = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(source);
    return Array.from(audioNodeConnectionsOfSource.outputs).filter((outputConnection)=>outputConnection[0] === destination && (output === undefined || outputConnection[1] === output) && (input === undefined || outputConnection[2] === input)).map((outputConnection)=>{
        if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(outputConnection)) $17fd1e9637f226c8$var$deleteInputsOfAudioNode(source, isOffline, ...outputConnection);
        else $17fd1e9637f226c8$var$deleteInputsOfAudioParam(source, isOffline, ...outputConnection);
        audioNodeConnectionsOfSource.outputs.delete(outputConnection);
        return outputConnection[0];
    });
};
const $17fd1e9637f226c8$export$20e3fa4f981cb01d = (addAudioNodeConnections, addConnectionToAudioNode, cacheTestResult, createIncrementCycleCounter, createIndexSizeError, createInvalidAccessError, createNotSupportedError, decrementCycleCounter, detectCycles, eventTargetConstructor, getNativeContext, isNativeAudioContext, isNativeAudioNode, isNativeAudioParam, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor)=>{
    return class AudioNode extends eventTargetConstructor {
        constructor(context, isActive, nativeAudioNode, audioNodeRenderer){
            super(nativeAudioNode);
            this._context = context;
            this._nativeAudioNode = nativeAudioNode;
            const nativeContext = getNativeContext(context);
            // Bug #12: Safari does not support to disconnect a specific destination.
            if (isNativeAudioContext(nativeContext) && true !== cacheTestResult((0, $8fbdf1ba7335a1ec$export$f938a299860627), ()=>{
                return (0, $8fbdf1ba7335a1ec$export$f938a299860627)(nativeContext, nativeAudioWorkletNodeConstructor);
            })) (0, $5cd1779abf94fd6d$export$d4ca24d0078a887f)(nativeAudioNode);
            (0, $7718e734b2fef711$export$864a3cfb55580d0c).set(this, nativeAudioNode);
            (0, $7718e734b2fef711$export$c998cfefa4fd5136).set(this, new Set());
            if (context.state !== 'closed' && isActive) (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(this);
            addAudioNodeConnections(this, audioNodeRenderer, nativeAudioNode);
        }
        get channelCount() {
            return this._nativeAudioNode.channelCount;
        }
        set channelCount(value) {
            this._nativeAudioNode.channelCount = value;
        }
        get channelCountMode() {
            return this._nativeAudioNode.channelCountMode;
        }
        set channelCountMode(value) {
            this._nativeAudioNode.channelCountMode = value;
        }
        get channelInterpretation() {
            return this._nativeAudioNode.channelInterpretation;
        }
        set channelInterpretation(value) {
            this._nativeAudioNode.channelInterpretation = value;
        }
        get context() {
            return this._context;
        }
        get numberOfInputs() {
            return this._nativeAudioNode.numberOfInputs;
        }
        get numberOfOutputs() {
            return this._nativeAudioNode.numberOfOutputs;
        }
        // tslint:disable-next-line:invalid-void
        connect(destination, output = 0, input = 0) {
            // Bug #174: Safari does expose a wrong numberOfOutputs for MediaStreamAudioDestinationNodes.
            if (output < 0 || output >= this._nativeAudioNode.numberOfOutputs) throw createIndexSizeError();
            const nativeContext = getNativeContext(this._context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            if (isNativeAudioNode(destination) || isNativeAudioParam(destination)) throw createInvalidAccessError();
            if ((0, $c23aedeecc2b6162$export$85cd8e93eb858e81)(destination)) {
                const nativeDestinationAudioNode = (0, $f19824d1c532946e$export$e719c0d45ea16d08)(destination);
                try {
                    const connection = (0, $19c742083556a242$export$b92162b3199b4461)(this._nativeAudioNode, nativeDestinationAudioNode, output, input);
                    const isPassive = (0, $a8abf1563cb0cb90$export$79a7cb9fa56970e)(this);
                    if (isOffline || isPassive) this._nativeAudioNode.disconnect(...connection);
                    if (this.context.state !== 'closed' && !isPassive && (0, $a8abf1563cb0cb90$export$79a7cb9fa56970e)(destination)) (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(destination);
                } catch (err) {
                    // Bug #41: Safari does not throw the correct exception so far.
                    if (err.code === 12) throw createInvalidAccessError();
                    throw err;
                }
                const isNewConnectionToAudioNode = addConnectionToAudioNode(this, destination, output, input, isOffline);
                // Bug #164: Only Firefox detects cycles so far.
                if (isNewConnectionToAudioNode) {
                    const cycles = detectCycles([
                        this
                    ], destination);
                    (0, $c63caa1a29cc4f1a$export$f8092aa3a6fcf50f)(cycles, createIncrementCycleCounter(isOffline));
                }
                return destination;
            }
            const nativeAudioParam = (0, $6cb22515327e5f96$export$fad3d843b2a56ffb)(destination);
            /*
             * Bug #73, #147 & #153: Safari does not support to connect an input signal to the playbackRate AudioParam of an
             * AudioBufferSourceNode. This can't be easily detected and that's why the outdated name property is used here to identify
             * Safari. In addition to that the maxValue property is used to only detect the affected versions below v14.0.2.
             */ if (nativeAudioParam.name === 'playbackRate' && nativeAudioParam.maxValue === 1024) throw createNotSupportedError();
            try {
                this._nativeAudioNode.connect(nativeAudioParam, output);
                if (isOffline || (0, $a8abf1563cb0cb90$export$79a7cb9fa56970e)(this)) this._nativeAudioNode.disconnect(nativeAudioParam, output);
            } catch (err) {
                // Bug #58: Safari doesn't throw an InvalidAccessError yet.
                if (err.code === 12) throw createInvalidAccessError();
                throw err;
            }
            const isNewConnectionToAudioParam = $17fd1e9637f226c8$var$addConnectionToAudioParamOfAudioContext(this, destination, output, isOffline);
            // Bug #164: Only Firefox detects cycles so far.
            if (isNewConnectionToAudioParam) {
                const cycles = detectCycles([
                    this
                ], destination);
                (0, $c63caa1a29cc4f1a$export$f8092aa3a6fcf50f)(cycles, createIncrementCycleCounter(isOffline));
            }
        }
        disconnect(destinationOrOutput, output, input) {
            let destinations;
            const nativeContext = getNativeContext(this._context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            if (destinationOrOutput === undefined) destinations = $17fd1e9637f226c8$var$deleteAnyConnection(this, isOffline);
            else if (typeof destinationOrOutput === 'number') {
                if (destinationOrOutput < 0 || destinationOrOutput >= this.numberOfOutputs) throw createIndexSizeError();
                destinations = $17fd1e9637f226c8$var$deleteConnectionAtOutput(this, isOffline, destinationOrOutput);
            } else {
                if (output !== undefined && (output < 0 || output >= this.numberOfOutputs)) throw createIndexSizeError();
                if ((0, $c23aedeecc2b6162$export$85cd8e93eb858e81)(destinationOrOutput) && input !== undefined && (input < 0 || input >= destinationOrOutput.numberOfInputs)) throw createIndexSizeError();
                destinations = $17fd1e9637f226c8$var$deleteConnectionToDestination(this, isOffline, destinationOrOutput, output, input);
                if (destinations.length === 0) throw createInvalidAccessError();
            }
            // Bug #164: Only Firefox detects cycles so far.
            for (const destination of destinations){
                const cycles = detectCycles([
                    this
                ], destination);
                (0, $c63caa1a29cc4f1a$export$f8092aa3a6fcf50f)(cycles, decrementCycleCounter);
            }
        }
    };
};



const $361bc03ea1ca7077$export$25d3edb077748cfc = (addAudioParamConnections, audioParamAudioNodeStore, audioParamStore, createAudioParamRenderer, createCancelAndHoldAutomationEvent, createCancelScheduledValuesAutomationEvent, createExponentialRampToValueAutomationEvent, createLinearRampToValueAutomationEvent, createSetTargetAutomationEvent, createSetValueAutomationEvent, createSetValueCurveAutomationEvent, nativeAudioContextConstructor, setValueAtTimeUntilPossible)=>{
    return (audioNode, isAudioParamOfOfflineAudioContext, nativeAudioParam, maxValue = null, minValue = null)=>{
        // Bug #196 Only Safari sets the defaultValue to the initial value.
        const defaultValue = nativeAudioParam.value;
        const automationEventList = new (0, $8f6857d83370bfe9$exports.AutomationEventList)(defaultValue);
        const audioParamRenderer = isAudioParamOfOfflineAudioContext ? createAudioParamRenderer(automationEventList) : null;
        const audioParam = {
            get defaultValue () {
                return defaultValue;
            },
            get maxValue () {
                return maxValue === null ? nativeAudioParam.maxValue : maxValue;
            },
            get minValue () {
                return minValue === null ? nativeAudioParam.minValue : minValue;
            },
            get value () {
                return nativeAudioParam.value;
            },
            set value (value){
                nativeAudioParam.value = value;
                // Bug #98: Firefox & Safari do not yet treat the value setter like a call to setValueAtTime().
                audioParam.setValueAtTime(value, audioNode.context.currentTime);
            },
            cancelAndHoldAtTime (cancelTime) {
                // Bug #28: Firefox & Safari do not yet implement cancelAndHoldAtTime().
                if (typeof nativeAudioParam.cancelAndHoldAtTime === 'function') {
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
                    nativeAudioParam.cancelAndHoldAtTime(cancelTime);
                } else {
                    const previousLastEvent = Array.from(automationEventList).pop();
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createCancelAndHoldAutomationEvent(cancelTime));
                    const currentLastEvent = Array.from(automationEventList).pop();
                    nativeAudioParam.cancelScheduledValues(cancelTime);
                    if (previousLastEvent !== currentLastEvent && currentLastEvent !== undefined) {
                        if (currentLastEvent.type === 'exponentialRampToValue') nativeAudioParam.exponentialRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
                        else if (currentLastEvent.type === 'linearRampToValue') nativeAudioParam.linearRampToValueAtTime(currentLastEvent.value, currentLastEvent.endTime);
                        else if (currentLastEvent.type === 'setValue') nativeAudioParam.setValueAtTime(currentLastEvent.value, currentLastEvent.startTime);
                        else if (currentLastEvent.type === 'setValueCurve') nativeAudioParam.setValueCurveAtTime(currentLastEvent.values, currentLastEvent.startTime, currentLastEvent.duration);
                    }
                }
                return audioParam;
            },
            cancelScheduledValues (cancelTime) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createCancelScheduledValuesAutomationEvent(cancelTime));
                nativeAudioParam.cancelScheduledValues(cancelTime);
                return audioParam;
            },
            exponentialRampToValueAtTime (value1, endTime) {
                // Bug #45: Safari does not throw an error yet.
                if (value1 === 0) throw new RangeError();
                // Bug #187: Safari does not throw an error yet.
                if (!Number.isFinite(endTime) || endTime < 0) throw new RangeError();
                const currentTime = audioNode.context.currentTime;
                if (audioParamRenderer === null) automationEventList.flush(currentTime);
                // Bug #194: Firefox does not implicitly call setValueAtTime() if there is no previous event.
                if (Array.from(automationEventList).length === 0) {
                    automationEventList.add(createSetValueAutomationEvent(defaultValue, currentTime));
                    nativeAudioParam.setValueAtTime(defaultValue, currentTime);
                }
                automationEventList.add(createExponentialRampToValueAutomationEvent(value1, endTime));
                nativeAudioParam.exponentialRampToValueAtTime(value1, endTime);
                return audioParam;
            },
            linearRampToValueAtTime (value1, endTime) {
                const currentTime = audioNode.context.currentTime;
                if (audioParamRenderer === null) automationEventList.flush(currentTime);
                // Bug #195: Firefox does not implicitly call setValueAtTime() if there is no previous event.
                if (Array.from(automationEventList).length === 0) {
                    automationEventList.add(createSetValueAutomationEvent(defaultValue, currentTime));
                    nativeAudioParam.setValueAtTime(defaultValue, currentTime);
                }
                automationEventList.add(createLinearRampToValueAutomationEvent(value1, endTime));
                nativeAudioParam.linearRampToValueAtTime(value1, endTime);
                return audioParam;
            },
            setTargetAtTime (target, startTime, timeConstant) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createSetTargetAutomationEvent(target, startTime, timeConstant));
                nativeAudioParam.setTargetAtTime(target, startTime, timeConstant);
                return audioParam;
            },
            setValueAtTime (value1, startTime) {
                if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                automationEventList.add(createSetValueAutomationEvent(value1, startTime));
                nativeAudioParam.setValueAtTime(value1, startTime);
                return audioParam;
            },
            setValueCurveAtTime (values, startTime, duration) {
                // Bug 183: Safari only accepts a Float32Array.
                const convertedValues = values instanceof Float32Array ? values : new Float32Array(values);
                /*
                 * Bug #152: Safari does not correctly interpolate the values of the curve.
                 * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the
                 * existence of the webkitAudioContext is used as a workaround here.
                 */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext') {
                    const endTime = startTime + duration;
                    const sampleRate = audioNode.context.sampleRate;
                    const firstSample = Math.ceil(startTime * sampleRate);
                    const lastSample = Math.floor(endTime * sampleRate);
                    const numberOfInterpolatedValues = lastSample - firstSample;
                    const interpolatedValues = new Float32Array(numberOfInterpolatedValues);
                    for(let i = 0; i < numberOfInterpolatedValues; i += 1){
                        const theoreticIndex = (convertedValues.length - 1) / duration * ((firstSample + i) / sampleRate - startTime);
                        const lowerIndex = Math.floor(theoreticIndex);
                        const upperIndex = Math.ceil(theoreticIndex);
                        interpolatedValues[i] = lowerIndex === upperIndex ? convertedValues[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * convertedValues[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * convertedValues[upperIndex];
                    }
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createSetValueCurveAutomationEvent(interpolatedValues, startTime, duration));
                    nativeAudioParam.setValueCurveAtTime(interpolatedValues, startTime, duration);
                    const timeOfLastSample = lastSample / sampleRate;
                    if (timeOfLastSample < endTime) setValueAtTimeUntilPossible(audioParam, interpolatedValues[interpolatedValues.length - 1], timeOfLastSample);
                    setValueAtTimeUntilPossible(audioParam, convertedValues[convertedValues.length - 1], endTime);
                } else {
                    if (audioParamRenderer === null) automationEventList.flush(audioNode.context.currentTime);
                    automationEventList.add(createSetValueCurveAutomationEvent(convertedValues, startTime, duration));
                    nativeAudioParam.setValueCurveAtTime(convertedValues, startTime, duration);
                }
                return audioParam;
            }
        };
        audioParamStore.set(audioParam, nativeAudioParam);
        audioParamAudioNodeStore.set(audioParam, audioNode);
        addAudioParamConnections(audioParam, audioParamRenderer);
        return audioParam;
    };
};


const $403e2aebd17670b8$export$8858f507eb103ac6 = (automationEventList)=>{
    return {
        replay (audioParam) {
            for (const automationEvent of automationEventList){
                if (automationEvent.type === 'exponentialRampToValue') {
                    const { endTime: endTime, value: value } = automationEvent;
                    audioParam.exponentialRampToValueAtTime(value, endTime);
                } else if (automationEvent.type === 'linearRampToValue') {
                    const { endTime: endTime, value: value } = automationEvent;
                    audioParam.linearRampToValueAtTime(value, endTime);
                } else if (automationEvent.type === 'setTarget') {
                    const { startTime: startTime, target: target, timeConstant: timeConstant } = automationEvent;
                    audioParam.setTargetAtTime(target, startTime, timeConstant);
                } else if (automationEvent.type === 'setValue') {
                    const { startTime: startTime, value: value } = automationEvent;
                    audioParam.setValueAtTime(value, startTime);
                } else if (automationEvent.type === 'setValueCurve') {
                    const { duration: duration, startTime: startTime, values: values } = automationEvent;
                    audioParam.setValueCurveAtTime(values, startTime, duration);
                } else throw new Error("Can't apply an unknown automation.");
            }
        }
    };
};



class $cb5c13986ebfa770$export$5da0cf80a3ca75d6 {
    constructor(parameters){
        this._map = new Map(parameters);
    }
    get size() {
        return this._map.size;
    }
    entries() {
        return this._map.entries();
    }
    forEach(callback, thisArg = null) {
        return this._map.forEach((value, key)=>callback.call(thisArg, value, key, this));
    }
    get(name) {
        return this._map.get(name);
    }
    has(name) {
        return this._map.has(name);
    }
    keys() {
        return this._map.keys();
    }
    values() {
        return this._map.values();
    }
}


const $81af2a00b3599a83$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    // Bug #61: The channelCountMode should be 'max' according to the spec but is set to 'explicit' to achieve consistent behavior.
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    numberOfInputs: 1,
    numberOfOutputs: 1,
    parameterData: {},
    processorOptions: {}
};
const $81af2a00b3599a83$export$48302d37fa2cf062 = (addUnrenderedAudioWorkletNode, audioNodeConstructor, createAudioParam, createAudioWorkletNodeRenderer, createNativeAudioWorkletNode, getAudioNodeConnections, getBackupOfflineAudioContext, getNativeContext, isNativeOfflineAudioContext, nativeAudioWorkletNodeConstructor, sanitizeAudioWorkletNodeOptions, setActiveAudioWorkletNodeInputs, testAudioWorkletNodeOptionsClonability, wrapEventListener)=>{
    return class AudioWorkletNode extends audioNodeConstructor {
        constructor(context, name, options){
            var _a;
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const mergedOptions = sanitizeAudioWorkletNodeOptions({
                ...$81af2a00b3599a83$var$DEFAULT_OPTIONS,
                ...options
            });
            // Bug #191: Safari doesn't throw an error if the options aren't clonable.
            testAudioWorkletNodeOptionsClonability(mergedOptions);
            const nodeNameToProcessorConstructorMap = (0, $7718e734b2fef711$export$b9bea39f06f96914).get(nativeContext);
            const processorConstructor = nodeNameToProcessorConstructorMap === null || nodeNameToProcessorConstructorMap === void 0 ? void 0 : nodeNameToProcessorConstructorMap.get(name);
            // Bug #186: Chrome and Edge do not allow to create an AudioWorkletNode on a closed AudioContext.
            const nativeContextOrBackupOfflineAudioContext = isOffline || nativeContext.state !== 'closed' ? nativeContext : (_a = getBackupOfflineAudioContext(nativeContext)) !== null && _a !== void 0 ? _a : nativeContext;
            const nativeAudioWorkletNode = createNativeAudioWorkletNode(nativeContextOrBackupOfflineAudioContext, isOffline ? null : context.baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, mergedOptions);
            const audioWorkletNodeRenderer = isOffline ? createAudioWorkletNodeRenderer(name, mergedOptions, processorConstructor) : null;
            /*
             * @todo Add a mechanism to switch an AudioWorkletNode to passive once the process() function of the AudioWorkletProcessor
             * returns false.
             */ super(context, true, nativeAudioWorkletNode, audioWorkletNodeRenderer);
            const parameters = [];
            nativeAudioWorkletNode.parameters.forEach((nativeAudioParam, nm)=>{
                const audioParam = createAudioParam(this, isOffline, nativeAudioParam);
                parameters.push([
                    nm,
                    audioParam
                ]);
            });
            this._nativeAudioWorkletNode = nativeAudioWorkletNode;
            this._onprocessorerror = null;
            this._parameters = new (0, $cb5c13986ebfa770$export$5da0cf80a3ca75d6)(parameters);
            /*
             * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to
             * the destination.
             */ if (isOffline) addUnrenderedAudioWorkletNode(nativeContext, this);
            const { activeInputs: activeInputs } = getAudioNodeConnections(this);
            setActiveAudioWorkletNodeInputs(nativeAudioWorkletNode, activeInputs);
        }
        get onprocessorerror() {
            return this._onprocessorerror;
        }
        set onprocessorerror(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeAudioWorkletNode.onprocessorerror = wrappedListener;
            const nativeOnProcessorError = this._nativeAudioWorkletNode.onprocessorerror;
            this._onprocessorerror = nativeOnProcessorError !== null && nativeOnProcessorError === wrappedListener ? value : nativeOnProcessorError;
        }
        get parameters() {
            if (this._parameters === null) // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            return this._nativeAudioWorkletNode.parameters;
            return this._parameters;
        }
        get port() {
            return this._nativeAudioWorkletNode.port;
        }
    };
};


function $824a78f49a5e02c5$export$e3c6e435bf217093(audioBuffer, // @todo There is currently no way to define something like { [ key: number | string ]: Float32Array }
parent, key, channelNumber, bufferOffset) {
    if (typeof audioBuffer.copyFromChannel === 'function') {
        // The byteLength will be 0 when the ArrayBuffer was transferred.
        if (parent[key].byteLength === 0) parent[key] = new Float32Array(128);
        audioBuffer.copyFromChannel(parent[key], channelNumber, bufferOffset);
    // Bug #5: Safari does not support copyFromChannel().
    } else {
        const channelData = audioBuffer.getChannelData(channelNumber);
        // The byteLength will be 0 when the ArrayBuffer was transferred.
        if (parent[key].byteLength === 0) parent[key] = channelData.slice(bufferOffset, bufferOffset + 128);
        else {
            const slicedInput = new Float32Array(channelData.buffer, bufferOffset * Float32Array.BYTES_PER_ELEMENT, 128);
            parent[key].set(slicedInput);
        }
    }
}


const $b17c809f1f01ce66$export$6bb6d131144bd753 = (audioBuffer, parent, key, channelNumber, bufferOffset)=>{
    if (typeof audioBuffer.copyToChannel === 'function') // The byteLength will be 0 when the ArrayBuffer was transferred.
    {
        if (parent[key].byteLength !== 0) audioBuffer.copyToChannel(parent[key], channelNumber, bufferOffset);
    } else // The byteLength will be 0 when the ArrayBuffer was transferred.
    if (parent[key].byteLength !== 0) audioBuffer.getChannelData(channelNumber).set(parent[key], bufferOffset);
};


const $495c163400b6fc08$export$495a31436d188d6d = (x, y)=>{
    const arrays = [];
    for(let i = 0; i < x; i += 1){
        const array = [];
        const length = typeof y === 'number' ? y : y[i];
        for(let j = 0; j < length; j += 1)array.push(new Float32Array(128));
        arrays.push(array);
    }
    return arrays;
};






const $cd8aa197172c5463$export$d948bbdb8f0d97d7 = (nativeOfflineAudioContext, proxy)=>{
    const nodeToProcessorMap = (0, $88ab0c374f97b769$export$520987e3ff3ffad3)((0, $7718e734b2fef711$export$16d7878f7e059d67), nativeOfflineAudioContext);
    const nativeAudioWorkletNode = (0, $f19824d1c532946e$export$e719c0d45ea16d08)(proxy);
    return (0, $88ab0c374f97b769$export$520987e3ff3ffad3)(nodeToProcessorMap, nativeAudioWorkletNode);
};



const $b10bbde18d49daa1$var$processBuffer = async (proxy, renderedBuffer, nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime)=>{
    // Ceil the length to the next full render quantum.
    // Bug #17: Safari does not yet expose the length.
    const length = renderedBuffer === null ? Math.ceil(proxy.context.length / 128) * 128 : renderedBuffer.length;
    const numberOfInputChannels = options.channelCount * options.numberOfInputs;
    const numberOfOutputChannels = outputChannelCount.reduce((sum, value)=>sum + value, 0);
    const processedBuffer = numberOfOutputChannels === 0 ? null : nativeOfflineAudioContext.createBuffer(numberOfOutputChannels, length, nativeOfflineAudioContext.sampleRate);
    if (processorConstructor === undefined) throw new Error('Missing the processor constructor.');
    const audioNodeConnections = (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc)(proxy);
    const audioWorkletProcessor = await (0, $cd8aa197172c5463$export$d948bbdb8f0d97d7)(nativeOfflineAudioContext, proxy);
    const inputs = (0, $495c163400b6fc08$export$495a31436d188d6d)(options.numberOfInputs, options.channelCount);
    const outputs = (0, $495c163400b6fc08$export$495a31436d188d6d)(options.numberOfOutputs, outputChannelCount);
    const parameters = Array.from(proxy.parameters.keys()).reduce((prmtrs, name)=>({
            ...prmtrs,
            [name]: new Float32Array(128)
        }), {});
    for(let i = 0; i < length; i += 128){
        if (options.numberOfInputs > 0 && renderedBuffer !== null) {
            for(let j = 0; j < options.numberOfInputs; j += 1)for(let k = 0; k < options.channelCount; k += 1)(0, $824a78f49a5e02c5$export$e3c6e435bf217093)(renderedBuffer, inputs[j], k, k, i);
        }
        if (processorConstructor.parameterDescriptors !== undefined && renderedBuffer !== null) processorConstructor.parameterDescriptors.forEach(({ name: name }, index)=>{
            (0, $824a78f49a5e02c5$export$e3c6e435bf217093)(renderedBuffer, parameters, name, numberOfInputChannels + index, i);
        });
        for(let j = 0; j < options.numberOfInputs; j += 1){
            for(let k = 0; k < outputChannelCount[j]; k += 1)// The byteLength will be 0 when the ArrayBuffer was transferred.
            if (outputs[j][k].byteLength === 0) outputs[j][k] = new Float32Array(128);
        }
        try {
            const potentiallyEmptyInputs = inputs.map((input, index)=>{
                if (audioNodeConnections.activeInputs[index].size === 0) return [];
                return input;
            });
            const activeSourceFlag = exposeCurrentFrameAndCurrentTime(i / nativeOfflineAudioContext.sampleRate, nativeOfflineAudioContext.sampleRate, ()=>audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
            if (processedBuffer !== null) for(let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1){
                for(let k = 0; k < outputChannelCount[j]; k += 1)(0, $b17c809f1f01ce66$export$6bb6d131144bd753)(processedBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
                outputChannelSplitterNodeOutput += outputChannelCount[j];
            }
            if (!activeSourceFlag) break;
        } catch (error) {
            proxy.dispatchEvent(new ErrorEvent('processorerror', {
                colno: error.colno,
                filename: error.filename,
                lineno: error.lineno,
                message: error.message
            }));
            break;
        }
    }
    return processedBuffer;
};
const $b10bbde18d49daa1$export$3a898af5d2b29a5b = (connectAudioParam, connectMultipleOutputs, createNativeAudioBufferSourceNode, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, deleteUnrenderedAudioWorkletNode, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getNativeAudioNode, nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return (name, options, processorConstructor)=>{
        const renderedNativeAudioNodes = new WeakMap();
        let processedBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioWorkletNode = getNativeAudioNode(proxy);
            let nativeOutputNodes = null;
            const nativeAudioWorkletNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAudioWorkletNode, nativeOfflineAudioContext);
            const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount);
            // Bug #61: Only Chrome, Edge & Firefox have an implementation of the AudioWorkletNode yet.
            if (nativeAudioWorkletNodeConstructor === null) {
                const numberOfOutputChannels = outputChannelCount.reduce((sum, value)=>sum + value, 0);
                const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, {
                    channelCount: Math.max(1, numberOfOutputChannels),
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    numberOfOutputs: Math.max(1, numberOfOutputChannels)
                });
                const outputChannelMergerNodes = [];
                for(let i = 0; i < proxy.numberOfOutputs; i += 1)outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeOfflineAudioContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'speakers',
                    numberOfInputs: outputChannelCount[i]
                }));
                const outputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    channelCount: options.channelCount,
                    channelCountMode: options.channelCountMode,
                    channelInterpretation: options.channelInterpretation,
                    gain: 1
                });
                outputGainNode.connect = connectMultipleOutputs.bind(null, outputChannelMergerNodes);
                outputGainNode.disconnect = disconnectMultipleOutputs.bind(null, outputChannelMergerNodes);
                nativeOutputNodes = [
                    outputChannelSplitterNode,
                    outputChannelMergerNodes,
                    outputGainNode
                ];
            } else if (!nativeAudioWorkletNodeIsOwnedByContext) nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeOfflineAudioContext, name);
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeOutputNodes === null ? nativeAudioWorkletNode : nativeOutputNodes[2]);
            if (nativeOutputNodes !== null) {
                if (processedBufferPromise === null) {
                    if (processorConstructor === undefined) throw new Error('Missing the processor constructor.');
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    // Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                    const numberOfInputChannels = proxy.channelCount * proxy.numberOfInputs;
                    const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
                    const numberOfChannels = numberOfInputChannels + numberOfParameters;
                    const renderBuffer = async ()=>{
                        const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(numberOfChannels, // Ceil the length to the next full render quantum.
                        // Bug #17: Safari does not yet expose the length.
                        Math.ceil(proxy.context.length / 128) * 128, nativeOfflineAudioContext.sampleRate);
                        const gainNodes = [];
                        const inputChannelSplitterNodes = [];
                        for(let i = 0; i < options.numberOfInputs; i += 1){
                            gainNodes.push(createNativeGainNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: options.channelCountMode,
                                channelInterpretation: options.channelInterpretation,
                                gain: 1
                            }));
                            inputChannelSplitterNodes.push(createNativeChannelSplitterNode(partialOfflineAudioContext, {
                                channelCount: options.channelCount,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                numberOfOutputs: options.channelCount
                            }));
                        }
                        const constantSourceNodes = await Promise.all(Array.from(proxy.parameters.values()).map(async (audioParam)=>{
                            const constantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                offset: audioParam.value
                            });
                            await renderAutomation(partialOfflineAudioContext, audioParam, constantSourceNode.offset);
                            return constantSourceNode;
                        }));
                        const inputChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                            channelCount: 1,
                            channelCountMode: 'explicit',
                            channelInterpretation: 'speakers',
                            numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
                        });
                        for(let i = 0; i < options.numberOfInputs; i += 1){
                            gainNodes[i].connect(inputChannelSplitterNodes[i]);
                            for(let j = 0; j < options.channelCount; j += 1)inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
                        }
                        for (const [index, constantSourceNode] of constantSourceNodes.entries()){
                            constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
                            constantSourceNode.start(0);
                        }
                        inputChannelMergerNode.connect(partialOfflineAudioContext.destination);
                        await Promise.all(gainNodes.map((gainNode)=>renderInputsOfAudioNode(proxy, partialOfflineAudioContext, gainNode)));
                        return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                    };
                    processedBufferPromise = $b10bbde18d49daa1$var$processBuffer(proxy, numberOfChannels === 0 ? null : await renderBuffer(), nativeOfflineAudioContext, options, outputChannelCount, processorConstructor, exposeCurrentFrameAndCurrentTime);
                }
                const processedBuffer = await processedBufferPromise;
                const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                    buffer: null,
                    channelCount: 2,
                    channelCountMode: 'max',
                    channelInterpretation: 'speakers',
                    loop: false,
                    loopEnd: 0,
                    loopStart: 0,
                    playbackRate: 1
                });
                const [outputChannelSplitterNode, outputChannelMergerNodes, outputGainNode] = nativeOutputNodes;
                if (processedBuffer !== null) {
                    audioBufferSourceNode.buffer = processedBuffer;
                    audioBufferSourceNode.start(0);
                }
                audioBufferSourceNode.connect(outputChannelSplitterNode);
                for(let i = 0, outputChannelSplitterNodeOutput = 0; i < proxy.numberOfOutputs; i += 1){
                    const outputChannelMergerNode = outputChannelMergerNodes[i];
                    for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                    outputChannelSplitterNodeOutput += outputChannelCount[i];
                }
                return outputGainNode;
            }
            if (!nativeAudioWorkletNodeIsOwnedByContext) for (const [nm, audioParam] of proxy.parameters.entries())await renderAutomation(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            nativeAudioWorkletNode.parameters.get(nm));
            else for (const [nm, audioParam] of proxy.parameters.entries())await connectAudioParam(nativeOfflineAudioContext, audioParam, // @todo The definition that TypeScript uses of the AudioParamMap is lacking many methods.
            nativeAudioWorkletNode.parameters.get(nm));
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioWorkletNode);
            return nativeAudioWorkletNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                deleteUnrenderedAudioWorkletNode(nativeOfflineAudioContext, proxy);
                const renderedNativeAudioWorkletNodeOrGainNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioWorkletNodeOrGainNode !== undefined) return Promise.resolve(renderedNativeAudioWorkletNodeOrGainNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $c7dce4d973e69828$export$7824d6f4713e1e35 = (addAudioWorkletModule, analyserNodeConstructor, audioBufferConstructor, audioBufferSourceNodeConstructor, biquadFilterNodeConstructor, channelMergerNodeConstructor, channelSplitterNodeConstructor, constantSourceNodeConstructor, convolverNodeConstructor, decodeAudioData, delayNodeConstructor, dynamicsCompressorNodeConstructor, gainNodeConstructor, iIRFilterNodeConstructor, minimalBaseAudioContextConstructor, oscillatorNodeConstructor, pannerNodeConstructor, periodicWaveConstructor, stereoPannerNodeConstructor, waveShaperNodeConstructor)=>{
    return class BaseAudioContext extends minimalBaseAudioContextConstructor {
        constructor(_nativeContext, numberOfChannels){
            super(_nativeContext, numberOfChannels);
            this._nativeContext = _nativeContext;
            this._audioWorklet = addAudioWorkletModule === undefined ? undefined : {
                addModule: (moduleURL, options)=>{
                    return addAudioWorkletModule(this, moduleURL, options);
                }
            };
        }
        get audioWorklet() {
            return this._audioWorklet;
        }
        createAnalyser() {
            return new analyserNodeConstructor(this);
        }
        createBiquadFilter() {
            return new biquadFilterNodeConstructor(this);
        }
        createBuffer(numberOfChannels, length, sampleRate) {
            return new audioBufferConstructor({
                length: length,
                numberOfChannels: numberOfChannels,
                sampleRate: sampleRate
            });
        }
        createBufferSource() {
            return new audioBufferSourceNodeConstructor(this);
        }
        createChannelMerger(numberOfInputs = 6) {
            return new channelMergerNodeConstructor(this, {
                numberOfInputs: numberOfInputs
            });
        }
        createChannelSplitter(numberOfOutputs = 6) {
            return new channelSplitterNodeConstructor(this, {
                numberOfOutputs: numberOfOutputs
            });
        }
        createConstantSource() {
            return new constantSourceNodeConstructor(this);
        }
        createConvolver() {
            return new convolverNodeConstructor(this);
        }
        createDelay(maxDelayTime = 1) {
            return new delayNodeConstructor(this, {
                maxDelayTime: maxDelayTime
            });
        }
        createDynamicsCompressor() {
            return new dynamicsCompressorNodeConstructor(this);
        }
        createGain() {
            return new gainNodeConstructor(this);
        }
        createIIRFilter(feedforward, feedback) {
            return new iIRFilterNodeConstructor(this, {
                feedback: feedback,
                feedforward: feedforward
            });
        }
        createOscillator() {
            return new oscillatorNodeConstructor(this);
        }
        createPanner() {
            return new pannerNodeConstructor(this);
        }
        createPeriodicWave(real, imag, constraints = {
            disableNormalization: false
        }) {
            return new periodicWaveConstructor(this, {
                ...constraints,
                imag: imag,
                real: real
            });
        }
        createStereoPanner() {
            return new stereoPannerNodeConstructor(this);
        }
        createWaveShaper() {
            return new waveShaperNodeConstructor(this);
        }
        decodeAudioData(audioData, successCallback, errorCallback) {
            return decodeAudioData(this._nativeContext, audioData).then((audioBuffer)=>{
                if (typeof successCallback === 'function') successCallback(audioBuffer);
                return audioBuffer;
            }, (err)=>{
                if (typeof errorCallback === 'function') errorCallback(err);
                throw err;
            });
        }
    };
};



const $66a4e6e6f309207a$var$DEFAULT_OPTIONS = {
    Q: 1,
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    detune: 0,
    frequency: 350,
    gain: 0,
    type: 'lowpass'
};
const $66a4e6e6f309207a$export$aa421daabad177b5 = (audioNodeConstructor, createAudioParam, createBiquadFilterNodeRenderer, createInvalidAccessError, createNativeBiquadFilterNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class BiquadFilterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$66a4e6e6f309207a$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeBiquadFilterNode = createNativeBiquadFilterNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const biquadFilterNodeRenderer = isOffline ? createBiquadFilterNodeRenderer() : null;
            super(context, false, nativeBiquadFilterNode, biquadFilterNodeRenderer);
            // Bug #80: Safari does not export the correct values for maxValue and minValue.
            this._Q = createAudioParam(this, isOffline, nativeBiquadFilterNode.Q, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            // Bug #78: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._detune = createAudioParam(this, isOffline, nativeBiquadFilterNode.detune, 1200 * Math.log2((0, $c205d95559d496ba$export$ab43bedd17d6a167)), -1200 * Math.log2((0, $c205d95559d496ba$export$ab43bedd17d6a167)));
            // Bug #77: Firefox & Safari do not export the correct value for minValue.
            this._frequency = createAudioParam(this, isOffline, nativeBiquadFilterNode.frequency, context.sampleRate / 2, 0);
            // Bug #79: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._gain = createAudioParam(this, isOffline, nativeBiquadFilterNode.gain, 40 * Math.log10((0, $c205d95559d496ba$export$ab43bedd17d6a167)), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._nativeBiquadFilterNode = nativeBiquadFilterNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get detune() {
            return this._detune;
        }
        get frequency() {
            return this._frequency;
        }
        get gain() {
            return this._gain;
        }
        get Q() {
            return this._Q;
        }
        get type() {
            return this._nativeBiquadFilterNode.type;
        }
        set type(value) {
            this._nativeBiquadFilterNode.type = value;
        }
        getFrequencyResponse(frequencyHz, magResponse, phaseResponse) {
            // Bug #189: Safari does throw an InvalidStateError.
            try {
                this._nativeBiquadFilterNode.getFrequencyResponse(frequencyHz, magResponse, phaseResponse);
            } catch (err) {
                if (err.code === 11) throw createInvalidAccessError();
                throw err;
            }
            // Bug #68: Safari does not throw an error if the parameters differ in their length.
            if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw createInvalidAccessError();
        }
    };
};



const $bcf262a04dcb901f$export$1532cc6682032d84 = (connectAudioParam, createNativeBiquadFilterNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeBiquadFilterNodes = new WeakMap();
        const createBiquadFilterNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeBiquadFilterNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeBiquadFilterNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeBiquadFilterNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeBiquadFilterNode, nativeOfflineAudioContext);
            if (!nativeBiquadFilterNodeIsOwnedByContext) {
                const options = {
                    Q: nativeBiquadFilterNode.Q.value,
                    channelCount: nativeBiquadFilterNode.channelCount,
                    channelCountMode: nativeBiquadFilterNode.channelCountMode,
                    channelInterpretation: nativeBiquadFilterNode.channelInterpretation,
                    detune: nativeBiquadFilterNode.detune.value,
                    frequency: nativeBiquadFilterNode.frequency.value,
                    gain: nativeBiquadFilterNode.gain.value,
                    type: nativeBiquadFilterNode.type
                };
                nativeBiquadFilterNode = createNativeBiquadFilterNode(nativeOfflineAudioContext, options);
            }
            renderedNativeBiquadFilterNodes.set(nativeOfflineAudioContext, nativeBiquadFilterNode);
            if (!nativeBiquadFilterNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.Q, nativeBiquadFilterNode.Q);
                await renderAutomation(nativeOfflineAudioContext, proxy.detune, nativeBiquadFilterNode.detune);
                await renderAutomation(nativeOfflineAudioContext, proxy.frequency, nativeBiquadFilterNode.frequency);
                await renderAutomation(nativeOfflineAudioContext, proxy.gain, nativeBiquadFilterNode.gain);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.Q, nativeBiquadFilterNode.Q);
                await connectAudioParam(nativeOfflineAudioContext, proxy.detune, nativeBiquadFilterNode.detune);
                await connectAudioParam(nativeOfflineAudioContext, proxy.frequency, nativeBiquadFilterNode.frequency);
                await connectAudioParam(nativeOfflineAudioContext, proxy.gain, nativeBiquadFilterNode.gain);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeBiquadFilterNode);
            return nativeBiquadFilterNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeBiquadFilterNode = renderedNativeBiquadFilterNodes.get(nativeOfflineAudioContext);
                if (renderedNativeBiquadFilterNode !== undefined) return Promise.resolve(renderedNativeBiquadFilterNode);
                return createBiquadFilterNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $c8f9a173cc3bf911$export$e72d622686b5f6c7 = (ongoingTests, testResults)=>{
    return (tester, test)=>{
        const cachedTestResult = testResults.get(tester);
        if (cachedTestResult !== undefined) return cachedTestResult;
        const ongoingTest = ongoingTests.get(tester);
        if (ongoingTest !== undefined) return ongoingTest;
        try {
            const synchronousTestResult = test();
            if (synchronousTestResult instanceof Promise) {
                ongoingTests.set(tester, synchronousTestResult);
                return synchronousTestResult.catch(()=>false).then((finalTestResult)=>{
                    ongoingTests.delete(tester);
                    testResults.set(tester, finalTestResult);
                    return finalTestResult;
                });
            }
            testResults.set(tester, synchronousTestResult);
            return synchronousTestResult;
        } catch  {
            testResults.set(tester, false);
            return false;
        }
    };
};


const $d240d532973e561a$var$DEFAULT_OPTIONS = {
    channelCount: 1,
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    numberOfInputs: 6
};
const $d240d532973e561a$export$a65a5a400135d27 = (audioNodeConstructor, createChannelMergerNodeRenderer, createNativeChannelMergerNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class ChannelMergerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$d240d532973e561a$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeChannelMergerNode = createNativeChannelMergerNode(nativeContext, mergedOptions);
            const channelMergerNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelMergerNodeRenderer() : null;
            super(context, false, nativeChannelMergerNode, channelMergerNodeRenderer);
        }
    };
};



const $49bc852e7ae475d1$export$79056cbe2b10cae5 = (createNativeChannelMergerNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioNode = getNativeAudioNode(proxy);
            // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAudioNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAudioNode, nativeOfflineAudioContext);
            if (!nativeAudioNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfInputs: nativeAudioNode.numberOfInputs
                };
                nativeAudioNode = createNativeChannelMergerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);
            return nativeAudioNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $ecc7f6221abcb6cb$var$DEFAULT_OPTIONS = {
    channelCount: 6,
    channelCountMode: 'explicit',
    channelInterpretation: 'discrete',
    numberOfOutputs: 6
};
const $ecc7f6221abcb6cb$export$ce9d996cafa605b = (audioNodeConstructor, createChannelSplitterNodeRenderer, createNativeChannelSplitterNode, getNativeContext, isNativeOfflineAudioContext, sanitizeChannelSplitterOptions)=>{
    return class ChannelSplitterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = sanitizeChannelSplitterOptions({
                ...$ecc7f6221abcb6cb$var$DEFAULT_OPTIONS,
                ...options
            });
            const nativeChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, mergedOptions);
            const channelSplitterNodeRenderer = isNativeOfflineAudioContext(nativeContext) ? createChannelSplitterNodeRenderer() : null;
            super(context, false, nativeChannelSplitterNode, channelSplitterNodeRenderer);
        }
    };
};



const $cbf1ca25428a2bfd$export$d815cad16abde9c3 = (createNativeChannelSplitterNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioNode = getNativeAudioNode(proxy);
            // If the initially used nativeAudioNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeAudioNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeAudioNode, nativeOfflineAudioContext);
            if (!nativeAudioNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeAudioNode.channelCount,
                    channelCountMode: nativeAudioNode.channelCountMode,
                    channelInterpretation: nativeAudioNode.channelInterpretation,
                    numberOfOutputs: nativeAudioNode.numberOfOutputs
                };
                nativeAudioNode = createNativeChannelSplitterNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioNode);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeAudioNode);
            return nativeAudioNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $d4e4872b149da763$export$1e69fdca2ad79f10 = (renderInputsOfAudioParam)=>{
    return (nativeOfflineAudioContext, audioParam, nativeAudioParam)=>{
        return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
    };
};



const $69e4c3c94e06c765$export$5f708e50316bf1a = (createIndexSizeError)=>{
    return (outputAudioNodes, destination, output = 0, input = 0)=>{
        const outputAudioNode = outputAudioNodes[output];
        if (outputAudioNode === undefined) throw createIndexSizeError();
        if ((0, $02572834e9cacc18$export$d647358384f164e0)(destination)) return outputAudioNode.connect(destination, 0, input);
        return outputAudioNode.connect(destination, 0);
    };
};


const $c57fc422e0055003$export$e82b2b63ea82dc82 = (createNativeAudioBufferSourceNode)=>{
    return (nativeContext, nativeAudioNode)=>{
        const nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
            buffer: null,
            channelCount: 2,
            channelCountMode: 'max',
            channelInterpretation: 'speakers',
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            playbackRate: 1
        });
        const nativeAudioBuffer = nativeContext.createBuffer(1, 2, 44100);
        nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
        nativeAudioBufferSourceNode.loop = true;
        nativeAudioBufferSourceNode.connect(nativeAudioNode);
        nativeAudioBufferSourceNode.start();
        return ()=>{
            nativeAudioBufferSourceNode.stop();
            nativeAudioBufferSourceNode.disconnect(nativeAudioNode);
        };
    };
};






const $a2dd1c01048670e7$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    offset: 1
};
const $a2dd1c01048670e7$export$a02a9a6200996500 = (audioNodeConstructor, createAudioParam, createConstantSourceNodeRendererFactory, createNativeConstantSourceNode, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class ConstantSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$a2dd1c01048670e7$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeConstantSourceNode = createNativeConstantSourceNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const constantSourceNodeRenderer = isOffline ? createConstantSourceNodeRendererFactory() : null;
            super(context, false, nativeConstantSourceNode, constantSourceNodeRenderer);
            this._constantSourceNodeRenderer = constantSourceNodeRenderer;
            this._nativeConstantSourceNode = nativeConstantSourceNode;
            /*
             * Bug #62 & #74: Safari does not support ConstantSourceNodes and does not export the correct values for maxValue and minValue
             * for GainNodes.
             */ this._offset = createAudioParam(this, isOffline, nativeConstantSourceNode.offset, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._onended = null;
        }
        get offset() {
            return this._offset;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeConstantSourceNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeConstantSourceNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        start(when = 0) {
            this._nativeConstantSourceNode.start(when);
            if (this._constantSourceNodeRenderer !== null) this._constantSourceNodeRenderer.start = when;
            if (this.context.state !== 'closed') {
                (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeConstantSourceNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(this)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(this);
                };
                this._nativeConstantSourceNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeConstantSourceNode.stop(when);
            if (this._constantSourceNodeRenderer !== null) this._constantSourceNodeRenderer.stop = when;
        }
    };
};



const $03ead4cb10fa624b$export$bc541a3c87b45a7d = (connectAudioParam, createNativeConstantSourceNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeConstantSourceNodes = new WeakMap();
        let start = null;
        let stop = null;
        const createConstantSourceNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeConstantSourceNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeConstantSourceNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeConstantSourceNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeConstantSourceNode, nativeOfflineAudioContext);
            if (!nativeConstantSourceNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeConstantSourceNode.channelCount,
                    channelCountMode: nativeConstantSourceNode.channelCountMode,
                    channelInterpretation: nativeConstantSourceNode.channelInterpretation,
                    offset: nativeConstantSourceNode.offset.value
                };
                nativeConstantSourceNode = createNativeConstantSourceNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeConstantSourceNode.start(start);
                if (stop !== null) nativeConstantSourceNode.stop(stop);
            }
            renderedNativeConstantSourceNodes.set(nativeOfflineAudioContext, nativeConstantSourceNode);
            if (!nativeConstantSourceNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.offset, nativeConstantSourceNode.offset);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConstantSourceNode);
            return nativeConstantSourceNode;
        };
        return {
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeConstantSourceNode = renderedNativeConstantSourceNodes.get(nativeOfflineAudioContext);
                if (renderedNativeConstantSourceNode !== undefined) return Promise.resolve(renderedNativeConstantSourceNode);
                return createConstantSourceNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $9b55f1ea73efe39c$export$540e228106d2c471 = (unit32Array)=>{
    return (value)=>{
        unit32Array[0] = value;
        return unit32Array[0];
    };
};


const $841973333d0cd390$var$DEFAULT_OPTIONS = {
    buffer: null,
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    disableNormalization: false
};
const $841973333d0cd390$export$4894173a4b4ee485 = (audioNodeConstructor, createConvolverNodeRenderer, createNativeConvolverNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class ConvolverNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$841973333d0cd390$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeConvolverNode = createNativeConvolverNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const convolverNodeRenderer = isOffline ? createConvolverNodeRenderer() : null;
            super(context, false, nativeConvolverNode, convolverNodeRenderer);
            this._isBufferNullified = false;
            this._nativeConvolverNode = nativeConvolverNode;
            if (mergedOptions.buffer !== null) setAudioNodeTailTime(this, mergedOptions.buffer.duration);
        }
        get buffer() {
            if (this._isBufferNullified) return null;
            return this._nativeConvolverNode.buffer;
        }
        set buffer(value) {
            this._nativeConvolverNode.buffer = value;
            // Bug #115: Safari does not allow to set the buffer to null.
            if (value === null && this._nativeConvolverNode.buffer !== null) {
                const nativeContext = this._nativeConvolverNode.context;
                this._nativeConvolverNode.buffer = nativeContext.createBuffer(1, 1, nativeContext.sampleRate);
                this._isBufferNullified = true;
                setAudioNodeTailTime(this, 0);
            } else {
                this._isBufferNullified = false;
                setAudioNodeTailTime(this, this._nativeConvolverNode.buffer === null ? 0 : this._nativeConvolverNode.buffer.duration);
            }
        }
        get normalize() {
            return this._nativeConvolverNode.normalize;
        }
        set normalize(value) {
            this._nativeConvolverNode.normalize = value;
        }
    };
};




const $8432906c3c9b8cbf$export$5b278ccdb1a6393 = (createNativeConvolverNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeConvolverNodes = new WeakMap();
        const createConvolverNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeConvolverNode = getNativeAudioNode(proxy);
            // If the initially used nativeConvolverNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeConvolverNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeConvolverNode, nativeOfflineAudioContext);
            if (!nativeConvolverNodeIsOwnedByContext) {
                const options = {
                    buffer: nativeConvolverNode.buffer,
                    channelCount: nativeConvolverNode.channelCount,
                    channelCountMode: nativeConvolverNode.channelCountMode,
                    channelInterpretation: nativeConvolverNode.channelInterpretation,
                    disableNormalization: !nativeConvolverNode.normalize
                };
                nativeConvolverNode = createNativeConvolverNode(nativeOfflineAudioContext, options);
            }
            renderedNativeConvolverNodes.set(nativeOfflineAudioContext, nativeConvolverNode);
            if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeConvolverNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConvolverNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeConvolverNode);
            return nativeConvolverNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeConvolverNode = renderedNativeConvolverNodes.get(nativeOfflineAudioContext);
                if (renderedNativeConvolverNode !== undefined) return Promise.resolve(renderedNativeConvolverNode);
                return createConvolverNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $b7a1d74149a5d9bf$export$ab44e304a31eb0ae = (createNotSupportedError, nativeOfflineAudioContextConstructor)=>{
    return (numberOfChannels, length, sampleRate)=>{
        if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
        try {
            return new nativeOfflineAudioContextConstructor(numberOfChannels, length, sampleRate);
        } catch (err) {
            // Bug #143, #144 & #146: Safari throws a SyntaxError when numberOfChannels, length or sampleRate are invalid.
            if (err.name === 'SyntaxError') throw createNotSupportedError();
            throw err;
        }
    };
};


const $c9e239e1d431cf9c$export$fc1a599a84ca01a8 = ()=>new DOMException('', 'DataCloneError');


const $a6bb0e541b432a5c$export$2d33e41548107ad3 = (arrayBuffer)=>{
    const { port1: port1, port2: port2 } = new MessageChannel();
    return new Promise((resolve)=>{
        const closeAndResolve = ()=>{
            port2.onmessage = null;
            port1.close();
            port2.close();
            resolve();
        };
        port2.onmessage = ()=>closeAndResolve();
        try {
            port1.postMessage(arrayBuffer, [
                arrayBuffer
            ]);
        } catch  {
        // Ignore errors.
        } finally{
            closeAndResolve();
        }
    });
};



const $9c7b16fbc9ba5a0d$export$d83e4a6039bccfb = (audioBufferStore, cacheTestResult, createDataCloneError, createEncodingError, detachedArrayBuffers, getNativeContext, isNativeContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, testPromiseSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    return (anyContext, audioData)=>{
        const nativeContext = isNativeContext(anyContext) ? anyContext : getNativeContext(anyContext);
        // Bug #43: Only Chrome and Edge do throw a DataCloneError.
        if (detachedArrayBuffers.has(audioData)) {
            const err = createDataCloneError();
            return Promise.reject(err);
        }
        // The audioData parameter maybe of a type which can't be added to a WeakSet.
        try {
            detachedArrayBuffers.add(audioData);
        } catch  {
        // Ignore errors.
        }
        // Bug #21: Safari does not support promises yet.
        if (cacheTestResult(testPromiseSupport, ()=>testPromiseSupport(nativeContext))) return nativeContext.decodeAudioData(audioData).then((audioBuffer)=>{
            // Bug #133: Safari does neuter the ArrayBuffer.
            (0, $a6bb0e541b432a5c$export$2d33e41548107ad3)(audioData).catch(()=>{
            // Ignore errors.
            });
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, ()=>testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            return audioBuffer;
        });
        // Bug #21: Safari does not return a Promise yet.
        return new Promise((resolve, reject)=>{
            const complete = async ()=>{
                // Bug #133: Safari does neuter the ArrayBuffer.
                try {
                    await (0, $a6bb0e541b432a5c$export$2d33e41548107ad3)(audioData);
                } catch  {
                // Ignore errors.
                }
            };
            const fail = (err)=>{
                reject(err);
                complete();
            };
            // Bug #26: Safari throws a synchronous error.
            try {
                // Bug #1: Safari requires a successCallback.
                nativeContext.decodeAudioData(audioData, (audioBuffer)=>{
                    // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
                    // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
                    if (typeof audioBuffer.copyFromChannel !== 'function') {
                        wrapAudioBufferCopyChannelMethods(audioBuffer);
                        (0, $e0def92b41d2ffa5$export$df65309cf6249598)(audioBuffer);
                    }
                    audioBufferStore.add(audioBuffer);
                    complete().then(()=>resolve(audioBuffer));
                }, (err)=>{
                    // Bug #4: Safari returns null instead of an error.
                    if (err === null) fail(createEncodingError());
                    else fail(err);
                });
            } catch (err) {
                fail(err);
            }
        });
    };
};



const $c348d8459649177f$export$93f58f9268fde9f6 = (connectNativeAudioNodeToNativeAudioNode, cycleCounters, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, getNativeContext, isActiveAudioNode, isNativeOfflineAudioContext)=>{
    return (audioNode, count)=>{
        const cycleCounter = cycleCounters.get(audioNode);
        if (cycleCounter === undefined) throw new Error('Missing the expected cycle count.');
        const nativeContext = getNativeContext(audioNode.context);
        const isOffline = isNativeOfflineAudioContext(nativeContext);
        if (cycleCounter === count) {
            cycleCounters.delete(audioNode);
            if (!isOffline && isActiveAudioNode(audioNode)) {
                const nativeSourceAudioNode = getNativeAudioNode(audioNode);
                const { outputs: outputs } = getAudioNodeConnections(audioNode);
                for (const output of outputs)if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(output)) {
                    const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                    connectNativeAudioNodeToNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
                } else {
                    const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                    nativeSourceAudioNode.connect(nativeDestinationAudioParam, output[1]);
                }
            }
        } else cycleCounters.set(audioNode, cycleCounter - count);
    };
};


const $8e78583293513642$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    delayTime: 0,
    maxDelayTime: 1
};
const $8e78583293513642$export$b89a0215c1c607e3 = (audioNodeConstructor, createAudioParam, createDelayNodeRenderer, createNativeDelayNode, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class DelayNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$8e78583293513642$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeDelayNode = createNativeDelayNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const delayNodeRenderer = isOffline ? createDelayNodeRenderer(mergedOptions.maxDelayTime) : null;
            super(context, false, nativeDelayNode, delayNodeRenderer);
            this._delayTime = createAudioParam(this, isOffline, nativeDelayNode.delayTime);
            setAudioNodeTailTime(this, mergedOptions.maxDelayTime);
        }
        get delayTime() {
            return this._delayTime;
        }
    };
};



const $f2c53e2a23d66a37$export$d03c2308083a28e5 = (connectAudioParam, createNativeDelayNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return (maxDelayTime)=>{
        const renderedNativeDelayNodes = new WeakMap();
        const createDelayNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeDelayNode = getNativeAudioNode(proxy);
            // If the initially used nativeDelayNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeDelayNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeDelayNode, nativeOfflineAudioContext);
            if (!nativeDelayNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeDelayNode.channelCount,
                    channelCountMode: nativeDelayNode.channelCountMode,
                    channelInterpretation: nativeDelayNode.channelInterpretation,
                    delayTime: nativeDelayNode.delayTime.value,
                    maxDelayTime: maxDelayTime
                };
                nativeDelayNode = createNativeDelayNode(nativeOfflineAudioContext, options);
            }
            renderedNativeDelayNodes.set(nativeOfflineAudioContext, nativeDelayNode);
            if (!nativeDelayNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.delayTime, nativeDelayNode.delayTime);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.delayTime, nativeDelayNode.delayTime);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDelayNode);
            return nativeDelayNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeDelayNode = renderedNativeDelayNodes.get(nativeOfflineAudioContext);
                if (renderedNativeDelayNode !== undefined) return Promise.resolve(renderedNativeDelayNode);
                return createDelayNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $e39a769fcfed862a$export$1f7c0152b9e322ae = (pickElementFromSet)=>{
    return (activeInputs, source, output, input)=>{
        return pickElementFromSet(activeInputs[input], (activeInputConnection)=>activeInputConnection[0] === source && activeInputConnection[1] === output);
    };
};


const $aaeabd7f1c2ff532$export$92df121abbf21dca = (getUnrenderedAudioWorkletNodes)=>{
    return (nativeContext, audioWorkletNode)=>{
        getUnrenderedAudioWorkletNodes(nativeContext).delete(audioWorkletNode);
    };
};



const $f41ec01349ffa62e$export$c283d436eafbd9b2 = (audioNode)=>{
    return 'delayTime' in audioNode;
};


const $60aaea16e2e167aa$export$b4f8d2824d9887dc = (audioParamAudioNodeStore, getAudioNodeConnections, getValueForKey)=>{
    return function detectCycles(chain, nextLink) {
        const audioNode = (0, $c23aedeecc2b6162$export$85cd8e93eb858e81)(nextLink) ? nextLink : getValueForKey(audioParamAudioNodeStore, nextLink);
        if ((0, $f41ec01349ffa62e$export$c283d436eafbd9b2)(audioNode)) return [];
        if (chain[0] === audioNode) return [
            chain
        ];
        if (chain.includes(audioNode)) return [];
        const { outputs: outputs } = getAudioNodeConnections(audioNode);
        return Array.from(outputs).map((outputConnection)=>detectCycles([
                ...chain,
                audioNode
            ], outputConnection[0])).reduce((mergedCycles, nestedCycles)=>mergedCycles.concat(nestedCycles), []);
    };
};



const $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex = (createIndexSizeError, outputAudioNodes, output)=>{
    const outputAudioNode = outputAudioNodes[output];
    if (outputAudioNode === undefined) throw createIndexSizeError();
    return outputAudioNode;
};
const $777f7939fea8f1ed$export$78a992fad11cd00e = (createIndexSizeError)=>{
    return (outputAudioNodes, destinationOrOutput, output, input = 0)=>{
        if (destinationOrOutput === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect());
        if (typeof destinationOrOutput === 'number') return $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, destinationOrOutput).disconnect();
        if ((0, $02572834e9cacc18$export$d647358384f164e0)(destinationOrOutput)) {
            if (output === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect(destinationOrOutput));
            if (input === undefined) return $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
            return $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0, input);
        }
        if (output === undefined) return outputAudioNodes.forEach((outputAudioNode)=>outputAudioNode.disconnect(destinationOrOutput));
        return $777f7939fea8f1ed$var$getOutputAudioNodeAtIndex(createIndexSizeError, outputAudioNodes, output).disconnect(destinationOrOutput, 0);
    };
};


const $84171167562b7343$var$DEFAULT_OPTIONS = {
    attack: 0.003,
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    knee: 30,
    ratio: 12,
    release: 0.25,
    threshold: -24
};
const $84171167562b7343$export$60ec6725c2d45fc8 = (audioNodeConstructor, createAudioParam, createDynamicsCompressorNodeRenderer, createNativeDynamicsCompressorNode, createNotSupportedError, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class DynamicsCompressorNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$84171167562b7343$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const dynamicsCompressorNodeRenderer = isOffline ? createDynamicsCompressorNodeRenderer() : null;
            super(context, false, nativeDynamicsCompressorNode, dynamicsCompressorNodeRenderer);
            this._attack = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.attack);
            this._knee = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.knee);
            this._nativeDynamicsCompressorNode = nativeDynamicsCompressorNode;
            this._ratio = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.ratio);
            this._release = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.release);
            this._threshold = createAudioParam(this, isOffline, nativeDynamicsCompressorNode.threshold);
            setAudioNodeTailTime(this, 0.006);
        }
        get attack() {
            return this._attack;
        }
        // Bug #108: Safari allows a channelCount of three and above which is why the getter and setter needs to be overwritten here.
        get channelCount() {
            return this._nativeDynamicsCompressorNode.channelCount;
        }
        set channelCount(value) {
            const previousChannelCount = this._nativeDynamicsCompressorNode.channelCount;
            this._nativeDynamicsCompressorNode.channelCount = value;
            if (value > 2) {
                this._nativeDynamicsCompressorNode.channelCount = previousChannelCount;
                throw createNotSupportedError();
            }
        }
        /*
         * Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max' yet which is why the getter and setter needs to be
         * overwritten here.
         */ get channelCountMode() {
            return this._nativeDynamicsCompressorNode.channelCountMode;
        }
        set channelCountMode(value) {
            const previousChannelCount = this._nativeDynamicsCompressorNode.channelCountMode;
            this._nativeDynamicsCompressorNode.channelCountMode = value;
            if (value === 'max') {
                this._nativeDynamicsCompressorNode.channelCountMode = previousChannelCount;
                throw createNotSupportedError();
            }
        }
        get knee() {
            return this._knee;
        }
        get ratio() {
            return this._ratio;
        }
        get reduction() {
            // Bug #111: Safari returns an AudioParam instead of a number.
            if (typeof this._nativeDynamicsCompressorNode.reduction.value === 'number') return this._nativeDynamicsCompressorNode.reduction.value;
            return this._nativeDynamicsCompressorNode.reduction;
        }
        get release() {
            return this._release;
        }
        get threshold() {
            return this._threshold;
        }
    };
};



const $c9213159046e81d8$export$1b1e82cc3f0a2c8 = (connectAudioParam, createNativeDynamicsCompressorNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeDynamicsCompressorNodes = new WeakMap();
        const createDynamicsCompressorNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeDynamicsCompressorNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeDynamicsCompressorNode was not constructed on the same OfflineAudioContext it needs to be
             * created again.
             */ const nativeDynamicsCompressorNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeDynamicsCompressorNode, nativeOfflineAudioContext);
            if (!nativeDynamicsCompressorNodeIsOwnedByContext) {
                const options = {
                    attack: nativeDynamicsCompressorNode.attack.value,
                    channelCount: nativeDynamicsCompressorNode.channelCount,
                    channelCountMode: nativeDynamicsCompressorNode.channelCountMode,
                    channelInterpretation: nativeDynamicsCompressorNode.channelInterpretation,
                    knee: nativeDynamicsCompressorNode.knee.value,
                    ratio: nativeDynamicsCompressorNode.ratio.value,
                    release: nativeDynamicsCompressorNode.release.value,
                    threshold: nativeDynamicsCompressorNode.threshold.value
                };
                nativeDynamicsCompressorNode = createNativeDynamicsCompressorNode(nativeOfflineAudioContext, options);
            }
            renderedNativeDynamicsCompressorNodes.set(nativeOfflineAudioContext, nativeDynamicsCompressorNode);
            if (!nativeDynamicsCompressorNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);
                await renderAutomation(nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);
                await renderAutomation(nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);
                await renderAutomation(nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);
                await renderAutomation(nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.attack, nativeDynamicsCompressorNode.attack);
                await connectAudioParam(nativeOfflineAudioContext, proxy.knee, nativeDynamicsCompressorNode.knee);
                await connectAudioParam(nativeOfflineAudioContext, proxy.ratio, nativeDynamicsCompressorNode.ratio);
                await connectAudioParam(nativeOfflineAudioContext, proxy.release, nativeDynamicsCompressorNode.release);
                await connectAudioParam(nativeOfflineAudioContext, proxy.threshold, nativeDynamicsCompressorNode.threshold);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeDynamicsCompressorNode);
            return nativeDynamicsCompressorNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeDynamicsCompressorNode = renderedNativeDynamicsCompressorNodes.get(nativeOfflineAudioContext);
                if (renderedNativeDynamicsCompressorNode !== undefined) return Promise.resolve(renderedNativeDynamicsCompressorNode);
                return createDynamicsCompressorNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $d2cc4ba64859d7eb$export$6372d3d9069bc778 = ()=>new DOMException('', 'EncodingError');


const $6d1c2f45ab543604$export$43b563d089dd1d8 = (window)=>{
    return (source)=>new Promise((resolve, reject)=>{
            if (window === null) {
                // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
                reject(new SyntaxError());
                return;
            }
            const head = window.document.head;
            if (head === null) // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
            reject(new SyntaxError());
            else {
                const script = window.document.createElement('script');
                // @todo Safari doesn't like URLs with a type of 'application/javascript; charset=utf-8'.
                const blob = new Blob([
                    source
                ], {
                    type: 'application/javascript'
                });
                const url = URL.createObjectURL(blob);
                const originalOnErrorHandler = window.onerror;
                const removeErrorEventListenerAndRevokeUrl = ()=>{
                    window.onerror = originalOnErrorHandler;
                    URL.revokeObjectURL(url);
                };
                window.onerror = (message, src, lineno, colno, error)=>{
                    // @todo Edge thinks the source is the one of the html document.
                    if (src === url || src === window.location.href && lineno === 1 && colno === 1) {
                        removeErrorEventListenerAndRevokeUrl();
                        reject(error);
                        return false;
                    }
                    if (originalOnErrorHandler !== null) return originalOnErrorHandler(message, src, lineno, colno, error);
                };
                script.onerror = ()=>{
                    removeErrorEventListenerAndRevokeUrl();
                    // Bug #182 Chrome and Edge do throw an instance of a SyntaxError instead of a DOMException.
                    reject(new SyntaxError());
                };
                script.onload = ()=>{
                    removeErrorEventListenerAndRevokeUrl();
                    resolve();
                };
                script.src = url;
                script.type = 'module';
                head.appendChild(script);
            }
        });
};


const $2c6595a0ef043725$export$a512af3fc2ab91f2 = (wrapEventListener)=>{
    return class EventTarget {
        constructor(_nativeEventTarget){
            this._nativeEventTarget = _nativeEventTarget;
            this._listeners = new WeakMap();
        }
        addEventListener(type, listener, options) {
            if (listener !== null) {
                let wrappedEventListener = this._listeners.get(listener);
                if (wrappedEventListener === undefined) {
                    wrappedEventListener = wrapEventListener(this, listener);
                    if (typeof listener === 'function') this._listeners.set(listener, wrappedEventListener);
                }
                this._nativeEventTarget.addEventListener(type, wrappedEventListener, options);
            }
        }
        dispatchEvent(event) {
            return this._nativeEventTarget.dispatchEvent(event);
        }
        removeEventListener(type, listener, options) {
            const wrappedEventListener = listener === null ? undefined : this._listeners.get(listener);
            this._nativeEventTarget.removeEventListener(type, wrappedEventListener === undefined ? null : wrappedEventListener, options);
        }
    };
};


const $a687388505de094d$export$c43b8ab5e8913cbb = (window)=>{
    return (currentTime, sampleRate, fn)=>{
        Object.defineProperties(window, {
            currentFrame: {
                configurable: true,
                get () {
                    return Math.round(currentTime * sampleRate);
                }
            },
            currentTime: {
                configurable: true,
                get () {
                    return currentTime;
                }
            }
        });
        try {
            return fn();
        } finally{
            if (window !== null) {
                delete window.currentFrame;
                delete window.currentTime;
            }
        }
    };
};


const $0835f0aafb89dee3$export$c7282a393375a8ca = (createAbortError)=>{
    return async (url)=>{
        try {
            const response = await fetch(url);
            if (response.ok) return [
                await response.text(),
                response.url
            ];
        } catch  {
        // Ignore errors.
        } // tslint:disable-line:no-empty
        throw createAbortError();
    };
};



const $98e2667480721d0b$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    gain: 1
};
const $98e2667480721d0b$export$7b37b693b55bf5d7 = (audioNodeConstructor, createAudioParam, createGainNodeRenderer, createNativeGainNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class GainNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$98e2667480721d0b$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeGainNode = createNativeGainNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const gainNodeRenderer = isOffline ? createGainNodeRenderer() : null;
            super(context, false, nativeGainNode, gainNodeRenderer);
            // Bug #74: Safari does not export the correct values for maxValue and minValue.
            this._gain = createAudioParam(this, isOffline, nativeGainNode.gain, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
        }
        get gain() {
            return this._gain;
        }
    };
};



const $49cb70513208922e$export$7312404e5bea9cd = (connectAudioParam, createNativeGainNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeGainNodes = new WeakMap();
        const createGainNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeGainNode = getNativeAudioNode(proxy);
            // If the initially used nativeGainNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeGainNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeGainNode, nativeOfflineAudioContext);
            if (!nativeGainNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeGainNode.channelCount,
                    channelCountMode: nativeGainNode.channelCountMode,
                    channelInterpretation: nativeGainNode.channelInterpretation,
                    gain: nativeGainNode.gain.value
                };
                nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, options);
            }
            renderedNativeGainNodes.set(nativeOfflineAudioContext, nativeGainNode);
            if (!nativeGainNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.gain, nativeGainNode.gain);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.gain, nativeGainNode.gain);
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeGainNode);
            return nativeGainNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeGainNode = renderedNativeGainNodes.get(nativeOfflineAudioContext);
                if (renderedNativeGainNode !== undefined) return Promise.resolve(renderedNativeGainNode);
                return createGainNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $987f4a38ab3c6a37$export$8b01844840684f8d = (activeAudioWorkletNodeInputsStore, getValueForKey)=>{
    return (nativeAudioWorkletNode)=>getValueForKey(activeAudioWorkletNodeInputsStore, nativeAudioWorkletNode);
};


const $177173849cab3696$export$97bb1acefff8970e = (getAudioNodeConnections)=>{
    return (audioNode)=>{
        const audioNodeConnections = getAudioNodeConnections(audioNode);
        if (audioNodeConnections.renderer === null) throw new Error('Missing the renderer of the given AudioNode in the audio graph.');
        return audioNodeConnections.renderer;
    };
};


const $1c502bf8d77347a3$export$4abc3abd061bc2cc = (audioNodeTailTimeStore)=>{
    return (audioNode)=>{
        var _a;
        return (_a = audioNodeTailTimeStore.get(audioNode)) !== null && _a !== void 0 ? _a : 0;
    };
};


const $3555b7973f69ce40$export$1653dd3e76bcb1b0 = (getAudioParamConnections)=>{
    return (audioParam)=>{
        const audioParamConnections = getAudioParamConnections(audioParam);
        if (audioParamConnections.renderer === null) throw new Error('Missing the renderer of the given AudioParam in the audio graph.');
        return audioParamConnections.renderer;
    };
};


const $27e05528439e83f2$export$afecf147821b5609 = (backupOfflineAudioContextStore)=>{
    return (nativeContext)=>{
        return backupOfflineAudioContextStore.get(nativeContext);
    };
};


const $c4ed5904220d24ef$export$5a1c4cd5830ea09b = ()=>new DOMException('', 'InvalidStateError');


const $ab34c55943f983a2$export$797a319a8065fb37 = (contextStore)=>{
    return (context)=>{
        const nativeContext = contextStore.get(context);
        if (nativeContext === undefined) throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
        return nativeContext;
    };
};


const $307a3ed6925bb7b6$export$70df0ae42e1340c8 = (backupOfflineAudioContextStore, nativeOfflineAudioContextConstructor)=>{
    return (nativeContext)=>{
        let backupOfflineAudioContext = backupOfflineAudioContextStore.get(nativeContext);
        if (backupOfflineAudioContext !== undefined) return backupOfflineAudioContext;
        if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        backupOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        backupOfflineAudioContextStore.set(nativeContext, backupOfflineAudioContext);
        return backupOfflineAudioContext;
    };
};


const $7674436fc406d726$export$43ef7eb1ae3d2f40 = (unrenderedAudioWorkletNodeStore)=>{
    return (nativeContext)=>{
        const unrenderedAudioWorkletNodes = unrenderedAudioWorkletNodeStore.get(nativeContext);
        if (unrenderedAudioWorkletNodes === undefined) throw new Error('The context has no set of AudioWorkletNodes.');
        return unrenderedAudioWorkletNodes;
    };
};


const $480811f16570294f$export$254c536c2ca9b917 = ()=>new DOMException('', 'InvalidAccessError');


const $35a124fa8f0bfed5$export$8170ec2d1debbbdd = (nativeIIRFilterNode)=>{
    nativeIIRFilterNode.getFrequencyResponse = ((getFrequencyResponse)=>{
        return (frequencyHz, magResponse, phaseResponse)=>{
            if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw (0, $480811f16570294f$export$254c536c2ca9b917)();
            return getFrequencyResponse.call(nativeIIRFilterNode, frequencyHz, magResponse, phaseResponse);
        };
    })(nativeIIRFilterNode.getFrequencyResponse);
};


const $d8dda65cffc64cac$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers'
};
const $d8dda65cffc64cac$export$a22f1eb785a05608 = (audioNodeConstructor, createNativeIIRFilterNode, createIIRFilterNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class IIRFilterNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const mergedOptions = {
                ...$d8dda65cffc64cac$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeIIRFilterNode = createNativeIIRFilterNode(nativeContext, isOffline ? null : context.baseLatency, mergedOptions);
            const iirFilterNodeRenderer = isOffline ? createIIRFilterNodeRenderer(mergedOptions.feedback, mergedOptions.feedforward) : null;
            super(context, false, nativeIIRFilterNode, iirFilterNodeRenderer);
            // Bug #23 & #24: FirefoxDeveloper does not throw an InvalidAccessError.
            // @todo Write a test which allows other browsers to remain unpatched.
            (0, $35a124fa8f0bfed5$export$8170ec2d1debbbdd)(nativeIIRFilterNode);
            this._nativeIIRFilterNode = nativeIIRFilterNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        getFrequencyResponse(frequencyHz, magResponse, phaseResponse) {
            return this._nativeIIRFilterNode.getFrequencyResponse(frequencyHz, magResponse, phaseResponse);
        }
    };
};


// This implementation as shamelessly inspired by source code of
// tslint:disable-next-line:max-line-length
// {@link https://chromium.googlesource.com/chromium/src.git/+/master/third_party/WebKit/Source/platform/audio/IIRFilter.cpp|Chromium's IIRFilter}.
const $753b6e2d7a61817d$export$7fa1177e7d2178dd = (feedback, feedbackLength, feedforward, feedforwardLength, minLength, xBuffer, yBuffer, bufferIndex, bufferLength, input, output)=>{
    const inputLength = input.length;
    let i = bufferIndex;
    for(let j = 0; j < inputLength; j += 1){
        let y = feedforward[0] * input[j];
        for(let k = 1; k < minLength; k += 1){
            const x = i - k & bufferLength - 1; // tslint:disable-line:no-bitwise
            y += feedforward[k] * xBuffer[x];
            y -= feedback[k] * yBuffer[x];
        }
        for(let k = minLength; k < feedforwardLength; k += 1)y += feedforward[k] * xBuffer[i - k & bufferLength - 1]; // tslint:disable-line:no-bitwise
        for(let k = minLength; k < feedbackLength; k += 1)y -= feedback[k] * yBuffer[i - k & bufferLength - 1]; // tslint:disable-line:no-bitwise
        xBuffer[i] = input[j];
        yBuffer[i] = y;
        i = i + 1 & bufferLength - 1; // tslint:disable-line:no-bitwise
        output[j] = y;
    }
    return i;
};



const $5f4b0a4e5f013c82$var$filterFullBuffer = (renderedBuffer, nativeOfflineAudioContext, feedback, feedforward)=>{
    const convertedFeedback = feedback instanceof Float64Array ? feedback : new Float64Array(feedback);
    const convertedFeedforward = feedforward instanceof Float64Array ? feedforward : new Float64Array(feedforward);
    const feedbackLength = convertedFeedback.length;
    const feedforwardLength = convertedFeedforward.length;
    const minLength = Math.min(feedbackLength, feedforwardLength);
    if (convertedFeedback[0] !== 1) {
        for(let i = 0; i < feedbackLength; i += 1)convertedFeedforward[i] /= convertedFeedback[0];
        for(let i = 1; i < feedforwardLength; i += 1)convertedFeedback[i] /= convertedFeedback[0];
    }
    const bufferLength = 32;
    const xBuffer = new Float32Array(bufferLength);
    const yBuffer = new Float32Array(bufferLength);
    const filteredBuffer = nativeOfflineAudioContext.createBuffer(renderedBuffer.numberOfChannels, renderedBuffer.length, renderedBuffer.sampleRate);
    const numberOfChannels = renderedBuffer.numberOfChannels;
    for(let i = 0; i < numberOfChannels; i += 1){
        const input = renderedBuffer.getChannelData(i);
        const output = filteredBuffer.getChannelData(i);
        xBuffer.fill(0);
        yBuffer.fill(0);
        (0, $753b6e2d7a61817d$export$7fa1177e7d2178dd)(convertedFeedback, feedbackLength, convertedFeedforward, feedforwardLength, minLength, xBuffer, yBuffer, 0, bufferLength, input, output);
    }
    return filteredBuffer;
};
const $5f4b0a4e5f013c82$export$329316f0ca6cf17e = (createNativeAudioBufferSourceNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return (feedback, feedforward)=>{
        const renderedNativeAudioNodes = new WeakMap();
        let filteredBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeAudioBufferSourceNode = null;
            let nativeIIRFilterNode = getNativeAudioNode(proxy);
            // If the initially used nativeIIRFilterNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeIIRFilterNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeIIRFilterNode, nativeOfflineAudioContext);
            // Bug #9: Safari does not support IIRFilterNodes.
            if (nativeOfflineAudioContext.createIIRFilter === undefined) nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeOfflineAudioContext, {
                buffer: null,
                channelCount: 2,
                channelCountMode: 'max',
                channelInterpretation: 'speakers',
                loop: false,
                loopEnd: 0,
                loopStart: 0,
                playbackRate: 1
            });
            else if (!nativeIIRFilterNodeIsOwnedByContext) // @todo TypeScript defines the parameters of createIIRFilter() as arrays of numbers.
            nativeIIRFilterNode = nativeOfflineAudioContext.createIIRFilter(feedforward, feedback);
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeAudioBufferSourceNode === null ? nativeIIRFilterNode : nativeAudioBufferSourceNode);
            if (nativeAudioBufferSourceNode !== null) {
                if (filteredBufferPromise === null) {
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(// Bug #47: The AudioDestinationNode in Safari gets not initialized correctly.
                    proxy.context.destination.channelCount, // Bug #17: Safari does not yet expose the length.
                    proxy.context.length, nativeOfflineAudioContext.sampleRate);
                    filteredBufferPromise = (async ()=>{
                        await renderInputsOfAudioNode(proxy, partialOfflineAudioContext, partialOfflineAudioContext.destination);
                        const renderedBuffer = await renderNativeOfflineAudioContext(partialOfflineAudioContext);
                        return $5f4b0a4e5f013c82$var$filterFullBuffer(renderedBuffer, nativeOfflineAudioContext, feedback, feedforward);
                    })();
                }
                const filteredBuffer = await filteredBufferPromise;
                nativeAudioBufferSourceNode.buffer = filteredBuffer;
                nativeAudioBufferSourceNode.start(0);
                return nativeAudioBufferSourceNode;
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeIIRFilterNode);
            return nativeIIRFilterNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeAudioNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeAudioNode !== undefined) return Promise.resolve(renderedNativeAudioNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};



const $f105592837a72b2d$export$e306a463e9286bbd = (cycleCounters, disconnectNativeAudioNodeFromNativeAudioNode, getAudioNodeConnections, getNativeAudioNode, getNativeAudioParam, isActiveAudioNode)=>{
    return (isOffline)=>{
        return (audioNode, count)=>{
            const cycleCounter = cycleCounters.get(audioNode);
            if (cycleCounter === undefined) {
                if (!isOffline && isActiveAudioNode(audioNode)) {
                    const nativeSourceAudioNode = getNativeAudioNode(audioNode);
                    const { outputs: outputs } = getAudioNodeConnections(audioNode);
                    for (const output of outputs)if ((0, $ea4b38b6f3ac443b$export$419d66ef3a96a878)(output)) {
                        const nativeDestinationAudioNode = getNativeAudioNode(output[0]);
                        disconnectNativeAudioNodeFromNativeAudioNode(nativeSourceAudioNode, nativeDestinationAudioNode, output[1], output[2]);
                    } else {
                        const nativeDestinationAudioParam = getNativeAudioParam(output[0]);
                        nativeSourceAudioNode.disconnect(nativeDestinationAudioParam, output[1]);
                    }
                }
                cycleCounters.set(audioNode, count);
            } else cycleCounters.set(audioNode, cycleCounter + count);
        };
    };
};





const $5640f46b23f2ba55$export$7030a6f3318876b = (contextStore, isNativeAudioContext)=>{
    return (anything)=>{
        const nativeContext = contextStore.get(anything);
        return isNativeAudioContext(nativeContext) || isNativeAudioContext(anything);
    };
};


const $a888bda59cc0dc6a$export$150a35c855945f9d = (audioNodeStore, isNativeAudioNode)=>{
    return (anything)=>audioNodeStore.has(anything) || isNativeAudioNode(anything);
};


const $e078436636c3eca1$export$41505fc8888255a0 = (audioParamStore, isNativeAudioParam)=>{
    return (anything)=>audioParamStore.has(anything) || isNativeAudioParam(anything);
};


const $3fc93d78c2927094$export$845691ce8ebc2907 = (contextStore, isNativeOfflineAudioContext)=>{
    return (anything)=>{
        const nativeContext = contextStore.get(anything);
        return isNativeOfflineAudioContext(nativeContext) || isNativeOfflineAudioContext(anything);
    };
};


const $5c37aa119fcb440b$export$5d44272df169092e = (nativeAudioContextConstructor)=>{
    return (anything)=>{
        return nativeAudioContextConstructor !== null && anything instanceof nativeAudioContextConstructor;
    };
};


const $3b617a30f7d7e286$export$96f2bb6e8a5795ea = (window)=>{
    return (anything)=>{
        return window !== null && typeof window.AudioNode === 'function' && anything instanceof window.AudioNode;
    };
};


const $3ef59b79efb5ffe7$export$7c3a44537acaf24e = (window)=>{
    return (anything)=>{
        return window !== null && typeof window.AudioParam === 'function' && anything instanceof window.AudioParam;
    };
};


const $c44d077ff851f0da$export$a7c969701e5471d0 = (isNativeAudioContext, isNativeOfflineAudioContext)=>{
    return (anything)=>{
        return isNativeAudioContext(anything) || isNativeOfflineAudioContext(anything);
    };
};


const $1f51870159fb4148$export$722bd4bab77df75a = (nativeOfflineAudioContextConstructor)=>{
    return (anything)=>{
        return nativeOfflineAudioContextConstructor !== null && anything instanceof nativeOfflineAudioContextConstructor;
    };
};


const $484b240e3f1f979d$export$2e9a7e6b17a9abae = (window)=>window !== null && window.isSecureContext;


const $c06e9ed236b03490$export$a245ecb43f54c4de = async (cacheTestResult, testAudioBufferCopyChannelMethodsSubarraySupport, testAudioContextCloseMethodSupport, testAudioContextDecodeAudioDataMethodTypeErrorSupport, testAudioContextOptionsSupport, testAudioNodeConnectMethodSupport, testAudioWorkletProcessorNoOutputsSupport, testChannelMergerNodeChannelCountSupport, testConstantSourceNodeAccurateSchedulingSupport, testConvolverNodeBufferReassignabilitySupport, testConvolverNodeChannelCountSupport, testDomExceptionContrucorSupport, testIsSecureContextSupport, testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport, testStereoPannerNodeDefaultValueSupport, testTransferablesSupport)=>{
    if (cacheTestResult(testAudioBufferCopyChannelMethodsSubarraySupport, testAudioBufferCopyChannelMethodsSubarraySupport) && cacheTestResult(testAudioContextCloseMethodSupport, testAudioContextCloseMethodSupport) && cacheTestResult(testAudioContextOptionsSupport, testAudioContextOptionsSupport) && cacheTestResult(testAudioNodeConnectMethodSupport, testAudioNodeConnectMethodSupport) && cacheTestResult(testChannelMergerNodeChannelCountSupport, testChannelMergerNodeChannelCountSupport) && cacheTestResult(testConstantSourceNodeAccurateSchedulingSupport, testConstantSourceNodeAccurateSchedulingSupport) && cacheTestResult(testConvolverNodeBufferReassignabilitySupport, testConvolverNodeBufferReassignabilitySupport) && cacheTestResult(testConvolverNodeChannelCountSupport, testConvolverNodeChannelCountSupport) && cacheTestResult(testDomExceptionContrucorSupport, testDomExceptionContrucorSupport) && cacheTestResult(testIsSecureContextSupport, testIsSecureContextSupport) && cacheTestResult(testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport, testMediaStreamAudioSourceNodeMediaStreamWithoutAudioTrackSupport)) {
        const results = await Promise.all([
            cacheTestResult(testAudioContextDecodeAudioDataMethodTypeErrorSupport, testAudioContextDecodeAudioDataMethodTypeErrorSupport),
            cacheTestResult(testAudioWorkletProcessorNoOutputsSupport, testAudioWorkletProcessorNoOutputsSupport),
            cacheTestResult(testStereoPannerNodeDefaultValueSupport, testStereoPannerNodeDefaultValueSupport),
            cacheTestResult(testTransferablesSupport, testTransferablesSupport)
        ]);
        return results.every((result)=>result);
    }
    return false;
};


const $5a5644b592df0bad$export$d24d3af0853fd021 = (audioNodeConstructor, createNativeMediaElementAudioSourceNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaElementAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaElementAudioSourceNode = createNativeMediaElementAudioSourceNode(nativeContext, options);
            // Bug #171: Safari allows to create a MediaElementAudioSourceNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw TypeError();
            super(context, true, nativeMediaElementAudioSourceNode, null);
            this._nativeMediaElementAudioSourceNode = nativeMediaElementAudioSourceNode;
        }
        get mediaElement() {
            return this._nativeMediaElementAudioSourceNode.mediaElement;
        }
    };
};


const $f377f0e28dbb751d$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'explicit',
    channelInterpretation: 'speakers'
};
const $f377f0e28dbb751d$export$5d3ee2470cd2874 = (audioNodeConstructor, createNativeMediaStreamAudioDestinationNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaStreamAudioDestinationNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            // Bug #173: Safari allows to create a MediaStreamAudioDestinationNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw new TypeError();
            const mergedOptions = {
                ...$f377f0e28dbb751d$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeMediaStreamAudioDestinationNode = createNativeMediaStreamAudioDestinationNode(nativeContext, mergedOptions);
            super(context, false, nativeMediaStreamAudioDestinationNode, null);
            this._nativeMediaStreamAudioDestinationNode = nativeMediaStreamAudioDestinationNode;
        }
        get stream() {
            return this._nativeMediaStreamAudioDestinationNode.stream;
        }
    };
};


const $304864b5ea02e52c$export$a42e10687df73a9d = (audioNodeConstructor, createNativeMediaStreamAudioSourceNode, getNativeContext, isNativeOfflineAudioContext)=>{
    return class MediaStreamAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaStreamAudioSourceNode = createNativeMediaStreamAudioSourceNode(nativeContext, options);
            // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.
            if (isNativeOfflineAudioContext(nativeContext)) throw new TypeError();
            super(context, true, nativeMediaStreamAudioSourceNode, null);
            this._nativeMediaStreamAudioSourceNode = nativeMediaStreamAudioSourceNode;
        }
        get mediaStream() {
            return this._nativeMediaStreamAudioSourceNode.mediaStream;
        }
    };
};


const $11b69ddc6f63f0f2$export$24f27d34fdf823bc = (audioNodeConstructor, createNativeMediaStreamTrackAudioSourceNode, getNativeContext)=>{
    return class MediaStreamTrackAudioSourceNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const nativeMediaStreamTrackAudioSourceNode = createNativeMediaStreamTrackAudioSourceNode(nativeContext, options);
            super(context, true, nativeMediaStreamTrackAudioSourceNode, null);
        }
    };
};




const $82d2d7cc0da6e790$export$8a5e66f668b2e9e8 = (createInvalidStateError, createNotSupportedError, createUnknownError, minimalBaseAudioContextConstructor, nativeAudioContextConstructor)=>{
    return class MinimalAudioContext extends minimalBaseAudioContextConstructor {
        constructor(options = {}){
            if (nativeAudioContextConstructor === null) throw new Error('Missing the native AudioContext constructor.');
            let nativeAudioContext;
            try {
                nativeAudioContext = new nativeAudioContextConstructor(options);
            } catch (err) {
                // Bug #192 Safari does throw a SyntaxError if the sampleRate is not supported.
                if (err.code === 12 && err.message === 'sampleRate is not in range') throw createNotSupportedError();
                throw err;
            }
            // Bug #131 Safari returns null when there are four other AudioContexts running already.
            if (nativeAudioContext === null) throw createUnknownError();
            // Bug #51 Only Chrome and Edge throw an error if the given latencyHint is invalid.
            if (!(0, $0cefff6266c0f0f4$export$82d5f0e102842fbe)(options.latencyHint)) throw new TypeError(`The provided value '${options.latencyHint}' is not a valid enum value of type AudioContextLatencyCategory.`);
            // Bug #150 Safari does not support setting the sampleRate.
            if (options.sampleRate !== undefined && nativeAudioContext.sampleRate !== options.sampleRate) throw createNotSupportedError();
            super(nativeAudioContext, 2);
            const { latencyHint: latencyHint } = options;
            const { sampleRate: sampleRate } = nativeAudioContext;
            // @todo The values for 'balanced', 'interactive' and 'playback' are just copied from Chrome's implementation.
            this._baseLatency = typeof nativeAudioContext.baseLatency === 'number' ? nativeAudioContext.baseLatency : latencyHint === 'balanced' ? 512 / sampleRate : latencyHint === 'interactive' || latencyHint === undefined ? 256 / sampleRate : latencyHint === 'playback' ? 1024 / sampleRate : /*
                                   * @todo The min (256) and max (16384) values are taken from the allowed bufferSize values of a
                                   * ScriptProcessorNode.
                                   */ Math.max(2, Math.min(128, Math.round(latencyHint * sampleRate / 128))) * 128 / sampleRate;
            this._nativeAudioContext = nativeAudioContext;
            // Bug #188: Safari will set the context's state to 'interrupted' in case the user switches tabs.
            if (nativeAudioContextConstructor.name === 'webkitAudioContext') {
                this._nativeGainNode = nativeAudioContext.createGain();
                this._nativeOscillatorNode = nativeAudioContext.createOscillator();
                this._nativeGainNode.gain.value = 1e-37;
                this._nativeOscillatorNode.connect(this._nativeGainNode).connect(nativeAudioContext.destination);
                this._nativeOscillatorNode.start();
            } else {
                this._nativeGainNode = null;
                this._nativeOscillatorNode = null;
            }
            this._state = null;
            /*
             * Bug #34: Chrome and Edge pretend to be running right away, but fire an onstatechange event when the state actually changes
             * to 'running'.
             */ if (nativeAudioContext.state === 'running') {
                this._state = 'suspended';
                const revokeState = ()=>{
                    if (this._state === 'suspended') this._state = null;
                    nativeAudioContext.removeEventListener('statechange', revokeState);
                };
                nativeAudioContext.addEventListener('statechange', revokeState);
            }
        }
        get baseLatency() {
            return this._baseLatency;
        }
        get state() {
            return this._state !== null ? this._state : this._nativeAudioContext.state;
        }
        close() {
            // Bug #35: Firefox does not throw an error if the AudioContext was closed before.
            if (this.state === 'closed') return this._nativeAudioContext.close().then(()=>{
                throw createInvalidStateError();
            });
            // Bug #34: If the state was set to suspended before it should be revoked now.
            if (this._state === 'suspended') this._state = null;
            return this._nativeAudioContext.close().then(()=>{
                if (this._nativeGainNode !== null && this._nativeOscillatorNode !== null) {
                    this._nativeOscillatorNode.stop();
                    this._nativeGainNode.disconnect();
                    this._nativeOscillatorNode.disconnect();
                }
                (0, $6d385241f7fab45a$export$cbd606bc629ea938)(this);
            });
        }
        resume() {
            if (this._state === 'suspended') return new Promise((resolve, reject)=>{
                const resolvePromise = ()=>{
                    this._nativeAudioContext.removeEventListener('statechange', resolvePromise);
                    if (this._nativeAudioContext.state === 'running') resolve();
                    else this.resume().then(resolve, reject);
                };
                this._nativeAudioContext.addEventListener('statechange', resolvePromise);
            });
            return this._nativeAudioContext.resume().catch((err)=>{
                // Bug #55: Chrome and Edge do throw an InvalidAccessError instead of an InvalidStateError.
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined || err.code === 15) throw createInvalidStateError();
                throw err;
            });
        }
        suspend() {
            return this._nativeAudioContext.suspend().catch((err)=>{
                // Bug #56: Safari invokes the catch handler but without an error.
                if (err === undefined) throw createInvalidStateError();
                throw err;
            });
        }
    };
};



const $487edb0432cdd783$export$3f49d9c870ba2692 = (audioDestinationNodeConstructor, createAudioListener, eventTargetConstructor, isNativeOfflineAudioContext, unrenderedAudioWorkletNodeStore, wrapEventListener)=>{
    return class MinimalBaseAudioContext extends eventTargetConstructor {
        constructor(_nativeContext, numberOfChannels){
            super(_nativeContext);
            this._nativeContext = _nativeContext;
            (0, $7718e734b2fef711$export$7d17302229276f06).set(this, _nativeContext);
            if (isNativeOfflineAudioContext(_nativeContext)) unrenderedAudioWorkletNodeStore.set(_nativeContext, new Set());
            this._destination = new audioDestinationNodeConstructor(this, numberOfChannels);
            this._listener = createAudioListener(this, _nativeContext);
            this._onstatechange = null;
        }
        get currentTime() {
            return this._nativeContext.currentTime;
        }
        get destination() {
            return this._destination;
        }
        get listener() {
            return this._listener;
        }
        get onstatechange() {
            return this._onstatechange;
        }
        set onstatechange(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeContext.onstatechange = wrappedListener;
            const nativeOnStateChange = this._nativeContext.onstatechange;
            this._onstatechange = nativeOnStateChange !== null && nativeOnStateChange === wrappedListener ? value : nativeOnStateChange;
        }
        get sampleRate() {
            return this._nativeContext.sampleRate;
        }
        get state() {
            return this._nativeContext.state;
        }
    };
};



const $4590a073dac74a1e$export$9ec44223b1284cd4 = (nativeContext)=>{
    // This 12 numbers represent the 48 bytes of an empty WAVE file with a single sample.
    const uint32Array = new Uint32Array([
        1179011410,
        40,
        1163280727,
        544501094,
        16,
        131073,
        44100,
        176400,
        1048580,
        1635017060,
        4,
        0
    ]);
    try {
        // Bug #1: Safari requires a successCallback.
        const promise = nativeContext.decodeAudioData(uint32Array.buffer, ()=>{
        // Ignore the success callback.
        });
        if (promise === undefined) return false;
        promise.catch(()=>{
        // Ignore rejected errors.
        });
        return true;
    } catch  {
    // Ignore errors.
    }
    return false;
};


const $c34e943c39218d26$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $c34e943c39218d26$export$3d487af37fe7f521 = (cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, minimalBaseAudioContextConstructor, startRendering)=>{
    return class MinimalOfflineAudioContext extends minimalBaseAudioContextConstructor {
        constructor(options){
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$c34e943c39218d26$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
            // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
            if (!cacheTestResult((0, $4590a073dac74a1e$export$9ec44223b1284cd4), ()=>(0, $4590a073dac74a1e$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) nativeOfflineAudioContext.addEventListener('statechange', (()=>{
                let i = 0;
                const delayStateChangeEvent = (event)=>{
                    if (this._state === 'running') {
                        if (i > 0) {
                            nativeOfflineAudioContext.removeEventListener('statechange', delayStateChangeEvent);
                            event.stopImmediatePropagation();
                            this._waitForThePromiseToSettle(event);
                        } else i += 1;
                    }
                };
                return delayStateChangeEvent;
            })());
            super(nativeOfflineAudioContext, numberOfChannels);
            this._length = length;
            this._nativeOfflineAudioContext = nativeOfflineAudioContext;
            this._state = null;
        }
        get length() {
            // Bug #17: Safari does not yet expose the length.
            if (this._nativeOfflineAudioContext.length === undefined) return this._length;
            return this._nativeOfflineAudioContext.length;
        }
        get state() {
            return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
        }
        startRendering() {
            /*
             * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
             * the state of the nativeOfflineAudioContext might no transition to running immediately.
             */ if (this._state === 'running') return Promise.reject(createInvalidStateError());
            this._state = 'running';
            return startRendering(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                this._state = null;
                (0, $6d385241f7fab45a$export$cbd606bc629ea938)(this);
            });
        }
        _waitForThePromiseToSettle(event) {
            if (this._state === null) this._nativeOfflineAudioContext.dispatchEvent(event);
            else setTimeout(()=>this._waitForThePromiseToSettle(event));
        }
    };
};


const $0c25af19b608275a$export$9f33b5a0b80f2717 = (insertElementInSet, isNativeAudioNode)=>{
    return (nativeAudioNode, whenConnected, whenDisconnected)=>{
        const connections = new Set();
        nativeAudioNode.connect = ((connect)=>{
            // tslint:disable-next-line:invalid-void no-inferrable-types
            return (destination, output = 0, input = 0)=>{
                const wasDisconnected = connections.size === 0;
                if (isNativeAudioNode(destination)) {
                    // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
                    connect.call(nativeAudioNode, destination, output, input);
                    insertElementInSet(connections, [
                        destination,
                        output,
                        input
                    ], (connection)=>connection[0] === destination && connection[1] === output && connection[2] === input, true);
                    if (wasDisconnected) whenConnected();
                    return destination;
                }
                connect.call(nativeAudioNode, destination, output);
                insertElementInSet(connections, [
                    destination,
                    output
                ], (connection)=>connection[0] === destination && connection[1] === output, true);
                if (wasDisconnected) whenConnected();
                return;
            };
        })(nativeAudioNode.connect);
        nativeAudioNode.disconnect = ((disconnect)=>{
            return (destinationOrOutput, output, input)=>{
                const wasConnected = connections.size > 0;
                if (destinationOrOutput === undefined) {
                    disconnect.apply(nativeAudioNode);
                    connections.clear();
                } else if (typeof destinationOrOutput === 'number') {
                    // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput);
                    for (const connection of connections)if (connection[1] === destinationOrOutput) connections.delete(connection);
                } else {
                    if (isNativeAudioNode(destinationOrOutput)) // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput, output, input);
                    else // @todo TypeScript cannot infer the overloaded signature with 2 arguments yet.
                    disconnect.call(nativeAudioNode, destinationOrOutput, output);
                    for (const connection of connections)if (connection[0] === destinationOrOutput && (output === undefined || connection[1] === output) && (input === undefined || connection[2] === input)) connections.delete(connection);
                }
                const isDisconnected = connections.size === 0;
                if (wasConnected && isDisconnected) whenDisconnected();
            };
        })(nativeAudioNode.disconnect);
        return nativeAudioNode;
    };
};


const $5eef3820deef0b72$export$26855c8d5a8f5839 = (nativeAudioNode, options, option)=>{
    const value = options[option];
    if (value !== undefined && value !== nativeAudioNode[option]) nativeAudioNode[option] = value;
};



const $acf0ae0814028a1b$export$a741a487b656b6ff = (nativeAudioNode, options)=>{
    (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioNode, options, 'channelCount');
    (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioNode, options, 'channelCountMode');
    (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioNode, options, 'channelInterpretation');
};


const $ed9d2653a13b0c96$export$1cb15f891b4f5e5e = (nativeAnalyserNode)=>{
    return typeof nativeAnalyserNode.getFloatTimeDomainData === 'function';
};


const $9bda2230e35c9ca6$export$df32660d042dab2e = (nativeAnalyserNode)=>{
    nativeAnalyserNode.getFloatTimeDomainData = (array)=>{
        const byteTimeDomainData = new Uint8Array(array.length);
        nativeAnalyserNode.getByteTimeDomainData(byteTimeDomainData);
        const length = Math.max(byteTimeDomainData.length, nativeAnalyserNode.fftSize);
        for(let i = 0; i < length; i += 1)array[i] = (byteTimeDomainData[i] - 128) * 0.0078125;
        return array;
    };
};


const $e8efe05ceea76e6b$export$36e704ad7c903a26 = (cacheTestResult, createIndexSizeError)=>{
    return (nativeContext, options)=>{
        const nativeAnalyserNode = nativeContext.createAnalyser();
        // Bug #37: Firefox does not create an AnalyserNode with the default properties.
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeAnalyserNode, options);
        // Bug #118: Safari does not throw an error if maxDecibels is not more than minDecibels.
        if (!(options.maxDecibels > options.minDecibels)) throw createIndexSizeError();
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAnalyserNode, options, 'fftSize');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAnalyserNode, options, 'maxDecibels');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAnalyserNode, options, 'minDecibels');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAnalyserNode, options, 'smoothingTimeConstant');
        // Bug #36: Safari does not support getFloatTimeDomainData() yet.
        if (!cacheTestResult((0, $ed9d2653a13b0c96$export$1cb15f891b4f5e5e), ()=>(0, $ed9d2653a13b0c96$export$1cb15f891b4f5e5e)(nativeAnalyserNode))) (0, $9bda2230e35c9ca6$export$df32660d042dab2e)(nativeAnalyserNode);
        return nativeAnalyserNode;
    };
};


const $3fdc510d024142a6$export$1ddb6a79e564be96 = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('AudioBuffer')) return window.AudioBuffer;
    return null;
};


const $ae111b58c598e4e4$export$4778de978774ec4f = (nativeAudioNode, options, audioParam)=>{
    const value = options[audioParam];
    if (value !== undefined && value !== nativeAudioNode[audioParam].value) nativeAudioNode[audioParam].value = value;
};





const $6ca747e8d28a6d93$export$6b4321a414ed55c5 = (nativeAudioBufferSourceNode)=>{
    nativeAudioBufferSourceNode.start = ((start)=>{
        let isScheduled = false;
        return (when = 0, offset = 0, duration)=>{
            if (isScheduled) throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
            start.call(nativeAudioBufferSourceNode, when, offset, duration);
            isScheduled = true;
        };
    })(nativeAudioBufferSourceNode.start);
};


const $e3342623b0c84b77$export$987b3a4087e6578c = (nativeAudioScheduledSourceNode)=>{
    nativeAudioScheduledSourceNode.start = ((start)=>{
        return (when = 0, offset = 0, duration)=>{
            if (typeof duration === 'number' && duration < 0 || offset < 0 || when < 0) throw new RangeError("The parameters can't be negative.");
            // @todo TypeScript cannot infer the overloaded signature with 3 arguments yet.
            start.call(nativeAudioScheduledSourceNode, when, offset, duration);
        };
    })(nativeAudioScheduledSourceNode.start);
};


const $ecb767d214ace196$export$7adf5b1e83aad45 = (nativeAudioScheduledSourceNode)=>{
    nativeAudioScheduledSourceNode.stop = ((stop)=>{
        return (when = 0)=>{
            if (when < 0) throw new RangeError("The parameter can't be negative.");
            stop.call(nativeAudioScheduledSourceNode, when);
        };
    })(nativeAudioScheduledSourceNode.stop);
};


const $fed0da5959484c32$export$4f48c993f264b207 = (addSilentConnection, cacheTestResult, testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, testAudioBufferSourceNodeStartMethodOffsetClampingSupport, testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioBufferSourceNodeStartMethodOffsetClampling, wrapAudioBufferSourceNodeStopMethodNullifiedBuffer, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls)=>{
    return (nativeContext, options)=>{
        const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeAudioBufferSourceNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeAudioBufferSourceNode, options, 'playbackRate');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, 'buffer');
        // Bug #149: Safari does not yet support the detune AudioParam.
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, 'loop');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, 'loopEnd');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeAudioBufferSourceNode, options, 'loopStart');
        // Bug #69: Safari does allow calls to start() of an already scheduled AudioBufferSourceNode.
        if (!cacheTestResult(testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport, ()=>testAudioBufferSourceNodeStartMethodConsecutiveCallsSupport(nativeContext))) (0, $6ca747e8d28a6d93$export$6b4321a414ed55c5)(nativeAudioBufferSourceNode);
        // Bug #154 & #155: Safari does not handle offsets which are equal to or greater than the duration of the buffer.
        if (!cacheTestResult(testAudioBufferSourceNodeStartMethodOffsetClampingSupport, ()=>testAudioBufferSourceNodeStartMethodOffsetClampingSupport(nativeContext))) wrapAudioBufferSourceNodeStartMethodOffsetClampling(nativeAudioBufferSourceNode);
        // Bug #162: Safari does throw an error when stop() is called on an AudioBufferSourceNode which has no buffer assigned to it.
        if (!cacheTestResult(testAudioBufferSourceNodeStopMethodNullifiedBufferSupport, ()=>testAudioBufferSourceNodeStopMethodNullifiedBufferSupport(nativeContext))) wrapAudioBufferSourceNodeStopMethodNullifiedBuffer(nativeAudioBufferSourceNode, nativeContext);
        // Bug #44: Safari does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $e3342623b0c84b77$export$987b3a4087e6578c)(nativeAudioBufferSourceNode);
        // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, ()=>testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeAudioBufferSourceNode, nativeContext);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $ecb767d214ace196$export$7adf5b1e83aad45)(nativeAudioBufferSourceNode);
        // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.
        addSilentConnection(nativeContext, nativeAudioBufferSourceNode);
        return nativeAudioBufferSourceNode;
    };
};


const $efc1676639ecd3f0$export$3a22fc4046f7b4ec = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('AudioContext')) return window.AudioContext;
    return window.hasOwnProperty('webkitAudioContext') ? window.webkitAudioContext : null;
};


const $a12f35f127b69772$export$d3097038f258fce = (createNativeGainNode, overwriteAccessors)=>{
    return (nativeContext, channelCount, isNodeOfNativeOfflineAudioContext)=>{
        const nativeAudioDestinationNode = nativeContext.destination;
        // Bug #132: Safari does not have the correct channelCount.
        if (nativeAudioDestinationNode.channelCount !== channelCount) try {
            nativeAudioDestinationNode.channelCount = channelCount;
        } catch  {
        // Bug #169: Safari throws an error on each attempt to change the channelCount.
        }
        // Bug #83: Safari does not have the correct channelCountMode.
        if (isNodeOfNativeOfflineAudioContext && nativeAudioDestinationNode.channelCountMode !== 'explicit') nativeAudioDestinationNode.channelCountMode = 'explicit';
        // Bug #47: The AudioDestinationNode in Safari does not initialize the maxChannelCount property correctly.
        if (nativeAudioDestinationNode.maxChannelCount === 0) Object.defineProperty(nativeAudioDestinationNode, 'maxChannelCount', {
            value: channelCount
        });
        // Bug #168: No browser does yet have an AudioDestinationNode with an output.
        const gainNode = createNativeGainNode(nativeContext, {
            channelCount: channelCount,
            channelCountMode: nativeAudioDestinationNode.channelCountMode,
            channelInterpretation: nativeAudioDestinationNode.channelInterpretation,
            gain: 1
        });
        overwriteAccessors(gainNode, 'channelCount', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                try {
                    nativeAudioDestinationNode.channelCount = value;
                } catch (err) {
                    // Bug #169: Safari throws an error on each attempt to change the channelCount.
                    if (value > nativeAudioDestinationNode.maxChannelCount) throw err;
                }
            });
        overwriteAccessors(gainNode, 'channelCountMode', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                nativeAudioDestinationNode.channelCountMode = value;
            });
        overwriteAccessors(gainNode, 'channelInterpretation', (get)=>()=>get.call(gainNode), (set)=>(value)=>{
                set.call(gainNode, value);
                nativeAudioDestinationNode.channelInterpretation = value;
            });
        Object.defineProperty(gainNode, 'maxChannelCount', {
            get: ()=>nativeAudioDestinationNode.maxChannelCount
        });
        // @todo This should be disconnected when the context is closed.
        gainNode.connect(nativeAudioDestinationNode);
        return gainNode;
    };
};


const $8a58495112d71adf$export$b0ef4818c07d1453 = (window)=>{
    if (window === null) return null;
    return window.hasOwnProperty('AudioWorkletNode') ? window.AudioWorkletNode : null;
};


const $6cddc0f2f0dd9ae1$export$8bad4bda0c154746 = (audioWorkletNodeOptions)=>{
    const { port1: port1 } = new MessageChannel();
    try {
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port1.postMessage(audioWorkletNodeOptions);
    } finally{
        port1.close();
    }
};


const $81c404ba25d71de5$export$a6399b47836cd044 = (createInvalidStateError, createNativeAudioWorkletNodeFaker, createNativeGainNode, createNotSupportedError, monitorConnections)=>{
    return (nativeContext, baseLatency, nativeAudioWorkletNodeConstructor, name, processorConstructor, options)=>{
        if (nativeAudioWorkletNodeConstructor !== null) try {
            const nativeAudioWorkletNode = new nativeAudioWorkletNodeConstructor(nativeContext, name, options);
            const patchedEventListeners = new Map();
            let onprocessorerror = null;
            Object.defineProperties(nativeAudioWorkletNode, {
                /*
                     * Bug #61: Overwriting the property accessors for channelCount and channelCountMode is necessary as long as some
                     * browsers have no native implementation to achieve a consistent behavior.
                     */ channelCount: {
                    get: ()=>options.channelCount,
                    set: ()=>{
                        throw createInvalidStateError();
                    }
                },
                channelCountMode: {
                    get: ()=>'explicit',
                    set: ()=>{
                        throw createInvalidStateError();
                    }
                },
                // Bug #156: Chrome and Edge do not yet fire an ErrorEvent.
                onprocessorerror: {
                    get: ()=>onprocessorerror,
                    set: (value)=>{
                        if (typeof onprocessorerror === 'function') nativeAudioWorkletNode.removeEventListener('processorerror', onprocessorerror);
                        onprocessorerror = typeof value === 'function' ? value : null;
                        if (typeof onprocessorerror === 'function') nativeAudioWorkletNode.addEventListener('processorerror', onprocessorerror);
                    }
                }
            });
            nativeAudioWorkletNode.addEventListener = ((addEventListener)=>{
                return (...args)=>{
                    if (args[0] === 'processorerror') {
                        const unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;
                        if (unpatchedEventListener !== null) {
                            const patchedEventListener = patchedEventListeners.get(args[1]);
                            if (patchedEventListener !== undefined) args[1] = patchedEventListener;
                            else {
                                args[1] = (event)=>{
                                    // Bug #178: Chrome and Edge do fire an event of type error.
                                    if (event.type === 'error') {
                                        Object.defineProperties(event, {
                                            type: {
                                                value: 'processorerror'
                                            }
                                        });
                                        unpatchedEventListener(event);
                                    } else unpatchedEventListener(new ErrorEvent(args[0], {
                                        ...event
                                    }));
                                };
                                patchedEventListeners.set(unpatchedEventListener, args[1]);
                            }
                        }
                    }
                    // Bug #178: Chrome and Edge do fire an event of type error.
                    addEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
                    return addEventListener.call(nativeAudioWorkletNode, ...args);
                };
            })(nativeAudioWorkletNode.addEventListener);
            nativeAudioWorkletNode.removeEventListener = ((removeEventListener)=>{
                return (...args)=>{
                    if (args[0] === 'processorerror') {
                        const patchedEventListener = patchedEventListeners.get(args[1]);
                        if (patchedEventListener !== undefined) {
                            patchedEventListeners.delete(args[1]);
                            args[1] = patchedEventListener;
                        }
                    }
                    // Bug #178: Chrome and Edge do fire an event of type error.
                    removeEventListener.call(nativeAudioWorkletNode, 'error', args[1], args[2]);
                    return removeEventListener.call(nativeAudioWorkletNode, args[0], args[1], args[2]);
                };
            })(nativeAudioWorkletNode.removeEventListener);
            /*
                 * Bug #86: Chrome and Edge do not invoke the process() function if the corresponding AudioWorkletNode is unconnected but
                 * has an output.
                 */ if (options.numberOfOutputs !== 0) {
                const nativeGainNode = createNativeGainNode(nativeContext, {
                    channelCount: 1,
                    channelCountMode: 'explicit',
                    channelInterpretation: 'discrete',
                    gain: 0
                });
                nativeAudioWorkletNode.connect(nativeGainNode).connect(nativeContext.destination);
                const whenConnected = ()=>nativeGainNode.disconnect();
                const whenDisconnected = ()=>nativeGainNode.connect(nativeContext.destination);
                // @todo Disconnect the connection when the process() function of the AudioWorkletNode returns false.
                return monitorConnections(nativeAudioWorkletNode, whenConnected, whenDisconnected);
            }
            return nativeAudioWorkletNode;
        } catch (err) {
            // Bug #60: Chrome & Edge throw an InvalidStateError instead of a NotSupportedError.
            if (err.code === 11) throw createNotSupportedError();
            throw err;
        }
        // Bug #61: Only Chrome & Edge have an implementation of the AudioWorkletNode yet.
        if (processorConstructor === undefined) throw createNotSupportedError();
        (0, $6cddc0f2f0dd9ae1$export$8bad4bda0c154746)(options);
        return createNativeAudioWorkletNodeFaker(nativeContext, baseLatency, processorConstructor, options);
    };
};



const $0470d07e32bfb928$export$c3c4ba87244c2bf4 = (baseLatency, sampleRate)=>{
    if (baseLatency === null) return 512;
    return Math.max(512, Math.min(16384, Math.pow(2, Math.round(Math.log2(baseLatency * sampleRate)))));
};





const $d3f33c86ba7c9d01$export$45f6aa3433a4eb0 = (audioWorkletNodeOptions)=>{
    return new Promise((resolve, reject)=>{
        const { port1: port1, port2: port2 } = new MessageChannel();
        port1.onmessage = ({ data: data })=>{
            port1.close();
            port2.close();
            resolve(data);
        };
        port1.onmessageerror = ({ data: data })=>{
            port1.close();
            port2.close();
            reject(data);
        };
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port2.postMessage(audioWorkletNodeOptions);
    });
};


const $5c252bbd462fc1fc$export$62410a657c3adf1d = async (processorConstructor, audioWorkletNodeOptions)=>{
    const clonedAudioWorkletNodeOptions = await (0, $d3f33c86ba7c9d01$export$45f6aa3433a4eb0)(audioWorkletNodeOptions);
    return new processorConstructor(clonedAudioWorkletNodeOptions);
};


const $b8276153f51079e2$export$5200a42feb14a7b7 = (nativeContext, nativeAudioWorkletNode, processorConstructor, audioWorkletNodeOptions)=>{
    let nodeToProcessorMap = (0, $7718e734b2fef711$export$16d7878f7e059d67).get(nativeContext);
    if (nodeToProcessorMap === undefined) {
        nodeToProcessorMap = new WeakMap();
        (0, $7718e734b2fef711$export$16d7878f7e059d67).set(nativeContext, nodeToProcessorMap);
    }
    const audioWorkletProcessorPromise = (0, $5c252bbd462fc1fc$export$62410a657c3adf1d)(processorConstructor, audioWorkletNodeOptions);
    nodeToProcessorMap.set(nativeAudioWorkletNode, audioWorkletProcessorPromise);
    return audioWorkletProcessorPromise;
};




const $d96ad3d348a8f882$export$ea40f9f600f0adcb = (connectMultipleOutputs, createIndexSizeError, createInvalidStateError, createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeConstantSourceNode, createNativeGainNode, createNativeScriptProcessorNode, createNotSupportedError, disconnectMultipleOutputs, exposeCurrentFrameAndCurrentTime, getActiveAudioWorkletNodeInputs, monitorConnections)=>{
    return (nativeContext, baseLatency, processorConstructor, options)=>{
        if (options.numberOfInputs === 0 && options.numberOfOutputs === 0) throw createNotSupportedError();
        const outputChannelCount = Array.isArray(options.outputChannelCount) ? options.outputChannelCount : Array.from(options.outputChannelCount);
        // @todo Check if any of the channelCount values is greater than the implementation's maximum number of channels.
        if (outputChannelCount.some((channelCount)=>channelCount < 1)) throw createNotSupportedError();
        if (outputChannelCount.length !== options.numberOfOutputs) throw createIndexSizeError();
        // Bug #61: This is not part of the standard but required for the faker to work.
        if (options.channelCountMode !== 'explicit') throw createNotSupportedError();
        const numberOfInputChannels = options.channelCount * options.numberOfInputs;
        const numberOfOutputChannels = outputChannelCount.reduce((sum, value1)=>sum + value1, 0);
        const numberOfParameters = processorConstructor.parameterDescriptors === undefined ? 0 : processorConstructor.parameterDescriptors.length;
        // Bug #61: This is not part of the standard but required for the faker to work.
        if (numberOfInputChannels + numberOfParameters > 6 || numberOfOutputChannels > 6) throw createNotSupportedError();
        const messageChannel = new MessageChannel();
        const gainNodes = [];
        const inputChannelSplitterNodes = [];
        for(let i = 0; i < options.numberOfInputs; i += 1){
            gainNodes.push(createNativeGainNode(nativeContext, {
                channelCount: options.channelCount,
                channelCountMode: options.channelCountMode,
                channelInterpretation: options.channelInterpretation,
                gain: 1
            }));
            inputChannelSplitterNodes.push(createNativeChannelSplitterNode(nativeContext, {
                channelCount: options.channelCount,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                numberOfOutputs: options.channelCount
            }));
        }
        const constantSourceNodes = [];
        if (processorConstructor.parameterDescriptors !== undefined) for (const { defaultValue: defaultValue, maxValue: maxValue, minValue: minValue, name: name } of processorConstructor.parameterDescriptors){
            const constantSourceNode = createNativeConstantSourceNode(nativeContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                offset: options.parameterData[name] !== undefined ? options.parameterData[name] : defaultValue === undefined ? 0 : defaultValue
            });
            Object.defineProperties(constantSourceNode.offset, {
                defaultValue: {
                    get: ()=>defaultValue === undefined ? 0 : defaultValue
                },
                maxValue: {
                    get: ()=>maxValue === undefined ? (0, $c205d95559d496ba$export$ab43bedd17d6a167) : maxValue
                },
                minValue: {
                    get: ()=>minValue === undefined ? (0, $c205d95559d496ba$export$ced6a5c63b103b52) : minValue
                }
            });
            constantSourceNodes.push(constantSourceNode);
        }
        const inputChannelMergerNode = createNativeChannelMergerNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'speakers',
            numberOfInputs: Math.max(1, numberOfInputChannels + numberOfParameters)
        });
        const bufferSize = (0, $0470d07e32bfb928$export$c3c4ba87244c2bf4)(baseLatency, nativeContext.sampleRate);
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, numberOfInputChannels + numberOfParameters, // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
        Math.max(1, numberOfOutputChannels));
        const outputChannelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
            channelCount: Math.max(1, numberOfOutputChannels),
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            numberOfOutputs: Math.max(1, numberOfOutputChannels)
        });
        const outputChannelMergerNodes = [];
        for(let i = 0; i < options.numberOfOutputs; i += 1)outputChannelMergerNodes.push(createNativeChannelMergerNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'speakers',
            numberOfInputs: outputChannelCount[i]
        }));
        for(let i = 0; i < options.numberOfInputs; i += 1){
            gainNodes[i].connect(inputChannelSplitterNodes[i]);
            for(let j = 0; j < options.channelCount; j += 1)inputChannelSplitterNodes[i].connect(inputChannelMergerNode, j, i * options.channelCount + j);
        }
        const parameterMap = new (0, $cb5c13986ebfa770$export$5da0cf80a3ca75d6)(processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.map(({ name: name }, index)=>{
            const constantSourceNode = constantSourceNodes[index];
            constantSourceNode.connect(inputChannelMergerNode, 0, numberOfInputChannels + index);
            constantSourceNode.start(0);
            return [
                name,
                constantSourceNode.offset
            ];
        }));
        inputChannelMergerNode.connect(scriptProcessorNode);
        let channelInterpretation = options.channelInterpretation;
        let onprocessorerror = null;
        // Bug #87: Expose at least one output to make this node connectable.
        const outputAudioNodes = options.numberOfOutputs === 0 ? [
            scriptProcessorNode
        ] : outputChannelMergerNodes;
        const nativeAudioWorkletNodeFaker = {
            get bufferSize () {
                return bufferSize;
            },
            get channelCount () {
                return options.channelCount;
            },
            set channelCount (_){
                // Bug #61: This is not part of the standard but required for the faker to work.
                throw createInvalidStateError();
            },
            get channelCountMode () {
                return options.channelCountMode;
            },
            set channelCountMode (_){
                // Bug #61: This is not part of the standard but required for the faker to work.
                throw createInvalidStateError();
            },
            get channelInterpretation () {
                return channelInterpretation;
            },
            set channelInterpretation (value){
                for (const gainNode of gainNodes)gainNode.channelInterpretation = value;
                channelInterpretation = value;
            },
            get context () {
                return scriptProcessorNode.context;
            },
            get inputs () {
                return gainNodes;
            },
            get numberOfInputs () {
                return options.numberOfInputs;
            },
            get numberOfOutputs () {
                return options.numberOfOutputs;
            },
            get onprocessorerror () {
                return onprocessorerror;
            },
            set onprocessorerror (value){
                if (typeof onprocessorerror === 'function') nativeAudioWorkletNodeFaker.removeEventListener('processorerror', onprocessorerror);
                onprocessorerror = typeof value === 'function' ? value : null;
                if (typeof onprocessorerror === 'function') nativeAudioWorkletNodeFaker.addEventListener('processorerror', onprocessorerror);
            },
            get parameters () {
                return parameterMap;
            },
            get port () {
                return messageChannel.port2;
            },
            addEventListener (...args) {
                return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
            },
            connect: connectMultipleOutputs.bind(null, outputAudioNodes),
            disconnect: disconnectMultipleOutputs.bind(null, outputAudioNodes),
            dispatchEvent (...args) {
                return scriptProcessorNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        const patchedEventListeners = new Map();
        messageChannel.port1.addEventListener = ((addEventListener)=>{
            return (...args)=>{
                if (args[0] === 'message') {
                    const unpatchedEventListener = typeof args[1] === 'function' ? args[1] : typeof args[1] === 'object' && args[1] !== null && typeof args[1].handleEvent === 'function' ? args[1].handleEvent : null;
                    if (unpatchedEventListener !== null) {
                        const patchedEventListener = patchedEventListeners.get(args[1]);
                        if (patchedEventListener !== undefined) args[1] = patchedEventListener;
                        else {
                            args[1] = (event)=>{
                                exposeCurrentFrameAndCurrentTime(nativeContext.currentTime, nativeContext.sampleRate, ()=>unpatchedEventListener(event));
                            };
                            patchedEventListeners.set(unpatchedEventListener, args[1]);
                        }
                    }
                }
                return addEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
            };
        })(messageChannel.port1.addEventListener);
        messageChannel.port1.removeEventListener = ((removeEventListener)=>{
            return (...args)=>{
                if (args[0] === 'message') {
                    const patchedEventListener = patchedEventListeners.get(args[1]);
                    if (patchedEventListener !== undefined) {
                        patchedEventListeners.delete(args[1]);
                        args[1] = patchedEventListener;
                    }
                }
                return removeEventListener.call(messageChannel.port1, args[0], args[1], args[2]);
            };
        })(messageChannel.port1.removeEventListener);
        let onmessage = null;
        Object.defineProperty(messageChannel.port1, 'onmessage', {
            get: ()=>onmessage,
            set: (value1)=>{
                if (typeof onmessage === 'function') messageChannel.port1.removeEventListener('message', onmessage);
                onmessage = typeof value1 === 'function' ? value1 : null;
                if (typeof onmessage === 'function') {
                    messageChannel.port1.addEventListener('message', onmessage);
                    messageChannel.port1.start();
                }
            }
        });
        processorConstructor.prototype.port = messageChannel.port1;
        let audioWorkletProcessor = null;
        const audioWorkletProcessorPromise = (0, $b8276153f51079e2$export$5200a42feb14a7b7)(nativeContext, nativeAudioWorkletNodeFaker, processorConstructor, options);
        audioWorkletProcessorPromise.then((dWrkltPrcssr)=>audioWorkletProcessor = dWrkltPrcssr);
        const inputs = (0, $495c163400b6fc08$export$495a31436d188d6d)(options.numberOfInputs, options.channelCount);
        const outputs = (0, $495c163400b6fc08$export$495a31436d188d6d)(options.numberOfOutputs, outputChannelCount);
        const parameters = processorConstructor.parameterDescriptors === undefined ? [] : processorConstructor.parameterDescriptors.reduce((prmtrs, { name: name })=>({
                ...prmtrs,
                [name]: new Float32Array(128)
            }), {});
        let isActive = true;
        const disconnectOutputsGraph = ()=>{
            if (options.numberOfOutputs > 0) scriptProcessorNode.disconnect(outputChannelSplitterNode);
            for(let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1){
                const outputChannelMergerNode = outputChannelMergerNodes[i];
                for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.disconnect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                outputChannelSplitterNodeOutput += outputChannelCount[i];
            }
        };
        const activeInputIndexes = new Map();
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer, outputBuffer: outputBuffer })=>{
            if (audioWorkletProcessor !== null) {
                const activeInputs = getActiveAudioWorkletNodeInputs(nativeAudioWorkletNodeFaker);
                for(let i = 0; i < bufferSize; i += 128){
                    for(let j = 0; j < options.numberOfInputs; j += 1)for(let k = 0; k < options.channelCount; k += 1)(0, $824a78f49a5e02c5$export$e3c6e435bf217093)(inputBuffer, inputs[j], k, k, i);
                    if (processorConstructor.parameterDescriptors !== undefined) processorConstructor.parameterDescriptors.forEach(({ name: name }, index)=>{
                        (0, $824a78f49a5e02c5$export$e3c6e435bf217093)(inputBuffer, parameters, name, numberOfInputChannels + index, i);
                    });
                    for(let j = 0; j < options.numberOfInputs; j += 1){
                        for(let k = 0; k < outputChannelCount[j]; k += 1)// The byteLength will be 0 when the ArrayBuffer was transferred.
                        if (outputs[j][k].byteLength === 0) outputs[j][k] = new Float32Array(128);
                    }
                    try {
                        const potentiallyEmptyInputs = inputs.map((input, index)=>{
                            const activeInput = activeInputs[index];
                            if (activeInput.size > 0) {
                                activeInputIndexes.set(index, bufferSize / 128);
                                return input;
                            }
                            const count = activeInputIndexes.get(index);
                            if (count === undefined) return [];
                            if (input.every((channelData)=>channelData.every((sample)=>sample === 0))) {
                                if (count === 1) activeInputIndexes.delete(index);
                                else activeInputIndexes.set(index, count - 1);
                            }
                            return input;
                        });
                        const activeSourceFlag = exposeCurrentFrameAndCurrentTime(nativeContext.currentTime + i / nativeContext.sampleRate, nativeContext.sampleRate, ()=>audioWorkletProcessor.process(potentiallyEmptyInputs, outputs, parameters));
                        isActive = activeSourceFlag;
                        for(let j = 0, outputChannelSplitterNodeOutput = 0; j < options.numberOfOutputs; j += 1){
                            for(let k = 0; k < outputChannelCount[j]; k += 1)(0, $b17c809f1f01ce66$export$6bb6d131144bd753)(outputBuffer, outputs[j], k, outputChannelSplitterNodeOutput + k, i);
                            outputChannelSplitterNodeOutput += outputChannelCount[j];
                        }
                    } catch (error) {
                        isActive = false;
                        nativeAudioWorkletNodeFaker.dispatchEvent(new ErrorEvent('processorerror', {
                            colno: error.colno,
                            filename: error.filename,
                            lineno: error.lineno,
                            message: error.message
                        }));
                    }
                    if (!isActive) {
                        for(let j = 0; j < options.numberOfInputs; j += 1){
                            gainNodes[j].disconnect(inputChannelSplitterNodes[j]);
                            for(let k = 0; k < options.channelCount; k += 1)inputChannelSplitterNodes[i].disconnect(inputChannelMergerNode, k, j * options.channelCount + k);
                        }
                        if (processorConstructor.parameterDescriptors !== undefined) {
                            const length = processorConstructor.parameterDescriptors.length;
                            for(let j = 0; j < length; j += 1){
                                const constantSourceNode = constantSourceNodes[j];
                                constantSourceNode.disconnect(inputChannelMergerNode, 0, numberOfInputChannels + j);
                                constantSourceNode.stop();
                            }
                        }
                        inputChannelMergerNode.disconnect(scriptProcessorNode);
                        scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation
                        if (isConnected) disconnectOutputsGraph();
                        else disconnectFakeGraph();
                        break;
                    }
                }
            }
        };
        let isConnected = false;
        // Bug #87: Only Firefox will fire an AudioProcessingEvent if there is no connected output.
        const nativeGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        const connectFakeGraph = ()=>scriptProcessorNode.connect(nativeGainNode).connect(nativeContext.destination);
        const disconnectFakeGraph = ()=>{
            scriptProcessorNode.disconnect(nativeGainNode);
            nativeGainNode.disconnect();
        };
        const whenConnected = ()=>{
            if (isActive) {
                disconnectFakeGraph();
                if (options.numberOfOutputs > 0) scriptProcessorNode.connect(outputChannelSplitterNode);
                for(let i = 0, outputChannelSplitterNodeOutput = 0; i < options.numberOfOutputs; i += 1){
                    const outputChannelMergerNode = outputChannelMergerNodes[i];
                    for(let j = 0; j < outputChannelCount[i]; j += 1)outputChannelSplitterNode.connect(outputChannelMergerNode, outputChannelSplitterNodeOutput + j, j);
                    outputChannelSplitterNodeOutput += outputChannelCount[i];
                }
            }
            isConnected = true;
        };
        const whenDisconnected = ()=>{
            if (isActive) {
                connectFakeGraph();
                disconnectOutputsGraph();
            }
            isConnected = false;
        };
        connectFakeGraph();
        return monitorConnections(nativeAudioWorkletNodeFaker, whenConnected, whenDisconnected);
    };
};





const $e80fde9dac479cbc$export$97e69c8dbd260f85 = (nativeContext, options)=>{
    const nativeBiquadFilterNode = nativeContext.createBiquadFilter();
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeBiquadFilterNode, options);
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeBiquadFilterNode, options, 'Q');
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeBiquadFilterNode, options, 'detune');
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeBiquadFilterNode, options, 'frequency');
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeBiquadFilterNode, options, 'gain');
    (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeBiquadFilterNode, options, 'type');
    return nativeBiquadFilterNode;
};



const $2a5d9150f87cc567$export$99fe194415d94151 = (nativeAudioContextConstructor, wrapChannelMergerNode)=>{
    return (nativeContext, options)=>{
        const nativeChannelMergerNode = nativeContext.createChannelMerger(options.numberOfInputs);
        /*
         * Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
         * the webkitAudioContext is used as a workaround here.
         */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext') wrapChannelMergerNode(nativeContext, nativeChannelMergerNode);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeChannelMergerNode, options);
        return nativeChannelMergerNode;
    };
};




const $ab180d1796a6eb7a$export$62f6b3ab91fa4589 = (channelSplitterNode)=>{
    const channelCount = channelSplitterNode.numberOfOutputs;
    // Bug #97: Safari does not throw an error when attempting to change the channelCount to something other than its initial value.
    Object.defineProperty(channelSplitterNode, 'channelCount', {
        get: ()=>channelCount,
        set: (value)=>{
            if (value !== channelCount) throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
        }
    });
    // Bug #30: Safari does not throw an error when attempting to change the channelCountMode to something other than explicit.
    Object.defineProperty(channelSplitterNode, 'channelCountMode', {
        get: ()=>'explicit',
        set: (value)=>{
            if (value !== 'explicit') throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
        }
    });
    // Bug #32: Safari does not throw an error when attempting to change the channelInterpretation to something other than discrete.
    Object.defineProperty(channelSplitterNode, 'channelInterpretation', {
        get: ()=>'discrete',
        set: (value)=>{
            if (value !== 'discrete') throw (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b)();
        }
    });
};


const $fb7eeefbad4e691e$export$17649533bf213707 = (nativeContext, options)=>{
    const nativeChannelSplitterNode = nativeContext.createChannelSplitter(options.numberOfOutputs);
    // Bug #96: Safari does not have the correct channelCount.
    // Bug #29: Safari does not have the correct channelCountMode.
    // Bug #31: Safari does not have the correct channelInterpretation.
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeChannelSplitterNode, options);
    // Bug #29, #30, #31, #32, #96 & #97: Only Chrome, Edge & Firefox partially support the spec yet.
    (0, $ab180d1796a6eb7a$export$62f6b3ab91fa4589)(nativeChannelSplitterNode);
    return nativeChannelSplitterNode;
};






const $cc19291652c95d8b$export$2dd44f7bb3dd8089 = (addSilentConnection, cacheTestResult, createNativeConstantSourceNodeFaker, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport)=>{
    return (nativeContext, options)=>{
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeContext.createConstantSource === undefined) return createNativeConstantSourceNodeFaker(nativeContext, options);
        const nativeConstantSourceNode = nativeContext.createConstantSource();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeConstantSourceNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeConstantSourceNode, options, 'offset');
        // Bug #44: Safari does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $e3342623b0c84b77$export$987b3a4087e6578c)(nativeConstantSourceNode);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $ecb767d214ace196$export$7adf5b1e83aad45)(nativeConstantSourceNode);
        // Bug #175: Safari will not fire an ended event if the ConstantSourceNode is unconnected.
        addSilentConnection(nativeContext, nativeConstantSourceNode);
        return nativeConstantSourceNode;
    };
};


const $a05c6395c19a176f$export$19c8a106f82dff14 = (original, interceptor)=>{
    original.connect = interceptor.connect.bind(interceptor);
    original.disconnect = interceptor.disconnect.bind(interceptor);
    return original;
};


const $7750b35622dacdb4$export$360749cf3d02285a = (addSilentConnection, createNativeAudioBufferSourceNode, createNativeGainNode, monitorConnections)=>{
    return (nativeContext, { offset: offset, ...audioNodeOptions })=>{
        const audioBuffer = nativeContext.createBuffer(1, 2, 44100);
        const audioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext, {
            buffer: null,
            channelCount: 2,
            channelCountMode: 'max',
            channelInterpretation: 'speakers',
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            playbackRate: 1
        });
        const gainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: offset
        });
        // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        const channelData = audioBuffer.getChannelData(0);
        // Bug #95: Safari does not play or loop one sample buffers.
        channelData[0] = 1;
        channelData[1] = 1;
        audioBufferSourceNode.buffer = audioBuffer;
        audioBufferSourceNode.loop = true;
        const nativeConstantSourceNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return gainNode.channelCount;
            },
            set channelCount (value){
                gainNode.channelCount = value;
            },
            get channelCountMode () {
                return gainNode.channelCountMode;
            },
            set channelCountMode (value){
                gainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return gainNode.channelInterpretation;
            },
            set channelInterpretation (value){
                gainNode.channelInterpretation = value;
            },
            get context () {
                return gainNode.context;
            },
            get inputs () {
                return [];
            },
            get numberOfInputs () {
                return audioBufferSourceNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return gainNode.numberOfOutputs;
            },
            get offset () {
                return gainNode.gain;
            },
            get onended () {
                return audioBufferSourceNode.onended;
            },
            set onended (value){
                audioBufferSourceNode.onended = value;
            },
            addEventListener (...args) {
                return audioBufferSourceNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return audioBufferSourceNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return audioBufferSourceNode.removeEventListener(args[0], args[1], args[2]);
            },
            start (when = 0) {
                audioBufferSourceNode.start.call(audioBufferSourceNode, when);
            },
            stop (when = 0) {
                audioBufferSourceNode.stop.call(audioBufferSourceNode, when);
            }
        };
        const whenConnected = ()=>audioBufferSourceNode.connect(gainNode);
        const whenDisconnected = ()=>audioBufferSourceNode.disconnect(gainNode);
        // Bug #175: Safari will not fire an ended event if the AudioBufferSourceNode is unconnected.
        addSilentConnection(nativeContext, audioBufferSourceNode);
        return monitorConnections((0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeConstantSourceNodeFaker, gainNode), whenConnected, whenDisconnected);
    };
};




const $370e4f21c26d451c$export$afdcf89d13ff62e = (createNotSupportedError, overwriteAccessors)=>{
    return (nativeContext, options)=>{
        const nativeConvolverNode = nativeContext.createConvolver();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeConvolverNode, options);
        // The normalize property needs to be set before setting the buffer.
        if (options.disableNormalization === nativeConvolverNode.normalize) nativeConvolverNode.normalize = !options.disableNormalization;
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeConvolverNode, options, 'buffer');
        // Bug #113: Safari does allow to set the channelCount to a value larger than 2.
        if (options.channelCount > 2) throw createNotSupportedError();
        overwriteAccessors(nativeConvolverNode, 'channelCount', (get)=>()=>get.call(nativeConvolverNode), (set)=>(value)=>{
                if (value > 2) throw createNotSupportedError();
                return set.call(nativeConvolverNode, value);
            });
        // Bug #114: Safari allows to set the channelCountMode to 'max'.
        if (options.channelCountMode === 'max') throw createNotSupportedError();
        overwriteAccessors(nativeConvolverNode, 'channelCountMode', (get)=>()=>get.call(nativeConvolverNode), (set)=>(value)=>{
                if (value === 'max') throw createNotSupportedError();
                return set.call(nativeConvolverNode, value);
            });
        return nativeConvolverNode;
    };
};




const $ef87939e6b57ab0a$export$f7dd6d407a2109ef = (nativeContext, options)=>{
    const nativeDelayNode = nativeContext.createDelay(options.maxDelayTime);
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeDelayNode, options);
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDelayNode, options, 'delayTime');
    return nativeDelayNode;
};




const $3bed81c18206a0fd$export$f19d90a0cd4a2ecc = (createNotSupportedError)=>{
    return (nativeContext, options)=>{
        const nativeDynamicsCompressorNode = nativeContext.createDynamicsCompressor();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeDynamicsCompressorNode, options);
        // Bug #108: Safari allows a channelCount of three and above.
        if (options.channelCount > 2) throw createNotSupportedError();
        // Bug #109: Only Chrome and Firefox disallow a channelCountMode of 'max'.
        if (options.channelCountMode === 'max') throw createNotSupportedError();
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'attack');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'knee');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'ratio');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'release');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeDynamicsCompressorNode, options, 'threshold');
        return nativeDynamicsCompressorNode;
    };
};




const $525849e875dd580b$export$7cf909169b9c4d6f = (nativeContext, options)=>{
    const nativeGainNode = nativeContext.createGain();
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeGainNode, options);
    (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeGainNode, options, 'gain');
    return nativeGainNode;
};



const $45205c9bc193dafd$export$3c1aed24ed6efd9d = (createNativeIIRFilterNodeFaker)=>{
    return (nativeContext, baseLatency, options)=>{
        // Bug #9: Safari does not support IIRFilterNodes.
        if (nativeContext.createIIRFilter === undefined) return createNativeIIRFilterNodeFaker(nativeContext, baseLatency, options);
        // @todo TypeScript defines the parameters of createIIRFilter() as arrays of numbers.
        const nativeIIRFilterNode = nativeContext.createIIRFilter(options.feedforward, options.feedback);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeIIRFilterNode, options);
        return nativeIIRFilterNode;
    };
};





function $9c6b76deea631207$var$divide(a, b) {
    const denominator = b[0] * b[0] + b[1] * b[1];
    return [
        (a[0] * b[0] + a[1] * b[1]) / denominator,
        (a[1] * b[0] - a[0] * b[1]) / denominator
    ];
}
function $9c6b76deea631207$var$multiply(a, b) {
    return [
        a[0] * b[0] - a[1] * b[1],
        a[0] * b[1] + a[1] * b[0]
    ];
}
function $9c6b76deea631207$var$evaluatePolynomial(coefficient, z) {
    let result = [
        0,
        0
    ];
    for(let i = coefficient.length - 1; i >= 0; i -= 1){
        result = $9c6b76deea631207$var$multiply(result, z);
        result[0] += coefficient[i];
    }
    return result;
}
const $9c6b76deea631207$export$49dca6a724f463b = (createInvalidAccessError, createInvalidStateError, createNativeScriptProcessorNode, createNotSupportedError)=>{
    return (nativeContext, baseLatency, { channelCount: channelCount, channelCountMode: channelCountMode, channelInterpretation: channelInterpretation, feedback: feedback, feedforward: feedforward })=>{
        const bufferSize = (0, $0470d07e32bfb928$export$c3c4ba87244c2bf4)(baseLatency, nativeContext.sampleRate);
        const convertedFeedback = feedback instanceof Float64Array ? feedback : new Float64Array(feedback);
        const convertedFeedforward = feedforward instanceof Float64Array ? feedforward : new Float64Array(feedforward);
        const feedbackLength = convertedFeedback.length;
        const feedforwardLength = convertedFeedforward.length;
        const minLength = Math.min(feedbackLength, feedforwardLength);
        if (feedbackLength === 0 || feedbackLength > 20) throw createNotSupportedError();
        if (convertedFeedback[0] === 0) throw createInvalidStateError();
        if (feedforwardLength === 0 || feedforwardLength > 20) throw createNotSupportedError();
        if (convertedFeedforward[0] === 0) throw createInvalidStateError();
        if (convertedFeedback[0] !== 1) {
            for(let i = 0; i < feedforwardLength; i += 1)convertedFeedforward[i] /= convertedFeedback[0];
            for(let i = 1; i < feedbackLength; i += 1)convertedFeedback[i] /= convertedFeedback[0];
        }
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, bufferSize, channelCount, channelCount);
        scriptProcessorNode.channelCount = channelCount;
        scriptProcessorNode.channelCountMode = channelCountMode;
        scriptProcessorNode.channelInterpretation = channelInterpretation;
        const bufferLength = 32;
        const bufferIndexes = [];
        const xBuffers = [];
        const yBuffers = [];
        for(let i = 0; i < channelCount; i += 1){
            bufferIndexes.push(0);
            const xBuffer = new Float32Array(bufferLength);
            const yBuffer = new Float32Array(bufferLength);
            xBuffer.fill(0);
            yBuffer.fill(0);
            xBuffers.push(xBuffer);
            yBuffers.push(yBuffer);
        }
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = (event)=>{
            const inputBuffer = event.inputBuffer;
            const outputBuffer = event.outputBuffer;
            const numberOfChannels = inputBuffer.numberOfChannels;
            for(let i = 0; i < numberOfChannels; i += 1){
                const input = inputBuffer.getChannelData(i);
                const output = outputBuffer.getChannelData(i);
                bufferIndexes[i] = (0, $753b6e2d7a61817d$export$7fa1177e7d2178dd)(convertedFeedback, feedbackLength, convertedFeedforward, feedforwardLength, minLength, xBuffers[i], yBuffers[i], bufferIndexes[i], bufferLength, input, output);
            }
        };
        const nyquist = nativeContext.sampleRate / 2;
        const nativeIIRFilterNodeFaker = {
            get bufferSize () {
                return bufferSize;
            },
            get channelCount () {
                return scriptProcessorNode.channelCount;
            },
            set channelCount (value){
                scriptProcessorNode.channelCount = value;
            },
            get channelCountMode () {
                return scriptProcessorNode.channelCountMode;
            },
            set channelCountMode (value){
                scriptProcessorNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return scriptProcessorNode.channelInterpretation;
            },
            set channelInterpretation (value){
                scriptProcessorNode.channelInterpretation = value;
            },
            get context () {
                return scriptProcessorNode.context;
            },
            get inputs () {
                return [
                    scriptProcessorNode
                ];
            },
            get numberOfInputs () {
                return scriptProcessorNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return scriptProcessorNode.numberOfOutputs;
            },
            addEventListener (...args) {
                // @todo Dissallow adding an audioprocess listener.
                return scriptProcessorNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return scriptProcessorNode.dispatchEvent(args[0]);
            },
            getFrequencyResponse (frequencyHz, magResponse, phaseResponse) {
                if (frequencyHz.length !== magResponse.length || magResponse.length !== phaseResponse.length) throw createInvalidAccessError();
                const length = frequencyHz.length;
                for(let i = 0; i < length; i += 1){
                    const omega = -Math.PI * (frequencyHz[i] / nyquist);
                    const z = [
                        Math.cos(omega),
                        Math.sin(omega)
                    ];
                    const numerator = $9c6b76deea631207$var$evaluatePolynomial(convertedFeedforward, z);
                    const denominator = $9c6b76deea631207$var$evaluatePolynomial(convertedFeedback, z);
                    const response = $9c6b76deea631207$var$divide(numerator, denominator);
                    magResponse[i] = Math.sqrt(response[0] * response[0] + response[1] * response[1]);
                    phaseResponse[i] = Math.atan2(response[1], response[0]);
                }
            },
            removeEventListener (...args) {
                return scriptProcessorNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        return (0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeIIRFilterNodeFaker, scriptProcessorNode);
    };
};


const $d4deb99e9b2af7cd$export$2b1682bf41b4d16b = (nativeAudioContext, options)=>{
    return nativeAudioContext.createMediaElementSource(options.mediaElement);
};



const $94c6adbd7f255efe$export$acb51039efa3405d = (nativeAudioContext, options)=>{
    const nativeMediaStreamAudioDestinationNode = nativeAudioContext.createMediaStreamDestination();
    (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeMediaStreamAudioDestinationNode, options);
    // Bug #174: Safari does expose a wrong numberOfOutputs.
    if (nativeMediaStreamAudioDestinationNode.numberOfOutputs === 1) Object.defineProperty(nativeMediaStreamAudioDestinationNode, 'numberOfOutputs', {
        get: ()=>0
    });
    return nativeMediaStreamAudioDestinationNode;
};


const $b4d28d9c960c771a$export$ad3e497ef44fc577 = (nativeAudioContext, { mediaStream: mediaStream })=>{
    const audioStreamTracks = mediaStream.getAudioTracks();
    /*
     * Bug #151: Safari does not use the audio track as input anymore if it gets removed from the mediaStream after construction.
     * Bug #159: Safari picks the first audio track if the MediaStream has more than one audio track.
     */ audioStreamTracks.sort((a, b)=>a.id < b.id ? -1 : a.id > b.id ? 1 : 0);
    const filteredAudioStreamTracks = audioStreamTracks.slice(0, 1);
    const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(new MediaStream(filteredAudioStreamTracks));
    /*
     * Bug #151 & #159: The given mediaStream gets reconstructed before it gets passed to the native node which is why the accessor needs
     * to be overwritten as it would otherwise expose the reconstructed version.
     */ Object.defineProperty(nativeMediaStreamAudioSourceNode, 'mediaStream', {
        value: mediaStream
    });
    return nativeMediaStreamAudioSourceNode;
};


const $0d8737ad5d3f94df$export$87e46bc6eb8ed6ac = (createInvalidStateError, isNativeOfflineAudioContext)=>{
    return (nativeAudioContext, { mediaStreamTrack: mediaStreamTrack })=>{
        // Bug #121: Only Firefox does yet support the MediaStreamTrackAudioSourceNode.
        if (typeof nativeAudioContext.createMediaStreamTrackSource === 'function') return nativeAudioContext.createMediaStreamTrackSource(mediaStreamTrack);
        const mediaStream = new MediaStream([
            mediaStreamTrack
        ]);
        const nativeMediaStreamAudioSourceNode = nativeAudioContext.createMediaStreamSource(mediaStream);
        // Bug #120: Firefox does not throw an error if the mediaStream has no audio track.
        if (mediaStreamTrack.kind !== 'audio') throw createInvalidStateError();
        // Bug #172: Safari allows to create a MediaStreamAudioSourceNode with an OfflineAudioContext.
        if (isNativeOfflineAudioContext(nativeAudioContext)) throw new TypeError();
        return nativeMediaStreamAudioSourceNode;
    };
};


const $19c5a8e8a9bd3d9c$export$e628a2a5fd5b78b9 = (window)=>{
    if (window === null) return null;
    if (window.hasOwnProperty('OfflineAudioContext')) return window.OfflineAudioContext;
    return window.hasOwnProperty('webkitOfflineAudioContext') ? window.webkitOfflineAudioContext : null;
};







const $138975cc1d22c83a$export$a40e02c218ae01d3 = (addSilentConnection, cacheTestResult, testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls)=>{
    return (nativeContext, options)=>{
        const nativeOscillatorNode = nativeContext.createOscillator();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeOscillatorNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeOscillatorNode, options, 'detune');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeOscillatorNode, options, 'frequency');
        if (options.periodicWave !== undefined) nativeOscillatorNode.setPeriodicWave(options.periodicWave);
        else (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeOscillatorNode, options, 'type');
        // Bug #44: Only Chrome & Edge throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStartMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStartMethodNegativeParametersSupport(nativeContext))) (0, $e3342623b0c84b77$export$987b3a4087e6578c)(nativeOscillatorNode);
        // Bug #19: Safari does not ignore calls to stop() of an already stopped AudioBufferSourceNode.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport, ()=>testAudioScheduledSourceNodeStopMethodConsecutiveCallsSupport(nativeContext))) wrapAudioScheduledSourceNodeStopMethodConsecutiveCalls(nativeOscillatorNode, nativeContext);
        // Bug #44: Only Firefox does not throw a RangeError yet.
        if (!cacheTestResult(testAudioScheduledSourceNodeStopMethodNegativeParametersSupport, ()=>testAudioScheduledSourceNodeStopMethodNegativeParametersSupport(nativeContext))) (0, $ecb767d214ace196$export$7adf5b1e83aad45)(nativeOscillatorNode);
        // Bug #175: Safari will not fire an ended event if the OscillatorNode is unconnected.
        addSilentConnection(nativeContext, nativeOscillatorNode);
        return nativeOscillatorNode;
    };
};





const $d34e0e0fbe459c97$export$8e3c89af72a58833 = (createNativePannerNodeFaker)=>{
    return (nativeContext, options)=>{
        const nativePannerNode = nativeContext.createPanner();
        // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.
        if (nativePannerNode.orientationX === undefined) return createNativePannerNodeFaker(nativeContext, options);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativePannerNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, 'orientationX');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, 'orientationY');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, 'orientationZ');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, 'positionX');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, 'positionY');
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativePannerNode, options, 'positionZ');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, 'coneInnerAngle');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, 'coneOuterAngle');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, 'coneOuterGain');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, 'distanceModel');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, 'maxDistance');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, 'panningModel');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, 'refDistance');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativePannerNode, options, 'rolloffFactor');
        return nativePannerNode;
    };
};




const $4d9cae61d16712a4$export$f04468477689c1b4 = (connectNativeAudioNodeToNativeAudioNode, createInvalidStateError, createNativeChannelMergerNode, createNativeGainNode, createNativeScriptProcessorNode, createNativeWaveShaperNode, createNotSupportedError, disconnectNativeAudioNodeFromNativeAudioNode, getFirstSample, monitorConnections)=>{
    return (nativeContext, { coneInnerAngle: coneInnerAngle, coneOuterAngle: coneOuterAngle, coneOuterGain: coneOuterGain, distanceModel: distanceModel, maxDistance: maxDistance, orientationX: orientationX, orientationY: orientationY, orientationZ: orientationZ, panningModel: panningModel, positionX: positionX, positionY: positionY, positionZ: positionZ, refDistance: refDistance, rolloffFactor: rolloffFactor, ...audioNodeOptions })=>{
        const pannerNode = nativeContext.createPanner();
        // Bug #125: Safari does not throw an error yet.
        if (audioNodeOptions.channelCount > 2) throw createNotSupportedError();
        // Bug #126: Safari does not throw an error yet.
        if (audioNodeOptions.channelCountMode === 'max') throw createNotSupportedError();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(pannerNode, audioNodeOptions);
        const SINGLE_CHANNEL_OPTIONS = {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete'
        };
        const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            channelInterpretation: 'speakers',
            numberOfInputs: 6
        });
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const orientationXGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 1
        });
        const orientationYGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const orientationZGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionXGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionYGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const positionZGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        const scriptProcessorNode = createNativeScriptProcessorNode(nativeContext, 256, 6, 1);
        const waveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            curve: new Float32Array([
                1,
                1
            ]),
            oversample: 'none'
        });
        let lastOrientation = [
            orientationX,
            orientationY,
            orientationZ
        ];
        let lastPosition = [
            positionX,
            positionY,
            positionZ
        ];
        const buffer = new Float32Array(1);
        // tslint:disable-next-line:deprecation
        scriptProcessorNode.onaudioprocess = ({ inputBuffer: inputBuffer })=>{
            const orientation = [
                getFirstSample(inputBuffer, buffer, 0),
                getFirstSample(inputBuffer, buffer, 1),
                getFirstSample(inputBuffer, buffer, 2)
            ];
            if (orientation.some((value1, index)=>value1 !== lastOrientation[index])) {
                pannerNode.setOrientation(...orientation); // tslint:disable-line:deprecation
                lastOrientation = orientation;
            }
            const positon = [
                getFirstSample(inputBuffer, buffer, 3),
                getFirstSample(inputBuffer, buffer, 4),
                getFirstSample(inputBuffer, buffer, 5)
            ];
            if (positon.some((value1, index)=>value1 !== lastPosition[index])) {
                pannerNode.setPosition(...positon); // tslint:disable-line:deprecation
                lastPosition = positon;
            }
        };
        Object.defineProperty(orientationYGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(orientationZGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionXGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionYGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(positionZGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        const nativePannerNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return pannerNode.channelCount;
            },
            set channelCount (value){
                // Bug #125: Safari does not throw an error yet.
                if (value > 2) throw createNotSupportedError();
                inputGainNode.channelCount = value;
                pannerNode.channelCount = value;
            },
            get channelCountMode () {
                return pannerNode.channelCountMode;
            },
            set channelCountMode (value){
                // Bug #126: Safari does not throw an error yet.
                if (value === 'max') throw createNotSupportedError();
                inputGainNode.channelCountMode = value;
                pannerNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return pannerNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
                pannerNode.channelInterpretation = value;
            },
            get coneInnerAngle () {
                return pannerNode.coneInnerAngle;
            },
            set coneInnerAngle (value){
                pannerNode.coneInnerAngle = value;
            },
            get coneOuterAngle () {
                return pannerNode.coneOuterAngle;
            },
            set coneOuterAngle (value){
                pannerNode.coneOuterAngle = value;
            },
            get coneOuterGain () {
                return pannerNode.coneOuterGain;
            },
            set coneOuterGain (value){
                // Bug #127: Safari does not throw an InvalidStateError yet.
                if (value < 0 || value > 1) throw createInvalidStateError();
                pannerNode.coneOuterGain = value;
            },
            get context () {
                return pannerNode.context;
            },
            get distanceModel () {
                return pannerNode.distanceModel;
            },
            set distanceModel (value){
                pannerNode.distanceModel = value;
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get maxDistance () {
                return pannerNode.maxDistance;
            },
            set maxDistance (value){
                // Bug #128: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.maxDistance = value;
            },
            get numberOfInputs () {
                return pannerNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return pannerNode.numberOfOutputs;
            },
            get orientationX () {
                return orientationXGainNode.gain;
            },
            get orientationY () {
                return orientationYGainNode.gain;
            },
            get orientationZ () {
                return orientationZGainNode.gain;
            },
            get panningModel () {
                return pannerNode.panningModel;
            },
            set panningModel (value){
                pannerNode.panningModel = value;
            },
            get positionX () {
                return positionXGainNode.gain;
            },
            get positionY () {
                return positionYGainNode.gain;
            },
            get positionZ () {
                return positionZGainNode.gain;
            },
            get refDistance () {
                return pannerNode.refDistance;
            },
            set refDistance (value){
                // Bug #129: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.refDistance = value;
            },
            get rolloffFactor () {
                return pannerNode.rolloffFactor;
            },
            set rolloffFactor (value){
                // Bug #130: Safari does not throw an error yet.
                if (value < 0) throw new RangeError();
                pannerNode.rolloffFactor = value;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        if (coneInnerAngle !== nativePannerNodeFaker.coneInnerAngle) nativePannerNodeFaker.coneInnerAngle = coneInnerAngle;
        if (coneOuterAngle !== nativePannerNodeFaker.coneOuterAngle) nativePannerNodeFaker.coneOuterAngle = coneOuterAngle;
        if (coneOuterGain !== nativePannerNodeFaker.coneOuterGain) nativePannerNodeFaker.coneOuterGain = coneOuterGain;
        if (distanceModel !== nativePannerNodeFaker.distanceModel) nativePannerNodeFaker.distanceModel = distanceModel;
        if (maxDistance !== nativePannerNodeFaker.maxDistance) nativePannerNodeFaker.maxDistance = maxDistance;
        if (orientationX !== nativePannerNodeFaker.orientationX.value) nativePannerNodeFaker.orientationX.value = orientationX;
        if (orientationY !== nativePannerNodeFaker.orientationY.value) nativePannerNodeFaker.orientationY.value = orientationY;
        if (orientationZ !== nativePannerNodeFaker.orientationZ.value) nativePannerNodeFaker.orientationZ.value = orientationZ;
        if (panningModel !== nativePannerNodeFaker.panningModel) nativePannerNodeFaker.panningModel = panningModel;
        if (positionX !== nativePannerNodeFaker.positionX.value) nativePannerNodeFaker.positionX.value = positionX;
        if (positionY !== nativePannerNodeFaker.positionY.value) nativePannerNodeFaker.positionY.value = positionY;
        if (positionZ !== nativePannerNodeFaker.positionZ.value) nativePannerNodeFaker.positionZ.value = positionZ;
        if (refDistance !== nativePannerNodeFaker.refDistance) nativePannerNodeFaker.refDistance = refDistance;
        if (rolloffFactor !== nativePannerNodeFaker.rolloffFactor) nativePannerNodeFaker.rolloffFactor = rolloffFactor;
        if (lastOrientation[0] !== 1 || lastOrientation[1] !== 0 || lastOrientation[2] !== 0) pannerNode.setOrientation(...lastOrientation); // tslint:disable-line:deprecation
        if (lastPosition[0] !== 0 || lastPosition[1] !== 0 || lastPosition[2] !== 0) pannerNode.setPosition(...lastPosition); // tslint:disable-line:deprecation
        const whenConnected = ()=>{
            inputGainNode.connect(pannerNode);
            // Bug #119: Safari does not fully support the WaveShaperNode.
            connectNativeAudioNodeToNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
            waveShaperNode.connect(orientationXGainNode).connect(channelMergerNode, 0, 0);
            waveShaperNode.connect(orientationYGainNode).connect(channelMergerNode, 0, 1);
            waveShaperNode.connect(orientationZGainNode).connect(channelMergerNode, 0, 2);
            waveShaperNode.connect(positionXGainNode).connect(channelMergerNode, 0, 3);
            waveShaperNode.connect(positionYGainNode).connect(channelMergerNode, 0, 4);
            waveShaperNode.connect(positionZGainNode).connect(channelMergerNode, 0, 5);
            channelMergerNode.connect(scriptProcessorNode).connect(nativeContext.destination);
        };
        const whenDisconnected = ()=>{
            inputGainNode.disconnect(pannerNode);
            // Bug #119: Safari does not fully support the WaveShaperNode.
            disconnectNativeAudioNodeFromNativeAudioNode(inputGainNode, waveShaperNode, 0, 0);
            waveShaperNode.disconnect(orientationXGainNode);
            orientationXGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(orientationYGainNode);
            orientationYGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(orientationZGainNode);
            orientationZGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionXGainNode);
            positionXGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionYGainNode);
            positionYGainNode.disconnect(channelMergerNode);
            waveShaperNode.disconnect(positionZGainNode);
            positionZGainNode.disconnect(channelMergerNode);
            channelMergerNode.disconnect(scriptProcessorNode);
            scriptProcessorNode.disconnect(nativeContext.destination);
        };
        return monitorConnections((0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativePannerNodeFaker, pannerNode), whenConnected, whenDisconnected);
    };
};


const $a6ed532ea5998f8a$export$3f519524c23feca0 = (createIndexSizeError)=>{
    return (nativeContext, { disableNormalization: disableNormalization, imag: imag, real: real })=>{
        // Bug #180: Safari does not allow to use ordinary arrays.
        const convertedImag = imag instanceof Float32Array ? imag : new Float32Array(imag);
        const convertedReal = real instanceof Float32Array ? real : new Float32Array(real);
        const nativePeriodicWave = nativeContext.createPeriodicWave(convertedReal, convertedImag, {
            disableNormalization: disableNormalization
        });
        // Bug #181: Safari does not throw an IndexSizeError so far if the given arrays have less than two values.
        if (Array.from(imag).length < 2) throw createIndexSizeError();
        return nativePeriodicWave;
    };
};


const $cb688845d3eca55e$export$9f784f497a6d6acb = (nativeContext, bufferSize, numberOfInputChannels, numberOfOutputChannels)=>{
    return nativeContext.createScriptProcessor(bufferSize, numberOfInputChannels, numberOfOutputChannels); // tslint:disable-line deprecation
};




const $e0e74a050611c4ea$export$247580dcf7d2f2c4 = (createNativeStereoPannerNodeFaker, createNotSupportedError)=>{
    return (nativeContext, options)=>{
        const channelCountMode = options.channelCountMode;
        /*
         * Bug #105: The channelCountMode of 'clamped-max' should be supported. However it is not possible to write a polyfill for Safari
         * which supports it and therefore it can't be supported at all.
         */ if (channelCountMode === 'clamped-max') throw createNotSupportedError();
        // Bug #105: Safari does not support the StereoPannerNode.
        if (nativeContext.createStereoPanner === undefined) return createNativeStereoPannerNodeFaker(nativeContext, options);
        const nativeStereoPannerNode = nativeContext.createStereoPanner();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeStereoPannerNode, options);
        (0, $ae111b58c598e4e4$export$4778de978774ec4f)(nativeStereoPannerNode, options, 'pan');
        /*
         * Bug #105: The channelCountMode of 'clamped-max' should be supported. However it is not possible to write a polyfill for Safari
         * which supports it and therefore it can't be supported at all.
         */ Object.defineProperty(nativeStereoPannerNode, 'channelCountMode', {
            get: ()=>channelCountMode,
            set: (value)=>{
                if (value !== channelCountMode) throw createNotSupportedError();
            }
        });
        return nativeStereoPannerNode;
    };
};



const $ea55b90e6ec12a54$export$5fe2a787c06b2d34 = (createNativeChannelMergerNode, createNativeChannelSplitterNode, createNativeGainNode, createNativeWaveShaperNode, createNotSupportedError, monitorConnections)=>{
    // The curve has a size of 14bit plus 1 value to have an exact representation for zero. This value has been determined experimentally.
    const CURVE_SIZE = 16385;
    const DC_CURVE = new Float32Array([
        1,
        1
    ]);
    const HALF_PI = Math.PI / 2;
    const SINGLE_CHANNEL_OPTIONS = {
        channelCount: 1,
        channelCountMode: 'explicit',
        channelInterpretation: 'discrete'
    };
    const SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS = {
        ...SINGLE_CHANNEL_OPTIONS,
        oversample: 'none'
    };
    const buildInternalGraphForMono = (nativeContext, inputGainNode, panGainNode, channelMergerNode)=>{
        const leftWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightWaveShaperCurve = new Float32Array(CURVE_SIZE);
        for(let i = 0; i < CURVE_SIZE; i += 1){
            const x = i / (CURVE_SIZE - 1) * HALF_PI;
            leftWaveShaperCurve[i] = Math.cos(x);
            rightWaveShaperCurve[i] = Math.sin(x);
        }
        const leftGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftWaveShaperCurve
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const panWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: DC_CURVE
        });
        const rightGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightWaveShaperCurve
        });
        return {
            connectGraph () {
                inputGainNode.connect(leftGainNode);
                inputGainNode.connect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                inputGainNode.connect(rightGainNode);
                panWaveShaperNode.connect(panGainNode);
                panGainNode.connect(leftWaveShaperNode.inputs === undefined ? leftWaveShaperNode : leftWaveShaperNode.inputs[0]);
                panGainNode.connect(rightWaveShaperNode.inputs === undefined ? rightWaveShaperNode : rightWaveShaperNode.inputs[0]);
                leftWaveShaperNode.connect(leftGainNode.gain);
                rightWaveShaperNode.connect(rightGainNode.gain);
                leftGainNode.connect(channelMergerNode, 0, 0);
                rightGainNode.connect(channelMergerNode, 0, 1);
            },
            disconnectGraph () {
                inputGainNode.disconnect(leftGainNode);
                inputGainNode.disconnect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                inputGainNode.disconnect(rightGainNode);
                panWaveShaperNode.disconnect(panGainNode);
                panGainNode.disconnect(leftWaveShaperNode.inputs === undefined ? leftWaveShaperNode : leftWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightWaveShaperNode.inputs === undefined ? rightWaveShaperNode : rightWaveShaperNode.inputs[0]);
                leftWaveShaperNode.disconnect(leftGainNode.gain);
                rightWaveShaperNode.disconnect(rightGainNode.gain);
                leftGainNode.disconnect(channelMergerNode, 0, 0);
                rightGainNode.disconnect(channelMergerNode, 0, 1);
            }
        };
    };
    const buildInternalGraphForStereo = (nativeContext, inputGainNode, panGainNode, channelMergerNode)=>{
        const leftInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const leftInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightInputForLeftOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const rightInputForRightOutputWaveShaperCurve = new Float32Array(CURVE_SIZE);
        const centerIndex = Math.floor(CURVE_SIZE / 2);
        for(let i = 0; i < CURVE_SIZE; i += 1)if (i > centerIndex) {
            const x = (i - centerIndex) / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
            leftInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
            leftInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
            rightInputForLeftOutputWaveShaperCurve[i] = 0;
            rightInputForRightOutputWaveShaperCurve[i] = 1;
        } else {
            const x = i / (CURVE_SIZE - 1 - centerIndex) * HALF_PI;
            leftInputForLeftOutputWaveShaperCurve[i] = 1;
            leftInputForRightOutputWaveShaperCurve[i] = 0;
            rightInputForLeftOutputWaveShaperCurve[i] = Math.cos(x);
            rightInputForRightOutputWaveShaperCurve[i] = Math.sin(x);
        }
        const channelSplitterNode = createNativeChannelSplitterNode(nativeContext, {
            channelCount: 2,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            numberOfOutputs: 2
        });
        const leftInputForLeftOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftInputForLeftOutputWaveShaperCurve
        });
        const leftInputForRightOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const leftInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: leftInputForRightOutputWaveShaperCurve
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const panWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: DC_CURVE
        });
        const rightInputForLeftOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightInputForLeftOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightInputForLeftOutputWaveShaperCurve
        });
        const rightInputForRightOutputGainNode = createNativeGainNode(nativeContext, {
            ...SINGLE_CHANNEL_OPTIONS,
            gain: 0
        });
        // Bug #119: Safari does not fully support the WaveShaperNode.
        const rightInputForRightOutputWaveShaperNode = createNativeWaveShaperNode(nativeContext, {
            ...SINGLE_CHANNEL_WAVE_SHAPER_OPTIONS,
            curve: rightInputForRightOutputWaveShaperCurve
        });
        return {
            connectGraph () {
                inputGainNode.connect(channelSplitterNode);
                inputGainNode.connect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                channelSplitterNode.connect(leftInputForLeftOutputGainNode, 0);
                channelSplitterNode.connect(leftInputForRightOutputGainNode, 0);
                channelSplitterNode.connect(rightInputForLeftOutputGainNode, 1);
                channelSplitterNode.connect(rightInputForRightOutputGainNode, 1);
                panWaveShaperNode.connect(panGainNode);
                panGainNode.connect(leftInputForLeftOutputWaveShaperNode.inputs === undefined ? leftInputForLeftOutputWaveShaperNode : leftInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(leftInputForRightOutputWaveShaperNode.inputs === undefined ? leftInputForRightOutputWaveShaperNode : leftInputForRightOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(rightInputForLeftOutputWaveShaperNode.inputs === undefined ? rightInputForLeftOutputWaveShaperNode : rightInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.connect(rightInputForRightOutputWaveShaperNode.inputs === undefined ? rightInputForRightOutputWaveShaperNode : rightInputForRightOutputWaveShaperNode.inputs[0]);
                leftInputForLeftOutputWaveShaperNode.connect(leftInputForLeftOutputGainNode.gain);
                leftInputForRightOutputWaveShaperNode.connect(leftInputForRightOutputGainNode.gain);
                rightInputForLeftOutputWaveShaperNode.connect(rightInputForLeftOutputGainNode.gain);
                rightInputForRightOutputWaveShaperNode.connect(rightInputForRightOutputGainNode.gain);
                leftInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
                rightInputForLeftOutputGainNode.connect(channelMergerNode, 0, 0);
                leftInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
                rightInputForRightOutputGainNode.connect(channelMergerNode, 0, 1);
            },
            disconnectGraph () {
                inputGainNode.disconnect(channelSplitterNode);
                inputGainNode.disconnect(panWaveShaperNode.inputs === undefined ? panWaveShaperNode : panWaveShaperNode.inputs[0]);
                channelSplitterNode.disconnect(leftInputForLeftOutputGainNode, 0);
                channelSplitterNode.disconnect(leftInputForRightOutputGainNode, 0);
                channelSplitterNode.disconnect(rightInputForLeftOutputGainNode, 1);
                channelSplitterNode.disconnect(rightInputForRightOutputGainNode, 1);
                panWaveShaperNode.disconnect(panGainNode);
                panGainNode.disconnect(leftInputForLeftOutputWaveShaperNode.inputs === undefined ? leftInputForLeftOutputWaveShaperNode : leftInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(leftInputForRightOutputWaveShaperNode.inputs === undefined ? leftInputForRightOutputWaveShaperNode : leftInputForRightOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightInputForLeftOutputWaveShaperNode.inputs === undefined ? rightInputForLeftOutputWaveShaperNode : rightInputForLeftOutputWaveShaperNode.inputs[0]);
                panGainNode.disconnect(rightInputForRightOutputWaveShaperNode.inputs === undefined ? rightInputForRightOutputWaveShaperNode : rightInputForRightOutputWaveShaperNode.inputs[0]);
                leftInputForLeftOutputWaveShaperNode.disconnect(leftInputForLeftOutputGainNode.gain);
                leftInputForRightOutputWaveShaperNode.disconnect(leftInputForRightOutputGainNode.gain);
                rightInputForLeftOutputWaveShaperNode.disconnect(rightInputForLeftOutputGainNode.gain);
                rightInputForRightOutputWaveShaperNode.disconnect(rightInputForRightOutputGainNode.gain);
                leftInputForLeftOutputGainNode.disconnect(channelMergerNode, 0, 0);
                rightInputForLeftOutputGainNode.disconnect(channelMergerNode, 0, 0);
                leftInputForRightOutputGainNode.disconnect(channelMergerNode, 0, 1);
                rightInputForRightOutputGainNode.disconnect(channelMergerNode, 0, 1);
            }
        };
    };
    const buildInternalGraph = (nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode)=>{
        if (channelCount === 1) return buildInternalGraphForMono(nativeContext, inputGainNode, panGainNode, channelMergerNode);
        if (channelCount === 2) return buildInternalGraphForStereo(nativeContext, inputGainNode, panGainNode, channelMergerNode);
        throw createNotSupportedError();
    };
    return (nativeContext, { channelCount: channelCount, channelCountMode: channelCountMode, pan: pan, ...audioNodeOptions })=>{
        if (channelCountMode === 'max') throw createNotSupportedError();
        const channelMergerNode = createNativeChannelMergerNode(nativeContext, {
            ...audioNodeOptions,
            channelCount: 1,
            channelCountMode: channelCountMode,
            numberOfInputs: 2
        });
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            channelCount: channelCount,
            channelCountMode: channelCountMode,
            gain: 1
        });
        const panGainNode = createNativeGainNode(nativeContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: pan
        });
        let { connectGraph: connectGraph, disconnectGraph: disconnectGraph } = buildInternalGraph(nativeContext, channelCount, inputGainNode, panGainNode, channelMergerNode);
        Object.defineProperty(panGainNode.gain, 'defaultValue', {
            get: ()=>0
        });
        Object.defineProperty(panGainNode.gain, 'maxValue', {
            get: ()=>1
        });
        Object.defineProperty(panGainNode.gain, 'minValue', {
            get: ()=>-1
        });
        const nativeStereoPannerNodeFakerFactory = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return inputGainNode.channelCount;
            },
            set channelCount (value){
                if (inputGainNode.channelCount !== value) {
                    if (isConnected) disconnectGraph();
                    ({ connectGraph: connectGraph, disconnectGraph: disconnectGraph } = buildInternalGraph(nativeContext, value, inputGainNode, panGainNode, channelMergerNode));
                    if (isConnected) connectGraph();
                }
                inputGainNode.channelCount = value;
            },
            get channelCountMode () {
                return inputGainNode.channelCountMode;
            },
            set channelCountMode (value){
                if (value === 'clamped-max' || value === 'max') throw createNotSupportedError();
                inputGainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return inputGainNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
            },
            get context () {
                return inputGainNode.context;
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get numberOfInputs () {
                return inputGainNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return inputGainNode.numberOfOutputs;
            },
            get pan () {
                return panGainNode.gain;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        let isConnected = false;
        const whenConnected = ()=>{
            connectGraph();
            isConnected = true;
        };
        const whenDisconnected = ()=>{
            disconnectGraph();
            isConnected = false;
        };
        return monitorConnections((0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeStereoPannerNodeFakerFactory, channelMergerNode), whenConnected, whenDisconnected);
    };
};




const $a275aa5a2c573982$export$75168c4c8ce320c4 = (createConnectedNativeAudioBufferSourceNode, createInvalidStateError, createNativeWaveShaperNodeFaker, isDCCurve, monitorConnections, nativeAudioContextConstructor, overwriteAccessors)=>{
    return (nativeContext, options)=>{
        const nativeWaveShaperNode = nativeContext.createWaveShaper();
        /*
         * Bug #119: Safari does not correctly map the values.
         * @todo Unfortunately there is no way to test for this behavior in a synchronous fashion which is why testing for the existence of
         * the webkitAudioContext is used as a workaround here. Testing for the automationRate property is necessary because this workaround
         * isn't necessary anymore since v14.0.2 of Safari.
         */ if (nativeAudioContextConstructor !== null && nativeAudioContextConstructor.name === 'webkitAudioContext' && nativeContext.createGain().gain.automationRate === undefined) return createNativeWaveShaperNodeFaker(nativeContext, options);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(nativeWaveShaperNode, options);
        const curve = options.curve === null || options.curve instanceof Float32Array ? options.curve : new Float32Array(options.curve);
        // Bug #104: Chrome and Edge will throw an InvalidAccessError when the curve has less than two samples.
        if (curve !== null && curve.length < 2) throw createInvalidStateError();
        // Only values of type Float32Array can be assigned to the curve property.
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeWaveShaperNode, {
            curve: curve
        }, 'curve');
        (0, $5eef3820deef0b72$export$26855c8d5a8f5839)(nativeWaveShaperNode, options, 'oversample');
        let disconnectNativeAudioBufferSourceNode = null;
        let isConnected = false;
        overwriteAccessors(nativeWaveShaperNode, 'curve', (get)=>()=>get.call(nativeWaveShaperNode), (set)=>(value)=>{
                set.call(nativeWaveShaperNode, value);
                if (isConnected) {
                    if (isDCCurve(value) && disconnectNativeAudioBufferSourceNode === null) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, nativeWaveShaperNode);
                    else if (!isDCCurve(value) && disconnectNativeAudioBufferSourceNode !== null) {
                        disconnectNativeAudioBufferSourceNode();
                        disconnectNativeAudioBufferSourceNode = null;
                    }
                }
                return value;
            });
        const whenConnected = ()=>{
            isConnected = true;
            if (isDCCurve(nativeWaveShaperNode.curve)) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, nativeWaveShaperNode);
        };
        const whenDisconnected = ()=>{
            isConnected = false;
            if (disconnectNativeAudioBufferSourceNode !== null) {
                disconnectNativeAudioBufferSourceNode();
                disconnectNativeAudioBufferSourceNode = null;
            }
        };
        return monitorConnections(nativeWaveShaperNode, whenConnected, whenDisconnected);
    };
};




const $e6b48514e14721aa$export$f5f0b26abc22907e = (createConnectedNativeAudioBufferSourceNode, createInvalidStateError, createNativeGainNode, isDCCurve, monitorConnections)=>{
    return (nativeContext, { curve: curve, oversample: oversample, ...audioNodeOptions })=>{
        const negativeWaveShaperNode = nativeContext.createWaveShaper();
        const positiveWaveShaperNode = nativeContext.createWaveShaper();
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(negativeWaveShaperNode, audioNodeOptions);
        (0, $acf0ae0814028a1b$export$a741a487b656b6ff)(positiveWaveShaperNode, audioNodeOptions);
        const inputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const invertGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: -1
        });
        const outputGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: 1
        });
        const revertGainNode = createNativeGainNode(nativeContext, {
            ...audioNodeOptions,
            gain: -1
        });
        let disconnectNativeAudioBufferSourceNode = null;
        let isConnected = false;
        let unmodifiedCurve = null;
        const nativeWaveShaperNodeFaker = {
            get bufferSize () {
                return undefined;
            },
            get channelCount () {
                return negativeWaveShaperNode.channelCount;
            },
            set channelCount (value){
                inputGainNode.channelCount = value;
                invertGainNode.channelCount = value;
                negativeWaveShaperNode.channelCount = value;
                outputGainNode.channelCount = value;
                positiveWaveShaperNode.channelCount = value;
                revertGainNode.channelCount = value;
            },
            get channelCountMode () {
                return negativeWaveShaperNode.channelCountMode;
            },
            set channelCountMode (value){
                inputGainNode.channelCountMode = value;
                invertGainNode.channelCountMode = value;
                negativeWaveShaperNode.channelCountMode = value;
                outputGainNode.channelCountMode = value;
                positiveWaveShaperNode.channelCountMode = value;
                revertGainNode.channelCountMode = value;
            },
            get channelInterpretation () {
                return negativeWaveShaperNode.channelInterpretation;
            },
            set channelInterpretation (value){
                inputGainNode.channelInterpretation = value;
                invertGainNode.channelInterpretation = value;
                negativeWaveShaperNode.channelInterpretation = value;
                outputGainNode.channelInterpretation = value;
                positiveWaveShaperNode.channelInterpretation = value;
                revertGainNode.channelInterpretation = value;
            },
            get context () {
                return negativeWaveShaperNode.context;
            },
            get curve () {
                return unmodifiedCurve;
            },
            set curve (value){
                // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
                if (value !== null && value.length < 2) throw createInvalidStateError();
                if (value === null) {
                    negativeWaveShaperNode.curve = value;
                    positiveWaveShaperNode.curve = value;
                } else {
                    const curveLength = value.length;
                    const negativeCurve = new Float32Array(curveLength + 2 - curveLength % 2);
                    const positiveCurve = new Float32Array(curveLength + 2 - curveLength % 2);
                    negativeCurve[0] = value[0];
                    positiveCurve[0] = -value[curveLength - 1];
                    const length = Math.ceil((curveLength + 1) / 2);
                    const centerIndex = (curveLength + 1) / 2 - 1;
                    for(let i = 1; i < length; i += 1){
                        const theoreticIndex = i / length * centerIndex;
                        const lowerIndex = Math.floor(theoreticIndex);
                        const upperIndex = Math.ceil(theoreticIndex);
                        negativeCurve[i] = lowerIndex === upperIndex ? value[lowerIndex] : (1 - (theoreticIndex - lowerIndex)) * value[lowerIndex] + (1 - (upperIndex - theoreticIndex)) * value[upperIndex];
                        positiveCurve[i] = lowerIndex === upperIndex ? -value[curveLength - 1 - lowerIndex] : -((1 - (theoreticIndex - lowerIndex)) * value[curveLength - 1 - lowerIndex]) - (1 - (upperIndex - theoreticIndex)) * value[curveLength - 1 - upperIndex];
                    }
                    negativeCurve[length] = curveLength % 2 === 1 ? value[length - 1] : (value[length - 2] + value[length - 1]) / 2;
                    negativeWaveShaperNode.curve = negativeCurve;
                    positiveWaveShaperNode.curve = positiveCurve;
                }
                unmodifiedCurve = value;
                if (isConnected) {
                    if (isDCCurve(unmodifiedCurve) && disconnectNativeAudioBufferSourceNode === null) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, inputGainNode);
                    else if (disconnectNativeAudioBufferSourceNode !== null) {
                        disconnectNativeAudioBufferSourceNode();
                        disconnectNativeAudioBufferSourceNode = null;
                    }
                }
            },
            get inputs () {
                return [
                    inputGainNode
                ];
            },
            get numberOfInputs () {
                return negativeWaveShaperNode.numberOfInputs;
            },
            get numberOfOutputs () {
                return negativeWaveShaperNode.numberOfOutputs;
            },
            get oversample () {
                return negativeWaveShaperNode.oversample;
            },
            set oversample (value){
                negativeWaveShaperNode.oversample = value;
                positiveWaveShaperNode.oversample = value;
            },
            addEventListener (...args) {
                return inputGainNode.addEventListener(args[0], args[1], args[2]);
            },
            dispatchEvent (...args) {
                return inputGainNode.dispatchEvent(args[0]);
            },
            removeEventListener (...args) {
                return inputGainNode.removeEventListener(args[0], args[1], args[2]);
            }
        };
        if (curve !== null) // Only values of type Float32Array can be assigned to the curve property.
        nativeWaveShaperNodeFaker.curve = curve instanceof Float32Array ? curve : new Float32Array(curve);
        if (oversample !== nativeWaveShaperNodeFaker.oversample) nativeWaveShaperNodeFaker.oversample = oversample;
        const whenConnected = ()=>{
            inputGainNode.connect(negativeWaveShaperNode).connect(outputGainNode);
            inputGainNode.connect(invertGainNode).connect(positiveWaveShaperNode).connect(revertGainNode).connect(outputGainNode);
            isConnected = true;
            if (isDCCurve(unmodifiedCurve)) disconnectNativeAudioBufferSourceNode = createConnectedNativeAudioBufferSourceNode(nativeContext, inputGainNode);
        };
        const whenDisconnected = ()=>{
            inputGainNode.disconnect(negativeWaveShaperNode);
            negativeWaveShaperNode.disconnect(outputGainNode);
            inputGainNode.disconnect(invertGainNode);
            invertGainNode.disconnect(positiveWaveShaperNode);
            positiveWaveShaperNode.disconnect(revertGainNode);
            revertGainNode.disconnect(outputGainNode);
            isConnected = false;
            if (disconnectNativeAudioBufferSourceNode !== null) {
                disconnectNativeAudioBufferSourceNode();
                disconnectNativeAudioBufferSourceNode = null;
            }
        };
        return monitorConnections((0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeWaveShaperNodeFaker, outputGainNode), whenConnected, whenDisconnected);
    };
};


const $b285affc6d8be1e4$export$dbebdb13622d486c = ()=>new DOMException('', 'NotSupportedError');




const $18cd39af3f5a11f9$var$DEFAULT_OPTIONS = {
    numberOfChannels: 1
};
const $18cd39af3f5a11f9$export$a9b5caf52b398870 = (baseAudioContextConstructor, cacheTestResult, createInvalidStateError, createNativeOfflineAudioContext, startRendering)=>{
    return class OfflineAudioContext extends baseAudioContextConstructor {
        constructor(a, b, c){
            let options;
            if (typeof a === 'number' && b !== undefined && c !== undefined) options = {
                length: b,
                numberOfChannels: a,
                sampleRate: c
            };
            else if (typeof a === 'object') options = a;
            else throw new Error('The given parameters are not valid.');
            const { length: length, numberOfChannels: numberOfChannels, sampleRate: sampleRate } = {
                ...$18cd39af3f5a11f9$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOfflineAudioContext = createNativeOfflineAudioContext(numberOfChannels, length, sampleRate);
            // #21 Safari does not support promises and therefore would fire the statechange event before the promise can be resolved.
            if (!cacheTestResult((0, $4590a073dac74a1e$export$9ec44223b1284cd4), ()=>(0, $4590a073dac74a1e$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) nativeOfflineAudioContext.addEventListener('statechange', (()=>{
                let i = 0;
                const delayStateChangeEvent = (event)=>{
                    if (this._state === 'running') {
                        if (i > 0) {
                            nativeOfflineAudioContext.removeEventListener('statechange', delayStateChangeEvent);
                            event.stopImmediatePropagation();
                            this._waitForThePromiseToSettle(event);
                        } else i += 1;
                    }
                };
                return delayStateChangeEvent;
            })());
            super(nativeOfflineAudioContext, numberOfChannels);
            this._length = length;
            this._nativeOfflineAudioContext = nativeOfflineAudioContext;
            this._state = null;
        }
        get length() {
            // Bug #17: Safari does not yet expose the length.
            if (this._nativeOfflineAudioContext.length === undefined) return this._length;
            return this._nativeOfflineAudioContext.length;
        }
        get state() {
            return this._state === null ? this._nativeOfflineAudioContext.state : this._state;
        }
        startRendering() {
            /*
             * Bug #9 & #59: It is theoretically possible that startRendering() will first render a partialOfflineAudioContext. Therefore
             * the state of the nativeOfflineAudioContext might no transition to running immediately.
             */ if (this._state === 'running') return Promise.reject(createInvalidStateError());
            this._state = 'running';
            return startRendering(this.destination, this._nativeOfflineAudioContext).finally(()=>{
                this._state = null;
                (0, $6d385241f7fab45a$export$cbd606bc629ea938)(this);
            });
        }
        _waitForThePromiseToSettle(event) {
            if (this._state === null) this._nativeOfflineAudioContext.dispatchEvent(event);
            else setTimeout(()=>this._waitForThePromiseToSettle(event));
        }
    };
};





const $36f6248399d5f3b2$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    detune: 0,
    frequency: 440,
    periodicWave: undefined,
    type: 'sine'
};
const $36f6248399d5f3b2$export$c1c3584074b042b3 = (audioNodeConstructor, createAudioParam, createNativeOscillatorNode, createOscillatorNodeRenderer, getNativeContext, isNativeOfflineAudioContext, wrapEventListener)=>{
    return class OscillatorNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$36f6248399d5f3b2$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeOscillatorNode = createNativeOscillatorNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const oscillatorNodeRenderer = isOffline ? createOscillatorNodeRenderer() : null;
            const nyquist = context.sampleRate / 2;
            super(context, false, nativeOscillatorNode, oscillatorNodeRenderer);
            // Bug #81: Firefox & Safari do not export the correct values for maxValue and minValue.
            this._detune = createAudioParam(this, isOffline, nativeOscillatorNode.detune, 153600, -153600);
            // Bug #76: Safari does not export the correct values for maxValue and minValue.
            this._frequency = createAudioParam(this, isOffline, nativeOscillatorNode.frequency, nyquist, -nyquist);
            this._nativeOscillatorNode = nativeOscillatorNode;
            this._onended = null;
            this._oscillatorNodeRenderer = oscillatorNodeRenderer;
            if (this._oscillatorNodeRenderer !== null && mergedOptions.periodicWave !== undefined) this._oscillatorNodeRenderer.periodicWave = mergedOptions.periodicWave;
        }
        get detune() {
            return this._detune;
        }
        get frequency() {
            return this._frequency;
        }
        get onended() {
            return this._onended;
        }
        set onended(value) {
            const wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
            this._nativeOscillatorNode.onended = wrappedListener;
            const nativeOnEnded = this._nativeOscillatorNode.onended;
            this._onended = nativeOnEnded !== null && nativeOnEnded === wrappedListener ? value : nativeOnEnded;
        }
        get type() {
            return this._nativeOscillatorNode.type;
        }
        set type(value) {
            this._nativeOscillatorNode.type = value;
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.periodicWave = null;
        }
        setPeriodicWave(periodicWave) {
            this._nativeOscillatorNode.setPeriodicWave(periodicWave);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.periodicWave = periodicWave;
        }
        start(when = 0) {
            this._nativeOscillatorNode.start(when);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.start = when;
            if (this.context.state !== 'closed') {
                (0, $6f1d61f1020f6c58$export$88a47afdc0e8539c)(this);
                const resetInternalStateToPassive = ()=>{
                    this._nativeOscillatorNode.removeEventListener('ended', resetInternalStateToPassive);
                    if ((0, $74af653805090ad8$export$e44f0fc8e83fb084)(this)) (0, $b44e7990017a0eb4$export$7c0830f3a5100dec)(this);
                };
                this._nativeOscillatorNode.addEventListener('ended', resetInternalStateToPassive);
            }
        }
        stop(when = 0) {
            this._nativeOscillatorNode.stop(when);
            if (this._oscillatorNodeRenderer !== null) this._oscillatorNodeRenderer.stop = when;
        }
    };
};



const $0d4239b2159c3e55$export$99143538b3590be5 = (connectAudioParam, createNativeOscillatorNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeOscillatorNodes = new WeakMap();
        let periodicWave = null;
        let start = null;
        let stop = null;
        const createOscillatorNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeOscillatorNode = getNativeAudioNode(proxy);
            // If the initially used nativeOscillatorNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeOscillatorNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeOscillatorNode, nativeOfflineAudioContext);
            if (!nativeOscillatorNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeOscillatorNode.channelCount,
                    channelCountMode: nativeOscillatorNode.channelCountMode,
                    channelInterpretation: nativeOscillatorNode.channelInterpretation,
                    detune: nativeOscillatorNode.detune.value,
                    frequency: nativeOscillatorNode.frequency.value,
                    periodicWave: periodicWave === null ? undefined : periodicWave,
                    type: nativeOscillatorNode.type
                };
                nativeOscillatorNode = createNativeOscillatorNode(nativeOfflineAudioContext, options);
                if (start !== null) nativeOscillatorNode.start(start);
                if (stop !== null) nativeOscillatorNode.stop(stop);
            }
            renderedNativeOscillatorNodes.set(nativeOfflineAudioContext, nativeOscillatorNode);
            if (!nativeOscillatorNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.detune, nativeOscillatorNode.detune);
                await renderAutomation(nativeOfflineAudioContext, proxy.frequency, nativeOscillatorNode.frequency);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.detune, nativeOscillatorNode.detune);
                await connectAudioParam(nativeOfflineAudioContext, proxy.frequency, nativeOscillatorNode.frequency);
            }
            await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeOscillatorNode);
            return nativeOscillatorNode;
        };
        return {
            set periodicWave (value){
                periodicWave = value;
            },
            set start (value){
                start = value;
            },
            set stop (value){
                stop = value;
            },
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeOscillatorNode = renderedNativeOscillatorNodes.get(nativeOfflineAudioContext);
                if (renderedNativeOscillatorNode !== undefined) return Promise.resolve(renderedNativeOscillatorNode);
                return createOscillatorNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};



const $ab22fa9f2ae9cf1a$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'clamped-max',
    channelInterpretation: 'speakers',
    coneInnerAngle: 360,
    coneOuterAngle: 360,
    coneOuterGain: 0,
    distanceModel: 'inverse',
    maxDistance: 10000,
    orientationX: 1,
    orientationY: 0,
    orientationZ: 0,
    panningModel: 'equalpower',
    positionX: 0,
    positionY: 0,
    positionZ: 0,
    refDistance: 1,
    rolloffFactor: 1
};
const $ab22fa9f2ae9cf1a$export$91b046021cf98bac = (audioNodeConstructor, createAudioParam, createNativePannerNode, createPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class PannerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$ab22fa9f2ae9cf1a$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativePannerNode = createNativePannerNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const pannerNodeRenderer = isOffline ? createPannerNodeRenderer() : null;
            super(context, false, nativePannerNode, pannerNodeRenderer);
            this._nativePannerNode = nativePannerNode;
            // Bug #74: Safari does not export the correct values for maxValue and minValue.
            this._orientationX = createAudioParam(this, isOffline, nativePannerNode.orientationX, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._orientationY = createAudioParam(this, isOffline, nativePannerNode.orientationY, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._orientationZ = createAudioParam(this, isOffline, nativePannerNode.orientationZ, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._positionX = createAudioParam(this, isOffline, nativePannerNode.positionX, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._positionY = createAudioParam(this, isOffline, nativePannerNode.positionY, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            this._positionZ = createAudioParam(this, isOffline, nativePannerNode.positionZ, (0, $c205d95559d496ba$export$ab43bedd17d6a167), (0, $c205d95559d496ba$export$ced6a5c63b103b52));
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get coneInnerAngle() {
            return this._nativePannerNode.coneInnerAngle;
        }
        set coneInnerAngle(value) {
            this._nativePannerNode.coneInnerAngle = value;
        }
        get coneOuterAngle() {
            return this._nativePannerNode.coneOuterAngle;
        }
        set coneOuterAngle(value) {
            this._nativePannerNode.coneOuterAngle = value;
        }
        get coneOuterGain() {
            return this._nativePannerNode.coneOuterGain;
        }
        set coneOuterGain(value) {
            this._nativePannerNode.coneOuterGain = value;
        }
        get distanceModel() {
            return this._nativePannerNode.distanceModel;
        }
        set distanceModel(value) {
            this._nativePannerNode.distanceModel = value;
        }
        get maxDistance() {
            return this._nativePannerNode.maxDistance;
        }
        set maxDistance(value) {
            this._nativePannerNode.maxDistance = value;
        }
        get orientationX() {
            return this._orientationX;
        }
        get orientationY() {
            return this._orientationY;
        }
        get orientationZ() {
            return this._orientationZ;
        }
        get panningModel() {
            return this._nativePannerNode.panningModel;
        }
        set panningModel(value) {
            this._nativePannerNode.panningModel = value;
        }
        get positionX() {
            return this._positionX;
        }
        get positionY() {
            return this._positionY;
        }
        get positionZ() {
            return this._positionZ;
        }
        get refDistance() {
            return this._nativePannerNode.refDistance;
        }
        set refDistance(value) {
            this._nativePannerNode.refDistance = value;
        }
        get rolloffFactor() {
            return this._nativePannerNode.rolloffFactor;
        }
        set rolloffFactor(value) {
            this._nativePannerNode.rolloffFactor = value;
        }
    };
};




const $23fb3d183f13b7ce$export$ccd091498494025 = (connectAudioParam, createNativeChannelMergerNode, createNativeConstantSourceNode, createNativeGainNode, createNativePannerNode, getNativeAudioNode, nativeOfflineAudioContextConstructor, renderAutomation, renderInputsOfAudioNode, renderNativeOfflineAudioContext)=>{
    return ()=>{
        const renderedNativeAudioNodes = new WeakMap();
        let renderedBufferPromise = null;
        const createAudioNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeGainNode = null;
            let nativePannerNode = getNativeAudioNode(proxy);
            const commonAudioNodeOptions = {
                channelCount: nativePannerNode.channelCount,
                channelCountMode: nativePannerNode.channelCountMode,
                channelInterpretation: nativePannerNode.channelInterpretation
            };
            const commonNativePannerNodeOptions = {
                ...commonAudioNodeOptions,
                coneInnerAngle: nativePannerNode.coneInnerAngle,
                coneOuterAngle: nativePannerNode.coneOuterAngle,
                coneOuterGain: nativePannerNode.coneOuterGain,
                distanceModel: nativePannerNode.distanceModel,
                maxDistance: nativePannerNode.maxDistance,
                panningModel: nativePannerNode.panningModel,
                refDistance: nativePannerNode.refDistance,
                rolloffFactor: nativePannerNode.rolloffFactor
            };
            // If the initially used nativePannerNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativePannerNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativePannerNode, nativeOfflineAudioContext);
            // Bug #124: Safari does not support modifying the orientation and the position with AudioParams.
            if ('bufferSize' in nativePannerNode) nativeGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                ...commonAudioNodeOptions,
                gain: 1
            });
            else if (!nativePannerNodeIsOwnedByContext) {
                const options = {
                    ...commonNativePannerNodeOptions,
                    orientationX: nativePannerNode.orientationX.value,
                    orientationY: nativePannerNode.orientationY.value,
                    orientationZ: nativePannerNode.orientationZ.value,
                    positionX: nativePannerNode.positionX.value,
                    positionY: nativePannerNode.positionY.value,
                    positionZ: nativePannerNode.positionZ.value
                };
                nativePannerNode = createNativePannerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeAudioNodes.set(nativeOfflineAudioContext, nativeGainNode === null ? nativePannerNode : nativeGainNode);
            if (nativeGainNode !== null) {
                if (renderedBufferPromise === null) {
                    if (nativeOfflineAudioContextConstructor === null) throw new Error('Missing the native OfflineAudioContext constructor.');
                    const partialOfflineAudioContext = new nativeOfflineAudioContextConstructor(6, // Bug #17: Safari does not yet expose the length.
                    proxy.context.length, nativeOfflineAudioContext.sampleRate);
                    const nativeChannelMergerNode = createNativeChannelMergerNode(partialOfflineAudioContext, {
                        channelCount: 1,
                        channelCountMode: 'explicit',
                        channelInterpretation: 'speakers',
                        numberOfInputs: 6
                    });
                    nativeChannelMergerNode.connect(partialOfflineAudioContext.destination);
                    renderedBufferPromise = (async ()=>{
                        const nativeConstantSourceNodes = await Promise.all([
                            proxy.orientationX,
                            proxy.orientationY,
                            proxy.orientationZ,
                            proxy.positionX,
                            proxy.positionY,
                            proxy.positionZ
                        ].map(async (audioParam, index)=>{
                            const nativeConstantSourceNode = createNativeConstantSourceNode(partialOfflineAudioContext, {
                                channelCount: 1,
                                channelCountMode: 'explicit',
                                channelInterpretation: 'discrete',
                                offset: index === 0 ? 1 : 0
                            });
                            await renderAutomation(partialOfflineAudioContext, audioParam, nativeConstantSourceNode.offset);
                            return nativeConstantSourceNode;
                        }));
                        for(let i = 0; i < 6; i += 1){
                            nativeConstantSourceNodes[i].connect(nativeChannelMergerNode, 0, i);
                            nativeConstantSourceNodes[i].start(0);
                        }
                        return renderNativeOfflineAudioContext(partialOfflineAudioContext);
                    })();
                }
                const renderedBuffer = await renderedBufferPromise;
                const inputGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    ...commonAudioNodeOptions,
                    gain: 1
                });
                await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, inputGainNode);
                const channelDatas = [];
                for(let i = 0; i < renderedBuffer.numberOfChannels; i += 1)channelDatas.push(renderedBuffer.getChannelData(i));
                let lastOrientation = [
                    channelDatas[0][0],
                    channelDatas[1][0],
                    channelDatas[2][0]
                ];
                let lastPosition = [
                    channelDatas[3][0],
                    channelDatas[4][0],
                    channelDatas[5][0]
                ];
                let gateGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                    ...commonAudioNodeOptions,
                    gain: 1
                });
                let partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, {
                    ...commonNativePannerNodeOptions,
                    orientationX: lastOrientation[0],
                    orientationY: lastOrientation[1],
                    orientationZ: lastOrientation[2],
                    positionX: lastPosition[0],
                    positionY: lastPosition[1],
                    positionZ: lastPosition[2]
                });
                inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                partialPannerNode.connect(nativeGainNode);
                for(let i = 128; i < renderedBuffer.length; i += 128){
                    const orientation = [
                        channelDatas[0][i],
                        channelDatas[1][i],
                        channelDatas[2][i]
                    ];
                    const positon = [
                        channelDatas[3][i],
                        channelDatas[4][i],
                        channelDatas[5][i]
                    ];
                    if (orientation.some((value, index)=>value !== lastOrientation[index]) || positon.some((value, index)=>value !== lastPosition[index])) {
                        lastOrientation = orientation;
                        lastPosition = positon;
                        const currentTime = i / nativeOfflineAudioContext.sampleRate;
                        gateGainNode.gain.setValueAtTime(0, currentTime);
                        gateGainNode = createNativeGainNode(nativeOfflineAudioContext, {
                            ...commonAudioNodeOptions,
                            gain: 0
                        });
                        partialPannerNode = createNativePannerNode(nativeOfflineAudioContext, {
                            ...commonNativePannerNodeOptions,
                            orientationX: lastOrientation[0],
                            orientationY: lastOrientation[1],
                            orientationZ: lastOrientation[2],
                            positionX: lastPosition[0],
                            positionY: lastPosition[1],
                            positionZ: lastPosition[2]
                        });
                        gateGainNode.gain.setValueAtTime(1, currentTime);
                        inputGainNode.connect(gateGainNode).connect(partialPannerNode.inputs[0]);
                        partialPannerNode.connect(nativeGainNode);
                    }
                }
                return nativeGainNode;
            }
            if (!nativePannerNodeIsOwnedByContext) {
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX);
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY);
                await renderAutomation(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY);
                await renderAutomation(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ);
            } else {
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationX, nativePannerNode.orientationX);
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationY, nativePannerNode.orientationY);
                await connectAudioParam(nativeOfflineAudioContext, proxy.orientationZ, nativePannerNode.orientationZ);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionX, nativePannerNode.positionX);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionY, nativePannerNode.positionY);
                await connectAudioParam(nativeOfflineAudioContext, proxy.positionZ, nativePannerNode.positionZ);
            }
            if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativePannerNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativePannerNode);
            return nativePannerNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeGainNodeOrNativePannerNode = renderedNativeAudioNodes.get(nativeOfflineAudioContext);
                if (renderedNativeGainNodeOrNativePannerNode !== undefined) return Promise.resolve(renderedNativeGainNodeOrNativePannerNode);
                return createAudioNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $51d2e80f451b9759$var$DEFAULT_OPTIONS = {
    disableNormalization: false
};
const $51d2e80f451b9759$export$10e47cfa48a5069d = (createNativePeriodicWave, getNativeContext, periodicWaveStore, sanitizePeriodicWaveOptions)=>{
    return class PeriodicWave {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = sanitizePeriodicWaveOptions({
                ...$51d2e80f451b9759$var$DEFAULT_OPTIONS,
                ...options
            });
            const periodicWave = createNativePeriodicWave(nativeContext, mergedOptions);
            periodicWaveStore.add(periodicWave);
            // This does violate all good pratices but it is used here to simplify the handling of periodic waves.
            return periodicWave;
        }
        static [Symbol.hasInstance](instance) {
            return instance !== null && typeof instance === 'object' && Object.getPrototypeOf(instance) === PeriodicWave.prototype || periodicWaveStore.has(instance);
        }
    };
};


const $49e48dbdfe378aa1$export$889eef7d338963f6 = (getAudioParamRenderer, renderInputsOfAudioParam)=>{
    return (nativeOfflineAudioContext, audioParam, nativeAudioParam)=>{
        const audioParamRenderer = getAudioParamRenderer(audioParam);
        audioParamRenderer.replay(nativeAudioParam);
        return renderInputsOfAudioParam(audioParam, nativeOfflineAudioContext, nativeAudioParam);
    };
};


const $d2ccdaf328a083a6$export$cff0938ddf51f6f4 = (getAudioNodeConnections, getAudioNodeRenderer, isPartOfACycle)=>{
    return async (audioNode, nativeOfflineAudioContext, nativeAudioNode)=>{
        const audioNodeConnections = getAudioNodeConnections(audioNode);
        await Promise.all(audioNodeConnections.activeInputs.map((connections, input)=>Array.from(connections).map(async ([source, output])=>{
                const audioNodeRenderer = getAudioNodeRenderer(source);
                const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
                const destination = audioNode.context.destination;
                if (!isPartOfACycle(source) && (audioNode !== destination || !isPartOfACycle(audioNode))) renderedNativeAudioNode.connect(nativeAudioNode, output, input);
            })).reduce((allRenderingPromises, renderingPromises)=>[
                ...allRenderingPromises,
                ...renderingPromises
            ], []));
    };
};


const $6ca48f6db88647ab$export$82cd58acb1062198 = (getAudioNodeRenderer, getAudioParamConnections, isPartOfACycle)=>{
    return async (audioParam, nativeOfflineAudioContext, nativeAudioParam)=>{
        const audioParamConnections = getAudioParamConnections(audioParam);
        await Promise.all(Array.from(audioParamConnections.activeInputs).map(async ([source, output])=>{
            const audioNodeRenderer = getAudioNodeRenderer(source);
            const renderedNativeAudioNode = await audioNodeRenderer.render(source, nativeOfflineAudioContext);
            if (!isPartOfACycle(source)) renderedNativeAudioNode.connect(nativeAudioParam, output);
        }));
    };
};



const $ed4f60f8df7f2dc8$export$feb8d4a8e403af48 = (cacheTestResult, createNativeGainNode, createNativeScriptProcessorNode, testOfflineAudioContextCurrentTimeSupport)=>{
    return (nativeOfflineAudioContext)=>{
        // Bug #21: Safari does not support promises yet.
        if (cacheTestResult((0, $4590a073dac74a1e$export$9ec44223b1284cd4), ()=>(0, $4590a073dac74a1e$export$9ec44223b1284cd4)(nativeOfflineAudioContext))) // Bug #158: Chrome and Edge do not advance currentTime if it is not accessed while rendering the audio.
        return Promise.resolve(cacheTestResult(testOfflineAudioContextCurrentTimeSupport, testOfflineAudioContextCurrentTimeSupport)).then((isOfflineAudioContextCurrentTimeSupported)=>{
            if (!isOfflineAudioContextCurrentTimeSupported) {
                const scriptProcessorNode = createNativeScriptProcessorNode(nativeOfflineAudioContext, 512, 0, 1);
                nativeOfflineAudioContext.oncomplete = ()=>{
                    scriptProcessorNode.onaudioprocess = null; // tslint:disable-line:deprecation
                    scriptProcessorNode.disconnect();
                };
                scriptProcessorNode.onaudioprocess = ()=>nativeOfflineAudioContext.currentTime; // tslint:disable-line:deprecation
                scriptProcessorNode.connect(nativeOfflineAudioContext.destination);
            }
            return nativeOfflineAudioContext.startRendering();
        });
        return new Promise((resolve)=>{
            // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
            const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
                channelCount: 1,
                channelCountMode: 'explicit',
                channelInterpretation: 'discrete',
                gain: 0
            });
            nativeOfflineAudioContext.oncomplete = (event)=>{
                gainNode.disconnect();
                resolve(event.renderedBuffer);
            };
            gainNode.connect(nativeOfflineAudioContext.destination);
            nativeOfflineAudioContext.startRendering();
        });
    };
};


const $880c6c9afb613707$export$17328c9508de4388 = (activeAudioWorkletNodeInputsStore)=>{
    return (nativeAudioWorkletNode, activeInputs)=>{
        activeAudioWorkletNodeInputsStore.set(nativeAudioWorkletNode, activeInputs);
    };
};


const $63b106594231aed7$export$c5e78cc8035d00aa = (audioNodeTailTimeStore)=>{
    return (audioNode, tailTime)=>audioNodeTailTimeStore.set(audioNode, tailTime);
};



const $e1a515c24adcdd0a$export$a04cd80dfb1b8309 = (audioBufferStore, cacheTestResult, getAudioNodeRenderer, getUnrenderedAudioWorkletNodes, renderNativeOfflineAudioContext, testAudioBufferCopyChannelMethodsOutOfBoundsSupport, wrapAudioBufferCopyChannelMethods, wrapAudioBufferCopyChannelMethodsOutOfBounds)=>{
    return (destination, nativeOfflineAudioContext)=>getAudioNodeRenderer(destination).render(destination, nativeOfflineAudioContext)/*
         * Bug #86 & #87: Invoking the renderer of an AudioWorkletNode might be necessary if it has no direct or indirect connection to the
         * destination.
         */ .then(()=>Promise.all(Array.from(getUnrenderedAudioWorkletNodes(nativeOfflineAudioContext)).map((audioWorkletNode)=>getAudioNodeRenderer(audioWorkletNode).render(audioWorkletNode, nativeOfflineAudioContext)))).then(()=>renderNativeOfflineAudioContext(nativeOfflineAudioContext)).then((audioBuffer)=>{
            // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
            // Bug #100: Safari does throw a wrong error when calling getChannelData() with an out-of-bounds value.
            if (typeof audioBuffer.copyFromChannel !== 'function') {
                wrapAudioBufferCopyChannelMethods(audioBuffer);
                (0, $e0def92b41d2ffa5$export$df65309cf6249598)(audioBuffer);
            // Bug #157: Firefox does not allow the bufferOffset to be out-of-bounds.
            } else if (!cacheTestResult(testAudioBufferCopyChannelMethodsOutOfBoundsSupport, ()=>testAudioBufferCopyChannelMethodsOutOfBoundsSupport(audioBuffer))) wrapAudioBufferCopyChannelMethodsOutOfBounds(audioBuffer);
            audioBufferStore.add(audioBuffer);
            return audioBuffer;
        });
};


const $24f00fc15291a590$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    /*
     * Bug #105: The channelCountMode should be 'clamped-max' according to the spec but is set to 'explicit' to achieve consistent
     * behavior.
     */ channelCountMode: 'explicit',
    channelInterpretation: 'speakers',
    pan: 0
};
const $24f00fc15291a590$export$9b005b0c35721c84 = (audioNodeConstructor, createAudioParam, createNativeStereoPannerNode, createStereoPannerNodeRenderer, getNativeContext, isNativeOfflineAudioContext)=>{
    return class StereoPannerNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$24f00fc15291a590$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeStereoPannerNode = createNativeStereoPannerNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const stereoPannerNodeRenderer = isOffline ? createStereoPannerNodeRenderer() : null;
            super(context, false, nativeStereoPannerNode, stereoPannerNodeRenderer);
            this._pan = createAudioParam(this, isOffline, nativeStereoPannerNode.pan);
        }
        get pan() {
            return this._pan;
        }
    };
};




const $32b7f7e177963e5c$export$3ba9002bd6b539cf = (connectAudioParam, createNativeStereoPannerNode, getNativeAudioNode, renderAutomation, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeStereoPannerNodes = new WeakMap();
        const createStereoPannerNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeStereoPannerNode = getNativeAudioNode(proxy);
            /*
             * If the initially used nativeStereoPannerNode was not constructed on the same OfflineAudioContext it needs to be created
             * again.
             */ const nativeStereoPannerNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeStereoPannerNode, nativeOfflineAudioContext);
            if (!nativeStereoPannerNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeStereoPannerNode.channelCount,
                    channelCountMode: nativeStereoPannerNode.channelCountMode,
                    channelInterpretation: nativeStereoPannerNode.channelInterpretation,
                    pan: nativeStereoPannerNode.pan.value
                };
                nativeStereoPannerNode = createNativeStereoPannerNode(nativeOfflineAudioContext, options);
            }
            renderedNativeStereoPannerNodes.set(nativeOfflineAudioContext, nativeStereoPannerNode);
            if (!nativeStereoPannerNodeIsOwnedByContext) await renderAutomation(nativeOfflineAudioContext, proxy.pan, nativeStereoPannerNode.pan);
            else await connectAudioParam(nativeOfflineAudioContext, proxy.pan, nativeStereoPannerNode.pan);
            if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeStereoPannerNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeStereoPannerNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeStereoPannerNode);
            return nativeStereoPannerNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeStereoPannerNode = renderedNativeStereoPannerNodes.get(nativeOfflineAudioContext);
                if (renderedNativeStereoPannerNode !== undefined) return Promise.resolve(renderedNativeStereoPannerNode);
                return createStereoPannerNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


// Bug #33: Safari exposes an AudioBuffer but it can't be used as a constructor.
const $3988bd8c6f69cf53$export$5bddcff46df9c642 = (nativeAudioBufferConstructor)=>{
    return ()=>{
        if (nativeAudioBufferConstructor === null) return false;
        try {
            new nativeAudioBufferConstructor({
                length: 1,
                sampleRate: 44100
            }); // tslint:disable-line:no-unused-expression
        } catch  {
            return false;
        }
        return true;
    };
};


/*
 * Firefox up to version 67 didn't fully support the copyFromChannel() and copyToChannel() methods. Therefore testing one of those methods
 * is enough to know if the other one is supported as well.
 */ const $05c9e19f79e8946a$export$1995b5466f5c2709 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeAudioBuffer = nativeOfflineAudioContext.createBuffer(1, 1, 44100);
        // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
        if (nativeAudioBuffer.copyToChannel === undefined) return true;
        const source = new Float32Array(2);
        try {
            nativeAudioBuffer.copyFromChannel(source, 0, 0);
        } catch  {
            return false;
        }
        return true;
    };
};


const $7b65ce19fe8f2342$export$34981ee6aafdf532 = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        // Try to check the prototype before constructing the AudioContext.
        if (nativeAudioContextConstructor.prototype !== undefined && nativeAudioContextConstructor.prototype.close !== undefined) return true;
        const audioContext = new nativeAudioContextConstructor();
        const isAudioContextClosable = audioContext.close !== undefined;
        try {
            audioContext.close();
        } catch  {
        // Ignore errors.
        }
        return isAudioContextClosable;
    };
};


/**
 * Edge up to version 14, Firefox up to version 52, Safari up to version 9 and maybe other browsers
 * did not refuse to decode invalid parameters with a TypeError.
 */ const $8590d5b2ea257754$export$622ba23aa6b35822 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #21: Safari does not support promises yet.
        return new Promise((resolve)=>{
            let isPending = true;
            const resolvePromise = (err)=>{
                if (isPending) {
                    isPending = false;
                    offlineAudioContext.startRendering();
                    resolve(err instanceof TypeError);
                }
            };
            let promise;
            // Bug #26: Safari throws a synchronous error.
            try {
                promise = offlineAudioContext// Bug #1: Safari requires a successCallback.
                .decodeAudioData(null, ()=>{
                // Ignore the success callback.
                }, resolvePromise);
            } catch (err) {
                resolvePromise(err);
            }
            // Bug #21: Safari does not support promises yet.
            if (promise !== undefined) // Bug #6: Chrome, Edge and Firefox do not call the errorCallback.
            promise.catch(resolvePromise);
        });
    };
};


const $867de883ce43c047$export$2f44088abd2df2e = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        let audioContext;
        try {
            audioContext = new nativeAudioContextConstructor({
                latencyHint: 'balanced'
            });
        } catch  {
            return false;
        }
        audioContext.close();
        return true;
    };
};


// Safari up to version 12.0 (but not v12.1) didn't return the destination in case it was an AudioNode.
const $c42fe39c700d4e84$export$f77a3bce7e4efd81 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeGainNode = nativeOfflineAudioContext.createGain();
        const isSupported = nativeGainNode.connect(nativeGainNode) === nativeGainNode;
        nativeGainNode.disconnect(nativeGainNode);
        return isSupported;
    };
};


/**
 * Chrome version 66 and 67 did not call the process() function of an AudioWorkletProcessor if it had no outputs. AudioWorklet support was
 * enabled by default in version 66.
 */ const $071627c414f7ce66$export$ce5ba80a98dc0ba7 = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor)=>{
    return async ()=>{
        // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
        if (nativeAudioWorkletNodeConstructor === null) return true;
        if (nativeOfflineAudioContextConstructor === null) return false;
        const blob = new Blob([
            'let c,p;class A extends AudioWorkletProcessor{constructor(){super();this.port.onmessage=(e)=>{p=e.data;p.onmessage=()=>{p.postMessage(c);p.close()};this.port.postMessage(0)}}process(){c=1}}registerProcessor("a",A)'
        ], {
            type: 'application/javascript; charset=utf-8'
        });
        const messageChannel = new MessageChannel();
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
        const url = URL.createObjectURL(blob);
        let isCallingProcess = false;
        try {
            await offlineAudioContext.audioWorklet.addModule(url);
            const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
                numberOfOutputs: 0
            });
            const oscillator = offlineAudioContext.createOscillator();
            await new Promise((resolve)=>{
                audioWorkletNode.port.onmessage = ()=>resolve();
                audioWorkletNode.port.postMessage(messageChannel.port2, [
                    messageChannel.port2
                ]);
            });
            audioWorkletNode.port.onmessage = ()=>isCallingProcess = true;
            oscillator.connect(audioWorkletNode);
            oscillator.start(0);
            await offlineAudioContext.startRendering();
            isCallingProcess = await new Promise((resolve)=>{
                messageChannel.port1.onmessage = ({ data: data })=>resolve(data === 1);
                messageChannel.port1.postMessage(0);
            });
        } catch  {
        // Ignore errors.
        } finally{
            messageChannel.port1.close();
            URL.revokeObjectURL(url);
        }
        return isCallingProcess;
    };
};


// Bug #179: Firefox does not allow to transfer any buffer which has been passed to the process() method as an argument.
const $f022a9196cd0a0cb$export$19b2cf184a7cfba8 = (nativeAudioWorkletNodeConstructor, nativeOfflineAudioContextConstructor)=>{
    return async ()=>{
        // Bug #61: If there is no native AudioWorkletNode it gets faked and therefore it is no problem if the it doesn't exist.
        if (nativeAudioWorkletNodeConstructor === null) return true;
        if (nativeOfflineAudioContextConstructor === null) return false;
        const blob = new Blob([
            'class A extends AudioWorkletProcessor{process(i){this.port.postMessage(i,[i[0][0].buffer])}}registerProcessor("a",A)'
        ], {
            type: 'application/javascript; charset=utf-8'
        });
        // Bug #141: Safari does not support creating an OfflineAudioContext with less than 44100 Hz.
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 128, 44100);
        const url = URL.createObjectURL(blob);
        let isEmittingMessageEvents = false;
        let isEmittingProcessorErrorEvents = false;
        try {
            await offlineAudioContext.audioWorklet.addModule(url);
            const audioWorkletNode = new nativeAudioWorkletNodeConstructor(offlineAudioContext, 'a', {
                numberOfOutputs: 0
            });
            const oscillator = offlineAudioContext.createOscillator();
            audioWorkletNode.port.onmessage = ()=>isEmittingMessageEvents = true;
            audioWorkletNode.onprocessorerror = ()=>isEmittingProcessorErrorEvents = true;
            oscillator.connect(audioWorkletNode);
            oscillator.start(0);
            await offlineAudioContext.startRendering();
            // Bug #197: Safari does not deliver the messages before the promise returned by startRendering() resolves.
            await new Promise((resolve)=>setTimeout(resolve));
        } catch  {
        // Ignore errors.
        } finally{
            URL.revokeObjectURL(url);
        }
        return isEmittingMessageEvents && !isEmittingProcessorErrorEvents;
    };
};


/**
 * Firefox up to version 69 did not throw an error when setting a different channelCount or channelCountMode.
 */ const $29d0b5a6333bdcd2$export$a04037cfe0b977fa = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeChannelMergerNode = offlineAudioContext.createChannelMerger();
        /**
         * Bug #15: Safari does not return the default properties. It still needs to be patched. This test is supposed to test the support
         * in other browsers.
         */ if (nativeChannelMergerNode.channelCountMode === 'max') return true;
        try {
            nativeChannelMergerNode.channelCount = 2;
        } catch  {
            return true;
        }
        return false;
    };
};


const $b8e9b03ced2f5e1d$export$63ae3ec177f0ed66 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeOfflineAudioContext.createConstantSource === undefined) return true;
        const nativeConstantSourceNode = nativeOfflineAudioContext.createConstantSource();
        /*
         * @todo This is using bug #75 to detect bug #70. That works because both bugs were unique to
         * the implementation of Firefox right now, but it could probably be done in a better way.
         */ return nativeConstantSourceNode.offset.maxValue !== Number.POSITIVE_INFINITY;
    };
};


// Opera up to version 57 did not allow to reassign the buffer of a ConvolverNode.
const $ae5370edee7f0789$export$b6f3c4027f959b95 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeConvolverNode = offlineAudioContext.createConvolver();
        nativeConvolverNode.buffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
        try {
            nativeConvolverNode.buffer = offlineAudioContext.createBuffer(1, 1, offlineAudioContext.sampleRate);
        } catch  {
            return false;
        }
        return true;
    };
};


// Chrome up to version v80, Edge up to version v80 and Opera up to version v67 did not allow to set the channelCount property of a ConvolverNode to 1. They also did not allow to set the channelCountMode to 'explicit'.
const $9794ec347afccbb2$export$d1bddb88e5c21d26 = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return false;
        const offlineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        const nativeConvolverNode = offlineAudioContext.createConvolver();
        try {
            nativeConvolverNode.channelCount = 1;
        } catch  {
            return false;
        }
        return true;
    };
};


const $e9f4e2f4c6bba1a3$export$41669e689e17d4f0 = (window)=>{
    return ()=>window !== null && window.hasOwnProperty('isSecureContext');
};


// Firefox up to version 68 did not throw an error when creating a MediaStreamAudioSourceNode with a mediaStream that had no audio track.
const $a6a66a7e2897c896$export$416bb3b14425e126 = (nativeAudioContextConstructor)=>{
    return ()=>{
        if (nativeAudioContextConstructor === null) return false;
        const audioContext = new nativeAudioContextConstructor();
        try {
            audioContext.createMediaStreamSource(new MediaStream());
            return false;
        } catch (err) {
            return true;
        } finally{
            audioContext.close();
        }
    };
};


const $5c0e2069a30b8db9$export$6db7e9dd49157213 = (createNativeGainNode, nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        // Bug #48: Safari does not render an OfflineAudioContext without any connected node.
        const gainNode = createNativeGainNode(nativeOfflineAudioContext, {
            channelCount: 1,
            channelCountMode: 'explicit',
            channelInterpretation: 'discrete',
            gain: 0
        });
        // Bug #21: Safari does not support promises yet.
        return new Promise((resolve)=>{
            nativeOfflineAudioContext.oncomplete = ()=>{
                gainNode.disconnect();
                resolve(nativeOfflineAudioContext.currentTime !== 0);
            };
            nativeOfflineAudioContext.startRendering();
        });
    };
};


/**
 * Firefox up to version 62 did not kick off the processing of the StereoPannerNode if the value of pan was zero.
 */ const $19fdb5dea8c1aa58$export$5ea70af76c7a03fc = (nativeOfflineAudioContextConstructor)=>{
    return ()=>{
        if (nativeOfflineAudioContextConstructor === null) return Promise.resolve(false);
        const nativeOfflineAudioContext = new nativeOfflineAudioContextConstructor(1, 1, 44100);
        /*
         * Bug #105: Safari does not support the StereoPannerNode. Therefore the returned value should normally be false but the faker does
         * support the tested behaviour.
         */ if (nativeOfflineAudioContext.createStereoPanner === undefined) return Promise.resolve(true);
        // Bug #62: Safari does not support ConstantSourceNodes.
        if (nativeOfflineAudioContext.createConstantSource === undefined) return Promise.resolve(true);
        const constantSourceNode = nativeOfflineAudioContext.createConstantSource();
        const stereoPanner = nativeOfflineAudioContext.createStereoPanner();
        constantSourceNode.channelCount = 1;
        constantSourceNode.offset.value = 1;
        stereoPanner.channelCount = 1;
        constantSourceNode.start();
        constantSourceNode.connect(stereoPanner).connect(nativeOfflineAudioContext.destination);
        return nativeOfflineAudioContext.startRendering().then((buffer)=>buffer.getChannelData(0)[0] !== 1);
    };
};


const $d528121802615e67$export$988fb803bae63f80 = ()=>new DOMException('', 'UnknownError');


const $58dd6b66debb262c$var$DEFAULT_OPTIONS = {
    channelCount: 2,
    channelCountMode: 'max',
    channelInterpretation: 'speakers',
    curve: null,
    oversample: 'none'
};
const $58dd6b66debb262c$export$3a30e911e17b1cf5 = (audioNodeConstructor, createInvalidStateError, createNativeWaveShaperNode, createWaveShaperNodeRenderer, getNativeContext, isNativeOfflineAudioContext, setAudioNodeTailTime)=>{
    return class WaveShaperNode extends audioNodeConstructor {
        constructor(context, options){
            const nativeContext = getNativeContext(context);
            const mergedOptions = {
                ...$58dd6b66debb262c$var$DEFAULT_OPTIONS,
                ...options
            };
            const nativeWaveShaperNode = createNativeWaveShaperNode(nativeContext, mergedOptions);
            const isOffline = isNativeOfflineAudioContext(nativeContext);
            const waveShaperNodeRenderer = isOffline ? createWaveShaperNodeRenderer() : null;
            // @todo Add a mechanism to only switch a WaveShaperNode to active while it is connected.
            super(context, true, nativeWaveShaperNode, waveShaperNodeRenderer);
            this._isCurveNullified = false;
            this._nativeWaveShaperNode = nativeWaveShaperNode;
            // @todo Determine a meaningful tail-time instead of just using one second.
            setAudioNodeTailTime(this, 1);
        }
        get curve() {
            if (this._isCurveNullified) return null;
            return this._nativeWaveShaperNode.curve;
        }
        set curve(value) {
            // Bug #103: Safari does not allow to set the curve to null.
            if (value === null) {
                this._isCurveNullified = true;
                this._nativeWaveShaperNode.curve = new Float32Array([
                    0,
                    0
                ]);
            } else {
                // Bug #102: Safari does not throw an InvalidStateError when the curve has less than two samples.
                // Bug #104: Chrome and Edge will throw an InvalidAccessError when the curve has less than two samples.
                if (value.length < 2) throw createInvalidStateError();
                this._isCurveNullified = false;
                this._nativeWaveShaperNode.curve = value;
            }
        }
        get oversample() {
            return this._nativeWaveShaperNode.oversample;
        }
        set oversample(value) {
            this._nativeWaveShaperNode.oversample = value;
        }
    };
};




const $99a27f25a76706ec$export$9709a48a5037d121 = (createNativeWaveShaperNode, getNativeAudioNode, renderInputsOfAudioNode)=>{
    return ()=>{
        const renderedNativeWaveShaperNodes = new WeakMap();
        const createWaveShaperNode = async (proxy, nativeOfflineAudioContext)=>{
            let nativeWaveShaperNode = getNativeAudioNode(proxy);
            // If the initially used nativeWaveShaperNode was not constructed on the same OfflineAudioContext it needs to be created again.
            const nativeWaveShaperNodeIsOwnedByContext = (0, $ce0defe62edd7ea8$export$4bd7a4bf54ca80bc)(nativeWaveShaperNode, nativeOfflineAudioContext);
            if (!nativeWaveShaperNodeIsOwnedByContext) {
                const options = {
                    channelCount: nativeWaveShaperNode.channelCount,
                    channelCountMode: nativeWaveShaperNode.channelCountMode,
                    channelInterpretation: nativeWaveShaperNode.channelInterpretation,
                    curve: nativeWaveShaperNode.curve,
                    oversample: nativeWaveShaperNode.oversample
                };
                nativeWaveShaperNode = createNativeWaveShaperNode(nativeOfflineAudioContext, options);
            }
            renderedNativeWaveShaperNodes.set(nativeOfflineAudioContext, nativeWaveShaperNode);
            if ((0, $0b958e40cf81116d$export$ac2aef07f705aa48)(nativeWaveShaperNode)) await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeWaveShaperNode.inputs[0]);
            else await renderInputsOfAudioNode(proxy, nativeOfflineAudioContext, nativeWaveShaperNode);
            return nativeWaveShaperNode;
        };
        return {
            render (proxy, nativeOfflineAudioContext) {
                const renderedNativeWaveShaperNode = renderedNativeWaveShaperNodes.get(nativeOfflineAudioContext);
                if (renderedNativeWaveShaperNode !== undefined) return Promise.resolve(renderedNativeWaveShaperNode);
                return createWaveShaperNode(proxy, nativeOfflineAudioContext);
            }
        };
    };
};


const $26d12d47448d9dca$export$ba255020126e276e = ()=>typeof window === 'undefined' ? null : window;


const $f2cd13b04f18ee3f$export$dbf1ce6ba2b4bc6a = (convertNumberToUnsignedLong, createIndexSizeError)=>{
    return (audioBuffer)=>{
        audioBuffer.copyFromChannel = (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
            const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
            const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
            if (channelNumber >= audioBuffer.numberOfChannels) throw createIndexSizeError();
            const audioBufferLength = audioBuffer.length;
            const channelData = audioBuffer.getChannelData(channelNumber);
            const destinationLength = destination.length;
            for(let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < destinationLength; i += 1)destination[i] = channelData[i + bufferOffset];
        };
        audioBuffer.copyToChannel = (source, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
            const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
            const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
            if (channelNumber >= audioBuffer.numberOfChannels) throw createIndexSizeError();
            const audioBufferLength = audioBuffer.length;
            const channelData = audioBuffer.getChannelData(channelNumber);
            const sourceLength = source.length;
            for(let i = bufferOffset < 0 ? -bufferOffset : 0; i + bufferOffset < audioBufferLength && i < sourceLength; i += 1)channelData[i + bufferOffset] = source[i];
        };
    };
};


const $15fe4df42e65956b$export$bff9a41e76b37a6e = (convertNumberToUnsignedLong)=>{
    return (audioBuffer)=>{
        audioBuffer.copyFromChannel = ((copyFromChannel)=>{
            return (destination, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
                const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
                const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
                if (bufferOffset < audioBuffer.length) return copyFromChannel.call(audioBuffer, destination, channelNumber, bufferOffset);
            };
        })(audioBuffer.copyFromChannel);
        audioBuffer.copyToChannel = ((copyToChannel)=>{
            return (source, channelNumberAsNumber, bufferOffsetAsNumber = 0)=>{
                const bufferOffset = convertNumberToUnsignedLong(bufferOffsetAsNumber);
                const channelNumber = convertNumberToUnsignedLong(channelNumberAsNumber);
                if (bufferOffset < audioBuffer.length) return copyToChannel.call(audioBuffer, source, channelNumber, bufferOffset);
            };
        })(audioBuffer.copyToChannel);
    };
};


const $0b1629607149f116$export$3c1722ed0f0ed532 = (overwriteAccessors)=>{
    return (nativeAudioBufferSourceNode, nativeContext)=>{
        const nullifiedBuffer = nativeContext.createBuffer(1, 1, 44100);
        if (nativeAudioBufferSourceNode.buffer === null) nativeAudioBufferSourceNode.buffer = nullifiedBuffer;
        overwriteAccessors(nativeAudioBufferSourceNode, 'buffer', (get)=>()=>{
                const value = get.call(nativeAudioBufferSourceNode);
                return value === nullifiedBuffer ? null : value;
            }, (set)=>(value)=>{
                return set.call(nativeAudioBufferSourceNode, value === null ? nullifiedBuffer : value);
            });
    };
};


const $afaabbfeccddeb33$export$162785cfa8a63221 = (createInvalidStateError, monitorConnections)=>{
    return (nativeContext, channelMergerNode)=>{
        // Bug #15: Safari does not return the default properties.
        channelMergerNode.channelCount = 1;
        channelMergerNode.channelCountMode = 'explicit';
        // Bug #16: Safari does not throw an error when setting a different channelCount or channelCountMode.
        Object.defineProperty(channelMergerNode, 'channelCount', {
            get: ()=>1,
            set: ()=>{
                throw createInvalidStateError();
            }
        });
        Object.defineProperty(channelMergerNode, 'channelCountMode', {
            get: ()=>'explicit',
            set: ()=>{
                throw createInvalidStateError();
            }
        });
        // Bug #20: Safari requires a connection of any kind to treat the input signal correctly.
        const audioBufferSourceNode = nativeContext.createBufferSource();
        const whenConnected = ()=>{
            const length = channelMergerNode.numberOfInputs;
            for(let i = 0; i < length; i += 1)audioBufferSourceNode.connect(channelMergerNode, 0, i);
        };
        const whenDisconnected = ()=>audioBufferSourceNode.disconnect(channelMergerNode);
        monitorConnections(channelMergerNode, whenConnected, whenDisconnected);
    };
};








const $8d0551d2e3011348$export$4ec0c13c358eb2b5 = (audioBuffer, buffer, channelNumber)=>{
    // Bug #5: Safari does not support copyFromChannel() and copyToChannel().
    if (audioBuffer.copyFromChannel === undefined) return audioBuffer.getChannelData(channelNumber)[0];
    audioBuffer.copyFromChannel(buffer, channelNumber);
    return buffer[0];
};







const $ac5d7f1a7bc00ad1$export$b32eba1f356dc699 = (curve)=>{
    if (curve === null) return false;
    const length = curve.length;
    if (length % 2 !== 0) return curve[Math.floor(length / 2)] !== 0;
    return curve[length / 2 - 1] + curve[length / 2] !== 0;
};




const $530b71ca59aca245$export$f25ed0e1b53c5d37 = (object, property, createGetter, createSetter)=>{
    let prototype = object;
    while(!prototype.hasOwnProperty(property))prototype = Object.getPrototypeOf(prototype);
    const { get: get, set: set } = Object.getOwnPropertyDescriptor(prototype, property);
    Object.defineProperty(object, property, {
        get: createGetter(get),
        set: createSetter(set)
    });
};



const $70e8704c373b96d4$export$9a47aefcb4b02450 = (options)=>{
    return {
        ...options,
        outputChannelCount: options.outputChannelCount !== undefined ? options.outputChannelCount : options.numberOfInputs === 1 && options.numberOfOutputs === 1 ? /*
                   * Bug #61: This should be the computedNumberOfChannels, but unfortunately that is almost impossible to fake. That's why
                   * the channelCountMode is required to be 'explicit' as long as there is not a native implementation in every browser. That
                   * makes sure the computedNumberOfChannels is equivilant to the channelCount which makes it much easier to compute.
                   */ [
            options.channelCount
        ] : Array.from({
            length: options.numberOfOutputs
        }, ()=>1)
    };
};


const $2bf28b0b46226c08$export$6edb0bde597f2c9a = (options)=>{
    return {
        ...options,
        channelCount: options.numberOfOutputs
    };
};


const $c6cbf9b4072d07b5$export$833c872c8eda5015 = (options)=>{
    const { imag: imag, real: real } = options;
    if (imag === undefined) {
        if (real === undefined) return {
            ...options,
            imag: [
                0,
                0
            ],
            real: [
                0,
                0
            ]
        };
        return {
            ...options,
            imag: Array.from(real, ()=>0),
            real: real
        };
    }
    if (real === undefined) return {
        ...options,
        imag: imag,
        real: Array.from(imag, ()=>0)
    };
    return {
        ...options,
        imag: imag,
        real: real
    };
};


const $2a8003ceab32d203$export$652ab3e522965552 = (audioParam, value, startTime)=>{
    try {
        audioParam.setValueAtTime(value, startTime);
    } catch (err) {
        if (err.code !== 9) throw err;
        $2a8003ceab32d203$export$652ab3e522965552(audioParam, value, startTime + 1e-7);
    }
};



const $cfb713f07f55dfb6$export$3211ed65c5b8326b = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.start();
    try {
        nativeAudioBufferSourceNode.start();
    } catch  {
        return true;
    }
    return false;
};


const $d7cdc94b55bf7d89$export$74929efb99360b7a = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    try {
        nativeAudioBufferSourceNode.start(0, 1);
    } catch  {
        return false;
    }
    return true;
};


const $cde727d83b713b25$export$c29f4eec5460fc70 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.start();
    try {
        nativeAudioBufferSourceNode.stop();
    } catch  {
        return false;
    }
    return true;
};


const $e3970505f53334fc$export$9be334adb9176c59 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createOscillator();
    try {
        nativeAudioBufferSourceNode.start(-1);
    } catch (err) {
        return err instanceof RangeError;
    }
    return false;
};


const $537c8041ad676874$export$a7f1019c14a08879 = (nativeContext)=>{
    const nativeAudioBuffer = nativeContext.createBuffer(1, 1, 44100);
    const nativeAudioBufferSourceNode = nativeContext.createBufferSource();
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    nativeAudioBufferSourceNode.start();
    nativeAudioBufferSourceNode.stop();
    try {
        nativeAudioBufferSourceNode.stop();
        return true;
    } catch  {
        return false;
    }
};


const $dadc6bbe89a710a4$export$67a72517a9facc5 = (nativeContext)=>{
    const nativeAudioBufferSourceNode = nativeContext.createOscillator();
    try {
        nativeAudioBufferSourceNode.stop(-1);
    } catch (err) {
        return err instanceof RangeError;
    }
    return false;
};


const $39927bdf4fc4578b$export$a40748749fc273c5 = (audioWorkletNodeOptions)=>{
    const { port1: port1, port2: port2 } = new MessageChannel();
    try {
        // This will throw an error if the audioWorkletNodeOptions are not clonable.
        port1.postMessage(audioWorkletNodeOptions);
    } finally{
        port1.close();
        port2.close();
    }
};


/*
 * Bug #122: Edge up to version v18 did not allow to construct a DOMException'. It also had a couple more bugs but since this is easy to
 * test it's used here as a placeholder.
 *
 * Bug #27: Edge up to version v18 did reject an invalid arrayBuffer passed to decodeAudioData() with a DOMException.
 *
 * Bug #50: Edge up to version v18 did not allow to create AudioNodes on a closed context.
 *
 * Bug #57: Edge up to version v18 did not throw an error when assigning the type of an OscillatorNode to 'custom'.
 *
 * Bug #63: Edge up to version v18 did not expose the mediaElement property of a MediaElementAudioSourceNode.
 *
 * Bug #64: Edge up to version v18 did not support the MediaStreamAudioDestinationNode.
 *
 * Bug #71: Edge up to version v18 did not allow to set the buffer of an AudioBufferSourceNode to null.
 *
 * Bug #93: Edge up to version v18 did set the sampleRate of an AudioContext to zero when it was closed.
 *
 * Bug #101: Edge up to version v18 refused to execute decodeAudioData() on a closed context.
 *
 * Bug #106: Edge up to version v18 did not expose the maxValue and minValue properties of the pan AudioParam of a StereoPannerNode.
 *
 * Bug #110: Edge up to version v18 did not expose the maxValue and minValue properties of the attack, knee, ratio, release and threshold AudioParams of a DynamicsCompressorNode.
 *
 * Bug #123: Edge up to version v18 did not support HRTF as the panningModel for a PannerNode.
 *
 * Bug #145: Edge up to version v18 did throw an IndexSizeError when an OfflineAudioContext was created with a sampleRate of zero.
 *
 * Bug #161: Edge up to version v18 did not expose the maxValue and minValue properties of the delayTime AudioParam of a DelayNode.
 */ const $d626a25f56a8d82b$export$1310f0b96d9d8115 = ()=>{
    try {
        new DOMException(); // tslint:disable-line:no-unused-expression
    } catch  {
        return false;
    }
    return true;
};



// Safari at version 11 did not support transferables.
const $54d8faf59e52b4bd$export$4f6e0d4bb1ead9ce = ()=>new Promise((resolve)=>{
        const arrayBuffer = new ArrayBuffer(0);
        const { port1: port1, port2: port2 } = new MessageChannel();
        port1.onmessage = ({ data: data })=>resolve(data !== null);
        port2.postMessage(arrayBuffer, [
            arrayBuffer
        ]);
    });


const $2d8df0897195a211$export$c3eb87c85305df2 = (nativeAudioBufferSourceNode)=>{
    nativeAudioBufferSourceNode.start = ((start)=>{
        return (when = 0, offset = 0, duration)=>{
            const buffer = nativeAudioBufferSourceNode.buffer;
            // Bug #154: Safari does not clamp the offset if it is equal to or greater than the duration of the buffer.
            const clampedOffset = buffer === null ? offset : Math.min(buffer.duration, offset);
            // Bug #155: Safari does not handle the offset correctly if it would cause the buffer to be not be played at all.
            if (buffer !== null && clampedOffset > buffer.duration - 0.5 / nativeAudioBufferSourceNode.context.sampleRate) start.call(nativeAudioBufferSourceNode, when, 0, 0);
            else start.call(nativeAudioBufferSourceNode, when, clampedOffset, duration);
        };
    })(nativeAudioBufferSourceNode.start);
};



const $e13cb619e47d347b$export$587074127be31245 = (nativeAudioScheduledSourceNode, nativeContext)=>{
    const nativeGainNode = nativeContext.createGain();
    nativeAudioScheduledSourceNode.connect(nativeGainNode);
    const disconnectGainNode = ((disconnect)=>{
        return ()=>{
            // @todo TypeScript cannot infer the overloaded signature with 1 argument yet.
            disconnect.call(nativeAudioScheduledSourceNode, nativeGainNode);
            nativeAudioScheduledSourceNode.removeEventListener('ended', disconnectGainNode);
        };
    })(nativeAudioScheduledSourceNode.disconnect);
    nativeAudioScheduledSourceNode.addEventListener('ended', disconnectGainNode);
    (0, $a05c6395c19a176f$export$19c8a106f82dff14)(nativeAudioScheduledSourceNode, nativeGainNode);
    nativeAudioScheduledSourceNode.stop = ((stop)=>{
        let isStopped = false;
        return (when = 0)=>{
            if (isStopped) try {
                stop.call(nativeAudioScheduledSourceNode, when);
            } catch  {
                nativeGainNode.gain.setValueAtTime(0, when);
            }
            else {
                stop.call(nativeAudioScheduledSourceNode, when);
                isStopped = true;
            }
        };
    })(nativeAudioScheduledSourceNode.stop);
};


const $507dfbd6dc37b887$export$63f14ca2e716ed28 = (target, eventListener)=>{
    return (event)=>{
        const descriptor = {
            value: target
        };
        Object.defineProperties(event, {
            currentTarget: descriptor,
            target: descriptor
        });
        if (typeof eventListener === 'function') return eventListener.call(target, event);
        return eventListener.handleEvent.call(target, event);
    };
};








































































































































































// @todo This is currently named IWorkletOptions and not IAudioWorkletOptions because it defines the options of a generic Worklet.




























































































































































































































































































































































































































































































































































































































































































































































































































const $73de05636a272705$var$addActiveInputConnectionToAudioNode = (0, $7f23be3a1785a3a3$export$43d20cccdc976834)((0, $b5b160ddb9cb72cc$export$64505511c8abc942));
const $73de05636a272705$var$addPassiveInputConnectionToAudioNode = (0, $3166079db94aa9a9$export$67aa4e90be3a506b)((0, $b5b160ddb9cb72cc$export$64505511c8abc942));
const $73de05636a272705$var$deleteActiveInputConnectionToAudioNode = (0, $e39a769fcfed862a$export$1f7c0152b9e322ae)((0, $b4907d346209c4aa$export$3f1b331b43a0e659));
const $73de05636a272705$var$audioNodeTailTimeStore = new WeakMap();
const $73de05636a272705$var$getAudioNodeTailTime = (0, $1c502bf8d77347a3$export$4abc3abd061bc2cc)($73de05636a272705$var$audioNodeTailTimeStore);
const $73de05636a272705$var$cacheTestResult = (0, $c8f9a173cc3bf911$export$e72d622686b5f6c7)(new Map(), new WeakMap());
const $73de05636a272705$var$window = (0, $26d12d47448d9dca$export$ba255020126e276e)();
const $73de05636a272705$var$createNativeAnalyserNode = (0, $e8efe05ceea76e6b$export$36e704ad7c903a26)($73de05636a272705$var$cacheTestResult, (0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$var$getAudioNodeRenderer = (0, $177173849cab3696$export$97bb1acefff8970e)((0, $b599ef0c4650ec6d$export$6b29eee2af836dfc));
const $73de05636a272705$var$renderInputsOfAudioNode = (0, $d2ccdaf328a083a6$export$cff0938ddf51f6f4)((0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), $73de05636a272705$var$getAudioNodeRenderer, (0, $5ab4cc8140911ed0$export$8658a39a04a404d5));
const $73de05636a272705$var$createAnalyserNodeRenderer = (0, $af022ab249d12b4e$export$5fe3f5c2d995fe20)($73de05636a272705$var$createNativeAnalyserNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$var$getNativeContext = (0, $ab34c55943f983a2$export$797a319a8065fb37)((0, $7718e734b2fef711$export$7d17302229276f06));
const $73de05636a272705$var$nativeOfflineAudioContextConstructor = (0, $19c5a8e8a9bd3d9c$export$e628a2a5fd5b78b9)($73de05636a272705$var$window);
const $73de05636a272705$var$isNativeOfflineAudioContext = (0, $1f51870159fb4148$export$722bd4bab77df75a)($73de05636a272705$var$nativeOfflineAudioContextConstructor);
const $73de05636a272705$var$audioParamAudioNodeStore = new WeakMap();
const $73de05636a272705$var$eventTargetConstructor = (0, $2c6595a0ef043725$export$a512af3fc2ab91f2)((0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$nativeAudioContextConstructor = (0, $efc1676639ecd3f0$export$3a22fc4046f7b4ec)($73de05636a272705$var$window);
const $73de05636a272705$var$isNativeAudioContext = (0, $5c37aa119fcb440b$export$5d44272df169092e)($73de05636a272705$var$nativeAudioContextConstructor);
const $73de05636a272705$var$isNativeAudioNode = (0, $3b617a30f7d7e286$export$96f2bb6e8a5795ea)($73de05636a272705$var$window);
const $73de05636a272705$var$isNativeAudioParam = (0, $3ef59b79efb5ffe7$export$7c3a44537acaf24e)($73de05636a272705$var$window);
const $73de05636a272705$var$nativeAudioWorkletNodeConstructor = (0, $8a58495112d71adf$export$b0ef4818c07d1453)($73de05636a272705$var$window);
const $73de05636a272705$var$audioNodeConstructor = (0, $17fd1e9637f226c8$export$20e3fa4f981cb01d)((0, $38a67e4228ec27a5$export$7ff07578cebde522)((0, $7718e734b2fef711$export$61ca80a8c8c6d728)), (0, $dc45a634363b6091$export$1776cf0d295db1d7)($73de05636a272705$var$addActiveInputConnectionToAudioNode, $73de05636a272705$var$addPassiveInputConnectionToAudioNode, (0, $19c742083556a242$export$b92162b3199b4461), $73de05636a272705$var$deleteActiveInputConnectionToAudioNode, (0, $c5150425da7035f6$export$a19b495df4b88921), (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), $73de05636a272705$var$getAudioNodeTailTime, (0, $4c5028d8fa80b78b$export$caac7ea54cb93b25), (0, $f19824d1c532946e$export$e719c0d45ea16d08), (0, $b5b160ddb9cb72cc$export$64505511c8abc942), (0, $74af653805090ad8$export$e44f0fc8e83fb084), (0, $5ab4cc8140911ed0$export$8658a39a04a404d5), (0, $a8abf1563cb0cb90$export$79a7cb9fa56970e)), $73de05636a272705$var$cacheTestResult, (0, $f105592837a72b2d$export$e306a463e9286bbd)((0, $7718e734b2fef711$export$cf686a6a3e402092), (0, $c5150425da7035f6$export$a19b495df4b88921), (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), (0, $f19824d1c532946e$export$e719c0d45ea16d08), (0, $6cb22515327e5f96$export$fad3d843b2a56ffb), (0, $74af653805090ad8$export$e44f0fc8e83fb084)), (0, $e1139ef113001733$export$926e4aa3eed6ec13), (0, $480811f16570294f$export$254c536c2ca9b917), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $c348d8459649177f$export$93f58f9268fde9f6)((0, $19c742083556a242$export$b92162b3199b4461), (0, $7718e734b2fef711$export$cf686a6a3e402092), (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), (0, $f19824d1c532946e$export$e719c0d45ea16d08), (0, $6cb22515327e5f96$export$fad3d843b2a56ffb), $73de05636a272705$var$getNativeContext, (0, $74af653805090ad8$export$e44f0fc8e83fb084), $73de05636a272705$var$isNativeOfflineAudioContext), (0, $60aaea16e2e167aa$export$b4f8d2824d9887dc)($73de05636a272705$var$audioParamAudioNodeStore, (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), (0, $88ab0c374f97b769$export$520987e3ff3ffad3)), $73de05636a272705$var$eventTargetConstructor, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeAudioContext, $73de05636a272705$var$isNativeAudioNode, $73de05636a272705$var$isNativeAudioParam, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$nativeAudioWorkletNodeConstructor);
const $73de05636a272705$export$ed204192bbbabcef = (0, $108e1fe42ca28dbf$export$569b2da15d7fe153)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAnalyserNodeRenderer, (0, $e1139ef113001733$export$926e4aa3eed6ec13), $73de05636a272705$var$createNativeAnalyserNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$audioBufferStore = new WeakSet();
const $73de05636a272705$var$nativeAudioBufferConstructor = (0, $3fdc510d024142a6$export$1ddb6a79e564be96)($73de05636a272705$var$window);
const $73de05636a272705$var$convertNumberToUnsignedLong = (0, $9b55f1ea73efe39c$export$540e228106d2c471)(new Uint32Array(1));
const $73de05636a272705$var$wrapAudioBufferCopyChannelMethods = (0, $f2cd13b04f18ee3f$export$dbf1ce6ba2b4bc6a)($73de05636a272705$var$convertNumberToUnsignedLong, (0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$var$wrapAudioBufferCopyChannelMethodsOutOfBounds = (0, $15fe4df42e65956b$export$bff9a41e76b37a6e)($73de05636a272705$var$convertNumberToUnsignedLong);
const $73de05636a272705$export$2dbca7d91f7769d7 = (0, $05b6b25752b14d73$export$c8b88126795b7df2)($73de05636a272705$var$audioBufferStore, $73de05636a272705$var$cacheTestResult, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$nativeAudioBufferConstructor, $73de05636a272705$var$nativeOfflineAudioContextConstructor, (0, $3988bd8c6f69cf53$export$5bddcff46df9c642)($73de05636a272705$var$nativeAudioBufferConstructor), $73de05636a272705$var$wrapAudioBufferCopyChannelMethods, $73de05636a272705$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $73de05636a272705$var$addSilentConnection = (0, $8d968cebac7e2205$export$c6991e18a29704b9)((0, $525849e875dd580b$export$7cf909169b9c4d6f));
const $73de05636a272705$var$renderInputsOfAudioParam = (0, $6ca48f6db88647ab$export$82cd58acb1062198)($73de05636a272705$var$getAudioNodeRenderer, (0, $ca92fb3bedacccdf$export$1b11f454bf19657), (0, $5ab4cc8140911ed0$export$8658a39a04a404d5));
const $73de05636a272705$var$connectAudioParam = (0, $d4e4872b149da763$export$1e69fdca2ad79f10)($73de05636a272705$var$renderInputsOfAudioParam);
const $73de05636a272705$var$createNativeAudioBufferSourceNode = (0, $fed0da5959484c32$export$4f48c993f264b207)($73de05636a272705$var$addSilentConnection, $73de05636a272705$var$cacheTestResult, (0, $cfb713f07f55dfb6$export$3211ed65c5b8326b), (0, $d7cdc94b55bf7d89$export$74929efb99360b7a), (0, $cde727d83b713b25$export$c29f4eec5460fc70), (0, $e3970505f53334fc$export$9be334adb9176c59), (0, $537c8041ad676874$export$a7f1019c14a08879), (0, $dadc6bbe89a710a4$export$67a72517a9facc5), (0, $2d8df0897195a211$export$c3eb87c85305df2), (0, $0b1629607149f116$export$3c1722ed0f0ed532)((0, $530b71ca59aca245$export$f25ed0e1b53c5d37)), (0, $e13cb619e47d347b$export$587074127be31245));
const $73de05636a272705$var$renderAutomation = (0, $49e48dbdfe378aa1$export$889eef7d338963f6)((0, $3555b7973f69ce40$export$1653dd3e76bcb1b0)((0, $ca92fb3bedacccdf$export$1b11f454bf19657)), $73de05636a272705$var$renderInputsOfAudioParam);
const $73de05636a272705$var$createAudioBufferSourceNodeRenderer = (0, $a4008e06a1e577c4$export$82721be5d1bb22c5)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeAudioBufferSourceNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$var$createAudioParam = (0, $361bc03ea1ca7077$export$25d3edb077748cfc)((0, $75c70a9d5b9cda8b$export$25226f7a087f88c3)((0, $7718e734b2fef711$export$c5d3ff1f46a0185a)), $73de05636a272705$var$audioParamAudioNodeStore, (0, $7718e734b2fef711$export$55484e3055c7a9e2), (0, $403e2aebd17670b8$export$8858f507eb103ac6), (0, $8f6857d83370bfe9$exports.createCancelAndHoldAutomationEvent), (0, $8f6857d83370bfe9$exports.createCancelScheduledValuesAutomationEvent), (0, $8f6857d83370bfe9$exports.createExponentialRampToValueAutomationEvent), (0, $8f6857d83370bfe9$exports.createLinearRampToValueAutomationEvent), (0, $8f6857d83370bfe9$exports.createSetTargetAutomationEvent), (0, $8f6857d83370bfe9$exports.createSetValueAutomationEvent), (0, $8f6857d83370bfe9$exports.createSetValueCurveAutomationEvent), $73de05636a272705$var$nativeAudioContextConstructor, (0, $2a8003ceab32d203$export$652ab3e522965552));
const $73de05636a272705$export$c1b1480edd16e065 = (0, $55305446a68bbcd4$export$6857b764b4428518)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioBufferSourceNodeRenderer, $73de05636a272705$var$createAudioParam, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeAudioBufferSourceNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, (0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$audioDestinationNodeConstructor = (0, $3c5495fa70efa802$export$cbbb0c3ba3f5dd5b)($73de05636a272705$var$audioNodeConstructor, (0, $722e3b4b287a6f68$export$d44f3f5d4e42ced2), (0, $e1139ef113001733$export$926e4aa3eed6ec13), (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $a12f35f127b69772$export$d3097038f258fce)((0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $530b71ca59aca245$export$f25ed0e1b53c5d37)), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$var$createBiquadFilterNodeRenderer = (0, $bcf262a04dcb901f$export$1532cc6682032d84)($73de05636a272705$var$connectAudioParam, (0, $e80fde9dac479cbc$export$97e69c8dbd260f85), (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$var$setAudioNodeTailTime = (0, $63b106594231aed7$export$c5e78cc8035d00aa)($73de05636a272705$var$audioNodeTailTimeStore);
const $73de05636a272705$export$f068340fbfd684eb = (0, $66a4e6e6f309207a$export$aa421daabad177b5)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createBiquadFilterNodeRenderer, (0, $480811f16570294f$export$254c536c2ca9b917), (0, $e80fde9dac479cbc$export$97e69c8dbd260f85), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$monitorConnections = (0, $0c25af19b608275a$export$9f33b5a0b80f2717)((0, $b5b160ddb9cb72cc$export$64505511c8abc942), $73de05636a272705$var$isNativeAudioNode);
const $73de05636a272705$var$wrapChannelMergerNode = (0, $afaabbfeccddeb33$export$162785cfa8a63221)((0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeChannelMergerNode = (0, $2a5d9150f87cc567$export$99fe194415d94151)($73de05636a272705$var$nativeAudioContextConstructor, $73de05636a272705$var$wrapChannelMergerNode);
const $73de05636a272705$var$createChannelMergerNodeRenderer = (0, $49bc852e7ae475d1$export$79056cbe2b10cae5)($73de05636a272705$var$createNativeChannelMergerNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$7488bfd772ec10fc = (0, $d240d532973e561a$export$a65a5a400135d27)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createChannelMergerNodeRenderer, $73de05636a272705$var$createNativeChannelMergerNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$createChannelSplitterNodeRenderer = (0, $cbf1ca25428a2bfd$export$d815cad16abde9c3)((0, $fb7eeefbad4e691e$export$17649533bf213707), (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$6f860927b3cf75c1 = (0, $ecc7f6221abcb6cb$export$ce9d996cafa605b)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createChannelSplitterNodeRenderer, (0, $fb7eeefbad4e691e$export$17649533bf213707), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, (0, $2bf28b0b46226c08$export$6edb0bde597f2c9a));
const $73de05636a272705$var$createNativeConstantSourceNodeFaker = (0, $7750b35622dacdb4$export$360749cf3d02285a)($73de05636a272705$var$addSilentConnection, $73de05636a272705$var$createNativeAudioBufferSourceNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeConstantSourceNode = (0, $cc19291652c95d8b$export$2dd44f7bb3dd8089)($73de05636a272705$var$addSilentConnection, $73de05636a272705$var$cacheTestResult, $73de05636a272705$var$createNativeConstantSourceNodeFaker, (0, $e3970505f53334fc$export$9be334adb9176c59), (0, $dadc6bbe89a710a4$export$67a72517a9facc5));
const $73de05636a272705$var$createConstantSourceNodeRenderer = (0, $03ead4cb10fa624b$export$bc541a3c87b45a7d)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeConstantSourceNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$d394f3dc072b3480 = (0, $a2dd1c01048670e7$export$a02a9a6200996500)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createConstantSourceNodeRenderer, $73de05636a272705$var$createNativeConstantSourceNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, (0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$createNativeConvolverNode = (0, $370e4f21c26d451c$export$afdcf89d13ff62e)((0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $530b71ca59aca245$export$f25ed0e1b53c5d37));
const $73de05636a272705$var$createConvolverNodeRenderer = (0, $8432906c3c9b8cbf$export$5b278ccdb1a6393)($73de05636a272705$var$createNativeConvolverNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$20cfee6cb9c5d644 = (0, $841973333d0cd390$export$4894173a4b4ee485)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createConvolverNodeRenderer, $73de05636a272705$var$createNativeConvolverNode, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createDelayNodeRenderer = (0, $f2c53e2a23d66a37$export$d03c2308083a28e5)($73de05636a272705$var$connectAudioParam, (0, $ef87939e6b57ab0a$export$f7dd6d407a2109ef), (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$ce8664483cc583db = (0, $8e78583293513642$export$b89a0215c1c607e3)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createDelayNodeRenderer, (0, $ef87939e6b57ab0a$export$f7dd6d407a2109ef), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createNativeDynamicsCompressorNode = (0, $3bed81c18206a0fd$export$f19d90a0cd4a2ecc)((0, $b285affc6d8be1e4$export$dbebdb13622d486c));
const $73de05636a272705$var$createDynamicsCompressorNodeRenderer = (0, $c9213159046e81d8$export$1b1e82cc3f0a2c8)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeDynamicsCompressorNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$c74a663d797d02ba = (0, $84171167562b7343$export$60ec6725c2d45fc8)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createDynamicsCompressorNodeRenderer, $73de05636a272705$var$createNativeDynamicsCompressorNode, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createGainNodeRenderer = (0, $49cb70513208922e$export$7312404e5bea9cd)($73de05636a272705$var$connectAudioParam, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$db147ea22bd7e3ce = (0, $98e2667480721d0b$export$7b37b693b55bf5d7)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createGainNodeRenderer, (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$createNativeIIRFilterNodeFaker = (0, $9c6b76deea631207$export$49dca6a724f463b)((0, $480811f16570294f$export$254c536c2ca9b917), (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $cb688845d3eca55e$export$9f784f497a6d6acb), (0, $b285affc6d8be1e4$export$dbebdb13622d486c));
const $73de05636a272705$var$renderNativeOfflineAudioContext = (0, $ed4f60f8df7f2dc8$export$feb8d4a8e403af48)($73de05636a272705$var$cacheTestResult, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $cb688845d3eca55e$export$9f784f497a6d6acb), (0, $5c0e2069a30b8db9$export$6db7e9dd49157213)((0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$nativeOfflineAudioContextConstructor));
const $73de05636a272705$var$createIIRFilterNodeRenderer = (0, $5f4b0a4e5f013c82$export$329316f0ca6cf17e)($73de05636a272705$var$createNativeAudioBufferSourceNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$nativeOfflineAudioContextConstructor, $73de05636a272705$var$renderInputsOfAudioNode, $73de05636a272705$var$renderNativeOfflineAudioContext);
const $73de05636a272705$var$createNativeIIRFilterNode = (0, $45205c9bc193dafd$export$3c1aed24ed6efd9d)($73de05636a272705$var$createNativeIIRFilterNodeFaker);
const $73de05636a272705$export$81c00f34825a7708 = (0, $d8dda65cffc64cac$export$a22f1eb785a05608)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createNativeIIRFilterNode, $73de05636a272705$var$createIIRFilterNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createAudioListener = (0, $76e2077b6d4a003e$export$3e70692c55bd5b52)($73de05636a272705$var$createAudioParam, $73de05636a272705$var$createNativeChannelMergerNode, $73de05636a272705$var$createNativeConstantSourceNode, (0, $cb688845d3eca55e$export$9f784f497a6d6acb), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $8d0551d2e3011348$export$4ec0c13c358eb2b5), $73de05636a272705$var$isNativeOfflineAudioContext, (0, $530b71ca59aca245$export$f25ed0e1b53c5d37));
const $73de05636a272705$var$unrenderedAudioWorkletNodeStore = new WeakMap();
const $73de05636a272705$var$minimalBaseAudioContextConstructor = (0, $487edb0432cdd783$export$3f49d9c870ba2692)($73de05636a272705$var$audioDestinationNodeConstructor, $73de05636a272705$var$createAudioListener, $73de05636a272705$var$eventTargetConstructor, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$unrenderedAudioWorkletNodeStore, (0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$createNativeOscillatorNode = (0, $138975cc1d22c83a$export$a40e02c218ae01d3)($73de05636a272705$var$addSilentConnection, $73de05636a272705$var$cacheTestResult, (0, $e3970505f53334fc$export$9be334adb9176c59), (0, $537c8041ad676874$export$a7f1019c14a08879), (0, $dadc6bbe89a710a4$export$67a72517a9facc5), (0, $e13cb619e47d347b$export$587074127be31245));
const $73de05636a272705$var$createOscillatorNodeRenderer = (0, $0d4239b2159c3e55$export$99143538b3590be5)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeOscillatorNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$f44e83cdc55961f2 = (0, $36f6248399d5f3b2$export$c1c3584074b042b3)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createNativeOscillatorNode, $73de05636a272705$var$createOscillatorNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, (0, $507dfbd6dc37b887$export$63f14ca2e716ed28));
const $73de05636a272705$var$createConnectedNativeAudioBufferSourceNode = (0, $c57fc422e0055003$export$e82b2b63ea82dc82)($73de05636a272705$var$createNativeAudioBufferSourceNode);
const $73de05636a272705$var$createNativeWaveShaperNodeFaker = (0, $e6b48514e14721aa$export$f5f0b26abc22907e)($73de05636a272705$var$createConnectedNativeAudioBufferSourceNode, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $ac5d7f1a7bc00ad1$export$b32eba1f356dc699), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeWaveShaperNode = (0, $a275aa5a2c573982$export$75168c4c8ce320c4)($73de05636a272705$var$createConnectedNativeAudioBufferSourceNode, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeWaveShaperNodeFaker, (0, $ac5d7f1a7bc00ad1$export$b32eba1f356dc699), $73de05636a272705$var$monitorConnections, $73de05636a272705$var$nativeAudioContextConstructor, (0, $530b71ca59aca245$export$f25ed0e1b53c5d37));
const $73de05636a272705$var$createNativePannerNodeFaker = (0, $4d9cae61d16712a4$export$f04468477689c1b4)((0, $19c742083556a242$export$b92162b3199b4461), (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeChannelMergerNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $cb688845d3eca55e$export$9f784f497a6d6acb), $73de05636a272705$var$createNativeWaveShaperNode, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $c5150425da7035f6$export$a19b495df4b88921), (0, $8d0551d2e3011348$export$4ec0c13c358eb2b5), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativePannerNode = (0, $d34e0e0fbe459c97$export$8e3c89af72a58833)($73de05636a272705$var$createNativePannerNodeFaker);
const $73de05636a272705$var$createPannerNodeRenderer = (0, $23fb3d183f13b7ce$export$ccd091498494025)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeChannelMergerNode, $73de05636a272705$var$createNativeConstantSourceNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$createNativePannerNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$nativeOfflineAudioContextConstructor, $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode, $73de05636a272705$var$renderNativeOfflineAudioContext);
const $73de05636a272705$export$dafa2f26c98332af = (0, $ab22fa9f2ae9cf1a$export$91b046021cf98bac)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createNativePannerNode, $73de05636a272705$var$createPannerNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$createNativePeriodicWave = (0, $a6ed532ea5998f8a$export$3f519524c23feca0)((0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$export$6b71e63ac9d62aa3 = (0, $51d2e80f451b9759$export$10e47cfa48a5069d)($73de05636a272705$var$createNativePeriodicWave, $73de05636a272705$var$getNativeContext, new WeakSet(), (0, $c6cbf9b4072d07b5$export$833c872c8eda5015));
const $73de05636a272705$var$nativeStereoPannerNodeFakerFactory = (0, $ea55b90e6ec12a54$export$5fe2a787c06b2d34)($73de05636a272705$var$createNativeChannelMergerNode, (0, $fb7eeefbad4e691e$export$17649533bf213707), (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$createNativeWaveShaperNode, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeStereoPannerNode = (0, $e0e74a050611c4ea$export$247580dcf7d2f2c4)($73de05636a272705$var$nativeStereoPannerNodeFakerFactory, (0, $b285affc6d8be1e4$export$dbebdb13622d486c));
const $73de05636a272705$var$createStereoPannerNodeRenderer = (0, $32b7f7e177963e5c$export$3ba9002bd6b539cf)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$createNativeStereoPannerNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$4ee0e4c1628c69a6 = (0, $24f00fc15291a590$export$9b005b0c35721c84)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createNativeStereoPannerNode, $73de05636a272705$var$createStereoPannerNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$createWaveShaperNodeRenderer = (0, $99a27f25a76706ec$export$9709a48a5037d121)($73de05636a272705$var$createNativeWaveShaperNode, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$renderInputsOfAudioNode);
const $73de05636a272705$export$400071720810ca26 = (0, $58dd6b66debb262c$export$3a30e911e17b1cf5)($73de05636a272705$var$audioNodeConstructor, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeWaveShaperNode, $73de05636a272705$var$createWaveShaperNodeRenderer, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$setAudioNodeTailTime);
const $73de05636a272705$var$isSecureContext = (0, $484b240e3f1f979d$export$2e9a7e6b17a9abae)($73de05636a272705$var$window);
const $73de05636a272705$var$exposeCurrentFrameAndCurrentTime = (0, $a687388505de094d$export$c43b8ab5e8913cbb)($73de05636a272705$var$window);
const $73de05636a272705$var$backupOfflineAudioContextStore = new WeakMap();
const $73de05636a272705$var$getOrCreateBackupOfflineAudioContext = (0, $307a3ed6925bb7b6$export$70df0ae42e1340c8)($73de05636a272705$var$backupOfflineAudioContextStore, $73de05636a272705$var$nativeOfflineAudioContextConstructor);
const $73de05636a272705$export$f820757b6d3df312 = $73de05636a272705$var$isSecureContext ? (0, $a5628482838dda15$export$16c6049a33c70efa)($73de05636a272705$var$cacheTestResult, (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $6d1c2f45ab543604$export$43b563d089dd1d8)($73de05636a272705$var$window), $73de05636a272705$var$exposeCurrentFrameAndCurrentTime, (0, $0835f0aafb89dee3$export$c7282a393375a8ca)((0, $a18cf10db56d480b$export$aff31bd5258e9fd4)), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$getOrCreateBackupOfflineAudioContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$nativeAudioWorkletNodeConstructor, new WeakMap(), new WeakMap(), (0, $f022a9196cd0a0cb$export$19b2cf184a7cfba8)($73de05636a272705$var$nativeAudioWorkletNodeConstructor, $73de05636a272705$var$nativeOfflineAudioContextConstructor), // @todo window is guaranteed to be defined because isSecureContext checks that as well.
$73de05636a272705$var$window) : undefined;
const $73de05636a272705$var$isNativeContext = (0, $c44d077ff851f0da$export$a7c969701e5471d0)($73de05636a272705$var$isNativeAudioContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$1fbfb80f24dc90ea = (0, $9c7b16fbc9ba5a0d$export$d83e4a6039bccfb)($73de05636a272705$var$audioBufferStore, $73de05636a272705$var$cacheTestResult, (0, $c9e239e1d431cf9c$export$fc1a599a84ca01a8), (0, $d2cc4ba64859d7eb$export$6372d3d9069bc778), new WeakSet(), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeContext, (0, $00de7ef4427b01cb$export$54e424f510c54ced), (0, $4590a073dac74a1e$export$9ec44223b1284cd4), $73de05636a272705$var$wrapAudioBufferCopyChannelMethods, $73de05636a272705$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $73de05636a272705$var$baseAudioContextConstructor = (0, $c7dce4d973e69828$export$7824d6f4713e1e35)($73de05636a272705$export$f820757b6d3df312, $73de05636a272705$export$ed204192bbbabcef, $73de05636a272705$export$2dbca7d91f7769d7, $73de05636a272705$export$c1b1480edd16e065, $73de05636a272705$export$f068340fbfd684eb, $73de05636a272705$export$7488bfd772ec10fc, $73de05636a272705$export$6f860927b3cf75c1, $73de05636a272705$export$d394f3dc072b3480, $73de05636a272705$export$20cfee6cb9c5d644, $73de05636a272705$export$1fbfb80f24dc90ea, $73de05636a272705$export$ce8664483cc583db, $73de05636a272705$export$c74a663d797d02ba, $73de05636a272705$export$db147ea22bd7e3ce, $73de05636a272705$export$81c00f34825a7708, $73de05636a272705$var$minimalBaseAudioContextConstructor, $73de05636a272705$export$f44e83cdc55961f2, $73de05636a272705$export$dafa2f26c98332af, $73de05636a272705$export$6b71e63ac9d62aa3, $73de05636a272705$export$4ee0e4c1628c69a6, $73de05636a272705$export$400071720810ca26);
const $73de05636a272705$export$cbdfd9619c90296e = (0, $5a5644b592df0bad$export$d24d3af0853fd021)($73de05636a272705$var$audioNodeConstructor, (0, $d4deb99e9b2af7cd$export$2b1682bf41b4d16b), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$3ebbc22363b821ba = (0, $f377f0e28dbb751d$export$5d3ee2470cd2874)($73de05636a272705$var$audioNodeConstructor, (0, $94c6adbd7f255efe$export$acb51039efa3405d), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$57f554392102e4c0 = (0, $304864b5ea02e52c$export$a42e10687df73a9d)($73de05636a272705$var$audioNodeConstructor, (0, $b4d28d9c960c771a$export$ad3e497ef44fc577), $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$var$createNativeMediaStreamTrackAudioSourceNode = (0, $0d8737ad5d3f94df$export$87e46bc6eb8ed6ac)((0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$b6c8ffccaed2d826 = (0, $11b69ddc6f63f0f2$export$24f27d34fdf823bc)($73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createNativeMediaStreamTrackAudioSourceNode, $73de05636a272705$var$getNativeContext);
const $73de05636a272705$export$fcbc63750ec2a81f = (0, $57f46748bc9ae741$export$c6fe175def53ff71)($73de05636a272705$var$baseAudioContextConstructor, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $d528121802615e67$export$988fb803bae63f80), $73de05636a272705$export$cbdfd9619c90296e, $73de05636a272705$export$3ebbc22363b821ba, $73de05636a272705$export$57f554392102e4c0, $73de05636a272705$export$b6c8ffccaed2d826, $73de05636a272705$var$nativeAudioContextConstructor);
const $73de05636a272705$var$getUnrenderedAudioWorkletNodes = (0, $7674436fc406d726$export$43ef7eb1ae3d2f40)($73de05636a272705$var$unrenderedAudioWorkletNodeStore);
const $73de05636a272705$var$addUnrenderedAudioWorkletNode = (0, $c770a27b2f3749ca$export$fd0136b1517d036f)($73de05636a272705$var$getUnrenderedAudioWorkletNodes);
const $73de05636a272705$var$connectMultipleOutputs = (0, $69e4c3c94e06c765$export$5f708e50316bf1a)((0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$var$deleteUnrenderedAudioWorkletNode = (0, $aaeabd7f1c2ff532$export$92df121abbf21dca)($73de05636a272705$var$getUnrenderedAudioWorkletNodes);
const $73de05636a272705$var$disconnectMultipleOutputs = (0, $777f7939fea8f1ed$export$78a992fad11cd00e)((0, $e1139ef113001733$export$926e4aa3eed6ec13));
const $73de05636a272705$var$activeAudioWorkletNodeInputsStore = new WeakMap();
const $73de05636a272705$var$getActiveAudioWorkletNodeInputs = (0, $987f4a38ab3c6a37$export$8b01844840684f8d)($73de05636a272705$var$activeAudioWorkletNodeInputsStore, (0, $88ab0c374f97b769$export$520987e3ff3ffad3));
const $73de05636a272705$var$createNativeAudioWorkletNodeFaker = (0, $d96ad3d348a8f882$export$ea40f9f600f0adcb)($73de05636a272705$var$connectMultipleOutputs, (0, $e1139ef113001733$export$926e4aa3eed6ec13), (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeChannelMergerNode, (0, $fb7eeefbad4e691e$export$17649533bf213707), $73de05636a272705$var$createNativeConstantSourceNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $cb688845d3eca55e$export$9f784f497a6d6acb), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$disconnectMultipleOutputs, $73de05636a272705$var$exposeCurrentFrameAndCurrentTime, $73de05636a272705$var$getActiveAudioWorkletNodeInputs, $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createNativeAudioWorkletNode = (0, $81c404ba25d71de5$export$a6399b47836cd044)((0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeAudioWorkletNodeFaker, (0, $525849e875dd580b$export$7cf909169b9c4d6f), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$monitorConnections);
const $73de05636a272705$var$createAudioWorkletNodeRenderer = (0, $b10bbde18d49daa1$export$3a898af5d2b29a5b)($73de05636a272705$var$connectAudioParam, $73de05636a272705$var$connectMultipleOutputs, $73de05636a272705$var$createNativeAudioBufferSourceNode, $73de05636a272705$var$createNativeChannelMergerNode, (0, $fb7eeefbad4e691e$export$17649533bf213707), $73de05636a272705$var$createNativeConstantSourceNode, (0, $525849e875dd580b$export$7cf909169b9c4d6f), $73de05636a272705$var$deleteUnrenderedAudioWorkletNode, $73de05636a272705$var$disconnectMultipleOutputs, $73de05636a272705$var$exposeCurrentFrameAndCurrentTime, (0, $f19824d1c532946e$export$e719c0d45ea16d08), $73de05636a272705$var$nativeAudioWorkletNodeConstructor, $73de05636a272705$var$nativeOfflineAudioContextConstructor, $73de05636a272705$var$renderAutomation, $73de05636a272705$var$renderInputsOfAudioNode, $73de05636a272705$var$renderNativeOfflineAudioContext);
const $73de05636a272705$var$getBackupOfflineAudioContext = (0, $27e05528439e83f2$export$afecf147821b5609)($73de05636a272705$var$backupOfflineAudioContextStore);
const $73de05636a272705$var$setActiveAudioWorkletNodeInputs = (0, $880c6c9afb613707$export$17328c9508de4388)($73de05636a272705$var$activeAudioWorkletNodeInputsStore);
// The AudioWorkletNode constructor is only available in a SecureContext.
const $73de05636a272705$export$bc6715221481535 = $73de05636a272705$var$isSecureContext ? (0, $81af2a00b3599a83$export$48302d37fa2cf062)($73de05636a272705$var$addUnrenderedAudioWorkletNode, $73de05636a272705$var$audioNodeConstructor, $73de05636a272705$var$createAudioParam, $73de05636a272705$var$createAudioWorkletNodeRenderer, $73de05636a272705$var$createNativeAudioWorkletNode, (0, $b599ef0c4650ec6d$export$6b29eee2af836dfc), $73de05636a272705$var$getBackupOfflineAudioContext, $73de05636a272705$var$getNativeContext, $73de05636a272705$var$isNativeOfflineAudioContext, $73de05636a272705$var$nativeAudioWorkletNodeConstructor, (0, $70e8704c373b96d4$export$9a47aefcb4b02450), $73de05636a272705$var$setActiveAudioWorkletNodeInputs, (0, $39927bdf4fc4578b$export$a40748749fc273c5), (0, $507dfbd6dc37b887$export$63f14ca2e716ed28)) : undefined;
const $73de05636a272705$export$898a44341df73d6e = (0, $82d2d7cc0da6e790$export$8a5e66f668b2e9e8)((0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), (0, $b285affc6d8be1e4$export$dbebdb13622d486c), (0, $d528121802615e67$export$988fb803bae63f80), $73de05636a272705$var$minimalBaseAudioContextConstructor, $73de05636a272705$var$nativeAudioContextConstructor);
const $73de05636a272705$var$createNativeOfflineAudioContext = (0, $b7a1d74149a5d9bf$export$ab44e304a31eb0ae)((0, $b285affc6d8be1e4$export$dbebdb13622d486c), $73de05636a272705$var$nativeOfflineAudioContextConstructor);
const $73de05636a272705$var$startRendering = (0, $e1a515c24adcdd0a$export$a04cd80dfb1b8309)($73de05636a272705$var$audioBufferStore, $73de05636a272705$var$cacheTestResult, $73de05636a272705$var$getAudioNodeRenderer, $73de05636a272705$var$getUnrenderedAudioWorkletNodes, $73de05636a272705$var$renderNativeOfflineAudioContext, (0, $00de7ef4427b01cb$export$54e424f510c54ced), $73de05636a272705$var$wrapAudioBufferCopyChannelMethods, $73de05636a272705$var$wrapAudioBufferCopyChannelMethodsOutOfBounds);
const $73de05636a272705$export$a6f995d32126fe2e = (0, $c34e943c39218d26$export$3d487af37fe7f521)($73de05636a272705$var$cacheTestResult, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeOfflineAudioContext, $73de05636a272705$var$minimalBaseAudioContextConstructor, $73de05636a272705$var$startRendering);
const $73de05636a272705$export$5ab5c649a10df7db = (0, $18cd39af3f5a11f9$export$a9b5caf52b398870)($73de05636a272705$var$baseAudioContextConstructor, $73de05636a272705$var$cacheTestResult, (0, $c4ed5904220d24ef$export$5a1c4cd5830ea09b), $73de05636a272705$var$createNativeOfflineAudioContext, $73de05636a272705$var$startRendering);
const $73de05636a272705$export$e55e427bf52f793d = (0, $5640f46b23f2ba55$export$7030a6f3318876b)((0, $7718e734b2fef711$export$7d17302229276f06), $73de05636a272705$var$isNativeAudioContext);
const $73de05636a272705$export$61ea8ea4691b9a32 = (0, $a888bda59cc0dc6a$export$150a35c855945f9d)((0, $7718e734b2fef711$export$864a3cfb55580d0c), $73de05636a272705$var$isNativeAudioNode);
const $73de05636a272705$export$254dcc24b342c8c2 = (0, $e078436636c3eca1$export$41505fc8888255a0)((0, $7718e734b2fef711$export$55484e3055c7a9e2), $73de05636a272705$var$isNativeAudioParam);
const $73de05636a272705$export$e78994f7990ad5d3 = (0, $3fc93d78c2927094$export$845691ce8ebc2907)((0, $7718e734b2fef711$export$7d17302229276f06), $73de05636a272705$var$isNativeOfflineAudioContext);
const $73de05636a272705$export$48c17662a6902497 = ()=>(0, $c06e9ed236b03490$export$a245ecb43f54c4de)($73de05636a272705$var$cacheTestResult, (0, $05c9e19f79e8946a$export$1995b5466f5c2709)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $7b65ce19fe8f2342$export$34981ee6aafdf532)($73de05636a272705$var$nativeAudioContextConstructor), (0, $8590d5b2ea257754$export$622ba23aa6b35822)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $867de883ce43c047$export$2f44088abd2df2e)($73de05636a272705$var$nativeAudioContextConstructor), (0, $c42fe39c700d4e84$export$f77a3bce7e4efd81)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $071627c414f7ce66$export$ce5ba80a98dc0ba7)($73de05636a272705$var$nativeAudioWorkletNodeConstructor, $73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $29d0b5a6333bdcd2$export$a04037cfe0b977fa)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $b8e9b03ced2f5e1d$export$63ae3ec177f0ed66)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $ae5370edee7f0789$export$b6f3c4027f959b95)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $9794ec347afccbb2$export$d1bddb88e5c21d26)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $d626a25f56a8d82b$export$1310f0b96d9d8115), (0, $e9f4e2f4c6bba1a3$export$41669e689e17d4f0)($73de05636a272705$var$window), (0, $a6a66a7e2897c896$export$416bb3b14425e126)($73de05636a272705$var$nativeAudioContextConstructor), (0, $19fdb5dea8c1aa58$export$5ea70af76c7a03fc)($73de05636a272705$var$nativeOfflineAudioContextConstructor), (0, $54d8faf59e52b4bd$export$4f6e0d4bb1ead9ce));


/**
 * Test if the arg is undefined
 */ function $4d7f709c9ffa5105$export$eb605f91c5895a5b(arg) {
    return arg === undefined;
}
function $4d7f709c9ffa5105$export$4e62c701997796c1(arg) {
    return arg !== undefined;
}
function $4d7f709c9ffa5105$export$f6e2535fb5126e54(arg) {
    return typeof arg === "function";
}
function $4d7f709c9ffa5105$export$7e4aa119212bc614(arg) {
    return typeof arg === "number";
}
function $4d7f709c9ffa5105$export$a6cdc56e425d0d0a(arg) {
    return Object.prototype.toString.call(arg) === "[object Object]" && arg.constructor === Object;
}
function $4d7f709c9ffa5105$export$f9ce7b637dfbe238(arg) {
    return typeof arg === "boolean";
}
function $4d7f709c9ffa5105$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $4d7f709c9ffa5105$export$844ec244b1367d54(arg) {
    return typeof arg === "string";
}
function $4d7f709c9ffa5105$export$4dcca4501f2037f9(arg) {
    return $4d7f709c9ffa5105$export$844ec244b1367d54(arg) && /^([a-g]{1}(?:b|#|x|bb)?)(-?[0-9]+)/i.test(arg);
}


function $afc9146c77d080c2$export$a7a9523472993e97(statement, error) {
    if (!statement) throw new Error(error);
}
function $afc9146c77d080c2$export$6698b6d148bc9b0c(value, gte, lte = Infinity) {
    if (!(gte <= value && value <= lte)) throw new RangeError(`Value must be within [${gte}, ${lte}], got: ${value}`);
}
function $afc9146c77d080c2$export$8ef1ce44f93c2687(context) {
    // add a warning if the context is not started
    if (!context.isOffline && context.state !== "running") $afc9146c77d080c2$export$c106dd0671a0fc2d('The AudioContext is "suspended". Invoke Tone.start() from a user action to start the audio.');
}
/**
 * If it is currently inside a scheduled callback
 */ let $afc9146c77d080c2$var$isInsideScheduledCallback = false;
let $afc9146c77d080c2$var$printedScheduledWarning = false;
function $afc9146c77d080c2$export$6e9f81da321f9b8d(insideCallback) {
    $afc9146c77d080c2$var$isInsideScheduledCallback = insideCallback;
}
function $afc9146c77d080c2$export$1e1fd5627ae72f50(time) {
    if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(time) && $afc9146c77d080c2$var$isInsideScheduledCallback && !$afc9146c77d080c2$var$printedScheduledWarning) {
        $afc9146c77d080c2$var$printedScheduledWarning = true;
        $afc9146c77d080c2$export$c106dd0671a0fc2d("Events scheduled inside of scheduled callbacks should use the passed in scheduling time. See https://github.com/Tonejs/Tone.js/wiki/Accurate-Timing");
    }
}
/**
 * The default logger is the console
 */ let $afc9146c77d080c2$var$defaultLogger = console;
function $afc9146c77d080c2$export$3abbd92f765bee58(logger) {
    $afc9146c77d080c2$var$defaultLogger = logger;
}
function $afc9146c77d080c2$export$bef1f36f5486a6a3(...args) {
    $afc9146c77d080c2$var$defaultLogger.log(...args);
}
function $afc9146c77d080c2$export$c106dd0671a0fc2d(...args) {
    $afc9146c77d080c2$var$defaultLogger.warn(...args);
}



function $bed5511bac81cb8c$export$9e09b0a77eebe103(options) {
    return new (0, $73de05636a272705$export$fcbc63750ec2a81f)(options);
}
function $bed5511bac81cb8c$export$b7df220975ff4035(channels, length, sampleRate) {
    return new (0, $73de05636a272705$export$5ab5c649a10df7db)(channels, length, sampleRate);
}
const $bed5511bac81cb8c$export$a3ddad83b7a6ba2 = typeof self === "object" ? self : null;
const $bed5511bac81cb8c$export$50898d6dff7e65a3 = $bed5511bac81cb8c$export$a3ddad83b7a6ba2 && ($bed5511bac81cb8c$export$a3ddad83b7a6ba2.hasOwnProperty("AudioContext") || $bed5511bac81cb8c$export$a3ddad83b7a6ba2.hasOwnProperty("webkitAudioContext"));
function $bed5511bac81cb8c$export$f2cca0e3f6d50e11(context, name, options) {
    (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)((0, $73de05636a272705$export$bc6715221481535)), "AudioWorkletNode only works in a secure context (https or localhost)");
    return new (context instanceof ($bed5511bac81cb8c$export$a3ddad83b7a6ba2 === null || $bed5511bac81cb8c$export$a3ddad83b7a6ba2 === void 0 ? void 0 : $bed5511bac81cb8c$export$a3ddad83b7a6ba2.BaseAudioContext) ? $bed5511bac81cb8c$export$a3ddad83b7a6ba2 === null || $bed5511bac81cb8c$export$a3ddad83b7a6ba2 === void 0 ? void 0 : $bed5511bac81cb8c$export$a3ddad83b7a6ba2.AudioWorkletNode : (0, $73de05636a272705$export$bc6715221481535))(context, name, options);
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


/**
 * A class which provides a reliable callback using either
 * a Web Worker, or if that isn't supported, falls back to setTimeout.
 */ class $1f93eef75029b0e2$export$39c54bcc89dcee11 {
    constructor(callback, type, updateInterval, contextSampleRate){
        this._callback = callback;
        this._type = type;
        this._minimumUpdateInterval = Math.max(128 / (contextSampleRate || 44100), 0.001);
        this.updateInterval = updateInterval;
        // create the clock source for the first time
        this._createClock();
    }
    /**
     * Generate a web worker
     */ _createWorker() {
        const blob = new Blob([
            /* javascript */ `
			// the initial timeout time
			let timeoutTime =  ${(this._updateInterval * 1000).toFixed(1)};
			// onmessage callback
			self.onmessage = function(msg){
				timeoutTime = parseInt(msg.data);
			};
			// the tick function which posts a message
			// and schedules a new tick
			function tick(){
				setTimeout(tick, timeoutTime);
				self.postMessage('tick');
			}
			// call tick initially
			tick();
			`
        ], {
            type: "text/javascript"
        });
        const blobUrl = URL.createObjectURL(blob);
        const worker = new Worker(blobUrl);
        worker.onmessage = this._callback.bind(this);
        this._worker = worker;
    }
    /**
     * Create a timeout loop
     */ _createTimeout() {
        this._timeout = setTimeout(()=>{
            this._createTimeout();
            this._callback();
        }, this._updateInterval * 1000);
    }
    /**
     * Create the clock source.
     */ _createClock() {
        if (this._type === "worker") try {
            this._createWorker();
        } catch (e) {
            // workers not supported, fallback to timeout
            this._type = "timeout";
            this._createClock();
        }
        else if (this._type === "timeout") this._createTimeout();
    }
    /**
     * Clean up the current clock source
     */ _disposeClock() {
        if (this._timeout) clearTimeout(this._timeout);
        if (this._worker) {
            this._worker.terminate();
            this._worker.onmessage = null;
        }
    }
    /**
     * The rate in seconds the ticker will update
     */ get updateInterval() {
        return this._updateInterval;
    }
    set updateInterval(interval) {
        var _a;
        this._updateInterval = Math.max(interval, this._minimumUpdateInterval);
        if (this._type === "worker") (_a = this._worker) === null || _a === void 0 || _a.postMessage(this._updateInterval * 1000);
    }
    /**
     * The type of the ticker, either a worker or a timeout
     */ get type() {
        return this._type;
    }
    set type(type) {
        this._disposeClock();
        this._type = type;
        this._createClock();
    }
    /**
     * Clean up
     */ dispose() {
        this._disposeClock();
    }
}



function $1487bdec8f3de4a7$export$1abe4e52803657f3(arg) {
    return (0, $73de05636a272705$export$254dcc24b342c8c2)(arg);
}
function $1487bdec8f3de4a7$export$85cd8e93eb858e81(arg) {
    return (0, $73de05636a272705$export$61ea8ea4691b9a32)(arg);
}
function $1487bdec8f3de4a7$export$539f87c8e5511243(arg) {
    return (0, $73de05636a272705$export$e78994f7990ad5d3)(arg);
}
function $1487bdec8f3de4a7$export$c46cbd835dc15c90(arg) {
    return (0, $73de05636a272705$export$e55e427bf52f793d)(arg);
}
function $1487bdec8f3de4a7$export$3cc2454c233bdc32(arg) {
    return arg instanceof (0, $73de05636a272705$export$2dbca7d91f7769d7);
}




/**
 * Some objects should not be merged
 */ function $07d9216a29f4e8bb$var$noCopy(key, arg) {
    return key === "value" || (0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(arg) || (0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(arg) || (0, $1487bdec8f3de4a7$export$3cc2454c233bdc32)(arg);
}
function $07d9216a29f4e8bb$export$6969335ea1e4e77c(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();
    if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(target) && (0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(source)) for(const key in source){
        if ($07d9216a29f4e8bb$var$noCopy(key, source[key])) target[key] = source[key];
        else if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(source[key])) {
            if (!target[key]) Object.assign(target, {
                [key]: {}
            });
            $07d9216a29f4e8bb$export$6969335ea1e4e77c(target[key], source[key]);
        } else Object.assign(target, {
            [key]: source[key]
        });
    }
    // @ts-ignore
    return $07d9216a29f4e8bb$export$6969335ea1e4e77c(target, ...sources);
}
function $07d9216a29f4e8bb$export$73ce4178444047a5(arrayA, arrayB) {
    return arrayA.length === arrayB.length && arrayA.every((element, index)=>arrayB[index] === element);
}
function $07d9216a29f4e8bb$export$71d3255081da70a3(defaults, argsArray, keys = [], objKey) {
    const opts = {};
    const args = Array.from(argsArray);
    // if the first argument is an object and has an object key
    if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(args[0]) && objKey && !Reflect.has(args[0], objKey)) {
        // if it's not part of the defaults
        const partOfDefaults = Object.keys(args[0]).some((key)=>Reflect.has(defaults, key));
        if (!partOfDefaults) {
            // merge that key
            $07d9216a29f4e8bb$export$6969335ea1e4e77c(opts, {
                [objKey]: args[0]
            });
            // remove the obj key from the keys
            keys.splice(keys.indexOf(objKey), 1);
            // shift the first argument off
            args.shift();
        }
    }
    if (args.length === 1 && (0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(args[0])) $07d9216a29f4e8bb$export$6969335ea1e4e77c(opts, args[0]);
    else {
        for(let i = 0; i < keys.length; i++)if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(args[i])) opts[keys[i]] = args[i];
    }
    return $07d9216a29f4e8bb$export$6969335ea1e4e77c(defaults, opts);
}
function $07d9216a29f4e8bb$export$4b8c3341c9aef2b8(instance) {
    return instance.constructor.getDefaults();
}
function $07d9216a29f4e8bb$export$37721a79838ca038(given, fallback) {
    if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(given)) return fallback;
    else return given;
}
function $07d9216a29f4e8bb$export$e35a36a1f3b5e86b(obj, omit) {
    omit.forEach((prop)=>{
        if (Reflect.has(obj, prop)) delete obj[prop];
    });
    return obj;
}


/**
 * Tone.js
 * @author Yotam Mann
 * @license http://opensource.org/licenses/MIT MIT License
 * @copyright 2014-2024 Yotam Mann
 */ 


class $15ec6319bc02226c$export$12b11dc969d02fed {
    constructor(){
        //-------------------------------------
        // 	DEBUGGING
        //-------------------------------------
        /**
         * Set this debug flag to log all events that happen in this class.
         */ this.debug = false;
        //-------------------------------------
        // 	DISPOSING
        //-------------------------------------
        /**
         * Indicates if the instance was disposed
         */ this._wasDisposed = false;
    }
    /**
     * Returns all of the default options belonging to the class.
     */ static getDefaults() {
        return {};
    }
    /**
     * Prints the outputs to the console log for debugging purposes.
     * Prints the contents only if either the object has a property
     * called `debug` set to true, or a variable called TONE_DEBUG_CLASS
     * is set to the name of the class.
     * @example
     * const osc = new Tone.Oscillator();
     * // prints all logs originating from this oscillator
     * osc.debug = true;
     * // calls to start/stop will print in the console
     * osc.start();
     */ log(...args) {
        // if the object is either set to debug = true
        // or if there is a string on the Tone.global.with the class name
        if (this.debug || (0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2) && this.toString() === (0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2).TONE_DEBUG_CLASS) (0, $afc9146c77d080c2$export$bef1f36f5486a6a3)(this, ...args);
    }
    /**
     * disconnect and dispose.
     */ dispose() {
        this._wasDisposed = true;
        return this;
    }
    /**
     * Indicates if the instance was disposed. 'Disposing' an
     * instance means that all of the Web Audio nodes that were
     * created for the instance are disconnected and freed for garbage collection.
     */ get disposed() {
        return this._wasDisposed;
    }
    /**
     * Convert the class to a string
     * @example
     * const osc = new Tone.Oscillator();
     * console.log(osc.toString());
     */ toString() {
        return this.name;
    }
}
/**
 * The version number semver
 */ $15ec6319bc02226c$export$12b11dc969d02fed.version = (0, $8087cb83ba2ea5ef$export$83d89fbfd8236492);




/**
 * The threshold for correctness for operators. Less than one sample even
 * at very high sampling rates (e.g. `1e-6 < 1 / 192000`).
 */ const $0f7b0e628156f5de$var$EPSILON = 1e-6;
function $0f7b0e628156f5de$export$b023c82b48e70453(a, b) {
    return a > b + $0f7b0e628156f5de$var$EPSILON;
}
function $0f7b0e628156f5de$export$c846515610eb2c50(a, b) {
    return $0f7b0e628156f5de$export$b023c82b48e70453(a, b) || $0f7b0e628156f5de$export$1c0a5d05eb3f6e18(a, b);
}
function $0f7b0e628156f5de$export$7158f0ceb70f54c7(a, b) {
    return a + $0f7b0e628156f5de$var$EPSILON < b;
}
function $0f7b0e628156f5de$export$1c0a5d05eb3f6e18(a, b) {
    return Math.abs(a - b) < $0f7b0e628156f5de$var$EPSILON;
}
function $0f7b0e628156f5de$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.max(Math.min(value, max), min);
}


class $4f983a11dbbcfd64$export$e6a97ba2cae5bb94 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super();
        this.name = "Timeline";
        /**
         * The array of scheduled timeline events
         */ this._timeline = [];
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4f983a11dbbcfd64$export$e6a97ba2cae5bb94.getDefaults(), arguments, [
            "memory"
        ]);
        this.memory = options.memory;
        this.increasing = options.increasing;
    }
    static getDefaults() {
        return {
            memory: Infinity,
            increasing: false
        };
    }
    /**
     * The number of items in the timeline.
     */ get length() {
        return this._timeline.length;
    }
    /**
     * Insert an event object onto the timeline. Events must have a "time" attribute.
     * @param event  The event object to insert into the timeline.
     */ add(event) {
        // the event needs to have a time attribute
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(Reflect.has(event, "time"), "Timeline: events must have a time attribute");
        event.time = event.time.valueOf();
        if (this.increasing && this.length) {
            const lastValue = this._timeline[this.length - 1];
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $0f7b0e628156f5de$export$c846515610eb2c50)(event.time, lastValue.time), "The time must be greater than or equal to the last scheduled time");
            this._timeline.push(event);
        } else {
            const index = this._search(event.time);
            this._timeline.splice(index + 1, 0, event);
        }
        // if the length is more than the memory, remove the previous ones
        if (this.length > this.memory) {
            const diff = this.length - this.memory;
            this._timeline.splice(0, diff);
        }
        return this;
    }
    /**
     * Remove an event from the timeline.
     * @param  {Object}  event  The event object to remove from the list.
     * @returns {Timeline} this
     */ remove(event) {
        const index = this._timeline.indexOf(event);
        if (index !== -1) this._timeline.splice(index, 1);
        return this;
    }
    /**
     * Get the nearest event whose time is less than or equal to the given time.
     * @param  time  The time to query.
     */ get(time, param = "time") {
        const index = this._search(time, param);
        if (index !== -1) return this._timeline[index];
        else return null;
    }
    /**
     * Return the first event in the timeline without removing it
     * @returns {Object} The first event object
     */ peek() {
        return this._timeline[0];
    }
    /**
     * Return the first event in the timeline and remove it
     */ shift() {
        return this._timeline.shift();
    }
    /**
     * Get the event which is scheduled after the given time.
     * @param  time  The time to query.
     */ getAfter(time, param = "time") {
        const index = this._search(time, param);
        if (index + 1 < this._timeline.length) return this._timeline[index + 1];
        else return null;
    }
    /**
     * Get the event before the event at the given time.
     * @param  time  The time to query.
     */ getBefore(time) {
        const len = this._timeline.length;
        // if it's after the last item, return the last item
        if (len > 0 && this._timeline[len - 1].time < time) return this._timeline[len - 1];
        const index = this._search(time);
        if (index - 1 >= 0) return this._timeline[index - 1];
        else return null;
    }
    /**
     * Cancel events at and after the given time
     * @param  after  The time to query.
     */ cancel(after) {
        if (this._timeline.length > 1) {
            let index = this._search(after);
            if (index >= 0) {
                if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(this._timeline[index].time, after)) {
                    // get the first item with that time
                    for(let i = index; i >= 0; i--){
                        if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(this._timeline[i].time, after)) index = i;
                        else break;
                    }
                    this._timeline = this._timeline.slice(0, index);
                } else this._timeline = this._timeline.slice(0, index + 1);
            } else this._timeline = [];
        } else if (this._timeline.length === 1) // the first item's time
        {
            if ((0, $0f7b0e628156f5de$export$c846515610eb2c50)(this._timeline[0].time, after)) this._timeline = [];
        }
        return this;
    }
    /**
     * Cancel events before or equal to the given time.
     * @param  time  The time to cancel before.
     */ cancelBefore(time) {
        const index = this._search(time);
        if (index >= 0) this._timeline = this._timeline.slice(index + 1);
        return this;
    }
    /**
     * Returns the previous event if there is one. null otherwise
     * @param  event The event to find the previous one of
     * @return The event right before the given event
     */ previousEvent(event) {
        const index = this._timeline.indexOf(event);
        if (index > 0) return this._timeline[index - 1];
        else return null;
    }
    /**
     * Does a binary search on the timeline array and returns the
     * nearest event index whose time is after or equal to the given time.
     * If a time is searched before the first index in the timeline, -1 is returned.
     * If the time is after the end, the index of the last item is returned.
     */ _search(time, param = "time") {
        if (this._timeline.length === 0) return -1;
        let beginning = 0;
        const len = this._timeline.length;
        let end = len;
        if (len > 0 && this._timeline[len - 1][param] <= time) return len - 1;
        while(beginning < end){
            // calculate the midpoint for roughly equal partition
            let midPoint = Math.floor(beginning + (end - beginning) / 2);
            const event = this._timeline[midPoint];
            const nextEvent = this._timeline[midPoint + 1];
            if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(event[param], time)) {
                // choose the last one that has the same time
                for(let i = midPoint; i < this._timeline.length; i++){
                    const testEvent = this._timeline[i];
                    if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(testEvent[param], time)) midPoint = i;
                    else break;
                }
                return midPoint;
            } else if ((0, $0f7b0e628156f5de$export$7158f0ceb70f54c7)(event[param], time) && (0, $0f7b0e628156f5de$export$b023c82b48e70453)(nextEvent[param], time)) return midPoint;
            else if ((0, $0f7b0e628156f5de$export$b023c82b48e70453)(event[param], time)) // search lower
            end = midPoint;
            else // search upper
            beginning = midPoint + 1;
        }
        return -1;
    }
    /**
     * Internal iterator. Applies extra safety checks for
     * removing items from the array.
     */ _iterate(callback, lowerBound = 0, upperBound = this._timeline.length - 1) {
        this._timeline.slice(lowerBound, upperBound + 1).forEach(callback);
    }
    /**
     * Iterate over everything in the array
     * @param  callback The callback to invoke with every item
     */ forEach(callback) {
        this._iterate(callback);
        return this;
    }
    /**
     * Iterate over everything in the array at or before the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachBefore(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const upperBound = this._search(time);
        if (upperBound !== -1) this._iterate(callback, 0, upperBound);
        return this;
    }
    /**
     * Iterate over everything in the array after the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachAfter(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const lowerBound = this._search(time);
        this._iterate(callback, lowerBound + 1);
        return this;
    }
    /**
     * Iterate over everything in the array between the startTime and endTime.
     * The timerange is inclusive of the startTime, but exclusive of the endTime.
     * range = [startTime, endTime).
     * @param  startTime The time to check if items are before
     * @param  endTime The end of the test interval.
     * @param  callback The callback to invoke with every item
     */ forEachBetween(startTime, endTime, callback) {
        let lowerBound = this._search(startTime);
        let upperBound = this._search(endTime);
        if (lowerBound !== -1 && upperBound !== -1) {
            if (this._timeline[lowerBound].time !== startTime) lowerBound += 1;
            // exclusive of the end time
            if (this._timeline[upperBound].time === endTime) upperBound -= 1;
            this._iterate(callback, lowerBound, upperBound);
        } else if (lowerBound === -1) this._iterate(callback, 0, upperBound);
        return this;
    }
    /**
     * Iterate over everything in the array at or after the given time. Similar to
     * forEachAfter, but includes the item(s) at the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachFrom(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        let lowerBound = this._search(time);
        // work backwards until the event time is less than time
        while(lowerBound >= 0 && this._timeline[lowerBound].time >= time)lowerBound--;
        this._iterate(callback, lowerBound + 1);
        return this;
    }
    /**
     * Iterate over everything in the array at the given time
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachAtTime(time, callback) {
        // iterate over the items in reverse so that removing an item doesn't break things
        const upperBound = this._search(time);
        if (upperBound !== -1 && (0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(this._timeline[upperBound].time, time)) {
            let lowerBound = upperBound;
            for(let i = upperBound; i >= 0; i--){
                if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(this._timeline[i].time, time)) lowerBound = i;
                else break;
            }
            this._iterate((event)=>{
                callback(event);
            }, lowerBound, upperBound);
        }
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._timeline = [];
        return this;
    }
}




/**
 * Array of callbacks to invoke when a new context is created
 */ const $33268d33018da22a$var$notifyNewContext = [];
function $33268d33018da22a$export$cdd816203a02e74e(cb) {
    $33268d33018da22a$var$notifyNewContext.push(cb);
}
function $33268d33018da22a$export$881f7fb71351b304(ctx) {
    // add any additional modules
    $33268d33018da22a$var$notifyNewContext.forEach((cb)=>cb(ctx));
}
/**
 * Array of callbacks to invoke when a new context is closed
 */ const $33268d33018da22a$var$notifyCloseContext = [];
function $33268d33018da22a$export$7e1ecadd06ae8222(cb) {
    $33268d33018da22a$var$notifyCloseContext.push(cb);
}
function $33268d33018da22a$export$c7e36f690049420f(ctx) {
    // remove any additional modules
    $33268d33018da22a$var$notifyCloseContext.forEach((cb)=>cb(ctx));
}




class $092748a42ac93843$export$4293555f241ae35a extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super(...arguments);
        this.name = "Emitter";
    }
    /**
     * Bind a callback to a specific event.
     * @param  event     The name of the event to listen for.
     * @param  callback  The callback to invoke when the event is emitted
     */ on(event, callback) {
        // split the event
        const events = event.split(/\W+/);
        events.forEach((eventName)=>{
            if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(this._events)) this._events = {};
            if (!this._events.hasOwnProperty(eventName)) this._events[eventName] = [];
            this._events[eventName].push(callback);
        });
        return this;
    }
    /**
     * Bind a callback which is only invoked once
     * @param  event     The name of the event to listen for.
     * @param  callback  The callback to invoke when the event is emitted
     */ once(event, callback) {
        const boundCallback = (...args)=>{
            // invoke the callback
            callback(...args);
            // remove the event
            this.off(event, boundCallback);
        };
        this.on(event, boundCallback);
        return this;
    }
    /**
     * Remove the event listener.
     * @param  event     The event to stop listening to.
     * @param  callback  The callback which was bound to the event with Emitter.on.
     *                   If no callback is given, all callbacks events are removed.
     */ off(event, callback) {
        const events = event.split(/\W+/);
        events.forEach((eventName)=>{
            if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(this._events)) this._events = {};
            if (this._events.hasOwnProperty(eventName)) {
                if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(callback)) this._events[eventName] = [];
                else {
                    const eventList = this._events[eventName];
                    for(let i = eventList.length - 1; i >= 0; i--)if (eventList[i] === callback) eventList.splice(i, 1);
                }
            }
        });
        return this;
    }
    /**
     * Invoke all of the callbacks bound to the event
     * with any arguments passed in.
     * @param  event  The name of the event.
     * @param args The arguments to pass to the functions listening.
     */ emit(event, ...args) {
        if (this._events) {
            if (this._events.hasOwnProperty(event)) {
                const eventList = this._events[event].slice(0);
                for(let i = 0, len = eventList.length; i < len; i++)eventList[i].apply(this, args);
            }
        }
        return this;
    }
    /**
     * Add Emitter functions (on/off/emit) to the object
     */ static mixin(constr) {
        // instance._events = {};
        [
            "on",
            "once",
            "off",
            "emit"
        ].forEach((name)=>{
            const property = Object.getOwnPropertyDescriptor($092748a42ac93843$export$4293555f241ae35a.prototype, name);
            Object.defineProperty(constr.prototype, name, property);
        });
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._events = undefined;
        return this;
    }
}


class $b31a039e43571af1$export$8138604c41bf2253 extends (0, $092748a42ac93843$export$4293555f241ae35a) {
    constructor(){
        super(...arguments);
        this.isOffline = false;
    }
    /*
     * This is a placeholder so that JSON.stringify does not throw an error
     * This matches what JSON.stringify(audioContext) returns on a native
     * audioContext instance.
     */ toJSON() {
        return {};
    }
}



class $97c32a9cce8e2f52$export$841858b892ce1f4c extends (0, $b31a039e43571af1$export$8138604c41bf2253) {
    constructor(){
        var _a, _b;
        super();
        this.name = "Context";
        /**
         * An object containing all of the constants AudioBufferSourceNodes
         */ this._constants = new Map();
        /**
         * All of the setTimeout events.
         */ this._timeouts = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        /**
         * The timeout id counter
         */ this._timeoutIds = 0;
        /**
         * Private indicator if the context has been initialized
         */ this._initialized = false;
        /**
         * Private indicator if a close() has been called on the context, since close is async
         */ this._closeStarted = false;
        /**
         * Indicates if the context is an OfflineAudioContext or an AudioContext
         */ this.isOffline = false;
        //--------------------------------------------
        // AUDIO WORKLET
        //--------------------------------------------
        /**
         * Maps a module name to promise of the addModule method
         */ this._workletPromise = null;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($97c32a9cce8e2f52$export$841858b892ce1f4c.getDefaults(), arguments, [
            "context"
        ]);
        if (options.context) {
            this._context = options.context;
            // custom context provided, latencyHint unknown (unless explicitly provided in options)
            this._latencyHint = ((_a = arguments[0]) === null || _a === void 0 ? void 0 : _a.latencyHint) || "";
        } else {
            this._context = (0, $bed5511bac81cb8c$export$9e09b0a77eebe103)({
                latencyHint: options.latencyHint
            });
            this._latencyHint = options.latencyHint;
        }
        this._ticker = new (0, $1f93eef75029b0e2$export$39c54bcc89dcee11)(this.emit.bind(this, "tick"), options.clockSource, options.updateInterval, this._context.sampleRate);
        this.on("tick", this._timeoutLoop.bind(this));
        // fwd events from the context
        this._context.onstatechange = ()=>{
            this.emit("statechange", this.state);
        };
        // if no custom updateInterval provided, updateInterval will be derived by lookAhead setter
        this[((_b = arguments[0]) === null || _b === void 0 ? void 0 : _b.hasOwnProperty("updateInterval")) ? "_lookAhead" : "lookAhead"] = options.lookAhead;
    }
    static getDefaults() {
        return {
            clockSource: "worker",
            latencyHint: "interactive",
            lookAhead: 0.1,
            updateInterval: 0.05
        };
    }
    /**
     * Finish setting up the context. **You usually do not need to do this manually.**
     */ initialize() {
        if (!this._initialized) {
            // add any additional modules
            (0, $33268d33018da22a$export$881f7fb71351b304)(this);
            this._initialized = true;
        }
        return this;
    }
    //---------------------------
    // BASE AUDIO CONTEXT METHODS
    //---------------------------
    createAnalyser() {
        return this._context.createAnalyser();
    }
    createOscillator() {
        return this._context.createOscillator();
    }
    createBufferSource() {
        return this._context.createBufferSource();
    }
    createBiquadFilter() {
        return this._context.createBiquadFilter();
    }
    createBuffer(numberOfChannels, length, sampleRate) {
        return this._context.createBuffer(numberOfChannels, length, sampleRate);
    }
    createChannelMerger(numberOfInputs) {
        return this._context.createChannelMerger(numberOfInputs);
    }
    createChannelSplitter(numberOfOutputs) {
        return this._context.createChannelSplitter(numberOfOutputs);
    }
    createConstantSource() {
        return this._context.createConstantSource();
    }
    createConvolver() {
        return this._context.createConvolver();
    }
    createDelay(maxDelayTime) {
        return this._context.createDelay(maxDelayTime);
    }
    createDynamicsCompressor() {
        return this._context.createDynamicsCompressor();
    }
    createGain() {
        return this._context.createGain();
    }
    createIIRFilter(feedForward, feedback) {
        // @ts-ignore
        return this._context.createIIRFilter(feedForward, feedback);
    }
    createPanner() {
        return this._context.createPanner();
    }
    createPeriodicWave(real, imag, constraints) {
        return this._context.createPeriodicWave(real, imag, constraints);
    }
    createStereoPanner() {
        return this._context.createStereoPanner();
    }
    createWaveShaper() {
        return this._context.createWaveShaper();
    }
    createMediaStreamSource(stream) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaStreamSource(stream);
    }
    createMediaElementSource(element) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaElementSource(element);
    }
    createMediaStreamDestination() {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context), "Not available if OfflineAudioContext");
        const context = this._context;
        return context.createMediaStreamDestination();
    }
    decodeAudioData(audioData) {
        return this._context.decodeAudioData(audioData);
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get currentTime() {
        return this._context.currentTime;
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get state() {
        return this._context.state;
    }
    /**
     * The current time in seconds of the AudioContext.
     */ get sampleRate() {
        return this._context.sampleRate;
    }
    /**
     * The listener
     */ get listener() {
        this.initialize();
        return this._listener;
    }
    set listener(l) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._initialized, "The listener cannot be set after initialization.");
        this._listener = l;
    }
    /**
     * There is only one Transport per Context. It is created on initialization.
     */ get transport() {
        this.initialize();
        return this._transport;
    }
    set transport(t) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._initialized, "The transport cannot be set after initialization.");
        this._transport = t;
    }
    /**
     * This is the Draw object for the context which is useful for synchronizing the draw frame with the Tone.js clock.
     */ get draw() {
        this.initialize();
        return this._draw;
    }
    set draw(d) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._initialized, "Draw cannot be set after initialization.");
        this._draw = d;
    }
    /**
     * A reference to the Context's destination node.
     */ get destination() {
        this.initialize();
        return this._destination;
    }
    set destination(d) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._initialized, "The destination cannot be set after initialization.");
        this._destination = d;
    }
    /**
     * Create an audio worklet node from a name and options. The module
     * must first be loaded using {@link addAudioWorkletModule}.
     */ createAudioWorkletNode(name, options) {
        return (0, $bed5511bac81cb8c$export$f2cca0e3f6d50e11)(this.rawContext, name, options);
    }
    /**
     * Add an AudioWorkletProcessor module
     * @param url The url of the module
     */ addAudioWorkletModule(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.rawContext.audioWorklet), "AudioWorkletNode is only available in a secure context (https or localhost)");
            if (!this._workletPromise) this._workletPromise = this.rawContext.audioWorklet.addModule(url);
            yield this._workletPromise;
        });
    }
    /**
     * Returns a promise which resolves when all of the worklets have been loaded on this context
     */ workletsAreReady() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (yield this._workletPromise) ? this._workletPromise : Promise.resolve();
        });
    }
    //---------------------------
    // TICKER
    //---------------------------
    /**
     * How often the interval callback is invoked.
     * This number corresponds to how responsive the scheduling
     * can be. Setting to 0 will result in the lowest practial interval
     * based on context properties. context.updateInterval + context.lookAhead
     * gives you the total latency between scheduling an event and hearing it.
     */ get updateInterval() {
        return this._ticker.updateInterval;
    }
    set updateInterval(interval) {
        this._ticker.updateInterval = interval;
    }
    /**
     * What the source of the clock is, either "worker" (default),
     * "timeout", or "offline" (none).
     */ get clockSource() {
        return this._ticker.type;
    }
    set clockSource(type) {
        this._ticker.type = type;
    }
    /**
     * The amount of time into the future events are scheduled. Giving Web Audio
     * a short amount of time into the future to schedule events can reduce clicks and
     * improve performance. This value can be set to 0 to get the lowest latency.
     * Adjusting this value also affects the {@link updateInterval}.
     */ get lookAhead() {
        return this._lookAhead;
    }
    set lookAhead(time) {
        this._lookAhead = time;
        // if lookAhead is 0, default to .01 updateInterval
        this.updateInterval = time ? time / 2 : 0.01;
    }
    /**
     * The type of playback, which affects tradeoffs between audio
     * output latency and responsiveness.
     * In addition to setting the value in seconds, the latencyHint also
     * accepts the strings "interactive" (prioritizes low latency),
     * "playback" (prioritizes sustained playback), "balanced" (balances
     * latency and performance).
     * @example
     * // prioritize sustained playback
     * const context = new Tone.Context({ latencyHint: "playback" });
     * // set this context as the global Context
     * Tone.setContext(context);
     * // the global context is gettable with Tone.getContext()
     * console.log(Tone.getContext().latencyHint);
     */ get latencyHint() {
        return this._latencyHint;
    }
    /**
     * The unwrapped AudioContext or OfflineAudioContext
     */ get rawContext() {
        return this._context;
    }
    /**
     * The current audio context time plus a short {@link lookAhead}.
     * @example
     * setInterval(() => {
     * 	console.log("now", Tone.now());
     * }, 100);
     */ now() {
        return this._context.currentTime + this._lookAhead;
    }
    /**
     * The current audio context time without the {@link lookAhead}.
     * In most cases it is better to use {@link now} instead of {@link immediate} since
     * with {@link now} the {@link lookAhead} is applied equally to _all_ components including internal components,
     * to making sure that everything is scheduled in sync. Mixing {@link now} and {@link immediate}
     * can cause some timing issues. If no lookAhead is desired, you can set the {@link lookAhead} to `0`.
     */ immediate() {
        return this._context.currentTime;
    }
    /**
     * Starts the audio context from a suspended state. This is required
     * to initially start the AudioContext.
     * @see {@link start}
     */ resume() {
        if ((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context)) return this._context.resume();
        else return Promise.resolve();
    }
    /**
     * Close the context. Once closed, the context can no longer be used and
     * any AudioNodes created from the context will be silent.
     */ close() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            if ((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(this._context) && this.state !== "closed" && !this._closeStarted) {
                this._closeStarted = true;
                yield this._context.close();
            }
            if (this._initialized) (0, $33268d33018da22a$export$c7e36f690049420f)(this);
        });
    }
    /**
     * **Internal** Generate a looped buffer at some constant value.
     */ getConstant(val) {
        if (this._constants.has(val)) return this._constants.get(val);
        else {
            const buffer = this._context.createBuffer(1, 128, this._context.sampleRate);
            const arr = buffer.getChannelData(0);
            for(let i = 0; i < arr.length; i++)arr[i] = val;
            const constant = this._context.createBufferSource();
            constant.channelCount = 1;
            constant.channelCountMode = "explicit";
            constant.buffer = buffer;
            constant.loop = true;
            constant.start(0);
            this._constants.set(val, constant);
            return constant;
        }
    }
    /**
     * Clean up. Also closes the audio context.
     */ dispose() {
        super.dispose();
        this._ticker.dispose();
        this._timeouts.dispose();
        Object.keys(this._constants).map((val)=>this._constants[val].disconnect());
        this.close();
        return this;
    }
    //---------------------------
    // TIMEOUTS
    //---------------------------
    /**
     * The private loop which keeps track of the context scheduled timeouts
     * Is invoked from the clock source
     */ _timeoutLoop() {
        const now = this.now();
        let firstEvent = this._timeouts.peek();
        while(this._timeouts.length && firstEvent && firstEvent.time <= now){
            // invoke the callback
            firstEvent.callback();
            // shift the first event off
            this._timeouts.shift();
            // get the next one
            firstEvent = this._timeouts.peek();
        }
    }
    /**
     * A setTimeout which is guaranteed by the clock source.
     * Also runs in the offline context.
     * @param  fn       The callback to invoke
     * @param  timeout  The timeout in seconds
     * @returns ID to use when invoking Context.clearTimeout
     */ setTimeout(fn, timeout) {
        this._timeoutIds++;
        const now = this.now();
        this._timeouts.add({
            callback: fn,
            id: this._timeoutIds,
            time: now + timeout
        });
        return this._timeoutIds;
    }
    /**
     * Clears a previously scheduled timeout with Tone.context.setTimeout
     * @param  id  The ID returned from setTimeout
     */ clearTimeout(id) {
        this._timeouts.forEach((event)=>{
            if (event.id === id) this._timeouts.remove(event);
        });
        return this;
    }
    /**
     * Clear the function scheduled by {@link setInterval}
     */ clearInterval(id) {
        return this.clearTimeout(id);
    }
    /**
     * Adds a repeating event to the context's callback clock
     */ setInterval(fn, interval) {
        const id = ++this._timeoutIds;
        const intervalFn = ()=>{
            const now = this.now();
            this._timeouts.add({
                callback: ()=>{
                    // invoke the callback
                    fn();
                    // invoke the event to repeat it
                    intervalFn();
                },
                id: id,
                time: now + interval
            });
        };
        // kick it off
        intervalFn();
        return id;
    }
}




class $0ec515c97546cbe4$export$bc5f2fd86e1bc223 extends (0, $b31a039e43571af1$export$8138604c41bf2253) {
    constructor(){
        super(...arguments);
        this.lookAhead = 0;
        this.latencyHint = 0;
        this.isOffline = false;
    }
    //---------------------------
    // BASE AUDIO CONTEXT METHODS
    //---------------------------
    createAnalyser() {
        return {};
    }
    createOscillator() {
        return {};
    }
    createBufferSource() {
        return {};
    }
    createBiquadFilter() {
        return {};
    }
    createBuffer(_numberOfChannels, _length, _sampleRate) {
        return {};
    }
    createChannelMerger(_numberOfInputs) {
        return {};
    }
    createChannelSplitter(_numberOfOutputs) {
        return {};
    }
    createConstantSource() {
        return {};
    }
    createConvolver() {
        return {};
    }
    createDelay(_maxDelayTime) {
        return {};
    }
    createDynamicsCompressor() {
        return {};
    }
    createGain() {
        return {};
    }
    createIIRFilter(_feedForward, _feedback) {
        return {};
    }
    createPanner() {
        return {};
    }
    createPeriodicWave(_real, _imag, _constraints) {
        return {};
    }
    createStereoPanner() {
        return {};
    }
    createWaveShaper() {
        return {};
    }
    createMediaStreamSource(_stream) {
        return {};
    }
    createMediaElementSource(_element) {
        return {};
    }
    createMediaStreamDestination() {
        return {};
    }
    decodeAudioData(_audioData) {
        return Promise.resolve({});
    }
    //---------------------------
    // TONE AUDIO CONTEXT METHODS
    //---------------------------
    createAudioWorkletNode(_name, _options) {
        return {};
    }
    get rawContext() {
        return {};
    }
    addAudioWorkletModule(_url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            return Promise.resolve();
        });
    }
    resume() {
        return Promise.resolve();
    }
    setTimeout(_fn, _timeout) {
        return 0;
    }
    clearTimeout(_id) {
        return this;
    }
    setInterval(_fn, _interval) {
        return 0;
    }
    clearInterval(_id) {
        return this;
    }
    getConstant(_val) {
        return {};
    }
    get currentTime() {
        return 0;
    }
    get state() {
        return {};
    }
    get sampleRate() {
        return 0;
    }
    get listener() {
        return {};
    }
    get transport() {
        return {};
    }
    get draw() {
        return {};
    }
    set draw(_d) {}
    get destination() {
        return {};
    }
    set destination(_d) {}
    now() {
        return 0;
    }
    immediate() {
        return 0;
    }
}











function $8cce0c9e2019bc8a$export$b2cbc93d4da94977(target, property) {
    if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(property)) property.forEach((str)=>$8cce0c9e2019bc8a$export$b2cbc93d4da94977(target, str));
    else Object.defineProperty(target, property, {
        enumerable: true,
        writable: false
    });
}
function $8cce0c9e2019bc8a$export$e6d3eada50a007b1(target, property) {
    if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(property)) property.forEach((str)=>$8cce0c9e2019bc8a$export$e6d3eada50a007b1(target, str));
    else Object.defineProperty(target, property, {
        writable: true
    });
}
const $8cce0c9e2019bc8a$export$b50b6e108474309b = ()=>{
// no operation here!
};




class $43da6dea502b5fe8$export$424a335715b38178 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super();
        this.name = "ToneAudioBuffer";
        /**
         * Callback when the buffer is loaded.
         */ this.onload = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($43da6dea502b5fe8$export$424a335715b38178.getDefaults(), arguments, [
            "url",
            "onload",
            "onerror"
        ]);
        this.reverse = options.reverse;
        this.onload = options.onload;
        if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(options.url)) // initiate the download
        this.load(options.url).catch(options.onerror);
        else if (options.url) this.set(options.url);
    }
    static getDefaults() {
        return {
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            reverse: false
        };
    }
    /**
     * The sample rate of the AudioBuffer
     */ get sampleRate() {
        if (this._buffer) return this._buffer.sampleRate;
        else return (0, $b7b11709569bdbef$export$31553aaa555c1514)().sampleRate;
    }
    /**
     * Pass in an AudioBuffer or ToneAudioBuffer to set the value of this buffer.
     */ set(buffer) {
        if (buffer instanceof $43da6dea502b5fe8$export$424a335715b38178) {
            // if it's loaded, set it
            if (buffer.loaded) this._buffer = buffer.get();
            else // otherwise when it's loaded, invoke it's callback
            buffer.onload = ()=>{
                this.set(buffer);
                this.onload(this);
            };
        } else this._buffer = buffer;
        // reverse it initially
        if (this._reversed) this._reverse();
        return this;
    }
    /**
     * The audio buffer stored in the object.
     */ get() {
        return this._buffer;
    }
    /**
     * Makes an fetch request for the selected url then decodes the file as an audio buffer.
     * Invokes the callback once the audio buffer loads.
     * @param url The url of the buffer to load. filetype support depends on the browser.
     * @returns A Promise which resolves with this ToneAudioBuffer
     */ load(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const doneLoading = $43da6dea502b5fe8$export$424a335715b38178.load(url).then((audioBuffer)=>{
                this.set(audioBuffer);
                // invoke the onload method
                this.onload(this);
            });
            $43da6dea502b5fe8$export$424a335715b38178.downloads.push(doneLoading);
            try {
                yield doneLoading;
            } finally{
                // remove the downloaded file
                const index = $43da6dea502b5fe8$export$424a335715b38178.downloads.indexOf(doneLoading);
                $43da6dea502b5fe8$export$424a335715b38178.downloads.splice(index, 1);
            }
            return this;
        });
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._buffer = undefined;
        return this;
    }
    /**
     * Set the audio buffer from the array.
     * To create a multichannel AudioBuffer, pass in a multidimensional array.
     * @param array The array to fill the audio buffer
     */ fromArray(array) {
        const isMultidimensional = (0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(array) && array[0].length > 0;
        const channels = isMultidimensional ? array.length : 1;
        const len = isMultidimensional ? array[0].length : array.length;
        const context = (0, $b7b11709569bdbef$export$31553aaa555c1514)();
        const buffer = context.createBuffer(channels, len, context.sampleRate);
        const multiChannelArray = !isMultidimensional && channels === 1 ? [
            array
        ] : array;
        for(let c = 0; c < channels; c++)buffer.copyToChannel(multiChannelArray[c], c);
        this._buffer = buffer;
        return this;
    }
    /**
     * Sums multiple channels into 1 channel
     * @param chanNum Optionally only copy a single channel from the array.
     */ toMono(chanNum) {
        if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(chanNum)) this.fromArray(this.toArray(chanNum));
        else {
            let outputArray = new Float32Array(this.length);
            const numChannels = this.numberOfChannels;
            for(let channel = 0; channel < numChannels; channel++){
                const channelArray = this.toArray(channel);
                for(let i = 0; i < channelArray.length; i++)outputArray[i] += channelArray[i];
            }
            // divide by the number of channels
            outputArray = outputArray.map((sample)=>sample / numChannels);
            this.fromArray(outputArray);
        }
        return this;
    }
    /**
     * Get the buffer as an array. Single channel buffers will return a 1-dimensional
     * Float32Array, and multichannel buffers will return multidimensional arrays.
     * @param channel Optionally only copy a single channel from the array.
     */ toArray(channel) {
        if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(channel)) return this.getChannelData(channel);
        else if (this.numberOfChannels === 1) return this.toArray(0);
        else {
            const ret = [];
            for(let c = 0; c < this.numberOfChannels; c++)ret[c] = this.getChannelData(c);
            return ret;
        }
    }
    /**
     * Returns the Float32Array representing the PCM audio data for the specific channel.
     * @param  channel  The channel number to return
     * @return The audio as a TypedArray
     */ getChannelData(channel) {
        if (this._buffer) return this._buffer.getChannelData(channel);
        else return new Float32Array(0);
    }
    /**
     * Cut a subsection of the array and return a buffer of the
     * subsection. Does not modify the original buffer
     * @param start The time to start the slice
     * @param end The end time to slice. If none is given will default to the end of the buffer
     */ slice(start, end = this.duration) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.loaded, "Buffer is not loaded");
        const startSamples = Math.floor(start * this.sampleRate);
        const endSamples = Math.floor(end * this.sampleRate);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(startSamples < endSamples, "The start time must be less than the end time");
        const length = endSamples - startSamples;
        const retBuffer = (0, $b7b11709569bdbef$export$31553aaa555c1514)().createBuffer(this.numberOfChannels, length, this.sampleRate);
        for(let channel = 0; channel < this.numberOfChannels; channel++)retBuffer.copyToChannel(this.getChannelData(channel).subarray(startSamples, endSamples), channel);
        return new $43da6dea502b5fe8$export$424a335715b38178(retBuffer);
    }
    /**
     * Reverse the buffer.
     */ _reverse() {
        if (this.loaded) for(let i = 0; i < this.numberOfChannels; i++)this.getChannelData(i).reverse();
        return this;
    }
    /**
     * If the buffer is loaded or not
     */ get loaded() {
        return this.length > 0;
    }
    /**
     * The duration of the buffer in seconds.
     */ get duration() {
        if (this._buffer) return this._buffer.duration;
        else return 0;
    }
    /**
     * The length of the buffer in samples
     */ get length() {
        if (this._buffer) return this._buffer.length;
        else return 0;
    }
    /**
     * The number of discrete audio channels. Returns 0 if no buffer is loaded.
     */ get numberOfChannels() {
        if (this._buffer) return this._buffer.numberOfChannels;
        else return 0;
    }
    /**
     * Reverse the buffer.
     */ get reverse() {
        return this._reversed;
    }
    set reverse(rev) {
        if (this._reversed !== rev) {
            this._reversed = rev;
            this._reverse();
        }
    }
    /**
     * Create a ToneAudioBuffer from the array. To create a multichannel AudioBuffer,
     * pass in a multidimensional array.
     * @param array The array to fill the audio buffer
     * @return A ToneAudioBuffer created from the array
     */ static fromArray(array) {
        return new $43da6dea502b5fe8$export$424a335715b38178().fromArray(array);
    }
    /**
     * Creates a ToneAudioBuffer from a URL, returns a promise which resolves to a ToneAudioBuffer
     * @param  url The url to load.
     * @return A promise which resolves to a ToneAudioBuffer
     */ static fromUrl(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const buffer = new $43da6dea502b5fe8$export$424a335715b38178();
            return yield buffer.load(url);
        });
    }
    /**
     * Loads a url using fetch and returns the AudioBuffer.
     */ static load(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            // test if the url contains multiple extensions
            const matches = url.match(/\[([^\]\[]+\|.+)\]$/);
            if (matches) {
                const extensions = matches[1].split("|");
                let extension = extensions[0];
                for (const ext of extensions)if ($43da6dea502b5fe8$export$424a335715b38178.supportsType(ext)) {
                    extension = ext;
                    break;
                }
                url = url.replace(matches[0], extension);
            }
            // make sure there is a slash between the baseUrl and the url
            const baseUrl = $43da6dea502b5fe8$export$424a335715b38178.baseUrl === "" || $43da6dea502b5fe8$export$424a335715b38178.baseUrl.endsWith("/") ? $43da6dea502b5fe8$export$424a335715b38178.baseUrl : $43da6dea502b5fe8$export$424a335715b38178.baseUrl + "/";
            // encode special characters in file path
            const location = document.createElement("a");
            location.href = baseUrl + url;
            location.pathname = (location.pathname + location.hash).split("/").map(encodeURIComponent).join("/");
            const response = yield fetch(location.href);
            if (!response.ok) throw new Error(`could not load url: ${url}`);
            const arrayBuffer = yield response.arrayBuffer();
            const audioBuffer = yield (0, $b7b11709569bdbef$export$31553aaa555c1514)().decodeAudioData(arrayBuffer);
            return audioBuffer;
        });
    }
    /**
     * Checks a url's extension to see if the current browser can play that file type.
     * @param url The url/extension to test
     * @return If the file extension can be played
     * @static
     * @example
     * Tone.ToneAudioBuffer.supportsType("wav"); // returns true
     * Tone.ToneAudioBuffer.supportsType("path/to/file.wav"); // returns true
     */ static supportsType(url) {
        const extensions = url.split(".");
        const extension = extensions[extensions.length - 1];
        const response = document.createElement("audio").canPlayType("audio/" + extension);
        return response !== "";
    }
    /**
     * Returns a Promise which resolves when all of the buffers have loaded
     */ static loaded() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            // this makes sure that the function is always async
            yield Promise.resolve();
            while($43da6dea502b5fe8$export$424a335715b38178.downloads.length)yield $43da6dea502b5fe8$export$424a335715b38178.downloads[0];
        });
    }
}
//-------------------------------------
// STATIC METHODS
//-------------------------------------
/**
 * A path which is prefixed before every url.
 */ $43da6dea502b5fe8$export$424a335715b38178.baseUrl = "";
/**
 * All of the downloads
 */ $43da6dea502b5fe8$export$424a335715b38178.downloads = [];


class $815e2eef5c5fc2a8$export$46814dd5412c611c extends (0, $97c32a9cce8e2f52$export$841858b892ce1f4c) {
    constructor(){
        super({
            clockSource: "offline",
            context: (0, $1487bdec8f3de4a7$export$539f87c8e5511243)(arguments[0]) ? arguments[0] : (0, $bed5511bac81cb8c$export$b7df220975ff4035)(arguments[0], arguments[1] * arguments[2], arguments[2]),
            lookAhead: 0,
            updateInterval: (0, $1487bdec8f3de4a7$export$539f87c8e5511243)(arguments[0]) ? 128 / arguments[0].sampleRate : 128 / arguments[2]
        });
        this.name = "OfflineContext";
        /**
         * An artificial clock source
         */ this._currentTime = 0;
        this.isOffline = true;
        this._duration = (0, $1487bdec8f3de4a7$export$539f87c8e5511243)(arguments[0]) ? arguments[0].length / arguments[0].sampleRate : arguments[1];
    }
    /**
     * Override the now method to point to the internal clock time
     */ now() {
        return this._currentTime;
    }
    /**
     * Same as this.now()
     */ get currentTime() {
        return this._currentTime;
    }
    /**
     * Render just the clock portion of the audio context.
     */ _renderClock(asynchronous) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            let index = 0;
            while(this._duration - this._currentTime >= 0){
                // invoke all the callbacks on that time
                this.emit("tick");
                // increment the clock in block-sized chunks
                this._currentTime += 128 / this.sampleRate;
                // yield once a second of audio
                index++;
                const yieldEvery = Math.floor(this.sampleRate / 128);
                if (asynchronous && index % yieldEvery === 0) yield new Promise((done)=>setTimeout(done, 1));
            }
        });
    }
    /**
     * Render the output of the OfflineContext
     * @param asynchronous If the clock should be rendered asynchronously, which will not block the main thread, but be slightly slower.
     */ render() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(asynchronous = true) {
            yield this.workletsAreReady();
            yield this._renderClock(asynchronous);
            const buffer = yield this._context.startRendering();
            return new (0, $43da6dea502b5fe8$export$424a335715b38178)(buffer);
        });
    }
    /**
     * Close the context
     */ close() {
        return Promise.resolve();
    }
}



/**
 * This dummy context is used to avoid throwing immediate errors when importing in Node.js
 */ const $b7b11709569bdbef$var$dummyContext = new (0, $0ec515c97546cbe4$export$bc5f2fd86e1bc223)();
/**
 * The global audio context which is getable and assignable through
 * getContext and setContext
 */ let $b7b11709569bdbef$var$globalContext = $b7b11709569bdbef$var$dummyContext;
function $b7b11709569bdbef$export$31553aaa555c1514() {
    if ($b7b11709569bdbef$var$globalContext === $b7b11709569bdbef$var$dummyContext && (0, $bed5511bac81cb8c$export$50898d6dff7e65a3)) $b7b11709569bdbef$export$2f04de43fe27971a(new (0, $97c32a9cce8e2f52$export$841858b892ce1f4c)());
    return $b7b11709569bdbef$var$globalContext;
}
function $b7b11709569bdbef$export$2f04de43fe27971a(context, disposeOld = false) {
    if (disposeOld) $b7b11709569bdbef$var$globalContext.dispose();
    if ((0, $1487bdec8f3de4a7$export$c46cbd835dc15c90)(context)) $b7b11709569bdbef$var$globalContext = new (0, $97c32a9cce8e2f52$export$841858b892ce1f4c)(context);
    else if ((0, $1487bdec8f3de4a7$export$539f87c8e5511243)(context)) $b7b11709569bdbef$var$globalContext = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(context);
    else $b7b11709569bdbef$var$globalContext = context;
}
function $b7b11709569bdbef$export$b3571188c770cc5a() {
    return $b7b11709569bdbef$var$globalContext.resume();
}
/**
 * Log Tone.js + version in the console.
 */ if ((0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2) && !(0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2).TONE_SILENCE_LOGGING) {
    let prefix = "v";
    if ((0, $8087cb83ba2ea5ef$export$83d89fbfd8236492) === "dev") prefix = "";
    const printString = ` * Tone.js ${prefix}${(0, $8087cb83ba2ea5ef$export$83d89fbfd8236492)} * `;
    // eslint-disable-next-line no-console
    console.log(`%c${printString}`, "background: #000; color: #fff");
}




/* eslint-disable key-spacing */ 
/**
 * Equal power gain scale. Good for cross-fading.
 * @param  percent (0-1)
 */ function $84c2af7dbf01a14d$export$bfc35d599238ec59(percent) {
    const piFactor = 0.5 * Math.PI;
    return Math.sin(percent * piFactor);
}
function $84c2af7dbf01a14d$export$33ed28de027e9482(db) {
    return Math.pow(10, db / 20);
}
function $84c2af7dbf01a14d$export$6af3969727ca2a60(gain) {
    return 20 * (Math.log(gain) / Math.LN10);
}
function $84c2af7dbf01a14d$export$5d18fe46719f6008(interval) {
    return Math.pow(2, interval / 12);
}
/**
 * The Global [concert tuning pitch](https://en.wikipedia.org/wiki/Concert_pitch) which is used
 * to generate all the other pitch values from notes. A4's values in Hertz.
 */ let $84c2af7dbf01a14d$var$A4 = 440;
function $84c2af7dbf01a14d$export$9f4826388a169ebd() {
    return $84c2af7dbf01a14d$var$A4;
}
function $84c2af7dbf01a14d$export$2a0f2ad6a5f8e4fe(freq) {
    $84c2af7dbf01a14d$var$A4 = freq;
}
function $84c2af7dbf01a14d$export$5cf9d9f9506eec5(frequency) {
    return Math.round($84c2af7dbf01a14d$export$12513e46625518e4(frequency));
}
function $84c2af7dbf01a14d$export$12513e46625518e4(frequency) {
    return 69 + 12 * Math.log2(frequency / $84c2af7dbf01a14d$var$A4);
}
function $84c2af7dbf01a14d$export$45a6434f7c391dc(midi) {
    return $84c2af7dbf01a14d$var$A4 * Math.pow(2, (midi - 69) / 12);
}






class $2e85bb48c14caf35$export$23b5656976f56273 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    /**
     * @param context The context associated with the time value. Used to compute
     * Transport and context-relative timing.
     * @param  value  The time value as a number, string or object
     * @param  units  Unit values
     */ constructor(context, value, units){
        super();
        /**
         * The default units
         */ this.defaultUnits = "s";
        this._val = value;
        this._units = units;
        this.context = context;
        this._expressions = this._getExpressions();
    }
    /**
     * All of the time encoding expressions
     */ _getExpressions() {
        return {
            hz: {
                method: (value)=>{
                    return this._frequencyToUnits(parseFloat(value));
                },
                regexp: /^(\d+(?:\.\d+)?)hz$/i
            },
            i: {
                method: (value)=>{
                    return this._ticksToUnits(parseInt(value, 10));
                },
                regexp: /^(\d+)i$/i
            },
            m: {
                method: (value)=>{
                    return this._beatsToUnits(parseInt(value, 10) * this._getTimeSignature());
                },
                regexp: /^(\d+)m$/i
            },
            n: {
                method: (value, dot)=>{
                    const numericValue = parseInt(value, 10);
                    const scalar = dot === "." ? 1.5 : 1;
                    if (numericValue === 1) return this._beatsToUnits(this._getTimeSignature()) * scalar;
                    else return this._beatsToUnits(4 / numericValue) * scalar;
                },
                regexp: /^(\d+)n(\.?)$/i
            },
            number: {
                method: (value)=>{
                    return this._expressions[this.defaultUnits].method.call(this, value);
                },
                regexp: /^(\d+(?:\.\d+)?)$/
            },
            s: {
                method: (value)=>{
                    return this._secondsToUnits(parseFloat(value));
                },
                regexp: /^(\d+(?:\.\d+)?)s$/
            },
            samples: {
                method: (value)=>{
                    return parseInt(value, 10) / this.context.sampleRate;
                },
                regexp: /^(\d+)samples$/
            },
            t: {
                method: (value)=>{
                    const numericValue = parseInt(value, 10);
                    return this._beatsToUnits(8 / (Math.floor(numericValue) * 3));
                },
                regexp: /^(\d+)t$/i
            },
            tr: {
                method: (m, q, s)=>{
                    let total = 0;
                    if (m && m !== "0") total += this._beatsToUnits(this._getTimeSignature() * parseFloat(m));
                    if (q && q !== "0") total += this._beatsToUnits(parseFloat(q));
                    if (s && s !== "0") total += this._beatsToUnits(parseFloat(s) / 4);
                    return total;
                },
                regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?$/
            }
        };
    }
    //-------------------------------------
    // 	VALUE OF
    //-------------------------------------
    /**
     * Evaluate the time value. Returns the time in seconds.
     */ valueOf() {
        if (this._val instanceof $2e85bb48c14caf35$export$23b5656976f56273) this.fromType(this._val);
        if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(this._val)) return this._noArg();
        else if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(this._val) && (0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(this._units)) {
            for(const units in this._expressions)if (this._expressions[units].regexp.test(this._val.trim())) {
                this._units = units;
                break;
            }
        } else if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(this._val)) {
            let total = 0;
            for(const typeName in this._val)if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._val[typeName])) {
                const quantity = this._val[typeName];
                const time = // @ts-ignore
                new this.constructor(this.context, typeName).valueOf() * quantity;
                total += time;
            }
            return total;
        }
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._units)) {
            const expr = this._expressions[this._units];
            const matching = this._val.toString().trim().match(expr.regexp);
            if (matching) return expr.method.apply(this, matching.slice(1));
            else return expr.method.call(this, this._val);
        } else if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(this._val)) return parseFloat(this._val);
        else return this._val;
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS
    //-------------------------------------
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return 1 / freq;
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return 60 / this._getBpm() * beats;
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return seconds;
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return ticks * this._beatsToUnits(1) / this._getPPQ();
    }
    /**
     * With no arguments, return 'now'
     */ _noArg() {
        return this._now();
    }
    //-------------------------------------
    // 	TEMPO CONVERSIONS
    //-------------------------------------
    /**
     * Return the bpm
     */ _getBpm() {
        return this.context.transport.bpm.value;
    }
    /**
     * Return the timeSignature
     */ _getTimeSignature() {
        return this.context.transport.timeSignature;
    }
    /**
     * Return the PPQ or 192 if Transport is not available
     */ _getPPQ() {
        return this.context.transport.PPQ;
    }
    //-------------------------------------
    // 	CONVERSION INTERFACE
    //-------------------------------------
    /**
     * Coerce a time type into this units type.
     * @param type Any time type units
     */ fromType(type) {
        this._units = undefined;
        switch(this.defaultUnits){
            case "s":
                this._val = type.toSeconds();
                break;
            case "i":
                this._val = type.toTicks();
                break;
            case "hz":
                this._val = type.toFrequency();
                break;
            case "midi":
                this._val = type.toMidi();
                break;
        }
        return this;
    }
    /**
     * Return the value in hertz
     */ toFrequency() {
        return 1 / this.toSeconds();
    }
    /**
     * Return the time in samples
     */ toSamples() {
        return this.toSeconds() * this.context.sampleRate;
    }
    /**
     * Return the time in milliseconds.
     */ toMilliseconds() {
        return this.toSeconds() * 1000;
    }
}


class $3b2efe963ae63025$export$52b3039dca93a306 extends (0, $2e85bb48c14caf35$export$23b5656976f56273) {
    constructor(){
        super(...arguments);
        this.name = "TimeClass";
    }
    _getExpressions() {
        return Object.assign(super._getExpressions(), {
            now: {
                method: (capture)=>{
                    return this._now() + new this.constructor(this.context, capture).valueOf();
                },
                regexp: /^\+(.+)/
            },
            quantize: {
                method: (capture)=>{
                    const quantTo = new $3b2efe963ae63025$export$52b3039dca93a306(this.context, capture).valueOf();
                    return this._secondsToUnits(this.context.transport.nextSubdivision(quantTo));
                },
                regexp: /^@(.+)/
            }
        });
    }
    /**
     * Quantize the time by the given subdivision. Optionally add a
     * percentage which will move the time value towards the ideal
     * quantized value by that percentage.
     * @param  subdiv    The subdivision to quantize to
     * @param  percent  Move the time value towards the quantized value by a percentage.
     * @example
     * Tone.Time(21).quantize(2); // returns 22
     * Tone.Time(0.6).quantize("4n", 0.5); // returns 0.55
     */ quantize(subdiv, percent = 1) {
        const subdivision = new this.constructor(this.context, subdiv).valueOf();
        const value = this.valueOf();
        const multiple = Math.round(value / subdivision);
        const ideal = multiple * subdivision;
        const diff = ideal - value;
        return value + diff * percent;
    }
    //-------------------------------------
    // CONVERSIONS
    //-------------------------------------
    /**
     * Convert a Time to Notation. The notation values are will be the
     * closest representation between 1m to 128th note.
     * @return {Notation}
     * @example
     * // if the Transport is at 120bpm:
     * Tone.Time(2).toNotation(); // returns "1m"
     */ toNotation() {
        const time = this.toSeconds();
        const testNotations = [
            "1m"
        ];
        for(let power = 1; power < 9; power++){
            const subdiv = Math.pow(2, power);
            testNotations.push(subdiv + "n.");
            testNotations.push(subdiv + "n");
            testNotations.push(subdiv + "t");
        }
        testNotations.push("0");
        // find the closets notation representation
        let closest = testNotations[0];
        let closestSeconds = new $3b2efe963ae63025$export$52b3039dca93a306(this.context, testNotations[0]).toSeconds();
        testNotations.forEach((notation)=>{
            const notationSeconds = new $3b2efe963ae63025$export$52b3039dca93a306(this.context, notation).toSeconds();
            if (Math.abs(notationSeconds - time) < Math.abs(closestSeconds - time)) {
                closest = notation;
                closestSeconds = notationSeconds;
            }
        });
        return closest;
    }
    /**
     * Return the time encoded as Bars:Beats:Sixteenths.
     */ toBarsBeatsSixteenths() {
        const quarterTime = this._beatsToUnits(1);
        let quarters = this.valueOf() / quarterTime;
        quarters = parseFloat(quarters.toFixed(4));
        const measures = Math.floor(quarters / this._getTimeSignature());
        let sixteenths = quarters % 1 * 4;
        quarters = Math.floor(quarters) % this._getTimeSignature();
        const sixteenthString = sixteenths.toString();
        if (sixteenthString.length > 3) // the additional parseFloat removes insignificant trailing zeroes
        sixteenths = parseFloat(parseFloat(sixteenthString).toFixed(3));
        const progress = [
            measures,
            quarters,
            sixteenths
        ];
        return progress.join(":");
    }
    /**
     * Return the time in ticks.
     */ toTicks() {
        const quarterTime = this._beatsToUnits(1);
        const quarters = this.valueOf() / quarterTime;
        return quarters * this._getPPQ();
    }
    /**
     * Return the time in seconds.
     */ toSeconds() {
        return this.valueOf();
    }
    /**
     * Return the value as a midi note.
     */ toMidi() {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(this.toFrequency());
    }
    _now() {
        return this.context.now();
    }
}
function $3b2efe963ae63025$export$680ea196effce5f(value, units) {
    return new $3b2efe963ae63025$export$52b3039dca93a306((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}


class $f4d7193118bd1d27$export$38b56155c8552868 extends (0, $3b2efe963ae63025$export$52b3039dca93a306) {
    constructor(){
        super(...arguments);
        this.name = "Frequency";
        this.defaultUnits = "hz";
    }
    /**
     * The [concert tuning pitch](https://en.wikipedia.org/wiki/Concert_pitch) which is used
     * to generate all the other pitch values from notes. A4's values in Hertz.
     */ static get A4() {
        return (0, $84c2af7dbf01a14d$export$9f4826388a169ebd)();
    }
    static set A4(freq) {
        (0, $84c2af7dbf01a14d$export$2a0f2ad6a5f8e4fe)(freq);
    }
    //-------------------------------------
    // 	AUGMENT BASE EXPRESSIONS
    //-------------------------------------
    _getExpressions() {
        return Object.assign({}, super._getExpressions(), {
            midi: {
                regexp: /^(\d+(?:\.\d+)?midi)/,
                method (value) {
                    if (this.defaultUnits === "midi") return value;
                    else return $f4d7193118bd1d27$export$38b56155c8552868.mtof(value);
                }
            },
            note: {
                regexp: /^([a-g]{1}(?:b|#|##|x|bb|###|#x|x#|bbb)?)(-?[0-9]+)/i,
                method (pitch, octave) {
                    const index = $f4d7193118bd1d27$var$noteToScaleIndex[pitch.toLowerCase()];
                    const noteNumber = index + (parseInt(octave, 10) + 1) * 12;
                    if (this.defaultUnits === "midi") return noteNumber;
                    else return $f4d7193118bd1d27$export$38b56155c8552868.mtof(noteNumber);
                }
            },
            tr: {
                regexp: /^(\d+(?:\.\d+)?):(\d+(?:\.\d+)?):?(\d+(?:\.\d+)?)?/,
                method (m, q, s) {
                    let total = 1;
                    if (m && m !== "0") total *= this._beatsToUnits(this._getTimeSignature() * parseFloat(m));
                    if (q && q !== "0") total *= this._beatsToUnits(parseFloat(q));
                    if (s && s !== "0") total *= this._beatsToUnits(parseFloat(s) / 4);
                    return total;
                }
            }
        });
    }
    //-------------------------------------
    // 	EXPRESSIONS
    //-------------------------------------
    /**
     * Transposes the frequency by the given number of semitones.
     * @return  A new transposed frequency
     * @example
     * Tone.Frequency("A4").transpose(3); // "C5"
     */ transpose(interval) {
        return new $f4d7193118bd1d27$export$38b56155c8552868(this.context, this.valueOf() * (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(interval));
    }
    /**
     * Takes an array of semitone intervals and returns
     * an array of frequencies transposed by those intervals.
     * @return  Returns an array of Frequencies
     * @example
     * Tone.Frequency("A4").harmonize([0, 3, 7]); // ["A4", "C5", "E5"]
     */ harmonize(intervals) {
        return intervals.map((interval)=>{
            return this.transpose(interval);
        });
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS
    //-------------------------------------
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Frequency("C4").toMidi(); // 60
     */ toMidi() {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(this.valueOf());
    }
    /**
     * Return the value of the frequency in Scientific Pitch Notation
     * @example
     * Tone.Frequency(69, "midi").toNote(); // "A4"
     */ toNote() {
        const freq = this.toFrequency();
        const log = Math.log2(freq / $f4d7193118bd1d27$export$38b56155c8552868.A4);
        let noteNumber = Math.round(12 * log) + 57;
        const octave = Math.floor(noteNumber / 12);
        if (octave < 0) noteNumber += -12 * octave;
        const noteName = $f4d7193118bd1d27$var$scaleIndexToNote[noteNumber % 12];
        return noteName + octave.toString();
    }
    /**
     * Return the duration of one cycle in seconds.
     */ toSeconds() {
        return 1 / super.toSeconds();
    }
    /**
     * Return the duration of one cycle in ticks
     */ toTicks() {
        const quarterTime = this._beatsToUnits(1);
        const quarters = this.valueOf() / quarterTime;
        return Math.floor(quarters * this._getPPQ());
    }
    //-------------------------------------
    // 	UNIT CONVERSIONS HELPERS
    //-------------------------------------
    /**
     * With no arguments, return 0
     */ _noArg() {
        return 0;
    }
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return freq;
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return 1 / (ticks * 60 / (this._getBpm() * this._getPPQ()));
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return 1 / super._beatsToUnits(beats);
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return 1 / seconds;
    }
    /**
     * Convert a MIDI note to frequency value.
     * @param  midi The midi number to convert.
     * @return The corresponding frequency value
     */ static mtof(midi) {
        return (0, $84c2af7dbf01a14d$export$45a6434f7c391dc)(midi);
    }
    /**
     * Convert a frequency value to a MIDI note.
     * @param frequency The value to frequency value to convert.
     */ static ftom(frequency) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(frequency);
    }
}
//-------------------------------------
// 	FREQUENCY CONVERSIONS
//-------------------------------------
/**
 * Note to scale index.
 * @hidden
 */ const $f4d7193118bd1d27$var$noteToScaleIndex = {
    cbbb: -3,
    cbb: -2,
    cb: -1,
    c: 0,
    "c#": 1,
    cx: 2,
    "c##": 2,
    "c###": 3,
    "cx#": 3,
    "c#x": 3,
    dbbb: -1,
    dbb: 0,
    db: 1,
    d: 2,
    "d#": 3,
    dx: 4,
    "d##": 4,
    "d###": 5,
    "dx#": 5,
    "d#x": 5,
    ebbb: 1,
    ebb: 2,
    eb: 3,
    e: 4,
    "e#": 5,
    ex: 6,
    "e##": 6,
    "e###": 7,
    "ex#": 7,
    "e#x": 7,
    fbbb: 2,
    fbb: 3,
    fb: 4,
    f: 5,
    "f#": 6,
    fx: 7,
    "f##": 7,
    "f###": 8,
    "fx#": 8,
    "f#x": 8,
    gbbb: 4,
    gbb: 5,
    gb: 6,
    g: 7,
    "g#": 8,
    gx: 9,
    "g##": 9,
    "g###": 10,
    "gx#": 10,
    "g#x": 10,
    abbb: 6,
    abb: 7,
    ab: 8,
    a: 9,
    "a#": 10,
    ax: 11,
    "a##": 11,
    "a###": 12,
    "ax#": 12,
    "a#x": 12,
    bbbb: 8,
    bbb: 9,
    bb: 10,
    b: 11,
    "b#": 12,
    bx: 13,
    "b##": 13,
    "b###": 14,
    "bx#": 14,
    "b#x": 14
};
/**
 * scale index to note (sharps)
 * @hidden
 */ const $f4d7193118bd1d27$var$scaleIndexToNote = [
    "C",
    "C#",
    "D",
    "D#",
    "E",
    "F",
    "F#",
    "G",
    "G#",
    "A",
    "A#",
    "B"
];
function $f4d7193118bd1d27$export$44c95d3770756ed2(value, units) {
    return new $f4d7193118bd1d27$export$38b56155c8552868((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}





class $ef656febef4c2085$export$c824041178a9697 extends (0, $3b2efe963ae63025$export$52b3039dca93a306) {
    constructor(){
        super(...arguments);
        this.name = "TransportTime";
    }
    /**
     * Return the current time in whichever context is relevant
     */ _now() {
        return this.context.transport.seconds;
    }
}
function $ef656febef4c2085$export$c5a05eab537a3f95(value, units) {
    return new $ef656febef4c2085$export$c824041178a9697((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}





class $f4f7e4e5607dba1a$export$4eb0ca57400aa172 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super();
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f4f7e4e5607dba1a$export$4eb0ca57400aa172.getDefaults(), arguments, [
            "context"
        ]);
        if (this.defaultContext) this.context = this.defaultContext;
        else this.context = options.context;
    }
    static getDefaults() {
        return {
            context: (0, $b7b11709569bdbef$export$31553aaa555c1514)()
        };
    }
    /**
     * Return the current time of the Context clock plus the lookAhead.
     * @example
     * setInterval(() => {
     * 	console.log(Tone.now());
     * }, 100);
     */ now() {
        return this.context.currentTime + this.context.lookAhead;
    }
    /**
     * Return the current time of the Context clock without any lookAhead.
     * @example
     * setInterval(() => {
     * 	console.log(Tone.immediate());
     * }, 100);
     */ immediate() {
        return this.context.currentTime;
    }
    /**
     * The duration in seconds of one sample.
     */ get sampleTime() {
        return 1 / this.context.sampleRate;
    }
    /**
     * The number of seconds of 1 processing block (128 samples)
     * @example
     * console.log(Tone.Destination.blockTime);
     */ get blockTime() {
        return 128 / this.context.sampleRate;
    }
    /**
     * Convert the incoming time to seconds.
     * This is calculated against the current {@link TransportClass} bpm
     * @example
     * const gain = new Tone.Gain();
     * setInterval(() => console.log(gain.toSeconds("4n")), 100);
     * // ramp the tempo to 60 bpm over 30 seconds
     * Tone.getTransport().bpm.rampTo(60, 30);
     */ toSeconds(time) {
        (0, $afc9146c77d080c2$export$1e1fd5627ae72f50)(time);
        return new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, time).toSeconds();
    }
    /**
     * Convert the input to a frequency number
     * @example
     * const gain = new Tone.Gain();
     * console.log(gain.toFrequency("4n"));
     */ toFrequency(freq) {
        return new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, freq).toFrequency();
    }
    /**
     * Convert the input time into ticks
     * @example
     * const gain = new Tone.Gain();
     * console.log(gain.toTicks("4n"));
     */ toTicks(time) {
        return new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toTicks();
    }
    //-------------------------------------
    // 	GET/SET
    //-------------------------------------
    /**
     * Get a subset of the properties which are in the partial props
     */ _getPartialProperties(props) {
        const options = this.get();
        // remove attributes from the prop that are not in the partial
        Object.keys(options).forEach((name)=>{
            if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(props[name])) delete options[name];
        });
        return options;
    }
    /**
     * Get the object's attributes.
     * @example
     * const osc = new Tone.Oscillator();
     * console.log(osc.get());
     */ get() {
        const defaults = (0, $07d9216a29f4e8bb$export$4b8c3341c9aef2b8)(this);
        Object.keys(defaults).forEach((attribute)=>{
            if (Reflect.has(this, attribute)) {
                const member = this[attribute];
                if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(member) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(member.value) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(member.setValueAtTime)) defaults[attribute] = member.value;
                else if (member instanceof $f4f7e4e5607dba1a$export$4eb0ca57400aa172) defaults[attribute] = member._getPartialProperties(defaults[attribute]);
                else if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(member) || (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(member) || (0, $4d7f709c9ffa5105$export$844ec244b1367d54)(member) || (0, $4d7f709c9ffa5105$export$f9ce7b637dfbe238)(member)) defaults[attribute] = member;
                else // remove all undefined and unserializable attributes
                delete defaults[attribute];
            }
        });
        return defaults;
    }
    /**
     * Set multiple properties at once with an object.
     * @example
     * const filter = new Tone.Filter().toDestination();
     * // set values using an object
     * filter.set({
     * 	frequency: "C6",
     * 	type: "highpass"
     * });
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/Analogsynth_octaves_highmid.mp3").connect(filter);
     * player.autostart = true;
     */ set(props) {
        Object.keys(props).forEach((attribute)=>{
            if (Reflect.has(this, attribute) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this[attribute])) {
                if (this[attribute] && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this[attribute].value) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this[attribute].setValueAtTime)) // small optimization
                {
                    if (this[attribute].value !== props[attribute]) this[attribute].value = props[attribute];
                } else if (this[attribute] instanceof $f4f7e4e5607dba1a$export$4eb0ca57400aa172) this[attribute].set(props[attribute]);
                else this[attribute] = props[attribute];
            }
        });
        return this;
    }
}







class $a30e69eba5ea5b5a$export$89221a927ffadcaf extends (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94) {
    constructor(initial = "stopped"){
        super();
        this.name = "StateTimeline";
        this._initial = initial;
        this.setStateAtTime(this._initial, 0);
    }
    /**
     * Returns the scheduled state scheduled before or at
     * the given time.
     * @param  time  The time to query.
     * @return  The name of the state input in setStateAtTime.
     */ getValueAtTime(time) {
        const event = this.get(time);
        if (event !== null) return event.state;
        else return this._initial;
    }
    /**
     * Add a state to the timeline.
     * @param  state The name of the state to set.
     * @param  time  The time to query.
     * @param options Any additional options that are needed in the timeline.
     */ setStateAtTime(state, time, options) {
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(time, 0);
        this.add(Object.assign({}, options, {
            state: state,
            time: time
        }));
        return this;
    }
    /**
     * Return the event before the time with the given state
     * @param  state The state to look for
     * @param  time  When to check before
     * @return  The event with the given state before the time
     */ getLastState(state, time) {
        // time = this.toSeconds(time);
        const index = this._search(time);
        for(let i = index; i >= 0; i--){
            const event = this._timeline[i];
            if (event.state === state) return event;
        }
    }
    /**
     * Return the event after the time with the given state
     * @param  state The state to look for
     * @param  time  When to check from
     * @return  The event with the given state after the time
     */ getNextState(state, time) {
        // time = this.toSeconds(time);
        const index = this._search(time);
        if (index !== -1) for(let i = index; i < this._timeline.length; i++){
            const event = this._timeline[i];
            if (event.state === state) return event;
        }
    }
}
















class $4e42d28fbc344697$export$1ca45c9a47aec42c extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4e42d28fbc344697$export$1ca45c9a47aec42c.getDefaults(), arguments, [
            "param",
            "units",
            "convert"
        ]);
        super(options);
        this.name = "Param";
        this.overridden = false;
        /**
         * The minimum output value
         */ this._minOutput = 1e-7;
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(options.param) && ((0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(options.param) || options.param instanceof $4e42d28fbc344697$export$1ca45c9a47aec42c), "param must be an AudioParam");
        while(!(0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(options.param))options.param = options.param._param;
        this._swappable = (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(options.swappable) ? options.swappable : false;
        if (this._swappable) {
            this.input = this.context.createGain();
            // initialize
            this._param = options.param;
            this.input.connect(this._param);
        } else this._param = this.input = options.param;
        this._events = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)(1000);
        this._initialValue = this._param.defaultValue;
        this.units = options.units;
        this.convert = options.convert;
        this._minValue = options.minValue;
        this._maxValue = options.maxValue;
        // if the value is defined, set it immediately
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(options.value) && options.value !== this._toType(this._initialValue)) this.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            convert: true,
            units: "number"
        });
    }
    get value() {
        const now = this.now();
        return this.getValueAtTime(now);
    }
    set value(value) {
        this.cancelScheduledValues(this.now());
        this.setValueAtTime(value, this.now());
    }
    get minValue() {
        // if it's not the default minValue, return it
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._minValue)) return this._minValue;
        else if (this.units === "time" || this.units === "frequency" || this.units === "normalRange" || this.units === "positive" || this.units === "transportTime" || this.units === "ticks" || this.units === "bpm" || this.units === "hertz" || this.units === "samples") return 0;
        else if (this.units === "audioRange") return -1;
        else if (this.units === "decibels") return -Infinity;
        else return this._param.minValue;
    }
    get maxValue() {
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._maxValue)) return this._maxValue;
        else if (this.units === "normalRange" || this.units === "audioRange") return 1;
        else return this._param.maxValue;
    }
    /**
     * Type guard based on the unit name
     */ _is(arg, type) {
        return this.units === type;
    }
    /**
     * Make sure the value is always in the defined range
     */ _assertRange(value) {
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.maxValue) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.minValue)) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(value, this._fromType(this.minValue), this._fromType(this.maxValue));
        return value;
    }
    /**
     * Convert the given value from the type specified by Param.units
     * into the destination value (such as Gain or Frequency).
     */ _fromType(val) {
        if (this.convert && !this.overridden) {
            if (this._is(val, "time")) return this.toSeconds(val);
            else if (this._is(val, "decibels")) return (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(val);
            else if (this._is(val, "frequency")) return this.toFrequency(val);
            else return val;
        } else if (this.overridden) // if it's overridden, should only schedule 0s
        return 0;
        else return val;
    }
    /**
     * Convert the parameters value into the units specified by Param.units.
     */ _toType(val) {
        if (this.convert && this.units === "decibels") return (0, $84c2af7dbf01a14d$export$6af3969727ca2a60)(val);
        else return val;
    }
    //-------------------------------------
    // ABSTRACT PARAM INTERFACE
    // all docs are generated from ParamInterface.ts
    //-------------------------------------
    setValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        const numericValue = this._fromType(value);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to setValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(time)}`);
        this._assertRange(numericValue);
        this.log(this.units, "setValueAtTime", value, computedTime);
        this._events.add({
            time: computedTime,
            type: "setValueAtTime",
            value: numericValue
        });
        this._param.setValueAtTime(numericValue, computedTime);
        return this;
    }
    getValueAtTime(time) {
        const computedTime = Math.max(this.toSeconds(time), 0);
        const after = this._events.getAfter(computedTime);
        const before = this._events.get(computedTime);
        let value = this._initialValue;
        // if it was set by
        if (before === null) value = this._initialValue;
        else if (before.type === "setTargetAtTime" && (after === null || after.type === "setValueAtTime")) {
            const previous = this._events.getBefore(before.time);
            let previousVal;
            if (previous === null) previousVal = this._initialValue;
            else previousVal = previous.value;
            if (before.type === "setTargetAtTime") value = this._exponentialApproach(before.time, previousVal, before.value, before.constant, computedTime);
        } else if (after === null) value = before.value;
        else if (after.type === "linearRampToValueAtTime" || after.type === "exponentialRampToValueAtTime") {
            let beforeValue = before.value;
            if (before.type === "setTargetAtTime") {
                const previous = this._events.getBefore(before.time);
                if (previous === null) beforeValue = this._initialValue;
                else beforeValue = previous.value;
            }
            if (after.type === "linearRampToValueAtTime") value = this._linearInterpolate(before.time, beforeValue, after.time, after.value, computedTime);
            else value = this._exponentialInterpolate(before.time, beforeValue, after.time, after.value, computedTime);
        } else value = before.value;
        return this._toType(value);
    }
    setRampPoint(time) {
        time = this.toSeconds(time);
        let currentVal = this.getValueAtTime(time);
        this.cancelAndHoldAtTime(time);
        if (this._fromType(currentVal) === 0) currentVal = this._toType(this._minOutput);
        this.setValueAtTime(currentVal, time);
        return this;
    }
    linearRampToValueAtTime(value, endTime) {
        const numericValue = this._fromType(value);
        const computedTime = this.toSeconds(endTime);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to linearRampToValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(endTime)}`);
        this._assertRange(numericValue);
        this._events.add({
            time: computedTime,
            type: "linearRampToValueAtTime",
            value: numericValue
        });
        this.log(this.units, "linearRampToValueAtTime", value, computedTime);
        this._param.linearRampToValueAtTime(numericValue, computedTime);
        return this;
    }
    exponentialRampToValueAtTime(value, endTime) {
        let numericValue = this._fromType(value);
        // the value can't be 0
        numericValue = (0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(numericValue, 0) ? this._minOutput : numericValue;
        this._assertRange(numericValue);
        const computedTime = this.toSeconds(endTime);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to exponentialRampToValueAtTime: ${JSON.stringify(value)}, ${JSON.stringify(endTime)}`);
        // store the event
        this._events.add({
            time: computedTime,
            type: "exponentialRampToValueAtTime",
            value: numericValue
        });
        this.log(this.units, "exponentialRampToValueAtTime", value, computedTime);
        this._param.exponentialRampToValueAtTime(numericValue, computedTime);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.exponentialRampToValueAtTime(value, startTime + this.toSeconds(rampTime));
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.linearRampToValueAtTime(value, startTime + this.toSeconds(rampTime));
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        startTime = this.toSeconds(startTime);
        this.setRampPoint(startTime);
        this.exponentialApproachValueAtTime(value, startTime, rampTime);
        return this;
    }
    exponentialApproachValueAtTime(value, time, rampTime) {
        time = this.toSeconds(time);
        rampTime = this.toSeconds(rampTime);
        const timeConstant = Math.log(rampTime + 1) / Math.log(200);
        this.setTargetAtTime(value, time, timeConstant);
        // at 90% start a linear ramp to the final value
        this.cancelAndHoldAtTime(time + rampTime * 0.9);
        this.linearRampToValueAtTime(value, time + rampTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        const numericValue = this._fromType(value);
        // The value will never be able to approach without timeConstant > 0.
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(timeConstant) && timeConstant > 0, "timeConstant must be a number greater than 0");
        const computedTime = this.toSeconds(startTime);
        this._assertRange(numericValue);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(numericValue) && isFinite(computedTime), `Invalid argument(s) to setTargetAtTime: ${JSON.stringify(value)}, ${JSON.stringify(startTime)}`);
        this._events.add({
            constant: timeConstant,
            time: computedTime,
            type: "setTargetAtTime",
            value: numericValue
        });
        this.log(this.units, "setTargetAtTime", value, computedTime, timeConstant);
        this._param.setTargetAtTime(numericValue, computedTime, timeConstant);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling = 1) {
        duration = this.toSeconds(duration);
        startTime = this.toSeconds(startTime);
        const startingValue = this._fromType(values[0]) * scaling;
        this.setValueAtTime(this._toType(startingValue), startTime);
        const segTime = duration / (values.length - 1);
        for(let i = 1; i < values.length; i++){
            const numericValue = this._fromType(values[i]) * scaling;
            this.linearRampToValueAtTime(this._toType(numericValue), startTime + i * segTime);
        }
        return this;
    }
    cancelScheduledValues(time) {
        const computedTime = this.toSeconds(time);
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(computedTime), `Invalid argument to cancelScheduledValues: ${JSON.stringify(time)}`);
        this._events.cancel(computedTime);
        this._param.cancelScheduledValues(computedTime);
        this.log(this.units, "cancelScheduledValues", computedTime);
        return this;
    }
    cancelAndHoldAtTime(time) {
        const computedTime = this.toSeconds(time);
        const valueAtTime = this._fromType(this.getValueAtTime(computedTime));
        // remove the schedule events
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isFinite(computedTime), `Invalid argument to cancelAndHoldAtTime: ${JSON.stringify(time)}`);
        this.log(this.units, "cancelAndHoldAtTime", computedTime, "value=" + valueAtTime);
        // if there is an event at the given computedTime
        // and that even is not a "set"
        const before = this._events.get(computedTime);
        const after = this._events.getAfter(computedTime);
        if (before && (0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(before.time, computedTime)) {
            // remove everything after
            if (after) {
                this._param.cancelScheduledValues(after.time);
                this._events.cancel(after.time);
            } else {
                this._param.cancelAndHoldAtTime(computedTime);
                this._events.cancel(computedTime + this.sampleTime);
            }
        } else if (after) {
            this._param.cancelScheduledValues(after.time);
            // cancel the next event(s)
            this._events.cancel(after.time);
            if (after.type === "linearRampToValueAtTime") this.linearRampToValueAtTime(this._toType(valueAtTime), computedTime);
            else if (after.type === "exponentialRampToValueAtTime") this.exponentialRampToValueAtTime(this._toType(valueAtTime), computedTime);
        }
        // set the value at the given time
        this._events.add({
            time: computedTime,
            type: "setValueAtTime",
            value: valueAtTime
        });
        this._param.setValueAtTime(valueAtTime, computedTime);
        return this;
    }
    rampTo(value, rampTime = 0.1, startTime) {
        if (this.units === "frequency" || this.units === "bpm" || this.units === "decibels") this.exponentialRampTo(value, rampTime, startTime);
        else this.linearRampTo(value, rampTime, startTime);
        return this;
    }
    /**
     * Apply all of the previously scheduled events to the passed in Param or AudioParam.
     * The applied values will start at the context's current time and schedule
     * all of the events which are scheduled on this Param onto the passed in param.
     */ apply(param) {
        const now = this.context.currentTime;
        // set the param's value at the current time and schedule everything else
        param.setValueAtTime(this.getValueAtTime(now), now);
        // if the previous event was a curve, then set the rest of it
        const previousEvent = this._events.get(now);
        if (previousEvent && previousEvent.type === "setTargetAtTime") {
            // approx it until the next event with linear ramps
            const nextEvent = this._events.getAfter(previousEvent.time);
            // or for 2 seconds if there is no event
            const endTime = nextEvent ? nextEvent.time : now + 2;
            const subdivisions = (endTime - now) / 10;
            for(let i = now; i < endTime; i += subdivisions)param.linearRampToValueAtTime(this.getValueAtTime(i), i);
        }
        this._events.forEachAfter(this.context.currentTime, (event)=>{
            if (event.type === "cancelScheduledValues") param.cancelScheduledValues(event.time);
            else if (event.type === "setTargetAtTime") param.setTargetAtTime(event.value, event.time, event.constant);
            else param[event.type](event.value, event.time);
        });
        return this;
    }
    /**
     * Replace the Param's internal AudioParam. Will apply scheduled curves
     * onto the parameter and replace the connections.
     */ setParam(param) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this._swappable, "The Param must be assigned as 'swappable' in the constructor");
        const input = this.input;
        input.disconnect(this._param);
        this.apply(param);
        this._param = param;
        input.connect(this._param);
        return this;
    }
    dispose() {
        super.dispose();
        this._events.dispose();
        return this;
    }
    get defaultValue() {
        return this._toType(this._param.defaultValue);
    }
    //-------------------------------------
    // 	AUTOMATION CURVE CALCULATIONS
    // 	MIT License, copyright (c) 2014 Jordan Santell
    //-------------------------------------
    // Calculates the the value along the curve produced by setTargetAtTime
    _exponentialApproach(t0, v0, v1, timeConstant, t) {
        return v1 + (v0 - v1) * Math.exp(-(t - t0) / timeConstant);
    }
    // Calculates the the value along the curve produced by linearRampToValueAtTime
    _linearInterpolate(t0, v0, t1, v1, t) {
        return v0 + (v1 - v0) * ((t - t0) / (t1 - t0));
    }
    // Calculates the the value along the curve produced by exponentialRampToValueAtTime
    _exponentialInterpolate(t0, v0, t1, v1, t) {
        return v0 * Math.pow(v1 / v0, (t - t0) / (t1 - t0));
    }
}







class $1dae52eee8c779dd$export$14a6d069f26d1d33 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super(...arguments);
        /**
         * List all of the node that must be set to match the ChannelProperties
         */ this._internalChannels = [];
    }
    /**
     * The number of inputs feeding into the AudioNode.
     * For source nodes, this will be 0.
     * @example
     * const node = new Tone.Gain();
     * console.log(node.numberOfInputs);
     */ get numberOfInputs() {
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.input)) {
            if ((0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(this.input) || this.input instanceof (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)) return 1;
            else return this.input.numberOfInputs;
        } else return 0;
    }
    /**
     * The number of outputs of the AudioNode.
     * @example
     * const node = new Tone.Gain();
     * console.log(node.numberOfOutputs);
     */ get numberOfOutputs() {
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.output)) return this.output.numberOfOutputs;
        else return 0;
    }
    //-------------------------------------
    // AUDIO PROPERTIES
    //-------------------------------------
    /**
     * Used to decide which nodes to get/set properties on
     */ _isAudioNode(node) {
        return (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(node) && (node instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33 || (0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(node));
    }
    /**
     * Get all of the audio nodes (either internal or input/output) which together
     * make up how the class node responds to channel input/output
     */ _getInternalNodes() {
        const nodeList = this._internalChannels.slice(0);
        if (this._isAudioNode(this.input)) nodeList.push(this.input);
        if (this._isAudioNode(this.output)) {
            if (this.input !== this.output) nodeList.push(this.output);
        }
        return nodeList;
    }
    /**
     * Set the audio options for this node such as channelInterpretation
     * channelCount, etc.
     * @param options
     */ _setChannelProperties(options) {
        const nodeList = this._getInternalNodes();
        nodeList.forEach((node)=>{
            node.channelCount = options.channelCount;
            node.channelCountMode = options.channelCountMode;
            node.channelInterpretation = options.channelInterpretation;
        });
    }
    /**
     * Get the current audio options for this node such as channelInterpretation
     * channelCount, etc.
     */ _getChannelProperties() {
        const nodeList = this._getInternalNodes();
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(nodeList.length > 0, "ToneAudioNode does not have any internal nodes");
        // use the first node to get properties
        // they should all be the same
        const node = nodeList[0];
        return {
            channelCount: node.channelCount,
            channelCountMode: node.channelCountMode,
            channelInterpretation: node.channelInterpretation
        };
    }
    /**
     * channelCount is the number of channels used when up-mixing and down-mixing
     * connections to any inputs to the node. The default value is 2 except for
     * specific nodes where its value is specially determined.
     */ get channelCount() {
        return this._getChannelProperties().channelCount;
    }
    set channelCount(channelCount) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelCount: channelCount
        }));
    }
    /**
     * channelCountMode determines how channels will be counted when up-mixing and
     * down-mixing connections to any inputs to the node.
     * The default value is "max". This attribute has no effect for nodes with no inputs.
     * * "max" - computedNumberOfChannels is the maximum of the number of channels of all connections to an input. In this mode channelCount is ignored.
     * * "clamped-max" - computedNumberOfChannels is determined as for "max" and then clamped to a maximum value of the given channelCount.
     * * "explicit" - computedNumberOfChannels is the exact value as specified by the channelCount.
     */ get channelCountMode() {
        return this._getChannelProperties().channelCountMode;
    }
    set channelCountMode(channelCountMode) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelCountMode: channelCountMode
        }));
    }
    /**
     * channelInterpretation determines how individual channels will be treated
     * when up-mixing and down-mixing connections to any inputs to the node.
     * The default value is "speakers".
     */ get channelInterpretation() {
        return this._getChannelProperties().channelInterpretation;
    }
    set channelInterpretation(channelInterpretation) {
        const props = this._getChannelProperties();
        // merge it with the other properties
        this._setChannelProperties(Object.assign(props, {
            channelInterpretation: channelInterpretation
        }));
    }
    //-------------------------------------
    // CONNECTIONS
    //-------------------------------------
    /**
     * connect the output of a ToneAudioNode to an AudioParam, AudioNode, or ToneAudioNode
     * @param destination The output to connect to
     * @param outputNum The output to connect from
     * @param inputNum The input to connect to
     */ connect(destination, outputNum = 0, inputNum = 0) {
        $1dae52eee8c779dd$export$64605811ab45167f(this, destination, outputNum, inputNum);
        return this;
    }
    /**
     * Connect the output to the context's destination node.
     * @example
     * const osc = new Tone.Oscillator("C2").start();
     * osc.toDestination();
     */ toDestination() {
        this.connect(this.context.destination);
        return this;
    }
    /**
     * Connect the output to the context's destination node.
     * @see {@link toDestination}
     * @deprecated
     */ toMaster() {
        (0, $afc9146c77d080c2$export$c106dd0671a0fc2d)("toMaster() has been renamed toDestination()");
        return this.toDestination();
    }
    /**
     * disconnect the output
     */ disconnect(destination, outputNum = 0, inputNum = 0) {
        $1dae52eee8c779dd$export$37dfea93db2e14ed(this, destination, outputNum, inputNum);
        return this;
    }
    /**
     * Connect the output of this node to the rest of the nodes in series.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/handdrum-loop.mp3");
     * player.autostart = true;
     * const filter = new Tone.AutoFilter(4).start();
     * const distortion = new Tone.Distortion(0.5);
     * // connect the player to the filter, distortion and then to the master output
     * player.chain(filter, distortion, Tone.Destination);
     */ chain(...nodes) {
        $1dae52eee8c779dd$export$933c3b67552fb559(this, ...nodes);
        return this;
    }
    /**
     * connect the output of this node to the rest of the nodes in parallel.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/conga-rhythm.mp3");
     * player.autostart = true;
     * const pitchShift = new Tone.PitchShift(4).toDestination();
     * const filter = new Tone.Filter("G5").toDestination();
     * // connect a node to the pitch shift and filter in parallel
     * player.fan(pitchShift, filter);
     */ fan(...nodes) {
        nodes.forEach((node)=>this.connect(node));
        return this;
    }
    /**
     * Dispose and disconnect
     */ dispose() {
        super.dispose();
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.input)) {
            if (this.input instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33) this.input.dispose();
            else if ((0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(this.input)) this.input.disconnect();
        }
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this.output)) {
            if (this.output instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33) this.output.dispose();
            else if ((0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(this.output)) this.output.disconnect();
        }
        this._internalChannels = [];
        return this;
    }
}
function $1dae52eee8c779dd$export$933c3b67552fb559(...nodes) {
    const first = nodes.shift();
    nodes.reduce((prev, current)=>{
        if (prev instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33) prev.connect(current);
        else if ((0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(prev)) $1dae52eee8c779dd$export$64605811ab45167f(prev, current);
        return current;
    }, first);
}
function $1dae52eee8c779dd$export$64605811ab45167f(srcNode, dstNode, outputNumber = 0, inputNumber = 0) {
    (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(srcNode), "Cannot connect from undefined node");
    (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(dstNode), "Cannot connect to undefined node");
    if (dstNode instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33 || (0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(dstNode)) (0, $afc9146c77d080c2$export$a7a9523472993e97)(dstNode.numberOfInputs > 0, "Cannot connect to node with no inputs");
    (0, $afc9146c77d080c2$export$a7a9523472993e97)(srcNode.numberOfOutputs > 0, "Cannot connect from node with no outputs");
    // resolve the input of the dstNode
    while(dstNode instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33 || dstNode instanceof (0, $4e42d28fbc344697$export$1ca45c9a47aec42c))if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(dstNode.input)) dstNode = dstNode.input;
    while(srcNode instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33)if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(srcNode.output)) srcNode = srcNode.output;
    // make the connection
    if ((0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(dstNode)) srcNode.connect(dstNode, outputNumber);
    else srcNode.connect(dstNode, outputNumber, inputNumber);
}
function $1dae52eee8c779dd$export$37dfea93db2e14ed(srcNode, dstNode, outputNumber = 0, inputNumber = 0) {
    // resolve the destination node
    if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(dstNode)) while(dstNode instanceof $1dae52eee8c779dd$export$14a6d069f26d1d33)dstNode = dstNode.input;
    // resolve the src node
    while(!(0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(srcNode))if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(srcNode.output)) srcNode = srcNode.output;
    if ((0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(dstNode)) srcNode.disconnect(dstNode, outputNumber);
    else if ((0, $1487bdec8f3de4a7$export$85cd8e93eb858e81)(dstNode)) srcNode.disconnect(dstNode, outputNumber, inputNumber);
    else srcNode.disconnect();
}
function $1dae52eee8c779dd$export$9d83629db62ac725(...nodes) {
    const dstNode = nodes.pop();
    if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(dstNode)) nodes.forEach((node)=>$1dae52eee8c779dd$export$64605811ab45167f(node, dstNode));
}











class $10a186a98a559639$export$acd19d919666900d extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($10a186a98a559639$export$acd19d919666900d.getDefaults(), arguments, [
            "gain",
            "units"
        ]);
        super(options);
        this.name = "Gain";
        /**
         * The wrapped GainNode.
         */ this._gainNode = this.context.createGain();
        // input = output
        this.input = this._gainNode;
        this.output = this._gainNode;
        this.gain = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            convert: options.convert,
            param: this._gainNode.gain,
            units: options.units,
            value: options.gain,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "gain");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            convert: true,
            gain: 1,
            units: "gain"
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._gainNode.disconnect();
        this.gain.dispose();
        return this;
    }
}





class $e20d6aed0c7175de$export$27749f88ede4d2a3 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        /**
         * The callback to invoke after the
         * source is done playing.
         */ this.onended = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        /**
         * The start time
         */ this._startTime = -1;
        /**
         * The stop time
         */ this._stopTime = -1;
        /**
         * The id of the timeout
         */ this._timeout = -1;
        /**
         * The public output node
         */ this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        /**
         * The output gain node.
         */ this._gainNode = this.output;
        /**
         * Get the playback state at the given time
         */ this.getStateAtTime = function(time) {
            const computedTime = this.toSeconds(time);
            if (this._startTime !== -1 && computedTime >= this._startTime && (this._stopTime === -1 || computedTime <= this._stopTime)) return "started";
            else return "stopped";
        };
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
        this._curve = options.curve;
        this.onended = options.onended;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            curve: "linear",
            fadeIn: 0,
            fadeOut: 0,
            onended: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)
        });
    }
    /**
     * Start the source at the given time
     * @param  time When to start the source
     */ _startGain(time, gain = 1) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this._startTime === -1, "Source cannot be started more than once");
        // apply a fade in envelope
        const fadeInTime = this.toSeconds(this._fadeIn);
        // record the start time
        this._startTime = time + fadeInTime;
        this._startTime = Math.max(this._startTime, this.context.currentTime);
        // schedule the envelope
        if (fadeInTime > 0) {
            this._gainNode.gain.setValueAtTime(0, time);
            if (this._curve === "linear") this._gainNode.gain.linearRampToValueAtTime(gain, time + fadeInTime);
            else this._gainNode.gain.exponentialApproachValueAtTime(gain, time, fadeInTime);
        } else this._gainNode.gain.setValueAtTime(gain, time);
        return this;
    }
    /**
     * Stop the source node at the given time.
     * @param time When to stop the source
     */ stop(time) {
        this.log("stop", time);
        this._stopGain(this.toSeconds(time));
        return this;
    }
    /**
     * Stop the source at the given time
     * @param  time When to stop the source
     */ _stopGain(time) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this._startTime !== -1, "'start' must be called before 'stop'");
        // cancel the previous stop
        this.cancelStop();
        // the fadeOut time
        const fadeOutTime = this.toSeconds(this._fadeOut);
        // schedule the stop callback
        this._stopTime = this.toSeconds(time) + fadeOutTime;
        this._stopTime = Math.max(this._stopTime, this.now());
        if (fadeOutTime > 0) {
            // start the fade out curve at the given time
            if (this._curve === "linear") this._gainNode.gain.linearRampTo(0, fadeOutTime, time);
            else this._gainNode.gain.targetRampTo(0, fadeOutTime, time);
        } else {
            // stop any ongoing ramps, and set the value to 0
            this._gainNode.gain.cancelAndHoldAtTime(time);
            this._gainNode.gain.setValueAtTime(0, time);
        }
        this.context.clearTimeout(this._timeout);
        this._timeout = this.context.setTimeout(()=>{
            // allow additional time for the exponential curve to fully decay
            const additionalTail = this._curve === "exponential" ? fadeOutTime * 2 : 0;
            this._stopSource(this.now() + additionalTail);
            this._onended();
        }, this._stopTime - this.context.currentTime);
        return this;
    }
    /**
     * Invoke the onended callback
     */ _onended() {
        if (this.onended !== (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)) {
            this.onended(this);
            // overwrite onended to make sure it only is called once
            this.onended = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
            // dispose when it's ended to free up for garbage collection only in the online context
            if (!this.context.isOffline) {
                const disposeCallback = ()=>this.dispose();
                // @ts-ignore
                if (typeof window.requestIdleCallback !== "undefined") // @ts-ignore
                window.requestIdleCallback(disposeCallback);
                else setTimeout(disposeCallback, 1000);
            }
        }
    }
    /**
     * Get the playback state at the current time
     */ get state() {
        return this.getStateAtTime(this.now());
    }
    /**
     * Cancel a scheduled stop event
     */ cancelStop() {
        this.log("cancelStop");
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this._startTime !== -1, "Source is not started");
        // cancel the stop envelope
        this._gainNode.gain.cancelScheduledValues(this._startTime + this.sampleTime);
        this.context.clearTimeout(this._timeout);
        this._stopTime = -1;
        return this;
    }
    dispose() {
        super.dispose();
        this._gainNode.dispose();
        this.onended = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        return this;
    }
}


class $07d091cc6b8a4926$export$717f1ef4ba8fd295 extends (0, $e20d6aed0c7175de$export$27749f88ede4d2a3) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($07d091cc6b8a4926$export$717f1ef4ba8fd295.getDefaults(), arguments, [
            "offset"
        ]);
        super(options);
        this.name = "ToneConstantSource";
        /**
         * The signal generator
         */ this._source = this.context.createConstantSource();
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._source, this._gainNode);
        this.offset = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            convert: options.convert,
            param: this._source.offset,
            units: options.units,
            value: options.offset,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
    }
    static getDefaults() {
        return Object.assign((0, $e20d6aed0c7175de$export$27749f88ede4d2a3).getDefaults(), {
            convert: true,
            offset: 1,
            units: "number"
        });
    }
    /**
     * Start the source node at the given time
     * @param  time When to start the source
     */ start(time) {
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        this._startGain(computedTime);
        this._source.start(computedTime);
        return this;
    }
    _stopSource(time) {
        this._source.stop(time);
    }
    dispose() {
        super.dispose();
        if (this.state === "started") this.stop();
        this._source.disconnect();
        this.offset.dispose();
        return this;
    }
}


class $87a50297d6fa5f61$export$8210dfe1863c478 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($87a50297d6fa5f61$export$8210dfe1863c478.getDefaults(), arguments, [
            "value",
            "units"
        ]);
        super(options);
        this.name = "Signal";
        /**
         * Indicates if the value should be overridden on connection.
         */ this.override = true;
        this.output = this._constantSource = new (0, $07d091cc6b8a4926$export$717f1ef4ba8fd295)({
            context: this.context,
            convert: options.convert,
            offset: options.value,
            units: options.units,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        this._constantSource.start(0);
        this.input = this._param = this._constantSource.offset;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            convert: true,
            units: "number",
            value: 0
        });
    }
    connect(destination, outputNum = 0, inputNum = 0) {
        // start it only when connected to something
        $87a50297d6fa5f61$export$c8174dc07173cff0(this, destination, outputNum, inputNum);
        return this;
    }
    dispose() {
        super.dispose();
        this._param.dispose();
        this._constantSource.dispose();
        return this;
    }
    //-------------------------------------
    // ABSTRACT PARAM INTERFACE
    // just a proxy for the ConstantSourceNode's offset AudioParam
    // all docs are generated from AbstractParam.ts
    //-------------------------------------
    setValueAtTime(value, time) {
        this._param.setValueAtTime(value, time);
        return this;
    }
    getValueAtTime(time) {
        return this._param.getValueAtTime(time);
    }
    setRampPoint(time) {
        this._param.setRampPoint(time);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        this._param.linearRampToValueAtTime(value, time);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        this._param.exponentialRampToValueAtTime(value, time);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        this._param.exponentialRampTo(value, rampTime, startTime);
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        this._param.linearRampTo(value, rampTime, startTime);
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        this._param.targetRampTo(value, rampTime, startTime);
        return this;
    }
    exponentialApproachValueAtTime(value, time, rampTime) {
        this._param.exponentialApproachValueAtTime(value, time, rampTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        this._param.setTargetAtTime(value, startTime, timeConstant);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling) {
        this._param.setValueCurveAtTime(values, startTime, duration, scaling);
        return this;
    }
    cancelScheduledValues(time) {
        this._param.cancelScheduledValues(time);
        return this;
    }
    cancelAndHoldAtTime(time) {
        this._param.cancelAndHoldAtTime(time);
        return this;
    }
    rampTo(value, rampTime, startTime) {
        this._param.rampTo(value, rampTime, startTime);
        return this;
    }
    get value() {
        return this._param.value;
    }
    set value(value) {
        this._param.value = value;
    }
    get convert() {
        return this._param.convert;
    }
    set convert(convert) {
        this._param.convert = convert;
    }
    get units() {
        return this._param.units;
    }
    get overridden() {
        return this._param.overridden;
    }
    set overridden(overridden) {
        this._param.overridden = overridden;
    }
    get maxValue() {
        return this._param.maxValue;
    }
    get minValue() {
        return this._param.minValue;
    }
    /**
     * @see {@link Param.apply}.
     */ apply(param) {
        this._param.apply(param);
        return this;
    }
}
function $87a50297d6fa5f61$export$c8174dc07173cff0(signal, destination, outputNum, inputNum) {
    if (destination instanceof (0, $4e42d28fbc344697$export$1ca45c9a47aec42c) || (0, $1487bdec8f3de4a7$export$1abe4e52803657f3)(destination) || destination instanceof $87a50297d6fa5f61$export$8210dfe1863c478 && destination.override) {
        // cancel changes
        destination.cancelScheduledValues(0);
        // reset the value
        destination.setValueAtTime(0, 0);
        // mark the value as overridden
        if (destination instanceof $87a50297d6fa5f61$export$8210dfe1863c478) destination.overridden = true;
    }
    (0, $1dae52eee8c779dd$export$64605811ab45167f)(signal, destination, outputNum, inputNum);
}







class $11a86ae0932ee6d8$export$7d6cb743a95f18af extends (0, $4e42d28fbc344697$export$1ca45c9a47aec42c) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($11a86ae0932ee6d8$export$7d6cb743a95f18af.getDefaults(), arguments, [
            "value"
        ]);
        super(options);
        this.name = "TickParam";
        /**
         * The timeline which tracks all of the automations.
         */ this._events = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)(Infinity);
        /**
         * The internal holder for the multiplier value
         */ this._multiplier = 1;
        // set the multiplier
        this._multiplier = options.multiplier;
        // clear the ticks from the beginning
        this._events.cancel(0);
        // set an initial event
        this._events.add({
            ticks: 0,
            time: 0,
            type: "setValueAtTime",
            value: this._fromType(options.value)
        });
        this.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $4e42d28fbc344697$export$1ca45c9a47aec42c).getDefaults(), {
            multiplier: 1,
            units: "hertz",
            value: 1
        });
    }
    setTargetAtTime(value, time, constant) {
        // approximate it with multiple linear ramps
        time = this.toSeconds(time);
        this.setRampPoint(time);
        const computedValue = this._fromType(value);
        // start from previously scheduled value
        const prevEvent = this._events.get(time);
        const segments = Math.round(Math.max(1 / constant, 1));
        for(let i = 0; i <= segments; i++){
            const segTime = constant * i + time;
            const rampVal = this._exponentialApproach(prevEvent.time, prevEvent.value, computedValue, constant, segTime);
            this.linearRampToValueAtTime(this._toType(rampVal), segTime);
        }
        return this;
    }
    setValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        super.setValueAtTime(value, time);
        const event = this._events.get(computedTime);
        const previousEvent = this._events.previousEvent(event);
        const ticksUntilTime = this._getTicksUntilEvent(previousEvent, computedTime);
        event.ticks = Math.max(ticksUntilTime, 0);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        const computedTime = this.toSeconds(time);
        super.linearRampToValueAtTime(value, time);
        const event = this._events.get(computedTime);
        const previousEvent = this._events.previousEvent(event);
        const ticksUntilTime = this._getTicksUntilEvent(previousEvent, computedTime);
        event.ticks = Math.max(ticksUntilTime, 0);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        // aproximate it with multiple linear ramps
        time = this.toSeconds(time);
        const computedVal = this._fromType(value);
        // start from previously scheduled value
        const prevEvent = this._events.get(time);
        // approx 10 segments per second
        const segments = Math.round(Math.max((time - prevEvent.time) * 10, 1));
        const segmentDur = (time - prevEvent.time) / segments;
        for(let i = 0; i <= segments; i++){
            const segTime = segmentDur * i + prevEvent.time;
            const rampVal = this._exponentialInterpolate(prevEvent.time, prevEvent.value, time, computedVal, segTime);
            this.linearRampToValueAtTime(this._toType(rampVal), segTime);
        }
        return this;
    }
    /**
     * Returns the tick value at the time. Takes into account
     * any automation curves scheduled on the signal.
     * @param  event The time to get the tick count at
     * @return The number of ticks which have elapsed at the time given any automations.
     */ _getTicksUntilEvent(event, time) {
        if (event === null) event = {
            ticks: 0,
            time: 0,
            type: "setValueAtTime",
            value: 0
        };
        else if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(event.ticks)) {
            const previousEvent = this._events.previousEvent(event);
            event.ticks = this._getTicksUntilEvent(previousEvent, event.time);
        }
        const val0 = this._fromType(this.getValueAtTime(event.time));
        let val1 = this._fromType(this.getValueAtTime(time));
        // if it's right on the line, take the previous value
        const onTheLineEvent = this._events.get(time);
        if (onTheLineEvent && onTheLineEvent.time === time && onTheLineEvent.type === "setValueAtTime") val1 = this._fromType(this.getValueAtTime(time - this.sampleTime));
        return 0.5 * (time - event.time) * (val0 + val1) + event.ticks;
    }
    /**
     * Returns the tick value at the time. Takes into account
     * any automation curves scheduled on the signal.
     * @param  time The time to get the tick count at
     * @return The number of ticks which have elapsed at the time given any automations.
     */ getTicksAtTime(time) {
        const computedTime = this.toSeconds(time);
        const event = this._events.get(computedTime);
        return Math.max(this._getTicksUntilEvent(event, computedTime), 0);
    }
    /**
     * Return the elapsed time of the number of ticks from the given time
     * @param ticks The number of ticks to calculate
     * @param  time The time to get the next tick from
     * @return The duration of the number of ticks from the given time in seconds
     */ getDurationOfTicks(ticks, time) {
        const computedTime = this.toSeconds(time);
        const currentTick = this.getTicksAtTime(time);
        return this.getTimeOfTick(currentTick + ticks) - computedTime;
    }
    /**
     * Given a tick, returns the time that tick occurs at.
     * @return The time that the tick occurs.
     */ getTimeOfTick(tick) {
        const before = this._events.get(tick, "ticks");
        const after = this._events.getAfter(tick, "ticks");
        if (before && before.ticks === tick) return before.time;
        else if (before && after && after.type === "linearRampToValueAtTime" && before.value !== after.value) {
            const val0 = this._fromType(this.getValueAtTime(before.time));
            const val1 = this._fromType(this.getValueAtTime(after.time));
            const delta = (val1 - val0) / (after.time - before.time);
            const k = Math.sqrt(Math.pow(val0, 2) - 2 * delta * (before.ticks - tick));
            const sol1 = (-val0 + k) / delta;
            const sol2 = (-val0 - k) / delta;
            return (sol1 > 0 ? sol1 : sol2) + before.time;
        } else if (before) {
            if (before.value === 0) return Infinity;
            else return before.time + (tick - before.ticks) / before.value;
        } else return tick / this._initialValue;
    }
    /**
     * Convert some number of ticks their the duration in seconds accounting
     * for any automation curves starting at the given time.
     * @param  ticks The number of ticks to convert to seconds.
     * @param  when  When along the automation timeline to convert the ticks.
     * @return The duration in seconds of the ticks.
     */ ticksToTime(ticks, when) {
        return this.getDurationOfTicks(ticks, when);
    }
    /**
     * The inverse of {@link ticksToTime}. Convert a duration in
     * seconds to the corresponding number of ticks accounting for any
     * automation curves starting at the given time.
     * @param  duration The time interval to convert to ticks.
     * @param  when When along the automation timeline to convert the ticks.
     * @return The duration in ticks.
     */ timeToTicks(duration, when) {
        const computedTime = this.toSeconds(when);
        const computedDuration = this.toSeconds(duration);
        const startTicks = this.getTicksAtTime(computedTime);
        const endTicks = this.getTicksAtTime(computedTime + computedDuration);
        return endTicks - startTicks;
    }
    /**
     * Convert from the type when the unit value is BPM
     */ _fromType(val) {
        if (this.units === "bpm" && this.multiplier) return 1 / (60 / val / this.multiplier);
        else return super._fromType(val);
    }
    /**
     * Special case of type conversion where the units === "bpm"
     */ _toType(val) {
        if (this.units === "bpm" && this.multiplier) return val / this.multiplier * 60;
        else return super._toType(val);
    }
    /**
     * A multiplier on the bpm value. Useful for setting a PPQ relative to the base frequency value.
     */ get multiplier() {
        return this._multiplier;
    }
    set multiplier(m) {
        // get and reset the current value with the new multiplier
        // might be necessary to clear all the previous values
        const currentVal = this.value;
        this._multiplier = m;
        this.cancelScheduledValues(0);
        this.setValueAtTime(currentVal, 0);
    }
}


class $0a0ea9c4476e6e0b$export$f1be63c3ef84bc34 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0a0ea9c4476e6e0b$export$f1be63c3ef84bc34.getDefaults(), arguments, [
            "value"
        ]);
        super(options);
        this.name = "TickSignal";
        this.input = this._param = new (0, $11a86ae0932ee6d8$export$7d6cb743a95f18af)({
            context: this.context,
            convert: options.convert,
            multiplier: options.multiplier,
            param: this._constantSource.offset,
            units: options.units,
            value: options.value
        });
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            multiplier: 1,
            units: "hertz",
            value: 1
        });
    }
    ticksToTime(ticks, when) {
        return this._param.ticksToTime(ticks, when);
    }
    timeToTicks(duration, when) {
        return this._param.timeToTicks(duration, when);
    }
    getTimeOfTick(tick) {
        return this._param.getTimeOfTick(tick);
    }
    getDurationOfTicks(ticks, time) {
        return this._param.getDurationOfTicks(ticks, time);
    }
    getTicksAtTime(time) {
        return this._param.getTicksAtTime(time);
    }
    /**
     * A multiplier on the bpm value. Useful for setting a PPQ relative to the base frequency value.
     */ get multiplier() {
        return this._param.multiplier;
    }
    set multiplier(m) {
        this._param.multiplier = m;
    }
    dispose() {
        super.dispose();
        this._param.dispose();
        return this;
    }
}



class $75fb8f7356b6d0dc$export$617abaa845df50f1 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($75fb8f7356b6d0dc$export$617abaa845df50f1.getDefaults(), arguments, [
            "frequency"
        ]);
        super(options);
        this.name = "TickSource";
        /**
         * The state timeline
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)();
        /**
         * The offset values of the ticks
         */ this._tickOffset = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        /**
         * Memoized values of getTicksAtTime at events with state other than "started"
         */ this._ticksAtTime = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        /**
         * Memoized values of getSecondsAtTime at events with state other than "started"
         */ this._secondsAtTime = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        this.frequency = new (0, $0a0ea9c4476e6e0b$export$f1be63c3ef84bc34)({
            context: this.context,
            units: options.units,
            value: options.frequency
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "frequency");
        // set the initial state
        this._state.setStateAtTime("stopped", 0);
        // add the first event
        this.setTicksAtTime(0, 0);
    }
    static getDefaults() {
        return Object.assign({
            frequency: 1,
            units: "hertz"
        }, (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults());
    }
    /**
     * Returns the playback state of the source, either "started", "stopped" or "paused".
     */ get state() {
        return this.getStateAtTime(this.now());
    }
    /**
     * Start the clock at the given time. Optionally pass in an offset
     * of where to start the tick counter from.
     * @param  time    The time the clock should start
     * @param offset The number of ticks to start the source at
     */ start(time, offset) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) !== "started") {
            this._state.setStateAtTime("started", computedTime);
            if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(offset)) this.setTicksAtTime(offset, computedTime);
            this._ticksAtTime.cancel(computedTime);
            this._secondsAtTime.cancel(computedTime);
        }
        return this;
    }
    /**
     * Stop the clock. Stopping the clock resets the tick counter to 0.
     * @param time The time when the clock should stop.
     */ stop(time) {
        const computedTime = this.toSeconds(time);
        // cancel the previous stop
        if (this._state.getValueAtTime(computedTime) === "stopped") {
            const event = this._state.get(computedTime);
            if (event && event.time > 0) {
                this._tickOffset.cancel(event.time);
                this._state.cancel(event.time);
            }
        }
        this._state.cancel(computedTime);
        this._state.setStateAtTime("stopped", computedTime);
        this.setTicksAtTime(0, computedTime);
        this._ticksAtTime.cancel(computedTime);
        this._secondsAtTime.cancel(computedTime);
        return this;
    }
    /**
     * Pause the clock. Pausing does not reset the tick counter.
     * @param time The time when the clock should stop.
     */ pause(time) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) === "started") {
            this._state.setStateAtTime("paused", computedTime);
            this._ticksAtTime.cancel(computedTime);
            this._secondsAtTime.cancel(computedTime);
        }
        return this;
    }
    /**
     * Cancel start/stop/pause and setTickAtTime events scheduled after the given time.
     * @param time When to clear the events after
     */ cancel(time) {
        time = this.toSeconds(time);
        this._state.cancel(time);
        this._tickOffset.cancel(time);
        this._ticksAtTime.cancel(time);
        this._secondsAtTime.cancel(time);
        return this;
    }
    /**
     * Get the elapsed ticks at the given time
     * @param  time  When to get the tick value
     * @return The number of ticks
     */ getTicksAtTime(time) {
        const computedTime = this.toSeconds(time);
        const stopEvent = this._state.getLastState("stopped", computedTime);
        // get previously memoized ticks if available
        const memoizedEvent = this._ticksAtTime.get(computedTime);
        // this event allows forEachBetween to iterate until the current time
        const tmpEvent = {
            state: "paused",
            time: computedTime
        };
        this._state.add(tmpEvent);
        // keep track of the previous offset event
        let lastState = memoizedEvent ? memoizedEvent : stopEvent;
        let elapsedTicks = memoizedEvent ? memoizedEvent.ticks : 0;
        let eventToMemoize = null;
        // iterate through all the events since the last stop
        this._state.forEachBetween(lastState.time, computedTime + this.sampleTime, (e)=>{
            let periodStartTime = lastState.time;
            // if there is an offset event in this period use that
            const offsetEvent = this._tickOffset.get(e.time);
            if (offsetEvent && offsetEvent.time >= lastState.time) {
                elapsedTicks = offsetEvent.ticks;
                periodStartTime = offsetEvent.time;
            }
            if (lastState.state === "started" && e.state !== "started") {
                elapsedTicks += this.frequency.getTicksAtTime(e.time) - this.frequency.getTicksAtTime(periodStartTime);
                // do not memoize the temporary event
                if (e.time !== tmpEvent.time) eventToMemoize = {
                    state: e.state,
                    time: e.time,
                    ticks: elapsedTicks
                };
            }
            lastState = e;
        });
        // remove the temporary event
        this._state.remove(tmpEvent);
        // memoize the ticks at the most recent event with state other than "started"
        if (eventToMemoize) this._ticksAtTime.add(eventToMemoize);
        // return the ticks
        return elapsedTicks;
    }
    /**
     * The number of times the callback was invoked. Starts counting at 0
     * and increments after the callback was invoked. Returns -1 when stopped.
     */ get ticks() {
        return this.getTicksAtTime(this.now());
    }
    set ticks(t) {
        this.setTicksAtTime(t, this.now());
    }
    /**
     * The time since ticks=0 that the TickSource has been running. Accounts
     * for tempo curves
     */ get seconds() {
        return this.getSecondsAtTime(this.now());
    }
    set seconds(s) {
        const now = this.now();
        const ticks = this.frequency.timeToTicks(s, now);
        this.setTicksAtTime(ticks, now);
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        time = this.toSeconds(time);
        const stopEvent = this._state.getLastState("stopped", time);
        // this event allows forEachBetween to iterate until the current time
        const tmpEvent = {
            state: "paused",
            time: time
        };
        this._state.add(tmpEvent);
        // get previously memoized seconds if available
        const memoizedEvent = this._secondsAtTime.get(time);
        // keep track of the previous offset event
        let lastState = memoizedEvent ? memoizedEvent : stopEvent;
        let elapsedSeconds = memoizedEvent ? memoizedEvent.seconds : 0;
        let eventToMemoize = null;
        // iterate through all the events since the last stop
        this._state.forEachBetween(lastState.time, time + this.sampleTime, (e)=>{
            let periodStartTime = lastState.time;
            // if there is an offset event in this period use that
            const offsetEvent = this._tickOffset.get(e.time);
            if (offsetEvent && offsetEvent.time >= lastState.time) {
                elapsedSeconds = offsetEvent.seconds;
                periodStartTime = offsetEvent.time;
            }
            if (lastState.state === "started" && e.state !== "started") {
                elapsedSeconds += e.time - periodStartTime;
                // do not memoize the temporary event
                if (e.time !== tmpEvent.time) eventToMemoize = {
                    state: e.state,
                    time: e.time,
                    seconds: elapsedSeconds
                };
            }
            lastState = e;
        });
        // remove the temporary event
        this._state.remove(tmpEvent);
        // memoize the seconds at the most recent event with state other than "started"
        if (eventToMemoize) this._secondsAtTime.add(eventToMemoize);
        // return the seconds
        return elapsedSeconds;
    }
    /**
     * Set the clock's ticks at the given time.
     * @param  ticks The tick value to set
     * @param  time  When to set the tick value
     */ setTicksAtTime(ticks, time) {
        time = this.toSeconds(time);
        this._tickOffset.cancel(time);
        this._tickOffset.add({
            seconds: this.frequency.getDurationOfTicks(ticks, time),
            ticks: ticks,
            time: time
        });
        this._ticksAtTime.cancel(time);
        this._secondsAtTime.cancel(time);
        return this;
    }
    /**
     * Returns the scheduled state at the given time.
     * @param  time  The time to query.
     */ getStateAtTime(time) {
        time = this.toSeconds(time);
        return this._state.getValueAtTime(time);
    }
    /**
     * Get the time of the given tick. The second argument
     * is when to test before. Since ticks can be set (with setTicksAtTime)
     * there may be multiple times for a given tick value.
     * @param  tick The tick number.
     * @param  before When to measure the tick value from.
     * @return The time of the tick
     */ getTimeOfTick(tick, before = this.now()) {
        const offset = this._tickOffset.get(before);
        const event = this._state.get(before);
        const startTime = Math.max(offset.time, event.time);
        const absoluteTicks = this.frequency.getTicksAtTime(startTime) + tick - offset.ticks;
        return this.frequency.getTimeOfTick(absoluteTicks);
    }
    /**
     * Invoke the callback event at all scheduled ticks between the
     * start time and the end time
     * @param  startTime  The beginning of the search range
     * @param  endTime    The end of the search range
     * @param  callback   The callback to invoke with each tick
     */ forEachTickBetween(startTime, endTime, callback) {
        // only iterate through the sections where it is "started"
        let lastStateEvent = this._state.get(startTime);
        this._state.forEachBetween(startTime, endTime, (event)=>{
            if (lastStateEvent && lastStateEvent.state === "started" && event.state !== "started") this.forEachTickBetween(Math.max(lastStateEvent.time, startTime), event.time - this.sampleTime, callback);
            lastStateEvent = event;
        });
        let error = null;
        if (lastStateEvent && lastStateEvent.state === "started") {
            const maxStartTime = Math.max(lastStateEvent.time, startTime);
            // figure out the difference between the frequency ticks and the
            const startTicks = this.frequency.getTicksAtTime(maxStartTime);
            const ticksAtStart = this.frequency.getTicksAtTime(lastStateEvent.time);
            const diff = startTicks - ticksAtStart;
            let offset = Math.ceil(diff) - diff;
            // guard against floating point issues
            offset = (0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(offset, 1) ? 0 : offset;
            let nextTickTime = this.frequency.getTimeOfTick(startTicks + offset);
            while(nextTickTime < endTime){
                try {
                    callback(nextTickTime, Math.round(this.getTicksAtTime(nextTickTime)));
                } catch (e) {
                    error = e;
                    break;
                }
                nextTickTime += this.frequency.getDurationOfTicks(1, nextTickTime);
            }
        }
        if (error) throw error;
        return this;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._state.dispose();
        this._tickOffset.dispose();
        this._ticksAtTime.dispose();
        this._secondsAtTime.dispose();
        this.frequency.dispose();
        return this;
    }
}



class $b0382ab9b2ce11b2$export$9735c82c4bae3302 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($b0382ab9b2ce11b2$export$9735c82c4bae3302.getDefaults(), arguments, [
            "callback",
            "frequency"
        ]);
        super(options);
        this.name = "Clock";
        /**
         * The callback function to invoke at the scheduled tick.
         */ this.callback = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        /**
         * The last time the loop callback was invoked
         */ this._lastUpdate = 0;
        /**
         * Keep track of the playback state
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)("stopped");
        /**
         * Context bound reference to the _loop method
         * This is necessary to remove the event in the end.
         */ this._boundLoop = this._loop.bind(this);
        this.callback = options.callback;
        this._tickSource = new (0, $75fb8f7356b6d0dc$export$617abaa845df50f1)({
            context: this.context,
            frequency: options.frequency,
            units: options.units
        });
        this._lastUpdate = 0;
        this.frequency = this._tickSource.frequency;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "frequency");
        // add an initial state
        this._state.setStateAtTime("stopped", 0);
        // bind a callback to the worker thread
        this.context.on("tick", this._boundLoop);
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            frequency: 1,
            units: "hertz"
        });
    }
    /**
     * Returns the playback state of the source, either "started", "stopped" or "paused".
     */ get state() {
        return this._state.getValueAtTime(this.now());
    }
    /**
     * Start the clock at the given time. Optionally pass in an offset
     * of where to start the tick counter from.
     * @param  time    The time the clock should start
     * @param offset  Where the tick counter starts counting from.
     */ start(time, offset) {
        // make sure the context is running
        (0, $afc9146c77d080c2$export$8ef1ce44f93c2687)(this.context);
        // start the loop
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        if (this._state.getValueAtTime(computedTime) !== "started") {
            this._state.setStateAtTime("started", computedTime);
            this._tickSource.start(computedTime, offset);
            if (computedTime < this._lastUpdate) this.emit("start", computedTime, offset);
        }
        return this;
    }
    /**
     * Stop the clock. Stopping the clock resets the tick counter to 0.
     * @param time The time when the clock should stop.
     * @example
     * const clock = new Tone.Clock(time => {
     * 	console.log(time);
     * }, 1);
     * clock.start();
     * // stop the clock after 10 seconds
     * clock.stop("+10");
     */ stop(time) {
        const computedTime = this.toSeconds(time);
        this.log("stop", computedTime);
        this._state.cancel(computedTime);
        this._state.setStateAtTime("stopped", computedTime);
        this._tickSource.stop(computedTime);
        if (computedTime < this._lastUpdate) this.emit("stop", computedTime);
        return this;
    }
    /**
     * Pause the clock. Pausing does not reset the tick counter.
     * @param time The time when the clock should stop.
     */ pause(time) {
        const computedTime = this.toSeconds(time);
        if (this._state.getValueAtTime(computedTime) === "started") {
            this._state.setStateAtTime("paused", computedTime);
            this._tickSource.pause(computedTime);
            if (computedTime < this._lastUpdate) this.emit("pause", computedTime);
        }
        return this;
    }
    /**
     * The number of times the callback was invoked. Starts counting at 0
     * and increments after the callback was invoked.
     */ get ticks() {
        return Math.ceil(this.getTicksAtTime(this.now()));
    }
    set ticks(t) {
        this._tickSource.ticks = t;
    }
    /**
     * The time since ticks=0 that the Clock has been running. Accounts for tempo curves
     */ get seconds() {
        return this._tickSource.seconds;
    }
    set seconds(s) {
        this._tickSource.seconds = s;
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        return this._tickSource.getSecondsAtTime(time);
    }
    /**
     * Set the clock's ticks at the given time.
     * @param  ticks The tick value to set
     * @param  time  When to set the tick value
     */ setTicksAtTime(ticks, time) {
        this._tickSource.setTicksAtTime(ticks, time);
        return this;
    }
    /**
     * Get the time of the given tick. The second argument
     * is when to test before. Since ticks can be set (with setTicksAtTime)
     * there may be multiple times for a given tick value.
     * @param  tick The tick number.
     * @param  before When to measure the tick value from.
     * @return The time of the tick
     */ getTimeOfTick(tick, before = this.now()) {
        return this._tickSource.getTimeOfTick(tick, before);
    }
    /**
     * Get the clock's ticks at the given time.
     * @param  time  When to get the tick value
     * @return The tick value at the given time.
     */ getTicksAtTime(time) {
        return this._tickSource.getTicksAtTime(time);
    }
    /**
     * Get the time of the next tick
     * @param  offset The tick number.
     */ nextTickTime(offset, when) {
        const computedTime = this.toSeconds(when);
        const currentTick = this.getTicksAtTime(computedTime);
        return this._tickSource.getTimeOfTick(currentTick + offset, computedTime);
    }
    /**
     * The scheduling loop.
     */ _loop() {
        const startTime = this._lastUpdate;
        const endTime = this.now();
        this._lastUpdate = endTime;
        this.log("loop", startTime, endTime);
        if (startTime !== endTime) {
            // the state change events
            this._state.forEachBetween(startTime, endTime, (e)=>{
                switch(e.state){
                    case "started":
                        const offset = this._tickSource.getTicksAtTime(e.time);
                        this.emit("start", e.time, offset);
                        break;
                    case "stopped":
                        if (e.time !== 0) this.emit("stop", e.time);
                        break;
                    case "paused":
                        this.emit("pause", e.time);
                        break;
                }
            });
            // the tick callbacks
            this._tickSource.forEachTickBetween(startTime, endTime, (time, ticks)=>{
                this.callback(time, ticks);
            });
        }
    }
    /**
     * Returns the scheduled state at the given time.
     * @param  time  The time to query.
     * @return  The name of the state input in setStateAtTime.
     * @example
     * const clock = new Tone.Clock();
     * clock.start("+0.1");
     * clock.getStateAtTime("+0.1"); // returns "started"
     */ getStateAtTime(time) {
        const computedTime = this.toSeconds(time);
        return this._state.getValueAtTime(computedTime);
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.context.off("tick", this._boundLoop);
        this._tickSource.dispose();
        this._state.dispose();
        return this;
    }
}
(0, $092748a42ac93843$export$4293555f241ae35a).mixin($b0382ab9b2ce11b2$export$9735c82c4bae3302);








class $89c598137ecf8dce$export$7419ff430885d61c extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($89c598137ecf8dce$export$7419ff430885d61c.getDefaults(), arguments, [
            "delayTime",
            "maxDelay"
        ]);
        super(options);
        this.name = "Delay";
        const maxDelayInSeconds = this.toSeconds(options.maxDelay);
        this._maxDelay = Math.max(maxDelayInSeconds, this.toSeconds(options.delayTime));
        this._delayNode = this.input = this.output = this.context.createDelay(maxDelayInSeconds);
        this.delayTime = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._delayNode.delayTime,
            units: "time",
            value: options.delayTime,
            minValue: 0,
            maxValue: this.maxDelay
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "delayTime");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            delayTime: 0,
            maxDelay: 1
        });
    }
    /**
     * The maximum delay time. This cannot be changed after
     * the value is passed into the constructor.
     */ get maxDelay() {
        return this._maxDelay;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._delayNode.disconnect();
        this.delayTime.dispose();
        return this;
    }
}











class $0515efee749e4f6d$export$dde279e52d625429 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0515efee749e4f6d$export$dde279e52d625429.getDefaults(), arguments, [
            "volume"
        ]);
        super(options);
        this.name = "Volume";
        this.input = this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.volume,
            units: "decibels"
        });
        this.volume = this.output.gain;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
        this._unmutedVolume = options.volume;
        // set the mute initially
        this.mute = options.mute;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Mute the output.
     * @example
     * const vol = new Tone.Volume(-12).toDestination();
     * const osc = new Tone.Oscillator().connect(vol).start();
     * // mute the output
     * vol.mute = true;
     */ get mute() {
        return this.volume.value === -Infinity;
    }
    set mute(mute) {
        if (!this.mute && mute) {
            this._unmutedVolume = this.volume.value;
            // maybe it should ramp here?
            this.volume.value = -Infinity;
        } else if (this.mute && !mute) this.volume.value = this._unmutedVolume;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this.input.dispose();
        this.volume.dispose();
        return this;
    }
}






class $2a339a17ddbbd1c5$export$5c0ea2d9ce784961 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2a339a17ddbbd1c5$export$5c0ea2d9ce784961.getDefaults(), arguments);
        super(options);
        this.name = "Destination";
        this.input = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The volume of the master output in decibels. -Infinity is silent, and 0 is no change.
         * @example
         * const osc = new Tone.Oscillator().toDestination();
         * osc.start();
         * // ramp the volume down to silent over 10 seconds
         * Tone.getDestination().volume.rampTo(-Infinity, 10);
         */ this.volume = this.input.volume;
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, this.output, this.context.rawContext.destination);
        this.mute = options.mute;
        this._internalChannels = [
            this.input,
            this.context.rawContext.destination,
            this.output
        ];
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Mute the output.
     * @example
     * const oscillator = new Tone.Oscillator().start().toDestination();
     * setTimeout(() => {
     * 	// mute the output
     * 	Tone.Destination.mute = true;
     * }, 1000);
     */ get mute() {
        return this.input.mute;
    }
    set mute(mute) {
        this.input.mute = mute;
    }
    /**
     * Add a master effects chain. NOTE: this will disconnect any nodes which were previously
     * chained in the master effects chain.
     * @param args All arguments will be connected in a row and the Master will be routed through it.
     * @example
     * // route all audio through a filter and compressor
     * const lowpass = new Tone.Filter(800, "lowpass");
     * const compressor = new Tone.Compressor(-18);
     * Tone.Destination.chain(lowpass, compressor);
     */ chain(...args) {
        this.input.disconnect();
        args.unshift(this.input);
        args.push(this.output);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(...args);
        return this;
    }
    /**
     * The maximum number of channels the system can output
     * @example
     * console.log(Tone.Destination.maxChannelCount);
     */ get maxChannelCount() {
        return this.context.rawContext.destination.maxChannelCount;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.volume.dispose();
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $33268d33018da22a$export$cdd816203a02e74e)((context)=>{
    context.destination = new $2a339a17ddbbd1c5$export$5c0ea2d9ce784961({
        context: context
    });
});
(0, $33268d33018da22a$export$7e1ecadd06ae8222)((context)=>{
    context.destination.dispose();
});





class $a325a8508d33c2c8$export$d8d619149fb795ef extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super(...arguments);
        this.name = "Listener";
        this.positionX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.positionX
        });
        this.positionY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.positionY
        });
        this.positionZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.positionZ
        });
        this.forwardX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.forwardX
        });
        this.forwardY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.forwardY
        });
        this.forwardZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.forwardZ
        });
        this.upX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.upX
        });
        this.upY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.upY
        });
        this.upZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this.context.rawContext.listener.upZ
        });
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            forwardX: 0,
            forwardY: 0,
            forwardZ: -1,
            upX: 0,
            upY: 1,
            upZ: 0
        });
    }
    dispose() {
        super.dispose();
        this.positionX.dispose();
        this.positionY.dispose();
        this.positionZ.dispose();
        this.forwardX.dispose();
        this.forwardY.dispose();
        this.forwardZ.dispose();
        this.upX.dispose();
        this.upY.dispose();
        this.upZ.dispose();
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $33268d33018da22a$export$cdd816203a02e74e)((context)=>{
    context.listener = new $a325a8508d33c2c8$export$d8d619149fb795ef({
        context: context
    });
});
(0, $33268d33018da22a$export$7e1ecadd06ae8222)((context)=>{
    context.listener.dispose();
});


function $b8b3069e267f9fe7$export$a273407dc53e3f0a(callback_1, duration_1) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(callback, duration, channels = 2, sampleRate = (0, $b7b11709569bdbef$export$31553aaa555c1514)().sampleRate) {
        // set the OfflineAudioContext based on the current context
        const originalContext = (0, $b7b11709569bdbef$export$31553aaa555c1514)();
        const context = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(channels, duration, sampleRate);
        (0, $b7b11709569bdbef$export$2f04de43fe27971a)(context);
        // invoke the callback/scheduling
        yield callback(context);
        // then render the audio
        const bufferPromise = context.render();
        // return the original AudioContext
        (0, $b7b11709569bdbef$export$2f04de43fe27971a)(originalContext);
        // await the rendering
        const buffer = yield bufferPromise;
        // return the audio
        return new (0, $43da6dea502b5fe8$export$424a335715b38178)(buffer);
    });
}











class $d37bb61f6ec53d08$export$7232b969b571e570 extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super();
        this.name = "ToneAudioBuffers";
        /**
         * All of the buffers
         */ this._buffers = new Map();
        /**
         * Keep track of the number of loaded buffers
         */ this._loadingCount = 0;
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($d37bb61f6ec53d08$export$7232b969b571e570.getDefaults(), arguments, [
            "urls",
            "onload",
            "baseUrl"
        ], "urls");
        this.baseUrl = options.baseUrl;
        // add each one
        Object.keys(options.urls).forEach((name)=>{
            this._loadingCount++;
            const url = options.urls[name];
            this.add(name, url, this._bufferLoaded.bind(this, options.onload), options.onerror);
        });
    }
    static getDefaults() {
        return {
            baseUrl: "",
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            urls: {}
        };
    }
    /**
     * True if the buffers object has a buffer by that name.
     * @param  name  The key or index of the buffer.
     */ has(name) {
        return this._buffers.has(name.toString());
    }
    /**
     * Get a buffer by name. If an array was loaded,
     * then use the array index.
     * @param  name  The key or index of the buffer.
     */ get(name) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.has(name), `ToneAudioBuffers has no buffer named: ${name}`);
        return this._buffers.get(name.toString());
    }
    /**
     * A buffer was loaded. decrement the counter.
     */ _bufferLoaded(callback) {
        this._loadingCount--;
        if (this._loadingCount === 0 && callback) callback();
    }
    /**
     * If the buffers are loaded or not
     */ get loaded() {
        return Array.from(this._buffers).every(([_, buffer])=>buffer.loaded);
    }
    /**
     * Add a buffer by name and url to the Buffers
     * @param  name      A unique name to give the buffer
     * @param  url  Either the url of the bufer, or a buffer which will be added with the given name.
     * @param  callback  The callback to invoke when the url is loaded.
     * @param  onerror  Invoked if the buffer can't be loaded
     */ add(name, url, callback = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b), onerror = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)) {
        if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(url)) {
            // don't include the baseUrl if the url is a base64 encoded sound
            if (this.baseUrl && url.trim().substring(0, 11).toLowerCase() === "data:audio/") this.baseUrl = "";
            this._buffers.set(name.toString(), new (0, $43da6dea502b5fe8$export$424a335715b38178)(this.baseUrl + url, callback, onerror));
        } else this._buffers.set(name.toString(), new (0, $43da6dea502b5fe8$export$424a335715b38178)(url, callback, onerror));
        return this;
    }
    dispose() {
        super.dispose();
        this._buffers.forEach((buffer)=>buffer.dispose());
        this._buffers.clear();
        return this;
    }
}







class $acb4e2b4a4f69a23$export$266cef4b055bf7de extends (0, $f4d7193118bd1d27$export$38b56155c8552868) {
    constructor(){
        super(...arguments);
        this.name = "MidiClass";
        this.defaultUnits = "midi";
    }
    /**
     * Returns the value of a frequency in the current units
     */ _frequencyToUnits(freq) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(super._frequencyToUnits(freq));
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(super._ticksToUnits(ticks));
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(super._beatsToUnits(beats));
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return (0, $84c2af7dbf01a14d$export$5cf9d9f9506eec5)(super._secondsToUnits(seconds));
    }
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Midi(60).toMidi(); // 60
     */ toMidi() {
        return this.valueOf();
    }
    /**
     * Return the value of the frequency as a MIDI note
     * @example
     * Tone.Midi(60).toFrequency(); // 261.6255653005986
     */ toFrequency() {
        return (0, $84c2af7dbf01a14d$export$45a6434f7c391dc)(this.toMidi());
    }
    /**
     * Transposes the frequency by the given number of semitones.
     * @return A new transposed MidiClass
     * @example
     * Tone.Midi("A4").transpose(3); // "C5"
     */ transpose(interval) {
        return new $acb4e2b4a4f69a23$export$266cef4b055bf7de(this.context, this.toMidi() + interval);
    }
}
function $acb4e2b4a4f69a23$export$ed87582254f87fd5(value, units) {
    return new $acb4e2b4a4f69a23$export$266cef4b055bf7de((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}





class $1c1f4b05c313775e$export$fe3569694b9f5728 extends (0, $ef656febef4c2085$export$c824041178a9697) {
    constructor(){
        super(...arguments);
        this.name = "Ticks";
        this.defaultUnits = "i";
    }
    /**
     * Get the current time in the given units
     */ _now() {
        return this.context.transport.ticks;
    }
    /**
     * Return the value of the beats in the current units
     */ _beatsToUnits(beats) {
        return this._getPPQ() * beats;
    }
    /**
     * Returns the value of a second in the current units
     */ _secondsToUnits(seconds) {
        return Math.floor(seconds / (60 / this._getBpm()) * this._getPPQ());
    }
    /**
     * Returns the value of a tick in the current time units
     */ _ticksToUnits(ticks) {
        return ticks;
    }
    /**
     * Return the time in ticks
     */ toTicks() {
        return this.valueOf();
    }
    /**
     * Return the time in seconds
     */ toSeconds() {
        return this.valueOf() / this._getPPQ() * (60 / this._getBpm());
    }
}
function $1c1f4b05c313775e$export$27c7467594ef87bd(value, units) {
    return new $1c1f4b05c313775e$export$fe3569694b9f5728((0, $b7b11709569bdbef$export$31553aaa555c1514)(), value, units);
}






class $86309483b65de2a8$export$ff4a280554e165ea extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        super(...arguments);
        this.name = "Draw";
        /**
         * The duration after which events are not invoked.
         */ this.expiration = 0.25;
        /**
         * The amount of time before the scheduled time
         * that the callback can be invoked. Default is
         * half the time of an animation frame (0.008 seconds).
         */ this.anticipation = 0.008;
        /**
         * All of the events.
         */ this._events = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        /**
         * The draw loop
         */ this._boundDrawLoop = this._drawLoop.bind(this);
        /**
         * The animation frame id
         */ this._animationFrame = -1;
    }
    /**
     * Schedule a function at the given time to be invoked
     * on the nearest animation frame.
     * @param  callback  Callback is invoked at the given time.
     * @param  time      The time relative to the AudioContext time to invoke the callback.
     * @example
     * Tone.Transport.scheduleRepeat(time => {
     * 	Tone.Draw.schedule(() => console.log(time), time);
     * }, 1);
     * Tone.Transport.start();
     */ schedule(callback, time) {
        this._events.add({
            callback: callback,
            time: this.toSeconds(time)
        });
        // start the draw loop on the first event
        if (this._events.length === 1) this._animationFrame = requestAnimationFrame(this._boundDrawLoop);
        return this;
    }
    /**
     * Cancel events scheduled after the given time
     * @param  after  Time after which scheduled events will be removed from the scheduling timeline.
     */ cancel(after) {
        this._events.cancel(this.toSeconds(after));
        return this;
    }
    /**
     * The draw loop
     */ _drawLoop() {
        const now = this.context.currentTime;
        while(this._events.length && this._events.peek().time - this.anticipation <= now){
            const event = this._events.shift();
            if (event && now - event.time <= this.expiration) event.callback();
        }
        if (this._events.length > 0) this._animationFrame = requestAnimationFrame(this._boundDrawLoop);
    }
    dispose() {
        super.dispose();
        this._events.dispose();
        cancelAnimationFrame(this._animationFrame);
        return this;
    }
}
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $33268d33018da22a$export$cdd816203a02e74e)((context)=>{
    context.draw = new $86309483b65de2a8$export$ff4a280554e165ea({
        context: context
    });
});
(0, $33268d33018da22a$export$7e1ecadd06ae8222)((context)=>{
    context.draw.dispose();
});






class $0953b64e7eb19dcb$export$5a615b1a895bd9ec extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    constructor(){
        super(...arguments);
        this.name = "IntervalTimeline";
        /**
         * The root node of the inteval tree
         */ this._root = null;
        /**
         * Keep track of the length of the timeline.
         */ this._length = 0;
    }
    /**
     * The event to add to the timeline. All events must
     * have a time and duration value
     * @param  event  The event to add to the timeline
     */ add(event) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(event.time), "Events must have a time property");
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(event.duration), "Events must have a duration parameter");
        event.time = event.time.valueOf();
        let node = new $0953b64e7eb19dcb$var$IntervalNode(event.time, event.time + event.duration, event);
        if (this._root === null) this._root = node;
        else this._root.insert(node);
        this._length++;
        // Restructure tree to be balanced
        while(node !== null){
            node.updateHeight();
            node.updateMax();
            this._rebalance(node);
            node = node.parent;
        }
        return this;
    }
    /**
     * Remove an event from the timeline.
     * @param  event  The event to remove from the timeline
     */ remove(event) {
        if (this._root !== null) {
            const results = [];
            this._root.search(event.time, results);
            for (const node of results)if (node.event === event) {
                this._removeNode(node);
                this._length--;
                break;
            }
        }
        return this;
    }
    /**
     * The number of items in the timeline.
     * @readOnly
     */ get length() {
        return this._length;
    }
    /**
     * Remove events whose time time is after the given time
     * @param  after  The time to query.
     */ cancel(after) {
        this.forEachFrom(after, (event)=>this.remove(event));
        return this;
    }
    /**
     * Set the root node as the given node
     */ _setRoot(node) {
        this._root = node;
        if (this._root !== null) this._root.parent = null;
    }
    /**
     * Replace the references to the node in the node's parent
     * with the replacement node.
     */ _replaceNodeInParent(node, replacement) {
        if (node.parent !== null) {
            if (node.isLeftChild()) node.parent.left = replacement;
            else node.parent.right = replacement;
            this._rebalance(node.parent);
        } else this._setRoot(replacement);
    }
    /**
     * Remove the node from the tree and replace it with
     * a successor which follows the schema.
     */ _removeNode(node) {
        if (node.left === null && node.right === null) this._replaceNodeInParent(node, null);
        else if (node.right === null) this._replaceNodeInParent(node, node.left);
        else if (node.left === null) this._replaceNodeInParent(node, node.right);
        else {
            const balance = node.getBalance();
            let replacement;
            let temp = null;
            if (balance > 0) {
                if (node.left.right === null) {
                    replacement = node.left;
                    replacement.right = node.right;
                    temp = replacement;
                } else {
                    replacement = node.left.right;
                    while(replacement.right !== null)replacement = replacement.right;
                    if (replacement.parent) {
                        replacement.parent.right = replacement.left;
                        temp = replacement.parent;
                        replacement.left = node.left;
                        replacement.right = node.right;
                    }
                }
            } else if (node.right.left === null) {
                replacement = node.right;
                replacement.left = node.left;
                temp = replacement;
            } else {
                replacement = node.right.left;
                while(replacement.left !== null)replacement = replacement.left;
                if (replacement.parent) {
                    replacement.parent.left = replacement.right;
                    temp = replacement.parent;
                    replacement.left = node.left;
                    replacement.right = node.right;
                }
            }
            if (node.parent !== null) {
                if (node.isLeftChild()) node.parent.left = replacement;
                else node.parent.right = replacement;
            } else this._setRoot(replacement);
            if (temp) this._rebalance(temp);
        }
        node.dispose();
    }
    /**
     * Rotate the tree to the left
     */ _rotateLeft(node) {
        const parent = node.parent;
        const isLeftChild = node.isLeftChild();
        // Make node.right the new root of this sub tree (instead of node)
        const pivotNode = node.right;
        if (pivotNode) {
            node.right = pivotNode.left;
            pivotNode.left = node;
        }
        if (parent !== null) {
            if (isLeftChild) parent.left = pivotNode;
            else parent.right = pivotNode;
        } else this._setRoot(pivotNode);
    }
    /**
     * Rotate the tree to the right
     */ _rotateRight(node) {
        const parent = node.parent;
        const isLeftChild = node.isLeftChild();
        // Make node.left the new root of this sub tree (instead of node)
        const pivotNode = node.left;
        if (pivotNode) {
            node.left = pivotNode.right;
            pivotNode.right = node;
        }
        if (parent !== null) {
            if (isLeftChild) parent.left = pivotNode;
            else parent.right = pivotNode;
        } else this._setRoot(pivotNode);
    }
    /**
     * Balance the BST
     */ _rebalance(node) {
        const balance = node.getBalance();
        if (balance > 1 && node.left) {
            if (node.left.getBalance() < 0) this._rotateLeft(node.left);
            else this._rotateRight(node);
        } else if (balance < -1 && node.right) {
            if (node.right.getBalance() > 0) this._rotateRight(node.right);
            else this._rotateLeft(node);
        }
    }
    /**
     * Get an event whose time and duration span the give time. Will
     * return the match whose "time" value is closest to the given time.
     * @return  The event which spans the desired time
     */ get(time) {
        if (this._root !== null) {
            const results = [];
            this._root.search(time, results);
            if (results.length > 0) {
                let max = results[0];
                for(let i = 1; i < results.length; i++)if (results[i].low > max.low) max = results[i];
                return max.event;
            }
        }
        return null;
    }
    /**
     * Iterate over everything in the timeline.
     * @param  callback The callback to invoke with every item
     */ forEach(callback) {
        if (this._root !== null) {
            const allNodes = [];
            this._root.traverse((node)=>allNodes.push(node));
            allNodes.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Iterate over everything in the array in which the given time
     * overlaps with the time and duration time of the event.
     * @param  time The time to check if items are overlapping
     * @param  callback The callback to invoke with every item
     */ forEachAtTime(time, callback) {
        if (this._root !== null) {
            const results = [];
            this._root.search(time, results);
            results.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Iterate over everything in the array in which the time is greater
     * than or equal to the given time.
     * @param  time The time to check if items are before
     * @param  callback The callback to invoke with every item
     */ forEachFrom(time, callback) {
        if (this._root !== null) {
            const results = [];
            this._root.searchAfter(time, results);
            results.forEach((node)=>{
                if (node.event) callback(node.event);
            });
        }
        return this;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        if (this._root !== null) this._root.traverse((node)=>node.dispose());
        this._root = null;
        return this;
    }
}
//-------------------------------------
// 	INTERVAL NODE HELPER
//-------------------------------------
/**
 * Represents a node in the binary search tree, with the addition
 * of a "high" value which keeps track of the highest value of
 * its children.
 * References:
 * https://brooknovak.wordpress.com/2013/12/07/augmented-interval-tree-in-c/
 * http://www.mif.vu.lt/~valdas/ALGORITMAI/LITERATURA/Cormen/Cormen.pdf
 * @param low
 * @param high
 */ class $0953b64e7eb19dcb$var$IntervalNode {
    constructor(low, high, event){
        // the nodes to the left
        this._left = null;
        // the nodes to the right
        this._right = null;
        // the parent node
        this.parent = null;
        // the number of child nodes
        this.height = 0;
        this.event = event;
        // the low value
        this.low = low;
        // the high value
        this.high = high;
        // the high value for this and all child nodes
        this.max = this.high;
    }
    /**
     * Insert a node into the correct spot in the tree
     */ insert(node) {
        if (node.low <= this.low) {
            if (this.left === null) this.left = node;
            else this.left.insert(node);
        } else if (this.right === null) this.right = node;
        else this.right.insert(node);
    }
    /**
     * Search the tree for nodes which overlap
     * with the given point
     * @param  point  The point to query
     * @param  results  The array to put the results
     */ search(point, results) {
        // If p is to the right of the rightmost point of any interval
        // in this node and all children, there won't be any matches.
        if (point > this.max) return;
        // Search left children
        if (this.left !== null) this.left.search(point, results);
        // Check this node
        if (this.low <= point && this.high > point) results.push(this);
        // If p is to the left of the time of this interval,
        // then it can't be in any child to the right.
        if (this.low > point) return;
        // Search right children
        if (this.right !== null) this.right.search(point, results);
    }
    /**
     * Search the tree for nodes which are less
     * than the given point
     * @param  point  The point to query
     * @param  results  The array to put the results
     */ searchAfter(point, results) {
        // Check this node
        if (this.low >= point) {
            results.push(this);
            if (this.left !== null) this.left.searchAfter(point, results);
        }
        // search the right side
        if (this.right !== null) this.right.searchAfter(point, results);
    }
    /**
     * Invoke the callback on this element and both it's branches
     * @param  {Function}  callback
     */ traverse(callback) {
        callback(this);
        if (this.left !== null) this.left.traverse(callback);
        if (this.right !== null) this.right.traverse(callback);
    }
    /**
     * Update the height of the node
     */ updateHeight() {
        if (this.left !== null && this.right !== null) this.height = Math.max(this.left.height, this.right.height) + 1;
        else if (this.right !== null) this.height = this.right.height + 1;
        else if (this.left !== null) this.height = this.left.height + 1;
        else this.height = 0;
    }
    /**
     * Update the height of the node
     */ updateMax() {
        this.max = this.high;
        if (this.left !== null) this.max = Math.max(this.max, this.left.max);
        if (this.right !== null) this.max = Math.max(this.max, this.right.max);
    }
    /**
     * The balance is how the leafs are distributed on the node
     * @return  Negative numbers are balanced to the right
     */ getBalance() {
        let balance = 0;
        if (this.left !== null && this.right !== null) balance = this.left.height - this.right.height;
        else if (this.left !== null) balance = this.left.height + 1;
        else if (this.right !== null) balance = -(this.right.height + 1);
        return balance;
    }
    /**
     * @returns true if this node is the left child of its parent
     */ isLeftChild() {
        return this.parent !== null && this.parent.left === this;
    }
    /**
     * get/set the left node
     */ get left() {
        return this._left;
    }
    set left(node) {
        this._left = node;
        if (node !== null) node.parent = this;
        this.updateHeight();
        this.updateMax();
    }
    /**
     * get/set the right node
     */ get right() {
        return this._right;
    }
    set right(node) {
        this._right = node;
        if (node !== null) node.parent = this;
        this.updateHeight();
        this.updateMax();
    }
    /**
     * null out references.
     */ dispose() {
        this.parent = null;
        this._left = null;
        this._right = null;
        this.event = null;
    }
}







// This file contains all of the valid note names for all pitches between C-4 and C11















class $48a02da4a4a54e79$export$562790db7cca758d extends (0, $15ec6319bc02226c$export$12b11dc969d02fed) {
    /**
     * @param initialValue The value to return if there is no scheduled values
     */ constructor(initialValue){
        super();
        this.name = "TimelineValue";
        /**
         * The timeline which stores the values
         */ this._timeline = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)({
            memory: 10
        });
        this._initialValue = initialValue;
    }
    /**
     * Set the value at the given time
     */ set(value, time) {
        this._timeline.add({
            value: value,
            time: time
        });
        return this;
    }
    /**
     * Get the value at the given time
     */ get(time) {
        const event = this._timeline.get(time);
        if (event) return event.value;
        else return this._initialValue;
    }
}









class $1c8b308fac67a067$export$5d271ddbaaaa6dbe extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($1c8b308fac67a067$export$5d271ddbaaaa6dbe.getDefaults(), arguments, [
            "context"
        ]));
    }
    connect(destination, outputNum = 0, inputNum = 0) {
        (0, $87a50297d6fa5f61$export$c8174dc07173cff0)(this, destination, outputNum, inputNum);
        return this;
    }
}


class $5bf337bc64bc83a6$export$4d933d013693e78 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5bf337bc64bc83a6$export$4d933d013693e78.getDefaults(), arguments, [
            "mapping",
            "length"
        ]);
        super(options);
        this.name = "WaveShaper";
        /**
         * the waveshaper node
         */ this._shaper = this.context.createWaveShaper();
        /**
         * The input to the waveshaper node.
         */ this.input = this._shaper;
        /**
         * The output from the waveshaper node
         */ this.output = this._shaper;
        if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(options.mapping) || options.mapping instanceof Float32Array) this.curve = Float32Array.from(options.mapping);
        else if ((0, $4d7f709c9ffa5105$export$f6e2535fb5126e54)(options.mapping)) this.setMap(options.mapping, options.length);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            length: 1024
        });
    }
    /**
     * Uses a mapping function to set the value of the curve.
     * @param mapping The function used to define the values.
     *                The mapping function take two arguments:
     *                the first is the value at the current position
     *                which goes from -1 to 1 over the number of elements
     *                in the curve array. The second argument is the array position.
     * @example
     * const shaper = new Tone.WaveShaper();
     * // map the input signal from [-1, 1] to [0, 10]
     * shaper.setMap((val, index) => (val + 1) * 5);
     */ setMap(mapping, length = 1024) {
        const array = new Float32Array(length);
        for(let i = 0, len = length; i < len; i++){
            const normalized = i / (len - 1) * 2 - 1;
            array[i] = mapping(normalized, i);
        }
        this.curve = array;
        return this;
    }
    /**
     * The array to set as the waveshaper curve. For linear curves
     * array length does not make much difference, but for complex curves
     * longer arrays will provide smoother interpolation.
     */ get curve() {
        return this._shaper.curve;
    }
    set curve(mapping) {
        this._shaper.curve = mapping;
    }
    /**
     * Specifies what type of oversampling (if any) should be used when
     * applying the shaping curve. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        const isOverSampleType = [
            "none",
            "2x",
            "4x"
        ].some((str)=>str.includes(oversampling));
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(isOverSampleType, "oversampling must be either 'none', '2x', or '4x'");
        this._shaper.oversample = oversampling;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._shaper.disconnect();
        return this;
    }
}




class $4603e249f478b841$export$ce28d653ec559ee extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4603e249f478b841$export$ce28d653ec559ee.getDefaults(), arguments, [
            "value"
        ]);
        super(options);
        this.name = "Pow";
        this._exponentScaler = this.input = this.output = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: this._expFunc(options.value),
            length: 8192
        });
        this._exponent = options.value;
    }
    static getDefaults() {
        return Object.assign((0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe).getDefaults(), {
            value: 1
        });
    }
    /**
     * the function which maps the waveshaper
     * @param exponent exponent value
     */ _expFunc(exponent) {
        return (val)=>{
            return Math.pow(Math.abs(val), exponent);
        };
    }
    /**
     * The value of the exponent.
     */ get value() {
        return this._exponent;
    }
    set value(exponent) {
        this._exponent = exponent;
        this._exponentScaler.setMap(this._expFunc(this._exponent));
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._exponentScaler.dispose();
        return this;
    }
}
















class $06f551da73286e34$export$bbddcd8b4881600f {
    /**
     * @param transport The transport object which the event belongs to
     */ constructor(transport, opts){
        /**
         * The unique id of the event
         */ this.id = $06f551da73286e34$export$bbddcd8b4881600f._eventId++;
        /**
         * The remaining value between the passed in time, and Math.floor(time).
         * This value is later added back when scheduling to get sub-tick precision.
         */ this._remainderTime = 0;
        const options = Object.assign($06f551da73286e34$export$bbddcd8b4881600f.getDefaults(), opts);
        this.transport = transport;
        this.callback = options.callback;
        this._once = options.once;
        this.time = Math.floor(options.time);
        this._remainderTime = options.time - this.time;
    }
    static getDefaults() {
        return {
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            once: false,
            time: 0
        };
    }
    /**
     * Get the time and remainder time.
     */ get floatTime() {
        return this.time + this._remainderTime;
    }
    /**
     * Invoke the event callback.
     * @param  time  The AudioContext time in seconds of the event
     */ invoke(time) {
        if (this.callback) {
            const tickDuration = this.transport.bpm.getDurationOfTicks(1, time);
            this.callback(time + this._remainderTime * tickDuration);
            if (this._once) this.transport.clear(this.id);
        }
    }
    /**
     * Clean up
     */ dispose() {
        this.callback = undefined;
        return this;
    }
}
/**
 * Current ID counter
 */ $06f551da73286e34$export$bbddcd8b4881600f._eventId = 0;





class $150b1e2b29109d9d$export$8473d2e877b20cae extends (0, $06f551da73286e34$export$bbddcd8b4881600f) {
    /**
     * @param transport The transport object which the event belongs to
     */ constructor(transport, opts){
        super(transport, opts);
        /**
         * The ID of the current timeline event
         */ this._currentId = -1;
        /**
         * The ID of the next timeline event
         */ this._nextId = -1;
        /**
         * The time of the next event
         */ this._nextTick = this.time;
        /**
         * a reference to the bound start method
         */ this._boundRestart = this._restart.bind(this);
        const options = Object.assign($150b1e2b29109d9d$export$8473d2e877b20cae.getDefaults(), opts);
        this.duration = options.duration;
        this._interval = options.interval;
        this._nextTick = options.time;
        this.transport.on("start", this._boundRestart);
        this.transport.on("loopStart", this._boundRestart);
        this.transport.on("ticks", this._boundRestart);
        this.context = this.transport.context;
        this._restart();
    }
    static getDefaults() {
        return Object.assign({}, (0, $06f551da73286e34$export$bbddcd8b4881600f).getDefaults(), {
            duration: Infinity,
            interval: 1,
            once: false
        });
    }
    /**
     * Invoke the callback. Returns the tick time which
     * the next event should be scheduled at.
     * @param  time  The AudioContext time in seconds of the event
     */ invoke(time) {
        // create more events if necessary
        this._createEvents(time);
        // call the super class
        super.invoke(time);
    }
    /**
     * Create an event on the transport on the nextTick
     */ _createEvent() {
        if ((0, $0f7b0e628156f5de$export$7158f0ceb70f54c7)(this._nextTick, this.floatTime + this.duration)) return this.transport.scheduleOnce(this.invoke.bind(this), new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._nextTick).toSeconds());
        return -1;
    }
    /**
     * Push more events onto the timeline to keep up with the position of the timeline
     */ _createEvents(time) {
        // schedule the next event
        // const ticks = this.transport.getTicksAtTime(time);
        // if the next tick is within the bounds set by "duration"
        if ((0, $0f7b0e628156f5de$export$7158f0ceb70f54c7)(this._nextTick + this._interval, this.floatTime + this.duration)) {
            this._nextTick += this._interval;
            this._currentId = this._nextId;
            this._nextId = this.transport.scheduleOnce(this.invoke.bind(this), new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._nextTick).toSeconds());
        }
    }
    /**
     * Re-compute the events when the transport time has changed from a start/ticks/loopStart event
     */ _restart(time) {
        this.transport.clear(this._currentId);
        this.transport.clear(this._nextId);
        // start at the first event
        this._nextTick = this.floatTime;
        const ticks = this.transport.getTicksAtTime(time);
        if ((0, $0f7b0e628156f5de$export$b023c82b48e70453)(ticks, this.time)) // the event is not being scheduled from the beginning and should be offset
        this._nextTick = this.floatTime + Math.ceil((ticks - this.floatTime) / this._interval) * this._interval;
        this._currentId = this._createEvent();
        this._nextTick += this._interval;
        this._nextId = this._createEvent();
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this.transport.clear(this._currentId);
        this.transport.clear(this._nextId);
        this.transport.off("start", this._boundRestart);
        this.transport.off("loopStart", this._boundRestart);
        this.transport.off("ticks", this._boundRestart);
        return this;
    }
}


class $a212afa9a967be50$export$bd165d2c500271f4 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a212afa9a967be50$export$bd165d2c500271f4.getDefaults(), arguments);
        super(options);
        this.name = "Transport";
        //-------------------------------------
        // 	LOOPING
        //-------------------------------------
        /**
         * If the transport loops or not.
         */ this._loop = new (0, $48a02da4a4a54e79$export$562790db7cca758d)(false);
        /**
         * The loop start position in ticks
         */ this._loopStart = 0;
        /**
         * The loop end position in ticks
         */ this._loopEnd = 0;
        //-------------------------------------
        // 	TIMELINE EVENTS
        //-------------------------------------
        /**
         * All the events in an object to keep track by ID
         */ this._scheduledEvents = {};
        /**
         * The scheduled events.
         */ this._timeline = new (0, $4f983a11dbbcfd64$export$e6a97ba2cae5bb94)();
        /**
         * Repeated events
         */ this._repeatedEvents = new (0, $0953b64e7eb19dcb$export$5a615b1a895bd9ec)();
        /**
         * All of the synced Signals
         */ this._syncedSignals = [];
        /**
         * The swing amount
         */ this._swingAmount = 0;
        // CLOCK/TEMPO
        this._ppq = options.ppq;
        this._clock = new (0, $b0382ab9b2ce11b2$export$9735c82c4bae3302)({
            callback: this._processTick.bind(this),
            context: this.context,
            frequency: 0,
            units: "bpm"
        });
        this._bindClockEvents();
        this.bpm = this._clock.frequency;
        this._clock.frequency.multiplier = options.ppq;
        this.bpm.setValueAtTime(options.bpm, 0);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "bpm");
        this._timeSignature = options.timeSignature;
        // SWING
        this._swingTicks = options.ppq / 2; // 8n
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            bpm: 120,
            loopEnd: "4m",
            loopStart: 0,
            ppq: 192,
            swing: 0,
            swingSubdivision: "8n",
            timeSignature: 4
        });
    }
    //-------------------------------------
    // 	TICKS
    //-------------------------------------
    /**
     * called on every tick
     * @param  tickTime clock relative tick time
     */ _processTick(tickTime, ticks) {
        // do the loop test
        if (this._loop.get(tickTime)) {
            if (ticks >= this._loopEnd) {
                this.emit("loopEnd", tickTime);
                this._clock.setTicksAtTime(this._loopStart, tickTime);
                ticks = this._loopStart;
                this.emit("loopStart", tickTime, this._clock.getSecondsAtTime(tickTime));
                this.emit("loop", tickTime);
            }
        }
        // handle swing
        if (this._swingAmount > 0 && ticks % this._ppq !== 0 && // not on a downbeat
        ticks % (this._swingTicks * 2) !== 0) {
            // add some swing
            const progress = ticks % (this._swingTicks * 2) / (this._swingTicks * 2);
            const amount = Math.sin(progress * Math.PI) * this._swingAmount;
            tickTime += new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._swingTicks * 2 / 3).toSeconds() * amount;
        }
        // invoke the timeline events scheduled on this tick
        (0, $afc9146c77d080c2$export$6e9f81da321f9b8d)(true);
        this._timeline.forEachAtTime(ticks, (event)=>event.invoke(tickTime));
        (0, $afc9146c77d080c2$export$6e9f81da321f9b8d)(false);
    }
    //-------------------------------------
    // 	SCHEDULABLE EVENTS
    //-------------------------------------
    /**
     * Schedule an event along the timeline.
     * @param callback The callback to be invoked at the time.
     * @param time The time to invoke the callback at.
     * @return The id of the event which can be used for canceling the event.
     * @example
     * // schedule an event on the 16th measure
     * Tone.getTransport().schedule((time) => {
     * 	// invoked on measure 16
     * 	console.log("measure 16!");
     * }, "16:0:0");
     */ schedule(callback, time) {
        const event = new (0, $06f551da73286e34$export$bbddcd8b4881600f)(this, {
            callback: callback,
            time: new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toTicks()
        });
        return this._addEvent(event, this._timeline);
    }
    /**
     * Schedule a repeated event along the timeline. The event will fire
     * at the `interval` starting at the `startTime` and for the specified
     * `duration`.
     * @param  callback   The callback to invoke.
     * @param  interval   The duration between successive callbacks. Must be a positive number.
     * @param  startTime  When along the timeline the events should start being invoked.
     * @param  duration How long the event should repeat.
     * @return  The ID of the scheduled event. Use this to cancel the event.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * // a callback invoked every eighth note after the first measure
     * Tone.getTransport().scheduleRepeat((time) => {
     * 	osc.start(time).stop(time + 0.1);
     * }, "8n", "1m");
     */ scheduleRepeat(callback, interval, startTime, duration = Infinity) {
        const event = new (0, $150b1e2b29109d9d$export$8473d2e877b20cae)(this, {
            callback: callback,
            duration: new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, duration).toTicks(),
            interval: new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, interval).toTicks(),
            time: new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toTicks()
        });
        // kick it off if the Transport is started
        // @ts-ignore
        return this._addEvent(event, this._repeatedEvents);
    }
    /**
     * Schedule an event that will be removed after it is invoked.
     * @param callback The callback to invoke once.
     * @param time The time the callback should be invoked.
     * @returns The ID of the scheduled event.
     */ scheduleOnce(callback, time) {
        const event = new (0, $06f551da73286e34$export$bbddcd8b4881600f)(this, {
            callback: callback,
            once: true,
            time: new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toTicks()
        });
        return this._addEvent(event, this._timeline);
    }
    /**
     * Clear the passed in event id from the timeline
     * @param eventId The id of the event.
     */ clear(eventId) {
        if (this._scheduledEvents.hasOwnProperty(eventId)) {
            const item = this._scheduledEvents[eventId.toString()];
            item.timeline.remove(item.event);
            item.event.dispose();
            delete this._scheduledEvents[eventId.toString()];
        }
        return this;
    }
    /**
     * Add an event to the correct timeline. Keep track of the
     * timeline it was added to.
     * @returns the event id which was just added
     */ _addEvent(event, timeline) {
        this._scheduledEvents[event.id.toString()] = {
            event: event,
            timeline: timeline
        };
        timeline.add(event);
        return event.id;
    }
    /**
     * Remove scheduled events from the timeline after
     * the given time. Repeated events will be removed
     * if their startTime is after the given time
     * @param after Clear all events after this time.
     */ cancel(after = 0) {
        const computedAfter = this.toTicks(after);
        this._timeline.forEachFrom(computedAfter, (event)=>this.clear(event.id));
        this._repeatedEvents.forEachFrom(computedAfter, (event)=>this.clear(event.id));
        return this;
    }
    //-------------------------------------
    // 	START/STOP/PAUSE
    //-------------------------------------
    /**
     * Bind start/stop/pause events from the clock and emit them.
     */ _bindClockEvents() {
        this._clock.on("start", (time, offset)=>{
            offset = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, offset).toSeconds();
            this.emit("start", time, offset);
        });
        this._clock.on("stop", (time)=>{
            this.emit("stop", time);
        });
        this._clock.on("pause", (time)=>{
            this.emit("pause", time);
        });
    }
    /**
     * Returns the playback state of the source, either "started", "stopped", or "paused"
     */ get state() {
        return this._clock.getStateAtTime(this.now());
    }
    /**
     * Start the transport and all sources synced to the transport.
     * @param  time The time when the transport should start.
     * @param  offset The timeline offset to start the transport.
     * @example
     * // start the transport in one second starting at beginning of the 5th measure.
     * Tone.getTransport().start("+1", "4:0:0");
     */ start(time, offset) {
        // start the context
        this.context.resume();
        let offsetTicks;
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(offset)) offsetTicks = this.toTicks(offset);
        // start the clock
        this._clock.start(time, offsetTicks);
        return this;
    }
    /**
     * Stop the transport and all sources synced to the transport.
     * @param time The time when the transport should stop.
     * @example
     * Tone.getTransport().stop();
     */ stop(time) {
        this._clock.stop(time);
        return this;
    }
    /**
     * Pause the transport and all sources synced to the transport.
     */ pause(time) {
        this._clock.pause(time);
        return this;
    }
    /**
     * Toggle the current state of the transport. If it is
     * started, it will stop it, otherwise it will start the Transport.
     * @param  time The time of the event
     */ toggle(time) {
        time = this.toSeconds(time);
        if (this._clock.getStateAtTime(time) !== "started") this.start(time);
        else this.stop(time);
        return this;
    }
    //-------------------------------------
    // 	SETTERS/GETTERS
    //-------------------------------------
    /**
     * The time signature as just the numerator over 4.
     * For example 4/4 would be just 4 and 6/8 would be 3.
     * @example
     * // common time
     * Tone.getTransport().timeSignature = 4;
     * // 7/8
     * Tone.getTransport().timeSignature = [7, 8];
     * // this will be reduced to a single number
     * Tone.getTransport().timeSignature; // returns 3.5
     */ get timeSignature() {
        return this._timeSignature;
    }
    set timeSignature(timeSig) {
        if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(timeSig)) timeSig = timeSig[0] / timeSig[1] * 4;
        this._timeSignature = timeSig;
    }
    /**
     * When the Transport.loop = true, this is the starting position of the loop.
     */ get loopStart() {
        return new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, this._loopStart, "i").toSeconds();
    }
    set loopStart(startPosition) {
        this._loopStart = this.toTicks(startPosition);
    }
    /**
     * When the Transport.loop = true, this is the ending position of the loop.
     */ get loopEnd() {
        return new (0, $3b2efe963ae63025$export$52b3039dca93a306)(this.context, this._loopEnd, "i").toSeconds();
    }
    set loopEnd(endPosition) {
        this._loopEnd = this.toTicks(endPosition);
    }
    /**
     * If the transport loops or not.
     */ get loop() {
        return this._loop.get(this.now());
    }
    set loop(loop) {
        this._loop.set(loop, this.now());
    }
    /**
     * Set the loop start and stop at the same time.
     * @example
     * // loop over the first measure
     * Tone.getTransport().setLoopPoints(0, "1m");
     * Tone.getTransport().loop = true;
     */ setLoopPoints(startPosition, endPosition) {
        this.loopStart = startPosition;
        this.loopEnd = endPosition;
        return this;
    }
    /**
     * The swing value. Between 0-1 where 1 equal to the note + half the subdivision.
     */ get swing() {
        return this._swingAmount;
    }
    set swing(amount) {
        // scale the values to a normal range
        this._swingAmount = amount;
    }
    /**
     * Set the subdivision which the swing will be applied to.
     * The default value is an 8th note. Value must be less
     * than a quarter note.
     */ get swingSubdivision() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._swingTicks).toNotation();
    }
    set swingSubdivision(subdivision) {
        this._swingTicks = this.toTicks(subdivision);
    }
    /**
     * The Transport's position in Bars:Beats:Sixteenths.
     * Setting the value will jump to that position right away.
     */ get position() {
        const now = this.now();
        const ticks = this._clock.getTicksAtTime(now);
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, ticks).toBarsBeatsSixteenths();
    }
    set position(progress) {
        const ticks = this.toTicks(progress);
        this.ticks = ticks;
    }
    /**
     * The Transport's position in seconds.
     * Setting the value will jump to that position right away.
     */ get seconds() {
        return this._clock.seconds;
    }
    set seconds(s) {
        const now = this.now();
        const ticks = this._clock.frequency.timeToTicks(s, now);
        this.ticks = ticks;
    }
    /**
     * The Transport's loop position as a normalized value. Always
     * returns 0 if the Transport.loop = false.
     */ get progress() {
        if (this.loop) {
            const now = this.now();
            const ticks = this._clock.getTicksAtTime(now);
            return (ticks - this._loopStart) / (this._loopEnd - this._loopStart);
        } else return 0;
    }
    /**
     * The Transport's current tick position.
     */ get ticks() {
        return this._clock.ticks;
    }
    set ticks(t) {
        if (this._clock.ticks !== t) {
            const now = this.now();
            // stop everything synced to the transport
            if (this.state === "started") {
                const ticks = this._clock.getTicksAtTime(now);
                // schedule to start on the next tick, #573
                const remainingTick = this._clock.frequency.getDurationOfTicks(Math.ceil(ticks) - ticks, now);
                const time = now + remainingTick;
                this.emit("stop", time);
                this._clock.setTicksAtTime(t, time);
                // restart it with the new time
                this.emit("start", time, this._clock.getSecondsAtTime(time));
            } else {
                this.emit("ticks", now);
                this._clock.setTicksAtTime(t, now);
            }
        }
    }
    /**
     * Get the clock's ticks at the given time.
     * @param  time  When to get the tick value
     * @return The tick value at the given time.
     */ getTicksAtTime(time) {
        return this._clock.getTicksAtTime(time);
    }
    /**
     * Return the elapsed seconds at the given time.
     * @param  time  When to get the elapsed seconds
     * @return  The number of elapsed seconds
     */ getSecondsAtTime(time) {
        return this._clock.getSecondsAtTime(time);
    }
    /**
     * Pulses Per Quarter note. This is the smallest resolution
     * the Transport timing supports. This should be set once
     * on initialization and not set again. Changing this value
     * after other objects have been created can cause problems.
     */ get PPQ() {
        return this._clock.frequency.multiplier;
    }
    set PPQ(ppq) {
        this._clock.frequency.multiplier = ppq;
    }
    //-------------------------------------
    // 	SYNCING
    //-------------------------------------
    /**
     * Returns the time aligned to the next subdivision
     * of the Transport. If the Transport is not started,
     * it will return 0.
     * Note: this will not work precisely during tempo ramps.
     * @param  subdivision  The subdivision to quantize to
     * @return  The context time of the next subdivision.
     * @example
     * // the transport must be started, otherwise returns 0
     * Tone.getTransport().start();
     * Tone.getTransport().nextSubdivision("4n");
     */ nextSubdivision(subdivision) {
        subdivision = this.toTicks(subdivision);
        if (this.state !== "started") // if the transport's not started, return 0
        return 0;
        else {
            const now = this.now();
            // the remainder of the current ticks and the subdivision
            const transportPos = this.getTicksAtTime(now);
            const remainingTicks = subdivision - transportPos % subdivision;
            return this._clock.nextTickTime(remainingTicks, now);
        }
    }
    /**
     * Attaches the signal to the tempo control signal so that
     * any changes in the tempo will change the signal in the same
     * ratio.
     *
     * @param signal
     * @param ratio Optionally pass in the ratio between the two signals.
     * 			Otherwise it will be computed based on their current values.
     */ syncSignal(signal, ratio) {
        const now = this.now();
        let source = this.bpm;
        let sourceValue = 1 / (60 / source.getValueAtTime(now) / this.PPQ);
        let nodes = [];
        // If the signal is in the time domain, sync it to the reciprocal of
        // the tempo instead of the tempo.
        if (signal.units === "time") {
            // The input to Pow should be in the range [1 / 4096, 1], where
            // where 4096 is half of the buffer size of Pow's waveshaper.
            // Pick a scaling factor based on the initial tempo that ensures
            // that the initial input is in this range, while leaving room for
            // tempo changes.
            const scaleFactor = 1 / 64 / sourceValue;
            const scaleBefore = new (0, $10a186a98a559639$export$acd19d919666900d)(scaleFactor);
            const reciprocal = new (0, $4603e249f478b841$export$ce28d653ec559ee)(-1);
            const scaleAfter = new (0, $10a186a98a559639$export$acd19d919666900d)(scaleFactor);
            // @ts-ignore
            source.chain(scaleBefore, reciprocal, scaleAfter);
            source = scaleAfter;
            sourceValue = 1 / sourceValue;
            nodes = [
                scaleBefore,
                reciprocal,
                scaleAfter
            ];
        }
        if (!ratio) {
            // get the sync ratio
            if (signal.getValueAtTime(now) !== 0) ratio = signal.getValueAtTime(now) / sourceValue;
            else ratio = 0;
        }
        const ratioSignal = new (0, $10a186a98a559639$export$acd19d919666900d)(ratio);
        // @ts-ignore
        source.connect(ratioSignal);
        // @ts-ignore
        ratioSignal.connect(signal._param);
        nodes.push(ratioSignal);
        this._syncedSignals.push({
            initial: signal.value,
            nodes: nodes,
            signal: signal
        });
        signal.value = 0;
        return this;
    }
    /**
     * Unsyncs a previously synced signal from the transport's control.
     * @see {@link syncSignal}.
     */ unsyncSignal(signal) {
        for(let i = this._syncedSignals.length - 1; i >= 0; i--){
            const syncedSignal = this._syncedSignals[i];
            if (syncedSignal.signal === signal) {
                syncedSignal.nodes.forEach((node)=>node.dispose());
                syncedSignal.signal.value = syncedSignal.initial;
                this._syncedSignals.splice(i, 1);
            }
        }
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._clock.dispose();
        (0, $8cce0c9e2019bc8a$export$e6d3eada50a007b1)(this, "bpm");
        this._timeline.dispose();
        this._repeatedEvents.dispose();
        return this;
    }
}
(0, $092748a42ac93843$export$4293555f241ae35a).mixin($a212afa9a967be50$export$bd165d2c500271f4);
//-------------------------------------
// 	INITIALIZATION
//-------------------------------------
(0, $33268d33018da22a$export$cdd816203a02e74e)((context)=>{
    context.transport = new $a212afa9a967be50$export$bd165d2c500271f4({
        context: context
    });
});
(0, $33268d33018da22a$export$7e1ecadd06ae8222)((context)=>{
    context.transport.dispose();
});









class $1a3cf1f57a33a53f$export$1d2df86270c81ecb extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        /**
         * Sources have no inputs
         */ this.input = undefined;
        /**
         * Keep track of the scheduled state.
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)("stopped");
        /**
         * The synced `start` callback function from the transport
         */ this._synced = false;
        /**
         * Keep track of all of the scheduled event ids
         */ this._scheduled = [];
        /**
         * Placeholder functions for syncing/unsyncing to transport
         */ this._syncedStart = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        this._syncedStop = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        this._state.memory = 100;
        this._state.increasing = true;
        this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            mute: options.mute,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
        this.onstop = options.onstop;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            onstop: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            volume: 0
        });
    }
    /**
     * Returns the playback state of the source, either "started" or "stopped".
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/ahntone_c3.mp3", () => {
     * 	player.start();
     * 	console.log(player.state);
     * }).toDestination();
     */ get state() {
        if (this._synced) {
            if (this.context.transport.state === "started") return this._state.getValueAtTime(this.context.transport.seconds);
            else return "stopped";
        } else return this._state.getValueAtTime(this.now());
    }
    /**
     * Mute the output.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * // mute the output
     * osc.mute = true;
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    /**
     * Ensure that the scheduled time is not before the current time.
     * Should only be used when scheduled unsynced.
     */ _clampToCurrentTime(time) {
        if (this._synced) return time;
        else return Math.max(time, this.context.currentTime);
    }
    /**
     * Start the source at the specified time. If no time is given,
     * start the source now.
     * @param  time When the source should be started.
     * @example
     * const source = new Tone.Oscillator().toDestination();
     * source.start("+0.5"); // starts the source 0.5 seconds from now
     */ start(time, offset, duration) {
        let computedTime = (0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(time) && this._synced ? this.context.transport.seconds : this.toSeconds(time);
        computedTime = this._clampToCurrentTime(computedTime);
        // if it's started, stop it and restart it
        if (!this._synced && this._state.getValueAtTime(computedTime) === "started") {
            // time should be strictly greater than the previous start time
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $0f7b0e628156f5de$export$b023c82b48e70453)(computedTime, this._state.get(computedTime).time), "Start time must be strictly greater than previous start time");
            this._state.cancel(computedTime);
            this._state.setStateAtTime("started", computedTime);
            this.log("restart", computedTime);
            this.restart(computedTime, offset, duration);
        } else {
            this.log("start", computedTime);
            this._state.setStateAtTime("started", computedTime);
            if (this._synced) {
                // add the offset time to the event
                const event = this._state.get(computedTime);
                if (event) {
                    event.offset = this.toSeconds((0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0));
                    event.duration = duration ? this.toSeconds(duration) : undefined;
                }
                const sched = this.context.transport.schedule((t)=>{
                    this._start(t, offset, duration);
                }, computedTime);
                this._scheduled.push(sched);
                // if the transport is already started
                // and the time is greater than where the transport is
                if (this.context.transport.state === "started" && this.context.transport.getSecondsAtTime(this.immediate()) > computedTime) this._syncedStart(this.now(), this.context.transport.seconds);
            } else {
                (0, $afc9146c77d080c2$export$8ef1ce44f93c2687)(this.context);
                this._start(computedTime, offset, duration);
            }
        }
        return this;
    }
    /**
     * Stop the source at the specified time. If no time is given,
     * stop the source now.
     * @param  time When the source should be stopped.
     * @example
     * const source = new Tone.Oscillator().toDestination();
     * source.start();
     * source.stop("+0.5"); // stops the source 0.5 seconds from now
     */ stop(time) {
        let computedTime = (0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(time) && this._synced ? this.context.transport.seconds : this.toSeconds(time);
        computedTime = this._clampToCurrentTime(computedTime);
        if (this._state.getValueAtTime(computedTime) === "started" || (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._state.getNextState("started", computedTime))) {
            this.log("stop", computedTime);
            if (!this._synced) this._stop(computedTime);
            else {
                const sched = this.context.transport.schedule(this._stop.bind(this), computedTime);
                this._scheduled.push(sched);
            }
            this._state.cancel(computedTime);
            this._state.setStateAtTime("stopped", computedTime);
        }
        return this;
    }
    /**
     * Restart the source.
     */ restart(time, offset, duration) {
        time = this.toSeconds(time);
        if (this._state.getValueAtTime(time) === "started") {
            this._state.cancel(time);
            this._restart(time, offset, duration);
        }
        return this;
    }
    /**
     * Sync the source to the Transport so that all subsequent
     * calls to `start` and `stop` are synced to the TransportTime
     * instead of the AudioContext time.
     *
     * @example
     * const osc = new Tone.Oscillator().toDestination();
     * // sync the source so that it plays between 0 and 0.3 on the Transport's timeline
     * osc.sync().start(0).stop(0.3);
     * // start the transport.
     * Tone.Transport.start();
     * // set it to loop once a second
     * Tone.Transport.loop = true;
     * Tone.Transport.loopEnd = 1;
     */ sync() {
        if (!this._synced) {
            this._synced = true;
            this._syncedStart = (time, offset)=>{
                if ((0, $0f7b0e628156f5de$export$b023c82b48e70453)(offset, 0)) {
                    // get the playback state at that time
                    const stateEvent = this._state.get(offset);
                    // listen for start events which may occur in the middle of the sync'ed time
                    if (stateEvent && stateEvent.state === "started" && stateEvent.time !== offset) {
                        // get the offset
                        const startOffset = offset - this.toSeconds(stateEvent.time);
                        let duration;
                        if (stateEvent.duration) duration = this.toSeconds(stateEvent.duration) - startOffset;
                        this._start(time, this.toSeconds(stateEvent.offset) + startOffset, duration);
                    }
                }
            };
            this._syncedStop = (time)=>{
                const seconds = this.context.transport.getSecondsAtTime(Math.max(time - this.sampleTime, 0));
                if (this._state.getValueAtTime(seconds) === "started") this._stop(time);
            };
            this.context.transport.on("start", this._syncedStart);
            this.context.transport.on("loopStart", this._syncedStart);
            this.context.transport.on("stop", this._syncedStop);
            this.context.transport.on("pause", this._syncedStop);
            this.context.transport.on("loopEnd", this._syncedStop);
        }
        return this;
    }
    /**
     * Unsync the source to the Transport.
     * @see {@link sync}
     */ unsync() {
        if (this._synced) {
            this.context.transport.off("stop", this._syncedStop);
            this.context.transport.off("pause", this._syncedStop);
            this.context.transport.off("loopEnd", this._syncedStop);
            this.context.transport.off("start", this._syncedStart);
            this.context.transport.off("loopStart", this._syncedStart);
        }
        this._synced = false;
        // clear all of the scheduled ids
        this._scheduled.forEach((id)=>this.context.transport.clear(id));
        this._scheduled = [];
        this._state.cancel(0);
        // stop it also
        this._stop(0);
        return this;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.onstop = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        this.unsync();
        this._volume.dispose();
        this._state.dispose();
        return this;
    }
}











class $faf7c8e078303879$export$30cbf4ba14db4fdd extends (0, $e20d6aed0c7175de$export$27749f88ede4d2a3) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faf7c8e078303879$export$30cbf4ba14db4fdd.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        super(options);
        this.name = "ToneBufferSource";
        /**
         * The oscillator
         */ this._source = this.context.createBufferSource();
        this._internalChannels = [
            this._source
        ];
        /**
         * indicators if the source has started/stopped
         */ this._sourceStarted = false;
        this._sourceStopped = false;
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._source, this._gainNode);
        this._source.onended = ()=>this._stopSource();
        /**
         * The playbackRate of the buffer
         */ this.playbackRate = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._source.playbackRate,
            units: "positive",
            value: options.playbackRate
        });
        // set some values initially
        this.loop = options.loop;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this._buffer = new (0, $43da6dea502b5fe8$export$424a335715b38178)(options.url, options.onload, options.onerror);
        this._internalChannels.push(this._source);
    }
    static getDefaults() {
        return Object.assign((0, $e20d6aed0c7175de$export$27749f88ede4d2a3).getDefaults(), {
            url: new (0, $43da6dea502b5fe8$export$424a335715b38178)(),
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            playbackRate: 1
        });
    }
    /**
     * The fadeIn time of the amplitude envelope.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(t) {
        this._fadeIn = t;
    }
    /**
     * The fadeOut time of the amplitude envelope.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(t) {
        this._fadeOut = t;
    }
    /**
     * The curve applied to the fades, either "linear" or "exponential"
     */ get curve() {
        return this._curve;
    }
    set curve(t) {
        this._curve = t;
    }
    /**
     * Start the buffer
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given, it will default to the full length of the sample (minus any offset)
     * @param  gain  The gain to play the buffer back at.
     */ start(time, offset, duration, gain = 1) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.buffer.loaded, "buffer is either not set or not loaded");
        const computedTime = this.toSeconds(time);
        // apply the gain envelope
        this._startGain(computedTime, gain);
        // if it's a loop the default offset is the loopstart point
        if (this.loop) offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, this.loopStart);
        else // otherwise the default offset is 0
        offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0);
        // make sure the offset is not less than 0
        let computedOffset = Math.max(this.toSeconds(offset), 0);
        // start the buffer source
        if (this.loop) {
            // modify the offset if it's greater than the loop time
            const loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration;
            const loopStart = this.toSeconds(this.loopStart);
            const loopDuration = loopEnd - loopStart;
            // move the offset back
            if ((0, $0f7b0e628156f5de$export$c846515610eb2c50)(computedOffset, loopEnd)) computedOffset = (computedOffset - loopStart) % loopDuration + loopStart;
            // when the offset is very close to the duration, set it to 0
            if ((0, $0f7b0e628156f5de$export$1c0a5d05eb3f6e18)(computedOffset, this.buffer.duration)) computedOffset = 0;
        }
        // this.buffer.loaded would have return false if the AudioBuffer was undefined
        this._source.buffer = this.buffer.get();
        this._source.loopEnd = this.toSeconds(this.loopEnd) || this.buffer.duration;
        if ((0, $0f7b0e628156f5de$export$7158f0ceb70f54c7)(computedOffset, this.buffer.duration)) {
            this._sourceStarted = true;
            this._source.start(computedTime, computedOffset);
        }
        // if a duration is given, schedule a stop
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(duration)) {
            let computedDur = this.toSeconds(duration);
            // make sure it's never negative
            computedDur = Math.max(computedDur, 0);
            this.stop(computedTime + computedDur);
        }
        return this;
    }
    _stopSource(time) {
        if (!this._sourceStopped && this._sourceStarted) {
            this._sourceStopped = true;
            this._source.stop(this.toSeconds(time));
            this._onended();
        }
    }
    /**
     * If loop is true, the loop will start at this position.
     */ get loopStart() {
        return this._source.loopStart;
    }
    set loopStart(loopStart) {
        this._source.loopStart = this.toSeconds(loopStart);
    }
    /**
     * If loop is true, the loop will end at this position.
     */ get loopEnd() {
        return this._source.loopEnd;
    }
    set loopEnd(loopEnd) {
        this._source.loopEnd = this.toSeconds(loopEnd);
    }
    /**
     * The audio buffer belonging to the player.
     */ get buffer() {
        return this._buffer;
    }
    set buffer(buffer) {
        this._buffer.set(buffer);
    }
    /**
     * If the buffer should loop once it's over.
     */ get loop() {
        return this._source.loop;
    }
    set loop(loop) {
        this._source.loop = loop;
        if (this._sourceStarted) this.cancelStop();
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._source.onended = null;
        this._source.disconnect();
        this._buffer.dispose();
        this.playbackRate.dispose();
        return this;
    }
}


class $93a0a7e8f19a773f$export$484d33a0500a4ce1 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($93a0a7e8f19a773f$export$484d33a0500a4ce1.getDefaults(), arguments, [
            "type"
        ]);
        super(options);
        this.name = "Noise";
        /**
         * Private reference to the source
         */ this._source = null;
        this._playbackRate = options.playbackRate;
        this.type = options.type;
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            fadeIn: 0,
            fadeOut: 0,
            playbackRate: 1,
            type: "white"
        });
    }
    /**
     * The type of the noise. Can be "white", "brown", or "pink".
     * @example
     * const noise = new Tone.Noise().toDestination().start();
     * noise.type = "brown";
     */ get type() {
        return this._type;
    }
    set type(type) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(type in $93a0a7e8f19a773f$var$_noiseBuffers, "Noise: invalid type: " + type);
        if (this._type !== type) {
            this._type = type;
            // if it's playing, stop and restart it
            if (this.state === "started") {
                const now = this.now();
                this._stop(now);
                this._start(now);
            }
        }
    }
    /**
     * The playback rate of the noise. Affects
     * the "frequency" of the noise.
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        if (this._source) this._source.playbackRate.value = rate;
    }
    /**
     * internal start method
     */ _start(time) {
        const buffer = $93a0a7e8f19a773f$var$_noiseBuffers[this._type];
        this._source = new (0, $faf7c8e078303879$export$30cbf4ba14db4fdd)({
            url: buffer,
            context: this.context,
            fadeIn: this._fadeIn,
            fadeOut: this._fadeOut,
            loop: true,
            onended: ()=>this.onstop(this),
            playbackRate: this._playbackRate
        }).connect(this.output);
        this._source.start(this.toSeconds(time), Math.random() * (buffer.duration - 0.001));
    }
    /**
     * internal stop method
     */ _stop(time) {
        if (this._source) {
            this._source.stop(this.toSeconds(time));
            this._source = null;
        }
    }
    /**
     * The fadeIn time of the amplitude envelope.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(time) {
        this._fadeIn = time;
        if (this._source) this._source.fadeIn = this._fadeIn;
    }
    /**
     * The fadeOut time of the amplitude envelope.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(time) {
        this._fadeOut = time;
        if (this._source) this._source.fadeOut = this._fadeOut;
    }
    _restart(time) {
        // TODO could be optimized by cancelling the buffer source 'stop'
        this._stop(time);
        this._start(time);
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        if (this._source) this._source.disconnect();
        return this;
    }
}
//--------------------
// THE NOISE BUFFERS
//--------------------
// Noise buffer stats
const $93a0a7e8f19a773f$var$BUFFER_LENGTH = 220500;
const $93a0a7e8f19a773f$var$NUM_CHANNELS = 2;
/**
 * Cache the noise buffers
 */ const $93a0a7e8f19a773f$var$_noiseCache = {
    brown: null,
    pink: null,
    white: null
};
/**
 * The noise arrays. Generated on initialization.
 * borrowed heavily from https://github.com/zacharydenton/noise.js
 * (c) 2013 Zach Denton (MIT)
 */ const $93a0a7e8f19a773f$var$_noiseBuffers = {
    get brown () {
        if (!$93a0a7e8f19a773f$var$_noiseCache.brown) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $93a0a7e8f19a773f$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($93a0a7e8f19a773f$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                let lastOut = 0.0;
                for(let i = 0; i < $93a0a7e8f19a773f$var$BUFFER_LENGTH; i++){
                    const white = Math.random() * 2 - 1;
                    channel[i] = (lastOut + 0.02 * white) / 1.02;
                    lastOut = channel[i];
                    channel[i] *= 3.5; // (roughly) compensate for gain
                }
            }
            $93a0a7e8f19a773f$var$_noiseCache.brown = new (0, $43da6dea502b5fe8$export$424a335715b38178)().fromArray(buffer);
        }
        return $93a0a7e8f19a773f$var$_noiseCache.brown;
    },
    get pink () {
        if (!$93a0a7e8f19a773f$var$_noiseCache.pink) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $93a0a7e8f19a773f$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($93a0a7e8f19a773f$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                let b0, b1, b2, b3, b4, b5, b6;
                b0 = b1 = b2 = b3 = b4 = b5 = b6 = 0.0;
                for(let i = 0; i < $93a0a7e8f19a773f$var$BUFFER_LENGTH; i++){
                    const white = Math.random() * 2 - 1;
                    b0 = 0.99886 * b0 + white * 0.0555179;
                    b1 = 0.99332 * b1 + white * 0.0750759;
                    b2 = 0.969 * b2 + white * 0.153852;
                    b3 = 0.8665 * b3 + white * 0.3104856;
                    b4 = 0.55 * b4 + white * 0.5329522;
                    b5 = -0.7616 * b5 - white * 0.016898;
                    channel[i] = b0 + b1 + b2 + b3 + b4 + b5 + b6 + white * 0.5362;
                    channel[i] *= 0.11; // (roughly) compensate for gain
                    b6 = white * 0.115926;
                }
            }
            $93a0a7e8f19a773f$var$_noiseCache.pink = new (0, $43da6dea502b5fe8$export$424a335715b38178)().fromArray(buffer);
        }
        return $93a0a7e8f19a773f$var$_noiseCache.pink;
    },
    get white () {
        if (!$93a0a7e8f19a773f$var$_noiseCache.white) {
            const buffer = [];
            for(let channelNum = 0; channelNum < $93a0a7e8f19a773f$var$NUM_CHANNELS; channelNum++){
                const channel = new Float32Array($93a0a7e8f19a773f$var$BUFFER_LENGTH);
                buffer[channelNum] = channel;
                for(let i = 0; i < $93a0a7e8f19a773f$var$BUFFER_LENGTH; i++)channel[i] = Math.random() * 2 - 1;
            }
            $93a0a7e8f19a773f$var$_noiseCache.white = new (0, $43da6dea502b5fe8$export$424a335715b38178)().fromArray(buffer);
        }
        return $93a0a7e8f19a773f$var$_noiseCache.white;
    }
};









class $c8800676c7f374c9$export$187d60d76727d102 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($c8800676c7f374c9$export$187d60d76727d102.getDefaults(), arguments, [
            "volume"
        ]);
        super(options);
        this.name = "UserMedia";
        this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
        this.mute = options.mute;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            volume: 0
        });
    }
    /**
     * Open the media stream. If a string is passed in, it is assumed
     * to be the label or id of the stream, if a number is passed in,
     * it is the input number of the stream.
     * @param  labelOrId The label or id of the audio input media device.
     *                   With no argument, the default stream is opened.
     * @return The promise is resolved when the stream is open.
     */ open(labelOrId) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)($c8800676c7f374c9$export$187d60d76727d102.supported, "UserMedia is not supported");
            // close the previous stream
            if (this.state === "started") this.close();
            const devices = yield $c8800676c7f374c9$export$187d60d76727d102.enumerateDevices();
            if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(labelOrId)) this._device = devices[labelOrId];
            else {
                this._device = devices.find((device)=>{
                    return device.label === labelOrId || device.deviceId === labelOrId;
                });
                // didn't find a matching device
                if (!this._device && devices.length > 0) this._device = devices[0];
                (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(this._device), `No matching device ${labelOrId}`);
            }
            // do getUserMedia
            const constraints = {
                audio: {
                    echoCancellation: false,
                    sampleRate: this.context.sampleRate,
                    noiseSuppression: false,
                    mozNoiseSuppression: false
                }
            };
            if (this._device) // @ts-ignore
            constraints.audio.deviceId = this._device.deviceId;
            const stream = yield navigator.mediaDevices.getUserMedia(constraints);
            // start a new source only if the previous one is closed
            if (!this._stream) {
                this._stream = stream;
                // Wrap a MediaStreamSourceNode around the live input stream.
                const mediaStreamNode = this.context.createMediaStreamSource(stream);
                // Connect the MediaStreamSourceNode to a gate gain node
                (0, $1dae52eee8c779dd$export$64605811ab45167f)(mediaStreamNode, this.output);
                this._mediaStream = mediaStreamNode;
            }
            return this;
        });
    }
    /**
     * Close the media stream
     */ close() {
        if (this._stream && this._mediaStream) {
            this._stream.getAudioTracks().forEach((track)=>{
                track.stop();
            });
            this._stream = undefined;
            // remove the old media stream
            this._mediaStream.disconnect();
            this._mediaStream = undefined;
        }
        this._device = undefined;
        return this;
    }
    /**
     * Returns a promise which resolves with the list of audio input devices available.
     * @return The promise that is resolved with the devices
     * @example
     * Tone.UserMedia.enumerateDevices().then((devices) => {
     * 	// print the device labels
     * 	console.log(devices.map(device => device.label));
     * });
     */ static enumerateDevices() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const allDevices = yield navigator.mediaDevices.enumerateDevices();
            return allDevices.filter((device)=>{
                return device.kind === "audioinput";
            });
        });
    }
    /**
     * Returns the playback state of the source, "started" when the microphone is open
     * and "stopped" when the mic is closed.
     */ get state() {
        return this._stream && this._stream.active ? "started" : "stopped";
    }
    /**
     * Returns an identifier for the represented device that is
     * persisted across sessions. It is un-guessable by other applications and
     * unique to the origin of the calling application. It is reset when the
     * user clears cookies (for Private Browsing, a different identifier is
     * used that is not persisted across sessions). Returns undefined when the
     * device is not open.
     */ get deviceId() {
        if (this._device) return this._device.deviceId;
        else return undefined;
    }
    /**
     * Returns a group identifier. Two devices have the
     * same group identifier if they belong to the same physical device.
     * Returns null  when the device is not open.
     */ get groupId() {
        if (this._device) return this._device.groupId;
        else return undefined;
    }
    /**
     * Returns a label describing this device (for example "Built-in Microphone").
     * Returns undefined when the device is not open or label is not available
     * because of permissions.
     */ get label() {
        if (this._device) return this._device.label;
        else return undefined;
    }
    /**
     * Mute the output.
     * @example
     * const mic = new Tone.UserMedia();
     * mic.open().then(() => {
     * 	// promise resolves when input is available
     * });
     * // mute the output
     * mic.mute = true;
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    dispose() {
        super.dispose();
        this.close();
        this._volume.dispose();
        this.volume.dispose();
        return this;
    }
    /**
     * If getUserMedia is supported by the browser.
     */ static get supported() {
        return (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(navigator.mediaDevices) && (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(navigator.mediaDevices.getUserMedia);
    }
}










function $e45997ed2518edd7$export$c5486db94e413392(instance, length) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const duration = length / instance.context.sampleRate;
        const context = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(1, duration, instance.context.sampleRate);
        const clone = new instance.constructor(Object.assign(instance.get(), {
            // should do 2 iterations
            frequency: 2 / duration,
            // zero out the detune
            detune: 0,
            context: context
        })).toDestination();
        clone.start(0);
        const buffer = yield context.render();
        return buffer.getChannelData(0);
    });
}







class $6dd36306779dbefc$export$284532b021137a4a extends (0, $e20d6aed0c7175de$export$27749f88ede4d2a3) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($6dd36306779dbefc$export$284532b021137a4a.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        super(options);
        this.name = "ToneOscillatorNode";
        /**
         * The oscillator
         */ this._oscillator = this.context.createOscillator();
        this._internalChannels = [
            this._oscillator
        ];
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._oscillator, this._gainNode);
        this.type = options.type;
        this.frequency = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._oscillator.frequency,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._oscillator.detune,
            units: "cents",
            value: options.detune
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $e20d6aed0c7175de$export$27749f88ede4d2a3).getDefaults(), {
            detune: 0,
            frequency: 440,
            type: "sine"
        });
    }
    /**
     * Start the oscillator node at the given time
     * @param  time When to start the oscillator
     */ start(time) {
        const computedTime = this.toSeconds(time);
        this.log("start", computedTime);
        this._startGain(computedTime);
        this._oscillator.start(computedTime);
        return this;
    }
    _stopSource(time) {
        this._oscillator.stop(time);
    }
    /**
     * Sets an arbitrary custom periodic waveform given a PeriodicWave.
     * @param  periodicWave PeriodicWave should be created with context.createPeriodicWave
     */ setPeriodicWave(periodicWave) {
        this._oscillator.setPeriodicWave(periodicWave);
        return this;
    }
    /**
     * The oscillator type. Either 'sine', 'sawtooth', 'square', or 'triangle'
     */ get type() {
        return this._oscillator.type;
    }
    set type(type) {
        this._oscillator.type = type;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        if (this.state === "started") this.stop();
        this._oscillator.disconnect();
        this.frequency.dispose();
        this.detune.dispose();
        return this;
    }
}




class $304d61465298e719$export$c01c5c7b81696d70 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($304d61465298e719$export$c01c5c7b81696d70.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        super(options);
        this.name = "Oscillator";
        /**
         * the main oscillator
         */ this._oscillator = null;
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "frequency");
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "detune");
        this._partials = options.partials;
        this._partialCount = options.partialCount;
        this._type = options.type;
        if (options.partialCount && options.type !== "custom") this._type = this.baseType + options.partialCount.toString();
        this.phase = options.phase;
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            detune: 0,
            frequency: 440,
            partialCount: 0,
            partials: [],
            phase: 0,
            type: "sine"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        const computedTime = this.toSeconds(time);
        // new oscillator with previous values
        const oscillator = new (0, $6dd36306779dbefc$export$284532b021137a4a)({
            context: this.context,
            onended: ()=>this.onstop(this)
        });
        this._oscillator = oscillator;
        if (this._wave) this._oscillator.setPeriodicWave(this._wave);
        else this._oscillator.type = this._type;
        // connect the control signal to the oscillator frequency & detune
        this._oscillator.connect(this.output);
        this.frequency.connect(this._oscillator.frequency);
        this.detune.connect(this._oscillator.detune);
        // start the oscillator
        this._oscillator.start(computedTime);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        const computedTime = this.toSeconds(time);
        if (this._oscillator) this._oscillator.stop(computedTime);
    }
    /**
     * Restart the oscillator. Does not stop the oscillator, but instead
     * just cancels any scheduled 'stop' from being invoked.
     */ _restart(time) {
        const computedTime = this.toSeconds(time);
        this.log("restart", computedTime);
        if (this._oscillator) this._oscillator.cancelStop();
        this._state.cancel(computedTime);
        return this;
    }
    /**
     * Sync the signal to the Transport's bpm. Any changes to the transports bpm,
     * will also affect the oscillators frequency.
     * @example
     * const osc = new Tone.Oscillator().toDestination().start();
     * osc.frequency.value = 440;
     * // the ratio between the bpm and the frequency will be maintained
     * osc.syncFrequency();
     * // double the tempo
     * Tone.Transport.bpm.value *= 2;
     * // the frequency of the oscillator is doubled to 880
     */ syncFrequency() {
        this.context.transport.syncSignal(this.frequency);
        return this;
    }
    /**
     * Unsync the oscillator's frequency from the Transport.
     * @see {@link syncFrequency}
     */ unsyncFrequency() {
        this.context.transport.unsyncSignal(this.frequency);
        return this;
    }
    /**
     * Get a cached periodic wave. Avoids having to recompute
     * the oscillator values when they have already been computed
     * with the same values.
     */ _getCachedPeriodicWave() {
        if (this._type === "custom") {
            const oscProps = $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.find((description)=>{
                return description.phase === this._phase && (0, $07d9216a29f4e8bb$export$73ce4178444047a5)(description.partials, this._partials);
            });
            return oscProps;
        } else {
            const oscProps = $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.find((description)=>{
                return description.type === this._type && description.phase === this._phase;
            });
            this._partialCount = oscProps ? oscProps.partialCount : this._partialCount;
            return oscProps;
        }
    }
    get type() {
        return this._type;
    }
    set type(type) {
        this._type = type;
        const isBasicType = [
            "sine",
            "square",
            "sawtooth",
            "triangle"
        ].indexOf(type) !== -1;
        if (this._phase === 0 && isBasicType) {
            this._wave = undefined;
            this._partialCount = 0;
            // just go with the basic approach
            if (this._oscillator !== null) // already tested that it's a basic type
            this._oscillator.type = type;
        } else {
            // first check if the value is cached
            const cache = this._getCachedPeriodicWave();
            if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(cache)) {
                const { partials: partials, wave: wave } = cache;
                this._wave = wave;
                this._partials = partials;
                if (this._oscillator !== null) this._oscillator.setPeriodicWave(this._wave);
            } else {
                const [real, imag] = this._getRealImaginary(type, this._phase);
                const periodicWave = this.context.createPeriodicWave(real, imag);
                this._wave = periodicWave;
                if (this._oscillator !== null) this._oscillator.setPeriodicWave(this._wave);
                // set the cache
                $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.push({
                    imag: imag,
                    partialCount: this._partialCount,
                    partials: this._partials,
                    phase: this._phase,
                    real: real,
                    type: this._type,
                    wave: this._wave
                });
                if ($304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.length > 100) $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache.shift();
            }
        }
    }
    get baseType() {
        return this._type.replace(this.partialCount.toString(), "");
    }
    set baseType(baseType) {
        if (this.partialCount && this._type !== "custom" && baseType !== "custom") this.type = baseType + this.partialCount;
        else this.type = baseType;
    }
    get partialCount() {
        return this._partialCount;
    }
    set partialCount(p) {
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(p, 0);
        let type = this._type;
        const partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(this._type);
        if (partial) type = partial[1];
        if (this._type !== "custom") {
            if (p === 0) this.type = type;
            else this.type = type + p.toString();
        } else {
            // extend or shorten the partials array
            const fullPartials = new Float32Array(p);
            // copy over the partials array
            this._partials.forEach((v, i)=>fullPartials[i] = v);
            this._partials = Array.from(fullPartials);
            this.type = this._type;
        }
    }
    /**
     * Returns the real and imaginary components based
     * on the oscillator type.
     * @returns [real: Float32Array, imaginary: Float32Array]
     */ _getRealImaginary(type, phase) {
        const fftSize = 4096;
        let periodicWaveSize = fftSize / 2;
        const real = new Float32Array(periodicWaveSize);
        const imag = new Float32Array(periodicWaveSize);
        let partialCount = 1;
        if (type === "custom") {
            partialCount = this._partials.length + 1;
            this._partialCount = this._partials.length;
            periodicWaveSize = partialCount;
            // if the partial count is 0, don't bother doing any computation
            if (this._partials.length === 0) return [
                real,
                imag
            ];
        } else {
            const partial = /^(sine|triangle|square|sawtooth)(\d+)$/.exec(type);
            if (partial) {
                partialCount = parseInt(partial[2], 10) + 1;
                this._partialCount = parseInt(partial[2], 10);
                type = partial[1];
                partialCount = Math.max(partialCount, 2);
                periodicWaveSize = partialCount;
            } else this._partialCount = 0;
            this._partials = [];
        }
        for(let n = 1; n < periodicWaveSize; ++n){
            const piFactor = 2 / (n * Math.PI);
            let b;
            switch(type){
                case "sine":
                    b = n <= partialCount ? 1 : 0;
                    this._partials[n - 1] = b;
                    break;
                case "square":
                    b = n & 1 ? 2 * piFactor : 0;
                    this._partials[n - 1] = b;
                    break;
                case "sawtooth":
                    b = piFactor * (n & 1 ? 1 : -1);
                    this._partials[n - 1] = b;
                    break;
                case "triangle":
                    if (n & 1) b = 2 * (piFactor * piFactor) * (n - 1 >> 1 & 1 ? -1 : 1);
                    else b = 0;
                    this._partials[n - 1] = b;
                    break;
                case "custom":
                    b = this._partials[n - 1];
                    break;
                default:
                    throw new TypeError("Oscillator: invalid type: " + type);
            }
            if (b !== 0) {
                real[n] = -b * Math.sin(phase * n);
                imag[n] = b * Math.cos(phase * n);
            } else {
                real[n] = 0;
                imag[n] = 0;
            }
        }
        return [
            real,
            imag
        ];
    }
    /**
     * Compute the inverse FFT for a given phase.
     */ _inverseFFT(real, imag, phase) {
        let sum = 0;
        const len = real.length;
        for(let i = 0; i < len; i++)sum += real[i] * Math.cos(i * phase) + imag[i] * Math.sin(i * phase);
        return sum;
    }
    /**
     * Returns the initial value of the oscillator when stopped.
     * E.g. a "sine" oscillator with phase = 90 would return an initial value of -1.
     */ getInitialValue() {
        const [real, imag] = this._getRealImaginary(this._type, 0);
        let maxValue = 0;
        const twoPi = Math.PI * 2;
        const testPositions = 32;
        // check for peaks in 16 places
        for(let i = 0; i < testPositions; i++)maxValue = Math.max(this._inverseFFT(real, imag, i / testPositions * twoPi), maxValue);
        return (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(-this._inverseFFT(real, imag, this._phase) / maxValue, -1, 1);
    }
    get partials() {
        return this._partials.slice(0, this.partialCount);
    }
    set partials(partials) {
        this._partials = partials;
        this._partialCount = this._partials.length;
        if (partials.length) this.type = "custom";
    }
    get phase() {
        return this._phase * (180 / Math.PI);
    }
    set phase(phase) {
        this._phase = phase * Math.PI / 180;
        // reset the type
        this.type = this._type;
    }
    asArray() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(length = 1024) {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    dispose() {
        super.dispose();
        if (this._oscillator !== null) this._oscillator.dispose();
        this._wave = undefined;
        this.frequency.dispose();
        this.detune.dispose();
        return this;
    }
}
/**
 * Cache the periodic waves to avoid having to redo computations
 */ $304d61465298e719$export$c01c5c7b81696d70._periodicWaveCache = [];








class $69552eca520acf8e$export$2e6ea0941c39f845 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(...arguments);
        this.name = "AudioToGain";
        /**
         * The node which converts the audio ranges
         */ this._norm = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: (x)=>(x + 1) / 2
        });
        /**
         * The AudioRange input [-1, 1]
         */ this.input = this._norm;
        /**
         * The GainRange output [0, 1]
         */ this.output = this._norm;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._norm.dispose();
        return this;
    }
}





class $3f90bb22f26a3ab2$export$f14f83b3b531d498 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3f90bb22f26a3ab2$export$f14f83b3b531d498.getDefaults(), arguments, [
            "value"
        ]);
        super(options);
        this.name = "Multiply";
        /**
         * Indicates if the value should be overridden on connection
         */ this.override = false;
        this._mult = this.input = this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            minValue: options.minValue,
            maxValue: options.maxValue
        });
        this.factor = this._param = this._mult.gain;
        this.factor.setValueAtTime(options.value, 0);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._mult.dispose();
        return this;
    }
}





class $81277ef08515f70b$export$782fe1d3ba34f8d6 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($81277ef08515f70b$export$782fe1d3ba34f8d6.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]);
        super(options);
        this.name = "AMOscillator";
        /**
         * convert the -1,1 output to 0,1
         */ this._modulationScale = new (0, $69552eca520acf8e$export$2e6ea0941c39f845)({
            context: this.context
        });
        /**
         * the node where the modulation happens
         */ this._modulationNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._carrier = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: options.type
        });
        this.frequency = this._carrier.frequency, this.detune = this._carrier.detune;
        this._modulator = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            phase: options.phase,
            type: options.modulationType
        });
        this.harmonicity = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        // connections
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this._modulator.chain(this._modulationScale, this._modulationNode.gain);
        this._carrier.chain(this._modulationNode, this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "detune",
            "harmonicity"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), {
            harmonicity: 1,
            modulationType: "square"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._modulator.start(time);
        this._carrier.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        this._modulator.stop(time);
        this._carrier.stop(time);
    }
    _restart(time) {
        this._modulator.restart(time);
        this._carrier.restart(time);
    }
    /**
     * The type of the carrier oscillator
     */ get type() {
        return this._carrier.type;
    }
    set type(type) {
        this._carrier.type = type;
    }
    get baseType() {
        return this._carrier.baseType;
    }
    set baseType(baseType) {
        this._carrier.baseType = baseType;
    }
    get partialCount() {
        return this._carrier.partialCount;
    }
    set partialCount(partialCount) {
        this._carrier.partialCount = partialCount;
    }
    /**
     * The type of the modulator oscillator
     */ get modulationType() {
        return this._modulator.type;
    }
    set modulationType(type) {
        this._modulator.type = type;
    }
    get phase() {
        return this._carrier.phase;
    }
    set phase(phase) {
        this._carrier.phase = phase;
        this._modulator.phase = phase;
    }
    get partials() {
        return this._carrier.partials;
    }
    set partials(partials) {
        this._carrier.partials = partials;
    }
    asArray() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(length = 1024) {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this.harmonicity.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this._modulationNode.dispose();
        this._modulationScale.dispose();
        return this;
    }
}











class $87e8e716b583ad3c$export$3055866937a7451d extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($87e8e716b583ad3c$export$3055866937a7451d.getDefaults(), arguments, [
            "frequency",
            "type",
            "modulationType"
        ]);
        super(options);
        this.name = "FMOscillator";
        /**
         * the node where the modulation happens
         */ this._modulationNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        this._carrier = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            detune: options.detune,
            frequency: 0,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: options.type
        });
        this.detune = this._carrier.detune;
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this._modulator = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            phase: options.phase,
            type: options.modulationType
        });
        this.harmonicity = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        this.modulationIndex = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            units: "positive",
            value: options.modulationIndex
        });
        // connections
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.frequency.chain(this.modulationIndex, this._modulationNode);
        this._modulator.connect(this._modulationNode.gain);
        this._modulationNode.connect(this._carrier.frequency);
        this._carrier.connect(this.output);
        this.detune.connect(this._modulator.detune);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "modulationIndex",
            "frequency",
            "detune",
            "harmonicity"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), {
            harmonicity: 1,
            modulationIndex: 2,
            modulationType: "square"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._modulator.start(time);
        this._carrier.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        this._modulator.stop(time);
        this._carrier.stop(time);
    }
    _restart(time) {
        this._modulator.restart(time);
        this._carrier.restart(time);
        return this;
    }
    get type() {
        return this._carrier.type;
    }
    set type(type) {
        this._carrier.type = type;
    }
    get baseType() {
        return this._carrier.baseType;
    }
    set baseType(baseType) {
        this._carrier.baseType = baseType;
    }
    get partialCount() {
        return this._carrier.partialCount;
    }
    set partialCount(partialCount) {
        this._carrier.partialCount = partialCount;
    }
    /**
     * The type of the modulator oscillator
     */ get modulationType() {
        return this._modulator.type;
    }
    set modulationType(type) {
        this._modulator.type = type;
    }
    get phase() {
        return this._carrier.phase;
    }
    set phase(phase) {
        this._carrier.phase = phase;
        this._modulator.phase = phase;
    }
    get partials() {
        return this._carrier.partials;
    }
    set partials(partials) {
        this._carrier.partials = partials;
    }
    asArray() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(length = 1024) {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.harmonicity.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this._modulationNode.dispose();
        this.modulationIndex.dispose();
        return this;
    }
}











class $fb1e1e5a6691f5f9$export$f134e81916b1e032 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($fb1e1e5a6691f5f9$export$f134e81916b1e032.getDefaults(), arguments, [
            "frequency",
            "width"
        ]);
        super(options);
        this.name = "PulseOscillator";
        /**
         * gate the width amount
         */ this._widthGate = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        /**
         * Threshold the signal to turn it into a square
         */ this._thresh = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: (val)=>val <= 0 ? -1 : 1
        });
        this.width = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "audioRange",
            value: options.width
        });
        this._triangle = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase,
            type: "triangle"
        });
        this.frequency = this._triangle.frequency;
        this.detune = this._triangle.detune;
        // connections
        this._triangle.chain(this._thresh, this.output);
        this.width.chain(this._widthGate, this._thresh);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "width",
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            detune: 0,
            frequency: 440,
            phase: 0,
            type: "pulse",
            width: 0.2
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._triangle.start(time);
        this._widthGate.gain.setValueAtTime(1, time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._triangle.stop(time);
        // the width is still connected to the output.
        // that needs to be stopped also
        this._widthGate.gain.cancelScheduledValues(time);
        this._widthGate.gain.setValueAtTime(0, time);
    }
    _restart(time) {
        this._triangle.restart(time);
        this._widthGate.gain.cancelScheduledValues(time);
        this._widthGate.gain.setValueAtTime(1, time);
    }
    /**
     * The phase of the oscillator in degrees.
     */ get phase() {
        return this._triangle.phase;
    }
    set phase(phase) {
        this._triangle.phase = phase;
    }
    /**
     * The type of the oscillator. Always returns "pulse".
     */ get type() {
        return "pulse";
    }
    /**
     * The baseType of the oscillator. Always returns "pulse".
     */ get baseType() {
        return "pulse";
    }
    /**
     * The partials of the waveform. Cannot set partials for this waveform type
     */ get partials() {
        return [];
    }
    /**
     * No partials for this waveform type.
     */ get partialCount() {
        return 0;
    }
    /**
     * *Internal use* The carrier oscillator type is fed through the
     * waveshaper node to create the pulse. Using different carrier oscillators
     * changes oscillator's behavior.
     */ set carrierType(type) {
        this._triangle.type = type;
    }
    asArray() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(length = 1024) {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up method.
     */ dispose() {
        super.dispose();
        this._triangle.dispose();
        this.width.dispose();
        this._widthGate.dispose();
        this._thresh.dispose();
        return this;
    }
}










class $3736813a08473376$export$a7d0bd116bda6b00 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3736813a08473376$export$a7d0bd116bda6b00.getDefaults(), arguments, [
            "frequency",
            "type",
            "spread"
        ]);
        super(options);
        this.name = "FatOscillator";
        /**
         * The array of oscillators
         */ this._oscillators = [];
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this._spread = options.spread;
        this._type = options.type;
        this._phase = options.phase;
        this._partials = options.partials;
        this._partialCount = options.partialCount;
        // set the count initially
        this.count = options.count;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), {
            count: 3,
            spread: 20,
            type: "sawtooth"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._forEach((osc)=>osc.start(time));
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._forEach((osc)=>osc.stop(time));
    }
    _restart(time) {
        this._forEach((osc)=>osc.restart(time));
    }
    /**
     * Iterate over all of the oscillators
     */ _forEach(iterator) {
        for(let i = 0; i < this._oscillators.length; i++)iterator(this._oscillators[i], i);
    }
    /**
     * The type of the oscillator
     */ get type() {
        return this._type;
    }
    set type(type) {
        this._type = type;
        this._forEach((osc)=>osc.type = type);
    }
    /**
     * The detune spread between the oscillators. If "count" is
     * set to 3 oscillators and the "spread" is set to 40,
     * the three oscillators would be detuned like this: [-20, 0, 20]
     * for a total detune spread of 40 cents.
     * @example
     * const fatOsc = new Tone.FatOscillator().toDestination().start();
     * fatOsc.spread = 70;
     */ get spread() {
        return this._spread;
    }
    set spread(spread) {
        this._spread = spread;
        if (this._oscillators.length > 1) {
            const start = -spread / 2;
            const step = spread / (this._oscillators.length - 1);
            this._forEach((osc, i)=>osc.detune.value = start + step * i);
        }
    }
    /**
     * The number of detuned oscillators. Must be an integer greater than 1.
     * @example
     * const fatOsc = new Tone.FatOscillator("C#3", "sawtooth").toDestination().start();
     * // use 4 sawtooth oscillators
     * fatOsc.count = 4;
     */ get count() {
        return this._oscillators.length;
    }
    set count(count) {
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(count, 1);
        if (this._oscillators.length !== count) {
            // dispose the previous oscillators
            this._forEach((osc)=>osc.dispose());
            this._oscillators = [];
            for(let i = 0; i < count; i++){
                const osc = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
                    context: this.context,
                    volume: -6 - count * 1.1,
                    type: this._type,
                    phase: this._phase + i / count * 360,
                    partialCount: this._partialCount,
                    onstop: i === 0 ? ()=>this.onstop(this) : (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)
                });
                if (this.type === "custom") osc.partials = this._partials;
                this.frequency.connect(osc.frequency);
                this.detune.connect(osc.detune);
                osc.detune.overridden = false;
                osc.connect(this.output);
                this._oscillators[i] = osc;
            }
            // set the spread
            this.spread = this._spread;
            if (this.state === "started") this._forEach((osc)=>osc.start());
        }
    }
    get phase() {
        return this._phase;
    }
    set phase(phase) {
        this._phase = phase;
        this._forEach((osc, i)=>osc.phase = this._phase + i / this.count * 360);
    }
    get baseType() {
        return this._oscillators[0].baseType;
    }
    set baseType(baseType) {
        this._forEach((osc)=>osc.baseType = baseType);
        this._type = this._oscillators[0].type;
    }
    get partials() {
        return this._oscillators[0].partials;
    }
    set partials(partials) {
        this._partials = partials;
        this._partialCount = this._partials.length;
        if (partials.length) {
            this._type = "custom";
            this._forEach((osc)=>osc.partials = partials);
        }
    }
    get partialCount() {
        return this._oscillators[0].partialCount;
    }
    set partialCount(partialCount) {
        this._partialCount = partialCount;
        this._forEach((osc)=>osc.partialCount = partialCount);
        this._type = this._oscillators[0].type;
    }
    asArray() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(length = 1024) {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this._forEach((osc)=>osc.dispose());
        return this;
    }
}










class $2ecfafda5b1bef2d$export$baa28c9ecd0db52 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2ecfafda5b1bef2d$export$baa28c9ecd0db52.getDefaults(), arguments, [
            "frequency",
            "modulationFrequency"
        ]);
        super(options);
        this.name = "PWMOscillator";
        this.sourceType = "pwm";
        /**
         * Scale the oscillator so it doesn't go silent
         * at the extreme values.
         */ this._scale = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: 2
        });
        this._pulse = new (0, $fb1e1e5a6691f5f9$export$f134e81916b1e032)({
            context: this.context,
            frequency: options.modulationFrequency
        });
        // change the pulse oscillator type
        this._pulse.carrierType = "sine";
        this.modulationFrequency = this._pulse.frequency;
        this._modulator = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            detune: options.detune,
            frequency: options.frequency,
            onstop: ()=>this.onstop(this),
            phase: options.phase
        });
        this.frequency = this._modulator.frequency;
        this.detune = this._modulator.detune;
        // connections
        this._modulator.chain(this._scale, this._pulse.width);
        this._pulse.connect(this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "modulationFrequency",
            "frequency",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            detune: 0,
            frequency: 440,
            modulationFrequency: 0.4,
            phase: 0,
            type: "pwm"
        });
    }
    /**
     * start the oscillator
     */ _start(time) {
        time = this.toSeconds(time);
        this._modulator.start(time);
        this._pulse.start(time);
    }
    /**
     * stop the oscillator
     */ _stop(time) {
        time = this.toSeconds(time);
        this._modulator.stop(time);
        this._pulse.stop(time);
    }
    /**
     * restart the oscillator
     */ _restart(time) {
        this._modulator.restart(time);
        this._pulse.restart(time);
    }
    /**
     * The type of the oscillator. Always returns "pwm".
     */ get type() {
        return "pwm";
    }
    /**
     * The baseType of the oscillator. Always returns "pwm".
     */ get baseType() {
        return "pwm";
    }
    /**
     * The partials of the waveform. Cannot set partials for this waveform type
     */ get partials() {
        return [];
    }
    /**
     * No partials for this waveform type.
     */ get partialCount() {
        return 0;
    }
    /**
     * The phase of the oscillator in degrees.
     */ get phase() {
        return this._modulator.phase;
    }
    set phase(phase) {
        this._modulator.phase = phase;
    }
    asArray() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(length = 1024) {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._pulse.dispose();
        this._scale.dispose();
        this._modulator.dispose();
        return this;
    }
}















const $7fd076cd12a174f2$var$OmniOscillatorSourceMap = {
    am: (0, $81277ef08515f70b$export$782fe1d3ba34f8d6),
    fat: (0, $3736813a08473376$export$a7d0bd116bda6b00),
    fm: (0, $87e8e716b583ad3c$export$3055866937a7451d),
    oscillator: (0, $304d61465298e719$export$c01c5c7b81696d70),
    pulse: (0, $fb1e1e5a6691f5f9$export$f134e81916b1e032),
    pwm: (0, $2ecfafda5b1bef2d$export$baa28c9ecd0db52)
};
class $7fd076cd12a174f2$export$46c9f562e6d6ca6d extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7fd076cd12a174f2$export$46c9f562e6d6ca6d.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        super(options);
        this.name = "OmniOscillator";
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "detune"
        ]);
        // set the options
        this.set(options);
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), (0, $87e8e716b583ad3c$export$3055866937a7451d).getDefaults(), (0, $81277ef08515f70b$export$782fe1d3ba34f8d6).getDefaults(), (0, $3736813a08473376$export$a7d0bd116bda6b00).getDefaults(), (0, $fb1e1e5a6691f5f9$export$f134e81916b1e032).getDefaults(), (0, $2ecfafda5b1bef2d$export$baa28c9ecd0db52).getDefaults());
    }
    /**
     * start the oscillator
     */ _start(time) {
        this._oscillator.start(time);
    }
    /**
     * start the oscillator
     */ _stop(time) {
        this._oscillator.stop(time);
    }
    _restart(time) {
        this._oscillator.restart(time);
        return this;
    }
    /**
     * The type of the oscillator. Can be any of the basic types: sine, square, triangle, sawtooth. Or
     * prefix the basic types with "fm", "am", or "fat" to use the FMOscillator, AMOscillator or FatOscillator
     * types. The oscillator could also be set to "pwm" or "pulse". All of the parameters of the
     * oscillator's class are accessible when the oscillator is set to that type, but throws an error
     * when it's not.
     * @example
     * const omniOsc = new Tone.OmniOscillator().toDestination().start();
     * omniOsc.type = "pwm";
     * // modulationFrequency is parameter which is available
     * // only when the type is "pwm".
     * omniOsc.modulationFrequency.value = 0.5;
     */ get type() {
        let prefix = "";
        if ([
            "am",
            "fm",
            "fat"
        ].some((p)=>this._sourceType === p)) prefix = this._sourceType;
        return prefix + this._oscillator.type;
    }
    set type(type) {
        if (type.substr(0, 2) === "fm") {
            this._createNewOscillator("fm");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(2);
        } else if (type.substr(0, 2) === "am") {
            this._createNewOscillator("am");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(2);
        } else if (type.substr(0, 3) === "fat") {
            this._createNewOscillator("fat");
            this._oscillator = this._oscillator;
            this._oscillator.type = type.substr(3);
        } else if (type === "pwm") {
            this._createNewOscillator("pwm");
            this._oscillator = this._oscillator;
        } else if (type === "pulse") this._createNewOscillator("pulse");
        else {
            this._createNewOscillator("oscillator");
            this._oscillator = this._oscillator;
            this._oscillator.type = type;
        }
    }
    /**
     * The value is an empty array when the type is not "custom".
     * This is not available on "pwm" and "pulse" oscillator types.
     * @see {@link Oscillator.partials}
     */ get partials() {
        return this._oscillator.partials;
    }
    set partials(partials) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm")) this._oscillator.partials = partials;
    }
    get partialCount() {
        return this._oscillator.partialCount;
    }
    set partialCount(partialCount) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm")) this._oscillator.partialCount = partialCount;
    }
    set(props) {
        // make sure the type is set first
        if (Reflect.has(props, "type") && props.type) this.type = props.type;
        // then set the rest
        super.set(props);
        return this;
    }
    /**
     * connect the oscillator to the frequency and detune signals
     */ _createNewOscillator(oscType) {
        if (oscType !== this._sourceType) {
            this._sourceType = oscType;
            const OscConstructor = $7fd076cd12a174f2$var$OmniOscillatorSourceMap[oscType];
            // short delay to avoid clicks on the change
            const now = this.now();
            if (this._oscillator) {
                const oldOsc = this._oscillator;
                oldOsc.stop(now);
                // dispose the old one
                this.context.setTimeout(()=>oldOsc.dispose(), this.blockTime);
            }
            this._oscillator = new OscConstructor({
                context: this.context
            });
            this.frequency.connect(this._oscillator.frequency);
            this.detune.connect(this._oscillator.detune);
            this._oscillator.connect(this.output);
            this._oscillator.onstop = ()=>this.onstop(this);
            if (this.state === "started") this._oscillator.start(now);
        }
    }
    get phase() {
        return this._oscillator.phase;
    }
    set phase(phase) {
        this._oscillator.phase = phase;
    }
    /**
     * The source type of the oscillator.
     * @example
     * const omniOsc = new Tone.OmniOscillator(440, "fmsquare");
     * console.log(omniOsc.sourceType); // 'fm'
     */ get sourceType() {
        return this._sourceType;
    }
    set sourceType(sType) {
        // the basetype defaults to sine
        let baseType = "sine";
        if (this._oscillator.type !== "pwm" && this._oscillator.type !== "pulse") baseType = this._oscillator.type;
        // set the type
        if (sType === "fm") this.type = "fm" + baseType;
        else if (sType === "am") this.type = "am" + baseType;
        else if (sType === "fat") this.type = "fat" + baseType;
        else if (sType === "oscillator") this.type = baseType;
        else if (sType === "pulse") this.type = "pulse";
        else if (sType === "pwm") this.type = "pwm";
    }
    _getOscType(osc, sourceType) {
        return osc instanceof $7fd076cd12a174f2$var$OmniOscillatorSourceMap[sourceType];
    }
    /**
     * The base type of the oscillator.
     * @see {@link Oscillator.baseType}
     * @example
     * const omniOsc = new Tone.OmniOscillator(440, "fmsquare4");
     * console.log(omniOsc.sourceType, omniOsc.baseType, omniOsc.partialCount);
     */ get baseType() {
        return this._oscillator.baseType;
    }
    set baseType(baseType) {
        if (!this._getOscType(this._oscillator, "pulse") && !this._getOscType(this._oscillator, "pwm") && baseType !== "pulse" && baseType !== "pwm") this._oscillator.baseType = baseType;
    }
    /**
     * The width of the oscillator when sourceType === "pulse".
     * @see {@link PWMOscillator}
     */ get width() {
        if (this._getOscType(this._oscillator, "pulse")) return this._oscillator.width;
        else return undefined;
    }
    /**
     * The number of detuned oscillators when sourceType === "fat".
     * @see {@link FatOscillator.count}
     */ get count() {
        if (this._getOscType(this._oscillator, "fat")) return this._oscillator.count;
        else return undefined;
    }
    set count(count) {
        if (this._getOscType(this._oscillator, "fat") && (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(count)) this._oscillator.count = count;
    }
    /**
     * The detune spread between the oscillators when sourceType === "fat".
     * @see {@link FatOscillator.count}
     */ get spread() {
        if (this._getOscType(this._oscillator, "fat")) return this._oscillator.spread;
        else return undefined;
    }
    set spread(spread) {
        if (this._getOscType(this._oscillator, "fat") && (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(spread)) this._oscillator.spread = spread;
    }
    /**
     * The type of the modulator oscillator. Only if the oscillator is set to "am" or "fm" types.
     * @see {@link AMOscillator} or {@link FMOscillator}
     */ get modulationType() {
        if (this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) return this._oscillator.modulationType;
        else return undefined;
    }
    set modulationType(mType) {
        if ((this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) && (0, $4d7f709c9ffa5105$export$844ec244b1367d54)(mType)) this._oscillator.modulationType = mType;
    }
    /**
     * The modulation index when the sourceType === "fm"
     * @see {@link FMOscillator}.
     */ get modulationIndex() {
        if (this._getOscType(this._oscillator, "fm")) return this._oscillator.modulationIndex;
        else return undefined;
    }
    /**
     * Harmonicity is the frequency ratio between the carrier and the modulator oscillators.
     * @see {@link AMOscillator} or {@link FMOscillator}
     */ get harmonicity() {
        if (this._getOscType(this._oscillator, "fm") || this._getOscType(this._oscillator, "am")) return this._oscillator.harmonicity;
        else return undefined;
    }
    /**
     * The modulationFrequency Signal of the oscillator when sourceType === "pwm"
     * see {@link PWMOscillator}
     * @min 0.1
     * @max 5
     */ get modulationFrequency() {
        if (this._getOscType(this._oscillator, "pwm")) return this._oscillator.modulationFrequency;
        else return undefined;
    }
    asArray() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(length = 1024) {
            return (0, $e45997ed2518edd7$export$c5486db94e413392)(this, length);
        });
    }
    dispose() {
        super.dispose();
        this.detune.dispose();
        this.frequency.dispose();
        this._oscillator.dispose();
        return this;
    }
}














class $ad8862926b54eb7c$export$d0265b2c425512d6 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($ad8862926b54eb7c$export$d0265b2c425512d6.getDefaults(), arguments, [
            "value"
        ]));
        this.override = false;
        this.name = "Add";
        /**
         * the summing node
         */ this._sum = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.input = this._sum;
        this.output = this._sum;
        /**
         * The value which is added to the input signal
         */ this.addend = this._param;
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this._constantSource, this._sum);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._sum.dispose();
        return this;
    }
}




class $d4646d969ab22afc$export$d60cfc58d3c358b6 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($d4646d969ab22afc$export$d60cfc58d3c358b6.getDefaults(), arguments, [
            "min",
            "max"
        ]);
        super(options);
        this.name = "Scale";
        this._mult = this.input = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: options.max - options.min
        });
        this._add = this.output = new (0, $ad8862926b54eb7c$export$d0265b2c425512d6)({
            context: this.context,
            value: options.min
        });
        this._min = options.min;
        this._max = options.max;
        this.input.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe).getDefaults(), {
            max: 1,
            min: 0
        });
    }
    /**
     * The minimum output value. This number is output when the value input value is 0.
     */ get min() {
        return this._min;
    }
    set min(min) {
        this._min = min;
        this._setRange();
    }
    /**
     * The maximum output value. This number is output when the value input value is 1.
     */ get max() {
        return this._max;
    }
    set max(max) {
        this._max = max;
        this._setRange();
    }
    /**
     * set the values
     */ _setRange() {
        this._add.value = this._min;
        this._mult.value = this._max - this._min;
    }
    dispose() {
        super.dispose();
        this._add.dispose();
        this._mult.dispose();
        return this;
    }
}







class $88073d0d401dc0e5$export$aaef8a3eae948f03 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($88073d0d401dc0e5$export$aaef8a3eae948f03.getDefaults(), arguments));
        this.name = "Zero";
        /**
         * The gain node which connects the constant source to the output
         */ this._gain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * Only outputs 0
         */ this.output = this._gain;
        /**
         * no input node
         */ this.input = undefined;
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this.context.getConstant(0), this._gain);
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        (0, $1dae52eee8c779dd$export$37dfea93db2e14ed)(this.context.getConstant(0), this._gain);
        return this;
    }
}



class $e29fd7f03d7e26e3$export$603054d5ec296d77 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e29fd7f03d7e26e3$export$603054d5ec296d77.getDefaults(), arguments, [
            "frequency",
            "min",
            "max"
        ]);
        super(options);
        this.name = "LFO";
        /**
         * The value that the LFO outputs when it's stopped
         */ this._stoppedValue = 0;
        /**
         * A private placeholder for the units
         */ this._units = "number";
        /**
         * If the input value is converted using the {@link units}
         */ this.convert = true;
        /**
         * Private methods borrowed from Param
         */ // @ts-ignore
        this._fromType = (0, $4e42d28fbc344697$export$1ca45c9a47aec42c).prototype._fromType;
        // @ts-ignore
        this._toType = (0, $4e42d28fbc344697$export$1ca45c9a47aec42c).prototype._toType;
        // @ts-ignore
        this._is = (0, $4e42d28fbc344697$export$1ca45c9a47aec42c).prototype._is;
        // @ts-ignore
        this._clampValue = (0, $4e42d28fbc344697$export$1ca45c9a47aec42c).prototype._clampValue;
        this._oscillator = new (0, $304d61465298e719$export$c01c5c7b81696d70)(options);
        this.frequency = this._oscillator.frequency;
        this._amplitudeGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.amplitude,
            units: "normalRange"
        });
        this.amplitude = this._amplitudeGain.gain;
        this._stoppedSignal = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "audioRange",
            value: 0
        });
        this._zeros = new (0, $88073d0d401dc0e5$export$aaef8a3eae948f03)({
            context: this.context
        });
        this._a2g = new (0, $69552eca520acf8e$export$2e6ea0941c39f845)({
            context: this.context
        });
        this._scaler = this.output = new (0, $d4646d969ab22afc$export$d60cfc58d3c358b6)({
            context: this.context,
            max: options.max,
            min: options.min
        });
        this.units = options.units;
        this.min = options.min;
        this.max = options.max;
        // connect it up
        this._oscillator.chain(this._amplitudeGain, this._a2g, this._scaler);
        this._zeros.connect(this._a2g);
        this._stoppedSignal.connect(this._a2g);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "amplitude",
            "frequency"
        ]);
        this.phase = options.phase;
    }
    static getDefaults() {
        return Object.assign((0, $304d61465298e719$export$c01c5c7b81696d70).getDefaults(), {
            amplitude: 1,
            frequency: "4n",
            max: 1,
            min: 0,
            type: "sine",
            units: "number"
        });
    }
    /**
     * Start the LFO.
     * @param time The time the LFO will start
     */ start(time) {
        time = this.toSeconds(time);
        this._stoppedSignal.setValueAtTime(0, time);
        this._oscillator.start(time);
        return this;
    }
    /**
     * Stop the LFO.
     * @param  time The time the LFO will stop
     */ stop(time) {
        time = this.toSeconds(time);
        this._stoppedSignal.setValueAtTime(this._stoppedValue, time);
        this._oscillator.stop(time);
        return this;
    }
    /**
     * Sync the start/stop/pause to the transport
     * and the frequency to the bpm of the transport
     * @example
     * const lfo = new Tone.LFO("8n");
     * lfo.sync().start(0);
     * // the rate of the LFO will always be an eighth note, even as the tempo changes
     */ sync() {
        this._oscillator.sync();
        this._oscillator.syncFrequency();
        return this;
    }
    /**
     * unsync the LFO from transport control
     */ unsync() {
        this._oscillator.unsync();
        this._oscillator.unsyncFrequency();
        return this;
    }
    /**
     * After the oscillator waveform is updated, reset the `_stoppedSignal` value to match the updated waveform
     */ _setStoppedValue() {
        this._stoppedValue = this._oscillator.getInitialValue();
        this._stoppedSignal.value = this._stoppedValue;
    }
    /**
     * The minimum output of the LFO.
     */ get min() {
        return this._toType(this._scaler.min);
    }
    set min(min) {
        min = this._fromType(min);
        this._scaler.min = min;
    }
    /**
     * The maximum output of the LFO.
     */ get max() {
        return this._toType(this._scaler.max);
    }
    set max(max) {
        max = this._fromType(max);
        this._scaler.max = max;
    }
    /**
     * The type of the oscillator.
     * @see {@link Oscillator.type}
     */ get type() {
        return this._oscillator.type;
    }
    set type(type) {
        this._oscillator.type = type;
        this._setStoppedValue();
    }
    /**
     * The oscillator's partials array.
     * @see {@link Oscillator.partials}
     */ get partials() {
        return this._oscillator.partials;
    }
    set partials(partials) {
        this._oscillator.partials = partials;
        this._setStoppedValue();
    }
    /**
     * The phase of the LFO.
     */ get phase() {
        return this._oscillator.phase;
    }
    set phase(phase) {
        this._oscillator.phase = phase;
        this._setStoppedValue();
    }
    /**
     * The output units of the LFO.
     */ get units() {
        return this._units;
    }
    set units(val) {
        const currentMin = this.min;
        const currentMax = this.max;
        // convert the min and the max
        this._units = val;
        this.min = currentMin;
        this.max = currentMax;
    }
    /**
     * Returns the playback state of the source, either "started" or "stopped".
     */ get state() {
        return this._oscillator.state;
    }
    /**
     * @param node the destination to connect to
     * @param outputNum the optional output number
     * @param inputNum the input number
     */ connect(node, outputNum, inputNum) {
        if (node instanceof (0, $4e42d28fbc344697$export$1ca45c9a47aec42c) || node instanceof (0, $87a50297d6fa5f61$export$8210dfe1863c478)) {
            this.convert = node.convert;
            this.units = node.units;
        }
        (0, $87a50297d6fa5f61$export$c8174dc07173cff0)(this, node, outputNum, inputNum);
        return this;
    }
    dispose() {
        super.dispose();
        this._oscillator.dispose();
        this._stoppedSignal.dispose();
        this._zeros.dispose();
        this._scaler.dispose();
        this._a2g.dispose();
        this._amplitudeGain.dispose();
        this.amplitude.dispose();
        return this;
    }
}












function $56353399eaf2b0ec$export$d02631cccf789723(min, max = Infinity) {
    const valueMap = new WeakMap();
    return function(target, propertyKey) {
        Reflect.defineProperty(target, propertyKey, {
            configurable: true,
            enumerable: true,
            get: function() {
                return valueMap.get(this);
            },
            set: function(newValue) {
                (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(newValue, min, max);
                valueMap.set(this, newValue);
            }
        });
    };
}
function $56353399eaf2b0ec$export$4748a2e3a6d34ca5(min, max = Infinity) {
    const valueMap = new WeakMap();
    return function(target, propertyKey) {
        Reflect.defineProperty(target, propertyKey, {
            configurable: true,
            enumerable: true,
            get: function() {
                return valueMap.get(this);
            },
            set: function(newValue) {
                (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(newValue), min, max);
                valueMap.set(this, newValue);
            }
        });
    };
}


class $44209288688a0328$export$2616165974278734 extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($44209288688a0328$export$2616165974278734.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        super(options);
        this.name = "Player";
        /**
         * All of the active buffer source nodes
         */ this._activeSources = new Set();
        this._buffer = new (0, $43da6dea502b5fe8$export$424a335715b38178)({
            onload: this._onload.bind(this, options.onload),
            onerror: options.onerror,
            reverse: options.reverse,
            url: options.url
        });
        this.autostart = options.autostart;
        this._loop = options.loop;
        this._loopStart = options.loopStart;
        this._loopEnd = options.loopEnd;
        this._playbackRate = options.playbackRate;
        this.fadeIn = options.fadeIn;
        this.fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            autostart: false,
            fadeIn: 0,
            fadeOut: 0,
            loop: false,
            loopEnd: 0,
            loopStart: 0,
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            playbackRate: 1,
            reverse: false
        });
    }
    /**
     * Load the audio file as an audio buffer.
     * Decodes the audio asynchronously and invokes
     * the callback once the audio buffer loads.
     * Note: this does not need to be called if a url
     * was passed in to the constructor. Only use this
     * if you want to manually load a new url.
     * @param url The url of the buffer to load. Filetype support depends on the browser.
     */ load(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            yield this._buffer.load(url);
            this._onload();
            return this;
        });
    }
    /**
     * Internal callback when the buffer is loaded.
     */ _onload(callback = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)) {
        callback();
        if (this.autostart) this.start();
    }
    /**
     * Internal callback when the buffer is done playing.
     */ _onSourceEnd(source) {
        // invoke the onstop function
        this.onstop(this);
        // delete the source from the active sources
        this._activeSources.delete(source);
        if (this._activeSources.size === 0 && !this._synced && this._state.getValueAtTime(this.now()) === "started") {
            // remove the 'implicitEnd' event and replace with an explicit end
            this._state.cancel(this.now());
            this._state.setStateAtTime("stopped", this.now());
        }
    }
    /**
     * Play the buffer at the given startTime. Optionally add an offset
     * and/or duration which will play the buffer from a position
     * within the buffer for the given duration.
     *
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given, it will default to the full length of the sample (minus any offset)
     */ start(time, offset, duration) {
        super.start(time, offset, duration);
        return this;
    }
    /**
     * Internal start method
     */ _start(startTime, offset, duration) {
        // if it's a loop the default offset is the loopStart point
        if (this._loop) offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, this._loopStart);
        else // otherwise the default offset is 0
        offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0);
        // compute the values in seconds
        const computedOffset = this.toSeconds(offset);
        // compute the duration which is either the passed in duration of the buffer.duration - offset
        const origDuration = duration;
        duration = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(duration, Math.max(this._buffer.duration - computedOffset, 0));
        let computedDuration = this.toSeconds(duration);
        // scale it by the playback rate
        computedDuration = computedDuration / this._playbackRate;
        // get the start time
        startTime = this.toSeconds(startTime);
        // make the source
        const source = new (0, $faf7c8e078303879$export$30cbf4ba14db4fdd)({
            url: this._buffer,
            context: this.context,
            fadeIn: this.fadeIn,
            fadeOut: this.fadeOut,
            loop: this._loop,
            loopEnd: this._loopEnd,
            loopStart: this._loopStart,
            onended: this._onSourceEnd.bind(this),
            playbackRate: this._playbackRate
        }).connect(this.output);
        // set the looping properties
        if (!this._loop && !this._synced) {
            // cancel the previous stop
            this._state.cancel(startTime + computedDuration);
            // if it's not looping, set the state change at the end of the sample
            this._state.setStateAtTime("stopped", startTime + computedDuration, {
                implicitEnd: true
            });
        }
        // add it to the array of active sources
        this._activeSources.add(source);
        // start it
        if (this._loop && (0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(origDuration)) source.start(startTime, computedOffset);
        else // subtract the fade out time
        source.start(startTime, computedOffset, computedDuration - this.toSeconds(this.fadeOut));
    }
    /**
     * Stop playback.
     */ _stop(time) {
        const computedTime = this.toSeconds(time);
        this._activeSources.forEach((source)=>source.stop(computedTime));
    }
    /**
     * Stop and then restart the player from the beginning (or offset)
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given,
     * 					it will default to the full length of the sample (minus any offset)
     */ restart(time, offset, duration) {
        super.restart(time, offset, duration);
        return this;
    }
    _restart(time, offset, duration) {
        var _a;
        (_a = [
            ...this._activeSources
        ].pop()) === null || _a === void 0 || _a.stop(time); // explicitly stop only the most recently created source, to avoid edge case when > 1 source exists and _stop() erroneously sets all stop times past original end offset
        this._start(time, offset, duration);
    }
    /**
     * Seek to a specific time in the player's buffer. If the
     * source is no longer playing at that time, it will stop.
     * @param offset The time to seek to.
     * @param when The time for the seek event to occur.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/gurgling_theremin_1.mp3", () => {
     * 	player.start();
     * 	// seek to the offset in 1 second from now
     * 	player.seek(0.4, "+1");
     * }).toDestination();
     */ seek(offset, when) {
        const computedTime = this.toSeconds(when);
        if (this._state.getValueAtTime(computedTime) === "started") {
            const computedOffset = this.toSeconds(offset);
            // if it's currently playing, stop it
            this._stop(computedTime);
            // restart it at the given time
            this._start(computedTime, computedOffset);
        }
        return this;
    }
    /**
     * Set the loop start and end. Will only loop if loop is set to true.
     * @param loopStart The loop start time
     * @param loopEnd The loop end time
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/malevoices_aa2_F3.mp3").toDestination();
     * // loop between the given points
     * player.setLoopPoints(0.2, 0.3);
     * player.loop = true;
     * player.autostart = true;
     */ setLoopPoints(loopStart, loopEnd) {
        this.loopStart = loopStart;
        this.loopEnd = loopEnd;
        return this;
    }
    /**
     * If loop is true, the loop will start at this position.
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(loopStart) {
        this._loopStart = loopStart;
        if (this.buffer.loaded) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(loopStart), 0, this.buffer.duration);
        // get the current source
        this._activeSources.forEach((source)=>{
            source.loopStart = loopStart;
        });
    }
    /**
     * If loop is true, the loop will end at this position.
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(loopEnd) {
        this._loopEnd = loopEnd;
        if (this.buffer.loaded) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(loopEnd), 0, this.buffer.duration);
        // get the current source
        this._activeSources.forEach((source)=>{
            source.loopEnd = loopEnd;
        });
    }
    /**
     * The audio buffer belonging to the player.
     */ get buffer() {
        return this._buffer;
    }
    set buffer(buffer) {
        this._buffer.set(buffer);
    }
    /**
     * If the buffer should loop once it's over.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/drum-samples/breakbeat.mp3").toDestination();
     * player.loop = true;
     * player.autostart = true;
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        // if no change, do nothing
        if (this._loop === loop) return;
        this._loop = loop;
        // set the loop of all of the sources
        this._activeSources.forEach((source)=>{
            source.loop = loop;
        });
        if (loop) {
            // remove the next stopEvent
            const stopEvent = this._state.getNextState("stopped", this.now());
            if (stopEvent) this._state.cancel(stopEvent.time);
        }
    }
    /**
     * Normal speed is 1. The pitch will change with the playback rate.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/femalevoices_aa2_A5.mp3").toDestination();
     * // play at 1/4 speed
     * player.playbackRate = 0.25;
     * // play as soon as the buffer is loaded
     * player.autostart = true;
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        const now = this.now();
        // cancel the stop event since it's at a different time now
        const stopEvent = this._state.getNextState("stopped", now);
        if (stopEvent && stopEvent.implicitEnd) {
            this._state.cancel(stopEvent.time);
            this._activeSources.forEach((source)=>source.cancelStop());
        }
        // set all the sources
        this._activeSources.forEach((source)=>{
            source.playbackRate.setValueAtTime(rate, now);
        });
    }
    /**
     * If the buffer should be reversed. Note that this sets the underlying {@link ToneAudioBuffer.reverse}, so
     * if multiple players are pointing at the same ToneAudioBuffer, they will all be reversed.
     * @example
     * const player = new Tone.Player("https://tonejs.github.io/audio/berklee/chime_1.mp3").toDestination();
     * player.autostart = true;
     * player.reverse = true;
     */ get reverse() {
        return this._buffer.reverse;
    }
    set reverse(rev) {
        this._buffer.reverse = rev;
    }
    /**
     * If the buffer is loaded
     */ get loaded() {
        return this._buffer.loaded;
    }
    dispose() {
        super.dispose();
        // disconnect all of the players
        this._activeSources.forEach((source)=>source.dispose());
        this._activeSources.clear();
        this._buffer.dispose();
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $44209288688a0328$export$2616165974278734.prototype, "fadeIn", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $44209288688a0328$export$2616165974278734.prototype, "fadeOut", void 0);










class $a4c8f7c082f8cecc$export$1912c9d78e93a6ed extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a4c8f7c082f8cecc$export$1912c9d78e93a6ed.getDefaults(), arguments, [
            "urls",
            "onload"
        ], "urls");
        super(options);
        this.name = "Players";
        /**
         * Players has no input.
         */ this.input = undefined;
        /**
         * The container of all of the players
         */ this._players = new Map();
        /**
         * The output volume node
         */ this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
        this._buffers = new (0, $d37bb61f6ec53d08$export$7232b969b571e570)({
            urls: options.urls,
            onload: options.onload,
            baseUrl: options.baseUrl,
            onerror: options.onerror
        });
        // mute initially
        this.mute = options.mute;
        this._fadeIn = options.fadeIn;
        this._fadeOut = options.fadeOut;
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            baseUrl: "",
            fadeIn: 0,
            fadeOut: 0,
            mute: false,
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            urls: {},
            volume: 0
        });
    }
    /**
     * Mute the output.
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    /**
     * The fadeIn time of the envelope applied to the source.
     */ get fadeIn() {
        return this._fadeIn;
    }
    set fadeIn(fadeIn) {
        this._fadeIn = fadeIn;
        this._players.forEach((player)=>{
            player.fadeIn = fadeIn;
        });
    }
    /**
     * The fadeOut time of the each of the sources.
     */ get fadeOut() {
        return this._fadeOut;
    }
    set fadeOut(fadeOut) {
        this._fadeOut = fadeOut;
        this._players.forEach((player)=>{
            player.fadeOut = fadeOut;
        });
    }
    /**
     * The state of the players object. Returns "started" if any of the players are playing.
     */ get state() {
        const playing = Array.from(this._players).some(([_, player])=>player.state === "started");
        return playing ? "started" : "stopped";
    }
    /**
     * True if the buffers object has a buffer by that name.
     * @param name  The key or index of the buffer.
     */ has(name) {
        return this._buffers.has(name);
    }
    /**
     * Get a player by name.
     * @param  name  The players name as defined in the constructor object or `add` method.
     */ player(name) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.has(name), `No Player with the name ${name} exists on this object`);
        if (!this._players.has(name)) {
            const player = new (0, $44209288688a0328$export$2616165974278734)({
                context: this.context,
                fadeIn: this._fadeIn,
                fadeOut: this._fadeOut,
                url: this._buffers.get(name)
            }).connect(this.output);
            this._players.set(name, player);
        }
        return this._players.get(name);
    }
    /**
     * If all the buffers are loaded or not
     */ get loaded() {
        return this._buffers.loaded;
    }
    /**
     * Add a player by name and url to the Players
     * @param  name A unique name to give the player
     * @param  url  Either the url of the bufer or a buffer which will be added with the given name.
     * @param callback  The callback to invoke when the url is loaded.
     * @example
     * const players = new Tone.Players();
     * players.add("gong", "https://tonejs.github.io/audio/berklee/gong_1.mp3", () => {
     * 	console.log("gong loaded");
     * 	players.player("gong").start();
     * });
     */ add(name, url, callback) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this._buffers.has(name), "A buffer with that name already exists on this object");
        this._buffers.add(name, url, callback);
        return this;
    }
    /**
     * Stop all of the players at the given time
     * @param time The time to stop all of the players.
     */ stopAll(time) {
        this._players.forEach((player)=>player.stop(time));
        return this;
    }
    dispose() {
        super.dispose();
        this._volume.dispose();
        this.volume.dispose();
        this._players.forEach((player)=>player.dispose());
        this._buffers.dispose();
        return this;
    }
}










class $c5cf1604473dbe8e$export$564c6bce96a1f8e extends (0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($c5cf1604473dbe8e$export$564c6bce96a1f8e.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        super(options);
        this.name = "GrainPlayer";
        /**
         * Internal loopStart value
         */ this._loopStart = 0;
        /**
         * Internal loopStart value
         */ this._loopEnd = 0;
        /**
         * All of the currently playing BufferSources
         */ this._activeSources = [];
        this.buffer = new (0, $43da6dea502b5fe8$export$424a335715b38178)({
            onload: options.onload,
            onerror: options.onerror,
            reverse: options.reverse,
            url: options.url
        });
        this._clock = new (0, $b0382ab9b2ce11b2$export$9735c82c4bae3302)({
            context: this.context,
            callback: this._tick.bind(this),
            frequency: 1 / options.grainSize
        });
        this._playbackRate = options.playbackRate;
        this._grainSize = options.grainSize;
        this._overlap = options.overlap;
        this.detune = options.detune;
        // setup
        this.overlap = options.overlap;
        this.loop = options.loop;
        this.playbackRate = options.playbackRate;
        this.grainSize = options.grainSize;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this.reverse = options.reverse;
        this._clock.on("stop", this._onstop.bind(this));
    }
    static getDefaults() {
        return Object.assign((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults(), {
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            overlap: 0.1,
            grainSize: 0.2,
            playbackRate: 1,
            detune: 0,
            loop: false,
            loopStart: 0,
            loopEnd: 0,
            reverse: false
        });
    }
    /**
     * Internal start method
     */ _start(time, offset, duration) {
        offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0);
        offset = this.toSeconds(offset);
        time = this.toSeconds(time);
        const grainSize = 1 / this._clock.frequency.getValueAtTime(time);
        this._clock.start(time, offset / grainSize);
        if (duration) this.stop(time + this.toSeconds(duration));
    }
    /**
     * Stop and then restart the player from the beginning (or offset)
     * @param  time When the player should start.
     * @param  offset The offset from the beginning of the sample to start at.
     * @param  duration How long the sample should play. If no duration is given,
     * 					it will default to the full length of the sample (minus any offset)
     */ restart(time, offset, duration) {
        super.restart(time, offset, duration);
        return this;
    }
    _restart(time, offset, duration) {
        this._stop(time);
        this._start(time, offset, duration);
    }
    /**
     * Internal stop method
     */ _stop(time) {
        this._clock.stop(time);
    }
    /**
     * Invoked when the clock is stopped
     */ _onstop(time) {
        // stop the players
        this._activeSources.forEach((source)=>{
            source.fadeOut = 0;
            source.stop(time);
        });
        this.onstop(this);
    }
    /**
     * Invoked on each clock tick. scheduled a new grain at this time.
     */ _tick(time) {
        // check if it should stop looping
        const ticks = this._clock.getTicksAtTime(time);
        const offset = ticks * this._grainSize;
        this.log("offset", offset);
        if (!this.loop && offset > this.buffer.duration) {
            this.stop(time);
            return;
        }
        // at the beginning of the file, the fade in should be 0
        const fadeIn = offset < this._overlap ? 0 : this._overlap;
        // create a buffer source
        const source = new (0, $faf7c8e078303879$export$30cbf4ba14db4fdd)({
            context: this.context,
            url: this.buffer,
            fadeIn: fadeIn,
            fadeOut: this._overlap,
            loop: this.loop,
            loopStart: this._loopStart,
            loopEnd: this._loopEnd,
            // compute the playbackRate based on the detune
            playbackRate: (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(this.detune / 100)
        }).connect(this.output);
        source.start(time, this._grainSize * ticks);
        source.stop(time + this._grainSize / this.playbackRate);
        // add it to the active sources
        this._activeSources.push(source);
        // remove it when it's done
        source.onended = ()=>{
            const index = this._activeSources.indexOf(source);
            if (index !== -1) this._activeSources.splice(index, 1);
        };
    }
    /**
     * The playback rate of the sample
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(rate, 0.001);
        this._playbackRate = rate;
        this.grainSize = this._grainSize;
    }
    /**
     * The loop start time.
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(time) {
        if (this.buffer.loaded) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(time), 0, this.buffer.duration);
        this._loopStart = this.toSeconds(time);
    }
    /**
     * The loop end time.
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(time) {
        if (this.buffer.loaded) (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(this.toSeconds(time), 0, this.buffer.duration);
        this._loopEnd = this.toSeconds(time);
    }
    /**
     * The direction the buffer should play in
     */ get reverse() {
        return this.buffer.reverse;
    }
    set reverse(rev) {
        this.buffer.reverse = rev;
    }
    /**
     * The size of each chunk of audio that the
     * buffer is chopped into and played back at.
     */ get grainSize() {
        return this._grainSize;
    }
    set grainSize(size) {
        this._grainSize = this.toSeconds(size);
        this._clock.frequency.setValueAtTime(this._playbackRate / this._grainSize, this.now());
    }
    /**
     * The duration of the cross-fade between successive grains.
     */ get overlap() {
        return this._overlap;
    }
    set overlap(time) {
        const computedTime = this.toSeconds(time);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(computedTime, 0);
        this._overlap = computedTime;
    }
    /**
     * If all the buffer is loaded
     */ get loaded() {
        return this.buffer.loaded;
    }
    dispose() {
        super.dispose();
        this.buffer.dispose();
        this._clock.dispose();
        this._activeSources.forEach((source)=>source.dispose());
        return this;
    }
}







class $bc6b6173dfd74460$export$b73c596ee8758a66 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(...arguments);
        this.name = "Abs";
        /**
         * The node which converts the audio ranges
         */ this._abs = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: (val)=>{
                if (Math.abs(val) < 0.001) return 0;
                else return Math.abs(val);
            }
        });
        /**
         * The AudioRange input [-1, 1]
         */ this.input = this._abs;
        /**
         * The output range [0, 1]
         */ this.output = this._abs;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._abs.dispose();
        return this;
    }
}





class $98f6ca22b8da8532$export$770438008a544d9b extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(...arguments);
        this.name = "GainToAudio";
        /**
         * The node which converts the audio ranges
         */ this._norm = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            mapping: (x)=>Math.abs(x) * 2 - 1
        });
        /**
         * The NormalRange input [0, 1]
         */ this.input = this._norm;
        /**
         * The AudioRange output [-1, 1]
         */ this.output = this._norm;
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this._norm.dispose();
        return this;
    }
}








class $12434edb56028935$export$a4e82151127277b0 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super(...arguments);
        this.name = "Negate";
        /**
         * negation is done by multiplying by -1
         */ this._multiply = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: -1
        });
        /**
         * The input and output are equal to the multiply node
         */ this.input = this._multiply;
        this.output = this._multiply;
    }
    /**
     * clean up
     * @returns {Negate} this
     */ dispose() {
        super.dispose();
        this._multiply.dispose();
        return this;
    }
}



class $270e4189b1a75906$export$8bc67ae85ef4b74f extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($270e4189b1a75906$export$8bc67ae85ef4b74f.getDefaults(), arguments, [
            "value"
        ]));
        this.override = false;
        this.name = "Subtract";
        /**
         * the summing node
         */ this._sum = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.input = this._sum;
        this.output = this._sum;
        /**
         * Negate the input of the second input before connecting it to the summing node.
         */ this._neg = new (0, $12434edb56028935$export$a4e82151127277b0)({
            context: this.context
        });
        /**
         * The value which is subtracted from the main signal
         */ this.subtrahend = this._param;
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this._constantSource, this._neg, this._sum);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._neg.dispose();
        this._sum.dispose();
        return this;
    }
}







class $27732e051cf527d8$export$fe50ca7dd7da9c45 extends (0, $1c8b308fac67a067$export$5d271ddbaaaa6dbe) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($27732e051cf527d8$export$fe50ca7dd7da9c45.getDefaults(), arguments));
        this.name = "GreaterThanZero";
        this._thresh = this.output = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            length: 127,
            mapping: (val)=>{
                if (val <= 0) return 0;
                else return 1;
            }
        });
        this._scale = this.input = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: 10000
        });
        // connections
        this._scale.connect(this._thresh);
    }
    dispose() {
        super.dispose();
        this._scale.dispose();
        this._thresh.dispose();
        return this;
    }
}



class $935df50545cf657e$export$fdac76ab71aa5db6 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($935df50545cf657e$export$fdac76ab71aa5db6.getDefaults(), arguments, [
            "value"
        ]);
        super(options);
        this.name = "GreaterThan";
        this.override = false;
        this._subtract = this.input = new (0, $270e4189b1a75906$export$8bc67ae85ef4b74f)({
            context: this.context,
            value: options.value
        });
        this._gtz = this.output = new (0, $27732e051cf527d8$export$fe50ca7dd7da9c45)({
            context: this.context
        });
        this.comparator = this._param = this._subtract.subtrahend;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "comparator");
        // connect
        this._subtract.connect(this._gtz);
    }
    static getDefaults() {
        return Object.assign((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), {
            value: 0
        });
    }
    dispose() {
        super.dispose();
        this._gtz.dispose();
        this._subtract.dispose();
        this.comparator.dispose();
        return this;
    }
}











class $75aaa92c69306be4$export$92c7140174c78083 extends (0, $d4646d969ab22afc$export$d60cfc58d3c358b6) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($75aaa92c69306be4$export$92c7140174c78083.getDefaults(), arguments, [
            "min",
            "max",
            "exponent"
        ]);
        super(options);
        this.name = "ScaleExp";
        this.input = this._exp = new (0, $4603e249f478b841$export$ce28d653ec559ee)({
            context: this.context,
            value: options.exponent
        });
        this._exp.connect(this._mult);
    }
    static getDefaults() {
        return Object.assign((0, $d4646d969ab22afc$export$d60cfc58d3c358b6).getDefaults(), {
            exponent: 1
        });
    }
    /**
     * Instead of interpolating linearly between the {@link min} and
     * {@link max} values, setting the exponent will interpolate between
     * the two values with an exponential curve.
     */ get exponent() {
        return this._exp.value;
    }
    set exponent(exp) {
        this._exp.value = exp;
    }
    dispose() {
        super.dispose();
        this._exp.dispose();
        return this;
    }
}







class $1a19093127c18aeb$export$35743999fcf7d6a4 extends (0, $87a50297d6fa5f61$export$8210dfe1863c478) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)((0, $87a50297d6fa5f61$export$8210dfe1863c478).getDefaults(), arguments, [
            "value",
            "units"
        ]);
        super(options);
        this.name = "SyncedSignal";
        /**
         * Don't override when something is connected to the input
         */ this.override = false;
        this._lastVal = options.value;
        this._synced = this.context.transport.scheduleRepeat(this._onTick.bind(this), "1i");
        this._syncedCallback = this._anchorValue.bind(this);
        this.context.transport.on("start", this._syncedCallback);
        this.context.transport.on("pause", this._syncedCallback);
        this.context.transport.on("stop", this._syncedCallback);
        // disconnect the constant source from the output and replace it with another one
        this._constantSource.disconnect();
        this._constantSource.stop(0);
        // create a new one
        this._constantSource = this.output = new (0, $07d091cc6b8a4926$export$717f1ef4ba8fd295)({
            context: this.context,
            offset: options.value,
            units: options.units
        }).start(0);
        this.setValueAtTime(options.value, 0);
    }
    /**
     * Callback which is invoked every tick.
     */ _onTick(time) {
        const val = super.getValueAtTime(this.context.transport.seconds);
        // approximate ramp curves with linear ramps
        if (this._lastVal !== val) {
            this._lastVal = val;
            this._constantSource.offset.setValueAtTime(val, time);
        }
    }
    /**
     * Anchor the value at the start and stop of the Transport
     */ _anchorValue(time) {
        const val = super.getValueAtTime(this.context.transport.seconds);
        this._lastVal = val;
        this._constantSource.offset.cancelAndHoldAtTime(time);
        this._constantSource.offset.setValueAtTime(val, time);
    }
    getValueAtTime(time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        return super.getValueAtTime(computedTime);
    }
    setValueAtTime(value, time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.setValueAtTime(value, computedTime);
        return this;
    }
    linearRampToValueAtTime(value, time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.linearRampToValueAtTime(value, computedTime);
        return this;
    }
    exponentialRampToValueAtTime(value, time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.exponentialRampToValueAtTime(value, computedTime);
        return this;
    }
    setTargetAtTime(value, startTime, timeConstant) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.setTargetAtTime(value, computedTime, timeConstant);
        return this;
    }
    cancelScheduledValues(startTime) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.cancelScheduledValues(computedTime);
        return this;
    }
    setValueCurveAtTime(values, startTime, duration, scaling) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        duration = this.toSeconds(duration);
        super.setValueCurveAtTime(values, computedTime, duration, scaling);
        return this;
    }
    cancelAndHoldAtTime(time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.cancelAndHoldAtTime(computedTime);
        return this;
    }
    setRampPoint(time) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toSeconds();
        super.setRampPoint(computedTime);
        return this;
    }
    exponentialRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.exponentialRampTo(value, rampTime, computedTime);
        return this;
    }
    linearRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.linearRampTo(value, rampTime, computedTime);
        return this;
    }
    targetRampTo(value, rampTime, startTime) {
        const computedTime = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, startTime).toSeconds();
        super.targetRampTo(value, rampTime, computedTime);
        return this;
    }
    dispose() {
        super.dispose();
        this.context.transport.clear(this._synced);
        this.context.transport.off("start", this._syncedCallback);
        this.context.transport.off("pause", this._syncedCallback);
        this.context.transport.off("stop", this._syncedCallback);
        this._constantSource.dispose();
        return this;
    }
}



















class $213294b6acd7c6a9$export$4e2d65a9843399df extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($213294b6acd7c6a9$export$4e2d65a9843399df.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]);
        super(options);
        this.name = "Envelope";
        /**
         * the signal which is output.
         */ this._sig = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: 0
        });
        /**
         * The output signal of the envelope
         */ this.output = this._sig;
        /**
         * Envelope has no input
         */ this.input = undefined;
        this.attack = options.attack;
        this.decay = options.decay;
        this.sustain = options.sustain;
        this.release = options.release;
        this.attackCurve = options.attackCurve;
        this.releaseCurve = options.releaseCurve;
        this.decayCurve = options.decayCurve;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            attack: 0.01,
            attackCurve: "linear",
            decay: 0.1,
            decayCurve: "exponential",
            release: 1,
            releaseCurve: "exponential",
            sustain: 0.5
        });
    }
    /**
     * Read the current value of the envelope. Useful for
     * synchronizing visual output to the envelope.
     */ get value() {
        return this.getValueAtTime(this.now());
    }
    /**
     * Get the curve
     * @param  curve
     * @param  direction  In/Out
     * @return The curve name
     */ _getCurve(curve, direction) {
        if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(curve)) return curve;
        else {
            // look up the name in the curves array
            let curveName;
            for(curveName in $213294b6acd7c6a9$var$EnvelopeCurves){
                if ($213294b6acd7c6a9$var$EnvelopeCurves[curveName][direction] === curve) return curveName;
            }
            // return the custom curve
            return curve;
        }
    }
    /**
     * Assign a the curve to the given name using the direction
     * @param  name
     * @param  direction In/Out
     * @param  curve
     */ _setCurve(name, direction, curve) {
        // check if it's a valid type
        if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(curve) && Reflect.has($213294b6acd7c6a9$var$EnvelopeCurves, curve)) {
            const curveDef = $213294b6acd7c6a9$var$EnvelopeCurves[curve];
            if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(curveDef)) {
                if (name !== "_decayCurve") this[name] = curveDef[direction];
            } else this[name] = curveDef;
        } else if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(curve) && name !== "_decayCurve") this[name] = curve;
        else throw new Error("Envelope: invalid curve: " + curve);
    }
    /**
     * The shape of the attack.
     * Can be any of these strings:
     * * "linear"
     * * "exponential"
     * * "sine"
     * * "cosine"
     * * "bounce"
     * * "ripple"
     * * "step"
     *
     * Can also be an array which describes the curve. Values
     * in the array are evenly subdivided and linearly
     * interpolated over the duration of the attack.
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope(0.4).toDestination();
     * 	env.attackCurve = "linear";
     * 	env.triggerAttack();
     * }, 1, 1);
     */ get attackCurve() {
        return this._getCurve(this._attackCurve, "In");
    }
    set attackCurve(curve) {
        this._setCurve("_attackCurve", "In", curve);
    }
    /**
     * The shape of the release. See the attack curve types.
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope({
     * 		release: 0.8
     * 	}).toDestination();
     * 	env.triggerAttack();
     * 	// release curve could also be defined by an array
     * 	env.releaseCurve = [1, 0.3, 0.4, 0.2, 0.7, 0];
     * 	env.triggerRelease(0.2);
     * }, 1, 1);
     */ get releaseCurve() {
        return this._getCurve(this._releaseCurve, "Out");
    }
    set releaseCurve(curve) {
        this._setCurve("_releaseCurve", "Out", curve);
    }
    /**
     * The shape of the decay either "linear" or "exponential"
     * @example
     * return Tone.Offline(() => {
     * 	const env = new Tone.Envelope({
     * 		sustain: 0.1,
     * 		decay: 0.5
     * 	}).toDestination();
     * 	env.decayCurve = "linear";
     * 	env.triggerAttack();
     * }, 1, 1);
     */ get decayCurve() {
        return this._getCurve(this._decayCurve, "Out");
    }
    set decayCurve(curve) {
        this._setCurve("_decayCurve", "Out", curve);
    }
    /**
     * Trigger the attack/decay portion of the ADSR envelope.
     * @param  time When the attack should start.
     * @param velocity The velocity of the envelope scales the vales.
     *                             number between 0-1
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator().connect(env).start();
     * // trigger the attack 0.5 seconds from now with a velocity of 0.2
     * env.triggerAttack("+0.5", 0.2);
     */ triggerAttack(time, velocity = 1) {
        this.log("triggerAttack", time, velocity);
        time = this.toSeconds(time);
        const originalAttack = this.toSeconds(this.attack);
        let attack = originalAttack;
        const decay = this.toSeconds(this.decay);
        // check if it's not a complete attack
        const currentValue = this.getValueAtTime(time);
        if (currentValue > 0) {
            // subtract the current value from the attack time
            const attackRate = 1 / attack;
            const remainingDistance = 1 - currentValue;
            // the attack is now the remaining time
            attack = remainingDistance / attackRate;
        }
        // attack
        if (attack < this.sampleTime) {
            this._sig.cancelScheduledValues(time);
            // case where the attack time is 0 should set instantly
            this._sig.setValueAtTime(velocity, time);
        } else if (this._attackCurve === "linear") this._sig.linearRampTo(velocity, attack, time);
        else if (this._attackCurve === "exponential") this._sig.targetRampTo(velocity, attack, time);
        else {
            this._sig.cancelAndHoldAtTime(time);
            let curve = this._attackCurve;
            // find the starting position in the curve
            for(let i = 1; i < curve.length; i++)// the starting index is between the two values
            if (curve[i - 1] <= currentValue && currentValue <= curve[i]) {
                curve = this._attackCurve.slice(i);
                // the first index is the current value
                curve[0] = currentValue;
                break;
            }
            this._sig.setValueCurveAtTime(curve, time, attack, velocity);
        }
        // decay
        if (decay && this.sustain < 1) {
            const decayValue = velocity * this.sustain;
            const decayStart = time + attack;
            this.log("decay", decayStart);
            if (this._decayCurve === "linear") this._sig.linearRampToValueAtTime(decayValue, decay + decayStart);
            else this._sig.exponentialApproachValueAtTime(decayValue, decayStart, decay);
        }
        return this;
    }
    /**
     * Triggers the release of the envelope.
     * @param  time When the release portion of the envelope should start.
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator({
     * 	type: "sawtooth"
     * }).connect(env).start();
     * env.triggerAttack();
     * // trigger the release half a second after the attack
     * env.triggerRelease("+0.5");
     */ triggerRelease(time) {
        this.log("triggerRelease", time);
        time = this.toSeconds(time);
        const currentValue = this.getValueAtTime(time);
        if (currentValue > 0) {
            const release = this.toSeconds(this.release);
            if (release < this.sampleTime) this._sig.setValueAtTime(0, time);
            else if (this._releaseCurve === "linear") this._sig.linearRampTo(0, release, time);
            else if (this._releaseCurve === "exponential") this._sig.targetRampTo(0, release, time);
            else {
                (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(this._releaseCurve), "releaseCurve must be either 'linear', 'exponential' or an array");
                this._sig.cancelAndHoldAtTime(time);
                this._sig.setValueCurveAtTime(this._releaseCurve, time, release, currentValue);
            }
        }
        return this;
    }
    /**
     * Get the scheduled value at the given time. This will
     * return the unconverted (raw) value.
     * @example
     * const env = new Tone.Envelope(0.5, 1, 0.4, 2);
     * env.triggerAttackRelease(2);
     * setInterval(() => console.log(env.getValueAtTime(Tone.now())), 100);
     */ getValueAtTime(time) {
        return this._sig.getValueAtTime(time);
    }
    /**
     * triggerAttackRelease is shorthand for triggerAttack, then waiting
     * some duration, then triggerRelease.
     * @param duration The duration of the sustain.
     * @param time When the attack should be triggered.
     * @param velocity The velocity of the envelope.
     * @example
     * const env = new Tone.AmplitudeEnvelope().toDestination();
     * const osc = new Tone.Oscillator().connect(env).start();
     * // trigger the release 0.5 seconds after the attack
     * env.triggerAttackRelease(0.5);
     */ triggerAttackRelease(duration, time, velocity = 1) {
        time = this.toSeconds(time);
        this.triggerAttack(time, velocity);
        this.triggerRelease(time + this.toSeconds(duration));
        return this;
    }
    /**
     * Cancels all scheduled envelope changes after the given time.
     */ cancel(after) {
        this._sig.cancelScheduledValues(this.toSeconds(after));
        return this;
    }
    /**
     * Connect the envelope to a destination node.
     */ connect(destination, outputNumber = 0, inputNumber = 0) {
        (0, $87a50297d6fa5f61$export$c8174dc07173cff0)(this, destination, outputNumber, inputNumber);
        return this;
    }
    /**
     * Render the envelope curve to an array of the given length.
     * Good for visualizing the envelope curve. Rescales the duration of the
     * envelope to fit the length.
     */ asArray() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(length = 1024) {
            const duration = length / this.context.sampleRate;
            const context = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(1, duration, this.context.sampleRate);
            // normalize the ADSR for the given duration with 20% sustain time
            const attackPortion = this.toSeconds(this.attack) + this.toSeconds(this.decay);
            const envelopeDuration = attackPortion + this.toSeconds(this.release);
            const sustainTime = envelopeDuration * 0.1;
            const totalDuration = envelopeDuration + sustainTime;
            // @ts-ignore
            const clone = new this.constructor(Object.assign(this.get(), {
                attack: duration * this.toSeconds(this.attack) / totalDuration,
                decay: duration * this.toSeconds(this.decay) / totalDuration,
                release: duration * this.toSeconds(this.release) / totalDuration,
                context: context
            }));
            clone._sig.toDestination();
            clone.triggerAttackRelease(duration * (attackPortion + sustainTime) / totalDuration, 0);
            const buffer = yield context.render();
            return buffer.getChannelData(0);
        });
    }
    dispose() {
        super.dispose();
        this._sig.dispose();
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $213294b6acd7c6a9$export$4e2d65a9843399df.prototype, "attack", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $213294b6acd7c6a9$export$4e2d65a9843399df.prototype, "decay", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$d02631cccf789723)(0, 1)
], $213294b6acd7c6a9$export$4e2d65a9843399df.prototype, "sustain", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $213294b6acd7c6a9$export$4e2d65a9843399df.prototype, "release", void 0);
/**
 * Generate some complex envelope curves.
 */ const $213294b6acd7c6a9$var$EnvelopeCurves = (()=>{
    const curveLen = 128;
    let i;
    let k;
    // cosine curve
    const cosineCurve = [];
    for(i = 0; i < curveLen; i++)cosineCurve[i] = Math.sin(i / (curveLen - 1) * (Math.PI / 2));
    // ripple curve
    const rippleCurve = [];
    const rippleCurveFreq = 6.4;
    for(i = 0; i < curveLen - 1; i++){
        k = i / (curveLen - 1);
        const sineWave = Math.sin(k * (Math.PI * 2) * rippleCurveFreq - Math.PI / 2) + 1;
        rippleCurve[i] = sineWave / 10 + k * 0.83;
    }
    rippleCurve[curveLen - 1] = 1;
    // stairs curve
    const stairsCurve = [];
    const steps = 5;
    for(i = 0; i < curveLen; i++)stairsCurve[i] = Math.ceil(i / (curveLen - 1) * steps) / steps;
    // in-out easing curve
    const sineCurve = [];
    for(i = 0; i < curveLen; i++){
        k = i / (curveLen - 1);
        sineCurve[i] = 0.5 * (1 - Math.cos(Math.PI * k));
    }
    // a bounce curve
    const bounceCurve = [];
    for(i = 0; i < curveLen; i++){
        k = i / (curveLen - 1);
        const freq = Math.pow(k, 3) * 4 + 0.2;
        const val = Math.cos(freq * Math.PI * 2 * k);
        bounceCurve[i] = Math.abs(val * (1 - k));
    }
    /**
     * Invert a value curve to make it work for the release
     */ function invertCurve(curve) {
        const out = new Array(curve.length);
        for(let j = 0; j < curve.length; j++)out[j] = 1 - curve[j];
        return out;
    }
    /**
     * reverse the curve
     */ function reverseCurve(curve) {
        return curve.slice(0).reverse();
    }
    /**
     * attack and release curve arrays
     */ return {
        bounce: {
            In: invertCurve(bounceCurve),
            Out: bounceCurve
        },
        cosine: {
            In: cosineCurve,
            Out: reverseCurve(cosineCurve)
        },
        exponential: "exponential",
        linear: "linear",
        ripple: {
            In: rippleCurve,
            Out: invertCurve(rippleCurve)
        },
        sine: {
            In: sineCurve,
            Out: invertCurve(sineCurve)
        },
        step: {
            In: stairsCurve,
            Out: invertCurve(stairsCurve)
        }
    };
})();











class $604ec55036b64d8b$export$25ef33f358b07cf4 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($604ec55036b64d8b$export$25ef33f358b07cf4.getDefaults(), arguments);
        super(options);
        /**
         * Keep track of all events scheduled to the transport
         * when the instrument is 'synced'
         */ this._scheduledEvents = [];
        /**
         * If the instrument is currently synced
         */ this._synced = false;
        this._original_triggerAttack = this.triggerAttack;
        this._original_triggerRelease = this.triggerRelease;
        /**
         * The release which is scheduled to the timeline.
         */ this._syncedRelease = (time)=>this._original_triggerRelease(time);
        this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "volume");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            volume: 0
        });
    }
    /**
     * Sync the instrument to the Transport. All subsequent calls of
     * {@link triggerAttack} and {@link triggerRelease} will be scheduled along the transport.
     * @example
     * const fmSynth = new Tone.FMSynth().toDestination();
     * fmSynth.volume.value = -6;
     * fmSynth.sync();
     * // schedule 3 notes when the transport first starts
     * fmSynth.triggerAttackRelease("C4", "8n", 0);
     * fmSynth.triggerAttackRelease("E4", "8n", "8n");
     * fmSynth.triggerAttackRelease("G4", "8n", "4n");
     * // start the transport to hear the notes
     * Tone.Transport.start();
     */ sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 0);
            this.context.transport.on("stop", this._syncedRelease);
            this.context.transport.on("pause", this._syncedRelease);
            this.context.transport.on("loopEnd", this._syncedRelease);
        }
        return this;
    }
    /**
     * set _sync
     */ _syncState() {
        let changed = false;
        if (!this._synced) {
            this._synced = true;
            changed = true;
        }
        return changed;
    }
    /**
     * Wrap the given method so that it can be synchronized
     * @param method Which method to wrap and sync
     * @param  timePosition What position the time argument appears in
     */ _syncMethod(method, timePosition) {
        const originalMethod = this["_original_" + method] = this[method];
        this[method] = (...args)=>{
            const time = args[timePosition];
            const id = this.context.transport.schedule((t)=>{
                args[timePosition] = t;
                originalMethod.apply(this, args);
            }, time);
            this._scheduledEvents.push(id);
        };
    }
    /**
     * Unsync the instrument from the Transport
     */ unsync() {
        this._scheduledEvents.forEach((id)=>this.context.transport.clear(id));
        this._scheduledEvents = [];
        if (this._synced) {
            this._synced = false;
            this.triggerAttack = this._original_triggerAttack;
            this.triggerRelease = this._original_triggerRelease;
            this.context.transport.off("stop", this._syncedRelease);
            this.context.transport.off("pause", this._syncedRelease);
            this.context.transport.off("loopEnd", this._syncedRelease);
        }
        return this;
    }
    /**
     * Trigger the attack and then the release after the duration.
     * @param  note     The note to trigger.
     * @param  duration How long the note should be held for before
     *                         triggering the release. This value must be greater than 0.
     * @param time  When the note should be triggered.
     * @param  velocity The velocity the note should be triggered at.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * // trigger "C4" for the duration of an 8th note
     * synth.triggerAttackRelease("C4", "8n");
     */ triggerAttackRelease(note, duration, time, velocity) {
        const computedTime = this.toSeconds(time);
        const computedDuration = this.toSeconds(duration);
        this.triggerAttack(note, computedTime, velocity);
        this.triggerRelease(computedTime + computedDuration);
        return this;
    }
    /**
     * clean up
     * @returns {Instrument} this
     */ dispose() {
        super.dispose();
        this._volume.dispose();
        this.unsync();
        this._scheduledEvents = [];
        return this;
    }
}



class $8a6857abebb22660$export$f16a08bc2d920a12 extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8a6857abebb22660$export$f16a08bc2d920a12.getDefaults(), arguments);
        super(options);
        this.portamento = options.portamento;
        this.onsilence = options.onsilence;
    }
    static getDefaults() {
        return Object.assign((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            detune: 0,
            onsilence: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            portamento: 0
        });
    }
    /**
     * Trigger the attack of the note optionally with a given velocity.
     * @param  note The note to trigger.
     * @param  time When the note should start.
     * @param  velocity The velocity determines how "loud" the note will be.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * // trigger the note a half second from now at half velocity
     * synth.triggerAttack("C4", "+0.5", 0.5);
     */ triggerAttack(note, time, velocity = 1) {
        this.log("triggerAttack", note, time, velocity);
        const seconds = this.toSeconds(time);
        this._triggerEnvelopeAttack(seconds, velocity);
        this.setNote(note, seconds);
        return this;
    }
    /**
     * Trigger the release portion of the envelope.
     * @param  time If no time is given, the release happens immediately.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * synth.triggerAttack("C4");
     * // trigger the release a second from now
     * synth.triggerRelease("+1");
     */ triggerRelease(time) {
        this.log("triggerRelease", time);
        const seconds = this.toSeconds(time);
        this._triggerEnvelopeRelease(seconds);
        return this;
    }
    /**
     * Set the note at the given time. If no time is given, the note
     * will set immediately.
     * @param note The note to change to.
     * @param  time The time when the note should be set.
     * @example
     * const synth = new Tone.Synth().toDestination();
     * synth.triggerAttack("C4");
     * // change to F#6 in one quarter note from now.
     * synth.setNote("F#6", "+4n");
     */ setNote(note, time) {
        const computedTime = this.toSeconds(time);
        const computedFrequency = note instanceof (0, $f4d7193118bd1d27$export$38b56155c8552868) ? note.toFrequency() : note;
        if (this.portamento > 0 && this.getLevelAtTime(computedTime) > 0.05) {
            const portTime = this.toSeconds(this.portamento);
            this.frequency.exponentialRampTo(computedFrequency, portTime, computedTime);
        } else this.frequency.setValueAtTime(computedFrequency, computedTime);
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $8a6857abebb22660$export$f16a08bc2d920a12.prototype, "portamento", void 0);







class $30aa93da9543c1e0$export$e04e0eedd8192587 extends (0, $213294b6acd7c6a9$export$4e2d65a9843399df) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($30aa93da9543c1e0$export$e04e0eedd8192587.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]));
        this.name = "AmplitudeEnvelope";
        this._gainNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        this.output = this._gainNode;
        this.input = this._gainNode;
        this._sig.connect(this._gainNode.gain);
        this.output = this._gainNode;
        this.input = this._gainNode;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._gainNode.dispose();
        return this;
    }
}









class $6489a0fb869a8c37$export$8ef26ca8e8d9bf70 extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($6489a0fb869a8c37$export$8ef26ca8e8d9bf70.getDefaults(), arguments);
        super(options);
        this.name = "Synth";
        this.oscillator = new (0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d)(Object.assign({
            context: this.context,
            detune: options.detune,
            onstop: ()=>this.onsilence(this)
        }, options.oscillator));
        this.frequency = this.oscillator.frequency;
        this.detune = this.oscillator.detune;
        this.envelope = new (0, $30aa93da9543c1e0$export$e04e0eedd8192587)(Object.assign({
            context: this.context
        }, options.envelope));
        // connect the oscillators to the output
        this.oscillator.chain(this.envelope, this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "oscillator",
            "frequency",
            "detune",
            "envelope"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.005,
                decay: 0.1,
                release: 1,
                sustain: 0.3
            }),
            oscillator: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d).getDefaults(), [
                ...Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "triangle"
            })
        });
    }
    /**
     * start the attack portion of the envelope
     * @param time the time the attack should start
     * @param velocity the velocity of the note (0-1)
     */ _triggerEnvelopeAttack(time, velocity) {
        // the envelopes
        this.envelope.triggerAttack(time, velocity);
        this.oscillator.start(time);
        // if there is no release portion, stop the oscillator
        if (this.envelope.sustain === 0) {
            const computedAttack = this.toSeconds(this.envelope.attack);
            const computedDecay = this.toSeconds(this.envelope.decay);
            this.oscillator.stop(time + computedAttack + computedDecay);
        }
    }
    /**
     * start the release portion of the envelope
     * @param time the time the release should start
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this.oscillator.stop(time + this.toSeconds(this.envelope.release));
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    /**
     * clean up
     */ dispose() {
        super.dispose();
        this.oscillator.dispose();
        this.envelope.dispose();
        return this;
    }
}




class $18ec96681065c3f1$export$aee9425caad4bd7e extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($18ec96681065c3f1$export$aee9425caad4bd7e.getDefaults(), arguments);
        super(options);
        this.name = "ModulationSynth";
        this._carrier = new (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70)({
            context: this.context,
            oscillator: options.oscillator,
            envelope: options.envelope,
            onsilence: ()=>this.onsilence(this),
            volume: -10
        });
        this._modulator = new (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70)({
            context: this.context,
            oscillator: options.modulation,
            envelope: options.modulationEnvelope,
            volume: -10
        });
        this.oscillator = this._carrier.oscillator;
        this.envelope = this._carrier.envelope;
        this.modulation = this._modulator.oscillator;
        this.modulationEnvelope = this._modulator.envelope;
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency"
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.detune,
            units: "cents"
        });
        this.harmonicity = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: options.harmonicity,
            minValue: 0
        });
        this._modulationNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "harmonicity",
            "oscillator",
            "envelope",
            "modulation",
            "modulationEnvelope",
            "detune"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            harmonicity: 3,
            oscillator: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d).getDefaults(), [
                ...Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "sine"
            }),
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.01,
                decay: 0.01,
                sustain: 1,
                release: 0.5
            }),
            modulation: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d).getDefaults(), [
                ...Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults()),
                "frequency",
                "detune"
            ]), {
                type: "square"
            }),
            modulationEnvelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.5,
                decay: 0.0,
                sustain: 1,
                release: 0.5
            })
        });
    }
    /**
     * Trigger the attack portion of the note
     */ _triggerEnvelopeAttack(time, velocity) {
        // @ts-ignore
        this._carrier._triggerEnvelopeAttack(time, velocity);
        // @ts-ignore
        this._modulator._triggerEnvelopeAttack(time, velocity);
    }
    /**
     * Trigger the release portion of the note
     */ _triggerEnvelopeRelease(time) {
        // @ts-ignore
        this._carrier._triggerEnvelopeRelease(time);
        // @ts-ignore
        this._modulator._triggerEnvelopeRelease(time);
        return this;
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    dispose() {
        super.dispose();
        this._carrier.dispose();
        this._modulator.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this.harmonicity.dispose();
        this._modulationNode.dispose();
        return this;
    }
}


class $06f7187fc6b08467$export$cd421a3dd25cf75d extends (0, $18ec96681065c3f1$export$aee9425caad4bd7e) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($06f7187fc6b08467$export$cd421a3dd25cf75d.getDefaults(), arguments));
        this.name = "AMSynth";
        this._modulationScale = new (0, $69552eca520acf8e$export$2e6ea0941c39f845)({
            context: this.context
        });
        // control the two voices frequency
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.detune.fan(this._carrier.detune, this._modulator.detune);
        this._modulator.chain(this._modulationScale, this._modulationNode.gain);
        this._carrier.chain(this._modulationNode, this.output);
    }
    dispose() {
        super.dispose();
        this._modulationScale.dispose();
        return this;
    }
}
















class $94fd137bb655066f$export$26bbc35c91a15e23 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($94fd137bb655066f$export$26bbc35c91a15e23.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        super(options);
        this.name = "BiquadFilter";
        this._filter = this.context.createBiquadFilter();
        this.input = this.output = this._filter;
        this.Q = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            units: "number",
            value: options.Q,
            param: this._filter.Q
        });
        this.frequency = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            units: "frequency",
            value: options.frequency,
            param: this._filter.frequency
        });
        this.detune = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            units: "cents",
            value: options.detune,
            param: this._filter.detune
        });
        this.gain = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            units: "decibels",
            convert: false,
            value: options.gain,
            param: this._filter.gain
        });
        this.type = options.type;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            Q: 1,
            type: "lowpass",
            frequency: 350,
            detune: 0,
            gain: 0
        });
    }
    /**
     * The type of this BiquadFilterNode. For a complete list of types and their attributes, see the
     * [Web Audio API](https://webaudio.github.io/web-audio-api/#dom-biquadfiltertype-lowpass)
     */ get type() {
        return this._filter.type;
    }
    set type(type) {
        const types = [
            "lowpass",
            "highpass",
            "bandpass",
            "lowshelf",
            "highshelf",
            "notch",
            "allpass",
            "peaking"
        ];
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(types.indexOf(type) !== -1, `Invalid filter type: ${type}`);
        this._filter.type = type;
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        // start with all 1s
        const freqValues = new Float32Array(len);
        for(let i = 0; i < len; i++){
            const norm = Math.pow(i / len, 2);
            const freq = norm * 19980 + 20;
            freqValues[i] = freq;
        }
        const magValues = new Float32Array(len);
        const phaseValues = new Float32Array(len);
        // clone the filter to remove any connections which may be changing the value
        const filterClone = this.context.createBiquadFilter();
        filterClone.type = this.type;
        filterClone.Q.value = this.Q.value;
        filterClone.frequency.value = this.frequency.value;
        filterClone.gain.value = this.gain.value;
        filterClone.getFrequencyResponse(freqValues, magValues, phaseValues);
        return magValues;
    }
    dispose() {
        super.dispose();
        this._filter.disconnect();
        this.Q.dispose();
        this.frequency.dispose();
        this.gain.dispose();
        this.detune.dispose();
        return this;
    }
}


class $a487e4b525eb8039$export$ec91da630f36d5ea extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a487e4b525eb8039$export$ec91da630f36d5ea.getDefaults(), arguments, [
            "frequency",
            "type",
            "rolloff"
        ]);
        super(options);
        this.name = "Filter";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._filters = [];
        this._filters = [];
        this.Q = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "positive",
            value: options.Q
        });
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this.gain = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "decibels",
            convert: false,
            value: options.gain
        });
        this._type = options.type;
        this.rolloff = options.rolloff;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "detune",
            "frequency",
            "gain",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            Q: 1,
            detune: 0,
            frequency: 350,
            gain: 0,
            rolloff: -12,
            type: "lowpass"
        });
    }
    /**
     * The type of the filter. Types: "lowpass", "highpass",
     * "bandpass", "lowshelf", "highshelf", "notch", "allpass", or "peaking".
     */ get type() {
        return this._type;
    }
    set type(type) {
        const types = [
            "lowpass",
            "highpass",
            "bandpass",
            "lowshelf",
            "highshelf",
            "notch",
            "allpass",
            "peaking"
        ];
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(types.indexOf(type) !== -1, `Invalid filter type: ${type}`);
        this._type = type;
        this._filters.forEach((filter)=>filter.type = type);
    }
    /**
     * The rolloff of the filter which is the drop in db
     * per octave. Implemented internally by cascading filters.
     * Only accepts the values -12, -24, -48 and -96.
     */ get rolloff() {
        return this._rolloff;
    }
    set rolloff(rolloff) {
        const rolloffNum = (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(rolloff) ? rolloff : parseInt(rolloff, 10);
        const possibilities = [
            -12,
            -24,
            -48,
            -96
        ];
        let cascadingCount = possibilities.indexOf(rolloffNum);
        // check the rolloff is valid
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(cascadingCount !== -1, `rolloff can only be ${possibilities.join(", ")}`);
        cascadingCount += 1;
        this._rolloff = rolloffNum;
        this.input.disconnect();
        this._filters.forEach((filter)=>filter.disconnect());
        this._filters = new Array(cascadingCount);
        for(let count = 0; count < cascadingCount; count++){
            const filter = new (0, $94fd137bb655066f$export$26bbc35c91a15e23)({
                context: this.context
            });
            filter.type = this._type;
            this.frequency.connect(filter.frequency);
            this.detune.connect(filter.detune);
            this.Q.connect(filter.Q);
            this.gain.connect(filter.gain);
            this._filters[count] = filter;
        }
        this._internalChannels = this._filters;
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, ...this._internalChannels, this.output);
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        const filterClone = new (0, $94fd137bb655066f$export$26bbc35c91a15e23)({
            frequency: this.frequency.value,
            gain: this.gain.value,
            Q: this.Q.value,
            type: this._type,
            detune: this.detune.value
        });
        // start with all 1s
        const totalResponse = new Float32Array(len).map(()=>1);
        this._filters.forEach(()=>{
            const response = filterClone.getFrequencyResponse(len);
            response.forEach((val, i)=>totalResponse[i] *= val);
        });
        filterClone.dispose();
        return totalResponse;
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._filters.forEach((filter)=>{
            filter.dispose();
        });
        (0, $8cce0c9e2019bc8a$export$e6d3eada50a007b1)(this, [
            "detune",
            "frequency",
            "gain",
            "Q"
        ]);
        this.frequency.dispose();
        this.Q.dispose();
        this.detune.dispose();
        this.gain.dispose();
        return this;
    }
}












class $579c7c7246f4d95f$export$46ffd25e6533b005 extends (0, $213294b6acd7c6a9$export$4e2d65a9843399df) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($579c7c7246f4d95f$export$46ffd25e6533b005.getDefaults(), arguments, [
            "attack",
            "decay",
            "sustain",
            "release"
        ]);
        super(options);
        this.name = "FrequencyEnvelope";
        this._octaves = options.octaves;
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._exponent = this.input = new (0, $4603e249f478b841$export$ce28d653ec559ee)({
            context: this.context,
            value: options.exponent
        });
        this._scale = this.output = new (0, $d4646d969ab22afc$export$d60cfc58d3c358b6)({
            context: this.context,
            min: this._baseFrequency,
            max: this._baseFrequency * Math.pow(2, this._octaves)
        });
        this._sig.chain(this._exponent, this._scale);
    }
    static getDefaults() {
        return Object.assign((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), {
            baseFrequency: 200,
            exponent: 1,
            octaves: 4
        });
    }
    /**
     * The envelope's minimum output value. This is the value which it
     * starts at.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(min) {
        const freq = this.toFrequency(min);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(freq, 0);
        this._baseFrequency = freq;
        this._scale.min = this._baseFrequency;
        // update the max value when the min changes
        this.octaves = this._octaves;
    }
    /**
     * The number of octaves above the baseFrequency that the
     * envelope will scale to.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        this._scale.max = this._baseFrequency * Math.pow(2, octaves);
    }
    /**
     * The envelope's exponent value.
     */ get exponent() {
        return this._exponent.value;
    }
    set exponent(exponent) {
        this._exponent.value = exponent;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._exponent.dispose();
        this._scale.dispose();
        return this;
    }
}



class $e9a7ff7284664907$export$319ecdcd955e80a7 extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e9a7ff7284664907$export$319ecdcd955e80a7.getDefaults(), arguments);
        super(options);
        this.name = "MonoSynth";
        this.oscillator = new (0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d)(Object.assign(options.oscillator, {
            context: this.context,
            detune: options.detune,
            onstop: ()=>this.onsilence(this)
        }));
        this.frequency = this.oscillator.frequency;
        this.detune = this.oscillator.detune;
        this.filter = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)(Object.assign(options.filter, {
            context: this.context
        }));
        this.filterEnvelope = new (0, $579c7c7246f4d95f$export$46ffd25e6533b005)(Object.assign(options.filterEnvelope, {
            context: this.context
        }));
        this.envelope = new (0, $30aa93da9543c1e0$export$e04e0eedd8192587)(Object.assign(options.envelope, {
            context: this.context
        }));
        // connect the oscillators to the output
        this.oscillator.chain(this.filter, this.envelope, this.output);
        // connect the filter envelope
        this.filterEnvelope.connect(this.filter.frequency);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "oscillator",
            "frequency",
            "detune",
            "filter",
            "filterEnvelope",
            "envelope"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.005,
                decay: 0.1,
                release: 1,
                sustain: 0.9
            }),
            filter: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $a487e4b525eb8039$export$ec91da630f36d5ea).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                Q: 1,
                rolloff: -12,
                type: "lowpass"
            }),
            filterEnvelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $579c7c7246f4d95f$export$46ffd25e6533b005).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.6,
                baseFrequency: 200,
                decay: 0.2,
                exponent: 2,
                octaves: 3,
                release: 2,
                sustain: 0.5
            }),
            oscillator: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $7fd076cd12a174f2$export$46c9f562e6d6ca6d).getDefaults(), Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults())), {
                type: "sawtooth"
            })
        });
    }
    /**
     * start the attack portion of the envelope
     * @param time the time the attack should start
     * @param velocity the velocity of the note (0-1)
     */ _triggerEnvelopeAttack(time, velocity = 1) {
        this.envelope.triggerAttack(time, velocity);
        this.filterEnvelope.triggerAttack(time);
        this.oscillator.start(time);
        if (this.envelope.sustain === 0) {
            const computedAttack = this.toSeconds(this.envelope.attack);
            const computedDecay = this.toSeconds(this.envelope.decay);
            this.oscillator.stop(time + computedAttack + computedDecay);
        }
    }
    /**
     * start the release portion of the envelope
     * @param time the time the release should start
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this.filterEnvelope.triggerRelease(time);
        this.oscillator.stop(time + this.toSeconds(this.envelope.release));
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    dispose() {
        super.dispose();
        this.oscillator.dispose();
        this.envelope.dispose();
        this.filterEnvelope.dispose();
        this.filter.dispose();
        return this;
    }
}








class $4128ede587292e91$export$374aff340bb3ea08 extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4128ede587292e91$export$374aff340bb3ea08.getDefaults(), arguments);
        super(options);
        this.name = "DuoSynth";
        this.voice0 = new (0, $e9a7ff7284664907$export$319ecdcd955e80a7)(Object.assign(options.voice0, {
            context: this.context,
            onsilence: ()=>this.onsilence(this)
        }));
        this.voice1 = new (0, $e9a7ff7284664907$export$319ecdcd955e80a7)(Object.assign(options.voice1, {
            context: this.context
        }));
        this.harmonicity = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            units: "positive",
            value: options.harmonicity
        });
        this._vibrato = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            frequency: options.vibratoRate,
            context: this.context,
            min: -50,
            max: 50
        });
        // start the vibrato immediately
        this._vibrato.start();
        this.vibratoRate = this._vibrato.frequency;
        this._vibratoGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            units: "normalRange",
            gain: options.vibratoAmount
        });
        this.vibratoAmount = this._vibratoGain.gain;
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: 440
        });
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        // control the two voices frequency
        this.frequency.connect(this.voice0.frequency);
        this.frequency.chain(this.harmonicity, this.voice1.frequency);
        this._vibrato.connect(this._vibratoGain);
        this._vibratoGain.fan(this.voice0.detune, this.voice1.detune);
        this.detune.fan(this.voice0.detune, this.voice1.detune);
        this.voice0.connect(this.output);
        this.voice1.connect(this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "voice0",
            "voice1",
            "frequency",
            "vibratoAmount",
            "vibratoRate"
        ]);
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.voice0.envelope.getValueAtTime(time) + this.voice1.envelope.getValueAtTime(time);
    }
    static getDefaults() {
        return (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            vibratoAmount: 0.5,
            vibratoRate: 5,
            harmonicity: 1.5,
            voice0: (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $e9a7ff7284664907$export$319ecdcd955e80a7).getDefaults(), Object.keys((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults())), {
                filterEnvelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                },
                envelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                }
            }),
            voice1: (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $e9a7ff7284664907$export$319ecdcd955e80a7).getDefaults(), Object.keys((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults())), {
                filterEnvelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                },
                envelope: {
                    attack: 0.01,
                    decay: 0.0,
                    sustain: 1,
                    release: 0.5
                }
            })
        });
    }
    /**
     * Trigger the attack portion of the note
     */ _triggerEnvelopeAttack(time, velocity) {
        // @ts-ignore
        this.voice0._triggerEnvelopeAttack(time, velocity);
        // @ts-ignore
        this.voice1._triggerEnvelopeAttack(time, velocity);
    }
    /**
     * Trigger the release portion of the note
     */ _triggerEnvelopeRelease(time) {
        // @ts-ignore
        this.voice0._triggerEnvelopeRelease(time);
        // @ts-ignore
        this.voice1._triggerEnvelopeRelease(time);
        return this;
    }
    dispose() {
        super.dispose();
        this.voice0.dispose();
        this.voice1.dispose();
        this.frequency.dispose();
        this.detune.dispose();
        this._vibrato.dispose();
        this.vibratoRate.dispose();
        this._vibratoGain.dispose();
        this.harmonicity.dispose();
        return this;
    }
}





class $f30c7049d881fb2b$export$45372df7fab1f04e extends (0, $18ec96681065c3f1$export$aee9425caad4bd7e) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f30c7049d881fb2b$export$45372df7fab1f04e.getDefaults(), arguments);
        super(options);
        this.name = "FMSynth";
        this.modulationIndex = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: options.modulationIndex
        });
        // control the two voices frequency
        this.frequency.connect(this._carrier.frequency);
        this.frequency.chain(this.harmonicity, this._modulator.frequency);
        this.frequency.chain(this.modulationIndex, this._modulationNode);
        this.detune.fan(this._carrier.detune, this._modulator.detune);
        this._modulator.connect(this._modulationNode.gain);
        this._modulationNode.connect(this._carrier.frequency);
        this._carrier.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $18ec96681065c3f1$export$aee9425caad4bd7e).getDefaults(), {
            modulationIndex: 10
        });
    }
    dispose() {
        super.dispose();
        this.modulationIndex.dispose();
        return this;
    }
}













/**
 * Inharmonic ratio of frequencies based on the Roland TR-808
 * Taken from https://ccrma.stanford.edu/papers/tr-808-cymbal-physically-informed-circuit-bendable-digital-model
 */ const $5f95d88511c29e38$var$inharmRatios = [
    1.0,
    1.483,
    1.932,
    2.546,
    2.63,
    3.897
];
class $5f95d88511c29e38$export$65cb3eae8bee686d extends (0, $8a6857abebb22660$export$f16a08bc2d920a12) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5f95d88511c29e38$export$65cb3eae8bee686d.getDefaults(), arguments);
        super(options);
        this.name = "MetalSynth";
        /**
         * The array of FMOscillators
         */ this._oscillators = [];
        /**
         * The frequency multipliers
         */ this._freqMultipliers = [];
        this.detune = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "cents",
            value: options.detune
        });
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency"
        });
        this._amplitude = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        }).connect(this.output);
        this._highpass = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            // Q: -3.0102999566398125,
            Q: 0,
            context: this.context,
            type: "highpass"
        }).connect(this._amplitude);
        for(let i = 0; i < $5f95d88511c29e38$var$inharmRatios.length; i++){
            const osc = new (0, $87e8e716b583ad3c$export$3055866937a7451d)({
                context: this.context,
                harmonicity: options.harmonicity,
                modulationIndex: options.modulationIndex,
                modulationType: "square",
                onstop: i === 0 ? ()=>this.onsilence(this) : (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
                type: "square"
            });
            osc.connect(this._highpass);
            this._oscillators[i] = osc;
            const mult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
                context: this.context,
                value: $5f95d88511c29e38$var$inharmRatios[i]
            });
            this._freqMultipliers[i] = mult;
            this.frequency.chain(mult, osc.frequency);
            this.detune.connect(osc.detune);
        }
        this._filterFreqScaler = new (0, $d4646d969ab22afc$export$d60cfc58d3c358b6)({
            context: this.context,
            max: 7000,
            min: this.toFrequency(options.resonance)
        });
        this.envelope = new (0, $213294b6acd7c6a9$export$4e2d65a9843399df)({
            attack: options.envelope.attack,
            attackCurve: "linear",
            context: this.context,
            decay: options.envelope.decay,
            release: options.envelope.release,
            sustain: 0
        });
        this.envelope.chain(this._filterFreqScaler, this._highpass.frequency);
        this.envelope.connect(this._amplitude.gain);
        // set the octaves
        this._octaves = options.octaves;
        this.octaves = options.octaves;
    }
    static getDefaults() {
        return (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), {
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                attack: 0.001,
                decay: 1.4,
                release: 0.2
            }),
            harmonicity: 5.1,
            modulationIndex: 32,
            octaves: 1.5,
            resonance: 4000
        });
    }
    /**
     * Trigger the attack.
     * @param time When the attack should be triggered.
     * @param velocity The velocity that the envelope should be triggered at.
     */ _triggerEnvelopeAttack(time, velocity = 1) {
        this.envelope.triggerAttack(time, velocity);
        this._oscillators.forEach((osc)=>osc.start(time));
        if (this.envelope.sustain === 0) this._oscillators.forEach((osc)=>{
            osc.stop(time + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay));
        });
        return this;
    }
    /**
     * Trigger the release of the envelope.
     * @param time When the release should be triggered.
     */ _triggerEnvelopeRelease(time) {
        this.envelope.triggerRelease(time);
        this._oscillators.forEach((osc)=>osc.stop(time + this.toSeconds(this.envelope.release)));
        return this;
    }
    getLevelAtTime(time) {
        time = this.toSeconds(time);
        return this.envelope.getValueAtTime(time);
    }
    /**
     * The modulationIndex of the oscillators which make up the source.
     * see {@link FMOscillator.modulationIndex}
     * @min 1
     * @max 100
     */ get modulationIndex() {
        return this._oscillators[0].modulationIndex.value;
    }
    set modulationIndex(val) {
        this._oscillators.forEach((osc)=>osc.modulationIndex.value = val);
    }
    /**
     * The harmonicity of the oscillators which make up the source.
     * see Tone.FMOscillator.harmonicity
     * @min 0.1
     * @max 10
     */ get harmonicity() {
        return this._oscillators[0].harmonicity.value;
    }
    set harmonicity(val) {
        this._oscillators.forEach((osc)=>osc.harmonicity.value = val);
    }
    /**
     * The lower level of the highpass filter which is attached to the envelope.
     * This value should be between [0, 7000]
     * @min 0
     * @max 7000
     */ get resonance() {
        return this._filterFreqScaler.min;
    }
    set resonance(val) {
        this._filterFreqScaler.min = this.toFrequency(val);
        this.octaves = this._octaves;
    }
    /**
     * The number of octaves above the "resonance" frequency
     * that the filter ramps during the attack/decay envelope
     * @min 0
     * @max 8
     */ get octaves() {
        return this._octaves;
    }
    set octaves(val) {
        this._octaves = val;
        this._filterFreqScaler.max = this._filterFreqScaler.min * Math.pow(2, val);
    }
    dispose() {
        super.dispose();
        this._oscillators.forEach((osc)=>osc.dispose());
        this._freqMultipliers.forEach((freqMult)=>freqMult.dispose());
        this.frequency.dispose();
        this.detune.dispose();
        this._filterFreqScaler.dispose();
        this._amplitude.dispose();
        this.envelope.dispose();
        this._highpass.dispose();
        return this;
    }
}









class $faf53c8844563a8e$export$e4f4b32b2e74f0e2 extends (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faf53c8844563a8e$export$e4f4b32b2e74f0e2.getDefaults(), arguments);
        super(options);
        this.name = "MembraneSynth";
        /**
         * Portamento is ignored in this synth. use pitch decay instead.
         */ this.portamento = 0;
        this.pitchDecay = options.pitchDecay;
        this.octaves = options.octaves;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "oscillator",
            "envelope"
        ]);
    }
    static getDefaults() {
        return (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $8a6857abebb22660$export$f16a08bc2d920a12).getDefaults(), (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70).getDefaults(), {
            envelope: {
                attack: 0.001,
                attackCurve: "exponential",
                decay: 0.4,
                release: 1.4,
                sustain: 0.01
            },
            octaves: 10,
            oscillator: {
                type: "sine"
            },
            pitchDecay: 0.05
        });
    }
    setNote(note, time) {
        const seconds = this.toSeconds(time);
        const hertz = this.toFrequency(note instanceof (0, $f4d7193118bd1d27$export$38b56155c8552868) ? note.toFrequency() : note);
        const maxNote = hertz * this.octaves;
        this.oscillator.frequency.setValueAtTime(maxNote, seconds);
        this.oscillator.frequency.exponentialRampToValueAtTime(hertz, seconds + this.toSeconds(this.pitchDecay));
        return this;
    }
    dispose() {
        super.dispose();
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$d02631cccf789723)(0)
], $faf53c8844563a8e$export$e4f4b32b2e74f0e2.prototype, "octaves", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $faf53c8844563a8e$export$e4f4b32b2e74f0e2.prototype, "pitchDecay", void 0);










class $8d503f33efd2345b$export$a0d6f4d32fd5959 extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8d503f33efd2345b$export$a0d6f4d32fd5959.getDefaults(), arguments);
        super(options);
        this.name = "NoiseSynth";
        this.noise = new (0, $93a0a7e8f19a773f$export$484d33a0500a4ce1)(Object.assign({
            context: this.context
        }, options.noise));
        this.envelope = new (0, $30aa93da9543c1e0$export$e04e0eedd8192587)(Object.assign({
            context: this.context
        }, options.envelope));
        // connect the noise to the output
        this.noise.chain(this.envelope, this.output);
    }
    static getDefaults() {
        return Object.assign((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            envelope: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $213294b6acd7c6a9$export$4e2d65a9843399df).getDefaults(), Object.keys((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults())), {
                decay: 0.1,
                sustain: 0.0
            }),
            noise: Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $93a0a7e8f19a773f$export$484d33a0500a4ce1).getDefaults(), Object.keys((0, $1a3cf1f57a33a53f$export$1d2df86270c81ecb).getDefaults())), {
                type: "white"
            })
        });
    }
    /**
     * Start the attack portion of the envelopes. Unlike other
     * instruments, Tone.NoiseSynth doesn't have a note.
     * @example
     * const noiseSynth = new Tone.NoiseSynth().toDestination();
     * noiseSynth.triggerAttack();
     */ triggerAttack(time, velocity = 1) {
        time = this.toSeconds(time);
        // the envelopes
        this.envelope.triggerAttack(time, velocity);
        // start the noise
        this.noise.start(time);
        if (this.envelope.sustain === 0) this.noise.stop(time + this.toSeconds(this.envelope.attack) + this.toSeconds(this.envelope.decay));
        return this;
    }
    /**
     * Start the release portion of the envelopes.
     */ triggerRelease(time) {
        time = this.toSeconds(time);
        this.envelope.triggerRelease(time);
        this.noise.stop(time + this.toSeconds(this.envelope.release));
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 0);
            this._syncMethod("triggerRelease", 0);
        }
        return this;
    }
    /**
     * Trigger the attack and then the release after the duration.
     * @param duration The amount of time to hold the note for
     * @param time The time the note should start
     * @param velocity The volume of the note (0-1)
     * @example
     * const noiseSynth = new Tone.NoiseSynth().toDestination();
     * // hold the note for 0.5 seconds
     * noiseSynth.triggerAttackRelease(0.5);
     */ triggerAttackRelease(duration, time, velocity = 1) {
        time = this.toSeconds(time);
        duration = this.toSeconds(duration);
        this.triggerAttack(time, velocity);
        this.triggerRelease(time + duration);
        return this;
    }
    dispose() {
        super.dispose();
        this.noise.dispose();
        this.envelope.dispose();
        return this;
    }
}











/**
 * All of the classes or functions which are loaded into the AudioWorkletGlobalScope
 */ const $084f2c4e06bfb0e6$var$workletContext = new Set();
function $084f2c4e06bfb0e6$export$4332289150d1c155(classOrFunction) {
    $084f2c4e06bfb0e6$var$workletContext.add(classOrFunction);
}
function $084f2c4e06bfb0e6$export$d575e6557ac1729f(name, classDesc) {
    const processor = /* javascript */ `registerProcessor("${name}", ${classDesc})`;
    $084f2c4e06bfb0e6$var$workletContext.add(processor);
}
function $084f2c4e06bfb0e6$export$b2ba7b9987bb8e81() {
    return Array.from($084f2c4e06bfb0e6$var$workletContext).join("\n");
}


class $ab96f0673d65b5e9$export$212d912bd0512eff extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        this.name = "ToneAudioWorklet";
        /**
         * The constructor options for the node
         */ this.workletOptions = {};
        /**
         * Callback which is invoked when there is an error in the processing
         */ this.onprocessorerror = (0, $8cce0c9e2019bc8a$export$b50b6e108474309b);
        const blobUrl = URL.createObjectURL(new Blob([
            (0, $084f2c4e06bfb0e6$export$b2ba7b9987bb8e81)()
        ], {
            type: "text/javascript"
        }));
        const name = this._audioWorkletName();
        this._dummyGain = this.context.createGain();
        this._dummyParam = this._dummyGain.gain;
        // Register the processor
        this.context.addAudioWorkletModule(blobUrl).then(()=>{
            // create the worklet when it's read
            if (!this.disposed) {
                this._worklet = this.context.createAudioWorkletNode(name, this.workletOptions);
                this._worklet.onprocessorerror = this.onprocessorerror.bind(this);
                this.onReady(this._worklet);
            }
        });
    }
    dispose() {
        super.dispose();
        this._dummyGain.disconnect();
        if (this._worklet) {
            this._worklet.port.postMessage("dispose");
            this._worklet.disconnect();
        }
        return this;
    }
}



const $e1d40bd789b6f49f$var$toneAudioWorkletProcessor = /* javascript */ `
	/**
	 * The base AudioWorkletProcessor for use in Tone.js. Works with the {@link ToneAudioWorklet}. 
	 */
	class ToneAudioWorkletProcessor extends AudioWorkletProcessor {

		constructor(options) {
			
			super(options);
			/**
			 * If the processor was disposed or not. Keep alive until it's disposed.
			 */
			this.disposed = false;
		   	/** 
			 * The number of samples in the processing block
			 */
			this.blockSize = 128;
			/**
			 * the sample rate
			 */
			this.sampleRate = sampleRate;

			this.port.onmessage = (event) => {
				// when it receives a dispose 
				if (event.data === "dispose") {
					this.disposed = true;
				}
			};
		}
	}
`;
(0, $084f2c4e06bfb0e6$export$4332289150d1c155)($e1d40bd789b6f49f$var$toneAudioWorkletProcessor);



const $bc3c048ac4b8ecdc$export$3821b1427992e4a0 = /* javascript */ `
	/**
	 * Abstract class for a single input/output processor. 
	 * has a 'generate' function which processes one sample at a time
	 */
	class SingleIOProcessor extends ToneAudioWorkletProcessor {

		constructor(options) {
			super(Object.assign(options, {
				numberOfInputs: 1,
				numberOfOutputs: 1
			}));
			/**
			 * Holds the name of the parameter and a single value of that
			 * parameter at the current sample
			 * @type { [name: string]: number }
			 */
			this.params = {}
		}

		/**
		 * Generate an output sample from the input sample and parameters
		 * @abstract
		 * @param input number
		 * @param channel number
		 * @param parameters { [name: string]: number }
		 * @returns number
		 */
		generate(){}

		/**
		 * Update the private params object with the 
		 * values of the parameters at the given index
		 * @param parameters { [name: string]: Float32Array },
		 * @param index number
		 */
		updateParams(parameters, index) {
			for (const paramName in parameters) {
				const param = parameters[paramName];
				if (param.length > 1) {
					this.params[paramName] = parameters[paramName][index];
				} else {
					this.params[paramName] = parameters[paramName][0];
				}
			}
		}

		/**
		 * Process a single frame of the audio
		 * @param inputs Float32Array[][]
		 * @param outputs Float32Array[][]
		 */
		process(inputs, outputs, parameters) {
			const input = inputs[0];
			const output = outputs[0];
			// get the parameter values
			const channelCount = Math.max(input && input.length || 0, output.length);
			for (let sample = 0; sample < this.blockSize; sample++) {
				this.updateParams(parameters, sample);
				for (let channel = 0; channel < channelCount; channel++) {
					const inputSample = input && input.length ? input[channel][sample] : 0;
					output[channel][sample] = this.generate(inputSample, channel, this.params);
				}
			}
			return !this.disposed;
		}
	};
`;
(0, $084f2c4e06bfb0e6$export$4332289150d1c155)($bc3c048ac4b8ecdc$export$3821b1427992e4a0);



const $70e2730250c9764e$var$delayLine = /* javascript */ `
	/**
	 * A multichannel buffer for use within an AudioWorkletProcessor as a delay line
	 */
	class DelayLine {
		
		constructor(size, channels) {
			this.buffer = [];
			this.writeHead = []
			this.size = size;

			// create the empty channels
			for (let i = 0; i < channels; i++) {
				this.buffer[i] = new Float32Array(this.size);
				this.writeHead[i] = 0;
			}
		}

		/**
		 * Push a value onto the end
		 * @param channel number
		 * @param value number
		 */
		push(channel, value) {
			this.writeHead[channel] += 1;
			if (this.writeHead[channel] > this.size) {
				this.writeHead[channel] = 0;
			}
			this.buffer[channel][this.writeHead[channel]] = value;
		}

		/**
		 * Get the recorded value of the channel given the delay
		 * @param channel number
		 * @param delay number delay samples
		 */
		get(channel, delay) {
			let readHead = this.writeHead[channel] - Math.floor(delay);
			if (readHead < 0) {
				readHead += this.size;
			}
			return this.buffer[channel][readHead];
		}
	}
`;
(0, $084f2c4e06bfb0e6$export$4332289150d1c155)($70e2730250c9764e$var$delayLine);



const $ad03077e589cae9c$export$85343ada6050a795 = "feedback-comb-filter";
const $ad03077e589cae9c$var$feedbackCombFilter = /* javascript */ `
	class FeedbackCombFilterWorklet extends SingleIOProcessor {

		constructor(options) {
			super(options);
			this.delayLine = new DelayLine(this.sampleRate, options.channelCount || 2);
		}

		static get parameterDescriptors() {
			return [{
				name: "delayTime",
				defaultValue: 0.1,
				minValue: 0,
				maxValue: 1,
				automationRate: "k-rate"
			}, {
				name: "feedback",
				defaultValue: 0.5,
				minValue: 0,
				maxValue: 0.9999,
				automationRate: "k-rate"
			}];
		}

		generate(input, channel, parameters) {
			const delayedSample = this.delayLine.get(channel, parameters.delayTime * this.sampleRate);
			this.delayLine.push(channel, input + delayedSample * parameters.feedback);
			return delayedSample;
		}
	}
`;
(0, $084f2c4e06bfb0e6$export$d575e6557ac1729f)($ad03077e589cae9c$export$85343ada6050a795, $ad03077e589cae9c$var$feedbackCombFilter);


class $39e0d797402e4e21$export$e7a685a7e8ffb78a extends (0, $ab96f0673d65b5e9$export$212d912bd0512eff) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($39e0d797402e4e21$export$e7a685a7e8ffb78a.getDefaults(), arguments, [
            "delayTime",
            "resonance"
        ]);
        super(options);
        this.name = "FeedbackCombFilter";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.delayTime = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            value: options.delayTime,
            units: "time",
            minValue: 0,
            maxValue: 1,
            param: this._dummyParam,
            swappable: true
        });
        this.resonance = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            value: options.resonance,
            units: "normalRange",
            param: this._dummyParam,
            swappable: true
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "resonance",
            "delayTime"
        ]);
    }
    _audioWorkletName() {
        return 0, $ad03077e589cae9c$export$85343ada6050a795;
    }
    /**
     * The default parameters
     */ static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            delayTime: 0.1,
            resonance: 0.5
        });
    }
    onReady(node) {
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, node, this.output);
        const delayTime = node.parameters.get("delayTime");
        this.delayTime.setParam(delayTime);
        const feedback = node.parameters.get("feedback");
        this.resonance.setParam(feedback);
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.delayTime.dispose();
        this.resonance.dispose();
        return this;
    }
}





class $e96b9b836f8a5fb5$export$7961b18021b7c8c9 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e96b9b836f8a5fb5$export$7961b18021b7c8c9.getDefaults(), arguments, [
            "frequency",
            "type"
        ]);
        super(options);
        this.name = "OnePoleFilter";
        this._frequency = options.frequency;
        this._type = options.type;
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._createFilter();
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            frequency: 880,
            type: "lowpass"
        });
    }
    /**
     * Create a filter and dispose the old one
     */ _createFilter() {
        const oldFilter = this._filter;
        const freq = this.toFrequency(this._frequency);
        const t = 1 / (2 * Math.PI * freq);
        if (this._type === "lowpass") {
            const a0 = 1 / (t * this.context.sampleRate);
            const b1 = a0 - 1;
            this._filter = this.context.createIIRFilter([
                a0,
                0
            ], [
                1,
                b1
            ]);
        } else {
            const b1 = 1 / (t * this.context.sampleRate) - 1;
            this._filter = this.context.createIIRFilter([
                1,
                -1
            ], [
                1,
                b1
            ]);
        }
        this.input.chain(this._filter, this.output);
        if (oldFilter) // dispose it on the next block
        this.context.setTimeout(()=>{
            if (!this.disposed) {
                this.input.disconnect(oldFilter);
                oldFilter.disconnect();
            }
        }, this.blockTime);
    }
    /**
     * The frequency value.
     */ get frequency() {
        return this._frequency;
    }
    set frequency(fq) {
        this._frequency = fq;
        this._createFilter();
    }
    /**
     * The OnePole Filter type, either "highpass" or "lowpass"
     */ get type() {
        return this._type;
    }
    set type(t) {
        this._type = t;
        this._createFilter();
    }
    /**
     * Get the frequency response curve. This curve represents how the filter
     * responses to frequencies between 20hz-20khz.
     * @param  len The number of values to return
     * @return The frequency response curve between 20-20kHz
     */ getFrequencyResponse(len = 128) {
        const freqValues = new Float32Array(len);
        for(let i = 0; i < len; i++){
            const norm = Math.pow(i / len, 2);
            const freq = norm * 19980 + 20;
            freqValues[i] = freq;
        }
        const magValues = new Float32Array(len);
        const phaseValues = new Float32Array(len);
        this._filter.getFrequencyResponse(freqValues, magValues, phaseValues);
        return magValues;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this._filter.disconnect();
        return this;
    }
}


class $ef6d05ab4f866c0f$export$e83d2527589f5587 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($ef6d05ab4f866c0f$export$e83d2527589f5587.getDefaults(), arguments, [
            "delayTime",
            "resonance",
            "dampening"
        ]);
        super(options);
        this.name = "LowpassCombFilter";
        this._combFilter = this.output = new (0, $39e0d797402e4e21$export$e7a685a7e8ffb78a)({
            context: this.context,
            delayTime: options.delayTime,
            resonance: options.resonance
        });
        this.delayTime = this._combFilter.delayTime;
        this.resonance = this._combFilter.resonance;
        this._lowpass = this.input = new (0, $e96b9b836f8a5fb5$export$7961b18021b7c8c9)({
            context: this.context,
            frequency: options.dampening,
            type: "lowpass"
        });
        // connections
        this._lowpass.connect(this._combFilter);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            dampening: 3000,
            delayTime: 0.1,
            resonance: 0.5
        });
    }
    /**
     * The dampening control of the feedback
     */ get dampening() {
        return this._lowpass.frequency;
    }
    set dampening(fq) {
        this._lowpass.frequency = fq;
    }
    dispose() {
        super.dispose();
        this._combFilter.dispose();
        this._lowpass.dispose();
        return this;
    }
}





class $0a4da90f1cd712fc$export$8334f51ae3f4c97e extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0a4da90f1cd712fc$export$8334f51ae3f4c97e.getDefaults(), arguments);
        super(options);
        this.name = "PluckSynth";
        this._noise = new (0, $93a0a7e8f19a773f$export$484d33a0500a4ce1)({
            context: this.context,
            type: "pink"
        });
        this.attackNoise = options.attackNoise;
        this._lfcf = new (0, $ef6d05ab4f866c0f$export$e83d2527589f5587)({
            context: this.context,
            dampening: options.dampening,
            resonance: options.resonance
        });
        this.resonance = options.resonance;
        this.release = options.release;
        this._noise.connect(this._lfcf);
        this._lfcf.connect(this.output);
    }
    static getDefaults() {
        return (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            attackNoise: 1,
            dampening: 4000,
            resonance: 0.7,
            release: 1
        });
    }
    /**
     * The dampening control. i.e. the lowpass filter frequency of the comb filter
     * @min 0
     * @max 7000
     */ get dampening() {
        return this._lfcf.dampening;
    }
    set dampening(fq) {
        this._lfcf.dampening = fq;
    }
    triggerAttack(note, time) {
        const freq = this.toFrequency(note);
        time = this.toSeconds(time);
        const delayAmount = 1 / freq;
        this._lfcf.delayTime.setValueAtTime(delayAmount, time);
        this._noise.start(time);
        this._noise.stop(time + delayAmount * this.attackNoise);
        this._lfcf.resonance.cancelScheduledValues(time);
        this._lfcf.resonance.setValueAtTime(this.resonance, time);
        return this;
    }
    /**
     * Ramp down the {@link resonance} to 0 over the duration of the release time.
     */ triggerRelease(time) {
        this._lfcf.resonance.linearRampTo(0, this.release, time);
        return this;
    }
    dispose() {
        super.dispose();
        this._noise.dispose();
        this._lfcf.dispose();
        return this;
    }
}









class $85ae9a076515912b$export$a7e98a317490a78b extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($85ae9a076515912b$export$a7e98a317490a78b.getDefaults(), arguments, [
            "voice",
            "options"
        ]);
        super(options);
        this.name = "PolySynth";
        /**
         * The voices which are not currently in use
         */ this._availableVoices = [];
        /**
         * The currently active voices
         */ this._activeVoices = [];
        /**
         * All of the allocated voices for this synth.
         */ this._voices = [];
        /**
         * The GC timeout. Held so that it could be cancelled when the node is disposed.
         */ this._gcTimeout = -1;
        /**
         * A moving average of the number of active voices
         */ this._averageActiveVoices = 0;
        /**
         * The release which is scheduled to the timeline.
         */ this._syncedRelease = (time)=>this.releaseAll(time);
        // check against the old API (pre 14.3.0)
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!(0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(options.voice), "DEPRECATED: The polyphony count is no longer the first argument.");
        const defaults = options.voice.getDefaults();
        this.options = Object.assign(defaults, options.options);
        this.voice = options.voice;
        this.maxPolyphony = options.maxPolyphony;
        // create the first voice
        this._dummyVoice = this._getNextAvailableVoice();
        // remove it from the voices list
        const index = this._voices.indexOf(this._dummyVoice);
        this._voices.splice(index, 1);
        // kick off the GC interval
        this._gcTimeout = this.context.setInterval(this._collectGarbage.bind(this), 1);
    }
    static getDefaults() {
        return Object.assign((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            maxPolyphony: 32,
            options: {},
            voice: (0, $6489a0fb869a8c37$export$8ef26ca8e8d9bf70)
        });
    }
    /**
     * The number of active voices.
     */ get activeVoices() {
        return this._activeVoices.length;
    }
    /**
     * Invoked when the source is done making sound, so that it can be
     * readded to the pool of available voices
     */ _makeVoiceAvailable(voice) {
        this._availableVoices.push(voice);
        // remove the midi note from 'active voices'
        const activeVoiceIndex = this._activeVoices.findIndex((e)=>e.voice === voice);
        this._activeVoices.splice(activeVoiceIndex, 1);
    }
    /**
     * Get an available voice from the pool of available voices.
     * If one is not available and the maxPolyphony limit is reached,
     * steal a voice, otherwise return null.
     */ _getNextAvailableVoice() {
        // if there are available voices, return the first one
        if (this._availableVoices.length) return this._availableVoices.shift();
        else if (this._voices.length < this.maxPolyphony) {
            // otherwise if there is still more maxPolyphony, make a new voice
            const voice = new this.voice(Object.assign(this.options, {
                context: this.context,
                onsilence: this._makeVoiceAvailable.bind(this)
            }));
            (0, $afc9146c77d080c2$export$a7a9523472993e97)(voice instanceof (0, $8a6857abebb22660$export$f16a08bc2d920a12), "Voice must extend Monophonic class");
            voice.connect(this.output);
            this._voices.push(voice);
            return voice;
        } else (0, $afc9146c77d080c2$export$c106dd0671a0fc2d)("Max polyphony exceeded. Note dropped.");
    }
    /**
     * Occasionally check if there are any allocated voices which can be cleaned up.
     */ _collectGarbage() {
        this._averageActiveVoices = Math.max(this._averageActiveVoices * 0.95, this.activeVoices);
        if (this._availableVoices.length && this._voices.length > Math.ceil(this._averageActiveVoices + 1)) {
            // take off an available note
            const firstAvail = this._availableVoices.shift();
            const index = this._voices.indexOf(firstAvail);
            this._voices.splice(index, 1);
            if (!this.context.isOffline) firstAvail.dispose();
        }
    }
    /**
     * Internal method which triggers the attack
     */ _triggerAttack(notes, time, velocity) {
        notes.forEach((note)=>{
            const midiNote = new (0, $acb4e2b4a4f69a23$export$266cef4b055bf7de)(this.context, note).toMidi();
            const voice = this._getNextAvailableVoice();
            if (voice) {
                voice.triggerAttack(note, time, velocity);
                this._activeVoices.push({
                    midi: midiNote,
                    voice: voice,
                    released: false
                });
                this.log("triggerAttack", note, time);
            }
        });
    }
    /**
     * Internal method which triggers the release
     */ _triggerRelease(notes, time) {
        notes.forEach((note)=>{
            const midiNote = new (0, $acb4e2b4a4f69a23$export$266cef4b055bf7de)(this.context, note).toMidi();
            const event = this._activeVoices.find(({ midi: midi, released: released })=>midi === midiNote && !released);
            if (event) {
                // trigger release on that note
                event.voice.triggerRelease(time);
                // mark it as released
                event.released = true;
                this.log("triggerRelease", note, time);
            }
        });
    }
    /**
     * Schedule the attack/release events. If the time is in the future, then it should set a timeout
     * to wait for just-in-time scheduling
     */ _scheduleEvent(type, notes, time, velocity) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(!this.disposed, "Synth was already disposed");
        // if the notes are greater than this amount of time in the future, they should be scheduled with setTimeout
        if (time <= this.now()) {
            // do it immediately
            if (type === "attack") this._triggerAttack(notes, time, velocity);
            else this._triggerRelease(notes, time);
        } else // schedule it to start in the future
        this.context.setTimeout(()=>{
            if (!this.disposed) this._scheduleEvent(type, notes, time, velocity);
        }, time - this.now());
    }
    /**
     * Trigger the attack portion of the note
     * @param  notes The notes to play. Accepts a single Frequency or an array of frequencies.
     * @param  time  The start time of the note.
     * @param velocity The velocity of the note.
     * @example
     * const synth = new Tone.PolySynth(Tone.FMSynth).toDestination();
     * // trigger a chord immediately with a velocity of 0.2
     * synth.triggerAttack(["Ab3", "C4", "F5"], Tone.now(), 0.2);
     */ triggerAttack(notes, time, velocity) {
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        const computedTime = this.toSeconds(time);
        this._scheduleEvent("attack", notes, computedTime, velocity);
        return this;
    }
    /**
     * Trigger the release of the note. Unlike monophonic instruments,
     * a note (or array of notes) needs to be passed in as the first argument.
     * @param  notes The notes to play. Accepts a single Frequency or an array of frequencies.
     * @param  time  When the release will be triggered.
     * @example
     * const poly = new Tone.PolySynth(Tone.AMSynth).toDestination();
     * poly.triggerAttack(["Ab3", "C4", "F5"]);
     * // trigger the release of the given notes.
     * poly.triggerRelease(["Ab3", "C4"], "+1");
     * poly.triggerRelease("F5", "+3");
     */ triggerRelease(notes, time) {
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        const computedTime = this.toSeconds(time);
        this._scheduleEvent("release", notes, computedTime);
        return this;
    }
    /**
     * Trigger the attack and release after the specified duration
     * @param  notes The notes to play. Accepts a single  Frequency or an array of frequencies.
     * @param  duration the duration of the note
     * @param  time  if no time is given, defaults to now
     * @param  velocity the velocity of the attack (0-1)
     * @example
     * const poly = new Tone.PolySynth(Tone.AMSynth).toDestination();
     * // can pass in an array of durations as well
     * poly.triggerAttackRelease(["Eb3", "G4", "Bb4", "D5"], [4, 3, 2, 1]);
     */ triggerAttackRelease(notes, duration, time, velocity) {
        const computedTime = this.toSeconds(time);
        this.triggerAttack(notes, computedTime, velocity);
        if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(duration)) {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(notes), "If the duration is an array, the notes must also be an array");
            notes;
            for(let i = 0; i < notes.length; i++){
                const d = duration[Math.min(i, duration.length - 1)];
                const durationSeconds = this.toSeconds(d);
                (0, $afc9146c77d080c2$export$a7a9523472993e97)(durationSeconds > 0, "The duration must be greater than 0");
                this.triggerRelease(notes[i], computedTime + durationSeconds);
            }
        } else {
            const durationSeconds = this.toSeconds(duration);
            (0, $afc9146c77d080c2$export$a7a9523472993e97)(durationSeconds > 0, "The duration must be greater than 0");
            this.triggerRelease(notes, computedTime + durationSeconds);
        }
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 1);
            // make sure that the sound doesn't play after its been stopped
            this.context.transport.on("stop", this._syncedRelease);
            this.context.transport.on("pause", this._syncedRelease);
            this.context.transport.on("loopEnd", this._syncedRelease);
        }
        return this;
    }
    /**
     * Set a member/attribute of the voices
     * @example
     * const poly = new Tone.PolySynth().toDestination();
     * // set all of the voices using an options object for the synth type
     * poly.set({
     * 	envelope: {
     * 		attack: 0.25
     * 	}
     * });
     * poly.triggerAttackRelease("Bb3", 0.2);
     */ set(options) {
        // remove options which are controlled by the PolySynth
        const sanitizedOptions = (0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)(options, [
            "onsilence",
            "context"
        ]);
        // store all of the options
        this.options = (0, $07d9216a29f4e8bb$export$6969335ea1e4e77c)(this.options, sanitizedOptions);
        this._voices.forEach((voice)=>voice.set(sanitizedOptions));
        this._dummyVoice.set(sanitizedOptions);
        return this;
    }
    get() {
        return this._dummyVoice.get();
    }
    /**
     * Trigger the release portion of all the currently active voices immediately.
     * Useful for silencing the synth.
     */ releaseAll(time) {
        const computedTime = this.toSeconds(time);
        this._activeVoices.forEach(({ voice: voice })=>{
            voice.triggerRelease(computedTime);
        });
        return this;
    }
    dispose() {
        super.dispose();
        this._dummyVoice.dispose();
        this._voices.forEach((v)=>v.dispose());
        this._activeVoices = [];
        this._availableVoices = [];
        this.context.clearInterval(this._gcTimeout);
        return this;
    }
}













class $f2139aa45d11abc9$export$322f102bec719b22 extends (0, $604ec55036b64d8b$export$25ef33f358b07cf4) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f2139aa45d11abc9$export$322f102bec719b22.getDefaults(), arguments, [
            "urls",
            "onload",
            "baseUrl"
        ], "urls");
        super(options);
        this.name = "Sampler";
        /**
         * The object of all currently playing BufferSources
         */ this._activeSources = new Map();
        const urlMap = {};
        Object.keys(options.urls).forEach((note)=>{
            const noteNumber = parseInt(note, 10);
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4dcca4501f2037f9)(note) || (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(noteNumber) && isFinite(noteNumber), `url key is neither a note or midi pitch: ${note}`);
            if ((0, $4d7f709c9ffa5105$export$4dcca4501f2037f9)(note)) {
                // convert the note name to MIDI
                const mid = new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, note).toMidi();
                urlMap[mid] = options.urls[note];
            } else if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(noteNumber) && isFinite(noteNumber)) // otherwise if it's numbers assume it's midi
            urlMap[noteNumber] = options.urls[noteNumber];
        });
        this._buffers = new (0, $d37bb61f6ec53d08$export$7232b969b571e570)({
            urls: urlMap,
            onload: options.onload,
            baseUrl: options.baseUrl,
            onerror: options.onerror
        });
        this.attack = options.attack;
        this.release = options.release;
        this.curve = options.curve;
        // invoke the callback if it's already loaded
        if (this._buffers.loaded) // invoke onload deferred
        Promise.resolve().then(options.onload);
    }
    static getDefaults() {
        return Object.assign((0, $604ec55036b64d8b$export$25ef33f358b07cf4).getDefaults(), {
            attack: 0,
            baseUrl: "",
            curve: "exponential",
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            onerror: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            release: 0.1,
            urls: {}
        });
    }
    /**
     * Returns the difference in steps between the given midi note at the closets sample.
     */ _findClosest(midi) {
        // searches within 8 octaves of the given midi note
        const MAX_INTERVAL = 96;
        let interval = 0;
        while(interval < MAX_INTERVAL){
            // check above and below
            if (this._buffers.has(midi + interval)) return -interval;
            else if (this._buffers.has(midi - interval)) return interval;
            interval++;
        }
        throw new Error(`No available buffers for note: ${midi}`);
    }
    /**
     * @param  notes	The note to play, or an array of notes.
     * @param  time     When to play the note
     * @param  velocity The velocity to play the sample back.
     */ triggerAttack(notes, time, velocity = 1) {
        this.log("triggerAttack", notes, time, velocity);
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        notes.forEach((note)=>{
            const midiFloat = (0, $84c2af7dbf01a14d$export$12513e46625518e4)(new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, note).toFrequency());
            const midi = Math.round(midiFloat);
            const remainder = midiFloat - midi;
            // find the closest note pitch
            const difference = this._findClosest(midi);
            const closestNote = midi - difference;
            const buffer = this._buffers.get(closestNote);
            const playbackRate = (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(difference + remainder);
            // play that note
            const source = new (0, $faf7c8e078303879$export$30cbf4ba14db4fdd)({
                url: buffer,
                context: this.context,
                curve: this.curve,
                fadeIn: this.attack,
                fadeOut: this.release,
                playbackRate: playbackRate
            }).connect(this.output);
            source.start(time, 0, buffer.duration / playbackRate, velocity);
            // add it to the active sources
            if (!(0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(this._activeSources.get(midi))) this._activeSources.set(midi, []);
            this._activeSources.get(midi).push(source);
            // remove it when it's done
            source.onended = ()=>{
                if (this._activeSources && this._activeSources.has(midi)) {
                    const sources = this._activeSources.get(midi);
                    const index = sources.indexOf(source);
                    if (index !== -1) sources.splice(index, 1);
                }
            };
        });
        return this;
    }
    /**
     * @param  notes	The note to release, or an array of notes.
     * @param  time     	When to release the note.
     */ triggerRelease(notes, time) {
        this.log("triggerRelease", notes, time);
        if (!Array.isArray(notes)) notes = [
            notes
        ];
        notes.forEach((note)=>{
            const midi = new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, note).toMidi();
            // find the note
            if (this._activeSources.has(midi) && this._activeSources.get(midi).length) {
                const sources = this._activeSources.get(midi);
                time = this.toSeconds(time);
                sources.forEach((source)=>{
                    source.stop(time);
                });
                this._activeSources.set(midi, []);
            }
        });
        return this;
    }
    /**
     * Release all currently active notes.
     * @param  time     	When to release the notes.
     */ releaseAll(time) {
        const computedTime = this.toSeconds(time);
        this._activeSources.forEach((sources)=>{
            while(sources.length){
                const source = sources.shift();
                source.stop(computedTime);
            }
        });
        return this;
    }
    sync() {
        if (this._syncState()) {
            this._syncMethod("triggerAttack", 1);
            this._syncMethod("triggerRelease", 1);
        }
        return this;
    }
    /**
     * Invoke the attack phase, then after the duration, invoke the release.
     * @param  notes	The note to play and release, or an array of notes.
     * @param  duration The time the note should be held
     * @param  time     When to start the attack
     * @param  velocity The velocity of the attack
     */ triggerAttackRelease(notes, duration, time, velocity = 1) {
        const computedTime = this.toSeconds(time);
        this.triggerAttack(notes, computedTime, velocity);
        if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(duration)) {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(notes), "notes must be an array when duration is array");
            notes.forEach((note, index)=>{
                const d = duration[Math.min(index, duration.length - 1)];
                this.triggerRelease(note, computedTime + this.toSeconds(d));
            });
        } else this.triggerRelease(notes, computedTime + this.toSeconds(duration));
        return this;
    }
    /**
     * Add a note to the sampler.
     * @param  note      The buffer's pitch.
     * @param  url  Either the url of the buffer, or a buffer which will be added with the given name.
     * @param  callback  The callback to invoke when the url is loaded.
     */ add(note, url, callback) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)((0, $4d7f709c9ffa5105$export$4dcca4501f2037f9)(note) || isFinite(note), `note must be a pitch or midi: ${note}`);
        if ((0, $4d7f709c9ffa5105$export$4dcca4501f2037f9)(note)) {
            // convert the note name to MIDI
            const mid = new (0, $f4d7193118bd1d27$export$38b56155c8552868)(this.context, note).toMidi();
            this._buffers.add(mid, url, callback);
        } else // otherwise if it's numbers assume it's midi
        this._buffers.add(note, url, callback);
        return this;
    }
    /**
     * If the buffers are loaded or not
     */ get loaded() {
        return this._buffers.loaded;
    }
    /**
     * Clean up
     */ dispose() {
        super.dispose();
        this._buffers.dispose();
        this._activeSources.forEach((sources)=>{
            sources.forEach((source)=>source.dispose());
        });
        this._activeSources.clear();
        return this;
    }
}
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $f2139aa45d11abc9$export$322f102bec719b22.prototype, "attack", void 0);
(0, $5c96a02c592fcff1$export$29e00dfd3077644b)([
    (0, $56353399eaf2b0ec$export$4748a2e3a6d34ca5)(0)
], $f2139aa45d11abc9$export$322f102bec719b22.prototype, "release", void 0);












class $2c5b4772ac8b2d19$export$f99f73502b006764 extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2c5b4772ac8b2d19$export$f99f73502b006764.getDefaults(), arguments, [
            "callback",
            "value"
        ]);
        super(options);
        this.name = "ToneEvent";
        /**
         * Tracks the scheduled events
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)("stopped");
        /**
         * A delay time from when the event is scheduled to start
         */ this._startOffset = 0;
        this._loop = options.loop;
        this.callback = options.callback;
        this.value = options.value;
        this._loopStart = this.toTicks(options.loopStart);
        this._loopEnd = this.toTicks(options.loopEnd);
        this._playbackRate = options.playbackRate;
        this._probability = options.probability;
        this._humanize = options.humanize;
        this.mute = options.mute;
        this._playbackRate = options.playbackRate;
        this._state.increasing = true;
        // schedule the events for the first time
        this._rescheduleEvents();
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            humanize: false,
            loop: false,
            loopEnd: "1m",
            loopStart: 0,
            mute: false,
            playbackRate: 1,
            probability: 1,
            value: null
        });
    }
    /**
     * Reschedule all of the events along the timeline
     * with the updated values.
     * @param after Only reschedules events after the given time.
     */ _rescheduleEvents(after = -1) {
        // if no argument is given, schedules all of the events
        this._state.forEachFrom(after, (event)=>{
            let duration;
            if (event.state === "started") {
                if (event.id !== -1) this.context.transport.clear(event.id);
                const startTick = event.time + Math.round(this.startOffset / this._playbackRate);
                if (this._loop === true || (0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(this._loop) && this._loop > 1) {
                    duration = Infinity;
                    if ((0, $4d7f709c9ffa5105$export$7e4aa119212bc614)(this._loop)) duration = this._loop * this._getLoopDuration();
                    const nextEvent = this._state.getAfter(startTick);
                    if (nextEvent !== null) duration = Math.min(duration, nextEvent.time - startTick);
                    if (duration !== Infinity) duration = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, duration);
                    const interval = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._getLoopDuration());
                    event.id = this.context.transport.scheduleRepeat(this._tick.bind(this), interval, new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, startTick), duration);
                } else event.id = this.context.transport.schedule(this._tick.bind(this), new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, startTick));
            }
        });
    }
    /**
     * Returns the playback state of the note, either "started" or "stopped".
     */ get state() {
        return this._state.getValueAtTime(this.context.transport.ticks);
    }
    /**
     * The start from the scheduled start time.
     */ get startOffset() {
        return this._startOffset;
    }
    set startOffset(offset) {
        this._startOffset = offset;
    }
    /**
     * The probability of the notes being triggered.
     */ get probability() {
        return this._probability;
    }
    set probability(prob) {
        this._probability = prob;
    }
    /**
     * If set to true, will apply small random variation
     * to the callback time. If the value is given as a time, it will randomize
     * by that amount.
     * @example
     * const event = new Tone.ToneEvent();
     * event.humanize = true;
     */ get humanize() {
        return this._humanize;
    }
    set humanize(variation) {
        this._humanize = variation;
    }
    /**
     * Start the note at the given time.
     * @param  time  When the event should start.
     */ start(time) {
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) === "stopped") {
            this._state.add({
                id: -1,
                state: "started",
                time: ticks
            });
            this._rescheduleEvents(ticks);
        }
        return this;
    }
    /**
     * Stop the Event at the given time.
     * @param  time  When the event should stop.
     */ stop(time) {
        this.cancel(time);
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) === "started") {
            this._state.setStateAtTime("stopped", ticks, {
                id: -1
            });
            const previousEvent = this._state.getBefore(ticks);
            let rescheduleTime = ticks;
            if (previousEvent !== null) rescheduleTime = previousEvent.time;
            this._rescheduleEvents(rescheduleTime);
        }
        return this;
    }
    /**
     * Cancel all scheduled events greater than or equal to the given time
     * @param  time  The time after which events will be cancel.
     */ cancel(time) {
        time = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(time, -Infinity);
        const ticks = this.toTicks(time);
        this._state.forEachFrom(ticks, (event)=>{
            this.context.transport.clear(event.id);
        });
        this._state.cancel(ticks);
        return this;
    }
    /**
     * The callback function invoker. Also
     * checks if the Event is done playing
     * @param  time  The time of the event in seconds
     */ _tick(time) {
        const ticks = this.context.transport.getTicksAtTime(time);
        if (!this.mute && this._state.getValueAtTime(ticks) === "started") {
            if (this.probability < 1 && Math.random() > this.probability) return;
            if (this.humanize) {
                let variation = 0.02;
                if (!(0, $4d7f709c9ffa5105$export$f9ce7b637dfbe238)(this.humanize)) variation = this.toSeconds(this.humanize);
                time += (Math.random() * 2 - 1) * variation;
            }
            this.callback(time, this.value);
        }
    }
    /**
     * Get the duration of the loop.
     */ _getLoopDuration() {
        return (this._loopEnd - this._loopStart) / this._playbackRate;
    }
    /**
     * If the note should loop or not
     * between ToneEvent.loopStart and
     * ToneEvent.loopEnd. If set to true,
     * the event will loop indefinitely,
     * if set to a number greater than 1
     * it will play a specific number of
     * times, if set to false, 0 or 1, the
     * part will only play once.
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this._rescheduleEvents();
    }
    /**
     * The playback rate of the event. Defaults to 1.
     * @example
     * const note = new Tone.ToneEvent();
     * note.loop = true;
     * // repeat the note twice as fast
     * note.playbackRate = 2;
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        this._rescheduleEvents();
    }
    /**
     * The loopEnd point is the time the event will loop
     * if ToneEvent.loop is true.
     */ get loopEnd() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._loopEnd).toSeconds();
    }
    set loopEnd(loopEnd) {
        this._loopEnd = this.toTicks(loopEnd);
        if (this._loop) this._rescheduleEvents();
    }
    /**
     * The time when the loop should start.
     */ get loopStart() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._loopStart).toSeconds();
    }
    set loopStart(loopStart) {
        this._loopStart = this.toTicks(loopStart);
        if (this._loop) this._rescheduleEvents();
    }
    /**
     * The current progress of the loop interval.
     * Returns 0 if the event is not started yet or
     * it is not set to loop.
     */ get progress() {
        if (this._loop) {
            const ticks = this.context.transport.ticks;
            const lastEvent = this._state.get(ticks);
            if (lastEvent !== null && lastEvent.state === "started") {
                const loopDuration = this._getLoopDuration();
                const progress = (ticks - lastEvent.time) % loopDuration;
                return progress / loopDuration;
            } else return 0;
        } else return 0;
    }
    dispose() {
        super.dispose();
        this.cancel();
        this._state.dispose();
        return this;
    }
}





class $a002ed03681cb287$export$550acbd06a1f5a6a extends (0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($a002ed03681cb287$export$550acbd06a1f5a6a.getDefaults(), arguments, [
            "callback",
            "interval"
        ]);
        super(options);
        this.name = "Loop";
        this._event = new (0, $2c5b4772ac8b2d19$export$f99f73502b006764)({
            context: this.context,
            callback: this._tick.bind(this),
            loop: true,
            loopEnd: options.interval,
            playbackRate: options.playbackRate,
            probability: options.probability,
            humanize: options.humanize
        });
        this.callback = options.callback;
        // set the iterations
        this.iterations = options.iterations;
    }
    static getDefaults() {
        return Object.assign((0, $f4f7e4e5607dba1a$export$4eb0ca57400aa172).getDefaults(), {
            interval: "4n",
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b),
            playbackRate: 1,
            iterations: Infinity,
            probability: 1,
            mute: false,
            humanize: false
        });
    }
    /**
     * Start the loop at the specified time along the Transport's timeline.
     * @param  time  When to start the Loop.
     */ start(time) {
        this._event.start(time);
        return this;
    }
    /**
     * Stop the loop at the given time.
     * @param  time  When to stop the Loop.
     */ stop(time) {
        this._event.stop(time);
        return this;
    }
    /**
     * Cancel all scheduled events greater than or equal to the given time
     * @param  time  The time after which events will be cancel.
     */ cancel(time) {
        this._event.cancel(time);
        return this;
    }
    /**
     * Internal function called when the notes should be called
     * @param time  The time the event occurs
     */ _tick(time) {
        this.callback(time);
    }
    /**
     * The state of the Loop, either started or stopped.
     */ get state() {
        return this._event.state;
    }
    /**
     * The progress of the loop as a value between 0-1. 0, when the loop is stopped or done iterating.
     */ get progress() {
        return this._event.progress;
    }
    /**
     * The time between successive callbacks.
     * @example
     * const loop = new Tone.Loop();
     * loop.interval = "8n"; // loop every 8n
     */ get interval() {
        return this._event.loopEnd;
    }
    set interval(interval) {
        this._event.loopEnd = interval;
    }
    /**
     * The playback rate of the loop. The normal playback rate is 1 (no change).
     * A `playbackRate` of 2 would be twice as fast.
     */ get playbackRate() {
        return this._event.playbackRate;
    }
    set playbackRate(rate) {
        this._event.playbackRate = rate;
    }
    /**
     * Random variation +/-0.01s to the scheduled time.
     * Or give it a time value which it will randomize by.
     */ get humanize() {
        return this._event.humanize;
    }
    set humanize(variation) {
        this._event.humanize = variation;
    }
    /**
     * The probably of the callback being invoked.
     */ get probability() {
        return this._event.probability;
    }
    set probability(prob) {
        this._event.probability = prob;
    }
    /**
     * Muting the Loop means that no callbacks are invoked.
     */ get mute() {
        return this._event.mute;
    }
    set mute(mute) {
        this._event.mute = mute;
    }
    /**
     * The number of iterations of the loop. The default value is `Infinity` (loop forever).
     */ get iterations() {
        if (this._event.loop === true) return Infinity;
        else return this._event.loop;
    }
    set iterations(iters) {
        if (iters === Infinity) this._event.loop = true;
        else this._event.loop = iters;
    }
    dispose() {
        super.dispose();
        this._event.dispose();
        return this;
    }
}








class $36407f82d559e3b2$export$7b5bf7981d51054e extends (0, $2c5b4772ac8b2d19$export$f99f73502b006764) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($36407f82d559e3b2$export$7b5bf7981d51054e.getDefaults(), arguments, [
            "callback",
            "events"
        ]);
        super(options);
        this.name = "Part";
        /**
         * Tracks the scheduled events
         */ this._state = new (0, $a30e69eba5ea5b5a$export$89221a927ffadcaf)("stopped");
        /**
         * The events that belong to this part
         */ this._events = new Set();
        // make sure things are assigned in the right order
        this._state.increasing = true;
        // add the events
        options.events.forEach((event)=>{
            if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(event)) this.add(event[0], event[1]);
            else this.add(event);
        });
    }
    static getDefaults() {
        return Object.assign((0, $2c5b4772ac8b2d19$export$f99f73502b006764).getDefaults(), {
            events: []
        });
    }
    /**
     * Start the part at the given time.
     * @param  time    When to start the part.
     * @param  offset  The offset from the start of the part to begin playing at.
     */ start(time, offset) {
        const ticks = this.toTicks(time);
        if (this._state.getValueAtTime(ticks) !== "started") {
            offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, this._loop ? this._loopStart : 0);
            if (this._loop) offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, this._loopStart);
            else offset = (0, $07d9216a29f4e8bb$export$37721a79838ca038)(offset, 0);
            const computedOffset = this.toTicks(offset);
            this._state.add({
                id: -1,
                offset: computedOffset,
                state: "started",
                time: ticks
            });
            this._forEach((event)=>{
                this._startNote(event, ticks, computedOffset);
            });
        }
        return this;
    }
    /**
     * Start the event in the given event at the correct time given
     * the ticks and offset and looping.
     * @param  event
     * @param  ticks
     * @param  offset
     */ _startNote(event, ticks, offset) {
        ticks -= offset;
        if (this._loop) {
            if (event.startOffset >= this._loopStart && event.startOffset < this._loopEnd) {
                if (event.startOffset < offset) // start it on the next loop
                ticks += this._getLoopDuration();
                event.start(new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, ticks));
            } else if (event.startOffset < this._loopStart && event.startOffset >= offset) {
                event.loop = false;
                event.start(new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, ticks));
            }
        } else if (event.startOffset >= offset) event.start(new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, ticks));
    }
    get startOffset() {
        return this._startOffset;
    }
    set startOffset(offset) {
        this._startOffset = offset;
        this._forEach((event)=>{
            event.startOffset += this._startOffset;
        });
    }
    /**
     * Stop the part at the given time.
     * @param  time  When to stop the part.
     */ stop(time) {
        const ticks = this.toTicks(time);
        this._state.cancel(ticks);
        this._state.setStateAtTime("stopped", ticks);
        this._forEach((event)=>{
            event.stop(time);
        });
        return this;
    }
    /**
     * Get/Set an Event's value at the given time.
     * If a value is passed in and no event exists at
     * the given time, one will be created with that value.
     * If two events are at the same time, the first one will
     * be returned.
     * @example
     * const part = new Tone.Part();
     * part.at("1m"); // returns the part at the first measure
     * part.at("2m", "C2"); // set the value at "2m" to C2.
     * // if an event didn't exist at that time, it will be created.
     * @param time The time of the event to get or set.
     * @param value If a value is passed in, the value of the event at the given time will be set to it.
     */ at(time, value) {
        const timeInTicks = new (0, $ef656febef4c2085$export$c824041178a9697)(this.context, time).toTicks();
        const tickTime = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, 1).toSeconds();
        const iterator = this._events.values();
        let result = iterator.next();
        while(!result.done){
            const event = result.value;
            if (Math.abs(timeInTicks - event.startOffset) < tickTime) {
                if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(value)) event.value = value;
                return event;
            }
            result = iterator.next();
        }
        // if there was no event at that time, create one
        if ((0, $4d7f709c9ffa5105$export$4e62c701997796c1)(value)) {
            this.add(time, value);
            // return the new event
            return this.at(time);
        } else return null;
    }
    add(time, value) {
        // extract the parameters
        if (time instanceof Object && Reflect.has(time, "time")) {
            value = time;
            time = value.time;
        }
        const ticks = this.toTicks(time);
        let event;
        if (value instanceof (0, $2c5b4772ac8b2d19$export$f99f73502b006764)) {
            event = value;
            event.callback = this._tick.bind(this);
        } else event = new (0, $2c5b4772ac8b2d19$export$f99f73502b006764)({
            callback: this._tick.bind(this),
            context: this.context,
            value: value
        });
        // the start offset
        event.startOffset = ticks;
        // initialize the values
        event.set({
            humanize: this.humanize,
            loop: this.loop,
            loopEnd: this.loopEnd,
            loopStart: this.loopStart,
            playbackRate: this.playbackRate,
            probability: this.probability
        });
        this._events.add(event);
        // start the note if it should be played right now
        this._restartEvent(event);
        return this;
    }
    /**
     * Restart the given event
     */ _restartEvent(event) {
        this._state.forEach((stateEvent)=>{
            if (stateEvent.state === "started") this._startNote(event, stateEvent.time, stateEvent.offset);
            else // stop the note
            event.stop(new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, stateEvent.time));
        });
    }
    remove(time, value) {
        // extract the parameters
        if ((0, $4d7f709c9ffa5105$export$a6cdc56e425d0d0a)(time) && time.hasOwnProperty("time")) {
            value = time;
            time = value.time;
        }
        time = this.toTicks(time);
        this._events.forEach((event)=>{
            if (event.startOffset === time) {
                if ((0, $4d7f709c9ffa5105$export$eb605f91c5895a5b)(value) || (0, $4d7f709c9ffa5105$export$4e62c701997796c1)(value) && event.value === value) {
                    this._events.delete(event);
                    event.dispose();
                }
            }
        });
        return this;
    }
    /**
     * Remove all of the notes from the group.
     */ clear() {
        this._forEach((event)=>event.dispose());
        this._events.clear();
        return this;
    }
    /**
     * Cancel scheduled state change events: i.e. "start" and "stop".
     * @param after The time after which to cancel the scheduled events.
     */ cancel(after) {
        this._forEach((event)=>event.cancel(after));
        this._state.cancel(this.toTicks(after));
        return this;
    }
    /**
     * Iterate over all of the events
     */ _forEach(callback) {
        if (this._events) this._events.forEach((event)=>{
            if (event instanceof $36407f82d559e3b2$export$7b5bf7981d51054e) event._forEach(callback);
            else callback(event);
        });
        return this;
    }
    /**
     * Set the attribute of all of the events
     * @param  attr  the attribute to set
     * @param  value      The value to set it to
     */ _setAll(attr, value) {
        this._forEach((event)=>{
            event[attr] = value;
        });
    }
    /**
     * Internal tick method
     * @param  time  The time of the event in seconds
     */ _tick(time, value) {
        if (!this.mute) this.callback(time, value);
    }
    /**
     * Determine if the event should be currently looping
     * given the loop boundries of this Part.
     * @param  event  The event to test
     */ _testLoopBoundries(event) {
        if (this._loop && (event.startOffset < this._loopStart || event.startOffset >= this._loopEnd)) event.cancel(0);
        else if (event.state === "stopped") // reschedule it if it's stopped
        this._restartEvent(event);
    }
    get probability() {
        return this._probability;
    }
    set probability(prob) {
        this._probability = prob;
        this._setAll("probability", prob);
    }
    get humanize() {
        return this._humanize;
    }
    set humanize(variation) {
        this._humanize = variation;
        this._setAll("humanize", variation);
    }
    /**
     * If the part should loop or not
     * between Part.loopStart and
     * Part.loopEnd. If set to true,
     * the part will loop indefinitely,
     * if set to a number greater than 1
     * it will play a specific number of
     * times, if set to false, 0 or 1, the
     * part will only play once.
     * @example
     * const part = new Tone.Part();
     * // loop the part 8 times
     * part.loop = 8;
     */ get loop() {
        return this._loop;
    }
    set loop(loop) {
        this._loop = loop;
        this._forEach((event)=>{
            event.loopStart = this.loopStart;
            event.loopEnd = this.loopEnd;
            event.loop = loop;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The loopEnd point determines when it will
     * loop if Part.loop is true.
     */ get loopEnd() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._loopEnd).toSeconds();
    }
    set loopEnd(loopEnd) {
        this._loopEnd = this.toTicks(loopEnd);
        if (this._loop) this._forEach((event)=>{
            event.loopEnd = loopEnd;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The loopStart point determines when it will
     * loop if Part.loop is true.
     */ get loopStart() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._loopStart).toSeconds();
    }
    set loopStart(loopStart) {
        this._loopStart = this.toTicks(loopStart);
        if (this._loop) this._forEach((event)=>{
            event.loopStart = this.loopStart;
            this._testLoopBoundries(event);
        });
    }
    /**
     * The playback rate of the part
     */ get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(rate) {
        this._playbackRate = rate;
        this._setAll("playbackRate", rate);
    }
    /**
     * The number of scheduled notes in the part.
     */ get length() {
        return this._events.size;
    }
    dispose() {
        super.dispose();
        this.clear();
        return this;
    }
}





/**
 * Start at the first value and go up to the last
 */ function* $9cb4b246771af6b8$var$upPatternGen(numValues) {
    let index = 0;
    while(index < numValues){
        index = (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(index, 0, numValues - 1);
        yield index;
        index++;
    }
}
/**
 * Start at the last value and go down to 0
 */ function* $9cb4b246771af6b8$var$downPatternGen(numValues) {
    let index = numValues - 1;
    while(index >= 0){
        index = (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(index, 0, numValues - 1);
        yield index;
        index--;
    }
}
/**
 * Infinitely yield the generator
 */ function* $9cb4b246771af6b8$var$infiniteGen(numValues, gen) {
    while(true)yield* gen(numValues);
}
/**
 * Alternate between two generators
 */ function* $9cb4b246771af6b8$var$alternatingGenerator(numValues, directionUp) {
    let index = directionUp ? 0 : numValues - 1;
    while(true){
        index = (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(index, 0, numValues - 1);
        yield index;
        if (directionUp) {
            index++;
            if (index >= numValues - 1) directionUp = false;
        } else {
            index--;
            if (index <= 0) directionUp = true;
        }
    }
}
/**
 * Starting from the bottom move up 2, down 1
 */ function* $9cb4b246771af6b8$var$jumpUp(numValues) {
    let index = 0;
    let stepIndex = 0;
    while(index < numValues){
        index = (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(index, 0, numValues - 1);
        yield index;
        stepIndex++;
        index += stepIndex % 2 ? 2 : -1;
    }
}
/**
 * Starting from the top move down 2, up 1
 */ function* $9cb4b246771af6b8$var$jumpDown(numValues) {
    let index = numValues - 1;
    let stepIndex = 0;
    while(index >= 0){
        index = (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(index, 0, numValues - 1);
        yield index;
        stepIndex++;
        index += stepIndex % 2 ? -2 : 1;
    }
}
/**
 * Choose a random index each time
 */ function* $9cb4b246771af6b8$var$randomGen(numValues) {
    while(true){
        const randomIndex = Math.floor(Math.random() * numValues);
        yield randomIndex;
    }
}
/**
 * Randomly go through all of the values once before choosing a new random order
 */ function* $9cb4b246771af6b8$var$randomOnce(numValues) {
    // create an array of indices
    const copy = [];
    for(let i = 0; i < numValues; i++)copy.push(i);
    while(copy.length > 0){
        // random choose an index, and then remove it so it's not chosen again
        const randVal = copy.splice(Math.floor(copy.length * Math.random()), 1);
        const index = (0, $0f7b0e628156f5de$export$7d15b64cf5a3a4c4)(randVal[0], 0, numValues - 1);
        yield index;
    }
}
/**
 * Randomly choose to walk up or down 1 index
 */ function* $9cb4b246771af6b8$var$randomWalk(numValues) {
    // randomly choose a starting index
    let index = Math.floor(Math.random() * numValues);
    while(true){
        if (index === 0) index++; // at bottom, so force upward step
        else if (index === numValues - 1) index--; // at top, so force downward step
        else if (Math.random() < 0.5) // else choose random downward or upward step
        index--;
        else index++;
        yield index;
    }
}
function* $9cb4b246771af6b8$export$891c3c0ea1af078a(numValues, pattern = "up", index = 0) {
    // safeguards
    (0, $afc9146c77d080c2$export$a7a9523472993e97)(numValues >= 1, "The number of values must be at least one");
    switch(pattern){
        case "up":
            yield* $9cb4b246771af6b8$var$infiniteGen(numValues, $9cb4b246771af6b8$var$upPatternGen);
        case "down":
            yield* $9cb4b246771af6b8$var$infiniteGen(numValues, $9cb4b246771af6b8$var$downPatternGen);
        case "upDown":
            yield* $9cb4b246771af6b8$var$alternatingGenerator(numValues, true);
        case "downUp":
            yield* $9cb4b246771af6b8$var$alternatingGenerator(numValues, false);
        case "alternateUp":
            yield* $9cb4b246771af6b8$var$infiniteGen(numValues, $9cb4b246771af6b8$var$jumpUp);
        case "alternateDown":
            yield* $9cb4b246771af6b8$var$infiniteGen(numValues, $9cb4b246771af6b8$var$jumpDown);
        case "random":
            yield* $9cb4b246771af6b8$var$randomGen(numValues);
        case "randomOnce":
            yield* $9cb4b246771af6b8$var$infiniteGen(numValues, $9cb4b246771af6b8$var$randomOnce);
        case "randomWalk":
            yield* $9cb4b246771af6b8$var$randomWalk(numValues);
    }
}




class $30778f25f10f0276$export$47606a6ae3eaed8e extends (0, $a002ed03681cb287$export$550acbd06a1f5a6a) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($30778f25f10f0276$export$47606a6ae3eaed8e.getDefaults(), arguments, [
            "callback",
            "values",
            "pattern"
        ]);
        super(options);
        this.name = "Pattern";
        this.callback = options.callback;
        this._values = options.values;
        this._pattern = (0, $9cb4b246771af6b8$export$891c3c0ea1af078a)(options.values.length, options.pattern);
        this._type = options.pattern;
    }
    static getDefaults() {
        return Object.assign((0, $a002ed03681cb287$export$550acbd06a1f5a6a).getDefaults(), {
            pattern: "up",
            values: [],
            callback: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)
        });
    }
    /**
     * Internal function called when the notes should be called
     */ _tick(time) {
        const index = this._pattern.next();
        this._index = index.value;
        this._value = this._values[index.value];
        this.callback(time, this._value);
    }
    /**
     * The array of events.
     */ get values() {
        return this._values;
    }
    set values(val) {
        this._values = val;
        // reset the pattern
        this.pattern = this._type;
    }
    /**
     * The current value of the pattern.
     */ get value() {
        return this._value;
    }
    /**
     * The current index of the pattern.
     */ get index() {
        return this._index;
    }
    /**
     * The pattern type.
     */ get pattern() {
        return this._type;
    }
    set pattern(pattern) {
        this._type = pattern;
        this._pattern = (0, $9cb4b246771af6b8$export$891c3c0ea1af078a)(this._values.length, this._type);
    }
}







class $4634066a6fd96bab$export$edde1bcb1b2b310e extends (0, $2c5b4772ac8b2d19$export$f99f73502b006764) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($4634066a6fd96bab$export$edde1bcb1b2b310e.getDefaults(), arguments, [
            "callback",
            "events",
            "subdivision"
        ]);
        super(options);
        this.name = "Sequence";
        /**
         * The object responsible for scheduling all of the events
         */ this._part = new (0, $36407f82d559e3b2$export$7b5bf7981d51054e)({
            callback: this._seqCallback.bind(this),
            context: this.context
        });
        /**
         * private reference to all of the sequence proxies
         */ this._events = [];
        /**
         * The proxied array
         */ this._eventsArray = [];
        this._subdivision = this.toTicks(options.subdivision);
        this.events = options.events;
        // set all of the values
        this.loop = options.loop;
        this.loopStart = options.loopStart;
        this.loopEnd = options.loopEnd;
        this.playbackRate = options.playbackRate;
        this.probability = options.probability;
        this.humanize = options.humanize;
        this.mute = options.mute;
        this.playbackRate = options.playbackRate;
    }
    static getDefaults() {
        return Object.assign((0, $07d9216a29f4e8bb$export$e35a36a1f3b5e86b)((0, $2c5b4772ac8b2d19$export$f99f73502b006764).getDefaults(), [
            "value"
        ]), {
            events: [],
            loop: true,
            loopEnd: 0,
            loopStart: 0,
            subdivision: "8n"
        });
    }
    /**
     * The internal callback for when an event is invoked
     */ _seqCallback(time, value) {
        if (value !== null && !this.mute) this.callback(time, value);
    }
    /**
     * The sequence
     */ get events() {
        return this._events;
    }
    set events(s) {
        this.clear();
        this._eventsArray = s;
        this._events = this._createSequence(this._eventsArray);
        this._eventsUpdated();
    }
    /**
     * Start the part at the given time.
     * @param  time    When to start the part.
     * @param  offset  The offset index to start at
     */ start(time, offset) {
        this._part.start(time, offset ? this._indexTime(offset) : offset);
        return this;
    }
    /**
     * Stop the part at the given time.
     * @param  time  When to stop the part.
     */ stop(time) {
        this._part.stop(time);
        return this;
    }
    /**
     * The subdivision of the sequence. This can only be
     * set in the constructor. The subdivision is the
     * interval between successive steps.
     */ get subdivision() {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, this._subdivision).toSeconds();
    }
    /**
     * Create a sequence proxy which can be monitored to create subsequences
     */ _createSequence(array) {
        return new Proxy(array, {
            get: (target, property)=>{
                // property is index in this case
                return target[property];
            },
            set: (target, property, value)=>{
                if ((0, $4d7f709c9ffa5105$export$844ec244b1367d54)(property) && isFinite(parseInt(property, 10))) {
                    if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(value)) target[property] = this._createSequence(value);
                    else target[property] = value;
                } else target[property] = value;
                this._eventsUpdated();
                // return true to accept the changes
                return true;
            }
        });
    }
    /**
     * When the sequence has changed, all of the events need to be recreated
     */ _eventsUpdated() {
        this._part.clear();
        this._rescheduleSequence(this._eventsArray, this._subdivision, this.startOffset);
        // update the loopEnd
        this.loopEnd = this.loopEnd;
    }
    /**
     * reschedule all of the events that need to be rescheduled
     */ _rescheduleSequence(sequence, subdivision, startOffset) {
        sequence.forEach((value, index)=>{
            const eventOffset = index * subdivision + startOffset;
            if ((0, $4d7f709c9ffa5105$export$43bee75e5e14138e)(value)) this._rescheduleSequence(value, subdivision / value.length, eventOffset);
            else {
                const startTime = new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, eventOffset, "i").toSeconds();
                this._part.add(startTime, value);
            }
        });
    }
    /**
     * Get the time of the index given the Sequence's subdivision
     * @param  index
     * @return The time of that index
     */ _indexTime(index) {
        return new (0, $1c1f4b05c313775e$export$fe3569694b9f5728)(this.context, index * this._subdivision + this.startOffset).toSeconds();
    }
    /**
     * Clear all of the events
     */ clear() {
        this._part.clear();
        return this;
    }
    dispose() {
        super.dispose();
        this._part.dispose();
        return this;
    }
    //-------------------------------------
    // PROXY CALLS
    //-------------------------------------
    get loop() {
        return this._part.loop;
    }
    set loop(l) {
        this._part.loop = l;
    }
    /**
     * The index at which the sequence should start looping
     */ get loopStart() {
        return this._loopStart;
    }
    set loopStart(index) {
        this._loopStart = index;
        this._part.loopStart = this._indexTime(index);
    }
    /**
     * The index at which the sequence should end looping
     */ get loopEnd() {
        return this._loopEnd;
    }
    set loopEnd(index) {
        this._loopEnd = index;
        if (index === 0) this._part.loopEnd = this._indexTime(this._eventsArray.length);
        else this._part.loopEnd = this._indexTime(index);
    }
    get startOffset() {
        return this._part.startOffset;
    }
    set startOffset(start) {
        this._part.startOffset = start;
    }
    get playbackRate() {
        return this._part.playbackRate;
    }
    set playbackRate(rate) {
        this._part.playbackRate = rate;
    }
    get probability() {
        return this._part.probability;
    }
    set probability(prob) {
        this._part.probability = prob;
    }
    get progress() {
        return this._part.progress;
    }
    get humanize() {
        return this._part.humanize;
    }
    set humanize(variation) {
        this._part.humanize = variation;
    }
    /**
     * The number of scheduled events
     */ get length() {
        return this._part.length;
    }
}













class $edbbeae191c550fb$export$d78c8c6074541cf2 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($edbbeae191c550fb$export$d78c8c6074541cf2.getDefaults(), arguments, [
            "fade"
        ]);
        super(options);
        this.name = "CrossFade";
        /**
         * The crossfading is done by a StereoPannerNode
         */ this._panner = this.context.createStereoPanner();
        /**
         * Split the output of the panner node into two values used to control the gains.
         */ this._split = this.context.createChannelSplitter(2);
        /**
         * Convert the fade value into an audio range value so it can be connected
         * to the panner.pan AudioParam
         */ this._g2a = new (0, $98f6ca22b8da8532$export$770438008a544d9b)({
            context: this.context
        });
        /**
         * The input which is at full level when fade = 0
         */ this.a = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        /**
         * The input which is at full level when fade = 1
         */ this.b = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: 0
        });
        /**
         * The output is a mix between `a` and `b` at the ratio of `fade`
         */ this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._internalChannels = [
            this.a,
            this.b
        ];
        this.fade = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "normalRange",
            value: options.fade
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "fade");
        this.context.getConstant(1).connect(this._panner);
        this._panner.connect(this._split);
        // this is necessary for standardized-audio-context
        // doesn't make any difference for the native AudioContext
        // https://github.com/chrisguttandin/standardized-audio-context/issues/647
        this._panner.channelCount = 1;
        this._panner.channelCountMode = "explicit";
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._split, this.a.gain, 0);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this._split, this.b.gain, 1);
        this.fade.chain(this._g2a, this._panner.pan);
        this.a.connect(this.output);
        this.b.connect(this.output);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            fade: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.a.dispose();
        this.b.dispose();
        this.output.dispose();
        this.fade.dispose();
        this._g2a.dispose();
        this._panner.disconnect();
        this._split.disconnect();
        return this;
    }
}





class $55a557a844190520$export$a32b0b1c1ac59d04 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        this.name = "Effect";
        /**
         * the drywet knob to control the amount of effect
         */ this._dryWet = new (0, $edbbeae191c550fb$export$d78c8c6074541cf2)({
            context: this.context
        });
        /**
         * The wet control is how much of the effected
         * will pass through to the output. 1 = 100% effected
         * signal, 0 = 100% dry signal.
         */ this.wet = this._dryWet.fade;
        /**
         * connect the effectSend to the input of hte effect
         */ this.effectSend = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * connect the output of the effect to the effectReturn
         */ this.effectReturn = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The effect input node
         */ this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The effect output
         */ this.output = this._dryWet;
        // connections
        this.input.fan(this._dryWet.a, this.effectSend);
        this.effectReturn.connect(this._dryWet.b);
        this.wet.setValueAtTime(options.wet, 0);
        this._internalChannels = [
            this.effectReturn,
            this.effectSend
        ];
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "wet");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            wet: 1
        });
    }
    /**
     * chains the effect in between the effectSend and effectReturn
     */ connectEffect(effect) {
        // add it to the internal channels
        this._internalChannels.push(effect);
        this.effectSend.chain(effect, this.effectReturn);
        return this;
    }
    dispose() {
        super.dispose();
        this._dryWet.dispose();
        this.effectSend.dispose();
        this.effectReturn.dispose();
        this.wet.dispose();
        return this;
    }
}




class $402599c7d88bac65$export$de224a2741e4b2f8 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(options){
        super(options);
        this.name = "LFOEffect";
        this._lfo = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            amplitude: options.depth
        });
        this.depth = this._lfo.amplitude;
        this.frequency = this._lfo.frequency;
        this.type = options.type;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "depth"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            frequency: 1,
            type: "sine",
            depth: 1
        });
    }
    /**
     * Start the effect.
     */ start(time) {
        this._lfo.start(time);
        return this;
    }
    /**
     * Stop the lfo
     */ stop(time) {
        this._lfo.stop(time);
        return this;
    }
    /**
     * Sync the filter to the transport.
     * @see {@link LFO.sync}
     */ sync() {
        this._lfo.sync();
        return this;
    }
    /**
     * Unsync the filter from the transport.
     */ unsync() {
        this._lfo.unsync();
        return this;
    }
    /**
     * The type of the LFO's oscillator.
     * @see {@link Oscillator.type}
     * @example
     * const autoFilter = new Tone.AutoFilter().start().toDestination();
     * const noise = new Tone.Noise().start().connect(autoFilter);
     * autoFilter.type = "square";
     */ get type() {
        return this._lfo.type;
    }
    set type(type) {
        this._lfo.type = type;
    }
    dispose() {
        super.dispose();
        this._lfo.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}


class $408e8dd19ecab46a$export$b80f807aa51d8d02 extends (0, $402599c7d88bac65$export$de224a2741e4b2f8) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($408e8dd19ecab46a$export$b80f807aa51d8d02.getDefaults(), arguments, [
            "frequency",
            "baseFrequency",
            "octaves"
        ]);
        super(options);
        this.name = "AutoFilter";
        this.filter = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)(Object.assign(options.filter, {
            context: this.context
        }));
        // connections
        this.connectEffect(this.filter);
        this._lfo.connect(this.filter.frequency);
        this.octaves = options.octaves;
        this.baseFrequency = options.baseFrequency;
    }
    static getDefaults() {
        return Object.assign((0, $402599c7d88bac65$export$de224a2741e4b2f8).getDefaults(), {
            baseFrequency: 200,
            octaves: 2.6,
            filter: {
                type: "lowpass",
                rolloff: -12,
                Q: 1
            }
        });
    }
    /**
     * The minimum value of the filter's cutoff frequency.
     */ get baseFrequency() {
        return this._lfo.min;
    }
    set baseFrequency(freq) {
        this._lfo.min = this.toFrequency(freq);
        // and set the max
        this.octaves = this._octaves;
    }
    /**
     * The maximum value of the filter's cutoff frequency.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(oct) {
        this._octaves = oct;
        this._lfo.max = this._lfo.min * Math.pow(2, oct);
    }
    dispose() {
        super.dispose();
        this.filter.dispose();
        return this;
    }
}






class $3104cbf8d2a8337f$export$d6d7a1629e59823d extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3104cbf8d2a8337f$export$d6d7a1629e59823d.getDefaults(), arguments, [
            "pan"
        ]);
        super(options);
        this.name = "Panner";
        /**
         * the panner node
         */ this._panner = this.context.createStereoPanner();
        this.input = this._panner;
        this.output = this._panner;
        this.pan = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.pan,
            value: options.pan,
            minValue: -1,
            maxValue: 1
        });
        // this is necessary for standardized-audio-context
        // doesn't make any difference for the native AudioContext
        // https://github.com/chrisguttandin/standardized-audio-context/issues/647
        this._panner.channelCount = options.channelCount;
        this._panner.channelCountMode = "explicit";
        // initial value
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "pan");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            pan: 0,
            channelCount: 1
        });
    }
    dispose() {
        super.dispose();
        this._panner.disconnect();
        this.pan.dispose();
        return this;
    }
}




class $7f0dcacdefc557fe$export$e9bd274ee70104df extends (0, $402599c7d88bac65$export$de224a2741e4b2f8) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7f0dcacdefc557fe$export$e9bd274ee70104df.getDefaults(), arguments, [
            "frequency"
        ]);
        super(options);
        this.name = "AutoPanner";
        this._panner = new (0, $3104cbf8d2a8337f$export$d6d7a1629e59823d)({
            context: this.context,
            channelCount: options.channelCount
        });
        // connections
        this.connectEffect(this._panner);
        this._lfo.connect(this._panner.pan);
        this._lfo.min = -1;
        this._lfo.max = 1;
    }
    static getDefaults() {
        return Object.assign((0, $402599c7d88bac65$export$de224a2741e4b2f8).getDefaults(), {
            channelCount: 1
        });
    }
    dispose() {
        super.dispose();
        this._panner.dispose();
        return this;
    }
}








class $1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f.getDefaults(), arguments, [
            "smoothing"
        ]);
        super(options);
        this.name = "Follower";
        this._abs = this.input = new (0, $bc6b6173dfd74460$export$b73c596ee8758a66)({
            context: this.context
        });
        this._lowpass = this.output = new (0, $e96b9b836f8a5fb5$export$7961b18021b7c8c9)({
            context: this.context,
            frequency: 1 / this.toSeconds(options.smoothing),
            type: "lowpass"
        });
        this._abs.connect(this._lowpass);
        this._smoothing = options.smoothing;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            smoothing: 0.05
        });
    }
    /**
     * The amount of time it takes a value change to arrive at the updated value.
     */ get smoothing() {
        return this._smoothing;
    }
    set smoothing(smoothing) {
        this._smoothing = smoothing;
        this._lowpass.frequency = 1 / this.toSeconds(this.smoothing);
    }
    dispose() {
        super.dispose();
        this._abs.dispose();
        this._lowpass.dispose();
        return this;
    }
}







class $0fcf624e170bb973$export$7107ee8d8b759a00 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($0fcf624e170bb973$export$7107ee8d8b759a00.getDefaults(), arguments, [
            "baseFrequency",
            "octaves",
            "sensitivity"
        ]);
        super(options);
        this.name = "AutoWah";
        this._follower = new (0, $1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f)({
            context: this.context,
            smoothing: options.follower
        });
        this._sweepRange = new (0, $75aaa92c69306be4$export$92c7140174c78083)({
            context: this.context,
            min: 0,
            max: 1,
            exponent: 0.5
        });
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._octaves = options.octaves;
        this._inputBoost = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._bandpass = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            rolloff: -48,
            frequency: 0,
            Q: options.Q
        });
        this._peaking = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            type: "peaking"
        });
        this._peaking.gain.value = options.gain;
        this.gain = this._peaking.gain;
        this.Q = this._bandpass.Q;
        // the control signal path
        this.effectSend.chain(this._inputBoost, this._follower, this._sweepRange);
        this._sweepRange.connect(this._bandpass.frequency);
        this._sweepRange.connect(this._peaking.frequency);
        // the filtered path
        this.effectSend.chain(this._bandpass, this._peaking, this.effectReturn);
        // set the initial value
        this._setSweepRange();
        this.sensitivity = options.sensitivity;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "gain",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            baseFrequency: 100,
            octaves: 6,
            sensitivity: 0,
            Q: 2,
            gain: 2,
            follower: 0.2
        });
    }
    /**
     * The number of octaves that the filter will sweep above the baseFrequency.
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        this._setSweepRange();
    }
    /**
     * The follower's smoothing time
     */ get follower() {
        return this._follower.smoothing;
    }
    set follower(follower) {
        this._follower.smoothing = follower;
    }
    /**
     * The base frequency from which the sweep will start from.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(baseFreq) {
        this._baseFrequency = this.toFrequency(baseFreq);
        this._setSweepRange();
    }
    /**
     * The sensitivity to control how responsive to the input signal the filter is.
     */ get sensitivity() {
        return (0, $84c2af7dbf01a14d$export$6af3969727ca2a60)(1 / this._inputBoost.gain.value);
    }
    set sensitivity(sensitivity) {
        this._inputBoost.gain.value = 1 / (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(sensitivity);
    }
    /**
     * sets the sweep range of the scaler
     */ _setSweepRange() {
        this._sweepRange.min = this._baseFrequency;
        this._sweepRange.max = Math.min(this._baseFrequency * Math.pow(2, this._octaves), this.context.sampleRate / 2);
    }
    dispose() {
        super.dispose();
        this._follower.dispose();
        this._sweepRange.dispose();
        this._bandpass.dispose();
        this._peaking.dispose();
        this._inputBoost.dispose();
        return this;
    }
}










const $8397ea99d103fd07$export$85343ada6050a795 = "bit-crusher";
const $8397ea99d103fd07$export$b0b3e57880d0a354 = /* javascript */ `
	class BitCrusherWorklet extends SingleIOProcessor {

		static get parameterDescriptors() {
			return [{
				name: "bits",
				defaultValue: 12,
				minValue: 1,
				maxValue: 16,
				automationRate: 'k-rate'
			}];
		}

		generate(input, _channel, parameters) {
			const step = Math.pow(0.5, parameters.bits - 1);
			const val = step * Math.floor(input / step + 0.5);
			return val;
		}
	}
`;
(0, $084f2c4e06bfb0e6$export$d575e6557ac1729f)($8397ea99d103fd07$export$85343ada6050a795, $8397ea99d103fd07$export$b0b3e57880d0a354);


class $f68d8caa4178701a$export$89e1fd5b393fbb6e extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f68d8caa4178701a$export$89e1fd5b393fbb6e.getDefaults(), arguments, [
            "bits"
        ]);
        super(options);
        this.name = "BitCrusher";
        this._bitCrusherWorklet = new $f68d8caa4178701a$var$BitCrusherWorklet({
            context: this.context,
            bits: options.bits
        });
        // connect it up
        this.connectEffect(this._bitCrusherWorklet);
        this.bits = this._bitCrusherWorklet.bits;
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            bits: 4
        });
    }
    dispose() {
        super.dispose();
        this._bitCrusherWorklet.dispose();
        return this;
    }
}
/**
 * Internal class which creates an AudioWorklet to do the bit crushing
 */ class $f68d8caa4178701a$var$BitCrusherWorklet extends (0, $ab96f0673d65b5e9$export$212d912bd0512eff) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f68d8caa4178701a$var$BitCrusherWorklet.getDefaults(), arguments);
        super(options);
        this.name = "BitCrusherWorklet";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.bits = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            value: options.bits,
            units: "positive",
            minValue: 1,
            maxValue: 16,
            param: this._dummyParam,
            swappable: true
        });
    }
    static getDefaults() {
        return Object.assign((0, $ab96f0673d65b5e9$export$212d912bd0512eff).getDefaults(), {
            bits: 12
        });
    }
    _audioWorkletName() {
        return 0, $8397ea99d103fd07$export$85343ada6050a795;
    }
    onReady(node) {
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, node, this.output);
        const bits = node.parameters.get("bits");
        this.bits.setParam(bits);
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.bits.dispose();
        return this;
    }
}






class $14520f372c07ba06$export$9e28f5c57e778427 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($14520f372c07ba06$export$9e28f5c57e778427.getDefaults(), arguments, [
            "order"
        ]);
        super(options);
        this.name = "Chebyshev";
        this._shaper = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            length: 4096
        });
        this._order = options.order;
        this.connectEffect(this._shaper);
        this.order = options.order;
        this.oversample = options.oversample;
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            order: 1,
            oversample: "none"
        });
    }
    /**
     * get the coefficient for that degree
     * @param  x the x value
     * @param  degree
     * @param  memo memoize the computed value. this speeds up computation greatly.
     */ _getCoefficient(x, degree, memo) {
        if (memo.has(degree)) return memo.get(degree);
        else if (degree === 0) memo.set(degree, 0);
        else if (degree === 1) memo.set(degree, x);
        else memo.set(degree, 2 * x * this._getCoefficient(x, degree - 1, memo) - this._getCoefficient(x, degree - 2, memo));
        return memo.get(degree);
    }
    /**
     * The order of the Chebyshev polynomial which creates the equation which is applied to the incoming
     * signal through a Tone.WaveShaper. Must be an integer. The equations are in the form:
     * ```
     * order 2: 2x^2 + 1
     * order 3: 4x^3 + 3x
     * ```
     * @min 1
     * @max 100
     */ get order() {
        return this._order;
    }
    set order(order) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(Number.isInteger(order), "'order' must be an integer");
        this._order = order;
        this._shaper.setMap((x)=>{
            return this._getCoefficient(x, order, new Map());
        });
    }
    /**
     * The oversampling of the effect. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        this._shaper.oversample = oversampling;
    }
    dispose() {
        super.dispose();
        this._shaper.dispose();
        return this;
    }
}






class $41adc9bb2ea0d651$export$f836382419f64c98 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($41adc9bb2ea0d651$export$f836382419f64c98.getDefaults(), arguments, [
            "channels"
        ]);
        super(options);
        this.name = "Split";
        this._splitter = this.input = this.output = this.context.createChannelSplitter(options.channels);
        this._internalChannels = [
            this._splitter
        ];
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            channels: 2
        });
    }
    dispose() {
        super.dispose();
        this._splitter.disconnect();
        return this;
    }
}





class $799c23fcce0ddd96$export$70ce1d34efd3b886 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($799c23fcce0ddd96$export$70ce1d34efd3b886.getDefaults(), arguments, [
            "channels"
        ]);
        super(options);
        this.name = "Merge";
        this._merger = this.output = this.input = this.context.createChannelMerger(options.channels);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            channels: 2
        });
    }
    dispose() {
        super.dispose();
        this._merger.disconnect();
        return this;
    }
}



class $915a8f1363471442$export$f02761adf21def8a extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        this.name = "StereoEffect";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        // force mono sources to be stereo
        this.input.channelCount = 2;
        this.input.channelCountMode = "explicit";
        this._dryWet = this.output = new (0, $edbbeae191c550fb$export$d78c8c6074541cf2)({
            context: this.context,
            fade: options.wet
        });
        this.wet = this._dryWet.fade;
        this._split = new (0, $41adc9bb2ea0d651$export$f836382419f64c98)({
            context: this.context,
            channels: 2
        });
        this._merge = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
            context: this.context,
            channels: 2
        });
        // connections
        this.input.connect(this._split);
        // dry wet connections
        this.input.connect(this._dryWet.a);
        this._merge.connect(this._dryWet.b);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "wet"
        ]);
    }
    /**
     * Connect the left part of the effect
     */ connectEffectLeft(...nodes) {
        this._split.connect(nodes[0], 0, 0);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(...nodes);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(nodes[nodes.length - 1], this._merge, 0, 0);
    }
    /**
     * Connect the right part of the effect
     */ connectEffectRight(...nodes) {
        this._split.connect(nodes[0], 1, 0);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(...nodes);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(nodes[nodes.length - 1], this._merge, 0, 1);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            wet: 1
        });
    }
    dispose() {
        super.dispose();
        this._dryWet.dispose();
        this._split.dispose();
        this._merge.dispose();
        return this;
    }
}







class $ef3d96dfca708839$export$d911e987c738486e extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(options){
        super(options);
        this.feedback = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.feedback,
            units: "normalRange"
        });
        this._feedbackL = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._feedbackR = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._feedbackSplit = new (0, $41adc9bb2ea0d651$export$f836382419f64c98)({
            context: this.context,
            channels: 2
        });
        this._feedbackMerge = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
            context: this.context,
            channels: 2
        });
        this._merge.connect(this._feedbackSplit);
        this._feedbackMerge.connect(this._split);
        // the left output connected to the left input
        this._feedbackSplit.connect(this._feedbackL, 0, 0);
        this._feedbackL.connect(this._feedbackMerge, 0, 0);
        // the right output connected to the right input
        this._feedbackSplit.connect(this._feedbackR, 1, 0);
        this._feedbackR.connect(this._feedbackMerge, 0, 1);
        // the feedback control
        this.feedback.fan(this._feedbackL.gain, this._feedbackR.gain);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "feedback"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            feedback: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.feedback.dispose();
        this._feedbackL.dispose();
        this._feedbackR.dispose();
        this._feedbackSplit.dispose();
        this._feedbackMerge.dispose();
        return this;
    }
}






class $3a08fb57b6335478$export$e876320b09eb8124 extends (0, $ef3d96dfca708839$export$d911e987c738486e) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3a08fb57b6335478$export$e876320b09eb8124.getDefaults(), arguments, [
            "frequency",
            "delayTime",
            "depth"
        ]);
        super(options);
        this.name = "Chorus";
        this._depth = options.depth;
        this._delayTime = options.delayTime / 1000;
        this._lfoL = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1
        });
        this._lfoR = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1,
            phase: 180
        });
        this._delayNodeL = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context
        });
        this._delayNodeR = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context
        });
        this.frequency = this._lfoL.frequency;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency"
        ]);
        // have one LFO frequency control the other
        this._lfoL.frequency.connect(this._lfoR.frequency);
        // connections
        this.connectEffectLeft(this._delayNodeL);
        this.connectEffectRight(this._delayNodeR);
        // lfo setup
        this._lfoL.connect(this._delayNodeL.delayTime);
        this._lfoR.connect(this._delayNodeR.delayTime);
        // set the initial values
        this.depth = this._depth;
        this.type = options.type;
        this.spread = options.spread;
    }
    static getDefaults() {
        return Object.assign((0, $ef3d96dfca708839$export$d911e987c738486e).getDefaults(), {
            frequency: 1.5,
            delayTime: 3.5,
            depth: 0.7,
            type: "sine",
            spread: 180,
            feedback: 0,
            wet: 0.5
        });
    }
    /**
     * The depth of the effect. A depth of 1 makes the delayTime
     * modulate between 0 and 2*delayTime (centered around the delayTime).
     */ get depth() {
        return this._depth;
    }
    set depth(depth) {
        this._depth = depth;
        const deviation = this._delayTime * depth;
        this._lfoL.min = Math.max(this._delayTime - deviation, 0);
        this._lfoL.max = this._delayTime + deviation;
        this._lfoR.min = Math.max(this._delayTime - deviation, 0);
        this._lfoR.max = this._delayTime + deviation;
    }
    /**
     * The delayTime in milliseconds of the chorus. A larger delayTime
     * will give a more pronounced effect. Nominal range a delayTime
     * is between 2 and 20ms.
     */ get delayTime() {
        return this._delayTime * 1000;
    }
    set delayTime(delayTime) {
        this._delayTime = delayTime / 1000;
        this.depth = this._depth;
    }
    /**
     * The oscillator type of the LFO.
     */ get type() {
        return this._lfoL.type;
    }
    set type(type) {
        this._lfoL.type = type;
        this._lfoR.type = type;
    }
    /**
     * Amount of stereo spread. When set to 0, both LFO's will be panned centrally.
     * When set to 180, LFO's will be panned hard left and right respectively.
     */ get spread() {
        return this._lfoR.phase - this._lfoL.phase;
    }
    set spread(spread) {
        this._lfoL.phase = 90 - spread / 2;
        this._lfoR.phase = spread / 2 + 90;
    }
    /**
     * Start the effect.
     */ start(time) {
        this._lfoL.start(time);
        this._lfoR.start(time);
        return this;
    }
    /**
     * Stop the lfo
     */ stop(time) {
        this._lfoL.stop(time);
        this._lfoR.stop(time);
        return this;
    }
    /**
     * Sync the filter to the transport.
     * @see {@link LFO.sync}
     */ sync() {
        this._lfoL.sync();
        this._lfoR.sync();
        return this;
    }
    /**
     * Unsync the filter from the transport.
     */ unsync() {
        this._lfoL.unsync();
        this._lfoR.unsync();
        return this;
    }
    dispose() {
        super.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._delayNodeL.dispose();
        this._delayNodeR.dispose();
        this.frequency.dispose();
        return this;
    }
}





class $357c00e1e161ebb4$export$406bc4309a3e7a54 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($357c00e1e161ebb4$export$406bc4309a3e7a54.getDefaults(), arguments, [
            "distortion"
        ]);
        super(options);
        this.name = "Distortion";
        this._shaper = new (0, $5bf337bc64bc83a6$export$4d933d013693e78)({
            context: this.context,
            length: 4096
        });
        this._distortion = options.distortion;
        this.connectEffect(this._shaper);
        this.distortion = options.distortion;
        this.oversample = options.oversample;
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            distortion: 0.4,
            oversample: "none"
        });
    }
    /**
     * The amount of distortion. Nominal range is between 0 and 1.
     */ get distortion() {
        return this._distortion;
    }
    set distortion(amount) {
        this._distortion = amount;
        const k = amount * 100;
        const deg = Math.PI / 180;
        this._shaper.setMap((x)=>{
            if (Math.abs(x) < 0.001) // should output 0 when input is 0
            return 0;
            else return (3 + k) * x * 20 * deg / (Math.PI + k * Math.abs(x));
        });
    }
    /**
     * The oversampling of the effect. Can either be "none", "2x" or "4x".
     */ get oversample() {
        return this._shaper.oversample;
    }
    set oversample(oversampling) {
        this._shaper.oversample = oversampling;
    }
    dispose() {
        super.dispose();
        this._shaper.dispose();
        return this;
    }
}








class $fcf44b813eed0eb7$export$125ce1b19cf7db0d extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(options){
        super(options);
        this.name = "FeedbackEffect";
        this._feedbackGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.feedback,
            units: "normalRange"
        });
        this.feedback = this._feedbackGain.gain;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "feedback");
        // the feedback loop
        this.effectReturn.chain(this._feedbackGain, this.effectSend);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            feedback: 0.125
        });
    }
    dispose() {
        super.dispose();
        this._feedbackGain.dispose();
        this.feedback.dispose();
        return this;
    }
}


class $7f2ffdf195e1ebb8$export$28e4d032ddc580fa extends (0, $fcf44b813eed0eb7$export$125ce1b19cf7db0d) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($7f2ffdf195e1ebb8$export$28e4d032ddc580fa.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]);
        super(options);
        this.name = "FeedbackDelay";
        this._delayNode = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            delayTime: options.delayTime,
            maxDelay: options.maxDelay
        });
        this.delayTime = this._delayNode.delayTime;
        // connect it up
        this.connectEffect(this._delayNode);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "delayTime");
    }
    static getDefaults() {
        return Object.assign((0, $fcf44b813eed0eb7$export$125ce1b19cf7db0d).getDefaults(), {
            delayTime: 0.25,
            maxDelay: 1
        });
    }
    dispose() {
        super.dispose();
        this._delayNode.dispose();
        this.delayTime.dispose();
        return this;
    }
}




class $8c6cd80796057282$export$fc0fd2e096a27936 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(options){
        super(options);
        this.name = "PhaseShiftAllpass";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The phase shifted output
         */ this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * The PhaseShifted allpass output
         */ this.offset90 = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        const allpassBank1Values = [
            0.6923878,
            0.9360654322959,
            0.988229522686,
            0.9987488452737
        ];
        const allpassBank2Values = [
            0.4021921162426,
            0.856171088242,
            0.9722909545651,
            0.9952884791278
        ];
        this._bank0 = this._createAllPassFilterBank(allpassBank1Values);
        this._bank1 = this._createAllPassFilterBank(allpassBank2Values);
        this._oneSampleDelay = this.context.createIIRFilter([
            0.0,
            1.0
        ], [
            1.0,
            0.0
        ]);
        // connect Allpass filter banks
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, ...this._bank0, this._oneSampleDelay, this.output);
        (0, $1dae52eee8c779dd$export$933c3b67552fb559)(this.input, ...this._bank1, this.offset90);
    }
    /**
     * Create all of the IIR filters from an array of values using the coefficient calculation.
     */ _createAllPassFilterBank(bankValues) {
        const nodes = bankValues.map((value)=>{
            const coefficients = [
                [
                    value * value,
                    0,
                    -1
                ],
                [
                    1,
                    0,
                    -(value * value)
                ]
            ];
            return this.context.createIIRFilter(coefficients[0], coefficients[1]);
        });
        return nodes;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this.output.dispose();
        this.offset90.dispose();
        this._bank0.forEach((f)=>f.disconnect());
        this._bank1.forEach((f)=>f.disconnect());
        this._oneSampleDelay.disconnect();
        return this;
    }
}










class $51c25c5d47cea6a8$export$183131474cdbc063 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($51c25c5d47cea6a8$export$183131474cdbc063.getDefaults(), arguments, [
            "frequency"
        ]);
        super(options);
        this.name = "FrequencyShifter";
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.frequency,
            minValue: -this.context.sampleRate / 2,
            maxValue: this.context.sampleRate / 2
        });
        this._sine = new (0, $6dd36306779dbefc$export$284532b021137a4a)({
            context: this.context,
            type: "sine"
        });
        this._cosine = new (0, $304d61465298e719$export$c01c5c7b81696d70)({
            context: this.context,
            phase: -90,
            type: "sine"
        });
        this._sineMultiply = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context
        });
        this._cosineMultiply = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context
        });
        this._negate = new (0, $12434edb56028935$export$a4e82151127277b0)({
            context: this.context
        });
        this._add = new (0, $ad8862926b54eb7c$export$d0265b2c425512d6)({
            context: this.context
        });
        this._phaseShifter = new (0, $8c6cd80796057282$export$fc0fd2e096a27936)({
            context: this.context
        });
        this.effectSend.connect(this._phaseShifter);
        // connect the carrier frequency signal to the two oscillators
        this.frequency.fan(this._sine.frequency, this._cosine.frequency);
        this._phaseShifter.offset90.connect(this._cosineMultiply);
        this._cosine.connect(this._cosineMultiply.factor);
        this._phaseShifter.connect(this._sineMultiply);
        this._sine.connect(this._sineMultiply.factor);
        this._sineMultiply.connect(this._negate);
        this._cosineMultiply.connect(this._add);
        this._negate.connect(this._add.addend);
        this._add.connect(this.effectReturn);
        // start the oscillators at the same time
        const now = this.immediate();
        this._sine.start(now);
        this._cosine.start(now);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            frequency: 0
        });
    }
    dispose() {
        super.dispose();
        this.frequency.dispose();
        this._add.dispose();
        this._cosine.dispose();
        this._cosineMultiply.dispose();
        this._negate.dispose();
        this._phaseShifter.dispose();
        this._sine.dispose();
        this._sineMultiply.dispose();
        return this;
    }
}







/**
 * An array of comb filter delay values from Freeverb implementation
 */ const $2aeaec223e48dd69$var$combFilterTunings = [
    1557 / 44100,
    1617 / 44100,
    1491 / 44100,
    1422 / 44100,
    1277 / 44100,
    1356 / 44100,
    1188 / 44100,
    1116 / 44100
];
/**
 * An array of allpass filter frequency values from Freeverb implementation
 */ const $2aeaec223e48dd69$var$allpassFilterFrequencies = [
    225,
    556,
    441,
    341
];
class $2aeaec223e48dd69$export$8f91cfa34e3c0ba extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2aeaec223e48dd69$export$8f91cfa34e3c0ba.getDefaults(), arguments, [
            "roomSize",
            "dampening"
        ]);
        super(options);
        this.name = "Freeverb";
        /**
         * the comb filters
         */ this._combFilters = [];
        /**
         * the allpass filters on the left
         */ this._allpassFiltersL = [];
        /**
         * the allpass filters on the right
         */ this._allpassFiltersR = [];
        this.roomSize = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.roomSize,
            units: "normalRange"
        });
        // make the allpass filters on the right
        this._allpassFiltersL = $2aeaec223e48dd69$var$allpassFilterFrequencies.map((freq)=>{
            const allpassL = this.context.createBiquadFilter();
            allpassL.type = "allpass";
            allpassL.frequency.value = freq;
            return allpassL;
        });
        // make the allpass filters on the left
        this._allpassFiltersR = $2aeaec223e48dd69$var$allpassFilterFrequencies.map((freq)=>{
            const allpassR = this.context.createBiquadFilter();
            allpassR.type = "allpass";
            allpassR.frequency.value = freq;
            return allpassR;
        });
        // make the comb filters
        this._combFilters = $2aeaec223e48dd69$var$combFilterTunings.map((delayTime, index)=>{
            const lfpf = new (0, $ef6d05ab4f866c0f$export$e83d2527589f5587)({
                context: this.context,
                dampening: options.dampening,
                delayTime: delayTime
            });
            if (index < $2aeaec223e48dd69$var$combFilterTunings.length / 2) this.connectEffectLeft(lfpf, ...this._allpassFiltersL);
            else this.connectEffectRight(lfpf, ...this._allpassFiltersR);
            this.roomSize.connect(lfpf.resonance);
            return lfpf;
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "roomSize"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            roomSize: 0.7,
            dampening: 3000
        });
    }
    /**
     * The amount of dampening of the reverberant signal.
     */ get dampening() {
        return this._combFilters[0].dampening;
    }
    set dampening(d) {
        this._combFilters.forEach((c)=>c.dampening = d);
    }
    dispose() {
        super.dispose();
        this._allpassFiltersL.forEach((al)=>al.disconnect());
        this._allpassFiltersR.forEach((ar)=>ar.disconnect());
        this._combFilters.forEach((cf)=>cf.dispose());
        this.roomSize.dispose();
        return this;
    }
}








/**
 * an array of the comb filter delay time values
 */ const $8d68cf8c147e14db$var$combFilterDelayTimes = [
    0.06748,
    0.06404,
    0.08212,
    0.09004
];
/**
 * the resonances of each of the comb filters
 */ const $8d68cf8c147e14db$var$combFilterResonances = [
    0.773,
    0.802,
    0.753,
    0.733
];
/**
 * the allpass filter frequencies
 */ const $8d68cf8c147e14db$var$allpassFilterFreqs = [
    347,
    113,
    37
];
class $8d68cf8c147e14db$export$d0cb5d67c6f5133d extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($8d68cf8c147e14db$export$d0cb5d67c6f5133d.getDefaults(), arguments, [
            "roomSize"
        ]);
        super(options);
        this.name = "JCReverb";
        /**
         * a series of allpass filters
         */ this._allpassFilters = [];
        /**
         * parallel feedback comb filters
         */ this._feedbackCombFilters = [];
        this.roomSize = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.roomSize,
            units: "normalRange"
        });
        this._scaleRoomSize = new (0, $d4646d969ab22afc$export$d60cfc58d3c358b6)({
            context: this.context,
            min: -0.733,
            max: 0.197
        });
        // make the allpass filters
        this._allpassFilters = $8d68cf8c147e14db$var$allpassFilterFreqs.map((freq)=>{
            const allpass = this.context.createBiquadFilter();
            allpass.type = "allpass";
            allpass.frequency.value = freq;
            return allpass;
        });
        // and the comb filters
        this._feedbackCombFilters = $8d68cf8c147e14db$var$combFilterDelayTimes.map((delayTime, index)=>{
            const fbcf = new (0, $39e0d797402e4e21$export$e7a685a7e8ffb78a)({
                context: this.context,
                delayTime: delayTime
            });
            this._scaleRoomSize.connect(fbcf.resonance);
            fbcf.resonance.value = $8d68cf8c147e14db$var$combFilterResonances[index];
            if (index < $8d68cf8c147e14db$var$combFilterDelayTimes.length / 2) this.connectEffectLeft(...this._allpassFilters, fbcf);
            else this.connectEffectRight(...this._allpassFilters, fbcf);
            return fbcf;
        });
        // chain the allpass filters together
        this.roomSize.connect(this._scaleRoomSize);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "roomSize"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            roomSize: 0.5
        });
    }
    dispose() {
        super.dispose();
        this._allpassFilters.forEach((apf)=>apf.disconnect());
        this._feedbackCombFilters.forEach((fbcf)=>fbcf.dispose());
        this.roomSize.dispose();
        this._scaleRoomSize.dispose();
        return this;
    }
}




class $b1f4f96c5094decb$export$a40db16ae36574f7 extends (0, $ef3d96dfca708839$export$d911e987c738486e) {
    constructor(options){
        super(options);
        // the left output connected to the right input
        this._feedbackL.disconnect();
        this._feedbackL.connect(this._feedbackMerge, 0, 1);
        // the left output connected to the right input
        this._feedbackR.disconnect();
        this._feedbackR.connect(this._feedbackMerge, 0, 0);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "feedback"
        ]);
    }
}






class $dc7e67c384875c83$export$7920b8962af65831 extends (0, $b1f4f96c5094decb$export$a40db16ae36574f7) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($dc7e67c384875c83$export$7920b8962af65831.getDefaults(), arguments, [
            "delayTime",
            "feedback"
        ]);
        super(options);
        this.name = "PingPongDelay";
        this._leftDelay = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this._rightDelay = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this._rightPreDelay = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            maxDelay: options.maxDelay
        });
        this.delayTime = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "time",
            value: options.delayTime
        });
        // connect it up
        this.connectEffectLeft(this._leftDelay);
        this.connectEffectRight(this._rightPreDelay, this._rightDelay);
        this.delayTime.fan(this._leftDelay.delayTime, this._rightDelay.delayTime, this._rightPreDelay.delayTime);
        // rearranged the feedback to be after the rightPreDelay
        this._feedbackL.disconnect();
        this._feedbackL.connect(this._rightDelay);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "delayTime"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $b1f4f96c5094decb$export$a40db16ae36574f7).getDefaults(), {
            delayTime: 0.25,
            maxDelay: 1
        });
    }
    dispose() {
        super.dispose();
        this._leftDelay.dispose();
        this._rightDelay.dispose();
        this._rightPreDelay.dispose();
        this.delayTime.dispose();
        return this;
    }
}










class $cd6978095473e468$export$996a02cfaea06f8f extends (0, $fcf44b813eed0eb7$export$125ce1b19cf7db0d) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cd6978095473e468$export$996a02cfaea06f8f.getDefaults(), arguments, [
            "pitch"
        ]);
        super(options);
        this.name = "PitchShift";
        this._frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context
        });
        this._delayA = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            maxDelay: 1,
            context: this.context
        });
        this._lfoA = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            min: 0,
            max: 0.1,
            type: "sawtooth"
        }).connect(this._delayA.delayTime);
        this._delayB = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            maxDelay: 1,
            context: this.context
        });
        this._lfoB = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            min: 0,
            max: 0.1,
            type: "sawtooth",
            phase: 180
        }).connect(this._delayB.delayTime);
        this._crossFade = new (0, $edbbeae191c550fb$export$d78c8c6074541cf2)({
            context: this.context
        });
        this._crossFadeLFO = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            min: 0,
            max: 1,
            type: "triangle",
            phase: 90
        }).connect(this._crossFade.fade);
        this._feedbackDelay = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            delayTime: options.delayTime,
            context: this.context
        });
        this.delayTime = this._feedbackDelay.delayTime;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "delayTime");
        this._pitch = options.pitch;
        this._windowSize = options.windowSize;
        // connect the two delay lines up
        this._delayA.connect(this._crossFade.a);
        this._delayB.connect(this._crossFade.b);
        // connect the frequency
        this._frequency.fan(this._lfoA.frequency, this._lfoB.frequency, this._crossFadeLFO.frequency);
        // route the input
        this.effectSend.fan(this._delayA, this._delayB);
        this._crossFade.chain(this._feedbackDelay, this.effectReturn);
        // start the LFOs at the same time
        const now = this.now();
        this._lfoA.start(now);
        this._lfoB.start(now);
        this._crossFadeLFO.start(now);
        // set the initial value
        this.windowSize = this._windowSize;
    }
    static getDefaults() {
        return Object.assign((0, $fcf44b813eed0eb7$export$125ce1b19cf7db0d).getDefaults(), {
            pitch: 0,
            windowSize: 0.1,
            delayTime: 0,
            feedback: 0
        });
    }
    /**
     * Repitch the incoming signal by some interval (measured in semi-tones).
     * @example
     * const pitchShift = new Tone.PitchShift().toDestination();
     * const osc = new Tone.Oscillator().connect(pitchShift).start().toDestination();
     * pitchShift.pitch = -12; // down one octave
     * pitchShift.pitch = 7; // up a fifth
     */ get pitch() {
        return this._pitch;
    }
    set pitch(interval) {
        this._pitch = interval;
        let factor = 0;
        if (interval < 0) {
            this._lfoA.min = 0;
            this._lfoA.max = this._windowSize;
            this._lfoB.min = 0;
            this._lfoB.max = this._windowSize;
            factor = (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(interval - 1) + 1;
        } else {
            this._lfoA.min = this._windowSize;
            this._lfoA.max = 0;
            this._lfoB.min = this._windowSize;
            this._lfoB.max = 0;
            factor = (0, $84c2af7dbf01a14d$export$5d18fe46719f6008)(interval) - 1;
        }
        this._frequency.value = factor * (1.2 / this._windowSize);
    }
    /**
     * The window size corresponds roughly to the sample length in a looping sampler.
     * Smaller values are desirable for a less noticeable delay time of the pitch shifted
     * signal, but larger values will result in smoother pitch shifting for larger intervals.
     * A nominal range of 0.03 to 0.1 is recommended.
     */ get windowSize() {
        return this._windowSize;
    }
    set windowSize(size) {
        this._windowSize = this.toSeconds(size);
        this.pitch = this._pitch;
    }
    dispose() {
        super.dispose();
        this._frequency.dispose();
        this._delayA.dispose();
        this._delayB.dispose();
        this._lfoA.dispose();
        this._lfoB.dispose();
        this._crossFade.dispose();
        this._crossFadeLFO.dispose();
        this._feedbackDelay.dispose();
        return this;
    }
}







class $cea3b54a2bdd8e6c$export$1be4418d8537c3f5 extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cea3b54a2bdd8e6c$export$1be4418d8537c3f5.getDefaults(), arguments, [
            "frequency",
            "octaves",
            "baseFrequency"
        ]);
        super(options);
        this.name = "Phaser";
        this._lfoL = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1
        });
        this._lfoR = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            frequency: options.frequency,
            min: 0,
            max: 1,
            phase: 180
        });
        this._baseFrequency = this.toFrequency(options.baseFrequency);
        this._octaves = options.octaves;
        this.Q = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.Q,
            units: "positive"
        });
        this._filtersL = this._makeFilters(options.stages, this._lfoL);
        this._filtersR = this._makeFilters(options.stages, this._lfoR);
        this.frequency = this._lfoL.frequency;
        this.frequency.value = options.frequency;
        // connect them up
        this.connectEffectLeft(...this._filtersL);
        this.connectEffectRight(...this._filtersR);
        // control the frequency with one LFO
        this._lfoL.frequency.connect(this._lfoR.frequency);
        // set the options
        this.baseFrequency = options.baseFrequency;
        this.octaves = options.octaves;
        // start the lfo
        this._lfoL.start();
        this._lfoR.start();
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "Q"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            frequency: 0.5,
            octaves: 3,
            stages: 10,
            Q: 10,
            baseFrequency: 350
        });
    }
    _makeFilters(stages, connectToFreq) {
        const filters = [];
        // make all the filters
        for(let i = 0; i < stages; i++){
            const filter = this.context.createBiquadFilter();
            filter.type = "allpass";
            this.Q.connect(filter.Q);
            connectToFreq.connect(filter.frequency);
            filters.push(filter);
        }
        return filters;
    }
    /**
     * The number of octaves the phase goes above the baseFrequency
     */ get octaves() {
        return this._octaves;
    }
    set octaves(octaves) {
        this._octaves = octaves;
        const max = this._baseFrequency * Math.pow(2, octaves);
        this._lfoL.max = max;
        this._lfoR.max = max;
    }
    /**
     * The the base frequency of the filters.
     */ get baseFrequency() {
        return this._baseFrequency;
    }
    set baseFrequency(freq) {
        this._baseFrequency = this.toFrequency(freq);
        this._lfoL.min = this._baseFrequency;
        this._lfoR.min = this._baseFrequency;
        this.octaves = this._octaves;
    }
    dispose() {
        super.dispose();
        this.Q.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._filtersL.forEach((f)=>f.disconnect());
        this._filtersR.forEach((f)=>f.disconnect());
        this.frequency.dispose();
        return this;
    }
}











class $e421cdcda956c3b5$export$6fb1520d4329a18d extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($e421cdcda956c3b5$export$6fb1520d4329a18d.getDefaults(), arguments, [
            "decay"
        ]);
        super(options);
        this.name = "Reverb";
        /**
         * Convolver node
         */ this._convolver = this.context.createConvolver();
        /**
         * Resolves when the reverb buffer is generated. Whenever either {@link decay}
         * or {@link preDelay} are set, you have to wait until {@link ready} resolves
         * before the IR is generated with the latest values.
         */ this.ready = Promise.resolve();
        this._decay = options.decay;
        this._preDelay = options.preDelay;
        this.generate();
        this.connectEffect(this._convolver);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            decay: 1.5,
            preDelay: 0.01
        });
    }
    /**
     * The duration of the reverb.
     */ get decay() {
        return this._decay;
    }
    set decay(time) {
        time = this.toSeconds(time);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(time, 0.001);
        this._decay = time;
        this.generate();
    }
    /**
     * The amount of time before the reverb is fully ramped in.
     */ get preDelay() {
        return this._preDelay;
    }
    set preDelay(time) {
        time = this.toSeconds(time);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(time, 0);
        this._preDelay = time;
        this.generate();
    }
    /**
     * Generate the Impulse Response. Returns a promise while the IR is being generated.
     * @return Promise which returns this object.
     */ generate() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const previousReady = this.ready;
            // create a noise burst which decays over the duration in each channel
            const context = new (0, $815e2eef5c5fc2a8$export$46814dd5412c611c)(2, this._decay + this._preDelay, this.context.sampleRate);
            const noiseL = new (0, $93a0a7e8f19a773f$export$484d33a0500a4ce1)({
                context: context
            });
            const noiseR = new (0, $93a0a7e8f19a773f$export$484d33a0500a4ce1)({
                context: context
            });
            const merge = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
                context: context
            });
            noiseL.connect(merge, 0, 0);
            noiseR.connect(merge, 0, 1);
            const gainNode = new (0, $10a186a98a559639$export$acd19d919666900d)({
                context: context
            }).toDestination();
            merge.connect(gainNode);
            noiseL.start(0);
            noiseR.start(0);
            // predelay
            gainNode.gain.setValueAtTime(0, 0);
            gainNode.gain.setValueAtTime(1, this._preDelay);
            // decay
            gainNode.gain.exponentialApproachValueAtTime(0, this._preDelay, this.decay);
            // render the buffer
            const renderPromise = context.render();
            this.ready = renderPromise.then((0, $8cce0c9e2019bc8a$export$b50b6e108474309b));
            // wait for the previous `ready` to resolve
            yield previousReady;
            // set the buffer
            this._convolver.buffer = (yield renderPromise).get();
            return this;
        });
    }
    dispose() {
        super.dispose();
        this._convolver.disconnect();
        return this;
    }
}









class $19a08d555cfc2bca$export$17b3caaa07b8690f extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($19a08d555cfc2bca$export$17b3caaa07b8690f.getDefaults(), arguments));
        this.name = "MidSideSplit";
        this._split = this.input = new (0, $41adc9bb2ea0d651$export$f836382419f64c98)({
            channels: 2,
            context: this.context
        });
        this._midAdd = new (0, $ad8862926b54eb7c$export$d0265b2c425512d6)({
            context: this.context
        });
        this.mid = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._sideSubtract = new (0, $270e4189b1a75906$export$8bc67ae85ef4b74f)({
            context: this.context
        });
        this.side = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._split.connect(this._midAdd, 0);
        this._split.connect(this._midAdd.addend, 1);
        this._split.connect(this._sideSubtract, 0);
        this._split.connect(this._sideSubtract.subtrahend, 1);
        this._midAdd.connect(this.mid);
        this._sideSubtract.connect(this.side);
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._midAdd.dispose();
        this._sideSubtract.dispose();
        this._split.dispose();
        return this;
    }
}









class $166d7e4e0737e4ca$export$be84ddbe7b4fbb5a extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($166d7e4e0737e4ca$export$be84ddbe7b4fbb5a.getDefaults(), arguments));
        this.name = "MidSideMerge";
        this.mid = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.side = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._left = new (0, $ad8862926b54eb7c$export$d0265b2c425512d6)({
            context: this.context
        });
        this._leftMult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._right = new (0, $270e4189b1a75906$export$8bc67ae85ef4b74f)({
            context: this.context
        });
        this._rightMult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: Math.SQRT1_2
        });
        this._merge = this.output = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
            context: this.context
        });
        this.mid.fan(this._left);
        this.side.connect(this._left.addend);
        this.mid.connect(this._right);
        this.side.connect(this._right.subtrahend);
        this._left.connect(this._leftMult);
        this._right.connect(this._rightMult);
        this._leftMult.connect(this._merge, 0, 0);
        this._rightMult.connect(this._merge, 0, 1);
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._leftMult.dispose();
        this._rightMult.dispose();
        this._left.dispose();
        this._right.dispose();
        return this;
    }
}


class $bfbd5e906f28fdb9$export$67948bb93e06c2e extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(options){
        super(options);
        this.name = "MidSideEffect";
        this._midSideMerge = new (0, $166d7e4e0737e4ca$export$be84ddbe7b4fbb5a)({
            context: this.context
        });
        this._midSideSplit = new (0, $19a08d555cfc2bca$export$17b3caaa07b8690f)({
            context: this.context
        });
        this._midSend = this._midSideSplit.mid;
        this._sideSend = this._midSideSplit.side;
        this._midReturn = this._midSideMerge.mid;
        this._sideReturn = this._midSideMerge.side;
        // the connections
        this.effectSend.connect(this._midSideSplit);
        this._midSideMerge.connect(this.effectReturn);
    }
    /**
     * Connect the mid chain of the effect
     */ connectEffectMid(...nodes) {
        this._midSend.chain(...nodes, this._midReturn);
    }
    /**
     * Connect the side chain of the effect
     */ connectEffectSide(...nodes) {
        this._sideSend.chain(...nodes, this._sideReturn);
    }
    dispose() {
        super.dispose();
        this._midSideSplit.dispose();
        this._midSideMerge.dispose();
        this._midSend.dispose();
        this._sideSend.dispose();
        this._midReturn.dispose();
        this._sideReturn.dispose();
        return this;
    }
}








class $5e555b5fa19b4791$export$54593a5432d0d54c extends (0, $bfbd5e906f28fdb9$export$67948bb93e06c2e) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($5e555b5fa19b4791$export$54593a5432d0d54c.getDefaults(), arguments, [
            "width"
        ]);
        super(options);
        this.name = "StereoWidener";
        this.width = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.width,
            units: "normalRange"
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "width"
        ]);
        this._twoTimesWidthMid = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: 2
        });
        this._twoTimesWidthSide = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context,
            value: 2
        });
        this._midMult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context
        });
        this._twoTimesWidthMid.connect(this._midMult.factor);
        this.connectEffectMid(this._midMult);
        this._oneMinusWidth = new (0, $270e4189b1a75906$export$8bc67ae85ef4b74f)({
            context: this.context
        });
        this._oneMinusWidth.connect(this._twoTimesWidthMid);
        (0, $1dae52eee8c779dd$export$64605811ab45167f)(this.context.getConstant(1), this._oneMinusWidth);
        this.width.connect(this._oneMinusWidth.subtrahend);
        this._sideMult = new (0, $3f90bb22f26a3ab2$export$f14f83b3b531d498)({
            context: this.context
        });
        this.width.connect(this._twoTimesWidthSide);
        this._twoTimesWidthSide.connect(this._sideMult.factor);
        this.connectEffectSide(this._sideMult);
    }
    static getDefaults() {
        return Object.assign((0, $bfbd5e906f28fdb9$export$67948bb93e06c2e).getDefaults(), {
            width: 0.5
        });
    }
    dispose() {
        super.dispose();
        this.width.dispose();
        this._midMult.dispose();
        this._sideMult.dispose();
        this._twoTimesWidthMid.dispose();
        this._twoTimesWidthSide.dispose();
        this._oneMinusWidth.dispose();
        return this;
    }
}








class $18ff96fe0a1aec28$export$74a4578e446afdc7 extends (0, $915a8f1363471442$export$f02761adf21def8a) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($18ff96fe0a1aec28$export$74a4578e446afdc7.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]);
        super(options);
        this.name = "Tremolo";
        this._lfoL = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            type: options.type,
            min: 1,
            max: 0
        });
        this._lfoR = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            type: options.type,
            min: 1,
            max: 0
        });
        this._amplitudeL = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._amplitudeR = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.frequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.frequency,
            units: "frequency"
        });
        this.depth = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            value: options.depth,
            units: "normalRange"
        });
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "depth"
        ]);
        this.connectEffectLeft(this._amplitudeL);
        this.connectEffectRight(this._amplitudeR);
        this._lfoL.connect(this._amplitudeL.gain);
        this._lfoR.connect(this._amplitudeR.gain);
        this.frequency.fan(this._lfoL.frequency, this._lfoR.frequency);
        this.depth.fan(this._lfoR.amplitude, this._lfoL.amplitude);
        this.spread = options.spread;
    }
    static getDefaults() {
        return Object.assign((0, $915a8f1363471442$export$f02761adf21def8a).getDefaults(), {
            frequency: 10,
            type: "sine",
            depth: 0.5,
            spread: 180
        });
    }
    /**
     * Start the tremolo.
     */ start(time) {
        this._lfoL.start(time);
        this._lfoR.start(time);
        return this;
    }
    /**
     * Stop the tremolo.
     */ stop(time) {
        this._lfoL.stop(time);
        this._lfoR.stop(time);
        return this;
    }
    /**
     * Sync the effect to the transport.
     */ sync() {
        this._lfoL.sync();
        this._lfoR.sync();
        this.context.transport.syncSignal(this.frequency);
        return this;
    }
    /**
     * Unsync the filter from the transport
     */ unsync() {
        this._lfoL.unsync();
        this._lfoR.unsync();
        this.context.transport.unsyncSignal(this.frequency);
        return this;
    }
    /**
     * The oscillator type.
     */ get type() {
        return this._lfoL.type;
    }
    set type(type) {
        this._lfoL.type = type;
        this._lfoR.type = type;
    }
    /**
     * Amount of stereo spread. When set to 0, both LFO's will be panned centrally.
     * When set to 180, LFO's will be panned hard left and right respectively.
     */ get spread() {
        return this._lfoR.phase - this._lfoL.phase; // 180
    }
    set spread(spread) {
        this._lfoL.phase = 90 - spread / 2;
        this._lfoR.phase = spread / 2 + 90;
    }
    dispose() {
        super.dispose();
        this._lfoL.dispose();
        this._lfoR.dispose();
        this._amplitudeL.dispose();
        this._amplitudeR.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}







class $39c7f7b701ff2506$export$eb898fc31d087455 extends (0, $55a557a844190520$export$a32b0b1c1ac59d04) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($39c7f7b701ff2506$export$eb898fc31d087455.getDefaults(), arguments, [
            "frequency",
            "depth"
        ]);
        super(options);
        this.name = "Vibrato";
        this._delayNode = new (0, $89c598137ecf8dce$export$7419ff430885d61c)({
            context: this.context,
            delayTime: 0,
            maxDelay: options.maxDelay
        });
        this._lfo = new (0, $e29fd7f03d7e26e3$export$603054d5ec296d77)({
            context: this.context,
            type: options.type,
            min: 0,
            max: options.maxDelay,
            frequency: options.frequency,
            phase: -90
        }).start().connect(this._delayNode.delayTime);
        this.frequency = this._lfo.frequency;
        this.depth = this._lfo.amplitude;
        this.depth.value = options.depth;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "frequency",
            "depth"
        ]);
        this.effectSend.chain(this._delayNode, this.effectReturn);
    }
    static getDefaults() {
        return Object.assign((0, $55a557a844190520$export$a32b0b1c1ac59d04).getDefaults(), {
            maxDelay: 0.005,
            frequency: 5,
            depth: 0.1,
            type: "sine"
        });
    }
    /**
     * Type of oscillator attached to the Vibrato.
     */ get type() {
        return this._lfo.type;
    }
    set type(type) {
        this._lfo.type = type;
    }
    dispose() {
        super.dispose();
        this._delayNode.dispose();
        this._lfo.dispose();
        this.frequency.dispose();
        this.depth.dispose();
        return this;
    }
}









class $1f00f651da26f3c8$export$86a05438820989b0 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($1f00f651da26f3c8$export$86a05438820989b0.getDefaults(), arguments, [
            "type",
            "size"
        ]);
        super(options);
        this.name = "Analyser";
        /**
         * The analyser node.
         */ this._analysers = [];
        /**
         * The buffer that the FFT data is written to
         */ this._buffers = [];
        this.input = this.output = this._gain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._split = new (0, $41adc9bb2ea0d651$export$f836382419f64c98)({
            context: this.context,
            channels: options.channels
        });
        this.input.connect(this._split);
        (0, $afc9146c77d080c2$export$6698b6d148bc9b0c)(options.channels, 1);
        // create the analysers
        for(let channel = 0; channel < options.channels; channel++){
            this._analysers[channel] = this.context.createAnalyser();
            this._split.connect(this._analysers[channel], channel, 0);
        }
        // set the values initially
        this.size = options.size;
        this.type = options.type;
        this.smoothing = options.smoothing;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            size: 1024,
            smoothing: 0.8,
            type: "fft",
            channels: 1
        });
    }
    /**
     * Run the analysis given the current settings. If {@link channels} = 1,
     * it will return a Float32Array. If {@link channels} > 1, it will
     * return an array of Float32Arrays where each index in the array
     * represents the analysis done on a channel.
     */ getValue() {
        this._analysers.forEach((analyser, index)=>{
            const buffer = this._buffers[index];
            if (this._type === "fft") analyser.getFloatFrequencyData(buffer);
            else if (this._type === "waveform") analyser.getFloatTimeDomainData(buffer);
        });
        if (this.channels === 1) return this._buffers[0];
        else return this._buffers;
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     */ get size() {
        return this._analysers[0].frequencyBinCount;
    }
    set size(size) {
        this._analysers.forEach((analyser, index)=>{
            analyser.fftSize = size * 2;
            this._buffers[index] = new Float32Array(size);
        });
    }
    /**
     * The number of channels the analyser does the analysis on. Channel
     * separation is done using {@link Split}
     */ get channels() {
        return this._analysers.length;
    }
    /**
     * The analysis function returned by analyser.getValue(), either "fft" or "waveform".
     */ get type() {
        return this._type;
    }
    set type(type) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(type === "waveform" || type === "fft", `Analyser: invalid type: ${type}`);
        this._type = type;
    }
    /**
     * 0 represents no time averaging with the last analysis frame.
     */ get smoothing() {
        return this._analysers[0].smoothingTimeConstant;
    }
    set smoothing(val) {
        this._analysers.forEach((a)=>a.smoothingTimeConstant = val);
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        this._analysers.forEach((a)=>a.disconnect());
        this._split.dispose();
        this._gain.dispose();
        return this;
    }
}







class $2310c477c62ba237$export$67f5eb90858fca69 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($2310c477c62ba237$export$67f5eb90858fca69.getDefaults(), arguments));
        this.name = "MeterBase";
        this.input = this.output = this._analyser = new (0, $1f00f651da26f3c8$export$86a05438820989b0)({
            context: this.context,
            size: 256,
            type: "waveform"
        });
    }
    dispose() {
        super.dispose();
        this._analyser.dispose();
        return this;
    }
}




class $93ce187344e44f5e$export$62e3ae2a4090b879 extends (0, $2310c477c62ba237$export$67f5eb90858fca69) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($93ce187344e44f5e$export$62e3ae2a4090b879.getDefaults(), arguments, [
            "smoothing"
        ]);
        super(options);
        this.name = "Meter";
        this.input = this.output = this._analyser = new (0, $1f00f651da26f3c8$export$86a05438820989b0)({
            context: this.context,
            size: 256,
            type: "waveform",
            channels: options.channelCount
        });
        this.smoothing = options.smoothing, this.normalRange = options.normalRange;
        this._rms = new Array(options.channelCount);
        this._rms.fill(0);
    }
    static getDefaults() {
        return Object.assign((0, $2310c477c62ba237$export$67f5eb90858fca69).getDefaults(), {
            smoothing: 0.8,
            normalRange: false,
            channelCount: 1
        });
    }
    /**
     * Use {@link getValue} instead. For the previous getValue behavior, use DCMeter.
     * @deprecated
     */ getLevel() {
        (0, $afc9146c77d080c2$export$c106dd0671a0fc2d)("'getLevel' has been changed to 'getValue'");
        return this.getValue();
    }
    /**
     * Get the current value of the incoming signal.
     * Output is in decibels when {@link normalRange} is `false`.
     * If {@link channels} = 1, then the output is a single number
     * representing the value of the input signal. When {@link channels} > 1,
     * then each channel is returned as a value in a number array.
     */ getValue() {
        const aValues = this._analyser.getValue();
        const channelValues = this.channels === 1 ? [
            aValues
        ] : aValues;
        const vals = channelValues.map((values, index)=>{
            const totalSquared = values.reduce((total, current)=>total + current * current, 0);
            const rms = Math.sqrt(totalSquared / values.length);
            // the rms can only fall at the rate of the smoothing
            // but can jump up instantly
            this._rms[index] = Math.max(rms, this._rms[index] * this.smoothing);
            return this.normalRange ? this._rms[index] : (0, $84c2af7dbf01a14d$export$6af3969727ca2a60)(this._rms[index]);
        });
        if (this.channels === 1) return vals[0];
        else return vals;
    }
    /**
     * The number of channels of analysis.
     */ get channels() {
        return this._analyser.channels;
    }
    dispose() {
        super.dispose();
        this._analyser.dispose();
        return this;
    }
}







class $98236c1e3c0a17e3$export$677347237c014ba extends (0, $2310c477c62ba237$export$67f5eb90858fca69) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($98236c1e3c0a17e3$export$677347237c014ba.getDefaults(), arguments, [
            "size"
        ]);
        super(options);
        this.name = "FFT";
        this.normalRange = options.normalRange;
        this._analyser.type = "fft";
        this.size = options.size;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            normalRange: false,
            size: 1024,
            smoothing: 0.8
        });
    }
    /**
     * Gets the current frequency data from the connected audio source.
     * Returns the frequency data of length {@link size} as a Float32Array of decibel values.
     */ getValue() {
        const values = this._analyser.getValue();
        return values.map((v)=>this.normalRange ? (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(v) : v);
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     * Determines the size of the array returned by {@link getValue} (i.e. the number of
     * frequency bins). Large FFT sizes may be costly to compute.
     */ get size() {
        return this._analyser.size;
    }
    set size(size) {
        this._analyser.size = size;
    }
    /**
     * 0 represents no time averaging with the last analysis frame.
     */ get smoothing() {
        return this._analyser.smoothing;
    }
    set smoothing(val) {
        this._analyser.smoothing = val;
    }
    /**
     * Returns the frequency value in hertz of each of the indices of the FFT's {@link getValue} response.
     * @example
     * const fft = new Tone.FFT(32);
     * console.log([0, 1, 2, 3, 4].map(index => fft.getFrequencyOfIndex(index)));
     */ getFrequencyOfIndex(index) {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(0 <= index && index < this.size, `index must be greater than or equal to 0 and less than ${this.size}`);
        return index * this.context.sampleRate / (this.size * 2);
    }
}




class $873fd3dda72326af$export$29aa14d256c74cc6 extends (0, $2310c477c62ba237$export$67f5eb90858fca69) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($873fd3dda72326af$export$29aa14d256c74cc6.getDefaults(), arguments));
        this.name = "DCMeter";
        this._analyser.type = "waveform";
        this._analyser.size = 256;
    }
    /**
     * Get the signal value of the incoming signal
     */ getValue() {
        const value = this._analyser.getValue();
        return value[0];
    }
}




class $cc680edd8ffd9180$export$4c2f72a4f17a358e extends (0, $2310c477c62ba237$export$67f5eb90858fca69) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($cc680edd8ffd9180$export$4c2f72a4f17a358e.getDefaults(), arguments, [
            "size"
        ]);
        super(options);
        this.name = "Waveform";
        this._analyser.type = "waveform";
        this.size = options.size;
    }
    static getDefaults() {
        return Object.assign((0, $2310c477c62ba237$export$67f5eb90858fca69).getDefaults(), {
            size: 1024
        });
    }
    /**
     * Return the waveform for the current time as a Float32Array where each value in the array
     * represents a sample in the waveform.
     */ getValue() {
        return this._analyser.getValue();
    }
    /**
     * The size of analysis. This must be a power of two in the range 16 to 16384.
     * Determines the size of the array returned by {@link getValue}.
     */ get size() {
        return this._analyser.size;
    }
    set size(size) {
        this._analyser.size = size;
    }
}








class $029368b9c74b1b72$export$43343ff6c11f7ee5 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($029368b9c74b1b72$export$43343ff6c11f7ee5.getDefaults(), arguments, [
            "solo"
        ]);
        super(options);
        this.name = "Solo";
        this.input = this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        if (!$029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.has(this.context)) $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.set(this.context, new Set());
        $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.get(this.context).add(this);
        // set initially
        this.solo = options.solo;
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            solo: false
        });
    }
    /**
     * Isolates this instance and mutes all other instances of Solo.
     * Only one instance can be soloed at a time. A soloed
     * instance will report `solo=false` when another instance is soloed.
     */ get solo() {
        return this._isSoloed();
    }
    set solo(solo) {
        if (solo) this._addSolo();
        else this._removeSolo();
        $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.get(this.context).forEach((instance)=>instance._updateSolo());
    }
    /**
     * If the current instance is muted, i.e. another instance is soloed
     */ get muted() {
        return this.input.gain.value === 0;
    }
    /**
     * Add this to the soloed array
     */ _addSolo() {
        if (!$029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context)) $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.set(this.context, new Set());
        $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.get(this.context).add(this);
    }
    /**
     * Remove this from the soloed array
     */ _removeSolo() {
        if ($029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context)) $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.get(this.context).delete(this);
    }
    /**
     * Is this on the soloed array
     */ _isSoloed() {
        return $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context) && $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.get(this.context).has(this);
    }
    /**
     * Returns true if no one is soloed
     */ _noSolos() {
        // either does not have any soloed added
        return !$029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context) || // or has a solo set but doesn't include any items
        $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.has(this.context) && $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed.get(this.context).size === 0;
    }
    /**
     * Solo the current instance and unsolo all other instances.
     */ _updateSolo() {
        if (this._isSoloed()) this.input.gain.value = 1;
        else if (this._noSolos()) // no one is soloed
        this.input.gain.value = 1;
        else this.input.gain.value = 0;
    }
    dispose() {
        super.dispose();
        $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos.get(this.context).delete(this);
        this._removeSolo();
        return this;
    }
}
/**
 * Hold all of the solo'ed tracks belonging to a specific context
 */ $029368b9c74b1b72$export$43343ff6c11f7ee5._allSolos = new Map();
/**
 * Hold the currently solo'ed instance(s)
 */ $029368b9c74b1b72$export$43343ff6c11f7ee5._soloed = new Map();







class $35f89e90159c405d$export$e62efb0df83a5c7c extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($35f89e90159c405d$export$e62efb0df83a5c7c.getDefaults(), arguments, [
            "pan",
            "volume"
        ]);
        super(options);
        this.name = "PanVol";
        this._panner = this.input = new (0, $3104cbf8d2a8337f$export$d6d7a1629e59823d)({
            context: this.context,
            pan: options.pan,
            channelCount: options.channelCount
        });
        this.pan = this._panner.pan;
        this._volume = this.output = new (0, $0515efee749e4f6d$export$dde279e52d625429)({
            context: this.context,
            volume: options.volume
        });
        this.volume = this._volume.volume;
        // connections
        this._panner.connect(this._volume);
        this.mute = options.mute;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "pan",
            "volume"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mute: false,
            pan: 0,
            volume: 0,
            channelCount: 1
        });
    }
    /**
     * Mute/unmute the volume
     */ get mute() {
        return this._volume.mute;
    }
    set mute(mute) {
        this._volume.mute = mute;
    }
    dispose() {
        super.dispose();
        this._panner.dispose();
        this.pan.dispose();
        this._volume.dispose();
        this.volume.dispose();
        return this;
    }
}




class $01b9d2d997527d24$export$cfdacaa37f9b4dd7 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($01b9d2d997527d24$export$cfdacaa37f9b4dd7.getDefaults(), arguments, [
            "volume",
            "pan"
        ]);
        super(options);
        this.name = "Channel";
        this._solo = this.input = new (0, $029368b9c74b1b72$export$43343ff6c11f7ee5)({
            solo: options.solo,
            context: this.context
        });
        this._panVol = this.output = new (0, $35f89e90159c405d$export$e62efb0df83a5c7c)({
            context: this.context,
            pan: options.pan,
            volume: options.volume,
            mute: options.mute,
            channelCount: options.channelCount
        });
        this.pan = this._panVol.pan;
        this.volume = this._panVol.volume;
        this._solo.connect(this._panVol);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "pan",
            "volume"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            pan: 0,
            volume: 0,
            mute: false,
            solo: false,
            channelCount: 1
        });
    }
    /**
     * Solo/unsolo the channel. Soloing is only relative to other {@link Channel}s and {@link Solo} instances
     */ get solo() {
        return this._solo.solo;
    }
    set solo(solo) {
        this._solo.solo = solo;
    }
    /**
     * If the current instance is muted, i.e. another instance is soloed,
     * or the channel is muted
     */ get muted() {
        return this._solo.muted || this.mute;
    }
    /**
     * Mute/unmute the volume
     */ get mute() {
        return this._panVol.mute;
    }
    set mute(mute) {
        this._panVol.mute = mute;
    }
    /**
     * Get the gain node belonging to the bus name. Create it if
     * it doesn't exist
     * @param name The bus name
     */ _getBus(name) {
        if (!$01b9d2d997527d24$export$cfdacaa37f9b4dd7.buses.has(name)) $01b9d2d997527d24$export$cfdacaa37f9b4dd7.buses.set(name, new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        }));
        return $01b9d2d997527d24$export$cfdacaa37f9b4dd7.buses.get(name);
    }
    /**
     * Send audio to another channel using a string. `send` is a lot like
     * {@link connect}, except it uses a string instead of an object. This can
     * be useful in large applications to decouple sections since {@link send}
     * and {@link receive} can be invoked separately in order to connect an object
     * @param name The channel name to send the audio
     * @param volume The amount of the signal to send.
     * 	Defaults to 0db, i.e. send the entire signal
     * @returns Returns the gain node of this connection.
     */ send(name, volume = 0) {
        const bus = this._getBus(name);
        const sendKnob = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            units: "decibels",
            gain: volume
        });
        this.connect(sendKnob);
        sendKnob.connect(bus);
        return sendKnob;
    }
    /**
     * Receive audio from a channel which was connected with {@link send}.
     * @param name The channel name to receive audio from.
     */ receive(name) {
        const bus = this._getBus(name);
        bus.connect(this);
        return this;
    }
    dispose() {
        super.dispose();
        this._panVol.dispose();
        this.pan.dispose();
        this.volume.dispose();
        this._solo.dispose();
        return this;
    }
}
/**
 * Store the send/receive channels by name.
 */ $01b9d2d997527d24$export$cfdacaa37f9b4dd7.buses = new Map();










class $af3c892bcfe05cf9$export$6a6cc05ddf64d43 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        super((0, $07d9216a29f4e8bb$export$71d3255081da70a3)($af3c892bcfe05cf9$export$6a6cc05ddf64d43.getDefaults(), arguments));
        this.name = "Mono";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._merge = this.output = new (0, $799c23fcce0ddd96$export$70ce1d34efd3b886)({
            channels: 2,
            context: this.context
        });
        this.input.connect(this._merge, 0, 0);
        this.input.connect(this._merge, 0, 1);
    }
    dispose() {
        super.dispose();
        this._merge.dispose();
        this.input.dispose();
        return this;
    }
}








class $595a0cee03b7d711$export$8243399b0243bc0b extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($595a0cee03b7d711$export$8243399b0243bc0b.getDefaults(), arguments, [
            "lowFrequency",
            "highFrequency"
        ]);
        super(options);
        this.name = "MultibandSplit";
        /**
         * the input
         */ this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        /**
         * no output node, use either low, mid or high outputs
         */ this.output = undefined;
        /**
         * The low band.
         */ this.low = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            frequency: 0,
            type: "lowpass"
        });
        /**
         * the lower filter of the mid band
         */ this._lowMidFilter = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            frequency: 0,
            type: "highpass"
        });
        /**
         * The mid band output.
         */ this.mid = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            frequency: 0,
            type: "lowpass"
        });
        /**
         * The high band output.
         */ this.high = new (0, $a487e4b525eb8039$export$ec91da630f36d5ea)({
            context: this.context,
            frequency: 0,
            type: "highpass"
        });
        this._internalChannels = [
            this.low,
            this.mid,
            this.high
        ];
        this.lowFrequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.lowFrequency
        });
        this.highFrequency = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "frequency",
            value: options.highFrequency
        });
        this.Q = new (0, $87a50297d6fa5f61$export$8210dfe1863c478)({
            context: this.context,
            units: "positive",
            value: options.Q
        });
        this.input.fan(this.low, this.high);
        this.input.chain(this._lowMidFilter, this.mid);
        // the frequency control signal
        this.lowFrequency.fan(this.low.frequency, this._lowMidFilter.frequency);
        this.highFrequency.fan(this.mid.frequency, this.high.frequency);
        // the Q value
        this.Q.connect(this.low.Q);
        this.Q.connect(this._lowMidFilter.Q);
        this.Q.connect(this.mid.Q);
        this.Q.connect(this.high.Q);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            Q: 1,
            highFrequency: 2500,
            lowFrequency: 400
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        (0, $8cce0c9e2019bc8a$export$e6d3eada50a007b1)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
        this.low.dispose();
        this._lowMidFilter.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.lowFrequency.dispose();
        this.highFrequency.dispose();
        this.Q.dispose();
        return this;
    }
}







class $25cdfed72df3ea98$export$40229b68a3be8579 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($25cdfed72df3ea98$export$40229b68a3be8579.getDefaults(), arguments, [
            "positionX",
            "positionY",
            "positionZ"
        ]);
        super(options);
        this.name = "Panner3D";
        this._panner = this.input = this.output = this.context.createPanner();
        // set some values
        this.panningModel = options.panningModel;
        this.maxDistance = options.maxDistance;
        this.distanceModel = options.distanceModel;
        this.coneOuterGain = options.coneOuterGain;
        this.coneOuterAngle = options.coneOuterAngle;
        this.coneInnerAngle = options.coneInnerAngle;
        this.refDistance = options.refDistance;
        this.rolloffFactor = options.rolloffFactor;
        this.positionX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.positionX,
            value: options.positionX
        });
        this.positionY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.positionY,
            value: options.positionY
        });
        this.positionZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.positionZ,
            value: options.positionZ
        });
        this.orientationX = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.orientationX,
            value: options.orientationX
        });
        this.orientationY = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.orientationY,
            value: options.orientationY
        });
        this.orientationZ = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            context: this.context,
            param: this._panner.orientationZ,
            value: options.orientationZ
        });
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            coneInnerAngle: 360,
            coneOuterAngle: 360,
            coneOuterGain: 0,
            distanceModel: "inverse",
            maxDistance: 10000,
            orientationX: 0,
            orientationY: 0,
            orientationZ: 0,
            panningModel: "equalpower",
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            refDistance: 1,
            rolloffFactor: 1
        });
    }
    /**
     * Sets the position of the source in 3d space.
     */ setPosition(x, y, z) {
        this.positionX.value = x;
        this.positionY.value = y;
        this.positionZ.value = z;
        return this;
    }
    /**
     * Sets the orientation of the source in 3d space.
     */ setOrientation(x, y, z) {
        this.orientationX.value = x;
        this.orientationY.value = y;
        this.orientationZ.value = z;
        return this;
    }
    /**
     * The panning model. Either "equalpower" or "HRTF".
     */ get panningModel() {
        return this._panner.panningModel;
    }
    set panningModel(val) {
        this._panner.panningModel = val;
    }
    /**
     * A reference distance for reducing volume as source move further from the listener
     */ get refDistance() {
        return this._panner.refDistance;
    }
    set refDistance(val) {
        this._panner.refDistance = val;
    }
    /**
     * Describes how quickly the volume is reduced as source moves away from listener.
     */ get rolloffFactor() {
        return this._panner.rolloffFactor;
    }
    set rolloffFactor(val) {
        this._panner.rolloffFactor = val;
    }
    /**
     * The distance model used by,  "linear", "inverse", or "exponential".
     */ get distanceModel() {
        return this._panner.distanceModel;
    }
    set distanceModel(val) {
        this._panner.distanceModel = val;
    }
    /**
     * The angle, in degrees, inside of which there will be no volume reduction
     */ get coneInnerAngle() {
        return this._panner.coneInnerAngle;
    }
    set coneInnerAngle(val) {
        this._panner.coneInnerAngle = val;
    }
    /**
     * The angle, in degrees, outside of which the volume will be reduced
     * to a constant value of coneOuterGain
     */ get coneOuterAngle() {
        return this._panner.coneOuterAngle;
    }
    set coneOuterAngle(val) {
        this._panner.coneOuterAngle = val;
    }
    /**
     * The gain outside of the coneOuterAngle
     */ get coneOuterGain() {
        return this._panner.coneOuterGain;
    }
    set coneOuterGain(val) {
        this._panner.coneOuterGain = val;
    }
    /**
     * The maximum distance between source and listener,
     * after which the volume will not be reduced any further.
     */ get maxDistance() {
        return this._panner.maxDistance;
    }
    set maxDistance(val) {
        this._panner.maxDistance = val;
    }
    dispose() {
        super.dispose();
        this._panner.disconnect();
        this.orientationX.dispose();
        this.orientationY.dispose();
        this.orientationZ.dispose();
        this.positionX.dispose();
        this.positionY.dispose();
        this.positionZ.dispose();
        return this;
    }
}









class $351b1d4f73bc2919$export$336a011955157f9a extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($351b1d4f73bc2919$export$336a011955157f9a.getDefaults(), arguments);
        super(options);
        this.name = "Recorder";
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        (0, $afc9146c77d080c2$export$a7a9523472993e97)($351b1d4f73bc2919$export$336a011955157f9a.supported, "Media Recorder API is not available");
        this._stream = this.context.createMediaStreamDestination();
        this.input.connect(this._stream);
        this._recorder = new MediaRecorder(this._stream.stream, {
            mimeType: options.mimeType
        });
    }
    static getDefaults() {
        return (0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults();
    }
    /**
     * The mime type is the format that the audio is encoded in. For Chrome
     * that is typically webm encoded as "vorbis".
     */ get mimeType() {
        return this._recorder.mimeType;
    }
    /**
     * Test if your platform supports the Media Recorder API. If it's not available,
     * try installing this (polyfill)[https://www.npmjs.com/package/audio-recorder-polyfill].
     */ static get supported() {
        return (0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2) !== null && Reflect.has((0, $bed5511bac81cb8c$export$a3ddad83b7a6ba2), "MediaRecorder");
    }
    /**
     * Get the playback state of the Recorder, either "started", "stopped" or "paused"
     */ get state() {
        if (this._recorder.state === "inactive") return "stopped";
        else if (this._recorder.state === "paused") return "paused";
        else return "started";
    }
    /**
     * Start the Recorder. Returns a promise which resolves
     * when the recorder has started.
     */ start() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.state !== "started", "Recorder is already started");
            const startPromise = new Promise((done)=>{
                const handleStart = ()=>{
                    this._recorder.removeEventListener("start", handleStart, false);
                    done();
                };
                this._recorder.addEventListener("start", handleStart, false);
            });
            this._recorder.start();
            return yield startPromise;
        });
    }
    /**
     * Stop the recorder. Returns a promise with the recorded content until this point
     * encoded as {@link mimeType}
     */ stop() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.state !== "stopped", "Recorder is not started");
            const dataPromise = new Promise((done)=>{
                const handleData = (e)=>{
                    this._recorder.removeEventListener("dataavailable", handleData, false);
                    done(e.data);
                };
                this._recorder.addEventListener("dataavailable", handleData, false);
            });
            this._recorder.stop();
            return yield dataPromise;
        });
    }
    /**
     * Pause the recorder
     */ pause() {
        (0, $afc9146c77d080c2$export$a7a9523472993e97)(this.state === "started", "Recorder must be started");
        this._recorder.pause();
        return this;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this._stream.disconnect();
        return this;
    }
}









class $f3c1c7f69db8aec2$export$41ba31ea44cbf87a extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($f3c1c7f69db8aec2$export$41ba31ea44cbf87a.getDefaults(), arguments, [
            "threshold",
            "ratio"
        ]);
        super(options);
        this.name = "Compressor";
        /**
         * the compressor node
         */ this._compressor = this.context.createDynamicsCompressor();
        this.input = this._compressor;
        this.output = this._compressor;
        this.threshold = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.threshold.minValue,
            maxValue: this._compressor.threshold.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.threshold,
            units: "decibels",
            value: options.threshold
        });
        this.attack = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.attack.minValue,
            maxValue: this._compressor.attack.maxValue,
            context: this.context,
            param: this._compressor.attack,
            units: "time",
            value: options.attack
        });
        this.release = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.release.minValue,
            maxValue: this._compressor.release.maxValue,
            context: this.context,
            param: this._compressor.release,
            units: "time",
            value: options.release
        });
        this.knee = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.knee.minValue,
            maxValue: this._compressor.knee.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.knee,
            units: "decibels",
            value: options.knee
        });
        this.ratio = new (0, $4e42d28fbc344697$export$1ca45c9a47aec42c)({
            minValue: this._compressor.ratio.minValue,
            maxValue: this._compressor.ratio.maxValue,
            context: this.context,
            convert: false,
            param: this._compressor.ratio,
            units: "positive",
            value: options.ratio
        });
        // set the defaults
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "knee",
            "release",
            "attack",
            "ratio",
            "threshold"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            attack: 0.003,
            knee: 30,
            ratio: 12,
            release: 0.25,
            threshold: -24
        });
    }
    /**
     * A read-only decibel value for metering purposes, representing the current amount of gain
     * reduction that the compressor is applying to the signal. If fed no signal the value will be 0 (no gain reduction).
     */ get reduction() {
        return this._compressor.reduction;
    }
    dispose() {
        super.dispose();
        this._compressor.disconnect();
        this.attack.dispose();
        this.release.dispose();
        this.threshold.dispose();
        this.ratio.dispose();
        this.knee.dispose();
        return this;
    }
}








class $b1dc822c92d1cb83$export$b4bc28ee584f979c extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($b1dc822c92d1cb83$export$b4bc28ee584f979c.getDefaults(), arguments, [
            "threshold",
            "smoothing"
        ]);
        super(options);
        this.name = "Gate";
        this._follower = new (0, $1cbcf0ccf8b4dd2c$export$8ccab1ce4a46f)({
            context: this.context,
            smoothing: options.smoothing
        });
        this._gt = new (0, $935df50545cf657e$export$fdac76ab71aa5db6)({
            context: this.context,
            value: (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(options.threshold)
        });
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._gate = this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        // connections
        this.input.connect(this._gate);
        // the control signal
        this.input.chain(this._follower, this._gt, this._gate.gain);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            smoothing: 0.1,
            threshold: -40
        });
    }
    /**
     * The threshold of the gate in decibels
     */ get threshold() {
        return (0, $84c2af7dbf01a14d$export$6af3969727ca2a60)(this._gt.value);
    }
    set threshold(thresh) {
        this._gt.value = (0, $84c2af7dbf01a14d$export$33ed28de027e9482)(thresh);
    }
    /**
     * The attack/decay speed of the gate.
     * @see {@link Follower.smoothing}
     */ get smoothing() {
        return this._follower.smoothing;
    }
    set smoothing(smoothingTime) {
        this._follower.smoothing = smoothingTime;
    }
    dispose() {
        super.dispose();
        this.input.dispose();
        this._follower.dispose();
        this._gt.dispose();
        this._gate.dispose();
        return this;
    }
}






class $3acc0d741b04b4a9$export$18d8154f27ea9172 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3acc0d741b04b4a9$export$18d8154f27ea9172.getDefaults(), arguments, [
            "threshold"
        ]);
        super(options);
        this.name = "Limiter";
        this._compressor = this.input = this.output = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)({
            context: this.context,
            ratio: 20,
            attack: 0.003,
            release: 0.01,
            threshold: options.threshold
        });
        this.threshold = this._compressor.threshold;
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, "threshold");
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            threshold: -12
        });
    }
    /**
     * A read-only decibel value for metering purposes, representing the current amount of gain
     * reduction that the compressor is applying to the signal.
     */ get reduction() {
        return this._compressor.reduction;
    }
    dispose() {
        super.dispose();
        this._compressor.dispose();
        this.threshold.dispose();
        return this;
    }
}








class $3f1bdd788834c9c8$export$4fe244964f9889ae extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($3f1bdd788834c9c8$export$4fe244964f9889ae.getDefaults(), arguments);
        super(options);
        this.name = "MidSideCompressor";
        this._midSideSplit = this.input = new (0, $19a08d555cfc2bca$export$17b3caaa07b8690f)({
            context: this.context
        });
        this._midSideMerge = this.output = new (0, $166d7e4e0737e4ca$export$be84ddbe7b4fbb5a)({
            context: this.context
        });
        this.mid = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.mid, {
            context: this.context
        }));
        this.side = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.side, {
            context: this.context
        }));
        this._midSideSplit.mid.chain(this.mid, this._midSideMerge.mid);
        this._midSideSplit.side.chain(this.side, this._midSideMerge.side);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "mid",
            "side"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            mid: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            },
            side: {
                ratio: 6,
                threshold: -30,
                release: 0.25,
                attack: 0.03,
                knee: 10
            }
        });
    }
    dispose() {
        super.dispose();
        this.mid.dispose();
        this.side.dispose();
        this._midSideSplit.dispose();
        this._midSideMerge.dispose();
        return this;
    }
}








class $faccc413e9e95c99$export$7cd9eb83d48f580b extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($faccc413e9e95c99$export$7cd9eb83d48f580b.getDefaults(), arguments);
        super(options);
        this.name = "MultibandCompressor";
        this._splitter = this.input = new (0, $595a0cee03b7d711$export$8243399b0243bc0b)({
            context: this.context,
            lowFrequency: options.lowFrequency,
            highFrequency: options.highFrequency
        });
        this.lowFrequency = this._splitter.lowFrequency;
        this.highFrequency = this._splitter.highFrequency;
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.low = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.low, {
            context: this.context
        }));
        this.mid = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.mid, {
            context: this.context
        }));
        this.high = new (0, $f3c1c7f69db8aec2$export$41ba31ea44cbf87a)(Object.assign(options.high, {
            context: this.context
        }));
        // connect the compressor
        this._splitter.low.chain(this.low, this.output);
        this._splitter.mid.chain(this.mid, this.output);
        this._splitter.high.chain(this.high, this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "high",
            "mid",
            "low",
            "highFrequency",
            "lowFrequency"
        ]);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            lowFrequency: 250,
            highFrequency: 2000,
            low: {
                ratio: 6,
                threshold: -30,
                release: 0.25,
                attack: 0.03,
                knee: 10
            },
            mid: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            },
            high: {
                ratio: 3,
                threshold: -24,
                release: 0.03,
                attack: 0.02,
                knee: 16
            }
        });
    }
    dispose() {
        super.dispose();
        this._splitter.dispose();
        this.low.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.output.dispose();
        return this;
    }
}










class $97dc6ad5209e914a$export$2adf407ed955ca5d extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($97dc6ad5209e914a$export$2adf407ed955ca5d.getDefaults(), arguments, [
            "low",
            "mid",
            "high"
        ]);
        super(options);
        this.name = "EQ3";
        /**
         * the output
         */ this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this._internalChannels = [];
        this.input = this._multibandSplit = new (0, $595a0cee03b7d711$export$8243399b0243bc0b)({
            context: this.context,
            highFrequency: options.highFrequency,
            lowFrequency: options.lowFrequency
        });
        this._lowGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.low,
            units: "decibels"
        });
        this._midGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.mid,
            units: "decibels"
        });
        this._highGain = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context,
            gain: options.high,
            units: "decibels"
        });
        this.low = this._lowGain.gain;
        this.mid = this._midGain.gain;
        this.high = this._highGain.gain;
        this.Q = this._multibandSplit.Q;
        this.lowFrequency = this._multibandSplit.lowFrequency;
        this.highFrequency = this._multibandSplit.highFrequency;
        // the frequency bands
        this._multibandSplit.low.chain(this._lowGain, this.output);
        this._multibandSplit.mid.chain(this._midGain, this.output);
        this._multibandSplit.high.chain(this._highGain, this.output);
        (0, $8cce0c9e2019bc8a$export$b2cbc93d4da94977)(this, [
            "low",
            "mid",
            "high",
            "lowFrequency",
            "highFrequency"
        ]);
        this._internalChannels = [
            this._multibandSplit
        ];
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            high: 0,
            highFrequency: 2500,
            low: 0,
            lowFrequency: 400,
            mid: 0
        });
    }
    /**
     * Clean up.
     */ dispose() {
        super.dispose();
        (0, $8cce0c9e2019bc8a$export$e6d3eada50a007b1)(this, [
            "low",
            "mid",
            "high",
            "lowFrequency",
            "highFrequency"
        ]);
        this._multibandSplit.dispose();
        this.lowFrequency.dispose();
        this.highFrequency.dispose();
        this._lowGain.dispose();
        this._midGain.dispose();
        this._highGain.dispose();
        this.low.dispose();
        this.mid.dispose();
        this.high.dispose();
        this.Q.dispose();
        return this;
    }
}












class $277738816d5b8132$export$f48597cb240e2420 extends (0, $1dae52eee8c779dd$export$14a6d069f26d1d33) {
    constructor(){
        const options = (0, $07d9216a29f4e8bb$export$71d3255081da70a3)($277738816d5b8132$export$f48597cb240e2420.getDefaults(), arguments, [
            "url",
            "onload"
        ]);
        super(options);
        this.name = "Convolver";
        /**
         * The native ConvolverNode
         */ this._convolver = this.context.createConvolver();
        this._buffer = new (0, $43da6dea502b5fe8$export$424a335715b38178)(options.url, (buffer)=>{
            this.buffer = buffer;
            options.onload();
        });
        this.input = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        this.output = new (0, $10a186a98a559639$export$acd19d919666900d)({
            context: this.context
        });
        // set if it's already loaded, set it immediately
        if (this._buffer.loaded) this.buffer = this._buffer;
        // initially set normalization
        this.normalize = options.normalize;
        // connect it up
        this.input.chain(this._convolver, this.output);
    }
    static getDefaults() {
        return Object.assign((0, $1dae52eee8c779dd$export$14a6d069f26d1d33).getDefaults(), {
            normalize: true,
            onload: (0, $8cce0c9e2019bc8a$export$b50b6e108474309b)
        });
    }
    /**
     * Load an impulse response url as an audio buffer.
     * Decodes the audio asynchronously and invokes
     * the callback once the audio buffer loads.
     * @param url The url of the buffer to load. filetype support depends on the browser.
     */ load(url) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            this.buffer = yield this._buffer.load(url);
        });
    }
    /**
     * The convolver's buffer
     */ get buffer() {
        if (this._buffer.length) return this._buffer;
        else return null;
    }
    set buffer(buffer) {
        if (buffer) this._buffer.set(buffer);
        // if it's already got a buffer, create a new one
        if (this._convolver.buffer) {
            // disconnect the old one
            this.input.disconnect();
            this._convolver.disconnect();
            // create and connect a new one
            this._convolver = this.context.createConvolver();
            this.input.chain(this._convolver, this.output);
        }
        const buff = this._buffer.get();
        this._convolver.buffer = buff ? buff : null;
    }
    /**
     * The normalize property of the ConvolverNode interface is a boolean that
     * controls whether the impulse response from the buffer will be scaled by
     * an equal-power normalization when the buffer attribute is set, or not.
     */ get normalize() {
        return this._convolver.normalize;
    }
    set normalize(norm) {
        this._convolver.normalize = norm;
    }
    dispose() {
        super.dispose();
        this._buffer.dispose();
        this._convolver.disconnect();
        return this;
    }
}












function $e40393b998e22e0d$export$461939dd4422153() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().now();
}
function $e40393b998e22e0d$export$7aea7eb3d7f025ec() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().immediate();
}
const $e40393b998e22e0d$export$86495b081fef8e52 = (0, $b7b11709569bdbef$export$31553aaa555c1514)().transport;
function $e40393b998e22e0d$export$867d8b939ab7f43e() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().transport;
}
const $e40393b998e22e0d$export$5c4bdf44e1e9cea1 = (0, $b7b11709569bdbef$export$31553aaa555c1514)().destination;
const $e40393b998e22e0d$export$44fd2db2d162647d = (0, $b7b11709569bdbef$export$31553aaa555c1514)().destination;
function $e40393b998e22e0d$export$be071a6ef30bc5f7() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().destination;
}
const $e40393b998e22e0d$export$c92b1d5f43586026 = (0, $b7b11709569bdbef$export$31553aaa555c1514)().listener;
function $e40393b998e22e0d$export$12abb5141c6fdc9c() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().listener;
}
const $e40393b998e22e0d$export$dca20402ebea5ece = (0, $b7b11709569bdbef$export$31553aaa555c1514)().draw;
function $e40393b998e22e0d$export$dc345928c36e8deb() {
    return (0, $b7b11709569bdbef$export$31553aaa555c1514)().draw;
}
const $e40393b998e22e0d$export$a078c61943f9dbbe = (0, $b7b11709569bdbef$export$31553aaa555c1514)();
function $e40393b998e22e0d$export$b40fc69c4a2927a1() {
    return (0, $43da6dea502b5fe8$export$424a335715b38178).loaded();
}
const $e40393b998e22e0d$export$a143d493d941bafc = (0, $43da6dea502b5fe8$export$424a335715b38178);
const $e40393b998e22e0d$export$2a73594b5be3a068 = (0, $d37bb61f6ec53d08$export$7232b969b571e570);
const $e40393b998e22e0d$export$54a46af252275b4d = (0, $faf7c8e078303879$export$30cbf4ba14db4fdd);


const $deb8675afe51395d$var$synthW = new $85ae9a076515912b$export$a7e98a317490a78b().toDestination();
$deb8675afe51395d$var$synthW.set({
    oscillator: {
        type: "triangle"
    },
    volume: -6
});
const $deb8675afe51395d$var$synthB = new $85ae9a076515912b$export$a7e98a317490a78b().toDestination();
$deb8675afe51395d$var$synthB.set({
    oscillator: {
        type: "sine"
    },
    volume: -6
});
const $deb8675afe51395d$var$tempoSlider = document.getElementById("tempo_slider");
const $deb8675afe51395d$var$sgfUrlInput = document.getElementById("sgf_url");
const $deb8675afe51395d$var$playButton = document.getElementById("play_button");
const $deb8675afe51395d$var$stopButton = document.getElementById("stop_button");
const $deb8675afe51395d$var$loadingIndicator = document.getElementById("loading_indicator");
async function $deb8675afe51395d$var$downloadSGFFile(url) {
    $deb8675afe51395d$var$loadingIndicator.innerHTML = "Loading...";
    try {
        // Fetch the file contents from the URL
        const response = await fetch(url);
        $deb8675afe51395d$var$loadingIndicator.innerHTML = "";
        if (!response.ok) throw new Error(`Failed to fetch the file: ${response.status} ${response.statusText}`);
        // Get the file contents as text
        const fileContents = await response.text();
        // Pass the file contents to your SGF parser module
        // Replace `parseSGF` with your actual module's parse function
        const parsedData = $3472ef69887c311d$exports.parse(fileContents);
        // Return or process the parsed data as needed
        return parsedData;
    } catch (error) {
        $deb8675afe51395d$var$loadingIndicator.innerHTML = "Error downloading or parsing SGF file...";
        console.error("Error downloading or parsing the SGF file:", error);
        throw error;
    }
}
const $deb8675afe51395d$var$sgfNodeDataToXYCoordinates = (nodeData)=>{
    const positions = [
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
    ];
    let x, y = -1;
    if (nodeData.B) {
        y = positions.indexOf(nodeData.B[0][0]);
        x = positions.indexOf(nodeData.B[0][1]);
    } else if (nodeData.W) {
        y = positions.indexOf(nodeData.W[0][0]);
        x = positions.indexOf(nodeData.W[0][1]);
    }
    return [
        x,
        y
    ];
};
let $deb8675afe51395d$var$interval = undefined;
const $deb8675afe51395d$var$playSGF = (sgfUrl)=>{
    $b7b11709569bdbef$export$b3571188c770cc5a();
    $deb8675afe51395d$var$downloadSGFFile(sgfUrl).then((parsedData)=>{
        let getId = ((id)=>()=>id++)(0);
        let gameTrees = parsedData.map((rootNode)=>{
            return new $5669c13f2796f695$exports({
                getId: getId,
                root: rootNode
            });
        });
        const rootTree = gameTrees[0];
        let nodeList = [
            ...rootTree.listNodes()
        ];
        const boardSize = parseInt(nodeList[0].data.SZ[0], 10);
        var boardElement = document.querySelector(".tenuki-board");
        boardElement.innerHTML = "";
        var game = new $225f7c2b7df55bb7$exports.Game({
            element: boardElement,
            boardSize: boardSize,
            _hooks: {
                hoverValue: function() {}
            } // disable user interaction
        });
        // Every intervalTime milliseconds, play the next move
        // Time should be adjustable in real-time using a slider
        const tempoToMilliseconds = (tempo)=>{
            // Return querter note length in milliseconds
            return 60000 / tempo / 4;
        };
        const tempoToSeconds = (tempo)=>{
            return tempoToMilliseconds(tempo) / 1000;
        };
        const playNextMove = ()=>{
            const node = nodeList[currentNode];
            const [x, y] = $deb8675afe51395d$var$sgfNodeDataToXYCoordinates(node.data);
            if (x > -1 && y > -1) {
                game.playAt(x, y);
                const velocity = 0.3 + y / boardSize * 0.7;
                const midiNote = x + 64;
                if (node.data.B) $deb8675afe51395d$var$synthB.triggerAttackRelease([
                    $f4d7193118bd1d27$export$44c95d3770756ed2(midiNote, "midi").toNote()
                ], [
                    tempoToSeconds($deb8675afe51395d$var$tempoSlider.value)
                ], undefined, [
                    velocity
                ]);
                else if (node.data.W) $deb8675afe51395d$var$synthW.triggerAttackRelease([
                    $f4d7193118bd1d27$export$44c95d3770756ed2(midiNote, "midi").toNote()
                ], [
                    tempoToSeconds($deb8675afe51395d$var$tempoSlider.value)
                ], undefined, [
                    velocity
                ]);
            } else console.log("Skipping move", node.data);
            currentNode++;
            if (currentNode >= nodeList.length) clearInterval($deb8675afe51395d$var$interval);
            else $deb8675afe51395d$var$interval = setTimeout(playNextMove, tempoToMilliseconds($deb8675afe51395d$var$tempoSlider.value));
        };
        let currentNode = 0;
        $deb8675afe51395d$var$interval = setTimeout(playNextMove, tempoToMilliseconds($deb8675afe51395d$var$tempoSlider.value));
    }).catch((error)=>{
        console.error("An error occurred:", error);
    });
};
const $deb8675afe51395d$var$stopAll = ()=>{
    clearInterval($deb8675afe51395d$var$interval);
    $deb8675afe51395d$var$synthW.releaseAll();
    $deb8675afe51395d$var$synthB.releaseAll();
};
$deb8675afe51395d$var$playButton.addEventListener("click", ()=>{
    $deb8675afe51395d$var$stopAll();
    $deb8675afe51395d$var$playSGF($deb8675afe51395d$var$sgfUrlInput.value);
});
$deb8675afe51395d$var$stopButton.addEventListener("click", ()=>{
    $deb8675afe51395d$var$stopAll();
});
// start adding empty board
var $deb8675afe51395d$var$boardElement = document.querySelector(".tenuki-board");
$deb8675afe51395d$var$boardElement.innerHTML = "";
var $deb8675afe51395d$var$game = new $225f7c2b7df55bb7$exports.Game({
    element: $deb8675afe51395d$var$boardElement,
    boardSize: 19,
    _hooks: {
        hoverValue: function() {}
    } // disable user interaction
});


//# sourceMappingURL=index.8c19ac04.js.map
